/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/barbershops/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(818);
	module.exports = __webpack_require__(1245);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(155);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1534)();
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.4
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        return name.match('^[^/\\\\]*$') != null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(1517)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.4';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(192)(module)))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(109);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(384);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(153);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1714);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(791);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1710);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(799);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1711);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1712);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(793);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1713);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(385);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(1723);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(798);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1716);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1717);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1721);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(795);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1695);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(787);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(1696);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderTurnstileChallenge = exports.wait = exports.isCommissionShop = exports.generateShortId = exports.ensureInt = exports.joinSlash = exports.appointmentIsCancelable = exports.getAvailableTimesEndDay = exports.getAvailableTimesStartDay = exports.joinQueryStringParams = exports.getReservationTimeFromTimeItem = exports.getPersonName = exports.arrayRotateRight = exports.addDaysToDate = exports.dayIsInRange = exports.getStartOfDay = exports.calculatePercent = exports.mapTimes = exports.paramMissing = exports.xor = exports.extendLocation = exports.transformShopLocation = exports.transformShopAddress = exports.formatAddress = exports.fireResizeEventOnWindow = exports.formatReservationTime = exports.parseTimeSlug = exports.toggleItemInArray = exports.randomItem = exports.nullFunc = exports.checkRoute = exports.handleRequestError = exports.checkStatus = exports.indexById = exports.byId = exports.getGiftCardUrls = exports.getServiceUrls = exports.getTimeUrls = exports.getBarberUrls = exports.getUrlPatternParamsOmitLast = exports.generateUrlString = exports.formatHours = exports.formatDuration = exports.isValidPhone = exports.isSameEmail = exports.isValidEmail = exports.isValidLastName = exports.isValidName = exports.formatPhone = exports.formatPrice = undefined;
	
	var _pathOr2 = __webpack_require__(754);
	
	var _pathOr3 = _interopRequireDefault(_pathOr2);
	
	var _prop2 = __webpack_require__(88);
	
	var _prop3 = _interopRequireDefault(_prop2);
	
	var _evolve2 = __webpack_require__(1549);
	
	var _evolve3 = _interopRequireDefault(_evolve2);
	
	var _defaultTo2 = __webpack_require__(738);
	
	var _defaultTo3 = _interopRequireDefault(_defaultTo2);
	
	var _pipe2 = __webpack_require__(75);
	
	var _pipe3 = _interopRequireDefault(_pipe2);
	
	var _isNil2 = __webpack_require__(234);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _negate2 = __webpack_require__(238);
	
	var _negate3 = _interopRequireDefault(_negate2);
	
	var _flow2 = __webpack_require__(125);
	
	var _flow3 = _interopRequireDefault(_flow2);
	
	var _isArray2 = __webpack_require__(28);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _compact2 = __webpack_require__(575);
	
	var _compact3 = _interopRequireDefault(_compact2);
	
	var _join2 = __webpack_require__(588);
	
	var _join3 = _interopRequireDefault(_join2);
	
	var _omit2 = __webpack_require__(350);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _last2 = __webpack_require__(237);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _isFinite2 = __webpack_require__(348);
	
	var _isFinite3 = _interopRequireDefault(_isFinite2);
	
	var _without2 = __webpack_require__(1512);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _some2 = __webpack_require__(181);
	
	var _some3 = _interopRequireDefault(_some2);
	
	var _random2 = __webpack_require__(1497);
	
	var _random3 = _interopRequireDefault(_random2);
	
	var _pickBy2 = __webpack_require__(105);
	
	var _pickBy3 = _interopRequireDefault(_pickBy2);
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _indexOf2 = __webpack_require__(584);
	
	var _indexOf3 = _interopRequireDefault(_indexOf2);
	
	var _has2 = __webpack_require__(583);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parsePhoneNumberFromString = __webpack_require__(521);
	
	var _parsePhoneNumberFromString2 = _interopRequireDefault(_parsePhoneNumberFromString);
	
	var _urlPattern = __webpack_require__(815);
	
	var _urlPattern2 = _interopRequireDefault(_urlPattern);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(10);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _metadataMin = __webpack_require__(500);
	
	var _metadataMin2 = _interopRequireDefault(_metadataMin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Format price in cents
	var formatPrice = exports.formatPrice = function formatPrice(num) {
	  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config2.default.defaultCurrency;
	  var noDecimalsIfInt = arguments[2];
	
	  var amount = num / 100;
	  if (!(0, _isFinite3.default)(amount)) return null;
	
	  var locale = void 0;
	  switch (currency.toUpperCase()) {
	    case 'CAD':
	      locale = 'en-CA';
	      break;
	    case 'USD':
	      locale = 'en-US';
	      break;
	    case 'GBP':
	      locale = 'en-UK';
	      break;
	    case 'AUD':
	      locale = 'en-AU';
	      break;
	    default:
	      locale = 'en-US';
	      break;
	  }
	
	  var isInteger = num % 100 === 0;
	  var amountString = amount.toLocaleString(locale, _extends({
	    style: currency ? 'currency' : 'decimal'
	  }, currency && { currency: currency }, {
	    minimumFractionDigits: noDecimalsIfInt && isInteger ? 0 : 2,
	    maximumFractionDigits: 2
	  }));
	
	  return '' + amountString;
	};
	
	// Format phone number with dashes
	var formatPhone = exports.formatPhone = function formatPhone(num) {
	  try {
	    return (0, _parsePhoneNumberFromString2.default)(num, _metadataMin2.default).formatInternational();
	  } catch (e) {
	    return num;
	  }
	};
	
	// eslint-disable-next-line max-len
	var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	var isValidName = exports.isValidName = function isValidName(name) {
	  return typeof name === 'string' && name.length > 1;
	};
	
	var isValidLastName = exports.isValidLastName = function isValidLastName(name) {
	  return typeof name === 'string' && name.length > 1;
	};
	
	var isValidEmail = exports.isValidEmail = function isValidEmail(email) {
	  return emailRegex.test(email);
	};
	var isSameEmail = exports.isSameEmail = function isSameEmail(email, emailToCheck) {
	  if (!email || !emailToCheck) {
	    return false;
	  }
	
	  // consider web@getsquire.com and web+1@getsquire.com equal
	  var plusPartRegex = /\+[\S\w]*@/ig;
	  return email.replace(plusPartRegex, '@') === emailToCheck.replace(plusPartRegex, '@');
	};
	
	var isValidPhone = exports.isValidPhone = function isValidPhone(phone) {
	  if (!phone) {
	    return false;
	  }
	
	  try {
	    return (0, _parsePhoneNumberFromString2.default)(phone, _metadataMin2.default).isPossible();
	  } catch (_e) {
	    return false;
	  }
	};
	
	var formatDuration = exports.formatDuration = function formatDuration(mins) {
	  var duration = _moment2.default.duration(mins, 'minutes');
	  var days = duration.days();
	  var hours = duration.hours();
	  var minutes = duration.minutes();
	
	  var daysHoursMins = '';
	  if (days) {
	    daysHoursMins += days + ' day';
	    if (days > 1) {
	      daysHoursMins += 's';
	    }
	    daysHoursMins += ' ';
	  }
	  if (hours) {
	    daysHoursMins += hours + ' hour';
	    if (hours > 1) {
	      daysHoursMins += 's';
	    }
	    daysHoursMins += ' ';
	  }
	  if (minutes) {
	    daysHoursMins += minutes + ' min';
	    if (minutes > 1) {
	      daysHoursMins += 's';
	    }
	    daysHoursMins += ' ';
	  }
	
	  return daysHoursMins;
	};
	
	var pluralize = function pluralize(str) {
	  return str + 's';
	};
	var suffixUnit = function suffixUnit(value, unit) {
	  return value > 1 ? value + ' ' + pluralize(unit) : value + ' ' + unit;
	};
	var formatHours = exports.formatHours = function formatHours(mins) {
	  var duration = _moment2.default.duration(mins, 'minutes');
	
	  var getHours = function getHours() {
	    var hours = Math.floor(duration.as('hours'));
	    if (!hours) return '';
	    return suffixUnit(hours, 'hour');
	  };
	
	  var getMinutes = function getMinutes() {
	    var minutes = duration.minutes();
	    if (!minutes) return '';
	    return suffixUnit(minutes, 'minute');
	  };
	
	  return (0, _compact3.default)([getHours(), getMinutes()]).join(' ');
	};
	
	var generateUrlString = exports.generateUrlString = function generateUrlString(params) {
	  var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config2.default.urlPatterns.old;
	
	  var stringifyParams = Object.keys(params).reduce(function (acc, key) {
	    return _extends({}, acc, _defineProperty({}, key, params[key] ? params[key] : ':' + key));
	  }, {});
	
	  var urlPattern = new _urlPattern2.default(pattern);
	
	  return urlPattern.stringify(stringifyParams);
	};
	
	var getUrlPatternLastParam = function getUrlPatternLastParam(params) {
	  var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config2.default.urlPatterns.old;
	
	  var urlPattern = new _urlPattern2.default(pattern);
	  return (0, _last3.default)(urlPattern.names);
	};
	
	var getUrlPatternParamsOmitLast = exports.getUrlPatternParamsOmitLast = function getUrlPatternParamsOmitLast(params) {
	  var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config2.default.urlPatterns.old;
	  return (0, _omit3.default)(params, getUrlPatternLastParam(params, pattern));
	};
	
	var getBarberUrls = exports.getBarberUrls = function getBarberUrls(urlPattern) {
	  return {
	    barbers: generateUrlString({ shopRoute: '' }, urlPattern),
	    services: generateUrlString({ shopRoute: '', barberRoute: '' }, urlPattern),
	    pickTime: generateUrlString({ shopRoute: '', barberRoute: '', serviceId: '' }, urlPattern),
	    makeReservation: generateUrlString({
	      shopRoute: '',
	      barberRoute: '',
	      serviceId: '',
	      reservationTime: ''
	    }, urlPattern)
	  };
	};
	
	var getTimeUrls = exports.getTimeUrls = function getTimeUrls(urlPattern) {
	  return {
	    pickTime: generateUrlString({ shopRoute: '' }, urlPattern),
	    barbers: generateUrlString({ shopRoute: '', reservationTime: '' }, urlPattern),
	    services: generateUrlString({ shopRoute: '', reservationTime: '', barberRoute: '' }, urlPattern),
	    makeReservation: generateUrlString({
	      shopRoute: '',
	      reservationTime: '',
	      barberRoute: '',
	      serviceId: ''
	    }, urlPattern)
	  };
	};
	
	var getServiceUrls = exports.getServiceUrls = function getServiceUrls(urlPattern) {
	  return {
	    services: generateUrlString({ shopRoute: '' }, urlPattern),
	    barbers: generateUrlString({ shopRoute: '', serviceId: '' }, urlPattern),
	    pickTime: generateUrlString({ shopRoute: '', barberRoute: '', serviceId: '' }, urlPattern),
	    makeReservation: generateUrlString({
	      shopRoute: '',
	      barberRoute: '',
	      serviceId: '',
	      reservationTime: ''
	    }, urlPattern)
	  };
	};
	
	var getGiftCardUrls = exports.getGiftCardUrls = function getGiftCardUrls(urlPattern) {
	  return {
	    shopUrl: generateUrlString({ shopRoute: '' }, urlPattern),
	    barberUrl: generateUrlString({ shopRoute: '', barberRoute: '' }, urlPattern),
	    checkoutUrl: generateUrlString({
	      shopRoute: '',
	      barberRoute: '',
	      giftCardAmount: ''
	    }, urlPattern)
	  };
	};
	
	var byId = exports.byId = function byId(set, id) {
	  return set.find(function (item) {
	    return item.get('id') === id;
	  });
	};
	
	var indexById = exports.indexById = function indexById(set, id) {
	  return set.findIndex(function (item) {
	    return item.get('id') === id;
	  });
	};
	
	var checkStatus = exports.checkStatus = function checkStatus(response) {
	  if (response.ok) return response.json();
	
	  return response.text().then(function (text) {
	    var json = void 0;
	    if (text) json = JSON.parse(text);
	    var message = (0, _get3.default)(json, 'message') || response.statusText;
	    var code = (0, _get3.default)(json, 'code');
	    var kind = (0, _get3.default)(json, 'kind');
	
	    return Promise.reject({ message: message, code: code, kind: kind });
	  });
	};
	
	var handleRequestError = exports.handleRequestError = function handleRequestError(dispatch) {
	  return function (error) {
	    if (error instanceof TypeError) {
	      return Promise.reject();
	    }
	
	    if (!error) return Promise.reject();
	
	    if (error.kind === 'only_prepay') {
	      dispatch({ type: _constants.FAILED_CHARGES });
	      return dispatch({
	        type: _constants.FAILED_BOOK_AND_RESERVE,
	        payload: error.message
	      });
	    }
	
	    var InvalidPromoErrorCode = 'RemoveInvalidPromoError';
	    if (error.code === InvalidPromoErrorCode) {
	      return dispatch({
	        type: _constants.RESCHEDULE_INVALID_PROMO_ERROR,
	        payload: error.message
	      });
	    }
	
	    if (error.code === 'ServiceUnavailable') {
	      return dispatch({
	        type: _constants.MAINTENANCE_MODE,
	        payload: error.message
	      });
	    }
	
	    return dispatch({
	      type: _constants.REQUEST_ERROR,
	      payload: (0, _get3.default)(error, 'message')
	    });
	  };
	};
	
	var checkRoute = exports.checkRoute = function checkRoute(dispatch, params, urlPattern) {
	  return function (response) {
	    // TODO: Remove 500 status check when service uuid error removed on API
	    if (response.status === 404 || response.status === 500) {
	      var redirect = generateUrlString(params, urlPattern);
	
	      dispatch({
	        type: _constants.BAD_ROUTE,
	        payload: redirect || '/404'
	      });
	
	      return Promise.reject();
	    }
	
	    return response;
	  };
	};
	
	var nullFunc = exports.nullFunc = function nullFunc() {
	  return null;
	};
	
	var randomItem = exports.randomItem = function randomItem(items) {
	  return (0, _isEmpty3.default)(items) ? items : items[(0, _random3.default)(items.length - 1)];
	};
	
	var toggleItemInArray = exports.toggleItemInArray = function toggleItemInArray(items, item) {
	  return (0, _indexOf3.default)(items, item) !== -1 ? (0, _without3.default)(items, item) : [].concat(_toConsumableArray(items), [item]);
	};
	
	var parseTimeSlug = exports.parseTimeSlug = function parseTimeSlug(time) {
	  var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'utc';
	
	  var parsed = (0, _moment2.default)(time, _config2.default.timeSlugFormat).tz(timezone);
	  if (parsed && parsed.isValid()) return parsed;
	  return null;
	};
	
	var formatReservationTime = exports.formatReservationTime = function formatReservationTime(time, timezone) {
	  if (time === _constants.TIME_WAITING_LIST) return '';
	  var parsed = parseTimeSlug(time, timezone);
	  if (!parsed) return '';
	
	  return parsed.format(_config2.default.dateTimeFormatLong);
	};
	
	var fireResizeEventOnWindow = exports.fireResizeEventOnWindow = function fireResizeEventOnWindow() {
	  var resizeEvent = function () {
	    if (typeof Event !== 'function') {
	      var evt = window.document.createEvent('UIEvents');
	      evt.initUIEvent('resize', true, false, window, 0);
	      return evt;
	    }
	    return new Event('resize');
	  }();
	
	  return window.dispatchEvent(resizeEvent);
	};
	
	var formatAddress = exports.formatAddress = function formatAddress() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      street = _ref.street,
	      street2 = _ref.street2,
	      city = _ref.city,
	      state = _ref.state,
	      zip = _ref.zip;
	
	  return (0, _join3.default)((0, _compact3.default)([street, street2, city, state, zip]), ', ');
	};
	
	var transformShopAddress = exports.transformShopAddress = (0, _pipe3.default)(function (shop) {
	  return _extends({}, shop, { country: (0, _pathOr3.default)(null, ['address', 'country'], shop) });
	}, (0, _evolve3.default)({
	  address: formatAddress
	}));
	
	var transformShopLocation = exports.transformShopLocation = (0, _evolve3.default)({
	  location: (0, _pipe3.default)((0, _prop3.default)('coordinates'), function (_ref2) {
	    var _ref3 = _slicedToArray(_ref2, 2),
	        lat = _ref3[0],
	        lng = _ref3[1];
	
	    return { lat: lat, lng: lng };
	  })
	});
	
	var extendLocation = exports.extendLocation = function extendLocation(location, params) {
	  if (typeof location === 'string') return _extends({}, params, { pathname: location });
	  if ((typeof location === 'undefined' ? 'undefined' : _typeof(location)) === 'object') return _extends({}, location, params);
	  return params;
	};
	
	var xor = exports.xor = function xor(a, b) {
	  return !a !== !b;
	};
	
	var paramMissing = exports.paramMissing = function paramMissing(keys, params) {
	  return (0, _some3.default)(keys, function (key) {
	    return !(0, _has3.default)((0, _pickBy3.default)(params, (0, _negate3.default)(_isNil3.default)), key);
	  });
	};
	
	var mapTimes = exports.mapTimes = function mapTimes(item) {
	  if (typeof item === 'string') return { time: item };
	  return item;
	};
	
	var calculatePercent = exports.calculatePercent = function calculatePercent(value, percent) {
	  return value * (percent / 100);
	};
	
	var getStartOfDay = exports.getStartOfDay = function getStartOfDay(day) {
	  var date = day ? new Date(day) : new Date();
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	};
	
	var dayIsInRange = exports.dayIsInRange = function dayIsInRange(day, from, to) {
	  return day >= from && day <= to;
	};
	
	var addDaysToDate = exports.addDaysToDate = function addDaysToDate(date, days) {
	  var newDate = new Date(date);
	  newDate.setDate(newDate.getDate() + days);
	  return newDate;
	};
	
	var arrayRotateRight = exports.arrayRotateRight = function arrayRotateRight(arr) {
	  var places = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  return [].concat(_toConsumableArray(arr.slice(-places)), _toConsumableArray(arr.slice(0, -places)));
	};
	
	var getPersonName = exports.getPersonName = function getPersonName() {
	  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      firstName = _ref4.firstName,
	      lastName = _ref4.lastName;
	
	  return firstName && lastName ? firstName + ' ' + lastName : '';
	};
	
	var getReservationTimeFromTimeItem = exports.getReservationTimeFromTimeItem = function getReservationTimeFromTimeItem() {
	  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      time = _ref5.time;
	
	  return time && (0, _moment2.default)(time).format(_config2.default.timeSlugFormat);
	};
	
	var joinQueryStringParams = exports.joinQueryStringParams = function joinQueryStringParams(params) {
	  if (!(0, _isArray3.default)(params)) {
	    return '';
	  }
	
	  var paramsStr = params.filter(Boolean).join('&');
	  if (!paramsStr) {
	    return '';
	  }
	
	  return '?' + paramsStr;
	};
	
	var getAvailableTimes = function getAvailableTimes(timezone) {
	  return function () {
	    var today = _moment2.default.tz(timezone).startOf('day');
	    var configIntervalInDays = _moment2.default.duration(_config2.default.availableTimesFetchInterval).days();
	
	    var differenceByDays = (0, _flow3.default)(function (dateString) {
	      return (0, _moment2.default)(dateString).diff(today);
	    }, function (dateMomentOrDuration) {
	      return _moment2.default.duration(dateMomentOrDuration).days();
	    });
	
	    var addDaysToToday = function addDaysToToday(days) {
	      return _moment2.default.tz(today, timezone).add(days, 'days').format(_config2.default.apiDateFormat);
	    };
	
	    var calculateStartDay = function calculateStartDay() {
	      var startDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : today;
	      return (0, _flow3.default)(differenceByDays, function (days) {
	        return Math.floor(days / configIntervalInDays) * configIntervalInDays;
	      }, addDaysToToday)(startDay);
	    };
	
	    var calculateEndDay = function calculateEndDay() {
	      var startDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : today;
	      return (0, _flow3.default)(differenceByDays, function (days) {
	        return (1 + Math.floor(days / configIntervalInDays)) * configIntervalInDays - 1;
	      }, addDaysToToday)(startDay);
	    };
	
	    return {
	      startDay: calculateStartDay,
	      endDay: calculateEndDay
	    };
	  }();
	};
	
	var getAvailableTimesStartDay = exports.getAvailableTimesStartDay = function getAvailableTimesStartDay(timezone) {
	  return getAvailableTimes(timezone).startDay;
	};
	
	var getAvailableTimesEndDay = exports.getAvailableTimesEndDay = function getAvailableTimesEndDay(timezone) {
	  return getAvailableTimes(timezone).endDay;
	};
	
	var appointmentIsCancelable = exports.appointmentIsCancelable = function appointmentIsCancelable(appointmentStart, advanceCancelMins) {
	  return _moment2.default.utc(appointmentStart).diff(_moment2.default.utc(), 'minutes') >= advanceCancelMins;
	};
	
	var joinSlash = exports.joinSlash = function joinSlash() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return args.filter(Boolean).join('/');
	};
	
	var ensureInt = exports.ensureInt = (0, _pipe3.default)(function (v) {
	  return parseInt(v, 10);
	}, (0, _defaultTo3.default)(0));
	
	/* eslint-disable no-bitwise, prefer-template */
	var generateShortId = exports.generateShortId = function generateShortId() {
	  var firstPart = Math.random() * 46656 | 0;
	  var secondPart = Math.random() * 46656 | 0;
	  firstPart = ('000' + firstPart.toString(36)).slice(-3);
	  secondPart = ('000' + secondPart.toString(36)).slice(-3);
	  return firstPart + secondPart;
	};
	/* eslint-enable no-bitwise, prefer-template */
	
	var isCommissionShop = exports.isCommissionShop = function isCommissionShop(shop) {
	  return shop && shop.kind === _constants.SHOP_TYPE.commission;
	};
	
	var wait = exports.wait = function wait(time) {
	  return new Promise(function (resolve) {
	    setTimeout(resolve, time);
	  });
	};
	
	var renderTurnstileChallenge = exports.renderTurnstileChallenge = function renderTurnstileChallenge(containerSelector) {
	  return new Promise(function (resolve) {
	    window.turnstile.render(containerSelector, {
	      appearance: 'always',
	      sitekey: _config2.default.botProtection.siteKey,
	      callback: function callback(token) {
	        resolve({ success: true, token: token });
	      },
	      'error-callback': function errorCallback() {
	        resolve({ success: false });
	      }
	    });
	  });
	};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _barbershop = __webpack_require__(1819);
	
	var _barbershop2 = _interopRequireDefault(_barbershop);
	
	var _defaultBarber = __webpack_require__(1820);
	
	var _defaultBarber2 = _interopRequireDefault(_defaultBarber);
	
	var _barberHero = __webpack_require__(1818);
	
	var _barberHero2 = _interopRequireDefault(_barberHero);
	
	var _squireLogo = __webpack_require__(1314);
	
	var _squireLogo2 = _interopRequireDefault(_squireLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BOOKING_URL = '/book';
	
	var getTemplateFolderByEnv = function getTemplateFolderByEnv(env) {
	  switch (env) {
	    case 'production':
	      return 'prod';
	
	    case 'staging':
	    case 'qa':
	      return 'staging';
	
	    default:
	      return 'dev';
	  }
	};
	
	var config = {
	  url: ("https://api.getsquire.com/v1") || 'https://api-qa-1.getsquire.com/v1',
	  stripeKey: ("pk_live_i7yVGwE1iFznsnhYqqpFNxmg") || 'pk_test_WFMOwR069KZvJoKilYNKsQNR',
	  branchKey: ("key_live_eafRKQ0rBNN7eNjrjJJFRhnlvzeWA93h") || 'key_test_lplOKGZFDRV1cTcCcVV6bihiBtj0z4Wt',
	  fbPixel: (378862599177017),
	  squireShopUrl:  true ? 'app' : 'app-dev',
	  emailTemplateFolder: getTemplateFolderByEnv(("production")),
	  defaultTimezone: 'America/New_York',
	  dateFormat: 'MM/DD/YYYY',
	  apiDateFormat: 'YYYY-MM-DD',
	  timeSlugFormat: 'YYMMDDHHmm',
	  dateTimeFormat: 'MM/DD/YYYY hh:mm A',
	  dateTimeFormatLong: 'MMMM Do [at] h:mm A',
	  timeFormat: 'h:mm A',
	  availableTimesFetchInterval: { weeks: 1 },
	  nextAvailableTimeFetchInterval: {
	    shop: { weeks: 1 },
	    barber: { weeks: 4 }
	  },
	  pubnub: {
	    subscribeKey: ("sub-c-b7a5edba-08f4-11e7-83b6-0619f8945a4f") || 'sub-c-b281b4c6-3f24-11e6-9baf-0619f8945a4f'
	  },
	  intercom: {
	    appId: ("jnflr57i") || 'fjhca6om'
	  },
	  googleMapsKey: ({"NODE_ENV":"production","WEB_ENV":"production","PUBLIC_URL":"/barbershops","FB_PIXEL_ID":378862599177017,"COMMANDER_URL":"https://app.getsquire.com","MIXPANEL_TOKEN":"26fd9fecaed51592cb1906e8549eca1e","FLAGSHIP_ANDROID_APP_URL":"https://play.google.com/store/apps/details?id=com.getsquire.flagship","FLAGSHIP_IOS_APP_URL":"https://apps.apple.com/us/app/squire/id957644357","PUBLISH_URL":"https://getsquire.com/barbershops","SQUIRE_BRANCH_KEY":"key_live_eafRKQ0rBNN7eNjrjJJFRhnlvzeWA93h","SQUIRE_STRIPE_KEY":"pk_live_i7yVGwE1iFznsnhYqqpFNxmg","SQUIRE_INTERCOM_ID":"jnflr57i","SQUIRE_TOKENS_URL":"https://squire-tokens-prod-1.getsquire.com","SQUIRE_PUBNUB_SUBSCRIBE_KEY":"sub-c-b7a5edba-08f4-11e7-83b6-0619f8945a4f","SQUIRE_FULLSTORY_ORG":"100T1W","SQUIRE_API_URL":"https://api.getsquire.com/v1","SQUIRE_GOOGLE_ANALYTICS_ID":"UA-70640238-1"}).SQUIRE_GOOGLE_MAPS_KEY || 'AIzaSyDLRFBhOTEMnT9sQyr-D_VQMByAU_yNpgs',
	  googleAnalyticsID: ("UA-70640238-1") || 'UA-73845752-1',
	  fallbackShopThumbnail: _barbershop2.default,
	  fallbackServiceThumbnail: _barbershop2.default,
	  fallbackBarberThumbnail: _defaultBarber2.default,
	  fallbackShopBackground: _barberHero2.default,
	  fallbackShopLogo: _squireLogo2.default,
	  urlPatterns: {
	    old: '(/:shopRoute(/:barberRoute(/:serviceId(/:reservationTime))))',
	    kiosk: '/kiosk(/:shopRoute(/:barberRoute(/:serviceId(/:reservationTime))))',
	    booking: '(' + BOOKING_URL + '/:shopRoute)',
	    barber: '(' + BOOKING_URL + '/:shopRoute/professional(/:barberRoute(/:serviceId(/:reservationTime))))',
	    service: '(' + BOOKING_URL + '/:shopRoute/service(/:serviceId(/:barberRoute(/:reservationTime))))',
	    giftCard: '/gift-card/:shopRoute(/:barberRoute(/:giftCardAmount))',
	    time: '(' + BOOKING_URL + '/:shopRoute/time(/:reservationTime(/:barberRoute(/:serviceId))))'
	  },
	  bookingFallbackRedirects: [{
	    from: BOOKING_URL + '/:shopRoute/barber*',
	    to: BOOKING_URL + '/:shopRoute/professional*'
	  }],
	  defaultCurrency: 'USD',
	  commanderUrl: ("https://app.getsquire.com"),
	  firebase: {
	    apiKey: 'AIzaSyDh_JBWohNL-Jw4RbKhhnNvpzXYHRcNX4g',
	    authDomain: 'online-booking-71b81.firebaseapp.com',
	    databaseURL: 'https://online-booking-71b81.firebaseio.com',
	    projectId: 'online-booking-71b81',
	    storageBucket: 'online-booking-71b81.appspot.com',
	    messagingSenderId: '595855054393',
	    appId: ({"NODE_ENV":"production","WEB_ENV":"production","PUBLIC_URL":"/barbershops","FB_PIXEL_ID":378862599177017,"COMMANDER_URL":"https://app.getsquire.com","MIXPANEL_TOKEN":"26fd9fecaed51592cb1906e8549eca1e","FLAGSHIP_ANDROID_APP_URL":"https://play.google.com/store/apps/details?id=com.getsquire.flagship","FLAGSHIP_IOS_APP_URL":"https://apps.apple.com/us/app/squire/id957644357","PUBLISH_URL":"https://getsquire.com/barbershops","SQUIRE_BRANCH_KEY":"key_live_eafRKQ0rBNN7eNjrjJJFRhnlvzeWA93h","SQUIRE_STRIPE_KEY":"pk_live_i7yVGwE1iFznsnhYqqpFNxmg","SQUIRE_INTERCOM_ID":"jnflr57i","SQUIRE_TOKENS_URL":"https://squire-tokens-prod-1.getsquire.com","SQUIRE_PUBNUB_SUBSCRIBE_KEY":"sub-c-b7a5edba-08f4-11e7-83b6-0619f8945a4f","SQUIRE_FULLSTORY_ORG":"100T1W","SQUIRE_API_URL":"https://api.getsquire.com/v1","SQUIRE_GOOGLE_ANALYTICS_ID":"UA-70640238-1"}).FIREBASE_APP_ID || '1:595855054393:web:f699847a2c4632ef4c5fe8',
	    measurementId: ({"NODE_ENV":"production","WEB_ENV":"production","PUBLIC_URL":"/barbershops","FB_PIXEL_ID":378862599177017,"COMMANDER_URL":"https://app.getsquire.com","MIXPANEL_TOKEN":"26fd9fecaed51592cb1906e8549eca1e","FLAGSHIP_ANDROID_APP_URL":"https://play.google.com/store/apps/details?id=com.getsquire.flagship","FLAGSHIP_IOS_APP_URL":"https://apps.apple.com/us/app/squire/id957644357","PUBLISH_URL":"https://getsquire.com/barbershops","SQUIRE_BRANCH_KEY":"key_live_eafRKQ0rBNN7eNjrjJJFRhnlvzeWA93h","SQUIRE_STRIPE_KEY":"pk_live_i7yVGwE1iFznsnhYqqpFNxmg","SQUIRE_INTERCOM_ID":"jnflr57i","SQUIRE_TOKENS_URL":"https://squire-tokens-prod-1.getsquire.com","SQUIRE_PUBNUB_SUBSCRIBE_KEY":"sub-c-b7a5edba-08f4-11e7-83b6-0619f8945a4f","SQUIRE_FULLSTORY_ORG":"100T1W","SQUIRE_API_URL":"https://api.getsquire.com/v1","SQUIRE_GOOGLE_ANALYTICS_ID":"UA-70640238-1"}).FIREBASE_MEASUREMENT_ID || 'G-J0XN6Y0CBT'
	  },
	  analytics: {
	    Mixpanel: {
	      token: ("26fd9fecaed51592cb1906e8549eca1e") || '1989ead379539857dd1bbafa3e37f7f7'
	    }
	  },
	  fullstory: {
	    url: 'https://api.fullstory.com',
	    apiKey: ({"NODE_ENV":"production","WEB_ENV":"production","PUBLIC_URL":"/barbershops","FB_PIXEL_ID":378862599177017,"COMMANDER_URL":"https://app.getsquire.com","MIXPANEL_TOKEN":"26fd9fecaed51592cb1906e8549eca1e","FLAGSHIP_ANDROID_APP_URL":"https://play.google.com/store/apps/details?id=com.getsquire.flagship","FLAGSHIP_IOS_APP_URL":"https://apps.apple.com/us/app/squire/id957644357","PUBLISH_URL":"https://getsquire.com/barbershops","SQUIRE_BRANCH_KEY":"key_live_eafRKQ0rBNN7eNjrjJJFRhnlvzeWA93h","SQUIRE_STRIPE_KEY":"pk_live_i7yVGwE1iFznsnhYqqpFNxmg","SQUIRE_INTERCOM_ID":"jnflr57i","SQUIRE_TOKENS_URL":"https://squire-tokens-prod-1.getsquire.com","SQUIRE_PUBNUB_SUBSCRIBE_KEY":"sub-c-b7a5edba-08f4-11e7-83b6-0619f8945a4f","SQUIRE_FULLSTORY_ORG":"100T1W","SQUIRE_API_URL":"https://api.getsquire.com/v1","SQUIRE_GOOGLE_ANALYTICS_ID":"UA-70640238-1"}).SQUIRE_FULLSTORY_API_KEY,
	    org: ("100T1W")
	  },
	  flagshipAppUrls: {
	    android: ("https://play.google.com/store/apps/details?id=com.getsquire.flagship") || 'https://play.google.com/store/apps/details?id=com.getsquire.flagship',
	    ios: ("https://apps.apple.com/us/app/squire/id957644357") || 'https://apps.apple.com/us/app/squire/id957644357'
	  },
	  payFacBrands: (({"NODE_ENV":"production","WEB_ENV":"production","PUBLIC_URL":"/barbershops","FB_PIXEL_ID":378862599177017,"COMMANDER_URL":"https://app.getsquire.com","MIXPANEL_TOKEN":"26fd9fecaed51592cb1906e8549eca1e","FLAGSHIP_ANDROID_APP_URL":"https://play.google.com/store/apps/details?id=com.getsquire.flagship","FLAGSHIP_IOS_APP_URL":"https://apps.apple.com/us/app/squire/id957644357","PUBLISH_URL":"https://getsquire.com/barbershops","SQUIRE_BRANCH_KEY":"key_live_eafRKQ0rBNN7eNjrjJJFRhnlvzeWA93h","SQUIRE_STRIPE_KEY":"pk_live_i7yVGwE1iFznsnhYqqpFNxmg","SQUIRE_INTERCOM_ID":"jnflr57i","SQUIRE_TOKENS_URL":"https://squire-tokens-prod-1.getsquire.com","SQUIRE_PUBNUB_SUBSCRIBE_KEY":"sub-c-b7a5edba-08f4-11e7-83b6-0619f8945a4f","SQUIRE_FULLSTORY_ORG":"100T1W","SQUIRE_API_URL":"https://api.getsquire.com/v1","SQUIRE_GOOGLE_ANALYTICS_ID":"UA-70640238-1"}).PAYFAC_BRANDS || [].join(',')).split(','),
	  squireTokensUrl: ("https://squire-tokens-prod-1.getsquire.com") || 'https://squire-tokens-dev-1.getsquire.com',
	
	  // prefix that is always attached to URLs for consolidated deployment
	  pathPrefix:  true ? ("https://getsquire.com/barbershops").split('.com')[1] : '',
	  botProtection: {
	    siteKey: ({"NODE_ENV":"production","WEB_ENV":"production","PUBLIC_URL":"/barbershops","FB_PIXEL_ID":378862599177017,"COMMANDER_URL":"https://app.getsquire.com","MIXPANEL_TOKEN":"26fd9fecaed51592cb1906e8549eca1e","FLAGSHIP_ANDROID_APP_URL":"https://play.google.com/store/apps/details?id=com.getsquire.flagship","FLAGSHIP_IOS_APP_URL":"https://apps.apple.com/us/app/squire/id957644357","PUBLISH_URL":"https://getsquire.com/barbershops","SQUIRE_BRANCH_KEY":"key_live_eafRKQ0rBNN7eNjrjJJFRhnlvzeWA93h","SQUIRE_STRIPE_KEY":"pk_live_i7yVGwE1iFznsnhYqqpFNxmg","SQUIRE_INTERCOM_ID":"jnflr57i","SQUIRE_TOKENS_URL":"https://squire-tokens-prod-1.getsquire.com","SQUIRE_PUBNUB_SUBSCRIBE_KEY":"sub-c-b7a5edba-08f4-11e7-83b6-0619f8945a4f","SQUIRE_FULLSTORY_ORG":"100T1W","SQUIRE_API_URL":"https://api.getsquire.com/v1","SQUIRE_GOOGLE_ANALYTICS_ID":"UA-70640238-1"}).SQUIRE_TURNSTILE_SITE_KEY
	  },
	  launchDarkly: {
	    clientSideId: ({"NODE_ENV":"production","WEB_ENV":"production","PUBLIC_URL":"/barbershops","FB_PIXEL_ID":378862599177017,"COMMANDER_URL":"https://app.getsquire.com","MIXPANEL_TOKEN":"26fd9fecaed51592cb1906e8549eca1e","FLAGSHIP_ANDROID_APP_URL":"https://play.google.com/store/apps/details?id=com.getsquire.flagship","FLAGSHIP_IOS_APP_URL":"https://apps.apple.com/us/app/squire/id957644357","PUBLISH_URL":"https://getsquire.com/barbershops","SQUIRE_BRANCH_KEY":"key_live_eafRKQ0rBNN7eNjrjJJFRhnlvzeWA93h","SQUIRE_STRIPE_KEY":"pk_live_i7yVGwE1iFznsnhYqqpFNxmg","SQUIRE_INTERCOM_ID":"jnflr57i","SQUIRE_TOKENS_URL":"https://squire-tokens-prod-1.getsquire.com","SQUIRE_PUBNUB_SUBSCRIBE_KEY":"sub-c-b7a5edba-08f4-11e7-83b6-0619f8945a4f","SQUIRE_FULLSTORY_ORG":"100T1W","SQUIRE_API_URL":"https://api.getsquire.com/v1","SQUIRE_GOOGLE_ANALYTICS_ID":"UA-70640238-1"}).SQUIRE_LD_CLIENT_SIDE_ID
	  }
	};
	
	exports.default = config;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _createEagerFactory = __webpack_require__(78);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _setDisplayName = __webpack_require__(69);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(79);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-console */
	
	
	var mapValues = function mapValues(obj, func) {
	  var result = {};
	  /* eslint-disable no-restricted-syntax */
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      result[key] = func(obj[key], key);
	    }
	  }
	  /* eslint-enable no-restricted-syntax */
	  return result;
	};
	
	var withHandlers = function withHandlers(handlers) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    var WithHandlers = function (_Component) {
	      _inherits(WithHandlers, _Component);
	
	      function WithHandlers() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithHandlers);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	        this.cachedHandlers = {};
	      };
	
	      WithHandlers.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.handlers));
	      };
	
	      return WithHandlers;
	    }(_react.Component);
	
	    var _initialiseProps = function _initialiseProps() {
	      var _this2 = this;
	
	      this.cachedHandlers = {};
	      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
	        return function () {
	          var cachedHandler = _this2.cachedHandlers[handlerName];
	          if (cachedHandler) {
	            return cachedHandler.apply(undefined, arguments);
	          }
	
	          var handler = createHandler(_this2.props);
	          _this2.cachedHandlers[handlerName] = handler;
	
	          if (false) {
	            console.error(
	            // eslint-disable-line no-console
	            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
	          }
	
	          return handler.apply(undefined, arguments);
	        };
	      });
	    };
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withHandlers'))(WithHandlers);
	    }
	    return WithHandlers;
	  };
	};
	
	exports.default = withHandlers;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var RESERVATION_CANCELED = exports.RESERVATION_CANCELED = 1;
	var ANY_BARBER = exports.ANY_BARBER = 'any';
	var ANY_SERVICE = exports.ANY_SERVICE = 'any';
	var TIME_WAITING_LIST = exports.TIME_WAITING_LIST = 'waiting-list';
	var TIP_NONE = exports.TIP_NONE = 0;
	
	var STEPS = exports.STEPS = {
	  barber: 'barber',
	  service: 'service',
	  time: 'time',
	  reservation: 'reservation'
	};
	var SHOP_TYPE = exports.SHOP_TYPE = {
	  rental: 0,
	  commission: 1
	};
	
	var OWNER_TYPE = exports.OWNER_TYPE = {
	  shop: 'shop',
	  barber: 'barber',
	  brand: 'brand'
	};
	
	var LADY_CLIPPER_SHOP_ID = exports.LADY_CLIPPER_SHOP_ID = '19f2f108-9243-41d3-9049-9f7589d9f1a0';
	var KRWN_ZAZZ_PLACE_STE_FOY_SHOP_ID = exports.KRWN_ZAZZ_PLACE_STE_FOY_SHOP_ID = '2f179764-f13b-4477-b880-768151a184e5';
	
	// for testing purposes use different shop ids for different environments
	var CHOP_MURRAY_HILL_SHOP_ID = exports.CHOP_MURRAY_HILL_SHOP_ID = function () {
	  switch (("production")) {
	    case 'development':
	      return '88e536e3-81ef-4e73-842c-1008dc824c76';
	    case 'qa':
	    case 'production':
	      return '9fcfca0c-9a8c-4ee2-8642-23f83d61f519';
	    case 'staging':
	      return 'f307a95d-c7b5-4db1-8052-e6100db1acd3';
	    default:
	      return '9fcfca0c-9a8c-4ee2-8642-23f83d61f519';
	  }
	}();
	
	var SQUIRE_FEE_SHOPS = exports.SQUIRE_FEE_SHOPS = [
	// Braid
	'0a6c88fd-15b5-4b1d-afba-15a241e30439', '0614c9c3-6b4b-400f-a52f-45f6766c7fc5',
	// Empire
	'34210d35-6048-4c0b-9157-5c05d476017a', 'dca00d00-1b39-41b8-a4b2-082049065c1c'];
	var NO_PROMO_BOX_SHOPS = exports.NO_PROMO_BOX_SHOPS = [
	// Monthly
	'7f105e43-206c-4c69-80c1-3a6168dbdedd', '2999973c-dfbd-4116-af3a-f9b4b0dd48b8', '764e8cee-292c-4399-9a31-3311c41af109', '76765d07-6aa4-46b8-8201-821f863ded5c', '3afb06db-a395-4dd1-b22f-1cb772f54e2e'];
	
	// Actions
	var SET_ERROR_MESSAGE = exports.SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
	var CLEAR_ERROR = exports.CLEAR_ERROR = 'CLEAR_ERROR';
	var SET_REDIRECTION = exports.SET_REDIRECTION = 'SET_REDIRECTION';
	var CLEAR_REDIRECTION = exports.CLEAR_REDIRECTION = 'CLEAR_REDIRECTION';
	var BAD_ROUTE = exports.BAD_ROUTE = 'BAD_ROUTE';
	var CLEAR_SHOPS = exports.CLEAR_SHOPS = 'CLEAR_SHOPS';
	var CLEAR_BARBERS = exports.CLEAR_BARBERS = 'CLEAR_BARBERS';
	var CLEAR_SERVICES = exports.CLEAR_SERVICES = 'CLEAR_SERVICES';
	var CLEAR_RESERVATIONS = exports.CLEAR_RESERVATIONS = 'CLEAR_RESERVATIONS';
	var REQUEST_ERROR = exports.REQUEST_ERROR = 'REQUEST_ERROR';
	var MAINTENANCE_MODE = exports.MAINTENANCE_MODE = 'MAINTENANCE_MODE';
	var RECEIVE_CITIES = exports.RECEIVE_CITIES = 'RECEIVE_CITIES';
	var REQUEST_CITIES = exports.REQUEST_CITIES = 'REQUEST_CITIES';
	var RECEIVE_SHOPS = exports.RECEIVE_SHOPS = 'RECEIVE_SHOPS';
	var RECEIVE_SHOP = exports.RECEIVE_SHOP = 'RECEIVE_SHOP';
	var REQUEST_SHOP = exports.REQUEST_SHOP = 'REQUEST_SHOP';
	var REQUEST_SHOPS = exports.REQUEST_SHOPS = 'REQUEST_SHOPS';
	var REQUEST_BARBERS = exports.REQUEST_BARBERS = 'REQUEST_BARBERS';
	var REQUEST_BARBER = exports.REQUEST_BARBER = 'REQUEST_BARBER';
	var RECEIVE_BARBERS = exports.RECEIVE_BARBERS = 'RECEIVE_BARBERS';
	var RECEIVE_BARBER = exports.RECEIVE_BARBER = 'RECEIVE_BARBER';
	var RECEIVE_BARBERS_TIMES = exports.RECEIVE_BARBERS_TIMES = 'RECEIVE_BARBERS_TIMES';
	var CLEAR_BARBER_AVAILABILITY = exports.CLEAR_BARBER_AVAILABILITY = 'CLEAR_BARBER_AVAILABILITY';
	var REQUEST_BARBER_AVAILABILITY = exports.REQUEST_BARBER_AVAILABILITY = 'REQUEST_BARBER_AVAILABILITY';
	var RECEIVE_BARBER_AVAILABILITY = exports.RECEIVE_BARBER_AVAILABILITY = 'RECEIVE_BARBER_AVAILABILITY';
	var REQUEST_SERVICES = exports.REQUEST_SERVICES = 'REQUEST_SERVICES';
	var RECEIVE_SERVICES = exports.RECEIVE_SERVICES = 'RECEIVE_SERVICES';
	var REQUEST_SERVICE = exports.REQUEST_SERVICE = 'REQUEST_SERVICE';
	var RECEIVE_SERVICE = exports.RECEIVE_SERVICE = 'RECEIVE_SERVICE';
	var ALL_SERVICES_FETCHED = exports.ALL_SERVICES_FETCHED = 'ALL_SERVICES_FETCHED';
	var SET_ACTIVE_DAY = exports.SET_ACTIVE_DAY = 'SET_ACTIVE_DAY';
	var SET_ACTIVE_TIME = exports.SET_ACTIVE_TIME = 'SET_ACTIVE_TIME';
	var SET_ACTIVE_TIME_BARBER = exports.SET_ACTIVE_TIME_BARBER = 'SET_ACTIVE_TIME_BARBER';
	var RESET_TIP = exports.RESET_TIP = 'RESET_TIP';
	var SET_TIPS = exports.SET_TIPS = 'SET_TIPS';
	var SET_TIP = exports.SET_TIP = 'SET_TIP';
	var SET_CUSTOM_TIP = exports.SET_CUSTOM_TIP = 'SET_CUSTOM_TIP';
	var SET_SERVICES = exports.SET_SERVICES = 'SET_SERVICES';
	var SET_TOTAL = exports.SET_TOTAL = 'SET_TOTAL';
	var SET_TOTAL_WITHOUT_TIP_AND_FEES = exports.SET_TOTAL_WITHOUT_TIP_AND_FEES = 'SET_TOTAL_WITHOUT_TIP_AND_FEES';
	var ADD_FIELD = exports.ADD_FIELD = 'ADD_FIELD';
	var TOUCH_FIELD = exports.TOUCH_FIELD = 'TOUCH_FIELD';
	var VALIDATE_FIELD = exports.VALIDATE_FIELD = 'VALIDATE_FIELD';
	var UPDATE_FIELD = exports.UPDATE_FIELD = 'UPDATE_FIELD';
	var RESET_FIELDS = exports.RESET_FIELDS = 'RESET_FIELDS';
	var CREATE_RESERVATION = exports.CREATE_RESERVATION = 'CREATE_RESERVATION';
	var REQUEST_RESERVATION = exports.REQUEST_RESERVATION = 'REQUEST_RESERVATION';
	var RECEIVE_RESERVATION = exports.RECEIVE_RESERVATION = 'RECEIVE_RESERVATION';
	var CANCEL_RESERVATION = exports.CANCEL_RESERVATION = 'CANCEL_RESERVATION';
	var REQUEST_BARBER_AVAILABLE_TIME = exports.REQUEST_BARBER_AVAILABLE_TIME = 'REQUEST_BARBER_AVAILABLE_TIME';
	var RECEIVE_BARBER_AVAILABLE_TIME = exports.RECEIVE_BARBER_AVAILABLE_TIME = 'RECEIVE_BARBER_AVAILABLE_TIME';
	var VERIFY_EMAIL = exports.VERIFY_EMAIL = 'VERIFY_EMAIL';
	var CONFIRM_BARBER = exports.CONFIRM_BARBER = 'CONFIRM_BARBER';
	var USER_TOKEN_ERROR = exports.USER_TOKEN_ERROR = 'USER_TOKEN_ERROR';
	var USER_TOKEN_SUCCESS = exports.USER_TOKEN_SUCCESS = 'USER_TOKEN_SUCCESS';
	var VERIFY_PASSWORD = exports.VERIFY_PASSWORD = 'VERIFY_PASSWORD';
	var VERIFY_PASSWORD_SUCCESS = exports.VERIFY_PASSWORD_SUCCESS = 'VERIFY_PASSWORD_SUCCESS';
	var VERIFY_PASSWORD_ERROR = exports.VERIFY_PASSWORD_ERROR = 'VERIFY_PASSWORD_ERROR';
	var PROCESS_PAYMENT = exports.PROCESS_PAYMENT = 'PROCESS_PAYMENT';
	var PROCESS_PAYMENT_SUCCESS = exports.PROCESS_PAYMENT_SUCCESS = 'PROCESS_PAYMENT_SUCCESS';
	var RESET_PROCESS_PAYMENT = exports.RESET_PROCESS_PAYMENT = 'RESET_PROCESS_PAYMENT';
	var UPDATE_FILTER = exports.UPDATE_FILTER = 'UPDATE_FILTER';
	var CHECK_TIME_AVAILABLE = exports.CHECK_TIME_AVAILABLE = 'CHECK_TIME_AVAILABLE';
	var TIME_AVAILABLE = exports.TIME_AVAILABLE = 'TIME_AVAILABLE';
	var TIME_UNAVAILABLE = exports.TIME_UNAVAILABLE = 'TIME_UNAVAILABLE';
	var VALIDATING_APPT_REQUEST_STARTED = exports.VALIDATING_APPT_REQUEST_STARTED = 'VALIDATING_APPT_REQUEST_STARTED';
	var VALIDATING_APPT_REQUEST_FINISHED = exports.VALIDATING_APPT_REQUEST_FINISHED = 'VALIDATING_APPT_REQUEST_FINISHED';
	var FAILED_CHARGES = exports.FAILED_CHARGES = 'FAILED_CHARGES';
	var FAILED_BOOK_AND_RESERVE = exports.FAILED_BOOK_AND_RESERVE = 'FAILED_BOOK_AND_RESERVE';
	var SET_APPLE_PAY = exports.SET_APPLE_PAY = 'SET_APPLE_PAY';
	var RESET_PROMO_CODE = exports.RESET_PROMO_CODE = 'RESET_PROMO_CODE';
	var SET_PROMO_CODE = exports.SET_PROMO_CODE = 'SET_PROMO_CODE';
	var SET_GIFT_CARD_CODE = exports.SET_GIFT_CARD_CODE = 'SET_GIFT_CARD_CODE';
	var FETCH_PROMO_CODE = exports.FETCH_PROMO_CODE = 'FETCH_PROMO_CODE';
	var INVALID_PROMO_CODE = exports.INVALID_PROMO_CODE = 'INVALID_PROMO_CODE';
	var RESET_FEE = exports.RESET_FEE = 'RESET_FEE';
	var FETCH_FEE = exports.FETCH_FEE = 'FETCH_FEE';
	var ADD_CUSTOMER_TO_WAITING_LIST = exports.ADD_CUSTOMER_TO_WAITING_LIST = 'ADD_CUSTOMER_TO_WAITING_LIST';
	var BOOK_APPOINTMENT_TIME_SLOT = exports.BOOK_APPOINTMENT_TIME_SLOT = 'BOOK_APPOINTMENT_TIME_SLOT';
	var BOOK_APPOINTMENT_TIME_SLOT_SUCCESS = exports.BOOK_APPOINTMENT_TIME_SLOT_SUCCESS = 'BOOK_APPOINTMENT_TIME_SLOT_SUCCESS';
	var REMOVE_CUSTOMER_FROM_WAITING_LIST = exports.REMOVE_CUSTOMER_FROM_WAITING_LIST = 'REMOVE_CUSTOMER_FROM_WAITING_LIST';
	var REMOVE_CUSTOMER_FROM_WAITING_LIST_SUCCESS = exports.REMOVE_CUSTOMER_FROM_WAITING_LIST_SUCCESS = 'REMOVE_CUSTOMER_FROM_WAITING_LIST_SUCCESS';
	var CONFIRM_BARBER_SUCCESS = exports.CONFIRM_BARBER_SUCCESS = 'CONFIRM_BARBER_SUCCESS';
	var FETCH_RECEIPT = exports.FETCH_RECEIPT = 'FETCH_RECEIPT';
	var FETCH_RECEIPT_SUCCESS = exports.FETCH_RECEIPT_SUCCESS = 'FETCH_RECEIPT_SUCCESS';
	var CLEAR_WAITING_LIST_INFO = exports.CLEAR_WAITING_LIST_INFO = 'CLEAR_WAITING_LIST_INFO';
	var SET_WAITING_LIST_INFO = exports.SET_WAITING_LIST_INFO = 'SET_WAITING_LIST_INFO';
	var CLEAR_WAITING_LIST_TIMES = exports.CLEAR_WAITING_LIST_TIMES = 'CLEAR_WAITING_LIST_TIMES';
	var SET_WAITING_LIST_TIMES = exports.SET_WAITING_LIST_TIMES = 'SET_WAITING_LIST_TIMES';
	var FETCH_CAMPAIGN = exports.FETCH_CAMPAIGN = 'FETCH_CAMPAIGN';
	var FETCH_CAMPAIGN_SUCCESS = exports.FETCH_CAMPAIGN_SUCCESS = 'FETCH_CAMPAIGN_SUCCESS';
	var CAMPAIGN_UNSUBSCRIBE = exports.CAMPAIGN_UNSUBSCRIBE = 'CAMPAIGN_UNSUBSCRIBE';
	var CAMPAIGN_UNSUBSCRIBE_SUCCESS = exports.CAMPAIGN_UNSUBSCRIBE_SUCCESS = 'CAMPAIGN_UNSUBSCRIBE_SUCCESS';
	var CAMPAIGN_UNSUBSCRIBE_ERROR = exports.CAMPAIGN_UNSUBSCRIBE_ERROR = 'CAMPAIGN_UNSUBSCRIBE_ERROR';
	var REQUEST_DAYS_OFF = exports.REQUEST_DAYS_OFF = 'REQUEST_DAYS_OFF';
	var RECEIVE_DAYS_OFF = exports.RECEIVE_DAYS_OFF = 'RECEIVE_DAYS_OFF';
	var SET_PROCESSING = exports.SET_PROCESSING = 'SET_PROCESSING';
	var RESCHEDULE_INVALID_PROMO_ERROR = exports.RESCHEDULE_INVALID_PROMO_ERROR = 'RESCHEDULE_INVALID_PROMO_ERROR';
	var SET_TAX_BREAKDOWN = exports.SET_TAX_BREAKDOWN = 'SET_TAX_BREAKDOWN';
	var RESET_PROMO_ERROR = exports.RESET_PROMO_ERROR = 'RESET_PROMO_ERROR';
	var REMOVE_PROMO_FROM_RESERVATION = exports.REMOVE_PROMO_FROM_RESERVATION = 'REMOVE_PROMO_FROM_RESERVATION';
	var THIRD_PARTY_PROMO = exports.THIRD_PARTY_PROMO = 'THIRD_PARTY_PROMO';
	var SET_MEMBERSHIP_DISCOUNTS = exports.SET_MEMBERSHIP_DISCOUNTS = 'SET_MEMBERSHIP_DISCOUNTS';

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getNoExtrasForReserveNoPay = exports.getGiftCardEnabled = exports.getShopLogo = exports.getShopWeekdaysOff = exports.getShopDayEnabled = exports.getShopSchedules = exports.getShopLocation = exports.getShopZip = exports.getShopCountry = exports.getShopAddress = exports.getShopCurrency = exports.getShopAdvanceBookDays = exports.getIsPayFacShop = exports.getIsChopMurrayHillShop = exports.getIsKrwnZazzPlaceSteFoyShop = exports.getIsLadyClipperShop = exports.getHasWaitingListEnabled = exports.getHasShopLoyaltyProgram = exports.getHasPromotionsEnabled = exports.getIsSquireFeeShop = exports.areGcSalesDisabledForBarber = exports.getShops = exports.getShopRoute = exports.getShopBrandId = exports.getShopId = exports.getAllowMultipleServices = exports.getAllowBookWithAnyBarber = exports.getShopAllowBookWithAnyBarber = exports.getImage = exports.getAdultsOnly = exports.getShopName = exports.getShopAllowBookAndReserve = exports.getShopBookNoPay = exports.getShopTimezone = exports.getShopByRoute = exports.getShopById = undefined;
	
	var _prop2 = __webpack_require__(88);
	
	var _prop3 = _interopRequireDefault(_prop2);
	
	var _pipe2 = __webpack_require__(75);
	
	var _pipe3 = _interopRequireDefault(_pipe2);
	
	var _none2 = __webpack_require__(752);
	
	var _none3 = _interopRequireDefault(_none2);
	
	var _equals2 = __webpack_require__(107);
	
	var _equals3 = _interopRequireDefault(_equals2);
	
	var _complement2 = __webpack_require__(357);
	
	var _complement3 = _interopRequireDefault(_complement2);
	
	var _both2 = __webpack_require__(356);
	
	var _both3 = _interopRequireDefault(_both2);
	
	var _flow2 = __webpack_require__(125);
	
	var _flow3 = _interopRequireDefault(_flow2);
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _sortBy2 = __webpack_require__(351);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _haversine = __webpack_require__(1320);
	
	var _haversine2 = _interopRequireDefault(_haversine);
	
	var _schedule = __webpack_require__(199);
	
	var _helpers = __webpack_require__(7);
	
	var _constants = __webpack_require__(10);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getShopById = exports.getShopById = function getShopById(state, id) {
	  return state.shops.items.find(function (shop) {
	    return shop.id === id;
	  });
	};
	
	var getShopByRoute = exports.getShopByRoute = function getShopByRoute(state, route) {
	  return state.shops.items.find(function (shop) {
	    return shop.route === route;
	  });
	};
	
	var getShopProp = function getShopProp(state, route, property, fallback) {
	  return (0, _get3.default)(getShopByRoute(state, route), property, fallback);
	};
	
	var getShopTimezone = exports.getShopTimezone = function getShopTimezone(state, route) {
	  return getShopProp(state, route, 'timezone');
	};
	
	var getShopBookNoPay = exports.getShopBookNoPay = function getShopBookNoPay(state, route) {
	  return getShopProp(state, route, 'bookNoPay');
	};
	
	var getShopAllowBookAndReserve = exports.getShopAllowBookAndReserve = function getShopAllowBookAndReserve(state, route) {
	  return getShopProp(state, route, 'allowBookAndReserve');
	};
	
	var getShopName = exports.getShopName = function getShopName(state, route) {
	  return getShopProp(state, route, 'name');
	};
	
	var getAdultsOnly = exports.getAdultsOnly = function getAdultsOnly(state, route) {
	  return getShopProp(state, route, 'adultsOnly');
	};
	
	var getImage = exports.getImage = function getImage(state, route) {
	  return getShopProp(state, route, 'photos[0].url]');
	};
	
	var getShopAllowBookWithAnyBarber = exports.getShopAllowBookWithAnyBarber = (0, _both3.default)((0, _prop3.default)('allowBookWithAnyBarber'), (0, _pipe3.default)((0, _prop3.default)('services'), (0, _complement3.default)(_isEmpty3.default)));
	
	var getAllowBookWithAnyBarber = exports.getAllowBookWithAnyBarber = (0, _pipe3.default)(getShopByRoute, getShopAllowBookWithAnyBarber);
	
	var getAllowMultipleServices = exports.getAllowMultipleServices = function getAllowMultipleServices(state, route) {
	  return getShopProp(state, route, 'allowMultipleServices');
	};
	
	var getShopId = exports.getShopId = function getShopId(state, route) {
	  return getShopProp(state, route, 'id');
	};
	var getShopBrandId = exports.getShopBrandId = function getShopBrandId(state, route) {
	  return getShopProp(state, route, 'brandId');
	};
	
	var getShopRoute = exports.getShopRoute = function getShopRoute(state, id) {
	  var shop = getShopById(state, id);
	  if (!shop) return null;
	  return shop.route;
	};
	
	var getDistance = function getDistance(shop, position) {
	  return (0, _haversine2.default)({ latitude: (0, _get3.default)(shop, 'location.coordinates[0]'),
	    longitude: (0, _get3.default)(shop, 'location.coordinates[1]') }, { latitude: (0, _get3.default)(position, 'lat'), longitude: (0, _get3.default)(position, 'lng') }, { unit: 'mile' });
	};
	
	var getShop = function getShop(shop, position) {
	  return _extends({}, shop, { distance: getDistance(shop, position) });
	};
	
	var getShops = exports.getShops = function getShops(state) {
	  var position = state.position;
	  var shops = state.shops.items.map(function (item) {
	    return getShop(item, position);
	  });
	  return (0, _sortBy3.default)(shops, 'distance');
	};
	
	var areGcSalesDisabledForBarber = exports.areGcSalesDisabledForBarber = function areGcSalesDisabledForBarber(state) {
	  return (0, _none3.default)((0, _pipe3.default)((0, _prop3.default)('barberSpecificGC'), (0, _equals3.default)(true)))(getShops(state));
	};
	
	var getIsSquireFeeShop = exports.getIsSquireFeeShop = function getIsSquireFeeShop(state, route) {
	  var shopId = getShopId(state, route);
	  return _constants.SQUIRE_FEE_SHOPS.some(function (shop) {
	    return shop === shopId;
	  });
	};
	
	var getHasPromotionsEnabled = exports.getHasPromotionsEnabled = function getHasPromotionsEnabled(state, route) {
	  return !_constants.NO_PROMO_BOX_SHOPS.some(function (shop) {
	    return shop === getShopId(state, route);
	  });
	};
	
	var getHasShopLoyaltyProgram = exports.getHasShopLoyaltyProgram = function getHasShopLoyaltyProgram(state, route) {
	  var reward = getShopProp(state, route, 'reward');
	  return reward && reward.enabled;
	};
	
	var getHasWaitingListEnabled = exports.getHasWaitingListEnabled = function getHasWaitingListEnabled(state, route) {
	  return getShopProp(state, route, 'waiting_lists[0].enabled', false);
	};
	
	var getIsLadyClipperShop = exports.getIsLadyClipperShop = function getIsLadyClipperShop(state, route) {
	  return getShopProp(state, route, 'id') === _constants.LADY_CLIPPER_SHOP_ID;
	};
	var getIsKrwnZazzPlaceSteFoyShop = exports.getIsKrwnZazzPlaceSteFoyShop = function getIsKrwnZazzPlaceSteFoyShop(state, route) {
	  return getShopProp(state, route, 'id') === _constants.KRWN_ZAZZ_PLACE_STE_FOY_SHOP_ID;
	};
	var getIsChopMurrayHillShop = exports.getIsChopMurrayHillShop = function getIsChopMurrayHillShop(state, route) {
	  return getShopProp(state, route, 'id') === _constants.CHOP_MURRAY_HILL_SHOP_ID;
	};
	var getIsPayFacShop = exports.getIsPayFacShop = function getIsPayFacShop(state, route) {
	  return _config2.default.payFacBrands.includes(getShopProp(state, route, 'brandId'));
	};
	
	var getShopAdvanceBookDays = exports.getShopAdvanceBookDays = function getShopAdvanceBookDays(state, route) {
	  return getShopProp(state, route, 'advanceBookDays', 7);
	};
	var getShopCurrency = exports.getShopCurrency = function getShopCurrency(state, route) {
	  return getShopProp(state, route, 'currency', '');
	};
	var getShopAddress = exports.getShopAddress = function getShopAddress(state, route) {
	  return getShopProp(state, route, 'address');
	};
	var getShopCountry = exports.getShopCountry = function getShopCountry(state, route) {
	  return getShopProp(state, route, 'country');
	};
	
	var getShopZip = exports.getShopZip = function getShopZip(state, route) {
	  return getShopProp(state, route, 'zip');
	};
	
	var getShopLocation = exports.getShopLocation = function getShopLocation(state, route) {
	  return getShopProp(state, route, 'location');
	};
	
	var getShopSchedules = exports.getShopSchedules = function getShopSchedules(state, route) {
	  return getShopProp(state, route, 'schedules');
	};
	
	var getShopScheduleWeekdays = function getShopScheduleWeekdays(state, route) {
	  return (0, _flow3.default)(getShopSchedules, _schedule.getScheduleWeekdaysFromSchedule)(state, route);
	};
	
	var getShopDayEnabled = exports.getShopDayEnabled = function getShopDayEnabled(state, route, activeDay) {
	  return (0, _flow3.default)(getShopScheduleWeekdays, function (weekdays) {
	    return (0, _schedule.isWeekdayEnabled)((0, _helpers.getStartOfDay)(activeDay), weekdays);
	  })(state, route);
	};
	
	var getShopWeekdaysOff = exports.getShopWeekdaysOff = function getShopWeekdaysOff(state, route) {
	  return (0, _flow3.default)(getShopSchedules, _schedule.getScheduleWeekdaysOffFromSchedule)(state, route);
	};
	
	var getShopLogo = exports.getShopLogo = function getShopLogo(state, id) {
	  return (0, _flow3.default)(getShopById, function (item) {
	    return (0, _get3.default)(item, 'logo.url');
	  })(state, id);
	};
	
	var getGiftCardEnabled = exports.getGiftCardEnabled = function getGiftCardEnabled(state, route) {
	  return getShopProp(state, route, 'giftCardEnabled');
	};
	
	var getNoExtrasForReserveNoPay = exports.getNoExtrasForReserveNoPay = function getNoExtrasForReserveNoPay(state, route) {
	  return getShopProp(state, route, 'noExtrasForBookNoPay');
	};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _wrapDisplayName = __webpack_require__(79);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _setDisplayName = __webpack_require__(69);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _mapProps = __webpack_require__(1747);
	
	var _mapProps2 = _interopRequireDefault(_mapProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withProps = function withProps(input) {
	  var hoc = (0, _mapProps2.default)(function (props) {
	    return _extends({}, props, typeof input === 'function' ? input(props) : input);
	  });
	  if (false) {
	    return function (BaseComponent) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withProps'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	exports.default = withProps;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setDisplayName = __webpack_require__(69);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(79);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createEagerFactory = __webpack_require__(78);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var identity = function identity(Component) {
	  return Component;
	};
	
	var branch = function branch(test, left) {
	  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
	  return function (BaseComponent) {
	    var leftFactory = void 0;
	    var rightFactory = void 0;
	    var Branch = function Branch(props) {
	      if (test(props)) {
	        leftFactory = leftFactory || (0, _createEagerFactory2.default)(left(BaseComponent));
	        return leftFactory(props);
	      }
	      rightFactory = rightFactory || (0, _createEagerFactory2.default)(right(BaseComponent));
	      return rightFactory(props);
	    };
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'branch'))(Branch);
	    }
	    return Branch;
	  };
	};
	
	exports.default = branch;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _setDisplayName = __webpack_require__(69);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(79);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createEagerFactory = __webpack_require__(78);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-console */
	
	
	var lifecycle = function lifecycle(spec) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    if (false) {
	      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
	    }
	
	    var Lifecycle = function (_Component) {
	      _inherits(Lifecycle, _Component);
	
	      function Lifecycle() {
	        _classCallCheck(this, Lifecycle);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        var _this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args)));
	
	        Object.assign(_this, spec);
	        return _this;
	      }
	
	      Lifecycle.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.state));
	      };
	
	      return Lifecycle;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'lifecycle'))(Lifecycle);
	    }
	    return Lifecycle;
	  };
	};
	
	exports.default = lifecycle;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var _isPlaceholder = /*#__PURE__*/__webpack_require__(241);
	
	/**
	 * Optimized internal two-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	
	
	function _curry2(fn) {
	  return function f2(a, b) {
	    switch (arguments.length) {
	      case 0:
	        return f2;
	      case 1:
	        return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
	          return fn(a, _b);
	        });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
	          return fn(_a, b);
	        }) : _isPlaceholder(b) ? _curry1(function (_b) {
	          return fn(a, _b);
	        }) : fn(a, b);
	    }
	  };
	}
	module.exports = _curry2;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(541);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(65);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(1725);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(1287);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(1685);
	
	var _HelmetConstants = __webpack_require__(781);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTaxBreakdownAmount = exports.getTaxBreakdown = exports.getProcessing = exports.getPaymentProcessing = exports.getIsPaid = exports.getCustomerEmail = exports.getTotalWithTip = exports.getTipAmount = exports.getDiscountPromo = exports.getTaxAmount = exports.getItems = exports.getBookAndPayCopy = exports.getScheduleLink = exports.getRebookLink = exports.getBookedWithAnyBarber = exports.getServiceDuration = exports.getServices = exports.getBarberId = exports.getPromoCode = exports.getServicesCost = exports.getActiveTipAmount = exports.getActiveTip = exports.getTips = exports.getCustomTip = exports.getHasCustomTip = exports.getBarberWeekdaysOff = exports.getBarberDaysOnAsDates = exports.getBarberDaysOffAsDates = exports.canBeChargedWithSavedCard = exports.getServiceIds = exports.getServiceId = exports.getBarberRoute = exports.getShopRoute = exports.getAppointmentShop = exports.getAppointmentCanceled = exports.getBarberAdvanceBookDays = exports.getAppointmentInFuture = exports.getAppointmentTime = exports.getCanCustomerCancel = exports.getBarberAdvanceCancelMins = exports.getCustomer = exports.getShopTimezone = exports.getShopId = exports.getShopName = exports.getShopBrandId = exports.getShopObject = exports.getShopImage = exports.getShopLogo = exports.getShop = exports.getServiceName = exports.getBarberName = exports.isAppointmentPaid = exports.getAppointmentId = exports.getAppointment = exports.getAppointmentStart = exports.getAppointmentTimeInUrlFormat = exports.getAppointmentDateTime = exports.getTimezone = exports.getIsValidatingAppointment = exports.getTotalAmountWithoutTipAndFees = exports.getTotalAmount = exports.getGiftCardAmount = exports.getGiftCardBalance = exports.getTotalMembershipDiscount = exports.getPromoAmount = exports.getUser = exports.getIsFormPristine = exports.getIsFormValid = undefined;
	
	var _prop2 = __webpack_require__(88);
	
	var _prop3 = _interopRequireDefault(_prop2);
	
	var _unless2 = __webpack_require__(757);
	
	var _unless3 = _interopRequireDefault(_unless2);
	
	var _path2 = __webpack_require__(87);
	
	var _path3 = _interopRequireDefault(_path2);
	
	var _always2 = __webpack_require__(354);
	
	var _always3 = _interopRequireDefault(_always2);
	
	var _ifElse2 = __webpack_require__(358);
	
	var _ifElse3 = _interopRequireDefault(_ifElse2);
	
	var _pipe2 = __webpack_require__(75);
	
	var _pipe3 = _interopRequireDefault(_pipe2);
	
	var _join2 = __webpack_require__(579);
	
	var _join3 = _interopRequireDefault(_join2);
	
	var _map3 = __webpack_require__(232);
	
	var _map4 = _interopRequireDefault(_map3);
	
	var _find2 = __webpack_require__(576);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _flow2 = __webpack_require__(125);
	
	var _flow3 = _interopRequireDefault(_flow2);
	
	var _sumBy2 = __webpack_require__(352);
	
	var _sumBy3 = _interopRequireDefault(_sumBy2);
	
	var _isNumber2 = __webpack_require__(1488);
	
	var _isNumber3 = _interopRequireDefault(_isNumber2);
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _map5 = __webpack_require__(74);
	
	var _map6 = _interopRequireDefault(_map5);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _momentTimezone = __webpack_require__(67);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _immutable = __webpack_require__(66);
	
	var _helpers = __webpack_require__(7);
	
	var _selectors = __webpack_require__(27);
	
	var barberSelectors = _interopRequireWildcard(_selectors);
	
	var _constants = __webpack_require__(10);
	
	var _schedule = __webpack_require__(199);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _selectors2 = __webpack_require__(11);
	
	var _selectors3 = __webpack_require__(51);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getIsFormValid = exports.getIsFormValid = function getIsFormValid(state) {
	  return state.reservation.get('fields').every(function (field) {
	    return field.get('touched') && !field.get('error');
	  });
	};
	
	var getIsFormPristine = exports.getIsFormPristine = function getIsFormPristine(state) {
	  return state.reservation.get('fields').every(function (field) {
	    return !field.get('touched') && !field.get('value');
	  });
	};
	
	var getUser = exports.getUser = function getUser(state) {
	  return state.reservation.get('fields').reduce(function (result, field) {
	    var user = _extends({}, result);
	    user[field.get('id')] = field.get('value') || '';
	    return user;
	  }, {});
	};
	
	var getPromoAmount = exports.getPromoAmount = function getPromoAmount(state, serviceCost, taxes) {
	  return Math.min(state.reservation.getIn(['promo', 'amount']), serviceCost + taxes);
	};
	
	var getTotalMembershipDiscount = exports.getTotalMembershipDiscount = function getTotalMembershipDiscount(state) {
	  var membershipsDiscounts = state.reservation.get('membershipDiscounts');
	  return (0, _sumBy3.default)(membershipsDiscounts, 'amount');
	};
	
	var getGiftCardBalance = exports.getGiftCardBalance = function getGiftCardBalance(state) {
	  return state.reservation.getIn(['giftCard', 'remainingAmount']);
	};
	
	var getGiftCardAmount = exports.getGiftCardAmount = function getGiftCardAmount(state) {
	  return state.reservation.getIn(['giftCard', 'appliedAmount']);
	};
	
	var getTotalAmount = exports.getTotalAmount = function getTotalAmount(state) {
	  return state.reservation.get('total');
	};
	var getTotalAmountWithoutTipAndFees = exports.getTotalAmountWithoutTipAndFees = function getTotalAmountWithoutTipAndFees(state) {
	  return state.reservation.get('totalWithoutTipAndFees');
	};
	
	var getIsValidatingAppointment = exports.getIsValidatingAppointment = function getIsValidatingAppointment(state) {
	  return state.reservation.get('outstandingAppointmentValidateRequests').size > 0;
	};
	
	var getTimezone = exports.getTimezone = function getTimezone(state) {
	  return state.reservation.getIn(['appointment', 'shop', 'timezone']);
	};
	
	var getAppointmentDateTime = exports.getAppointmentDateTime = function getAppointmentDateTime(state) {
	  return state.reservation.getIn(['appointment', 'dateTime']);
	};
	var getAppointmentTimeInUrlFormat = exports.getAppointmentTimeInUrlFormat = function getAppointmentTimeInUrlFormat(state) {
	  return (0, _momentTimezone2.default)(state.reservation.getIn(['appointment', 'dateTime'])).format(_config2.default.timeSlugFormat);
	};
	
	var getAppointmentStart = exports.getAppointmentStart = function getAppointmentStart(state) {
	  return _momentTimezone2.default.tz(getAppointmentDateTime(state), getTimezone(state));
	};
	
	var getAppointmentService = function getAppointmentService(state) {
	  return state.reservation.getIn(['appointment', 'appointment_service']);
	};
	var getAppointmentConfCode = function getAppointmentConfCode(state) {
	  return state.reservation.getIn(['appointment', 'confirmationCode']);
	};
	
	var getAppointment = exports.getAppointment = function getAppointment(state) {
	  var duration = state.reservation.getIn(['appointment', 'duration']);
	  var start = getAppointmentStart(state);
	
	  return {
	    formatted: start.format(_config2.default.dateTimeFormatLong),
	    start: start.format(),
	    formattedDuration: (0, _helpers.formatDuration)(duration),
	    duration: duration,
	    appointment_service: getAppointmentService(state),
	    confirmationCode: getAppointmentConfCode(state)
	  };
	};
	
	var getAppointmentId = exports.getAppointmentId = function getAppointmentId(state) {
	  return state.reservation.getIn(['appointment', 'id']);
	};
	var isAppointmentPaid = exports.isAppointmentPaid = function isAppointmentPaid(state) {
	  return !!state.reservation.getIn(['appointment', 'paymentStatus']);
	};
	var getBarberName = exports.getBarberName = function getBarberName(state) {
	  var firstName = state.reservation.getIn(['appointment', 'barber', 'firstName']);
	  var lastName = state.reservation.getIn(['appointment', 'barber', 'lastName']);
	
	  return (firstName || '') + ' ' + (lastName || '');
	};
	
	var getServiceName = exports.getServiceName = (0, _pipe3.default)(function (state) {
	  return state.reservation.getIn(['appointment', 'appointment_service']);
	}, (0, _ifElse3.default)(_isEmpty3.default, (0, _always3.default)(''), (0, _pipe3.default)(function (item) {
	  return item.toJS();
	}, (0, _map4.default)('name'), (0, _join3.default)(', '))));
	
	var getShop = exports.getShop = (0, _pipe3.default)(function (state) {
	  return state.reservation.getIn(['appointment', 'shop']);
	}, (0, _ifElse3.default)(_isEmpty3.default, (0, _always3.default)({}), (0, _pipe3.default)(function (item) {
	  return item.toJS();
	}, _helpers.transformShopLocation)));
	
	var getShopLogo = exports.getShopLogo = (0, _pipe3.default)(getShop, (0, _path3.default)(['logo', 'url']));
	
	var getShopImage = exports.getShopImage = (0, _pipe3.default)(getShop, (0, _path3.default)(['photos', 0, 'url']));
	
	var getShopObject = exports.getShopObject = function getShopObject(state) {
	  var shop = state.reservation.getIn(['appointment', 'shop']);
	  return shop && shop.toJS();
	};
	
	var getShopBrandId = exports.getShopBrandId = function getShopBrandId(state) {
	  var brandId = state.reservation.getIn(['appointment', 'shop', 'brandId']);
	  return brandId;
	};
	
	var getShopName = exports.getShopName = function getShopName(state) {
	  return state.reservation.getIn(['appointment', 'shop', 'name']);
	};
	
	var getShopId = exports.getShopId = function getShopId(state) {
	  return state.reservation.getIn(['appointment', 'shop', 'id']);
	};
	
	var getShopTimezone = exports.getShopTimezone = function getShopTimezone(state) {
	  return state.reservation.getIn(['appointment', 'shop', 'timezone']);
	};
	
	var getCustomer = exports.getCustomer = function getCustomer(state) {
	  var id = state.reservation.getIn(['appointment', 'customer', 'id']);
	  var firstName = state.reservation.getIn(['appointment', 'customer', 'firstName']);
	  var lastName = state.reservation.getIn(['appointment', 'customer', 'lastName']);
	  var name = firstName && lastName && firstName + ' ' + lastName;
	  var email = state.reservation.getIn(['appointment', 'customer', 'email']);
	
	  return { name: name, email: email, id: id };
	};
	
	var getBarberAdvanceCancelMins = exports.getBarberAdvanceCancelMins = function getBarberAdvanceCancelMins(state) {
	  return state.reservation.getIn(['appointment', 'barber', 'advanceCancelMins']);
	};
	
	var getCanCustomerCancel = exports.getCanCustomerCancel = function getCanCustomerCancel(state) {
	  return state.reservation.getIn(['appointment', 'barber', 'canCustomerCancel']);
	};
	
	var getAppointmentTime = exports.getAppointmentTime = function getAppointmentTime(state) {
	  return state.reservation.getIn(['appointment', 'dateTime']);
	};
	
	var getAppointmentInFuture = exports.getAppointmentInFuture = function getAppointmentInFuture(state) {
	  var dateTime = getAppointmentTime(state);
	  var timezone = state.reservation.getIn(['appointment', 'shop', 'timezone']);
	
	  return _momentTimezone2.default.tz(dateTime, timezone).isAfter((0, _momentTimezone2.default)());
	};
	
	var getBarberAdvanceBookDays = exports.getBarberAdvanceBookDays = function getBarberAdvanceBookDays(state) {
	  return state.reservation.getIn(['appointment', 'barber', 'advanceBookDays']);
	};
	
	var getAppointmentCanceled = exports.getAppointmentCanceled = function getAppointmentCanceled(state) {
	  return state.reservation.getIn(['appointment', 'status']) === 1;
	};
	
	var getAppointmentShop = exports.getAppointmentShop = function getAppointmentShop(state) {
	  return state.reservation.getIn(['appointment', 'shop']);
	};
	var getShopRoute = exports.getShopRoute = function getShopRoute(state) {
	  return state.reservation.getIn(['appointment', 'shop', 'route']);
	};
	var getBarberRoute = exports.getBarberRoute = function getBarberRoute(state) {
	  return state.reservation.getIn(['appointment', 'barber', 'route']);
	};
	var getServiceId = exports.getServiceId = function getServiceId(state) {
	  return state.reservation.getIn(['appointment', 'appointment_service', 0, 'serviceId']);
	};
	var getServiceIds = exports.getServiceIds = function getServiceIds(state) {
	  return (state.reservation.getIn(['appointment', 'appointment_service']) || new _immutable.Map()).map(function (as) {
	    return as.getIn(['serviceId']);
	  }).join(';');
	};
	var canBeChargedWithSavedCard = exports.canBeChargedWithSavedCard = function canBeChargedWithSavedCard(state) {
	  return state.reservation.getIn(['appointment', 'canBeChargedWithSavedCard']);
	};
	
	var getBarberDaysOff = function getBarberDaysOff(state) {
	  var daysOff = state.reservation.getIn(['appointment', 'barber', 'days_off']);
	  if (!daysOff || !daysOff.size) return [];
	  return (0, _schedule.getWholeDaysOff)(daysOff.toJS());
	};
	
	var mapDaysStringToDate = function mapDaysStringToDate(days) {
	  return (0, _map6.default)(days, function (item) {
	    return (0, _momentTimezone2.default)(item, _config2.default.apiDateFormat).toDate();
	  });
	};
	var getBarberDaysOffAsDates = exports.getBarberDaysOffAsDates = (0, _flow3.default)(getBarberDaysOff, mapDaysStringToDate);
	
	var getBarberDaysOn = function getBarberDaysOn(state) {
	  var daysOn = state.reservation.getIn(['appointment', 'barber', 'days_on']);
	  if (!daysOn || !daysOn.size) return [];
	  return daysOn.toJS();
	};
	
	var getBarberDaysOnAsDates = exports.getBarberDaysOnAsDates = (0, _flow3.default)(getBarberDaysOn, function (items) {
	  return (0, _map6.default)(items, function (item) {
	    return (0, _get3.default)(item, 'day');
	  });
	}, mapDaysStringToDate);
	
	var getBarberSchedules = function getBarberSchedules(state) {
	  var schedules = state.reservation.getIn(['appointment', 'barber', 'schedules']);
	  return schedules && schedules.toJS();
	};
	
	var getBarberWeekdaysOff = exports.getBarberWeekdaysOff = (0, _flow3.default)(getBarberSchedules, _schedule.getScheduleWeekdaysOffFromSchedule);
	
	var getHasCustomTip = exports.getHasCustomTip = function getHasCustomTip(state) {
	  return state.reservation.get('customTip') > 0;
	};
	var getCustomTip = exports.getCustomTip = function getCustomTip(state) {
	  return state.reservation.get('customTip');
	};
	
	var getTips = exports.getTips = function getTips(state) {
	  return [].concat(_toConsumableArray(state.reservation.get('tips')), [_constants.TIP_NONE]).map(function (tip) {
	    var isNoTip = (0, _isNumber3.default)(tip);
	    var selectedTip = state.reservation.get('tip');
	
	    if (isNoTip) {
	      return {
	        value: tip,
	        desc: 'tip in cash',
	        amount: 0,
	        active: getCustomTip(state) === 0 || tip === selectedTip
	      };
	    }
	
	    if (tip.flatAmount) {
	      return {
	        amount: tip.flatAmount,
	        active: tip.flatAmount === selectedTip,
	        flat: true
	      };
	    }
	
	    return {
	      value: tip.percentage,
	      desc: 'about ' + tip.percentage + '%',
	      amount: tip.amount,
	      active: tip.percentage === selectedTip
	    };
	  });
	};
	var getActiveTip = exports.getActiveTip = function getActiveTip(state) {
	  var customTip = state.reservation.get('customTip');
	  if (customTip) {
	    return {
	      value: 0,
	      desc: 'Custom tip',
	      amount: customTip
	    };
	  }
	
	  return (0, _find3.default)(getTips(state), function (tip) {
	    return tip.active;
	  }) || null;
	};
	var getActiveTipAmount = exports.getActiveTipAmount = function getActiveTipAmount(state) {
	  var activeTip = getActiveTip(state);
	
	  return activeTip ? activeTip.amount : 0;
	};
	
	var getServicesCost = exports.getServicesCost = function getServicesCost(state) {
	  return (0, _sumBy3.default)(state.reservation.get('services'), function (service) {
	    return service.amount;
	  }) || 0;
	};
	
	var getPromoCode = exports.getPromoCode = function getPromoCode(state) {
	  return state.reservation.getIn(['promo', 'promoCode']);
	};
	
	var getBarberId = exports.getBarberId = function getBarberId(state) {
	  return state.reservation.getIn(['appointment', 'barber', 'id']);
	};
	
	var getServices = exports.getServices = function getServices(state) {
	  return state.reservation.getIn(['appointment', 'appointment_service']);
	};
	
	var getServiceDuration = exports.getServiceDuration = function getServiceDuration(state) {
	  return (0, _flow3.default)(getServices, function (item) {
	    return item && item.toJS();
	  }, function (items) {
	    return (0, _sumBy3.default)(items, 'duration');
	  })(state);
	};
	
	var getBookedWithAnyBarber = exports.getBookedWithAnyBarber = function getBookedWithAnyBarber(state) {
	  return state.reservation.getIn(['appointment', 'bookedWithAnyBarber']);
	};
	
	var getRebookLink = exports.getRebookLink = function getRebookLink(state) {
	  return (0, _helpers.generateUrlString)({
	    shopRoute: getShopRoute(state),
	    barberRoute: getBookedWithAnyBarber(state) ? _constants.ANY_BARBER : getBarberRoute(state),
	    serviceId: getServiceId(state)
	  });
	};
	
	var getScheduleLink = exports.getScheduleLink = function getScheduleLink(state) {
	  var shopRoute = getShopRoute(state);
	  var url = (0, _helpers.generateUrlString)({ shopRoute: shopRoute });
	  var bookingUrl = '/book' + url;
	
	  var shop = getAppointmentShop(state);
	  if (!shop || !shop.toJS().allowBookWithAnyBarber) {
	    return bookingUrl + '/barber';
	  }
	
	  return bookingUrl;
	};
	
	var getBookAndPayCopy = exports.getBookAndPayCopy = function getBookAndPayCopy(state, shopRoute, barberRoute, serviceIds, totalAmount, isCoveredByDiscount, isReserveNoPayOnly) {
	  var isServicePrepayRequired = !(0, _selectors3.getSelectedServicesPrepaid)(state, serviceIds);
	  var allowBookAndReserve = (0, _selectors2.getShopAllowBookAndReserve)(state, shopRoute) && !isServicePrepayRequired;
	  var allowBookNoPay = (0, _selectors2.getShopBookNoPay)(state, shopRoute) && !isServicePrepayRequired;
	  var advanceCancelMins = (0, _helpers.formatHours)(barberSelectors.getBarberAdvanceCancelMins(state, barberRoute));
	  var noExtrasForBookNoPay = (0, _selectors2.getNoExtrasForReserveNoPay)(state, shopRoute);
	  var disclaimer = ['You will not be charged should you cancel/reschedule your appointment', advanceCancelMins + ' before your appointment is scheduled to begin.'];
	
	  if (!noExtrasForBookNoPay && isCoveredByDiscount) {
	    return '';
	  }
	
	  var reserveWithCardCopy = ['By selecting "Reserve With Card" you will be able to attach a payment to your', 'reservation, a convenient way to save time on the day of your service.', 'The payment will not process at the time of the booking, but will process', 'at the time of your service.'];
	  var reserveOnlyCopy = ['By selecting "Reserve" you are authorizing the shop to charge for your appointment.'];
	
	  if (isReserveNoPayOnly) {
	    return reserveOnlyCopy.concat(disclaimer).join(' ');
	  }
	
	  var hasTotalAndShowsTips = totalAmount > 0 || noExtrasForBookNoPay;
	  if (allowBookAndReserve) {
	    var reserveAndProvideCardCopy = ['If you select “Reserve” you will still', 'be required to provide your credit/debit card info. You will only be charged if you', 'do not show up to your appointment.'];
	    if (hasTotalAndShowsTips) {
	      var reserveAndPayCopy = ['If you select "Reserve & Pay" your payment will automatically', 'process at the time of your service, saving you and your professional', 'time on the day of your service.'];
	      return reserveAndPayCopy.concat(reserveAndProvideCardCopy).concat(disclaimer).join(' ');
	    }
	    return reserveAndProvideCardCopy.concat(disclaimer).join(' ');
	  }
	
	  if (hasTotalAndShowsTips && allowBookNoPay) {
	    return reserveWithCardCopy.concat(reserveOnlyCopy).concat(disclaimer).join(' ');
	  }
	  if (hasTotalAndShowsTips) {
	    return reserveWithCardCopy.concat(disclaimer).join(' ');
	  }
	  return reserveOnlyCopy.concat(disclaimer).join(' ');
	};
	
	var getItems = exports.getItems = (0, _pipe3.default)(function (state) {
	  return state.reservation.getIn(['appointment', 'items']);
	}, (0, _unless3.default)(_isEmpty3.default, function (items) {
	  return items.toJS();
	}));
	
	var getTaxAmount = exports.getTaxAmount = function getTaxAmount(state) {
	  return state.reservation.getIn(['appointment', 'taxAmount']);
	};
	
	var getDiscountPromo = exports.getDiscountPromo = function getDiscountPromo(state) {
	  return state.reservation.getIn(['appointment', 'discountPromo']);
	};
	
	var getTipAmount = exports.getTipAmount = function getTipAmount(state) {
	  return state.reservation.getIn(['appointment', 'tipAmount']);
	};
	
	var getTotalWithTip = exports.getTotalWithTip = function getTotalWithTip(state) {
	  return state.reservation.getIn(['appointment', 'totalWithTip']);
	};
	
	var getCustomerEmail = exports.getCustomerEmail = (0, _pipe3.default)(getCustomer, (0, _prop3.default)('email'));
	
	var getIsPaid = exports.getIsPaid = function getIsPaid(state) {
	  return state.reservation.getIn(['appointment', 'isPaid']);
	};
	
	var getPaymentProcessing = exports.getPaymentProcessing = function getPaymentProcessing(state) {
	  return state.reservation.get('paymentProcessing');
	};
	
	var getProcessing = exports.getProcessing = function getProcessing(state) {
	  return state.reservation.get('processing');
	};
	
	var getTaxBreakdown = exports.getTaxBreakdown = function getTaxBreakdown(state) {
	  return state.reservation.get('taxBreakdown').toJS();
	};
	var getTaxBreakdownAmount = exports.getTaxBreakdownAmount = function getTaxBreakdownAmount(state) {
	  return (0, _sumBy3.default)(getTaxBreakdown(state), function (b) {
	    return b.amount;
	  });
	};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nothing = function (_Component) {
	  _inherits(Nothing, _Component);
	
	  function Nothing() {
	    _classCallCheck(this, Nothing);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Nothing.prototype.render = function render() {
	    return null;
	  };
	
	  return Nothing;
	}(_react.Component);
	
	Nothing.displayName = 'Nothing';
	
	var renderNothing = function renderNothing(_) {
	  return Nothing;
	};
	
	exports.default = renderNothing;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.taxBreakdownArray = exports.taxBreakdownShape = exports.linkShape = exports.stepsShape = exports.stepShape = exports.handler = exports.flag = exports.positionShape = exports.fieldShape = exports.fieldPropTypes = exports.tipShape = exports.timesShape = exports.timeShape = exports.dayShape = exports.categoriesShape = exports.categoryShape = exports.serviceShape = exports.barberShape = exports.shopShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shopShape = exports.shopShape = _propTypes2.default.shape({
	  id: _propTypes2.default.string,
	  name: _propTypes2.default.string.isRequired,
	  photos: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  address: _propTypes2.default.string.isRequired,
	  location: _propTypes2.default.shape({
	    coordinates: _propTypes2.default.arrayOf(_propTypes2.default.number)
	  }),
	  distance: _propTypes2.default.number,
	  zip: _propTypes2.default.string.isRequired,
	  yelpRating: _propTypes2.default.number,
	  yelpID: _propTypes2.default.string
	});
	
	var barberShape = exports.barberShape = _propTypes2.default.shape({
	  id: _propTypes2.default.string.isRequired,
	  photos: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  firstName: _propTypes2.default.string,
	  lastName: _propTypes2.default.string,
	  nextTimeFormatted: _propTypes2.default.string
	});
	
	var serviceShape = exports.serviceShape = _propTypes2.default.shape({
	  id: _propTypes2.default.string.isRequired,
	  name: _propTypes2.default.string.isRequired,
	  cost: _propTypes2.default.number.isRequired,
	  desc: _propTypes2.default.string
	});
	
	var categoryShape = exports.categoryShape = _propTypes2.default.shape({
	  id: _propTypes2.default.string.isRequired,
	  name: _propTypes2.default.string.isRequired
	});
	
	var categoriesShape = exports.categoriesShape = _propTypes2.default.arrayOf(categoryShape);
	
	var dayShape = exports.dayShape = _propTypes2.default.shape({
	  date: _propTypes2.default.string.isRequired,
	  dayOfWeek: _propTypes2.default.string.isRequired,
	  disabled: _propTypes2.default.bool
	});
	
	var timeShape = exports.timeShape = _propTypes2.default.shape({
	  barberRoute: _propTypes2.default.string,
	  time: _propTypes2.default.string
	});
	
	var timesShape = exports.timesShape = _propTypes2.default.arrayOf(timeShape);
	
	var tipShape = exports.tipShape = _propTypes2.default.shape({
	  value: _propTypes2.default.number.isRequired,
	  amount: _propTypes2.default.number.isRequired,
	  desc: _propTypes2.default.string.isRequired
	});
	
	var fieldPropTypes = exports.fieldPropTypes = {
	  id: _propTypes2.default.string.isRequired,
	  label: _propTypes2.default.string.isRequired,
	  error: _propTypes2.default.bool,
	  errorMessage: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  autoComplete: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  required: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  value: _propTypes2.default.string,
	  size: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool
	};
	
	var fieldShape = exports.fieldShape = _propTypes2.default.shape(fieldPropTypes);
	
	var positionShape = exports.positionShape = _propTypes2.default.shape({
	  lat: _propTypes2.default.number,
	  lng: _propTypes2.default.number
	});
	
	var flag = exports.flag = _propTypes2.default.bool;
	var handler = exports.handler = _propTypes2.default.func;
	
	var stepShape = exports.stepShape = _propTypes2.default.shape({
	  key: _propTypes2.default.string.isRequired,
	  url: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.string.isRequired,
	  trim: _propTypes2.default.bool
	});
	var stepsShape = exports.stepsShape = _propTypes2.default.arrayOf(stepShape);
	
	var linkShape = exports.linkShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  pathname: _propTypes2.default.string,
	  query: _propTypes2.default.object
	})]);
	
	var taxBreakdownShape = exports.taxBreakdownShape = _propTypes2.default.shape({
	  name: _propTypes2.default.string,
	  amount: _propTypes2.default.number,
	  taxId: _propTypes2.default.string
	});
	
	var taxBreakdownArray = exports.taxBreakdownArray = _propTypes2.default.arrayOf(taxBreakdownShape);

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _setDisplayName = __webpack_require__(69);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(79);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createEagerFactory = __webpack_require__(78);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withState = function withState(stateName, stateUpdaterName, initialState) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    var WithState = function (_Component) {
	      _inherits(WithState, _Component);
	
	      function WithState() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithState);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
	        }, _this.updateStateValue = function (updateFn, callback) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
	            };
	          }, callback);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithState.prototype.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
	      };
	
	      return WithState;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withState'))(WithState);
	    }
	    return WithState;
	  };
	};
	
	exports.default = withState;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBarberAdvanceCancelMins = exports.getBarberDaysOnAsDates = exports.getBarberDaysOffAsDates = exports.getBarberWeekdaysOff = exports.getBarberDayEnabled = exports.getBarberName = exports.getHasBarberLoyaltyProgram = exports.getAllowMultipleServices = exports.getBarberId = exports.getBarberAdvanceBookDays = exports.getBarberShortName = exports.getBarberBookNoPay = exports.getTipEnabledForBarber = exports.getBarberByIdOrRoute = exports.getBarberByRoute = exports.getBarberById = exports.getBarbersCount = exports.getBarbers = exports.getAllBarbersRaw = undefined;
	
	var _map2 = __webpack_require__(74);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _flow2 = __webpack_require__(125);
	
	var _flow3 = _interopRequireDefault(_flow2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _schedule = __webpack_require__(199);
	
	var _helpers = __webpack_require__(7);
	
	var _constants = __webpack_require__(10);
	
	var _selectors = __webpack_require__(11);
	
	var _selectors2 = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getBarberWholeDaysOff = function getBarberWholeDaysOff(state) {
	  var daysOff = state.daysOff.get('items');
	  return daysOff.size ? (0, _schedule.getWholeDaysOff)(daysOff.toJS()) : [];
	};
	
	var getBarberDisabled = function getBarberDisabled(barber, daysOff) {
	  var daysOn = barber.get('days_on');
	  var advanceBookDays = barber.get('advanceBookDays');
	  var from = (0, _helpers.getStartOfDay)();
	  var to = (0, _helpers.addDaysToDate)(from, advanceBookDays);
	  var hasDayOnInRange = daysOn && daysOn.some(function (item) {
	    var day = new Date(item.get('day'));
	    return (0, _helpers.dayIsInRange)(day, from, to);
	  });
	  if (hasDayOnInRange) return false;
	
	  // Weekdays in Schedule start from 1 (Monday),
	  // but in JS start from 0 (Sunday), hence rotating of weekdays array
	  var scheduleWeekdays = (0, _schedule.getScheduleWeekdaysFromSchedule)(barber.get('schedules').toJS());
	
	  // Find a day in schedule that is not off day
	  // Loop from start day until end day
	  // Check if day in schedule is enabled and not off day
	  var day = new Date(from);
	  while (day <= to) {
	    if ((0, _schedule.isWeekdayEnabled)(day, scheduleWeekdays) && !(0, _schedule.dayIsInArray)(day, daysOff)) {
	      return false;
	    }
	    day = (0, _helpers.addDaysToDate)(day, 1);
	  }
	
	  return true;
	};
	
	var filterByShopId = function filterByShopId(shopRoute) {
	  return function (barber) {
	    return barber.getIn(['shop', 'route']) === shopRoute;
	  };
	};
	
	var getAllBarbersRaw = exports.getAllBarbersRaw = function getAllBarbersRaw(state) {
	  return state.barbers.get('items').toJS();
	};
	
	var getBarbers = exports.getBarbers = function getBarbers(state, _ref) {
	  var shopRoute = _ref.shopRoute,
	      serviceId = _ref.serviceId,
	      barberRoute = _ref.barberRoute;
	
	  var barbers = state.barbers.get('items').filter(filterByShopId(shopRoute)).filter(function (barber) {
	    if (!serviceId) return true;
	    var servicesIds = serviceId.split(';');
	    var barberServices = barber.get('services') ? barber.get('services').toJS() : [];
	    if ((0, _selectors2.doServicesHaveAssignments)(state)) {
	      barberServices = (0, _selectors2.getBarberAssignments)(state, barber.get('id'));
	    }
	
	    return servicesIds.every(function (id) {
	      return barberServices.some(function (service) {
	        return id === service.id;
	      });
	    });
	  });
	
	  return barbers.map(function (barber) {
	    var nextBarberTime = barber.get('nextTime') || null;
	    var timezone = barber.getIn(['shop', 'timezone']);
	    var nextTime = (0, _moment2.default)(nextBarberTime).isValid() ? _moment2.default.tz(nextBarberTime, timezone) : null;
	    var dateTimeFormat = 'MMMM D @ h:mmA';
	    var nextTimeFormatted = nextTime ? nextTime.calendar(null, {
	      sameDay: '[Today] @ h:mmA',
	      nextWeek: dateTimeFormat,
	      sameElse: dateTimeFormat
	    }) : null;
	    var thumbnail = barber.getIn(['photos', 0, 'thumbnail']);
	    var isActive = barber.get('route') === barberRoute;
	    var disabled = nextTime ? false : getBarberDisabled(barber, getBarberWholeDaysOff(state));
	
	    return barber.set('nextTime', nextTime).set('thumbnail', thumbnail).set('nextTimeFormatted', nextTimeFormatted).set('isActive', isActive).set('disabled', disabled);
	  }).toJS();
	};
	
	var getBarbersCount = exports.getBarbersCount = function getBarbersCount(state, _ref2) {
	  var shopRoute = _ref2.shopRoute;
	  return state.barbers.get('items').filter(filterByShopId(shopRoute)).size;
	};
	
	var getBarberById = exports.getBarberById = function getBarberById(state, id) {
	  return state.barbers.get('items').find(function (barber) {
	    return barber.get('id') === id;
	  });
	};
	
	var getBarberByRoute = exports.getBarberByRoute = function getBarberByRoute(state, route) {
	  return state.barbers.get('items').find(function (barber) {
	    return barber.get('route') === route;
	  });
	};
	
	var getBarberByIdOrRoute = exports.getBarberByIdOrRoute = function getBarberByIdOrRoute(state, idOrRoute) {
	  return getBarberById(state, idOrRoute) || getBarberByRoute(state, idOrRoute);
	};
	
	var getTipEnabledForBarber = exports.getTipEnabledForBarber = function getTipEnabledForBarber(state, route) {
	  var barber = getBarberByIdOrRoute(state, route);
	  return barber && barber.get('tipEnabled');
	};
	
	var getBarberBookNoPay = exports.getBarberBookNoPay = function getBarberBookNoPay(state, route) {
	  var barber = getBarberByIdOrRoute(state, route);
	
	  return barber && barber.get('bookNoPay');
	};
	
	var getBarberShortName = exports.getBarberShortName = function getBarberShortName(state, route) {
	  var barber = getBarberByIdOrRoute(state, route);
	
	  if (!barber) return '';
	
	  var lastName = barber.get('lastName') ? ' ' + barber.get('lastName')[0] + '.' : '';
	
	  return '' + barber.get('firstName') + lastName;
	};
	
	var getBarberAdvanceBookDays = exports.getBarberAdvanceBookDays = function getBarberAdvanceBookDays(state, route) {
	  var barber = getBarberByIdOrRoute(state, route);
	  return barber && barber.get('advanceBookDays');
	};
	
	var getBarberId = exports.getBarberId = function getBarberId(state, route) {
	  if (route === _constants.ANY_BARBER) return route;
	  var barber = getBarberByIdOrRoute(state, route);
	  return barber && barber.get('id');
	};
	
	var getAllowMultipleServices = exports.getAllowMultipleServices = function getAllowMultipleServices(state, route, shopRoute) {
	  if (route === _constants.ANY_BARBER) return (0, _selectors.getAllowMultipleServices)(state, shopRoute);
	  var barber = getBarberByIdOrRoute(state, route);
	  return barber && barber.get('allowMultipleServices');
	};
	
	var getHasBarberLoyaltyProgram = exports.getHasBarberLoyaltyProgram = function getHasBarberLoyaltyProgram(state, route) {
	  var barber = getBarberByIdOrRoute(state, route);
	
	  if (!barber) return false;
	
	  var reward = barber.get('reward');
	  return reward && reward.get('enabled');
	};
	
	var getBarberName = exports.getBarberName = function getBarberName(state, idOrRoute) {
	  var barber = getBarberByIdOrRoute(state, idOrRoute);
	  return barber && barber.get('firstName') + ' ' + barber.get('lastName');
	};
	
	var getBarberSchedules = function getBarberSchedules(state, idOrRoute) {
	  return (0, _flow3.default)(getBarberByIdOrRoute, function (barber) {
	    return barber && barber.get('schedules');
	  }, function (schedules) {
	    return schedules && schedules.toJS();
	  })(state, idOrRoute);
	};
	
	var getBarberScheduleWeekdays = function getBarberScheduleWeekdays(state, idOrRoute) {
	  return (0, _flow3.default)(getBarberSchedules, _schedule.getScheduleWeekdaysFromSchedule)(state, idOrRoute);
	};
	
	var getBarberDayEnabled = exports.getBarberDayEnabled = function getBarberDayEnabled(state, route, activeDay) {
	  var day = (0, _helpers.getStartOfDay)(activeDay);
	  var barber = getBarberByRoute(state, route);
	  var scheduleWeekdays = getBarberScheduleWeekdays(state, route);
	  return barber && (0, _schedule.isWeekdayEnabled)(day, scheduleWeekdays) && !(0, _schedule.dayIsInArray)(day, getBarberWholeDaysOff(state));
	};
	
	var getBarberWeekdaysOff = exports.getBarberWeekdaysOff = function getBarberWeekdaysOff(state, idOrRoute) {
	  return (0, _flow3.default)(getBarberSchedules, _schedule.getScheduleWeekdaysOffFromSchedule)(state, idOrRoute);
	};
	
	var mapDaysStringToDate = function mapDaysStringToDate(days) {
	  return (0, _map3.default)(days, function (item) {
	    return (0, _moment2.default)(item, _config2.default.apiDateFormat).toDate();
	  });
	};
	
	var getBarberDaysOffAsDates = exports.getBarberDaysOffAsDates = function getBarberDaysOffAsDates(state) {
	  return (0, _flow3.default)(getBarberWholeDaysOff, mapDaysStringToDate)(state);
	};
	
	var getBarberDaysOn = function getBarberDaysOn(barber) {
	  if (!barber) return null;
	  var daysOn = barber.get('days_on');
	  return daysOn.size ? daysOn.toJS() : [];
	};
	
	var getBarberDaysOnAsDates = exports.getBarberDaysOnAsDates = function getBarberDaysOnAsDates(state, idOrRoute) {
	  return (0, _flow3.default)(getBarberByIdOrRoute, getBarberDaysOn, function (items) {
	    return (0, _map3.default)(items, function (item) {
	      return (0, _get3.default)(item, 'day');
	    });
	  }, mapDaysStringToDate)(state, idOrRoute);
	};
	
	var getBarberAdvanceCancelMins = exports.getBarberAdvanceCancelMins = (0, _flow3.default)(getBarberByIdOrRoute, function (barber) {
	  return barber && barber.get('advanceCancelMins');
	});

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFinite2 = __webpack_require__(348);
	
	var _isFinite3 = _interopRequireDefault(_isFinite2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _WithShopCurrency = __webpack_require__(135);
	
	var _WithShopCurrency2 = _interopRequireDefault(_WithShopCurrency);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Money = function Money(_ref) {
	  var children = _ref.children,
	      noDecimalsIfInt = _ref.noDecimalsIfInt,
	      currency = _ref.currency,
	      cents = _ref.cents;
	
	  var amount = (0, _isFinite3.default)(cents) ? cents : children;
	  if (!(0, _isFinite3.default)(amount)) return null;
	  return _react2.default.createElement(
	    'span',
	    null,
	    (0, _helpers.formatPrice)(amount, currency, noDecimalsIfInt)
	  );
	};
	Money.propTypes = {
	  children: _propTypes2.default.number,
	  noDecimalsIfInt: _propTypes2.default.bool,
	  currency: _propTypes2.default.string,
	  cents: _propTypes2.default.number
	};
	Money.defaultProps = {
	  noDecimalsIfInt: false,
	  currency: _config2.default.defaultCurrency,
	  cents: null,
	  children: null
	};
	
	exports.default = (0, _WithShopCurrency2.default)(Money);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var createCaseFirst = __webpack_require__(1408);
	
	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = createCaseFirst('toUpperCase');
	
	module.exports = upperFirst;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _constants = __webpack_require__(10);
	
	var _events = __webpack_require__(878);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _integrations = __webpack_require__(883);
	
	var _integrations2 = _interopRequireDefault(_integrations);
	
	var _Analytics2 = __webpack_require__(869);
	
	var _Analytics3 = _interopRequireDefault(_Analytics2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Class that implements methods that track customer behavior through process of booking
	 * Following events are tracked:
	 *  'page_loaded - fires when page is loaded
	 *  'query_entered - fires when visitor perform search for shop
	 *  'select_shop - fires when a customer clicks on a shop
	 *  'choose_professional_clicked' or 'choose_service_clicked' depending on what option a customer clicks
	 *  'select_barber' - fires when a customer clicks on a barber
	 *  'select_any_barber' - fires when a customer clicks on “book with any profession” button
	 *  'select_service' - fires when a customer clicks on a particular service
	 *  'select_date' - fires when a customer clicks on a day
	 *  'select_time' - fires when a customer clicks on a time slot
	 *  'review_and_book' - fires when a customer clicks on "Review & Book" button
	 *  'review_and_pay' - fires when a customer clicks on "Review & Pay" button (Apple Pay)
	 *  'waiting_list' - fires when a customer clicks on "Put me on a waiting list" button
	 *  'waiting_list_with_apple_pay' - fires when a customer clicks on "Put me on a waiting list" button (Apple Pay)
	 *  'fill_personal_info' - fires when a customer fills his info and book buttons become available
	 *  'reserve_and_pay' - fires when a customer clicks on 'Reserve & Pay'/'Process' button
	 *  'reserve_and_provide_card' - fires when a customer clicks on 'Reserve' button
	 *  'reserve' - fires when a customer clicks on book without card
	 *  'show_stripe_modal' - fires when stripe payment modal is opened
	 *  'show_squire_modal' - fires when squire payment modal is opened
	 *  'start_payment' - fires when a customer opens payment modal (custom or stripe default)
	 *  'cc_number_entered' - fires when a customer adds 'well-formed and potentially complete' cc number
	 *  'cc_expiration_date_entered' - fires when a customer adds 'well-formed and potentially complete' cc expiration date
	 *  'cc_security_code_entered' - fires when a customer adds 'well-formed and potentially complete' cc cvc code
	 *  'cc_zip_code_entered' - fires when a customer adds 'well-formed and potentially complete' cc zip code
	 *  'tip_option_active' - fires if tips are enabled on checkout page/modal
	 *  'tip_selected' - fires when tip is selected
	 *  'fill_card_info' - fires when a customer fills card info (only with custom modal)
	 *  'abandon_payment' - fires when a customer closes payment modal
	 *  'payment_error' - fires when we receive payment error from the backend
	 *  'booking_complete' - fires when a customer successfully books an appointment
	 *  'only_pay_active' - (only reserve and pay is shown)
	 *  'reserve_and_provide_card_active' - (reserve and pay and reserve and provide card are both shown)
	 *  'reserve_without_pay_active' - (reserve and pay and reserve without providing a card are both shown)
	 *  'only_reserve_active' - (only a reserve without payment is shown... I think this is only possible with kiosk mode)
	 *  'promo_active' - fires when third party promotion is shown to customer on checkout page
	 *
	 *  @see {@link https://stripe.com/docs/js/element/events/on_change?type=cardElement#element_on_change-handler-complete|StripeJS}
	 *       For 'well-formed and potentially complete' field value
	 */
	var BookingAnalytics = function (_Analytics) {
	  _inherits(BookingAnalytics, _Analytics);
	
	  function BookingAnalytics() {
	    _classCallCheck(this, BookingAnalytics);
	
	    return _possibleConstructorReturn(this, (BookingAnalytics.__proto__ || Object.getPrototypeOf(BookingAnalytics)).apply(this, arguments));
	  }
	
	  _createClass(BookingAnalytics, [{
	    key: 'pageLoaded',
	    value: function pageLoaded() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      return this.fireEvent(_events2.default.PAGE_LOAD, options);
	    }
	  }, {
	    key: 'queryShop',
	    value: function queryShop() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      return this.fireEvent(_events2.default.QUERY_SHOP, options);
	    }
	  }, {
	    key: 'selectShop',
	    value: function selectShop(shop) {
	      return this.fireEvent(_events2.default.SELECT_SHOP, { shop: shop.name, brandId: shop.brandId });
	    }
	  }, {
	    key: 'chooseProfessional',
	    value: function chooseProfessional() {
	      return this.fireEvent(_events2.default.CHOOSE_PROFESSIONAL_CLICKED);
	    }
	  }, {
	    key: 'chooseService',
	    value: function chooseService() {
	      return this.fireEvent(_events2.default.CHOOSE_SERVICE_CLICKED);
	    }
	  }, {
	    key: 'selectBarber',
	    value: function selectBarber(barber, _ref) {
	      var _ref$shop = _ref.shop,
	          shop = _ref$shop === undefined ? {} : _ref$shop;
	
	      var isAnyBarber = barber === _constants.ANY_BARBER;
	      var event = isAnyBarber ? _events2.default.SELECT_ANY_BARBER : _events2.default.SELECT_BARBER;
	
	      return this.fireEvent(event, isAnyBarber ? undefined : {
	        barber: barber.firstName + ' ' + barber.lastName,
	        shop: shop.name
	      });
	    }
	  }, {
	    key: 'selectService',
	    value: function selectService(service, _ref2) {
	      var _ref2$shop = _ref2.shop,
	          shop = _ref2$shop === undefined ? {} : _ref2$shop;
	
	      return this.fireEvent(_events2.default.SELECT_SERVICE, { service: service, shop: shop.name });
	    }
	  }, {
	    key: 'selectDate',
	    value: function selectDate(date) {
	      return this.fireEvent(_events2.default.SELECT_DATE, { date: date });
	    }
	  }, {
	    key: 'selectTime',
	    value: function selectTime(time, _ref3) {
	      var _ref3$shop = _ref3.shop,
	          shop = _ref3$shop === undefined ? {} : _ref3$shop;
	
	      return this.fireEvent(_events2.default.SELECT_TIME, { time: time, shop: shop.name });
	    }
	  }, {
	    key: 'proceedToCheckout',
	    value: function proceedToCheckout(_ref4) {
	      var service = _ref4.service,
	          barber = _ref4.barber,
	          date = _ref4.date,
	          time = _ref4.time,
	          isApplePay = _ref4.isApplePay,
	          applePayAvailable = _ref4.applePayAvailable,
	          waitingList = _ref4.waitingList,
	          shop = _ref4.shop;
	
	      if (service) {
	        this.selectService(service, { shop: shop });
	      }
	      if (barber) {
	        this.selectBarber(barber, { shop: shop });
	      }
	      this.selectDate(date);
	      this.selectTime(time, { shop: shop });
	
	      if (waitingList) {
	        return isApplePay ? this.waitingListWithApplePay() : this.waitingList({
	          applePayAvailable: !!applePayAvailable
	        });
	      }
	
	      return isApplePay ? this.reviewAndPay() : this.reviewAndBook({
	        applePayAvailable: !!applePayAvailable
	      });
	    }
	  }, {
	    key: 'reviewAndBook',
	    value: function reviewAndBook(otherOptions) {
	      return this.fireEvent(_events2.default.REVIEW_AND_BOOK, { otherOptions: otherOptions });
	    }
	  }, {
	    key: 'reviewAndPay',
	    value: function reviewAndPay() {
	      return this.fireEvent(_events2.default.REVIEW_AND_PAY);
	    }
	  }, {
	    key: 'waitingList',
	    value: function waitingList(otherOptions) {
	      return this.fireEvent(_events2.default.WAITING_LIST, { otherOptions: otherOptions });
	    }
	  }, {
	    key: 'waitingListWithApplePay',
	    value: function waitingListWithApplePay() {
	      return this.fireEvent(_events2.default.WAITING_LIST_WITH_APPLE_PAY);
	    }
	  }, {
	    key: 'fillPersonalInfo',
	    value: function fillPersonalInfo() {
	      return this.fireEvent(_events2.default.FILL_PERSONAL_INFO);
	    }
	  }, {
	    key: 'startPayment',
	    value: function startPayment(options) {
	      return this.fireEvent(_events2.default.START_PAYMENT, options);
	    }
	  }, {
	    key: 'fillCardInfoField',
	    value: function fillCardInfoField(inputType) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var eventMap = {
	        cardNumber: _events2.default.CREDIT_CARD_NUMBER_ENTERED,
	        cardExpiry: _events2.default.CREDIT_CARD_EXP_DATE_ENTERED,
	        cardCvc: _events2.default.CREDIT_CARD_CVC_ENTERED,
	        cardZipCode: _events2.default.CREDIT_CARD_ZIP_CODE_ENTERED
	      };
	
	      if (!eventMap[inputType]) {
	        return null;
	      }
	
	      return this.fireEvent(eventMap[inputType], options);
	    }
	  }, {
	    key: 'creditCardNumberEntered',
	    value: function creditCardNumberEntered() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      return this.fillCardInfoField('cardNumber', options);
	    }
	  }, {
	    key: 'creditCardExpDateEntered',
	    value: function creditCardExpDateEntered() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      return this.fillCardInfoField('cardExpiry', options);
	    }
	  }, {
	    key: 'creditCardCvcEntered',
	    value: function creditCardCvcEntered() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      return this.fillCardInfoField('cardCvc', options);
	    }
	  }, {
	    key: 'creditCardZipCodeEntered',
	    value: function creditCardZipCodeEntered() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      return this.fillCardInfoField('cardZipCode', options);
	    }
	  }, {
	    key: 'tipOptionActive',
	    value: function tipOptionActive() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      return this.fireEvent(_events2.default.TIP_OPTION_ACTIVE, options);
	    }
	  }, {
	    key: 'tipSelected',
	    value: function tipSelected() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      return this.fireEvent(_events2.default.TIP_SELECTED, options);
	    }
	  }, {
	    key: 'fillCardInfo',
	    value: function fillCardInfo(_ref5) {
	      var source = _ref5.source,
	          _ref5$isApplePay = _ref5.isApplePay,
	          isApplePay = _ref5$isApplePay === undefined ? false : _ref5$isApplePay;
	
	      return this.fireEvent(_events2.default.FILL_CARD_INFO, { source: source, isApplePay: isApplePay });
	    }
	  }, {
	    key: 'abandonPayment',
	    value: function abandonPayment(options) {
	      return this.fireEvent(_events2.default.ABANDON_PAYMENT, options);
	    }
	  }, {
	    key: 'paymentError',
	    value: function paymentError(options) {
	      return this.fireEvent(_events2.default.PAYMENT_ERROR, options);
	    }
	  }, {
	    key: 'reserveAndPay',
	    value: function reserveAndPay(options) {
	      return this.fireEvent(_events2.default.RESERVE_AND_PAY, options);
	    }
	  }, {
	    key: 'reserveAndProvideCard',
	    value: function reserveAndProvideCard(options) {
	      return this.fireEvent(_events2.default.RESERVE_AND_PROVIDE_CARD, options);
	    }
	  }, {
	    key: 'reserve',
	    value: function reserve(options) {
	      return this.fireEvent(_events2.default.RESERVE, options);
	    }
	  }, {
	    key: 'bookingComplete',
	    value: function bookingComplete(options) {
	      if (window.stylzGtag) {
	        window.stylzGtag('event', 'conversion', {
	          send_to: 'AW-10926152046/sXAsCL-G6sIDEO6y_9ko',
	          value: (options.totalWithTip / 100).toFixed(2),
	          currency: 'USD',
	          transaction_id: options.appointmentId
	        });
	      }
	
	      return this.fireEvent(_events2.default.BOOKING_COMPLETE, options);
	    }
	  }, {
	    key: 'showStripeModal',
	    value: function showStripeModal(options) {
	      return this.fireEvent(_events2.default.SHOW_STRIPE_MODAL, options);
	    }
	  }, {
	    key: 'showSquireModal',
	    value: function showSquireModal(options) {
	      return this.fireEvent(_events2.default.SHOW_SQUIRE_MODAL, options);
	    }
	  }, {
	    key: 'buttonsActive',
	    value: function buttonsActive(_ref6) {
	      var reserve = _ref6.reserve,
	          bookAndPay = _ref6.bookAndPay,
	          reserveWithCard = _ref6.reserveWithCard,
	          shop = _ref6.shop;
	
	      if (bookAndPay && !reserve && !reserveWithCard) {
	        return this.fireEvent(_events2.default.ONLY_PAY_ACTIVE, { shop: shop.name });
	      }
	      if (bookAndPay && reserveWithCard) {
	        return this.fireEvent(_events2.default.RESERVE_AND_PROVIDE_CARD_ACTIVE, { shop: shop.name });
	      }
	      if (bookAndPay && reserve) {
	        return this.fireEvent(_events2.default.RESERVE_WITHOUT_PAY_ACTIVE, { shop: shop.name });
	      }
	      if (!bookAndPay && reserve && !reserveWithCard) {
	        return this.fireEvent(_events2.default.ONLY_RESERVE_ACTIVE, { shop: shop.name });
	      }
	
	      return false;
	    }
	  }, {
	    key: 'thirdPartyPromoActive',
	    value: function thirdPartyPromoActive(context) {
	      return this.fireEvent(_events2.default.PROMO_ACTIVE, { context: context });
	    }
	  }, {
	    key: 'fireEvent',
	    value: function fireEvent(event) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      // eslint-disable-next-line no-underscore-dangle
	      return _get(BookingAnalytics.prototype.__proto__ || Object.getPrototypeOf(BookingAnalytics.prototype), 'fireEvent', this).call(this, this._getEventName(event), options);
	    }
	
	    // eslint-disable-next-line class-methods-use-this
	
	  }, {
	    key: '_getEventName',
	    value: function _getEventName(event) {
	      return event;
	    }
	  }]);
	
	  return BookingAnalytics;
	}(_Analytics3.default);
	
	var analytics = new BookingAnalytics(_integrations2.default);
	exports.default = analytics;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withExtensionContextConsumer = __webpack_require__(136);
	
	var _withExtensionContextConsumer2 = _interopRequireDefault(_withExtensionContextConsumer);
	
	var _utils = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var AppointmentContainer = function AppointmentContainer(_ref) {
	  var children = _ref.children,
	      danger = _ref.danger,
	      _ref$extension = _ref.extension,
	      extension = _ref$extension === undefined ? {} : _ref$extension;
	  return _react2.default.createElement(
	    'div',
	    {
	      style: { borderTopColor: (0, _utils.hexToCssHex)(extension.primaryColor) },
	      className: (0, _classnames2.default)('c-notification-content', { 'c-notification-content--danger': danger })
	    },
	    children
	  );
	};
	
	exports.default = (0, _withExtensionContextConsumer2.default)(AppointmentContainer);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _breakpoint = __webpack_require__(267);
	
	var _breakpoint2 = _interopRequireDefault(_breakpoint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Footer = function Footer(_ref) {
	  var link = _ref.link;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pb-30 u-mt-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _breakpoint2.default,
	      { name: 'phone' },
	      'To manage',
	      _react2.default.createElement('br', { className: 'u-hide-on-desktop' }),
	      ' notifications,\xA0',
	      _react2.default.createElement(
	        'a',
	        { className: 'u-co-grey--light u-td-underline u-co-black-2', href: link, target: '_blank' },
	        'click here'
	      ),
	      '.'
	    )
	  );
	};
	
	exports.default = Footer;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PostCtaAction = __webpack_require__(1117);
	
	var _PostCtaAction2 = _interopRequireDefault(_PostCtaAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var SquireInfo = function SquireInfo(_ref) {
	  var reservationLink = _ref.reservationLink,
	      shopName = _ref.shopName,
	      renderAction = _ref.renderAction,
	      standalone = _ref.standalone,
	      isCustomerEmail = _ref.isCustomerEmail,
	      supportLink = _ref.supportLink;
	
	  var poweredByClass = standalone ? '' : 'u-hide-on-desktop';
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'u-text-small u-co-grey u-hide-on-desktop u-mb-8' },
	      renderAction({ reservationLink: reservationLink })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: poweredByClass },
	      _react2.default.createElement('img', {
	        className: 'u-mb-1',
	        width: '64px',
	        src: 'https://squire-emails.s3-us-west-1.amazonaws.com/images/squire-powered-by.png',
	        alt: ''
	      }),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('img', {
	        width: '80px',
	        src: 'https://squire-emails.s3-us-west-1.amazonaws.com/images/squire.png',
	        alt: ''
	      })
	    ),
	    _react2.default.createElement('div', { className: 'u-pt-5 ' + (standalone ? '' : 'u-hide-on-desktop') }),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-flex u-mb-10' },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-1/2-medium-and-up u-text-small u-co-grey' },
	        'Squire Technologies is a company',
	        _react2.default.createElement('br', null),
	        'dedicated to making style and',
	        _react2.default.createElement('br', null),
	        'grooming for men simple.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-1/2 u-text-small u-co-grey u-hide-on-mobile' },
	        renderAction({ reservationLink: reservationLink })
	      )
	    ),
	    _react2.default.createElement('div', { className: 'c-divider' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-footer-info' },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-tiny u-co-grey--light' },
	        'You\'re receiving this email because you use Squire to',
	        _react2.default.createElement('br', null),
	        'manage your appointments for ',
	        shopName,
	        '.'
	      ),
	      _react2.default.createElement(
	        'a',
	        {
	          href: isCustomerEmail ? 'https://www.instagram.com/getsquire' : supportLink,
	          className: 'u-flex u-align-center u-text-small u-co-grey',
	          target: '_blank',
	          rel: 'noopener noreferrer'
	        },
	        isCustomerEmail ? _react2.default.createElement('img', { width: '20px', src: 'https://squire-emails.s3-us-west-1.amazonaws.com/images/instagram@4x.png', alt: '' }) : _react2.default.createElement('img', { width: '20px', src: 'https://squire-emails.s3-us-west-1.amazonaws.com/images/intercom.png', alt: '' }),
	        '\xA0\xA0',
	        _react2.default.createElement(
	          'span',
	          { className: 'u-mr-2' },
	          isCustomerEmail ? 'Instagram' : 'Support'
	        )
	      )
	    )
	  );
	};
	
	SquireInfo.defaultProps = {
	  renderAction: _PostCtaAction2.default
	};
	
	exports.default = SquireInfo;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _pick = __webpack_require__(1752);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _shallowEqual = __webpack_require__(1750);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _setDisplayName = __webpack_require__(69);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(79);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createEagerFactory = __webpack_require__(78);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
	      return !(0, _shallowEqual2.default)((0, _pick2.default)(props, shouldMapOrKeys), (0, _pick2.default)(nextProps, shouldMapOrKeys));
	    };
	
	    var WithPropsOnChange = function (_Component) {
	      _inherits(WithPropsOnChange, _Component);
	
	      function WithPropsOnChange() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithPropsOnChange);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (shouldMap(this.props, nextProps)) {
	          this.computedProps = propsMapper(nextProps);
	        }
	      };
	
	      WithPropsOnChange.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.computedProps));
	      };
	
	      return WithPropsOnChange;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
	    }
	    return WithPropsOnChange;
	  };
	};
	
	exports.default = withPropsOnChange;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withExtensionContextConsumer = __webpack_require__(136);
	
	var _withExtensionContextConsumer2 = _interopRequireDefault(_withExtensionContextConsumer);
	
	var _utils = __webpack_require__(47);
	
	var _squireLogo = __webpack_require__(488);
	
	var _squireLogo2 = _interopRequireDefault(_squireLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Logo = function Logo(_ref) {
	  var extension = _ref.extension;
	
	  // Overriding the extension is a fix for backwards compatibility of email routes;
	  // There are cases where emails are sent w/out providing a brand/brandId route
	  // and in these cases, displayed notifications would get a 404 when requesting a brand.
	  // Therefore this is a default fallback, in case the brand route isn't available.
	
	  // A more elaborate fix is possible with cascading requests after pulling data about
	  // the reservation, but it would increase page load times before first render
	  // and we're nuking it all in WOM-656 anyway.
	  var ext = extension || {
	    primaryColor: '0xFFFFFF',
	    appIconImage: _squireLogo2.default
	  };
	
	  var styles = { backgroundColor: (0, _utils.hexToCssHex)(ext.primaryColor), borderRadius: '8px' };
	  return _react2.default.createElement('img', { style: styles, width: '64px', height: '64px', src: ext.appIconImage, alt: 'Logo' });
	};
	
	exports.default = (0, _withExtensionContextConsumer2.default)(Logo);

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _renderComponent2 = __webpack_require__(57);
	
	var _renderComponent3 = _interopRequireDefault(_renderComponent2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _map2 = __webpack_require__(74);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _momentTimezone = __webpack_require__(67);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _reactRouter = __webpack_require__(5);
	
	var _actions = __webpack_require__(42);
	
	var _helpers = __webpack_require__(7);
	
	var _Loader = __webpack_require__(82);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _utils = __webpack_require__(47);
	
	var _withExtensionContextConsumer = __webpack_require__(136);
	
	var _withExtensionContextConsumer2 = _interopRequireDefault(_withExtensionContextConsumer);
	
	var _routes = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getDate = function getDate(appt) {
	  var timezone = appt.shop.timezone;
	  var date = _momentTimezone2.default.utc(appt.dateTime).tz(timezone).format('ddd, MMM Do');
	  var startTime = _momentTimezone2.default.utc(appt.dateTime).tz(timezone).format('h:mm A');
	  return date + ', ' + startTime;
	};
	
	var getDaysUntilDateCopy = function getDaysUntilDateCopy(nowMoment, dateMoment) {
	  var startToday = nowMoment.clone().startOf('day');
	  var endToday = nowMoment.clone().endOf('day');
	  var startTomorrow = nowMoment.clone().add(1, 'day').startOf('day');
	  var endTomorrow = nowMoment.clone().add(1, 'day').endOf('day');
	  var startTarget = dateMoment.clone().startOf('day');
	  var numberOfDays = startTarget.diff(startToday, 'days');
	  var date = dateMoment.format('MM/DD/YYYY');
	  var time = dateMoment.format('h:mma');
	
	  if (dateMoment.isBetween(startToday, endToday) || numberOfDays === 0) return 'today at ' + time;
	  if (dateMoment.isBetween(startTomorrow, endTomorrow) || numberOfDays === 1) return 'tomorrow at ' + time;
	  if (numberOfDays <= 14) return 'in ' + numberOfDays + ' days';
	  if (numberOfDays === 15) return 'in 2 weeks and a day';
	  if (numberOfDays >= 16 && numberOfDays < 21) {
	    var remainder = numberOfDays - 14;
	    return 'in 2 weeks and ' + remainder + ' days';
	  }
	  if (numberOfDays === 21) return 'in 3 weeks';
	  if (numberOfDays === 22) return 'in 3 weeks and 1 day';
	  if (numberOfDays >= 23 && numberOfDays < 28) {
	    var _remainder = numberOfDays - 21;
	    return 'in 3 weeks and ' + _remainder + ' days';
	  }
	  if (numberOfDays >= 28 && numberOfDays < 60) return 'in a month or so';
	  if (numberOfDays >= 60 && numberOfDays < 90) return 'in a couple of months';
	  if (numberOfDays >= 90 && numberOfDays < 120) return 'in 3 months or so';
	  if (numberOfDays >= 120) return 'on ' + date;
	
	  return '';
	};
	
	var getDateShort = function getDateShort(appointment) {
	  var timezone = appointment.shop.timezone;
	
	  var now = _momentTimezone2.default.utc().tz(timezone);
	  var date = _momentTimezone2.default.utc(appointment.dateTime).tz(timezone);
	
	  return getDaysUntilDateCopy(now, date);
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _withState3.default)('busy', 'setBusy', true), (0, _withState3.default)('appointment', 'setAppointment', null), _withExtensionContextConsumer2.default, (0, _withHandlers3.default)({
	  fetchReservation: function fetchReservation(props) {
	    return function () {
	      var _props$params = props.params,
	          confirmationCode = _props$params.confirmationCode,
	          brandRoute = _props$params.brandRoute;
	
	      try {
	        var reservationCall = void 0;
	        if (brandRoute) {
	          reservationCall = (0, _actions.getBrandReservation)(props.extension.brandId, confirmationCode);
	        } else {
	          reservationCall = (0, _actions.getReservation)(confirmationCode);
	        }
	        reservationCall.then(function (reservation) {
	          var appts = [].concat(_toConsumableArray(reservation.pastAppointments), _toConsumableArray(reservation.upcomingAppointments));
	          var appt = appts.find(function (a) {
	            return a.confirmationCode === confirmationCode;
	          });
	          props.setAppointment(appt || reservation.appointment);
	          props.setBusy(false);
	        });
	      } catch (e) {
	        props.setBusy(false);
	      }
	    };
	  }
	}), (0, _withPropsOnChange3.default)(['extension'], function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(props) {
	    var brandRoute;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            brandRoute = props.params.brandRoute;
	
	            if (!(brandRoute && !props.extension)) {
	              _context.next = 4;
	              break;
	            }
	
	            props.setBusy(false);
	            return _context.abrupt('return');
	
	          case 4:
	            _context.next = 6;
	            return props.fetchReservation();
	
	          case 6:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function (_x) {
	    return _ref.apply(this, arguments);
	  };
	}()), (0, _branch3.default)(function (props) {
	  return props.busy;
	}, (0, _renderComponent3.default)(_Loader2.default)), (0, _branch3.default)(function (props) {
	  return !props.appointment;
	}, _renderNothing3.default), (0, _withProps3.default)(function (_ref2) {
	  var appt = _ref2.appointment,
	      params = _ref2.params;
	  return _extends({
	    appointment: appt,
	    shop: appt.shop,
	    confirmationCode: appt.confirmationCode,
	    customer: appt.customer,
	    barber: appt.barber,
	    service: (0, _map3.default)(appt.appointment_service, 'name').join(', '),
	    date: getDate(appt),
	    dateShort: getDateShort(appt),
	    address: (0, _utils.getShopAddress)(appt.shop),
	    duration: (0, _helpers.formatDuration)(appt.duration),
	    reservationLink: (0, _routes.prependLocationPrefix)('/view-reservation/' + appt.id),
	    appointmentNote: appt.customerNotes,
	    total: appt.totalWithTip,
	    tip: appt.tipAmount
	  }, (0, _utils.getAppLinks)(params.brandRoute, params.confirmationCode), {
	    squireInfoClassName: appt.shop.mobileAppCta ? 'c-phones-background__content' : 'u-mt-15'
	  });
	}));

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1249);


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var _isPlaceholder = /*#__PURE__*/__webpack_require__(241);
	
	/**
	 * Optimized internal one-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	
	
	function _curry1(fn) {
	  return function f1(a) {
	    if (arguments.length === 0 || _isPlaceholder(a)) {
	      return f1;
	    } else {
	      return fn.apply(this, arguments);
	    }
	  };
	}
	module.exports = _curry1;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var DOMProperty = __webpack_require__(151);
	var ReactDOMComponentFlags = __webpack_require__(764);
	
	var invariant = __webpack_require__(13);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var AppointmentInfo = function AppointmentInfo(props) {
	  var appointments = props.appointments || [props];
	  var wrapperClassName = (0, _classnames2.default)('c-appointment-info', {
	    'c-appointment-info--cancel': props.cancel,
	    'c-appointment-info--waiting-list': props.waitingList
	  });
	
	  var shouldShowInfo = appointments.length && appointments[0].confirmationCode || props.waitingList;
	  if (!shouldShowInfo) {
	    return _react2.default.createElement(
	      'div',
	      { className: wrapperClassName },
	      _react2.default.createElement('div', { className: 'c-appointment-info__shield' })
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: wrapperClassName },
	    _react2.default.createElement('div', { className: 'c-appointment-info__shield' }),
	    _react2.default.createElement(
	      'h3',
	      { className: 'u-text-large u-fw-bold u-mb-6' },
	      'Appointment details'
	    ),
	    appointments.map(function (appt, idx) {
	      return _react2.default.createElement(
	        'div',
	        { key: appt.confirmationCode || idx },
	        appointments.length > 1 && idx > 0 && _react2.default.createElement('div', { className: 'c-divider u-mt-5 u-mb-5' }),
	        appt.shopLocation && _react2.default.createElement(
	          'div',
	          { className: 'u-flex u-justify-content-space-between u-align-center u-mb-3' },
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-co-grey u-hide-on-mobile' },
	            'Location'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-co-grey u-hide-on-desktop' },
	            'Location'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-hide-on-mobile' },
	            (0, _utils.cut)(appt.shopLocation, 20)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-hide-on-desktop' },
	            (0, _utils.cut)(appt.shopLocation, 20)
	          )
	        ),
	        appt.confirmationCode && _react2.default.createElement(
	          'div',
	          { className: 'u-flex u-justify-content-space-between u-align-center u-mb-3' },
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-co-grey u-hide-on-mobile' },
	            'Confirmation code'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-co-grey u-hide-on-desktop' },
	            'Confirm. code'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-hide-on-mobile' },
	            appt.confirmationCode
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-hide-on-desktop' },
	            appt.confirmationCode
	          )
	        ),
	        appt.position && _react2.default.createElement(
	          'div',
	          { className: 'u-flex u-justify-content-space-between u-align-center u-mb-3' },
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-co-grey u-hide-on-mobile' },
	            'Waiting list position'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-co-grey u-hide-on-desktop' },
	            'Waiting list position'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-hide-on-mobile' },
	            appt.position
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-hide-on-desktop' },
	            appt.position
	          )
	        ),
	        appt.barberName && _react2.default.createElement(
	          'div',
	          { className: 'u-flex u-justify-content-space-between u-align-center u-mb-3' },
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-co-grey u-hide-on-mobile' },
	            'Professional'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-co-grey u-hide-on-desktop' },
	            'Professional'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-hide-on-mobile' },
	            appt.barberName
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-hide-on-desktop' },
	            appt.barberName
	          )
	        ),
	        appt.customerName && _react2.default.createElement(
	          'div',
	          { className: 'u-flex u-justify-content-space-between u-align-center u-mb-3' },
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-co-grey u-hide-on-mobile' },
	            'Client'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-co-grey u-hide-on-desktop' },
	            'Client'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-hide-on-mobile' },
	            (0, _utils.firstNameAndLastInitial)(appt.customerName)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-hide-on-desktop' },
	            (0, _utils.firstNameAndLastInitial)(appt.customerName)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'u-flex u-justify-content-space-between u-align-center u-mb-3' },
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-co-grey u-hide-on-mobile' },
	            'Service'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-co-grey u-hide-on-desktop' },
	            'Service'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-hide-on-mobile' },
	            (0, _upperFirst3.default)((0, _utils.cut)(appt.service, 20))
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-hide-on-desktop' },
	            (0, _upperFirst3.default)((0, _utils.cut)(appt.service, 20))
	          )
	        ),
	        appt.date && _react2.default.createElement(
	          'div',
	          { className: 'u-flex u-justify-content-space-between u-align-center u-mb-3' },
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-co-grey u-hide-on-mobile' },
	            'Time'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-co-grey u-hide-on-desktop' },
	            'Time'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-hide-on-mobile' },
	            appt.date
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-hide-on-desktop' },
	            appt.date
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'u-flex u-justify-content-space-between u-align-center' },
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-co-grey u-hide-on-mobile' },
	            'Duration'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-co-grey u-hide-on-desktop' },
	            'Duration'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-hide-on-mobile' },
	            appt.duration
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-hide-on-desktop' },
	            appt.duration
	          )
	        ),
	        appt.appointmentNote && _react2.default.createElement(
	          'div',
	          { className: 'u-flex u-justify-content-space-between u-mt-3' },
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-co-grey u-hide-on-mobile' },
	            'Note'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-co-grey u-hide-on-desktop' },
	            'Note'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-normal u-hide-on-mobile u-ta-right u-1/2' },
	            (0, _utils.cut)(appt.appointmentNote, 60)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'u-text-medium u-hide-on-desktop u-ta-right u-1/2' },
	            (0, _utils.cut)(appt.appointmentNote, 60)
	          )
	        )
	      );
	    }),
	    props.children
	  );
	};
	
	exports.default = AppointmentInfo;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchThirdPartyPromoCode = exports.chargeAppointment = exports.removeReservedTime = exports.reserveTime = exports.validatePrepayOnlyCustomer = exports.reschedule = exports.setCustomTip = exports.applePayAddCustomerToWaitingList = exports.addCustomerToWaitingList = exports.appointmentValidate = exports.resetFee = exports.fetchPromo = exports.resetPromoError = exports.removePromoFromReservation = exports.resetPromo = exports.applePay = exports.clearReservations = exports.getCustomerReward = exports.getBrandRewardProgram = exports.getReservation = exports.getBrandReservation = exports.getAppointmentDetails = exports.receiveReservation = exports.createReservation = exports.processPaymentSuccess = exports.checkForFailedCharges = exports.processPayment = exports.resetPaymentProcessing = exports.updateField = exports.touchField = exports.addAdultsOnlyField = exports.resetFields = exports.setTip = exports.resetTip = exports.cancelAppointment = exports.wrapWithSetProcessingAction = exports.setProcessing = undefined;
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _pickBy2 = __webpack_require__(105);
	
	var _pickBy3 = _interopRequireDefault(_pickBy2);
	
	var _pick2 = __webpack_require__(180);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchReservation = fetchReservation;
	
	var _momentTimezone = __webpack_require__(67);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _actions = __webpack_require__(434);
	
	var _actions2 = __webpack_require__(301);
	
	var _constants = __webpack_require__(10);
	
	var _applePay = __webpack_require__(299);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _googleAnalytics = __webpack_require__(400);
	
	var _googleAnalytics2 = _interopRequireDefault(_googleAnalytics);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var PAYMENT_REQUIRED = 'PaymentRequired';
	
	var setProcessing = exports.setProcessing = function setProcessing(payload) {
	  return { type: _constants.SET_PROCESSING, payload: payload };
	};
	
	var wrapWithSetProcessingAction = exports.wrapWithSetProcessingAction = function wrapWithSetProcessingAction(action) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                dispatch(setProcessing(true));
	                _context.prev = 1;
	                _context.next = 4;
	                return dispatch(action.apply(undefined, args));
	
	              case 4:
	                _context.next = 8;
	                break;
	
	              case 6:
	                _context.prev = 6;
	                _context.t0 = _context['catch'](1);
	
	              case 8:
	                dispatch(setProcessing(false)); // Finally
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[1, 6]]);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	  };
	};
	
	var cancelAppointmentAction = function cancelAppointmentAction(appointmentId) {
	  return function (dispatch) {
	    var url = _config2.default.url + '/cancel-appointment/' + appointmentId;
	
	    dispatch({
	      type: _constants.CANCEL_RESERVATION,
	      payload: appointmentId
	    });
	
	    return fetch(url, {
	      method: 'POST',
	      headers: {
	        Accept: 'application/json',
	        'Content-Type': 'application/json'
	      },
	      body: JSON.stringify({
	        platform: 'Web',
	        sendNotifications: true
	      })
	    }).then(_helpers.checkStatus).then(function () {
	      return dispatch({
	        type: _constants.SET_REDIRECTION,
	        payload: '/appointment-canceled/' + appointmentId
	      });
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};
	var cancelAppointment = exports.cancelAppointment = wrapWithSetProcessingAction(cancelAppointmentAction);
	
	var resetTip = exports.resetTip = function resetTip() {
	  return { type: _constants.RESET_TIP };
	};
	
	var setTip = exports.setTip = function setTip(tip) {
	  return {
	    type: _constants.SET_TIP,
	    payload: tip
	  };
	};
	
	var resetFields = exports.resetFields = function resetFields() {
	  return { type: _constants.RESET_FIELDS };
	};
	
	var addField = function addField(field) {
	  return {
	    type: _constants.ADD_FIELD,
	    payload: field
	  };
	};
	
	var addAdultsOnlyField = exports.addAdultsOnlyField = function addAdultsOnlyField() {
	  var shopName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Barbershop';
	
	  var field = {
	    id: 'adultsonly',
	    name: 'adults-only',
	    type: 'checkbox',
	    label: 'Are you over 21 years old? ' + shopName + ' serves liquor and only allows adults on premises.',
	    fullWidth: true,
	    errorMessage: 'You must verify that you are over 21 years old.',
	    required: true
	  };
	
	  return addField(field);
	};
	
	var validateField = function validateField(id, countryCode, shop) {
	  return {
	    type: _constants.VALIDATE_FIELD,
	    payload: { id: id, countryCode: countryCode, shop: shop }
	  };
	};
	
	var touchField = exports.touchField = function touchField(id, countryCode, shop) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.TOUCH_FIELD,
	      payload: id
	    });
	
	    return dispatch(validateField(id, countryCode, shop));
	  };
	};
	
	var updateField = exports.updateField = function updateField(id, value, countryCode, shop) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.UPDATE_FIELD,
	      payload: { id: id, value: value }
	    });
	
	    return dispatch(validateField(id, countryCode, shop));
	  };
	};
	
	var resetPaymentProcessing = exports.resetPaymentProcessing = function resetPaymentProcessing() {
	  return { type: _constants.RESET_PROCESS_PAYMENT };
	};
	
	var processPayment = exports.processPayment = function processPayment() {
	  return { type: _constants.PROCESS_PAYMENT };
	};
	
	var checkForFailedCharges = exports.checkForFailedCharges = function checkForFailedCharges(dispatch) {
	  return function (_ref2) {
	    var code = _ref2.code,
	        message = _ref2.message,
	        kind = _ref2.kind;
	
	    if (code === PAYMENT_REQUIRED) {
	      return dispatch({
	        type: _constants.FAILED_CHARGES,
	        payload: message
	      });
	    }
	
	    return Promise.reject({ code: code, message: message, kind: kind });
	  };
	};
	
	var processPaymentSuccess = exports.processPaymentSuccess = function processPaymentSuccess() {
	  return { type: _constants.PROCESS_PAYMENT_SUCCESS };
	};
	
	var saveConsents = function saveConsents(customerId, shopId, smsConsent, emailConsent) {
	  var url = _config2.default.url + '/customer/' + customerId + '/shop/' + shopId + '/notifications-consent';
	  var payload = {
	    promotional: {
	      phone: !!smsConsent,
	      email: !!emailConsent
	    }
	  };
	
	  fetch(url, {
	    method: 'PUT',
	    headers: {
	      Accept: 'application/json',
	      'Content-Type': 'application/json'
	    },
	    body: JSON.stringify(payload)
	  });
	};
	
	var callCreateReservationAPIAction = function callCreateReservationAPIAction(reservationUrl, reservationData) {
	  var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/view-reservation';
	  var consents = arguments[3];
	  var turnstileToken = arguments[4];
	  return function (dispatch) {
	    var turnstileHeaders = turnstileToken ? { 'cf-turnstile-response': turnstileToken } : {};
	
	    return fetch(reservationUrl, {
	      method: 'POST',
	      headers: _extends({
	        Accept: 'application/json',
	        'Content-Type': 'application/json'
	      }, turnstileHeaders),
	      body: JSON.stringify(reservationData)
	    }).then(_helpers.checkStatus).then(function (data) {
	      if (!data) {
	        return false;
	      }
	
	      dispatch({
	        type: _constants.SET_REDIRECTION,
	        payload: baseUrl + '/' + data.id
	      });
	
	      dispatch((0, _actions.pixelReservationEvent)(data));
	
	      _BookingAnalytics2.default.bookingComplete({
	        totalWithTip: data.totalWithTip,
	        appointmentId: data.id
	      });
	      _BookingAnalytics2.default.identify(data.customerID, {
	        firstName: data.customer.firstName,
	        lastName: data.customer.lastName,
	        email: data.customer.email,
	        phone: data.customer.phone
	      });
	
	      if (consents) {
	        saveConsents(data.customerId, data.shopId, consents.smsConsent, consents.emailConsent);
	      }
	
	      return dispatch(processPaymentSuccess());
	    }).catch(checkForFailedCharges(dispatch)).catch(function (error) {
	      _BookingAnalytics2.default.paymentError(error);
	      (0, _helpers.handleRequestError)(dispatch)(error);
	    });
	  };
	};
	var callCreateReservationAPI = wrapWithSetProcessingAction(callCreateReservationAPIAction);
	
	var createReservation = exports.createReservation = function createReservation(_ref3) {
	  var redirectUrl = _ref3.redirectUrl,
	      serviceIds = _ref3.serviceIds,
	      reservationTime = _ref3.reservationTime,
	      barberId = _ref3.barberId,
	      user = _ref3.user,
	      tipAmount = _ref3.tipAmount,
	      token = _ref3.token,
	      bookNoPay = _ref3.bookNoPay,
	      anyBarber = _ref3.anyBarber,
	      promoCode = _ref3.promoCode,
	      isReservation = _ref3.isReservation,
	      kiosk = _ref3.kiosk,
	      thirdPartyPromotions = _ref3.thirdPartyPromotions,
	      _ref3$consents = _ref3.consents,
	      consents = _ref3$consents === undefined ? null : _ref3$consents,
	      turnstileToken = _ref3.turnstileToken;
	  return function (dispatch) {
	    var dateTime = (0, _momentTimezone2.default)(reservationTime, _config2.default.timeSlugFormat);
	
	    var reservationData = {
	      barberId: barberId,
	      customer: user,
	      dateTime: dateTime.format(),
	      appointment_service: serviceIds.split(';').map(function (serviceId) {
	        return { serviceId: serviceId };
	      }),
	      tipAmount: tipAmount,
	      sendNotifications: true,
	      platform: 'Web',
	      bookedWithAnyBarber: anyBarber,
	      promoCode: promoCode,
	      isReservation: isReservation,
	      bookNoPay: bookNoPay,
	      thirdPartyPromotions: thirdPartyPromotions
	    };
	    if (token) {
	      reservationData.paymentToken = token.id;
	    }
	
	    dispatch({ type: _constants.CREATE_RESERVATION, payload: reservationData });
	
	    var params = (0, _helpers.joinQueryStringParams)([kiosk ? 'kiosk=true' : '']);
	    var reservationUrl = _config2.default.url + '/book-appointment' + params;
	    return dispatch(callCreateReservationAPI(reservationUrl, (0, _pickBy3.default)(reservationData), redirectUrl, consents, turnstileToken));
	  };
	};
	
	var requestReservation = function requestReservation(id) {
	  return {
	    type: _constants.REQUEST_RESERVATION,
	    payload: id
	  };
	};
	
	var receiveReservation = exports.receiveReservation = function receiveReservation(reservation) {
	  return {
	    type: _constants.RECEIVE_RESERVATION,
	    payload: reservation
	  };
	};
	
	var shouldFetchReservation = function shouldFetchReservation(state, id) {
	  return state.reservation.getIn(['appointment', 'id']) !== id;
	};
	
	var getAppointmentDetails = exports.getAppointmentDetails = function getAppointmentDetails(id) {
	  return fetch(_config2.default.url + '/view-appointment/' + id).then(_helpers.checkStatus);
	};
	
	var getBrandReservation = exports.getBrandReservation = function getBrandReservation(brandId, confirmationCode) {
	  return fetch(_config2.default.url + '/brand/' + brandId + '/reservation/' + confirmationCode).then(_helpers.checkStatus);
	};
	
	var getReservation = exports.getReservation = function getReservation(confirmationCode) {
	  return fetch(_config2.default.url + '/reservation/' + confirmationCode).then(_helpers.checkStatus);
	};
	
	var getBrandRewardProgram = exports.getBrandRewardProgram = function getBrandRewardProgram(brandId) {
	  return fetch(_config2.default.url + '/brand/' + brandId + '/reward').then(_helpers.checkStatus);
	};
	
	var getCustomerReward = exports.getCustomerReward = function getCustomerReward(customerRewardId) {
	  return fetch(_config2.default.url + '/customer-reward/' + customerRewardId).then(_helpers.checkStatus);
	};
	
	function fetchReservation(appointmentId) {
	  return function (dispatch, getState) {
	    if (!shouldFetchReservation(getState(), appointmentId)) return Promise.resolve();
	
	    dispatch(requestReservation(appointmentId));
	
	    return getAppointmentDetails(appointmentId).then(function (appointment) {
	      dispatch(receiveReservation(appointment));
	
	      var customer = appointment.customer;
	
	
	      _BookingAnalytics2.default.identify(customer.customerID, {
	        firstName: customer.firstName,
	        lastName: customer.lastName,
	        email: customer.email,
	        phone: customer.phone
	      });
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	}
	
	var clearReservations = exports.clearReservations = function clearReservations() {
	  return {
	    type: _constants.CLEAR_RESERVATIONS
	  };
	};
	
	var applePay = exports.applePay = function applePay(_ref4) {
	  var redirectUrl = _ref4.redirectUrl,
	      serviceIds = _ref4.serviceIds,
	      reservationTime = _ref4.reservationTime,
	      barberId = _ref4.barberId,
	      tipAmount = _ref4.tipAmount,
	      bookNoPay = _ref4.bookNoPay,
	      anyBarber = _ref4.anyBarber,
	      amount = _ref4.amount,
	      promoCode = _ref4.promoCode,
	      isReservation = _ref4.isReservation,
	      currency = _ref4.currency,
	      thirdPartyPromotions = _ref4.thirdPartyPromotions,
	      consents = _ref4.consents;
	  return function (dispatch) {
	    return (0, _applePay.applePaySession)(amount, currency, function (result) {
	      return dispatch(createReservation({
	        redirectUrl: redirectUrl,
	        serviceIds: serviceIds,
	        reservationTime: reservationTime,
	        barberId: barberId,
	        user: (0, _applePay.mapApplePayUser)((0, _get3.default)(result, 'shippingContact', {})),
	        tipAmount: tipAmount,
	        token: result.token,
	        bookNoPay: bookNoPay,
	        anyBarber: anyBarber,
	        promoCode: promoCode,
	        isReservation: isReservation,
	        thirdPartyPromotions: thirdPartyPromotions,
	        consents: consents
	      }));
	    }, function (error) {
	      _BookingAnalytics2.default.paymentError(error);
	      (0, _helpers.handleRequestError)(dispatch)(error);
	    });
	  };
	};
	
	var resetPromo = exports.resetPromo = function resetPromo() {
	  return {
	    type: _constants.RESET_PROMO_CODE
	  };
	};
	
	var removePromoFromReservation = exports.removePromoFromReservation = function removePromoFromReservation() {
	  return {
	    type: _constants.REMOVE_PROMO_FROM_RESERVATION
	  };
	};
	
	var resetPromoError = exports.resetPromoError = function resetPromoError() {
	  return function (dispatch) {
	    return dispatch({ type: _constants.RESET_PROMO_ERROR });
	  };
	};
	
	var startFetchPromo = function startFetchPromo() {
	  return {
	    type: _constants.FETCH_PROMO_CODE
	  };
	};
	
	var invalidPromo = function invalidPromo(error) {
	  return {
	    type: _constants.INVALID_PROMO_CODE,
	    payload: error
	  };
	};
	
	var setPromo = function setPromo(promo, promoCode) {
	  return {
	    type: _constants.SET_PROMO_CODE,
	    payload: {
	      amount: promo.promoAmount,
	      validationNote: promo.validationNote,
	      promoCode: promoCode
	    }
	  };
	};
	
	var setGiftCard = function setGiftCard(giftCard, promoCode) {
	  return {
	    type: _constants.SET_GIFT_CARD_CODE,
	    payload: {
	      appliedAmount: giftCard.appliedAmount,
	      remainingAmount: giftCard.remainingAmount,
	      promoCode: promoCode
	    }
	  };
	};
	
	var setPromoCode = function setPromoCode(promoCode) {
	  return {
	    type: _constants.SET_PROMO_CODE,
	    payload: { promoCode: promoCode }
	  };
	};
	
	var fetchPromo = exports.fetchPromo = function fetchPromo(promoCode) {
	  return function (dispatch) {
	    dispatch(startFetchPromo());
	    dispatch(setPromoCode(promoCode));
	  };
	};
	
	var resetFee = exports.resetFee = function resetFee() {
	  return { type: _constants.RESET_FEE };
	};
	
	var setTaxBreakdown = function setTaxBreakdown(breakdown) {
	  return {
	    type: _constants.SET_TAX_BREAKDOWN,
	    payload: breakdown
	  };
	};
	
	var appointmentValidate = exports.appointmentValidate = function appointmentValidate(params, giftCardEnabled) {
	  return function (dispatch) {
	    var requiredKeys = ['shopId', 'barberId', 'services'];
	    var requestId = Math.random();
	    if ((0, _helpers.paramMissing)(requiredKeys, params) || params.tip === undefined) return null;
	
	    var paramKeys = [].concat(requiredKeys, ['dateTime', 'firstName', 'lastName', 'phone', 'email', 'promoCode', 'includeWaitingListFee', 'tipAmount', 'tip', 'services', 'duration', 'appointmentId']);
	    if (params.tip === null && !params.useFlatTips) {
	      paramKeys.splice(paramKeys.indexOf('tipAmount'), 1);
	    }
	    var url = _config2.default.url + '/appointment/validate';
	
	    var body = (0, _pick3.default)(params, paramKeys);
	    if (body.barberId === _constants.ANY_BARBER) {
	      delete body.barberId;
	    }
	
	    dispatch({ type: _constants.VALIDATING_APPT_REQUEST_STARTED, payload: requestId });
	
	    return fetch(url, {
	      method: 'POST',
	      headers: {
	        Accept: 'application/json',
	        'Content-Type': 'application/json'
	      },
	      body: JSON.stringify(body)
	    }).then(_helpers.checkStatus).then(function (response) {
	      var fees = response.fees,
	          _response$promo = response.promo,
	          promo = _response$promo === undefined ? {} : _response$promo,
	          _response$giftCard = response.giftCard,
	          giftCard = _response$giftCard === undefined ? {} : _response$giftCard,
	          _response$taxBreakdow = response.taxBreakdown,
	          taxBreakdown = _response$taxBreakdow === undefined ? [] : _response$taxBreakdow,
	          _response$tips = response.tips,
	          tips = _response$tips === undefined ? [] : _response$tips,
	          _response$tip = response.tip,
	          tip = _response$tip === undefined ? null : _response$tip,
	          _response$total = response.total,
	          total = _response$total === undefined ? 0 : _response$total,
	          _response$totalWithou = response.totalWithoutTipAndFees,
	          totalWithoutTipAndFees = _response$totalWithou === undefined ? 0 : _response$totalWithou,
	          _response$services = response.services,
	          services = _response$services === undefined ? [] : _response$services,
	          _response$validTime = response.validTime,
	          validTime = _response$validTime === undefined ? true : _response$validTime,
	          _response$membershipD = response.membershipDiscounts,
	          membershipDiscounts = _response$membershipD === undefined ? [] : _response$membershipD;
	
	
	      dispatch({ type: _constants.VALIDATING_APPT_REQUEST_FINISHED, payload: requestId });
	
	      if (!params.appointmentId) {
	        dispatch({ type: _constants.CHECK_TIME_AVAILABLE });
	
	        if (validTime) {
	          dispatch({ type: _constants.TIME_AVAILABLE });
	        } else {
	          dispatch({
	            type: _constants.TIME_UNAVAILABLE,
	            payload: {
	              message: 'The selected time is no longer available. ' + 'Please try another time or call for assistance. Thank you for your Service.',
	              redirect: params.fallbackUrl
	            }
	          });
	        }
	      }
	
	      dispatch({
	        type: _constants.SET_SERVICES,
	        payload: services
	      });
	
	      dispatch({
	        type: _constants.SET_TIPS,
	        payload: tips
	      });
	
	      // this indicates that default tip was not set and needs to be consumed from the validation result
	      var needToSetDefaultTip = params.tip === null && !params.tipAmount;
	      if (needToSetDefaultTip) {
	        if (tip && !tip.flatAmount) {
	          dispatch(setTip(tip.percentage));
	        } else if (tip && tip.flatAmount) {
	          dispatch(setTip(tip.flatAmount));
	        } else {
	          dispatch(setTip(null));
	        }
	      }
	
	      dispatch({
	        type: _constants.FETCH_FEE,
	        payload: fees.customerBookingFee
	      });
	
	      dispatch(setTaxBreakdown(taxBreakdown));
	
	      dispatch({
	        type: _constants.SET_TOTAL,
	        payload: total
	      });
	
	      dispatch({
	        type: _constants.SET_TOTAL_WITHOUT_TIP_AND_FEES,
	        payload: totalWithoutTipAndFees
	      });
	
	      dispatch({
	        type: _constants.SET_MEMBERSHIP_DISCOUNTS,
	        payload: membershipDiscounts
	      });
	
	      if (!params.promoCode) return;
	
	      if (giftCardEnabled && giftCard.error) {
	        dispatch(invalidPromo(giftCard.error));
	        return;
	      }
	      if (giftCardEnabled && !(0, _isEmpty3.default)(giftCard)) {
	        dispatch(setGiftCard(giftCard, params.promoCode));
	        return;
	      }
	
	      if (promo.error) {
	        dispatch(invalidPromo(promo.error));
	        return;
	      }
	      if (!(0, _isEmpty3.default)(promo)) {
	        dispatch(setPromo(promo, params.promoCode));
	        return;
	      }
	
	      dispatch(invalidPromo('Invalid promo code'));
	    }).catch(function (e) {
	      dispatch({ type: _constants.VALIDATING_APPT_REQUEST_FINISHED, payload: requestId });
	      (0, _helpers.handleRequestError)(dispatch(e));
	    });
	  };
	};
	
	var addCustomerToWaitingList = exports.addCustomerToWaitingList = function addCustomerToWaitingList(_ref5) {
	  var shopId = _ref5.shopId,
	      barberId = _ref5.barberId,
	      serviceIds = _ref5.serviceIds,
	      day = _ref5.day,
	      user = _ref5.user,
	      token = _ref5.token,
	      isApplePay = _ref5.isApplePay,
	      redirectUrl = _ref5.redirectUrl,
	      tipAmount = _ref5.tipAmount,
	      consents = _ref5.consents;
	  return function (dispatch) {
	    var firstName = user.firstName,
	        lastName = user.lastName,
	        phone = user.phone,
	        email = user.email;
	
	    var url = _config2.default.url + '/customer/waiting-list';
	    return fetch(url, {
	      method: 'POST',
	      headers: {
	        Accept: 'application/json',
	        'Content-Type': 'application/json'
	      },
	      body: JSON.stringify({
	        shopId: shopId,
	        barberId: barberId,
	        serviceIds: serviceIds,
	        day: day,
	        firstName: firstName,
	        lastName: lastName,
	        phone: phone,
	        email: email,
	        paymentToken: token,
	        isApplePay: isApplePay,
	        tipAmount: tipAmount
	      })
	    }).then(_helpers.checkStatus).then(function (response) {
	      dispatch({ type: _constants.ADD_CUSTOMER_TO_WAITING_LIST });
	      dispatch((0, _actions2.setWaitingListInfo)(shopId, barberId, serviceIds, response.numberInLine));
	
	      if (consents) {
	        saveConsents(response.customerId, shopId, consents.smsConsent, consents.emailConsent);
	      }
	
	      return dispatch({ type: _constants.SET_REDIRECTION, payload: redirectUrl });
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};
	
	var applePayAddCustomerToWaitingList = exports.applePayAddCustomerToWaitingList = function applePayAddCustomerToWaitingList(amount, currency, params) {
	  return function (dispatch) {
	    return (0, _applePay.applePaySession)(amount, currency, function (result) {
	      return dispatch(addCustomerToWaitingList(_extends({}, params, {
	        isApplePay: true,
	        token: result.token.id,
	        user: (0, _applePay.mapApplePayUser)((0, _get3.default)(result, 'shippingContact', {}))
	      })));
	    }, (0, _helpers.handleRequestError)(dispatch));
	  };
	};
	
	var setCustomTip = exports.setCustomTip = function setCustomTip(amount) {
	  return {
	    type: _constants.SET_CUSTOM_TIP,
	    payload: amount
	  };
	};
	
	var rescheduleAction = function rescheduleAction(appointmentId, dateTime, barberId, removeInvalidPromo, turnstileToken) {
	  return function (dispatch) {
	    dispatch(setProcessing(true));
	
	    var turnstileHeaders = turnstileToken ? { 'cf-turnstile-response': turnstileToken } : {};
	
	    return fetch(_config2.default.url + '/reschedule-appointment/' + appointmentId, {
	      method: 'PUT',
	      headers: _extends({
	        Accept: 'application/json',
	        'Content-Type': 'application/json'
	      }, turnstileHeaders),
	      body: JSON.stringify({
	        dateTime: dateTime,
	        barberId: barberId,
	        confirmations: {
	          removeInvalidPromo: removeInvalidPromo
	        }
	      })
	    }).then(_helpers.checkStatus).then(function (appointment) {
	      if (!appointment) {
	        return false;
	      }
	      dispatch({
	        type: _constants.SET_REDIRECTION,
	        payload: '/view-reservation/' + appointment.id
	      });
	      dispatch(setProcessing(false));
	      return dispatch(receiveReservation(appointment));
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};
	var reschedule = exports.reschedule = wrapWithSetProcessingAction(rescheduleAction);
	
	var validatePrepayOnlyCustomer = exports.validatePrepayOnlyCustomer = function validatePrepayOnlyCustomer(dispatch) {
	  return function (params) {
	    var paramKeys = ['shopId', 'barberId', 'serviceCost', 'dateTime', 'firstName', 'phone', 'email', 'promoCode', 'includeWaitingListFee', 'tipAmount', 'validatePrepayOnly', 'services'];
	    var url = _config2.default.url + '/appointment/validate';
	
	    return fetch(url, {
	      method: 'POST',
	      headers: {
	        Accept: 'application/json',
	        'Content-Type': 'application/json'
	      },
	      body: JSON.stringify((0, _pick3.default)(params, paramKeys))
	    }).then(_helpers.checkStatus).then(function (_ref6) {
	      var customer = _ref6.customer;
	
	      if (customer && customer.error) {
	        dispatch({
	          type: _constants.FAILED_BOOK_AND_RESERVE,
	          payload: customer.error
	        });
	
	        return Promise.reject();
	      }
	
	      return { customer: customer };
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};
	
	var reserveTimeAction = function reserveTimeAction(barberId, action) {
	  var dateTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	  var kiosk = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  var kioskParam = kiosk ? '?kiosk=true' : '';
	  var url = _config2.default.url + '/barber/' + barberId + '/reserve-time' + kioskParam;
	  return fetch(url, {
	    method: 'POST',
	    headers: {
	      Accept: 'application/json',
	      'Content-Type': 'application/json'
	    },
	    body: JSON.stringify({ dateTime: dateTime, action: action, duration: duration })
	  }).then(_helpers.checkStatus);
	};
	
	var reserveTime = exports.reserveTime = function reserveTime(barberId, dateTime, duration, kiosk) {
	  return reserveTimeAction(barberId, 'add', dateTime, duration, kiosk);
	};
	var removeReservedTime = exports.removeReservedTime = function removeReservedTime(barberId) {
	  return reserveTimeAction(barberId, 'remove');
	};
	
	var chargeAppointmentAction = function chargeAppointmentAction(id, data) {
	  return function (dispatch) {
	    var url = _config2.default.url + '/charge-appointment/' + id;
	
	    return fetch(url, {
	      method: 'POST',
	      headers: {
	        Accept: 'application/json',
	        'Content-Type': 'application/json'
	      },
	      body: JSON.stringify(data)
	    }).then(_helpers.checkStatus).then(function (response) {
	      if (!response) {
	        return false;
	      }
	
	      _googleAnalytics2.default.event({
	        category: 'Booking',
	        action: 'Charge from link',
	        value: (0, _get3.default)(response, 'payment.customerBookingFee', 0)
	      });
	
	      dispatch({
	        type: _constants.SET_REDIRECTION,
	        payload: '/view-reservation/' + response.id
	      });
	      return dispatch(processPaymentSuccess());
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};
	
	var chargeAppointment = exports.chargeAppointment = wrapWithSetProcessingAction(chargeAppointmentAction);
	
	var fetchThirdPartyPromoCode = exports.fetchThirdPartyPromoCode = function fetchThirdPartyPromoCode(customerID, subjectID) {
	  return fetch(_config2.default.url + '/promotions/search', {
	    method: 'POST',
	    headers: {
	      'Content-Type': 'application/json'
	    },
	    body: JSON.stringify({
	      subjectType: 'appointment',
	      customerId: customerID,
	      subjectId: subjectID
	    })
	  }).then(function (response) {
	    return response.json();
	  });
	};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	exports.getCountryCallingCode = getCountryCallingCode;
	exports.getExtPrefix = getExtPrefix;
	exports.isSupportedCountry = isSupportedCountry;
	exports.validateMetadata = validateMetadata;
	
	var _semverCompare = _interopRequireDefault(__webpack_require__(1352));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	// Added "possibleLengths" and renamed
	// "country_phone_code_to_countries" to "country_calling_codes".
	var V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".
	
	var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.
	
	var V4 = '1.7.35';
	var DEFAULT_EXT_PREFIX = ' ext. ';
	var CALLING_CODE_REG_EXP = /^\d+$/;
	/**
	 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
	 */
	
	var Metadata = /*#__PURE__*/function () {
	  function Metadata(metadata) {
	    _classCallCheck(this, Metadata);
	
	    validateMetadata(metadata);
	    this.metadata = metadata;
	    setVersion.call(this, metadata);
	  }
	
	  _createClass(Metadata, [{
	    key: "getCountries",
	    value: function getCountries() {
	      return Object.keys(this.metadata.countries).filter(function (_) {
	        return _ !== '001';
	      });
	    }
	  }, {
	    key: "getCountryMetadata",
	    value: function getCountryMetadata(countryCode) {
	      return this.metadata.countries[countryCode];
	    }
	  }, {
	    key: "nonGeographic",
	    value: function nonGeographic() {
	      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
	      // It's present in metadata generated from `1.7.35` to `1.7.37`.
	      // The test case could be found by searching for "nonGeographical".
	
	      return this.metadata.nonGeographic || this.metadata.nonGeographical;
	    }
	  }, {
	    key: "hasCountry",
	    value: function hasCountry(country) {
	      return this.getCountryMetadata(country) !== undefined;
	    }
	  }, {
	    key: "hasCallingCode",
	    value: function hasCallingCode(callingCode) {
	      if (this.getCountryCodesForCallingCode(callingCode)) {
	        return true;
	      }
	
	      if (this.nonGeographic()) {
	        if (this.nonGeographic()[callingCode]) {
	          return true;
	        }
	      } else {
	        // A hacky workaround for old custom metadata (generated before V4).
	        var countryCodes = this.countryCallingCodes()[callingCode];
	
	        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
	          return true;
	        }
	      }
	    }
	  }, {
	    key: "isNonGeographicCallingCode",
	    value: function isNonGeographicCallingCode(callingCode) {
	      if (this.nonGeographic()) {
	        return this.nonGeographic()[callingCode] ? true : false;
	      } else {
	        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
	      }
	    } // Deprecated.
	
	  }, {
	    key: "country",
	    value: function country(countryCode) {
	      return this.selectNumberingPlan(countryCode);
	    }
	  }, {
	    key: "selectNumberingPlan",
	    value: function selectNumberingPlan(countryCode, callingCode) {
	      // Supports just passing `callingCode` as the first argument.
	      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
	        callingCode = countryCode;
	        countryCode = null;
	      }
	
	      if (countryCode && countryCode !== '001') {
	        if (!this.hasCountry(countryCode)) {
	          throw new Error("Unknown country: ".concat(countryCode));
	        }
	
	        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
	      } else if (callingCode) {
	        if (!this.hasCallingCode(callingCode)) {
	          throw new Error("Unknown calling code: ".concat(callingCode));
	        }
	
	        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
	      } else {
	        this.numberingPlan = undefined;
	      }
	
	      return this;
	    }
	  }, {
	    key: "getCountryCodesForCallingCode",
	    value: function getCountryCodesForCallingCode(callingCode) {
	      var countryCodes = this.countryCallingCodes()[callingCode];
	
	      if (countryCodes) {
	        // Metadata before V4 included "non-geographic entity" calling codes
	        // inside `country_calling_codes` (for example, `"881":["001"]`).
	        // Now the semantics of `country_calling_codes` has changed:
	        // it's specifically for "countries" now.
	        // Older versions of custom metadata will simply skip parsing
	        // "non-geographic entity" phone numbers with new versions
	        // of this library: it's not considered a bug,
	        // because such numbers are extremely rare,
	        // and developers extremely rarely use custom metadata.
	        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
	          return;
	        }
	
	        return countryCodes;
	      }
	    }
	  }, {
	    key: "getCountryCodeForCallingCode",
	    value: function getCountryCodeForCallingCode(callingCode) {
	      var countryCodes = this.getCountryCodesForCallingCode(callingCode);
	
	      if (countryCodes) {
	        return countryCodes[0];
	      }
	    }
	  }, {
	    key: "getNumberingPlanMetadata",
	    value: function getNumberingPlanMetadata(callingCode) {
	      var countryCode = this.getCountryCodeForCallingCode(callingCode);
	
	      if (countryCode) {
	        return this.getCountryMetadata(countryCode);
	      }
	
	      if (this.nonGeographic()) {
	        var metadata = this.nonGeographic()[callingCode];
	
	        if (metadata) {
	          return metadata;
	        }
	      } else {
	        // A hacky workaround for old custom metadata (generated before V4).
	        // In that metadata, there was no concept of "non-geographic" metadata
	        // so metadata for `001` country code was stored along with other countries.
	        // The test case can be found by searching for:
	        // "should work around `nonGeographic` metadata not existing".
	        var countryCodes = this.countryCallingCodes()[callingCode];
	
	        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
	          return this.metadata.countries['001'];
	        }
	      }
	    } // Deprecated.
	
	  }, {
	    key: "countryCallingCode",
	    value: function countryCallingCode() {
	      return this.numberingPlan.callingCode();
	    } // Deprecated.
	
	  }, {
	    key: "IDDPrefix",
	    value: function IDDPrefix() {
	      return this.numberingPlan.IDDPrefix();
	    } // Deprecated.
	
	  }, {
	    key: "defaultIDDPrefix",
	    value: function defaultIDDPrefix() {
	      return this.numberingPlan.defaultIDDPrefix();
	    } // Deprecated.
	
	  }, {
	    key: "nationalNumberPattern",
	    value: function nationalNumberPattern() {
	      return this.numberingPlan.nationalNumberPattern();
	    } // Deprecated.
	
	  }, {
	    key: "possibleLengths",
	    value: function possibleLengths() {
	      return this.numberingPlan.possibleLengths();
	    } // Deprecated.
	
	  }, {
	    key: "formats",
	    value: function formats() {
	      return this.numberingPlan.formats();
	    } // Deprecated.
	
	  }, {
	    key: "nationalPrefixForParsing",
	    value: function nationalPrefixForParsing() {
	      return this.numberingPlan.nationalPrefixForParsing();
	    } // Deprecated.
	
	  }, {
	    key: "nationalPrefixTransformRule",
	    value: function nationalPrefixTransformRule() {
	      return this.numberingPlan.nationalPrefixTransformRule();
	    } // Deprecated.
	
	  }, {
	    key: "leadingDigits",
	    value: function leadingDigits() {
	      return this.numberingPlan.leadingDigits();
	    } // Deprecated.
	
	  }, {
	    key: "hasTypes",
	    value: function hasTypes() {
	      return this.numberingPlan.hasTypes();
	    } // Deprecated.
	
	  }, {
	    key: "type",
	    value: function type(_type) {
	      return this.numberingPlan.type(_type);
	    } // Deprecated.
	
	  }, {
	    key: "ext",
	    value: function ext() {
	      return this.numberingPlan.ext();
	    }
	  }, {
	    key: "countryCallingCodes",
	    value: function countryCallingCodes() {
	      if (this.v1) return this.metadata.country_phone_code_to_countries;
	      return this.metadata.country_calling_codes;
	    } // Deprecated.
	
	  }, {
	    key: "chooseCountryByCountryCallingCode",
	    value: function chooseCountryByCountryCallingCode(callingCode) {
	      return this.selectNumberingPlan(callingCode);
	    }
	  }, {
	    key: "hasSelectedNumberingPlan",
	    value: function hasSelectedNumberingPlan() {
	      return this.numberingPlan !== undefined;
	    }
	  }]);
	
	  return Metadata;
	}();
	
	exports["default"] = Metadata;
	
	var NumberingPlan = /*#__PURE__*/function () {
	  function NumberingPlan(metadata, globalMetadataObject) {
	    _classCallCheck(this, NumberingPlan);
	
	    this.globalMetadataObject = globalMetadataObject;
	    this.metadata = metadata;
	    setVersion.call(this, globalMetadataObject.metadata);
	  }
	
	  _createClass(NumberingPlan, [{
	    key: "callingCode",
	    value: function callingCode() {
	      return this.metadata[0];
	    } // Formatting information for regions which share
	    // a country calling code is contained by only one region
	    // for performance reasons. For example, for NANPA region
	    // ("North American Numbering Plan Administration",
	    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
	    // it will be contained in the metadata for `US`.
	
	  }, {
	    key: "getDefaultCountryMetadataForRegion",
	    value: function getDefaultCountryMetadataForRegion() {
	      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
	    } // Is always present.
	
	  }, {
	    key: "IDDPrefix",
	    value: function IDDPrefix() {
	      if (this.v1 || this.v2) return;
	      return this.metadata[1];
	    } // Is only present when a country supports multiple IDD prefixes.
	
	  }, {
	    key: "defaultIDDPrefix",
	    value: function defaultIDDPrefix() {
	      if (this.v1 || this.v2) return;
	      return this.metadata[12];
	    }
	  }, {
	    key: "nationalNumberPattern",
	    value: function nationalNumberPattern() {
	      if (this.v1 || this.v2) return this.metadata[1];
	      return this.metadata[2];
	    } // "possible length" data is always present in Google's metadata.
	
	  }, {
	    key: "possibleLengths",
	    value: function possibleLengths() {
	      if (this.v1) return;
	      return this.metadata[this.v2 ? 2 : 3];
	    }
	  }, {
	    key: "_getFormats",
	    value: function _getFormats(metadata) {
	      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
	    } // For countries of the same region (e.g. NANPA)
	    // formats are all stored in the "main" country for that region.
	    // E.g. "RU" and "KZ", "US" and "CA".
	
	  }, {
	    key: "formats",
	    value: function formats() {
	      var _this = this;
	
	      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
	      return formats.map(function (_) {
	        return new Format(_, _this);
	      });
	    }
	  }, {
	    key: "nationalPrefix",
	    value: function nationalPrefix() {
	      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
	    }
	  }, {
	    key: "_getNationalPrefixFormattingRule",
	    value: function _getNationalPrefixFormattingRule(metadata) {
	      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
	    } // For countries of the same region (e.g. NANPA)
	    // national prefix formatting rule is stored in the "main" country for that region.
	    // E.g. "RU" and "KZ", "US" and "CA".
	
	  }, {
	    key: "nationalPrefixFormattingRule",
	    value: function nationalPrefixFormattingRule() {
	      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
	    }
	  }, {
	    key: "_nationalPrefixForParsing",
	    value: function _nationalPrefixForParsing() {
	      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
	    }
	  }, {
	    key: "nationalPrefixForParsing",
	    value: function nationalPrefixForParsing() {
	      // If `national_prefix_for_parsing` is not set explicitly,
	      // then infer it from `national_prefix` (if any)
	      return this._nationalPrefixForParsing() || this.nationalPrefix();
	    }
	  }, {
	    key: "nationalPrefixTransformRule",
	    value: function nationalPrefixTransformRule() {
	      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
	    }
	  }, {
	    key: "_getNationalPrefixIsOptionalWhenFormatting",
	    value: function _getNationalPrefixIsOptionalWhenFormatting() {
	      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
	    } // For countries of the same region (e.g. NANPA)
	    // "national prefix is optional when formatting" flag is
	    // stored in the "main" country for that region.
	    // E.g. "RU" and "KZ", "US" and "CA".
	
	  }, {
	    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
	    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
	      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
	    }
	  }, {
	    key: "leadingDigits",
	    value: function leadingDigits() {
	      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
	    }
	  }, {
	    key: "types",
	    value: function types() {
	      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
	    }
	  }, {
	    key: "hasTypes",
	    value: function hasTypes() {
	      // Versions 1.2.0 - 1.2.4: can be `[]`.
	
	      /* istanbul ignore next */
	      if (this.types() && this.types().length === 0) {
	        return false;
	      } // Versions <= 1.2.4: can be `undefined`.
	      // Version >= 1.2.5: can be `0`.
	
	
	      return !!this.types();
	    }
	  }, {
	    key: "type",
	    value: function type(_type2) {
	      if (this.hasTypes() && getType(this.types(), _type2)) {
	        return new Type(getType(this.types(), _type2), this);
	      }
	    }
	  }, {
	    key: "ext",
	    value: function ext() {
	      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
	      return this.metadata[13] || DEFAULT_EXT_PREFIX;
	    }
	  }]);
	
	  return NumberingPlan;
	}();
	
	var Format = /*#__PURE__*/function () {
	  function Format(format, metadata) {
	    _classCallCheck(this, Format);
	
	    this._format = format;
	    this.metadata = metadata;
	  }
	
	  _createClass(Format, [{
	    key: "pattern",
	    value: function pattern() {
	      return this._format[0];
	    }
	  }, {
	    key: "format",
	    value: function format() {
	      return this._format[1];
	    }
	  }, {
	    key: "leadingDigitsPatterns",
	    value: function leadingDigitsPatterns() {
	      return this._format[2] || [];
	    }
	  }, {
	    key: "nationalPrefixFormattingRule",
	    value: function nationalPrefixFormattingRule() {
	      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
	    }
	  }, {
	    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
	    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
	      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
	    }
	  }, {
	    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
	    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
	      // National prefix is omitted if there's no national prefix formatting rule
	      // set for this country, or when the national prefix formatting rule
	      // contains no national prefix itself, or when this rule is set but
	      // national prefix is optional for this phone number format
	      // (and it is not enforced explicitly)
	      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
	    } // Checks whether national prefix formatting rule contains national prefix.
	
	  }, {
	    key: "usesNationalPrefix",
	    value: function usesNationalPrefix() {
	      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
	      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
	      // when `national_prefix_formatting_rule` is not present.
	      // So, `true` or `false` are returned explicitly here, so that
	      // `0` number isn't returned.
	      ? true : false;
	    }
	  }, {
	    key: "internationalFormat",
	    value: function internationalFormat() {
	      return this._format[5] || this.format();
	    }
	  }]);
	
	  return Format;
	}();
	/**
	 * A pattern that is used to determine if the national prefix formatting rule
	 * has the first group only, i.e., does not start with the national prefix.
	 * Note that the pattern explicitly allows for unbalanced parentheses.
	 */
	
	
	var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
	
	var Type = /*#__PURE__*/function () {
	  function Type(type, metadata) {
	    _classCallCheck(this, Type);
	
	    this.type = type;
	    this.metadata = metadata;
	  }
	
	  _createClass(Type, [{
	    key: "pattern",
	    value: function pattern() {
	      if (this.metadata.v1) return this.type;
	      return this.type[0];
	    }
	  }, {
	    key: "possibleLengths",
	    value: function possibleLengths() {
	      if (this.metadata.v1) return;
	      return this.type[1] || this.metadata.possibleLengths();
	    }
	  }]);
	
	  return Type;
	}();
	
	function getType(types, type) {
	  switch (type) {
	    case 'FIXED_LINE':
	      return types[0];
	
	    case 'MOBILE':
	      return types[1];
	
	    case 'TOLL_FREE':
	      return types[2];
	
	    case 'PREMIUM_RATE':
	      return types[3];
	
	    case 'PERSONAL_NUMBER':
	      return types[4];
	
	    case 'VOICEMAIL':
	      return types[5];
	
	    case 'UAN':
	      return types[6];
	
	    case 'PAGER':
	      return types[7];
	
	    case 'VOIP':
	      return types[8];
	
	    case 'SHARED_COST':
	      return types[9];
	  }
	}
	
	function validateMetadata(metadata) {
	  if (!metadata) {
	    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
	  } // `country_phone_code_to_countries` was renamed to
	  // `country_calling_codes` in `1.0.18`.
	
	
	  if (!is_object(metadata) || !is_object(metadata.countries)) {
	    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + type_of(metadata) + ': ' + metadata, "."));
	  }
	} // Babel transforms `typeof` into some "branches"
	// so istanbul will show this as "branch not covered".
	
	/* istanbul ignore next */
	
	
	var is_object = function is_object(_) {
	  return _typeof(_) === 'object';
	}; // Babel transforms `typeof` into some "branches"
	// so istanbul will show this as "branch not covered".
	
	/* istanbul ignore next */
	
	
	var type_of = function type_of(_) {
	  return _typeof(_);
	};
	/**
	 * Returns extension prefix for a country.
	 * @param  {string} country
	 * @param  {object} metadata
	 * @return {string?}
	 * @example
	 * // Returns " ext. "
	 * getExtPrefix("US")
	 */
	
	
	function getExtPrefix(country, metadata) {
	  metadata = new Metadata(metadata);
	
	  if (metadata.hasCountry(country)) {
	    return metadata.country(country).ext();
	  }
	
	  return DEFAULT_EXT_PREFIX;
	}
	/**
	 * Returns "country calling code" for a country.
	 * Throws an error if the country doesn't exist or isn't supported by this library.
	 * @param  {string} country
	 * @param  {object} metadata
	 * @return {string}
	 * @example
	 * // Returns "44"
	 * getCountryCallingCode("GB")
	 */
	
	
	function getCountryCallingCode(country, metadata) {
	  metadata = new Metadata(metadata);
	
	  if (metadata.hasCountry(country)) {
	    return metadata.country(country).countryCallingCode();
	  }
	
	  throw new Error("Unknown country: ".concat(country));
	}
	
	function isSupportedCountry(country, metadata) {
	  // metadata = new Metadata(metadata)
	  // return metadata.hasCountry(country)
	  return metadata.countries[country] !== undefined;
	}
	
	function setVersion(metadata) {
	  var version = metadata.version;
	
	  if (typeof version === 'number') {
	    this.v1 = version === 1;
	    this.v2 = version === 2;
	    this.v3 = version === 3;
	    this.v4 = version === 4;
	  } else {
	    if (!version) {
	      this.v1 = true;
	    } else if ((0, _semverCompare["default"])(version, V3) === -1) {
	      this.v2 = true;
	    } else if ((0, _semverCompare["default"])(version, V4) === -1) {
	      this.v3 = true;
	    } else {
	      this.v4 = true;
	    }
	  }
	} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
	// function isCountryCode(countryCode) {
	// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
	// }
	//# sourceMappingURL=metadata.js.map

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1378),
	    baseMatchesProperty = __webpack_require__(1379),
	    identity = __webpack_require__(177),
	    isArray = __webpack_require__(28),
	    property = __webpack_require__(1496);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(344),
	    isArguments = __webpack_require__(178),
	    isArray = __webpack_require__(28),
	    isArrayLike = __webpack_require__(103),
	    isBuffer = __webpack_require__(585),
	    isPrototype = __webpack_require__(227),
	    nativeKeys = __webpack_require__(569);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' ||
	        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (nonEnumShadows || isPrototype(value)) {
	    return !nativeKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _selectors = __webpack_require__(164);
	
	var _selectors2 = __webpack_require__(11);
	
	var _selectors3 = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    shop: (0, _selectors2.getShopByRoute)(state, ownProps.params.shopRoute) || (0, _selectors3.getShopObject)(state) || (0, _selectors.getWaitingListTimesShop)(state)
	  };
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(mapStateToProps));

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getShopAddress = exports.hexToCssHex = exports.stripHexPrefix = exports.getAppLinks = exports.getCustomerPhoto = exports.firstNameAndLastInitial = exports.cut = undefined;
	
	var _prepend2 = __webpack_require__(1583);
	
	var _prepend3 = _interopRequireDefault(_prepend2);
	
	var _join2 = __webpack_require__(1574);
	
	var _join3 = _interopRequireDefault(_join2);
	
	var _is2 = __webpack_require__(1572);
	
	var _is3 = _interopRequireDefault(_is2);
	
	var _ifElse2 = __webpack_require__(358);
	
	var _ifElse3 = _interopRequireDefault(_ifElse2);
	
	var _identity2 = __webpack_require__(742);
	
	var _identity3 = _interopRequireDefault(_identity2);
	
	var _equals2 = __webpack_require__(107);
	
	var _equals3 = _interopRequireDefault(_equals2);
	
	var _both2 = __webpack_require__(356);
	
	var _both3 = _interopRequireDefault(_both2);
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _pipe2 = __webpack_require__(581);
	
	var _pipe3 = _interopRequireDefault(_pipe2);
	
	var _last2 = __webpack_require__(580);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _get2 = __webpack_require__(176);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _routes = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cut = exports.cut = function cut(str, length) {
	  if (!str || str.length <= length) return str;
	  return str.slice(0, length) + '...';
	};
	
	var firstNameAndLastInitial = exports.firstNameAndLastInitial = function firstNameAndLastInitial(name) {
	  var _name$split = name.split(' '),
	      _name$split2 = _slicedToArray(_name$split, 2),
	      firstName = _name$split2[0],
	      lastName = _name$split2[1];
	
	  return (0, _upperFirst3.default)(firstName) + ' ' + ((0, _upperFirst3.default)(lastName) || ' ')[0] + '.';
	};
	
	var getCustomerPhoto = exports.getCustomerPhoto = (0, _pipe3.default)((0, _get3.default)('photos'), _last3.default, (0, _get3.default)('thumbnail'));
	
	var getAppLinks = exports.getAppLinks = function getAppLinks(brandRoute, confirmationCode) {
	  return _extends({
	    appLink: brandRoute ? (0, _routes.prependLocationPrefix)('/apps/' + brandRoute + '/confirmation/' + confirmationCode) : (0, _routes.prependLocationPrefix)('/apps/confirmation/' + confirmationCode)
	  }, !brandRoute ? {
	    androidLink: _config2.default.flagshipAppUrls.android,
	    iosLink: _config2.default.flagshipAppUrls.ios
	  } : {});
	};
	
	var stripHexPrefix = exports.stripHexPrefix = (0, _ifElse3.default)((0, _both3.default)((0, _is3.default)(String), (0, _pipe3.default)(function (str) {
	  return str.slice(0, 2);
	}, (0, _equals3.default)('0x'))), function (str) {
	  return str.slice(2);
	}, _identity3.default);
	
	var hexToCssHex = exports.hexToCssHex = (0, _pipe3.default)(stripHexPrefix, (0, _prepend3.default)('#'), (0, _join3.default)(''));
	
	var getDirections = function getDirections(_ref) {
	  var street = _ref.street,
	      street2 = _ref.street2,
	      city = _ref.city,
	      state = _ref.state,
	      zip = _ref.zip,
	      country = _ref.country;
	
	  var addrStr = [street, street2, city, state, zip, country].filter(Boolean).join(', ');
	  return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(addrStr);
	};
	
	var getShopAddress = exports.getShopAddress = function getShopAddress(shop) {
	  var _shop$address = shop.address,
	      street = _shop$address.street,
	      street2 = _shop$address.street2,
	      city = _shop$address.city,
	      state = _shop$address.state,
	      zip = _shop$address.zip;
	
	  var stateAndZip = [state, zip].filter(Boolean).join(' ');
	  return {
	    line1: [street, street2].filter(Boolean).join(', '),
	    line2: [city, stateAndZip].filter(Boolean).join(', '),
	    directions: getDirections(shop.address)
	  };
	};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(807);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1758);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1757);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1756);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(806);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(808);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2["default"])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2["default"];
	exports.combineReducers = _combineReducers2["default"];
	exports.bindActionCreators = _bindActionCreators2["default"];
	exports.applyMiddleware = _applyMiddleware2["default"];
	exports.compose = _compose2["default"];

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var Sprite = __webpack_require__(1804);
	var globalSprite = new Sprite();
	
	if (document.body) {
	  globalSprite.elem = globalSprite.render(document.body);
	} else {
	  document.addEventListener('DOMContentLoaded', function () {
	    globalSprite.elem = globalSprite.render(document.body);
	  }, false);
	}
	
	module.exports = globalSprite;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBarberAssignments = exports.doServicesHaveAssignments = exports.getSelectedServicesPrepaid = exports.getSelectedCategories = exports.getCategories = exports.getKioskServices = exports.getServices = exports.getSelectedServicesForValidate = exports.getSelectedServices = exports.getServiceNameLong = exports.getServiceNameShort = exports.getServiceName = exports.getServiceDuration = exports.getServiceById = undefined;
	
	var _has2 = __webpack_require__(583);
	
	var _has3 = _interopRequireDefault(_has2);
	
	var _uniqBy2 = __webpack_require__(1510);
	
	var _uniqBy3 = _interopRequireDefault(_uniqBy2);
	
	var _truncate2 = __webpack_require__(1508);
	
	var _truncate3 = _interopRequireDefault(_truncate2);
	
	var _sumBy2 = __webpack_require__(352);
	
	var _sumBy3 = _interopRequireDefault(_sumBy2);
	
	var _some2 = __webpack_require__(181);
	
	var _some3 = _interopRequireDefault(_some2);
	
	var _pick2 = __webpack_require__(180);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _map2 = __webpack_require__(74);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _flow2 = __webpack_require__(125);
	
	var _flow3 = _interopRequireDefault(_flow2);
	
	var _filter2 = __webpack_require__(175);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _every2 = __webpack_require__(1473);
	
	var _every3 = _interopRequireDefault(_every2);
	
	var _compact2 = __webpack_require__(575);
	
	var _compact3 = _interopRequireDefault(_compact2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var SERVICE_NAMES_MAX_LENGTH = 25;
	
	var getServiceById = exports.getServiceById = function getServiceById(state, id) {
	  return (0, _helpers.byId)(state.services.get('items'), id);
	};
	
	var getServiceDuration = exports.getServiceDuration = function getServiceDuration(state, id) {
	  if ((0, _isEmpty3.default)(id)) return 0;
	
	  return (0, _flow3.default)([function (ids) {
	    return (0, _map3.default)(ids, function (item) {
	      return getServiceById(state, item);
	    });
	  }, function (services) {
	    return (0, _sumBy3.default)(services, function (service) {
	      return service && service.get('duration');
	    });
	  }])(id.split(';')) || 0;
	};
	
	var getServiceName = exports.getServiceName = function getServiceName(state, ids) {
	  if (!ids) return '';
	
	  return ids.split(';').map(function (id) {
	    return getServiceById(state, id);
	  }).reduce(function (acc, service) {
	    if (!service) return acc;
	    if (!acc) return service.get('name');
	    return acc + ', ' + service.get('name');
	  }, '');
	};
	
	var getServiceNameShort = exports.getServiceNameShort = function getServiceNameShort(state, ids) {
	  return (0, _truncate3.default)(getServiceName(state, ids), { length: SERVICE_NAMES_MAX_LENGTH, ommission: '...' });
	};
	
	var getServiceNameLong = exports.getServiceNameLong = function getServiceNameLong(state, ids) {
	  var services = getServiceName(state, ids);
	  if (services.length <= SERVICE_NAMES_MAX_LENGTH) return '';
	  return services;
	};
	
	var getSelectedServices = exports.getSelectedServices = function getSelectedServices(state, ids) {
	  return !(0, _isEmpty3.default)(ids) && ids.split(';').map(function (id) {
	    return getServiceById(state, id);
	  }).filter(function (service) {
	    return service;
	  }).map(function (service) {
	    return service.toJS();
	  });
	};
	
	var getSelectedServicesForValidate = exports.getSelectedServicesForValidate = function getSelectedServicesForValidate(state, ids) {
	  return (0, _map3.default)(getSelectedServices(state, ids), function (service) {
	    return (0, _pick3.default)(service, ['id']);
	  });
	};
	
	var isServiceSelected = function isServiceSelected(service, ids) {
	  return ids && ids.split(';').some(function (id) {
	    return id === service.id;
	  });
	};
	var getServices = exports.getServices = function getServices(state, ids) {
	  var services = state.services.get('items').toJS();
	  return services.map(function (service) {
	    return _extends({}, service, {
	      selected: isServiceSelected(service, ids)
	    });
	  });
	};
	
	var getKioskServices = exports.getKioskServices = function getKioskServices(state, ids) {
	  return (0, _filter3.default)(getServices(state, ids), { kioskEnabled: true });
	};
	
	var addUncategorizedCategory = function addUncategorizedCategory(categories) {
	  if ((0, _isEmpty3.default)(categories)) return categories;
	  return [].concat(_toConsumableArray(categories), [{ id: null, name: 'uncategorized' }]);
	};
	var getCategories = exports.getCategories = function getCategories(state) {
	  return addUncategorizedCategory((0, _compact3.default)((0, _uniqBy3.default)((0, _map3.default)(getServices(state), 'categories[0]'), 'id')));
	};
	var getSelectedCategories = exports.getSelectedCategories = function getSelectedCategories(state, ids) {
	  var categories = getCategories(state);
	
	  return (0, _map3.default)(categories, function (category) {
	    return _extends({}, category, {
	      selected: (0, _some3.default)(getSelectedServices(state, ids), { serviceCategoryId: category.id })
	    });
	  });
	};
	
	var getSelectedServicesPrepaid = exports.getSelectedServicesPrepaid = function getSelectedServicesPrepaid(state, ids) {
	  return (0, _every3.default)(getSelectedServices(state, ids), { requiresPrepaid: false });
	};
	
	var doServicesHaveAssignments = exports.doServicesHaveAssignments = function doServicesHaveAssignments(state) {
	  return (0, _has3.default)(state.services.get('items').toJS(), '[0].assignments');
	};
	var getBarberAssignments = exports.getBarberAssignments = function getBarberAssignments(state, barberId) {
	  var services = state.services.get('items').toJS();
	
	  return services.reduce(function (barberAssignments, service) {
	    if (service.assignmentType === 'barber' && service.assigneeId === barberId) {
	      barberAssignments.push(service);
	
	      return barberAssignments;
	    }
	
	    var assignment = (service.assignments || []).find(function (a) {
	      return a.assigneeId === barberId;
	    });
	    if (assignment) {
	      barberAssignments.push(service);
	    }
	
	    return barberAssignments;
	  }, []);
	};

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(560);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var PhonesBackground = function PhonesBackground(_ref) {
	  var name = _ref.name,
	      negative = _ref.negative;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-phones-background ' + (negative && 'c-phones-background-negative') },
	    _react2.default.createElement('img', {
	      width: '100%',
	      className: 'u-hide-on-mobile',
	      src: 'https://squire-emails.s3-us-west-1.amazonaws.com/images/' + name + '-desktop.png',
	      alt: ''
	    }),
	    _react2.default.createElement('img', {
	      width: '100%',
	      className: 'u-hide-on-desktop u-mt-10',
	      src: 'https://squire-emails.s3-us-west-1.amazonaws.com/images/' + name + '-mobile.png',
	      alt: ''
	    })
	  );
	};
	
	exports.default = PhonesBackground;

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	/**
	 * The default argument placeholder value for methods.
	 *
	 * @type {Object}
	 */
	module.exports = {};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerFactory = __webpack_require__(78);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _wrapDisplayName = __webpack_require__(79);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderComponent = function renderComponent(Component) {
	  return function (_) {
	    var factory = (0, _createEagerFactory2.default)(Component);
	    var RenderComponent = function RenderComponent(props) {
	      return factory(props);
	    };
	    if (false) {
	      RenderComponent.displayName = (0, _wrapDisplayName2.default)(Component, 'renderComponent');
	    }
	    return RenderComponent;
	  };
	};
	
	exports.default = renderComponent;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GLYPHS = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _iconSearch = __webpack_require__(1795);
	
	var _iconSearch2 = _interopRequireDefault(_iconSearch);
	
	var _iconLinkedin = __webpack_require__(1794);
	
	var _iconLinkedin2 = _interopRequireDefault(_iconLinkedin);
	
	var _iconInstagram = __webpack_require__(1793);
	
	var _iconInstagram2 = _interopRequireDefault(_iconInstagram);
	
	var _iconFacebook = __webpack_require__(1792);
	
	var _iconFacebook2 = _interopRequireDefault(_iconFacebook);
	
	var _iconTwitter = __webpack_require__(1797);
	
	var _iconTwitter2 = _interopRequireDefault(_iconTwitter);
	
	var _slideArrowLeft = __webpack_require__(1802);
	
	var _slideArrowLeft2 = _interopRequireDefault(_slideArrowLeft);
	
	var _slideArrowRight = __webpack_require__(1803);
	
	var _slideArrowRight2 = _interopRequireDefault(_slideArrowRight);
	
	var _appleIcon = __webpack_require__(1787);
	
	var _appleIcon2 = _interopRequireDefault(_appleIcon);
	
	var _prevWeek = __webpack_require__(1800);
	
	var _prevWeek2 = _interopRequireDefault(_prevWeek);
	
	var _nextWeek = __webpack_require__(1799);
	
	var _nextWeek2 = _interopRequireDefault(_nextWeek);
	
	var _info = __webpack_require__(1798);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _iconCalendar = __webpack_require__(1790);
	
	var _iconCalendar2 = _interopRequireDefault(_iconCalendar);
	
	var _arrowCircleLeft = __webpack_require__(1788);
	
	var _arrowCircleLeft2 = _interopRequireDefault(_arrowCircleLeft);
	
	var _arrowCircleRight = __webpack_require__(1789);
	
	var _arrowCircleRight2 = _interopRequireDefault(_arrowCircleRight);
	
	var _sendArrow = __webpack_require__(1801);
	
	var _sendArrow2 = _interopRequireDefault(_sendArrow);
	
	var _iconSms = __webpack_require__(1796);
	
	var _iconSms2 = _interopRequireDefault(_iconSms);
	
	var _iconEmail = __webpack_require__(1791);
	
	var _iconEmail2 = _interopRequireDefault(_iconEmail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GLYPHS = exports.GLYPHS = {
	  SEARCH: _iconSearch2.default,
	  LINKEDIN: _iconLinkedin2.default,
	  INSTAGRAM: _iconInstagram2.default,
	  FACEBOOK: _iconFacebook2.default,
	  TWITTER: _iconTwitter2.default,
	  SLIDE_ARROW_LEFT: _slideArrowLeft2.default,
	  SLIDE_ARROW_RIGHT: _slideArrowRight2.default,
	  APPLE: _appleIcon2.default,
	  PREV_WEEK: _prevWeek2.default,
	  NEXT_WEEK: _nextWeek2.default,
	  INFO: _info2.default,
	  CALENDAR: _iconCalendar2.default,
	  ARROW_CIRCLE_LEFT: _arrowCircleLeft2.default,
	  ARROW_CIRCLE_RIGHT: _arrowCircleRight2.default,
	  SEND_ARROW: _sendArrow2.default,
	  SMS: _iconSms2.default,
	  EMAIL: _iconEmail2.default
	};
	
	var Icon = function Icon(_ref) {
	  var glyph = _ref.glyph,
	      size = _ref.size,
	      className = _ref.className;
	
	  var classes = (0, _classnames2.default)('o-icon', { 'o-icon--medium': size === 'medium' }, { 'o-icon--small': size === 'small' }, className);
	
	  return _react2.default.createElement(
	    'svg',
	    { className: classes, role: 'img' },
	    _react2.default.createElement('use', { xlinkHref: glyph })
	  );
	};
	Icon.propTypes = {
	  glyph: _propTypes2.default.string.isRequired,
	  size: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	Icon.defaultProps = {
	  size: '',
	  className: ''
	};
	
	exports.default = Icon;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getContext2 = __webpack_require__(803);
	
	var _getContext3 = _interopRequireDefault(_getContext2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getContext3.default)({
	  kiosk: _propTypes2.default.bool.isRequired
	});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function(useSourceMap) {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			return this.map(function (item) {
				var content = cssWithMappingToString(item, useSourceMap);
				if(item[2]) {
					return "@media " + item[2] + "{" + content + "}";
				} else {
					return content;
				}
			}).join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};
	
	function cssWithMappingToString(item, useSourceMap) {
		var content = item[1] || '';
		var cssMapping = item[3];
		if (!cssMapping) {
			return content;
		}
	
		if (useSourceMap && typeof btoa === 'function') {
			var sourceMapping = toComment(cssMapping);
			var sourceURLs = cssMapping.sources.map(function (source) {
				return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
			});
	
			return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
		}
	
		return [content].join('\n');
	}
	
	// Adapted from convert-source-map (MIT)
	function toComment(sourceMap) {
		// eslint-disable-next-line no-undef
		var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
		var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
	
		return '/*# ' + data + ' */';
	}


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var baseConvert = __webpack_require__(1476),
	    util = __webpack_require__(1478);
	
	/**
	 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
	 * version with conversion `options` applied. If `name` is an object its methods
	 * will be converted.
	 *
	 * @param {string} name The name of the function to wrap.
	 * @param {Function} [func] The function to wrap.
	 * @param {Object} [options] The options object. See `baseConvert` for more details.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function convert(name, func, options) {
	  return baseConvert(util, name, func, options);
	}
	
	module.exports = convert;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			// Test for IE <= 9 as proposed by Browserhacks
			// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
			// Tests for existence of standard globals is to allow style-loader 
			// to operate correctly into non-standard environments
			// @see https://github.com/webpack-contrib/style-loader/issues/177
			return window && document && document.all && !window.atob;
		}),
		getElement = (function(fn) {
			var memo = {};
			return function(selector) {
				if (typeof memo[selector] === "undefined") {
					memo[selector] = fn.call(this, selector);
				}
				return memo[selector]
			};
		})(function (styleTarget) {
			return document.querySelector(styleTarget)
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [],
		fixUrls = __webpack_require__(1774);
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		options.attrs = typeof options.attrs === "object" ? options.attrs : {};
	
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the <head> element
		if (typeof options.insertInto === "undefined") options.insertInto = "head";
	
		// By default, add <style> tags to the bottom of the target
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list, options);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList, options);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	};
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list, options) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = options.base ? item[0] + options.base : item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var styleTarget = getElement(options.insertInto)
		if (!styleTarget) {
			throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
		}
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				styleTarget.insertBefore(styleElement, styleTarget.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				styleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				styleTarget.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			styleTarget.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		options.attrs.type = "text/css";
	
		attachTagAttrs(styleElement, options.attrs);
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		options.attrs.type = "text/css";
		options.attrs.rel = "stylesheet";
	
		attachTagAttrs(linkElement, options.attrs);
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function attachTagAttrs(element, attrs) {
		Object.keys(attrs).forEach(function (key) {
			element.setAttribute(key, attrs[key]);
		});
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove, transformResult;
	
		// If a transform function was defined, run it on the css
		if (options.transform && obj.css) {
		    transformResult = options.transform(obj.css);
		    
		    if (transformResult) {
		    	// If transform returns a value, use that instead of the original css.
		    	// This allows running runtime transformations on the css.
		    	obj.css = transformResult;
		    } else {
		    	// If the transform function returns a falsy value, don't add this css. 
		    	// This allows conditional loading of css
		    	return function() {
		    		// noop
		    	};
		    }
		}
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement, options);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, options, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
		*/
		var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;
	
		if (options.convertToAbsoluteUrls || autoFixUrls){
			css = fixUrls(css);
		}
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WithToggle = (0, _compose3.default)((0, _withState3.default)('toggled', 'toggle', function (props) {
	  return !!props.initialState;
	}), (0, _withHandlers3.default)({
	  on: function on(_ref) {
	    var toggle = _ref.toggle;
	    return function () {
	      return toggle(true);
	    };
	  },
	  off: function off(_ref2) {
	    var toggle = _ref2.toggle;
	    return function () {
	      return toggle(false);
	    };
	  },
	  toggle: function toggle(_ref3) {
	    var _toggle = _ref3.toggle;
	    return function () {
	      return _toggle(function (current) {
	        return !current;
	      });
	    };
	  }
	}));
	
	exports.default = WithToggle;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchShopsById = exports.fetchShops = undefined;
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _pipe2 = __webpack_require__(75);
	
	var _pipe3 = _interopRequireDefault(_pipe2);
	
	var _identity2 = __webpack_require__(742);
	
	var _identity3 = _interopRequireDefault(_identity2);
	
	exports.clearShops = clearShops;
	exports.requestShops = requestShops;
	exports.updateFilter = updateFilter;
	exports.receiveShops = receiveShops;
	exports.fetchShop = fetchShop;
	
	var _constants = __webpack_require__(10);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _bayAreaShops = __webpack_require__(402);
	
	var _bayAreaShops2 = _interopRequireDefault(_bayAreaShops);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SHOP_INCLUDES = 'include=services,photos,address,reward,schedules,waitingLists,logo';
	
	function clearShops() {
	  return { type: _constants.CLEAR_SHOPS };
	}
	
	function requestShops() {
	  return {
	    type: _constants.REQUEST_SHOPS
	  };
	}
	
	function updateFilter(filter) {
	  return {
	    type: _constants.UPDATE_FILTER,
	    payload: filter
	  };
	}
	
	function receiveShops(shops) {
	  return {
	    type: _constants.RECEIVE_SHOPS,
	    payload: shops
	  };
	}
	
	function shouldFetchShops(state) {
	  if (!state.shops.items.length && !state.isFetching) {
	    return true;
	  }
	  return true;
	}
	
	function fetchShopsAction(_ref) {
	  var lat = _ref.lat,
	      lng = _ref.lng,
	      searchName = _ref.searchName,
	      city = _ref.city;
	  var clear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _identity3.default;
	
	  return function (dispatch, getState) {
	    if (!shouldFetchShops(getState())) return Promise.resolve();
	
	    if (clear) dispatch(clearShops());
	    dispatch(requestShops());
	
	    var cityFilter = city && city !== '-1';
	    var searchFilter = !!searchName;
	    var coordFilter = lat && lng && !(cityFilter || searchFilter);
	    var ipFilter = !(lat && lng) && !(cityFilter || searchFilter);
	
	    var url = _config2.default.url + '/shop?' + SHOP_INCLUDES + (coordFilter ? '&lat=' + lat + '&lng=' + lng : '') + (cityFilter ? '&city=' + city : '') + (searchFilter ? '&name__like=' + searchName : '') + '&limit=1000' + (ipFilter ? '&searchByIp=true' : '');
	
	    return fetch(url).then(_helpers.checkStatus).then((0, _pipe3.default)(filter, receiveShops, dispatch)).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	}
	var fetchShops = exports.fetchShops = _bayAreaShops2.default.fetchShops(clearShops, fetchShopsAction);
	
	var fetchShopsById = exports.fetchShopsById = function fetchShopsById(ids) {
	  return function (dispatch) {
	    if ((0, _isEmpty3.default)(ids)) return null;
	    dispatch(requestShops());
	    var shopsFilter = 'id__in=' + ids.join(',');
	    var url = _config2.default.url + '/shop?' + SHOP_INCLUDES + '&' + shopsFilter;
	
	    return fetch(url).then(_helpers.checkStatus).then(function (shops) {
	      return dispatch(receiveShops(shops));
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};
	
	function requestShop(route) {
	  return {
	    type: _constants.REQUEST_SHOP,
	    payload: route
	  };
	}
	
	function receiveShop(shop) {
	  return {
	    type: _constants.RECEIVE_SHOP,
	    payload: shop
	  };
	}
	
	function shouldFetchShop(state, route) {
	  return state.shops.items && !state.shops.items.find(function (shop) {
	    return shop.route === route;
	  });
	}
	
	function fetchShop(route, urlPattern) {
	  return function (dispatch, getState) {
	    if (!shouldFetchShop(getState(), route)) {
	      return Promise.resolve();
	    }
	
	    dispatch(requestShop(route));
	
	    var url = _config2.default.url + '/shop/' + route + '?' + SHOP_INCLUDES;
	
	    return fetch(url).then((0, _helpers.checkRoute)(dispatch, {}, urlPattern)).then(_helpers.checkStatus).then(function (shop) {
	      return dispatch(receiveShop(shop));
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	}

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(1516);
	moment.tz.load(__webpack_require__(1329));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _isPlaceholder = /*#__PURE__*/__webpack_require__(241);
	
	/**
	 * Optimized internal three-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	
	
	function _curry3(fn) {
	  return function f3(a, b, c) {
	    switch (arguments.length) {
	      case 0:
	        return f3;
	      case 1:
	        return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
	          return fn(a, _b, _c);
	        });
	      case 2:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
	          return fn(_a, b, _c);
	        }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
	          return fn(a, _b, _c);
	        }) : _curry1(function (_c) {
	          return fn(a, b, _c);
	        });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
	          return fn(_a, _b, c);
	        }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
	          return fn(_a, b, _c);
	        }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
	          return fn(a, _b, _c);
	        }) : _isPlaceholder(a) ? _curry1(function (_a) {
	          return fn(_a, b, c);
	        }) : _isPlaceholder(b) ? _curry1(function (_b) {
	          return fn(a, _b, c);
	        }) : _isPlaceholder(c) ? _curry1(function (_c) {
	          return fn(a, b, _c);
	        }) : fn(a, b, c);
	    }
	  };
	}
	module.exports = _curry3;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(1749);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setDisplayName = function setDisplayName(displayName) {
	  return (0, _setStatic2.default)('displayName', displayName);
	};
	
	exports.default = setDisplayName;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var ShopLocation = function ShopLocation(_ref) {
	  var map = _ref.map,
	      shopName = _ref.shopName,
	      line1 = _ref.line1,
	      line2 = _ref.line2,
	      phone = _ref.phone,
	      directions = _ref.directions,
	      fixed = _ref.fixed;
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('c-shop-location', { 'c-shop-location--fixed': fixed }) },
	    _react2.default.createElement('img', { src: map, alt: '' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-pt-6 u-pr-4 u-pb-4 u-pl-4 u-flex-1 u-flex u-justify-content-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-ta-left' },
	        _react2.default.createElement(
	          'div',
	          { className: 'u-text-normal u-fw-bold u-mb-2' },
	          shopName
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'u-text-small u-co-grey u-mb-3' },
	          line1,
	          ',',
	          _react2.default.createElement('br', null),
	          line2,
	          _react2.default.createElement('br', null),
	          phone
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'u-text-normal u-co-grey', href: directions, target: '_blank' },
	          'Get directions'
	        )
	      )
	    )
	  );
	};
	
	exports.default = ShopLocation;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIsWholeDayOff = exports.getNextLink = exports.getNextAvailableTime = exports.getTimeOrItem = exports.getActiveTimeBarber = exports.getActiveTime = exports.getActiveDay = exports.getSelectedTimeBarberRoute = exports.getNextUnfetchedDayUpToAdvanceBookDays = exports.getNextUnfetchedDay = exports.getNoTimesAvailable = exports.shouldLoadTimesForInterval = exports.getDaysUpToAdvanceBookDays = exports.getDays = exports.getActiveDayTimes = exports.getTimesForDay = undefined;
	
	var _sortBy2 = __webpack_require__(582);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _filter2 = __webpack_require__(175);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _isNil2 = __webpack_require__(234);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _negate2 = __webpack_require__(238);
	
	var _negate3 = _interopRequireDefault(_negate2);
	
	var _pickBy2 = __webpack_require__(105);
	
	var _pickBy3 = _interopRequireDefault(_pickBy2);
	
	var _some2 = __webpack_require__(181);
	
	var _some3 = _interopRequireDefault(_some2);
	
	var _times2 = __webpack_require__(1504);
	
	var _times3 = _interopRequireDefault(_times2);
	
	var _map2 = __webpack_require__(74);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _last2 = __webpack_require__(237);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _flow2 = __webpack_require__(125);
	
	var _flow3 = _interopRequireDefault(_flow2);
	
	var _flatten2 = __webpack_require__(1474);
	
	var _flatten3 = _interopRequireDefault(_flatten2);
	
	var _find2 = __webpack_require__(576);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _momentTimezone = __webpack_require__(67);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTimes = function getTimes(state) {
	  return (0, _get3.default)(state, 'times.items');
	};
	
	var getTimesForDay = exports.getTimesForDay = function getTimesForDay(state, day) {
	  var items = (0, _get3.default)(state.times, 'items', []);
	  var findTimesForDay = function findTimesForDay(item) {
	    return item.day === day;
	  };
	  return (0, _get3.default)(items.find(findTimesForDay), 'times', []).map(_helpers.mapTimes);
	};
	
	var getActiveDayTimes = exports.getActiveDayTimes = function getActiveDayTimes(state) {
	  return getTimesForDay(state, state.times.activeDay);
	};
	
	var isDayActive = function isDayActive(state, day) {
	  return day === state.times.activeDay;
	};
	
	var dayHasTimes = function dayHasTimes(state, day) {
	  return getTimesForDay(state, day).length > 0;
	};
	
	var getDay = function getDay(state, day) {
	  var dayOfWeek = (0, _momentTimezone2.default)(day).format('ddd');
	  var formatted = (0, _momentTimezone2.default)(day).format('D');
	
	  var date = day.format(_config2.default.apiDateFormat);
	
	  return {
	    dayOfWeek: dayOfWeek,
	    formatted: formatted,
	    active: isDayActive(state, date),
	    disabled: !dayHasTimes(state, date),
	    date: date
	  };
	};
	
	var getDays = exports.getDays = function getDays(state) {
	  return (0, _map3.default)(state.times.items, function (item) {
	    return getDay(state, (0, _momentTimezone2.default)(item.day, _config2.default.apiDateFormat));
	  });
	};
	
	var getDaysForWeek = function getDaysForWeek(state) {
	  var startDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _momentTimezone2.default)();
	  return (0, _times3.default)(7, function (i) {
	    return getDay(state, (0, _momentTimezone2.default)(startDay).add(i, 'days'));
	  });
	};
	
	var getDaysUpToAdvanceBookDays = exports.getDaysUpToAdvanceBookDays = function getDaysUpToAdvanceBookDays(state) {
	  var advanceBookDays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;
	
	  var weeks = Math.ceil(advanceBookDays / 7) || 1;
	  return (0, _flatten3.default)((0, _times3.default)(weeks, function (i) {
	    return getDaysForWeek(state, (0, _momentTimezone2.default)().add(i, 'week'));
	  }));
	};
	
	var shouldLoadTimesForInterval = exports.shouldLoadTimesForInterval = function shouldLoadTimesForInterval(state, startDay, endDay) {
	  if (!startDay || !endDay) return false;
	
	  return !(0, _some3.default)((0, _get3.default)(state, 'times.items'), function (item) {
	    return item.day === startDay;
	  }) || !(0, _some3.default)((0, _get3.default)(state, 'times.items'), function (item) {
	    return item.day === endDay;
	  });
	};
	
	var getNoTimesAvailable = exports.getNoTimesAvailable = function getNoTimesAvailable(state) {
	  return getActiveDayTimes(state).length === 0;
	};
	
	var getNextUnfetchedDay = exports.getNextUnfetchedDay = function getNextUnfetchedDay(state) {
	  var lastFetchedDay = (0, _get3.default)((0, _last3.default)(state.times.items), 'day');
	  if (!lastFetchedDay) return null;
	  return (0, _momentTimezone2.default)(lastFetchedDay).add(1, 'days').format(_config2.default.apiDateFormat);
	};
	
	var getNextUnfetchedDayUpToAdvanceBookDays = exports.getNextUnfetchedDayUpToAdvanceBookDays = function getNextUnfetchedDayUpToAdvanceBookDays(state, advanceBookDays) {
	  var nextUnfetchedDay = getNextUnfetchedDay(state);
	  if ((0, _momentTimezone2.default)(nextUnfetchedDay).isBefore((0, _momentTimezone2.default)().add(advanceBookDays, 'days'))) return nextUnfetchedDay;
	  return null;
	};
	
	var getSelectedTime = function getSelectedTime(state, reservationTime, timezone) {
	  var selected = (0, _helpers.parseTimeSlug)(reservationTime, timezone);
	  if ((0, _isEmpty3.default)(selected)) return null;
	  var selectedDay = selected.format(_config2.default.apiDateFormat);
	  var selectedTimes = (0, _get3.default)((0, _find3.default)(state.times.items, { day: selectedDay }), 'times');
	  return (0, _find3.default)(selectedTimes, { time: selected.toISOString() });
	};
	
	var getSelectedTimeBarberRoute = exports.getSelectedTimeBarberRoute = function getSelectedTimeBarberRoute(state, reservationTime, timezone) {
	  var selectedTime = getSelectedTime(state, reservationTime, timezone);
	  if ((0, _isEmpty3.default)(selectedTime)) return null;
	  return (0, _get3.default)(selectedTime, 'barberRoute');
	};
	
	var getActiveDay = exports.getActiveDay = function getActiveDay(state) {
	  return (0, _get3.default)(state, 'times.activeDay');
	};
	
	var getActiveTime = exports.getActiveTime = function getActiveTime(state) {
	  return (0, _get3.default)(state, 'times.activeTime');
	};
	
	var getActiveTimeBarber = exports.getActiveTimeBarber = function getActiveTimeBarber(state) {
	  return (0, _get3.default)(state, 'times.activeTimeBarber', '');
	};
	
	var getTimeOrItem = exports.getTimeOrItem = function getTimeOrItem(item) {
	  return (0, _get3.default)(item, 'time') ? item.time : item;
	};
	var sortTimeItems = (0, _sortBy3.default)(getTimeOrItem);
	var getNextAvailableTime = exports.getNextAvailableTime = function getNextAvailableTime(state, fromDate, timezone) {
	  var from = _momentTimezone2.default.tz(fromDate, timezone).startOf('day');
	  var isTimeAfter = function isTimeAfter(time) {
	    return (0, _momentTimezone2.default)(time).isAfter(from);
	  };
	  return (0, _flow3.default)(getTimes, function (items) {
	    return (0, _map3.default)(items, 'times');
	  }, _flatten3.default, sortTimeItems, function (items) {
	    return (0, _find3.default)(items, (0, _flow3.default)(getTimeOrItem, isTimeAfter));
	  })(state);
	};
	
	var getNextLink = exports.getNextLink = function getNextLink(state, generateUrlString, anyBarber) {
	  var reservationTime = getActiveTime(state);
	  var barberRoute = getActiveTimeBarber(state);
	  var query = anyBarber ? { anyBarber: true } : null;
	
	  return {
	    pathname: generateUrlString((0, _pickBy3.default)({ reservationTime: reservationTime, barberRoute: barberRoute }, (0, _negate3.default)(_isNil3.default))),
	    query: query
	  };
	};
	
	var getIsWholeDayOff = exports.getIsWholeDayOff = function getIsWholeDayOff(state, day) {
	  var wholeDaysOff = (0, _filter3.default)(state.daysOff.get('items'), 'wholeDay');
	  var daysOff = (0, _map3.default)(wholeDaysOff, function (item) {
	    return _momentTimezone2.default.utc(item.day).format('YYYY-MM-DD');
	  });
	  return daysOff.includes(day);
	};

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WHITESPACE = exports.VALID_PUNCTUATION = exports.VALID_DIGITS = exports.PLUS_CHARS = exports.MIN_LENGTH_FOR_NSN = exports.MAX_LENGTH_FOR_NSN = exports.MAX_LENGTH_COUNTRY_CODE = void 0;
	// The minimum length of the national significant number.
	var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
	// but one can find longer numbers in Germany.
	
	exports.MIN_LENGTH_FOR_NSN = MIN_LENGTH_FOR_NSN;
	var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.
	
	exports.MAX_LENGTH_FOR_NSN = MAX_LENGTH_FOR_NSN;
	var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
	// (ascii, fullwidth, arabic-indic, and eastern arabic digits).
	
	exports.MAX_LENGTH_COUNTRY_CODE = MAX_LENGTH_COUNTRY_CODE;
	var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
	
	exports.VALID_DIGITS = VALID_DIGITS;
	var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
	var SLASHES = "\uFF0F/";
	var DOTS = "\uFF0E.";
	var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
	exports.WHITESPACE = WHITESPACE;
	var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
	
	var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
	// excludes punctuation found as a leading character only. This consists of dash
	// characters, white space characters, full stops, slashes, square brackets,
	// parentheses and tildes. Full-width variants are also present.
	
	var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
	exports.VALID_PUNCTUATION = VALID_PUNCTUATION;
	var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')
	
	exports.PLUS_CHARS = PLUS_CHARS;
	//# sourceMappingURL=constants.js.map

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(169);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = baseRest;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(101),
	    baseIteratee = __webpack_require__(44),
	    baseMap = __webpack_require__(546),
	    isArray = __webpack_require__(28);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(240);
	
	var _pipe = /*#__PURE__*/__webpack_require__(1563);
	
	var reduce = /*#__PURE__*/__webpack_require__(245);
	
	var tail = /*#__PURE__*/__webpack_require__(1587);
	
	/**
	 * Performs left-to-right function composition. The leftmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * In some libraries this function is named `sequence`.
	 *
	 * **Note:** The result of pipe is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.compose
	 * @example
	 *
	 *      var f = R.pipe(Math.pow, R.negate, R.inc);
	 *
	 *      f(3, 4); // -(3^4) + 1
	 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
	 */
	
	
	function pipe() {
	  if (arguments.length === 0) {
	    throw new Error('pipe requires at least one argument');
	  }
	  return _arity(arguments[0].length, reduce(_pipe, arguments[0], tail(arguments)));
	}
	module.exports = pipe;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.GatewayRegistry = exports.GatewayProvider = exports.GatewayDest = exports.Gateway = undefined;
	
	var _Gateway2 = __webpack_require__(1676);
	
	var _Gateway3 = _interopRequireDefault(_Gateway2);
	
	var _GatewayDest2 = __webpack_require__(1677);
	
	var _GatewayDest3 = _interopRequireDefault(_GatewayDest2);
	
	var _GatewayProvider2 = __webpack_require__(1678);
	
	var _GatewayProvider3 = _interopRequireDefault(_GatewayProvider2);
	
	var _GatewayRegistry2 = __webpack_require__(255);
	
	var _GatewayRegistry3 = _interopRequireDefault(_GatewayRegistry2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Gateway = _Gateway3.default;
	exports.GatewayDest = _GatewayDest3.default;
	exports.GatewayProvider = _GatewayProvider3.default;
	exports.GatewayRegistry = _GatewayRegistry3.default;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerElementUtil = __webpack_require__(1751);
	
	var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);
	
	var _isReferentiallyTransparentFunctionComponent = __webpack_require__(1746);
	
	var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFactory = function createFactory(type) {
	  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
	  return function (p, c) {
	    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
	  };
	};
	
	exports.default = createFactory;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getDisplayName = __webpack_require__(804);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
	};
	
	exports.default = wrapDisplayName;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.inherit = __webpack_require__(317);
	exports.clone = __webpack_require__(258);
	exports.type = __webpack_require__(1817);


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSpinkit = __webpack_require__(90);
	
	var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Loader = function Loader() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-heading u-p++ u-text-center' },
	    'Loading',
	    _react2.default.createElement(_reactSpinkit2.default, { className: 'u-co-teal-blue', noFadeIn: true })
	  );
	};
	
	exports.default = Loader;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    shopRoute: (0, _selectors.getShopRoute)(state),
	    barberRoute: (0, _selectors.getBarberRoute)(state),
	    serviceId: (0, _selectors.getServiceIds)(state),
	    reservationTime: (0, _selectors.getAppointmentTimeInUrlFormat)(state)
	  };
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(mapStateToProps), (0, _withProps3.default)(function (props) {
	  return _extends({
	    serviceId: props.serviceId,
	    barberRoute: props.barberRoute,
	    shopRoute: props.shopRoute,
	    reservationTime: props.reservationTime
	  }, props.params);
	}));

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26),
	    _assign = __webpack_require__(24);
	
	var CallbackQueue = __webpack_require__(762);
	var PooledClass = __webpack_require__(129);
	var ReactFeatureFlags = __webpack_require__(767);
	var ReactReconciler = __webpack_require__(152);
	var Transaction = __webpack_require__(252);
	
	var invariant = __webpack_require__(13);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	/**
	 * toString ref.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Return the type of `val`.
	 *
	 * @param {Mixed} val
	 * @return {String}
	 * @api public
	 */
	
	module.exports = function(val){
	  switch (toString.call(val)) {
	    case '[object Date]': return 'date';
	    case '[object RegExp]': return 'regexp';
	    case '[object Arguments]': return 'arguments';
	    case '[object Array]': return 'array';
	    case '[object Error]': return 'error';
	  }
	
	  if (val === null) return 'null';
	  if (val === undefined) return 'undefined';
	  if (val !== val) return 'nan';
	  if (val && val.nodeType === 1) return 'element';
	
	  if (isBuffer(val)) return 'buffer';
	
	  val = val.valueOf
	    ? val.valueOf()
	    : Object.prototype.valueOf.apply(val);
	
	  return typeof val;
	};
	
	// code borrowed from https://github.com/feross/is-buffer/blob/master/index.js
	function isBuffer(obj) {
	  return !!(obj != null &&
	    (obj._isBuffer || // For Safari 5-7 (missing Object.prototype.constructor)
	      (obj.constructor &&
	      typeof obj.constructor.isBuffer === 'function' &&
	      obj.constructor.isBuffer(obj))
	    ))
	}


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	/**
	 * Retrieve the value at a given path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> {a} -> a | Undefined
	 * @param {Array} path The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path`.
	 * @see R.prop
	 * @example
	 *
	 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
	 */
	
	
	var path = /*#__PURE__*/_curry2(function path(paths, obj) {
	  var val = obj;
	  var idx = 0;
	  while (idx < paths.length) {
	    if (val == null) {
	      return;
	    }
	    val = val[paths[idx]];
	    idx += 1;
	  }
	  return val;
	});
	module.exports = path;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var path = /*#__PURE__*/__webpack_require__(87);
	
	/**
	 * Returns a function that when supplied an object returns the indicated
	 * property of that object, if it exists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig s -> {s: a} -> a | Undefined
	 * @param {String} p The property name
	 * @param {Object} obj The object to query
	 * @return {*} The value at `obj.p`.
	 * @see R.path
	 * @example
	 *
	 *      R.prop('x', {x: 100}); //=> 100
	 *      R.prop('x', {}); //=> undefined
	 */
	
	var prop = /*#__PURE__*/_curry2(function prop(p, obj) {
	  return path([p], obj);
	});
	module.exports = prop;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(24);
	
	var PooledClass = __webpack_require__(129);
	
	var emptyFunction = __webpack_require__(65);
	var warning = __webpack_require__(19);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(24);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	__webpack_require__(1779);
	
	__webpack_require__(1775);
	
	__webpack_require__(1776);
	
	__webpack_require__(1777);
	
	__webpack_require__(1778);
	
	__webpack_require__(1780);
	
	__webpack_require__(1781);
	
	__webpack_require__(1782);
	
	__webpack_require__(1783);
	
	__webpack_require__(1784);
	
	__webpack_require__(1785);
	
	__webpack_require__(1786);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-extraneous-dependencies
	
	
	var Spinner = function (_React$Component) {
	  _inherits(Spinner, _React$Component);
	
	  function Spinner(props) {
	    _classCallCheck(this, Spinner);
	
	    var _this = _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).call(this, props));
	
	    _this.displayName = 'SpinKit';
	    return _this;
	  }
	
	  _createClass(Spinner, [{
	    key: 'render',
	    value: function render() {
	      var _cx;
	
	      var classes = (0, _classnames2.default)((_cx = {
	        'sk-fade-in': !this.props.noFadeIn,
	        'sk-spinner': this.props.overrideSpinnerClassName === ''
	      }, _defineProperty(_cx, this.props.overrideSpinnerClassName, !!this.props.overrideSpinnerClassName), _defineProperty(_cx, this.props.className, !!this.props.className), _cx));
	
	      var props = (0, _objectAssign2.default)({}, this.props);
	      delete props.spinnerName;
	      delete props.noFadeIn;
	      delete props.overrideSpinnerClassName;
	      delete props.className;
	
	      var spinnerEl = void 0;
	      switch (this.props.spinnerName) {
	        case 'double-bounce':
	          spinnerEl = _react2.default.createElement(
	            'div',
	            _extends({}, props, { className: 'sk-double-bounce ' + classes }),
	            _react2.default.createElement('div', { className: 'sk-double-bounce1' }),
	            _react2.default.createElement('div', { className: 'sk-double-bounce2' })
	          );
	          break;
	        case 'rotating-plane':
	          spinnerEl = _react2.default.createElement(
	            'div',
	            _extends({}, props, { className: classes }),
	            _react2.default.createElement('div', { className: 'sk-rotating-plane' })
	          );
	          break;
	        case 'wave':
	          spinnerEl = _react2.default.createElement(
	            'div',
	            _extends({}, props, { className: 'sk-wave ' + classes }),
	            _react2.default.createElement('div', { className: 'sk-rect1' }),
	            _react2.default.createElement('div', { className: 'sk-rect2' }),
	            _react2.default.createElement('div', { className: 'sk-rect3' }),
	            _react2.default.createElement('div', { className: 'sk-rect4' }),
	            _react2.default.createElement('div', { className: 'sk-rect5' })
	          );
	          break;
	        case 'wandering-cubes':
	          spinnerEl = _react2.default.createElement(
	            'div',
	            _extends({}, props, { className: 'sk-wandering-cubes ' + classes }),
	            _react2.default.createElement('div', { className: 'sk-cube1' }),
	            _react2.default.createElement('div', { className: 'sk-cube2' })
	          );
	          break;
	        case 'pulse':
	          spinnerEl = _react2.default.createElement(
	            'div',
	            _extends({}, props, { className: classes }),
	            _react2.default.createElement('div', { className: 'sk-pulse' })
	          );
	          break;
	        case 'chasing-dots':
	          spinnerEl = _react2.default.createElement(
	            'div',
	            _extends({}, props, { className: classes }),
	            _react2.default.createElement(
	              'div',
	              { className: 'sk-chasing-dots' },
	              _react2.default.createElement('div', { className: 'sk-dot1' }),
	              _react2.default.createElement('div', { className: 'sk-dot2' })
	            )
	          );
	          break;
	        case 'circle':
	          spinnerEl = _react2.default.createElement(
	            'div',
	            _extends({}, props, { className: 'sk-circle-wrapper ' + classes }),
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-circle' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-circle' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-circle' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-circle' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-circle' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-circle' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-circle' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-circle' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-circle' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-circle' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-circle' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-circle' })
	          );
	          break;
	        case 'cube-grid':
	          spinnerEl = _react2.default.createElement(
	            'div',
	            _extends({}, props, { className: 'sk-cube-grid ' + classes }),
	            _react2.default.createElement('div', { className: 'sk-cube' }),
	            _react2.default.createElement('div', { className: 'sk-cube' }),
	            _react2.default.createElement('div', { className: 'sk-cube' }),
	            _react2.default.createElement('div', { className: 'sk-cube' }),
	            _react2.default.createElement('div', { className: 'sk-cube' }),
	            _react2.default.createElement('div', { className: 'sk-cube' }),
	            _react2.default.createElement('div', { className: 'sk-cube' }),
	            _react2.default.createElement('div', { className: 'sk-cube' }),
	            _react2.default.createElement('div', { className: 'sk-cube' })
	          );
	          break;
	        case 'folding-cube':
	          spinnerEl = _react2.default.createElement(
	            'div',
	            _extends({}, props, { className: 'sk-folding-cube ' + classes }),
	            _react2.default.createElement('div', { className: 'sk-cube' }),
	            _react2.default.createElement('div', { className: 'sk-cube' }),
	            _react2.default.createElement('div', { className: 'sk-cube' }),
	            _react2.default.createElement('div', { className: 'sk-cube' })
	          );
	          break;
	        case 'wordpress':
	          spinnerEl = _react2.default.createElement(
	            'div',
	            _extends({}, props, { className: classes }),
	            _react2.default.createElement(
	              'div',
	              { className: 'sk-wordpress' },
	              _react2.default.createElement('div', { className: 'sk-inner-circle' })
	            )
	          );
	          break;
	        case 'three-bounce':
	        default:
	          spinnerEl = _react2.default.createElement(
	            'div',
	            _extends({}, props, { className: 'sk-three-bounce ' + classes }),
	            _react2.default.createElement('div', { className: 'sk-bounce1' }),
	            _react2.default.createElement('div', { className: 'sk-bounce2' }),
	            _react2.default.createElement('div', { className: 'sk-bounce3' })
	          );
	      }
	      return spinnerEl;
	    }
	  }]);
	
	  return Spinner;
	}(_react2.default.Component);
	
	Spinner.propTypes = {
	  spinnerName: _propTypes2.default.string.isRequired,
	  noFadeIn: _propTypes2.default.bool,
	  overrideSpinnerClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	Spinner.defaultProps = {
	  spinnerName: 'sk-three-bounce',
	  noFadeIn: false,
	  overrideSpinnerClassName: ''
	};
	
	module.exports = Spinner;

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.receiveBarbers = receiveBarbers;
	exports.fetchBarbers = fetchBarbers;
	exports.fetchBrandBarbers = fetchBrandBarbers;
	exports.fetchBarbersWithNextAvailableTime = fetchBarbersWithNextAvailableTime;
	
	var _reactRouter = __webpack_require__(5);
	
	var _history = __webpack_require__(201);
	
	var _constants = __webpack_require__(10);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _selectors = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requestBarbers() {
	  return { type: _constants.REQUEST_BARBERS };
	}
	
	function receiveBarbers(barbers) {
	  return {
	    type: _constants.RECEIVE_BARBERS,
	    payload: barbers
	  };
	}
	
	var appendPrefix = function appendPrefix(path, prefix) {
	  if (!prefix) {
	    return path;
	  }
	  return '/' + prefix + path;
	};
	
	var redirectIfOldRoute = function redirectIfOldRoute(oldRoute, kiosk, book) {
	  return function (barbers) {
	    var route = (0, _get3.default)(barbers, '[0].shop.route');
	    if (route && oldRoute !== route) {
	      var path = _reactRouter.browserHistory.getCurrentLocation().pathname.split('/');
	
	      var consolidatedPrefix = _config2.default.pathPrefix.replace(/^\/|\/$/g, '').split('/').join('/');
	      if (consolidatedPrefix) {
	        var regexp = new RegExp('^/' + consolidatedPrefix);
	        path = _reactRouter.browserHistory.getCurrentLocation().pathname.replace(regexp, '').split('/');
	      }
	
	      path.splice(0, 3);
	      if (kiosk !== -1) _history.history.replace(appendPrefix('/kiosk/' + route + '/' + path.join('/')));else if (book !== -1) _history.history.replace(appendPrefix('/book/' + route + '/' + path.join('/')));else _history.history.replace(appendPrefix('/' + route));
	    }
	    return barbers;
	  };
	};
	
	function fetchBarbers(shopRoute, params, urlPattern) {
	  return function (dispatch, getState) {
	    if (!shopRoute) return Promise.resolve();
	    if ((0, _selectors.getBarbersCount)(getState(), { shopRoute: shopRoute }) > 0) return Promise.resolve();
	
	    dispatch(requestBarbers());
	
	    var includes = 'include=photos,shop,services,days_on,reward&limit=100&sortBy=order:asc,createdAt:desc';
	    var url = _config2.default.url + '/shop/' + shopRoute + '/barber/?' + includes;
	
	    var pattern = urlPattern && urlPattern.search ? urlPattern : params;
	
	    // -1 is what .search returns if nothing is found
	    var kiosk = -1,
	        book = -1;
	
	    if (pattern && pattern.search) {
	      kiosk = pattern.search('kiosk');
	      book = pattern.search('book');
	    }
	
	    return fetch(url).then((0, _helpers.checkRoute)(dispatch, params, urlPattern)).then(_helpers.checkStatus).then(redirectIfOldRoute(shopRoute, kiosk, book)).then(function (barbers) {
	      return dispatch(receiveBarbers(barbers, params));
	    }).catch(function (error) {
	      return Promise.reject(error);
	    });
	  };
	}
	
	var transformBrandBarbers = function transformBrandBarbers(barbers) {
	  return barbers.map(function (barber) {
	    return _extends({}, barber, {
	      route: barber.shops[0].barberId,
	      id: barber.shops[0].barberId
	    });
	  });
	};
	
	function fetchBrandBarbers(brandId, params, urlPattern) {
	  return function (dispatch) {
	    if (!brandId) return Promise.resolve();
	
	    dispatch(requestBarbers());
	
	    return fetch(_config2.default.url + '/brand/' + brandId + '/barber').then((0, _helpers.checkRoute)(dispatch, params, urlPattern)).then(_helpers.checkStatus).then(transformBrandBarbers).then(function (barbers) {
	      return dispatch(receiveBarbers(barbers, params));
	    }).catch(function (error) {
	      return Promise.reject(error);
	    });
	  };
	}
	
	function shouldFetchBarberAvailableTime(state, id) {
	  return !state.barbers.get('items').find(function (barber) {
	    return barber.get('id') === id && barber.get('nextTime');
	  });
	}
	
	function requestBarberAvailableTime(id) {
	  return {
	    type: _constants.REQUEST_BARBER_AVAILABLE_TIME,
	    payload: id
	  };
	}
	
	function receiveBarberAvailableTime(id, nextTime) {
	  return {
	    type: _constants.RECEIVE_BARBER_AVAILABLE_TIME,
	    payload: { id: id, nextTime: nextTime }
	  };
	}
	
	function fetchBarberNextAvailableTime(barber, serviceDuration, kiosk, shopRoute) {
	  var id = barber.get('id');
	  return function (dispatch, getState) {
	    if (!shouldFetchBarberAvailableTime(getState(), id)) return Promise.resolve();
	
	    dispatch(requestBarberAvailableTime(id));
	
	    var params = (0, _helpers.joinQueryStringParams)([kiosk ? 'kiosk=true' : '']);
	    var durationString = serviceDuration ? '/' + serviceDuration : '';
	    var url = _config2.default.url + '/shop/' + shopRoute + '/barber/' + id + '/next-available-time' + durationString + params;
	
	    return fetch(url).then(_helpers.checkStatus).then(function (_ref) {
	      var time = _ref.time;
	      return dispatch(receiveBarberAvailableTime(id, time));
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	}
	
	function fetchBarbersWithNextAvailableTime(shopRoute, params, urlPattern, serviceDuration, kiosk) {
	  return function (dispatch, getState) {
	    return dispatch(fetchBarbers(shopRoute, params, urlPattern)).then(function () {
	      return Promise.all(getState().barbers.get('items').map(function (barber) {
	        return dispatch(fetchBarberNextAvailableTime(barber, serviceDuration, kiosk, shopRoute));
	      }));
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactModal = __webpack_require__(783);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGateway = __webpack_require__(77);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modal = function Modal(_ref) {
	  var close = _ref.close,
	      children = _ref.children,
	      size = _ref.size,
	      title = _ref.title,
	      className = _ref.className,
	      backdropStyles = _ref.backdropStyles;
	  return _react2.default.createElement(
	    _reactGateway.Gateway,
	    { into: 'modal' },
	    _react2.default.createElement(
	      _reactModal2.default,
	      {
	        modalClassName: (0, _classnames2.default)('c-modal', className, { 'c-modal--small': size === 'small' }),
	        backdropClassName: 'c-modal-wrapper',
	        onClose: close,
	        backdropStyles: backdropStyles
	      },
	      title && _react2.default.createElement(
	        'div',
	        { className: 'c-modal__header' },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-modal__body' },
	        children
	      )
	    )
	  );
	};
	Modal.propTypes = {
	  close: _propTypes2.default.func.isRequired,
	  children: _propTypes2.default.node.isRequired,
	  size: _propTypes2.default.oneOf(['small', '']),
	  title: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  backdropStyles: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
	};
	Modal.defaultProps = {
	  size: '',
	  title: '',
	  className: '',
	  backdropStyles: {}
	};
	
	exports.default = Modal;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.campaignUnsubscribe = exports.validatePassword = exports.fetchCustomerWaitingList = exports.removeCustomerFromWaitingList = exports.bookAppointmentTimeSlot = exports.resetPassword = exports.confirmBarber = exports.verifyBarberEmail = exports.verifyCustomerEmail = undefined;
	
	var _constants = __webpack_require__(10);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var verifyEmail = function verifyEmail(url) {
	  return function (token) {
	    return function (dispatch) {
	      dispatch({
	        type: _constants.VERIFY_EMAIL,
	        payload: token
	      });
	
	      return fetch(url, {
	        method: 'POST',
	        headers: {
	          Accept: 'application/json',
	          'Content-Type': 'application/json'
	        },
	        body: JSON.stringify({
	          emailVerificationToken: token
	        })
	      }).then(_helpers.checkStatus).then(function (user) {
	        return dispatch({
	          type: _constants.USER_TOKEN_SUCCESS,
	          payload: 'Thank you ' + user.firstName + '. Your email is successfully verified.'
	        });
	      }).catch((0, _helpers.handleRequestError)(dispatch));
	    };
	  };
	};
	
	var verifyCustomerEmail = exports.verifyCustomerEmail = verifyEmail(_config2.default.url + '/customer/verify-email');
	
	var verifyBarberEmail = exports.verifyBarberEmail = verifyEmail(_config2.default.url + '/barber/verify-email');
	
	var confirmBarber = exports.confirmBarber = function confirmBarber(shopId, barberId) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.CONFIRM_BARBER,
	      payload: barberId
	    });
	
	    var url = _config2.default.url + '/shop/' + shopId + '/confirm/' + barberId;
	
	    return fetch(url, {
	      method: 'POST'
	    }).then(_helpers.checkStatus).then(function (_ref) {
	      var message = _ref.message;
	      return dispatch({
	        type: _constants.CONFIRM_BARBER_SUCCESS,
	        payload: message
	      });
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};
	
	var resetPassword = exports.resetPassword = function resetPassword(token, password) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.VERIFY_PASSWORD,
	      payload: token
	    });
	
	    var url = _config2.default.url + '/user/password-verify';
	
	    return fetch(url, {
	      method: 'POST',
	      headers: {
	        Accept: 'application/json',
	        'Content-Type': 'application/json'
	      },
	      body: JSON.stringify({
	        passwordResetToken: token,
	        password: password
	      })
	    }).then(_helpers.checkStatus).then(function () {
	      return dispatch({
	        type: _constants.VERIFY_PASSWORD_SUCCESS,
	        payload: 'Password is successfully changed.'
	      });
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};
	
	var bookAppointmentTimeSlot = exports.bookAppointmentTimeSlot = function bookAppointmentTimeSlot(_ref2) {
	  var waitingListCustomerId = _ref2.waitingListCustomerId,
	      waitingListSlotId = _ref2.waitingListSlotId;
	  return function (dispatch) {
	    dispatch({
	      type: _constants.BOOK_APPOINTMENT_TIME_SLOT
	    });
	
	    return fetch(_config2.default.url + '/book-appointment-time-slot', {
	      method: 'POST',
	      headers: {
	        Accept: 'application/json',
	        'Content-Type': 'application/json'
	      },
	      body: JSON.stringify({
	        waitingListCustomerId: waitingListCustomerId,
	        waitingListSlotId: waitingListSlotId,
	        platform: 'Web'
	      })
	    }).then(_helpers.checkStatus).then(function (data) {
	      return dispatch({
	        type: _constants.BOOK_APPOINTMENT_TIME_SLOT_SUCCESS,
	        payload: data
	      });
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};
	
	var removeCustomerFromWaitingList = exports.removeCustomerFromWaitingList = function removeCustomerFromWaitingList(waitingListCustomerId) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.REMOVE_CUSTOMER_FROM_WAITING_LIST,
	      payload: waitingListCustomerId
	    });
	
	    var url = _config2.default.url + '/customer/waiting-list/' + waitingListCustomerId;
	
	    return fetch(url, {
	      method: 'DELETE'
	    }).then(_helpers.checkStatus).then(function () {
	      return dispatch({
	        type: _constants.REMOVE_CUSTOMER_FROM_WAITING_LIST_SUCCESS,
	        payload: 'Customer is successfully removed from waiting list'
	      });
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};
	
	var defaultWLIncludes = ['shop', 'shop.address', 'customer', 'barber', 'services'];
	var fetchCustomerWaitingList = exports.fetchCustomerWaitingList = function fetchCustomerWaitingList(waitingListCustomerId) {
	  var includes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultWLIncludes;
	
	  var params = includes && includes.length ? '?include='.concat((includes || []).join(',')) : '';
	  var url = _config2.default.url + '/customer/waiting-list/' + waitingListCustomerId + params;
	  return fetch(url).then(_helpers.checkStatus);
	};
	
	var validatePassword = exports.validatePassword = function validatePassword(password) {
	  return fetch(_config2.default.url + '/user/validate-password', {
	    method: 'POST',
	    headers: {
	      Accept: 'application/json',
	      'Content-Type': 'application/json'
	    },
	    body: JSON.stringify({ password: password })
	  }).then(_helpers.checkStatus).then(function (_ref3) {
	    var isValid = _ref3.isValid,
	        feedback = _ref3.feedback;
	
	    if (isValid) return true;
	    return Promise.reject(feedback);
	  });
	};
	
	var campaignUnsubscribe = exports.campaignUnsubscribe = function campaignUnsubscribe(ownerType, ownerId, customerId) {
	  return function (dispatch) {
	    dispatch({ type: _constants.CAMPAIGN_UNSUBSCRIBE });
	
	    var url = _config2.default.url + '/campaign/unsubscribe/' + ownerType + '/' + ownerId + '/' + customerId;
	
	    return fetch(url, {
	      method: 'POST'
	    }).then(_helpers.checkStatus).then(function () {
	      return dispatch({
	        type: _constants.CAMPAIGN_UNSUBSCRIBE_SUCCESS,
	        payload: 'You successfully unsubscribed from future campaign emails.'
	      });
	    }).catch(function (err) {
	      return dispatch({
	        type: _constants.CAMPAIGN_UNSUBSCRIBE_ERROR,
	        payload: err.message
	      });
	    });
	  };
	};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectors = __webpack_require__(417);
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});
	
	var _withExtensions = __webpack_require__(269);
	
	var _withExtensions2 = _interopRequireDefault(_withExtensions);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _withExtensions2.default;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _omit2 = __webpack_require__(350);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _WithApplePay = __webpack_require__(274);
	
	var _WithApplePay2 = _interopRequireDefault(_WithApplePay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkQueryString = function checkQueryString(BaseComponent) {
	  return function (props) {
	    var withApplePay = !!(0, _get3.default)(props, 'location.query.applePay');
	    if (withApplePay && !props.hasApplePay) {
	      props.router.replace(_extends({}, props.location, { query: (0, _omit3.default)(location.query, 'applePay') }));
	      return null;
	    }
	    return _react2.default.createElement(BaseComponent, Object.assign({}, props, { withApplePay: withApplePay }));
	  };
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, _WithApplePay2.default, checkQueryString);

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _withProps3.default)(function (props) {
	  return {
	    timeWaitingList: props.params.reservationTime === _constants.TIME_WAITING_LIST
	  };
	}));

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperCase2 = __webpack_require__(1511);
	
	var _upperCase3 = _interopRequireDefault(_upperCase2);
	
	var _startCase2 = __webpack_require__(1502);
	
	var _startCase3 = _interopRequireDefault(_startCase2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var CustomerInfo = function CustomerInfo(_ref) {
	  var customerPhoto = _ref.customerPhoto,
	      customerName = _ref.customerName,
	      customerNameShort = _ref.customerNameShort,
	      customerNotes = _ref.customerNotes,
	      customerPhone = _ref.customerPhone,
	      customerEmail = _ref.customerEmail,
	      customerFirstName = _ref.customerFirstName;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-shop-location' },
	    customerPhoto && _react2.default.createElement('img', { className: 'c-customer-avatar', src: customerPhoto, alt: '' }),
	    !customerPhoto && _react2.default.createElement(
	      'div',
	      { className: 'c-avatar-placeholder u-mt-6 u-ml-4 u-hide-on-mobile' },
	      (0, _upperCase3.default)(customerNameShort)
	    ),
	    !customerPhoto && _react2.default.createElement(
	      'div',
	      { className: 'c-avatar-placeholder u-mt-5 u-mb-5 u-hide-on-desktop' },
	      (0, _upperCase3.default)(customerNameShort)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-pt-5 u-pr-4 u-pb-4 u-pl-4 u-flex-1 u-flex u-justify-content-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-ta-left' },
	        _react2.default.createElement(
	          'div',
	          { className: 'u-text-normal u-fw-bold u-mb-2' },
	          (0, _startCase3.default)(customerName)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'u-text-small u-co-grey u-mb-5' },
	          customerNotes ? (0, _utils.cut)(customerNotes, 120) : (0, _startCase3.default)(customerFirstName) + ' doesn\'t have any custom notes'
	        ),
	        customerPhone && _react2.default.createElement(
	          'div',
	          { className: 'u-mb-1' },
	          _react2.default.createElement(
	            'a',
	            { className: 'u-co-grey u-text-extrasmall u-fw-bold', href: 'tel:' + customerPhone },
	            _react2.default.createElement('img', {
	              className: 'c-contact-icon',
	              src: 'https://squire-emails.s3-us-west-1.amazonaws.com/images/message.png',
	              alt: ''
	            }),
	            customerPhone
	          )
	        ),
	        customerEmail && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'a',
	            { className: 'u-co-grey u-text-extrasmall u-fw-bold', href: 'mailto:' + customerEmail },
	            _react2.default.createElement('img', {
	              className: 'c-contact-icon',
	              src: 'https://squire-emails.s3-us-west-1.amazonaws.com/images/email.png',
	              alt: ''
	            }),
	            'Email ',
	            (0, _startCase3.default)(customerFirstName)
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = CustomerInfo;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchShopBarberAvailability = exports.fetchBarberAvailability = exports.setActiveTimeBarber = exports.resetActiveTime = exports.setActiveTime = exports.clearBarberAvailability = undefined;
	
	var _identity2 = __webpack_require__(177);
	
	var _identity3 = _interopRequireDefault(_identity2);
	
	var _map2 = __webpack_require__(74);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	exports.setActiveDay = setActiveDay;
	exports.fetchShopAvailability = fetchShopAvailability;
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(10);
	
	var _selectors = __webpack_require__(71);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearBarberAvailability = exports.clearBarberAvailability = function clearBarberAvailability() {
	  return { type: _constants.CLEAR_BARBER_AVAILABILITY };
	};
	
	function requestBarberAvailability() {
	  return { type: _constants.REQUEST_BARBER_AVAILABILITY };
	}
	
	var mapTimes = function mapTimes(times) {
	  var transformBarber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity3.default;
	  return (0, _map3.default)(times, function (_ref) {
	    var time = _ref.time,
	        barberRoutes = _ref.barberRoutes;
	    return {
	      time: time,
	      barberRoute: transformBarber(barberRoutes)
	    };
	  });
	};
	
	var mapAvailableTimes = function mapAvailableTimes(availableTimes, transform) {
	  return (0, _map3.default)(availableTimes, function (_ref2) {
	    var day = _ref2.day,
	        times = _ref2.times;
	    return {
	      day: day,
	      times: typeof (0, _get3.default)(times, '[0]') === 'string' ? times : mapTimes(times, transform)
	    };
	  });
	};
	
	function receiveBarberAvailability(availableTimes, transform) {
	  return {
	    type: _constants.RECEIVE_BARBER_AVAILABILITY,
	    payload: mapAvailableTimes(availableTimes, transform)
	  };
	}
	
	function setActiveDay(day) {
	  var resetTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  return {
	    type: _constants.SET_ACTIVE_DAY,
	    payload: day,
	    resetTime: resetTime
	  };
	}
	
	var setActiveTime = exports.setActiveTime = function setActiveTime(time) {
	  return {
	    type: _constants.SET_ACTIVE_TIME,
	    payload: time
	  };
	};
	
	var resetActiveTime = exports.resetActiveTime = function resetActiveTime() {
	  return {
	    type: _constants.SET_ACTIVE_TIME,
	    payload: ''
	  };
	};
	
	var setActiveTimeBarber = exports.setActiveTimeBarber = function setActiveTimeBarber(barber) {
	  return {
	    type: _constants.SET_ACTIVE_TIME_BARBER,
	    payload: barber
	  };
	};
	
	var fetchAvailability = function fetchAvailability(url, transform) {
	  return function (dispatch) {
	    dispatch(requestBarberAvailability());
	
	    return fetch(url).then(_helpers.checkStatus).then(function (availableTimes) {
	      return dispatch(receiveBarberAvailability(availableTimes, transform));
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};
	
	var getShopIdParam = function getShopIdParam(shopRoute, barberRoute) {
	  return shopRoute && barberRoute !== _constants.ANY_BARBER ? 'shopId=' + shopRoute : '';
	};
	
	var getExcludeAppointmentParam = function getExcludeAppointmentParam(appointmentId) {
	  return appointmentId ? 'excludeAppointmentId=' + appointmentId : '';
	};
	var getKioskParam = function getKioskParam(kiosk) {
	  return kiosk ? 'kiosk=true' : '';
	};
	
	var fetchBarberAvailability = exports.fetchBarberAvailability = function fetchBarberAvailability(barberRoute, shopId, serviceDuration) {
	  var startDay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (0, _moment2.default)();
	  var endDay = arguments[4];
	  var appointmentId = arguments[5];
	  var kiosk = arguments[6];
	  var shopRoute = arguments[7];
	  return function (dispatch, getState) {
	    if (!barberRoute || !shopId || !serviceDuration) return Promise.resolve();
	
	    var start = (0, _moment2.default)(startDay).format(_config2.default.apiDateFormat);
	    var end = endDay || (0, _moment2.default)(startDay).add(6, 'days').format(_config2.default.apiDateFormat);
	    if (!(0, _selectors.shouldLoadTimesForInterval)(getState(), start, end)) return Promise.resolve();
	
	    var params = (0, _helpers.joinQueryStringParams)([getShopIdParam(shopId, barberRoute), getExcludeAppointmentParam(appointmentId), getKioskParam(kiosk)]);
	    var url = _config2.default.url + '/shop/' + shopRoute + '/barber/' + barberRoute + '/' + ('available-time-range/' + start + '/' + end + '/' + serviceDuration + params);
	
	    return dispatch(fetchAvailability(url));
	  };
	};
	
	var fetchShopBarberAvailability = exports.fetchShopBarberAvailability = function fetchShopBarberAvailability(shopRoute, selectedServices) {
	  var startDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _moment2.default)();
	  var endDay = arguments[3];
	  var appointmentId = arguments[4];
	  var kiosk = arguments[5];
	  return function (dispatch, getState) {
	    if (!shopRoute || !selectedServices) return Promise.resolve();
	
	    var start = (0, _moment2.default)(startDay).format(_config2.default.apiDateFormat);
	    var end = endDay || (0, _moment2.default)(startDay).add(6, 'days').format(_config2.default.apiDateFormat);
	
	    if (!(0, _selectors.shouldLoadTimesForInterval)(getState(), start, end)) return Promise.resolve();
	    var params = (0, _helpers.joinQueryStringParams)([getExcludeAppointmentParam(appointmentId), getKioskParam(kiosk)]);
	    var url = _config2.default.url + '/shop/' + shopRoute + '/available-time-range/' + start + '/' + end + '/' + selectedServices + params;
	
	    return dispatch(fetchAvailability(url, _helpers.randomItem));
	  };
	};
	
	function fetchShopAvailability(shopRoute) {
	  var startDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _moment2.default)();
	
	  if (!shopRoute) return Promise.resolve();
	
	  var start = (0, _moment2.default)(startDay).format(_config2.default.apiDateFormat);
	  var end = (0, _moment2.default)(startDay).add(6, 'days').format(_config2.default.apiDateFormat);
	  var url = _config2.default.url + '/shop/' + shopRoute + '/available-time-range/' + start + '/' + end;
	
	  return fetchAvailability(url);
	}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(216),
	    isFlattenable = __webpack_require__(1434);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(179),
	    isLength = __webpack_require__(349);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(44),
	    basePickBy = __webpack_require__(548),
	    getAllKeysIn = __webpack_require__(561);
	
	/**
	 * Creates an object composed of the `object` properties `predicate` returns
	 * truthy for. The predicate is invoked with two arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pickBy(object, _.isNumber);
	 * // => { 'a': 1, 'c': 3 }
	 */
	function pickBy(object, predicate) {
	  return object == null ? {} : basePickBy(object, getAllKeysIn(object), baseIteratee(predicate));
	}
	
	module.exports = pickBy;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(593);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _equals = /*#__PURE__*/__webpack_require__(1555);
	
	/**
	 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
	 * cyclical data structures.
	 *
	 * Dispatches symmetrically to the `equals` methods of both arguments, if
	 * present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> b -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      R.equals(1, 1); //=> true
	 *      R.equals(1, '1'); //=> false
	 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
	 *
	 *      var a = {}; a.v = a;
	 *      var b = {}; b.v = b;
	 *      R.equals(a, b); //=> true
	 */
	
	
	var equals = /*#__PURE__*/_curry2(function equals(a, b) {
	  return _equals(a, b, [], []);
	});
	module.exports = equals;

/***/ }),
/* 108 */
[1846, 1609],
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 110 */
[1843, 835],
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setApplePay = undefined;
	exports.clearRedirection = clearRedirection;
	exports.clearErrors = clearErrors;
	exports.errorRedirect = errorRedirect;
	exports.fetchThirdPartyPromoStatus = fetchThirdPartyPromoStatus;
	
	var _constants = __webpack_require__(10);
	
	function clearRedirection() {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.CLEAR_REDIRECTION
	    });
	  };
	} /* global Stripe */
	function clearErrors() {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.CLEAR_ERROR
	    });
	  };
	}
	
	function errorRedirect(message, route) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.SET_ERROR_MESSAGE,
	      error: { message: message || 'Invalid parameters!' }
	    });
	    return dispatch({
	      type: _constants.SET_REDIRECTION,
	      payload: route
	    });
	  };
	}
	
	var setApplePay = exports.setApplePay = function setApplePay() {
	  return function (dispatch) {
	    return Stripe.applePay.checkAvailability(function (available) {
	      return dispatch({
	        type: _constants.SET_APPLE_PAY,
	        payload: !!available
	      });
	    });
	  };
	};
	
	function fetchThirdPartyPromoStatus() {
	  return function (dispatch) {
	    return dispatch({
	      type: _constants.THIRD_PARTY_PROMO,
	      payload: {
	        active: false,
	        context: null
	      }
	    });
	  };
	}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Header = __webpack_require__(903);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(902);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ShopFooter = __webpack_require__(912);
	
	var _ShopFooter2 = _interopRequireDefault(_ShopFooter);
	
	var _WithShopBackground = __webpack_require__(998);
	
	var _WithShopBackground2 = _interopRequireDefault(_WithShopBackground);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      backgroundImage = _ref.backgroundImage,
	      logo = _ref.logo,
	      shopLayout = _ref.shopLayout,
	      homeUrl = _ref.homeUrl,
	      kiosk = _ref.kiosk,
	      noFooter = _ref.noFooter;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { homeUrl: homeUrl, kiosk: kiosk, logo: logo }),
	    _react2.default.createElement(
	      'main',
	      {
	        className: (0, _classnames2.default)('c-main', { 'c-main--shop': shopLayout }, { 'c-main--no-footer': noFooter }),
	        style: { backgroundImage: 'url(' + backgroundImage + ')' }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'o-wrapper o-wrapper--page u-pb+' },
	        children
	      )
	    ),
	    !noFooter && (shopLayout ? _react2.default.createElement(_ShopFooter2.default, null) : _react2.default.createElement(_Footer2.default, null))
	  );
	};
	Layout.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  backgroundImage: _propTypes2.default.string.isRequired,
	  shopLayout: _propTypes2.default.bool,
	  homeUrl: _propTypes2.default.string,
	  kiosk: _propTypes2.default.bool,
	  noFooter: _propTypes2.default.bool,
	  logo: _propTypes2.default.string
	};
	Layout.defaultProps = {
	  shopLayout: false,
	  homeUrl: '/',
	  kiosk: false,
	  noFooter: false,
	  logo: ''
	};
	
	exports.default = (0, _WithShopBackground2.default)(Layout);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGateway = __webpack_require__(77);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Subtitle = function Subtitle(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	
	  if ((0, _isEmpty3.default)(children)) return null;
	  return _react2.default.createElement(
	    _reactGateway.Gateway,
	    { into: 'subtitle' },
	    _react2.default.createElement(
	      'h3',
	      { className: (0, _classnames2.default)('c-heading c-heading--huge u-mv', className) },
	      children
	    )
	  );
	};
	Subtitle.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  className: _propTypes2.default.string
	};
	Subtitle.defaultProps = {
	  className: ''
	};
	
	exports.default = Subtitle;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGateway = __webpack_require__(77);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = function Title(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	
	  if ((0, _isEmpty3.default)(children)) return null;
	  return _react2.default.createElement(
	    _reactGateway.Gateway,
	    { into: 'title' },
	    _react2.default.createElement(
	      'h2',
	      { className: (0, _classnames2.default)('c-title qa-title', className) },
	      children
	    )
	  );
	};
	Title.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  className: _propTypes2.default.string
	};
	Title.defaultProps = {
	  className: ''
	};
	
	exports.default = Title;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(11);
	
	var _selectors2 = __webpack_require__(21);
	
	var reservationSelectors = _interopRequireWildcard(_selectors2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WithTimezone = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    timezone: (0, _selectors.getShopTimezone)(state, ownProps.params.shopRoute) || reservationSelectors.getShopTimezone(state)
	  };
	}));
	
	exports.default = WithTimezone;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _WithBookNoPayQuery = __webpack_require__(161);
	
	var _WithBookNoPayQuery2 = _interopRequireDefault(_WithBookNoPayQuery);
	
	var _selectors = __webpack_require__(27);
	
	var barberSelectors = _interopRequireWildcard(_selectors);
	
	var _selectors2 = __webpack_require__(21);
	
	var reservationSelectors = _interopRequireWildcard(_selectors2);
	
	var _selectors3 = __webpack_require__(51);
	
	var servicesSelectors = _interopRequireWildcard(_selectors3);
	
	var _WithKioskProp = __webpack_require__(59);
	
	var _WithKioskProp2 = _interopRequireDefault(_WithKioskProp);
	
	var _WithTimeWaitingList = __webpack_require__(97);
	
	var _WithTimeWaitingList2 = _interopRequireDefault(_WithTimeWaitingList);
	
	var _withRouteParameters = __webpack_require__(83);
	
	var _withRouteParameters2 = _interopRequireDefault(_withRouteParameters);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_WithTimeWaitingList2.default, _WithKioskProp2.default, _withRouteParameters2.default, _WithBookNoPayQuery2.default, (0, _reactRedux.connect)(function (state, ownProps) {
	  // tip is calculated based on cost with taxes
	  var tipEnabled = barberSelectors.getTipEnabledForBarber(state, ownProps.barberRoute) && !ownProps.kiosk;
	  var activeTip = tipEnabled ? reservationSelectors.getActiveTip(state) : null;
	  var tipAmount = reservationSelectors.getActiveTipAmount(state);
	  var fees = state.reservation.get('fees');
	  var serviceCost = reservationSelectors.getServicesCost(state);
	  var taxes = reservationSelectors.getTaxBreakdownAmount(state);
	  var taxBreakdown = reservationSelectors.getTaxBreakdown(state);
	  var discount = reservationSelectors.getPromoAmount(state, serviceCost, taxes) + reservationSelectors.getGiftCardAmount(state);
	  var membershipDiscount = reservationSelectors.getTotalMembershipDiscount(state);
	  var totalAmount = reservationSelectors.getTotalAmount(state);
	
	  // hide booking fee and tip in new payment modal when reserving and paying
	  if (ownProps.action === 'reserveAndPay') {
	    fees = 0;
	    tipAmount = 0;
	    activeTip = null;
	    totalAmount = reservationSelectors.getTotalAmountWithoutTipAndFees(state);
	  }
	
	  if (ownProps.barberRoute === _constants.ANY_BARBER && ownProps.timeWaitingList) {
	    totalAmount = Math.max(0, totalAmount - tipAmount);
	    tipAmount = 0;
	  }
	
	  return {
	    servicesNamesShort: servicesSelectors.getServiceNameShort(state, ownProps.serviceId),
	    servicesNamesLong: servicesSelectors.getServiceNameLong(state, ownProps.serviceId),
	    taxes: taxes,
	    fees: fees,
	    totalAmount: totalAmount,
	    costWithTaxes: serviceCost + taxes,
	    tipEnabled: tipEnabled,
	    serviceCost: serviceCost,
	    remainingGiftCardBalance: reservationSelectors.getGiftCardBalance(state),
	    discount: discount,
	    membershipDiscount: membershipDiscount,
	    activeTip: activeTip,
	    tipAmount: tipAmount,
	    taxBreakdown: taxBreakdown,
	    isGiftCardDiscount: !!reservationSelectors.getGiftCardAmount(state),
	    isCoveredByDiscount: !!discount && totalAmount === 0
	  };
	}));

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pick2 = __webpack_require__(180);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	exports.receiveServices = receiveServices;
	exports.fetchServices = fetchServices;
	exports.fetchService = fetchService;
	exports.fetchSelectedServices = fetchSelectedServices;
	
	var _constants = __webpack_require__(10);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requestServices() {
	  return { type: _constants.REQUEST_SERVICES };
	}
	
	function receiveServices(services) {
	  return {
	    type: _constants.RECEIVE_SERVICES,
	    payload: services
	  };
	}
	
	function serviceUrl(shopRoute, barberRoute) {
	  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  var baseUrl = _config2.default.url + '/shop/' + shopRoute + '/';
	  var shouldGetBarberServices = barberRoute && barberRoute !== _constants.ANY_BARBER;
	  var barberUrl = shouldGetBarberServices ? 'barber/' + barberRoute + '/' : '';
	  return '' + baseUrl + barberUrl + 'service' + filter;
	}
	
	var fetchServicesAction = function fetchServicesAction(dispatch) {
	  return function (url, redirectParams, urlPattern) {
	    return fetch(url).then((0, _helpers.checkRoute)(dispatch, redirectParams, urlPattern)).then(_helpers.checkStatus).then(function (services) {
	      return dispatch(receiveServices(services));
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};
	
	function fetchServices(shopRoute, barberRoute, params, urlPattern, kiosk) {
	  return function (dispatch) {
	    if (!shopRoute) return Promise.resolve();
	
	    dispatch(requestServices());
	
	    return fetchServicesAction(dispatch)(serviceUrl(shopRoute, barberRoute, '?sortBy=order&limit=500' + (kiosk ? '&kiosk=true' : '')), (0, _pick3.default)(params, ['shopRoute']), urlPattern);
	  };
	}
	
	function requestService(id) {
	  return {
	    type: _constants.REQUEST_SERVICE,
	    id: id
	  };
	}
	
	function receiveService(service) {
	  return {
	    type: _constants.RECEIVE_SERVICE,
	    payload: service
	  };
	}
	
	function shouldFetchService(state, id) {
	  if (!state.services) return true;
	  return !state.services.get('items').find(function (service) {
	    return service.get('id') === id;
	  });
	}
	
	function fetchService(shopRoute, barberRoute, serviceId, params, urlPattern) {
	  return function (dispatch, getState) {
	    if (!serviceId || !shouldFetchService(getState(), serviceId)) return Promise.resolve();
	
	    dispatch(requestService(serviceId));
	
	    var url = serviceUrl(shopRoute, barberRoute) + '/' + serviceId;
	    var redirectParams = (0, _pick3.default)(params, ['shopRoute', 'barberRoute']);
	
	    return fetch(url).then((0, _helpers.checkRoute)(dispatch, redirectParams, urlPattern)).then(_helpers.checkStatus).then(function (service) {
	      return dispatch(receiveService(service));
	    }).catch(function (error) {
	      return Promise.reject((0, _helpers.handleRequestError)(dispatch)(error));
	    });
	  };
	}
	
	function fetchSelectedServices(shopRoute, barberRoute, servicesIds, params, urlPattern) {
	  return function (dispatch) {
	    if (!servicesIds) return Promise.resolve();
	
	    var services = servicesIds.split(';').map(function (serviceId) {
	      return dispatch(fetchService(shopRoute, barberRoute, serviceId, params, urlPattern));
	    });
	
	    return Promise.all(services).then(function () {
	      return dispatch({ type: _constants.ALL_SERVICES_FETCHED });
	    })
	    // Error dispatching is handled in individual fetch function
	    .catch(_helpers.nullFunc);
	  };
	}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(477);
	
	function bindAll(obj) {
	  // eslint-disable-next-line guard-for-in
	  for (var key in obj) {
	    var val = obj[key];
	    if (typeof val === 'function') {
	      obj[key] = bind(obj, obj[key]);
	    }
	  }
	  return obj;
	}
	
	module.exports = bindAll;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(100);
	
	var _Actions = __webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DIGITS = void 0;
	exports["default"] = parseDigits;
	exports.parseDigit = parseDigit;
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	// These mappings map a character (key) to a specific digit that should
	// replace it for normalization purposes. Non-European digits that
	// may be used in phone numbers are mapped to a European equivalent.
	//
	// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	//
	var DIGITS = {
	  '0': '0',
	  '1': '1',
	  '2': '2',
	  '3': '3',
	  '4': '4',
	  '5': '5',
	  '6': '6',
	  '7': '7',
	  '8': '8',
	  '9': '9',
	  "\uFF10": '0',
	  // Fullwidth digit 0
	  "\uFF11": '1',
	  // Fullwidth digit 1
	  "\uFF12": '2',
	  // Fullwidth digit 2
	  "\uFF13": '3',
	  // Fullwidth digit 3
	  "\uFF14": '4',
	  // Fullwidth digit 4
	  "\uFF15": '5',
	  // Fullwidth digit 5
	  "\uFF16": '6',
	  // Fullwidth digit 6
	  "\uFF17": '7',
	  // Fullwidth digit 7
	  "\uFF18": '8',
	  // Fullwidth digit 8
	  "\uFF19": '9',
	  // Fullwidth digit 9
	  "\u0660": '0',
	  // Arabic-indic digit 0
	  "\u0661": '1',
	  // Arabic-indic digit 1
	  "\u0662": '2',
	  // Arabic-indic digit 2
	  "\u0663": '3',
	  // Arabic-indic digit 3
	  "\u0664": '4',
	  // Arabic-indic digit 4
	  "\u0665": '5',
	  // Arabic-indic digit 5
	  "\u0666": '6',
	  // Arabic-indic digit 6
	  "\u0667": '7',
	  // Arabic-indic digit 7
	  "\u0668": '8',
	  // Arabic-indic digit 8
	  "\u0669": '9',
	  // Arabic-indic digit 9
	  "\u06F0": '0',
	  // Eastern-Arabic digit 0
	  "\u06F1": '1',
	  // Eastern-Arabic digit 1
	  "\u06F2": '2',
	  // Eastern-Arabic digit 2
	  "\u06F3": '3',
	  // Eastern-Arabic digit 3
	  "\u06F4": '4',
	  // Eastern-Arabic digit 4
	  "\u06F5": '5',
	  // Eastern-Arabic digit 5
	  "\u06F6": '6',
	  // Eastern-Arabic digit 6
	  "\u06F7": '7',
	  // Eastern-Arabic digit 7
	  "\u06F8": '8',
	  // Eastern-Arabic digit 8
	  "\u06F9": '9' // Eastern-Arabic digit 9
	
	};
	exports.DIGITS = DIGITS;
	
	function parseDigit(character) {
	  return DIGITS[character];
	}
	/**
	 * Parses phone number digits from a string.
	 * Drops all punctuation leaving only digits.
	 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
	 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	 * @param  {string} string
	 * @return {string}
	 * @example
	 * ```js
	 * parseDigits('8 (800) 555')
	 * // Outputs '8800555'.
	 * ```
	 */
	
	
	function parseDigits(string) {
	  var result = ''; // Using `.split('')` here instead of normal `for ... of`
	  // because the importing application doesn't neccessarily include an ES6 polyfill.
	  // The `.split('')` approach discards "exotic" UTF-8 characters
	  // (the ones consisting of four bytes) but digits
	  // (including non-European ones) don't fall into that range
	  // so such "exotic" characters would be discarded anyway.
	
	  for (var _iterator = _createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
	    var character = _step.value;
	    var digit = parseDigit(character);
	
	    if (digit) {
	      result += digit;
	    }
	  }
	
	  return result;
	}
	//# sourceMappingURL=parseDigits.js.map

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parse;
	
	var _constants = __webpack_require__(72);
	
	var _ParseError = _interopRequireDefault(__webpack_require__(318));
	
	var _metadata = _interopRequireDefault(__webpack_require__(43));
	
	var _isViablePhoneNumber = _interopRequireWildcard(__webpack_require__(168));
	
	var _extractExtension = _interopRequireDefault(__webpack_require__(1345));
	
	var _parseIncompletePhoneNumber = _interopRequireDefault(__webpack_require__(326));
	
	var _getCountryCallingCode = _interopRequireDefault(__webpack_require__(320));
	
	var _isPossibleNumber_ = __webpack_require__(325);
	
	var _RFC = __webpack_require__(207);
	
	var _PhoneNumber = _interopRequireDefault(__webpack_require__(205));
	
	var _matchesEntirely = _interopRequireDefault(__webpack_require__(139));
	
	var _extractCountryCallingCode = _interopRequireDefault(__webpack_require__(515));
	
	var _extractCountryCallingCodeFromInternationalNumberWithoutPlusSign = _interopRequireDefault(__webpack_require__(322));
	
	var _extractNationalNumber = _interopRequireDefault(__webpack_require__(516));
	
	var _stripIddPrefix = _interopRequireDefault(__webpack_require__(324));
	
	var _getCountryByCallingCode = _interopRequireDefault(__webpack_require__(518));
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// This is a port of Google Android `libphonenumber`'s
	// `phonenumberutil.js` of December 31th, 2018.
	//
	// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
	// We don't allow input strings for parsing to be longer than 250 chars.
	// This prevents malicious input from consuming CPU.
	var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
	
	var PHONE_NUMBER_START_PATTERN = new RegExp('[' + _constants.PLUS_CHARS + _constants.VALID_DIGITS + ']'); // Regular expression of trailing characters that we want to remove.
	// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
	// Example: "+1 (645) 123 1234-910#" number has extension "910".
	
	var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + _constants.VALID_DIGITS + '#' + ']+$');
	var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
	//
	// ```js
	// parse('8 (800) 555-35-35', 'RU')
	// parse('8 (800) 555-35-35', 'RU', metadata)
	// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
	// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
	// parse('+7 800 555 35 35')
	// parse('+7 800 555 35 35', metadata)
	// ```
	//
	
	function parse(text, options, metadata) {
	  // If assigning the `{}` default value is moved to the arguments above,
	  // code coverage would decrease for some weird reason.
	  options = options || {};
	  metadata = new _metadata["default"](metadata); // Validate `defaultCountry`.
	
	  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
	    if (options.v2) {
	      throw new _ParseError["default"]('INVALID_COUNTRY');
	    }
	
	    throw new Error("Unknown country: ".concat(options.defaultCountry));
	  } // Parse the phone number.
	
	
	  var _parseInput = parseInput(text, options.v2, options.extract),
	      formattedPhoneNumber = _parseInput.number,
	      ext = _parseInput.ext,
	      error = _parseInput.error; // If the phone number is not viable then return nothing.
	
	
	  if (!formattedPhoneNumber) {
	    if (options.v2) {
	      if (error === 'TOO_SHORT') {
	        throw new _ParseError["default"]('TOO_SHORT');
	      }
	
	      throw new _ParseError["default"]('NOT_A_NUMBER');
	    }
	
	    return {};
	  }
	
	  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
	      country = _parsePhoneNumber.country,
	      nationalNumber = _parsePhoneNumber.nationalNumber,
	      countryCallingCode = _parsePhoneNumber.countryCallingCode,
	      carrierCode = _parsePhoneNumber.carrierCode;
	
	  if (!metadata.hasSelectedNumberingPlan()) {
	    if (options.v2) {
	      throw new _ParseError["default"]('INVALID_COUNTRY');
	    }
	
	    return {};
	  } // Validate national (significant) number length.
	
	
	  if (!nationalNumber || nationalNumber.length < _constants.MIN_LENGTH_FOR_NSN) {
	    // Won't throw here because the regexp already demands length > 1.
	
	    /* istanbul ignore if */
	    if (options.v2) {
	      throw new _ParseError["default"]('TOO_SHORT');
	    } // Google's demo just throws an error in this case.
	
	
	    return {};
	  } // Validate national (significant) number length.
	  //
	  // A sidenote:
	  //
	  // They say that sometimes national (significant) numbers
	  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
	  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
	  // Such numbers will just be discarded.
	  //
	
	
	  if (nationalNumber.length > _constants.MAX_LENGTH_FOR_NSN) {
	    if (options.v2) {
	      throw new _ParseError["default"]('TOO_LONG');
	    } // Google's demo just throws an error in this case.
	
	
	    return {};
	  }
	
	  if (options.v2) {
	    var phoneNumber = new _PhoneNumber["default"](countryCallingCode, nationalNumber, metadata.metadata);
	
	    if (country) {
	      phoneNumber.country = country;
	    }
	
	    if (carrierCode) {
	      phoneNumber.carrierCode = carrierCode;
	    }
	
	    if (ext) {
	      phoneNumber.ext = ext;
	    }
	
	    return phoneNumber;
	  } // Check if national phone number pattern matches the number.
	  // National number pattern is different for each country,
	  // even for those ones which are part of the "NANPA" group.
	
	
	  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, _matchesEntirely["default"])(nationalNumber, metadata.nationalNumberPattern()) : false;
	
	  if (!options.extended) {
	    return valid ? result(country, nationalNumber, ext) : {};
	  } // isInternational: countryCallingCode !== undefined
	
	
	  return {
	    country: country,
	    countryCallingCode: countryCallingCode,
	    carrierCode: carrierCode,
	    valid: valid,
	    possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, _isPossibleNumber_.isPossibleNumber)(nationalNumber, metadata) ? true : false,
	    phone: nationalNumber,
	    ext: ext
	  };
	}
	/**
	 * Extracts a formatted phone number from text.
	 * Doesn't guarantee that the extracted phone number
	 * is a valid phone number (for example, doesn't validate its length).
	 * @param  {string} text
	 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
	 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
	 * @return {string}
	 * @example
	 * // Returns "(213) 373-4253".
	 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
	 */
	
	
	function extractFormattedPhoneNumber(text, extract, throwOnError) {
	  if (!text) {
	    return;
	  }
	
	  if (text.length > MAX_INPUT_STRING_LENGTH) {
	    if (throwOnError) {
	      throw new _ParseError["default"]('TOO_LONG');
	    }
	
	    return;
	  }
	
	  if (extract === false) {
	    return text;
	  } // Attempt to extract a possible number from the string passed in
	
	
	  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
	
	  if (startsAt < 0) {
	    return;
	  }
	
	  return text // Trim everything to the left of the phone number
	  .slice(startsAt) // Remove trailing non-numerical characters
	  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
	}
	/**
	 * @param  {string} text - Input.
	 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
	 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
	 * @return {object} `{ ?number, ?ext }`.
	 */
	
	
	function parseInput(text, v2, extract) {
	  // Parse RFC 3966 phone number URI.
	  if (text && text.indexOf('tel:') === 0) {
	    return (0, _RFC.parseRFC3966)(text);
	  }
	
	  var number = extractFormattedPhoneNumber(text, extract, v2); // If the phone number is not viable, then abort.
	
	  if (!number) {
	    return {};
	  }
	
	  if (!(0, _isViablePhoneNumber["default"])(number)) {
	    if ((0, _isViablePhoneNumber.isViablePhoneNumberStart)(number)) {
	      return {
	        error: 'TOO_SHORT'
	      };
	    }
	
	    return {};
	  } // Attempt to parse extension first, since it doesn't require region-specific
	  // data and we want to have the non-normalised number here.
	
	
	  var withExtensionStripped = (0, _extractExtension["default"])(number);
	
	  if (withExtensionStripped.ext) {
	    return withExtensionStripped;
	  }
	
	  return {
	    number: number
	  };
	}
	/**
	 * Creates `parse()` result object.
	 */
	
	
	function result(country, nationalNumber, ext) {
	  var result = {
	    country: country,
	    phone: nationalNumber
	  };
	
	  if (ext) {
	    result.ext = ext;
	  }
	
	  return result;
	}
	/**
	 * Parses a viable phone number.
	 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
	 * @param {string} [defaultCountry]
	 * @param {string} [defaultCallingCode]
	 * @param {Metadata} metadata
	 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
	 */
	
	
	function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
	  // Extract calling code from phone number.
	  var _extractCountryCallin = (0, _extractCountryCallingCode["default"])((0, _parseIncompletePhoneNumber["default"])(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
	      countryCallingCode = _extractCountryCallin.countryCallingCode,
	      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
	
	
	  var country;
	
	  if (countryCallingCode) {
	    metadata.selectNumberingPlan(countryCallingCode);
	  } // If `formattedPhoneNumber` is in "national" format
	  // then `number` is defined and `countryCallingCode` isn't.
	  else if (number && (defaultCountry || defaultCallingCode)) {
	    metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
	
	    if (defaultCountry) {
	      country = defaultCountry;
	    } else {
	      /* istanbul ignore if */
	      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
	        if (metadata.isNonGeographicCallingCode(defaultCallingCode)) {
	          country = '001';
	        }
	      }
	    }
	
	    countryCallingCode = defaultCallingCode || (0, _getCountryCallingCode["default"])(defaultCountry, metadata.metadata);
	  } else return {};
	
	  if (!number) {
	    return {
	      countryCallingCode: countryCallingCode
	    };
	  }
	
	  var _extractNationalNumbe = (0, _extractNationalNumber["default"])((0, _parseIncompletePhoneNumber["default"])(number), metadata),
	      nationalNumber = _extractNationalNumbe.nationalNumber,
	      carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
	  // corresponding to the same country phone code
	  // (e.g. NANPA countries all having `1` country phone code).
	  // Therefore, to reliably determine the exact country,
	  // national (significant) number should have been parsed first.
	  //
	  // When `metadata.json` is generated, all "ambiguous" country phone codes
	  // get their countries populated with the full set of
	  // "phone number type" regular expressions.
	  //
	
	
	  var exactCountry = (0, _getCountryByCallingCode["default"])(countryCallingCode, nationalNumber, metadata);
	
	  if (exactCountry) {
	    country = exactCountry;
	    /* istanbul ignore if */
	
	    if (exactCountry === '001') {// Can't happen with `USE_NON_GEOGRAPHIC_COUNTRY_CODE` being `false`.
	      // If `USE_NON_GEOGRAPHIC_COUNTRY_CODE` is set to `true` for some reason,
	      // then remove the "istanbul ignore if".
	    } else {
	      metadata.country(country);
	    }
	  }
	
	  return {
	    country: country,
	    countryCallingCode: countryCallingCode,
	    nationalNumber: nationalNumber,
	    carrierCode: carrierCode
	  };
	}
	//# sourceMappingURL=parse_.js.map

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1375),
	    getValue = __webpack_require__(1422);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(144);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(52),
	    now = __webpack_require__(590),
	    toNumber = __webpack_require__(594);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var createFlow = __webpack_require__(1411);
	
	/**
	 * Creates a function that returns the result of invoking the given functions
	 * with the `this` binding of the created function, where each successive
	 * invocation is supplied the return value of the previous.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Util
	 * @param {...(Function|Function[])} [funcs] The functions to invoke.
	 * @returns {Function} Returns the new composite function.
	 * @see _.flowRight
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flow([_.add, square]);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flow = createFlow();
	
	module.exports = flow;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(533),
	    baseKeys = __webpack_require__(544),
	    isArrayLike = __webpack_require__(103);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(337);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(240);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _curryN = /*#__PURE__*/__webpack_require__(1554);
	
	/**
	 * Returns a curried equivalent of the provided function, with the specified
	 * arity. The curried function has two unusual capabilities. First, its
	 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
	 * the following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curry
	 * @example
	 *
	 *      var sumArgs = (...args) => R.sum(args);
	 *
	 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	
	
	var curryN = /*#__PURE__*/_curry2(function curryN(length, fn) {
	  if (length === 1) {
	    return _curry1(fn);
	  }
	  return _arity(length, _curryN(length, [], fn));
	});
	module.exports = curryN;

/***/ }),
/* 129 */
[1847, 26],
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var address = __webpack_require__(1762);
	var clone = __webpack_require__(80).clone;
	var isEnabled = __webpack_require__(1766);
	var newDate = __webpack_require__(353);
	var objCase = __webpack_require__(182);
	var traverse = __webpack_require__(398);
	var type = __webpack_require__(80).type;
	
	/**
	 * A *Facade* is an object meant for creating convience wrappers around
	 * objects. When developing integrations, you probably want to look at its
	 * subclasses, such as {@link Track} or {@link Identify}, rather than this
	 * general-purpose class.
	 *
	 * This constructor will initialize a new `Facade` with an `obj` of arguments.
	 *
	 * If the inputted `obj` doesn't have a `timestamp` property, one will be added
	 * with the value `new Date()`. Otherwise, the `timestamp` property will be
	 * converted to a Date using the `new-date` package.
	 *
	 * By default, the inputted object will be defensively copied, and all ISO
	 * strings present in the string will be converted into Dates.
	 *
	 * @param {Object} obj - The object to wrap.
	 * @param {Object} opts - Options about what kind of Facade to create.
	 * @param {boolean} [opts.clone=true] - Whether to make defensive clones. If enabled,
	 * the inputted object will be cloned, and any objects derived from this facade
	 * will be cloned before being returned.
	 * @param {boolean} [opts.traverse=true] - Whether to perform ISODate-Traverse
	 * on the inputted object.
	 *
	 * @see {@link https://github.com/segmentio/new-date|new-date}
	 * @see {@link https://github.com/segmentio/isodate-traverse|isodate-traverse}
	 */
	function Facade(obj, opts) {
	  opts = opts || {};
	  if (!('clone' in opts)) opts.clone = true;
	  if (opts.clone) obj = clone(obj);
	  if (!('traverse' in opts)) opts.traverse = true;
	  if (!('timestamp' in obj)) obj.timestamp = new Date();
	  else obj.timestamp = newDate(obj.timestamp);
	  if (opts.traverse) traverse(obj);
	  this.opts = opts;
	  this.obj = obj;
	}
	
	/**
	 * Get a potentially-nested field in this facade. `field` should be a
	 * period-separated sequence of properties.
	 *
	 * If the first field passed in points to a function (e.g. the `field` passed
	 * in is `a.b.c` and this facade's `obj.a` is a function), then that function
	 * will be called, and then the deeper fields will be fetched (using obj-case)
	 * from what that function returns. If the first field isn't a function, then
	 * this function works just like obj-case.
	 *
	 * Because this function uses obj-case, the camel- or snake-case of the input
	 * is irrelevant.
	 *
	 * @example
	 * YourClass.prototype.height = function() {
	 *   return this.proxy('getDimensions.height') ||
	 *     this.proxy('props.size.side_length');
	 * }
	 * @param {string} field - A sequence of properties, joined by periods (`.`).
	 * @return {*} - A property of the inputted object.
	 * @see {@link https://github.com/segmentio/obj-case|obj-case}
	 */
	Facade.prototype.proxy = function(field) {
	  var fields = field.split('.');
	  field = fields.shift();
	
	  // Call a function at the beginning to take advantage of facaded fields
	  var obj = this[field] || this.field(field);
	  if (!obj) return obj;
	  if (typeof obj === 'function') obj = obj.call(this) || {};
	  if (fields.length === 0) return this.opts.clone ? transform(obj) : obj;
	
	  obj = objCase(obj, fields.join('.'));
	  return this.opts.clone ? transform(obj) : obj;
	};
	
	/**
	 * Directly access a specific `field` from the underlying object. Only
	 * "top-level" fields will work with this function. "Nested" fields *will not
	 * work* with this function.
	 *
	 * @param {string} field
	 * @return {*}
	 */
	Facade.prototype.field = function(field) {
	  var obj = this.obj[field];
	  return this.opts.clone ? transform(obj) : obj;
	};
	
	/**
	 * Utility method to always proxy a particular `field`. In other words, it
	 * returns a function that will always return `this.proxy(field)`.
	 *
	 * @example
	 * MyClass.prototype.height = Facade.proxy('options.dimensions.height');
	 *
	 * @param {string} field
	 * @return {Function}
	 */
	Facade.proxy = function(field) {
	  return function() {
	    return this.proxy(field);
	  };
	};
	
	/**
	 * Utility method to always access a `field`. In other words, it returns a
	 * function that will always return `this.field(field)`.
	 *
	 * @param {string} field
	 * @return {Function}
	 */
	Facade.field = function(field) {
	  return function() {
	    return this.field(field);
	  };
	};
	
	/**
	 * Create a helper function for fetching a "plural" thing.
	 *
	 * The generated method will take the inputted `path` and append an "s" to it
	 * and calls `this.proxy` with this "pluralized" path. If that produces an
	 * array, that will be returned. Otherwise, a one-element array containing
	 * `this.proxy(path)` will be returned.
	 *
	 * @example
	 * MyClass.prototype.birds = Facade.multi('animals.bird');
	 *
	 * @param {string} path
	 * @return {Function}
	 */
	Facade.multi = function(path) {
	  return function() {
	    var multi = this.proxy(path + 's');
	    if (type(multi) === 'array') return multi;
	    var one = this.proxy(path);
	    if (one) one = [this.opts.clone ? clone(one) : one];
	    return one || [];
	  };
	};
	
	/**
	 * Create a helper function for getting a "singular" thing.
	 *
	 * The generated method will take the inputted path and call
	 * `this.proxy(path)`. If a truthy thing is produced, it will be returned.
	 * Otherwise, `this.proxy(path + 's')` will be called, and if that produces an
	 * array the first element of that array will be returned. Otherwise,
	 * `undefined` is returned.
	 *
	 * @example
	 * MyClass.prototype.bird = Facade.one('animals.bird');
	 *
	 * @param {string} path
	 * @return {Function}
	 */
	Facade.one = function(path) {
	  return function() {
	    var one = this.proxy(path);
	    if (one) return one;
	    var multi = this.proxy(path + 's');
	    if (type(multi) === 'array') return multi[0];
	  };
	};
	
	/**
	 * Gets the underlying object this facade wraps around.
	 *
	 * If this facade has a property `type`, it will be invoked as a function and
	 * will be assigned as the property `type` of the outputted object.
	 *
	 * @return {Object}
	 */
	Facade.prototype.json = function() {
	  var ret = this.opts.clone ? clone(this.obj) : this.obj;
	  if (this.type) ret.type = this.type();
	  return ret;
	};
	
	/**
	 * Get the options of a call. If an integration is passed, only the options for
	 * that integration are included. If the integration is not enabled, then
	 * `undefined` is returned.
	 *
	 * Options are taken from the `options` property of the underlying object,
	 * falling back to the object's `context` or simply `{}`.
	 *
	 * @param {string} integration - The name of the integration to get settings
	 * for. Casing does not matter.
	 * @return {Object|undefined}
	 */
	Facade.prototype.options = function(integration) {
	  var obj = this.obj.options || this.obj.context || {};
	  var options = this.opts.clone ? clone(obj) : obj;
	  if (!integration) return options;
	  if (!this.enabled(integration)) return;
	  var integrations = this.integrations();
	  var value = integrations[integration] || objCase(integrations, integration);
	  if (typeof value !== 'object') value = objCase(this.options(), integration);
	  return typeof value === 'object' ? value : {};
	};
	
	/**
	 * An alias for {@link Facade#options}.
	 */
	Facade.prototype.context = Facade.prototype.options;
	
	/**
	 * Check whether an integration is enabled.
	 *
	 * Basically, this method checks whether this integration is explicitly
	 * enabled. If it isn'texplicitly mentioned, it checks whether it has been
	 * enabled at the global level. Some integrations (e.g. Salesforce), cannot
	 * enabled by these global event settings.
	 *
	 * More concretely, the deciding factors here are:
	 *
	 * 1. If `this.integrations()` has the integration set to `true`, return `true`.
	 * 2. If `this.integrations().providers` has the integration set to `true`, return `true`.
	 * 3. If integrations are set to default-disabled via global parameters (i.e.
	 * `options.providers.all`, `options.all`, or `integrations.all`), then return
	 * false.
	 * 4. If the integration is one of the special default-deny integrations
	 * (currently, only Salesforce), then return false.
	 * 5. Else, return true.
	 *
	 * @param {string} integration
	 * @return {boolean}
	 */
	Facade.prototype.enabled = function(integration) {
	  var allEnabled = this.proxy('options.providers.all');
	  if (typeof allEnabled !== 'boolean') allEnabled = this.proxy('options.all');
	  if (typeof allEnabled !== 'boolean') allEnabled = this.proxy('integrations.all');
	  if (typeof allEnabled !== 'boolean') allEnabled = true;
	
	  var enabled = allEnabled && isEnabled(integration);
	  var options = this.integrations();
	
	  // If the integration is explicitly enabled or disabled, use that
	  // First, check options.providers for backwards compatibility
	  if (options.providers && options.providers.hasOwnProperty(integration)) {
	    enabled = options.providers[integration];
	  }
	
	  // Next, check for the integration's existence in 'options' to enable it.
	  // If the settings are a boolean, use that, otherwise it should be enabled.
	  if (options.hasOwnProperty(integration)) {
	    var settings = options[integration];
	    if (typeof settings === 'boolean') {
	      enabled = settings;
	    } else {
	      enabled = true;
	    }
	  }
	
	  return !!enabled;
	};
	
	/**
	 * Get all `integration` options.
	 *
	 * @ignore
	 * @param {string} integration
	 * @return {Object}
	 */
	Facade.prototype.integrations = function() {
	  return this.obj.integrations || this.proxy('options.providers') || this.options();
	};
	
	/**
	 * Check whether the user is active.
	 *
	 * @return {boolean}
	 */
	Facade.prototype.active = function() {
	  var active = this.proxy('options.active');
	  if (active === null || active === undefined) active = true;
	  return active;
	};
	
	/**
	 * Get `sessionId / anonymousId`.
	 *
	 * @return {*}
	 */
	Facade.prototype.anonymousId = function() {
	  return this.field('anonymousId') || this.field('sessionId');
	};
	
	/**
	 * An alias for {@link Facade#anonymousId}.
	 *
	 * @function
	 * @return {string}
	 */
	Facade.prototype.sessionId = Facade.prototype.anonymousId;
	
	/**
	 * Get `groupId` from `context.groupId`.
	 *
	 * @function
	 * @return {string}
	 */
	Facade.prototype.groupId = Facade.proxy('options.groupId');
	
	/**
	 * Get the call's "traits". All event types can pass in traits, though {@link
	 * Identify} and {@link Group} override this implementation.
	 *
	 * Traits are gotten from `options.traits`, augmented with a property `id` with
	 * the event's `userId`.
	 *
	 * The parameter `aliases` is meant to transform keys in `options.traits` into
	 * new keys. Each alias like `{ "xxx": "yyy" }` will take whatever is at `xxx`
	 * in the traits, and move it to `yyy`. If `xxx` is a method of this facade,
	 * it'll be called as a function instead of treated as a key into the traits.
	 *
	 * @example
	 * var obj = { options: { traits: { foo: "bar" } }, anonymousId: "xxx" }
	 * var facade = new Facade(obj)
	 *
	 * facade.traits() // { "foo": "bar" }
	 * facade.traits({ "foo": "asdf" }) // { "asdf": "bar" }
	 * facade.traits({ "sessionId": "rofl" }) // { "rofl": "xxx" }
	 *
	 * @param {Object} aliases - A mapping from keys to the new keys they should be
	 * transformed to.
	 * @return {Object}
	 */
	Facade.prototype.traits = function(aliases) {
	  var ret = this.proxy('options.traits') || {};
	  var id = this.userId();
	  aliases = aliases || {};
	
	  if (id) ret.id = id;
	
	  for (var alias in aliases) {
	    var value = this[alias] == null ? this.proxy('options.traits.' + alias) : this[alias]();
	    if (value == null) continue;
	    ret[aliases[alias]] = value;
	    delete ret[alias];
	  }
	
	  return ret;
	};
	
	/**
	 * The library and version of the client used to produce the message.
	 *
	 * If the library name cannot be determined, it is set to `"unknown"`. If the
	 * version cannot be determined, it is set to `null`.
	 *
	 * @return {{name: string, version: string}}
	 */
	Facade.prototype.library = function() {
	  var library = this.proxy('options.library');
	  if (!library) return { name: 'unknown', version: null };
	  if (typeof library === 'string') return { name: library, version: null };
	  return library;
	};
	
	/**
	 * Return the device information, falling back to an empty object.
	 *
	 * Interesting values of `type` are `"ios"` and `"android"`, but other values
	 * are possible if the client is doing something unusual with `context.device`.
	 *
	 * @return {{type: string}}
	 */
	Facade.prototype.device = function() {
	  var device = this.proxy('context.device');
	  if (type(device) !== 'object') device = {};
	  var library = this.library().name;
	  if (device.type) return device;
	
	  if (library.indexOf('ios') > -1) device.type = 'ios';
	  if (library.indexOf('android') > -1) device.type = 'android';
	  return device;
	};
	
	/**
	 * Get the User-Agent from `context.userAgent`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return string
	 */
	Facade.prototype.userAgent = Facade.proxy('context.userAgent');
	
	/**
	 * Get the timezone from `context.timezone`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return string
	 */
	Facade.prototype.timezone = Facade.proxy('context.timezone');
	
	/**
	 * Get the timestamp from `context.timestamp`.
	 *
	 * @function
	 * @return string
	 */
	Facade.prototype.timestamp = Facade.field('timestamp');
	
	/**
	 * Get the channel from `channel`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return string
	 */
	Facade.prototype.channel = Facade.field('channel');
	
	/**
	 * Get the IP address from `context.ip`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return string
	 */
	Facade.prototype.ip = Facade.proxy('context.ip');
	
	/**
	 * Get the user ID from `userId`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return string
	 */
	Facade.prototype.userId = Facade.field('userId');
	
	/**
	 * Get the ZIP/Postal code from `traits`, `traits.address`, `properties`, or
	 * `properties.address`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @name zip
	 * @function
	 * @memberof Facade.prototype
	 * @return {string}
	 */
	
	/**
	 * Get the country from `traits`, `traits.address`, `properties`, or
	 * `properties.address`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @name country
	 * @function
	 * @memberof Facade.prototype
	 * @return {string}
	 */
	
	/**
	 * Get the street from `traits`, `traits.address`, `properties`, or
	 * `properties.address`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @name street
	 * @function
	 * @memberof Facade.prototype
	 * @return {string}
	 */
	
	/**
	 * Get the state from `traits`, `traits.address`, `properties`, or
	 * `properties.address`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @name state
	 * @function
	 * @memberof Facade.prototype
	 * @return {string}
	 */
	
	/**
	 * Get the city from `traits`, `traits.address`, `properties`, or
	 * `properties.address`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @name city
	 * @function
	 * @memberof Facade.prototype
	 * @return {string}
	 */
	
	/**
	 * Get the region from `traits`, `traits.address`, `properties`, or
	 * `properties.address`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @name region
	 * @function
	 * @memberof Facade.prototype
	 * @return {string}
	 */
	
	address(Facade.prototype);
	
	/**
	 * Return the cloned and traversed object
	 *
	 * @ignore
	 * @param {*} obj
	 * @return {*}
	 */
	function transform(obj) {
	  return clone(obj);
	}
	
	module.exports = Facade;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Facade = __webpack_require__(130);
	
	Facade.Alias = __webpack_require__(1763);
	Facade.Group = __webpack_require__(1765);
	Facade.Identify = __webpack_require__(810);
	Facade.Track = __webpack_require__(389);
	Facade.Page = __webpack_require__(811);
	Facade.Screen = __webpack_require__(1767);
	Facade.Delete = __webpack_require__(1764);
	
	module.exports = Facade;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (typeof window === 'undefined') {
	  module.exports = function () {
	    return null;
	  };
	} else {
	  module.exports = __webpack_require__(1805); // eslint-disable-line global-require
	}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * Module dependencies.
	 */
	
	var keys = __webpack_require__(825);
	
	var objToString = Object.prototype.toString;
	
	/**
	 * Tests if a value is a number.
	 *
	 * @name isNumber
	 * @api private
	 * @param {*} val The value to test.
	 * @return {boolean} Returns `true` if `val` is a number, otherwise `false`.
	 */
	// TODO: Move to library
	var isNumber = function isNumber(val) {
	  var type = typeof val;
	  return type === 'number' || (type === 'object' && objToString.call(val) === '[object Number]');
	};
	
	/**
	 * Tests if a value is an array.
	 *
	 * @name isArray
	 * @api private
	 * @param {*} val The value to test.
	 * @return {boolean} Returns `true` if the value is an array, otherwise `false`.
	 */
	// TODO: Move to library
	var isArray = typeof Array.isArray === 'function' ? Array.isArray : function isArray(val) {
	  return objToString.call(val) === '[object Array]';
	};
	
	/**
	 * Tests if a value is array-like. Array-like means the value is not a function and has a numeric
	 * `.length` property.
	 *
	 * @name isArrayLike
	 * @api private
	 * @param {*} val
	 * @return {boolean}
	 */
	// TODO: Move to library
	var isArrayLike = function isArrayLike(val) {
	  return val != null && (isArray(val) || (val !== 'function' && isNumber(val.length)));
	};
	
	/**
	 * Internal implementation of `each`. Works on arrays and array-like data structures.
	 *
	 * @name arrayEach
	 * @api private
	 * @param {Function(value, key, collection)} iterator The function to invoke per iteration.
	 * @param {Array} array The array(-like) structure to iterate over.
	 * @return {undefined}
	 */
	var arrayEach = function arrayEach(iterator, array) {
	  for (var i = 0; i < array.length; i += 1) {
	    // Break iteration early if `iterator` returns `false`
	    if (iterator(array[i], i, array) === false) {
	      break;
	    }
	  }
	};
	
	/**
	 * Internal implementation of `each`. Works on objects.
	 *
	 * @name baseEach
	 * @api private
	 * @param {Function(value, key, collection)} iterator The function to invoke per iteration.
	 * @param {Object} object The object to iterate over.
	 * @return {undefined}
	 */
	var baseEach = function baseEach(iterator, object) {
	  var ks = keys(object);
	
	  for (var i = 0; i < ks.length; i += 1) {
	    // Break iteration early if `iterator` returns `false`
	    if (iterator(object[ks[i]], ks[i], object) === false) {
	      break;
	    }
	  }
	};
	
	/**
	 * Iterate over an input collection, invoking an `iterator` function for each element in the
	 * collection and passing to it three arguments: `(value, index, collection)`. The `iterator`
	 * function can end iteration early by returning `false`.
	 *
	 * @name each
	 * @api public
	 * @param {Function(value, key, collection)} iterator The function to invoke per iteration.
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @return {undefined} Because `each` is run only for side effects, always returns `undefined`.
	 * @example
	 * var log = console.log.bind(console);
	 *
	 * each(log, ['a', 'b', 'c']);
	 * //-> 'a', 0, ['a', 'b', 'c']
	 * //-> 'b', 1, ['a', 'b', 'c']
	 * //-> 'c', 2, ['a', 'b', 'c']
	 * //=> undefined
	 *
	 * each(log, 'tim');
	 * //-> 't', 2, 'tim'
	 * //-> 'i', 1, 'tim'
	 * //-> 'm', 0, 'tim'
	 * //=> undefined
	 *
	 * // Note: Iteration order not guaranteed across environments
	 * each(log, { name: 'tim', occupation: 'enchanter' });
	 * //-> 'tim', 'name', { name: 'tim', occupation: 'enchanter' }
	 * //-> 'enchanter', 'occupation', { name: 'tim', occupation: 'enchanter' }
	 * //=> undefined
	 */
	var each = function each(iterator, collection) {
	  return (isArrayLike(collection) ? arrayEach : baseEach).call(this, iterator, collection);
	};
	
	/*
	 * Exports.
	 */
	
	module.exports = each;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FetchOnMount = (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    this.props.fetchData();
	  }
	});
	
	exports.default = FetchOnMount;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _selectors = __webpack_require__(164);
	
	var _selectors2 = __webpack_require__(11);
	
	var _selectors3 = __webpack_require__(21);
	
	var _selectors4 = __webpack_require__(452);
	
	var _selectors5 = __webpack_require__(405);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WithShopCurrency = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  var shop = (0, _selectors2.getShopByRoute)(state, ownProps.params.shopRoute) || (0, _selectors3.getShopObject)(state) || (0, _selectors.getWaitingListTimesShop)(state) || (0, _selectors4.getShopObjectFromReceipt)(state) || (0, _selectors5.getCampaignShop)(state);
	  return {
	    currency: (0, _get3.default)(shop, 'currency', 'USD')
	  };
	}));
	
	exports.default = WithShopCurrency;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getContext2 = __webpack_require__(803);
	
	var _getContext3 = _interopRequireDefault(_getContext2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getContext3.default)({ extension: _propTypes2.default.object });

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.openLocationWithPrefix = exports.prependLocationPrefix = exports.composeReplaceHooks = exports.persistShowShops = undefined;
	
	var _view2 = __webpack_require__(1591);
	
	var _view3 = _interopRequireDefault(_view2);
	
	var _unless2 = __webpack_require__(757);
	
	var _unless3 = _interopRequireDefault(_unless2);
	
	var _set2 = __webpack_require__(1585);
	
	var _set3 = _interopRequireDefault(_set2);
	
	var _reduce2 = __webpack_require__(245);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _prop2 = __webpack_require__(88);
	
	var _prop3 = _interopRequireDefault(_prop2);
	
	var _pipe2 = __webpack_require__(75);
	
	var _pipe3 = _interopRequireDefault(_pipe2);
	
	var _lensPath2 = __webpack_require__(1576);
	
	var _lensPath3 = _interopRequireDefault(_lensPath2);
	
	var _identical2 = __webpack_require__(741);
	
	var _identical3 = _interopRequireDefault(_identical2);
	
	var _complement2 = __webpack_require__(357);
	
	var _complement3 = _interopRequireDefault(_complement2);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Persists query key on location change
	var persistQuery = function persistQuery(key) {
	  return function (prevState, nextState) {
	    var lens = (0, _lensPath3.default)(['location', 'query', key]);
	
	    var isKeySet = (0, _pipe3.default)((0, _view3.default)(lens), Boolean);
	    var isKeyNotSet = (0, _complement3.default)(isKeySet);
	    if (isKeyNotSet(prevState) || isKeySet(nextState)) return nextState;
	
	    var newState = (0, _set3.default)(lens, (0, _view3.default)(lens, prevState), nextState);
	    return newState;
	  };
	}; /* eslint-disable */
	var persistShowShops = exports.persistShowShops = persistQuery('showShops');
	
	// Composes hooks with replacing location on the end
	var composeReplaceHooks = exports.composeReplaceHooks = function composeReplaceHooks() {
	  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
	    fns[_key] = arguments[_key];
	  }
	
	  return function (prevState, nextState, replace) {
	    return (0, _pipe3.default)((0, _reduce3.default)(function (acc, fn) {
	      return fn(prevState, acc);
	    }, nextState), (0, _prop3.default)('location'), (0, _unless3.default)((0, _identical3.default)(nextState.location), replace))(fns);
	  };
	};
	
	// updates links with a PUBLISH_URL prefix in consolidated mode
	var prependLocationPrefix = exports.prependLocationPrefix = function prependLocationPrefix(path) {
	  var formattedPath = path;
	  if (!formattedPath.startsWith('/')) {
	    formattedPath = '/' + formattedPath;
	  }
	
	  return '' + _config2.default.pathPrefix + formattedPath;
	};
	
	var openLocationWithPrefix = exports.openLocationWithPrefix = function openLocationWithPrefix(path) {
	  window.location.href = prependLocationPrefix(path);
	};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = matchesEntirely;
	
	/**
	 * Checks whether the entire input sequence can be matched
	 * against the regular expression.
	 * @return {boolean}
	 */
	function matchesEntirely(text, regular_expression) {
	  // If assigning the `''` default value is moved to the arguments above,
	  // code coverage would decrease for some weird reason.
	  text = text || '';
	  return new RegExp('^(?:' + regular_expression + ')$').test(text);
	}
	//# sourceMappingURL=matchesEntirely.js.map

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parsePhoneNumber;
	exports.normalizeArguments = normalizeArguments;
	
	var _parsePhoneNumber_ = _interopRequireDefault(__webpack_require__(522));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function parsePhoneNumber() {
	  var _normalizeArguments = normalizeArguments(arguments),
	      text = _normalizeArguments.text,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _parsePhoneNumber_["default"])(text, options, metadata);
	}
	
	function normalizeArguments(args) {
	  var _Array$prototype$slic = Array.prototype.slice.call(args),
	      _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4),
	      arg_1 = _Array$prototype$slic2[0],
	      arg_2 = _Array$prototype$slic2[1],
	      arg_3 = _Array$prototype$slic2[2],
	      arg_4 = _Array$prototype$slic2[3];
	
	  var text;
	  var options;
	  var metadata; // If the phone number is passed as a string.
	  // `parsePhoneNumber('88005553535', ...)`.
	
	  if (typeof arg_1 === 'string') {
	    text = arg_1;
	  } else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
	  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
	
	
	  if (!arg_2 || typeof arg_2 === 'string') {
	    if (arg_4) {
	      options = arg_3;
	      metadata = arg_4;
	    } else {
	      options = undefined;
	      metadata = arg_3;
	    }
	
	    if (arg_2) {
	      options = _objectSpread({
	        defaultCountry: arg_2
	      }, options);
	    }
	  } // `defaultCountry` is not passed.
	  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
	  else if (isObject(arg_2)) {
	    if (arg_3) {
	      options = arg_2;
	      metadata = arg_3;
	    } else {
	      metadata = arg_2;
	    }
	  } else throw new Error("Invalid second argument: ".concat(arg_2));
	
	  return {
	    text: text,
	    options: options,
	    metadata: metadata
	  };
	} // Otherwise istanbul would show this as "branch not covered".
	
	/* istanbul ignore next */
	
	
	var isObject = function isObject(_) {
	  return _typeof(_) === 'object';
	};
	//# sourceMappingURL=parsePhoneNumber.js.map

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(540),
	    createBaseEach = __webpack_require__(1405);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(174),
	    isArrayLike = __webpack_require__(103),
	    isIndex = __webpack_require__(225),
	    isObject = __webpack_require__(52);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(104);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 145 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 146 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 147 */
/***/ (function(module, exports) {

	function _has(prop, obj) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	module.exports = _has;

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clone = clone;
	exports.addMonths = addMonths;
	exports.isSameDay = isSameDay;
	exports.isDayBefore = isDayBefore;
	exports.isDayAfter = isDayAfter;
	exports.isPastDay = isPastDay;
	exports.isFutureDay = isFutureDay;
	exports.isDayBetween = isDayBetween;
	exports.addDayToRange = addDayToRange;
	exports.isDayInRange = isDayInRange;
	exports.getWeekNumber = getWeekNumber;
	/**
	 * Clone a date object.
	 *
	 * @export
	 * @param  {Date} d The date to clone
	 * @return {Date} The cloned date
	 */
	function clone(d) {
	  return new Date(d.getTime());
	}
	
	/**
	 * Return `d` as a new date with `n` months added.
	 *
	 * @export
	 * @param {[type]} d
	 * @param {[type]} n
	 */
	function addMonths(d, n) {
	  var newDate = clone(d);
	  newDate.setMonth(d.getMonth() + n);
	  return newDate;
	}
	
	/**
	 * Return `true` if two dates are the same day, ignoring the time.
	 *
	 * @export
	 * @param  {Date}  d1
	 * @param  {Date}  d2
	 * @return {Boolean}
	 */
	function isSameDay(d1, d2) {
	  if (!d1 || !d2) {
	    return false;
	  }
	  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
	}
	
	/**
	 * Returns `true` if the first day is before the second day.
	 *
	 * @export
	 * @param {Date} d1
	 * @param {Date} d2
	 * @returns {Boolean}
	 */
	function isDayBefore(d1, d2) {
	  var day1 = clone(d1).setHours(0, 0, 0, 0);
	  var day2 = clone(d2).setHours(0, 0, 0, 0);
	  return day1 < day2;
	}
	
	/**
	 * Returns `true` if the first day is after the second day.
	 *
	 * @export
	 * @param {Date} d1
	 * @param {Date} d2
	 * @returns {Boolean}
	 */
	function isDayAfter(d1, d2) {
	  var day1 = clone(d1).setHours(0, 0, 0, 0);
	  var day2 = clone(d2).setHours(0, 0, 0, 0);
	  return day1 > day2;
	}
	
	/**
	 * Return `true` if a day is in the past, e.g. yesterday or any day
	 * before yesterday.
	 *
	 * @export
	 * @param  {Date}  d
	 * @return {Boolean}
	 */
	function isPastDay(d) {
	  var today = new Date();
	  today.setHours(0, 0, 0, 0);
	  return isDayBefore(d, today);
	}
	
	/**
	 * Return `true` if a day is in the future, e.g. tomorrow or any day
	 * after tomorrow.
	 *
	 * @export
	 * @param  {Date}  d
	 * @return {Boolean}
	 */
	function isFutureDay(d) {
	  var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
	  tomorrow.setHours(0, 0, 0, 0);
	  return d >= tomorrow;
	}
	
	/**
	 * Return `true` if day `d` is between days `d1` and `d2`,
	 * without including them.
	 *
	 * @export
	 * @param  {Date}  d
	 * @param  {Date}  d1
	 * @param  {Date}  d2
	 * @return {Boolean}
	 */
	function isDayBetween(d, d1, d2) {
	  var date = clone(d);
	  date.setHours(0, 0, 0, 0);
	  return isDayAfter(date, d1) && isDayBefore(date, d2) || isDayAfter(date, d2) && isDayBefore(date, d1);
	}
	
	/**
	 * Add a day to a range and return a new range. A range is an object with
	 * `from` and `to` days.
	 *
	 * @export
	 * @param {Date} day
	 * @param {Object} range
	 * @return {Object} Returns a new range object
	 */
	function addDayToRange(day) {
	  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { from: null, to: null };
	  var from = range.from,
	      to = range.to;
	
	  if (!from) {
	    from = day;
	  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
	    from = null;
	    to = null;
	  } else if (to && isDayBefore(day, from)) {
	    from = day;
	  } else if (to && isSameDay(day, to)) {
	    from = day;
	    to = day;
	  } else {
	    to = day;
	    if (isDayBefore(to, from)) {
	      to = from;
	      from = day;
	    }
	  }
	
	  return { from: from, to: to };
	}
	
	/**
	 * Return `true` if a day is included in a range of days.
	 *
	 * @export
	 * @param  {Date}  day
	 * @param  {Object}  range
	 * @return {Boolean}
	 */
	function isDayInRange(day, range) {
	  var from = range.from,
	      to = range.to;
	
	  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
	}
	
	/**
	 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
	 * for the given day.
	 *
	 * @export
	 * @param {Date} day
	 * @returns {Number}
	 */
	function getWeekNumber(day) {
	  var date = clone(day);
	  date.setHours(0, 0, 0);
	  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
	  return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
	}
	
	exports.default = {
	  addDayToRange: addDayToRange,
	  addMonths: addMonths,
	  clone: clone,
	  getWeekNumber: getWeekNumber,
	  isDayAfter: isDayAfter,
	  isDayBefore: isDayBefore,
	  isDayBetween: isDayBetween,
	  isDayInRange: isDayInRange,
	  isFutureDay: isFutureDay,
	  isPastDay: isPastDay,
	  isSameDay: isSameDay
	};
	//# sourceMappingURL=DateUtils.js.map

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1625);


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(365);
	var setInnerHTML = __webpack_require__(254);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(373);
	var setTextContent = __webpack_require__(779);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var invariant = __webpack_require__(13);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1648);
	var ReactInstrumentation = __webpack_require__(76);
	
	var warning = __webpack_require__(19);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(24);
	
	var ReactChildren = __webpack_require__(1733);
	var ReactComponent = __webpack_require__(387);
	var ReactPureComponent = __webpack_require__(1738);
	var ReactClass = __webpack_require__(1734);
	var ReactDOMFactories = __webpack_require__(1735);
	var ReactElement = __webpack_require__(156);
	var ReactPropTypes = __webpack_require__(1737);
	var ReactVersion = __webpack_require__(1739);
	
	var onlyChild = __webpack_require__(1742);
	var warning = __webpack_require__(19);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	// TODO: Fix tests so that this deprecation warning doesn't cause failures.
	if (false) {
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	  }
	}
	
	module.exports = React;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(24);
	
	var ReactCurrentOwner = __webpack_require__(91);
	
	var warning = __webpack_require__(19);
	var canDefineProperty = __webpack_require__(802);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(801);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 157 */
26,
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _castArray2 = __webpack_require__(1467);
	
	var _castArray3 = _interopRequireDefault(_castArray2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global fbq */
	
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FB_EVENTS_SCRIPT = 'https://connect.facebook.net/en_US/fbevents.js';
	var FB_EXTENSIONS_SCRIPT = 'https://connect.facebook.net/en_US/platform.Extensions.js';
	
	var FBPixel = function () {
	  function FBPixel() {
	    _classCallCheck(this, FBPixel);
	  }
	
	  _createClass(FBPixel, null, [{
	    key: 'init',
	    value: function init() {
	      var loadExtensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!this.fbEventsInitialized) {
	        // Async load facebook pixel library
	        // eslint-disable-next-line
	        !function (f, b, e, v, n, t, s) {
	          if (f.fbq) return;n = f.fbq = function () {
	            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
	          };if (!f._fbq) f._fbq = n;n.push = n;n.loaded = !0;n.version = '2.0';n.queue = [];t = b.createElement(e);t.async = !0;t.src = v;s = b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t, s);
	        }(window, document, 'script', FB_EVENTS_SCRIPT);
	        // We will track
	        fbq.disablePushState = true;
	        this.setGranted(false);
	        this.fbEventsInitialized = true;
	      }
	
	      if (loadExtensions) {
	        this.loadExtensionsScript();
	      }
	    }
	  }, {
	    key: 'loadExtensionsScript',
	    value: function loadExtensionsScript() {
	      if (!this.extensionsLoaded) {
	        // Async load facebook extensions library
	        // eslint-disable-next-line
	        (function (d, s, id) {
	          var js,
	              fjs = d.getElementsByTagName(s)[0];if (d.getElementById(id)) {
	            return;
	          }js = d.createElement(s);js.id = id;js.src = FB_EXTENSIONS_SCRIPT;fjs.parentNode.insertBefore(js, fjs);
	        })(document, 'script', 'facebook-ixsdk');
	        this.extensionsLoaded = true;
	      }
	    }
	  }, {
	    key: 'initExtensions',
	    value: function initExtensions() {
	      if (!this.extensionsInitialized) {
	        window.FBExtensions.init({ appId: _config2.default.fbPixel });
	        this.extensionsInitialized = true;
	      }
	    }
	  }, {
	    key: 'setGranted',
	    value: function setGranted() {
	      var granted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (this.fbEventsInitialized) {
	        fbq('consent', granted ? 'grant' : 'revoke');
	      }
	    }
	  }, {
	    key: 'setPixelFor',
	    value: function setPixelFor(context) {
	      var pixelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (pixelId === null) {
	        if (this.loadedPixels.has(context)) {
	          this.loadedPixels.delete(context);
	        }
	        return;
	      }
	
	      this.init();
	      fbq('init', pixelId);
	      this.loadedPixels.set(context, pixelId);
	    }
	  }, {
	    key: 'trackPageView',
	    value: function trackPageView(context, customData, eventData) {
	      this.track(context, 'PageView', customData, eventData);
	    }
	  }, {
	    key: 'trackReservation',
	    value: function trackReservation(context, customData) {
	      this.track(context, 'Reservation', customData);
	    }
	  }, {
	    key: 'trackSchedule',
	    value: function trackSchedule(context) {
	      this.track(context, 'Schedule');
	    }
	  }, {
	    key: 'track',
	    value: function track(context, eventName, customData, eventData) {
	      this.init();
	      var identifiers = (0, _castArray3.default)(context);
	      for (var i = 0; i < identifiers.length; i += 1) {
	        var pixelId = this.loadedPixels.get(identifiers[i]);
	        if (pixelId) {
	          fbq('trackSingle', pixelId, eventName, customData, eventData);
	        }
	      }
	    }
	  }]);
	
	  return FBPixel;
	}();
	
	FBPixel.fbEventsInitialized = false;
	FBPixel.extensionsLoaded = false;
	FBPixel.extensionsInitialized = false;
	FBPixel.consent = false;
	FBPixel.loadedPixels = new Map();
	exports.default = FBPixel;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBrandId = exports.getBrandBranchKey = exports.getBrandShops = exports.getBrandLogo = exports.getBrandImage = exports.getBrandName = exports.getBrand = undefined;
	
	var _prop2 = __webpack_require__(88);
	
	var _prop3 = _interopRequireDefault(_prop2);
	
	var _pipe2 = __webpack_require__(75);
	
	var _pipe3 = _interopRequireDefault(_pipe2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getBrand = exports.getBrand = function getBrand(state, route) {
	  return state.extensions.byRoute[route];
	};
	
	var getBrandName = exports.getBrandName = (0, _pipe3.default)(getBrand, (0, _prop3.default)('name'));
	
	var getBrandImage = exports.getBrandImage = (0, _pipe3.default)(getBrand, (0, _prop3.default)('backgroundImage'));
	
	var getBrandLogo = exports.getBrandLogo = (0, _pipe3.default)(getBrand, (0, _prop3.default)('logoImage'));
	
	var getBrandShops = exports.getBrandShops = (0, _pipe3.default)(getBrand, (0, _prop3.default)('shops'));
	
	var getBrandBranchKey = exports.getBrandBranchKey = (0, _pipe3.default)(getBrand, (0, _prop3.default)('branchKey'));
	
	var getBrandId = exports.getBrandId = (0, _pipe3.default)(getBrand, (0, _prop3.default)('brandId'));

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGateway = __webpack_require__(77);
	
	var _WithShopName = __webpack_require__(196);
	
	var _WithShopName2 = _interopRequireDefault(_WithShopName);
	
	var _Layout = __webpack_require__(112);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _Title = __webpack_require__(114);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Steps = __webpack_require__(916);
	
	var _Steps2 = _interopRequireDefault(_Steps);
	
	var _GiftCardLink = __webpack_require__(418);
	
	var _GiftCardLink2 = _interopRequireDefault(_GiftCardLink);
	
	var _passcode = __webpack_require__(198);
	
	var _passcode2 = _interopRequireDefault(_passcode);
	
	var _ThirdPartyPromotion = __webpack_require__(985);
	
	var _ThirdPartyPromotion2 = _interopRequireDefault(_ThirdPartyPromotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainLayout = function MainLayout(_ref) {
	  var children = _ref.children,
	      urlPattern = _ref.urlPattern,
	      shopName = _ref.shopName;
	  return _react2.default.createElement(
	    _Layout2.default,
	    { shopLayout: true },
	    _react2.default.createElement(
	      _Title2.default,
	      null,
	      shopName
	    ),
	    _react2.default.createElement(_Steps2.default, { urlPattern: urlPattern }),
	    _react2.default.createElement(_GiftCardLink2.default, { className: 'u-mt- medium-and-up-mt+ medium-and-down-mb' }),
	    _react2.default.createElement(_reactGateway.GatewayDest, { name: 'subtitle', className: 'u-show-for-large-and-up' }),
	    children,
	    _react2.default.createElement(_passcode2.default, null),
	    _react2.default.createElement(_ThirdPartyPromotion2.default, null)
	  );
	};
	
	MainLayout.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  urlPattern: _propTypes2.default.string,
	  shopName: _propTypes2.default.string
	};
	
	MainLayout.defaultProps = {
	  urlPattern: undefined,
	  shopName: ''
	};
	
	exports.default = (0, _WithShopName2.default)(MainLayout);

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _withProps3.default)(function (props) {
	  return {
	    bookNoPayQuery: (0, _get3.default)(props, 'location.query.bookNoPay', false)
	  };
	}));

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var copyrightYear = new Date().getFullYear();
	var AddressFooter = function AddressFooter() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "p",
	      { className: "c-ig-text-info u-mb-6 u-mt-8 u-text-center" },
	      "Copyright \xA9 ",
	      copyrightYear,
	      " Squire Technologies.\xA0",
	      _react2.default.createElement("br", { className: "u-hide-on-desktop" }),
	      "All rights reserved.",
	      _react2.default.createElement("br", null),
	      "You are receiving this email because you're awesome and because you have a Squire account."
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "c-ig-text-info u-text-center" },
	      "Our mailing address is:",
	      _react2.default.createElement("br", null),
	      "Squire Technologies",
	      _react2.default.createElement("br", null),
	      "139 Eldridge St.",
	      _react2.default.createElement("br", null),
	      "New York, NY 10002"
	    )
	  );
	};
	
	exports.default = AddressFooter;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _split2 = __webpack_require__(1500);
	
	var _split3 = _interopRequireDefault(_split2);
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _redux = __webpack_require__(49);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _WithShopCurrency = __webpack_require__(135);
	
	var _WithShopCurrency2 = _interopRequireDefault(_WithShopCurrency);
	
	var _selectors = __webpack_require__(51);
	
	var _constants = __webpack_require__(10);
	
	var _actions = __webpack_require__(42);
	
	var _WithTimeWaitingList = __webpack_require__(97);
	
	var _WithTimeWaitingList2 = _interopRequireDefault(_WithTimeWaitingList);
	
	var _actions2 = __webpack_require__(111);
	
	var _actions3 = __webpack_require__(92);
	
	var _actions4 = __webpack_require__(117);
	
	var _actions5 = __webpack_require__(64);
	
	var _helpers = __webpack_require__(7);
	
	var _selectors2 = __webpack_require__(11);
	
	var _selectors3 = __webpack_require__(27);
	
	var _selectors4 = __webpack_require__(295);
	
	var _selectors5 = __webpack_require__(21);
	
	var _shapes = __webpack_require__(23);
	
	var _MakeReservation = __webpack_require__(1166);
	
	var _MakeReservation2 = _interopRequireDefault(_MakeReservation);
	
	var _WithShopName = __webpack_require__(196);
	
	var _WithShopName2 = _interopRequireDefault(_WithShopName);
	
	var _withCost = __webpack_require__(116);
	
	var _withCost2 = _interopRequireDefault(_withCost);
	
	var _WithKioskProp = __webpack_require__(59);
	
	var _WithKioskProp2 = _interopRequireDefault(_WithKioskProp);
	
	var _OnUnload = __webpack_require__(983);
	
	var _OnUnload2 = _interopRequireDefault(_OnUnload);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _AskForEmailConsentModal = __webpack_require__(1157);
	
	var _AskForEmailConsentModal2 = _interopRequireDefault(_AskForEmailConsentModal);
	
	var _AskForEmailConsentContents = __webpack_require__(1156);
	
	var _AskForEmailConsentContents2 = _interopRequireDefault(_AskForEmailConsentContents);
	
	var _AskForSMSConsentContents = __webpack_require__(1158);
	
	var _AskForSMSConsentContents2 = _interopRequireDefault(_AskForSMSConsentContents);
	
	var _withKioskIsReserveOnly = __webpack_require__(465);
	
	var _withKioskIsReserveOnly2 = _interopRequireDefault(_withKioskIsReserveOnly);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var MakeReservationContainer = function (_Component) {
	  _inherits(MakeReservationContainer, _Component);
	
	  function MakeReservationContainer(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, MakeReservationContainer);
	
	    var _this = _possibleConstructorReturn(this, (MakeReservationContainer.__proto__ || Object.getPrototypeOf(MakeReservationContainer)).call(this, props));
	
	    _this.handleReserveAndPay = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(token) {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                // We're adding timeout here... because browsers are stupid.
	                // When paying with Apple Pay, the system UI will pop up and
	                // it will ask for confirmation and so on. Once the request is
	                // complete, we'd immediately go into getting user consent;
	                // this causes the apple pay modal to get all confused and
	                // report a payment error, even though the payment did go through
	                // (likely this is due to UI thread going into a deadlock)
	
	                // If we add a timeout, it plays the 'success' animation
	                // and we're all good to go.
	
	                setTimeout(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                  var consents;
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          _context.next = 2;
	                          return _this.askForConsent();
	
	                        case 2:
	                          consents = _context.sent;
	
	
	                          _this.createReservation({
	                            consents: consents,
	                            bookNoPay: false,
	                            token: token
	                          });
	
	                        case 4:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                })), 20);
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.handleBookAndReserve = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(token) {
	        var consents;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return _this.askForConsent();
	
	              case 2:
	                consents = _context3.sent;
	
	
	                _this.createReservation({
	                  consents: consents,
	                  bookNoPay: false,
	                  isReservation: true,
	                  token: token,
	                  tipAmount: 0
	                });
	
	              case 4:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.getConsentsFromRemote = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var firstName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        var lastName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	        var phone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	        var email = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	        var shopId, settings, askForSmsConsent, askForEmailConsent;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                shopId = _this.props.shopId;
	                _context4.next = 3;
	                return fetch(_config2.default.url + '/shop/' + shopId + '/notifications-consent', {
	                  method: 'POST',
	                  headers: {
	                    Accept: 'application/json',
	                    'Content-Type': 'application/json'
	                  },
	                  body: JSON.stringify({
	                    firstName: firstName, lastName: lastName, phone: phone, email: email
	                  })
	                }).then(function (res) {
	                  return res.json();
	                });
	
	              case 3:
	                settings = _context4.sent;
	                askForSmsConsent = settings.showPrompt.promotional.phone;
	                askForEmailConsent = settings.showPrompt.promotional.email;
	                return _context4.abrupt('return', { askForSmsConsent: askForSmsConsent, askForEmailConsent: askForEmailConsent });
	
	              case 7:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function () {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.getInitialStateOfConsentPrompts = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var _ref6, askForSmsConsent, askForEmailConsent;
	
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              _context5.next = 2;
	              return _this.getConsentsFromRemote();
	
	            case 2:
	              _ref6 = _context5.sent;
	              askForSmsConsent = _ref6.askForSmsConsent;
	              askForEmailConsent = _ref6.askForEmailConsent;
	
	
	              if (!askForSmsConsent) {
	                _this.setState({ smsConsent: true });
	              }
	
	              if (!askForEmailConsent) {
	                _this.setState({ emailConsent: true });
	              }
	
	            case 7:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	    _this.askForConsent = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	      var paymentProps, _paymentProps$user, firstName, lastName, phone, email, shopName, _this$state, smsConsent, emailConsent, _ref8, askForSmsConsent, askForEmailConsent;
	
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              paymentProps = _this.getPaymentProps();
	              _paymentProps$user = paymentProps.user, firstName = _paymentProps$user.firstName, lastName = _paymentProps$user.lastName, phone = _paymentProps$user.phone, email = _paymentProps$user.email;
	              shopName = _this.props.shopName;
	              _this$state = _this.state, smsConsent = _this$state.smsConsent, emailConsent = _this$state.emailConsent;
	
	              // Don't ask for anything if we've already gotten both consents - eg. if shop isn't asking for them at all
	
	              if (!(emailConsent !== null && smsConsent !== null)) {
	                _context6.next = 6;
	                break;
	              }
	
	              return _context6.abrupt('return', { smsConsent: smsConsent, emailConsent: emailConsent });
	
	            case 6:
	              _context6.next = 8;
	              return _this.getConsentsFromRemote(firstName, lastName, phone, email);
	
	            case 8:
	              _ref8 = _context6.sent;
	              askForSmsConsent = _ref8.askForSmsConsent;
	              askForEmailConsent = _ref8.askForEmailConsent;
	
	              if (!askForSmsConsent) {
	                _context6.next = 18;
	                break;
	              }
	
	              _context6.next = 14;
	              return (0, _AskForEmailConsentModal2.default)('askForSmsConsent', _AskForSMSConsentContents2.default, { shopName: shopName });
	
	            case 14:
	              smsConsent = _context6.sent;
	
	              _this.setState({ smsConsent: smsConsent });
	              _context6.next = 19;
	              break;
	
	            case 18:
	              if (smsConsent === null) {
	                smsConsent = true; // If theres no need to ask for consent AND it wasn't already rejected, we assume its given
	                _this.setState({ smsConsent: true });
	              }
	
	            case 19:
	              if (!askForEmailConsent) {
	                _context6.next = 26;
	                break;
	              }
	
	              _context6.next = 22;
	              return (0, _AskForEmailConsentModal2.default)('askForEmailConsent', _AskForEmailConsentContents2.default, { shopName: shopName });
	
	            case 22:
	              emailConsent = _context6.sent;
	
	              _this.setState({ emailConsent: emailConsent });
	              _context6.next = 27;
	              break;
	
	            case 26:
	              if (emailConsent === null) {
	                emailConsent = true; // If theres no need to ask for consent AND it wasn't already rejected, we assume its given
	                _this.setState({ emailConsent: true });
	              }
	
	            case 27:
	              return _context6.abrupt('return', { smsConsent: smsConsent, emailConsent: emailConsent });
	
	            case 28:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this2);
	    }));
	
	    _this.handleReserve = function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(turnstileToken) {
	        var consents;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _context7.next = 2;
	                return _this.askForConsent();
	
	              case 2:
	                consents = _context7.sent;
	
	                _this.createReservation({ tipAmount: 0, consents: consents, turnstileToken: turnstileToken });
	
	              case 4:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this2);
	      }));
	
	      return function (_x7) {
	        return _ref9.apply(this, arguments);
	      };
	    }();
	
	    _this.applePay = function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(isReservation) {
	        var consents;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _context8.next = 2;
	                return _this.askForConsent();
	
	              case 2:
	                consents = _context8.sent;
	
	
	                _this.props.processPayment();
	
	                _this.props.applePay({
	                  barberId: _this.props.barberId,
	                  tip: _this.getTip(),
	                  tipAmount: _this.getTipAmount(),
	                  bookNoPay: false,
	                  hasLoyaltyProgram: _this.props.hasLoyaltyProgram,
	                  anyBarber: _this.props.anyBarber,
	                  amount: _this.props.totalAmount,
	                  promoCode: _this.props.promoCode,
	                  isReservation: isReservation,
	                  consents: consents
	                });
	
	              case 5:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this2);
	      }));
	
	      return function (_x8) {
	        return _ref10.apply(this, arguments);
	      };
	    }();
	
	    _this.addCustomerToWaitingList = function () {
	      var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(token) {
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                // We're adding timeout here... because browsers are stupid.
	                // When paying with Apple Pay, the system UI will pop up and
	                // it will ask for confirmation and so on. Once the request is
	                // complete, we'd immediately go into getting user consent;
	                // this causes the apple pay modal to get all confused and
	                // report a payment error, even though the payment did go through
	                // (likely this is due to UI thread going into a deadlock)
	
	                // If we add a timeout, it plays the 'success' animation
	                // and we're all good to go.
	
	                setTimeout(_asyncToGenerator(_regenerator2.default.mark(function _callee9() {
	                  var consents, user, tipAmount, payload;
	                  return _regenerator2.default.wrap(function _callee9$(_context9) {
	                    while (1) {
	                      switch (_context9.prev = _context9.next) {
	                        case 0:
	                          _context9.next = 2;
	                          return _this.askForConsent();
	
	                        case 2:
	                          consents = _context9.sent;
	
	
	                          _this.props.processPayment();
	                          user = _this.props.user;
	                          tipAmount = _this.getTipAmount();
	                          payload = {
	                            user: user,
	                            token: token.id,
	                            tip: _this.getTip(),
	                            consents: consents
	                          };
	
	
	                          if (tipAmount !== null) {
	                            payload.tipAmount = tipAmount;
	                          }
	
	                          _this.props.addCustomerToWaitingList(payload);
	
	                        case 9:
	                        case 'end':
	                          return _context9.stop();
	                      }
	                    }
	                  }, _callee9, _this2);
	                })), 20);
	
	              case 1:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this2);
	      }));
	
	      return function (_x9) {
	        return _ref11.apply(this, arguments);
	      };
	    }();
	
	    _this.applePayAddCustomerToWaitingList = _asyncToGenerator(_regenerator2.default.mark(function _callee11() {
	      var consents, user;
	      return _regenerator2.default.wrap(function _callee11$(_context11) {
	        while (1) {
	          switch (_context11.prev = _context11.next) {
	            case 0:
	              _context11.next = 2;
	              return _this.askForConsent();
	
	            case 2:
	              consents = _context11.sent;
	
	
	              _this.props.processPayment();
	
	              user = _this.props.user;
	
	              _this.props.applePayAddCustomerToWaitingList(user, _this.getTipAmount(), { consents: consents });
	
	            case 6:
	            case 'end':
	              return _context11.stop();
	          }
	        }
	      }, _callee11, _this2);
	    }));
	
	
	    _this.state = {
	      analyticsFired: false,
	      showPromo: false,
	      smsConsent: null,
	      emailConsent: null
	    };
	    return _this;
	  }
	
	  _createClass(MakeReservationContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.resetTip();
	      this.props.resetFee();
	      this.props.resetPromo();
	      this.props.resetFields();
	      this.props.resetPaymentProcessing();
	      this.props.fetchShop().then(this.props.fetchService).then(this.props.fetchBarbers).catch(_helpers.nullFunc);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getInitialStateOfConsentPrompts();
	    }
	  }, {
	    key: 'getTip',
	    value: function getTip() {
	      if (!this.props.tipEnabled) return null;
	      var activeTip = (0, _get3.default)(this.props, 'activeTip.value');
	      return activeTip ? activeTip.value : null;
	    }
	  }, {
	    key: 'getTipAmount',
	    value: function getTipAmount() {
	      if (!this.props.tipEnabled) return null;
	      return (0, _get3.default)(this.props, 'tipAmount');
	    }
	  }, {
	    key: 'getPaymentEnabled',
	    value: function getPaymentEnabled() {
	      if (!this.props.isFormValid) return false;
	      if (this.props.processing) return false;
	
	      var paymentEnabled = !(!this.props.timeWaitingList && !this.props.timeAvailable);
	
	      if (paymentEnabled && !this.state.analyticsFired) {
	        _BookingAnalytics2.default.fillPersonalInfo();
	        this.setState({ analyticsFired: true });
	      }
	
	      return paymentEnabled;
	    }
	  }, {
	    key: 'getPaymentProps',
	    value: function getPaymentProps() {
	      return {
	        barberId: this.props.barberId,
	        user: this.props.user,
	        tip: this.getTip(),
	        tipAmount: this.getTipAmount(),
	        bookNoPay: this.props.bookNoPay,
	        hasLoyaltyProgram: this.props.hasLoyaltyProgram,
	        hasPromotions: this.props.hasPromotions,
	        anyBarber: this.props.anyBarber,
	        promoCode: this.props.promoCode
	      };
	    }
	  }, {
	    key: 'createReservation',
	    value: function createReservation(props) {
	      var thirdPartyPromotions = [this.props.thirdPartyPromo.context];
	      var paymentProps = _extends({}, this.getPaymentProps(), props);
	
	      if (paymentProps.bookNoPay === true || paymentProps.isReservation === true && paymentProps.bookNoPay === false) {
	        thirdPartyPromotions = [];
	      }
	
	      // check for null status in array
	      if (thirdPartyPromotions.length > 0 && thirdPartyPromotions[0] === null) {
	        thirdPartyPromotions = [];
	      }
	
	      this.props.processPayment();
	      this.props.createReservation(_extends({
	        thirdPartyPromotions: thirdPartyPromotions
	      }, paymentProps));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          servicesNamesShort = _props.servicesNamesShort,
	          servicesNamesLong = _props.servicesNamesLong,
	          totalAmount = _props.totalAmount,
	          bookNoPay = _props.bookNoPay,
	          hasLoyaltyProgram = _props.hasLoyaltyProgram,
	          hasPromotions = _props.hasPromotions,
	          tipEnabled = _props.tipEnabled,
	          activeTip = _props.activeTip,
	          user = _props.user,
	          taxes = _props.taxes,
	          reservationTime = _props.reservationTime,
	          noAutofill = _props.noAutofill,
	          timeWaitingList = _props.timeWaitingList,
	          bookAndReserve = _props.bookAndReserve,
	          bookAndPayCopy = _props.bookAndPayCopy,
	          noExtrasForBookNoPay = _props.noExtrasForBookNoPay;
	
	
	      return _react2.default.createElement(_MakeReservation2.default, Object.assign({
	        handleReserveAndPay: this.handleReserveAndPay,
	        handleBookAndReserve: this.handleBookAndReserve,
	        handleReserve: this.handleReserve,
	        applePay: this.applePay,
	        addCustomerToWaitingList: this.addCustomerToWaitingList,
	        applePayAddCustomerToWaitingList: this.applePayAddCustomerToWaitingList,
	        showPromo: this.state.showPromo
	
	      }, {
	        servicesNamesShort: servicesNamesShort,
	        servicesNamesLong: servicesNamesLong,
	        totalAmount: totalAmount,
	        bookNoPay: bookNoPay,
	        hasLoyaltyProgram: hasLoyaltyProgram,
	        hasPromotions: hasPromotions,
	        tipEnabled: tipEnabled,
	        activeTip: activeTip,
	        userEmail: user.email,
	        paymentEnabled: this.getPaymentEnabled(),
	        taxes: taxes,
	        reservationTime: reservationTime,
	        noAutofill: noAutofill,
	        timeWaitingList: timeWaitingList,
	        bookAndReserve: bookAndReserve,
	        bookAndPayCopy: bookAndPayCopy,
	        noExtrasForBookNoPay: noExtrasForBookNoPay
	      }));
	    }
	  }]);
	
	  return MakeReservationContainer;
	}(_react.Component);
	
	MakeReservationContainer.propTypes = {
	  totalAmount: _propTypes2.default.number,
	  bookNoPay: _propTypes2.default.bool,
	  hasLoyaltyProgram: _propTypes2.default.bool,
	  hasPromotions: _propTypes2.default.bool,
	  fetchShop: _propTypes2.default.func.isRequired,
	  fetchBarbers: _propTypes2.default.func.isRequired,
	  fetchService: _propTypes2.default.func.isRequired,
	  tipEnabled: _propTypes2.default.bool,
	  activeTip: _shapes.tipShape,
	  createReservation: _propTypes2.default.func.isRequired,
	  applePay: _propTypes2.default.func.isRequired,
	  isFormValid: _propTypes2.default.bool.isRequired,
	  user: _propTypes2.default.shape({
	    firstName: _propTypes2.default.string,
	    lastName: _propTypes2.default.string,
	    email: _propTypes2.default.string,
	    phone: _propTypes2.default.string
	  }).isRequired,
	  resetFields: _propTypes2.default.func.isRequired,
	  resetPromo: _propTypes2.default.func.isRequired,
	  processPayment: _propTypes2.default.func.isRequired,
	  resetPaymentProcessing: _propTypes2.default.func.isRequired,
	  barberId: _propTypes2.default.string,
	  processing: _propTypes2.default.bool,
	  timeAvailable: _propTypes2.default.bool.isRequired,
	  taxes: _propTypes2.default.number,
	  anyBarber: _propTypes2.default.bool,
	  servicesNamesShort: _propTypes2.default.string,
	  servicesNamesLong: _propTypes2.default.string,
	  reservationTime: _propTypes2.default.string,
	  promoCode: _propTypes2.default.string,
	  resetFee: _propTypes2.default.func.isRequired,
	  resetTip: _propTypes2.default.func.isRequired,
	  noAutofill: _propTypes2.default.bool,
	  timeWaitingList: _propTypes2.default.bool.isRequired,
	  addCustomerToWaitingList: _propTypes2.default.func.isRequired,
	  applePayAddCustomerToWaitingList: _propTypes2.default.func.isRequired,
	  bookAndReserve: _propTypes2.default.bool,
	  bookAndPayCopy: _propTypes2.default.string,
	  noExtrasForBookNoPay: _propTypes2.default.bool.isRequired
	};
	
	MakeReservationContainer.defaultProps = {
	  barberId: '',
	  totalAmount: 0,
	  bookNoPay: false,
	  hasLoyaltyProgram: false,
	  hasPromotions: true,
	  tipEnabled: false,
	  activeTip: null,
	  processing: false,
	  anyBarber: false,
	  servicesNamesShort: '',
	  servicesNamesLong: '',
	  reservationTime: '',
	  promoCode: '',
	  taxes: 0,
	  noAutofill: false,
	  bookAndReserve: false,
	  bookAndPayCopy: ''
	};
	
	var addAdultsOnlyFieldIfEnabled = function addAdultsOnlyFieldIfEnabled(props) {
	  if (props.adultsOnly) props.addAdultsOnlyField(props.shopName);
	};
	
	var formProps = (0, _compose3.default)(_WithShopName2.default, _withCost2.default, _withKioskIsReserveOnly2.default, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    errorMessage: state.app.errorMessage,
	    fields: state.reservation.get('fields').toJS(),
	    isFormValid: (0, _selectors5.getIsFormValid)(state),
	    isFormPristine: (0, _selectors5.getIsFormPristine)(state),
	    user: (0, _selectors5.getUser)(state),
	    adultsOnly: (0, _selectors2.getAdultsOnly)(state, ownProps.params.shopRoute),
	    bookAndPayCopy: (0, _selectors5.getBookAndPayCopy)(state, ownProps.params.shopRoute, ownProps.params.barberRoute, ownProps.params.serviceId, ownProps.totalAmount, ownProps.isCoveredByDiscount, ownProps.isReserveNoPayOnly)
	  };
	}, {
	  resetFields: _actions.resetFields,
	  errorRedirect: _actions2.errorRedirect,
	  addAdultsOnlyField: _actions.addAdultsOnlyField
	}), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    addAdultsOnlyFieldIfEnabled(this.props);
	    this.props.resetPromo();
	    this.props.resetTip();
	  },
	  componentDidUpdate: function componentDidUpdate(nextProps) {
	    if (this.props.adultsOnly !== nextProps.adultsOnly) addAdultsOnlyFieldIfEnabled(this.props);
	  }
	}));
	
	var reservationTimeProps = (0, _reactRedux.connect)(function (state, ownProps) {
	  var timezone = (0, _selectors2.getShopTimezone)(state, ownProps.params.shopRoute);
	  return {
	    timeAvailable: state.reservation.get('timeAvailable'),
	    reservationTime: (0, _helpers.formatReservationTime)(ownProps.params.reservationTime, timezone),
	    barberId: (0, _selectors3.getBarberId)(state, ownProps.params.barberRoute),
	    shopId: (0, _selectors2.getShopId)(state, ownProps.params.shopRoute),
	    hasWaitingList: (0, _selectors2.getHasWaitingListEnabled)(state, ownProps.params.shopRoute),
	    timezone: timezone
	  };
	});
	
	var paymentProps = (0, _reactRedux.connect)(function (state, ownProps) {
	  var isServicePrepayRequired = !(0, _selectors.getSelectedServicesPrepaid)(state, ownProps.params.serviceId);
	  return {
	    barberId: (0, _selectors3.getBarberId)(state, ownProps.params.barberRoute),
	    shopId: (0, _selectors2.getShopId)(state, ownProps.params.shopRoute),
	    shopName: (0, _selectors2.getShopName)(state, ownProps.params.shopRoute),
	    bookNoPay: (0, _selectors3.getBarberBookNoPay)(state, ownProps.params.barberRoute) && !isServicePrepayRequired,
	    hasLoyaltyProgram: (0, _selectors3.getHasBarberLoyaltyProgram)(state, ownProps.params.barberRoute) || (0, _selectors2.getHasShopLoyaltyProgram)(state, ownProps.params.shopRoute),
	    hasPromotions: (0, _selectors2.getHasPromotionsEnabled)(state, ownProps.params.shopRoute),
	    processing: (0, _selectors5.getPaymentProcessing)(state),
	    anyBarber: !!(0, _get3.default)(ownProps, 'location.query.anyBarber'),
	    promoCode: state.reservation.getIn(['promo', 'promoCode']),
	    bookAndReserve: (0, _selectors2.getShopAllowBookAndReserve)(state, ownProps.params.shopRoute) && !isServicePrepayRequired,
	    noExtrasForBookNoPay: (0, _selectors2.getNoExtrasForReserveNoPay)(state, ownProps.params.shopRoute),
	    thirdPartyPromo: (0, _selectors4.getThirdPartyPromotion)(state)
	  };
	}, function (dispatch, ownProps) {
	  return (0, _redux.bindActionCreators)({
	    fetchShop: _actions5.fetchShop.bind(null, ownProps.params.shopRoute, ownProps.urlPattern),
	    fetchBarbers: _actions3.fetchBarbers.bind(null, ownProps.params.shopRoute, ownProps.params, ownProps.urlPattern),
	    fetchService: _actions4.fetchSelectedServices.bind(null, ownProps.params.shopRoute, ownProps.params.barberRoute, ownProps.params.serviceId, ownProps.params, ownProps.urlPattern),
	    createReservation: function createReservation(params) {
	      return (0, _actions.createReservation)(_extends({
	        redirectUrl: (ownProps.baseUrl || '') + '/view-reservation',
	        serviceIds: ownProps.params.serviceId,
	        reservationTime: ownProps.params.reservationTime,
	        kiosk: ownProps.kiosk
	      }, params));
	    },
	    applePay: function applePay(params) {
	      return (0, _actions.applePay)(_extends({
	        redirectUrl: (ownProps.baseUrl || '') + '/view-reservation',
	        serviceIds: ownProps.params.serviceId,
	        reservationTime: ownProps.params.reservationTime,
	        currency: ownProps.currency
	      }, params));
	    },
	    addCustomerToWaitingList: _actions.addCustomerToWaitingList,
	    applePayAddCustomerToWaitingList: _actions.applePayAddCustomerToWaitingList,
	    processPayment: _actions.processPayment,
	    resetPaymentProcessing: _actions.resetPaymentProcessing,
	    resetPromo: _actions.resetPromo,
	    resetFee: _actions.resetFee,
	    resetTip: _actions.resetTip
	  }, dispatch);
	}, function (stateProps, dispatchProps, ownProps) {
	  var props = _extends({}, ownProps, stateProps, dispatchProps);
	  props.addCustomerToWaitingList = function (params) {
	    return dispatchProps.addCustomerToWaitingList(_extends({
	      shopId: props.shopId,
	      barberId: props.barberId === _constants.ANY_BARBER ? undefined : props.barberId,
	      serviceIds: (0, _split3.default)(ownProps.params.serviceId, ';'),
	      day: (0, _get3.default)(props, 'location.query.date', ''),
	      redirectUrl: '/waiting-list'
	    }, params));
	  };
	
	  props.applePayAddCustomerToWaitingList = function (user, tipAmount, params) {
	    return dispatchProps.applePayAddCustomerToWaitingList(props.costWithTaxes, props.currency, _extends({}, params, {
	      shopId: props.shopId,
	      barberId: props.barberId === _constants.ANY_BARBER ? undefined : props.barberId,
	      serviceIds: (0, _split3.default)(ownProps.params.serviceId, ';'),
	      day: (0, _get3.default)(props, 'location.query.date', ''),
	      redirectUrl: '/waiting-list',
	      user: user,
	      tipAmount: tipAmount
	    }));
	  };
	  return props;
	});
	
	exports.default = (0, _compose3.default)(_withCost2.default, _WithKioskProp2.default, _WithTimeWaitingList2.default, _WithShopCurrency2.default, _reactRouter.withRouter, paymentProps, formProps, reservationTimeProps, (0, _withHandlers3.default)({
	  onUnload: function onUnload(props) {
	    return function () {
	      return (0, _actions.removeReservedTime)(props.barberId);
	    };
	  }
	}), _OnUnload2.default)(MakeReservationContainer);

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getWaitingListTimesTimes = exports.getWaitingListTimesDay = exports.getWaitingListTimesTimezone = exports.getWaitingListTimeShopLocation = exports.getWaitingListTimesShopZip = exports.getWaitingListTimesShopAddress = exports.getWaitingListTimesShopName = exports.getWaitingListTimesShop = exports.getWaitingListTimesServiceDuration = exports.getWaitingListTimesServiceName = exports.getWaitingListTimesBarberName = exports.getWaitingListInfoNumberInLine = exports.getWaitingListInfoServiceIds = exports.getWaitingListInfoBarberId = exports.getWaitingListInfoShopId = undefined;
	
	var _get = __webpack_require__(176);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _flow = __webpack_require__(231);
	
	var _flow2 = _interopRequireDefault(_flow);
	
	var _map = __webpack_require__(232);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _join = __webpack_require__(579);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _sumBy = __webpack_require__(1482);
	
	var _sumBy2 = _interopRequireDefault(_sumBy);
	
	var _zipObject = __webpack_require__(1484);
	
	var _zipObject2 = _interopRequireDefault(_zipObject);
	
	var _isEmpty = __webpack_require__(578);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _momentTimezone = __webpack_require__(67);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getWaitingListInfoProp = function getWaitingListInfoProp(propName) {
	  return (0, _get2.default)(['waitingList', 'waitingListInfo', propName]);
	};
	
	var getWaitingListInfoShopId = exports.getWaitingListInfoShopId = getWaitingListInfoProp('shopId');
	var getWaitingListInfoBarberId = exports.getWaitingListInfoBarberId = getWaitingListInfoProp('barberId');
	var getWaitingListInfoServiceIds = exports.getWaitingListInfoServiceIds = getWaitingListInfoProp('serviceIds');
	var getWaitingListInfoNumberInLine = exports.getWaitingListInfoNumberInLine = getWaitingListInfoProp('numberInLine');
	
	var getWaitingListTimesProp = function getWaitingListTimesProp(propName) {
	  return (0, _get2.default)(['waitingList', 'waitingListTimes', propName]);
	};
	
	var getWaitingListTimesBarberName = exports.getWaitingListTimesBarberName = (0, _flow2.default)(getWaitingListInfoProp('barber'), _helpers.getPersonName);
	
	var getWaitingListTimesServiceName = exports.getWaitingListTimesServiceName = (0, _flow2.default)(getWaitingListTimesProp('services'), (0, _map2.default)('name'), (0, _join2.default)(', '));
	
	var getWaitingListTimesServiceDuration = exports.getWaitingListTimesServiceDuration = (0, _flow2.default)(getWaitingListTimesProp('services'), (0, _sumBy2.default)('duration'));
	
	var getWaitingListTimesShop = exports.getWaitingListTimesShop = (0, _flow2.default)(getWaitingListTimesProp('shop'), function (shop) {
	  return !(0, _isEmpty2.default)(shop) && (0, _helpers.transformShopAddress)(shop);
	});
	
	var getWaitingListTimesShopName = exports.getWaitingListTimesShopName = (0, _flow2.default)(getWaitingListTimesShop, (0, _get2.default)('name'));
	
	var getWaitingListTimesShopAddress = exports.getWaitingListTimesShopAddress = (0, _flow2.default)(getWaitingListTimesShop, (0, _get2.default)('address'));
	
	var getWaitingListTimesShopZip = exports.getWaitingListTimesShopZip = (0, _flow2.default)(getWaitingListTimesShop, (0, _get2.default)('zip'));
	
	var getWaitingListTimeShopLocation = exports.getWaitingListTimeShopLocation = (0, _flow2.default)(getWaitingListTimesShop, (0, _get2.default)('location.coordinates'), (0, _zipObject2.default)(['lat', 'lng']));
	
	var getWaitingListTimesTimezone = exports.getWaitingListTimesTimezone = (0, _flow2.default)(getWaitingListTimesShop, (0, _get2.default)('timezone'));
	
	var getWaitingListTimesDay = exports.getWaitingListTimesDay = function getWaitingListTimesDay(state) {
	  return (0, _flow2.default)(getWaitingListTimesProp('day'), function (day) {
	    return _momentTimezone2.default.tz(day, getWaitingListTimesTimezone(state)).format(_config2.default.dateFormat);
	  })(state);
	};
	
	var getWaitingListTimesTimes = exports.getWaitingListTimesTimes = getWaitingListTimesProp('times');

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	/* globals window, HTMLElement */
	
	'use strict';
	
	/**!
	 * is
	 * the definitive JavaScript type testing library
	 *
	 * @copyright 2013-2014 Enrico Marino / Jordan Harband
	 * @license MIT
	 */
	
	var objProto = Object.prototype;
	var owns = objProto.hasOwnProperty;
	var toStr = objProto.toString;
	var symbolValueOf;
	if (typeof Symbol === 'function') {
	  symbolValueOf = Symbol.prototype.valueOf;
	}
	var bigIntValueOf;
	if (typeof BigInt === 'function') {
	  bigIntValueOf = BigInt.prototype.valueOf;
	}
	var isActualNaN = function (value) {
	  return value !== value;
	};
	var NON_HOST_TYPES = {
	  'boolean': 1,
	  number: 1,
	  string: 1,
	  undefined: 1
	};
	
	var base64Regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/;
	var hexRegex = /^[A-Fa-f0-9]+$/;
	
	/**
	 * Expose `is`
	 */
	
	var is = {};
	
	/**
	 * Test general.
	 */
	
	/**
	 * is.type
	 * Test if `value` is a type of `type`.
	 *
	 * @param {*} value value to test
	 * @param {String} type type
	 * @return {Boolean} true if `value` is a type of `type`, false otherwise
	 * @api public
	 */
	
	is.a = is.type = function (value, type) {
	  return typeof value === type;
	};
	
	/**
	 * is.defined
	 * Test if `value` is defined.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if 'value' is defined, false otherwise
	 * @api public
	 */
	
	is.defined = function (value) {
	  return typeof value !== 'undefined';
	};
	
	/**
	 * is.empty
	 * Test if `value` is empty.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is empty, false otherwise
	 * @api public
	 */
	
	is.empty = function (value) {
	  var type = toStr.call(value);
	  var key;
	
	  if (type === '[object Array]' || type === '[object Arguments]' || type === '[object String]') {
	    return value.length === 0;
	  }
	
	  if (type === '[object Object]') {
	    for (key in value) {
	      if (owns.call(value, key)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  return !value;
	};
	
	/**
	 * is.equal
	 * Test if `value` is equal to `other`.
	 *
	 * @param {*} value value to test
	 * @param {*} other value to compare with
	 * @return {Boolean} true if `value` is equal to `other`, false otherwise
	 */
	
	is.equal = function equal(value, other) {
	  if (value === other) {
	    return true;
	  }
	
	  var type = toStr.call(value);
	  var key;
	
	  if (type !== toStr.call(other)) {
	    return false;
	  }
	
	  if (type === '[object Object]') {
	    for (key in value) {
	      if (!is.equal(value[key], other[key]) || !(key in other)) {
	        return false;
	      }
	    }
	    for (key in other) {
	      if (!is.equal(value[key], other[key]) || !(key in value)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  if (type === '[object Array]') {
	    key = value.length;
	    if (key !== other.length) {
	      return false;
	    }
	    while (key--) {
	      if (!is.equal(value[key], other[key])) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  if (type === '[object Function]') {
	    return value.prototype === other.prototype;
	  }
	
	  if (type === '[object Date]') {
	    return value.getTime() === other.getTime();
	  }
	
	  return false;
	};
	
	/**
	 * is.hosted
	 * Test if `value` is hosted by `host`.
	 *
	 * @param {*} value to test
	 * @param {*} host host to test with
	 * @return {Boolean} true if `value` is hosted by `host`, false otherwise
	 * @api public
	 */
	
	is.hosted = function (value, host) {
	  var type = typeof host[value];
	  return type === 'object' ? !!host[value] : !NON_HOST_TYPES[type];
	};
	
	/**
	 * is.instance
	 * Test if `value` is an instance of `constructor`.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an instance of `constructor`
	 * @api public
	 */
	
	is.instance = is['instanceof'] = function (value, constructor) {
	  return value instanceof constructor;
	};
	
	/**
	 * is.nil / is.null
	 * Test if `value` is null.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is null, false otherwise
	 * @api public
	 */
	
	is.nil = is['null'] = function (value) {
	  return value === null;
	};
	
	/**
	 * is.undef / is.undefined
	 * Test if `value` is undefined.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is undefined, false otherwise
	 * @api public
	 */
	
	is.undef = is.undefined = function (value) {
	  return typeof value === 'undefined';
	};
	
	/**
	 * Test arguments.
	 */
	
	/**
	 * is.args
	 * Test if `value` is an arguments object.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an arguments object, false otherwise
	 * @api public
	 */
	
	is.args = is.arguments = function (value) {
	  var isStandardArguments = toStr.call(value) === '[object Arguments]';
	  var isOldArguments = !is.array(value) && is.arraylike(value) && is.object(value) && is.fn(value.callee);
	  return isStandardArguments || isOldArguments;
	};
	
	/**
	 * Test array.
	 */
	
	/**
	 * is.array
	 * Test if 'value' is an array.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an array, false otherwise
	 * @api public
	 */
	
	is.array = Array.isArray || function (value) {
	  return toStr.call(value) === '[object Array]';
	};
	
	/**
	 * is.arguments.empty
	 * Test if `value` is an empty arguments object.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an empty arguments object, false otherwise
	 * @api public
	 */
	is.args.empty = function (value) {
	  return is.args(value) && value.length === 0;
	};
	
	/**
	 * is.array.empty
	 * Test if `value` is an empty array.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an empty array, false otherwise
	 * @api public
	 */
	is.array.empty = function (value) {
	  return is.array(value) && value.length === 0;
	};
	
	/**
	 * is.arraylike
	 * Test if `value` is an arraylike object.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an arguments object, false otherwise
	 * @api public
	 */
	
	is.arraylike = function (value) {
	  return !!value && !is.bool(value)
	    && owns.call(value, 'length')
	    && isFinite(value.length)
	    && is.number(value.length)
	    && value.length >= 0;
	};
	
	/**
	 * Test boolean.
	 */
	
	/**
	 * is.bool
	 * Test if `value` is a boolean.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a boolean, false otherwise
	 * @api public
	 */
	
	is.bool = is['boolean'] = function (value) {
	  return toStr.call(value) === '[object Boolean]';
	};
	
	/**
	 * is.false
	 * Test if `value` is false.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is false, false otherwise
	 * @api public
	 */
	
	is['false'] = function (value) {
	  return is.bool(value) && Boolean(Number(value)) === false;
	};
	
	/**
	 * is.true
	 * Test if `value` is true.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is true, false otherwise
	 * @api public
	 */
	
	is['true'] = function (value) {
	  return is.bool(value) && Boolean(Number(value)) === true;
	};
	
	/**
	 * Test date.
	 */
	
	/**
	 * is.date
	 * Test if `value` is a date.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a date, false otherwise
	 * @api public
	 */
	
	is.date = function (value) {
	  return toStr.call(value) === '[object Date]';
	};
	
	/**
	 * is.date.valid
	 * Test if `value` is a valid date.
	 *
	 * @param {*} value value to test
	 * @returns {Boolean} true if `value` is a valid date, false otherwise
	 */
	is.date.valid = function (value) {
	  return is.date(value) && !isNaN(Number(value));
	};
	
	/**
	 * Test element.
	 */
	
	/**
	 * is.element
	 * Test if `value` is an html element.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an HTML Element, false otherwise
	 * @api public
	 */
	
	is.element = function (value) {
	  return value !== undefined
	    && typeof HTMLElement !== 'undefined'
	    && value instanceof HTMLElement
	    && value.nodeType === 1;
	};
	
	/**
	 * Test error.
	 */
	
	/**
	 * is.error
	 * Test if `value` is an error object.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an error object, false otherwise
	 * @api public
	 */
	
	is.error = function (value) {
	  return toStr.call(value) === '[object Error]';
	};
	
	/**
	 * Test function.
	 */
	
	/**
	 * is.fn / is.function (deprecated)
	 * Test if `value` is a function.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a function, false otherwise
	 * @api public
	 */
	
	is.fn = is['function'] = function (value) {
	  var isAlert = typeof window !== 'undefined' && value === window.alert;
	  if (isAlert) {
	    return true;
	  }
	  var str = toStr.call(value);
	  return str === '[object Function]' || str === '[object GeneratorFunction]' || str === '[object AsyncFunction]';
	};
	
	/**
	 * Test number.
	 */
	
	/**
	 * is.number
	 * Test if `value` is a number.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a number, false otherwise
	 * @api public
	 */
	
	is.number = function (value) {
	  return toStr.call(value) === '[object Number]';
	};
	
	/**
	 * is.infinite
	 * Test if `value` is positive or negative infinity.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is positive or negative Infinity, false otherwise
	 * @api public
	 */
	is.infinite = function (value) {
	  return value === Infinity || value === -Infinity;
	};
	
	/**
	 * is.decimal
	 * Test if `value` is a decimal number.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a decimal number, false otherwise
	 * @api public
	 */
	
	is.decimal = function (value) {
	  return is.number(value) && !isActualNaN(value) && !is.infinite(value) && value % 1 !== 0;
	};
	
	/**
	 * is.divisibleBy
	 * Test if `value` is divisible by `n`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} n dividend
	 * @return {Boolean} true if `value` is divisible by `n`, false otherwise
	 * @api public
	 */
	
	is.divisibleBy = function (value, n) {
	  var isDividendInfinite = is.infinite(value);
	  var isDivisorInfinite = is.infinite(n);
	  var isNonZeroNumber = is.number(value) && !isActualNaN(value) && is.number(n) && !isActualNaN(n) && n !== 0;
	  return isDividendInfinite || isDivisorInfinite || (isNonZeroNumber && value % n === 0);
	};
	
	/**
	 * is.integer
	 * Test if `value` is an integer.
	 *
	 * @param value to test
	 * @return {Boolean} true if `value` is an integer, false otherwise
	 * @api public
	 */
	
	is.integer = is['int'] = function (value) {
	  return is.number(value) && !isActualNaN(value) && value % 1 === 0;
	};
	
	/**
	 * is.maximum
	 * Test if `value` is greater than 'others' values.
	 *
	 * @param {Number} value value to test
	 * @param {Array} others values to compare with
	 * @return {Boolean} true if `value` is greater than `others` values
	 * @api public
	 */
	
	is.maximum = function (value, others) {
	  if (isActualNaN(value)) {
	    throw new TypeError('NaN is not a valid value');
	  } else if (!is.arraylike(others)) {
	    throw new TypeError('second argument must be array-like');
	  }
	  var len = others.length;
	
	  while (--len >= 0) {
	    if (value < others[len]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	/**
	 * is.minimum
	 * Test if `value` is less than `others` values.
	 *
	 * @param {Number} value value to test
	 * @param {Array} others values to compare with
	 * @return {Boolean} true if `value` is less than `others` values
	 * @api public
	 */
	
	is.minimum = function (value, others) {
	  if (isActualNaN(value)) {
	    throw new TypeError('NaN is not a valid value');
	  } else if (!is.arraylike(others)) {
	    throw new TypeError('second argument must be array-like');
	  }
	  var len = others.length;
	
	  while (--len >= 0) {
	    if (value > others[len]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	/**
	 * is.nan
	 * Test if `value` is not a number.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is not a number, false otherwise
	 * @api public
	 */
	
	is.nan = function (value) {
	  return !is.number(value) || value !== value;
	};
	
	/**
	 * is.even
	 * Test if `value` is an even number.
	 *
	 * @param {Number} value value to test
	 * @return {Boolean} true if `value` is an even number, false otherwise
	 * @api public
	 */
	
	is.even = function (value) {
	  return is.infinite(value) || (is.number(value) && value === value && value % 2 === 0);
	};
	
	/**
	 * is.odd
	 * Test if `value` is an odd number.
	 *
	 * @param {Number} value value to test
	 * @return {Boolean} true if `value` is an odd number, false otherwise
	 * @api public
	 */
	
	is.odd = function (value) {
	  return is.infinite(value) || (is.number(value) && value === value && value % 2 !== 0);
	};
	
	/**
	 * is.ge
	 * Test if `value` is greater than or equal to `other`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} other value to compare with
	 * @return {Boolean}
	 * @api public
	 */
	
	is.ge = function (value, other) {
	  if (isActualNaN(value) || isActualNaN(other)) {
	    throw new TypeError('NaN is not a valid value');
	  }
	  return !is.infinite(value) && !is.infinite(other) && value >= other;
	};
	
	/**
	 * is.gt
	 * Test if `value` is greater than `other`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} other value to compare with
	 * @return {Boolean}
	 * @api public
	 */
	
	is.gt = function (value, other) {
	  if (isActualNaN(value) || isActualNaN(other)) {
	    throw new TypeError('NaN is not a valid value');
	  }
	  return !is.infinite(value) && !is.infinite(other) && value > other;
	};
	
	/**
	 * is.le
	 * Test if `value` is less than or equal to `other`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} other value to compare with
	 * @return {Boolean} if 'value' is less than or equal to 'other'
	 * @api public
	 */
	
	is.le = function (value, other) {
	  if (isActualNaN(value) || isActualNaN(other)) {
	    throw new TypeError('NaN is not a valid value');
	  }
	  return !is.infinite(value) && !is.infinite(other) && value <= other;
	};
	
	/**
	 * is.lt
	 * Test if `value` is less than `other`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} other value to compare with
	 * @return {Boolean} if `value` is less than `other`
	 * @api public
	 */
	
	is.lt = function (value, other) {
	  if (isActualNaN(value) || isActualNaN(other)) {
	    throw new TypeError('NaN is not a valid value');
	  }
	  return !is.infinite(value) && !is.infinite(other) && value < other;
	};
	
	/**
	 * is.within
	 * Test if `value` is within `start` and `finish`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} start lower bound
	 * @param {Number} finish upper bound
	 * @return {Boolean} true if 'value' is is within 'start' and 'finish'
	 * @api public
	 */
	is.within = function (value, start, finish) {
	  if (isActualNaN(value) || isActualNaN(start) || isActualNaN(finish)) {
	    throw new TypeError('NaN is not a valid value');
	  } else if (!is.number(value) || !is.number(start) || !is.number(finish)) {
	    throw new TypeError('all arguments must be numbers');
	  }
	  var isAnyInfinite = is.infinite(value) || is.infinite(start) || is.infinite(finish);
	  return isAnyInfinite || (value >= start && value <= finish);
	};
	
	/**
	 * Test object.
	 */
	
	/**
	 * is.object
	 * Test if `value` is an object.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an object, false otherwise
	 * @api public
	 */
	is.object = function (value) {
	  return toStr.call(value) === '[object Object]';
	};
	
	/**
	 * is.primitive
	 * Test if `value` is a primitive.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a primitive, false otherwise
	 * @api public
	 */
	is.primitive = function isPrimitive(value) {
	  if (!value) {
	    return true;
	  }
	  if (typeof value === 'object' || is.object(value) || is.fn(value) || is.array(value)) {
	    return false;
	  }
	  return true;
	};
	
	/**
	 * is.hash
	 * Test if `value` is a hash - a plain object literal.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a hash, false otherwise
	 * @api public
	 */
	
	is.hash = function (value) {
	  return is.object(value) && value.constructor === Object && !value.nodeType && !value.setInterval;
	};
	
	/**
	 * Test regexp.
	 */
	
	/**
	 * is.regexp
	 * Test if `value` is a regular expression.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a regexp, false otherwise
	 * @api public
	 */
	
	is.regexp = function (value) {
	  return toStr.call(value) === '[object RegExp]';
	};
	
	/**
	 * Test string.
	 */
	
	/**
	 * is.string
	 * Test if `value` is a string.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if 'value' is a string, false otherwise
	 * @api public
	 */
	
	is.string = function (value) {
	  return toStr.call(value) === '[object String]';
	};
	
	/**
	 * Test base64 string.
	 */
	
	/**
	 * is.base64
	 * Test if `value` is a valid base64 encoded string.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if 'value' is a base64 encoded string, false otherwise
	 * @api public
	 */
	
	is.base64 = function (value) {
	  return is.string(value) && (!value.length || base64Regex.test(value));
	};
	
	/**
	 * Test base64 string.
	 */
	
	/**
	 * is.hex
	 * Test if `value` is a valid hex encoded string.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if 'value' is a hex encoded string, false otherwise
	 * @api public
	 */
	
	is.hex = function (value) {
	  return is.string(value) && (!value.length || hexRegex.test(value));
	};
	
	/**
	 * is.symbol
	 * Test if `value` is an ES6 Symbol
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a Symbol, false otherise
	 * @api public
	 */
	
	is.symbol = function (value) {
	  return typeof Symbol === 'function' && toStr.call(value) === '[object Symbol]' && typeof symbolValueOf.call(value) === 'symbol';
	};
	
	/**
	 * is.bigint
	 * Test if `value` is an ES-proposed BigInt
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a BigInt, false otherise
	 * @api public
	 */
	
	is.bigint = function (value) {
	  // eslint-disable-next-line valid-typeof
	  return typeof BigInt === 'function' && toStr.call(value) === '[object BigInt]' && typeof bigIntValueOf.call(value) === 'bigint';
	};
	
	module.exports = is;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VALID_PHONE_NUMBER_WITH_EXTENSION = exports.VALID_PHONE_NUMBER = void 0;
	exports["default"] = isViablePhoneNumber;
	exports.isViablePhoneNumberStart = isViablePhoneNumberStart;
	
	var _constants = __webpack_require__(72);
	
	var _createExtensionPattern = _interopRequireDefault(__webpack_require__(209));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	//  Regular expression of viable phone numbers. This is location independent.
	//  Checks we have at least three leading digits, and only valid punctuation,
	//  alpha characters and digits in the phone number. Does not include extension
	//  data. The symbol 'x' is allowed here as valid punctuation since it is often
	//  used as a placeholder for carrier codes, for example in Brazilian phone
	//  numbers. We also allow multiple '+' characters at the start.
	//
	//  Corresponds to the following:
	//  [digits]{minLengthNsn}|
	//  plus_sign*
	//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
	//
	//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
	//  they are entered as "15" etc, but only if there is no punctuation in them.
	//  The second expression restricts the number of digits to three or more, but
	//  then allows them to be in international form, and to have alpha-characters
	//  and punctuation. We split up the two reg-exes here and combine them when
	//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
	//  with ^ and append $ to each branch.
	//
	//  "Note VALID_PUNCTUATION starts with a -,
	//   so must be the first in the range" (c) Google devs.
	//  (wtf did they mean by saying that; probably nothing)
	//
	var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + _constants.VALID_DIGITS + ']{' + _constants.MIN_LENGTH_FOR_NSN + '}'; //
	// And this is the second reg-exp:
	// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
	//
	
	var VALID_PHONE_NUMBER = '[' + _constants.PLUS_CHARS + ']{0,1}' + '(?:' + '[' + _constants.VALID_PUNCTUATION + ']*' + '[' + _constants.VALID_DIGITS + ']' + '){3,}' + '[' + _constants.VALID_PUNCTUATION + _constants.VALID_DIGITS + ']*'; // This regular expression isn't present in Google's `libphonenumber`
	// and is only used to determine whether the phone number being input
	// is too short for it to even consider it a "valid" number.
	// This is just a way to differentiate between a really invalid phone
	// number like "abcde" and a valid phone number that a user has just
	// started inputting, like "+1" or "1": both these cases would be
	// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
	// library can provide a more detailed error message — whether it's
	// really "not a number", or is it just a start of a valid phone number.
	
	exports.VALID_PHONE_NUMBER = VALID_PHONE_NUMBER;
	var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp('^' + '[' + _constants.PLUS_CHARS + ']{0,1}' + '(?:' + '[' + _constants.VALID_PUNCTUATION + ']*' + '[' + _constants.VALID_DIGITS + ']' + '){1,2}' + '$', 'i');
	var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
	'(?:' + (0, _createExtensionPattern["default"])() + ')?'; // The combined regular expression for valid phone numbers:
	//
	
	exports.VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER_WITH_EXTENSION;
	var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
	'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
	'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
	// all. At the moment, checks to see that the string begins with at least 2
	// digits, ignoring any punctuation commonly found in phone numbers. This method
	// does not require the number to be normalized in advance - but does assume
	// that leading non-number symbols have been removed, such as by the method
	// `extract_possible_number`.
	//
	
	function isViablePhoneNumber(number) {
	  return number.length >= _constants.MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
	} // This is just a way to differentiate between a really invalid phone
	// number like "abcde" and a valid phone number that a user has just
	// started inputting, like "+1" or "1": both these cases would be
	// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
	// library can provide a more detailed error message — whether it's
	// really "not a number", or is it just a start of a valid phone number.
	
	
	function isViablePhoneNumberStart(number) {
	  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
	}
	//# sourceMappingURL=isViablePhoneNumber.js.map

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(52);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	module.exports = baseCreate;


/***/ }),
/* 171 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 172 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ }),
/* 174 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(531),
	    baseFilter = __webpack_require__(538),
	    baseIteratee = __webpack_require__(44),
	    isArray = __webpack_require__(28);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(61),
	    func = convert('get', __webpack_require__(18));
	
	func.placeholder = __webpack_require__(56);
	module.exports = func;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(233);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	module.exports = isArguments;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(52);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(101),
	    baseFlatten = __webpack_require__(102),
	    basePick = __webpack_require__(547),
	    baseRest = __webpack_require__(73),
	    toKey = __webpack_require__(123);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = baseRest(function(object, props) {
	  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
	});
	
	module.exports = pick;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(534),
	    baseIteratee = __webpack_require__(44),
	    baseSome = __webpack_require__(1388),
	    isArray = __webpack_require__(28),
	    isIterateeCall = __webpack_require__(143);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ }),
/* 182 */
/***/ (function(module, exports) {

	
	var identity = function(_){ return _; };
	
	
	/**
	 * Module exports, export
	 */
	
	module.exports = multiple(find);
	module.exports.find = module.exports;
	
	
	/**
	 * Export the replacement function, return the modified object
	 */
	
	module.exports.replace = function (obj, key, val, options) {
	  multiple(replace).call(this, obj, key, val, options);
	  return obj;
	};
	
	
	/**
	 * Export the delete function, return the modified object
	 */
	
	module.exports.del = function (obj, key, options) {
	  multiple(del).call(this, obj, key, null, options);
	  return obj;
	};
	
	
	/**
	 * Compose applying the function to a nested key
	 */
	
	function multiple (fn) {
	  return function (obj, path, val, options) {
	    normalize = options && isFunction(options.normalizer) ? options.normalizer : defaultNormalize;
	    path = normalize(path);
	
	    var key;
	    var finished = false;
	
	    while (!finished) loop();
	
	    function loop() {
	      for (key in obj) {
	        var normalizedKey = normalize(key);
	        if (0 === path.indexOf(normalizedKey)) {
	          var temp = path.substr(normalizedKey.length);
	          if (temp.charAt(0) === '.' || temp.length === 0) {
	            path = temp.substr(1);
	            var child = obj[key];
	
	            // we're at the end and there is nothing.
	            if (null == child) {
	              finished = true;
	              return;
	            }
	
	            // we're at the end and there is something.
	            if (!path.length) {
	              finished = true;
	              return;
	            }
	
	            // step into child
	            obj = child;
	
	            // but we're done here
	            return;
	          }
	        }
	      }
	
	      key = undefined;
	      // if we found no matching properties
	      // on the current object, there's no match.
	      finished = true;
	    }
	
	    if (!key) return;
	    if (null == obj) return obj;
	
	    // the `obj` and `key` is one above the leaf object and key, so
	    // start object: { a: { 'b.c': 10 } }
	    // end object: { 'b.c': 10 }
	    // end key: 'b.c'
	    // this way, you can do `obj[key]` and get `10`.
	    return fn(obj, key, val);
	  };
	}
	
	
	/**
	 * Find an object by its key
	 *
	 * find({ first_name : 'Calvin' }, 'firstName')
	 */
	
	function find (obj, key) {
	  if (obj.hasOwnProperty(key)) return obj[key];
	}
	
	
	/**
	 * Delete a value for a given key
	 *
	 * del({ a : 'b', x : 'y' }, 'X' }) -> { a : 'b' }
	 */
	
	function del (obj, key) {
	  if (obj.hasOwnProperty(key)) delete obj[key];
	  return obj;
	}
	
	
	/**
	 * Replace an objects existing value with a new one
	 *
	 * replace({ a : 'b' }, 'a', 'c') -> { a : 'c' }
	 */
	
	function replace (obj, key, val) {
	  if (obj.hasOwnProperty(key)) obj[key] = val;
	  return obj;
	}
	
	/**
	 * Normalize a `dot.separated.path`.
	 *
	 * A.HELL(!*&#(!)O_WOR   LD.bar => ahelloworldbar
	 *
	 * @param {String} path
	 * @return {String}
	 */
	
	function defaultNormalize(path) {
	  return path.replace(/[^a-zA-Z0-9\.]+/g, '').toLowerCase();
	}
	
	/**
	 * Check if a value is a function.
	 *
	 * @param {*} val
	 * @return {boolean} Returns `true` if `val` is a function, otherwise `false`.
	 */
	
	function isFunction(val) {
	  return typeof val === 'function';
	}


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArray = /*#__PURE__*/__webpack_require__(184);
	
	var _isTransformer = /*#__PURE__*/__webpack_require__(1562);
	
	/**
	 * Returns a function that dispatches with different strategies based on the
	 * object in list position (last argument). If it is an array, executes [fn].
	 * Otherwise, if it has a function with one of the given method names, it will
	 * execute that function (functor case). Otherwise, if it is a transformer,
	 * uses transducer [xf] to return a new transformer (transducer case).
	 * Otherwise, it will default to executing [fn].
	 *
	 * @private
	 * @param {Array} methodNames properties to check for a custom implementation
	 * @param {Function} xf transducer to initialize if object is transformer
	 * @param {Function} fn default ramda implementation
	 * @return {Function} A function that dispatches on object in list position
	 */
	
	
	function _dispatchable(methodNames, xf, fn) {
	  return function () {
	    if (arguments.length === 0) {
	      return fn();
	    }
	    var args = Array.prototype.slice.call(arguments, 0);
	    var obj = args.pop();
	    if (!_isArray(obj)) {
	      var idx = 0;
	      while (idx < methodNames.length) {
	        if (typeof obj[methodNames[idx]] === 'function') {
	          return obj[methodNames[idx]].apply(obj, args);
	        }
	        idx += 1;
	      }
	      if (_isTransformer(obj)) {
	        var transducer = xf.apply(null, args);
	        return transducer(obj);
	      }
	    }
	    return fn.apply(this, arguments);
	  };
	}
	module.exports = _dispatchable;

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	/**
	 * Tests whether or not an object is an array.
	 *
	 * @private
	 * @param {*} val The object to test.
	 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
	 * @example
	 *
	 *      _isArray([]); //=> true
	 *      _isArray(null); //=> false
	 *      _isArray({}); //=> false
	 */
	module.exports = Array.isArray || function _isArray(val) {
	  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
	};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArrayLike = /*#__PURE__*/__webpack_require__(1560);
	
	var _xwrap = /*#__PURE__*/__webpack_require__(1570);
	
	var bind = /*#__PURE__*/__webpack_require__(1546);
	
	function _arrayReduce(xf, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    acc = xf['@@transducer/step'](acc, list[idx]);
	    if (acc && acc['@@transducer/reduced']) {
	      acc = acc['@@transducer/value'];
	      break;
	    }
	    idx += 1;
	  }
	  return xf['@@transducer/result'](acc);
	}
	
	function _iterableReduce(xf, acc, iter) {
	  var step = iter.next();
	  while (!step.done) {
	    acc = xf['@@transducer/step'](acc, step.value);
	    if (acc && acc['@@transducer/reduced']) {
	      acc = acc['@@transducer/value'];
	      break;
	    }
	    step = iter.next();
	  }
	  return xf['@@transducer/result'](acc);
	}
	
	function _methodReduce(xf, acc, obj, methodName) {
	  return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
	}
	
	var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
	
	function _reduce(fn, acc, list) {
	  if (typeof fn === 'function') {
	    fn = _xwrap(fn);
	  }
	  if (_isArrayLike(list)) {
	    return _arrayReduce(fn, acc, list);
	  }
	  if (typeof list['fantasy-land/reduce'] === 'function') {
	    return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
	  }
	  if (list[symIterator] != null) {
	    return _iterableReduce(fn, acc, list[symIterator]());
	  }
	  if (typeof list.next === 'function') {
	    return _iterableReduce(fn, acc, list);
	  }
	  if (typeof list.reduce === 'function') {
	    return _methodReduce(fn, acc, list, 'reduce');
	  }
	
	  throw new TypeError('reduce: list must be array or iterable');
	}
	module.exports = _reduce;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var EventPluginRegistry = __webpack_require__(366);
	var EventPluginUtils = __webpack_require__(367);
	var ReactErrorUtils = __webpack_require__(371);
	
	var accumulateInto = __webpack_require__(773);
	var forEachAccumulated = __webpack_require__(774);
	var invariant = __webpack_require__(13);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(186);
	var EventPluginUtils = __webpack_require__(367);
	
	var accumulateInto = __webpack_require__(773);
	var forEachAccumulated = __webpack_require__(774);
	var warning = __webpack_require__(19);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(89);
	
	var getEventTarget = __webpack_require__(376);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func,
	    object = _react.PropTypes.object,
	    arrayOf = _react.PropTypes.arrayOf,
	    oneOfType = _react.PropTypes.oneOfType,
	    element = _react.PropTypes.element,
	    shape = _react.PropTypes.shape,
	    string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var hasClass = function hasClass(elem, className) {
	  return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
	};
	
	var addClass = function addClass(elem, className) {
	  if (!hasClass(elem, className)) {
	    elem.className += ' ' + className;
	  }
	};
	
	var removeClass = function removeClass(elem, className) {
	  var newClass = ' ' + elem.className.replace(/[\t\r\n]/g, ' ') + ' ';
	  if (hasClass(elem, className)) {
	    while (newClass.indexOf(' ' + className + ' ') >= 0) {
	      newClass = newClass.replace(' ' + className + ' ', ' ');
	    }
	    elem.className = newClass.replace(/^\s+|\s+$/g, '');
	  }
	};
	
	var escapeHtml = function escapeHtml(str) {
	  var div = document.createElement('div');
	  div.appendChild(document.createTextNode(str));
	  return div.innerHTML;
	};
	
	var _show = function _show(elem) {
	  elem.style.opacity = '';
	  elem.style.display = 'block';
	};
	
	var show = function show(elems) {
	  if (elems && !elems.length) {
	    return _show(elems);
	  }
	  for (var i = 0; i < elems.length; ++i) {
	    _show(elems[i]);
	  }
	};
	
	var _hide = function _hide(elem) {
	  elem.style.opacity = '';
	  elem.style.display = 'none';
	};
	
	var hide = function hide(elems) {
	  if (elems && !elems.length) {
	    return _hide(elems);
	  }
	  for (var i = 0; i < elems.length; ++i) {
	    _hide(elems[i]);
	  }
	};
	
	var isDescendant = function isDescendant(parent, child) {
	  var node = child.parentNode;
	  while (node !== null) {
	    if (node === parent) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	  return false;
	};
	
	var getTopMargin = function getTopMargin(elem) {
	  elem.style.left = '-9999px';
	  elem.style.display = 'block';
	
	  var height = elem.clientHeight,
	      padding;
	  if (typeof getComputedStyle !== 'undefined') {
	    // IE 8
	    padding = parseInt(getComputedStyle(elem).getPropertyValue('padding-top'), 10);
	  } else {
	    padding = parseInt(elem.currentStyle.padding);
	  }
	
	  elem.style.left = '';
	  elem.style.display = 'none';
	  return '-' + parseInt((height + padding) / 2) + 'px';
	};
	
	var fadeIn = function fadeIn(elem, interval) {
	  if (+elem.style.opacity < 1) {
	    interval = interval || 16;
	    elem.style.opacity = 0;
	    elem.style.display = 'block';
	    var last = +new Date();
	    var tick = (function (_tick) {
	      function tick() {
	        return _tick.apply(this, arguments);
	      }
	
	      tick.toString = function () {
	        return _tick.toString();
	      };
	
	      return tick;
	    })(function () {
	      elem.style.opacity = +elem.style.opacity + (new Date() - last) / 100;
	      last = +new Date();
	
	      if (+elem.style.opacity < 1) {
	        setTimeout(tick, interval);
	      }
	    });
	    tick();
	  }
	  elem.style.display = 'block'; //fallback IE8
	};
	
	var fadeOut = function fadeOut(elem, interval) {
	  interval = interval || 16;
	  elem.style.opacity = 1;
	  var last = +new Date();
	  var tick = (function (_tick2) {
	    function tick() {
	      return _tick2.apply(this, arguments);
	    }
	
	    tick.toString = function () {
	      return _tick2.toString();
	    };
	
	    return tick;
	  })(function () {
	    elem.style.opacity = +elem.style.opacity - (new Date() - last) / 100;
	    last = +new Date();
	
	    if (+elem.style.opacity > 0) {
	      setTimeout(tick, interval);
	    } else {
	      elem.style.display = 'none';
	    }
	  });
	  tick();
	};
	
	var fireClick = function fireClick(node) {
	  // Taken from http://www.nonobtrusive.com/2011/11/29/programatically-fire-crossbrowser-click-event-with-javascript/
	  // Then fixed for today's Chrome browser.
	  if (typeof MouseEvent === 'function') {
	    // Up-to-date approach
	    var mevt = new MouseEvent('click', {
	      view: window,
	      bubbles: false,
	      cancelable: true
	    });
	    node.dispatchEvent(mevt);
	  } else if (document.createEvent) {
	    // Fallback
	    var evt = document.createEvent('MouseEvents');
	    evt.initEvent('click', false, false);
	    node.dispatchEvent(evt);
	  } else if (document.createEventObject) {
	    node.fireEvent('onclick');
	  } else if (typeof node.onclick === 'function') {
	    node.onclick();
	  }
	};
	
	var stopEventPropagation = function stopEventPropagation(e) {
	  // In particular, make sure the space bar doesn't scroll the main window.
	  if (typeof e.stopPropagation === 'function') {
	    e.stopPropagation();
	    e.preventDefault();
	  } else if (window.event && window.event.hasOwnProperty('cancelBubble')) {
	    window.event.cancelBubble = true;
	  }
	};
	
	exports.hasClass = hasClass;
	exports.addClass = addClass;
	exports.removeClass = removeClass;
	exports.escapeHtml = escapeHtml;
	exports._show = _show;
	exports.show = show;
	exports._hide = _hide;
	exports.hide = hide;
	exports.isDescendant = isDescendant;
	exports.getTopMargin = getTopMargin;
	exports.fadeIn = fadeIn;
	exports.fadeOut = fadeOut;
	exports.fireClick = fireClick;
	exports.stopEventPropagation = stopEventPropagation;

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 193 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var COOKIE = exports.COOKIE = 'squire-analytics';
	
	var SET_ACCEPT_COOKIE = exports.SET_ACCEPT_COOKIE = 'SET_ACCEPT_COOKIE';

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _actions = __webpack_require__(117);
	
	var _selectors = __webpack_require__(27);
	
	var _WithServiceDuration = __webpack_require__(995);
	
	var _WithServiceDuration2 = _interopRequireDefault(_WithServiceDuration);
	
	var _FetchOnMount = __webpack_require__(134);
	
	var _FetchOnMount2 = _interopRequireDefault(_FetchOnMount);
	
	var _WithLoader = __webpack_require__(195);
	
	var _WithLoader2 = _interopRequireDefault(_WithLoader);
	
	var _Barbers = __webpack_require__(403);
	
	var _Barbers2 = _interopRequireDefault(_Barbers);
	
	var _actions2 = __webpack_require__(64);
	
	var _actions3 = __webpack_require__(92);
	
	var _selectors2 = __webpack_require__(11);
	
	var _helpers = __webpack_require__(7);
	
	var _WithKioskProp = __webpack_require__(59);
	
	var _WithKioskProp2 = _interopRequireDefault(_WithKioskProp);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state, ownProps) {
	  return {
	    barbers: (0, _selectors.getBarbers)(state, ownProps.params),
	    shop: (0, _selectors2.getShopByRoute)(state, ownProps.params.shopRoute),
	    allowBookWithAnyBarber: (0, _selectors.getBarbersCount)(state, ownProps.params) > 1 && (0, _selectors2.getAllowBookWithAnyBarber)(state, ownProps.params.shopRoute),
	    generateUrlString: function generateUrlString(params) {
	      return (0, _helpers.generateUrlString)(_extends({}, ownProps.params, params), ownProps.urlPattern);
	    }
	  };
	}
	
	var mapDispatchToProps = {
	  fetchShopAction: _actions2.fetchShop,
	  fetchServiceAction: _actions.fetchSelectedServices,
	  fetchBarbersWithNextAvailableTimeAction: _actions3.fetchBarbersWithNextAvailableTime
	};
	
	exports.default = (0, _compose3.default)(_WithKioskProp2.default, _WithServiceDuration2.default, _WithShop2.default, _reactRouter.withRouter, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _withHandlers3.default)({
	  fetchShop: function fetchShop(props) {
	    return function () {
	      return props.fetchShopAction(props.params.shopRoute, props.urlPattern);
	    };
	  },
	  fetchService: function fetchService(props) {
	    return function () {
	      return props.fetchServiceAction(props.params.shopRoute, null, props.params.serviceId, props.params, props.urlPattern);
	    };
	  },
	  fetchBarbersWithNextAvailableTime: function fetchBarbersWithNextAvailableTime(props) {
	    return function () {
	      return props.fetchBarbersWithNextAvailableTimeAction(props.params.shopRoute, props.params, props.urlPattern, props.serviceDuration, props.kiosk);
	    };
	  }
	}), (0, _withHandlers3.default)({
	  fetchData: function fetchData(props) {
	    return function () {
	      return props.fetchShop().then(function () {
	        return props.fetchService();
	      }).then(function () {
	        return props.fetchBarbersWithNextAvailableTime();
	      });
	    };
	  }
	}), _FetchOnMount2.default, _WithLoader2.default)(_Barbers2.default);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _renderComponent2 = __webpack_require__(57);
	
	var _renderComponent3 = _interopRequireDefault(_renderComponent2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Loader = __webpack_require__(82);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WithLoader = (0, _branch3.default)(function (props) {
	  return props.isFetching;
	}, (0, _renderComponent3.default)(_Loader2.default));
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    isFetching: ownProps.isLoading || state.app.get('isFetching')
	  };
	};
	
	exports.default = (0, _compose3.default)((0, _reactRedux.connect)(mapStateToProps), WithLoader);

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _selectors = __webpack_require__(164);
	
	var _selectors2 = __webpack_require__(11);
	
	var _selectors3 = __webpack_require__(21);
	
	var reservationSelectors = _interopRequireWildcard(_selectors3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    shopName: (0, _selectors2.getShopName)(state, ownProps.params.shopRoute) || reservationSelectors.getShopName(state) || (0, _selectors.getWaitingListTimesShopName)(state)
	  };
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(mapStateToProps));

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _renderComponent2 = __webpack_require__(57);
	
	var _renderComponent3 = _interopRequireDefault(_renderComponent2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _map2 = __webpack_require__(74);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(5);
	
	var _helpers = __webpack_require__(7);
	
	var _Loader = __webpack_require__(82);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _utils = __webpack_require__(47);
	
	var _actions = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _withState3.default)('busy', 'setBusy', true), (0, _withState3.default)('waitingList', 'setWaitingList', null), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    return _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var customerWaitingListId, includes, waitingList;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              customerWaitingListId = _this.props.params.customerWaitingListId;
	              includes = ['shop', 'shop.address', 'shop.staticMap', 'customer', 'barber', 'services'];
	              _context.next = 5;
	              return (0, _actions.fetchCustomerWaitingList)(customerWaitingListId, includes);
	
	            case 5:
	              waitingList = _context.sent;
	
	              _this.props.setWaitingList(waitingList);
	
	            case 7:
	              _context.prev = 7;
	
	              _this.props.setBusy(false);
	              return _context.finish(7);
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[0,, 7, 10]]);
	    }))();
	  }
	}), (0, _branch3.default)(function (props) {
	  return props.busy;
	}, (0, _renderComponent3.default)(_Loader2.default)), (0, _branch3.default)(function (props) {
	  return !props.waitingList;
	}, _renderNothing3.default), (0, _withProps3.default)(function (_ref) {
	  var waitingList = _ref.waitingList,
	      params = _ref.params;
	  var shop = waitingList.shop;
	
	  return _extends({
	    shop: shop,
	    customer: waitingList.customer,
	    barber: waitingList.barber,
	    service: (0, _map3.default)(waitingList.services, 'name').join(', '),
	    address: (0, _utils.getShopAddress)(shop),
	    currentWaitingListPosition: waitingList.numberInLine,
	    currentWaitingListPositionTitle: _moment2.default.localeData().ordinal(waitingList.numberInLine),
	    duration: (0, _helpers.formatDuration)(waitingList.serviceDuration)
	  }, (0, _utils.getAppLinks)(params.brandRoute, ''), {
	    squireInfoClassName: shop.mobileAppCta ? 'c-phones-background__content' : 'u-mt-15'
	  });
	}));

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reducer = undefined;
	
	var _actions = __webpack_require__(447);
	
	Object.keys(_actions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _actions[key];
	    }
	  });
	});
	
	var _reducer = __webpack_require__(449);
	
	Object.defineProperty(exports, 'reducer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_reducer).default;
	  }
	});
	
	var _Passcode = __webpack_require__(1143);
	
	var _Passcode2 = _interopRequireDefault(_Passcode);
	
	var _PasscodeContainer = __webpack_require__(1144);
	
	var _PasscodeContainer2 = _interopRequireDefault(_PasscodeContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _PasscodeContainer2.default)(_Passcode2.default);

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isLessThanPrepayOnlyThreshold = exports.getMinutesBeforeReservation = exports.dayIsInArray = exports.isWeekdayEnabled = exports.getScheduleWeekdaysOffFromSchedule = exports.getScheduleWeekdaysFromSchedule = exports.getWholeDaysOff = undefined;
	
	var _flow = __webpack_require__(231);
	
	var _flow2 = _interopRequireDefault(_flow);
	
	var _get = __webpack_require__(176);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _map = __webpack_require__(232);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _filter = __webpack_require__(1479);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getWholeDaysOff = exports.getWholeDaysOff = function getWholeDaysOff(daysOff) {
	  return (0, _flow2.default)((0, _filter2.default)('wholeDay'), (0, _map2.default)('day'))(daysOff);
	};
	
	var getScheduleWeekdaysFromSchedule = exports.getScheduleWeekdaysFromSchedule = function getScheduleWeekdaysFromSchedule(schedules) {
	  return (0, _flow2.default)((0, _get2.default)('0.workdays'), (0, _map2.default)('enabled'), _helpers.arrayRotateRight)(schedules);
	};
	
	var getScheduleWeekdaysOffFromSchedule = exports.getScheduleWeekdaysOffFromSchedule = function getScheduleWeekdaysOffFromSchedule(schedules) {
	  return (0, _flow2.default)((0, _get2.default)('0.workdays'), (0, _filter2.default)({ enabled: false }), (0, _map2.default)('weekDay'),
	  // days_off from the api are 1 based (1-7),
	  // and JS dates are 0 based (0-6)
	  (0, _map2.default)(function (day) {
	    return day % 7;
	  }))(schedules);
	};
	
	var isWeekdayEnabled = exports.isWeekdayEnabled = function isWeekdayEnabled(date, weekdaysArr) {
	  return weekdaysArr[date.getUTCDay()];
	};
	
	var dayIsInArray = exports.dayIsInArray = function dayIsInArray(day, arr) {
	  return arr.some(function (item) {
	    return (0, _helpers.getStartOfDay)(item).getTime() === day.getTime();
	  });
	};
	
	var getMinutesBeforeReservation = exports.getMinutesBeforeReservation = function getMinutesBeforeReservation(reservationTime, timezone) {
	  return (0, _moment2.default)(reservationTime, _config2.default.timeSlugFormat).tz(timezone).diff((0, _moment2.default)().tz(timezone), 'minutes');
	};
	
	var isLessThanPrepayOnlyThreshold = exports.isLessThanPrepayOnlyThreshold = function isLessThanPrepayOnlyThreshold(minutesBeforeAppointment, shop) {
	  return minutesBeforeAppointment < shop.prepayOnlyThreshold;
	};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFlag = undefined;
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var defaultFlags = {
	  'check-if-human': false,
	  'rebooking-reminder-sms': false
	};
	
	var ldClient = null;
	
	if (window.LDClient) {
	  ldClient = window.LDClient.initialize(_config2.default.launchDarkly.clientSideId, {
	    kind: 'user',
	    key: 'anonymous',
	    anonymous: true
	  });
	}
	
	var getFlag = exports.getFlag = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(flagName, context) {
	    var evaluation;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            if (!ldClient) {
	              _context.next = 11;
	              break;
	            }
	
	            if (!context) {
	              _context.next = 10;
	              break;
	            }
	
	            _context.next = 4;
	            return ldClient.waitUntilReady();
	
	          case 4:
	            _context.next = 6;
	            return ldClient.identify(context);
	
	          case 6:
	            evaluation = ldClient.variation(flagName, defaultFlags[flagName]);
	            // Revert back to original context
	
	            _context.next = 9;
	            return ldClient.identify({
	              kind: 'user',
	              key: 'anonymous',
	              anonymous: true
	            });
	
	          case 9:
	            return _context.abrupt('return', evaluation);
	
	          case 10:
	            return _context.abrupt('return', ldClient.variation(flagName, defaultFlags[flagName]));
	
	          case 11:
	            return _context.abrupt('return', defaultFlags[flagName]);
	
	          case 12:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function getFlag(_x, _x2) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	exports.default = getFlag;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.history = undefined;
	
	var _history = __webpack_require__(1324);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line import/prefer-default-export
	var history = exports.history = (0, _history.useQueries)((0, _history.useBasename)(_history.createHistory))({
	  basename: _config2.default.pathPrefix
	});

/***/ }),
/* 202 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	
	module.exports = function isEmail (string) {
	    return (/.+\@.+\..+/).test(string);
	};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _metadata2 = _interopRequireDefault(__webpack_require__(43));
	
	var _isPossibleNumber_ = _interopRequireDefault(__webpack_require__(325));
	
	var _validate_ = _interopRequireDefault(__webpack_require__(211));
	
	var _isValidNumberForRegion_ = _interopRequireDefault(__webpack_require__(519));
	
	var _getNumberType = _interopRequireDefault(__webpack_require__(210));
	
	var _format_ = _interopRequireDefault(__webpack_require__(513));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
	
	var PhoneNumber = /*#__PURE__*/function () {
	  function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
	    _classCallCheck(this, PhoneNumber);
	
	    if (!countryCallingCode) {
	      throw new TypeError('`country` or `countryCallingCode` not passed');
	    }
	
	    if (!nationalNumber) {
	      throw new TypeError('`nationalNumber` not passed');
	    }
	
	    if (!metadata) {
	      throw new TypeError('`metadata` not passed');
	    }
	
	    var _metadata = new _metadata2["default"](metadata); // If country code is passed then derive `countryCallingCode` from it.
	    // Also store the country code as `.country`.
	
	
	    if (isCountryCode(countryCallingCode)) {
	      this.country = countryCallingCode;
	
	      _metadata.country(countryCallingCode);
	
	      countryCallingCode = _metadata.countryCallingCode();
	    } else {
	      /* istanbul ignore if */
	      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
	        if (_metadata.isNonGeographicCallingCode(countryCallingCode)) {
	          this.country = '001';
	        }
	      }
	    }
	
	    this.countryCallingCode = countryCallingCode;
	    this.nationalNumber = nationalNumber;
	    this.number = '+' + this.countryCallingCode + this.nationalNumber;
	    this.metadata = metadata;
	  }
	
	  _createClass(PhoneNumber, [{
	    key: "setExt",
	    value: function setExt(ext) {
	      this.ext = ext;
	    }
	  }, {
	    key: "isPossible",
	    value: function isPossible() {
	      return (0, _isPossibleNumber_["default"])(this, {
	        v2: true
	      }, this.metadata);
	    }
	  }, {
	    key: "isValid",
	    value: function isValid() {
	      return (0, _validate_["default"])(this, {
	        v2: true
	      }, this.metadata);
	    }
	  }, {
	    key: "isNonGeographic",
	    value: function isNonGeographic() {
	      var metadata = new _metadata2["default"](this.metadata);
	      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
	    }
	  }, {
	    key: "isEqual",
	    value: function isEqual(phoneNumber) {
	      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
	    } // // Is just an alias for `this.isValid() && this.country === country`.
	    // // https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
	    // isValidForRegion(country) {
	    // 	return isValidNumberForRegion(this, country, { v2: true }, this.metadata)
	    // }
	
	  }, {
	    key: "getType",
	    value: function getType() {
	      return (0, _getNumberType["default"])(this, {
	        v2: true
	      }, this.metadata);
	    }
	  }, {
	    key: "format",
	    value: function format(_format, options) {
	      return (0, _format_["default"])(this, _format, options ? _objectSpread(_objectSpread({}, options), {}, {
	        v2: true
	      }) : {
	        v2: true
	      }, this.metadata);
	    }
	  }, {
	    key: "formatNational",
	    value: function formatNational(options) {
	      return this.format('NATIONAL', options);
	    }
	  }, {
	    key: "formatInternational",
	    value: function formatInternational(options) {
	      return this.format('INTERNATIONAL', options);
	    }
	  }, {
	    key: "getURI",
	    value: function getURI(options) {
	      return this.format('RFC3966', options);
	    }
	  }]);
	
	  return PhoneNumber;
	}();
	
	exports["default"] = PhoneNumber;
	
	var isCountryCode = function isCountryCode(value) {
	  return /^[A-Z]{2}$/.test(value);
	};
	//# sourceMappingURL=PhoneNumber.js.map

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.endsWith = endsWith;
	exports.limit = limit;
	exports.startsWith = startsWith;
	exports.trimAfterFirstMatch = trimAfterFirstMatch;
	
	/** Returns a regular expression quantifier with an upper and lower limit. */
	function limit(lower, upper) {
	  if (lower < 0 || upper <= 0 || upper < lower) {
	    throw new TypeError();
	  }
	
	  return "{".concat(lower, ",").concat(upper, "}");
	}
	/**
	 * Trims away any characters after the first match of {@code pattern} in {@code candidate},
	 * returning the trimmed version.
	 */
	
	
	function trimAfterFirstMatch(regexp, string) {
	  var index = string.search(regexp);
	
	  if (index >= 0) {
	    return string.slice(0, index);
	  }
	
	  return string;
	}
	
	function startsWith(string, substring) {
	  return string.indexOf(substring) === 0;
	}
	
	function endsWith(string, substring) {
	  return string.indexOf(substring, string.length - substring.length) === string.length - substring.length;
	}
	//# sourceMappingURL=util.js.map

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatRFC3966 = formatRFC3966;
	exports.parseRFC3966 = parseRFC3966;
	
	var _isViablePhoneNumber = _interopRequireDefault(__webpack_require__(168));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	// https://www.ietf.org/rfc/rfc3966.txt
	
	/**
	 * @param  {string} text - Phone URI (RFC 3966).
	 * @return {object} `{ ?number, ?ext }`.
	 */
	function parseRFC3966(text) {
	  var number;
	  var ext; // Replace "tel:" with "tel=" for parsing convenience.
	
	  text = text.replace(/^tel:/, 'tel=');
	
	  for (var _iterator = _createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;) {
	    var part = _step.value;
	
	    var _part$split = part.split('='),
	        _part$split2 = _slicedToArray(_part$split, 2),
	        name = _part$split2[0],
	        value = _part$split2[1];
	
	    switch (name) {
	      case 'tel':
	        number = value;
	        break;
	
	      case 'ext':
	        ext = value;
	        break;
	
	      case 'phone-context':
	        // Only "country contexts" are supported.
	        // "Domain contexts" are ignored.
	        if (value[0] === '+') {
	          number = value + number;
	        }
	
	        break;
	    }
	  } // If the phone number is not viable, then abort.
	
	
	  if (!(0, _isViablePhoneNumber["default"])(number)) {
	    return {};
	  }
	
	  var result = {
	    number: number
	  };
	
	  if (ext) {
	    result.ext = ext;
	  }
	
	  return result;
	}
	/**
	 * @param  {object} - `{ ?number, ?extension }`.
	 * @return {string} Phone URI (RFC 3966).
	 */
	
	
	function formatRFC3966(_ref) {
	  var number = _ref.number,
	      ext = _ref.ext;
	
	  if (!number) {
	    return '';
	  }
	
	  if (number[0] !== '+') {
	    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
	  }
	
	  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
	}
	//# sourceMappingURL=RFC3966.js.map

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkNumberLengthForType = checkNumberLengthForType;
	exports["default"] = checkNumberLength;
	
	var _mergeArrays = _interopRequireDefault(__webpack_require__(1347));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function checkNumberLength(nationalNumber, metadata) {
	  return checkNumberLengthForType(nationalNumber, undefined, metadata);
	} // Checks whether a number is possible for the country based on its length.
	// Should only be called for the "new" metadata which has "possible lengths".
	
	
	function checkNumberLengthForType(nationalNumber, type, metadata) {
	  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
	  // This is declared in the XML schema.
	  // For size efficiency, where a sub-description (e.g. fixed-line)
	  // has the same "<possiblePengths/>" as the "general description", this is missing,
	  // so we fall back to the "general description". Where no numbers of the type
	  // exist at all, there is one possible length (-1) which is guaranteed
	  // not to match the length of any real phone number.
	
	  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
	  // Metadata before version `1.0.18` didn't contain `possible_lengths`.
	
	  if (!possible_lengths) {
	    return 'IS_POSSIBLE';
	  }
	
	  if (type === 'FIXED_LINE_OR_MOBILE') {
	    // No such country in metadata.
	
	    /* istanbul ignore next */
	    if (!metadata.type('FIXED_LINE')) {
	      // The rare case has been encountered where no fixedLine data is available
	      // (true for some non-geographic entities), so we just check mobile.
	      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
	    }
	
	    var mobile_type = metadata.type('MOBILE');
	
	    if (mobile_type) {
	      // Merge the mobile data in if there was any. "Concat" creates a new
	      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
	      // Note that when adding the possible lengths from mobile, we have
	      // to again check they aren't empty since if they are this indicates
	      // they are the same as the general desc and should be obtained from there.
	      possible_lengths = (0, _mergeArrays["default"])(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
	      // re-sort (duplicates are okay). Sorting isn't so expensive because
	      // the lists are very small.
	      // if (local_lengths) {
	      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
	      // } else {
	      // 	local_lengths = mobile_type.possibleLengthsLocal()
	      // }
	    }
	  } // If the type doesn't exist then return 'INVALID_LENGTH'.
	  else if (type && !type_info) {
	    return 'INVALID_LENGTH';
	  }
	
	  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
	  // // This is safe because there is never an overlap beween the possible lengths
	  // // and the local-only lengths; this is checked at build time.
	  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
	  // {
	  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
	  // }
	
	  var minimum_length = possible_lengths[0];
	
	  if (minimum_length === actual_length) {
	    return 'IS_POSSIBLE';
	  }
	
	  if (minimum_length > actual_length) {
	    return 'TOO_SHORT';
	  }
	
	  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
	    return 'TOO_LONG';
	  } // We skip the first element since we've already checked it.
	
	
	  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
	}
	//# sourceMappingURL=checkNumberLength.js.map

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createExtensionPattern;
	
	var _constants = __webpack_require__(72);
	
	// The RFC 3966 format for extensions.
	var RFC3966_EXTN_PREFIX = ';ext=';
	/**
	 * Helper method for constructing regular expressions for parsing. Creates
	 * an expression that captures up to max_length digits.
	 * @return {string} RegEx pattern to capture extension digits.
	 */
	
	var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
	  return "([".concat(_constants.VALID_DIGITS, "]{1,").concat(maxLength, "})");
	};
	/**
	 * Helper initialiser method to create the regular-expression pattern to match
	 * extensions.
	 * Copy-pasted from Google's `libphonenumber`:
	 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
	 * @return {string} RegEx pattern to capture extensions.
	 */
	
	
	function createExtensionPattern(purpose) {
	  // We cap the maximum length of an extension based on the ambiguity of the way
	  // the extension is prefixed. As per ITU, the officially allowed length for
	  // extensions is actually 40, but we don't support this since we haven't seen real
	  // examples and this introduces many false interpretations as the extension labels
	  // are not standardized.
	
	  /** @type {string} */
	  var extLimitAfterExplicitLabel = '20';
	  /** @type {string} */
	
	  var extLimitAfterLikelyLabel = '15';
	  /** @type {string} */
	
	  var extLimitAfterAmbiguousChar = '9';
	  /** @type {string} */
	
	  var extLimitWhenNotSure = '6';
	  /** @type {string} */
	
	  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
	
	  /** @type {string} */
	
	  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
	  /** @type {string} */
	
	  var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
	  // patterns like "ext.".
	
	  /** @type {string} */
	
	  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
	  // commonly used or more ambiguous extension labels.
	
	  /** @type {string} */
	
	  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
	
	  /** @type {string} */
	
	  var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
	  // comma as extension label may have it.
	
	  /** @type {string} */
	
	  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
	  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
	  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
	  // button with the extension number following.
	
	  /** @type {string} */
	
	  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
	  /** @type {string} */
	
	  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
	  /** @type {string} */
	
	  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
	  /** @type {string} */
	
	  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
	  /** @type {string} */
	
	  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
	  /** @type {string} */
	
	  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
	  /** @type {string} */
	
	  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
	  // using ";ext=". The second more generic where extension is mentioned with explicit
	  // labels like "ext:". In both the above cases we allow more numbers in extension than
	  // any other extension labels. The third one captures when single character extension
	  // labels or less commonly used labels are used. In such cases we capture fewer
	  // extension digits in order to reduce the chance of falsely interpreting two
	  // numbers beside each other as a number + extension. The fourth one covers the
	  // special case of American numbers where the extension is written with a hash
	  // at the end, such as "- 503#". The fifth one is exclusively for extension
	  // autodialling formats which are used when dialling and in this case we accept longer
	  // extensions. The last one is more liberal on the number of commas that acts as
	  // extension labels, so we have a strict cap on the number of digits in such extensions.
	
	  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
	}
	//# sourceMappingURL=createExtensionPattern.js.map

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getNumberType;
	exports.isNumberTypeEqualTo = isNumberTypeEqualTo;
	
	var _metadata = _interopRequireDefault(__webpack_require__(43));
	
	var _matchesEntirely = _interopRequireDefault(__webpack_require__(139));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)
	
	function getNumberType(input, options, metadata) {
	  // If assigning the `{}` default value is moved to the arguments above,
	  // code coverage would decrease for some weird reason.
	  options = options || {}; // When `parse()` returned `{}`
	  // meaning that the phone number is not a valid one.
	
	  if (!input.country) {
	    return;
	  }
	
	  metadata = new _metadata["default"](metadata);
	  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
	  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
	  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
	  // Is this national number even valid for this country
	
	  if (!(0, _matchesEntirely["default"])(nationalNumber, metadata.nationalNumberPattern())) {
	    return;
	  } // Is it fixed line number
	
	
	  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
	    // Because duplicate regular expressions are removed
	    // to reduce metadata size, if "mobile" pattern is ""
	    // then it means it was removed due to being a duplicate of the fixed-line pattern.
	    //
	    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
	      return 'FIXED_LINE_OR_MOBILE';
	    } // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
	    // For example, for "US" country.
	    // Old metadata (< `1.0.18`) had a specific "types" data structure
	    // that happened to be `undefined` for `MOBILE` in that case.
	    // Newer metadata (>= `1.0.18`) has another data structure that is
	    // not `undefined` for `MOBILE` in that case (it's just an empty array).
	    // So this `if` is just for backwards compatibility with old metadata.
	
	
	    if (!metadata.type('MOBILE')) {
	      return 'FIXED_LINE_OR_MOBILE';
	    } // Check if the number happens to qualify as both fixed line and mobile.
	    // (no such country in the minimal metadata set)
	
	    /* istanbul ignore if */
	
	
	    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
	      return 'FIXED_LINE_OR_MOBILE';
	    }
	
	    return 'FIXED_LINE';
	  }
	
	  for (var _iterator = _createForOfIteratorHelperLoose(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;) {
	    var type = _step.value;
	
	    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
	      return type;
	    }
	  }
	}
	
	function isNumberTypeEqualTo(nationalNumber, type, metadata) {
	  type = metadata.type(type);
	
	  if (!type || !type.pattern()) {
	    return false;
	  } // Check if any possible number lengths are present;
	  // if so, we use them to avoid checking
	  // the validation pattern if they don't match.
	  // If they are absent, this means they match
	  // the general description, which we have
	  // already checked before a specific number type.
	
	
	  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
	    return false;
	  }
	
	  return (0, _matchesEntirely["default"])(nationalNumber, type.pattern());
	}
	//# sourceMappingURL=getNumberType.js.map

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isValidNumber;
	
	var _metadata = _interopRequireDefault(__webpack_require__(43));
	
	var _matchesEntirely = _interopRequireDefault(__webpack_require__(139));
	
	var _getNumberType = _interopRequireDefault(__webpack_require__(210));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Checks if a given phone number is valid.
	 *
	 * If the `number` is a string, it will be parsed to an object,
	 * but only if it contains only valid phone number characters (including punctuation).
	 * If the `number` is an object, it is used as is.
	 *
	 * The optional `defaultCountry` argument is the default country.
	 * I.e. it does not restrict to just that country,
	 * e.g. in those cases where several countries share
	 * the same phone numbering rules (NANPA, Britain, etc).
	 * For example, even though the number `07624 369230`
	 * belongs to the Isle of Man ("IM" country code)
	 * calling `isValidNumber('07624369230', 'GB', metadata)`
	 * still returns `true` because the country is not restricted to `GB`,
	 * it's just that `GB` is the default one for the phone numbering rules.
	 * For restricting the country see `isValidNumberForRegion()`
	 * though restricting a country might not be a good idea.
	 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
	 *
	 * Examples:
	 *
	 * ```js
	 * isValidNumber('+78005553535', metadata)
	 * isValidNumber('8005553535', 'RU', metadata)
	 * isValidNumber('88005553535', 'RU', metadata)
	 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
	 * ```
	 */
	function isValidNumber(input, options, metadata) {
	  // If assigning the `{}` default value is moved to the arguments above,
	  // code coverage would decrease for some weird reason.
	  options = options || {};
	  metadata = new _metadata["default"](metadata); // This is just to support `isValidNumber({})`
	  // for cases when `parseNumber()` returns `{}`.
	
	  if (!input.country) {
	    return false;
	  }
	
	  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
	  // distinguishing different countries having the same `countryCallingCode`.
	
	  if (metadata.hasTypes()) {
	    return (0, _getNumberType["default"])(input, options, metadata.metadata) !== undefined;
	  } // If there are no type regexps for this country in metadata then use
	  // `nationalNumberPattern` as a "better than nothing" replacement.
	
	
	  var national_number = options.v2 ? input.nationalNumber : input.phone;
	  return (0, _matchesEntirely["default"])(national_number, metadata.nationalNumberPattern());
	}
	//# sourceMappingURL=validate_.js.map

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, true, true);
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = cloneDeep;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(192)(module)))

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1437),
	    listCacheDelete = __webpack_require__(1438),
	    listCacheGet = __webpack_require__(1439),
	    listCacheHas = __webpack_require__(1440),
	    listCacheSet = __webpack_require__(1441);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(213),
	    stackClear = __webpack_require__(1453),
	    stackDelete = __webpack_require__(1454),
	    stackGet = __webpack_require__(1455),
	    stackHas = __webpack_require__(1456),
	    stackSet = __webpack_require__(1457);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(53);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 216 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(174);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(1387);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(170),
	    isObject = __webpack_require__(52);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtor;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(550),
	    createBind = __webpack_require__(1407),
	    createCurry = __webpack_require__(1409),
	    createHybrid = __webpack_require__(557),
	    createPartial = __webpack_require__(1413),
	    getData = __webpack_require__(341),
	    mergeData = __webpack_require__(1447),
	    setData = __webpack_require__(571),
	    setWrapToString = __webpack_require__(572),
	    toInteger = __webpack_require__(106);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - `_.bind`
	 *     2 - `_.bindKey`
	 *     4 - `_.curry` or `_.curryRight` of a bound function
	 *     8 - `_.curry`
	 *    16 - `_.curryRight`
	 *    32 - `_.partial`
	 *    64 - `_.partialRight`
	 *   128 - `_.rearg`
	 *   256 - `_.ary`
	 *   512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] == null
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setWrapToString(setter(result, newData), func, bitmask);
	}
	
	module.exports = createWrap;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1435);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(345);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 224 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ }),
/* 225 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(28),
	    isSymbol = __webpack_require__(144);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(122);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ }),
/* 230 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(61),
	    func = convert('flow', __webpack_require__(125));
	
	func.placeholder = __webpack_require__(56);
	module.exports = func;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(61),
	    func = convert('map', __webpack_require__(74));
	
	func.placeholder = __webpack_require__(56);
	module.exports = func;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(103),
	    isObjectLike = __webpack_require__(104);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 234 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(223),
	    isHostObject = __webpack_require__(224),
	    isObjectLike = __webpack_require__(104);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1377),
	    baseUnary = __webpack_require__(171),
	    nodeUtil = __webpack_require__(570);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 237 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 238 */
/***/ (function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that negates the result of the predicate `func`. The
	 * `func` predicate is invoked with the `this` binding and arguments of the
	 * created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} predicate The predicate to negate.
	 * @returns {Function} Returns the new negated function.
	 * @example
	 *
	 * function isEven(n) {
	 *   return n % 2 == 0;
	 * }
	 *
	 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	 * // => [1, 3, 5]
	 */
	function negate(predicate) {
	  if (typeof predicate != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return function() {
	    var args = arguments;
	    switch (args.length) {
	      case 0: return !predicate.call(this);
	      case 1: return !predicate.call(this, args[0]);
	      case 2: return !predicate.call(this, args[0], args[1]);
	      case 3: return !predicate.call(this, args[0], args[1], args[2]);
	    }
	    return !predicate.apply(this, args);
	  };
	}
	
	module.exports = negate;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {'use strict';
	
	var callable, byObserver;
	
	callable = function (fn) {
		if (typeof fn !== 'function') throw new TypeError(fn + " is not a function");
		return fn;
	};
	
	byObserver = function (Observer) {
		var node = document.createTextNode(''), queue, i = 0;
		new Observer(function () {
			var data;
			if (!queue) return;
			data = queue;
			queue = null;
			if (typeof data === 'function') {
				data();
				return;
			}
			data.forEach(function (fn) { fn(); });
		}).observe(node, { characterData: true });
		return function (fn) {
			callable(fn);
			if (queue) {
				if (typeof queue === 'function') queue = [queue, fn];
				else queue.push(fn);
				return;
			}
			queue = fn;
			node.data = (i = ++i % 2);
		};
	};
	
	module.exports = (function () {
		// Node.js
		if ((typeof process !== 'undefined') && process &&
				(typeof process.nextTick === 'function')) {
			return process.nextTick;
		}
	
		// MutationObserver=
		if ((typeof document === 'object') && document) {
			if (typeof MutationObserver === 'function') {
				return byObserver(MutationObserver);
			}
			if (typeof WebKitMutationObserver === 'function') {
				return byObserver(WebKitMutationObserver);
			}
		}
	
		// W3C Draft
		// http://dvcs.w3.org/hg/webperf/raw-file/tip/specs/setImmediate/Overview.html
		if (typeof setImmediate === 'function') {
			return function (cb) { setImmediate(callable(cb)); };
		}
	
		// Wide available standard
		if (typeof setTimeout === 'function') {
			return function (cb) { setTimeout(callable(cb), 0); };
		}
	
		return null;
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146), __webpack_require__(1814).setImmediate))

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	function _arity(n, fn) {
	  /* eslint-disable no-unused-vars */
	  switch (n) {
	    case 0:
	      return function () {
	        return fn.apply(this, arguments);
	      };
	    case 1:
	      return function (a0) {
	        return fn.apply(this, arguments);
	      };
	    case 2:
	      return function (a0, a1) {
	        return fn.apply(this, arguments);
	      };
	    case 3:
	      return function (a0, a1, a2) {
	        return fn.apply(this, arguments);
	      };
	    case 4:
	      return function (a0, a1, a2, a3) {
	        return fn.apply(this, arguments);
	      };
	    case 5:
	      return function (a0, a1, a2, a3, a4) {
	        return fn.apply(this, arguments);
	      };
	    case 6:
	      return function (a0, a1, a2, a3, a4, a5) {
	        return fn.apply(this, arguments);
	      };
	    case 7:
	      return function (a0, a1, a2, a3, a4, a5, a6) {
	        return fn.apply(this, arguments);
	      };
	    case 8:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
	        return fn.apply(this, arguments);
	      };
	    case 9:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
	        return fn.apply(this, arguments);
	      };
	    case 10:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
	        return fn.apply(this, arguments);
	      };
	    default:
	      throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
	  }
	}
	module.exports = _arity;

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	function _isPlaceholder(a) {
	       return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
	}
	module.exports = _isPlaceholder;

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	module.exports = {
	  init: function () {
	    return this.xf['@@transducer/init']();
	  },
	  result: function (result) {
	    return this.xf['@@transducer/result'](result);
	  }
	};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var _has = /*#__PURE__*/__webpack_require__(147);
	
	var _isArguments = /*#__PURE__*/__webpack_require__(745);
	
	// cover IE < 9 keys issues
	
	
	var hasEnumBug = ! /*#__PURE__*/{ toString: null }.propertyIsEnumerable('toString');
	var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	// Safari bug
	var hasArgsEnumBug = /*#__PURE__*/function () {
	  'use strict';
	
	  return arguments.propertyIsEnumerable('length');
	}();
	
	var contains = function contains(list, item) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (list[idx] === item) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	};
	
	/**
	 * Returns a list containing the names of all the enumerable own properties of
	 * the supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own properties.
	 * @see R.keysIn, R.values
	 * @example
	 *
	 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
	 */
	var _keys = typeof Object.keys === 'function' && !hasArgsEnumBug ? function keys(obj) {
	  return Object(obj) !== obj ? [] : Object.keys(obj);
	} : function keys(obj) {
	  if (Object(obj) !== obj) {
	    return [];
	  }
	  var prop, nIdx;
	  var ks = [];
	  var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
	  for (prop in obj) {
	    if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
	      ks[ks.length] = prop;
	    }
	  }
	  if (hasEnumBug) {
	    nIdx = nonEnumerableProps.length - 1;
	    while (nIdx >= 0) {
	      prop = nonEnumerableProps[nIdx];
	      if (_has(prop, obj) && !contains(ks, prop)) {
	        ks[ks.length] = prop;
	      }
	      nIdx -= 1;
	    }
	  }
	  return ks;
	};
	var keys = /*#__PURE__*/_curry1(_keys);
	module.exports = keys;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(183);
	
	var _map = /*#__PURE__*/__webpack_require__(748);
	
	var _reduce = /*#__PURE__*/__webpack_require__(185);
	
	var _xmap = /*#__PURE__*/__webpack_require__(1569);
	
	var curryN = /*#__PURE__*/__webpack_require__(128);
	
	var keys = /*#__PURE__*/__webpack_require__(243);
	
	/**
	 * Takes a function and
	 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
	 * applies the function to each of the functor's values, and returns
	 * a functor of the same shape.
	 *
	 * Ramda provides suitable `map` implementations for `Array` and `Object`,
	 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
	 *
	 * Dispatches to the `map` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * Also treats functions as functors and will compose them together.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => (a -> b) -> f a -> f b
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {Array} list The list to be iterated over.
	 * @return {Array} The new list.
	 * @see R.transduce, R.addIndex
	 * @example
	 *
	 *      var double = x => x * 2;
	 *
	 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
	 *
	 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
	 * @symb R.map(f, [a, b]) = [f(a), f(b)]
	 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
	 * @symb R.map(f, functor_o) = functor_o.map(f)
	 */
	
	
	var map = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
	  switch (Object.prototype.toString.call(functor)) {
	    case '[object Function]':
	      return curryN(functor.length, function () {
	        return fn.call(this, functor.apply(this, arguments));
	      });
	    case '[object Object]':
	      return _reduce(function (acc, key) {
	        acc[key] = fn(functor[key]);
	        return acc;
	      }, {}, keys(functor));
	    default:
	      return _map(fn, functor);
	  }
	}));
	module.exports = map;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(68);
	
	var _reduce = /*#__PURE__*/__webpack_require__(185);
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It may use
	 * [`R.reduced`](#reduced) to shortcut the iteration.
	 *
	 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
	 * is *(value, acc)*.
	 *
	 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
	 *
	 * Dispatches to the `reduce` method of the third argument, if present. When
	 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
	 * shortcuting, as this is not implemented by `reduce`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduced, R.addIndex, R.reduceRight
	 * @example
	 *
	 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
	 *      //          -               -10
	 *      //         / \              / \
	 *      //        -   4           -6   4
	 *      //       / \              / \
	 *      //      -   3   ==>     -3   3
	 *      //     / \              / \
	 *      //    -   2           -1   2
	 *      //   / \              / \
	 *      //  0   1            0   1
	 *
	 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
	 */
	
	
	var reduce = /*#__PURE__*/_curry3(_reduce);
	module.exports = reduce;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.cancelEvent = cancelEvent;
	exports.getFirstDayOfMonth = getFirstDayOfMonth;
	exports.getDaysInMonth = getDaysInMonth;
	exports.getModifiersFromProps = getModifiersFromProps;
	exports.getFirstDayOfWeekFromProps = getFirstDayOfWeekFromProps;
	exports.isRangeOfDates = isRangeOfDates;
	exports.getMonthsDiff = getMonthsDiff;
	exports.getWeekArray = getWeekArray;
	exports.startOfMonth = startOfMonth;
	exports.getDayNodes = getDayNodes;
	exports.nodeListToArray = nodeListToArray;
	exports.hasOwnProp = hasOwnProp;
	
	var _DateUtils = __webpack_require__(148);
	
	var _LocaleUtils = __webpack_require__(247);
	
	var _classNames = __webpack_require__(248);
	
	var _classNames2 = _interopRequireDefault(_classNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cancelEvent(e) {
	  e.preventDefault();
	  e.stopPropagation();
	}
	
	function getFirstDayOfMonth(d) {
	  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
	}
	
	function getDaysInMonth(d) {
	  var resultDate = getFirstDayOfMonth(d);
	
	  resultDate.setMonth(resultDate.getMonth() + 1);
	  resultDate.setDate(resultDate.getDate() - 1);
	
	  return resultDate.getDate();
	}
	
	function getModifiersFromProps(props) {
	  var modifiers = _extends({}, props.modifiers);
	  if (props.selectedDays) {
	    modifiers[props.classNames.selected] = props.selectedDays;
	  }
	  if (props.disabledDays) {
	    modifiers[props.classNames.disabled] = props.disabledDays;
	  }
	  return modifiers;
	}
	
	function getFirstDayOfWeekFromProps(props) {
	  var firstDayOfWeek = props.firstDayOfWeek,
	      _props$locale = props.locale,
	      locale = _props$locale === undefined ? 'en' : _props$locale,
	      _props$localeUtils = props.localeUtils,
	      localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;
	
	  if (!isNaN(firstDayOfWeek)) {
	    return firstDayOfWeek;
	  }
	  if (localeUtils.getFirstDayOfWeek) {
	    return localeUtils.getFirstDayOfWeek(locale);
	  }
	  return 0;
	}
	
	function isRangeOfDates(value) {
	  return !!(value && value.from && value.to);
	}
	
	function getMonthsDiff(d1, d2) {
	  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
	}
	
	function getWeekArray(d) {
	  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _LocaleUtils.getFirstDayOfWeek)();
	  var fixedWeeks = arguments[2];
	
	  var daysInMonth = getDaysInMonth(d);
	  var dayArray = [];
	
	  var week = [];
	  var weekArray = [];
	
	  for (var i = 1; i <= daysInMonth; i += 1) {
	    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
	  }
	
	  dayArray.forEach(function (day) {
	    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
	      weekArray.push(week);
	      week = [];
	    }
	    week.push(day);
	    if (dayArray.indexOf(day) === dayArray.length - 1) {
	      weekArray.push(week);
	    }
	  });
	
	  // unshift days to start the first week
	  var firstWeek = weekArray[0];
	  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
	    var outsideDate = (0, _DateUtils.clone)(firstWeek[0]);
	    outsideDate.setDate(firstWeek[0].getDate() - 1);
	    firstWeek.unshift(outsideDate);
	  }
	
	  // push days until the end of the last week
	  var lastWeek = weekArray[weekArray.length - 1];
	  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
	    var _outsideDate = (0, _DateUtils.clone)(lastWeek[lastWeek.length - 1]);
	    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
	    lastWeek.push(_outsideDate);
	  }
	
	  // add extra weeks to reach 6 weeks
	  if (fixedWeeks && weekArray.length < 6) {
	    var lastExtraWeek = void 0;
	
	    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
	      lastExtraWeek = weekArray[weekArray.length - 1];
	      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
	      var extraWeek = [];
	
	      for (var j = 0; j < 7; j += 1) {
	        var _outsideDate2 = (0, _DateUtils.clone)(lastDay);
	        _outsideDate2.setDate(lastDay.getDate() + j + 1);
	        extraWeek.push(_outsideDate2);
	      }
	
	      weekArray.push(extraWeek);
	    }
	  }
	
	  return weekArray;
	}
	
	function startOfMonth(d) {
	  var newDate = (0, _DateUtils.clone)(d);
	  newDate.setDate(1);
	  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
	  return newDate;
	}
	
	function getDayNodes(node, classNames) {
	  var outsideClassName = void 0;
	  if (classNames === _classNames2.default) {
	    // When using CSS modules prefix the modifier as required by the BEM syntax
	    outsideClassName = classNames.day + '--' + classNames.outside;
	  } else {
	    outsideClassName = '' + classNames.outside;
	  }
	  var dayQuery = classNames.day.replace(/ /g, '.');
	  var outsideDayQuery = outsideClassName.replace(/ /g, '.');
	  var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
	  return node.querySelectorAll(selector);
	}
	
	function nodeListToArray(nodeList) {
	  return Array.prototype.slice.call(nodeList, 0);
	}
	
	function hasOwnProp(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	//# sourceMappingURL=Helpers.js.map

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatDay = formatDay;
	exports.formatMonthTitle = formatMonthTitle;
	exports.formatWeekdayShort = formatWeekdayShort;
	exports.formatWeekdayLong = formatWeekdayLong;
	exports.getFirstDayOfWeek = getFirstDayOfWeek;
	exports.getMonths = getMonths;
	var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	
	var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
	
	var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	function formatDay(day) {
	  return day.toDateString();
	}
	
	function formatMonthTitle(d) {
	  return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
	}
	
	function formatWeekdayShort(i) {
	  return WEEKDAYS_SHORT[i];
	}
	
	function formatWeekdayLong(i) {
	  return WEEKDAYS_LONG[i];
	}
	
	function getFirstDayOfWeek() {
	  return 0;
	}
	
	function getMonths() {
	  return MONTHS;
	}
	
	exports.default = {
	  formatDay: formatDay,
	  formatMonthTitle: formatMonthTitle,
	  formatWeekdayShort: formatWeekdayShort,
	  formatWeekdayLong: formatWeekdayLong,
	  getFirstDayOfWeek: getFirstDayOfWeek,
	  getMonths: getMonths
	};
	//# sourceMappingURL=LocaleUtils.js.map

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Proxy object to map classnames when css modules are not used
	
	exports.default = {
	  container: 'DayPicker',
	  wrapper: 'DayPicker-wrapper',
	  interactionDisabled: 'DayPicker--interactionDisabled',
	  months: 'DayPicker-Months',
	  month: 'DayPicker-Month',
	
	  navBar: 'DayPicker-NavBar',
	  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
	  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
	  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',
	
	  caption: 'DayPicker-Caption',
	  weekdays: 'DayPicker-Weekdays',
	  weekdaysRow: 'DayPicker-WeekdaysRow',
	  weekday: 'DayPicker-Weekday',
	  body: 'DayPicker-Body',
	  week: 'DayPicker-Week',
	  weekNumber: 'DayPicker-WeekNumber',
	  day: 'DayPicker-Day',
	  footer: 'DayPicker-Footer',
	  todayButton: 'DayPicker-TodayButton',
	
	  // default modifiers
	  today: 'today',
	  selected: 'selected',
	  disabled: 'disabled',
	  outside: 'outside'
	};
	//# sourceMappingURL=classNames.js.map

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LEFT = exports.LEFT = 37;
	var UP = exports.UP = 38;
	var RIGHT = exports.RIGHT = 39;
	var DOWN = exports.DOWN = 40;
	var ENTER = exports.ENTER = 13;
	var SPACE = exports.SPACE = 32;
	var ESC = exports.ESC = 27;
	var TAB = exports.TAB = 9;
	//# sourceMappingURL=keys.js.map

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(24);
	
	var EventPluginRegistry = __webpack_require__(366);
	var ReactEventEmitterMixin = __webpack_require__(1640);
	var ViewportMetrics = __webpack_require__(772);
	
	var getVendorPrefixedEventName = __webpack_require__(1672);
	var isEventSupported = __webpack_require__(377);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(189);
	var ViewportMetrics = __webpack_require__(772);
	
	var getEventModifierState = __webpack_require__(375);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var invariant = __webpack_require__(13);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(55);
	var DOMNamespaces = __webpack_require__(365);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(373);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GatewayRegistry = function () {
	  function GatewayRegistry() {
	    _classCallCheck(this, GatewayRegistry);
	
	    this._containers = {};
	    this._children = {};
	
	    // Unique key for children of a gateway
	    this._currentId = 0;
	  }
	
	  GatewayRegistry.prototype._renderContainer = function _renderContainer(name) {
	    var _this = this;
	
	    if (!this._containers[name] || !this._children[name]) {
	      return;
	    }
	
	    this._containers[name].setState({
	      children: Object.keys(this._children[name]).sort().map(function (id) {
	        return _this._children[name][id];
	      })
	    });
	  };
	
	  GatewayRegistry.prototype.addContainer = function addContainer(name, container) {
	    this._containers[name] = container;
	    this._renderContainer(name);
	  };
	
	  GatewayRegistry.prototype.removeContainer = function removeContainer(name) {
	    this._containers[name] = null;
	  };
	
	  GatewayRegistry.prototype.addChild = function addChild(name, gatewayId, child) {
	    this._children[name][gatewayId] = child;
	    this._renderContainer(name);
	  };
	
	  GatewayRegistry.prototype.clearChild = function clearChild(name, gatewayId) {
	    delete this._children[name][gatewayId];
	  };
	
	  GatewayRegistry.prototype.register = function register(name, child) {
	    this._children[name] = this._children[name] || {};
	
	    var gatewayId = name + "_" + this._currentId;
	    this._children[name][gatewayId] = child;
	    this._currentId += 1;
	
	    return gatewayId;
	  };
	
	  GatewayRegistry.prototype.unregister = function unregister(name, gatewayId) {
	    this.clearChild(name, gatewayId);
	    this._renderContainer(name);
	  };
	
	  return GatewayRegistry;
	}();
	
	exports.default = GatewayRegistry;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _hexToRgb = __webpack_require__(257);
	
	var _removeClass$getTopMargin$fadeIn$show$addClass = __webpack_require__(191);
	
	var _defaultParams = __webpack_require__(813);
	
	var _defaultParams2 = _interopRequireWildcard(_defaultParams);
	
	/*
	 * Add modal + overlay to DOM
	 */
	
	var _injectedHTML = __webpack_require__(1810);
	
	var _injectedHTML2 = _interopRequireWildcard(_injectedHTML);
	
	var modalClass = '.sweet-alert';
	var overlayClass = '.sweet-overlay';
	
	var sweetAlertInitialize = function sweetAlertInitialize() {
	  var sweetWrap = document.createElement('div');
	  sweetWrap.innerHTML = _injectedHTML2['default'];
	
	  // Append elements to body
	  while (sweetWrap.firstChild) {
	    document.body.appendChild(sweetWrap.firstChild);
	  }
	};
	
	/*
	 * Get DOM element of modal
	 */
	var getModal = (function (_getModal) {
	  function getModal() {
	    return _getModal.apply(this, arguments);
	  }
	
	  getModal.toString = function () {
	    return _getModal.toString();
	  };
	
	  return getModal;
	})(function () {
	  var $modal = document.querySelector(modalClass);
	
	  if (!$modal) {
	    sweetAlertInitialize();
	    $modal = getModal();
	  }
	
	  return $modal;
	});
	
	/*
	 * Get DOM element of input (in modal)
	 */
	var getInput = function getInput() {
	  var $modal = getModal();
	  if ($modal) {
	    return $modal.querySelector('input');
	  }
	};
	
	/*
	 * Get DOM element of overlay
	 */
	var getOverlay = function getOverlay() {
	  return document.querySelector(overlayClass);
	};
	
	/*
	 * Add box-shadow style to button (depending on its chosen bg-color)
	 */
	var setFocusStyle = function setFocusStyle($button, bgColor) {
	  var rgbColor = _hexToRgb.hexToRgb(bgColor);
	  $button.style.boxShadow = '0 0 2px rgba(' + rgbColor + ', 0.8), inset 0 0 0 1px rgba(0, 0, 0, 0.05)';
	};
	
	/*
	 * Animation when opening modal
	 */
	var openModal = function openModal(callback) {
	  var $modal = getModal();
	  _removeClass$getTopMargin$fadeIn$show$addClass.fadeIn(getOverlay(), 10);
	  _removeClass$getTopMargin$fadeIn$show$addClass.show($modal);
	  _removeClass$getTopMargin$fadeIn$show$addClass.addClass($modal, 'showSweetAlert');
	  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($modal, 'hideSweetAlert');
	
	  window.previousActiveElement = document.activeElement;
	  var $okButton = $modal.querySelector('button.confirm');
	  $okButton.focus();
	
	  setTimeout(function () {
	    _removeClass$getTopMargin$fadeIn$show$addClass.addClass($modal, 'visible');
	  }, 500);
	
	  var timer = $modal.getAttribute('data-timer');
	
	  if (timer !== 'null' && timer !== '') {
	    var timerCallback = callback;
	    $modal.timeout = setTimeout(function () {
	      var doneFunctionExists = (timerCallback || null) && $modal.getAttribute('data-has-done-function') === 'true';
	      if (doneFunctionExists) {
	        timerCallback(null);
	      } else {
	        sweetAlert.close();
	      }
	    }, timer);
	  }
	};
	
	/*
	 * Reset the styling of the input
	 * (for example if errors have been shown)
	 */
	var resetInput = function resetInput() {
	  var $modal = getModal();
	  var $input = getInput();
	
	  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($modal, 'show-input');
	  $input.value = _defaultParams2['default'].inputValue;
	  $input.setAttribute('type', _defaultParams2['default'].inputType);
	  $input.setAttribute('placeholder', _defaultParams2['default'].inputPlaceholder);
	
	  resetInputError();
	};
	
	var resetInputError = function resetInputError(event) {
	  // If press enter => ignore
	  if (event && event.keyCode === 13) {
	    return false;
	  }
	
	  var $modal = getModal();
	
	  var $errorIcon = $modal.querySelector('.sa-input-error');
	  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($errorIcon, 'show');
	
	  var $errorContainer = $modal.querySelector('.sa-error-container');
	  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($errorContainer, 'show');
	};
	
	/*
	 * Set "margin-top"-property on modal based on its computed height
	 */
	var fixVerticalPosition = function fixVerticalPosition() {
	  var $modal = getModal();
	  $modal.style.marginTop = _removeClass$getTopMargin$fadeIn$show$addClass.getTopMargin(getModal());
	};
	
	exports.sweetAlertInitialize = sweetAlertInitialize;
	exports.getModal = getModal;
	exports.getOverlay = getOverlay;
	exports.getInput = getInput;
	exports.setFocusStyle = setFocusStyle;
	exports.openModal = openModal;
	exports.resetInput = resetInput;
	exports.resetInputError = resetInputError;
	exports.fixVerticalPosition = fixVerticalPosition;

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	/*
	 * Allow user to pass their own params
	 */
	var extend = function extend(a, b) {
	  for (var key in b) {
	    if (b.hasOwnProperty(key)) {
	      a[key] = b[key];
	    }
	  }
	  return a;
	};
	
	/*
	 * Convert HEX codes to RGB values (#000000 -> rgb(0,0,0))
	 */
	var hexToRgb = function hexToRgb(hex) {
	  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	  return result ? parseInt(result[1], 16) + ', ' + parseInt(result[2], 16) + ', ' + parseInt(result[3], 16) : null;
	};
	
	/*
	 * Check if the user is using Internet Explorer 8 (for fallbacks)
	 */
	var isIE8 = function isIE8() {
	  return window.attachEvent && !window.addEventListener;
	};
	
	/*
	 * IE compatible logging for developers
	 */
	var logStr = function logStr(string) {
	  if (window.console) {
	    // IE...
	    window.console.log('SweetAlert: ' + string);
	  }
	};
	
	/*
	 * Set hover, active and focus-states for buttons 
	 * (source: http://www.sitepoint.com/javascript-generate-lighter-darker-color)
	 */
	var colorLuminance = function colorLuminance(hex, lum) {
	  // Validate hex string
	  hex = String(hex).replace(/[^0-9a-f]/gi, '');
	  if (hex.length < 6) {
	    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	  }
	  lum = lum || 0;
	
	  // Convert to decimal and change luminosity
	  var rgb = '#';
	  var c;
	  var i;
	
	  for (i = 0; i < 3; i++) {
	    c = parseInt(hex.substr(i * 2, 2), 16);
	    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
	    rgb += ('00' + c).substr(c.length);
	  }
	
	  return rgb;
	};
	
	exports.extend = extend;
	exports.hexToRgb = hexToRgb;
	exports.isIE8 = isIE8;
	exports.logStr = logStr;
	exports.colorLuminance = colorLuminance;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * Module dependencies.
	 */
	
	var type = __webpack_require__(86);
	
	/**
	 * Deeply clone an object.
	 *
	 * @param {*} obj Any object.
	 */
	
	var clone = function clone(obj) {
	  var t = type(obj);
	
	  if (t === 'object') {
	    var copy = {};
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        copy[key] = clone(obj[key]);
	      }
	    }
	    return copy;
	  }
	
	  if (t === 'array') {
	    var copy = new Array(obj.length);
	    for (var i = 0, l = obj.length; i < l; i++) {
	      copy[i] = clone(obj[i]);
	    }
	    return copy;
	  }
	
	  if (t === 'regexp') {
	    // from millermedeiros/amd-utils - MIT
	    var flags = '';
	    flags += obj.multiline ? 'm' : '';
	    flags += obj.global ? 'g' : '';
	    flags += obj.ignoreCase ? 'i' : '';
	    return new RegExp(obj.source, flags);
	  }
	
	  if (t === 'date') {
	    return new Date(obj.getTime());
	  }
	
	  // string, number, boolean, etc.
	  return obj;
	};
	
	/*
	 * Exports.
	 */
	
	module.exports = clone;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_clonedeep_1 = __importDefault(__webpack_require__(212));
	/**
	 * Module dependencies.
	 */
	var bindAll = __webpack_require__(118);
	var cookie = __webpack_require__(397);
	var debug = __webpack_require__(110)('analytics.js:cookie');
	var topDomain = __webpack_require__(858);
	var MAX_AGE_ONE_YEAR = 31536000000;
	/**
	 * Initialize a new `Cookie` with `options`.
	 *
	 * @param {Object} options
	 */
	function Cookie(options) {
	    this.options(options);
	}
	/**
	 * Get or set the cookie options.
	 */
	Cookie.prototype.options = function (options) {
	    if (arguments.length === 0)
	        return this._options;
	    options = options || {};
	    var domain = '.' + topDomain(window.location.href);
	    if (domain === '.')
	        domain = null;
	    var defaults = {
	        maxage: MAX_AGE_ONE_YEAR,
	        domain: domain,
	        path: '/',
	        sameSite: 'Lax'
	    };
	    this._options = __assign(__assign({}, defaults), options);
	    // http://curl.haxx.se/rfc/cookie_spec.html
	    // https://publicsuffix.org/list/effective_tld_names.dat
	    //
	    // try setting a dummy cookie with the options
	    // if the cookie isn't set, it probably means
	    // that the domain is on the public suffix list
	    // like myapp.herokuapp.com or localhost / ip.
	    this.set('ajs:test', true);
	    if (!this.get('ajs:test')) {
	        debug('fallback to domain=null');
	        this._options.domain = null;
	    }
	    this.remove('ajs:test');
	};
	/**
	 * Set a `key` and `value` in our cookie.
	 */
	Cookie.prototype.set = function (key, value) {
	    try {
	        value = window.JSON.stringify(value);
	        cookie(key, value === 'null' ? null : value, lodash_clonedeep_1.default(this._options));
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	};
	/**
	 * Get a value from our cookie by `key`.
	 */
	Cookie.prototype.get = function (key) {
	    try {
	        var value = cookie(key);
	        value = value ? window.JSON.parse(value) : null;
	        return value;
	    }
	    catch (e) {
	        return null;
	    }
	};
	/**
	 * Remove a value from our cookie by `key`.
	 */
	Cookie.prototype.remove = function (key) {
	    try {
	        cookie(key, null, lodash_clonedeep_1.default(this._options));
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	};
	/**
	 * Expose the cookie singleton.
	 */
	module.exports = bindAll(new Cookie());
	/**
	 * Expose the `Cookie` constructor.
	 */
	module.exports.Cookie = Cookie;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Facade = __webpack_require__(131);
	module.exports.SourceMiddlewareChain = function SourceMiddlewareChain() {
	    var apply = middlewareChain(this);
	    this.applyMiddlewares = function (facade, integrations, callback) {
	        return apply(function (mw, payload, next) {
	            mw({
	                integrations: integrations,
	                next: next,
	                payload: payload
	            });
	        }, facade, callback);
	    };
	};
	module.exports.IntegrationMiddlewareChain = function IntegrationMiddlewareChain() {
	    var apply = middlewareChain(this);
	    this.applyMiddlewares = function (facade, integration, callback) {
	        return apply(function (mw, payload, next) {
	            mw(payload, integration, next);
	        }, facade, callback);
	    };
	};
	module.exports.DestinationMiddlewareChain = function DestinationMiddlewareChain() {
	    var apply = middlewareChain(this);
	    this.applyMiddlewares = function (facade, integration, callback) {
	        return apply(function (mw, payload, next) {
	            mw({ payload: payload, integration: integration, next: next });
	        }, facade, callback);
	    };
	};
	// Chain is essentially a linked list of middlewares to run in order.
	function middlewareChain(dest) {
	    var middlewares = [];
	    // Return a copy to prevent external mutations.
	    dest.getMiddlewares = function () {
	        return middlewares.slice();
	    };
	    dest.add = function (middleware) {
	        if (typeof middleware !== 'function')
	            throw new Error('attempted to add non-function middleware');
	        // Check for identical object references - bug check.
	        if (middlewares.indexOf(middleware) !== -1)
	            throw new Error('middleware is already registered');
	        middlewares.push(middleware);
	    };
	    // fn is the callback to be run once all middlewares have been applied.
	    return function applyMiddlewares(run, facade, callback) {
	        if (typeof facade !== 'object')
	            throw new Error('applyMiddlewares requires a payload object');
	        if (typeof callback !== 'function')
	            throw new Error('applyMiddlewares requires a function callback');
	        // Attach callback to the end of the chain.
	        var middlewaresToApply = middlewares.slice();
	        middlewaresToApply.push(callback);
	        executeChain(run, facade, middlewaresToApply, 0);
	    };
	}
	// Go over all middlewares until all have been applied.
	function executeChain(run, payload, middlewares, index) {
	    // If the facade has been nullified, immediately skip to the final middleware.
	    if (payload === null) {
	        middlewares[middlewares.length - 1](null);
	        return;
	    }
	    // Check if the payload is still a Facade. If not, convert it to one.
	    if (!(payload instanceof Facade)) {
	        payload = new Facade(payload);
	    }
	    var mw = middlewares[index];
	    if (mw) {
	        // If there's another middleware, continue down the chain. Otherwise, call the final function.
	        if (middlewares[index + 1]) {
	            run(mw, payload, function (result) {
	                executeChain(run, result, middlewares, ++index);
	            });
	        }
	        else {
	            mw(payload);
	        }
	    }
	}
	module.exports.middlewareChain = middlewareChain;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Module dependencies.
	 */
	var bindAll = __webpack_require__(118);
	var store = __webpack_require__(856);
	/**
	 * Initialize a new `Store` with `options`.
	 *
	 * @param {Object} options
	 */
	function Store(options) {
	    this.options(options);
	}
	/**
	 * Set the `options` for the store.
	 */
	Store.prototype.options = function (options) {
	    if (arguments.length === 0)
	        return this._options;
	    options = options || {};
	    options = __assign({ enabled: true }, options);
	    this.enabled = options.enabled && store.enabled;
	    this._options = options;
	};
	/**
	 * Set a `key` and `value` in local storage.
	 */
	Store.prototype.set = function (key, value) {
	    if (!this.enabled)
	        return false;
	    return store.set(key, value);
	};
	/**
	 * Get a value from local storage by `key`.
	 */
	Store.prototype.get = function (key) {
	    if (!this.enabled)
	        return null;
	    return store.get(key);
	};
	/**
	 * Remove a value from local storage by `key`.
	 */
	Store.prototype.remove = function (key) {
	    if (!this.enabled)
	        return false;
	    return store.remove(key);
	};
	/**
	 * Expose the store singleton.
	 */
	module.exports = bindAll(new Store());
	/**
	 * Expose the `Store` constructor.
	 */
	module.exports.Store = Store;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AcceptCookies = exports.getAcceptCookie = undefined;
	
	var _selectors = __webpack_require__(868);
	
	Object.defineProperty(exports, 'getAcceptCookie', {
	  enumerable: true,
	  get: function get() {
	    return _selectors.getAcceptCookie;
	  }
	});
	
	var _AcceptCookies = __webpack_require__(865);
	
	var _AcceptCookies2 = _interopRequireDefault(_AcceptCookies);
	
	var _AcceptCookies3 = __webpack_require__(866);
	
	var _AcceptCookies4 = _interopRequireDefault(_AcceptCookies3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AcceptCookies = exports.AcceptCookies = (0, _AcceptCookies4.default)(_AcceptCookies2.default);

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debounce2 = __webpack_require__(124);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddScrollHeight = function (_Component) {
	  _inherits(AddScrollHeight, _Component);
	
	  function AddScrollHeight(props) {
	    _classCallCheck(this, AddScrollHeight);
	
	    var _this = _possibleConstructorReturn(this, (AddScrollHeight.__proto__ || Object.getPrototypeOf(AddScrollHeight)).call(this, props));
	
	    _this.onResize = (0, _debounce3.default)(function () {
	      return _this.calculateChildrenHeight();
	    }, 150);
	
	    _this.state = {
	      height: 0
	    };
	    return _this;
	  }
	
	  _createClass(AddScrollHeight, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.onResize);
	      this.calculateChildrenHeight();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.onResize);
	    }
	  }, {
	    key: 'calculateChildrenHeight',
	    value: function calculateChildrenHeight() {
	      this.setState({
	        height: (0, _get3.default)(this.el, 'children[0].clientHeight', 0)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(el) {
	            _this2.el = el;
	          },
	          style: { height: this.state.height }
	        },
	        this.props.children
	      );
	    }
	  }]);
	
	  return AddScrollHeight;
	}(_react.Component);
	
	AddScrollHeight.propTypes = {
	  children: _propTypes2.default.element.isRequired
	};
	
	exports.default = AddScrollHeight;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Input = __webpack_require__(266);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Checkbox = __webpack_require__(900);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _shapes = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Field = function Field(_ref) {
	  var id = _ref.id,
	      label = _ref.label,
	      type = _ref.type,
	      error = _ref.error,
	      errorMessage = _ref.errorMessage,
	      onChange = _ref.onChange,
	      onBlur = _ref.onBlur,
	      autoComplete = _ref.autoComplete,
	      name = _ref.name,
	      required = _ref.required,
	      className = _ref.className,
	      value = _ref.value;
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('c-field', className) },
	    type === 'checkbox' ? _react2.default.createElement(_Checkbox2.default, { id: id, label: label, onChange: onChange, name: name, required: required }) : _react2.default.createElement(_Input2.default, Object.assign({
	      autoCorrect: 'off',
	      spellCheck: 'false'
	    }, { id: id, label: label, onChange: onChange, onBlur: onBlur, type: type, autoComplete: autoComplete, name: name, required: required, value: value })),
	    error && _react2.default.createElement(
	      'div',
	      { className: 'c-field__message', style: { color: 'red' } },
	      errorMessage
	    )
	  );
	};
	Field.propTypes = _shapes.fieldPropTypes;
	Field.defaultProps = {
	  type: 'text',
	  errorMessage: 'Please fill field',
	  error: false,
	  name: '',
	  autoComplete: 'on',
	  required: false,
	  onChange: null,
	  onBlur: null
	};
	
	exports.default = Field;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _sweetalertReact = __webpack_require__(132);
	
	var _sweetalertReact2 = _interopRequireDefault(_sweetalertReact);
	
	var _actions = __webpack_require__(111);
	
	var _history = __webpack_require__(201);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GlobalErrorAndRedirectionListener = function (_Component) {
	  _inherits(GlobalErrorAndRedirectionListener, _Component);
	
	  function GlobalErrorAndRedirectionListener(props) {
	    _classCallCheck(this, GlobalErrorAndRedirectionListener);
	
	    var _this = _possibleConstructorReturn(this, (GlobalErrorAndRedirectionListener.__proto__ || Object.getPrototypeOf(GlobalErrorAndRedirectionListener)).call(this, props));
	
	    _this.closeModal = _this.closeModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(GlobalErrorAndRedirectionListener, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      if (this.props.errorMessage !== nextProps.errorMessage) return true;
	      if (this.props.redirectTo !== nextProps.redirectTo) return true;
	
	      return false;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!this.props.hasError && this.props.redirectTo) this.redirect();
	    }
	  }, {
	    key: 'redirect',
	    value: function redirect() {
	      if (!this.props.redirectTo) return;
	
	      _history.history.push(this.props.redirectTo);
	      this.props.clearRedirection();
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.props.clearErrors();
	      this.redirect();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _split = (this.props.errorMessage || '').split('. '),
	          _split2 = _toArray(_split),
	          title = _split2[0],
	          rest = _split2.slice(1);
	
	      var text = rest.join('. ');
	
	      return _react2.default.createElement(_sweetalertReact2.default, {
	        show: this.props.hasError,
	        title: title || 'Error',
	        text: text,
	        type: 'error',
	        confirmButtonColor: '#dd6b55',
	        confirmButtonText: this.props.confirmButtonText,
	        onEscapeKey: this.closeModal,
	        onConfirm: this.closeModal
	      });
	    }
	  }]);
	
	  return GlobalErrorAndRedirectionListener;
	}(_react.Component);
	
	GlobalErrorAndRedirectionListener.propTypes = {
	  errorMessage: _propTypes2.default.string,
	  redirectTo: _propTypes2.default.string,
	  clearErrors: _propTypes2.default.func.isRequired,
	  hasError: _propTypes2.default.bool,
	  clearRedirection: _propTypes2.default.func.isRequired,
	  confirmButtonText: _propTypes2.default.string
	};
	GlobalErrorAndRedirectionListener.defaultProps = {
	  errorMessage: '',
	  redirectTo: '',
	  hasError: false,
	  confirmButtonText: 'Back to home'
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    errorMessage: state.app.error_message,
	    redirectTo: state.app.redirect_to,
	    hasError: state.app.error_message && state.app.error_message.length > 0,
	    confirmButtonText: state.app.confirmButtonText
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    clearRedirection: function clearRedirection() {
	      return dispatch((0, _actions.clearRedirection)());
	    },
	    clearErrors: function clearErrors() {
	      return dispatch((0, _actions.clearErrors)());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GlobalErrorAndRedirectionListener);

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pickBy2 = __webpack_require__(105);
	
	var _pickBy3 = _interopRequireDefault(_pickBy2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _renderComponent2 = __webpack_require__(57);
	
	var _renderComponent3 = _interopRequireDefault(_renderComponent2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PhoneInput = __webpack_require__(910);
	
	var _PhoneInput2 = _interopRequireDefault(_PhoneInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)((0, _withProps3.default)(function (props) {
	  return (0, _pickBy3.default)({
	    className: (0, _classnames2.default)('c-input u-mt--', props.className, { 'c-input--small': props.size === 'small' }),
	    placeholder: props.label
	  });
	}), (0, _branch3.default)(function (props) {
	  return props.type === 'tel';
	}, (0, _renderComponent3.default)(_PhoneInput2.default)))('input');

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactResponsive = __webpack_require__(1704);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var breakpoints = {
	  desktop: '(min-width: 1025px)',
	  notDesktop: '(max-width: 1024px)',
	  tablet: '(min-width: 768px) and (max-width: 1024px)',
	  phone: '(max-width: 767px)'
	};
	
	var Breakpoint = function Breakpoint(props) {
	  var breakpoint = breakpoints[props.name] || breakpoints.desktop;
	  return _react2.default.createElement(
	    _reactResponsive2.default,
	    Object.assign({}, props, { query: breakpoint }),
	    props.children
	  );
	};
	
	Breakpoint.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = Breakpoint;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AddScrollHeight = __webpack_require__(263);
	
	var _AddScrollHeight2 = _interopRequireDefault(_AddScrollHeight);
	
	var _Services = __webpack_require__(1217);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _PickTime = __webpack_require__(468);
	
	var _PickTime2 = _interopRequireDefault(_PickTime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DynamicServices = function DynamicServices(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Services2.default, props),
	    _react2.default.createElement(
	      _AddScrollHeight2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'c-second-layer' },
	        _react2.default.createElement(_PickTime2.default, Object.assign({}, props, { autoHeight: true, from: 'service' }))
	      )
	    )
	  );
	};
	
	exports.default = DynamicServices;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _contains2 = __webpack_require__(737);
	
	var _contains3 = _interopRequireDefault(_contains2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__(6);
	
	var _actions = __webpack_require__(952);
	
	var _selectors = __webpack_require__(417);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    extensions: _extends({}, state.extensions.byId, state.extensions.byRoute),
	    loadingList: (0, _selectors.getLoadingList)(state)
	  };
	};
	
	var mapDispatchToProps = { fetchExtension: _actions.fetchExtension };
	
	exports.default = (0, _compose3.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _withHandlers3.default)({
	  fetchExtension: function fetchExtension(props) {
	    return function (idOrRoute, isBrandPageLookup) {
	      if (props.extensions[idOrRoute]) return;
	      if ((0, _contains3.default)(idOrRoute, props.loadingList)) return;
	
	      props.fetchExtension(idOrRoute, isBrandPageLookup);
	    };
	  }
	}));

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _anyPass2 = __webpack_require__(1542);
	
	var _anyPass3 = _interopRequireDefault(_anyPass2);
	
	var _equals2 = __webpack_require__(107);
	
	var _equals3 = _interopRequireDefault(_equals2);
	
	var _none2 = __webpack_require__(752);
	
	var _none3 = _interopRequireDefault(_none2);
	
	var _not2 = __webpack_require__(753);
	
	var _not3 = _interopRequireDefault(_not2);
	
	var _pathEq2 = __webpack_require__(1581);
	
	var _pathEq3 = _interopRequireDefault(_pathEq2);
	
	var _propEq2 = __webpack_require__(755);
	
	var _propEq3 = _interopRequireDefault(_propEq2);
	
	var _isNil2 = __webpack_require__(751);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _complement2 = __webpack_require__(357);
	
	var _complement3 = _interopRequireDefault(_complement2);
	
	var _both2 = __webpack_require__(356);
	
	var _both3 = _interopRequireDefault(_both2);
	
	var _prop2 = __webpack_require__(88);
	
	var _prop3 = _interopRequireDefault(_prop2);
	
	var _pipe2 = __webpack_require__(75);
	
	var _pipe3 = _interopRequireDefault(_pipe2);
	
	var _withRouter = __webpack_require__(799);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	var _WithShops = __webpack_require__(430);
	
	var _WithShops2 = _interopRequireDefault(_WithShops);
	
	var _withAreGcSalesDisabledForBarber = __webpack_require__(421);
	
	var _withAreGcSalesDisabledForBarber2 = _interopRequireDefault(_withAreGcSalesDisabledForBarber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createUserTypeRouteChecker = function createUserTypeRouteChecker(userType) {
	  return (0, _pipe3.default)((0, _prop3.default)('params'), (0, _prop3.default)(userType + 'Route'), (0, _complement3.default)(_isNil3.default));
	};
	
	var isBrandRouteActive = createUserTypeRouteChecker('brand');
	var isDisabledOnBrandPage = (0, _both3.default)(isBrandRouteActive, (0, _pipe3.default)((0, _prop3.default)('shops'), (0, _none3.default)((0, _pipe3.default)((0, _prop3.default)('customerGiftCardEnabled'), (0, _equals3.default)(true)))));
	
	var isShopRouteActive = createUserTypeRouteChecker('shop');
	var isDisabledOnShopPage = (0, _both3.default)(isShopRouteActive, (0, _pipe3.default)((0, _pathEq3.default)(['shop', 'customerGiftCardEnabled'], true), _not3.default));
	
	var isBarberRouteActive = createUserTypeRouteChecker('barber');
	var isDisabledOnBarberPage = (0, _both3.default)(isBarberRouteActive, (0, _propEq3.default)('areGcSalesDisabledForBarber', true));
	
	exports.default = (0, _compose3.default)(_WithShop2.default, _WithShops2.default, _withRouter2.default, _withAreGcSalesDisabledForBarber2.default, (0, _branch3.default)((0, _anyPass3.default)([isDisabledOnBrandPage, isDisabledOnShopPage, isDisabledOnBarberPage]), _renderNothing3.default));

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(423);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    gcBarber: (0, _selectors.getGiftCardBarber)(state)
	  };
	});

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propOr2 = __webpack_require__(1584);
	
	var _propOr3 = _interopRequireDefault(_propOr2);
	
	var _prop2 = __webpack_require__(88);
	
	var _prop3 = _interopRequireDefault(_prop2);
	
	var _pipe2 = __webpack_require__(75);
	
	var _pipe3 = _interopRequireDefault(_pipe2);
	
	var _find2 = __webpack_require__(740);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _equals2 = __webpack_require__(107);
	
	var _equals3 = _interopRequireDefault(_equals2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _helpers = __webpack_require__(979);
	
	var _helpers2 = __webpack_require__(7);
	
	var _WithGiftCardUrlPattern = __webpack_require__(276);
	
	var _WithGiftCardUrlPattern2 = _interopRequireDefault(_WithGiftCardUrlPattern);
	
	var _WithShops = __webpack_require__(430);
	
	var _WithShops2 = _interopRequireDefault(_WithShops);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getGcSalesShop = (0, _find3.default)((0, _pipe3.default)((0, _prop3.default)('customerGiftCardEnabled'), (0, _equals3.default)(true)));
	
	var getBrandId = (0, _pipe3.default)((0, _find3.default)((0, _pipe3.default)((0, _prop3.default)('brandId'), Boolean, (0, _equals3.default)(true))), (0, _propOr3.default)(null, 'brandId'));
	
	var withBrandGiftCardLink = (0, _compose3.default)(_WithGiftCardUrlPattern2.default, _WithShops2.default, (0, _withProps3.default)(function (props) {
	  var shop = getGcSalesShop(props.shops);
	  var brand = getBrandId(props.shops);
	  if (!shop || !brand) {
	    return { link: null };
	  }
	
	  var params = { shopRoute: shop.route };
	  return {
	    link: (0, _helpers.getNextLink)(params, function () {
	      return (0, _helpers2.generateUrlString)(params, props.urlPattern);
	    }, false, brand)
	  };
	}));
	
	var withGiftCardLink = (0, _compose3.default)(_WithGiftCardUrlPattern2.default, _reactRouter.withRouter, (0, _withProps3.default)(function (props) {
	  return {
	    link: (0, _helpers.getNextLink)(props.params, function () {
	      return (0, _helpers2.generateUrlString)(props.params, props.urlPattern);
	    }, false)
	  };
	}));
	
	exports.default = (0, _branch3.default)(function (props) {
	  return props.withBrand;
	}, withBrandGiftCardLink, withGiftCardLink);

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WithAnyBarber = (0, _compose3.default)(_reactRouter.withRouter, (0, _withProps3.default)(function (props) {
	  return {
	    anyBarber: props.params.barberRoute === _constants.ANY_BARBER
	  };
	}));
	
	exports.default = WithAnyBarber;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    hasApplePay: state.app.applePay
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps);

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(11);
	
	var _selectors2 = __webpack_require__(27);
	
	var _actions = __webpack_require__(99);
	
	var _constants = __webpack_require__(10);
	
	var _selectors3 = __webpack_require__(51);
	
	var _selectors4 = __webpack_require__(21);
	
	var reservationSelectors = _interopRequireWildcard(_selectors4);
	
	var _WithKioskProp = __webpack_require__(59);
	
	var _WithKioskProp2 = _interopRequireDefault(_WithKioskProp);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WithFetchAvailability = (0, _compose3.default)(_WithKioskProp2.default, _reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  var serviceId = ownProps.params.serviceId || reservationSelectors.getServiceIds(state);
	  var serviceDuration = (0, _selectors3.getServiceDuration)(state, serviceId) || reservationSelectors.getServiceDuration(state);
	  return {
	    anyBarber: ownProps.params.barberRoute === _constants.ANY_BARBER || reservationSelectors.getBookedWithAnyBarber(state),
	    shopId: (0, _selectors.getShopId)(state, ownProps.params.shopRoute) || reservationSelectors.getShopId(state),
	    barberId: (0, _selectors2.getBarberId)(state, ownProps.params.barberRoute) || reservationSelectors.getBarberId(state),
	    serviceDuration: serviceDuration,
	    serviceId: serviceId
	  };
	}, {
	  fetchBarberAvailability: _actions.fetchBarberAvailability,
	  fetchShopBarberAvailability: _actions.fetchShopBarberAvailability
	}), (0, _withHandlers3.default)({
	  fetchAvailability: function fetchAvailability(props) {
	    return function (fromDate, endDate, appointmentId) {
	      if (props.anyBarber) {
	        return props.fetchShopBarberAvailability(props.shopId, props.serviceId, fromDate, endDate, appointmentId, props.kiosk);
	      }
	      return props.fetchBarberAvailability(props.barberId, props.shopId, props.serviceDuration, fromDate, endDate, appointmentId, props.kiosk, props.params.shopRoute);
	    };
	  }
	}));
	
	exports.default = WithFetchAvailability;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _withProps3.default)({
	  urlPattern: _config2.default.urlPatterns.giftCard
	});

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getInstantExperiencesOwner = exports.getInstantExperiences = undefined;
	
	var _path2 = __webpack_require__(87);
	
	var _path3 = _interopRequireDefault(_path2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line import/prefer-default-export
	var getInstantExperiences = exports.getInstantExperiences = (0, _path3.default)(['instantExperiences', 'enabled']);
	var getInstantExperiencesOwner = exports.getInstantExperiencesOwner = (0, _path3.default)(['instantExperiences', 'owner']);

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendReminderSMSLinkClickedEvent = exports.sendAppLinkSms = undefined;
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sendAppLinkSms = exports.sendAppLinkSms = function sendAppLinkSms(brandId, phone) {
	  var url = brandId ? _config2.default.url + '/brand/' + brandId + '/sms-app-link' : _config2.default.url + '/customer/sms-app-link';
	  return fetch(url, {
	    method: 'POST',
	    headers: {
	      Accept: 'application/json',
	      'Content-Type': 'application/json'
	    },
	    body: JSON.stringify({
	      phone: phone
	    })
	  }).then(_helpers.checkStatus).catch(_helpers.handleRequestError);
	};
	
	var sendReminderSMSLinkClickedEvent = exports.sendReminderSMSLinkClickedEvent = function sendReminderSMSLinkClickedEvent(customerId, brandId, redirectLink, userAgent) {
	  var url = _config2.default.fullstory.url + '/v2/events';
	  var name = 'Rebooking Reminder SMS Link Clicked';
	  var event = {
	    user: {
	      uid: customerId
	    },
	    name: name,
	    timestamp: new Date().toISOString(),
	    properties: {
	      source: 'Squire Web',
	      title: 'Customer ' + customerId + ': ' + name,
	      customer_id: customerId,
	      brand_id: brandId,
	      redirect_link: redirectLink,
	      user_agent: userAgent
	    }
	  };
	
	  return fetch(url, {
	    method: 'POST',
	    headers: {
	      Accept: 'application/json',
	      'Content-Type': 'application/json',
	      Authorization: 'Basic ' + _config2.default.fullstory.apiKey
	    },
	    body: JSON.stringify(event)
	  }).then(_helpers.checkStatus).catch(_helpers.handleRequestError);
	};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Footer = function Footer(_ref) {
	  var link = _ref.link;
	  return _react2.default.createElement(
	    "div",
	    { className: "u-pb-30 u-mt-4 u-text-small u-co-grey--light u-ta-center shared-footer" },
	    "To manage notifications\xA0",
	    _react2.default.createElement(
	      "a",
	      { className: "u-co-grey--light u-td-underline u-co-black-2", href: link, target: "_blank" },
	      "click here"
	    ),
	    "."
	  );
	};
	
	exports.default = Footer;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center flgshp-header' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        children
	      )
	    ),
	    children
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Injecting global styles to override values but ONLY if this
	// component exists in the DOM. Othwerwise CSS props would leak out
	// to other parts of the application, hence regular import isn't
	// possible.
	
	var Helmets = function Helmets() {
	    return _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement('meta', { name: 'viewport', content: 'width=device-width, initial-scale=1.0' }),
	        _react2.default.createElement(
	            'style',
	            { type: 'text/css' },
	            '.c-notifications-basic-layout {\n            min-width: auto;\n\n            background: linear-gradient(0deg, #eaeaea 0, #fffffe 50%);\n        }\n\n        @media screen and (prefers-color-scheme: dark) {\n            .c-notifications-basic-layout {\n                background: #222222 !important;\n            }\n        }\n      \n        .c-notifications-basic-layout > * {\n            max-width: 632px;\n            width: 100%;\n            margin: auto;\n        }\n        \n        #app {\n            padding-bottom: 0 !important;\n        }'
	        )
	    );
	};
	
	exports.default = Helmets;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _renderComponent2 = __webpack_require__(57);
	
	var _renderComponent3 = _interopRequireDefault(_renderComponent2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _reactRouter = __webpack_require__(5);
	
	var _Loader = __webpack_require__(82);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _withExtensionContextConsumer = __webpack_require__(136);
	
	var _withExtensionContextConsumer2 = _interopRequireDefault(_withExtensionContextConsumer);
	
	var _actions = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _withState3.default)('busy', 'setBusy', true), (0, _withState3.default)('rewardProgram', 'setRewardProgram', null), (0, _withState3.default)('customerReward', 'setCustomerReward', null), _withExtensionContextConsumer2.default, (0, _withPropsOnChange3.default)(['extension'], function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(props) {
	    var promises, _ref2, _ref3, rewardProgram, customerReward;
	
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            if (props.extension) {
	              _context.next = 3;
	              break;
	            }
	
	            props.setBusy(false);
	            return _context.abrupt('return');
	
	          case 3:
	            promises = [(0, _actions.getBrandRewardProgram)(props.extension.brandId)];
	
	            if (props.params.customerRewardId) {
	              promises.push((0, _actions.getCustomerReward)(props.params.customerRewardId));
	            }
	
	            _context.prev = 5;
	            _context.next = 8;
	            return Promise.all(promises);
	
	          case 8:
	            _ref2 = _context.sent;
	            _ref3 = _slicedToArray(_ref2, 2);
	            rewardProgram = _ref3[0];
	            customerReward = _ref3[1];
	
	            props.setRewardProgram(rewardProgram);
	            if (customerReward) {
	              props.setCustomerReward(customerReward);
	            }
	
	          case 14:
	            _context.prev = 14;
	
	            props.setBusy(false);
	            return _context.finish(14);
	
	          case 17:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined, [[5,, 14, 17]]);
	  }));
	
	  return function (_x) {
	    return _ref.apply(this, arguments);
	  };
	}()), (0, _branch3.default)(function (props) {
	  return props.busy;
	}, (0, _renderComponent3.default)(_Loader2.default)), (0, _branch3.default)(function (props) {
	  var shouldWaitForCustomerReward = !!props.params.customerRewardId;
	  return !props.rewardProgram && (!shouldWaitForCustomerReward || props.customerReward);
	}, _renderNothing3.default), (0, _withProps3.default)(function (_ref4) {
	  var rewardProgram = _ref4.rewardProgram,
	      customerReward = _ref4.customerReward;
	  return {
	    isAmountBased: rewardProgram.rewardType === 'value',
	    loyaltyAmountGoal: rewardProgram.goalCounter,
	    loyaltyTransactionsGoal: rewardProgram.numberOfTransactions,
	    loyaltyAmount: rewardProgram.rewardAmount,
	    loyaltyProgress: 50, // it's hardcoded for now
	    loyaltyCode: customerReward ? customerReward.customerPromo.promo.code : null
	  };
	}));

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var AppointmentInfo = function AppointmentInfo(props) {
	  var appointments = props.appointments || [props];
	
	  var shouldShowInfo = appointments.length && appointments[0].confirmationCode || props.waitingList;
	  if (!shouldShowInfo) {
	    return _react2.default.createElement('div', { className: 'c-flagship-appointment-info ' + (props.className || '') });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-flagship-appointment-info ' + (props.className || '') },
	    _react2.default.createElement(
	      'h3',
	      { className: 'u-text-large u-fw-bold u-mb-6' },
	      'Appointment details'
	    ),
	    appointments.map(function (appt, idx) {
	      return _react2.default.createElement(
	        'div',
	        { key: appt.confirmationCode || idx },
	        appointments.length > 1 && idx > 0 && _react2.default.createElement('div', { className: 'c-divider u-mt-5 u-mb-5' }),
	        appt.shopLocation && _react2.default.createElement(
	          'div',
	          { className: 'flgshp-row' },
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-label' },
	            'Location'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-value' },
	            (0, _utils.cut)(appt.shopLocation, 20)
	          )
	        ),
	        appt.confirmationCode && _react2.default.createElement(
	          'div',
	          { className: 'flgshp-row' },
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-label' },
	            'Confirmation code'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-value' },
	            appt.confirmationCode
	          )
	        ),
	        appt.position && _react2.default.createElement(
	          'div',
	          { className: 'flgshp-row' },
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-label' },
	            'Waiting list position'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-value' },
	            appt.position
	          )
	        ),
	        appt.customerName && _react2.default.createElement(
	          'div',
	          { className: 'flgshp-row' },
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-label' },
	            'Client'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-value' },
	            (0, _utils.firstNameAndLastInitial)(appt.customerName)
	          )
	        ),
	        appt.barberName && _react2.default.createElement(
	          'div',
	          { className: 'flgshp-row' },
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-label' },
	            'Professional'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-value' },
	            appt.barberName
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flgshp-row' },
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-label' },
	            'Service'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-value' },
	            (0, _upperFirst3.default)((0, _utils.cut)(appt.service, 20))
	          )
	        ),
	        appt.date && _react2.default.createElement(
	          'div',
	          { className: 'flgshp-row' },
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-label' },
	            'Time'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-value' },
	            appt.date
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flgshp-row' },
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-label' },
	            'Duration'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-value' },
	            appt.duration
	          )
	        ),
	        appt.appointmentNote && _react2.default.createElement(
	          'div',
	          { className: 'u-mt-3 flgshp-row' },
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-label' },
	            'Note'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'flgshp-value u-1/2' },
	            (0, _utils.cut)(appt.appointmentNote, 60)
	          )
	        )
	      );
	    }),
	    props.children
	  );
	};
	
	exports.default = AppointmentInfo;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var FlagshipNotification = function FlagshipNotification(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-flagship-notification ' + (className || '') },
	    children
	  );
	};
	
	exports.default = FlagshipNotification;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var FlagshipRescheduleOrCancel = function FlagshipRescheduleOrCancel(_ref) {
	  var appLink = _ref.appLink,
	      androidLink = _ref.androidLink,
	      iosLink = _ref.iosLink;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "u-mt-8 u-mb-6" },
	        _react2.default.createElement(
	          "a",
	          {
	            className: "u-text-large u-td-none u-dotted-border u-dotted-border--flagship u-co-black u-fw-bold",
	            href: appLink,
	            target: "_blank"
	          },
	          "Reschedule"
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "u-text-large u-fw-bold" },
	          " or "
	        ),
	        _react2.default.createElement(
	          "a",
	          {
	            className: "u-text-large u-td-none u-dotted-border u-dotted-border--flagship u-co-black u-fw-bold",
	            href: appLink,
	            target: "_blank"
	          },
	          "Cancel"
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "u-text-large u-fw-bold" },
	          "\xA0your",
	          _react2.default.createElement("br", null),
	          "appointment using our",
	          _react2.default.createElement("br", null),
	          "free app."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "u-flex" },
	        _react2.default.createElement(
	          "a",
	          { className: "c-store-button u-mr-4", href: androidLink || appLink, target: "_blank" },
	          _react2.default.createElement("img", { src: "https://assets.getsquire.com/images/google-play.png", alt: "" })
	        ),
	        _react2.default.createElement(
	          "a",
	          { className: "c-store-button", href: iosLink || appLink, target: "_blank" },
	          _react2.default.createElement("img", { src: "https://assets.getsquire.com/images/app-store.png", alt: "" })
	        )
	      )
	    ),
	    _react2.default.createElement("img", {
	      src: "https://assets.getsquire.com/images/flagship-app-mockup.png",
	      className: "c-flagship-mockup dark-invert",
	      alt: "Squire App"
	    }),
	    _react2.default.createElement("img", {
	      src: "https://assets.getsquire.com/images/flagship-powered-by-squire.png",
	      className: "c-flagship-powered dark-invert",
	      alt: "Powered by Squire"
	    })
	  );
	};
	
	exports.default = FlagshipRescheduleOrCancel;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var FlagshipSharedBottom = function FlagshipSharedBottom(_ref) {
	  var reservationLink = _ref.reservationLink,
	      shopName = _ref.shopName;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "flgshp-footer u-mb-10 u-mt-5" },
	      _react2.default.createElement(
	        "div",
	        { className: "column u-text-small u-co-grey u-hide-breaks-on-mobile" },
	        "Squire Technologies is a company",
	        " ",
	        _react2.default.createElement("br", null),
	        "dedicated to making style and",
	        " ",
	        _react2.default.createElement("br", null),
	        "grooming simple for everyone."
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "column u-text-small u-co-grey" },
	        _react2.default.createElement(
	          "span",
	          { className: "u-text-small u-co-grey" },
	          "If you need to modify or cancel this appointment,\xA0",
	          _react2.default.createElement(
	            "a",
	            { className: "u-co-grey u-td-underline", href: reservationLink, target: "_blank", rel: "noopener noreferrer" },
	            "view reservation"
	          ),
	          "."
	        )
	      )
	    ),
	    _react2.default.createElement("div", { className: "c-divider" }),
	    _react2.default.createElement(
	      "div",
	      { className: "c-footer-info" },
	      _react2.default.createElement(
	        "div",
	        { className: "u-text-tiny u-co-grey--light u-hide-breaks-on-mobile u-pr-5" },
	        "You're receiving this email because you use Squire to\xA0",
	        _react2.default.createElement("br", null),
	        "manage your appointments for ",
	        shopName,
	        "."
	      ),
	      _react2.default.createElement(
	        "a",
	        {
	          href: "https://www.instagram.com/getsquire",
	          className: "u-flex u-align-center u-text-small u-co-grey",
	          target: "_blank",
	          rel: "noopener noreferrer"
	        },
	        _react2.default.createElement("img", { width: "20px", src: "https://assets.getsquire.com/images/instagram@4x.png", alt: "" }),
	        "\xA0\xA0",
	        _react2.default.createElement(
	          "span",
	          { className: "u-mr-2" },
	          "Instagram"
	        )
	      )
	    )
	  );
	};
	
	exports.default = FlagshipSharedBottom;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var ShopLocation = function ShopLocation(_ref) {
	  var map = _ref.map,
	      shopName = _ref.shopName,
	      line1 = _ref.line1,
	      line2 = _ref.line2,
	      phone = _ref.phone,
	      directions = _ref.directions;
	
	  var locationImgStyle = map ? { backgroundImage: "url(\"" + map + "\")" } : {};
	  return _react2.default.createElement(
	    "div",
	    { className: "c-flagship-shop-location" },
	    _react2.default.createElement("div", { className: "c-flagship-shop-location__image", style: locationImgStyle }),
	    _react2.default.createElement(
	      "div",
	      { className: "u-pt-6 u-pr-4 u-pb-4 u-pl-4 u-flex-1 u-flex" },
	      _react2.default.createElement(
	        "div",
	        { className: "u-ta-left" },
	        _react2.default.createElement(
	          "div",
	          { className: "u-text-normal u-fw-bold u-mb-2" },
	          shopName
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "u-text-small u-co-grey u-mb-3" },
	          line1,
	          ",",
	          _react2.default.createElement("br", null),
	          line2,
	          _react2.default.createElement("br", null),
	          phone
	        ),
	        _react2.default.createElement(
	          "a",
	          { className: "u-text-normal u-co-grey", href: directions, target: "_blank" },
	          "Get directions"
	        )
	      )
	    )
	  );
	};
	
	exports.default = ShopLocation;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PhoneInputComponent = __webpack_require__(1121);
	
	var _PhoneInputComponent2 = _interopRequireDefault(_PhoneInputComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isMobileDevice = function isMobileDevice() {
	  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	  return (/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
	  );
	};
	
	// eslint-disable-next-line react/prop-types
	var RescheduleOrCancel = function RescheduleOrCancel(_ref) {
	  var appLink = _ref.appLink,
	      shop = _ref.shop,
	      androidLink = _ref.androidLink,
	      iosLink = _ref.iosLink;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'u-hide-on-mobile u-mt-8 ' + (isMobileDevice() && 'u-mb-6') },
	      _react2.default.createElement(
	        'a',
	        { className: 'u-text-large u-td-none u-dotted-border u-co-black u-fw-bold', href: appLink, target: '_blank' },
	        'Reschedule'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'u-text-large u-fw-bold' },
	        ' or '
	      ),
	      _react2.default.createElement(
	        'a',
	        { className: 'u-text-large u-td-none u-dotted-border u-co-black u-fw-bold', href: appLink, target: '_blank' },
	        'Cancel'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'u-text-large u-fw-bold' },
	        '\xA0your',
	        _react2.default.createElement('br', null),
	        'appointment using our',
	        _react2.default.createElement('br', null),
	        'free app.'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-hide-on-desktop u-mt-8 u-mb-4' },
	      _react2.default.createElement(
	        'a',
	        { className: 'u-text-big u-td-none u-dotted-border u-co-black u-fw-bold', href: appLink, target: '_blank' },
	        'Reschedule'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'u-text-big u-fw-bold' },
	        ' or '
	      ),
	      _react2.default.createElement(
	        'a',
	        { className: 'u-text-big u-td-none u-dotted-border u-co-black u-fw-bold', href: appLink, target: '_blank' },
	        'Cancel'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'u-text-big u-fw-bold' },
	        '\xA0your',
	        _react2.default.createElement('br', null),
	        'appointment using our free app.'
	      )
	    ),
	    isMobileDevice() && _react2.default.createElement(
	      'div',
	      { className: 'u-flex' },
	      _react2.default.createElement(
	        'a',
	        { className: 'c-store-button u-mr-4', href: androidLink || appLink, target: '_blank' },
	        _react2.default.createElement('img', { src: 'https://squire-emails.s3-us-west-1.amazonaws.com/images/google-play.png', alt: '' })
	      ),
	      _react2.default.createElement(
	        'a',
	        { className: 'c-store-button', href: iosLink || appLink, target: '_blank' },
	        _react2.default.createElement('img', { src: 'https://squire-emails.s3-us-west-1.amazonaws.com/images/app-store.png', alt: '' })
	      )
	    ),
	    !isMobileDevice() && _react2.default.createElement(_PhoneInputComponent2.default, { shop: shop })
	  );
	};
	
	exports.default = RescheduleOrCancel;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontsPreloader = undefined;
	
	var _noop2 = __webpack_require__(145);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Modal = __webpack_require__(93);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _squireLogoLight = __webpack_require__(309);
	
	var _squireLogoLight2 = _interopRequireDefault(_squireLogoLight);
	
	var _PaymentModalTip = __webpack_require__(1204);
	
	var _PaymentModalTip2 = _interopRequireDefault(_PaymentModalTip);
	
	var _PaymentModalOrderInformation = __webpack_require__(1202);
	
	var _PaymentModalOrderInformation2 = _interopRequireDefault(_PaymentModalOrderInformation);
	
	var _PaymentModalReedemCode = __webpack_require__(1203);
	
	var _PaymentModalReedemCode2 = _interopRequireDefault(_PaymentModalReedemCode);
	
	var _PaymentFormContainerPayFac = __webpack_require__(1200);
	
	var _PaymentFormContainerPayFac2 = _interopRequireDefault(_PaymentFormContainerPayFac);
	
	var _PaymentFormContainerStripe = __webpack_require__(462);
	
	var _PaymentFormContainerStripe2 = _interopRequireDefault(_PaymentFormContainerStripe);
	
	var _PaymentFormWithoutCard = __webpack_require__(1172);
	
	var _PaymentFormWithoutCard2 = _interopRequireDefault(_PaymentFormWithoutCard);
	
	var _PromoTidalCheckout = __webpack_require__(1207);
	
	var _PromoTidalCheckout2 = _interopRequireDefault(_PromoTidalCheckout);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// preloads payment modal's fonts so stuff inside is not jumping around when opening the first time
	var FontsPreloader = exports.FontsPreloader = function FontsPreloader() {
	  return _react2.default.createElement(
	    'div',
	    { style: { opacity: 0 } },
	    _react2.default.createElement('span', { style: { fontFamily: 'Open Sans', fontWeight: '300' } }),
	    _react2.default.createElement('span', { style: { fontFamily: 'Open Sans', fontWeight: '400' } }),
	    _react2.default.createElement('span', { style: { fontFamily: 'Open Sans', fontWeight: '700' } }),
	    _react2.default.createElement('link', { rel: 'preload', href: 'https://fonts.gstatic.com/s/opensans/v17/mem8YaGs126MiZpBA-UFVZ0bf8pkAg.woff2' })
	  );
	};
	
	var CheckoutModal = function CheckoutModal(props) {
	  var isReserveAndPay = props.action === 'reserveAndPay';
	  var gridClassName = isReserveAndPay || !props.tipEnabled ? 'c-payment-modal-tip-grid__no-tip' : 'c-payment-modal-tip-grid';
	  var backdropStyles = props.toggled ? { backdropFilter: 'blur(5px)', animation: '.1s modal-in forwards' } : { display: 'none' };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Modal2.default,
	      {
	        className: (0, _classnames2.default)('c-checkout-modal', { 'is-hidden': !props.toggled }),
	        backdropStyles: backdropStyles,
	        close: _noop3.default
	      },
	      _react2.default.createElement('span', { className: 'c-checkout-modal__lock' }),
	      !props.formDisabled && props.off && _react2.default.createElement('button', { className: 'c-checkout-modal__close', onClick: props.onBeforeClose && props.off }),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-checkout-modal__header' },
	        _react2.default.createElement('img', { src: _squireLogoLight2.default, alt: 'Squire' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: gridClassName },
	        !isReserveAndPay && _react2.default.createElement(_PaymentModalTip2.default, { tipEnabled: props.tipEnabled }),
	        _react2.default.createElement(
	          'div',
	          { className: 'u-flex u-flex-column u-justify-content-space-between' },
	          _react2.default.createElement(_PaymentModalOrderInformation2.default, { action: props.action, kioskMode: props.kiosk }),
	          _react2.default.createElement(_PaymentModalReedemCode2.default, null)
	        ),
	        !props.canBeChargedWithSavedCard && props.isPayFacBrand && _react2.default.createElement(_PaymentFormContainerPayFac2.default, {
	          amount: props.totalAmount,
	          panelLabel: props.panelLabel,
	          confirmSetup: props.confirmSetup,
	          formDisabled: props.formDisabled,
	          hasErrors: props.hasErrors,
	          isCoveredByDiscount: props.isCoveredByDiscount,
	          disableApplePay: isReserveAndPay || props.isReservation
	        }),
	        !props.canBeChargedWithSavedCard && !props.isPayFacBrand && _react2.default.createElement(_PaymentFormContainerStripe2.default, {
	          amount: props.totalAmount,
	          panelLabel: props.panelLabel,
	          buttonLabel: props.isReservation ? 'Reserve' : null,
	          confirmSetup: props.confirmSetup,
	          formDisabled: props.formDisabled,
	          hasErrors: props.hasErrors,
	          isCoveredByDiscount: props.isCoveredByDiscount,
	          disableApplePay: isReserveAndPay || props.isReservation
	        }),
	        props.canBeChargedWithSavedCard && _react2.default.createElement(_PaymentFormWithoutCard2.default, {
	          formDisabled: props.formDisabled,
	          amount: props.totalAmount,
	          hasErrors: props.hasErrors,
	          confirmSetup: props.confirmSetup,
	          panelLabel: 'Charge'
	        })
	      ),
	      props.showPromo && _react2.default.createElement(_PromoTidalCheckout2.default, null)
	    )
	  );
	};
	
	CheckoutModal.propTypes = {
	  formDisabled: _propTypes2.default.bool.isRequired,
	  totalAmount: _propTypes2.default.number.isRequired,
	  confirmSetup: _propTypes2.default.func.isRequired,
	  panelLabel: _propTypes2.default.string,
	  toggled: _propTypes2.default.bool,
	  hasErrors: _propTypes2.default.bool.isRequired,
	  isCoveredByDiscount: _propTypes2.default.bool.isRequired,
	  off: _propTypes2.default.func,
	  canBeChargedWithSavedCard: _propTypes2.default.bool,
	  action: _propTypes2.default.string.isRequired,
	  tipEnabled: _propTypes2.default.bool.isRequired,
	  showPromo: _propTypes2.default.bool,
	  onBeforeOpen: _propTypes2.default.func, // eslint-disable-line
	  onBeforeClose: _propTypes2.default.func,
	  isPayFacBrand: _propTypes2.default.bool,
	  kiosk: _propTypes2.default.bool,
	  isReservation: _propTypes2.default.bool
	};
	
	CheckoutModal.defaultProps = {
	  panelLabel: 'Pay',
	  off: undefined,
	  toggled: true,
	  canBeChargedWithSavedCard: false,
	  showPromo: false,
	  onBeforeOpen: _helpers.nullFunc,
	  onBeforeClose: _helpers.nullFunc,
	  isPayFacBrand: false,
	  kiosk: false
	};
	
	exports.default = CheckoutModal;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _qs = __webpack_require__(1536);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShopMap = function ShopMap(_ref) {
	  var name = _ref.name,
	      address = _ref.address;
	
	  var embed = 'https://www.google.com/maps/embed/v1/place?';
	  var query = {
	    q: name + ',' + address,
	    key: _config2.default.googleMapsKey,
	    zoom: 11
	  };
	
	  return _react2.default.createElement('iframe', {
	    className: 'c-map',
	    title: 'map',
	    frameBorder: '0',
	    src: embed + _qs2.default.stringify(query),
	    allowFullScreen: true
	  });
	};
	ShopMap.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  address: _propTypes2.default.string.isRequired
	};
	
	exports.default = ShopMap;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _withCost = __webpack_require__(116);
	
	var _withCost2 = _interopRequireDefault(_withCost);
	
	var _CheckoutModal = __webpack_require__(289);
	
	var _CheckoutModal2 = _interopRequireDefault(_CheckoutModal);
	
	var _withRouteParameters = __webpack_require__(83);
	
	var _withRouteParameters2 = _interopRequireDefault(_withRouteParameters);
	
	var _selectors = __webpack_require__(27);
	
	var _selectors2 = __webpack_require__(11);
	
	var _selectors3 = __webpack_require__(21);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	var _ValidateAppointment = __webpack_require__(293);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_ValidateAppointment.ValidateAppointmentContainer, _withRouteParameters2.default, (0, _reactRedux.connect)(function (state, ownProps) {
	  var tipEnabledForBarber = (0, _selectors.getTipEnabledForBarber)(state, ownProps.barberRoute);
	  var noExtrasForReserveNoPay = (0, _selectors2.getNoExtrasForReserveNoPay)(state, ownProps.shopRoute);
	  var onChargeAppointment = !!(0, _selectors3.getAppointmentId)(state);
	  var isValidating = (0, _selectors3.getIsValidatingAppointment)(state);
	
	  return {
	    tipEnabled: tipEnabledForBarber && (noExtrasForReserveNoPay || onChargeAppointment) && !ownProps.kiosk,
	    isPayFacBrand: (0, _selectors2.getIsPayFacShop)(state, ownProps.shopRoute),
	    isValidating: isValidating
	  };
	}), _withCost2.default, (0, _withState3.default)('setupIntent', 'setSetupIntent', null), (0, _withHandlers3.default)({
	  confirmSetup: function confirmSetup(props) {
	    return function (token) {
	      var result = props.onSuccess(token);
	      if (props.off) {
	        props.off();
	      }
	      return result;
	    };
	  },
	  off: function off(props) {
	    return function () {
	      _BookingAnalytics2.default.abandonPayment({ source: 'squire_modal' });
	      props.off();
	    };
	  }
	}), (0, _withProps3.default)(function (props) {
	  return {
	    formDisabled: props.disabled || props.isValidating
	  };
	}), (0, _lifecycle3.default)({
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    // trigger only when a modal turns from closed to opened
	    if (this.props.toggled && !prevProps.toggled) {
	      this.props.validate();
	      _BookingAnalytics2.default.showSquireModal();
	      _BookingAnalytics2.default.startPayment({ source: 'squire_modal' });
	    }
	  }
	}))(_CheckoutModal2.default);

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(21);
	
	var _ProcessingIndicator = __webpack_require__(1176);
	
	var _ProcessingIndicator2 = _interopRequireDefault(_ProcessingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProcessingIndicatorContainer = (0, _compose3.default)((0, _reactRedux.connect)(function (state) {
	  return {
	    processing: (0, _selectors.getProcessing)(state)
	  };
	}), (0, _branch3.default)(function (props) {
	  return !props.processing;
	}, _renderNothing3.default))(_ProcessingIndicator2.default);
	
	exports.default = ProcessingIndicatorContainer;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ValidateAppointmentContainer = undefined;
	
	var _debounce2 = __webpack_require__(124);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _setDisplayName2 = __webpack_require__(69);
	
	var _setDisplayName3 = _interopRequireDefault(_setDisplayName2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(6);
	
	var _helpers = __webpack_require__(7);
	
	var _actions = __webpack_require__(42);
	
	var _withCost = __webpack_require__(116);
	
	var _withCost2 = _interopRequireDefault(_withCost);
	
	var _WithTimeWaitingList = __webpack_require__(97);
	
	var _WithTimeWaitingList2 = _interopRequireDefault(_WithTimeWaitingList);
	
	var _selectors = __webpack_require__(11);
	
	var _selectors2 = __webpack_require__(27);
	
	var _selectors3 = __webpack_require__(21);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _selectors4 = __webpack_require__(51);
	
	var _withRouteParameters = __webpack_require__(83);
	
	var _withRouteParameters2 = _interopRequireDefault(_withRouteParameters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getValidationTipSettings = function getValidationTipSettings(props) {
	  // backend validation returns default tip instead of 0 for kiosk
	  // since we don't send kiosk flag there, so they don't know the difference
	  if (props.kiosk) {
	    return {
	      tipAmount: 0,
	      tip: 0
	    };
	  }
	  return {
	    tipAmount: props.tipAmount,
	    tip: props.activeTip && !props.activeTip.flat ? props.activeTip.value : null,
	    useFlatTips: !!props.activeTip && !!props.activeTip.flat
	  };
	};
	
	var executeValidation = function executeValidation(props) {
	  return props.appointmentValidate(_extends({}, props.customer, {
	    shopId: props.shopId,
	    barberId: props.barberId,
	    promoCode: props.promoCode,
	    includeWaitingListFee: props.timeWaitingList,
	    dateTime: props.dateTime,
	    services: props.services,
	    duration: props.duration,
	    fallbackUrl: props.fallbackUrl,
	    appointmentId: props.appointmentId
	  }, getValidationTipSettings(props)), props.giftCardEnabled);
	};
	
	var debouncedValidation = (0, _debounce3.default)(executeValidation, 500, { leading: true, trailing: true });
	
	var ValidateAppointmentContainer = exports.ValidateAppointmentContainer = (0, _compose3.default)((0, _setDisplayName3.default)('ValidateAppointment'), _withRouteParameters2.default, _withCost2.default, _WithTimeWaitingList2.default, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    shopId: (0, _selectors.getShopId)(state, ownProps.shopRoute),
	    barberId: (0, _selectors2.getBarberId)(state, ownProps.barberRoute),
	    promoCode: (0, _selectors3.getPromoCode)(state),
	    customer: (0, _selectors3.getIsFormValid)(state) ? (0, _selectors3.getUser)(state) : undefined,
	    giftCardEnabled: (0, _selectors.getGiftCardEnabled)(state, ownProps.shopRoute),
	    dateTime: (0, _moment2.default)(ownProps.reservationTime, _config2.default.timeSlugFormat).toJSON(),
	    services: (0, _selectors4.getSelectedServicesForValidate)(state, ownProps.serviceId),
	    duration: (0, _selectors4.getServiceDuration)(state, ownProps.serviceId),
	    fallbackUrl: (0, _helpers.generateUrlString)((0, _helpers.getUrlPatternParamsOmitLast)(ownProps.params, ownProps.urlPattern), ownProps.urlPattern)
	  };
	}, { appointmentValidate: _actions.appointmentValidate }), (0, _withHandlers3.default)({
	  validate: function validate(props) {
	    return function () {
	      return executeValidation(props);
	    };
	  }
	}), (0, _withPropsOnChange3.default)(['shopId', 'barberId', 'promoCode', 'tipAmount'], function (props) {
	  debouncedValidation(props);
	}));
	
	exports.default = ValidateAppointmentContainer(_helpers.nullFunc);

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withNewCheckoutButton = undefined;
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _renderComponent2 = __webpack_require__(57);
	
	var _renderComponent3 = _interopRequireDefault(_renderComponent2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _StripeCheckoutButton = __webpack_require__(456);
	
	var _StripeCheckoutButton2 = _interopRequireDefault(_StripeCheckoutButton);
	
	var _CheckoutButton = __webpack_require__(1194);
	
	var _CheckoutButton2 = _interopRequireDefault(_CheckoutButton);
	
	var _selectors = __webpack_require__(11);
	
	var _WithShopCurrency = __webpack_require__(135);
	
	var _WithShopCurrency2 = _interopRequireDefault(_WithShopCurrency);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsAwareStripeCheckoutButton = (0, _withHandlers3.default)({
	  onSuccess: function onSuccess(props) {
	    return function () {
	      _BookingAnalytics2.default.showStripeModal();
	
	      return props.onSuccess.apply(props, arguments);
	    };
	  }
	})(_StripeCheckoutButton2.default);
	
	var withNewCheckoutButton = exports.withNewCheckoutButton = (0, _compose3.default)(_reactRouter.withRouter, _WithShopCurrency2.default, (0, _branch3.default)(function (props) {
	  return !props.currency;
	}, _renderNothing3.default), (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    noExtrasForBookNoPay: (0, _selectors.getNoExtrasForReserveNoPay)(state, ownProps.params.shopRoute)
	  };
	}), (0, _branch3.default)(function (props) {
	  return !props.noExtrasForBookNoPay;
	}, (0, _renderComponent3.default)(AnalyticsAwareStripeCheckoutButton)));
	
	exports.default = withNewCheckoutButton(_CheckoutButton2.default);

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getThirdPartyPromotion = exports.getShopId = undefined;
	
	var _either2 = __webpack_require__(739);
	
	var _either3 = _interopRequireDefault(_either2);
	
	var _selectors = __webpack_require__(11);
	
	var shopSelectors = _interopRequireWildcard(_selectors);
	
	var _selectors2 = __webpack_require__(21);
	
	var reservationSelectors = _interopRequireWildcard(_selectors2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line import/prefer-default-export
	var getShopId = exports.getShopId = (0, _either3.default)(shopSelectors.getShopId, reservationSelectors.getShopId);
	
	var getThirdPartyPromotion = exports.getThirdPartyPromotion = function getThirdPartyPromotion(state) {
	  return state.app.get('thirdPartyPromotion');
	};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Subtitle = __webpack_require__(113);
	
	var _Subtitle2 = _interopRequireDefault(_Subtitle);
	
	var _shapes = __webpack_require__(23);
	
	var _NoServices = __webpack_require__(1220);
	
	var _NoServices2 = _interopRequireDefault(_NoServices);
	
	var _Categories = __webpack_require__(1218);
	
	var _Categories2 = _interopRequireDefault(_Categories);
	
	var _Service = __webpack_require__(1221);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _helpers = __webpack_require__(7);
	
	var _GiftCardService = __webpack_require__(1219);
	
	var _GiftCardService2 = _interopRequireDefault(_GiftCardService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Services = function Services(_ref) {
	  var services = _ref.services,
	      categories = _ref.categories,
	      generateUrlString = _ref.generateUrlString,
	      nested = _ref.nested,
	      onServiceClick = _ref.onServiceClick,
	      setCategory = _ref.setCategory,
	      resetCategory = _ref.resetCategory,
	      selectedCategory = _ref.selectedCategory;
	  return _react2.default.createElement(
	    'div',
	    null,
	    !nested && _react2.default.createElement(
	      _Subtitle2.default,
	      null,
	      'Choose a service'
	    ),
	    _react2.default.createElement(_Categories2.default, {
	      categories: categories,
	      setCategory: setCategory,
	      resetCategory: resetCategory,
	      selectedCategory: selectedCategory
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'o-services-list-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'layout' },
	        !services.length && _react2.default.createElement(_NoServices2.default, null),
	        services.length > 0 && _react2.default.createElement(_GiftCardService2.default, null),
	        services.length > 0 && services.map(function (service) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up', key: service.id },
	            _react2.default.createElement(_Service2.default, { service: service, generateUrlString: generateUrlString, onClick: onServiceClick(service.id) })
	          );
	        })
	      )
	    )
	  );
	};
	Services.propTypes = {
	  services: _propTypes2.default.arrayOf(_shapes.serviceShape).isRequired,
	  categories: _shapes.categoriesShape,
	  generateUrlString: _propTypes2.default.func,
	  nested: _propTypes2.default.bool,
	  onServiceClick: _propTypes2.default.func,
	  setCategory: _propTypes2.default.func,
	  resetCategory: _propTypes2.default.func,
	  selectedCategory: _shapes.categoryShape
	};
	Services.defaultProps = {
	  categories: [],
	  selectedCategory: undefined,
	  generateUrlString: null,
	  nested: false,
	  onServiceClick: _helpers.nullFunc,
	  setCategory: _helpers.nullFunc,
	  resetCategory: _helpers.nullFunc
	};
	
	exports.default = Services;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.commonServicesProvider = undefined;
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _FetchOnMount = __webpack_require__(134);
	
	var _FetchOnMount2 = _interopRequireDefault(_FetchOnMount);
	
	var _WithLoader = __webpack_require__(195);
	
	var _WithLoader2 = _interopRequireDefault(_WithLoader);
	
	var _categoryFilter = __webpack_require__(1222);
	
	var _categoryFilter2 = _interopRequireDefault(_categoryFilter);
	
	var _selectors = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var servicesAndCategories = (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    services: ownProps.kiosk ? (0, _selectors.getKioskServices)(state, ownProps.params.serviceId) : (0, _selectors.getServices)(state, ownProps.params.serviceId || ownProps.selectedIds),
	    categories: (0, _selectors.getSelectedCategories)(state, ownProps.params.serviceId || ownProps.selectedIds)
	  };
	});
	
	// eslint-disable-next-line import/prefer-default-export
	var commonServicesProvider = exports.commonServicesProvider = (0, _compose3.default)(_reactRouter.withRouter, servicesAndCategories, _FetchOnMount2.default, _WithLoader2.default, _categoryFilter2.default);

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DateSlider = __webpack_require__(1233);
	
	var _DateSlider2 = _interopRequireDefault(_DateSlider);
	
	var _shapes = __webpack_require__(23);
	
	var _TimePicker = __webpack_require__(1234);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DateTimePicker = function DateTimePicker(_ref) {
	  var times = _ref.times,
	      selectedTime = _ref.selectedTime,
	      setTime = _ref.setTime,
	      timezone = _ref.timezone,
	      noTimesAvailable = _ref.noTimesAvailable,
	      isFetching = _ref.isFetching,
	      serviceId = _ref.serviceId,
	      barberId = _ref.barberId,
	      setActiveDay = _ref.setActiveDay;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'o-wrapper o-wrapper--small' },
	      _react2.default.createElement(_DateSlider2.default, { setActiveDay: setActiveDay })
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'u-text-center u-mt large-and-up-mt large-and-up-pt-',
	        style: { minHeight: 20 }
	      },
	      _react2.default.createElement(_TimePicker2.default, {
	        times: times,
	        timezone: timezone,
	        selectedTime: selectedTime,
	        setTime: setTime,
	        isFetching: isFetching,
	        serviceId: serviceId,
	        noTimesAvailable: noTimesAvailable,
	        barberId: barberId
	      })
	    )
	  );
	};
	DateTimePicker.propTypes = {
	  setActiveDay: _propTypes2.default.func.isRequired,
	  times: _shapes.timesShape,
	  selectedTime: _propTypes2.default.string,
	  setTime: _propTypes2.default.func.isRequired,
	  timezone: _propTypes2.default.string,
	  noTimesAvailable: _propTypes2.default.bool,
	  isFetching: _propTypes2.default.bool,
	  serviceId: _propTypes2.default.string,
	  barberId: _propTypes2.default.string
	};
	DateTimePicker.defaultProps = {
	  times: [],
	  selectedTime: '',
	  timezone: null,
	  noTimesAvailable: false,
	  isFetching: false,
	  anyBarber: false,
	  serviceId: '',
	  barberId: ''
	};
	
	exports.default = DateTimePicker;

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global Stripe, ApplePaySession */
	var formatAmount = function formatAmount(amount) {
	  return Math.floor(amount / 100) + '.' + amount % 100;
	};
	
	var paymentRequest = function paymentRequest(amount, currency) {
	  return {
	    countryCode: 'US',
	    currencyCode: currency.toUpperCase(),
	    total: {
	      label: 'SQUIRE',
	      amount: formatAmount(amount)
	    },
	    requiredShippingContactFields: ['name', 'email', 'phone']
	  };
	};
	
	var mapApplePayUser = exports.mapApplePayUser = function mapApplePayUser(_ref) {
	  var givenName = _ref.givenName,
	      familyName = _ref.familyName,
	      phoneNumber = _ref.phoneNumber,
	      emailAddress = _ref.emailAddress;
	  return {
	    firstName: givenName,
	    lastName: familyName,
	    phone: phoneNumber,
	    email: emailAddress
	  };
	};
	
	var applePaySession = exports.applePaySession = function applePaySession(amount, currency, onSuccess, onError, onCancel) {
	  var session = Stripe.applePay.buildSession(paymentRequest(amount, currency), function (result, completion) {
	    return onSuccess(result).then(function () {
	      return completion(ApplePaySession.STATUS_SUCCESS);
	    }).catch(function () {
	      return completion(ApplePaySession.STATUS_FAILURE);
	    });
	  }, onError);
	
	  session.begin();
	
	  if (onCancel) {
	    session.oncancel = onCancel;
	  }
	};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCountryCodeByCountryAndCurrency = exports.COUNTRY_CODE_BY_NAME = exports.CURRENCY_COUNTRY_CODE = exports.COUNTRY_CODE = exports.COUNTRY_NAME = exports.CURRENCY = undefined;
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _CURRENCY_COUNTRY_COD, _COUNTRY_CODE_BY_NAME;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CURRENCY = exports.CURRENCY = {
	  usd: 'usd',
	  cad: 'cad',
	  gbp: 'gbp',
	  aud: 'aud'
	};
	
	var COUNTRY_NAME = exports.COUNTRY_NAME = {
	  US: 'United States',
	  CA: 'Canada',
	  GB: 'United Kingdom',
	  GI: 'Gibraltar',
	  AU: 'Australia'
	};
	
	var COUNTRY_CODE = exports.COUNTRY_CODE = {
	  US: 'US',
	  CA: 'CA',
	  GB: 'GB',
	  GI: 'GI',
	  AU: 'AU'
	};
	
	var CURRENCY_COUNTRY_CODE = exports.CURRENCY_COUNTRY_CODE = (_CURRENCY_COUNTRY_COD = {}, _defineProperty(_CURRENCY_COUNTRY_COD, CURRENCY.usd, COUNTRY_CODE.US), _defineProperty(_CURRENCY_COUNTRY_COD, CURRENCY.cad, COUNTRY_CODE.CA), _defineProperty(_CURRENCY_COUNTRY_COD, CURRENCY.gbp, COUNTRY_CODE.GB), _defineProperty(_CURRENCY_COUNTRY_COD, CURRENCY.aud, COUNTRY_CODE.AU), _CURRENCY_COUNTRY_COD);
	
	var COUNTRY_CODE_BY_NAME = exports.COUNTRY_CODE_BY_NAME = (_COUNTRY_CODE_BY_NAME = {}, _defineProperty(_COUNTRY_CODE_BY_NAME, COUNTRY_NAME.US, COUNTRY_CODE.US), _defineProperty(_COUNTRY_CODE_BY_NAME, COUNTRY_NAME.CA, COUNTRY_CODE.CA), _defineProperty(_COUNTRY_CODE_BY_NAME, COUNTRY_NAME.GB, COUNTRY_CODE.GB), _defineProperty(_COUNTRY_CODE_BY_NAME, COUNTRY_NAME.GI, COUNTRY_CODE.GI), _defineProperty(_COUNTRY_CODE_BY_NAME, COUNTRY_NAME.AU, COUNTRY_CODE.AU), _COUNTRY_CODE_BY_NAME);
	
	var getCountryCodeByCountryAndCurrency = exports.getCountryCodeByCountryAndCurrency = function getCountryCodeByCountryAndCurrency(shop) {
	  var currency = (0, _get3.default)(shop, 'currency', null);
	  var country = (0, _get3.default)(shop, 'country', null) || (0, _get3.default)(shop, 'address.country', null);
	  return COUNTRY_CODE_BY_NAME[country] || CURRENCY_COUNTRY_CODE[currency] || COUNTRY_CODE.US;
	};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchWaitingListTimes = exports.clearWaitingListTimes = exports.setWaitingListInfo = exports.clearWaitingListInfo = undefined;
	
	var _constants = __webpack_require__(10);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearWaitingListInfo = exports.clearWaitingListInfo = function clearWaitingListInfo() {
	  return {
	    type: _constants.CLEAR_WAITING_LIST_INFO
	  };
	};
	
	var setWaitingListInfo = exports.setWaitingListInfo = function setWaitingListInfo(shopId, barberId, serviceIds, numberInLine) {
	  return {
	    type: _constants.SET_WAITING_LIST_INFO,
	    payload: {
	      shopId: shopId,
	      barberId: barberId,
	      serviceIds: serviceIds.join(';'),
	      numberInLine: numberInLine
	    }
	  };
	};
	
	var clearWaitingListTimes = exports.clearWaitingListTimes = function clearWaitingListTimes() {
	  return {
	    type: _constants.CLEAR_WAITING_LIST_TIMES
	  };
	};
	
	var setWaitingListTimes = function setWaitingListTimes(payload) {
	  return {
	    type: _constants.SET_WAITING_LIST_TIMES,
	    payload: payload
	  };
	};
	
	var fetchWaitingListTimes = exports.fetchWaitingListTimes = function fetchWaitingListTimes(waitingListCustomerId, slotId) {
	  return function (dispatch) {
	    var url = _config2.default.url + '/customer/waiting-list-slot-times/' + waitingListCustomerId + '/' + slotId;
	    return fetch(url).then(_helpers.checkStatus).then(function (response) {
	      return dispatch(setWaitingListTimes(response));
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.expirationYear = void 0;
	var DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE = 19;
	function verification(isValid, isPotentiallyValid, isCurrentYear) {
	    return {
	        isValid: isValid,
	        isPotentiallyValid: isPotentiallyValid,
	        isCurrentYear: isCurrentYear || false,
	    };
	}
	function expirationYear(value, maxElapsedYear) {
	    if (maxElapsedYear === void 0) { maxElapsedYear = DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE; }
	    var isCurrentYear;
	    if (typeof value !== "string") {
	        return verification(false, false);
	    }
	    if (value.replace(/\s/g, "") === "") {
	        return verification(false, true);
	    }
	    if (!/^\d*$/.test(value)) {
	        return verification(false, false);
	    }
	    var len = value.length;
	    if (len < 2) {
	        return verification(false, true);
	    }
	    var currentYear = new Date().getFullYear();
	    if (len === 3) {
	        // 20x === 20x
	        var firstTwo = value.slice(0, 2);
	        var currentFirstTwo = String(currentYear).slice(0, 2);
	        return verification(false, firstTwo === currentFirstTwo);
	    }
	    if (len > 4) {
	        return verification(false, false);
	    }
	    var numericValue = parseInt(value, 10);
	    var twoDigitYear = Number(String(currentYear).substr(2, 2));
	    var valid = false;
	    if (len === 2) {
	        isCurrentYear = twoDigitYear === numericValue;
	        valid =
	            numericValue >= twoDigitYear &&
	                numericValue <= twoDigitYear + maxElapsedYear;
	    }
	    else if (len === 4) {
	        isCurrentYear = currentYear === numericValue;
	        valid =
	            numericValue >= currentYear &&
	                numericValue <= currentYear + maxElapsedYear;
	    }
	    return verification(valid, valid, isCurrentYear);
	}
	exports.expirationYear = expirationYear;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	
	  // Remove event specific arrays for event types that no
	  // one is subscribed for to avoid memory leak.
	  if (callbacks.length === 0) {
	    delete this._callbacks['$' + event];
	  }
	
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	
	  var args = new Array(arguments.length - 1)
	    , callbacks = this._callbacks['$' + event];
	
	  for (var i = 1; i < arguments.length; i++) {
	    args[i - 1] = arguments[i];
	  }
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var cardTypes = __webpack_require__(1269);
	var add_matching_cards_to_results_1 = __webpack_require__(1268);
	var is_valid_input_type_1 = __webpack_require__(1271);
	var find_best_match_1 = __webpack_require__(1270);
	var clone_1 = __webpack_require__(481);
	var customCards = {};
	var cardNames = {
	    VISA: "visa",
	    MASTERCARD: "mastercard",
	    AMERICAN_EXPRESS: "american-express",
	    DINERS_CLUB: "diners-club",
	    DISCOVER: "discover",
	    JCB: "jcb",
	    UNIONPAY: "unionpay",
	    MAESTRO: "maestro",
	    ELO: "elo",
	    MIR: "mir",
	    HIPER: "hiper",
	    HIPERCARD: "hipercard",
	};
	var ORIGINAL_TEST_ORDER = [
	    cardNames.VISA,
	    cardNames.MASTERCARD,
	    cardNames.AMERICAN_EXPRESS,
	    cardNames.DINERS_CLUB,
	    cardNames.DISCOVER,
	    cardNames.JCB,
	    cardNames.UNIONPAY,
	    cardNames.MAESTRO,
	    cardNames.ELO,
	    cardNames.MIR,
	    cardNames.HIPER,
	    cardNames.HIPERCARD,
	];
	var testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
	function findType(cardType) {
	    return customCards[cardType] || cardTypes[cardType];
	}
	function getAllCardTypes() {
	    return testOrder.map(function (cardType) { return clone_1.clone(findType(cardType)); });
	}
	function getCardPosition(name, ignoreErrorForNotExisting) {
	    if (ignoreErrorForNotExisting === void 0) { ignoreErrorForNotExisting = false; }
	    var position = testOrder.indexOf(name);
	    if (!ignoreErrorForNotExisting && position === -1) {
	        throw new Error('"' + name + '" is not a supported card type.');
	    }
	    return position;
	}
	function creditCardType(cardNumber) {
	    var results = [];
	    if (!is_valid_input_type_1.isValidInputType(cardNumber)) {
	        return results;
	    }
	    if (cardNumber.length === 0) {
	        return getAllCardTypes();
	    }
	    testOrder.forEach(function (cardType) {
	        var cardConfiguration = findType(cardType);
	        add_matching_cards_to_results_1.addMatchingCardsToResults(cardNumber, cardConfiguration, results);
	    });
	    var bestMatch = find_best_match_1.findBestMatch(results);
	    if (bestMatch) {
	        return [bestMatch];
	    }
	    return results;
	}
	creditCardType.getTypeInfo = function (cardType) {
	    return clone_1.clone(findType(cardType));
	};
	creditCardType.removeCard = function (name) {
	    var position = getCardPosition(name);
	    testOrder.splice(position, 1);
	};
	creditCardType.addCard = function (config) {
	    var existingCardPosition = getCardPosition(config.type, true);
	    customCards[config.type] = config;
	    if (existingCardPosition === -1) {
	        testOrder.push(config.type);
	    }
	};
	creditCardType.updateCard = function (cardType, updates) {
	    var originalObject = customCards[cardType] || cardTypes[cardType];
	    if (!originalObject) {
	        throw new Error("\"" + cardType + "\" is not a recognized type. Use `addCard` instead.'");
	    }
	    if (updates.type && originalObject.type !== updates.type) {
	        throw new Error("Cannot overwrite type parameter.");
	    }
	    var clonedCard = clone_1.clone(originalObject);
	    clonedCard = __assign(__assign({}, clonedCard), updates);
	    customCards[clonedCard.type] = clonedCard;
	};
	creditCardType.changeOrder = function (name, position) {
	    var currentPosition = getCardPosition(name);
	    testOrder.splice(currentPosition, 1);
	    testOrder.splice(position, 0, name);
	};
	creditCardType.resetModifications = function () {
	    testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
	    customCards = {};
	};
	creditCardType.types = cardNames;
	module.exports = creditCardType;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(1286);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  return ('WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  return JSON.stringify(v);
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}


/***/ }),
/* 306 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	module.exports = exports['default'];

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tidal-logo-white.d271f2ed.svg";

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/squire-logo-light.e18b9f42.svg";

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(119);
	
	var _DOMUtils = __webpack_require__(166);
	
	var _DOMStateStorage = __webpack_require__(311);
	
	var _PathUtils = __webpack_require__(100);
	
	var _ExecutionEnvironment = __webpack_require__(203);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(1321);
	
	var _PathUtils = __webpack_require__(100);
	
	var _runTransitionHook = __webpack_require__(313);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(165);
	
	var _LocationUtils = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(313);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(1539);
	
	var _runTransitionHook = __webpack_require__(313);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(119);
	
	var _PathUtils = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 317 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 318 */
/***/ (function(module, exports) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
	
	function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	// https://stackoverflow.com/a/46971044/970769
	// "Breaking changes in Typescript 2.1"
	// "Extending built-ins like Error, Array, and Map may no longer work."
	// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
	// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
	var ParseError = /*#__PURE__*/function (_Error) {
	  _inherits(ParseError, _Error);
	
	  var _super = _createSuper(ParseError);
	
	  function ParseError(code) {
	    var _this;
	
	    _classCallCheck(this, ParseError);
	
	    _this = _super.call(this, code); // Set the prototype explicitly.
	    // Any subclass of FooError will have to manually set the prototype as well.
	
	    Object.setPrototypeOf(_assertThisInitialized(_this), ParseError.prototype);
	    _this.name = _this.constructor.name;
	    return _this;
	  }
	
	  return _createClass(ParseError);
	}( /*#__PURE__*/_wrapNativeSuper(Error));
	
	exports["default"] = ParseError;
	//# sourceMappingURL=ParseError.js.map

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _PhoneNumber = _interopRequireDefault(__webpack_require__(205));
	
	var _constants = __webpack_require__(72);
	
	var _createExtensionPattern = _interopRequireDefault(__webpack_require__(209));
	
	var _RegExpCache = _interopRequireDefault(__webpack_require__(1340));
	
	var _util = __webpack_require__(206);
	
	var _utf = __webpack_require__(508);
	
	var _Leniency = _interopRequireDefault(__webpack_require__(1339));
	
	var _parsePreCandidate = _interopRequireDefault(__webpack_require__(507));
	
	var _isValidPreCandidate = _interopRequireDefault(__webpack_require__(506));
	
	var _isValidCandidate = _interopRequireWildcard(__webpack_require__(505));
	
	var _metadata = __webpack_require__(43);
	
	var _parse_ = _interopRequireDefault(__webpack_require__(121));
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	var EXTN_PATTERNS_FOR_MATCHING = (0, _createExtensionPattern["default"])('matching');
	/**
	 * Patterns used to extract phone numbers from a larger phone-number-like pattern. These are
	 * ordered according to specificity. For example, white-space is last since that is frequently
	 * used in numbers, not just to separate two numbers. We have separate patterns since we don't
	 * want to break up the phone-number-like text on more than one different kind of symbol at one
	 * time, although symbols of the same type (e.g. space) can be safely grouped together.
	 *
	 * Note that if there is a match, we will always check any text found up to the first match as
	 * well.
	 */
	
	var INNER_MATCHES = [// Breaks on the slash - e.g. "651-234-2345/332-445-1234"
	'\\/+(.*)/', // Note that the bracket here is inside the capturing group, since we consider it part of the
	// phone number. Will match a pattern like "(650) 223 3345 (754) 223 3321".
	'(\\([^(]*)', // Breaks on a hyphen - e.g. "12345 - 332-445-1234 is my number."
	// We require a space on either side of the hyphen for it to be considered a separator.
	"(?:".concat(_utf.pZ, "-|-").concat(_utf.pZ, ")").concat(_utf.pZ, "*(.+)"), // Various types of wide hyphens. Note we have decided not to enforce a space here, since it's
	// possible that it's supposed to be used to break two numbers without spaces, and we haven't
	// seen many instances of it used within a number.
	"[\u2012-\u2015\uFF0D]".concat(_utf.pZ, "*(.+)"), // Breaks on a full stop - e.g. "12345. 332-445-1234 is my number."
	"\\.+".concat(_utf.pZ, "*([^.]+)"), // Breaks on space - e.g. "3324451234 8002341234"
	"".concat(_utf.pZ, "+(").concat(_utf.PZ, "+)")]; // Limit on the number of leading (plus) characters.
	
	var leadLimit = (0, _util.limit)(0, 2); // Limit on the number of consecutive punctuation characters.
	
	var punctuationLimit = (0, _util.limit)(0, 4);
	/* The maximum number of digits allowed in a digit-separated block. As we allow all digits in a
	 * single block, set high enough to accommodate the entire national number and the international
	 * country code. */
	
	var digitBlockLimit = _constants.MAX_LENGTH_FOR_NSN + _constants.MAX_LENGTH_COUNTRY_CODE; // Limit on the number of blocks separated by punctuation.
	// Uses digitBlockLimit since some formats use spaces to separate each digit.
	
	var blockLimit = (0, _util.limit)(0, digitBlockLimit);
	/* A punctuation sequence allowing white space. */
	
	var punctuation = "[".concat(_constants.VALID_PUNCTUATION, "]") + punctuationLimit; // A digits block without punctuation.
	
	var digitSequence = _utf.pNd + (0, _util.limit)(1, digitBlockLimit);
	/**
	 * Phone number pattern allowing optional punctuation.
	 * The phone number pattern used by `find()`, similar to
	 * VALID_PHONE_NUMBER, but with the following differences:
	 * <ul>
	 *   <li>All captures are limited in order to place an upper bound to the text matched by the
	 *       pattern.
	 * <ul>
	 *   <li>Leading punctuation / plus signs are limited.
	 *   <li>Consecutive occurrences of punctuation are limited.
	 *   <li>Number of digits is limited.
	 * </ul>
	 *   <li>No whitespace is allowed at the start or end.
	 *   <li>No alpha digits (vanity numbers such as 1-800-SIX-FLAGS) are currently supported.
	 * </ul>
	 */
	
	var PATTERN = '(?:' + _isValidCandidate.LEAD_CLASS + punctuation + ')' + leadLimit + digitSequence + '(?:' + punctuation + digitSequence + ')' + blockLimit + '(?:' + EXTN_PATTERNS_FOR_MATCHING + ')?'; // Regular expression of trailing characters that we want to remove.
	// We remove all characters that are not alpha or numerical characters.
	// The hash character is retained here, as it may signify
	// the previous block was an extension.
	//
	// // Don't know what does '&&' mean here.
	// const UNWANTED_END_CHAR_PATTERN = new RegExp(`[[\\P{N}&&\\P{L}]&&[^#]]+$`)
	//
	
	var UNWANTED_END_CHAR_PATTERN = new RegExp("[^".concat(_utf._pN).concat(_utf._pL, "#]+$"));
	var NON_DIGITS_PATTERN = /(\D+)/;
	var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	/**
	 * A stateful class that finds and extracts telephone numbers from {@linkplain CharSequence text}.
	 * Instances can be created using the {@linkplain PhoneNumberUtil#findNumbers factory methods} in
	 * {@link PhoneNumberUtil}.
	 *
	 * <p>Vanity numbers (phone numbers using alphabetic digits such as <tt>1-800-SIX-FLAGS</tt> are
	 * not found.
	 *
	 * <p>This class is not thread-safe.
	 */
	
	var PhoneNumberMatcher = /*#__PURE__*/function () {
	  /**
	   * Creates a new instance. See the factory methods in {@link PhoneNumberUtil} on how to obtain a
	   * new instance.
	   *
	   * @param util  the phone number util to use
	   * @param text  the character sequence that we will search, null for no text
	   * @param country  the country to assume for phone numbers not written in international format
	   *     (with a leading plus, or with the international dialing prefix of the specified region).
	   *     May be null or "ZZ" if only numbers with a leading plus should be
	   *     considered.
	   * @param leniency  the leniency to use when evaluating candidate phone numbers
	   * @param maxTries  the maximum number of invalid numbers to try before giving up on the text.
	   *     This is to cover degenerate cases where the text has a lot of false positives in it. Must
	   *     be {@code >= 0}.
	   */
	  function PhoneNumberMatcher() {
	    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var metadata = arguments.length > 2 ? arguments[2] : undefined;
	
	    _classCallCheck(this, PhoneNumberMatcher);
	
	    options = _objectSpread(_objectSpread({}, options), {}, {
	      defaultCallingCode: options.defaultCallingCode,
	      defaultCountry: options.defaultCountry && (0, _metadata.isSupportedCountry)(options.defaultCountry, metadata) ? options.defaultCountry : undefined,
	      leniency: options.leniency || options.extended ? 'POSSIBLE' : 'VALID',
	      maxTries: options.maxTries || MAX_SAFE_INTEGER
	    });
	
	    if (!options.leniency) {
	      throw new TypeError('`Leniency` not supplied');
	    }
	
	    if (options.maxTries < 0) {
	      throw new TypeError('`maxTries` not supplied');
	    }
	
	    this.text = text;
	    this.options = options;
	    this.metadata = metadata;
	    /** The degree of validation requested. */
	
	    this.leniency = _Leniency["default"][options.leniency];
	
	    if (!this.leniency) {
	      throw new TypeError("Unknown leniency: ".concat(options.leniency, "."));
	    }
	    /** The maximum number of retries after matching an invalid number. */
	
	
	    this.maxTries = options.maxTries;
	    this.PATTERN = new RegExp(PATTERN, 'ig');
	    /** The iteration tristate. */
	
	    this.state = 'NOT_READY';
	    /** The next index to start searching at. Undefined in {@link State#DONE}. */
	
	    this.searchIndex = 0; // A cache for frequently used country-specific regular expressions. Set to 32 to cover ~2-3
	    // countries being used for the same doc with ~10 patterns for each country. Some pages will have
	    // a lot more countries in use, but typically fewer numbers for each so expanding the cache for
	    // that use-case won't have a lot of benefit.
	
	    this.regExpCache = new _RegExpCache["default"](32);
	  }
	  /**
	   * Attempts to find the next subsequence in the searched sequence on or after {@code searchIndex}
	   * that represents a phone number. Returns the next match, null if none was found.
	   *
	   * @param index  the search index to start searching at
	   * @return  the phone number match found, null if none can be found
	   */
	
	
	  _createClass(PhoneNumberMatcher, [{
	    key: "find",
	    value: function find() {
	      // // Reset the regular expression.
	      // this.PATTERN.lastIndex = index
	      var matches;
	
	      while (this.maxTries > 0 && (matches = this.PATTERN.exec(this.text)) !== null) {
	        var candidate = matches[0];
	        var offset = matches.index;
	        candidate = (0, _parsePreCandidate["default"])(candidate);
	
	        if ((0, _isValidPreCandidate["default"])(candidate, offset, this.text)) {
	          var match = // Try to come up with a valid match given the entire candidate.
	          this.parseAndVerify(candidate, offset, this.text) // If that failed, try to find an "inner match" -
	          // there might be a phone number within this candidate.
	          || this.extractInnerMatch(candidate, offset, this.text);
	
	          if (match) {
	            if (this.options.v2) {
	              var phoneNumber = new _PhoneNumber["default"](match.country || match.countryCallingCode, match.phone, this.metadata);
	
	              if (match.ext) {
	                phoneNumber.ext = match.ext;
	              }
	
	              return {
	                startsAt: match.startsAt,
	                endsAt: match.endsAt,
	                number: phoneNumber
	              };
	            }
	
	            return match;
	          }
	        }
	
	        this.maxTries--;
	      }
	    }
	    /**
	     * Attempts to extract a match from `substring`
	     * if the substring itself does not qualify as a match.
	     */
	
	  }, {
	    key: "extractInnerMatch",
	    value: function extractInnerMatch(substring, offset, text) {
	      for (var _iterator = _createForOfIteratorHelperLoose(INNER_MATCHES), _step; !(_step = _iterator()).done;) {
	        var innerMatchPattern = _step.value;
	        var isFirstMatch = true;
	        var candidateMatch = void 0;
	        var innerMatchRegExp = new RegExp(innerMatchPattern, 'g');
	
	        while (this.maxTries > 0 && (candidateMatch = innerMatchRegExp.exec(substring)) !== null) {
	          if (isFirstMatch) {
	            // We should handle any group before this one too.
	            var _candidate = (0, _util.trimAfterFirstMatch)(UNWANTED_END_CHAR_PATTERN, substring.slice(0, candidateMatch.index));
	
	            var _match = this.parseAndVerify(_candidate, offset, text);
	
	            if (_match) {
	              return _match;
	            }
	
	            this.maxTries--;
	            isFirstMatch = false;
	          }
	
	          var candidate = (0, _util.trimAfterFirstMatch)(UNWANTED_END_CHAR_PATTERN, candidateMatch[1]); // Java code does `groupMatcher.start(1)` here,
	          // but there's no way in javascript to get a `candidate` start index,
	          // therefore resort to using this kind of an approximation.
	          // (`groupMatcher` is called `candidateInSubstringMatch` in this javascript port)
	          // https://stackoverflow.com/questions/15934353/get-index-of-each-capture-in-a-javascript-regex
	
	          var candidateIndexGuess = substring.indexOf(candidate, candidateMatch.index);
	          var match = this.parseAndVerify(candidate, offset + candidateIndexGuess, text);
	
	          if (match) {
	            return match;
	          }
	
	          this.maxTries--;
	        }
	      }
	    }
	    /**
	     * Parses a phone number from the `candidate` using `parseNumber` and
	     * verifies it matches the requested `leniency`. If parsing and verification succeed,
	     * a corresponding `PhoneNumberMatch` is returned, otherwise this method returns `null`.
	     *
	     * @param candidate  the candidate match
	     * @param offset  the offset of {@code candidate} within {@link #text}
	     * @return  the parsed and validated phone number match, or null
	     */
	
	  }, {
	    key: "parseAndVerify",
	    value: function parseAndVerify(candidate, offset, text) {
	      if (!(0, _isValidCandidate["default"])(candidate, offset, text, this.options.leniency)) {
	        return;
	      }
	
	      var number = (0, _parse_["default"])(candidate, {
	        extended: true,
	        defaultCountry: this.options.defaultCountry,
	        defaultCallingCode: this.options.defaultCallingCode
	      }, this.metadata);
	
	      if (!number.possible) {
	        return;
	      }
	
	      if (this.leniency(number, candidate, this.metadata, this.regExpCache)) {
	        // // We used parseAndKeepRawInput to create this number,
	        // // but for now we don't return the extra values parsed.
	        // // TODO: stop clearing all values here and switch all users over
	        // // to using rawInput() rather than the rawString() of PhoneNumberMatch.
	        // number.clearCountryCodeSource()
	        // number.clearRawInput()
	        // number.clearPreferredDomesticCarrierCode()
	        var result = {
	          startsAt: offset,
	          endsAt: offset + candidate.length,
	          phone: number.phone
	        };
	
	        if (number.country && number.country !== '001') {
	          result.country = number.country;
	        } else {
	          result.countryCallingCode = number.countryCallingCode;
	        }
	
	        if (number.ext) {
	          result.ext = number.ext;
	        }
	
	        return result;
	      }
	    }
	  }, {
	    key: "hasNext",
	    value: function hasNext() {
	      if (this.state === 'NOT_READY') {
	        this.lastMatch = this.find(); // (this.searchIndex)
	
	        if (this.lastMatch) {
	          // this.searchIndex = this.lastMatch.endsAt
	          this.state = 'READY';
	        } else {
	          this.state = 'DONE';
	        }
	      }
	
	      return this.state === 'READY';
	    }
	  }, {
	    key: "next",
	    value: function next() {
	      // Check the state and find the next match as a side-effect if necessary.
	      if (!this.hasNext()) {
	        throw new Error('No next element');
	      } // Don't retain that memory any longer than necessary.
	
	
	      var result = this.lastMatch;
	      this.lastMatch = null;
	      this.state = 'NOT_READY';
	      return result;
	    }
	  }]);
	
	  return PhoneNumberMatcher;
	}();
	
	exports["default"] = PhoneNumberMatcher;
	//# sourceMappingURL=PhoneNumberMatcher.js.map

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _metadata.getCountryCallingCode;
	  }
	});
	
	var _metadata = __webpack_require__(43);
	//# sourceMappingURL=getCountryCallingCode.js.map

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getNumberType;
	exports.normalizeArguments = normalizeArguments;
	
	var _isViablePhoneNumber = _interopRequireDefault(__webpack_require__(168));
	
	var _getNumberType2 = _interopRequireDefault(__webpack_require__(210));
	
	var _parse_ = _interopRequireDefault(__webpack_require__(121));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	// Finds out national phone number type (fixed line, mobile, etc)
	function getNumberType() {
	  var _normalizeArguments = normalizeArguments(arguments),
	      input = _normalizeArguments.input,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _getNumberType2["default"])(input, options, metadata);
	} // Sort out arguments
	
	
	function normalizeArguments(args) {
	  var _Array$prototype$slic = Array.prototype.slice.call(args),
	      _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4),
	      arg_1 = _Array$prototype$slic2[0],
	      arg_2 = _Array$prototype$slic2[1],
	      arg_3 = _Array$prototype$slic2[2],
	      arg_4 = _Array$prototype$slic2[3];
	
	  var input;
	  var options = {};
	  var metadata; // If the phone number is passed as a string.
	  // `getNumberType('88005553535', ...)`.
	
	  if (typeof arg_1 === 'string') {
	    // If "default country" argument is being passed
	    // then convert it to an `options` object.
	    // `getNumberType('88005553535', 'RU', metadata)`.
	    if (_typeof(arg_2) !== 'object') {
	      if (arg_4) {
	        options = arg_3;
	        metadata = arg_4;
	      } else {
	        metadata = arg_3;
	      } // `parse` extracts phone numbers from raw text,
	      // therefore it will cut off all "garbage" characters,
	      // while this `validate` function needs to verify
	      // that the phone number contains no "garbage"
	      // therefore the explicit `isViablePhoneNumber` check.
	
	
	      if ((0, _isViablePhoneNumber["default"])(arg_1)) {
	        input = (0, _parse_["default"])(arg_1, {
	          defaultCountry: arg_2
	        }, metadata);
	      } else {
	        input = {};
	      }
	    } // No "resrict country" argument is being passed.
	    // International phone number is passed.
	    // `getNumberType('+78005553535', metadata)`.
	    else {
	      if (arg_3) {
	        options = arg_2;
	        metadata = arg_3;
	      } else {
	        metadata = arg_2;
	      } // `parse` extracts phone numbers from raw text,
	      // therefore it will cut off all "garbage" characters,
	      // while this `validate` function needs to verify
	      // that the phone number contains no "garbage"
	      // therefore the explicit `isViablePhoneNumber` check.
	
	
	      if ((0, _isViablePhoneNumber["default"])(arg_1)) {
	        input = (0, _parse_["default"])(arg_1, undefined, metadata);
	      } else {
	        input = {};
	      }
	    }
	  } // If the phone number is passed as a parsed phone number.
	  // `getNumberType({ phone: '88005553535', country: 'RU' }, ...)`.
	  else if (is_object(arg_1)) {
	    input = arg_1;
	
	    if (arg_3) {
	      options = arg_2;
	      metadata = arg_3;
	    } else {
	      metadata = arg_2;
	    }
	  } else throw new TypeError('A phone number must either be a string or an object of shape { phone, [country] }.');
	
	  return {
	    input: input,
	    options: options,
	    metadata: metadata
	  };
	} // Babel transforms `typeof` into some "branches"
	// so istanbul will show this as "branch not covered".
	
	/* istanbul ignore next */
	
	
	var is_object = function is_object(_) {
	  return _typeof(_) === 'object';
	};
	//# sourceMappingURL=getNumberType.js.map

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign;
	
	var _metadata = _interopRequireDefault(__webpack_require__(43));
	
	var _matchesEntirely = _interopRequireDefault(__webpack_require__(139));
	
	var _extractNationalNumber = _interopRequireDefault(__webpack_require__(516));
	
	var _checkNumberLength = _interopRequireDefault(__webpack_require__(208));
	
	var _getCountryCallingCode = _interopRequireDefault(__webpack_require__(320));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Sometimes some people incorrectly input international phone numbers
	 * without the leading `+`. This function corrects such input.
	 * @param  {string} number — Phone number digits.
	 * @param  {string?} country
	 * @param  {string?} callingCode
	 * @param  {object} metadata
	 * @return {object} `{ countryCallingCode: string?, number: string }`.
	 */
	function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
	  var countryCallingCode = country ? (0, _getCountryCallingCode["default"])(country, metadata) : callingCode;
	
	  if (number.indexOf(countryCallingCode) === 0) {
	    metadata = new _metadata["default"](metadata);
	    metadata.selectNumberingPlan(country, callingCode);
	    var possibleShorterNumber = number.slice(countryCallingCode.length);
	
	    var _extractNationalNumbe = (0, _extractNationalNumber["default"])(possibleShorterNumber, metadata),
	        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
	
	    var _extractNationalNumbe2 = (0, _extractNationalNumber["default"])(number, metadata),
	        nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
	    // or if it was too long before, we consider the number
	    // with the country calling code stripped to be a better result
	    // and keep that instead.
	    // For example, in Germany (+49), `49` is a valid area code,
	    // so if a number starts with `49`, it could be both a valid
	    // national German number or an international number without
	    // a leading `+`.
	
	
	    if (!(0, _matchesEntirely["default"])(nationalNumber, metadata.nationalNumberPattern()) && (0, _matchesEntirely["default"])(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, _checkNumberLength["default"])(nationalNumber, metadata) === 'TOO_LONG') {
	      return {
	        countryCallingCode: countryCallingCode,
	        number: possibleShorterNumber
	      };
	    }
	  }
	
	  return {
	    number: number
	  };
	}
	//# sourceMappingURL=extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js.map

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FIRST_GROUP_PATTERN = void 0;
	exports["default"] = formatNationalNumberUsingFormat;
	
	var _applyInternationalSeparatorStyle = _interopRequireDefault(__webpack_require__(514));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// This was originally set to $1 but there are some countries for which the
	// first group is not used in the national pattern (e.g. Argentina) so the $1
	// group does not match correctly. Therefore, we use `\d`, so that the first
	// group actually used in the pattern will be matched.
	var FIRST_GROUP_PATTERN = /(\$\d)/;
	exports.FIRST_GROUP_PATTERN = FIRST_GROUP_PATTERN;
	
	function formatNationalNumberUsingFormat(number, format, _ref) {
	  var useInternationalFormat = _ref.useInternationalFormat,
	      withNationalPrefix = _ref.withNationalPrefix,
	      carrierCode = _ref.carrierCode,
	      metadata = _ref.metadata;
	  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
	  // because that one is only used when formatting phone numbers
	  // for dialing from a mobile phone, and this is not a dialing library.
	  // carrierCode && format.domesticCarrierCodeFormattingRule()
	  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
	  // 	// Then, replace the $FG in the formatting rule with the first group
	  // 	// and the carrier code combined in the appropriate way.
	  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
	  // 	: (
	  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
	  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
	  // 			: format.format()
	  // 	)
	  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());
	
	  if (useInternationalFormat) {
	    return (0, _applyInternationalSeparatorStyle["default"])(formattedNumber);
	  }
	
	  return formattedNumber;
	}
	//# sourceMappingURL=formatNationalNumberUsingFormat.js.map

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = stripIddPrefix;
	
	var _metadata = _interopRequireDefault(__webpack_require__(43));
	
	var _constants = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var CAPTURING_DIGIT_PATTERN = new RegExp('([' + _constants.VALID_DIGITS + '])');
	
	function stripIddPrefix(number, country, callingCode, metadata) {
	  if (!country) {
	    return;
	  } // Check if the number is IDD-prefixed.
	
	
	  var countryMetadata = new _metadata["default"](metadata);
	  countryMetadata.selectNumberingPlan(country, callingCode);
	  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
	
	  if (number.search(IDDPrefixPattern) !== 0) {
	    return;
	  } // Strip IDD prefix.
	
	
	  number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
	  // then those digits are a country calling code.
	  // Since no country code starts with a `0`,
	  // the code below validates that the next digit (if present) is not `0`.
	
	  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
	
	  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
	    if (matchedGroups[1] === '0') {
	      return;
	    }
	  }
	
	  return number;
	}
	//# sourceMappingURL=stripIddPrefix.js.map

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isPossiblePhoneNumber;
	exports.isPossibleNumber = isPossibleNumber;
	
	var _metadata = _interopRequireDefault(__webpack_require__(43));
	
	var _checkNumberLength = _interopRequireDefault(__webpack_require__(208));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isPossiblePhoneNumber(input, options, metadata) {
	  /* istanbul ignore if */
	  if (options === undefined) {
	    options = {};
	  }
	
	  metadata = new _metadata["default"](metadata);
	
	  if (options.v2) {
	    if (!input.countryCallingCode) {
	      throw new Error('Invalid phone number object passed');
	    }
	
	    metadata.selectNumberingPlan(input.countryCallingCode);
	  } else {
	    if (!input.phone) {
	      return false;
	    }
	
	    if (input.country) {
	      if (!metadata.hasCountry(input.country)) {
	        throw new Error("Unknown country: ".concat(input.country));
	      }
	
	      metadata.country(input.country);
	    } else {
	      if (!input.countryCallingCode) {
	        throw new Error('Invalid phone number object passed');
	      }
	
	      metadata.selectNumberingPlan(input.countryCallingCode);
	    }
	  } // Old metadata (< 1.0.18) had no "possible length" data.
	
	
	  if (metadata.possibleLengths()) {
	    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
	  } else {
	    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
	    // were missing for "non-geographical" numbering plans.
	    // Just assume the number is possible in such cases:
	    // it's unlikely that anyone generated their custom metadata
	    // in that short period of time (one day).
	    // This code can be removed in some future major version update.
	    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
	      // "Non-geographic entities" did't have `possibleLengths`
	      // due to a bug in metadata generation process.
	      return true;
	    } else {
	      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
	    }
	  }
	}
	
	function isPossibleNumber(nationalNumber, metadata) {
	  //, isInternational) {
	  switch ((0, _checkNumberLength["default"])(nationalNumber, metadata)) {
	    case 'IS_POSSIBLE':
	      return true;
	    // This library ignores "local-only" phone numbers (for simplicity).
	    // See the readme for more info on what are "local-only" phone numbers.
	    // case 'IS_POSSIBLE_LOCAL_ONLY':
	    // 	return !isInternational
	
	    default:
	      return false;
	  }
	}
	//# sourceMappingURL=isPossibleNumber_.js.map

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parseIncompletePhoneNumber;
	exports.parsePhoneNumberCharacter = parsePhoneNumberCharacter;
	
	var _parseDigits = __webpack_require__(120);
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	/**
	 * Parses phone number characters from a string.
	 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
	 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
	 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	 * @param  {string} string
	 * @return {string}
	 * @example
	 * ```js
	 * // Outputs '8800555'.
	 * parseIncompletePhoneNumber('8 (800) 555')
	 * // Outputs '+7800555'.
	 * parseIncompletePhoneNumber('+7 800 555')
	 * ```
	 */
	function parseIncompletePhoneNumber(string) {
	  var result = ''; // Using `.split('')` here instead of normal `for ... of`
	  // because the importing application doesn't neccessarily include an ES6 polyfill.
	  // The `.split('')` approach discards "exotic" UTF-8 characters
	  // (the ones consisting of four bytes) but digits
	  // (including non-European ones) don't fall into that range
	  // so such "exotic" characters would be discarded anyway.
	
	  for (var _iterator = _createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
	    var character = _step.value;
	    result += parsePhoneNumberCharacter(character, result) || '';
	  }
	
	  return result;
	}
	/**
	 * Parses next character while parsing phone number digits (including a `+`)
	 * from text: discards everything except `+` and digits, and `+` is only allowed
	 * at the start of a phone number.
	 * For example, is used in `react-phone-number-input` where it uses
	 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
	 * @param  {string} character - Yet another character from raw input string.
	 * @param  {string?} prevParsedCharacters - Previous parsed characters.
	 * @param  {object} meta - Optional custom use-case-specific metadata.
	 * @return {string?} The parsed character.
	 */
	
	
	function parsePhoneNumberCharacter(character, prevParsedCharacters) {
	  // Only allow a leading `+`.
	  if (character === '+') {
	    // If this `+` is not the first parsed character
	    // then discard it.
	    if (prevParsedCharacters) {
	      return;
	    }
	
	    return '+';
	  } // Allow digits.
	
	
	  return (0, _parseDigits.parseDigit)(character);
	}
	//# sourceMappingURL=parseIncompletePhoneNumber.js.map

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(170),
	    baseLodash = __webpack_require__(336);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(170),
	    baseLodash = __webpack_require__(336);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(122),
	    root = __webpack_require__(53);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1442),
	    mapCacheDelete = __webpack_require__(1443),
	    mapCacheGet = __webpack_require__(1444),
	    mapCacheHas = __webpack_require__(1445),
	    mapCacheSet = __webpack_require__(1446);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(330),
	    setCacheAdd = __webpack_require__(1451),
	    setCacheHas = __webpack_require__(1452);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(543);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(174);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(214),
	    arrayEach = __webpack_require__(141),
	    assignValue = __webpack_require__(333),
	    baseAssign = __webpack_require__(536),
	    cloneBuffer = __webpack_require__(1392),
	    copyArray = __webpack_require__(172),
	    copySymbols = __webpack_require__(1401),
	    getAllKeys = __webpack_require__(1419),
	    getTag = __webpack_require__(344),
	    initCloneArray = __webpack_require__(1430),
	    initCloneByTag = __webpack_require__(1431),
	    initCloneObject = __webpack_require__(1432),
	    isArray = __webpack_require__(28),
	    isBuffer = __webpack_require__(585),
	    isHostObject = __webpack_require__(224),
	    isObject = __webpack_require__(52),
	    keys = __webpack_require__(126);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1372),
	    isObject = __webpack_require__(52),
	    isObjectLike = __webpack_require__(104);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 336 */
/***/ (function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(215),
	    isSymbol = __webpack_require__(144);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(529);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(333);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(217),
	    deburr = __webpack_require__(1471),
	    words = __webpack_require__(1513);
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	module.exports = createCompounder;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(568),
	    noop = __webpack_require__(145);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ }),
/* 342 */
/***/ (function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(345),
	    stubArray = __webpack_require__(592);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	module.exports = getSymbols;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1358),
	    Map = __webpack_require__(329),
	    Promise = __webpack_require__(1360),
	    Set = __webpack_require__(528),
	    WeakMap = __webpack_require__(530),
	    baseGetTag = __webpack_require__(1369),
	    toSource = __webpack_require__(574);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 345 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(1365),
	    hasUnicode = __webpack_require__(173),
	    unicodeToArray = __webpack_require__(1460);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(539),
	    baseIteratee = __webpack_require__(44),
	    toInteger = __webpack_require__(106);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(53);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsFinite = root.isFinite;
	
	/**
	 * Checks if `value` is a finite primitive number.
	 *
	 * **Note:** This method is based on
	 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	 * @example
	 *
	 * _.isFinite(3);
	 * // => true
	 *
	 * _.isFinite(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isFinite(Infinity);
	 * // => false
	 *
	 * _.isFinite('3');
	 * // => false
	 */
	function isFinite(value) {
	  return typeof value == 'number' && nativeIsFinite(value);
	}
	
	module.exports = isFinite;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(101),
	    baseDifference = __webpack_require__(537),
	    baseFlatten = __webpack_require__(102),
	    basePick = __webpack_require__(547),
	    baseRest = __webpack_require__(73),
	    getAllKeysIn = __webpack_require__(561),
	    toKey = __webpack_require__(123);
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable string keyed properties of `object` that are
	 * not omitted.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property identifiers to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = baseRest(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  props = arrayMap(baseFlatten(props, 1), toKey);
	  return basePick(object, baseDifference(getAllKeysIn(object), props));
	});
	
	module.exports = omit;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(102),
	    baseOrderBy = __webpack_require__(1382),
	    baseRest = __webpack_require__(73),
	    isIterateeCall = __webpack_require__(143);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, function(o) { return o.user; });
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	 *
	 * _.sortBy(users, 'user', function(o) {
	 *   return Math.floor(o.age / 10);
	 * });
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(44),
	    baseSum = __webpack_require__(1390);
	
	/**
	 * This method is like `_.sum` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the value to be summed.
	 * The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	 *
	 * _.sumBy(objects, function(o) { return o.n; });
	 * // => 20
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sumBy(objects, 'n');
	 * // => 20
	 */
	function sumBy(array, iteratee) {
	  return (array && array.length)
	    ? baseSum(array, baseIteratee(iteratee, 2))
	    : 0;
	}
	
	module.exports = sumBy;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var is = __webpack_require__(167);
	var isodate = __webpack_require__(1522);
	var milliseconds = __webpack_require__(1520);
	var seconds = __webpack_require__(1521);
	
	/**
	 * Returns a new Javascript Date object, allowing a variety of extra input types
	 * over the native Date constructor.
	 *
	 * @param {Date|string|number} val
	 */
	module.exports = function newDate(val) {
	  if (is.date(val)) return val;
	  if (is.number(val)) return new Date(toMs(val));
	
	  // date strings
	  if (isodate.is(val)) {
	    return isodate.parse(val);
	  }
	  if (milliseconds.is(val)) {
	    return milliseconds.parse(val);
	  }
	  if (seconds.is(val)) {
	    return seconds.parse(val);
	  }
	
	  // fallback to Date.parse
	  return new Date(val);
	};
	
	
	/**
	 * If the number passed val is seconds from the epoch, turn it into milliseconds.
	 * Milliseconds would be greater than 31557600000 (December 31, 1970).
	 *
	 * @param {number} num
	 */
	function toMs(num) {
	  if (num < 31557600000) return num * 1000;
	  return num;
	}


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	/**
	 * Returns a function that always returns the given value. Note that for
	 * non-primitives the value returned is a reference to the original value.
	 *
	 * This function is known as `const`, `constant`, or `K` (for K combinator) in
	 * other languages and libraries.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> (* -> a)
	 * @param {*} val The value to wrap in a function
	 * @return {Function} A Function :: * -> val.
	 * @example
	 *
	 *      var t = R.always('Tee');
	 *      t(); //=> 'Tee'
	 */
	
	
	var always = /*#__PURE__*/_curry1(function always(val) {
	  return function () {
	    return val;
	  };
	});
	module.exports = always;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(68);
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the specified
	 * property with the given value. Note that this copies and flattens prototype
	 * properties onto the new object as well. All non-primitive properties are
	 * copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig String -> a -> {k: v} -> {k: v}
	 * @param {String} prop The property name to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except for the changed property.
	 * @see R.dissoc
	 * @example
	 *
	 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
	 */
	
	
	var assoc = /*#__PURE__*/_curry3(function assoc(prop, val, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  result[prop] = val;
	  return result;
	});
	module.exports = assoc;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _isFunction = /*#__PURE__*/__webpack_require__(361);
	
	var and = /*#__PURE__*/__webpack_require__(1540);
	
	var lift = /*#__PURE__*/__webpack_require__(362);
	
	/**
	 * A function which calls the two provided functions and returns the `&&`
	 * of the results.
	 * It returns the result of the first function if it is false-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * false-y value.
	 *
	 * In addition to functions, `R.both` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f A predicate
	 * @param {Function} g Another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
	 * @see R.and
	 * @example
	 *
	 *      var gt10 = R.gt(R.__, 10)
	 *      var lt20 = R.lt(R.__, 20)
	 *      var f = R.both(gt10, lt20);
	 *      f(15); //=> true
	 *      f(30); //=> false
	 */
	
	
	var both = /*#__PURE__*/_curry2(function both(f, g) {
	  return _isFunction(f) ? function _both() {
	    return f.apply(this, arguments) && g.apply(this, arguments);
	  } : lift(and)(f, g);
	});
	module.exports = both;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var lift = /*#__PURE__*/__webpack_require__(362);
	
	var not = /*#__PURE__*/__webpack_require__(753);
	
	/**
	 * Takes a function `f` and returns a function `g` such that if called with the same arguments
	 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
	 *
	 * `R.complement` may be applied to any functor
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> *) -> (*... -> Boolean)
	 * @param {Function} f
	 * @return {Function}
	 * @see R.not
	 * @example
	 *
	 *      var isNotNil = R.complement(R.isNil);
	 *      isNil(null); //=> true
	 *      isNotNil(null); //=> false
	 *      isNil(7); //=> false
	 *      isNotNil(7); //=> true
	 */
	
	
	var complement = /*#__PURE__*/lift(not);
	module.exports = complement;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(68);
	
	var curryN = /*#__PURE__*/__webpack_require__(128);
	
	/**
	 * Creates a function that will process either the `onTrue` or the `onFalse`
	 * function depending upon the result of the `condition` predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
	 * @param {Function} condition A predicate function
	 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
	 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
	 * @return {Function} A new unary function that will process either the `onTrue` or the `onFalse`
	 *                    function depending upon the result of the `condition` predicate.
	 * @see R.unless, R.when
	 * @example
	 *
	 *      var incCount = R.ifElse(
	 *        R.has('count'),
	 *        R.over(R.lensProp('count'), R.inc),
	 *        R.assoc('count', 1)
	 *      );
	 *      incCount({});           //=> { count: 1 }
	 *      incCount({ count: 1 }); //=> { count: 2 }
	 */
	
	
	var ifElse = /*#__PURE__*/_curry3(function ifElse(condition, onTrue, onFalse) {
	  return curryN(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
	    return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
	  });
	});
	module.exports = ifElse;

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	/**
	 * Private `concat` function to merge two array-like objects.
	 *
	 * @private
	 * @param {Array|Arguments} [set1=[]] An array-like object.
	 * @param {Array|Arguments} [set2=[]] An array-like object.
	 * @return {Array} A new, merged array.
	 * @example
	 *
	 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 */
	function _concat(set1, set2) {
	  set1 = set1 || [];
	  set2 = set2 || [];
	  var idx;
	  var len1 = set1.length;
	  var len2 = set2.length;
	  var result = [];
	
	  idx = 0;
	  while (idx < len1) {
	    result[result.length] = set1[idx];
	    idx += 1;
	  }
	  idx = 0;
	  while (idx < len2) {
	    result[result.length] = set2[idx];
	    idx += 1;
	  }
	  return result;
	}
	module.exports = _concat;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	var _indexOf = /*#__PURE__*/__webpack_require__(1559);
	
	function _contains(a, list) {
	  return _indexOf(list, a, 0) >= 0;
	}
	module.exports = _contains;

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	function _isFunction(x) {
	  return Object.prototype.toString.call(x) === '[object Function]';
	}
	module.exports = _isFunction;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var liftN = /*#__PURE__*/__webpack_require__(1577);
	
	/**
	 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
	 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.liftN
	 * @example
	 *
	 *      var madd3 = R.lift((a, b, c) => a + b + c);
	 *
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 *
	 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
	 *
	 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
	 */
	
	
	var lift = /*#__PURE__*/_curry1(function lift(fn) {
	  return liftN(fn.length, fn);
	});
	module.exports = lift;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dayMatchesModifier = dayMatchesModifier;
	exports.getModifiersForDay = getModifiersForDay;
	
	var _DateUtils = __webpack_require__(148);
	
	var _Helpers = __webpack_require__(246);
	
	/**
	 * Return `true` if a date matches the specified modifier.
	 *
	 * @export
	 * @param {Date} day
	 * @param {Any} modifier
	 * @return {Boolean}
	 */
	function dayMatchesModifier(day, modifier) {
	  if (!modifier) {
	    return false;
	  }
	  var arr = Array.isArray(modifier) ? modifier : [modifier];
	  return arr.some(function (mod) {
	    if (!mod) {
	      return false;
	    }
	    if (mod instanceof Date) {
	      return (0, _DateUtils.isSameDay)(day, mod);
	    }
	    if ((0, _Helpers.isRangeOfDates)(mod)) {
	      return (0, _DateUtils.isDayInRange)(day, mod);
	    }
	    if (mod.after && mod.before && (0, _DateUtils.isDayAfter)(mod.before, mod.after)) {
	      return (0, _DateUtils.isDayAfter)(day, mod.after) && (0, _DateUtils.isDayBefore)(day, mod.before);
	    }
	    if (mod.after && mod.before && ((0, _DateUtils.isDayAfter)(mod.after, mod.before) || (0, _DateUtils.isSameDay)(mod.after, mod.before))) {
	      return (0, _DateUtils.isDayAfter)(day, mod.after) || (0, _DateUtils.isDayBefore)(day, mod.before);
	    }
	    if (mod.after) {
	      return (0, _DateUtils.isDayAfter)(day, mod.after);
	    }
	    if (mod.before) {
	      return (0, _DateUtils.isDayBefore)(day, mod.before);
	    }
	    if (mod.daysOfWeek) {
	      return mod.daysOfWeek.some(function (dayOfWeek) {
	        return day.getDay() === dayOfWeek;
	      });
	    }
	    if (typeof mod === 'function') {
	      return mod(day);
	    }
	    return false;
	  });
	}
	
	/**
	 * Return the modifiers matching the given day for the given
	 * object of modifiers.
	 *
	 * @export
	 * @param {Date} day
	 * @param {Object} [modifiersObj={}]
	 * @return {Array}
	 */
	function getModifiersForDay(day) {
	  var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return Object.keys(modifiersObj).reduce(function (modifiers, modifierName) {
	    var value = modifiersObj[modifierName];
	    if (dayMatchesModifier(day, value)) {
	      modifiers.push(modifierName);
	    }
	    return modifiers;
	  }, []);
	}
	
	exports.default = { dayMatchesModifier: dayMatchesModifier, getModifiersForDay: getModifiersForDay };
	//# sourceMappingURL=ModifiersUtils.js.map

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(150);
	var Danger = __webpack_require__(1617);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactInstrumentation = __webpack_require__(76);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(373);
	var setInnerHTML = __webpack_require__(254);
	var setTextContent = __webpack_require__(779);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var ReactErrorUtils = __webpack_require__(371);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(19);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var ReactPropTypesSecret = __webpack_require__(1646);
	var propTypesFactory = __webpack_require__(733);
	
	var React = __webpack_require__(155);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(19);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var invariant = __webpack_require__(13);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var ReactCurrentOwner = __webpack_require__(91);
	var ReactInstanceMap = __webpack_require__(188);
	var ReactInstrumentation = __webpack_require__(76);
	var ReactUpdates = __webpack_require__(85);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(19);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(55);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(24);
	
	var emptyFunction = __webpack_require__(65);
	var warning = __webpack_require__(19);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(1);
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  eventIndex: _react.PropTypes.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func,
	    object = _react.PropTypes.object,
	    shape = _react.PropTypes.shape,
	    string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getRouteParams = __webpack_require__(1720);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(383);
	
	var _RouteUtils = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    array = _React$PropTypes.array,
	    func = _React$PropTypes.func,
	    object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(1727);
	
	var SimpleCurrencyInput = (function (_React$Component) {
	  _inherits(SimpleCurrencyInput, _React$Component);
	
	  function SimpleCurrencyInput(props) {
	    _classCallCheck(this, SimpleCurrencyInput);
	
	    _get(Object.getPrototypeOf(SimpleCurrencyInput.prototype), 'constructor', this).call(this, props);
	
	    this.onInputType = this.onInputType.bind(this);
	    this.formattedRawValue = this.formattedRawValue.bind(this);
	    this.getRawValue = this.getRawValue.bind(this);
	
	    this.state = {
	      rawValue: this.props.value,
	      tabIndex: this.props.tabIndex,
	      readOnly: this.props.readOnly
	    };
	  }
	
	  _createClass(SimpleCurrencyInput, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.notifyParentWithRawValue(this.state.rawValue);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value || nextProps.value === 0) {
	        this.setState({
	          rawValue: nextProps.value
	        });
	      }
	    }
	  }, {
	    key: 'onInputType',
	    value: function onInputType(event) {
	      var input = event.target.value;
	      var rawValue = this.getRawValue(input);
	      if (!rawValue) {
	        rawValue = 0;
	      }
	
	      this.notifyParentWithRawValue(rawValue);
	
	      this.setState({
	        rawValue: rawValue
	      });
	    }
	  }, {
	    key: 'notifyParentWithRawValue',
	    value: function notifyParentWithRawValue(rawValue) {
	      var display = this.formattedRawValue(rawValue);
	      this.props.onInputChange(rawValue, display);
	    }
	  }, {
	    key: 'getRawValue',
	    value: function getRawValue(displayedValue) {
	      var result = displayedValue;
	
	      result = removeOccurrences(result, this.props.delimiter);
	      result = removeOccurrences(result, this.props.separator);
	      result = removeOccurrences(result, this.props.unit);
	
	      var intValue = parseInt(result);
	
	      return intValue;
	    }
	  }, {
	    key: 'formattedRawValue',
	    value: function formattedRawValue(rawValue) {
	      var minChars = '0'.length + this.props.precision;
	
	      var result = '';
	      result = '' + rawValue;
	
	      if (result.length < minChars) {
	        var leftZeroesToAdd = minChars - result.length;
	        result = '' + repeatZeroes(leftZeroesToAdd) + result;
	      }
	
	      var beforeSeparator = result.slice(0, result.length - this.props.precision);
	      var afterSeparator = result.slice(result.length - this.props.precision);
	
	      if (beforeSeparator.length > 3) {
	        var chars = beforeSeparator.split('').reverse();
	        var withDots = '';
	        for (var i = chars.length - 1; i >= 0; i--) {
	          var char = chars[i];
	          var dot = i % 3 === 0 ? this.props.delimiter : '';
	          withDots = '' + withDots + char + dot;
	        }
	        withDots = withDots.substring(0, withDots.length - 1);
	        beforeSeparator = withDots;
	      }
	      result = beforeSeparator + this.props.separator + afterSeparator;
	
	      if (this.props.unit) {
	        result = this.props.unit + ' ' + result;
	      }
	
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return React.createElement('input', {
	        id: this.props.id,
	        className: this.props.className,
	        onBlur: this.props.onInputBlur,
	        onFocus: this.props.onInputFocus,
	        onChange: this.onInputType,
	        value: this.formattedRawValue(this.state.rawValue),
	        disabled: this.props.disabled,
	        autoFocus: this.props.autoFocus,
	        tabIndex: this.state.tabIndex,
	        readOnly: this.state.readOnly,
	        autoComplete: this.props.autoComplete,
	        autoCorrect: this.props.autoCorrect,
	        name: this.props.name,
	        placeholder: this.props.placeholder,
	        type: this.props.type
	      });
	    }
	  }]);
	
	  return SimpleCurrencyInput;
	})(React.Component);
	
	var repeatZeroes = function repeatZeroes(times) {
	  var result = '';
	  var i = 0;
	  for (i = 0; i < times; i++) {
	    result += '0';
	  }
	
	  return result;
	};
	
	var removeOccurrences = function removeOccurrences(from, toRemove) {
	  toRemove = toRemove.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	  var re = new RegExp(toRemove, 'g');
	  return from.replace(re, '');
	};
	
	SimpleCurrencyInput.propTypes = {
	  id: PropTypes.string,
	  autoFocus: PropTypes.bool,
	  delimiter: PropTypes.string,
	  disabled: PropTypes.bool,
	  onInputChange: PropTypes.func,
	  onInputBlur: PropTypes.func,
	  onInputFocus: PropTypes.func,
	  precision: PropTypes.number,
	  readOnly: PropTypes.bool,
	  separator: PropTypes.string,
	  tabIndex: PropTypes.number,
	  unit: PropTypes.string,
	  value: PropTypes.number.isRequired,
	  type: PropTypes.string
	};
	
	SimpleCurrencyInput.defaultProps = {
	  value: 0,
	  precision: 2,
	  separator: '.',
	  delimiter: ',',
	  unit: '',
	  disabled: false,
	  autoFocus: false,
	  onInputChange: function onInputChange() {},
	  onInputBlur: function onInputBlur() {},
	  onInputFocus: function onInputFocus() {},
	  type: 'text'
	};
	
	exports['default'] = SimpleCurrencyInput;
	module.exports = exports['default'];


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(157);
	
	var ReactNoopUpdateQueue = __webpack_require__(388);
	
	var canDefineProperty = __webpack_require__(802);
	var emptyObject = __webpack_require__(138);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(19);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(19);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var inherit = __webpack_require__(80).inherit;
	var type = __webpack_require__(80).type;
	var Facade = __webpack_require__(130);
	var Identify = __webpack_require__(810);
	var isEmail = __webpack_require__(204);
	var get = __webpack_require__(182);
	
	/**
	 * Initialize a new `Track` facade with a `dictionary` of arguments.
	 *
	 * @param {Object} dictionary - The object to wrap.
	 * @param {string} [dictionary.event] - The name of the event being tracked.
	 * @param {string} [dictionary.userId] - The ID of the user being tracked.
	 * @param {string} [dictionary.anonymousId] - The anonymous ID of the user.
	 * @param {string} [dictionary.properties] - Properties of the track event.
	 * @param {Object} opts - Options about what kind of Facade to create.
	 *
	 * @augments Facade
	 */
	function Track(dictionary, opts) {
	  Facade.call(this, dictionary, opts);
	}
	
	inherit(Track, Facade);
	
	/**
	 * Return the type of facade this is. This will always return `"track"`.
	 *
	 * @return {string}
	 */
	Track.prototype.action = function() {
	  return 'track';
	};
	
	/**
	 * An alias for {@link Track#action}.
	 *
	 * @function
	 * @return {string}
	 */
	Track.prototype.type = Track.prototype.action;
	
	/**
	 * Get the event name from `event`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {string}
	 */
	Track.prototype.event = Facade.field('event');
	
	/**
	 * Get the event value, usually the monetary value, from `properties.value`.
	 *
	 * This *should* be a number, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {string}
	 */
	Track.prototype.value = Facade.proxy('properties.value');
	
	/**
	 * Get the event cateogry from `properties.category`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {string}
	 */
	Track.prototype.category = Facade.proxy('properties.category');
	
	/**
	 * Get the event ID from `properties.id`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {string}
	 */
	Track.prototype.id = Facade.proxy('properties.id');
	
	/**
	 * Get the product ID from `properties.productId`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Track.prototype.productId = function() {
	  return this.proxy('properties.product_id') || this.proxy('properties.productId');
	};
	
	/**
	 * Get the promotion ID from `properties.promotionId`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Track.prototype.promotionId = function() {
	  return this.proxy('properties.promotion_id') || this.proxy('properties.promotionId');
	};
	
	/**
	 * Get the cart ID from `properties.cartId`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Track.prototype.cartId = function() {
	  return this.proxy('properties.cart_id') || this.proxy('properties.cartId');
	};
	
	/**
	 * Get the checkout ID from `properties.checkoutId`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Track.prototype.checkoutId = function() {
	  return this.proxy('properties.checkout_id') || this.proxy('properties.checkoutId');
	};
	
	/**
	 * Get the payment ID from `properties.paymentId`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Track.prototype.paymentId = function() {
	  return this.proxy('properties.payment_id') || this.proxy('properties.paymentId');
	};
	
	/**
	 * Get the coupon ID from `properties.couponId`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Track.prototype.couponId = function() {
	  return this.proxy('properties.coupon_id') || this.proxy('properties.couponId');
	};
	
	/**
	 * Get the wishlist ID from `properties.wishlistId`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Track.prototype.wishlistId = function() {
	  return this.proxy('properties.wishlist_id') || this.proxy('properties.wishlistId');
	};
	
	/**
	 * Get the review ID from `properties.reviewId`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Track.prototype.reviewId = function() {
	  return this.proxy('properties.review_id') || this.proxy('properties.reviewId');
	};
	
	/**
	 * Get the order ID from `properties.id` or `properties.orderId`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Track.prototype.orderId = function() {
	  // doesn't follow above convention since this fallback order was how it used to be
	  return this.proxy('properties.id')
	    || this.proxy('properties.order_id')
	    || this.proxy('properties.orderId');
	};
	
	/**
	 * Get the SKU from `properties.sku`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {string}
	 */
	Track.prototype.sku = Facade.proxy('properties.sku');
	
	/**
	 * Get the amount of tax for this purchase from `properties.tax`.
	 *
	 * This *should* be a number, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {number}
	 */
	Track.prototype.tax = Facade.proxy('properties.tax');
	
	/**
	 * Get the name of this event from `properties.name`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {string}
	 */
	Track.prototype.name = Facade.proxy('properties.name');
	
	/**
	 * Get the price of this purchase from `properties.price`.
	 *
	 * This *should* be a number, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {number}
	 */
	Track.prototype.price = Facade.proxy('properties.price');
	
	/**
	 * Get the total for this purchase from `properties.total`.
	 *
	 * This *should* be a number, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {number}
	 */
	Track.prototype.total = Facade.proxy('properties.total');
	
	/**
	 * Whether this is a repeat purchase from `properties.repeat`.
	 *
	 * This *should* be a boolean, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {boolean}
	 */
	Track.prototype.repeat = Facade.proxy('properties.repeat');
	
	/**
	 * Get the coupon for this purchase from `properties.coupon`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {string}
	 */
	Track.prototype.coupon = Facade.proxy('properties.coupon');
	
	/**
	 * Get the shipping for this purchase from `properties.shipping`.
	 *
	 * This *should* be a number, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {number}
	 */
	Track.prototype.shipping = Facade.proxy('properties.shipping');
	
	/**
	 * Get the discount for this purchase from `properties.discount`.
	 *
	 * This *should* be a number, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {number}
	 */
	Track.prototype.discount = Facade.proxy('properties.discount');
	
	/**
	 * Get the shipping method for this purchase from `properties.shippingMethod`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Track.prototype.shippingMethod = function() {
	  return this.proxy('properties.shipping_method') || this.proxy('properties.shippingMethod');
	};
	
	/**
	 * Get the payment method for this purchase from `properties.paymentMethod`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Track.prototype.paymentMethod = function() {
	  return this.proxy('properties.payment_method') || this.proxy('properties.paymentMethod');
	};
	
	/**
	 * Get a description for this event from `properties.description`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {string}
	 */
	Track.prototype.description = Facade.proxy('properties.description');
	
	/**
	 * Get a plan, as in the plan the user is on, for this event from
	 * `properties.plan`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {string}
	 */
	Track.prototype.plan = Facade.proxy('properties.plan');
	
	/**
	 * Get the subtotal for this purchase from `properties.subtotal`.
	 *
	 * If `properties.subtotal` isn't available, then fall back to computing the
	 * total from `properties.total` or `properties.revenue`, and then subtracting
	 * tax, shipping, and discounts.
	 *
	 * If neither subtotal, total, nor revenue are available, then return 0.
	 *
	 * @return {number}
	 */
	Track.prototype.subtotal = function() {
	  var subtotal = get(this.properties(), 'subtotal');
	  var total = this.total() || this.revenue();
	
	  if (subtotal) return subtotal;
	  if (!total) return 0;
	
	  if (this.total()) {
	    var n = this.tax();
	    if (n) total -= n;
	    n = this.shipping();
	    if (n) total -= n;
	    n = this.discount();
	    if (n) total += n;
	  }
	
	  return total;
	};
	
	/**
	 * Get the products for this event from `properties.products` if it's an
	 * array, falling back to an empty array.
	 *
	 * @return {Array}
	 */
	Track.prototype.products = function() {
	  var props = this.properties();
	  var products = get(props, 'products');
	  return type(products) === 'array' ? products : [];
	};
	
	/**
	 * Get the quantity for this event from `properties.quantity`, falling back to
	 * a quantity of one.
	 *
	 * @return {number}
	 */
	Track.prototype.quantity = function() {
	  var props = this.obj.properties || {};
	  return props.quantity || 1;
	};
	
	/**
	 * Get the currency for this event from `properties.currency`, falling back to
	 * "USD".
	 *
	 * @return {string}
	 */
	Track.prototype.currency = function() {
	  var props = this.obj.properties || {};
	  return props.currency || 'USD';
	};
	
	/**
	 * Get the referrer for this event from `context.referrer.url`,
	 * `context.page.referrer`, or `properties.referrer`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Track.prototype.referrer = function() {
	  // TODO re-examine whether this function is necessary
	  return this.proxy('context.referrer.url')
	    || this.proxy('context.page.referrer')
	    || this.proxy('properties.referrer');
	};
	
	/**
	 * Get the query for this event from `options.query`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {string|object}
	 */
	Track.prototype.query = Facade.proxy('options.query');
	
	/**
	 * Get the page's properties. This is identical to how {@link Facade#traits}
	 * works, except it looks at `properties.*` instead of `options.traits.*`.
	 *
	 * Properties are gotten from `properties`.
	 *
	 * The parameter `aliases` is meant to transform keys in `properties` into new
	 * keys. Each alias like `{ "xxx": "yyy" }` will take whatever is at `xxx` in
	 * the traits, and move it to `yyy`. If `xxx` is a method of this facade, it'll
	 * be called as a function instead of treated as a key into the traits.
	 *
	 * @example
	 * var obj = { properties: { foo: "bar" }, anonymousId: "xxx" }
	 * var track = new Track(obj)
	 *
	 * track.traits() // { "foo": "bar" }
	 * track.traits({ "foo": "asdf" }) // { "asdf": "bar" }
	 * track.traits({ "sessionId": "rofl" }) // { "rofl": "xxx" }
	 *
	 * @param {Object} aliases - A mapping from keys to the new keys they should be
	 * transformed to.
	 * @return {Object}
	 */
	Track.prototype.properties = function(aliases) {
	  var ret = this.field('properties') || {};
	  aliases = aliases || {};
	
	  for (var alias in aliases) {
	    var value = this[alias] == null ? this.proxy('properties.' + alias) : this[alias]();
	    if (value == null) continue;
	    ret[aliases[alias]] = value;
	    delete ret[alias];
	  }
	
	  return ret;
	};
	
	/**
	 * Get the username of the user for this event from `traits.username`,
	 * `properties.username`, `userId`, or `anonymousId`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string|undefined}
	 */
	Track.prototype.username = function() {
	  return this.proxy('traits.username')
	    || this.proxy('properties.username')
	    || this.userId()
	    || this.sessionId();
	};
	
	/**
	 * Get the email of the user for this event from `trais.email`,
	 * `properties.email`, or `options.traits.email`, falling back to `userId` if
	 * it looks like a valid email.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string|undefined}
	 */
	Track.prototype.email = function() {
	  var email = this.proxy('traits.email')
	    || this.proxy('properties.email')
	    || this.proxy('options.traits.email');
	  if (email) return email;
	
	  var userId = this.userId();
	  if (isEmail(userId)) return userId;
	};
	
	/**
	 * Get the revenue for this event.
	 *
	 * If this is an "Order Completed" event, this will be the `properties.total`
	 * falling back to the `properties.revenue`. For all other events, this is
	 * simply taken from `properties.revenue`.
	 *
	 * If there are dollar signs in these properties, they will be removed. The
	 * result will be parsed into a number.
	 *
	 * @return {number}
	 */
	Track.prototype.revenue = function() {
	  var revenue = this.proxy('properties.revenue');
	  var event = this.event();
	  var orderCompletedRegExp = /^[ _]?completed[ _]?order[ _]?|^[ _]?order[ _]?completed[ _]?$/i;
	
	  // it's always revenue, unless it's called during an order completion.
	  if (!revenue && event && event.match(orderCompletedRegExp)) {
	    revenue = this.proxy('properties.total');
	  }
	
	  return currency(revenue);
	};
	
	/**
	 * Get the revenue for this event in "cents" -- in other words, multiply the
	 * {@link Track#revenue} by 100, or return 0 if there isn't a numerical revenue
	 * for this event.
	 *
	 * @return {number}
	 */
	Track.prototype.cents = function() {
	  var revenue = this.revenue();
	  return typeof revenue !== 'number' ? this.value() || 0 : revenue * 100;
	};
	
	/**
	 * Convert this event into an {@link Identify} facade.
	 *
	 * This works by taking this event's underlying object and creating an Identify
	 * from it. This event's traits, taken from `options.traits`, will be used as
	 * the Identify's traits.
	 *
	 * @return {Identify}
	 */
	Track.prototype.identify = function() {
	  // TODO: remove me.
	  var json = this.json();
	  json.traits = this.traits();
	  return new Identify(json, this.opts);
	};
	
	/**
	 * Get float from currency value.
	 *
	 * @ignore
	 * @param {*} val
	 * @return {number}
	 */
	function currency(val) {
	  if (!val) return;
	  if (typeof val === 'number') {
	    return val;
	  }
	  if (typeof val !== 'string') {
	    return;
	  }
	
	  val = val.replace(/\$/g, '');
	  val = parseFloat(val);
	
	  if (!isNaN(val)) {
	    return val;
	  }
	}
	
	module.exports = Track;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * Module dependencies.
	 */
	
	var drop = __webpack_require__(821);
	var rest = __webpack_require__(827);
	
	var has = Object.prototype.hasOwnProperty;
	var objToString = Object.prototype.toString;
	
	/**
	 * Returns `true` if a value is an object, otherwise `false`.
	 *
	 * @name isObject
	 * @api private
	 * @param {*} val The value to test.
	 * @return {boolean}
	 */
	// TODO: Move to a library
	var isObject = function isObject(value) {
	  return Boolean(value) && typeof value === 'object';
	};
	
	/**
	 * Returns `true` if a value is a plain object, otherwise `false`.
	 *
	 * @name isPlainObject
	 * @api private
	 * @param {*} val The value to test.
	 * @return {boolean}
	 */
	// TODO: Move to a library
	var isPlainObject = function isPlainObject(value) {
	  return Boolean(value) && objToString.call(value) === '[object Object]';
	};
	
	/**
	 * Assigns a key-value pair to a target object when the value assigned is owned,
	 * and where target[key] is undefined.
	 *
	 * @name shallowCombiner
	 * @api private
	 * @param {Object} target
	 * @param {Object} source
	 * @param {*} value
	 * @param {string} key
	 */
	var shallowCombiner = function shallowCombiner(target, source, value, key) {
	  if (has.call(source, key) && target[key] === undefined) {
	    target[key] = value;
	  }
	  return source;
	};
	
	/**
	 * Assigns a key-value pair to a target object when the value assigned is owned,
	 * and where target[key] is undefined; also merges objects recursively.
	 *
	 * @name deepCombiner
	 * @api private
	 * @param {Object} target
	 * @param {Object} source
	 * @param {*} value
	 * @param {string} key
	 * @return {Object}
	 */
	var deepCombiner = function(target, source, value, key) {
	  if (has.call(source, key)) {
	    if (isPlainObject(target[key]) && isPlainObject(value)) {
	        target[key] = defaultsDeep(target[key], value);
	    } else if (target[key] === undefined) {
	        target[key] = value;
	    }
	  }
	
	  return source;
	};
	
	/**
	 * TODO: Document
	 *
	 * @name defaultsWith
	 * @api private
	 * @param {Function} combiner
	 * @param {Object} target
	 * @param {...Object} sources
	 * @return {Object} Return the input `target`.
	 */
	var defaultsWith = function(combiner, target /*, ...sources */) {
	  if (!isObject(target)) {
	    return target;
	  }
	
	  combiner = combiner || shallowCombiner;
	  var sources = drop(2, arguments);
	
	  for (var i = 0; i < sources.length; i += 1) {
	    for (var key in sources[i]) {
	      combiner(target, sources[i], sources[i][key], key);
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Copies owned, enumerable properties from a source object(s) to a target
	 * object when the value of that property on the source object is `undefined`.
	 * Recurses on objects.
	 *
	 * @name defaultsDeep
	 * @api public
	 * @param {Object} target
	 * @param {...Object} sources
	 * @return {Object} The input `target`.
	 */
	var defaultsDeep = function defaultsDeep(target /*, sources */) {
	  // TODO: Replace with `partial` call?
	  return defaultsWith.apply(null, [deepCombiner, target].concat(rest(arguments)));
	};
	
	/**
	 * Copies owned, enumerable properties from a source object(s) to a target
	 * object when the value of that property on the source object is `undefined`.
	 *
	 * @name defaults
	 * @api public
	 * @param {Object} target
	 * @param {...Object} sources
	 * @return {Object}
	 * @example
	 * var a = { a: 1 };
	 * var b = { a: 2, b: 2 };
	 *
	 * defaults(a, b);
	 * console.log(a); //=> { a: 1, b: 2 }
	 */
	var defaults = function(target /*, ...sources */) {
	  // TODO: Replace with `partial` call?
	  return defaultsWith.apply(null, [null, target].concat(rest(arguments)));
	};
	
	/*
	 * Exports.
	 */
	
	module.exports = defaults;
	module.exports.deep = defaultsDeep;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * Module dependencies.
	 */
	
	var each = __webpack_require__(133);
	
	var strIndexOf = String.prototype.indexOf;
	
	/**
	 * Object.is/sameValueZero polyfill.
	 *
	 * @api private
	 * @param {*} value1
	 * @param {*} value2
	 * @return {boolean}
	 */
	// TODO: Move to library
	var sameValueZero = function sameValueZero(value1, value2) {
	  // Normal values and check for 0 / -0
	  if (value1 === value2) {
	    return value1 !== 0 || 1 / value1 === 1 / value2;
	  }
	  // NaN
	  return value1 !== value1 && value2 !== value2;
	};
	
	/**
	 * Searches a given `collection` for a value, returning true if the collection
	 * contains the value and false otherwise. Can search strings, arrays, and
	 * objects.
	 *
	 * @name includes
	 * @api public
	 * @param {*} searchElement The element to search for.
	 * @param {Object|Array|string} collection The collection to search.
	 * @return {boolean}
	 * @example
	 * includes(2, [1, 2, 3]);
	 * //=> true
	 *
	 * includes(4, [1, 2, 3]);
	 * //=> false
	 *
	 * includes(2, { a: 1, b: 2, c: 3 });
	 * //=> true
	 *
	 * includes('a', { a: 1, b: 2, c: 3 });
	 * //=> false
	 *
	 * includes('abc', 'xyzabc opq');
	 * //=> true
	 *
	 * includes('nope', 'xyzabc opq');
	 * //=> false
	 */
	var includes = function includes(searchElement, collection) {
	  var found = false;
	
	  // Delegate to String.prototype.indexOf when `collection` is a string
	  if (typeof collection === 'string') {
	    return strIndexOf.call(collection, searchElement) !== -1;
	  }
	
	  // Iterate through enumerable/own array elements and object properties.
	  each(function(value) {
	    if (sameValueZero(value, searchElement)) {
	      found = true;
	      // Exit iteration early when found
	      return false;
	    }
	  }, collection);
	
	  return found;
	};
	
	/*
	 * Exports.
	 */
	
	module.exports = includes;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_clonedeep_1 = __importDefault(__webpack_require__(212));
	var lodash_assignin_1 = __importDefault(__webpack_require__(1356));
	/*
	 * Module dependencies.
	 */
	var cookie = __webpack_require__(259);
	var debug = __webpack_require__(110)('analytics:entity');
	var memory = __webpack_require__(393);
	var store = __webpack_require__(261);
	var isodateTraverse = __webpack_require__(398);
	/**
	 * Expose `Entity`
	 */
	module.exports = Entity;
	/**
	 * Initialize new `Entity` with `options`.
	 */
	function Entity(options) {
	    this.options(options);
	    this.initialize();
	}
	/**
	 * Initialize picks the storage.
	 *
	 * Checks to see if cookies can be set
	 * otherwise fallsback to localStorage.
	 */
	Entity.prototype.initialize = function () {
	    cookie.set('ajs:cookies', true);
	    // cookies are enabled.
	    if (cookie.get('ajs:cookies')) {
	        cookie.remove('ajs:cookies');
	        this._storage = cookie;
	        return;
	    }
	    // localStorage is enabled.
	    if (store.enabled) {
	        this._storage = store;
	        return;
	    }
	    // fallback to memory storage.
	    debug('warning using memory store both cookies and localStorage are disabled');
	    this._storage = memory;
	};
	/**
	 * Get the storage.
	 */
	Entity.prototype.storage = function () {
	    return this._storage;
	};
	/**
	 * Get or set storage `options`.
	 */
	Entity.prototype.options = function (options) {
	    if (arguments.length === 0)
	        return this._options;
	    this._options = __assign(__assign({}, this.defaults), options);
	};
	/**
	 * Get or set the entity's `id`.
	 */
	Entity.prototype.id = function (id) {
	    switch (arguments.length) {
	        case 0:
	            return this._getId();
	        case 1:
	            return this._setId(id);
	        default:
	        // No default case
	    }
	};
	/**
	 * Get the entity's id.
	 */
	Entity.prototype._getId = function () {
	    if (!this._options.persist) {
	        return this._id === undefined ? null : this._id;
	    }
	    // Check cookies.
	    var cookieId = this._getIdFromCookie();
	    if (cookieId) {
	        return cookieId;
	    }
	    // Check localStorage.
	    var lsId = this._getIdFromLocalStorage();
	    if (lsId) {
	        // Copy the id to cookies so we can read it directly from cookies next time.
	        this._setIdInCookies(lsId);
	        return lsId;
	    }
	    return null;
	};
	/**
	 * Get the entity's id from cookies.
	 */
	// FIXME `options.cookie` is an optional field, so `this._options.cookie.key`
	// can thrown an exception.
	Entity.prototype._getIdFromCookie = function () {
	    return this.storage().get(this._options.cookie.key);
	};
	/**
	 * Get the entity's id from cookies.
	 */
	Entity.prototype._getIdFromLocalStorage = function () {
	    if (!this._options.localStorageFallbackDisabled) {
	        return store.get(this._options.cookie.key);
	    }
	    return null;
	};
	/**
	 * Set the entity's `id`.
	 */
	Entity.prototype._setId = function (id) {
	    if (this._options.persist) {
	        this._setIdInCookies(id);
	        this._setIdInLocalStorage(id);
	    }
	    else {
	        this._id = id;
	    }
	};
	/**
	 * Set the entity's `id` in cookies.
	 */
	Entity.prototype._setIdInCookies = function (id) {
	    this.storage().set(this._options.cookie.key, id);
	};
	/**
	 * Set the entity's `id` in local storage.
	 */
	Entity.prototype._setIdInLocalStorage = function (id) {
	    if (!this._options.localStorageFallbackDisabled) {
	        store.set(this._options.cookie.key, id);
	    }
	};
	/**
	 * Get or set the entity's `traits`.
	 *
	 * BACKWARDS COMPATIBILITY: aliased to `properties`
	 */
	Entity.prototype.properties = Entity.prototype.traits = function (traits) {
	    switch (arguments.length) {
	        case 0:
	            return this._getTraits();
	        case 1:
	            return this._setTraits(traits);
	        default:
	        // No default case
	    }
	};
	/**
	 * Get the entity's traits. Always convert ISO date strings into real dates,
	 * since they aren't parsed back from local storage.
	 */
	Entity.prototype._getTraits = function () {
	    var ret = this._options.persist
	        ? store.get(this._options.localStorage.key)
	        : this._traits;
	    return ret ? isodateTraverse(lodash_clonedeep_1.default(ret)) : {};
	};
	/**
	 * Set the entity's `traits`.
	 */
	Entity.prototype._setTraits = function (traits) {
	    traits = traits || {};
	    if (this._options.persist) {
	        store.set(this._options.localStorage.key, traits);
	    }
	    else {
	        this._traits = traits;
	    }
	};
	/**
	 * Identify the entity with an `id` and `traits`. If we it's the same entity,
	 * extend the existing `traits` instead of overwriting.
	 */
	Entity.prototype.identify = function (id, traits) {
	    traits = traits || {};
	    var current = this.id();
	    if (current === null || current === id) {
	        traits = lodash_assignin_1.default(this.traits(), traits);
	    }
	    if (id) {
	        this.id(id);
	    }
	    this.debug('identify %o, %o', id, traits);
	    this.traits(traits);
	    this.save();
	};
	/**
	 * Save the entity to local storage and the cookie.
	 */
	Entity.prototype.save = function () {
	    if (!this._options.persist)
	        return false;
	    this._setId(this.id());
	    this._setTraits(this.traits());
	    return true;
	};
	/**
	 * Log the entity out, reseting `id` and `traits` to defaults.
	 */
	Entity.prototype.logout = function () {
	    this.id(null);
	    this.traits({});
	    this.storage().remove(this._options.cookie.key);
	    store.remove(this._options.cookie.key);
	    store.remove(this._options.localStorage.key);
	};
	/**
	 * Reset all entity state, logging out and returning options to defaults.
	 */
	Entity.prototype.reset = function () {
	    this.logout();
	    this.options({});
	};
	/**
	 * Load saved entity `id` or `traits` from storage.
	 */
	Entity.prototype.load = function () {
	    this.id(this.id());
	    this.traits(this.traits());
	};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Module Dependencies.
	 */
	var lodash_clonedeep_1 = __importDefault(__webpack_require__(212));
	var bindAll = __webpack_require__(118);
	/**
	 * HOP.
	 */
	var has = Object.prototype.hasOwnProperty;
	/**
	 * Expose `Memory`
	 */
	module.exports = bindAll(new Memory());
	/**
	 * Initialize `Memory` store
	 */
	function Memory() {
	    this.store = {};
	}
	/**
	 * Set a `key` and `value`.
	 */
	Memory.prototype.set = function (key, value) {
	    this.store[key] = lodash_clonedeep_1.default(value);
	    return true;
	};
	/**
	 * Get a `key`.
	 */
	Memory.prototype.get = function (key) {
	    if (!has.call(this.store, key))
	        return;
	    return lodash_clonedeep_1.default(this.store[key]);
	};
	/**
	 * Remove a `key`.
	 */
	Memory.prototype.remove = function (key) {
	    delete this.store[key];
	    return true;
	};


/***/ }),
/* 394 */
/***/ (function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]]
	  ]).join('');
	}
	
	module.exports = bytesToUuid;


/***/ }),
/* 395 */
/***/ (function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto
	// implementation. Also, find the complete implementation of crypto on IE11.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(395);
	var bytesToUuid = __webpack_require__(394);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	
	var debug = __webpack_require__(847)('cookie');
	
	/**
	 * Set or get cookie `name` with `value` and `options` object.
	 *
	 * @param {String} name
	 * @param {String} value
	 * @param {Object} options
	 * @return {Mixed}
	 * @api public
	 */
	
	module.exports = function(name, value, options) {
	  switch (arguments.length) {
	    case 3:
	    case 2:
	      return set(name, value, options);
	    case 1:
	      return get(name);
	    default:
	      return all();
	  }
	};
	
	/**
	 * Set cookie `name` to `value`.
	 *
	 * @param {String} name
	 * @param {String} value
	 * @param {Object} options
	 * @api private
	 */
	
	function set(name, value, options) {
	  options = options || {};
	  var str = encode(name) + '=' + encode(value);
	
	  if (value == null) options.maxage = -1;
	
	  if (options.maxage) {
	    options.expires = new Date(+new Date() + options.maxage);
	  }
	
	  if (options.path) str += '; path=' + options.path;
	  if (options.domain) str += '; domain=' + options.domain;
	  if (options.expires) str += '; expires=' + options.expires.toUTCString();
	  if (options.sameSite) str += '; SameSite=' + options.sameSite;
	  if (options.secure) str += '; secure';
	
	  document.cookie = str;
	}
	
	/**
	 * Return all cookies.
	 *
	 * @return {Object}
	 * @api private
	 */
	
	function all() {
	  var str;
	  try {
	    str = document.cookie;
	  } catch (err) {
	    if (typeof console !== 'undefined' && typeof console.error === 'function') {
	      console.error(err.stack || err);
	    }
	    return {};
	  }
	  return parse(str);
	}
	
	/**
	 * Get cookie `name`.
	 *
	 * @param {String} name
	 * @return {String}
	 * @api private
	 */
	
	function get(name) {
	  return all()[name];
	}
	
	/**
	 * Parse cookie `str`.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parse(str) {
	  var obj = {};
	  var pairs = str.split(/ *; */);
	  var pair;
	  if (pairs[0] == '') return obj; // eslint-disable-line eqeqeq
	  for (var i = 0; i < pairs.length; ++i) {
	    pair = pairs[i].split('=');
	    obj[decode(pair[0])] = decode(pair[1]);
	  }
	  return obj;
	}
	
	/**
	 * Encode.
	 */
	
	function encode(value) {
	  try {
	    return encodeURIComponent(value);
	  } catch (e) {
	    debug('error `encode(%o)` - %o', value, e);
	  }
	}
	
	/**
	 * Decode.
	 */
	
	function decode(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    debug('error `decode(%o)` - %o', value, e);
	  }
	}


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var type = __webpack_require__(86);
	var each = __webpack_require__(1263);
	var isodate = __webpack_require__(852);
	
	/**
	 * Expose `traverse`.
	 */
	
	module.exports = traverse;
	
	/**
	 * Traverse an object or array, and return a clone with all ISO strings parsed
	 * into Date objects.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 */
	
	function traverse(input, strict) {
	  if (strict === undefined) strict = true;
	
	  if (type(input) === 'object') return object(input, strict);
	  if (type(input) === 'array') return array(input, strict);
	  return input;
	}
	
	/**
	 * Object traverser.
	 *
	 * @param {Object} obj
	 * @param {Boolean} strict
	 * @return {Object}
	 */
	
	function object(obj, strict) {
	  // 'each' utility uses obj.length to check whether the obj is array. To avoid incorrect classification, wrap call to 'each' with rename of obj.length
	  if (obj.length && typeof obj.length === 'number' && !(obj.length - 1 in obj)) { // cross browser compatible way of checking has length and is not array
	    obj.lengthNonArray = obj.length;
	    delete obj.length;
	  }
	  each(obj, function(key, val) {
	    if (isodate.is(val, strict)) {
	      obj[key] = isodate.parse(val);
	    } else if (type(val) === 'object' || type(val) === 'array') {
	      traverse(val, strict);
	    }
	  });
	  // restore obj.length if it was renamed
	  if (obj.lengthNonArray) {
	    obj.length = obj.lengthNonArray;
	    delete obj.lengthNonArray;
	  }
	  return obj;
	}
	
	/**
	 * Array traverser.
	 *
	 * @param {Array} arr
	 * @param {Boolean} strict
	 * @return {Array}
	 */
	
	function array(arr, strict) {
	  each(arr, function(val, x) {
	    if (type(val) === 'object') {
	      traverse(val, strict);
	    } else if (isodate.is(val, strict)) {
	      arr[x] = isodate.parse(val);
	    }
	  });
	  return arr;
	}


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _acceptCookies = __webpack_require__(262);
	
	var _fbPixel = __webpack_require__(158);
	
	var _fbPixel2 = _interopRequireDefault(_fbPixel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)((0, _reactRedux.connect)(function (state) {
	  return {
	    acceptCookie: (0, _acceptCookies.getAcceptCookie)(state)
	  };
	}), (0, _withPropsOnChange3.default)(['acceptCookie'], function (props) {
	  _fbPixel2.default.setGranted(props.acceptCookie);
	}));

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactGa = __webpack_require__(1675);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GoogleAnalytics = function () {
	  function GoogleAnalytics(googleAnalytics) {
	    _classCallCheck(this, GoogleAnalytics);
	
	    googleAnalytics.initialize(_config2.default.googleAnalyticsID, { testMode: ("production") === 'test' });
	    this.googleAnalytics = googleAnalytics;
	  }
	
	  _createClass(GoogleAnalytics, [{
	    key: 'logPageView',
	    value: function logPageView(page) {
	      this.googleAnalytics.set({ page: page });
	      this.googleAnalytics.pageview(page);
	    }
	  }, {
	    key: 'event',
	    value: function event(_event) {
	      return this.googleAnalytics.event(_event);
	    }
	  }]);
	
	  return GoogleAnalytics;
	}();
	
	var googleAnalytics = new GoogleAnalytics(_reactGa2.default);
	exports.default = googleAnalytics;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.onRouteUpdate = exports.Analytics = undefined;
	
	var _Analytics = __webpack_require__(876);
	
	Object.defineProperty(exports, 'Analytics', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Analytics).default;
	  }
	});
	
	var _googleAnalytics = __webpack_require__(400);
	
	var _googleAnalytics2 = _interopRequireDefault(_googleAnalytics);
	
	var _fbPixel = __webpack_require__(158);
	
	var _fbPixel2 = _interopRequireDefault(_fbPixel);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line import/prefer-default-export
	var onRouteUpdate = exports.onRouteUpdate = function onRouteUpdate(store, acceptCookies) {
	  return function () {
	    var acceptCookie = acceptCookies.getAcceptCookie(store.getState());
	    if (acceptCookie) _googleAnalytics2.default.logPageView(window.location.pathname);
	    _fbPixel2.default.trackPageView(['instantExperience', 'ownerPixel']);
	    _BookingAnalytics2.default.trackPageview(window.location.pathname);
	  };
	};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reject = __webpack_require__(1481);
	
	var _reject2 = _interopRequireDefault(_reject);
	
	var _constants = __webpack_require__(884);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var fetchCities = function fetchCities(cities) {
	  return [_constants.BAY_AREA].concat(_toConsumableArray(cities));
	};
	
	var fetchShops = function fetchShops(clearShops, fetchAction) {
	  return function (_ref) {
	    var city = _ref.city,
	        args = _objectWithoutProperties(_ref, ['city']);
	
	    return function (dispatch) {
	      dispatch(clearShops());
	      if (city !== _constants.BAY_AREA) return dispatch(fetchAction(_extends({ city: city }, args), false));
	      var filterShops = (0, _reject2.default)({ id: _constants.NO_GREASE_CONCORD_SHOP });
	      var actions = _constants.BAY_AREA_CITIES.map(function (item) {
	        return dispatch(fetchAction(_extends({ city: item }, args), false, filterShops));
	      });
	      return Promise.all(actions);
	    };
	  };
	};
	
	exports.default = {
	  fetchCities: fetchCities,
	  fetchShops: fetchShops
	};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _helpers = __webpack_require__(7);
	
	var _Subtitle = __webpack_require__(113);
	
	var _Subtitle2 = _interopRequireDefault(_Subtitle);
	
	var _Barber = __webpack_require__(885);
	
	var _Barber2 = _interopRequireDefault(_Barber);
	
	var _shapes = __webpack_require__(23);
	
	var _constants = __webpack_require__(10);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Barbers = function Barbers(_ref) {
	  var barbers = _ref.barbers,
	      generateUrlString = _ref.generateUrlString,
	      allowBookWithAnyBarber = _ref.allowBookWithAnyBarber,
	      onBarberClick = _ref.onBarberClick,
	      shop = _ref.shop;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Subtitle2.default,
	      null,
	      'Pick a professional'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-mb' },
	      allowBookWithAnyBarber && _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          to: generateUrlString({ barberRoute: _constants.ANY_BARBER }),
	          className: 'c-btn c-btn--secondary u-width-430 u-inline-block',
	          onClick: function onClick() {
	            _BookingAnalytics2.default.selectBarber(_constants.ANY_BARBER, { shop: shop });
	          }
	        },
	        'Book With Any Professional'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'layout' },
	      (0, _isEmpty3.default)(barbers) && _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up' },
	        'There are no professionals for selected shop'
	      ),
	      !(0, _isEmpty3.default)(barbers) && barbers.map(function (barber) {
	        return _react2.default.createElement(
	          'div',
	          {
	            key: barber.id,
	            className: 'layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up'
	          },
	          _react2.default.createElement(_Barber2.default, {
	            link: generateUrlString({ barberRoute: barber.route }),
	            barber: barber,
	            onClick: onBarberClick,
	            disabled: barber.disabled
	          })
	        );
	      })
	    )
	  );
	};
	Barbers.propTypes = {
	  barbers: _propTypes2.default.arrayOf(_shapes.barberShape).isRequired,
	  generateUrlString: _propTypes2.default.func.isRequired,
	  allowBookWithAnyBarber: _propTypes2.default.bool.isRequired,
	  onBarberClick: _propTypes2.default.func,
	  shop: _propTypes2.default.object.isRequired // eslint-disable-line react/forbid-prop-types
	};
	Barbers.defaultProps = {
	  onBarberClick: _helpers.nullFunc
	};
	
	exports.default = Barbers;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(159);
	
	var _BrandLayout = __webpack_require__(888);
	
	var _BrandLayout2 = _interopRequireDefault(_BrandLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BrandLayoutContainer = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    brandName: (0, _selectors.getBrandName)(state, ownProps.params.brandRoute),
	    brandImage: (0, _selectors.getBrandImage)(state, ownProps.params.brandRoute),
	    brandLogo: (0, _selectors.getBrandLogo)(state, ownProps.params.brandRoute)
	  };
	}))(_BrandLayout2.default);
	
	exports.default = BrandLayoutContainer;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCampaignBookUrl = exports.getCampaignPromo = exports.getCampaignShop = exports.getCampaignUnsubscribeUrl = exports.getCampaignBody = exports.getCampaignSubject = exports.getCampaignColor = exports.getCampaignBackgroundImage = exports.getCampaignShopAddress = exports.getCampaignShopName = exports.getCampaignLogo = exports.getCampaign = exports.getCampaignLoading = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _get = __webpack_require__(176);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _pipe = __webpack_require__(581);
	
	var _pipe2 = _interopRequireDefault(_pipe);
	
	var _isEmpty = __webpack_require__(578);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getCampaignLoading = exports.getCampaignLoading = (0, _get2.default)('campaign.loading');
	
	var getCampaign = exports.getCampaign = (0, _get2.default)('campaign.item');
	
	var getCampaignLogo = exports.getCampaignLogo = (0, _pipe2.default)(getCampaign, (0, _get2.default)('logo.url'));
	
	var getCampaignShopName = exports.getCampaignShopName = (0, _pipe2.default)(getCampaign, (0, _get2.default)('shop.name'));
	
	var getCampaignShopAddress = exports.getCampaignShopAddress = (0, _pipe2.default)(getCampaign, (0, _get2.default)('shop.address'), _helpers.formatAddress);
	
	var getCampaignBackgroundImage = exports.getCampaignBackgroundImage = (0, _pipe2.default)(getCampaign, (0, _get2.default)('background.url'));
	
	var getCampaignColor = exports.getCampaignColor = (0, _pipe2.default)(getCampaign, (0, _get2.default)('color'));
	
	var getCampaignSubject = exports.getCampaignSubject = (0, _pipe2.default)(getCampaign, (0, _get2.default)('subject'));
	
	var getCampaignBody = exports.getCampaignBody = (0, _pipe2.default)(getCampaign, (0, _get2.default)('body'));
	
	var getCampaignUnsubscribeUrl = exports.getCampaignUnsubscribeUrl = (0, _pipe2.default)(getCampaign, (0, _get2.default)('unsubscribeUrl'));
	
	var getCampaignShop = exports.getCampaignShop = (0, _pipe2.default)(getCampaign, (0, _get2.default)('shop'));
	
	var transformPromo = function transformPromo(promo) {
	  if ((0, _isEmpty2.default)(promo)) return {};
	  return _extends({}, promo, {
	    expirationDate: promo.expirationDate && (0, _moment2.default)(promo.expirationDate, _config2.default.apiDateFormat).format(_config2.default.apiDateFormat)
	  });
	};
	
	var getCampaignPromo = exports.getCampaignPromo = (0, _pipe2.default)(getCampaign, (0, _get2.default)('promo'), transformPromo);
	
	var getCampaignBookUrl = exports.getCampaignBookUrl = (0, _pipe2.default)(getCampaign, (0, _get2.default)('bookingUrl'), function (url) {
	  return url || '';
	});

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _capitalize2 = __webpack_require__(1466);
	
	var _capitalize3 = _interopRequireDefault(_capitalize2);
	
	var _momentTimezone = __webpack_require__(67);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADD_TO_CALENDAR_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
	
	var addressToString = function addressToString(address) {
	  if (!address) return '';
	  if (typeof address === 'string') return address;
	
	  var street = address.street,
	      street2 = address.street2,
	      city = address.city,
	      state = address.state,
	      zip = address.zip,
	      country = address.country;
	
	  return [street, street2, city, state, zip, country].filter(Boolean).join(', ');
	};
	
	var formatServicesForDescription = function formatServicesForDescription(appt, commaSeparatedServicesStr) {
	  var services = appt.appointment_service || [];
	  if (!services.length) return commaSeparatedServicesStr.split(',').map(function (s) {
	    return '  '.concat(s);
	  }).join('<br/>');
	  return services.map(function (s) {
	    return '  ' + [s.name, s.desc].filter(Boolean).join(' – ') + '<br/>';
	  });
	};
	
	exports.default = (0, _compose3.default)((0, _withProps3.default)(function (props) {
	  var shop = props.shop,
	      appointment = props.appointment,
	      serviceName = props.serviceName,
	      barberName = props.barberName,
	      customer = props.customer;
	
	  var apptTime = appointment.dateTime || appointment.start;
	  var apptTimeString = _momentTimezone2.default.tz(apptTime, shop.timezone);
	  var servicesForDescription = formatServicesForDescription(appointment, serviceName);
	
	  return {
	    startTime: apptTimeString.format(ADD_TO_CALENDAR_DATE_FORMAT),
	    finishTime: (0, _momentTimezone2.default)(apptTimeString).add(appointment.duration, 'minutes').format(ADD_TO_CALENDAR_DATE_FORMAT),
	    timezone: shop.timezone,
	    title: (0, _capitalize3.default)(serviceName),
	    location: addressToString(shop.address),
	    organizer: customer.name,
	    organizerEmail: customer.email,
	    description: '\n        Confirmation Code: ' + appointment.confirmationCode + '\n        Barber: ' + barberName + '\n        Client: ' + (customer.name || [customer.firstName, customer.lastName].filter(Boolean).join(' ')) + '\n        Duration: ' + (0, _helpers.formatDuration)(appointment.duration) + '\n        Services:\n        ' + servicesForDescription + '\n      '
	  };
	}), (0, _withHandlers3.default)({
	  getCalendarLink: function getCalendarLink(props) {
	    return function (calendarType) {
	      return ('https://addtocalendar.com/atc/' + calendarType + '?f=m&e').concat('[0][date_start]=' + encodeURIComponent(props.startTime) + '&e').concat('[0][date_end]=' + encodeURIComponent(props.finishTime) + '&e').concat('[0][timezone]=' + props.timezone + '&e').concat('[0][title]=' + encodeURIComponent(props.title) + '&e').concat('[0][location]=' + encodeURIComponent(props.location) + '&e').concat('[0][organizer]=' + encodeURIComponent(props.organizer) + '&e').concat('[0][organizer_email]=' + encodeURIComponent(props.organizerEmail) + '&e').concat('[0][description]=' + encodeURIComponent(props.description) + '&e').concat('[0][privacy]=public');
	    };
	  }
	}));

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(7);
	
	var _ThrottledButton = __webpack_require__(917);
	
	var _ThrottledButton2 = _interopRequireDefault(_ThrottledButton);
	
	var _selectors = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ApplePay = function ApplePay(_ref) {
	  var hasApplePay = _ref.hasApplePay,
	      className = _ref.className,
	      processing = _ref.processing,
	      onClick = _ref.onClick,
	      isValidatingAppointment = _ref.isValidatingAppointment;
	
	  if (!hasApplePay) return null;
	
	  return _react2.default.createElement(_ThrottledButton2.default, {
	    type: 'button',
	    className: (0, _classnames2.default)('c-btn c-btn--apple-pay', className),
	    onClick: onClick,
	    disabled: processing || isValidatingAppointment
	  });
	};
	ApplePay.propTypes = {
	  className: _propTypes2.default.string,
	  processing: _propTypes2.default.bool,
	  hasApplePay: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  isValidatingAppointment: _propTypes2.default.bool
	};
	ApplePay.defaultProps = {
	  className: '',
	  processing: false,
	  hasApplePay: false,
	  onClick: _helpers.nullFunc,
	  isValidatingAppointment: false
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    hasApplePay: state.app.applePay,
	    isValidatingAppointment: (0, _selectors.getIsValidatingAppointment)(state)
	  };
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ApplePay);

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debounce2 = __webpack_require__(124);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutoHeight = function (_Component) {
	  _inherits(AutoHeight, _Component);
	
	  function AutoHeight(props) {
	    _classCallCheck(this, AutoHeight);
	
	    var _this = _possibleConstructorReturn(this, (AutoHeight.__proto__ || Object.getPrototypeOf(AutoHeight)).call(this, props));
	
	    _this.onWindowResize = (0, _debounce3.default)(function () {
	      return _this.updateHeight();
	    }, 150);
	
	
	    _this.state = {
	      height: 50
	    };
	    return _this;
	  }
	
	  _createClass(AutoHeight, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.onWindowResize);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        return _this2.updateHeight() && (0, _helpers.fireResizeEventOnWindow)();
	      }); // Wait things to settle before updating height
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.onWindowResize);
	    }
	  }, {
	    key: 'updateHeight',
	    value: function updateHeight() {
	      if (!this.wrapper || this.state.height === this.wrapper.clientHeight) return false;
	      this.setState({ height: this.wrapper.clientHeight });
	      return true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (!this.props.children) return null;
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'c-autoheight',
	          style: { height: this.state.height }
	        },
	        _react2.default.createElement(
	          'div',
	          { ref: function ref(_ref) {
	              _this3.wrapper = _ref;
	            } },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return AutoHeight;
	}(_react.Component);
	
	AutoHeight.propTypes = {
	  children: _propTypes2.default.node
	};
	AutoHeight.defaultProps = {
	  children: null
	};
	
	exports.default = AutoHeight;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Field = __webpack_require__(264);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _shapes = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactInformation = function ContactInformation(_ref) {
	  var fields = _ref.fields,
	      touchField = _ref.touchField,
	      updateField = _ref.updateField,
	      noAutofill = _ref.noAutofill;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'c-heading c-heading--huge u-mb u-show-for-large-and-up' },
	      'Contact Information'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-heading c-heading--huge u-mt u-mb- u-text-center u-hide-for-large-and-up' },
	      'Contact Information'
	    ),
	    _react2.default.createElement(
	      'form',
	      { className: 'layout layout--flush u--ml- large-and-up--ml' },
	      fields.map(function (field) {
	        return _react2.default.createElement(
	          'div',
	          {
	            key: field.id,
	            className: (0, _classnames2.default)('layout__item u-pl- large-and-up-pl u-mb- large-and-up-mb', { 'u-1/1': field.fullWidth,
	              'u-1/2-small-plus-and-up': !field.fullWidth })
	          },
	          _react2.default.createElement(_Field2.default, {
	            id: field.id,
	            label: field.label,
	            errorMessage: field.errorMessage,
	            autoComplete: noAutofill ? 'off' : field.autoComplete,
	            name: field.name,
	            required: field.required,
	            onChange: updateField(field),
	            onBlur: touchField(field),
	            type: field.type,
	            error: field.error,
	            value: field.value
	          })
	        );
	      })
	    )
	  );
	};
	ContactInformation.propTypes = {
	  fields: _propTypes2.default.arrayOf(_shapes.fieldShape),
	  touchField: _propTypes2.default.func,
	  updateField: _propTypes2.default.func,
	  noAutofill: _propTypes2.default.bool
	};
	ContactInformation.defaultProps = {
	  fields: [],
	  touchField: null,
	  updateField: null,
	  noAutofill: false
	};
	
	exports.default = ContactInformation;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorMsg = function ErrorMsg(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('c-heading u-co-red epsilon u-type--bold', className) },
	    children
	  );
	};
	ErrorMsg.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  className: _propTypes2.default.string
	};
	ErrorMsg.defaultProps = {
	  className: ''
	};
	
	exports.default = ErrorMsg;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var attributesByCountry = new Map([['United States', {
	  type: 'text', // let zip start with 0
	  inputMode: 'numeric', // force numeric keyboard
	  minLength: '5',
	  maxLength: '5'
	}]]);
	
	var InputZip = function InputZip(_ref) {
	  var country = _ref.country,
	      setRef = _ref.setRef,
	      props = _objectWithoutProperties(_ref, ['country', 'setRef']);
	
	  return _react2.default.createElement('input', Object.assign({}, props, attributesByCountry.get(country), { ref: setRef }));
	};
	
	InputZip.propTypes = {
	  country: _propTypes2.default.string,
	  setRef: _propTypes2.default.func
	};
	InputZip.defaultProps = {
	  country: undefined,
	  setRef: undefined
	};
	
	exports.default = InputZip;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _instagramLogo = __webpack_require__(1821);
	
	var _instagramLogo2 = _interopRequireDefault(_instagramLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InstagramLink = function InstagramLink(_ref) {
	  var user = _ref.user;
	
	  if (!user) return null;
	  return _react2.default.createElement(
	    'a',
	    { className: 'c-instagram-link', href: 'https://www.instagram.com/' + user, target: '_blank', onClickCapture: function onClickCapture(e) {
	        return e.stopPropagation();
	      } },
	    _react2.default.createElement('img', { src: _instagramLogo2.default, alt: '' })
	  );
	};
	InstagramLink.propTypes = {
	  user: _propTypes2.default.string
	};
	InstagramLink.defaultProps = {
	  user: ''
	};
	
	exports.default = InstagramLink;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRouter = __webpack_require__(5);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _momentTimezone = __webpack_require__(67);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _shapes = __webpack_require__(23);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _WithApplePay = __webpack_require__(274);
	
	var _WithApplePay2 = _interopRequireDefault(_WithApplePay);
	
	var _helpers = __webpack_require__(7);
	
	var _selectors = __webpack_require__(11);
	
	var _selectors2 = __webpack_require__(51);
	
	var _WithKioskProp = __webpack_require__(59);
	
	var _WithKioskProp2 = _interopRequireDefault(_WithKioskProp);
	
	var _WithReserveTimeHandler = __webpack_require__(994);
	
	var _WithReserveTimeHandler2 = _interopRequireDefault(_WithReserveTimeHandler);
	
	var _WithTimezone = __webpack_require__(115);
	
	var _WithTimezone2 = _interopRequireDefault(_WithTimezone);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	var _selectors3 = __webpack_require__(71);
	
	var _selectors4 = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReserveLink = function ReserveLink(_ref) {
	  var to = _ref.to,
	      shouldShowApplePay = _ref.shouldShowApplePay,
	      reserveTime = _ref.reserveTime,
	      service = _ref.service,
	      date = _ref.date,
	      time = _ref.time,
	      timezone = _ref.timezone,
	      from = _ref.from,
	      barber = _ref.barber,
	      shop = _ref.shop;
	
	  var proceedToCheckout = function proceedToCheckout() {
	    var isApplePay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _BookingAnalytics2.default.proceedToCheckout(_extends({}, from === 'barber' ? { barber: barber && barber.toJS() } : { service: service }, {
	        date: date,
	        time: _momentTimezone2.default.tz(time, timezone).format('h:mmA'),
	        isApplePay: isApplePay,
	        shouldShowApplePay: shouldShowApplePay,
	        shop: shop
	      }));
	
	      return reserveTime.apply(undefined, args.concat([to]));
	    };
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'layout layout--auto layout--center u-mt' },
	    _react2.default.createElement(
	      'div',
	      { className: 'layout__item' },
	      _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          onClick: proceedToCheckout(),
	          to: to,
	          className: 'c-btn c-btn--primary'
	        },
	        'Review & Book'
	      )
	    ),
	    shouldShowApplePay && _react2.default.createElement(
	      'div',
	      { className: 'layout__item' },
	      _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          onClick: proceedToCheckout(true),
	          to: (0, _helpers.extendLocation)(to, { query: { applePay: true } }),
	          className: 'c-btn c-btn--default'
	        },
	        _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.APPLE, size: 'large' }),
	        ' Review & Pay'
	      )
	    )
	  );
	};
	ReserveLink.propTypes = {
	  to: _shapes.linkShape.isRequired,
	  from: _propTypes2.default.string.isRequired,
	  shouldShowApplePay: _propTypes2.default.bool.isRequired,
	  reserveTime: _propTypes2.default.func.isRequired,
	  service: _propTypes2.default.string.isRequired,
	  barber: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
	  shop: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
	  date: _propTypes2.default.string.isRequired,
	  time: _propTypes2.default.string.isRequired,
	  timezone: _propTypes2.default.string.isRequired
	};
	exports.default = (0, _compose3.default)(_WithKioskProp2.default, _WithApplePay2.default, _WithTimezone2.default, _reactRouter.withRouter, _WithReserveTimeHandler2.default, (0, _reactRedux.connect)(function (state, ownParams) {
	  return {
	    isKrwnZazzPlaceSteFoyShop: (0, _selectors.getIsKrwnZazzPlaceSteFoyShop)(state, ownParams.params.shopRoute),
	    service: (0, _selectors2.getServiceName)(state, ownParams.params.serviceId),
	    date: (0, _selectors3.getActiveDay)(state),
	    time: (0, _helpers.parseTimeSlug)((0, _selectors3.getActiveTime)(state), ownParams.timezone),
	    barber: (0, _selectors4.getBarberByIdOrRoute)(state, ownParams.params.barberRoute),
	    shop: (0, _selectors.getShopByRoute)(state, ownParams.params.shopRoute)
	  };
	}), (0, _withProps3.default)(function (props) {
	  return {
	    shouldShowApplePay: !props.kiosk && props.hasApplePay && !props.isKrwnZazzPlaceSteFoyShop
	  };
	}))(ReserveLink);

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _breakpoint = __webpack_require__(267);
	
	var _breakpoint2 = _interopRequireDefault(_breakpoint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DesktopBreakpoint = function DesktopBreakpoint(props) {
	  return _react2.default.createElement(
	    _breakpoint2.default,
	    { name: 'desktop' },
	    props.children
	  );
	};
	
	DesktopBreakpoint.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = DesktopBreakpoint;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _breakpoint = __webpack_require__(267);
	
	var _breakpoint2 = _interopRequireDefault(_breakpoint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotDesktopBreakpoint = function NotDesktopBreakpoint(props) {
	  return _react2.default.createElement(
	    _breakpoint2.default,
	    { name: 'notDesktop' },
	    props.children
	  );
	};
	
	NotDesktopBreakpoint.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = NotDesktopBreakpoint;

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOAD_EXTENSION = exports.LOAD_EXTENSION = 'LOAD_EXTENSION';
	var LOAD_EXTENSION_ERROR = exports.LOAD_EXTENSION_ERROR = 'LOAD_EXTENSION_ERROR';
	var LOAD_EXTENSION_SUCCESS = exports.LOAD_EXTENSION_SUCCESS = 'LOAD_EXTENSION_SUCCESS';

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isExtensionLoading = exports.getLoadingList = exports.isLoading = exports.getExtensionByShopId = exports.getExtension = undefined;
	
	var _pathOr2 = __webpack_require__(754);
	
	var _pathOr3 = _interopRequireDefault(_pathOr2);
	
	var _toPairs2 = __webpack_require__(1588);
	
	var _toPairs3 = _interopRequireDefault(_toPairs2);
	
	var _find2 = __webpack_require__(740);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _pipe2 = __webpack_require__(75);
	
	var _pipe3 = _interopRequireDefault(_pipe2);
	
	var _contains2 = __webpack_require__(737);
	
	var _contains3 = _interopRequireDefault(_contains2);
	
	var _path2 = __webpack_require__(87);
	
	var _path3 = _interopRequireDefault(_path2);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getExtension = exports.getExtension = function getExtension(state, idOrRoute) {
	  return (0, _path3.default)(['extensions', 'byId', idOrRoute], state) || (0, _path3.default)(['extensions', 'byRoute', idOrRoute], state);
	};
	
	var getExtensionByShopId = exports.getExtensionByShopId = function getExtensionByShopId(state, shopId) {
	  return (0, _pipe3.default)((0, _pathOr3.default)({}, ['extensions', 'byId']), _toPairs3.default, (0, _find3.default)(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        extension = _ref2[1];
	
	    return extension.shops && extension.shops.includes(shopId);
	  }), (0, _pathOr3.default)(null, [1]))(state);
	};
	
	var isLoading = exports.isLoading = (0, _path3.default)(['extensions', 'busy']);
	var getLoadingList = exports.getLoadingList = (0, _path3.default)(['extensions', 'loadingList']);
	var isExtensionLoading = exports.isExtensionLoading = function isExtensionLoading(state, idOrRoute) {
	  return (0, _pipe3.default)(getLoadingList, (0, _contains3.default)(idOrRoute))(state);
	};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GiftCardLink = __webpack_require__(972);
	
	var _GiftCardLink2 = _interopRequireDefault(_GiftCardLink);
	
	var _GiftCardLinkContainer = __webpack_require__(973);
	
	var _GiftCardLinkContainer2 = _interopRequireDefault(_GiftCardLinkContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _GiftCardLinkContainer2.default)(_GiftCardLink2.default);

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateSelectedBarber = exports.updateGcAmount = exports.buyGiftCard = exports.setGiftCard = undefined;
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _constants = __webpack_require__(10);
	
	var _helpers = __webpack_require__(7);
	
	var _constants2 = __webpack_require__(420);
	
	var _actions = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setGiftCard = exports.setGiftCard = function setGiftCard(giftCard) {
	  return function (dispatch) {
	    return dispatch({
	      type: _constants2.SET_GC,
	      payload: giftCard
	    });
	  };
	};
	
	var showErrorMessage = function showErrorMessage(dispatch) {
	  return function (error) {
	    dispatch((0, _actions.setProcessing)(false));
	    window.swal({
	      title: 'Error!',
	      text: error.message,
	      type: 'error',
	      confirmButtonColor: '#DD6B55'
	    });
	  };
	};
	
	var buyGiftCardAPI = function buyGiftCardAPI(shop, data, successUrl) {
	  return function (dispatch) {
	    return fetch(_config2.default.url + '/shop/' + shop.id + '/customer-gift-card', {
	      method: 'POST',
	      headers: {
	        Accept: 'application/json',
	        'Content-Type': 'application/json'
	      },
	      body: JSON.stringify(data)
	    }).then(_helpers.checkStatus).then(function (response) {
	      setGiftCard(response)(dispatch);
	      dispatch({
	        type: _constants.SET_REDIRECTION,
	        payload: successUrl
	      });
	      return dispatch((0, _actions.processPaymentSuccess)());
	    }).catch(showErrorMessage(dispatch));
	  };
	};
	
	var buyGiftCard = exports.buyGiftCard = (0, _actions.wrapWithSetProcessingAction)(buyGiftCardAPI);
	
	var updateGcAmount = exports.updateGcAmount = function updateGcAmount(amount) {
	  return function (dispatch) {
	    return dispatch({
	      type: _constants2.UPDATE_GC_AMOUNT,
	      payload: amount
	    });
	  };
	};
	
	var updateSelectedBarber = exports.updateSelectedBarber = function updateSelectedBarber(barber) {
	  return function (dispatch) {
	    return dispatch({
	      type: _constants2.UPDATE_GC_BARBER,
	      payload: barber
	    });
	  };
	};

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_GC = exports.SET_GC = 'SET_GC';
	var UPDATE_GC_AMOUNT = exports.UPDATE_GC_AMOUNT = 'UPDATE_GC_AMOUNT';
	var UPDATE_GC_BARBER = exports.UPDATE_GC_BARBER = 'UPDATE_GC_BARBER';

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(11);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    areGcSalesDisabledForBarber: (0, _selectors.areGcSalesDisabledForBarber)(state)
	  };
	});

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(423);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    gcAmount: (0, _selectors.getGiftCardAmount)(state)
	  };
	});

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getGiftCardAmount = exports.getGiftCardAmount = function getGiftCardAmount(state) {
	  return state.giftCard.get('amount');
	};
	var getGiftCardBarber = exports.getGiftCardBarber = function getGiftCardBarber(state) {
	  return state.giftCard.get('barber');
	};

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onClick = function onClick(method, options) {
	  return function () {
	    _BookingAnalytics2.default[method](options);
	  };
	};
	
	var TrackClick = function TrackClick(_ref) {
	  var children = _ref.children,
	      method = _ref.method,
	      options = _ref.options;
	  return _react2.default.createElement(
	    'div',
	    {
	      role: 'presentation',
	      onClick: onClick(method, options)
	    },
	    children
	  );
	}; // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions
	
	TrackClick.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  method: _propTypes2.default.string.isRequired,
	  options: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
	};
	
	TrackClick.defaultProps = {
	  options: undefined
	};
	
	exports.default = TrackClick;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _helpers = __webpack_require__(7);
	
	var _actions = __webpack_require__(99);
	
	var _WithFetchAvailability = __webpack_require__(275);
	
	var _WithFetchAvailability2 = _interopRequireDefault(_WithFetchAvailability);
	
	var _constants = __webpack_require__(10);
	
	var _WithTimezone = __webpack_require__(115);
	
	var _WithTimezone2 = _interopRequireDefault(_WithTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BarberAvailableTimeRangeProvider = function BarberAvailableTimeRangeProvider(propStartDateKey) {
	  return (0, _compose3.default)((0, _withPropsOnChange3.default)(['serviceDuration', 'barberId', 'shopId'], function (props) {
	    props.clearBarberAvailability();
	    props.fetchAvailability(props[propStartDateKey]);
	  }));
	};
	
	var ShopAvailableTimeRangeProvider = function ShopAvailableTimeRangeProvider(propStartDateKey) {
	  return (0, _compose3.default)((0, _withPropsOnChange3.default)(['serviceId', 'shopId'], function (props) {
	    props.clearBarberAvailability();
	    props.fetchAvailability(props[propStartDateKey]);
	  }));
	};
	
	var AvailableTimeRangeProvider = function AvailableTimeRangeProvider(propStartDateKey) {
	  return (0, _compose3.default)(_WithFetchAvailability2.default, _WithTimezone2.default, (0, _withHandlers3.default)({
	    fetchAvailability: function fetchAvailability(props) {
	      return function (fromDate) {
	        return props.fetchAvailability((0, _helpers.getAvailableTimesStartDay)(props.timezone)(fromDate), (0, _helpers.getAvailableTimesEndDay)(props.timezone)(fromDate), props.appointmentId);
	      };
	    }
	  }), (0, _reactRedux.connect)(null, { clearBarberAvailability: _actions.clearBarberAvailability }), (0, _branch3.default)(function (props) {
	    return props.barberId === _constants.ANY_BARBER;
	  }, ShopAvailableTimeRangeProvider(propStartDateKey), BarberAvailableTimeRangeProvider(propStartDateKey)), (0, _lifecycle3.default)({
	    componentDidMount: function componentDidMount() {
	      this.props.fetchAvailability(this.props[propStartDateKey]);
	    }
	  }), (0, _withPropsOnChange3.default)([propStartDateKey], function (props) {
	    props.fetchAvailability(props[propStartDateKey]);
	  }));
	};
	
	exports.default = AvailableTimeRangeProvider;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(71);
	
	var _constants = __webpack_require__(10);
	
	var _selectors2 = __webpack_require__(11);
	
	var _selectors3 = __webpack_require__(27);
	
	var _selectors4 = __webpack_require__(21);
	
	var reservationSelectors = _interopRequireWildcard(_selectors4);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WithAdvanceBookDays = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  var anyBarber = ownProps.params.barberRoute === _constants.ANY_BARBER;
	  var advanceBookDays = function () {
	    if (!ownProps.params.barberRoute) {
	      return reservationSelectors.getBarberAdvanceBookDays(state);
	    }
	    if (anyBarber) {
	      return (0, _selectors2.getShopAdvanceBookDays)(state, ownProps.params.shopRoute);
	    }
	    return (0, _selectors3.getBarberAdvanceBookDays)(state, ownProps.params.barberRoute);
	  }();
	  return {
	    activeDay: (0, _selectors.getActiveDay)(state),
	    advanceBookDays: advanceBookDays
	  };
	}));
	
	exports.default = WithAdvanceBookDays;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _nest2 = __webpack_require__(1748);
	
	var _nest3 = _interopRequireDefault(_nest2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _AutoHeight = __webpack_require__(408);
	
	var _AutoHeight2 = _interopRequireDefault(_AutoHeight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _branch3.default)(function (_ref) {
	  var autoHeight = _ref.autoHeight;
	  return autoHeight;
	}, function (BaseComponent) {
	  return (0, _nest3.default)(_AutoHeight2.default, BaseComponent);
	});

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(277);
	
	var WithInstantExperiences = (0, _reactRedux.connect)(function (state) {
	  return {
	    instantExperiences: (0, _selectors.getInstantExperiences)(state),
	    getInstantExperiencesOwner: (0, _selectors.getInstantExperiencesOwner)(state)
	  };
	});
	
	exports.default = WithInstantExperiences;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _withProps3.default)({
	  urlPattern: _config2.default.urlPatterns.kiosk
	});

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(11);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    shops: (0, _selectors.getShops)(state)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps);

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(295);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    thirdPartyPromo: (0, _selectors.getThirdPartyPromotion)(state)
	  };
	};
	
	exports.default = (0, _compose3.default)((0, _reactRedux.connect)(mapStateToProps, null));

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose = __webpack_require__(4);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _branch = __webpack_require__(14);
	
	var _branch2 = _interopRequireDefault(_branch);
	
	var _renderNothing = __webpack_require__(22);
	
	var _renderNothing2 = _interopRequireDefault(_renderNothing);
	
	var _WithInstantExperiences = __webpack_require__(428);
	
	var _WithInstantExperiences2 = _interopRequireDefault(_WithInstantExperiences);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var preventRenderForEmbeddedMode = (0, _compose2.default)(_WithInstantExperiences2.default, (0, _branch2.default)(function (props) {
	  return props.instantExperiences;
	}, _renderNothing2.default));
	
	exports.default = preventRenderForEmbeddedMode;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose = __webpack_require__(4);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _branch = __webpack_require__(14);
	
	var _branch2 = _interopRequireDefault(_branch);
	
	var _renderNothing = __webpack_require__(22);
	
	var _renderNothing2 = _interopRequireDefault(_renderNothing);
	
	var _reactRouter = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkIfKiosk = function checkIfKiosk(_ref) {
	  var pathname = _ref.location.pathname;
	  return (/kiosk/.test(pathname)
	  );
	};
	
	var preventRenderForKioskMode = (0, _compose2.default)(_reactRouter.withRouter, (0, _branch2.default)(checkIfKiosk, _renderNothing2.default));
	
	exports.default = preventRenderForKioskMode;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pixelReservationEvent = exports.setInstantExperiencesOwner = exports.setInstantExperiences = undefined;
	
	var _constants = __webpack_require__(435);
	
	var _selectors = __webpack_require__(277);
	
	var _fbPixel = __webpack_require__(158);
	
	var _fbPixel2 = _interopRequireDefault(_fbPixel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setInstantExperiences = exports.setInstantExperiences = function setInstantExperiences(payload) {
	  return {
	    type: _constants.SET_INSTANT_EXPERIENCES,
	    payload: payload
	  };
	};
	
	var setInstantExperiencesOwner = exports.setInstantExperiencesOwner = function setInstantExperiencesOwner(payload) {
	  return {
	    type: _constants.SET_INSTANT_EXPERIENCES_OWNER,
	    payload: payload
	  };
	};
	
	var pixelReservationEventAction = function pixelReservationEventAction(data) {
	  return {
	    type: _constants.FB_PIXEL_RESERVATION,
	    data: data
	  };
	};
	
	var pixelReservationEvent = exports.pixelReservationEvent = function pixelReservationEvent(data) {
	  return function (dispatch, getState) {
	    var instantExperiences = (0, _selectors.getInstantExperiences)(getState());
	    var instantExperiencesOwner = (0, _selectors.getInstantExperiencesOwner)(getState());
	    if (!instantExperiences || !_fbPixel2.default.fbEventsInitialized) return;
	
	    // track reservation in case shop uses deprecated ig ix and schedule if it's a fbe ig booking
	    if (!instantExperiencesOwner) {
	      var eventData = {
	        reservation_id: data.id,
	        reservation_time: data.dateTime,
	        reservation_size: 2,
	        merchant_id: data.shopId
	      };
	
	      _fbPixel2.default.trackReservation('instantExperience', eventData);
	      dispatch(pixelReservationEventAction(eventData));
	    } else {
	      _fbPixel2.default.trackSchedule('instantExperience');
	    }
	  };
	};

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_INSTANT_EXPERIENCES = exports.SET_INSTANT_EXPERIENCES = 'SET_INSTANT_EXPERIENCES';
	var FB_PIXEL_RESERVATION = exports.FB_PIXEL_RESERVATION = 'FB_PIXEL_RESERVATION';
	var SET_INSTANT_EXPERIENCES_OWNER = exports.SET_INSTANT_EXPERIENCES_OWNER = 'SET_INSTANT_EXPERIENCES_OWNER';

/***/ }),
/* 436 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// eslint-disable-next-line import/prefer-default-export
	var BACK_BUTTON_GATEWAY = exports.BACK_BUTTON_GATEWAY = 'back-button';

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateCustomerInfo = exports.clearSuccess = exports.showSuccess = exports.updateField = exports.touchField = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _helpers = __webpack_require__(7);
	
	var _constants = __webpack_require__(440);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validateField = function validateField(id, countryCode, shop) {
	  return {
	    type: _constants.UPDATE_CUSTOMER_VALIDATE_FIELD,
	    payload: { id: id, countryCode: countryCode, shop: shop }
	  };
	};
	
	var touchField = exports.touchField = function touchField(id, countryCode, shop) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.UPDATE_CUSTOMER_TOUCH_FIELD,
	      payload: id
	    });
	
	    return dispatch(validateField(id, countryCode, shop));
	  };
	};
	
	var updateField = exports.updateField = function updateField(id, value, countryCode, shop) {
	  return function (dispatch) {
	    dispatch({
	      type: _constants.UPDATE_CUSTOMER_UPDATE_FIELD,
	      payload: { id: id, value: value }
	    });
	
	    return dispatch(validateField(id, countryCode, shop));
	  };
	};
	
	var showSuccess = exports.showSuccess = function showSuccess() {
	  return {
	    type: _constants.UPDATE_CUSTOMER_SUCCESS
	  };
	};
	
	var clearSuccess = exports.clearSuccess = function clearSuccess() {
	  return {
	    type: _constants.UPDATE_CUSTOMERP_CLEAR_SUCCESS
	  };
	};
	
	var updateCustomerInfo = exports.updateCustomerInfo = function updateCustomerInfo(id, customerData, tokenData, subscriptionId) {
	  return function (dispatch) {
	    var url = _config2.default.url + '/customer/' + id + '/info';
	
	    return fetch(url, {
	      method: 'PUT',
	      headers: {
	        'Content-Type': 'application/json'
	      },
	      body: JSON.stringify(_extends({}, customerData, {
	        token: tokenData.id,
	        subscriptionId: subscriptionId
	      }))
	    }).then(_helpers.checkStatus).then(function () {
	      return dispatch(showSuccess());
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionTitle = function SectionTitle(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-heading c-heading--huge u-mb' },
	    children
	  );
	};
	
	SectionTitle.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = SectionTitle;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContactInformationContainer = __webpack_require__(1022);
	
	var _ContactInformationContainer2 = _interopRequireDefault(_ContactInformationContainer);
	
	var _UpdateCardButton = __webpack_require__(1021);
	
	var _UpdateCardButton2 = _interopRequireDefault(_UpdateCardButton);
	
	var _Container = __webpack_require__(1018);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Section = __webpack_require__(1019);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _CardInfoModal = __webpack_require__(1017);
	
	var _CardInfoModal2 = _interopRequireDefault(_CardInfoModal);
	
	var _SuccessAlert = __webpack_require__(1020);
	
	var _SuccessAlert2 = _interopRequireDefault(_SuccessAlert);
	
	var _uiHelpers = __webpack_require__(442);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UpdateCustomerInfo = function UpdateCustomerInfo(_ref) {
	  var formDisabled = _ref.formDisabled,
	      toggled = _ref.toggled,
	      on = _ref.on,
	      off = _ref.off,
	      confirmSetup = _ref.confirmSetup,
	      isSuccess = _ref.isSuccess,
	      onSuccess = _ref.onSuccess,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        _Section2.default,
	        null,
	        children
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        null,
	        _react2.default.createElement(_ContactInformationContainer2.default, null)
	      ),
	      _react2.default.createElement(
	        _UpdateCardButton2.default,
	        {
	          disabled: formDisabled,
	          onClick: on
	        },
	        'Update Credit Card'
	      ),
	      _react2.default.createElement(_SuccessAlert2.default, { show: isSuccess, text: _uiHelpers.successMessage, onConfirm: onSuccess }),
	      toggled && _react2.default.createElement(_CardInfoModal2.default, { off: off, confirmSetup: confirmSetup })
	    )
	  );
	};
	
	UpdateCustomerInfo.propTypes = {
	  off: _propTypes2.default.func.isRequired,
	  on: _propTypes2.default.func.isRequired,
	  toggled: _propTypes2.default.bool,
	  confirmSetup: _propTypes2.default.func.isRequired,
	  formDisabled: _propTypes2.default.bool,
	  isSuccess: _propTypes2.default.bool,
	  onSuccess: _propTypes2.default.func.isRequired,
	  children: _propTypes2.default.node.isRequired
	};
	
	UpdateCustomerInfo.defaultProps = {
	  formDisabled: false,
	  toggled: false,
	  isSuccess: false
	};
	
	exports.default = UpdateCustomerInfo;

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UPDATE_CUSTOMER_TOUCH_FIELD = exports.UPDATE_CUSTOMER_TOUCH_FIELD = 'UPDATE_CUSTOMER_TOUCH_FIELD';
	var UPDATE_CUSTOMER_VALIDATE_FIELD = exports.UPDATE_CUSTOMER_VALIDATE_FIELD = 'UPDATE_CUSTOMER_VALIDATE_FIELD';
	var UPDATE_CUSTOMER_UPDATE_FIELD = exports.UPDATE_CUSTOMER_UPDATE_FIELD = 'UPDATE_CUSTOMER_UPDATE_FIELD';
	var UPDATE_CUSTOMER_SUCCESS = exports.UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS';
	var UPDATE_CUSTOMERP_CLEAR_SUCCESS = exports.UPDATE_CUSTOMERP_CLEAR_SUCCESS = 'UPDATE_CUSTOMERP_CLEAR_SUCCESS';

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _extensions = __webpack_require__(95);
	
	var _extensions2 = _interopRequireDefault(_extensions);
	
	var _WithToggle = __webpack_require__(63);
	
	var _WithToggle2 = _interopRequireDefault(_WithToggle);
	
	var _selectors = __webpack_require__(1024);
	
	var _actions = __webpack_require__(437);
	
	var _selectors2 = __webpack_require__(159);
	
	var _routes = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, _extensions2.default, _WithToggle2.default, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    brandRoute: ownProps.params.brandRoute,
	    customerId: ownProps.params.customerId,
	    customerName: ownProps.location.query.firstName,
	    brandName: (0, _selectors2.getBrandName)(state, ownProps.params.brandRoute),
	    subscriptionId: ownProps.location.query.subscription,
	    formDisabled: !(0, _selectors.getIsFormValid)(state),
	    user: (0, _selectors.getUser)(state),
	    isSuccess: (0, _selectors.isSuccess)(state)
	  };
	}, { updateCustomerInfo: _actions.updateCustomerInfo, clearSuccess: _actions.clearSuccess }), (0, _withHandlers3.default)({
	  confirmSetup: function confirmSetup(props) {
	    return function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(token) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return props.updateCustomerInfo(props.customerId, props.user, token, props.subscriptionId);
	
	              case 2:
	                props.off();
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	  },
	  onSuccess: function onSuccess(props) {
	    return function () {
	      props.clearSuccess();
	      props.router.push((0, _routes.prependLocationPrefix)('/'));
	    };
	  }
	}), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    this.props.fetchExtension(this.props.brandRoute);
	  }
	}));

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var contactFields = exports.contactFields = [{
	  id: 'firstName',
	  name: 'fname',
	  label: 'First name',
	  errorMessage: 'You must enter first name',
	  autoComplete: 'given-name',
	  required: true
	}, {
	  id: 'lastName',
	  name: 'lname',
	  label: 'Last name',
	  errorMessage: 'You must enter last name',
	  autoComplete: 'family-name',
	  required: true
	}, {
	  id: 'phone',
	  name: 'phone',
	  label: 'Phone number',
	  errorMessage: 'You must enter valid phone number',
	  autoComplete: 'tel-national',
	  required: true,
	  type: 'tel'
	}, {
	  id: 'email',
	  name: 'email',
	  label: 'Email address',
	  errorMessage: 'You must enter valid email that you own',
	  autoComplete: 'email',
	  required: true,
	  type: 'email'
	}];
	
	var successMessage = exports.successMessage = 'Your information has been updated successfully';

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AddToCalendarContainer = __webpack_require__(406);
	
	var _AddToCalendarContainer2 = _interopRequireDefault(_AddToCalendarContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddToCalendar = function AddToCalendar(_ref) {
	  var className = _ref.className,
	      getCalendarLink = _ref.getCalendarLink;
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(
	      'div',
	      { className: 'u-text-medium u-co-gray u-mb-3' },
	      'Add to calendar'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-text-center u-flex' },
	      _react2.default.createElement(
	        'a',
	        { className: 'c-calendar-button u-mr-2 dark-invert', href: getCalendarLink('ical'), target: '_blank' },
	        _react2.default.createElement(
	          'span',
	          { 'data-bg-icon': 'apple' },
	          'iCal'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { className: 'c-calendar-button u-mr-2 dark-invert', href: getCalendarLink('google'), target: '_blank' },
	        _react2.default.createElement(
	          'span',
	          { 'data-bg-icon': 'google' },
	          'Google'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { className: 'c-calendar-button dark-invert', href: getCalendarLink('yahoo'), target: '_blank' },
	        _react2.default.createElement(
	          'span',
	          { 'data-bg-icon': 'yahoo' },
	          'Yahoo'
	        )
	      )
	    )
	  );
	};
	
	AddToCalendar.propTypes = {
	  className: _propTypes2.default.string,
	  getCalendarLink: _propTypes2.default.func.isRequired
	};
	
	AddToCalendar.defaultProps = {
	  className: ''
	};
	
	exports.default = (0, _AddToCalendarContainer2.default)(AddToCalendar);

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hr = function Hr() {
	  return _react2.default.createElement('div', { className: 'c-vi-hr' });
	};
	
	exports.default = Hr;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Hr = __webpack_require__(444);
	
	var _Hr2 = _interopRequireDefault(_Hr);
	
	__webpack_require__(1298);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InnerFooter = function InnerFooter(_ref) {
	  var shopName = _ref.shopName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Hr2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-vi-inner-footer-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-vi-inner-footer-column left' },
	        "You're",
	        ' receiving this email because you use Squire to manage your appointments for ',
	        shopName,
	        '.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-vi-inner-footer-column right' },
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.instagram.com/getsquire/', target: '_blank', rel: 'noopener noreferrer' },
	          _react2.default.createElement('img', { src: 'https://assets.getsquire.com/widget-release-email/instagram.png', alt: 'IG', role: 'presentation' }),
	          'Instagram'
	        )
	      )
	    )
	  );
	};
	
	InnerFooter.propTypes = {
	  shopName: _propTypes2.default.string.isRequired
	};
	
	exports.default = InnerFooter;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo() {
	  return _react2.default.createElement("img", {
	    src: "https://assets.getsquire.com/widget-release-email/logo.png",
	    srcSet: "https://assets.getsquire.com/widget-release-email/logo@2x.png 2x",
	    role: "presentation",
	    alt: "Squire",
	    title: "Squire logo",
	    className: "c-vi-logo"
	  });
	};
	
	exports.default = Logo;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validatePasscode = exports.setPasscodePassed = exports.hidePasscode = exports.showPasscode = undefined;
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _helpers = __webpack_require__(7);
	
	var _constants = __webpack_require__(448);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var showPasscode = exports.showPasscode = function showPasscode(idOrRoute) {
	  return { type: _constants.SHOW_PASSCODE, payload: idOrRoute };
	};
	var hidePasscode = exports.hidePasscode = function hidePasscode() {
	  return { type: _constants.HIDE_PASSCODE };
	};
	
	var setPasscodePassed = exports.setPasscodePassed = function setPasscodePassed(barber) {
	  return {
	    type: _constants.PASSCODE_PASSED,
	    payload: barber
	  };
	};
	
	var validatePasscode = exports.validatePasscode = function validatePasscode(barberId, passcode) {
	  var url = _config2.default.url + '/barber/validate/' + barberId;
	
	  return function (dispatch) {
	    return fetch(url, {
	      method: 'POST',
	      headers: {
	        Accept: 'application/json',
	        'Content-Type': 'application/json'
	      },
	      body: JSON.stringify({ passcode: passcode })
	    }).then(_helpers.checkStatus).then(function (response) {
	      return response.passcode;
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SHOW_PASSCODE = exports.SHOW_PASSCODE = 'SHOW_PASSCODE';
	var HIDE_PASSCODE = exports.HIDE_PASSCODE = 'HIDE_PASSCODE';
	
	var PASSCODE_PASSED = exports.PASSCODE_PASSED = 'PASSCODE_PASSED';

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assoc2 = __webpack_require__(355);
	
	var _assoc3 = _interopRequireDefault(_assoc2);
	
	var _redux = __webpack_require__(49);
	
	var _constants = __webpack_require__(448);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var visibleFor = function visibleFor() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SHOW_PASSCODE:
	      return action.payload;
	    case _constants.HIDE_PASSCODE:
	      return false;
	    default:
	      return state;
	  }
	};
	
	var byBarberId = function byBarberId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.PASSCODE_PASSED:
	      return (0, _assoc3.default)(action.payload.id, true, state);
	    default:
	      return state;
	  }
	};
	
	var byBarberRoute = function byBarberRoute() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.PASSCODE_PASSED:
	      return (0, _assoc3.default)(action.payload.route, true, state);
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({ visibleFor: visibleFor, byBarberId: byBarberId, byBarberRoute: byBarberRoute });

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// eslint-disable-next-line import/prefer-default-export
	var SET_POSITION = exports.SET_POSITION = 'SET_POSITION';

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchReceipt = exports.getReceipt = undefined;
	
	var _constants = __webpack_require__(10);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getReceipt = exports.getReceipt = function getReceipt(id, transactionId) {
	  return fetch(_config2.default.url + '/pos/receipt/' + id + '/' + transactionId).then(_helpers.checkStatus);
	};
	
	// eslint-disable-next-line import/prefer-default-export
	var fetchReceipt = exports.fetchReceipt = function fetchReceipt(id, transactionIdentifier) {
	  return function (dispatch) {
	    dispatch({ type: _constants.FETCH_RECEIPT });
	    return getReceipt(id, transactionIdentifier).then(function (response) {
	      if (response.shop.logo) {
	        var shopLogo = new Image();
	        shopLogo.src = response.shop.logo.url;
	        shopLogo.onload = function () {
	          dispatch({ type: _constants.FETCH_RECEIPT_SUCCESS, payload: response });
	        };
	      } else {
	        dispatch({ type: _constants.FETCH_RECEIPT_SUCCESS, payload: response });
	      }
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getShopObjectFromReceipt = exports.getReceiptLoading = exports.getReceipt = undefined;
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getReceipt = exports.getReceipt = function getReceipt(state) {
	  return (0, _get3.default)(state, 'receipt.item', {});
	};
	var getReceiptLoading = exports.getReceiptLoading = function getReceiptLoading(state) {
	  return (0, _get3.default)(state, 'receipt.loading', {});
	};
	var getShopObjectFromReceipt = exports.getShopObjectFromReceipt = function getShopObjectFromReceipt(state) {
	  return (0, _get3.default)(state, 'receipt.item.shop');
	};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _Modal = __webpack_require__(93);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _TaxesAndFees = __webpack_require__(1188);
	
	var _TaxesAndFees2 = _interopRequireDefault(_TaxesAndFees);
	
	var _shapes = __webpack_require__(23);
	
	var shapes = _interopRequireWildcard(_shapes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrderInformation = function OrderInformation(_ref) {
	  var servicesNamesShort = _ref.servicesNamesShort,
	      servicesNamesLong = _ref.servicesNamesLong,
	      serviceCost = _ref.serviceCost,
	      totalAmount = _ref.totalAmount,
	      costWithTaxes = _ref.costWithTaxes,
	      activeTip = _ref.activeTip,
	      taxes = _ref.taxes,
	      toggled = _ref.toggled,
	      on = _ref.on,
	      off = _ref.off,
	      discount = _ref.discount,
	      bookNoPayQuery = _ref.bookNoPayQuery,
	      isSquireFeeShop = _ref.isSquireFeeShop,
	      isChopMurrayHillShop = _ref.isChopMurrayHillShop,
	      taxBreakdown = _ref.taxBreakdown,
	      shouldShowTip = _ref.shouldShowTip,
	      showOnlyCostAndTaxes = _ref.showOnlyCostAndTaxes,
	      headingClassName = _ref.headingClassName,
	      className = _ref.className,
	      isGiftCardDiscount = _ref.isGiftCardDiscount,
	      fees = _ref.fees,
	      membershipDiscount = _ref.membershipDiscount;
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(
	      'div',
	      { className: headingClassName },
	      'Order Information'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-order-info' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-order-info__desc' },
	        servicesNamesLong && _react2.default.createElement(
	          'div',
	          {
	            role: 'button',
	            className: 'c-btn c-btn--bare u-inline-block u--mt-- u-mr--',
	            onClickCapture: function onClickCapture(e) {
	              e.preventDefault();
	              e.stopPropagation();
	              on();
	            },
	            tabIndex: '0'
	          },
	          _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.INFO })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'u-inline-block' },
	          servicesNamesShort,
	          ':'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-order-info__price' },
	        _react2.default.createElement(
	          _Money2.default,
	          null,
	          serviceCost
	        )
	      ),
	      shouldShowTip && _react2.default.createElement(
	        'div',
	        { className: 'c-order-info__desc' },
	        'Tip: ',
	        activeTip.value ? Math.floor(activeTip.value) + '%' : ''
	      ),
	      shouldShowTip && _react2.default.createElement(
	        'div',
	        { className: 'c-order-info__price' },
	        _react2.default.createElement(
	          _Money2.default,
	          null,
	          activeTip.amount
	        )
	      ),
	      !bookNoPayQuery && _react2.default.createElement(_TaxesAndFees2.default, {
	        taxes: taxes,
	        fees: fees,
	        isSquireFeeShop: isSquireFeeShop,
	        isChopMurrayHillShop: isChopMurrayHillShop,
	        taxBreakdown: taxBreakdown
	      }),
	      discount ? _react2.default.createElement(
	        'div',
	        { className: 'c-order-info__desc' },
	        isGiftCardDiscount ? 'Gift Card' : 'Discount',
	        ':'
	      ) : null,
	      discount ? _react2.default.createElement(
	        'div',
	        { className: 'c-order-info__price u-co-red' },
	        '-',
	        _react2.default.createElement(
	          _Money2.default,
	          null,
	          discount
	        )
	      ) : null,
	      !!membershipDiscount && _react2.default.createElement(
	        'div',
	        { className: 'c-order-info__desc' },
	        'Membership discount:'
	      ),
	      !!membershipDiscount && _react2.default.createElement(
	        'div',
	        { className: 'c-order-info__price u-co-red' },
	        '-',
	        _react2.default.createElement(
	          _Money2.default,
	          null,
	          membershipDiscount
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'c-separator u-mt u-mb- c-order-info__separator' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-pt-- u-co-black-2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'c-order-info__desc u-type--extrabold' },
	          'Total:'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-order-info__price u-type--extrabold' },
	          _react2.default.createElement(
	            _Money2.default,
	            null,
	            showOnlyCostAndTaxes ? costWithTaxes : totalAmount
	          )
	        )
	      )
	    ),
	    toggled && _react2.default.createElement(
	      _Modal2.default,
	      { size: 'small', close: off },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-co-gray' },
	        servicesNamesLong
	      )
	    )
	  );
	};
	OrderInformation.propTypes = {
	  activeTip: shapes.tipShape,
	  taxes: _propTypes2.default.number.isRequired,
	  fees: _propTypes2.default.number.isRequired,
	  discount: _propTypes2.default.number,
	  totalAmount: _propTypes2.default.number.isRequired,
	  costWithTaxes: _propTypes2.default.number.isRequired,
	  servicesNamesShort: _propTypes2.default.string,
	  servicesNamesLong: _propTypes2.default.string,
	  serviceCost: _propTypes2.default.number,
	  toggled: shapes.flag.isRequired,
	  on: shapes.handler.isRequired,
	  off: shapes.handler.isRequired,
	  bookNoPayQuery: _propTypes2.default.bool.isRequired,
	  isSquireFeeShop: _propTypes2.default.bool.isRequired,
	  isChopMurrayHillShop: _propTypes2.default.bool.isRequired,
	  taxBreakdown: shapes.taxBreakdownArray,
	  shouldShowTip: _propTypes2.default.bool.isRequired,
	  showOnlyCostAndTaxes: _propTypes2.default.bool.isRequired,
	  headingClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  isGiftCardDiscount: _propTypes2.default.bool,
	  membershipDiscount: _propTypes2.default.number.isRequired
	};
	OrderInformation.defaultProps = {
	  activeTip: null,
	  taxes: '',
	  servicesNamesShort: '',
	  servicesNamesLong: '',
	  serviceCost: 0,
	  discount: 0,
	  taxBreakdown: [],
	  headingClassName: 'c-heading c-heading--huge u-mb',
	  className: '',
	  isGiftCardDiscount: false,
	  showOnlyCostAndTaxes: false
	};
	
	exports.default = OrderInformation;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ApplePay = __webpack_require__(407);
	
	var _ApplePay2 = _interopRequireDefault(_ApplePay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable jsx-a11y/label-has-for */
	var PaymentFormApplePay = function PaymentFormApplePay(_ref) {
	  var onClick = _ref.onClick,
	      formDisabled = _ref.formDisabled,
	      hasErrors = _ref.hasErrors,
	      isCoveredByDiscount = _ref.isCoveredByDiscount,
	      hasApplePay = _ref.hasApplePay,
	      toggleApplePay = _ref.toggleApplePay;
	  return _react2.default.createElement(
	    'form',
	    {
	      className: (0, _classnames2.default)('c-card-information u-flex u-flex-column', { 'c-card-information--discounted': isCoveredByDiscount })
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'c-payment-modal-heading u-mb' },
	      'Payment Information'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-flex-1 u-flex u-flex-column u-justify-content-space-between' },
	      !isCoveredByDiscount && _react2.default.createElement(_ApplePay2.default, { onClick: onClick, processing: formDisabled || hasErrors }),
	      isCoveredByDiscount && _react2.default.createElement(
	        'button',
	        { className: 'c-button' },
	        'Process'
	      ),
	      !isCoveredByDiscount && hasApplePay && _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'c-btn-link c-btn-link--small u-mt- u-co-black-3 u-font-weight-normal',
	          onClick: toggleApplePay
	        },
	        'Or pay with Card'
	      )
	    )
	  );
	};
	
	PaymentFormApplePay.propTypes = {
	  formDisabled: _propTypes2.default.bool.isRequired,
	  onClick: _propTypes2.default.func.isRequired,
	  hasErrors: _propTypes2.default.bool.isRequired,
	  isCoveredByDiscount: _propTypes2.default.bool.isRequired,
	  hasApplePay: _propTypes2.default.bool,
	  toggleApplePay: _propTypes2.default.func
	};
	
	PaymentFormApplePay.defaultProps = {
	  panelLabel: 'Pay',
	  hasApplePay: true,
	  toggleApplePay: function toggleApplePay() {}
	};
	
	exports.default = PaymentFormApplePay;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReservationInfo = function ReservationInfo(_ref) {
	  var barberName = _ref.barberName,
	      serviceName = _ref.serviceName,
	      appointment = _ref.appointment,
	      shop = _ref.shop;
	  return _react2.default.createElement(
	    'dl',
	    null,
	    _react2.default.createElement(
	      'dt',
	      { className: 'c-heading c-heading--large' },
	      'Professional:'
	    ),
	    _react2.default.createElement(
	      'dd',
	      { className: 'c-heading c-heading--large u-mb' },
	      barberName
	    ),
	    _react2.default.createElement(
	      'dt',
	      { className: 'c-heading c-heading--large' },
	      'Service:'
	    ),
	    _react2.default.createElement(
	      'dd',
	      { className: 'c-heading c-heading--large u-type--capitalize u-mb' },
	      serviceName
	    ),
	    _react2.default.createElement(
	      'dt',
	      { className: 'c-heading c-heading--large' },
	      'Time:'
	    ),
	    _react2.default.createElement(
	      'dd',
	      { className: 'c-heading c-heading--large u-mb' },
	      appointment.formatted
	    ),
	    _react2.default.createElement(
	      'dt',
	      { className: 'c-heading c-heading--large' },
	      'Duration:'
	    ),
	    _react2.default.createElement(
	      'dd',
	      { className: 'c-heading c-heading--large u-mb' },
	      appointment.formattedDuration
	    ),
	    _react2.default.createElement(
	      'dt',
	      { className: 'c-heading c-heading--large' },
	      'Shop:'
	    ),
	    _react2.default.createElement(
	      'dd',
	      { className: 'c-heading c-heading--large' },
	      shop.name
	    ),
	    _react2.default.createElement(
	      'dt',
	      { className: 'c-heading c-heading--large' },
	      shop.address
	    ),
	    _react2.default.createElement(
	      'dd',
	      { className: 'c-heading c-heading--large u-mb+' },
	      shop.zip
	    )
	  );
	};
	ReservationInfo.propTypes = {
	  barberName: _propTypes2.default.string,
	  serviceName: _propTypes2.default.string,
	  appointment: _propTypes2.default.shape({
	    start: _propTypes2.default.string,
	    formatted: _propTypes2.default.string,
	    formattedDuration: _propTypes2.default.string
	  }),
	  shop: _propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    address: _propTypes2.default.string,
	    zip: _propTypes2.default.string,
	    location: _propTypes2.default.shape({
	      lat: _propTypes2.default.number,
	      lng: _propTypes2.default.number
	    })
	  })
	};
	ReservationInfo.defaultProps = {
	  barberName: '',
	  serviceName: '',
	  appointment: {},
	  shop: {}
	};
	exports.default = ReservationInfo;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactStripeCheckout = __webpack_require__(1729);
	
	var _reactStripeCheckout2 = _interopRequireDefault(_reactStripeCheckout);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckoutButton = function CheckoutButton(_ref) {
	  var onSuccess = _ref.onSuccess,
	      currency = _ref.currency,
	      amount = _ref.amount,
	      disabled = _ref.disabled,
	      email = _ref.email,
	      className = _ref.className,
	      panelLabel = _ref.panelLabel,
	      children = _ref.children;
	
	  var submitted = false;
	
	  return _react2.default.createElement(
	    _reactStripeCheckout2.default,
	    {
	      token: function token() {
	        submitted = true;return onSuccess.apply(undefined, arguments);
	      },
	      currency: currency.toUpperCase(),
	      amount: amount,
	      stripeKey: _config2.default.stripeKey,
	      name: 'SQUIRE',
	      description: 'Squire Technologies is a company dedicated to making style and grooming simple for men.',
	      panelLabel: panelLabel,
	      email: email,
	      disabled: disabled,
	      opened: function opened() {
	        return _BookingAnalytics2.default.startPayment({ source: 'stripe_modal' });
	      },
	      closed: function closed() {
	        return !submitted && _BookingAnalytics2.default.abandonPayment({ source: 'stripe_modal' });
	      }
	    },
	    _react2.default.createElement(
	      'button',
	      {
	        className: className,
	        type: 'button',
	        disabled: disabled
	      },
	      children
	    )
	  );
	};
	
	CheckoutButton.propTypes = {
	  onSuccess: _propTypes2.default.func.isRequired,
	  currency: _propTypes2.default.string.isRequired,
	  amount: _propTypes2.default.number.isRequired,
	  disabled: _propTypes2.default.bool.isRequired,
	  email: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  panelLabel: _propTypes2.default.string,
	  children: _propTypes2.default.node.isRequired
	};
	
	CheckoutButton.defaultProps = {
	  email: '',
	  className: '',
	  panelLabel: null
	};
	
	exports.default = CheckoutButton;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(7);
	
	var _Subtitle = __webpack_require__(113);
	
	var _Subtitle2 = _interopRequireDefault(_Subtitle);
	
	var _ReservationError = __webpack_require__(1186);
	
	var _ReservationError2 = _interopRequireDefault(_ReservationError);
	
	var _ReservationInfo = __webpack_require__(455);
	
	var _ReservationInfo2 = _interopRequireDefault(_ReservationInfo);
	
	var _ShopMap = __webpack_require__(290);
	
	var _ShopMap2 = _interopRequireDefault(_ShopMap);
	
	var _Controls = __webpack_require__(1163);
	
	var _Controls2 = _interopRequireDefault(_Controls);
	
	var _Modals = __webpack_require__(1167);
	
	var _Modals2 = _interopRequireDefault(_Modals);
	
	var _ProcessingIndicator = __webpack_require__(292);
	
	var _ProcessingIndicator2 = _interopRequireDefault(_ProcessingIndicator);
	
	var _PromoTidalReservation = __webpack_require__(1208);
	
	var _PromoTidalReservation2 = _interopRequireDefault(_PromoTidalReservation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CONFIRM_MODAL = 'confirmModal';
	
	var ViewReservation = function (_Component) {
	  _inherits(ViewReservation, _Component);
	
	  function ViewReservation() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ViewReservation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ViewReservation.__proto__ || Object.getPrototypeOf(ViewReservation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      confirmModal: { open: false }
	    }, _this.cancelAppointment = function () {
	      _this.closeConfirmModal();
	      setTimeout(function () {
	        // Prevent race condition on multiple SweetAlert modals
	        _this.props.cancelAppointment();
	      });
	    }, _this.openConfirmModal = function () {
	      return _this.openModal(CONFIRM_MODAL);
	    }, _this.closeConfirmModal = function () {
	      return _this.closeModal(CONFIRM_MODAL);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ViewReservation, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.fetchReservation();
	    }
	  }, {
	    key: 'getAppointmentCancelable',
	    value: function getAppointmentCancelable() {
	      return (0, _helpers.appointmentIsCancelable)(this.props.appointment.start, this.props.advanceCancelMins) && this.props.canCustomerCancel;
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal(modal) {
	      this.setState(_defineProperty({}, modal, { open: true }));
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal(modal) {
	      this.setState(_defineProperty({}, modal, { open: false }));
	    }
	  }, {
	    key: 'renderControls',
	    value: function renderControls() {
	      if (this.props.children) return null;
	      var _props = this.props,
	          canceled = _props.canceled,
	          inFuture = _props.inFuture,
	          barberName = _props.barberName,
	          serviceName = _props.serviceName,
	          shop = _props.shop,
	          customer = _props.customer,
	          appointment = _props.appointment,
	          rebookLink = _props.rebookLink,
	          scheduleLink = _props.scheduleLink,
	          clearReservations = _props.clearReservations;
	
	
	      return _react2.default.createElement(_Controls2.default, {
	        isCancelable: this.getAppointmentCancelable(),
	        cancelAppointment: this.openConfirmModal,
	        canceled: canceled,
	        inFuture: inFuture,
	        barberName: barberName,
	        serviceName: serviceName,
	        shop: shop,
	        customer: customer,
	        appointment: appointment,
	        rebookLink: rebookLink,
	        scheduleLink: scheduleLink,
	        clearReservations: clearReservations
	      });
	    }
	  }, {
	    key: 'renderModals',
	    value: function renderModals() {
	      return _react2.default.createElement(_Modals2.default, {
	        confirmModal: _extends({}, this.state.confirmModal),
	        closeConfirmModal: this.closeConfirmModal,
	        cancelAppointment: this.cancelAppointment
	      });
	    }
	  }, {
	    key: 'renderMessage',
	    value: function renderMessage() {
	      if (!this.props.children) {
	        return 'Canceling Order';
	      }
	
	      if (this.props.children.type.displayName === 'CheckoutContainer') {
	        return 'Processing';
	      }
	
	      return 'Rescheduling';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          reservationError = _props2.reservationError,
	          barberName = _props2.barberName,
	          serviceName = _props2.serviceName,
	          appointment = _props2.appointment,
	          shop = _props2.shop,
	          advanceCancelMins = _props2.advanceCancelMins,
	          promoCode = _props2.promoCode;
	
	
	      var shopInfo = '' + shop.name + (shop.phone ? ' at ' + (0, _helpers.formatPhone)(shop.phone) : '');
	      var isCancelable = this.getAppointmentCancelable();
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Subtitle2.default,
	          null,
	          'Appointment Details'
	        ),
	        reservationError && _react2.default.createElement(_ReservationError2.default, { error: reservationError }),
	        !reservationError && _react2.default.createElement(
	          'div',
	          { className: 'layout layout--large u-mt+' },
	          _react2.default.createElement(
	            'div',
	            { className: 'layout__item u-1/2-medium-and-up' },
	            _react2.default.createElement(_ReservationInfo2.default, {
	              barberName: barberName,
	              serviceName: serviceName,
	              appointment: appointment,
	              shop: shop
	            }),
	            this.renderControls()
	          ),
	          promoCode && _react2.default.createElement(
	            'div',
	            { className: 'layout__item u-1/2-medium-and-up' },
	            _react2.default.createElement(_PromoTidalReservation2.default, { promoCode: promoCode })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'layout__item u-1/2-medium-and-up' },
	            shop.location && _react2.default.createElement(
	              'div',
	              { className: 'u-mb-' },
	              _react2.default.createElement(_ShopMap2.default, { name: shop.name, address: shop.address })
	            ),
	            isCancelable && _react2.default.createElement(
	              'p',
	              null,
	              'According to the cancellation policy of ',
	              shop.name,
	              ', this appointment could be canceled/rescheduled up to',
	              ' ',
	              (0, _helpers.formatHours)(advanceCancelMins),
	              ' before it is set to begin. If a payment was included when scheduling this appointment, it will be fully refunded upon cancellation.  For all other inquiries please call the ',
	              shopInfo,
	              '.'
	            ),
	            !isCancelable && _react2.default.createElement(
	              'p',
	              null,
	              'According to the cancellation policy of ',
	              shop.name,
	              ' you cannot cancel this appt at this time. Please contact ',
	              shopInfo,
	              ' for more information.'
	            )
	          ),
	          this.renderModals()
	        ),
	        this.props.children,
	        _react2.default.createElement(
	          _ProcessingIndicator2.default,
	          null,
	          this.renderMessage()
	        )
	      );
	    }
	  }]);
	
	  return ViewReservation;
	}(_react.Component);
	
	ViewReservation.propTypes = {
	  fetchReservation: _propTypes2.default.func.isRequired,
	  reservationError: _propTypes2.default.string,
	  appointment: _propTypes2.default.shape({
	    start: _propTypes2.default.string,
	    formatted: _propTypes2.default.string,
	    duration: _propTypes2.default.number
	  }).isRequired,
	  barberName: _propTypes2.default.string,
	  serviceName: _propTypes2.default.string,
	  shop: _propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    address: _propTypes2.default.string,
	    zip: _propTypes2.default.string,
	    location: _propTypes2.default.shape({
	      lat: _propTypes2.default.number,
	      lng: _propTypes2.default.number
	    })
	  }).isRequired,
	  customer: _propTypes2.default.shape({
	    name: _propTypes2.default.string,
	    email: _propTypes2.default.string,
	    id: _propTypes2.default.string
	  }).isRequired,
	  cancelAppointment: _propTypes2.default.func.isRequired,
	  advanceCancelMins: _propTypes2.default.number,
	  canCustomerCancel: _propTypes2.default.bool.isRequired,
	  inFuture: _propTypes2.default.bool,
	  canceled: _propTypes2.default.bool,
	  rebookLink: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  scheduleLink: _propTypes2.default.string,
	  clearReservations: _propTypes2.default.func.isRequired,
	  promoCode: _propTypes2.default.string
	};
	
	ViewReservation.defaultProps = {
	  reservationError: '',
	  barberName: '',
	  serviceName: '',
	  advanceCancelMins: 60,
	  inFuture: false,
	  canceled: true,
	  rebookLink: '/',
	  children: null,
	  scheduleLink: '/',
	  promoCode: null
	};
	
	exports.default = ViewReservation;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _WithApplePayQuery = __webpack_require__(96);
	
	var _WithApplePayQuery2 = _interopRequireDefault(_WithApplePayQuery);
	
	var _ApplePay = __webpack_require__(1154);
	
	var _ApplePay2 = _interopRequireDefault(_ApplePay);
	
	var _selectors = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_WithApplePayQuery2.default, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    processing: state.reservation.get('paymentProcessing'),
	    isKrwnZazzPlaceSteFoyShop: (0, _selectors.getIsKrwnZazzPlaceSteFoyShop)(state, ownProps.params.shopRoute)
	  };
	}), (0, _branch3.default)(function (props) {
	  return !props.withApplePay || props.isKrwnZazzPlaceSteFoyShop;
	}, _renderNothing3.default))(_ApplePay2.default);

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	var _WithShopCurrency = __webpack_require__(135);
	
	var _WithShopCurrency2 = _interopRequireDefault(_WithShopCurrency);
	
	var _intl = __webpack_require__(300);
	
	var _WithInstantExperiences = __webpack_require__(428);
	
	var _WithInstantExperiences2 = _interopRequireDefault(_WithInstantExperiences);
	
	var _WithApplePayQuery = __webpack_require__(96);
	
	var _WithApplePayQuery2 = _interopRequireDefault(_WithApplePayQuery);
	
	var _ContactInformation = __webpack_require__(409);
	
	var _ContactInformation2 = _interopRequireDefault(_ContactInformation);
	
	var _actions = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_WithApplePayQuery2.default, _WithInstantExperiences2.default, _WithShop2.default, _WithShopCurrency2.default, (0, _branch3.default)(function (props) {
	  return props.withApplePay;
	}, _renderNothing3.default), (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    fields: state.reservation.get('fields').toJS(),
	    countryCode: (0, _intl.getCountryCodeByCountryAndCurrency)(ownProps.shop)
	  };
	}, { touchField: _actions.touchField, updateField: _actions.updateField }), (0, _withHandlers3.default)({
	  updateField: function updateField(props) {
	    return function (field) {
	      return function (e) {
	        var valueMap = {
	          checkbox: function checkbox(event) {
	            return event.target.checked;
	          },
	          tel: function tel(value) {
	            return value;
	          },
	          default: function _default(event) {
	            return event.target.value;
	          }
	        };
	
	        var valueFn = valueMap[field.type] || valueMap.default;
	        var value = valueFn(e);
	
	        props.updateField(field.id, value, props.countryCode, props.shop);
	        props.touchField(field.id, props.countryCode, props.shop);
	      };
	    };
	  },
	  touchField: function touchField(props) {
	    return function (field) {
	      return function () {
	        return props.touchField(field.id, props.countryCode, props.shop);
	      };
	    };
	  },
	  updateFieldValue: function updateFieldValue(props) {
	    return function (fieldId, value) {
	      props.updateField(fieldId, value, props.countryCode, props.shop);
	      props.touchField(fieldId, props.countryCode, props.shop);
	    };
	  }
	}), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var isDeprecatedIgIx = this.props.instantExperiences && !this.props.instantExperiencesOwner;
	    if (isDeprecatedIgIx && window.FBExtensions) {
	      window.FBExtensions.requestFormFields(function () {
	        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	            _ref$fields = _ref.fields,
	            fields = _ref$fields === undefined ? {} : _ref$fields;
	
	        Object.keys(fields).forEach(function (key) {
	          return _this.props.updateFieldValue(key, fields[key].value);
	        });
	      }, function () {
	        return null;
	      }, {
	        fields: [{ id: 'firstName', label: 'First name', autocomplete: 'given-name' }, { id: 'lastName', label: 'Last name', autocomplete: 'family-name' }, { id: 'phone', label: 'Phone number', autocomplete: 'tel-national' }, { id: 'email', label: 'Email address', autocomplete: 'email' }],
	        business_name: 'Squire Technologies',
	        terms_url: 'https://getsquire.com/terms-of-service.html'
	      });
	    }
	  }
	}))(_ContactInformation2.default);

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _actions = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)((0, _reactRedux.connect)(null, { setCustomTip: _actions.setCustomTip }), (0, _withState3.default)('tip', 'setTip', 0), (0, _withHandlers3.default)({
	  onChange: function onChange(props) {
	    return function (value) {
	      return props.setTip(value);
	    };
	  },
	  onSubmit: function onSubmit(props) {
	    return function (e) {
	      e.preventDefault();
	      props.setCustomTip(props.tip);
	      props.close();
	    };
	  },
	  increment: function increment(props) {
	    return function () {
	      return props.setTip(props.tip + 100);
	    };
	  },
	  decrement: function decrement(props) {
	    return function () {
	      var nextTip = props.tip - 100;
	      if (nextTip < 0) {
	        props.setTip(0);
	        return;
	      }
	
	      props.setTip(nextTip);
	    };
	  }
	}));

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _WithToggle = __webpack_require__(63);
	
	var _WithToggle2 = _interopRequireDefault(_WithToggle);
	
	var _WithBookNoPayQuery = __webpack_require__(161);
	
	var _WithBookNoPayQuery2 = _interopRequireDefault(_WithBookNoPayQuery);
	
	var _selectors = __webpack_require__(11);
	
	var _withRouteParameters = __webpack_require__(83);
	
	var _withRouteParameters2 = _interopRequireDefault(_withRouteParameters);
	
	var _WithTimeWaitingList = __webpack_require__(97);
	
	var _WithTimeWaitingList2 = _interopRequireDefault(_WithTimeWaitingList);
	
	var _WithApplePayQuery = __webpack_require__(96);
	
	var _WithApplePayQuery2 = _interopRequireDefault(_WithApplePayQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_WithApplePayQuery2.default, _withRouteParameters2.default, _WithToggle2.default, _WithBookNoPayQuery2.default, _WithTimeWaitingList2.default, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    isSquireFeeShop: (0, _selectors.getIsSquireFeeShop)(state, ownProps.shopRoute),
	    isChopMurrayHillShop: (0, _selectors.getIsChopMurrayHillShop)(state, ownProps.shopRoute),
	    noExtrasForReserveNoPay: (0, _selectors.getNoExtrasForReserveNoPay)(state, ownProps.shopRoute)
	  };
	}), (0, _withProps3.default)(function (props) {
	  var shouldShowTipForWaitingList = !!props.timeWaitingList && !!props.activeTip;
	  var shouldShowApplePayTip = !!props.withApplePay && !!props.activeTip;
	  var shouldShowTipForBooking = !props.noExtrasForReserveNoPay && !props.bookNoPayQuery && !!props.activeTip;
	  return {
	    shouldShowTip: shouldShowTipForBooking || shouldShowTipForWaitingList || shouldShowApplePayTip
	  };
	}));

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _once2 = __webpack_require__(1493);
	
	var _once3 = _interopRequireDefault(_once2);
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _renderComponent2 = __webpack_require__(57);
	
	var _renderComponent3 = _interopRequireDefault(_renderComponent2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _PaymentFormStripe = __webpack_require__(1171);
	
	var _PaymentFormStripe2 = _interopRequireDefault(_PaymentFormStripe);
	
	var _WithToggle = __webpack_require__(63);
	
	var _WithToggle2 = _interopRequireDefault(_WithToggle);
	
	var _PaymentFormApplePay = __webpack_require__(454);
	
	var _PaymentFormApplePay2 = _interopRequireDefault(_PaymentFormApplePay);
	
	var _applePay = __webpack_require__(299);
	
	var _withRouteParameters = __webpack_require__(83);
	
	var _withRouteParameters2 = _interopRequireDefault(_withRouteParameters);
	
	var _selectors = __webpack_require__(11);
	
	var _withStripeInput = __webpack_require__(1215);
	
	var _withStripeInput2 = _interopRequireDefault(_withStripeInput);
	
	var _stripe = __webpack_require__(473);
	
	var _stripe2 = _interopRequireDefault(_stripe);
	
	var _selectors2 = __webpack_require__(21);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var areWeOnChargeAppointment = (0, _selectors2.getAppointmentId)(state);
	  var hasApplePay = state.app.applePay && !props.disableApplePay;
	  return {
	    hasApplePay: hasApplePay,
	    currency: (0, _selectors.getShopCurrency)(state, props.shopRoute),
	    shopCountry: (0, _selectors.getShopCountry)(state, props.shopRoute),
	    areWeOnChargeAppointment: (0, _selectors2.getAppointmentId)(state),
	    initialState: hasApplePay && areWeOnChargeAppointment,
	    isValidating: (0, _selectors2.getIsValidatingAppointment)(state)
	  };
	};
	
	var showSwalError = function showSwalError(error) {
	  window.swal({
	    title: 'Error',
	    text: (0, _get3.default)(error, 'message', ''),
	    type: 'error',
	    confirmButtonColor: '#dd6b55'
	  });
	};
	
	exports.default = (0, _compose3.default)(_withRouteParameters2.default, (0, _reactRedux.connect)(mapStateToProps), _WithToggle2.default, (0, _withState3.default)('processing', 'setProcessing', false), (0, _withProps3.default)(function (props) {
	  return {
	    toggleApplePay: props.toggle,
	    formDisabled: props.formDisabled || props.processing || props.isValidating
	  };
	}), (0, _withHandlers3.default)({
	  handleProcessingError: function handleProcessingError(props) {
	    return function (error) {
	      props.setProcessing(false);
	      showSwalError(error);
	    };
	  }
	}), (0, _withHandlers3.default)({
	  onClick: function onClick(props) {
	    return function () {
	      props.setProcessing(true);
	      (0, _applePay.applePaySession)(props.amount, props.currency, function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(result) {
	          var setupResponse;
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  _BookingAnalytics2.default.fillCardInfo({ source: 'squire_modal', isApplePay: true });
	                  _context.next = 3;
	                  return props.confirmSetup(result.token);
	
	                case 3:
	                  setupResponse = _context.sent;
	
	                  props.setProcessing(false);
	                  return _context.abrupt('return', setupResponse);
	
	                case 6:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, undefined);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }(), props.handleProcessingError, function () {
	        return props.setProcessing(false);
	      });
	    };
	  }
	}), (0, _branch3.default)(function (props) {
	  return props.toggled;
	}, (0, _renderComponent3.default)(_PaymentFormApplePay2.default)), (0, _withStripeInput2.default)({}), (0, _withState3.default)('zipCode', 'setZipCode', ''), (0, _withState3.default)('submitEnabled', 'setSubmitEnabled', false), (0, _withHandlers3.default)({
	  submit: function submit(props) {
	    return function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	        var token, stripe, _ref3, error, result, isZipValid;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                e.preventDefault();
	
	                props.setProcessing(true);
	                token = null;
	
	                if (props.isCoveredByDiscount) {
	                  _context2.next = 18;
	                  break;
	                }
	
	                stripe = new _stripe2.default();
	
	                props.setStripeInputsDisabled(true);
	
	                _context2.next = 8;
	                return stripe.createToken(props.cardNumber, {
	                  address_zip: props.zipCode
	                });
	
	              case 8:
	                _ref3 = _context2.sent;
	                error = _ref3.error;
	                result = _objectWithoutProperties(_ref3, ['error']);
	
	
	                token = result.token;
	                props.setStripeInputsDisabled(false);
	
	                isZipValid = props.validateZipCode();
	
	                if (!(error || !isZipValid)) {
	                  _context2.next = 18;
	                  break;
	                }
	
	                if (isZipValid && error.type !== 'validation_error') {
	                  props.handleProcessingError(error);
	                }
	
	                props.setProcessing(false);
	                return _context2.abrupt('return');
	
	              case 18:
	                _context2.prev = 18;
	                _context2.next = 21;
	                return props.confirmSetup(token);
	
	              case 21:
	                _context2.next = 26;
	                break;
	
	              case 23:
	                _context2.prev = 23;
	                _context2.t0 = _context2['catch'](18);
	
	                props.handleProcessingError(_context2.t0);
	
	              case 26:
	                _context2.prev = 26;
	
	                props.setProcessing(false);
	                return _context2.finish(26);
	
	              case 29:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, undefined, [[18, 23, 26, 29]]);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	  },
	  setZipCode: function setZipCode(props) {
	    return function (event) {
	      props.setZipCode(event.target.value);
	      props.validateZipCode();
	    };
	  },
	  zipCodeBlur: function zipCodeBlur(props) {
	    return function () {
	      if (!props.hasErrors) {
	        if (props.zipCode) {
	          _BookingAnalytics2.default.fillCardInfoField('cardZipCode');
	        }
	        _BookingAnalytics2.default.fillCardInfo({ source: 'squire_modal' });
	      }
	    };
	  },
	  mountStripeInputs: function mountStripeInputs(props) {
	    return (0, _once3.default)(function () {
	      return props.mountStripeInputs();
	    });
	  }
	}), (0, _lifecycle3.default)({
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (this.props.cardNumber) {
	      if (prevProps.isCoveredByDiscount !== this.props.isCoveredByDiscount) {
	        this.props.setStripeInputsDisabled(this.props.isCoveredByDiscount);
	      }
	    }
	
	    if (this.props.cardNumber !== '' && this.props.cardExpiry !== '' && this.props.cardCvc !== '' && this.props.zipCode !== '' && this.props.submitEnabled === false) {
	      this.props.setSubmitEnabled(true);
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    this.props.mountStripeInputs();
	    setTimeout(function () {
	      return _this.props.focusInput('cardNumber');
	    }, 1000);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.props.unmountStripeInputs();
	  }
	}))(_PaymentFormStripe2.default);

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _withCost = __webpack_require__(116);
	
	var _withCost2 = _interopRequireDefault(_withCost);
	
	var _selectors = __webpack_require__(27);
	
	var _selectors2 = __webpack_require__(21);
	
	var _actions = __webpack_require__(42);
	
	var _selectors3 = __webpack_require__(11);
	
	var _withRouteParameters = __webpack_require__(83);
	
	var _withRouteParameters2 = _interopRequireDefault(_withRouteParameters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    isValid: state.reservation.getIn(['promo', 'isValid']),
	    error: state.reservation.getIn(['promo', 'error']),
	    isFetching: state.reservation.getIn(['promo', 'isFetching']),
	    validatedPromoCode: (0, _selectors2.getPromoCode)(state),
	    inputDisabled: state.reservation.getIn(['promo', 'isValid']),
	    formValid: (0, _selectors2.getIsFormValid)(state),
	    giftCardEnabled: (0, _selectors3.getGiftCardEnabled)(state, ownProps.shopRoute),
	    hasGiftCardBalance: (0, _selectors2.getGiftCardBalance)(state) !== null,
	    hasPromotions: (0, _selectors3.getHasPromotionsEnabled)(state, ownProps.shopRoute),
	    hasLoyaltyProgram: (0, _selectors.getHasBarberLoyaltyProgram)(state, ownProps.barberRoute) || (0, _selectors3.getHasShopLoyaltyProgram)(state, ownProps.shopRoute),
	    validationNote: state.reservation.getIn(['promo', 'validationNote'])
	  };
	};
	
	var mapDispatchToProps = {
	  fetchPromo: _actions.fetchPromo,
	  resetPromo: _actions.resetPromo,
	  resetPromoError: _actions.resetPromoError,
	  removePromoFromReservation: _actions.removePromoFromReservation
	};
	
	exports.default = (0, _compose3.default)(_withRouteParameters2.default, _withCost2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _withState3.default)('promoCode', 'setPromoCode', ''), (0, _withPropsOnChange3.default)(['validatedPromoCode'], function (props) {
	  if (!props.validatedPromoCode) {
	    props.setPromoCode();
	  }
	}), (0, _withPropsOnChange3.default)(function (prevProps, nextProps) {
	  return !prevProps.error && nextProps.error;
	}, function (props) {
	  props.setPromoCode('');
	  props.removePromoFromReservation();
	}), (0, _withHandlers3.default)({
	  onChange: function onChange(props) {
	    return function (e) {
	      props.setPromoCode(e.target.value.toUpperCase());
	      if (props.error) {
	        props.resetPromoError();
	      }
	    };
	  },
	  handleSubmit: function handleSubmit(props) {
	    return function (e) {
	      e.preventDefault();
	      if ((0, _isEmpty3.default)(props.promoCode)) return;
	      if (props.isValid) {
	        props.resetPromo();
	        return;
	      }
	      props.fetchPromo(props.promoCode);
	    };
	  }
	}), (0, _withProps3.default)(function (props) {
	  return {
	    submitEnabled: props.promoCode && (props.isValid || props.promoCode !== props.validatedPromoCode)
	  };
	}));

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _actions = __webpack_require__(42);
	
	var _helpers = __webpack_require__(7);
	
	var _WithToggle = __webpack_require__(63);
	
	var _WithToggle2 = _interopRequireDefault(_WithToggle);
	
	var _selectors = __webpack_require__(11);
	
	var _WithKioskProp = __webpack_require__(59);
	
	var _WithKioskProp2 = _interopRequireDefault(_WithKioskProp);
	
	var _WithApplePayQuery = __webpack_require__(96);
	
	var _WithApplePayQuery2 = _interopRequireDefault(_WithApplePayQuery);
	
	var _WithBookNoPayQuery = __webpack_require__(161);
	
	var _WithBookNoPayQuery2 = _interopRequireDefault(_WithBookNoPayQuery);
	
	var _withRouteParameters = __webpack_require__(83);
	
	var _withRouteParameters2 = _interopRequireDefault(_withRouteParameters);
	
	var _selectors2 = __webpack_require__(21);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    tips: (0, _selectors2.getTips)(state),
	    hasCustomTip: (0, _selectors2.getHasCustomTip)(state),
	    customTip: (0, _selectors2.getCustomTip)(state),
	    total: (0, _selectors2.getTotalAmount)(state),
	    noExtrasForBookNoPay: (0, _selectors.getNoExtrasForReserveNoPay)(state, ownProps.shopRoute)
	  };
	};
	
	var mapDispatchToProps = {
	  onTipSelect: _actions.setTip
	};
	
	exports.default = (0, _compose3.default)(_withRouteParameters2.default, _WithApplePayQuery2.default, _WithKioskProp2.default, _WithToggle2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _withHandlers3.default)({
	  onTipSelect: function onTipSelect(props) {
	    return function (value) {
	      _BookingAnalytics2.default.tipSelected();
	      props.onTipSelect(value);
	      if (props.toggled) {
	        props.off();
	      }
	    };
	  }
	}), _WithBookNoPayQuery2.default, (0, _branch3.default)(function (props) {
	  if (props.bookNoPayQuery) return true;
	  if (!props.tipEnabled) return true;
	  return (0, _helpers.xor)(props.showOnApplePay, props.withApplePay);
	}, _renderNothing3.default), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    _BookingAnalytics2.default.tipOptionActive();
	  }
	}));

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _WithKioskProp = __webpack_require__(59);
	
	var _WithKioskProp2 = _interopRequireDefault(_WithKioskProp);
	
	var _WithTimezone = __webpack_require__(115);
	
	var _WithTimezone2 = _interopRequireDefault(_WithTimezone);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	var _schedule = __webpack_require__(199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_WithKioskProp2.default, _WithTimezone2.default, _WithShop2.default, _reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  var minutesBeforeReservation = (0, _schedule.getMinutesBeforeReservation)(ownProps.params.reservationTime, ownProps.timezone);
	
	  return {
	    isReserveNoPayOnly: ownProps.kiosk && (0, _schedule.isLessThanPrepayOnlyThreshold)(minutesBeforeReservation, ownProps.shop)
	  };
	}));

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Modal = __webpack_require__(93);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _shapes = __webpack_require__(23);
	
	var shapes = _interopRequireWildcard(_shapes);
	
	var _WithToggle = __webpack_require__(63);
	
	var _WithToggle2 = _interopRequireDefault(_WithToggle);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceDetails = function ServiceDetails(_ref) {
	  var service = _ref.service,
	      toggled = _ref.toggled,
	      on = _ref.on,
	      off = _ref.off;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-fill-parent' },
	    _react2.default.createElement(
	      'div',
	      { className: 'o-tableize o-tableize--full o-tableize--fixed o-tableize--middle u-fill-parent' },
	      _react2.default.createElement(
	        'div',
	        { className: 'o-tableize__cell u-1/1' },
	        service.desc && _react2.default.createElement(
	          'div',
	          { className: 'c-select-box__controls' },
	          _react2.default.createElement(
	            'div',
	            {
	              role: 'button',
	              className: 'c-btn c-btn--bare u-inline-block',
	              onClickCapture: function onClickCapture(e) {
	                e.preventDefault();
	                e.stopPropagation();
	                on();
	              },
	              tabIndex: '0'
	            },
	            _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.INFO })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('c-service-name u-ph-', { 'u-mt-': !service.duration }) },
	          service.name
	        ),
	        service.duration && _react2.default.createElement(
	          'div',
	          { className: 'epsilon u-type--bold u--mt--' },
	          _react2.default.createElement(
	            'span',
	            { className: 'u-co-white' },
	            _react2.default.createElement(
	              _Money2.default,
	              null,
	              service.cost
	            )
	          ),
	          '-',
	          _react2.default.createElement(
	            'span',
	            { className: 'u-co-gray-1' },
	            service.duration,
	            ' mins'
	          )
	        ),
	        toggled && _react2.default.createElement(
	          _Modal2.default,
	          {
	            close: off,
	            size: 'small'
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'u-co-gray' },
	            service.desc
	          )
	        )
	      )
	    )
	  );
	};
	ServiceDetails.propTypes = {
	  service: shapes.serviceShape.isRequired,
	  toggled: shapes.flag.isRequired,
	  on: shapes.handler.isRequired,
	  off: shapes.handler.isRequired
	};
	
	exports.default = (0, _WithToggle2.default)(ServiceDetails);

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEmpty2 = __webpack_require__(1573);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Loader = __webpack_require__(82);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _shapes = __webpack_require__(23);
	
	var _selectors = __webpack_require__(11);
	
	var _constants = __webpack_require__(10);
	
	var _helpers = __webpack_require__(7);
	
	var _Shop = __webpack_require__(1226);
	
	var _Shop2 = _interopRequireDefault(_Shop);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getUrlPattern = function getUrlPattern(shop) {
	  if (shop.kind === _constants.SHOP_TYPE.commision || (0, _selectors.getShopAllowBookWithAnyBarber)(shop)) {
	    return _config2.default.urlPatterns.booking;
	  }
	  return _config2.default.urlPatterns.barber;
	};
	
	var LoadingState = function LoadingState() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'layout u-mt+' },
	    _react2.default.createElement(_Loader2.default, null),
	    ';'
	  );
	};
	
	var ShopList = function ShopList(_ref) {
	  var shops = _ref.shops,
	      shopIds = _ref.shopIds,
	      isLoading = _ref.isLoading;
	
	  if (isLoading) return _react2.default.createElement(LoadingState, null);
	  if ((0, _isEmpty3.default)(shops)) return null;
	
	  var shopMap = shops.reduce(function (acc, shop) {
	    acc[shop.id] = shop;
	    return acc;
	  }, {});
	  var sortedShops = shopIds.reduce(function (acc, id) {
	    var shop = shopMap[id];
	    if (shopMap[id]) {
	      acc.push(shop);
	    }
	    return acc;
	  }, []);
	  var list = (0, _isEmpty3.default)(sortedShops) ? shops : sortedShops;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'layout u-mt+ u-flex u-flex-wrap u-justify-content-center' },
	    list.map(function (shop) {
	      var url = (0, _helpers.generateUrlString)({ shopRoute: shop.route }, getUrlPattern(shop));
	      return _react2.default.createElement(
	        'div',
	        {
	          key: shop.id,
	          className: 'layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up'
	        },
	        _react2.default.createElement(_Shop2.default, { shop: shop, url: url })
	      );
	    })
	  );
	};
	ShopList.propTypes = {
	  shops: _propTypes2.default.arrayOf(_shapes.shopShape),
	  shopIds: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  isLoading: _propTypes2.default.bool
	};
	ShopList.defaultProps = {
	  shops: [],
	  shopIds: [],
	  isLoading: false
	};
	
	exports.default = ShopList;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pickBy2 = __webpack_require__(105);
	
	var _pickBy3 = _interopRequireDefault(_pickBy2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(49);
	
	var _momentTimezone = __webpack_require__(67);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _selectors = __webpack_require__(11);
	
	var _selectors2 = __webpack_require__(27);
	
	var _constants = __webpack_require__(10);
	
	var _actions = __webpack_require__(99);
	
	var _selectors3 = __webpack_require__(71);
	
	var _AvailableTimeRangeProvider = __webpack_require__(425);
	
	var _AvailableTimeRangeProvider2 = _interopRequireDefault(_AvailableTimeRangeProvider);
	
	var _PickTime = __webpack_require__(1230);
	
	var _PickTime2 = _interopRequireDefault(_PickTime);
	
	var _actions2 = __webpack_require__(64);
	
	var _actions3 = __webpack_require__(92);
	
	var _actions4 = __webpack_require__(117);
	
	var _selectors4 = __webpack_require__(51);
	
	var _actions5 = __webpack_require__(111);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetchData = (0, _compose3.default)((0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    this.props.clearBarberAvailability();
	    this.props.fetchShop().then(this.props.fetchBarbers).then(this.props.fetchService).catch(_helpers.nullFunc);
	  }
	}));
	
	var selectedTimeUrlState = (0, _compose3.default)((0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    selectedTime: (0, _selectors3.getActiveTime)(state),
	    nextLink: (0, _selectors3.getNextLink)(state, ownProps.generateUrlString, ownProps.anyBarber)
	  };
	}, { setSelectedTime: _actions.setActiveTime, setActiveTimeBarber: _actions.setActiveTimeBarber }), (0, _withHandlers3.default)({
	  setTime: function setTime(props) {
	    return function (item) {
	      return function () {
	        var reservationTime = (0, _momentTimezone2.default)(item.time).format(_config2.default.timeSlugFormat);
	        props.setSelectedTime(reservationTime);
	        props.setActiveTimeBarber(item.barberRoute || '');
	      };
	    };
	  },
	  resetTime: function resetTime(props) {
	    return function () {
	      props.setSelectedTime('');
	      props.setActiveTimeBarber('');
	    };
	  }
	}));
	
	var waitingListLink = (0, _withProps3.default)(function (props) {
	  var query = (0, _pickBy3.default)({
	    date: props.activeDay,
	    anyBarber: props.anyBarber
	  });
	  return {
	    waitingListLink: {
	      pathname: props.generateUrlString({ reservationTime: _constants.TIME_WAITING_LIST }),
	      query: query
	    }
	  };
	});
	
	function mapStateToProps(state, ownProps) {
	  var timezone = (0, _selectors.getShopTimezone)(state, ownProps.params.shopRoute);
	  var activeDay = state.times.activeDay;
	  var dayEnabled = ownProps.params.barberRoute === _constants.ANY_BARBER ? (0, _selectors.getShopDayEnabled)(state, ownProps.params.shopRoute, activeDay) : (0, _selectors2.getBarberDayEnabled)(state, ownProps.params.barberRoute, activeDay);
	
	  return {
	    serviceId: ownProps.params.serviceId,
	    servicesFetched: state.services.get('allFetched'),
	    serviceDuration: (0, _selectors4.getServiceDuration)(state, ownProps.params.serviceId),
	    activeDay: activeDay,
	    times: (0, _selectors3.getActiveDayTimes)(state, timezone),
	    noTimesAvailable: (0, _selectors3.getNoTimesAvailable)(state),
	    nextUnfetchedDay: (0, _selectors3.getNextUnfetchedDay)(state),
	    isFetching: state.times.get('isFetching'),
	    timezone: timezone,
	    generateUrlString: function generateUrlString(params) {
	      return (0, _helpers.generateUrlString)(_extends({
	        shopRoute: ownProps.params.shopRoute,
	        barberRoute: ownProps.params.barberRoute,
	        serviceId: ownProps.params.serviceId
	      }, (0, _pickBy3.default)(params)), ownProps.urlPattern);
	    },
	    shopId: (0, _selectors.getShopId)(state, ownProps.params.shopRoute),
	    barberId: (0, _selectors2.getBarberId)(state, ownProps.params.barberRoute),
	    shouldShowWaitingList: (0, _selectors.getHasWaitingListEnabled)(state, ownProps.params.shopRoute) && dayEnabled
	  };
	}
	
	function mapDispatchToProps(dispatch, ownProps) {
	  return (0, _redux.bindActionCreators)({
	    fetchShop: _actions2.fetchShop.bind(null, ownProps.params.shopRoute, ownProps.urlPattern),
	    fetchBarbers: _actions3.fetchBarbers.bind(null, ownProps.params.shopRoute, ownProps.urlPattern),
	    fetchService: _actions4.fetchSelectedServices.bind(null, ownProps.params.shopRoute, ownProps.params.barberRoute, ownProps.params.serviceId, ownProps.params, ownProps.urlPattern),
	    clearBarberAvailability: _actions.clearBarberAvailability,
	    setActiveDay: _actions.setActiveDay,
	    errorRedirect: _actions5.errorRedirect
	  }, dispatch);
	}
	
	exports.default = (0, _compose3.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), fetchData, (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    this.props.setActiveDay((0, _momentTimezone2.default)().format(_config2.default.apiDateFormat));
	  }
	}), (0, _AvailableTimeRangeProvider2.default)('activeDay'), selectedTimeUrlState, waitingListLink)(_PickTime2.default);

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _desktop = __webpack_require__(414);
	
	var _desktop2 = _interopRequireDefault(_desktop);
	
	var _notDesktop = __webpack_require__(415);
	
	var _notDesktop2 = _interopRequireDefault(_notDesktop);
	
	var _TimeSlider = __webpack_require__(1232);
	
	var _TimeSlider2 = _interopRequireDefault(_TimeSlider);
	
	var _TimeGrid = __webpack_require__(1231);
	
	var _TimeGrid2 = _interopRequireDefault(_TimeGrid);
	
	var _shapes = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimePicker = function TimePicker(_ref) {
	  var times = _ref.times,
	      timezone = _ref.timezone,
	      selectedTime = _ref.selectedTime,
	      setTime = _ref.setTime;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _desktop2.default,
	      null,
	      _react2.default.createElement(_TimeGrid2.default, {
	        times: times,
	        timezone: timezone,
	        selectedTime: selectedTime,
	        setTime: setTime
	      })
	    ),
	    _react2.default.createElement(
	      _notDesktop2.default,
	      null,
	      _react2.default.createElement(_TimeSlider2.default, {
	        times: times,
	        timezone: timezone,
	        selectedTime: selectedTime,
	        setTime: setTime
	      })
	    )
	  );
	};
	TimePicker.propTypes = {
	  times: _propTypes2.default.arrayOf(_shapes.timeShape),
	  timezone: _propTypes2.default.string,
	  selectedTime: _propTypes2.default.string,
	  setTime: _propTypes2.default.func.isRequired
	};
	TimePicker.defaultProps = {
	  timezone: null,
	  times: [],
	  selectedTime: ''
	};
	
	exports.default = TimePicker;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _momentTimezone = __webpack_require__(67);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(7);
	
	var _shapes = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeSlot = function TimeSlot(_ref) {
	  var item = _ref.item,
	      timezone = _ref.timezone,
	      selectedTime = _ref.selectedTime,
	      setTime = _ref.setTime;
	
	  var reservationTime = (0, _helpers.getReservationTimeFromTimeItem)(item);
	  var date = _momentTimezone2.default.tz(item.time, timezone);
	  var time = date.format('h:mm[\n]A');
	
	  var className = (0, _classnames2.default)('c-time-slider__item', { 'is-active': reservationTime === selectedTime });
	
	  return _react2.default.createElement(
	    'button',
	    {
	      className: className,
	      onClick: setTime(item)
	    },
	    time
	  );
	};
	
	TimeSlot.propTypes = {
	  item: _shapes.timeShape.isRequired,
	  timezone: _propTypes2.default.string.isRequired,
	  setTime: _propTypes2.default.func.isRequired,
	  selectedTime: _propTypes2.default.string.isRequired
	};
	TimeSlot.defaultProps = {};
	
	exports.default = TimeSlot;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _momentTimezone = __webpack_require__(67);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _reactRedux = __webpack_require__(6);
	
	var _WithAnyBarber = __webpack_require__(273);
	
	var _WithAnyBarber2 = _interopRequireDefault(_WithAnyBarber);
	
	var _WithFetchAvailability = __webpack_require__(275);
	
	var _WithFetchAvailability2 = _interopRequireDefault(_WithFetchAvailability);
	
	var _WithTimezone = __webpack_require__(115);
	
	var _WithTimezone2 = _interopRequireDefault(_WithTimezone);
	
	var _selectors = __webpack_require__(71);
	
	var _WithAdvanceBookDays = __webpack_require__(426);
	
	var _WithAdvanceBookDays2 = _interopRequireDefault(_WithAdvanceBookDays);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _NextAvailableButton = __webpack_require__(1229);
	
	var _NextAvailableButton2 = _interopRequireDefault(_NextAvailableButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_WithAnyBarber2.default, _WithAdvanceBookDays2.default, _WithTimezone2.default, _WithFetchAvailability2.default, (0, _reactRedux.connect)(function (state, ownProps) {
	  var activeDay = (0, _selectors.getActiveDay)(state);
	  return {
	    nextAvailableTime: (0, _selectors.getNextAvailableTime)(state, activeDay, ownProps.timezone),
	    nextUnfetchedDay: (0, _selectors.getNextUnfetchedDayUpToAdvanceBookDays)(state, ownProps.advanceBookDays),
	    activeDay: activeDay
	  };
	}), (0, _withHandlers3.default)({
	  onClick: function onClick(props) {
	    return function () {
	      var time = (0, _selectors.getTimeOrItem)(props.nextAvailableTime);
	      props.setActiveDay(_momentTimezone2.default.tz(time, props.timezone).startOf('day').format(_config2.default.apiDateFormat));
	      props.setTime((0, _helpers.mapTimes)(props.nextAvailableTime))();
	    };
	  }
	}), (0, _withPropsOnChange3.default)(['activeDay', 'nextAvailableTime', 'nextUnfetchedDay'], function (props) {
	  if (props.activeDay && !props.nextAvailableTime && props.nextUnfetchedDay) {
	    var nextAvailableTimeFetchInterval = props.anyBarber ? _config2.default.nextAvailableTimeFetchInterval.shop : _config2.default.nextAvailableTimeFetchInterval.barber;
	    props.fetchAvailability(props.nextUnfetchedDay, (0, _momentTimezone2.default)(props.nextUnfetchedDay).add(nextAvailableTimeFetchInterval).format(_config2.default.apiDateFormat));
	  }
	}), (0, _branch3.default)(function (props) {
	  return !props.nextAvailableTime;
	}, _renderNothing3.default))(_NextAvailableButton2.default);

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.INVALID_CVC = exports.INVALID_EXPIRY = exports.INVALID_CARD = exports.DEFAULT_ICON = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cardValidator = __webpack_require__(1256);
	
	var _cardValidator2 = _interopRequireDefault(_cardValidator);
	
	var _creditCardType = __webpack_require__(304);
	
	var _visa = __webpack_require__(496);
	
	var _visa2 = _interopRequireDefault(_visa);
	
	var _mastercard = __webpack_require__(494);
	
	var _mastercard2 = _interopRequireDefault(_mastercard);
	
	var _amex = __webpack_require__(490);
	
	var _amex2 = _interopRequireDefault(_amex);
	
	var _discover = __webpack_require__(492);
	
	var _discover2 = _interopRequireDefault(_discover);
	
	var _diners = __webpack_require__(491);
	
	var _diners2 = _interopRequireDefault(_diners);
	
	var _jcb = __webpack_require__(493);
	
	var _jcb2 = _interopRequireDefault(_jcb);
	
	var _unionpay = __webpack_require__(495);
	
	var _unionpay2 = _interopRequireDefault(_unionpay);
	
	var _default = __webpack_require__(489);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_ICON = exports.DEFAULT_ICON = _default2.default;
	var INVALID_CARD = exports.INVALID_CARD = 'Your card number is invalid.';
	var INVALID_EXPIRY = exports.INVALID_EXPIRY = "Your card's expiration is invalid.";
	var INVALID_CVC = exports.INVALID_CVC = "Your card's security code is incomplete.";
	
	var DEFAULT_CARD = {
	  gaps: [4, 8, 12],
	  lengths: [16],
	  code: { size: 3 }
	};
	
	var PayFac = function () {
	  function PayFac() {
	    var _this = this;
	
	    _classCallCheck(this, PayFac);
	
	    this.brandIcon = function (card) {
	      if (!card) return DEFAULT_ICON;
	      switch (card.type) {
	        case _creditCardType.types.VISA:
	          return _visa2.default;
	        case _creditCardType.types.MASTERCARD:
	          return _mastercard2.default;
	        case _creditCardType.types.AMERICAN_EXPRESS:
	          return _amex2.default;
	        case _creditCardType.types.DINERS_CLUB:
	          return _diners2.default;
	        case _creditCardType.types.DISCOVER:
	          return _discover2.default;
	        case _creditCardType.types.JCB:
	          return _jcb2.default;
	        case _creditCardType.types.UNIONPAY:
	          return _unionpay2.default;
	        default:
	          return DEFAULT_ICON;
	      }
	    };
	
	    this.prettyCardNumber = function (cardNumber, card) {
	      if (card) {
	        var offsets = [].concat(0, card.gaps, cardNumber.length);
	        var components = [];
	
	        for (var i = 0; offsets[i] < cardNumber.length; i += 1) {
	          var start = offsets[i];
	          var end = Math.min(offsets[i + 1], cardNumber.length);
	          components.push(cardNumber.substring(start, end));
	        }
	
	        return components.join(' ');
	      }
	
	      return cardNumber;
	    };
	
	    this.formatExpiry = function (expiry) {
	      var limitExpiry = expiry.substr(0, 4);
	
	      if (limitExpiry.match(/^[2-9]$/)) {
	        return '0' + limitExpiry;
	      }
	
	      if (limitExpiry.length > 2) {
	        return [limitExpiry.substr(0, 2), limitExpiry.substr(2, limitExpiry.length)].join(' / ');
	      }
	
	      return limitExpiry;
	    };
	
	    this.validateCardExpiry = function (expiry) {
	      var checkPotentiallyValid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var sanitized = expiry.replace(/[^\d]/g, '');
	      var formatted = _this.formatExpiry(sanitized);
	      var validation = _cardValidator2.default.expirationDate(formatted);
	      validation.formatted = formatted;
	
	      if (checkPotentiallyValid) {
	        validation.error = !validation.isPotentiallyValid ? INVALID_EXPIRY : null;
	      } else {
	        validation.error = !validation.isValid ? INVALID_EXPIRY : null;
	      }
	
	      return validation;
	    };
	
	    this.formatCardCvc = function (cvc, card) {
	      return cvc.substr(0, card.code.size);
	    };
	
	    this.validateCardCvc = function (cvc, cardNumber) {
	      var checkPotentiallyValid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var sanitizedCvc = cvc.replace(/[^\d]/g, '');
	      var sanitizedNumber = cardNumber.replace(/[^\d]/g, '');
	      var validation = _cardValidator2.default.number(sanitizedNumber);
	      var card = validation.card || DEFAULT_CARD;
	      var formatted = _this.formatCardCvc(sanitizedCvc, card);
	      validation.formattedCvc = formatted;
	      validation.cvcError = checkPotentiallyValid || !checkPotentiallyValid && formatted && formatted.length === card.code.size ? null : INVALID_CVC;
	      return validation;
	    };
	
	    this.createToken = function (_ref) {
	      var cardNumber = _ref.cardNumber,
	          cvc = _ref.cvc,
	          expiry = _ref.expiry,
	          zipCode = _ref.zipCode;
	
	      var url = _config2.default.squireTokensUrl + '/tokens';
	      var expiryValidation = _this.validateCardExpiry(expiry);
	      return fetch(url, {
	        method: 'POST',
	        headers: {
	          'Content-Type': 'application/json'
	        },
	        body: JSON.stringify({
	          number: cardNumber,
	          expMonth: expiryValidation.month,
	          expYear: expiryValidation.year,
	          cvc: cvc,
	          zipCode: zipCode
	        })
	      }).then(_helpers.checkStatus);
	    };
	  }
	
	  _createClass(PayFac, [{
	    key: 'formatCardNumber',
	    value: function formatCardNumber(cardNumber, card) {
	      var maxLength = card.lengths[card.lengths.length - 1];
	      var limitCard = cardNumber.substr(0, maxLength);
	      return this.prettyCardNumber(limitCard, card);
	    }
	  }, {
	    key: 'validateCardNumber',
	    value: function validateCardNumber(cardNumber) {
	      var checkPotentiallyValid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var sanitized = cardNumber.replace(/[^\d]/g, '');
	      var validation = _cardValidator2.default.number(sanitized);
	      var card = validation.card || DEFAULT_CARD;
	      validation.brandIcon = this.brandIcon(validation.card);
	      validation.formatted = this.formatCardNumber(sanitized, card);
	
	      if (checkPotentiallyValid) {
	        validation.error = !validation.isPotentiallyValid ? INVALID_CARD : null;
	      } else {
	        validation.error = !validation.isValid ? INVALID_CARD : null;
	      }
	
	      return validation;
	    }
	  }]);
	
	  return PayFac;
	}();
	
	exports.default = PayFac;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var instance = null;
	
	var StripeInstance = function StripeInstance() {
	  _classCallCheck(this, StripeInstance);
	
	  instance = instance || window.Stripe.StripeV3(_config2.default.stripeKey);
	  return instance;
	};
	
	exports.default = StripeInstance;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFinite2 = __webpack_require__(348);
	
	var _isFinite3 = _interopRequireDefault(_isFinite2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ShopMap = __webpack_require__(290);
	
	var _ShopMap2 = _interopRequireDefault(_ShopMap);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Info = function Info(_ref) {
	  var barberName = _ref.barberName,
	      serviceName = _ref.serviceName,
	      serviceDuration = _ref.serviceDuration,
	      shopName = _ref.shopName,
	      shopAddress = _ref.shopAddress,
	      shopZip = _ref.shopZip,
	      numberInLine = _ref.numberInLine;
	  return _react2.default.createElement(
	    'div',
	    { className: 'layout layout--large u-mt+' },
	    _react2.default.createElement(
	      'div',
	      { className: 'layout__item u-1/2-medium-and-up' },
	      _react2.default.createElement(
	        'dl',
	        null,
	        barberName && [_react2.default.createElement(
	          'dt',
	          { className: 'c-heading c-heading--large' },
	          'Professional:'
	        ), _react2.default.createElement(
	          'dd',
	          { className: 'c-heading c-heading--large u-mb' },
	          barberName
	        )],
	        _react2.default.createElement(
	          'dt',
	          { className: 'c-heading c-heading--large' },
	          'Service:'
	        ),
	        _react2.default.createElement(
	          'dd',
	          { className: 'c-heading c-heading--large u-type--capitalize u-mb' },
	          serviceName
	        ),
	        _react2.default.createElement(
	          'dt',
	          { className: 'c-heading c-heading--large' },
	          'Duration:'
	        ),
	        _react2.default.createElement(
	          'dd',
	          { className: 'c-heading c-heading--large u-mb' },
	          (0, _helpers.formatDuration)(serviceDuration)
	        ),
	        _react2.default.createElement(
	          'dt',
	          { className: 'c-heading c-heading--large' },
	          'Shop:'
	        ),
	        _react2.default.createElement(
	          'dd',
	          { className: 'c-heading c-heading--large' },
	          shopName
	        ),
	        _react2.default.createElement(
	          'dd',
	          { className: 'c-heading c-heading--large' },
	          shopAddress
	        ),
	        _react2.default.createElement(
	          'dd',
	          { className: 'c-heading c-heading--large u-mb' },
	          shopZip
	        ),
	        (0, _isFinite3.default)(numberInLine) && [_react2.default.createElement(
	          'dt',
	          { className: 'c-heading c-heading--large' },
	          'Your waitlist position is:'
	        ), _react2.default.createElement(
	          'dd',
	          { className: 'c-heading c-heading--large u-mb+' },
	          numberInLine
	        )]
	      )
	    ),
	    shopAddress && _react2.default.createElement(
	      'div',
	      { className: 'layout__item u-1/2-medium-and-up' },
	      _react2.default.createElement(_ShopMap2.default, { name: shopName, address: shopAddress })
	    )
	  );
	};
	Info.propTypes = {
	  barberName: _propTypes2.default.string.isRequired,
	  serviceName: _propTypes2.default.string.isRequired,
	  serviceDuration: _propTypes2.default.number.isRequired,
	  shopName: _propTypes2.default.string.isRequired,
	  shopAddress: _propTypes2.default.string.isRequired,
	  shopZip: _propTypes2.default.string.isRequired,
	  numberInLine: _propTypes2.default.number
	};
	Info.defaultProps = {
	  shopLocation: null,
	  numberInLine: null
	};
	
	exports.default = Info;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.store = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _analytics = __webpack_require__(401);
	
	var analytics = _interopRequireWildcard(_analytics);
	
	var _acceptCookies = __webpack_require__(262);
	
	var acceptCookies = _interopRequireWildcard(_acceptCookies);
	
	var _routes = __webpack_require__(1247);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__(1248);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = exports.store = (0, _store2.default)();
	
	var Root = function Root() {
	  return _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    (0, _routes2.default)(analytics.onRouteUpdate(store, acceptCookies))
	  );
	};
	
	exports.default = Root;

/***/ }),
/* 476 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.expirationMonth = void 0;
	function verification(isValid, isPotentiallyValid, isValidForThisYear) {
	    return {
	        isValid: isValid,
	        isPotentiallyValid: isPotentiallyValid,
	        isValidForThisYear: isValidForThisYear || false,
	    };
	}
	function expirationMonth(value) {
	    var currentMonth = new Date().getMonth() + 1;
	    if (typeof value !== "string") {
	        return verification(false, false);
	    }
	    if (value.replace(/\s/g, "") === "" || value === "0") {
	        return verification(false, true);
	    }
	    if (!/^\d*$/.test(value)) {
	        return verification(false, false);
	    }
	    var month = parseInt(value, 10);
	    if (isNaN(Number(value))) {
	        return verification(false, false);
	    }
	    var result = month > 0 && month < 13;
	    return verification(result, result, result && month >= currentMonth);
	}
	exports.expirationMonth = expirationMonth;


/***/ }),
/* 477 */
/***/ (function(module, exports) {

	/**
	 * Slice reference.
	 */
	
	var slice = [].slice;
	
	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */
	
	module.exports = function(obj, fn){
	  if ('string' == typeof fn) fn = obj[fn];
	  if ('function' != typeof fn) throw new Error('bind() requires a function');
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};


/***/ }),
/* 478 */
/***/ (function(module, exports) {

	
	/**
	 * toString ref.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Return the type of `val`.
	 *
	 * @param {Mixed} val
	 * @return {String}
	 * @api public
	 */
	
	module.exports = function(val){
	  switch (toString.call(val)) {
	    case '[object Function]': return 'function';
	    case '[object Date]': return 'date';
	    case '[object RegExp]': return 'regexp';
	    case '[object Arguments]': return 'arguments';
	    case '[object Array]': return 'array';
	    case '[object String]': return 'string';
	  }
	
	  if (val === null) return 'null';
	  if (val === undefined) return 'undefined';
	  if (val && val.nodeType === 1) return 'element';
	  if (val === Object(val)) return 'object';
	
	  return typeof val;
	};


/***/ }),
/* 479 */
/***/ (function(module, exports) {

	/**
	 * Global Names
	 */
	
	var globals = /\b(Array|Date|Object|Math|JSON)\b/g;
	
	/**
	 * Return immediate identifiers parsed from `str`.
	 *
	 * @param {String} str
	 * @param {String|Function} map function or prefix
	 * @return {Array}
	 * @api public
	 */
	
	module.exports = function(str, fn){
	  var p = unique(props(str));
	  if (fn && 'string' == typeof fn) fn = prefixed(fn);
	  if (fn) return map(str, p, fn);
	  return p;
	};
	
	/**
	 * Return immediate identifiers in `str`.
	 *
	 * @param {String} str
	 * @return {Array}
	 * @api private
	 */
	
	function props(str) {
	  return str
	    .replace(/\.\w+|\w+ *\(|"[^"]*"|'[^']*'|\/([^/]+)\//g, '')
	    .replace(globals, '')
	    .match(/[a-zA-Z_]\w*/g)
	    || [];
	}
	
	/**
	 * Return `str` with `props` mapped with `fn`.
	 *
	 * @param {String} str
	 * @param {Array} props
	 * @param {Function} fn
	 * @return {String}
	 * @api private
	 */
	
	function map(str, props, fn) {
	  var re = /\.\w+|\w+ *\(|"[^"]*"|'[^']*'|\/([^/]+)\/|[a-zA-Z_]\w*/g;
	  return str.replace(re, function(_){
	    if ('(' == _[_.length - 1]) return fn(_);
	    if (!~props.indexOf(_)) return _;
	    return fn(_);
	  });
	}
	
	/**
	 * Return unique array.
	 *
	 * @param {Array} arr
	 * @return {Array}
	 * @api private
	 */
	
	function unique(arr) {
	  var ret = [];
	
	  for (var i = 0; i < arr.length; i++) {
	    if (~ret.indexOf(arr[i])) continue;
	    ret.push(arr[i]);
	  }
	
	  return ret;
	}
	
	/**
	 * Map with prefix `str`.
	 */
	
	function prefixed(str) {
	  return function(_){
	    return str + _;
	  };
	}


/***/ }),
/* 480 */
/***/ (function(module, exports) {

	
	/**
	 * Parse the given `url`.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api public
	 */
	
	exports.parse = function(url){
	  var a = document.createElement('a');
	  a.href = url;
	  return {
	    href: a.href,
	    host: a.host || location.host,
	    port: ('0' === a.port || '' === a.port) ? port(a.protocol) : a.port,
	    hash: a.hash,
	    hostname: a.hostname || location.hostname,
	    pathname: a.pathname.charAt(0) != '/' ? '/' + a.pathname : a.pathname,
	    protocol: !a.protocol || ':' == a.protocol ? location.protocol : a.protocol,
	    search: a.search,
	    query: a.search.slice(1)
	  };
	};
	
	/**
	 * Check if `url` is absolute.
	 *
	 * @param {String} url
	 * @return {Boolean}
	 * @api public
	 */
	
	exports.isAbsolute = function(url){
	  return 0 == url.indexOf('//') || !!~url.indexOf('://');
	};
	
	/**
	 * Check if `url` is relative.
	 *
	 * @param {String} url
	 * @return {Boolean}
	 * @api public
	 */
	
	exports.isRelative = function(url){
	  return !exports.isAbsolute(url);
	};
	
	/**
	 * Check if `url` is cross domain.
	 *
	 * @param {String} url
	 * @return {Boolean}
	 * @api public
	 */
	
	exports.isCrossDomain = function(url){
	  url = exports.parse(url);
	  var location = exports.parse(window.location.href);
	  return url.hostname !== location.hostname
	    || url.port !== location.port
	    || url.protocol !== location.protocol;
	};
	
	/**
	 * Return default port for `protocol`.
	 *
	 * @param  {String} protocol
	 * @return {String}
	 * @api private
	 */
	function port (protocol){
	  switch (protocol) {
	    case 'http:':
	      return 80;
	    case 'https:':
	      return 443;
	    default:
	      return location.port;
	  }
	}


/***/ }),
/* 481 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.clone = void 0;
	function clone(originalObject) {
	    if (!originalObject) {
	        return null;
	    }
	    return JSON.parse(JSON.stringify(originalObject));
	}
	exports.clone = clone;


/***/ }),
/* 482 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWindow;
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	module.exports = exports["default"];

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(65);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/chevron.c0f955a8.svg";

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tidal-logo-black.c6d0066c.svg";

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/squire-logo.92f732b2.svg";

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/default.63a19caf.svg";

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/amex.fb803771.svg";

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/diners.48148d1d.svg";

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/discover.acb2f470.svg";

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/jcb.d075213a.svg";

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mastercard.8e8d0718.svg";

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/unionpay.e80816ad.svg";

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/visa.e95aa8a1.svg";

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(203);
	
	var _BrowserProtocol = __webpack_require__(310);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(1323);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(166);
	
	var _createHistory = __webpack_require__(312);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(203);
	
	var _DOMUtils = __webpack_require__(166);
	
	var _HashProtocol = __webpack_require__(1322);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(312);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(119);
	
	var _PathUtils = __webpack_require__(100);
	
	var _createHistory = __webpack_require__(312);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ }),
/* 500 */
/***/ (function(module, exports) {

	module.exports = {
		"version": 4,
		"country_calling_codes": {
			"1": [
				"US",
				"AG",
				"AI",
				"AS",
				"BB",
				"BM",
				"BS",
				"CA",
				"DM",
				"DO",
				"GD",
				"GU",
				"JM",
				"KN",
				"KY",
				"LC",
				"MP",
				"MS",
				"PR",
				"SX",
				"TC",
				"TT",
				"VC",
				"VG",
				"VI"
			],
			"7": [
				"RU",
				"KZ"
			],
			"20": [
				"EG"
			],
			"27": [
				"ZA"
			],
			"30": [
				"GR"
			],
			"31": [
				"NL"
			],
			"32": [
				"BE"
			],
			"33": [
				"FR"
			],
			"34": [
				"ES"
			],
			"36": [
				"HU"
			],
			"39": [
				"IT",
				"VA"
			],
			"40": [
				"RO"
			],
			"41": [
				"CH"
			],
			"43": [
				"AT"
			],
			"44": [
				"GB",
				"GG",
				"IM",
				"JE"
			],
			"45": [
				"DK"
			],
			"46": [
				"SE"
			],
			"47": [
				"NO",
				"SJ"
			],
			"48": [
				"PL"
			],
			"49": [
				"DE"
			],
			"51": [
				"PE"
			],
			"52": [
				"MX"
			],
			"53": [
				"CU"
			],
			"54": [
				"AR"
			],
			"55": [
				"BR"
			],
			"56": [
				"CL"
			],
			"57": [
				"CO"
			],
			"58": [
				"VE"
			],
			"60": [
				"MY"
			],
			"61": [
				"AU",
				"CC",
				"CX"
			],
			"62": [
				"ID"
			],
			"63": [
				"PH"
			],
			"64": [
				"NZ"
			],
			"65": [
				"SG"
			],
			"66": [
				"TH"
			],
			"81": [
				"JP"
			],
			"82": [
				"KR"
			],
			"84": [
				"VN"
			],
			"86": [
				"CN"
			],
			"90": [
				"TR"
			],
			"91": [
				"IN"
			],
			"92": [
				"PK"
			],
			"93": [
				"AF"
			],
			"94": [
				"LK"
			],
			"95": [
				"MM"
			],
			"98": [
				"IR"
			],
			"211": [
				"SS"
			],
			"212": [
				"MA",
				"EH"
			],
			"213": [
				"DZ"
			],
			"216": [
				"TN"
			],
			"218": [
				"LY"
			],
			"220": [
				"GM"
			],
			"221": [
				"SN"
			],
			"222": [
				"MR"
			],
			"223": [
				"ML"
			],
			"224": [
				"GN"
			],
			"225": [
				"CI"
			],
			"226": [
				"BF"
			],
			"227": [
				"NE"
			],
			"228": [
				"TG"
			],
			"229": [
				"BJ"
			],
			"230": [
				"MU"
			],
			"231": [
				"LR"
			],
			"232": [
				"SL"
			],
			"233": [
				"GH"
			],
			"234": [
				"NG"
			],
			"235": [
				"TD"
			],
			"236": [
				"CF"
			],
			"237": [
				"CM"
			],
			"238": [
				"CV"
			],
			"239": [
				"ST"
			],
			"240": [
				"GQ"
			],
			"241": [
				"GA"
			],
			"242": [
				"CG"
			],
			"243": [
				"CD"
			],
			"244": [
				"AO"
			],
			"245": [
				"GW"
			],
			"246": [
				"IO"
			],
			"247": [
				"AC"
			],
			"248": [
				"SC"
			],
			"249": [
				"SD"
			],
			"250": [
				"RW"
			],
			"251": [
				"ET"
			],
			"252": [
				"SO"
			],
			"253": [
				"DJ"
			],
			"254": [
				"KE"
			],
			"255": [
				"TZ"
			],
			"256": [
				"UG"
			],
			"257": [
				"BI"
			],
			"258": [
				"MZ"
			],
			"260": [
				"ZM"
			],
			"261": [
				"MG"
			],
			"262": [
				"RE",
				"YT"
			],
			"263": [
				"ZW"
			],
			"264": [
				"NA"
			],
			"265": [
				"MW"
			],
			"266": [
				"LS"
			],
			"267": [
				"BW"
			],
			"268": [
				"SZ"
			],
			"269": [
				"KM"
			],
			"290": [
				"SH",
				"TA"
			],
			"291": [
				"ER"
			],
			"297": [
				"AW"
			],
			"298": [
				"FO"
			],
			"299": [
				"GL"
			],
			"350": [
				"GI"
			],
			"351": [
				"PT"
			],
			"352": [
				"LU"
			],
			"353": [
				"IE"
			],
			"354": [
				"IS"
			],
			"355": [
				"AL"
			],
			"356": [
				"MT"
			],
			"357": [
				"CY"
			],
			"358": [
				"FI",
				"AX"
			],
			"359": [
				"BG"
			],
			"370": [
				"LT"
			],
			"371": [
				"LV"
			],
			"372": [
				"EE"
			],
			"373": [
				"MD"
			],
			"374": [
				"AM"
			],
			"375": [
				"BY"
			],
			"376": [
				"AD"
			],
			"377": [
				"MC"
			],
			"378": [
				"SM"
			],
			"380": [
				"UA"
			],
			"381": [
				"RS"
			],
			"382": [
				"ME"
			],
			"383": [
				"XK"
			],
			"385": [
				"HR"
			],
			"386": [
				"SI"
			],
			"387": [
				"BA"
			],
			"389": [
				"MK"
			],
			"420": [
				"CZ"
			],
			"421": [
				"SK"
			],
			"423": [
				"LI"
			],
			"500": [
				"FK"
			],
			"501": [
				"BZ"
			],
			"502": [
				"GT"
			],
			"503": [
				"SV"
			],
			"504": [
				"HN"
			],
			"505": [
				"NI"
			],
			"506": [
				"CR"
			],
			"507": [
				"PA"
			],
			"508": [
				"PM"
			],
			"509": [
				"HT"
			],
			"590": [
				"GP",
				"BL",
				"MF"
			],
			"591": [
				"BO"
			],
			"592": [
				"GY"
			],
			"593": [
				"EC"
			],
			"594": [
				"GF"
			],
			"595": [
				"PY"
			],
			"596": [
				"MQ"
			],
			"597": [
				"SR"
			],
			"598": [
				"UY"
			],
			"599": [
				"CW",
				"BQ"
			],
			"670": [
				"TL"
			],
			"672": [
				"NF"
			],
			"673": [
				"BN"
			],
			"674": [
				"NR"
			],
			"675": [
				"PG"
			],
			"676": [
				"TO"
			],
			"677": [
				"SB"
			],
			"678": [
				"VU"
			],
			"679": [
				"FJ"
			],
			"680": [
				"PW"
			],
			"681": [
				"WF"
			],
			"682": [
				"CK"
			],
			"683": [
				"NU"
			],
			"685": [
				"WS"
			],
			"686": [
				"KI"
			],
			"687": [
				"NC"
			],
			"688": [
				"TV"
			],
			"689": [
				"PF"
			],
			"690": [
				"TK"
			],
			"691": [
				"FM"
			],
			"692": [
				"MH"
			],
			"850": [
				"KP"
			],
			"852": [
				"HK"
			],
			"853": [
				"MO"
			],
			"855": [
				"KH"
			],
			"856": [
				"LA"
			],
			"880": [
				"BD"
			],
			"886": [
				"TW"
			],
			"960": [
				"MV"
			],
			"961": [
				"LB"
			],
			"962": [
				"JO"
			],
			"963": [
				"SY"
			],
			"964": [
				"IQ"
			],
			"965": [
				"KW"
			],
			"966": [
				"SA"
			],
			"967": [
				"YE"
			],
			"968": [
				"OM"
			],
			"970": [
				"PS"
			],
			"971": [
				"AE"
			],
			"972": [
				"IL"
			],
			"973": [
				"BH"
			],
			"974": [
				"QA"
			],
			"975": [
				"BT"
			],
			"976": [
				"MN"
			],
			"977": [
				"NP"
			],
			"992": [
				"TJ"
			],
			"993": [
				"TM"
			],
			"994": [
				"AZ"
			],
			"995": [
				"GE"
			],
			"996": [
				"KG"
			],
			"998": [
				"UZ"
			]
		},
		"countries": {
			"AC": [
				"247",
				"00",
				"(?:[01589]\\d|[46])\\d{4}",
				[
					5,
					6
				]
			],
			"AD": [
				"376",
				"00",
				"(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
				[
					6,
					8,
					9
				],
				[
					[
						"(\\d{3})(\\d{3})",
						"$1 $2",
						[
							"[135-9]"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"6"
						]
					]
				]
			],
			"AE": [
				"971",
				"00",
				"(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
				[
					5,
					6,
					7,
					8,
					9,
					10,
					11,
					12
				],
				[
					[
						"(\\d{3})(\\d{2,9})",
						"$1 $2",
						[
							"60|8"
						]
					],
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[236]|[479][2-8]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d)(\\d{5})",
						"$1 $2 $3",
						[
							"[479]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"5"
						],
						"0$1"
					]
				],
				"0"
			],
			"AF": [
				"93",
				"00",
				"[2-7]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2-7]"
						],
						"0$1"
					]
				],
				"0"
			],
			"AG": [
				"1",
				"011",
				"(?:268|[58]\\d\\d|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([457]\\d{6})$",
				"268$1",
				0,
				"268"
			],
			"AI": [
				"1",
				"011",
				"(?:264|[58]\\d\\d|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([2457]\\d{6})$",
				"264$1",
				0,
				"264"
			],
			"AL": [
				"355",
				"00",
				"(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
				[
					6,
					7,
					8,
					9
				],
				[
					[
						"(\\d{3})(\\d{3,4})",
						"$1 $2",
						[
							"80|9"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"4[2-6]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2358][2-5]|4"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"[23578]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"6"
						],
						"0$1"
					]
				],
				"0"
			],
			"AM": [
				"374",
				"00",
				"(?:[1-489]\\d|55|60|77)\\d{6}",
				[
					8
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[89]0"
						],
						"0 $1"
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"2|3[12]"
						],
						"(0$1)"
					],
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"1|47"
						],
						"(0$1)"
					],
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"[3-9]"
						],
						"0$1"
					]
				],
				"0"
			],
			"AO": [
				"244",
				"00",
				"[29]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[29]"
						]
					]
				]
			],
			"AR": [
				"54",
				"00",
				"(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
				[
					10,
					11
				],
				[
					[
						"(\\d{4})(\\d{2})(\\d{4})",
						"$1 $2-$3",
						[
							"2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
							"2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
							"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
							"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
						],
						"0$1",
						1
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2-$3",
						[
							"1"
						],
						"0$1",
						1
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[68]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2-$3",
						[
							"[23]"
						],
						"0$1",
						1
					],
					[
						"(\\d)(\\d{4})(\\d{2})(\\d{4})",
						"$2 15-$3-$4",
						[
							"9(?:2[2-469]|3[3-578])",
							"9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
							"9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
							"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
							"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
						],
						"0$1",
						0,
						"$1 $2 $3-$4"
					],
					[
						"(\\d)(\\d{2})(\\d{4})(\\d{4})",
						"$2 15-$3-$4",
						[
							"91"
						],
						"0$1",
						0,
						"$1 $2 $3-$4"
					],
					[
						"(\\d{3})(\\d{3})(\\d{5})",
						"$1-$2-$3",
						[
							"8"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{3})(\\d{3})(\\d{4})",
						"$2 15-$3-$4",
						[
							"9"
						],
						"0$1",
						0,
						"$1 $2 $3-$4"
					]
				],
				"0",
				0,
				"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
				"9$1"
			],
			"AS": [
				"1",
				"011",
				"(?:[58]\\d\\d|684|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([267]\\d{6})$",
				"684$1",
				0,
				"684"
			],
			"AT": [
				"43",
				"00",
				"1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
				[
					4,
					5,
					6,
					7,
					8,
					9,
					10,
					11,
					12,
					13
				],
				[
					[
						"(\\d)(\\d{3,12})",
						"$1 $2",
						[
							"1(?:11|[2-9])"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})",
						"$1 $2",
						[
							"517"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3,5})",
						"$1 $2",
						[
							"5[079]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3,10})",
						"$1 $2",
						[
							"(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{3,9})",
						"$1 $2",
						[
							"[2-467]|5[2-6]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"5"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{4})(\\d{4,7})",
						"$1 $2 $3",
						[
							"5"
						],
						"0$1"
					]
				],
				"0"
			],
			"AU": [
				"61",
				"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
				"1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
				[
					5,
					6,
					7,
					8,
					9,
					10,
					12
				],
				[
					[
						"(\\d{2})(\\d{3,4})",
						"$1 $2",
						[
							"16"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{2,4})",
						"$1 $2 $3",
						[
							"16"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"14|4"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[2378]"
						],
						"(0$1)"
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1(?:30|[89])"
						]
					]
				],
				"0",
				0,
				"0|(183[12])",
				0,
				0,
				0,
				[
					[
						"(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
						[
							9
						]
					],
					[
						"4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
						[
							9
						]
					],
					[
						"180(?:0\\d{3}|2)\\d{3}",
						[
							7,
							10
						]
					],
					[
						"190[0-26]\\d{6}",
						[
							10
						]
					],
					0,
					0,
					0,
					[
						"163\\d{2,6}",
						[
							5,
							6,
							7,
							8,
							9
						]
					],
					[
						"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
						[
							9
						]
					],
					[
						"13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
						[
							6,
							8,
							10,
							12
						]
					]
				],
				"0011"
			],
			"AW": [
				"297",
				"00",
				"(?:[25-79]\\d\\d|800)\\d{4}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[25-9]"
						]
					]
				]
			],
			"AX": [
				"358",
				"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
				"2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
				[
					5,
					6,
					7,
					8,
					9,
					10,
					11,
					12
				],
				0,
				"0",
				0,
				0,
				0,
				0,
				"18",
				0,
				"00"
			],
			"AZ": [
				"994",
				"00",
				"365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"90"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"1[28]|2|365|46",
							"1[28]|2|365[45]|46",
							"1[28]|2|365(?:4|5[02])|46"
						],
						"(0$1)"
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[13-9]"
						],
						"0$1"
					]
				],
				"0"
			],
			"BA": [
				"387",
				"00",
				"6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"6[1-3]|[7-9]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2-$3",
						[
							"[3-5]|6[56]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"6"
						],
						"0$1"
					]
				],
				"0"
			],
			"BB": [
				"1",
				"011",
				"(?:246|[58]\\d\\d|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([2-9]\\d{6})$",
				"246$1",
				0,
				"246"
			],
			"BD": [
				"880",
				"00",
				"[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
				[
					6,
					7,
					8,
					9,
					10
				],
				[
					[
						"(\\d{2})(\\d{4,6})",
						"$1-$2",
						[
							"31[5-8]|[459]1"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3,7})",
						"$1-$2",
						[
							"3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{3,6})",
						"$1-$2",
						[
							"[13-9]|22"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{7,8})",
						"$1-$2",
						[
							"2"
						],
						"0$1"
					]
				],
				"0"
			],
			"BE": [
				"32",
				"00",
				"4\\d{8}|[1-9]\\d{7}",
				[
					8,
					9
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"(?:80|9)0"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[239]|4[23]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[15-8]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"4"
						],
						"0$1"
					]
				],
				"0"
			],
			"BF": [
				"226",
				"00",
				"[025-7]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[025-7]"
						]
					]
				]
			],
			"BG": [
				"359",
				"00",
				"[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
				[
					6,
					7,
					8,
					9
				],
				[
					[
						"(\\d)(\\d)(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"2"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"43[1-6]|70[1-9]"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{2,3})",
						"$1 $2 $3",
						[
							"[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"(?:70|8)0"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{2})",
						"$1 $2 $3",
						[
							"43[1-7]|7"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[48]|9[08]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"9"
						],
						"0$1"
					]
				],
				"0"
			],
			"BH": [
				"973",
				"00",
				"[136-9]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[13679]|8[047]"
						]
					]
				]
			],
			"BI": [
				"257",
				"00",
				"(?:[267]\\d|31)\\d{6}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2367]"
						]
					]
				]
			],
			"BJ": [
				"229",
				"00",
				"(?:[25689]\\d|40)\\d{6}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[24-689]"
						]
					]
				]
			],
			"BL": [
				"590",
				"00",
				"(?:590|(?:69|80)\\d|976)\\d{6}",
				[
					9
				],
				0,
				"0",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"590(?:2[7-9]|5[12]|87)\\d{4}"
					],
					[
						"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
					],
					[
						"80[0-5]\\d{6}"
					],
					0,
					0,
					0,
					0,
					0,
					[
						"976[01]\\d{5}"
					]
				]
			],
			"BM": [
				"1",
				"011",
				"(?:441|[58]\\d\\d|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([2-8]\\d{6})$",
				"441$1",
				0,
				"441"
			],
			"BN": [
				"673",
				"00",
				"[2-578]\\d{6}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[2-578]"
						]
					]
				]
			],
			"BO": [
				"591",
				"00(?:1\\d)?",
				"(?:[2-467]\\d\\d|8001)\\d{5}",
				[
					8,
					9
				],
				[
					[
						"(\\d)(\\d{7})",
						"$1 $2",
						[
							"[23]|4[46]"
						]
					],
					[
						"(\\d{8})",
						"$1",
						[
							"[67]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"8"
						]
					]
				],
				"0",
				0,
				"0(1\\d)?"
			],
			"BQ": [
				"599",
				"00",
				"(?:[34]1|7\\d)\\d{5}",
				[
					7
				],
				0,
				0,
				0,
				0,
				0,
				0,
				"[347]"
			],
			"BR": [
				"55",
				"00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
				"(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
				[
					8,
					9,
					10,
					11
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1-$2",
						[
							"300|4(?:0[02]|37)",
							"4(?:02|37)0|[34]00"
						]
					],
					[
						"(\\d{3})(\\d{2,3})(\\d{4})",
						"$1 $2 $3",
						[
							"(?:[358]|90)0"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2-$3",
						[
							"(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
						],
						"($1)"
					],
					[
						"(\\d{2})(\\d{5})(\\d{4})",
						"$1 $2-$3",
						[
							"[16][1-9]|[2-57-9]"
						],
						"($1)"
					]
				],
				"0",
				0,
				"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
				"$2"
			],
			"BS": [
				"1",
				"011",
				"(?:242|[58]\\d\\d|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([3-8]\\d{6})$",
				"242$1",
				0,
				"242"
			],
			"BT": [
				"975",
				"00",
				"[17]\\d{7}|[2-8]\\d{6}",
				[
					7,
					8
				],
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2-68]|7[246]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"1[67]|7"
						]
					]
				]
			],
			"BW": [
				"267",
				"00",
				"(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
				[
					7,
					8,
					10
				],
				[
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"90"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[24-6]|3[15-79]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[37]"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"0"
						]
					],
					[
						"(\\d{3})(\\d{4})(\\d{3})",
						"$1 $2 $3",
						[
							"8"
						]
					]
				]
			],
			"BY": [
				"375",
				"810",
				"(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
				[
					6,
					7,
					8,
					9,
					10,
					11
				],
				[
					[
						"(\\d{3})(\\d{3})",
						"$1 $2",
						[
							"800"
						],
						"8 $1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2,4})",
						"$1 $2 $3",
						[
							"800"
						],
						"8 $1"
					],
					[
						"(\\d{4})(\\d{2})(\\d{3})",
						"$1 $2-$3",
						[
							"1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
							"1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
						],
						"8 0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"1(?:[56]|7[467])|2[1-3]"
						],
						"8 0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"[1-4]"
						],
						"8 0$1"
					],
					[
						"(\\d{3})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"[89]"
						],
						"8 $1"
					]
				],
				"8",
				0,
				"0|80?",
				0,
				0,
				0,
				0,
				"8~10"
			],
			"BZ": [
				"501",
				"00",
				"(?:0800\\d|[2-8])\\d{6}",
				[
					7,
					11
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[2-8]"
						]
					],
					[
						"(\\d)(\\d{3})(\\d{4})(\\d{3})",
						"$1-$2-$3-$4",
						[
							"0"
						]
					]
				]
			],
			"CA": [
				"1",
				"011",
				"(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
				[
					7,
					10
				],
				0,
				"1",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|68|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
						[
							10
						]
					],
					[
						"",
						[
							10
						]
					],
					[
						"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
						[
							10
						]
					],
					[
						"900[2-9]\\d{6}",
						[
							10
						]
					],
					[
						"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-7]|33|44|66|77|88)|622)[2-9]\\d{6}",
						[
							10
						]
					],
					0,
					[
						"310\\d{4}",
						[
							7
						]
					],
					0,
					[
						"600[2-9]\\d{6}",
						[
							10
						]
					]
				]
			],
			"CC": [
				"61",
				"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
				"1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
				[
					6,
					7,
					8,
					9,
					10,
					12
				],
				0,
				"0",
				0,
				"0|([59]\\d{7})$",
				"8$1",
				0,
				0,
				[
					[
						"8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
						[
							9
						]
					],
					[
						"4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
						[
							9
						]
					],
					[
						"180(?:0\\d{3}|2)\\d{3}",
						[
							7,
							10
						]
					],
					[
						"190[0-26]\\d{6}",
						[
							10
						]
					],
					0,
					0,
					0,
					0,
					[
						"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
						[
							9
						]
					],
					[
						"13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
						[
							6,
							8,
							10,
							12
						]
					]
				],
				"0011"
			],
			"CD": [
				"243",
				"00",
				"[189]\\d{8}|[1-68]\\d{6}",
				[
					7,
					9
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"88"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"[1-6]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[89]"
						],
						"0$1"
					]
				],
				"0"
			],
			"CF": [
				"236",
				"00",
				"(?:[27]\\d{3}|8776)\\d{4}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[278]"
						]
					]
				]
			],
			"CG": [
				"242",
				"00",
				"222\\d{6}|(?:0\\d|80)\\d{7}",
				[
					9
				],
				[
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"8"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[02]"
						]
					]
				]
			],
			"CH": [
				"41",
				"00",
				"8\\d{11}|[2-9]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8[047]|90"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2-79]|81"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						[
							"8"
						],
						"0$1"
					]
				],
				"0"
			],
			"CI": [
				"225",
				"00",
				"[02]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d)(\\d{5})",
						"$1 $2 $3 $4",
						[
							"2"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
						"$1 $2 $3 $4",
						[
							"0"
						]
					]
				]
			],
			"CK": [
				"682",
				"00",
				"[2-578]\\d{4}",
				[
					5
				],
				[
					[
						"(\\d{2})(\\d{3})",
						"$1 $2",
						[
							"[2-578]"
						]
					]
				]
			],
			"CL": [
				"56",
				"(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
				"12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
				[
					9,
					10,
					11
				],
				[
					[
						"(\\d{5})(\\d{4})",
						"$1 $2",
						[
							"219",
							"2196"
						],
						"($1)"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"44"
						]
					],
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2[1-36]"
						],
						"($1)"
					],
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"9[2-9]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
						],
						"($1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"60|8"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"60"
						]
					]
				]
			],
			"CM": [
				"237",
				"00",
				"[26]\\d{8}|88\\d{6,7}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"88"
						]
					],
					[
						"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						[
							"[26]|88"
						]
					]
				]
			],
			"CN": [
				"86",
				"00|1(?:[12]\\d|79)\\d\\d00",
				"1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
				[
					7,
					8,
					9,
					10,
					11,
					12
				],
				[
					[
						"(\\d{2})(\\d{5,6})",
						"$1 $2",
						[
							"(?:10|2[0-57-9])[19]",
							"(?:10|2[0-57-9])(?:10|9[56])",
							"(?:10|2[0-57-9])(?:100|9[56])"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
							"(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
							"85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
							"85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"(?:4|80)0"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"10|2(?:[02-57-9]|1[1-9])",
							"10|2(?:[02-57-9]|1[1-9])",
							"10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
						],
						"0$1",
						1
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
						],
						"0$1",
						1
					],
					[
						"(\\d{3})(\\d{7,8})",
						"$1 $2",
						[
							"9"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"80"
						],
						"0$1",
						1
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[3-578]"
						],
						"0$1",
						1
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"1[3-9]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3 $4",
						[
							"[12]"
						],
						"0$1",
						1
					]
				],
				"0",
				0,
				"0|(1(?:[12]\\d|79)\\d\\d)",
				0,
				0,
				0,
				0,
				"00"
			],
			"CO": [
				"57",
				"00(?:4(?:[14]4|56)|[579])",
				"(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
				[
					10,
					11
				],
				[
					[
						"(\\d{3})(\\d{7})",
						"$1 $2",
						[
							"6"
						],
						"($1)"
					],
					[
						"(\\d{3})(\\d{7})",
						"$1 $2",
						[
							"[39]"
						]
					],
					[
						"(\\d)(\\d{3})(\\d{7})",
						"$1-$2-$3",
						[
							"1"
						],
						"0$1",
						0,
						"$1 $2 $3"
					]
				],
				"0",
				0,
				"0(4(?:[14]4|56)|[579])?"
			],
			"CR": [
				"506",
				"00",
				"(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
				[
					8,
					10
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[2-7]|8[3-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[89]"
						]
					]
				],
				0,
				0,
				"(19(?:0[0-2468]|1[09]|20|66|77|99))"
			],
			"CU": [
				"53",
				"119",
				"[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",
				[
					6,
					7,
					8,
					10
				],
				[
					[
						"(\\d{2})(\\d{4,6})",
						"$1 $2",
						[
							"2[1-4]|[34]"
						],
						"(0$1)"
					],
					[
						"(\\d)(\\d{6,7})",
						"$1 $2",
						[
							"7"
						],
						"(0$1)"
					],
					[
						"(\\d)(\\d{7})",
						"$1 $2",
						[
							"5"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{7})",
						"$1 $2",
						[
							"8"
						],
						"0$1"
					]
				],
				"0"
			],
			"CV": [
				"238",
				"0",
				"(?:[2-59]\\d\\d|800)\\d{4}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"[2-589]"
						]
					]
				]
			],
			"CW": [
				"599",
				"00",
				"(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
				[
					7,
					8
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[3467]"
						]
					],
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"9[4-8]"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				"[69]"
			],
			"CX": [
				"61",
				"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
				"1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
				[
					6,
					7,
					8,
					9,
					10,
					12
				],
				0,
				"0",
				0,
				"0|([59]\\d{7})$",
				"8$1",
				0,
				0,
				[
					[
						"8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
						[
							9
						]
					],
					[
						"4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
						[
							9
						]
					],
					[
						"180(?:0\\d{3}|2)\\d{3}",
						[
							7,
							10
						]
					],
					[
						"190[0-26]\\d{6}",
						[
							10
						]
					],
					0,
					0,
					0,
					0,
					[
						"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
						[
							9
						]
					],
					[
						"13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
						[
							6,
							8,
							10,
							12
						]
					]
				],
				"0011"
			],
			"CY": [
				"357",
				"00",
				"(?:[279]\\d|[58]0)\\d{6}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"[257-9]"
						]
					]
				]
			],
			"CZ": [
				"420",
				"00",
				"(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2-8]|9[015-7]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"96"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"9"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"9"
						]
					]
				]
			],
			"DE": [
				"49",
				"00",
				"[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:1\\d|2[02-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|[23]1|[46][1-8])\\d{1,9}",
				[
					4,
					5,
					6,
					7,
					8,
					9,
					10,
					11,
					12,
					13,
					14,
					15
				],
				[
					[
						"(\\d{2})(\\d{3,13})",
						"$1 $2",
						[
							"3[02]|40|[68]9"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3,12})",
						"$1 $2",
						[
							"2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
							"2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{2,11})",
						"$1 $2",
						[
							"[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
							"[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"138"
						],
						"0$1"
					],
					[
						"(\\d{5})(\\d{2,10})",
						"$1 $2",
						[
							"3"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{5,11})",
						"$1 $2",
						[
							"181"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d)(\\d{4,10})",
						"$1 $2 $3",
						[
							"1(?:3|80)|9"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{7,8})",
						"$1 $2",
						[
							"1[67]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{7,12})",
						"$1 $2",
						[
							"8"
						],
						"0$1"
					],
					[
						"(\\d{5})(\\d{6})",
						"$1 $2",
						[
							"185",
							"1850",
							"18500"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{7})",
						"$1 $2",
						[
							"18[68]"
						],
						"0$1"
					],
					[
						"(\\d{5})(\\d{6})",
						"$1 $2",
						[
							"15[0568]"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{7})",
						"$1 $2",
						[
							"15[1279]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{8})",
						"$1 $2",
						[
							"18"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{7,8})",
						"$1 $2 $3",
						[
							"1(?:6[023]|7)"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{2})(\\d{7})",
						"$1 $2 $3",
						[
							"15[279]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{8})",
						"$1 $2 $3",
						[
							"15"
						],
						"0$1"
					]
				],
				"0"
			],
			"DJ": [
				"253",
				"00",
				"(?:2\\d|77)\\d{6}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[27]"
						]
					]
				]
			],
			"DK": [
				"45",
				"00",
				"[2-9]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2-9]"
						]
					]
				]
			],
			"DM": [
				"1",
				"011",
				"(?:[58]\\d\\d|767|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([2-7]\\d{6})$",
				"767$1",
				0,
				"767"
			],
			"DO": [
				"1",
				"011",
				"(?:[58]\\d\\d|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				0,
				0,
				0,
				"8001|8[024]9"
			],
			"DZ": [
				"213",
				"00",
				"(?:[1-4]|[5-79]\\d|80)\\d{7}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[1-4]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"9"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[5-8]"
						],
						"0$1"
					]
				],
				"0"
			],
			"EC": [
				"593",
				"00",
				"1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
				[
					8,
					9,
					10,
					11
				],
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2-$3",
						[
							"[2-7]"
						],
						"(0$1)",
						0,
						"$1-$2-$3"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"9"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"1"
						]
					]
				],
				"0"
			],
			"EE": [
				"372",
				"00",
				"8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
				[
					7,
					8,
					10
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
							"[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
						]
					],
					[
						"(\\d{4})(\\d{3,4})",
						"$1 $2",
						[
							"[45]|8(?:00|[1-49])",
							"[45]|8(?:00[1-9]|[1-49])"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8"
						]
					]
				]
			],
			"EG": [
				"20",
				"00",
				"[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
				[
					8,
					9,
					10
				],
				[
					[
						"(\\d)(\\d{7,8})",
						"$1 $2",
						[
							"[23]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{6,7})",
						"$1 $2",
						[
							"1[35]|[4-6]|8[2468]|9[235-7]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[189]"
						],
						"0$1"
					]
				],
				"0"
			],
			"EH": [
				"212",
				"00",
				"[5-8]\\d{8}",
				[
					9
				],
				0,
				"0",
				0,
				0,
				0,
				0,
				"528[89]"
			],
			"ER": [
				"291",
				"00",
				"[178]\\d{6}",
				[
					7
				],
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[178]"
						],
						"0$1"
					]
				],
				"0"
			],
			"ES": [
				"34",
				"00",
				"[5-9]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[89]00"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[5-9]"
						]
					]
				]
			],
			"ET": [
				"251",
				"00",
				"(?:11|[2-59]\\d)\\d{7}",
				[
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[1-59]"
						],
						"0$1"
					]
				],
				"0"
			],
			"FI": [
				"358",
				"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
				"[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
				[
					5,
					6,
					7,
					8,
					9,
					10,
					11,
					12
				],
				[
					[
						"(\\d)(\\d{4,9})",
						"$1 $2",
						[
							"[2568][1-8]|3(?:0[1-9]|[1-9])|9"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3,7})",
						"$1 $2",
						[
							"[12]00|[368]|70[07-9]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{4,8})",
						"$1 $2",
						[
							"[1245]|7[135]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{6,10})",
						"$1 $2",
						[
							"7"
						],
						"0$1"
					]
				],
				"0",
				0,
				0,
				0,
				0,
				"1[03-79]|[2-9]",
				0,
				"00"
			],
			"FJ": [
				"679",
				"0(?:0|52)",
				"45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
				[
					7,
					11
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[235-9]|45"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"0"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"FK": [
				"500",
				"00",
				"[2-7]\\d{4}",
				[
					5
				]
			],
			"FM": [
				"691",
				"00",
				"(?:[39]\\d\\d|820)\\d{4}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[389]"
						]
					]
				]
			],
			"FO": [
				"298",
				"00",
				"[2-9]\\d{5}",
				[
					6
				],
				[
					[
						"(\\d{6})",
						"$1",
						[
							"[2-9]"
						]
					]
				],
				0,
				0,
				"(10(?:01|[12]0|88))"
			],
			"FR": [
				"33",
				"00",
				"[1-9]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8"
						],
						"0 $1"
					],
					[
						"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						[
							"[1-79]"
						],
						"0$1"
					]
				],
				"0"
			],
			"GA": [
				"241",
				"00",
				"(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
				[
					7,
					8
				],
				[
					[
						"(\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2-7]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"0"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"11|[67]"
						],
						"0$1"
					]
				],
				0,
				0,
				"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
				"$1"
			],
			"GB": [
				"44",
				"00",
				"[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
				[
					7,
					9,
					10
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"800",
							"8001",
							"80011",
							"800111",
							"8001111"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"845",
							"8454",
							"84546",
							"845464"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"800"
						],
						"0$1"
					],
					[
						"(\\d{5})(\\d{4,5})",
						"$1 $2",
						[
							"1(?:38|5[23]|69|76|94)",
							"1(?:(?:38|69)7|5(?:24|39)|768|946)",
							"1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{5,6})",
						"$1 $2",
						[
							"1(?:[2-69][02-9]|[78])"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[25]|7(?:0|6[02-9])",
							"[25]|7(?:0|6(?:[03-9]|2[356]))"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{6})",
						"$1 $2",
						[
							"7"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[1389]"
						],
						"0$1"
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[01359])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[0-79]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-26-9])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
						[
							9,
							10
						]
					],
					[
						"7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
						[
							10
						]
					],
					[
						"80[08]\\d{7}|800\\d{6}|8001111"
					],
					[
						"(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
						[
							7,
							10
						]
					],
					[
						"70\\d{8}",
						[
							10
						]
					],
					0,
					[
						"(?:3[0347]|55)\\d{8}",
						[
							10
						]
					],
					[
						"76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
						[
							10
						]
					],
					[
						"56\\d{8}",
						[
							10
						]
					]
				],
				0,
				" x"
			],
			"GD": [
				"1",
				"011",
				"(?:473|[58]\\d\\d|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([2-9]\\d{6})$",
				"473$1",
				0,
				"473"
			],
			"GE": [
				"995",
				"00",
				"(?:[3-57]\\d\\d|800)\\d{6}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"70"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"32"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[57]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[348]"
						],
						"0$1"
					]
				],
				"0"
			],
			"GF": [
				"594",
				"00",
				"(?:[56]94|80\\d|976)\\d{6}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[569]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8"
						],
						"0$1"
					]
				],
				"0"
			],
			"GG": [
				"44",
				"00",
				"(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
				[
					7,
					9,
					10
				],
				0,
				"0",
				0,
				"0|([25-9]\\d{5})$",
				"1481$1",
				0,
				0,
				[
					[
						"1481[25-9]\\d{5}",
						[
							10
						]
					],
					[
						"7(?:(?:781|839)\\d|911[17])\\d{5}",
						[
							10
						]
					],
					[
						"80[08]\\d{7}|800\\d{6}|8001111"
					],
					[
						"(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
						[
							7,
							10
						]
					],
					[
						"70\\d{8}",
						[
							10
						]
					],
					0,
					[
						"(?:3[0347]|55)\\d{8}",
						[
							10
						]
					],
					[
						"76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
						[
							10
						]
					],
					[
						"56\\d{8}",
						[
							10
						]
					]
				]
			],
			"GH": [
				"233",
				"00",
				"(?:[235]\\d{3}|800)\\d{5}",
				[
					8,
					9
				],
				[
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"8"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[235]"
						],
						"0$1"
					]
				],
				"0"
			],
			"GI": [
				"350",
				"00",
				"(?:[25]\\d\\d|606)\\d{5}",
				[
					8
				],
				[
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"2"
						]
					]
				]
			],
			"GL": [
				"299",
				"00",
				"(?:19|[2-689]\\d|70)\\d{4}",
				[
					6
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"19|[2-9]"
						]
					]
				]
			],
			"GM": [
				"220",
				"00",
				"[2-9]\\d{6}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[2-9]"
						]
					]
				]
			],
			"GN": [
				"224",
				"00",
				"722\\d{6}|(?:3|6\\d)\\d{7}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"3"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[67]"
						]
					]
				]
			],
			"GP": [
				"590",
				"00",
				"(?:590|(?:69|80)\\d|976)\\d{6}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[569]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8"
						],
						"0$1"
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1289]|5[3-579]|6[0-289]|7[08]|8[0-689]|9\\d)\\d{4}"
					],
					[
						"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
					],
					[
						"80[0-5]\\d{6}"
					],
					0,
					0,
					0,
					0,
					0,
					[
						"976[01]\\d{5}"
					]
				]
			],
			"GQ": [
				"240",
				"00",
				"222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[235]"
						]
					],
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"[89]"
						]
					]
				]
			],
			"GR": [
				"30",
				"00",
				"5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
				[
					10,
					11,
					12
				],
				[
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"21|7"
						]
					],
					[
						"(\\d{4})(\\d{6})",
						"$1 $2",
						[
							"2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2689]"
						]
					],
					[
						"(\\d{3})(\\d{3,4})(\\d{5})",
						"$1 $2 $3",
						[
							"8"
						]
					]
				]
			],
			"GT": [
				"502",
				"00",
				"(?:1\\d{3}|[2-7])\\d{7}",
				[
					8,
					11
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[2-7]"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					]
				]
			],
			"GU": [
				"1",
				"011",
				"(?:[58]\\d\\d|671|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([3-9]\\d{6})$",
				"671$1",
				0,
				"671"
			],
			"GW": [
				"245",
				"00",
				"[49]\\d{8}|4\\d{6}",
				[
					7,
					9
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"40"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[49]"
						]
					]
				]
			],
			"GY": [
				"592",
				"001",
				"9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[2-46-9]"
						]
					]
				]
			],
			"HK": [
				"852",
				"00(?:30|5[09]|[126-9]?)",
				"8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
				[
					5,
					6,
					7,
					8,
					9,
					11
				],
				[
					[
						"(\\d{3})(\\d{2,5})",
						"$1 $2",
						[
							"900",
							"9003"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"9"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"HN": [
				"504",
				"00",
				"8\\d{10}|[237-9]\\d{7}",
				[
					8,
					11
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1-$2",
						[
							"[237-9]"
						]
					]
				]
			],
			"HR": [
				"385",
				"00",
				"(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
				[
					6,
					7,
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"6[01]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"8"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{4})(\\d{3})",
						"$1 $2 $3",
						[
							"1"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[67]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"9"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[2-5]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8"
						],
						"0$1"
					]
				],
				"0"
			],
			"HT": [
				"509",
				"00",
				"[2-489]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[2-489]"
						]
					]
				]
			],
			"HU": [
				"36",
				"00",
				"[235-7]\\d{8}|[1-9]\\d{7}",
				[
					8,
					9
				],
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						],
						"(06 $1)"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
						],
						"(06 $1)"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[2-9]"
						],
						"06 $1"
					]
				],
				"06"
			],
			"ID": [
				"62",
				"00[89]",
				"(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
				[
					7,
					8,
					9,
					10,
					11,
					12,
					13
				],
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"15"
						]
					],
					[
						"(\\d{2})(\\d{5,9})",
						"$1 $2",
						[
							"2[124]|[36]1"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{5,7})",
						"$1 $2",
						[
							"800"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{5,8})",
						"$1 $2",
						[
							"[2-79]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3,4})(\\d{3})",
						"$1-$2-$3",
						[
							"8[1-35-9]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{6,8})",
						"$1 $2",
						[
							"1"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"804"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"80"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{4})(\\d{4,5})",
						"$1-$2-$3",
						[
							"8"
						],
						"0$1"
					]
				],
				"0"
			],
			"IE": [
				"353",
				"00",
				"(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
				[
					7,
					8,
					9,
					10
				],
				[
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"2[24-9]|47|58|6[237-9]|9[35-9]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"[45]0"
						],
						"(0$1)"
					],
					[
						"(\\d)(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						],
						"(0$1)"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[2569]|4[1-69]|7[14]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"70"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"81"
						],
						"(0$1)"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[78]"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"4"
						],
						"(0$1)"
					],
					[
						"(\\d{2})(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3 $4",
						[
							"8"
						],
						"0$1"
					]
				],
				"0"
			],
			"IL": [
				"972",
				"0(?:0|1[2-9])",
				"1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
				[
					7,
					8,
					9,
					10,
					11,
					12
				],
				[
					[
						"(\\d{4})(\\d{3})",
						"$1-$2",
						[
							"125"
						]
					],
					[
						"(\\d{4})(\\d{2})(\\d{2})",
						"$1-$2-$3",
						[
							"121"
						]
					],
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[2-489]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[57]"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1-$2-$3",
						[
							"12"
						]
					],
					[
						"(\\d{4})(\\d{6})",
						"$1-$2",
						[
							"159"
						]
					],
					[
						"(\\d)(\\d{3})(\\d{3})(\\d{3})",
						"$1-$2-$3-$4",
						[
							"1[7-9]"
						]
					],
					[
						"(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
						"$1-$2 $3-$4",
						[
							"15"
						]
					]
				],
				"0"
			],
			"IM": [
				"44",
				"00",
				"1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
				[
					10
				],
				0,
				"0",
				0,
				"0|([25-8]\\d{5})$",
				"1624$1",
				0,
				"74576|(?:16|7[56])24"
			],
			"IN": [
				"91",
				"00",
				"(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
				[
					8,
					9,
					10,
					11,
					12,
					13
				],
				[
					[
						"(\\d{8})",
						"$1",
						[
							"5(?:0|2[23]|3[03]|[67]1|88)",
							"5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
							"5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
						],
						0,
						1
					],
					[
						"(\\d{4})(\\d{4,5})",
						"$1 $2",
						[
							"180",
							"1800"
						],
						0,
						1
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"140"
						],
						0,
						1
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"11|2[02]|33|4[04]|79[1-7]|80[2-46]",
							"11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
							"11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
						],
						"0$1",
						1
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
							"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
							"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
						],
						"0$1",
						1
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
							"1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
							"1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
						],
						"0$1",
						1
					],
					[
						"(\\d{5})(\\d{5})",
						"$1 $2",
						[
							"[6-9]"
						],
						"0$1",
						1
					],
					[
						"(\\d{4})(\\d{2,4})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:6|8[06])",
							"1(?:6|8[06]0)"
						],
						0,
						1
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"18"
						],
						0,
						1
					]
				],
				"0"
			],
			"IO": [
				"246",
				"00",
				"3\\d{6}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"3"
						]
					]
				]
			],
			"IQ": [
				"964",
				"00",
				"(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
				[
					8,
					9,
					10
				],
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[2-6]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						],
						"0$1"
					]
				],
				"0"
			],
			"IR": [
				"98",
				"00",
				"[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
				[
					4,
					5,
					6,
					7,
					10
				],
				[
					[
						"(\\d{4,5})",
						"$1",
						[
							"96"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{4,5})",
						"$1 $2",
						[
							"(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"9"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[1-8]"
						],
						"0$1"
					]
				],
				"0"
			],
			"IS": [
				"354",
				"00|1(?:0(?:01|[12]0)|100)",
				"(?:38\\d|[4-9])\\d{6}",
				[
					7,
					9
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[4-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"3"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"IT": [
				"39",
				"00",
				"0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
				[
					6,
					7,
					8,
					9,
					10,
					11
				],
				[
					[
						"(\\d{2})(\\d{4,6})",
						"$1 $2",
						[
							"0[26]"
						]
					],
					[
						"(\\d{3})(\\d{3,6})",
						"$1 $2",
						[
							"0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
							"0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
						]
					],
					[
						"(\\d{4})(\\d{2,6})",
						"$1 $2",
						[
							"0(?:[13-579][2-46-8]|8[236-8])"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"894"
						]
					],
					[
						"(\\d{2})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"0[26]|5"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"1(?:44|[679])|[378]"
						]
					],
					[
						"(\\d{3})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"0[13-57-9][0159]|14"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{5})",
						"$1 $2 $3",
						[
							"0[26]"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"0"
						]
					],
					[
						"(\\d{3})(\\d{4})(\\d{4,5})",
						"$1 $2 $3",
						[
							"3"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				[
					[
						"0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
					],
					[
						"3[1-9]\\d{8}|3[2-9]\\d{7}",
						[
							9,
							10
						]
					],
					[
						"80(?:0\\d{3}|3)\\d{3}",
						[
							6,
							9
						]
					],
					[
						"(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
						[
							6,
							8,
							9,
							10
						]
					],
					[
						"1(?:78\\d|99)\\d{6}",
						[
							9,
							10
						]
					],
					0,
					0,
					0,
					[
						"55\\d{8}",
						[
							10
						]
					],
					[
						"84(?:[08]\\d{3}|[17])\\d{3}",
						[
							6,
							9
						]
					]
				]
			],
			"JE": [
				"44",
				"00",
				"1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
				[
					10
				],
				0,
				"0",
				0,
				"0|([0-24-8]\\d{5})$",
				"1534$1",
				0,
				0,
				[
					[
						"1534[0-24-8]\\d{5}"
					],
					[
						"7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
					],
					[
						"80(?:07(?:35|81)|8901)\\d{4}"
					],
					[
						"(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
					],
					[
						"701511\\d{4}"
					],
					0,
					[
						"(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
					],
					[
						"76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
					],
					[
						"56\\d{8}"
					]
				]
			],
			"JM": [
				"1",
				"011",
				"(?:[58]\\d\\d|658|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				0,
				0,
				0,
				"658|876"
			],
			"JO": [
				"962",
				"00",
				"(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
				[
					8,
					9
				],
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2356]|87"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"[89]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{7})",
						"$1 $2",
						[
							"70"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						],
						"0$1"
					]
				],
				"0"
			],
			"JP": [
				"81",
				"010",
				"00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
				[
					8,
					9,
					10,
					11,
					12,
					13,
					14,
					15,
					16,
					17
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1-$2-$3",
						[
							"(?:12|57|99)0"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d)(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])",
							"1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
							"1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"60"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1-$2-$3",
						[
							"[36]|4(?:2[09]|7[01])",
							"[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
							"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
							"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
							"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1-$2-$3",
						[
							"[14]|[289][2-9]|5[3-9]|7[2-4679]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"800"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1-$2-$3",
						[
							"[257-9]"
						],
						"0$1"
					]
				],
				"0"
			],
			"KE": [
				"254",
				"000",
				"(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
				[
					7,
					8,
					9,
					10
				],
				[
					[
						"(\\d{2})(\\d{5,7})",
						"$1 $2",
						[
							"[24-6]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"[17]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[89]"
						],
						"0$1"
					]
				],
				"0"
			],
			"KG": [
				"996",
				"00",
				"8\\d{9}|(?:[235-8]\\d|99)\\d{7}",
				[
					9,
					10
				],
				[
					[
						"(\\d{4})(\\d{5})",
						"$1 $2",
						[
							"3(?:1[346]|[24-79])"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[235-79]|88"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
						"$1 $2 $3 $4",
						[
							"8"
						],
						"0$1"
					]
				],
				"0"
			],
			"KH": [
				"855",
				"00[14-9]",
				"1\\d{9}|[1-9]\\d{7,8}",
				[
					8,
					9,
					10
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[1-9]"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1"
						]
					]
				],
				"0"
			],
			"KI": [
				"686",
				"00",
				"(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
				[
					5,
					8
				],
				0,
				"0"
			],
			"KM": [
				"269",
				"00",
				"[3478]\\d{6}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"[3478]"
						]
					]
				]
			],
			"KN": [
				"1",
				"011",
				"(?:[58]\\d\\d|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([2-7]\\d{6})$",
				"869$1",
				0,
				"869"
			],
			"KP": [
				"850",
				"00|99",
				"85\\d{6}|(?:19\\d|[2-7])\\d{7}",
				[
					8,
					10
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2-7]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						],
						"0$1"
					]
				],
				"0"
			],
			"KR": [
				"82",
				"00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
				"00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
				[
					5,
					6,
					8,
					9,
					10,
					11,
					12,
					13,
					14
				],
				[
					[
						"(\\d{2})(\\d{3,4})",
						"$1-$2",
						[
							"(?:3[1-3]|[46][1-4]|5[1-5])1"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{4})",
						"$1-$2",
						[
							"1"
						]
					],
					[
						"(\\d)(\\d{3,4})(\\d{4})",
						"$1-$2-$3",
						[
							"2"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"60|8"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3,4})(\\d{4})",
						"$1-$2-$3",
						[
							"[1346]|5[1-5]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1-$2-$3",
						[
							"[57]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{5})(\\d{4})",
						"$1-$2-$3",
						[
							"5"
						],
						"0$1"
					]
				],
				"0",
				0,
				"0(8(?:[1-46-8]|5\\d\\d))?"
			],
			"KW": [
				"965",
				"00",
				"18\\d{5}|(?:[2569]\\d|41)\\d{6}",
				[
					7,
					8
				],
				[
					[
						"(\\d{4})(\\d{3,4})",
						"$1 $2",
						[
							"[169]|2(?:[235]|4[1-35-9])|52"
						]
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"[245]"
						]
					]
				]
			],
			"KY": [
				"1",
				"011",
				"(?:345|[58]\\d\\d|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([2-9]\\d{6})$",
				"345$1",
				0,
				"345"
			],
			"KZ": [
				"7",
				"810",
				"(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
				[
					10,
					14
				],
				0,
				"8",
				0,
				0,
				0,
				0,
				"33|7",
				0,
				"8~10"
			],
			"LA": [
				"856",
				"00",
				"[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
				[
					8,
					9,
					10
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2[13]|3[14]|[4-8]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"30[013-9]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"[23]"
						],
						"0$1"
					]
				],
				"0"
			],
			"LB": [
				"961",
				"00",
				"[27-9]\\d{7}|[13-9]\\d{6}",
				[
					7,
					8
				],
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[27-9]"
						]
					]
				],
				"0"
			],
			"LC": [
				"1",
				"011",
				"(?:[58]\\d\\d|758|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([2-8]\\d{6})$",
				"758$1",
				0,
				"758"
			],
			"LI": [
				"423",
				"00",
				"[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
				[
					7,
					9
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"[2379]|8(?:0[09]|7)",
							"[2379]|8(?:0(?:02|9)|7)"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"69"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"6"
						]
					]
				],
				"0",
				0,
				"0|(1001)"
			],
			"LK": [
				"94",
				"00",
				"[1-9]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[1-689]"
						],
						"0$1"
					]
				],
				"0"
			],
			"LR": [
				"231",
				"00",
				"(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",
				[
					7,
					8,
					9
				],
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[4-6]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[3578]"
						],
						"0$1"
					]
				],
				"0"
			],
			"LS": [
				"266",
				"00",
				"(?:[256]\\d\\d|800)\\d{5}",
				[
					8
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[2568]"
						]
					]
				]
			],
			"LT": [
				"370",
				"00",
				"(?:[3469]\\d|52|[78]0)\\d{6}",
				[
					8
				],
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"52[0-7]"
						],
						"(8-$1)",
						1
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[7-9]"
						],
						"8 $1",
						1
					],
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"37|4(?:[15]|6[1-8])"
						],
						"(8-$1)",
						1
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"[3-6]"
						],
						"(8-$1)",
						1
					]
				],
				"8",
				0,
				"[08]"
			],
			"LU": [
				"352",
				"00",
				"35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
				[
					4,
					5,
					6,
					7,
					8,
					9,
					10,
					11
				],
				[
					[
						"(\\d{2})(\\d{3})",
						"$1 $2",
						[
							"2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"20[2-689]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
						"$1 $2 $3 $4",
						[
							"2(?:[0367]|4[3-8])"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"80[01]|90[015]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"20"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"6"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
						"$1 $2 $3 $4 $5",
						[
							"2(?:[0367]|4[3-8])"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
						"$1 $2 $3 $4",
						[
							"[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
						]
					]
				],
				0,
				0,
				"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
			],
			"LV": [
				"371",
				"00",
				"(?:[268]\\d|90)\\d{6}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[269]|8[01]"
						]
					]
				]
			],
			"LY": [
				"218",
				"00",
				"[2-9]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{2})(\\d{7})",
						"$1-$2",
						[
							"[2-9]"
						],
						"0$1"
					]
				],
				"0"
			],
			"MA": [
				"212",
				"00",
				"[5-8]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{5})(\\d{4})",
						"$1-$2",
						[
							"5(?:29|38)",
							"5(?:29[89]|389)",
							"5(?:29[89]|389)0"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"5[45]"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{5})",
						"$1-$2",
						[
							"5(?:2[2-489]|3[5-9]|9)|892",
							"5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{7})",
						"$1-$2",
						[
							"8"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{6})",
						"$1-$2",
						[
							"[5-7]"
						],
						"0$1"
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"5(?:29(?:[189][05]|2[29]|3[01])|389[05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[08]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
					],
					[
						"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]))\\d{6}"
					],
					[
						"80\\d{7}"
					],
					[
						"89\\d{7}"
					],
					0,
					0,
					0,
					0,
					[
						"592(?:4[0-2]|93)\\d{4}"
					]
				]
			],
			"MC": [
				"377",
				"00",
				"(?:[3489]|6\\d)\\d{7}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"4"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[389]"
						]
					],
					[
						"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						[
							"6"
						],
						"0$1"
					]
				],
				"0"
			],
			"MD": [
				"373",
				"00",
				"(?:[235-7]\\d|[89]0)\\d{6}",
				[
					8
				],
				[
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"[89]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"22|3"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[25-7]"
						],
						"0$1"
					]
				],
				"0"
			],
			"ME": [
				"382",
				"00",
				"(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[2-9]"
						],
						"0$1"
					]
				],
				"0"
			],
			"MF": [
				"590",
				"00",
				"(?:590|(?:69|80)\\d|976)\\d{6}",
				[
					9
				],
				0,
				"0",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"
					],
					[
						"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
					],
					[
						"80[0-5]\\d{6}"
					],
					0,
					0,
					0,
					0,
					0,
					[
						"976[01]\\d{5}"
					]
				]
			],
			"MG": [
				"261",
				"00",
				"[23]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[23]"
						],
						"0$1"
					]
				],
				"0",
				0,
				"0|([24-9]\\d{6})$",
				"20$1"
			],
			"MH": [
				"692",
				"011",
				"329\\d{4}|(?:[256]\\d|45)\\d{5}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[2-6]"
						]
					]
				],
				"1"
			],
			"MK": [
				"389",
				"00",
				"[2-578]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2|34[47]|4(?:[37]7|5[47]|64)"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[347]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d)(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[58]"
						],
						"0$1"
					]
				],
				"0"
			],
			"ML": [
				"223",
				"00",
				"[24-9]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[24-9]"
						]
					]
				]
			],
			"MM": [
				"95",
				"00",
				"1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
				[
					6,
					7,
					8,
					9,
					10
				],
				[
					[
						"(\\d)(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"16|2"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[12]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[4-7]|8[1-35]"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{3})(\\d{4,6})",
						"$1 $2 $3",
						[
							"9(?:2[0-4]|[35-9]|4[137-9])"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"92"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{5})(\\d{4})",
						"$1 $2 $3",
						[
							"9"
						],
						"0$1"
					]
				],
				"0"
			],
			"MN": [
				"976",
				"001",
				"[12]\\d{7,9}|[57-9]\\d{7}",
				[
					8,
					9,
					10
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[12]1"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[57-9]"
						]
					],
					[
						"(\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"[12]2[1-3]"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{5,6})",
						"$1 $2",
						[
							"[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
							"[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
						],
						"0$1"
					],
					[
						"(\\d{5})(\\d{4,5})",
						"$1 $2",
						[
							"[12]"
						],
						"0$1"
					]
				],
				"0"
			],
			"MO": [
				"853",
				"00",
				"0800\\d{3}|(?:28|[68]\\d)\\d{6}",
				[
					7,
					8
				],
				[
					[
						"(\\d{4})(\\d{3})",
						"$1 $2",
						[
							"0"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[268]"
						]
					]
				]
			],
			"MP": [
				"1",
				"011",
				"[58]\\d{9}|(?:67|90)0\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([2-9]\\d{6})$",
				"670$1",
				0,
				"670"
			],
			"MQ": [
				"596",
				"00",
				"(?:69|80)\\d{7}|(?:59|97)6\\d{6}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[569]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8"
						],
						"0$1"
					]
				],
				"0"
			],
			"MR": [
				"222",
				"00",
				"(?:[2-4]\\d\\d|800)\\d{5}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2-48]"
						]
					]
				]
			],
			"MS": [
				"1",
				"011",
				"(?:[58]\\d\\d|664|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([34]\\d{6})$",
				"664$1",
				0,
				"664"
			],
			"MT": [
				"356",
				"00",
				"3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
				[
					8
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[2357-9]"
						]
					]
				]
			],
			"MU": [
				"230",
				"0(?:0|[24-7]0|3[03])",
				"(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}",
				[
					7,
					8,
					10
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[2-46]|8[013]"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"5"
						]
					],
					[
						"(\\d{5})(\\d{5})",
						"$1 $2",
						[
							"8"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"020"
			],
			"MV": [
				"960",
				"0(?:0|19)",
				"(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
				[
					7,
					10
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[3467]|9[13-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[89]"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"MW": [
				"265",
				"00",
				"(?:[129]\\d|31|77|88)\\d{7}|1\\d{6}",
				[
					7,
					9
				],
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[2-9]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[137-9]"
						],
						"0$1"
					]
				],
				"0"
			],
			"MX": [
				"52",
				"0[09]",
				"1(?:(?:44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[017]\\d|[235][1-9]|4[0-35-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",
				[
					10,
					11
				],
				[
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"33|5[56]|81"
						],
						0,
						1
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2-9]"
						],
						0,
						1
					],
					[
						"(\\d)(\\d{2})(\\d{4})(\\d{4})",
						"$2 $3 $4",
						[
							"1(?:33|5[56]|81)"
						],
						0,
						1
					],
					[
						"(\\d)(\\d{3})(\\d{3})(\\d{4})",
						"$2 $3 $4",
						[
							"1"
						],
						0,
						1
					]
				],
				"01",
				0,
				"0(?:[12]|4[45])|1",
				0,
				0,
				0,
				0,
				"00"
			],
			"MY": [
				"60",
				"00",
				"1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
				[
					8,
					9,
					10
				],
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1-$2 $3",
						[
							"[4-79]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1-$2 $3",
						[
							"1(?:[02469]|[378][1-9]|53)|8",
							"1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1-$2 $3",
						[
							"3"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{3})(\\d{2})(\\d{4})",
						"$1-$2-$3-$4",
						[
							"1(?:[367]|80)"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1-$2 $3",
						[
							"15"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1-$2 $3",
						[
							"1"
						],
						"0$1"
					]
				],
				"0"
			],
			"MZ": [
				"258",
				"00",
				"(?:2|8\\d)\\d{7}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2|8[2-79]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8"
						]
					]
				]
			],
			"NA": [
				"264",
				"00",
				"[68]\\d{7,8}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"88"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"6"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"87"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8"
						],
						"0$1"
					]
				],
				"0"
			],
			"NC": [
				"687",
				"00",
				"(?:050|[2-57-9]\\d\\d)\\d{3}",
				[
					6
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1.$2.$3",
						[
							"[02-57-9]"
						]
					]
				]
			],
			"NE": [
				"227",
				"00",
				"[027-9]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"08"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[089]|2[013]|7[04]"
						]
					]
				]
			],
			"NF": [
				"672",
				"00",
				"[13]\\d{5}",
				[
					6
				],
				[
					[
						"(\\d{2})(\\d{4})",
						"$1 $2",
						[
							"1[0-3]"
						]
					],
					[
						"(\\d)(\\d{5})",
						"$1 $2",
						[
							"[13]"
						]
					]
				],
				0,
				0,
				"([0-258]\\d{4})$",
				"3$1"
			],
			"NG": [
				"234",
				"009",
				"(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
				[
					7,
					8,
					10,
					11,
					12,
					13,
					14
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"78"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[12]|9(?:0[3-9]|[1-9])"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{2,3})",
						"$1 $2 $3",
						[
							"[3-7]|8[2-9]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[7-9]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{4})(\\d{4,5})",
						"$1 $2 $3",
						[
							"[78]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{5})(\\d{5,6})",
						"$1 $2 $3",
						[
							"[78]"
						],
						"0$1"
					]
				],
				"0"
			],
			"NI": [
				"505",
				"00",
				"(?:1800|[25-8]\\d{3})\\d{4}",
				[
					8
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[125-8]"
						]
					]
				]
			],
			"NL": [
				"31",
				"00",
				"(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
				[
					5,
					6,
					7,
					8,
					9,
					10,
					11
				],
				[
					[
						"(\\d{3})(\\d{4,7})",
						"$1 $2",
						[
							"[89]0"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{7})",
						"$1 $2",
						[
							"66"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{8})",
						"$1 $2",
						[
							"6"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[1-578]|91"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{5})",
						"$1 $2 $3",
						[
							"9"
						],
						"0$1"
					]
				],
				"0"
			],
			"NO": [
				"47",
				"00",
				"(?:0|[2-9]\\d{3})\\d{4}",
				[
					5,
					8
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[489]|59"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[235-7]"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				"[02-689]|7[0-8]"
			],
			"NP": [
				"977",
				"00",
				"(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
				[
					8,
					10,
					11
				],
				[
					[
						"(\\d)(\\d{7})",
						"$1-$2",
						[
							"1[2-6]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{6})",
						"$1-$2",
						[
							"1[01]|[2-8]|9(?:[1-579]|6[2-6])"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{7})",
						"$1-$2",
						[
							"9"
						]
					]
				],
				"0"
			],
			"NR": [
				"674",
				"00",
				"(?:444|(?:55|8\\d)\\d|666)\\d{4}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[4-68]"
						]
					]
				]
			],
			"NU": [
				"683",
				"00",
				"(?:[47]|888\\d)\\d{3}",
				[
					4,
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"8"
						]
					]
				]
			],
			"NZ": [
				"64",
				"0(?:0|161)",
				"[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",
				[
					5,
					6,
					7,
					8,
					9,
					10
				],
				[
					[
						"(\\d{2})(\\d{3,8})",
						"$1 $2",
						[
							"8[1-579]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"50[036-8]|[89]0",
							"50(?:[0367]|88)|[89]0"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"24|[346]|7[2-57-9]|9[2-9]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2(?:10|74)|[59]|80"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"1|2[028]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,5})",
						"$1 $2 $3",
						[
							"2(?:[169]|7[0-35-9])|7|86"
						],
						"0$1"
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"OM": [
				"968",
				"00",
				"(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
				[
					7,
					8,
					9
				],
				[
					[
						"(\\d{3})(\\d{4,6})",
						"$1 $2",
						[
							"[58]"
						]
					],
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"2"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[179]"
						]
					]
				]
			],
			"PA": [
				"507",
				"00",
				"(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
				[
					7,
					8,
					10,
					11
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[1-57-9]"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1-$2",
						[
							"[68]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8"
						]
					]
				]
			],
			"PE": [
				"51",
				"19(?:1[124]|77|90)00",
				"(?:[14-8]|9\\d)\\d{7}",
				[
					8,
					9
				],
				[
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"80"
						],
						"(0$1)"
					],
					[
						"(\\d)(\\d{7})",
						"$1 $2",
						[
							"1"
						],
						"(0$1)"
					],
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"[4-8]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"9"
						]
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				" Anexo "
			],
			"PF": [
				"689",
				"00",
				"4\\d{5}(?:\\d{2})?|8\\d{7,8}",
				[
					6,
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"44"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"4|8[7-9]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8"
						]
					]
				]
			],
			"PG": [
				"675",
				"00|140[1-3]",
				"(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
				[
					7,
					8
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"18|[2-69]|85"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[78]"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"PH": [
				"63",
				"00",
				"(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
				[
					6,
					8,
					9,
					10,
					11,
					12,
					13
				],
				[
					[
						"(\\d)(\\d{5})",
						"$1 $2",
						[
							"2"
						],
						"(0$1)"
					],
					[
						"(\\d{4})(\\d{4,6})",
						"$1 $2",
						[
							"3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
							"3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
						],
						"(0$1)"
					],
					[
						"(\\d{5})(\\d{4})",
						"$1 $2",
						[
							"346|4(?:27|9[35])|883",
							"3469|4(?:279|9(?:30|56))|8834"
						],
						"(0$1)"
					],
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2"
						],
						"(0$1)"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[3-7]|8[2-8]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[89]"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
						"$1 $2 $3 $4",
						[
							"1"
						]
					]
				],
				"0"
			],
			"PK": [
				"92",
				"00",
				"122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
				[
					8,
					9,
					10,
					11,
					12
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{2,7})",
						"$1 $2 $3",
						[
							"[89]0"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{5})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(\\d{3})(\\d{6,7})",
						"$1 $2",
						[
							"2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
							"9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
						],
						"(0$1)"
					],
					[
						"(\\d{2})(\\d{7,8})",
						"$1 $2",
						[
							"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
						],
						"(0$1)"
					],
					[
						"(\\d{5})(\\d{5})",
						"$1 $2",
						[
							"58"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{7})",
						"$1 $2",
						[
							"3"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"[24-9]"
						],
						"(0$1)"
					]
				],
				"0"
			],
			"PL": [
				"48",
				"00",
				"6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",
				[
					6,
					7,
					8,
					9,
					10
				],
				[
					[
						"(\\d{5})",
						"$1",
						[
							"19"
						]
					],
					[
						"(\\d{3})(\\d{3})",
						"$1 $2",
						[
							"11|64"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
							"(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"64"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"1[2-8]|[2-7]|8[1-79]|9[145]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"8"
						]
					]
				]
			],
			"PM": [
				"508",
				"00",
				"(?:[45]|80\\d\\d)\\d{5}",
				[
					6,
					9
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"[45]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8"
						],
						"0$1"
					]
				],
				"0"
			],
			"PR": [
				"1",
				"011",
				"(?:[589]\\d\\d|787)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				0,
				0,
				0,
				"787|939"
			],
			"PS": [
				"970",
				"00",
				"[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
				[
					8,
					9,
					10
				],
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2489]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"5"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1"
						]
					]
				],
				"0"
			],
			"PT": [
				"351",
				"00",
				"1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
				[
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2[12]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"16|[236-9]"
						]
					]
				]
			],
			"PW": [
				"680",
				"01[12]",
				"(?:[24-8]\\d\\d|345|900)\\d{4}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[2-9]"
						]
					]
				]
			],
			"PY": [
				"595",
				"00",
				"59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
				[
					6,
					7,
					8,
					9,
					10,
					11
				],
				[
					[
						"(\\d{3})(\\d{3,6})",
						"$1 $2",
						[
							"[2-9]0"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{4,5})",
						"$1 $2",
						[
							"2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
						],
						"(0$1)"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
						],
						"(0$1)"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"87"
						]
					],
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"9(?:[5-79]|8[1-6])"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2-8]"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"9"
						]
					]
				],
				"0"
			],
			"QA": [
				"974",
				"00",
				"[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}",
				[
					7,
					8,
					9
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"2[126]|8"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[2-7]"
						]
					]
				]
			],
			"RE": [
				"262",
				"00",
				"976\\d{6}|(?:26|[68]\\d)\\d{7}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2689]"
						],
						"0$1"
					]
				],
				"0",
				0,
				0,
				0,
				0,
				"26[23]|69|[89]"
			],
			"RO": [
				"40",
				"00",
				"(?:[2378]\\d|90)\\d{7}|[23]\\d{5}",
				[
					6,
					9
				],
				[
					[
						"(\\d{3})(\\d{3})",
						"$1 $2",
						[
							"2[3-6]",
							"2[3-6]\\d9"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{4})",
						"$1 $2",
						[
							"219|31"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[23]1"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[237-9]"
						],
						"0$1"
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				" int "
			],
			"RS": [
				"381",
				"00",
				"38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
				[
					6,
					7,
					8,
					9,
					10,
					11,
					12
				],
				[
					[
						"(\\d{3})(\\d{3,9})",
						"$1 $2",
						[
							"(?:2[389]|39)0|[7-9]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{5,10})",
						"$1 $2",
						[
							"[1-36]"
						],
						"0$1"
					]
				],
				"0"
			],
			"RU": [
				"7",
				"810",
				"8\\d{13}|[347-9]\\d{9}",
				[
					10,
					14
				],
				[
					[
						"(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"7(?:1[0-8]|2[1-9])",
							"7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))",
							"7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
						],
						"8 ($1)",
						1
					],
					[
						"(\\d{5})(\\d)(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"7(?:1[0-68]|2[1-9])",
							"7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
							"7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
						],
						"8 ($1)",
						1
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						],
						"8 ($1)",
						1
					],
					[
						"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"[349]|8(?:[02-7]|1[1-8])"
						],
						"8 ($1)",
						1
					],
					[
						"(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"8"
						],
						"8 ($1)"
					]
				],
				"8",
				0,
				0,
				0,
				0,
				"3[04-689]|[489]",
				0,
				"8~10"
			],
			"RW": [
				"250",
				"00",
				"(?:06|[27]\\d\\d|[89]00)\\d{6}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"0"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[7-9]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2"
						]
					]
				],
				"0"
			],
			"SA": [
				"966",
				"00",
				"92\\d{7}|(?:[15]|8\\d)\\d{8}",
				[
					9,
					10
				],
				[
					[
						"(\\d{4})(\\d{5})",
						"$1 $2",
						[
							"9"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"5"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"81"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8"
						]
					]
				],
				"0"
			],
			"SB": [
				"677",
				"0[01]",
				"(?:[1-6]|[7-9]\\d\\d)\\d{4}",
				[
					5,
					7
				],
				[
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"7|8[4-9]|9(?:[1-8]|9[0-8])"
						]
					]
				]
			],
			"SC": [
				"248",
				"010|0[0-2]",
				"800\\d{4}|(?:[249]\\d|64)\\d{5}",
				[
					7
				],
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[246]|9[57]"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"SD": [
				"249",
				"00",
				"[19]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[19]"
						],
						"0$1"
					]
				],
				"0"
			],
			"SE": [
				"46",
				"00",
				"(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
				[
					6,
					7,
					8,
					9,
					10
				],
				[
					[
						"(\\d{2})(\\d{2,3})(\\d{2})",
						"$1-$2 $3",
						[
							"20"
						],
						"0$1",
						0,
						"$1 $2 $3"
					],
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"9(?:00|39|44|9)"
						],
						"0$1",
						0,
						"$1 $2"
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})",
						"$1-$2 $3",
						[
							"[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
						],
						"0$1",
						0,
						"$1 $2 $3"
					],
					[
						"(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"8"
						],
						"0$1",
						0,
						"$1 $2 $3 $4"
					],
					[
						"(\\d{3})(\\d{2,3})(\\d{2})",
						"$1-$2 $3",
						[
							"1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
						],
						"0$1",
						0,
						"$1 $2 $3"
					],
					[
						"(\\d{3})(\\d{2,3})(\\d{3})",
						"$1-$2 $3",
						[
							"9(?:00|39|44)"
						],
						"0$1",
						0,
						"$1 $2 $3"
					],
					[
						"(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
						],
						"0$1",
						0,
						"$1 $2 $3 $4"
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"10|7"
						],
						"0$1",
						0,
						"$1 $2 $3 $4"
					],
					[
						"(\\d)(\\d{3})(\\d{3})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"8"
						],
						"0$1",
						0,
						"$1 $2 $3 $4"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
						],
						"0$1",
						0,
						"$1 $2 $3 $4"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
						"$1-$2 $3 $4",
						[
							"9"
						],
						"0$1",
						0,
						"$1 $2 $3 $4"
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4 $5",
						[
							"[26]"
						],
						"0$1",
						0,
						"$1 $2 $3 $4 $5"
					]
				],
				"0"
			],
			"SG": [
				"65",
				"0[0-3]\\d",
				"(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
				[
					8,
					10,
					11
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[369]|8(?:0[1-5]|[1-9])"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8"
						]
					],
					[
						"(\\d{4})(\\d{4})(\\d{3})",
						"$1 $2 $3",
						[
							"7"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					]
				]
			],
			"SH": [
				"290",
				"00",
				"(?:[256]\\d|8)\\d{3}",
				[
					4,
					5
				],
				0,
				0,
				0,
				0,
				0,
				0,
				"[256]"
			],
			"SI": [
				"386",
				"00|10(?:22|66|88|99)",
				"[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
				[
					5,
					6,
					7,
					8
				],
				[
					[
						"(\\d{2})(\\d{3,6})",
						"$1 $2",
						[
							"8[09]|9"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"59|8"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[37][01]|4[0139]|51|6"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[1-57]"
						],
						"(0$1)"
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"SJ": [
				"47",
				"00",
				"0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",
				[
					5,
					8
				],
				0,
				0,
				0,
				0,
				0,
				0,
				"79"
			],
			"SK": [
				"421",
				"00",
				"[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
				[
					6,
					7,
					9
				],
				[
					[
						"(\\d)(\\d{2})(\\d{3,4})",
						"$1 $2 $3",
						[
							"21"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"[3-5][1-8]1",
							"[3-5][1-8]1[67]"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{3})(\\d{3})(\\d{2})",
						"$1/$2 $3 $4",
						[
							"2"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[689]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1/$2 $3 $4",
						[
							"[3-5]"
						],
						"0$1"
					]
				],
				"0"
			],
			"SL": [
				"232",
				"00",
				"(?:[237-9]\\d|66)\\d{6}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"[236-9]"
						],
						"(0$1)"
					]
				],
				"0"
			],
			"SM": [
				"378",
				"00",
				"(?:0549|[5-7]\\d)\\d{6}",
				[
					8,
					10
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[5-7]"
						]
					],
					[
						"(\\d{4})(\\d{6})",
						"$1 $2",
						[
							"0"
						]
					]
				],
				0,
				0,
				"([89]\\d{5})$",
				"0549$1"
			],
			"SN": [
				"221",
				"00",
				"(?:[378]\\d|93)\\d{7}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[379]"
						]
					]
				]
			],
			"SO": [
				"252",
				"00",
				"[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
				[
					6,
					7,
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{4})",
						"$1 $2",
						[
							"8[125]"
						]
					],
					[
						"(\\d{6})",
						"$1",
						[
							"[134]"
						]
					],
					[
						"(\\d)(\\d{6})",
						"$1 $2",
						[
							"[15]|2[0-79]|3[0-46-8]|4[0-7]"
						]
					],
					[
						"(\\d)(\\d{7})",
						"$1 $2",
						[
							"24|[67]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[3478]|64|90"
						]
					],
					[
						"(\\d{2})(\\d{5,7})",
						"$1 $2",
						[
							"1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"
						]
					]
				],
				"0"
			],
			"SR": [
				"597",
				"00",
				"(?:[2-5]|68|[78]\\d)\\d{5}",
				[
					6,
					7
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1-$2-$3",
						[
							"56"
						]
					],
					[
						"(\\d{3})(\\d{3})",
						"$1-$2",
						[
							"[2-5]"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[6-8]"
						]
					]
				]
			],
			"SS": [
				"211",
				"00",
				"[19]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[19]"
						],
						"0$1"
					]
				],
				"0"
			],
			"ST": [
				"239",
				"00",
				"(?:22|9\\d)\\d{5}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[29]"
						]
					]
				]
			],
			"SV": [
				"503",
				"00",
				"[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
				[
					7,
					8,
					11
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[89]"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[267]"
						]
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[89]"
						]
					]
				]
			],
			"SX": [
				"1",
				"011",
				"7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|(5\\d{6})$",
				"721$1",
				0,
				"721"
			],
			"SY": [
				"963",
				"00",
				"[1-39]\\d{8}|[1-5]\\d{7}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[1-5]"
						],
						"0$1",
						1
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"9"
						],
						"0$1",
						1
					]
				],
				"0"
			],
			"SZ": [
				"268",
				"00",
				"0800\\d{4}|(?:[237]\\d|900)\\d{6}",
				[
					8,
					9
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[0237]"
						]
					],
					[
						"(\\d{5})(\\d{4})",
						"$1 $2",
						[
							"9"
						]
					]
				]
			],
			"TA": [
				"290",
				"00",
				"8\\d{3}",
				[
					4
				],
				0,
				0,
				0,
				0,
				0,
				0,
				"8"
			],
			"TC": [
				"1",
				"011",
				"(?:[58]\\d\\d|649|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([2-479]\\d{6})$",
				"649$1",
				0,
				"649"
			],
			"TD": [
				"235",
				"00|16",
				"(?:22|[69]\\d|77)\\d{6}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2679]"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"TG": [
				"228",
				"00",
				"[279]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[279]"
						]
					]
				]
			],
			"TH": [
				"66",
				"00[1-9]",
				"(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
				[
					8,
					9,
					10,
					13
				],
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[13-9]"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1"
						]
					]
				],
				"0"
			],
			"TJ": [
				"992",
				"810",
				"(?:00|[1-57-9]\\d)\\d{7}",
				[
					9
				],
				[
					[
						"(\\d{6})(\\d)(\\d{2})",
						"$1 $2 $3",
						[
							"331",
							"3317"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[34]7|91[78]"
						]
					],
					[
						"(\\d{4})(\\d)(\\d{4})",
						"$1 $2 $3",
						[
							"3[1-5]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[0-57-9]"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"8~10"
			],
			"TK": [
				"690",
				"00",
				"[2-47]\\d{3,6}",
				[
					4,
					5,
					6,
					7
				]
			],
			"TL": [
				"670",
				"00",
				"7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
				[
					7,
					8
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[2-489]|70"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"7"
						]
					]
				]
			],
			"TM": [
				"993",
				"810",
				"[1-6]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"12"
						],
						"(8 $1)"
					],
					[
						"(\\d{3})(\\d)(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"[1-5]"
						],
						"(8 $1)"
					],
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"6"
						],
						"8 $1"
					]
				],
				"8",
				0,
				0,
				0,
				0,
				0,
				0,
				"8~10"
			],
			"TN": [
				"216",
				"00",
				"[2-57-9]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2-57-9]"
						]
					]
				]
			],
			"TO": [
				"676",
				"00",
				"(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
				[
					5,
					7
				],
				[
					[
						"(\\d{2})(\\d{3})",
						"$1-$2",
						[
							"[2-4]|50|6[09]|7[0-24-69]|8[05]"
						]
					],
					[
						"(\\d{4})(\\d{3})",
						"$1 $2",
						[
							"0"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[5-9]"
						]
					]
				]
			],
			"TR": [
				"90",
				"00",
				"4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
				[
					7,
					10,
					12,
					13
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"512|8[01589]|90"
						],
						"0$1",
						1
					],
					[
						"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"5(?:[0-59]|61)",
							"5(?:[0-59]|616)",
							"5(?:[0-59]|6161)"
						],
						"0$1",
						1
					],
					[
						"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[24][1-8]|3[1-9]"
						],
						"(0$1)",
						1
					],
					[
						"(\\d{3})(\\d{3})(\\d{6,7})",
						"$1 $2 $3",
						[
							"80"
						],
						"0$1",
						1
					]
				],
				"0"
			],
			"TT": [
				"1",
				"011",
				"(?:[58]\\d\\d|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([2-46-8]\\d{6})$",
				"868$1",
				0,
				"868"
			],
			"TV": [
				"688",
				"00",
				"(?:2|7\\d\\d|90)\\d{4}",
				[
					5,
					6,
					7
				],
				[
					[
						"(\\d{2})(\\d{3})",
						"$1 $2",
						[
							"2"
						]
					],
					[
						"(\\d{2})(\\d{4})",
						"$1 $2",
						[
							"90"
						]
					],
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"7"
						]
					]
				]
			],
			"TW": [
				"886",
				"0(?:0[25-79]|19)",
				"[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
				[
					7,
					8,
					9,
					10,
					11
				],
				[
					[
						"(\\d{2})(\\d)(\\d{4})",
						"$1 $2 $3",
						[
							"202"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[258]0"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
							"[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[49]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{4})(\\d{4,5})",
						"$1 $2 $3",
						[
							"7"
						],
						"0$1"
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"#"
			],
			"TZ": [
				"255",
				"00[056]",
				"(?:[26-8]\\d|41|90)\\d{7}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[89]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[24]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[67]"
						],
						"0$1"
					]
				],
				"0"
			],
			"UA": [
				"380",
				"00",
				"[89]\\d{9}|[3-9]\\d{8}",
				[
					9,
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
							"6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{5})",
						"$1 $2",
						[
							"3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
							"3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[3-7]|89|9[1-9]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[89]"
						],
						"0$1"
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				0,
				"0~0"
			],
			"UG": [
				"256",
				"00[057]",
				"800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
				[
					9
				],
				[
					[
						"(\\d{4})(\\d{5})",
						"$1 $2",
						[
							"202",
							"2024"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"[27-9]|4(?:6[45]|[7-9])"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{7})",
						"$1 $2",
						[
							"[34]"
						],
						"0$1"
					]
				],
				"0"
			],
			"US": [
				"1",
				"011",
				"[2-9]\\d{9}|3\\d{6}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"310"
						],
						0,
						1
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						[
							"[2-9]"
						],
						0,
						1,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-3]|[268]2)|3(?:0[02]|22|33)|4(?:00|4[24]|65|82)|5(?:00|29|58|83)|6(?:00|66|82)|7(?:58|77)|8(?:00|42|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0157-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
					],
					[
						""
					],
					[
						"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
					],
					[
						"900[2-9]\\d{6}"
					],
					[
						"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}"
					]
				]
			],
			"UY": [
				"598",
				"0(?:0|1[3-9]\\d)",
				"4\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
				[
					7,
					8,
					10
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"405|8|90"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"9"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[124]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"4"
						],
						"0$1"
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				0,
				"00",
				" int. "
			],
			"UZ": [
				"998",
				"810",
				"(?:33|55|[679]\\d|88)\\d{7}",
				[
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[35-9]"
						],
						"8 $1"
					]
				],
				"8",
				0,
				0,
				0,
				0,
				0,
				0,
				"8~10"
			],
			"VA": [
				"39",
				"00",
				"0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
				[
					6,
					7,
					8,
					9,
					10,
					11
				],
				0,
				0,
				0,
				0,
				0,
				0,
				"06698"
			],
			"VC": [
				"1",
				"011",
				"(?:[58]\\d\\d|784|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([2-7]\\d{6})$",
				"784$1",
				0,
				"784"
			],
			"VE": [
				"58",
				"00",
				"[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{7})",
						"$1-$2",
						[
							"[24-689]"
						],
						"0$1"
					]
				],
				"0"
			],
			"VG": [
				"1",
				"011",
				"(?:284|[58]\\d\\d|900)\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([2-578]\\d{6})$",
				"284$1",
				0,
				"284"
			],
			"VI": [
				"1",
				"011",
				"[58]\\d{9}|(?:34|90)0\\d{7}",
				[
					10
				],
				0,
				"1",
				0,
				"1|([2-9]\\d{6})$",
				"340$1",
				0,
				"340"
			],
			"VN": [
				"84",
				"00",
				"[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
				[
					7,
					8,
					9,
					10
				],
				[
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"80"
						],
						"0$1",
						1
					],
					[
						"(\\d{4})(\\d{4,6})",
						"$1 $2",
						[
							"1"
						],
						0,
						1
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[69]"
						],
						"0$1",
						1
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[3578]"
						],
						"0$1",
						1
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2[48]"
						],
						"0$1",
						1
					],
					[
						"(\\d{3})(\\d{4})(\\d{3})",
						"$1 $2 $3",
						[
							"2"
						],
						"0$1",
						1
					]
				],
				"0"
			],
			"VU": [
				"678",
				"00",
				"[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
				[
					5,
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[57-9]"
						]
					]
				]
			],
			"WF": [
				"681",
				"00",
				"(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
				[
					6,
					9
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"[478]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8"
						]
					]
				]
			],
			"WS": [
				"685",
				"0",
				"(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
				[
					5,
					6,
					7,
					10
				],
				[
					[
						"(\\d{5})",
						"$1",
						[
							"[2-5]|6[1-9]"
						]
					],
					[
						"(\\d{3})(\\d{3,7})",
						"$1 $2",
						[
							"[68]"
						]
					],
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"7"
						]
					]
				]
			],
			"XK": [
				"383",
				"00",
				"[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
				[
					8,
					9
				],
				[
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"[89]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2-4]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[23]"
						],
						"0$1"
					]
				],
				"0"
			],
			"YE": [
				"967",
				"00",
				"(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
				[
					7,
					8,
					9
				],
				[
					[
						"(\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[1-6]|7[24-68]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"7"
						],
						"0$1"
					]
				],
				"0"
			],
			"YT": [
				"262",
				"00",
				"80\\d{7}|(?:26|63)9\\d{6}",
				[
					9
				],
				0,
				"0",
				0,
				0,
				0,
				0,
				"269|63"
			],
			"ZA": [
				"27",
				"00",
				"[1-79]\\d{8}|8\\d{4,9}",
				[
					5,
					6,
					7,
					8,
					9,
					10
				],
				[
					[
						"(\\d{2})(\\d{3,4})",
						"$1 $2",
						[
							"8[1-4]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{2,3})",
						"$1 $2 $3",
						[
							"8[1-4]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"860"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[1-9]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8"
						],
						"0$1"
					]
				],
				"0"
			],
			"ZM": [
				"260",
				"00",
				"800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[28]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{7})",
						"$1 $2",
						[
							"[79]"
						],
						"0$1"
					]
				],
				"0"
			],
			"ZW": [
				"263",
				"00",
				"2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
				[
					5,
					6,
					7,
					8,
					9,
					10
				],
				[
					[
						"(\\d{3})(\\d{3,5})",
						"$1 $2",
						[
							"2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
						],
						"0$1"
					],
					[
						"(\\d)(\\d{3})(\\d{2,4})",
						"$1 $2 $3",
						[
							"[49]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"80"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{7})",
						"$1 $2",
						[
							"24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
							"2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
						],
						"(0$1)"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
							"2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{6})",
						"$1 $2",
						[
							"8"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3,5})",
						"$1 $2",
						[
							"1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"29[013-9]|39|54"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{3,5})",
						"$1 $2",
						[
							"(?:25|54)8",
							"258|5483"
						],
						"0$1"
					]
				],
				"0"
			]
		},
		"nonGeographic": {
			"800": [
				"800",
				0,
				"(?:00|[1-9]\\d)\\d{6}",
				[
					8
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"\\d"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				[
					0,
					0,
					[
						"(?:00|[1-9]\\d)\\d{6}"
					]
				]
			],
			"808": [
				"808",
				0,
				"[1-9]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[1-9]"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				[
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					[
						"[1-9]\\d{7}"
					]
				]
			],
			"870": [
				"870",
				0,
				"7\\d{11}|[35-7]\\d{8}",
				[
					9,
					12
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[35-7]"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				[
					0,
					[
						"(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
					]
				]
			],
			"878": [
				"878",
				0,
				"10\\d{10}",
				[
					12
				],
				[
					[
						"(\\d{2})(\\d{5})(\\d{5})",
						"$1 $2 $3",
						[
							"1"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				[
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					[
						"10\\d{10}"
					]
				]
			],
			"881": [
				"881",
				0,
				"[0-36-9]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d)(\\d{3})(\\d{5})",
						"$1 $2 $3",
						[
							"[0-36-9]"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				[
					0,
					[
						"[0-36-9]\\d{8}"
					]
				]
			],
			"882": [
				"882",
				0,
				"[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}",
				[
					7,
					8,
					9,
					10,
					11,
					12
				],
				[
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"16|342"
						]
					],
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"4"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[19]"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{3})",
						"$1 $2 $3",
						[
							"3[23]"
						]
					],
					[
						"(\\d{2})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"34[57]"
						]
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"34"
						]
					],
					[
						"(\\d{2})(\\d{4,5})(\\d{5})",
						"$1 $2 $3",
						[
							"[1-3]"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				[
					0,
					[
						"342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}",
						[
							7,
							8,
							9,
							10,
							12
						]
					],
					0,
					0,
					0,
					0,
					0,
					0,
					[
						"1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"
					]
				]
			],
			"883": [
				"883",
				0,
				"(?:210|370\\d\\d)\\d{7}|51\\d{7}(?:\\d{3})?",
				[
					9,
					10,
					12
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"510"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"(\\d{4})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"51[13]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"[35]"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				[
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					[
						"(?:210|(?:370[1-9]|51[013]0)\\d)\\d{7}|5100\\d{5}"
					]
				]
			],
			"888": [
				"888",
				0,
				"\\d{11}",
				[
					11
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{5})",
						"$1 $2 $3"
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				[
					0,
					0,
					0,
					0,
					0,
					0,
					[
						"\\d{11}"
					]
				]
			],
			"979": [
				"979",
				0,
				"[1359]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[1359]"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				[
					0,
					0,
					0,
					[
						"[1359]\\d{8}"
					]
				]
			]
		}
	};

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
	;(function () {
	  // Detect the `define` function exposed by asynchronous module loaders. The
	  // strict `define` check is necessary for compatibility with `r.js`.
	  var isLoader = "function" === "function" && __webpack_require__(816);
	
	  // A set of types used to distinguish objects from primitives.
	  var objectTypes = {
	    "function": true,
	    "object": true
	  };
	
	  // Detect the `exports` object exposed by CommonJS implementations.
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  // Use the `global` object exposed by Node (including Browserify via
	  // `insert-module-globals`), Narwhal, and Ringo as the default context,
	  // and the `window` object in browsers. Rhino exports a `global` function
	  // instead.
	  var root = objectTypes[typeof window] && window || this,
	      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;
	
	  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  // Public: Initializes JSON 3 using the given `context` object, attaching the
	  // `stringify` and `parse` functions to the specified `exports` object.
	  function runInContext(context, exports) {
	    context || (context = root["Object"]());
	    exports || (exports = root["Object"]());
	
	    // Native constructor aliases.
	    var Number = context["Number"] || root["Number"],
	        String = context["String"] || root["String"],
	        Object = context["Object"] || root["Object"],
	        Date = context["Date"] || root["Date"],
	        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
	        TypeError = context["TypeError"] || root["TypeError"],
	        Math = context["Math"] || root["Math"],
	        nativeJSON = context["JSON"] || root["JSON"];
	
	    // Delegate to the native `stringify` and `parse` implementations.
	    if (typeof nativeJSON == "object" && nativeJSON) {
	      exports.stringify = nativeJSON.stringify;
	      exports.parse = nativeJSON.parse;
	    }
	
	    // Convenience aliases.
	    var objectProto = Object.prototype,
	        getClass = objectProto.toString,
	        isProperty, forEach, undef;
	
	    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
	    var isExtended = new Date(-3509827334573292);
	    try {
	      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
	      // results for certain dates in Opera >= 10.53.
	      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
	        // Safari < 2.0.2 stores the internal millisecond time value correctly,
	        // but clips the values returned by the date methods to the range of
	        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
	        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
	    } catch (exception) {}
	
	    // Internal: Determines whether the native `JSON.stringify` and `parse`
	    // implementations are spec-compliant. Based on work by Ken Snyder.
	    function has(name) {
	      if (has[name] !== undef) {
	        // Return cached feature test result.
	        return has[name];
	      }
	      var isSupported;
	      if (name == "bug-string-char-index") {
	        // IE <= 7 doesn't support accessing string characters using square
	        // bracket notation. IE 8 only supports this for primitives.
	        isSupported = "a"[0] != "a";
	      } else if (name == "json") {
	        // Indicates whether both `JSON.stringify` and `JSON.parse` are
	        // supported.
	        isSupported = has("json-stringify") && has("json-parse");
	      } else {
	        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
	        // Test `JSON.stringify`.
	        if (name == "json-stringify") {
	          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
	          if (stringifySupported) {
	            // A test function object with a custom `toJSON` method.
	            (value = function () {
	              return 1;
	            }).toJSON = value;
	            try {
	              stringifySupported =
	                // Firefox 3.1b1 and b2 serialize string, number, and boolean
	                // primitives as object literals.
	                stringify(0) === "0" &&
	                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
	                // literals.
	                stringify(new Number()) === "0" &&
	                stringify(new String()) == '""' &&
	                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
	                // does not define a canonical JSON representation (this applies to
	                // objects with `toJSON` properties as well, *unless* they are nested
	                // within an object or array).
	                stringify(getClass) === undef &&
	                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
	                // FF 3.1b3 pass this test.
	                stringify(undef) === undef &&
	                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
	                // respectively, if the value is omitted entirely.
	                stringify() === undef &&
	                // FF 3.1b1, 2 throw an error if the given value is not a number,
	                // string, array, object, Boolean, or `null` literal. This applies to
	                // objects with custom `toJSON` methods as well, unless they are nested
	                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
	                // methods entirely.
	                stringify(value) === "1" &&
	                stringify([value]) == "[1]" &&
	                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
	                // `"[null]"`.
	                stringify([undef]) == "[null]" &&
	                // YUI 3.0.0b1 fails to serialize `null` literals.
	                stringify(null) == "null" &&
	                // FF 3.1b1, 2 halts serialization if an array contains a function:
	                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
	                // elides non-JSON values from objects and arrays, unless they
	                // define custom `toJSON` methods.
	                stringify([undef, getClass, null]) == "[null,null,null]" &&
	                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
	                // where character escape codes are expected (e.g., `\b` => `\u0008`).
	                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
	                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
	                stringify(null, value) === "1" &&
	                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
	                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
	                // serialize extended years.
	                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
	                // The milliseconds are optional in ES 5, but required in 5.1.
	                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
	                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
	                // four-digit years instead of six-digit years. Credits: @Yaffle.
	                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
	                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
	                // values less than 1000. Credits: @Yaffle.
	                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
	            } catch (exception) {
	              stringifySupported = false;
	            }
	          }
	          isSupported = stringifySupported;
	        }
	        // Test `JSON.parse`.
	        if (name == "json-parse") {
	          var parse = exports.parse;
	          if (typeof parse == "function") {
	            try {
	              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
	              // Conforming implementations should also coerce the initial argument to
	              // a string prior to parsing.
	              if (parse("0") === 0 && !parse(false)) {
	                // Simple parsing test.
	                value = parse(serialized);
	                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
	                if (parseSupported) {
	                  try {
	                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
	                    parseSupported = !parse('"\t"');
	                  } catch (exception) {}
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
	                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
	                      // certain octal literals.
	                      parseSupported = parse("01") !== 1;
	                    } catch (exception) {}
	                  }
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
	                      // points. These environments, along with FF 3.1b1 and 2,
	                      // also allow trailing commas in JSON objects and arrays.
	                      parseSupported = parse("1.") !== 1;
	                    } catch (exception) {}
	                  }
	                }
	              }
	            } catch (exception) {
	              parseSupported = false;
	            }
	          }
	          isSupported = parseSupported;
	        }
	      }
	      return has[name] = !!isSupported;
	    }
	
	    if (!has("json")) {
	      // Common `[[Class]]` name aliases.
	      var functionClass = "[object Function]",
	          dateClass = "[object Date]",
	          numberClass = "[object Number]",
	          stringClass = "[object String]",
	          arrayClass = "[object Array]",
	          booleanClass = "[object Boolean]";
	
	      // Detect incomplete support for accessing string characters by index.
	      var charIndexBuggy = has("bug-string-char-index");
	
	      // Define additional utility methods if the `Date` methods are buggy.
	      if (!isExtended) {
	        var floor = Math.floor;
	        // A mapping between the months of the year and the number of days between
	        // January 1st and the first of the respective month.
	        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
	        // Internal: Calculates the number of days between the Unix epoch and the
	        // first day of the given month.
	        var getDay = function (year, month) {
	          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
	        };
	      }
	
	      // Internal: Determines if a property is a direct property of the given
	      // object. Delegates to the native `Object#hasOwnProperty` method.
	      if (!(isProperty = objectProto.hasOwnProperty)) {
	        isProperty = function (property) {
	          var members = {}, constructor;
	          if ((members.__proto__ = null, members.__proto__ = {
	            // The *proto* property cannot be set multiple times in recent
	            // versions of Firefox and SeaMonkey.
	            "toString": 1
	          }, members).toString != getClass) {
	            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
	            // supports the mutable *proto* property.
	            isProperty = function (property) {
	              // Capture and break the object's prototype chain (see section 8.6.2
	              // of the ES 5.1 spec). The parenthesized expression prevents an
	              // unsafe transformation by the Closure Compiler.
	              var original = this.__proto__, result = property in (this.__proto__ = null, this);
	              // Restore the original prototype chain.
	              this.__proto__ = original;
	              return result;
	            };
	          } else {
	            // Capture a reference to the top-level `Object` constructor.
	            constructor = members.constructor;
	            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
	            // other environments.
	            isProperty = function (property) {
	              var parent = (this.constructor || constructor).prototype;
	              return property in this && !(property in parent && this[property] === parent[property]);
	            };
	          }
	          members = null;
	          return isProperty.call(this, property);
	        };
	      }
	
	      // Internal: Normalizes the `for...in` iteration algorithm across
	      // environments. Each enumerated key is yielded to a `callback` function.
	      forEach = function (object, callback) {
	        var size = 0, Properties, members, property;
	
	        // Tests for bugs in the current environment's `for...in` algorithm. The
	        // `valueOf` property inherits the non-enumerable flag from
	        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
	        (Properties = function () {
	          this.valueOf = 0;
	        }).prototype.valueOf = 0;
	
	        // Iterate over a new instance of the `Properties` class.
	        members = new Properties();
	        for (property in members) {
	          // Ignore all properties inherited from `Object.prototype`.
	          if (isProperty.call(members, property)) {
	            size++;
	          }
	        }
	        Properties = members = null;
	
	        // Normalize the iteration algorithm.
	        if (!size) {
	          // A list of non-enumerable properties inherited from `Object.prototype`.
	          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
	          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
	          // properties.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, length;
	            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
	            for (property in object) {
	              // Gecko <= 1.0 enumerates the `prototype` property of functions under
	              // certain conditions; IE does not.
	              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for each non-enumerable property.
	            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
	          };
	        } else if (size == 2) {
	          // Safari <= 2.0.4 enumerates shadowed properties twice.
	          forEach = function (object, callback) {
	            // Create a set of iterated properties.
	            var members = {}, isFunction = getClass.call(object) == functionClass, property;
	            for (property in object) {
	              // Store each property name to prevent double enumeration. The
	              // `prototype` property of functions is not enumerated due to cross-
	              // environment inconsistencies.
	              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	          };
	        } else {
	          // No bugs detected; use the standard `for...in` algorithm.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
	            for (property in object) {
	              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for the `constructor` property due to
	            // cross-environment inconsistencies.
	            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
	              callback(property);
	            }
	          };
	        }
	        return forEach(object, callback);
	      };
	
	      // Public: Serializes a JavaScript `value` as a JSON string. The optional
	      // `filter` argument may specify either a function that alters how object and
	      // array members are serialized, or an array of strings and numbers that
	      // indicates which properties should be serialized. The optional `width`
	      // argument may be either a string or number that specifies the indentation
	      // level of the output.
	      if (!has("json-stringify")) {
	        // Internal: A map of control characters and their escaped equivalents.
	        var Escapes = {
	          92: "\\\\",
	          34: '\\"',
	          8: "\\b",
	          12: "\\f",
	          10: "\\n",
	          13: "\\r",
	          9: "\\t"
	        };
	
	        // Internal: Converts `value` into a zero-padded string such that its
	        // length is at least equal to `width`. The `width` must be <= 6.
	        var leadingZeroes = "000000";
	        var toPaddedString = function (width, value) {
	          // The `|| 0` expression is necessary to work around a bug in
	          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
	          return (leadingZeroes + (value || 0)).slice(-width);
	        };
	
	        // Internal: Double-quotes a string `value`, replacing all ASCII control
	        // characters (characters with code unit values between 0 and 31) with
	        // their escaped equivalents. This is an implementation of the
	        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
	        var unicodePrefix = "\\u00";
	        var quote = function (value) {
	          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
	          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
	          for (; index < length; index++) {
	            var charCode = value.charCodeAt(index);
	            // If the character is a control character, append its Unicode or
	            // shorthand escape sequence; otherwise, append the character as-is.
	            switch (charCode) {
	              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
	                result += Escapes[charCode];
	                break;
	              default:
	                if (charCode < 32) {
	                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
	                  break;
	                }
	                result += useCharIndex ? symbols[index] : value.charAt(index);
	            }
	          }
	          return result + '"';
	        };
	
	        // Internal: Recursively serializes an object. Implements the
	        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
	        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
	          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
	          try {
	            // Necessary for host object support.
	            value = object[property];
	          } catch (exception) {}
	          if (typeof value == "object" && value) {
	            className = getClass.call(value);
	            if (className == dateClass && !isProperty.call(value, "toJSON")) {
	              if (value > -1 / 0 && value < 1 / 0) {
	                // Dates are serialized according to the `Date#toJSON` method
	                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
	                // for the ISO 8601 date time string format.
	                if (getDay) {
	                  // Manually compute the year, month, date, hours, minutes,
	                  // seconds, and milliseconds if the `getUTC*` methods are
	                  // buggy. Adapted from @Yaffle's `date-shim` project.
	                  date = floor(value / 864e5);
	                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
	                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
	                  date = 1 + date - getDay(year, month);
	                  // The `time` value specifies the time within the day (see ES
	                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
	                  // to compute `A modulo B`, as the `%` operator does not
	                  // correspond to the `modulo` operation for negative numbers.
	                  time = (value % 864e5 + 864e5) % 864e5;
	                  // The hours, minutes, seconds, and milliseconds are obtained by
	                  // decomposing the time within the day. See section 15.9.1.10.
	                  hours = floor(time / 36e5) % 24;
	                  minutes = floor(time / 6e4) % 60;
	                  seconds = floor(time / 1e3) % 60;
	                  milliseconds = time % 1e3;
	                } else {
	                  year = value.getUTCFullYear();
	                  month = value.getUTCMonth();
	                  date = value.getUTCDate();
	                  hours = value.getUTCHours();
	                  minutes = value.getUTCMinutes();
	                  seconds = value.getUTCSeconds();
	                  milliseconds = value.getUTCMilliseconds();
	                }
	                // Serialize extended years correctly.
	                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
	                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
	                  // Months, dates, hours, minutes, and seconds should have two
	                  // digits; milliseconds should have three.
	                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
	                  // Milliseconds are optional in ES 5.0, but required in 5.1.
	                  "." + toPaddedString(3, milliseconds) + "Z";
	              } else {
	                value = null;
	              }
	            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
	              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
	              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
	              // ignores all `toJSON` methods on these objects unless they are
	              // defined directly on an instance.
	              value = value.toJSON(property);
	            }
	          }
	          if (callback) {
	            // If a replacement function was provided, call it to obtain the value
	            // for serialization.
	            value = callback.call(object, property, value);
	          }
	          if (value === null) {
	            return "null";
	          }
	          className = getClass.call(value);
	          if (className == booleanClass) {
	            // Booleans are represented literally.
	            return "" + value;
	          } else if (className == numberClass) {
	            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
	            // `"null"`.
	            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
	          } else if (className == stringClass) {
	            // Strings are double-quoted and escaped.
	            return quote("" + value);
	          }
	          // Recursively serialize objects and arrays.
	          if (typeof value == "object") {
	            // Check for cyclic structures. This is a linear search; performance
	            // is inversely proportional to the number of unique nested objects.
	            for (length = stack.length; length--;) {
	              if (stack[length] === value) {
	                // Cyclic structures cannot be serialized by `JSON.stringify`.
	                throw TypeError();
	              }
	            }
	            // Add the object to the stack of traversed objects.
	            stack.push(value);
	            results = [];
	            // Save the current indentation level and indent one additional level.
	            prefix = indentation;
	            indentation += whitespace;
	            if (className == arrayClass) {
	              // Recursively serialize array elements.
	              for (index = 0, length = value.length; index < length; index++) {
	                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
	                results.push(element === undef ? "null" : element);
	              }
	              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
	            } else {
	              // Recursively serialize object members. Members are selected from
	              // either a user-specified list of property names, or the object
	              // itself.
	              forEach(properties || value, function (property) {
	                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
	                if (element !== undef) {
	                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
	                  // is not the empty string, let `member` {quote(property) + ":"}
	                  // be the concatenation of `member` and the `space` character."
	                  // The "`space` character" refers to the literal space
	                  // character, not the `space` {width} argument provided to
	                  // `JSON.stringify`.
	                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
	                }
	              });
	              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
	            }
	            // Remove the object from the traversed object stack.
	            stack.pop();
	            return result;
	          }
	        };
	
	        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
	        exports.stringify = function (source, filter, width) {
	          var whitespace, callback, properties, className;
	          if (objectTypes[typeof filter] && filter) {
	            if ((className = getClass.call(filter)) == functionClass) {
	              callback = filter;
	            } else if (className == arrayClass) {
	              // Convert the property names array into a makeshift set.
	              properties = {};
	              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
	            }
	          }
	          if (width) {
	            if ((className = getClass.call(width)) == numberClass) {
	              // Convert the `width` to an integer and create a string containing
	              // `width` number of space characters.
	              if ((width -= width % 1) > 0) {
	                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
	              }
	            } else if (className == stringClass) {
	              whitespace = width.length <= 10 ? width : width.slice(0, 10);
	            }
	          }
	          // Opera <= 7.54u2 discards the values associated with empty string keys
	          // (`""`) only if they are used directly within an object member list
	          // (e.g., `!("" in { "": 1})`).
	          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
	        };
	      }
	
	      // Public: Parses a JSON source string.
	      if (!has("json-parse")) {
	        var fromCharCode = String.fromCharCode;
	
	        // Internal: A map of escaped control characters and their unescaped
	        // equivalents.
	        var Unescapes = {
	          92: "\\",
	          34: '"',
	          47: "/",
	          98: "\b",
	          116: "\t",
	          110: "\n",
	          102: "\f",
	          114: "\r"
	        };
	
	        // Internal: Stores the parser state.
	        var Index, Source;
	
	        // Internal: Resets the parser state and throws a `SyntaxError`.
	        var abort = function () {
	          Index = Source = null;
	          throw SyntaxError();
	        };
	
	        // Internal: Returns the next token, or `"$"` if the parser has reached
	        // the end of the source string. A token may be a string, number, `null`
	        // literal, or Boolean literal.
	        var lex = function () {
	          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
	          while (Index < length) {
	            charCode = source.charCodeAt(Index);
	            switch (charCode) {
	              case 9: case 10: case 13: case 32:
	                // Skip whitespace tokens, including tabs, carriage returns, line
	                // feeds, and space characters.
	                Index++;
	                break;
	              case 123: case 125: case 91: case 93: case 58: case 44:
	                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
	                // the current position.
	                value = charIndexBuggy ? source.charAt(Index) : source[Index];
	                Index++;
	                return value;
	              case 34:
	                // `"` delimits a JSON string; advance to the next character and
	                // begin parsing the string. String tokens are prefixed with the
	                // sentinel `@` character to distinguish them from punctuators and
	                // end-of-string tokens.
	                for (value = "@", Index++; Index < length;) {
	                  charCode = source.charCodeAt(Index);
	                  if (charCode < 32) {
	                    // Unescaped ASCII control characters (those with a code unit
	                    // less than the space character) are not permitted.
	                    abort();
	                  } else if (charCode == 92) {
	                    // A reverse solidus (`\`) marks the beginning of an escaped
	                    // control character (including `"`, `\`, and `/`) or Unicode
	                    // escape sequence.
	                    charCode = source.charCodeAt(++Index);
	                    switch (charCode) {
	                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
	                        // Revive escaped control characters.
	                        value += Unescapes[charCode];
	                        Index++;
	                        break;
	                      case 117:
	                        // `\u` marks the beginning of a Unicode escape sequence.
	                        // Advance to the first character and validate the
	                        // four-digit code point.
	                        begin = ++Index;
	                        for (position = Index + 4; Index < position; Index++) {
	                          charCode = source.charCodeAt(Index);
	                          // A valid sequence comprises four hexdigits (case-
	                          // insensitive) that form a single hexadecimal value.
	                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
	                            // Invalid Unicode escape sequence.
	                            abort();
	                          }
	                        }
	                        // Revive the escaped character.
	                        value += fromCharCode("0x" + source.slice(begin, Index));
	                        break;
	                      default:
	                        // Invalid escape sequence.
	                        abort();
	                    }
	                  } else {
	                    if (charCode == 34) {
	                      // An unescaped double-quote character marks the end of the
	                      // string.
	                      break;
	                    }
	                    charCode = source.charCodeAt(Index);
	                    begin = Index;
	                    // Optimize for the common case where a string is valid.
	                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
	                      charCode = source.charCodeAt(++Index);
	                    }
	                    // Append the string as-is.
	                    value += source.slice(begin, Index);
	                  }
	                }
	                if (source.charCodeAt(Index) == 34) {
	                  // Advance to the next character and return the revived string.
	                  Index++;
	                  return value;
	                }
	                // Unterminated string.
	                abort();
	              default:
	                // Parse numbers and literals.
	                begin = Index;
	                // Advance past the negative sign, if one is specified.
	                if (charCode == 45) {
	                  isSigned = true;
	                  charCode = source.charCodeAt(++Index);
	                }
	                // Parse an integer or floating-point value.
	                if (charCode >= 48 && charCode <= 57) {
	                  // Leading zeroes are interpreted as octal literals.
	                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
	                    // Illegal octal literal.
	                    abort();
	                  }
	                  isSigned = false;
	                  // Parse the integer component.
	                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
	                  // Floats cannot contain a leading decimal point; however, this
	                  // case is already accounted for by the parser.
	                  if (source.charCodeAt(Index) == 46) {
	                    position = ++Index;
	                    // Parse the decimal component.
	                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal trailing decimal.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Parse exponents. The `e` denoting the exponent is
	                  // case-insensitive.
	                  charCode = source.charCodeAt(Index);
	                  if (charCode == 101 || charCode == 69) {
	                    charCode = source.charCodeAt(++Index);
	                    // Skip past the sign following the exponent, if one is
	                    // specified.
	                    if (charCode == 43 || charCode == 45) {
	                      Index++;
	                    }
	                    // Parse the exponential component.
	                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal empty exponent.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Coerce the parsed value to a JavaScript number.
	                  return +source.slice(begin, Index);
	                }
	                // A negative sign may only precede numbers.
	                if (isSigned) {
	                  abort();
	                }
	                // `true`, `false`, and `null` literals.
	                if (source.slice(Index, Index + 4) == "true") {
	                  Index += 4;
	                  return true;
	                } else if (source.slice(Index, Index + 5) == "false") {
	                  Index += 5;
	                  return false;
	                } else if (source.slice(Index, Index + 4) == "null") {
	                  Index += 4;
	                  return null;
	                }
	                // Unrecognized token.
	                abort();
	            }
	          }
	          // Return the sentinel `$` character if the parser has reached the end
	          // of the source string.
	          return "$";
	        };
	
	        // Internal: Parses a JSON `value` token.
	        var get = function (value) {
	          var results, hasMembers;
	          if (value == "$") {
	            // Unexpected end of input.
	            abort();
	          }
	          if (typeof value == "string") {
	            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
	              // Remove the sentinel `@` character.
	              return value.slice(1);
	            }
	            // Parse object and array literals.
	            if (value == "[") {
	              // Parses a JSON array, returning a new JavaScript array.
	              results = [];
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing square bracket marks the end of the array literal.
	                if (value == "]") {
	                  break;
	                }
	                // If the array literal contains elements, the current token
	                // should be a comma separating the previous element from the
	                // next.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "]") {
	                      // Unexpected trailing `,` in array literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each array element.
	                    abort();
	                  }
	                }
	                // Elisions and leading commas are not permitted.
	                if (value == ",") {
	                  abort();
	                }
	                results.push(get(value));
	              }
	              return results;
	            } else if (value == "{") {
	              // Parses a JSON object, returning a new JavaScript object.
	              results = {};
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing curly brace marks the end of the object literal.
	                if (value == "}") {
	                  break;
	                }
	                // If the object literal contains members, the current token
	                // should be a comma separator.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "}") {
	                      // Unexpected trailing `,` in object literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each object member.
	                    abort();
	                  }
	                }
	                // Leading commas are not permitted, object property names must be
	                // double-quoted strings, and a `:` must separate each property
	                // name and value.
	                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
	                  abort();
	                }
	                results[value.slice(1)] = get(lex());
	              }
	              return results;
	            }
	            // Unexpected token encountered.
	            abort();
	          }
	          return value;
	        };
	
	        // Internal: Updates a traversed object member.
	        var update = function (source, property, callback) {
	          var element = walk(source, property, callback);
	          if (element === undef) {
	            delete source[property];
	          } else {
	            source[property] = element;
	          }
	        };
	
	        // Internal: Recursively traverses a parsed JSON object, invoking the
	        // `callback` function for each value. This is an implementation of the
	        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
	        var walk = function (source, property, callback) {
	          var value = source[property], length;
	          if (typeof value == "object" && value) {
	            // `forEach` can't be used to traverse an array in Opera <= 8.54
	            // because its `Object#hasOwnProperty` implementation returns `false`
	            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
	            if (getClass.call(value) == arrayClass) {
	              for (length = value.length; length--;) {
	                update(value, length, callback);
	              }
	            } else {
	              forEach(value, function (property) {
	                update(value, property, callback);
	              });
	            }
	          }
	          return callback.call(source, property, value);
	        };
	
	        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
	        exports.parse = function (source, callback) {
	          var result, value;
	          Index = 0;
	          Source = "" + source;
	          result = get(lex());
	          // If a JSON string contains multiple tokens, it is invalid.
	          if (lex() != "$") {
	            abort();
	          }
	          // Reset the parser state.
	          Index = Source = null;
	          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
	        };
	      }
	    }
	
	    exports["runInContext"] = runInContext;
	    return exports;
	  }
	
	  if (freeExports && !isLoader) {
	    // Export for CommonJS environments.
	    runInContext(root, freeExports);
	  } else {
	    // Export for web browsers and JavaScript engines.
	    var nativeJSON = root.JSON,
	        previousJSON = root["JSON3"],
	        isRestored = false;
	
	    var JSON3 = runInContext(root, (root["JSON3"] = {
	      // Public: Restores the original value of the global `JSON` object and
	      // returns a reference to the `JSON3` object.
	      "noConflict": function () {
	        if (!isRestored) {
	          isRestored = true;
	          root.JSON = nativeJSON;
	          root["JSON3"] = previousJSON;
	          nativeJSON = previousJSON = null;
	        }
	        return JSON3;
	      }
	    }));
	
	    root.JSON = {
	      "parse": JSON3.parse,
	      "stringify": JSON3.stringify
	    };
	  }
	
	  // Export for asynchronous module loaders.
	  if (isLoader) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return JSON3;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(192)(module), (function() { return this; }())))

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _metadata = _interopRequireDefault(__webpack_require__(43));
	
	var _PhoneNumber = _interopRequireDefault(__webpack_require__(205));
	
	var _AsYouTypeState = _interopRequireDefault(__webpack_require__(1337));
	
	var _AsYouTypeFormatter = _interopRequireWildcard(__webpack_require__(503));
	
	var _AsYouTypeParser = _interopRequireWildcard(__webpack_require__(1336));
	
	var _getCountryByCallingCode = _interopRequireDefault(__webpack_require__(518));
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
	
	var AsYouType = /*#__PURE__*/function () {
	  /**
	   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
	   * @param {Object} metadata
	   */
	  function AsYouType(optionsOrDefaultCountry, metadata) {
	    _classCallCheck(this, AsYouType);
	
	    this.metadata = new _metadata["default"](metadata);
	
	    var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry),
	        _this$getCountryAndCa2 = _slicedToArray(_this$getCountryAndCa, 2),
	        defaultCountry = _this$getCountryAndCa2[0],
	        defaultCallingCode = _this$getCountryAndCa2[1];
	
	    this.defaultCountry = defaultCountry;
	    this.defaultCallingCode = defaultCallingCode;
	    this.reset();
	  }
	
	  _createClass(AsYouType, [{
	    key: "getCountryAndCallingCode",
	    value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
	      // Set `defaultCountry` and `defaultCallingCode` options.
	      var defaultCountry;
	      var defaultCallingCode; // Turns out `null` also has type "object". Weird.
	
	      if (optionsOrDefaultCountry) {
	        if (_typeof(optionsOrDefaultCountry) === 'object') {
	          defaultCountry = optionsOrDefaultCountry.defaultCountry;
	          defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
	        } else {
	          defaultCountry = optionsOrDefaultCountry;
	        }
	      }
	
	      if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) {
	        defaultCountry = undefined;
	      }
	
	      if (defaultCallingCode) {
	        /* istanbul ignore if */
	        if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
	          if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) {
	            defaultCountry = '001';
	          }
	        }
	      }
	
	      return [defaultCountry, defaultCallingCode];
	    }
	    /**
	     * Inputs "next" phone number characters.
	     * @param  {string} text
	     * @return {string} Formatted phone number characters that have been input so far.
	     */
	
	  }, {
	    key: "input",
	    value: function input(text) {
	      var _this$parser$input = this.parser.input(text, this.state),
	          digits = _this$parser$input.digits,
	          justLeadingPlus = _this$parser$input.justLeadingPlus;
	
	      if (justLeadingPlus) {
	        this.formattedOutput = '+';
	      } else if (digits) {
	        this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.
	
	        if (this.state.nationalSignificantNumber) {
	          this.formatter.narrowDownMatchingFormats(this.state);
	        }
	
	        var formattedNationalNumber;
	
	        if (this.metadata.hasSelectedNumberingPlan()) {
	          formattedNationalNumber = this.formatter.format(digits, this.state);
	        }
	
	        if (formattedNationalNumber === undefined) {
	          // See if another national (significant) number could be re-extracted.
	          if (this.parser.reExtractNationalSignificantNumber(this.state)) {
	            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.
	
	            var nationalDigits = this.state.getNationalDigits();
	
	            if (nationalDigits) {
	              formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
	            }
	          }
	        }
	
	        this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
	      }
	
	      return this.formattedOutput;
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      var _this = this;
	
	      this.state = new _AsYouTypeState["default"]({
	        onCountryChange: function onCountryChange(country) {
	          // Before version `1.6.0`, the official `AsYouType` formatter API
	          // included the `.country` property of an `AsYouType` instance.
	          // Since that property (along with the others) have been moved to
	          // `this.state`, `this.country` property is emulated for compatibility
	          // with the old versions.
	          _this.country = country;
	        },
	        onCallingCodeChange: function onCallingCodeChange(country, callingCode) {
	          _this.metadata.selectNumberingPlan(country, callingCode);
	
	          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
	
	          _this.parser.reset(_this.metadata.numberingPlan);
	        }
	      });
	      this.formatter = new _AsYouTypeFormatter["default"]({
	        state: this.state,
	        metadata: this.metadata
	      });
	      this.parser = new _AsYouTypeParser["default"]({
	        defaultCountry: this.defaultCountry,
	        defaultCallingCode: this.defaultCallingCode,
	        metadata: this.metadata,
	        state: this.state,
	        onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
	          _this.determineTheCountryIfNeeded();
	
	          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
	        }
	      });
	      this.state.reset(this.defaultCountry, this.defaultCallingCode);
	      this.formattedOutput = '';
	      return this;
	    }
	    /**
	     * Returns `true` if the phone number is being input in international format.
	     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
	     * @return {boolean}
	     */
	
	  }, {
	    key: "isInternational",
	    value: function isInternational() {
	      return this.state.international;
	    }
	    /**
	     * Returns the "calling code" part of the phone number when it's being input
	     * in an international format.
	     * If no valid calling code has been entered so far, returns `undefined`.
	     * @return {string} [callingCode]
	     */
	
	  }, {
	    key: "getCallingCode",
	    value: function getCallingCode() {
	      // If the number is being input in national format and some "default calling code"
	      // has been passed to `AsYouType` constructor, then `this.state.callingCode`
	      // is equal to that "default calling code".
	      //
	      // If the number is being input in national format and no "default calling code"
	      // has been passed to `AsYouType` constructor, then returns `undefined`,
	      // even if a "default country" has been passed to `AsYouType` constructor.
	      //
	      if (this.isInternational()) {
	        return this.state.callingCode;
	      }
	    } // A legacy alias.
	
	  }, {
	    key: "getCountryCallingCode",
	    value: function getCountryCallingCode() {
	      return this.getCallingCode();
	    }
	    /**
	     * Returns a two-letter country code of the phone number.
	     * Returns `undefined` for "non-geographic" phone numbering plans.
	     * Returns `undefined` if no phone number has been input yet.
	     * @return {string} [country]
	     */
	
	  }, {
	    key: "getCountry",
	    value: function getCountry() {
	      var digits = this.state.digits; // Return `undefined` if no digits have been input yet.
	
	      if (digits) {
	        return this._getCountry();
	      }
	    }
	    /**
	     * Returns a two-letter country code of the phone number.
	     * Returns `undefined` for "non-geographic" phone numbering plans.
	     * @return {string} [country]
	     */
	
	  }, {
	    key: "_getCountry",
	    value: function _getCountry() {
	      var country = this.state.country;
	      /* istanbul ignore if */
	
	      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
	        // `AsYouType.getCountry()` returns `undefined`
	        // for "non-geographic" phone numbering plans.
	        if (country === '001') {
	          return;
	        }
	      }
	
	      return country;
	    }
	  }, {
	    key: "determineTheCountryIfNeeded",
	    value: function determineTheCountryIfNeeded() {
	      // Suppose a user enters a phone number in international format,
	      // and there're several countries corresponding to that country calling code,
	      // and a country has been derived from the number, and then
	      // a user enters one more digit and the number is no longer
	      // valid for the derived country, so the country should be re-derived
	      // on every new digit in those cases.
	      //
	      // If the phone number is being input in national format,
	      // then it could be a case when `defaultCountry` wasn't specified
	      // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
	      // and that "calling code" could correspond to a "non-geographic entity",
	      // or there could be several countries corresponding to that country calling code.
	      // In those cases, `this.country` is `undefined` and should be derived
	      // from the number. Again, if country calling code is ambiguous, then
	      // `this.country` should be re-derived with each new digit.
	      //
	      if (!this.state.country || this.isCountryCallingCodeAmbiguous()) {
	        this.determineTheCountry();
	      }
	    } // Prepends `+CountryCode ` in case of an international phone number
	
	  }, {
	    key: "getFullNumber",
	    value: function getFullNumber(formattedNationalNumber) {
	      var _this2 = this;
	
	      if (this.isInternational()) {
	        var prefix = function prefix(text) {
	          return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
	            spacing: text ? true : false
	          }) + text;
	        };
	
	        var callingCode = this.state.callingCode;
	
	        if (!callingCode) {
	          return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
	        }
	
	        if (!formattedNationalNumber) {
	          return prefix(callingCode);
	        }
	
	        return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
	      }
	
	      return formattedNationalNumber;
	    }
	  }, {
	    key: "getNonFormattedNationalNumberWithPrefix",
	    value: function getNonFormattedNationalNumberWithPrefix() {
	      var _this$state = this.state,
	          nationalSignificantNumber = _this$state.nationalSignificantNumber,
	          complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber,
	          nationalPrefix = _this$state.nationalPrefix;
	      var number = nationalSignificantNumber;
	      var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;
	
	      if (prefix) {
	        number = prefix + number;
	      }
	
	      return number;
	    }
	  }, {
	    key: "getNonFormattedNumber",
	    value: function getNonFormattedNumber() {
	      var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
	      return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
	    }
	  }, {
	    key: "getNonFormattedTemplate",
	    value: function getNonFormattedTemplate() {
	      var number = this.getNonFormattedNumber();
	
	      if (number) {
	        return number.replace(/[\+\d]/g, _AsYouTypeFormatter.DIGIT_PLACEHOLDER);
	      }
	    }
	  }, {
	    key: "isCountryCallingCodeAmbiguous",
	    value: function isCountryCallingCodeAmbiguous() {
	      var callingCode = this.state.callingCode;
	      var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
	      return countryCodes && countryCodes.length > 1;
	    } // Determines the country of the phone number
	    // entered so far based on the country phone code
	    // and the national phone number.
	
	  }, {
	    key: "determineTheCountry",
	    value: function determineTheCountry() {
	      this.state.setCountry((0, _getCountryByCallingCode["default"])(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, this.state.nationalSignificantNumber, this.metadata));
	    }
	    /**
	     * Returns a E.164 phone number value for the user's input.
	     *
	     * For example, for country `"US"` and input `"(222) 333-4444"`
	     * it will return `"+12223334444"`.
	     *
	     * For international phone number input, it will also auto-correct
	     * some minor errors such as using a national prefix when writing
	     * an international phone number. For example, if the user inputs
	     * `"+44 0 7400 000000"` then it will return an auto-corrected
	     * `"+447400000000"` phone number value.
	     *
	     * Will return `undefined` if no digits have been input,
	     * or when inputting a phone number in national format and no
	     * default country or default "country calling code" have been set.
	     *
	     * @return {string} [value]
	     */
	
	  }, {
	    key: "getNumberValue",
	    value: function getNumberValue() {
	      var _this$state2 = this.state,
	          digits = _this$state2.digits,
	          callingCode = _this$state2.callingCode,
	          country = _this$state2.country,
	          nationalSignificantNumber = _this$state2.nationalSignificantNumber; // Will return `undefined` if no digits have been input.
	
	      if (!digits) {
	        return;
	      }
	
	      if (this.isInternational()) {
	        if (callingCode) {
	          return '+' + callingCode + nationalSignificantNumber;
	        } else {
	          return '+' + digits;
	        }
	      } else {
	        if (country || callingCode) {
	          var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
	          return '+' + callingCode_ + nationalSignificantNumber;
	        }
	      }
	    }
	    /**
	     * Returns an instance of `PhoneNumber` class.
	     * Will return `undefined` if no national (significant) number
	     * digits have been entered so far, or if no `defaultCountry` has been
	     * set and the user enters a phone number not in international format.
	     */
	
	  }, {
	    key: "getNumber",
	    value: function getNumber() {
	      var _this$state3 = this.state,
	          nationalSignificantNumber = _this$state3.nationalSignificantNumber,
	          carrierCode = _this$state3.carrierCode,
	          callingCode = _this$state3.callingCode; // `this._getCountry()` is basically same as `this.state.country`
	      // with the only change that it return `undefined` in case of a
	      // "non-geographic" numbering plan instead of `"001"` "internal use" value.
	
	      var country = this._getCountry();
	
	      if (!nationalSignificantNumber) {
	        return;
	      }
	
	      if (!country && !callingCode) {
	        return;
	      }
	
	      var phoneNumber = new _PhoneNumber["default"](country || callingCode, nationalSignificantNumber, this.metadata.metadata);
	
	      if (carrierCode) {
	        phoneNumber.carrierCode = carrierCode;
	      } // Phone number extensions are not supported by "As You Type" formatter.
	
	
	      return phoneNumber;
	    }
	    /**
	     * Returns `true` if the phone number is "possible".
	     * Is just a shortcut for `PhoneNumber.isPossible()`.
	     * @return {boolean}
	     */
	
	  }, {
	    key: "isPossible",
	    value: function isPossible() {
	      var phoneNumber = this.getNumber();
	
	      if (!phoneNumber) {
	        return false;
	      }
	
	      return phoneNumber.isPossible();
	    }
	    /**
	     * Returns `true` if the phone number is "valid".
	     * Is just a shortcut for `PhoneNumber.isValid()`.
	     * @return {boolean}
	     */
	
	  }, {
	    key: "isValid",
	    value: function isValid() {
	      var phoneNumber = this.getNumber();
	
	      if (!phoneNumber) {
	        return false;
	      }
	
	      return phoneNumber.isValid();
	    }
	    /**
	     * @deprecated
	     * This method is used in `react-phone-number-input/source/input-control.js`
	     * in versions before `3.0.16`.
	     */
	
	  }, {
	    key: "getNationalNumber",
	    value: function getNationalNumber() {
	      return this.state.nationalSignificantNumber;
	    }
	    /**
	     * Returns the phone number characters entered by the user.
	     * @return {string}
	     */
	
	  }, {
	    key: "getChars",
	    value: function getChars() {
	      return (this.state.international ? '+' : '') + this.state.digits;
	    }
	    /**
	     * Returns the template for the formatted phone number.
	     * @return {string}
	     */
	
	  }, {
	    key: "getTemplate",
	    value: function getTemplate() {
	      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
	    }
	  }]);
	
	  return AsYouType;
	}();
	
	exports["default"] = AsYouType;
	//# sourceMappingURL=AsYouType.js.map

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "DIGIT_PLACEHOLDER", {
	  enumerable: true,
	  get: function get() {
	    return _AsYouTypeFormatterUtil.DIGIT_PLACEHOLDER;
	  }
	});
	exports["default"] = void 0;
	
	var _AsYouTypeFormatterUtil = __webpack_require__(1335);
	
	var _AsYouTypeFormatterComplete = _interopRequireWildcard(__webpack_require__(1334));
	
	var _AsYouTypeFormatterPatternMatcher = _interopRequireDefault(__webpack_require__(1332));
	
	var _parseDigits = _interopRequireDefault(__webpack_require__(120));
	
	var _formatNationalNumberUsingFormat = __webpack_require__(323);
	
	var _constants = __webpack_require__(72);
	
	var _applyInternationalSeparatorStyle = _interopRequireDefault(__webpack_require__(514));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	// Used in phone number format template creation.
	// Could be any digit, I guess.
	var DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`
	
	var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
	// `number_pattern` by applying the pattern to the "longest phone number" string.
	
	var LONGEST_DUMMY_PHONE_NUMBER = (0, _AsYouTypeFormatterUtil.repeat)(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
	// us that we should separate the national prefix from the number when formatting.
	
	var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
	// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
	// "We no longer have numbers in formatting matching patterns, only \d."
	// Because this library supports generating custom metadata
	// some users may still be using old metadata so the relevant
	// code seems to stay until some next major version update.
	
	var SUPPORT_LEGACY_FORMATTING_PATTERNS = true; // A pattern that is used to match character classes in regular expressions.
	// An example of a character class is "[1-4]".
	
	var CREATE_CHARACTER_CLASS_PATTERN = SUPPORT_LEGACY_FORMATTING_PATTERNS && function () {
	  return /\[([^\[\]])*\]/g;
	}; // Any digit in a regular expression that actually denotes a digit. For
	// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
	// (8 and 0) are standalone digits, but the rest are not.
	// Two look-aheads are needed because the number following \\d could be a
	// two-digit number, since the phone number can be as long as 15 digits.
	
	
	var CREATE_STANDALONE_DIGIT_PATTERN = SUPPORT_LEGACY_FORMATTING_PATTERNS && function () {
	  return /\d(?=[^,}][^,}])/g;
	}; // A regular expression that is used to determine if a `format` is
	// suitable to be used in the "as you type formatter".
	// A `format` is suitable when the resulting formatted number has
	// the same digits as the user has entered.
	//
	// In the simplest case, that would mean that the format
	// doesn't add any additional digits when formatting a number.
	// Google says that it also shouldn't add "star" (`*`) characters,
	// like it does in some Israeli formats.
	// Such basic format would only contain "valid punctuation"
	// and "captured group" identifiers ($1, $2, etc).
	//
	// An example of a format that adds additional digits:
	//
	// Country: `AR` (Argentina).
	// Format:
	// {
	//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
	//    "leading_digits_patterns": ["91"],
	//    "national_prefix_formatting_rule": "0$1",
	//    "format": "$2 15-$3-$4",
	//    "international_format": "$1 $2 $3-$4"
	// }
	//
	// In the format above, the `format` adds `15` to the digits when formatting a number.
	// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
	// has previously removed `15` from a national number, so re-adding `15` in `format`
	// doesn't actually result in any extra digits added to user's input.
	// But verifying that would be a complex procedure, so the code chooses a simpler path:
	// it simply filters out all `format`s that contain anything but "captured group" ids.
	//
	// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
	// `libphonenumber` code.
	//
	
	
	var NON_ALTERING_FORMAT_REG_EXP = new RegExp('[' + _constants.VALID_PUNCTUATION + ']*' + // Google developers say:
	// "We require that the first matching group is present in the
	//  output pattern to ensure no data is lost while formatting."
	'\\$1' + '[' + _constants.VALID_PUNCTUATION + ']*' + '(\\$\\d[' + _constants.VALID_PUNCTUATION + ']*)*' + '$'); // This is the minimum length of the leading digits of a phone number
	// to guarantee the first "leading digits pattern" for a phone number format
	// to be preemptive.
	
	var MIN_LEADING_DIGITS_LENGTH = 3;
	
	var AsYouTypeFormatter = /*#__PURE__*/function () {
	  function AsYouTypeFormatter(_ref) {
	    var state = _ref.state,
	        metadata = _ref.metadata;
	
	    _classCallCheck(this, AsYouTypeFormatter);
	
	    this.metadata = metadata;
	    this.resetFormat();
	  }
	
	  _createClass(AsYouTypeFormatter, [{
	    key: "resetFormat",
	    value: function resetFormat() {
	      this.chosenFormat = undefined;
	      this.template = undefined;
	      this.nationalNumberTemplate = undefined;
	      this.populatedNationalNumberTemplate = undefined;
	      this.populatedNationalNumberTemplatePosition = -1;
	    }
	  }, {
	    key: "reset",
	    value: function reset(numberingPlan, state) {
	      this.resetFormat();
	
	      if (numberingPlan) {
	        this.isNANP = numberingPlan.callingCode() === '1';
	        this.matchingFormats = numberingPlan.formats();
	
	        if (state.nationalSignificantNumber) {
	          this.narrowDownMatchingFormats(state);
	        }
	      } else {
	        this.isNANP = undefined;
	        this.matchingFormats = [];
	      }
	    }
	    /**
	     * Formats an updated phone number.
	     * @param  {string} nextDigits — Additional phone number digits.
	     * @param  {object} state — `AsYouType` state.
	     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
	     */
	
	  }, {
	    key: "format",
	    value: function format(nextDigits, state) {
	      var _this = this;
	
	      // See if the phone number digits can be formatted as a complete phone number.
	      // If not, use the results from `formatNationalNumberWithNextDigits()`,
	      // which formats based on the chosen formatting pattern.
	      //
	      // Attempting to format complete phone number first is how it's done
	      // in Google's `libphonenumber`, so this library just follows it.
	      // Google's `libphonenumber` code doesn't explain in detail why does it
	      // attempt to format digits as a complete phone number
	      // instead of just going with a previoulsy (or newly) chosen `format`:
	      //
	      // "Checks to see if there is an exact pattern match for these digits.
	      //  If so, we should use this instead of any other formatting template
	      //  whose leadingDigitsPattern also matches the input."
	      //
	      if ((0, _AsYouTypeFormatterComplete.canFormatCompleteNumber)(state.nationalSignificantNumber, this.metadata)) {
	        for (var _iterator = _createForOfIteratorHelperLoose(this.matchingFormats), _step; !(_step = _iterator()).done;) {
	          var format = _step.value;
	          var formattedCompleteNumber = (0, _AsYouTypeFormatterComplete["default"])(state, format, {
	            metadata: this.metadata,
	            shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
	              return _this.shouldTryNationalPrefixFormattingRule(format, {
	                international: state.international,
	                nationalPrefix: state.nationalPrefix
	              });
	            },
	            getSeparatorAfterNationalPrefix: function getSeparatorAfterNationalPrefix(format) {
	              return _this.getSeparatorAfterNationalPrefix(format);
	            }
	          });
	
	          if (formattedCompleteNumber) {
	            this.resetFormat();
	            this.chosenFormat = format;
	            this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, _AsYouTypeFormatterUtil.DIGIT_PLACEHOLDER), state);
	            this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
	            // using the old template needs to be reset.
	
	            this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(_AsYouTypeFormatterUtil.DIGIT_PLACEHOLDER);
	            return formattedCompleteNumber;
	          }
	        }
	      } // Format the digits as a partial (incomplete) phone number
	      // using the previously chosen formatting pattern (or a newly chosen one).
	
	
	      return this.formatNationalNumberWithNextDigits(nextDigits, state);
	    } // Formats the next phone number digits.
	
	  }, {
	    key: "formatNationalNumberWithNextDigits",
	    value: function formatNationalNumberWithNextDigits(nextDigits, state) {
	      var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.
	
	      var newlyChosenFormat = this.chooseFormat(state);
	
	      if (newlyChosenFormat) {
	        if (newlyChosenFormat === previouslyChosenFormat) {
	          // If it can format the next (current) digits
	          // using the previously chosen phone number format
	          // then return the updated formatted number.
	          return this.formatNextNationalNumberDigits(nextDigits);
	        } else {
	          // If a more appropriate phone number format
	          // has been chosen for these "leading digits",
	          // then re-format the national phone number part
	          // using the newly selected format.
	          return this.formatNextNationalNumberDigits(state.getNationalDigits());
	        }
	      }
	    }
	  }, {
	    key: "narrowDownMatchingFormats",
	    value: function narrowDownMatchingFormats(_ref2) {
	      var _this2 = this;
	
	      var nationalSignificantNumber = _ref2.nationalSignificantNumber,
	          nationalPrefix = _ref2.nationalPrefix,
	          international = _ref2.international;
	      var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
	      // "leading digits" pattern fitting a maximum of 3 leading digits.
	      // So, after a user inputs 3 digits of a national (significant) phone number
	      // this national (significant) number can already be formatted.
	      // The next "leading digits" pattern is for 4 leading digits max,
	      // and the "leading digits" pattern after it is for 5 leading digits max, etc.
	      // This implementation is different from Google's
	      // in that it searches for a fitting format
	      // even if the user has entered less than
	      // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
	      // Because some leading digit patterns already match for a single first digit.
	
	      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;
	
	      if (leadingDigitsPatternIndex < 0) {
	        leadingDigitsPatternIndex = 0;
	      }
	
	      this.matchingFormats = this.matchingFormats.filter(function (format) {
	        return _this2.formatSuits(format, international, nationalPrefix) && _this2.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
	      }); // If there was a phone number format chosen
	      // and it no longer holds given the new leading digits then reset it.
	      // The test for this `if` condition is marked as:
	      // "Reset a chosen format when it no longer holds given the new leading digits".
	      // To construct a valid test case for this one can find a country
	      // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
	      // and yielding another format for 4 `<leadingDigits>` (Australia in this case).
	
	      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
	        this.resetFormat();
	      }
	    }
	  }, {
	    key: "formatSuits",
	    value: function formatSuits(format, international, nationalPrefix) {
	      // When a prefix before a national (significant) number is
	      // simply a national prefix, then it's parsed as `this.nationalPrefix`.
	      // In more complex cases, a prefix before national (significant) number
	      // could include a national prefix as well as some "capturing groups",
	      // and in that case there's no info whether a national prefix has been parsed.
	      // If national prefix is not used when formatting a phone number
	      // using this format, but a national prefix has been entered by the user,
	      // and was extracted, then discard such phone number format.
	      // In Google's "AsYouType" formatter code, the equivalent would be this part:
	      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
	      if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
	      !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) {
	        return false;
	      } // If national prefix is mandatory for this phone number format
	      // and there're no guarantees that a national prefix is present in user input
	      // then discard this phone number format as not suitable.
	      // In Google's "AsYouType" formatter code, the equivalent would be this part:
	      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193
	
	
	      if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: "formatMatches",
	    value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
	      var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
	      // leading digits pattern then it fits.
	      // The test case could be found by searching for "leadingDigitsPatternsCount === 0".
	
	      if (leadingDigitsPatternsCount === 0) {
	        return true;
	      } // Start narrowing down the list of possible formats based on the leading digits.
	      // (only previously matched formats take part in the narrowing down process)
	      // `leading_digits_patterns` start with 3 digits min
	      // and then go up from there one digit at a time.
	
	
	      leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
	      var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Google imposes a requirement on the leading digits
	      // to be minimum 3 digits long in order to be eligible
	      // for checking those with a leading digits pattern.
	      //
	      // Since `leading_digits_patterns` start with 3 digits min,
	      // Google's original `libphonenumber` library only starts
	      // excluding any non-matching formats only when the
	      // national number entered so far is at least 3 digits long,
	      // otherwise format matching would give false negatives.
	      //
	      // For example, when the digits entered so far are `2`
	      // and the leading digits pattern is `21` –
	      // it's quite obvious in this case that the format could be the one
	      // but due to the absence of further digits it would give false negative.
	      //
	      // Also, `leading_digits_patterns` doesn't always correspond to a single
	      // digits count. For example, `60|8` pattern would already match `8`
	      // but the `60` part would require having at least two leading digits,
	      // so the whole pattern would require inputting two digits first in order to
	      // decide on whether it matches the input, even when the input is "80".
	      //
	      // This library — `libphonenumber-js` — allows filtering by `leading_digits_patterns`
	      // even when there's only 1 or 2 digits of the national (significant) number.
	      // To do that, it uses a non-strict pattern matcher written specifically for that.
	      //
	
	      if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
	        // Before leading digits < 3 matching was implemented:
	        // return true
	        //
	        // After leading digits < 3 matching was implemented:
	        try {
	          return new _AsYouTypeFormatterPatternMatcher["default"](leadingDigitsPattern).match(leadingDigits, {
	            allowOverflow: true
	          }) !== undefined;
	        } catch (error)
	        /* istanbul ignore next */
	        {
	          // There's a slight possibility that there could be some undiscovered bug
	          // in the pattern matcher code. Since the "leading digits < 3 matching"
	          // feature is not "essential" for operation, it can fall back to the old way
	          // in case of any issues rather than halting the application's execution.
	          console.error(error);
	          return true;
	        }
	      } // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are
	      // available then use the usual regular expression matching.
	      //
	      // The whole pattern is wrapped in round brackets (`()`) because
	      // the pattern can use "or" operator (`|`) at the top level of the pattern.
	      //
	
	
	      return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
	    }
	  }, {
	    key: "getFormatFormat",
	    value: function getFormatFormat(format, international) {
	      return international ? format.internationalFormat() : format.format();
	    }
	  }, {
	    key: "chooseFormat",
	    value: function chooseFormat(state) {
	      var _this3 = this;
	
	      var _loop = function _loop() {
	        var format = _step2.value;
	
	        // If this format is currently being used
	        // and is still suitable, then stick to it.
	        if (_this3.chosenFormat === format) {
	          return "break";
	        } // Sometimes, a formatting rule inserts additional digits in a phone number,
	        // and "as you type" formatter can't do that: it should only use the digits
	        // that the user has input.
	        //
	        // For example, in Argentina, there's a format for mobile phone numbers:
	        //
	        // {
	        //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
	        //    "leading_digits_patterns": ["91"],
	        //    "national_prefix_formatting_rule": "0$1",
	        //    "format": "$2 15-$3-$4",
	        //    "international_format": "$1 $2 $3-$4"
	        // }
	        //
	        // In that format, `international_format` is used instead of `format`
	        // because `format` inserts `15` in the formatted number,
	        // and `AsYouType` formatter should only use the digits
	        // the user has actually input, without adding any extra digits.
	        // In this case, it wouldn't make a difference, because the `15`
	        // is first stripped when applying `national_prefix_for_parsing`
	        // and then re-added when using `format`, so in reality it doesn't
	        // add any new digits to the number, but to detect that, the code
	        // would have to be more complex: it would have to try formatting
	        // the digits using the format and then see if any digits have
	        // actually been added or removed, and then, every time a new digit
	        // is input, it should re-check whether the chosen format doesn't
	        // alter the digits.
	        //
	        // Google's code doesn't go that far, and so does this library:
	        // it simply requires that a `format` doesn't add any additonal
	        // digits to user's input.
	        //
	        // Also, people in general should move from inputting phone numbers
	        // in national format (possibly with national prefixes)
	        // and use international phone number format instead:
	        // it's a logical thing in the modern age of mobile phones,
	        // globalization and the internet.
	        //
	
	        /* istanbul ignore if */
	
	
	        if (!NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format, state.international))) {
	          return "continue";
	        }
	
	        if (!_this3.createTemplateForFormat(format, state)) {
	          // Remove the format if it can't generate a template.
	          _this3.matchingFormats = _this3.matchingFormats.filter(function (_) {
	            return _ !== format;
	          });
	          return "continue";
	        }
	
	        _this3.chosenFormat = format;
	        return "break";
	      };
	
	      // When there are multiple available formats, the formatter uses the first
	      // format where a formatting template could be created.
	      //
	      // For some weird reason, `istanbul` says "else path not taken"
	      // for the `for of` line below. Supposedly that means that
	      // the loop doesn't ever go over the last element in the list.
	      // That's true because there always is `this.chosenFormat`
	      // when `this.matchingFormats` is non-empty.
	      // And, for some weird reason, it doesn't think that the case
	      // with empty `this.matchingFormats` qualifies for a valid "else" path.
	      // So simply muting this `istanbul` warning.
	      // It doesn't skip the contents of the `for of` loop,
	      // it just skips the `for of` line.
	      //
	
	      /* istanbul ignore next */
	      for (var _iterator2 = _createForOfIteratorHelperLoose(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done;) {
	        var _ret = _loop();
	
	        if (_ret === "break") break;
	        if (_ret === "continue") continue;
	      }
	
	      if (!this.chosenFormat) {
	        // No format matches the national (significant) phone number.
	        this.resetFormat();
	      }
	
	      return this.chosenFormat;
	    }
	  }, {
	    key: "createTemplateForFormat",
	    value: function createTemplateForFormat(format, state) {
	      // The formatter doesn't format numbers when numberPattern contains '|', e.g.
	      // (20|3)\d{4}. In those cases we quickly return.
	      // (Though there's no such format in current metadata)
	
	      /* istanbul ignore if */
	      if (SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf('|') >= 0) {
	        return;
	      } // Get formatting template for this phone number format
	
	
	      var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
	      // for any phone number format, then abort.
	
	      if (template) {
	        this.setNationalNumberTemplate(template, state);
	        return true;
	      }
	    }
	  }, {
	    key: "getSeparatorAfterNationalPrefix",
	    value: function getSeparatorAfterNationalPrefix(format) {
	      // `US` metadata doesn't have a `national_prefix_formatting_rule`,
	      // so the `if` condition below doesn't apply to `US`,
	      // but in reality there shoudl be a separator
	      // between a national prefix and a national (significant) number.
	      // So `US` national prefix separator is a "special" "hardcoded" case.
	      if (this.isNANP) {
	        return ' ';
	      } // If a `format` has a `national_prefix_formatting_rule`
	      // and that rule has a separator after a national prefix,
	      // then it means that there should be a separator
	      // between a national prefix and a national (significant) number.
	
	
	      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
	        return ' ';
	      } // At this point, there seems to be no clear evidence that
	      // there should be a separator between a national prefix
	      // and a national (significant) number. So don't insert one.
	
	
	      return '';
	    }
	  }, {
	    key: "getInternationalPrefixBeforeCountryCallingCode",
	    value: function getInternationalPrefixBeforeCountryCallingCode(_ref3, options) {
	      var IDDPrefix = _ref3.IDDPrefix,
	          missingPlus = _ref3.missingPlus;
	
	      if (IDDPrefix) {
	        return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
	      }
	
	      if (missingPlus) {
	        return '';
	      }
	
	      return '+';
	    }
	  }, {
	    key: "getTemplate",
	    value: function getTemplate(state) {
	      if (!this.template) {
	        return;
	      } // `this.template` holds the template for a "complete" phone number.
	      // The currently entered phone number is most likely not "complete",
	      // so trim all non-populated digits.
	
	
	      var index = -1;
	      var i = 0;
	      var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
	        spacing: false
	      }) : '';
	
	      while (i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length) {
	        index = this.template.indexOf(_AsYouTypeFormatterUtil.DIGIT_PLACEHOLDER, index + 1);
	        i++;
	      }
	
	      return (0, _AsYouTypeFormatterUtil.cutAndStripNonPairedParens)(this.template, index + 1);
	    }
	  }, {
	    key: "setNationalNumberTemplate",
	    value: function setNationalNumberTemplate(template, state) {
	      this.nationalNumberTemplate = template;
	      this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
	      // using the old template needs to be reset.
	
	      this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
	      // contains the whole international number
	      // if the phone number being input is international:
	      // 'x' for the '+' sign, 'x'es for the country phone code,
	      // a spacebar and then the template for the formatted national number.
	
	      if (state.international) {
	        this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, _AsYouTypeFormatterUtil.DIGIT_PLACEHOLDER) + (0, _AsYouTypeFormatterUtil.repeat)(_AsYouTypeFormatterUtil.DIGIT_PLACEHOLDER, state.callingCode.length) + ' ' + template;
	      } else {
	        this.template = template;
	      }
	    }
	    /**
	     * Generates formatting template for a national phone number,
	     * optionally containing a national prefix, for a format.
	     * @param  {Format} format
	     * @param  {string} nationalPrefix
	     * @return {string}
	     */
	
	  }, {
	    key: "getTemplateForFormat",
	    value: function getTemplateForFormat(format, _ref4) {
	      var nationalSignificantNumber = _ref4.nationalSignificantNumber,
	          international = _ref4.international,
	          nationalPrefix = _ref4.nationalPrefix,
	          complexPrefixBeforeNationalSignificantNumber = _ref4.complexPrefixBeforeNationalSignificantNumber;
	      var pattern = format.pattern();
	      /* istanbul ignore else */
	
	      if (SUPPORT_LEGACY_FORMATTING_PATTERNS) {
	        pattern = pattern // Replace anything in the form of [..] with \d
	        .replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
	        .replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
	      } // Generate a dummy national number (consisting of `9`s)
	      // that fits this format's `pattern`.
	      //
	      // This match will always succeed,
	      // because the "longest dummy phone number"
	      // has enough length to accomodate any possible
	      // national phone number format pattern.
	      //
	
	
	      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
	      // for any phone number format, then abort.
	
	      if (nationalSignificantNumber.length > digits.length) {
	        return;
	      } // Get a formatting template which can be used to efficiently format
	      // a partial number where digits are added one by one.
	      // Below `strictPattern` is used for the
	      // regular expression (with `^` and `$`).
	      // This wasn't originally in Google's `libphonenumber`
	      // and I guess they don't really need it
	      // because they're not using "templates" to format phone numbers
	      // but I added `strictPattern` after encountering
	      // South Korean phone number formatting bug.
	      //
	      // Non-strict regular expression bug demonstration:
	      //
	      // this.nationalSignificantNumber : `111111111` (9 digits)
	      //
	      // pattern : (\d{2})(\d{3,4})(\d{4})
	      // format : `$1 $2 $3`
	      // digits : `9999999999` (10 digits)
	      //
	      // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
	      //
	      // template : xx xxxx xxxx
	      //
	      // But the correct template in this case is `xx xxx xxxx`.
	      // The template was generated incorrectly because of the
	      // `{3,4}` variability in the `pattern`.
	      //
	      // The fix is, if `this.nationalSignificantNumber` has already sufficient length
	      // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
	      // is used instead of `digits`.
	
	
	      var strictPattern = new RegExp('^' + pattern + '$');
	      var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
	      // to satisfy the `pattern` completely then use it
	      // instead of `digits`.
	
	      if (strictPattern.test(nationalNumberDummyDigits)) {
	        digits = nationalNumberDummyDigits;
	      }
	
	      var numberFormat = this.getFormatFormat(format, international);
	      var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
	      // and if a `format` does have a national prefix formatting rule,
	      // then see if that national prefix formatting rule
	      // prepends exactly the same national prefix the user has input.
	      // If that's the case, then use the `format` with the national prefix formatting rule.
	      // Otherwise, use  the `format` without the national prefix formatting rule,
	      // and prepend a national prefix manually to it.
	
	      if (this.shouldTryNationalPrefixFormattingRule(format, {
	        international: international,
	        nationalPrefix: nationalPrefix
	      })) {
	        var numberFormatWithNationalPrefix = numberFormat.replace(_formatNationalNumberUsingFormat.FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
	        // national prefix at the start of a national (significant) number,
	        // then such formatting can be used with `AsYouType` formatter.
	        // There seems to be no `else` case: everywhere in metadata,
	        // national prefix formatting rule is national prefix + $1,
	        // or `($1)`, in which case such format isn't even considered
	        // when the user has input a national prefix.
	
	        /* istanbul ignore else */
	
	        if ((0, _parseDigits["default"])(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + (0, _parseDigits["default"])('$1')) {
	          numberFormat = numberFormatWithNationalPrefix;
	          nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
	          // with `DIGIT_PLACEHOLDER`s.
	
	          if (nationalPrefix) {
	            var i = nationalPrefix.length;
	
	            while (i > 0) {
	              numberFormat = numberFormat.replace(/\d/, _AsYouTypeFormatterUtil.DIGIT_PLACEHOLDER);
	              i--;
	            }
	          }
	        }
	      } // Generate formatting template for this phone number format.
	
	
	      var template = digits // Format the dummy phone number according to the format.
	      .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
	      .replace(new RegExp(DUMMY_DIGIT, 'g'), _AsYouTypeFormatterUtil.DIGIT_PLACEHOLDER); // If a prefix of a national (significant) number is not as simple
	      // as just a basic national prefix, then just prepend such prefix
	      // before the national (significant) number, optionally spacing
	      // the two with a whitespace.
	
	      if (!nationalPrefixIncludedInTemplate) {
	        if (complexPrefixBeforeNationalSignificantNumber) {
	          // Prepend the prefix to the template manually.
	          template = (0, _AsYouTypeFormatterUtil.repeat)(_AsYouTypeFormatterUtil.DIGIT_PLACEHOLDER, complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
	        } else if (nationalPrefix) {
	          // Prepend national prefix to the template manually.
	          template = (0, _AsYouTypeFormatterUtil.repeat)(_AsYouTypeFormatterUtil.DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
	        }
	      }
	
	      if (international) {
	        template = (0, _applyInternationalSeparatorStyle["default"])(template);
	      }
	
	      return template;
	    }
	  }, {
	    key: "formatNextNationalNumberDigits",
	    value: function formatNextNationalNumberDigits(digits) {
	      var result = (0, _AsYouTypeFormatterUtil.populateTemplateWithDigits)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);
	
	      if (!result) {
	        // Reset the format.
	        this.resetFormat();
	        return;
	      }
	
	      this.populatedNationalNumberTemplate = result[0];
	      this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.
	
	      return (0, _AsYouTypeFormatterUtil.cutAndStripNonPairedParens)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
	      // for `react-phone-number-input`'s default input (`InputBasic`).
	      // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
	      // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
	    }
	  }, {
	    key: "shouldTryNationalPrefixFormattingRule",
	    value: function shouldTryNationalPrefixFormattingRule(format, _ref5) {
	      var international = _ref5.international,
	          nationalPrefix = _ref5.nationalPrefix;
	
	      if (format.nationalPrefixFormattingRule()) {
	        // In some countries, `national_prefix_formatting_rule` is `($1)`,
	        // so it applies even if the user hasn't input a national prefix.
	        // `format.usesNationalPrefix()` detects such cases.
	        var usesNationalPrefix = format.usesNationalPrefix();
	
	        if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) {
	          return true;
	        }
	      }
	    }
	  }]);
	
	  return AsYouTypeFormatter;
	}();
	
	exports["default"] = AsYouTypeFormatter;
	//# sourceMappingURL=AsYouTypeFormatter.js.map

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = findNumbers;
	
	var _findNumbers_ = _interopRequireDefault(__webpack_require__(1341));
	
	var _parsePhoneNumber = __webpack_require__(140);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function findNumbers() {
	  var _normalizeArguments = (0, _parsePhoneNumber.normalizeArguments)(arguments),
	      text = _normalizeArguments.text,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _findNumbers_["default"])(text, options, metadata);
	}
	//# sourceMappingURL=findNumbers.js.map

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LEAD_CLASS = void 0;
	exports["default"] = isValidCandidate;
	
	var _constants = __webpack_require__(72);
	
	var _util = __webpack_require__(206);
	
	var _utf = __webpack_require__(508);
	
	// Copy-pasted from `PhoneNumberMatcher.js`.
	var OPENING_PARENS = "(\\[\uFF08\uFF3B";
	var CLOSING_PARENS = ")\\]\uFF09\uFF3D";
	var NON_PARENS = "[^".concat(OPENING_PARENS).concat(CLOSING_PARENS, "]");
	var LEAD_CLASS = "[".concat(OPENING_PARENS).concat(_constants.PLUS_CHARS, "]"); // Punctuation that may be at the start of a phone number - brackets and plus signs.
	
	exports.LEAD_CLASS = LEAD_CLASS;
	var LEAD_CLASS_LEADING = new RegExp('^' + LEAD_CLASS); // Limit on the number of pairs of brackets in a phone number.
	
	var BRACKET_PAIR_LIMIT = (0, _util.limit)(0, 3);
	/**
	 * Pattern to check that brackets match. Opening brackets should be closed within a phone number.
	 * This also checks that there is something inside the brackets. Having no brackets at all is also
	 * fine.
	 *
	 * An opening bracket at the beginning may not be closed, but subsequent ones should be.  It's
	 * also possible that the leading bracket was dropped, so we shouldn't be surprised if we see a
	 * closing bracket first. We limit the sets of brackets in a phone number to four.
	 */
	
	var MATCHING_BRACKETS_ENTIRE = new RegExp('^' + "(?:[" + OPENING_PARENS + "])?" + "(?:" + NON_PARENS + "+" + "[" + CLOSING_PARENS + "])?" + NON_PARENS + "+" + "(?:[" + OPENING_PARENS + "]" + NON_PARENS + "+[" + CLOSING_PARENS + "])" + BRACKET_PAIR_LIMIT + NON_PARENS + "*" + '$');
	/**
	 * Matches strings that look like publication pages. Example:
	 * <pre>Computing Complete Answers to Queries in the Presence of Limited Access Patterns.
	 * Chen Li. VLDB J. 12(3): 211-227 (2003).</pre>
	 *
	 * The string "211-227 (2003)" is not a telephone number.
	 */
	
	var PUB_PAGES = /\d{1,5}-+\d{1,5}\s{0,4}\(\d{1,4}/;
	
	function isValidCandidate(candidate, offset, text, leniency) {
	  // Check the candidate doesn't contain any formatting
	  // which would indicate that it really isn't a phone number.
	  if (!MATCHING_BRACKETS_ENTIRE.test(candidate) || PUB_PAGES.test(candidate)) {
	    return;
	  } // If leniency is set to VALID or stricter, we also want to skip numbers that are surrounded
	  // by Latin alphabetic characters, to skip cases like abc8005001234 or 8005001234def.
	
	
	  if (leniency !== 'POSSIBLE') {
	    // If the candidate is not at the start of the text,
	    // and does not start with phone-number punctuation,
	    // check the previous character.
	    if (offset > 0 && !LEAD_CLASS_LEADING.test(candidate)) {
	      var previousChar = text[offset - 1]; // We return null if it is a latin letter or an invalid punctuation symbol.
	
	      if ((0, _utf.isInvalidPunctuationSymbol)(previousChar) || (0, _utf.isLatinLetter)(previousChar)) {
	        return false;
	      }
	    }
	
	    var lastCharIndex = offset + candidate.length;
	
	    if (lastCharIndex < text.length) {
	      var nextChar = text[lastCharIndex];
	
	      if ((0, _utf.isInvalidPunctuationSymbol)(nextChar) || (0, _utf.isLatinLetter)(nextChar)) {
	        return false;
	      }
	    }
	  }
	
	  return true;
	}
	//# sourceMappingURL=isValidCandidate.js.map

/***/ }),
/* 506 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isValidPreCandidate;
	// Matches strings that look like dates using "/" as a separator.
	// Examples: 3/10/2011, 31/10/96 or 08/31/95.
	var SLASH_SEPARATED_DATES = /(?:(?:[0-3]?\d\/[01]?\d)|(?:[01]?\d\/[0-3]?\d))\/(?:[12]\d)?\d{2}/; // Matches timestamps.
	// Examples: "2012-01-02 08:00".
	// Note that the reg-ex does not include the
	// trailing ":\d\d" -- that is covered by TIME_STAMPS_SUFFIX.
	
	var TIME_STAMPS = /[12]\d{3}[-/]?[01]\d[-/]?[0-3]\d +[0-2]\d$/;
	var TIME_STAMPS_SUFFIX_LEADING = /^:[0-5]\d/;
	
	function isValidPreCandidate(candidate, offset, text) {
	  // Skip a match that is more likely to be a date.
	  if (SLASH_SEPARATED_DATES.test(candidate)) {
	    return false;
	  } // Skip potential time-stamps.
	
	
	  if (TIME_STAMPS.test(candidate)) {
	    var followingText = text.slice(offset + candidate.length);
	
	    if (TIME_STAMPS_SUFFIX_LEADING.test(followingText)) {
	      return false;
	    }
	  }
	
	  return true;
	}
	//# sourceMappingURL=isValidPreCandidate.js.map

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parsePreCandidate;
	
	var _util = __webpack_require__(206);
	
	// Regular expression of characters typically used to start a second phone number for the purposes
	// of parsing. This allows us to strip off parts of the number that are actually the start of
	// another number, such as for: (530) 583-6985 x302/x2303 -> the second extension here makes this
	// actually two phone numbers, (530) 583-6985 x302 and (530) 583-6985 x2303. We remove the second
	// extension so that the first number is parsed correctly.
	//
	// Matches a slash (\ or /) followed by a space followed by an `x`.
	//
	var SECOND_NUMBER_START_PATTERN = /[\\/] *x/;
	
	function parsePreCandidate(candidate) {
	  // Check for extra numbers at the end.
	  // TODO: This is the place to start when trying to support extraction of multiple phone number
	  // from split notations (+41 79 123 45 67 / 68).
	  return (0, _util.trimAfterFirstMatch)(SECOND_NUMBER_START_PATTERN, candidate);
	}
	//# sourceMappingURL=parsePreCandidate.js.map

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports._pN = exports._pL = exports.PZ = void 0;
	exports.isInvalidPunctuationSymbol = isInvalidPunctuationSymbol;
	exports.isLatinLetter = isLatinLetter;
	exports.pZ = exports.pNd = void 0;
	// Javascript doesn't support UTF-8 regular expressions.
	// So mimicking them here.
	// Copy-pasted from `PhoneNumberMatcher.js`.
	
	/**
	 * "\p{Z}" is any kind of whitespace or invisible separator ("Separator").
	 * http://www.regular-expressions.info/unicode.html
	 * "\P{Z}" is the reverse of "\p{Z}".
	 * "\p{N}" is any kind of numeric character in any script ("Number").
	 * "\p{Nd}" is a digit zero through nine in any script except "ideographic scripts" ("Decimal_Digit_Number").
	 * "\p{Sc}" is a currency symbol ("Currency_Symbol").
	 * "\p{L}" is any kind of letter from any language ("Letter").
	 * "\p{Mn}" is "non-spacing mark".
	 *
	 * Javascript doesn't support Unicode Regular Expressions
	 * so substituting it with this explicit set of characters.
	 *
	 * https://stackoverflow.com/questions/13210194/javascript-regex-equivalent-of-a-za-z-using-pl
	 * https://github.com/danielberndt/babel-plugin-utf-8-regex/blob/master/src/transformer.js
	 */
	var _pZ = " \xA0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000";
	var pZ = "[".concat(_pZ, "]");
	exports.pZ = pZ;
	var PZ = "[^".concat(_pZ, "]");
	exports.PZ = PZ;
	var _pN = "0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19"; // const pN = `[${_pN}]`
	
	exports._pN = _pN;
	var _pNd = "0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19";
	var pNd = "[".concat(_pNd, "]");
	exports.pNd = pNd;
	var _pL = "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
	exports._pL = _pL;
	var pL = "[".concat(_pL, "]");
	var pL_regexp = new RegExp(pL);
	var _pSc = "$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20B9\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6";
	var pSc = "[".concat(_pSc, "]");
	var pSc_regexp = new RegExp(pSc);
	var _pMn = "\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E4-\u08FE\u0900-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1DC0-\u1DE6\u1DFC-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE26";
	var pMn = "[".concat(_pMn, "]");
	var pMn_regexp = new RegExp(pMn);
	var _InBasic_Latin = "\0-\x7F";
	var _InLatin_1_Supplement = "\x80-\xFF";
	var _InLatin_Extended_A = "\u0100-\u017F";
	var _InLatin_Extended_Additional = "\u1E00-\u1EFF";
	var _InLatin_Extended_B = "\u0180-\u024F";
	var _InCombining_Diacritical_Marks = "\u0300-\u036F";
	var latinLetterRegexp = new RegExp('[' + _InBasic_Latin + _InLatin_1_Supplement + _InLatin_Extended_A + _InLatin_Extended_Additional + _InLatin_Extended_B + _InCombining_Diacritical_Marks + ']');
	/**
	 * Helper method to determine if a character is a Latin-script letter or not.
	 * For our purposes, combining marks should also return true since we assume
	 * they have been added to a preceding Latin character.
	 */
	
	function isLatinLetter(letter) {
	  // Combining marks are a subset of non-spacing-mark.
	  if (!pL_regexp.test(letter) && !pMn_regexp.test(letter)) {
	    return false;
	  }
	
	  return latinLetterRegexp.test(letter);
	}
	
	function isInvalidPunctuationSymbol(character) {
	  return character === '%' || pSc_regexp.test(character);
	}
	//# sourceMappingURL=utf-8.js.map

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = findPhoneNumbers;
	exports.searchPhoneNumbers = searchPhoneNumbers;
	
	var _findPhoneNumbers_ = _interopRequireWildcard(__webpack_require__(511));
	
	var _parsePhoneNumber = __webpack_require__(140);
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	// This is a legacy function.
	// Use `findNumbers()` instead.
	function findPhoneNumbers() {
	  var _normalizeArguments = (0, _parsePhoneNumber.normalizeArguments)(arguments),
	      text = _normalizeArguments.text,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _findPhoneNumbers_["default"])(text, options, metadata);
	}
	/**
	 * @return ES6 `for ... of` iterator.
	 */
	
	
	function searchPhoneNumbers() {
	  var _normalizeArguments2 = (0, _parsePhoneNumber.normalizeArguments)(arguments),
	      text = _normalizeArguments2.text,
	      options = _normalizeArguments2.options,
	      metadata = _normalizeArguments2.metadata;
	
	  return (0, _findPhoneNumbers_.searchPhoneNumbers)(text, options, metadata);
	}
	//# sourceMappingURL=findPhoneNumbers.js.map

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = findPhoneNumbersInText;
	exports.getArguments = getArguments;
	
	var _findNumbers = _interopRequireDefault(__webpack_require__(504));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function findPhoneNumbersInText(text, defaultCountry, options, metadata) {
	  var args = getArguments(defaultCountry, options, metadata);
	  return (0, _findNumbers["default"])(text, args.options, args.metadata);
	}
	
	function getArguments(defaultCountry, options, metadata) {
	  if (metadata) {
	    if (defaultCountry) {
	      options = _objectSpread(_objectSpread({}, options), {}, {
	        defaultCountry: defaultCountry
	      });
	    }
	  } else {
	    if (options) {
	      metadata = options;
	
	      if (defaultCountry) {
	        if (is_object(defaultCountry)) {
	          options = defaultCountry;
	        } else {
	          options = {
	            defaultCountry: defaultCountry
	          };
	        }
	      } else {
	        options = undefined;
	      }
	    } else {
	      metadata = defaultCountry;
	      options = undefined;
	    }
	  }
	
	  return {
	    options: _objectSpread(_objectSpread({}, options), {}, {
	      v2: true
	    }),
	    metadata: metadata
	  };
	} // Babel transforms `typeof` into some "branches"
	// so istanbul will show this as "branch not covered".
	
	/* istanbul ignore next */
	
	
	var is_object = function is_object(_) {
	  return _typeof(_) === 'object';
	};
	//# sourceMappingURL=findPhoneNumbersInText.js.map

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhoneNumberSearch = exports.EXTN_PATTERNS_FOR_PARSING = void 0;
	exports["default"] = findPhoneNumbers;
	exports.searchPhoneNumbers = searchPhoneNumbers;
	
	var _constants = __webpack_require__(72);
	
	var _parse_ = _interopRequireDefault(__webpack_require__(121));
	
	var _isViablePhoneNumber = __webpack_require__(168);
	
	var _createExtensionPattern = _interopRequireDefault(__webpack_require__(209));
	
	var _parsePreCandidate = _interopRequireDefault(__webpack_require__(507));
	
	var _isValidPreCandidate = _interopRequireDefault(__webpack_require__(506));
	
	var _isValidCandidate = _interopRequireDefault(__webpack_require__(505));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Regexp of all possible ways to write extensions, for use when parsing. This
	 * will be run as a case-insensitive regexp match. Wide character versions are
	 * also provided after each ASCII version. There are three regular expressions
	 * here. The first covers RFC 3966 format, where the extension is added using
	 * ';ext='. The second more generic one starts with optional white space and
	 * ends with an optional full stop (.), followed by zero or more spaces/tabs
	 * /commas and then the numbers themselves. The other one covers the special
	 * case of American numbers where the extension is written with a hash at the
	 * end, such as '- 503#'. Note that the only capturing groups should be around
	 * the digits that you want to capture as part of the extension, or else parsing
	 * will fail! We allow two options for representing the accented o - the
	 * character itself, and one in the unicode decomposed form with the combining
	 * acute accent.
	 */
	var EXTN_PATTERNS_FOR_PARSING = (0, _createExtensionPattern["default"])('parsing');
	exports.EXTN_PATTERNS_FOR_PARSING = EXTN_PATTERNS_FOR_PARSING;
	var WHITESPACE_IN_THE_BEGINNING_PATTERN = new RegExp('^[' + _constants.WHITESPACE + ']+');
	var PUNCTUATION_IN_THE_END_PATTERN = new RegExp('[' + _constants.VALID_PUNCTUATION + ']+$'); // // Regular expression for getting opening brackets for a valid number
	// // found using `PHONE_NUMBER_START_PATTERN` for prepending those brackets to the number.
	// const BEFORE_NUMBER_DIGITS_PUNCTUATION = new RegExp('[' + OPENING_BRACKETS + ']+' + '[' + WHITESPACE + ']*' + '$')
	
	var VALID_PRECEDING_CHARACTER_PATTERN = /[^a-zA-Z0-9]/;
	
	function findPhoneNumbers(text, options, metadata) {
	  /* istanbul ignore if */
	  if (options === undefined) {
	    options = {};
	  }
	
	  var search = new PhoneNumberSearch(text, options, metadata);
	  var phones = [];
	
	  while (search.hasNext()) {
	    phones.push(search.next());
	  }
	
	  return phones;
	}
	/**
	 * @return ES6 `for ... of` iterator.
	 */
	
	
	function searchPhoneNumbers(text, options, metadata) {
	  /* istanbul ignore if */
	  if (options === undefined) {
	    options = {};
	  }
	
	  var search = new PhoneNumberSearch(text, options, metadata);
	  return _defineProperty({}, Symbol.iterator, function () {
	    return {
	      next: function next() {
	        if (search.hasNext()) {
	          return {
	            done: false,
	            value: search.next()
	          };
	        }
	
	        return {
	          done: true
	        };
	      }
	    };
	  });
	}
	/**
	 * Extracts a parseable phone number including any opening brackets, etc.
	 * @param  {string} text - Input.
	 * @return {object} `{ ?number, ?startsAt, ?endsAt }`.
	 */
	
	
	var PhoneNumberSearch = /*#__PURE__*/function () {
	  function PhoneNumberSearch(text, options, metadata) {
	    _classCallCheck(this, PhoneNumberSearch);
	
	    this.text = text; // If assigning the `{}` default value is moved to the arguments above,
	    // code coverage would decrease for some weird reason.
	
	    this.options = options || {};
	    this.metadata = metadata; // Iteration tristate.
	
	    this.state = 'NOT_READY';
	    this.regexp = new RegExp(_isViablePhoneNumber.VALID_PHONE_NUMBER_WITH_EXTENSION, 'ig');
	  }
	
	  _createClass(PhoneNumberSearch, [{
	    key: "find",
	    value: function find() {
	      var matches = this.regexp.exec(this.text);
	
	      if (!matches) {
	        return;
	      }
	
	      var number = matches[0];
	      var startsAt = matches.index;
	      number = number.replace(WHITESPACE_IN_THE_BEGINNING_PATTERN, '');
	      startsAt += matches[0].length - number.length; // Fixes not parsing numbers with whitespace in the end.
	      // Also fixes not parsing numbers with opening parentheses in the end.
	      // https://github.com/catamphetamine/libphonenumber-js/issues/252
	
	      number = number.replace(PUNCTUATION_IN_THE_END_PATTERN, '');
	      number = (0, _parsePreCandidate["default"])(number);
	      var result = this.parseCandidate(number, startsAt);
	
	      if (result) {
	        return result;
	      } // Tail recursion.
	      // Try the next one if this one is not a valid phone number.
	
	
	      return this.find();
	    }
	  }, {
	    key: "parseCandidate",
	    value: function parseCandidate(number, startsAt) {
	      if (!(0, _isValidPreCandidate["default"])(number, startsAt, this.text)) {
	        return;
	      } // Don't parse phone numbers which are non-phone numbers
	      // due to being part of something else (e.g. a UUID).
	      // https://github.com/catamphetamine/libphonenumber-js/issues/213
	      // Copy-pasted from Google's `PhoneNumberMatcher.js` (`.parseAndValidate()`).
	
	
	      if (!(0, _isValidCandidate["default"])(number, startsAt, this.text, this.options.extended ? 'POSSIBLE' : 'VALID')) {
	        return;
	      } // // Prepend any opening brackets left behind by the
	      // // `PHONE_NUMBER_START_PATTERN` regexp.
	      // const text_before_number = text.slice(this.searching_from, startsAt)
	      // const full_number_starts_at = text_before_number.search(BEFORE_NUMBER_DIGITS_PUNCTUATION)
	      // if (full_number_starts_at >= 0)
	      // {
	      // 	number   = text_before_number.slice(full_number_starts_at) + number
	      // 	startsAt = full_number_starts_at
	      // }
	      //
	      // this.searching_from = matches.lastIndex
	
	
	      var result = (0, _parse_["default"])(number, this.options, this.metadata);
	
	      if (!result.phone) {
	        return;
	      }
	
	      result.startsAt = startsAt;
	      result.endsAt = startsAt + number.length;
	      return result;
	    }
	  }, {
	    key: "hasNext",
	    value: function hasNext() {
	      if (this.state === 'NOT_READY') {
	        this.last_match = this.find();
	
	        if (this.last_match) {
	          this.state = 'READY';
	        } else {
	          this.state = 'DONE';
	        }
	      }
	
	      return this.state === 'READY';
	    }
	  }, {
	    key: "next",
	    value: function next() {
	      // Check the state and find the next match as a side-effect if necessary.
	      if (!this.hasNext()) {
	        throw new Error('No next element');
	      } // Don't retain that memory any longer than necessary.
	
	
	      var result = this.last_match;
	      this.last_match = null;
	      this.state = 'NOT_READY';
	      return result;
	    }
	  }]);
	
	  return PhoneNumberSearch;
	}();
	
	exports.PhoneNumberSearch = PhoneNumberSearch;
	//# sourceMappingURL=findPhoneNumbers_.js.map

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = formatNumber;
	
	var _format_ = _interopRequireDefault(__webpack_require__(513));
	
	var _parse_ = _interopRequireDefault(__webpack_require__(121));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function formatNumber() {
	  var _normalizeArguments = normalizeArguments(arguments),
	      input = _normalizeArguments.input,
	      format = _normalizeArguments.format,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _format_["default"])(input, format, options, metadata);
	} // Sort out arguments
	
	
	function normalizeArguments(args) {
	  var _Array$prototype$slic = Array.prototype.slice.call(args),
	      _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 5),
	      arg_1 = _Array$prototype$slic2[0],
	      arg_2 = _Array$prototype$slic2[1],
	      arg_3 = _Array$prototype$slic2[2],
	      arg_4 = _Array$prototype$slic2[3],
	      arg_5 = _Array$prototype$slic2[4];
	
	  var input;
	  var format;
	  var options;
	  var metadata; // Sort out arguments.
	  // If the phone number is passed as a string.
	  // `format('8005553535', ...)`.
	
	  if (typeof arg_1 === 'string') {
	    // If country code is supplied.
	    // `format('8005553535', 'RU', 'NATIONAL', [options], metadata)`.
	    if (typeof arg_3 === 'string') {
	      format = arg_3;
	
	      if (arg_5) {
	        options = arg_4;
	        metadata = arg_5;
	      } else {
	        metadata = arg_4;
	      }
	
	      input = (0, _parse_["default"])(arg_1, {
	        defaultCountry: arg_2,
	        extended: true
	      }, metadata);
	    } // Just an international phone number is supplied
	    // `format('+78005553535', 'NATIONAL', [options], metadata)`.
	    else {
	      if (typeof arg_2 !== 'string') {
	        throw new Error('`format` argument not passed to `formatNumber(number, format)`');
	      }
	
	      format = arg_2;
	
	      if (arg_4) {
	        options = arg_3;
	        metadata = arg_4;
	      } else {
	        metadata = arg_3;
	      }
	
	      input = (0, _parse_["default"])(arg_1, {
	        extended: true
	      }, metadata);
	    }
	  } // If the phone number is passed as a parsed number object.
	  // `format({ phone: '8005553535', country: 'RU' }, 'NATIONAL', [options], metadata)`.
	  else if (is_object(arg_1)) {
	    input = arg_1;
	    format = arg_2;
	
	    if (arg_4) {
	      options = arg_3;
	      metadata = arg_4;
	    } else {
	      metadata = arg_3;
	    }
	  } else throw new TypeError('A phone number must either be a string or an object of shape { phone, [country] }.'); // Legacy lowercase formats.
	
	
	  if (format === 'International') {
	    format = 'INTERNATIONAL';
	  } else if (format === 'National') {
	    format = 'NATIONAL';
	  }
	
	  return {
	    input: input,
	    format: format,
	    options: options,
	    metadata: metadata
	  };
	} // Babel transforms `typeof` into some "branches"
	// so istanbul will show this as "branch not covered".
	
	/* istanbul ignore next */
	
	
	var is_object = function is_object(_) {
	  return _typeof(_) === 'object';
	};
	//# sourceMappingURL=format.js.map

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = formatNumber;
	
	var _matchesEntirely = _interopRequireDefault(__webpack_require__(139));
	
	var _formatNationalNumberUsingFormat = _interopRequireDefault(__webpack_require__(323));
	
	var _metadata = _interopRequireWildcard(__webpack_require__(43));
	
	var _getIddPrefix = _interopRequireDefault(__webpack_require__(1346));
	
	var _RFC = __webpack_require__(207);
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DEFAULT_OPTIONS = {
	  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
	    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
	  }
	}; // Formats a phone number
	//
	// Example use cases:
	//
	// ```js
	// formatNumber('8005553535', 'RU', 'INTERNATIONAL')
	// formatNumber('8005553535', 'RU', 'INTERNATIONAL', metadata)
	// formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL')
	// formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', metadata)
	// formatNumber('+78005553535', 'NATIONAL')
	// formatNumber('+78005553535', 'NATIONAL', metadata)
	// ```
	//
	
	function formatNumber(input, format, options, metadata) {
	  // Apply default options.
	  if (options) {
	    options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
	  } else {
	    options = DEFAULT_OPTIONS;
	  }
	
	  metadata = new _metadata["default"](metadata);
	
	  if (input.country && input.country !== '001') {
	    // Validate `input.country`.
	    if (!metadata.hasCountry(input.country)) {
	      throw new Error("Unknown country: ".concat(input.country));
	    }
	
	    metadata.country(input.country);
	  } else if (input.countryCallingCode) {
	    metadata.selectNumberingPlan(input.countryCallingCode);
	  } else return input.phone || '';
	
	  var countryCallingCode = metadata.countryCallingCode();
	  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
	  // but Babel has a bug and it says "duplicate variable declaration".
	
	  var number;
	
	  switch (format) {
	    case 'NATIONAL':
	      // Legacy argument support.
	      // (`{ country: ..., phone: '' }`)
	      if (!nationalNumber) {
	        return '';
	      }
	
	      number = formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
	      return addExtension(number, input.ext, metadata, options.formatExtension);
	
	    case 'INTERNATIONAL':
	      // Legacy argument support.
	      // (`{ country: ..., phone: '' }`)
	      if (!nationalNumber) {
	        return "+".concat(countryCallingCode);
	      }
	
	      number = formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
	      number = "+".concat(countryCallingCode, " ").concat(number);
	      return addExtension(number, input.ext, metadata, options.formatExtension);
	
	    case 'E.164':
	      // `E.164` doesn't define "phone number extensions".
	      return "+".concat(countryCallingCode).concat(nationalNumber);
	
	    case 'RFC3966':
	      return (0, _RFC.formatRFC3966)({
	        number: "+".concat(countryCallingCode).concat(nationalNumber),
	        ext: input.ext
	      });
	    // For reference, here's Google's IDD formatter:
	    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
	    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
	    // Who would even need to format phone numbers in IDD format anyway?
	
	    case 'IDD':
	      if (!options.fromCountry) {
	        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
	      }
	
	      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
	      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
	
	    default:
	      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
	  }
	}
	
	function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
	  var format = chooseFormatForNumber(metadata.formats(), number);
	
	  if (!format) {
	    return number;
	  }
	
	  return (0, _formatNationalNumberUsingFormat["default"])(number, format, {
	    useInternationalFormat: formatAs === 'INTERNATIONAL',
	    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
	    carrierCode: carrierCode,
	    metadata: metadata
	  });
	}
	
	function chooseFormatForNumber(availableFormats, nationalNnumber) {
	  for (var _iterator = _createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;) {
	    var format = _step.value;
	
	    // Validate leading digits.
	    // The test case for "else path" could be found by searching for
	    // "format.leadingDigitsPatterns().length === 0".
	    if (format.leadingDigitsPatterns().length > 0) {
	      // The last leading_digits_pattern is used here, as it is the most detailed
	      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
	
	      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
	        continue;
	      }
	    } // Check that the national number matches the phone number format regular expression
	
	
	    if ((0, _matchesEntirely["default"])(nationalNnumber, format.pattern())) {
	      return format;
	    }
	  }
	}
	
	function addExtension(formattedNumber, ext, metadata, formatExtension) {
	  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
	}
	
	function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
	  var fromCountryCallingCode = (0, _metadata.getCountryCallingCode)(fromCountry, metadata.metadata); // When calling within the same country calling code.
	
	  if (fromCountryCallingCode === countryCallingCode) {
	    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
	    // but prefix it with the country calling code.
	
	    if (countryCallingCode === '1') {
	      return countryCallingCode + ' ' + formattedNumber;
	    } // If regions share a country calling code, the country calling code need
	    // not be dialled. This also applies when dialling within a region, so this
	    // if clause covers both these cases. Technically this is the case for
	    // dialling from La Reunion to other overseas departments of France (French
	    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
	    // this edge case for now and for those cases return the version including
	    // country calling code. Details here:
	    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
	    //
	
	
	    return formattedNumber;
	  }
	
	  var iddPrefix = (0, _getIddPrefix["default"])(fromCountry, undefined, metadata.metadata);
	
	  if (iddPrefix) {
	    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
	  }
	}
	//# sourceMappingURL=format_.js.map

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = applyInternationalSeparatorStyle;
	
	var _constants = __webpack_require__(72);
	
	// Removes brackets and replaces dashes with spaces.
	//
	// E.g. "(999) 111-22-33" -> "999 111 22 33"
	//
	// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
	// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
	//
	// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
	// And here's a quote from WikiPedia's "North American Numbering Plan" page:
	// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
	//
	// "The country calling code for all countries participating in the NANP is 1.
	// In international format, an NANP number should be listed as +1 301 555 01 00,
	// where 301 is an area code (Maryland)."
	//
	// I personally prefer the international format without any punctuation.
	// For example, brackets are remnants of the old age, meaning that the
	// phone number part in brackets (so called "area code") can be omitted
	// if dialing within the same "area".
	// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
	// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
	// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
	// He has a couple of seconds to memorize that number until it passes by.
	// If it were spaces instead of hyphens the man wouldn't necessarily get it,
	// but with hyphens instead of spaces the grouping is more explicit.
	// I personally think that hyphens introduce visual clutter,
	// so I prefer replacing them with spaces in international numbers.
	// In the modern age all output is done on displays where spaces are clearly distinguishable
	// so hyphens can be safely replaced with spaces without losing any legibility.
	//
	function applyInternationalSeparatorStyle(formattedNumber) {
	  return formattedNumber.replace(new RegExp("[".concat(_constants.VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
	}
	//# sourceMappingURL=applyInternationalSeparatorStyle.js.map

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = extractCountryCallingCode;
	
	var _stripIddPrefix = _interopRequireDefault(__webpack_require__(324));
	
	var _extractCountryCallingCodeFromInternationalNumberWithoutPlusSign = _interopRequireDefault(__webpack_require__(322));
	
	var _metadata = _interopRequireDefault(__webpack_require__(43));
	
	var _constants = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Converts a phone number digits (possibly with a `+`)
	 * into a calling code and the rest phone number digits.
	 * The "rest phone number digits" could include
	 * a national prefix, carrier code, and national
	 * (significant) number.
	 * @param  {string} number — Phone number digits (possibly with a `+`).
	 * @param  {string} [country] — Default country.
	 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
	 * @param  {object} metadata
	 * @return {object} `{ countryCallingCode: string?, number: string }`
	 * @example
	 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
	 * extractCountryCallingCode('2133734253', 'US', null, metadata)
	 * extractCountryCallingCode('2133734253', null, '1', metadata)
	 * extractCountryCallingCode('+12133734253', null, null, metadata)
	 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
	 */
	function extractCountryCallingCode(number, country, callingCode, metadata) {
	  if (!number) {
	    return {};
	  } // If this is not an international phone number,
	  // then either extract an "IDD" prefix, or extract a
	  // country calling code from a number by autocorrecting it
	  // by prepending a leading `+` in cases when it starts
	  // with the country calling code.
	  // https://wikitravel.org/en/International_dialling_prefix
	  // https://github.com/catamphetamine/libphonenumber-js/issues/376
	
	
	  if (number[0] !== '+') {
	    // Convert an "out-of-country" dialing phone number
	    // to a proper international phone number.
	    var numberWithoutIDD = (0, _stripIddPrefix["default"])(number, country, callingCode, metadata); // If an IDD prefix was stripped then
	    // convert the number to international one
	    // for subsequent parsing.
	
	    if (numberWithoutIDD && numberWithoutIDD !== number) {
	      number = '+' + numberWithoutIDD;
	    } else {
	      // Check to see if the number starts with the country calling code
	      // for the default country. If so, we remove the country calling code,
	      // and do some checks on the validity of the number before and after.
	      // https://github.com/catamphetamine/libphonenumber-js/issues/376
	      if (country || callingCode) {
	        var _extractCountryCallin = (0, _extractCountryCallingCodeFromInternationalNumberWithoutPlusSign["default"])(number, country, callingCode, metadata),
	            countryCallingCode = _extractCountryCallin.countryCallingCode,
	            shorterNumber = _extractCountryCallin.number;
	
	        if (countryCallingCode) {
	          return {
	            countryCallingCode: countryCallingCode,
	            number: shorterNumber
	          };
	        }
	      }
	
	      return {
	        number: number
	      };
	    }
	  } // Fast abortion: country codes do not begin with a '0'
	
	
	  if (number[1] === '0') {
	    return {};
	  }
	
	  metadata = new _metadata["default"](metadata); // The thing with country phone codes
	  // is that they are orthogonal to each other
	  // i.e. there's no such country phone code A
	  // for which country phone code B exists
	  // where B starts with A.
	  // Therefore, while scanning digits,
	  // if a valid country code is found,
	  // that means that it is the country code.
	  //
	
	  var i = 2;
	
	  while (i - 1 <= _constants.MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
	    var _countryCallingCode = number.slice(1, i);
	
	    if (metadata.hasCallingCode(_countryCallingCode)) {
	      metadata.selectNumberingPlan(_countryCallingCode);
	      return {
	        countryCallingCode: _countryCallingCode,
	        number: number.slice(i)
	      };
	    }
	
	    i++;
	  }
	
	  return {};
	}
	//# sourceMappingURL=extractCountryCallingCode.js.map

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = extractNationalNumber;
	
	var _extractNationalNumberFromPossiblyIncompleteNumber = _interopRequireDefault(__webpack_require__(517));
	
	var _matchesEntirely = _interopRequireDefault(__webpack_require__(139));
	
	var _checkNumberLength = _interopRequireDefault(__webpack_require__(208));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Strips national prefix and carrier code from a complete phone number.
	 * The difference from the non-"FromCompleteNumber" function is that
	 * it won't extract national prefix if the resultant number is too short
	 * to be a complete number for the selected phone numbering plan.
	 * @param  {string} number — Complete phone number digits.
	 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
	 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
	 */
	function extractNationalNumber(number, metadata) {
	  // Parsing national prefixes and carrier codes
	  // is only required for local phone numbers
	  // but some people don't understand that
	  // and sometimes write international phone numbers
	  // with national prefixes (or maybe even carrier codes).
	  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
	  // Google's original library forgives such mistakes
	  // and so does this library, because it has been requested:
	  // https://github.com/catamphetamine/libphonenumber-js/issues/127
	  var _extractNationalNumbe = (0, _extractNationalNumberFromPossiblyIncompleteNumber["default"])(number, metadata),
	      carrierCode = _extractNationalNumbe.carrierCode,
	      nationalNumber = _extractNationalNumbe.nationalNumber;
	
	  if (nationalNumber !== number) {
	    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
	      // Don't strip the national prefix.
	      return {
	        nationalNumber: number
	      };
	    } // Check the national (significant) number length after extracting national prefix and carrier code.
	    // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
	
	
	    if (metadata.possibleLengths()) {
	      // The number remaining after stripping the national prefix and carrier code
	      // should be long enough to have a possible length for the country.
	      // Otherwise, don't strip the national prefix and carrier code,
	      // since the original number could be a valid number.
	      // This check has been copy-pasted "as is" from Google's original library:
	      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
	      // It doesn't check for the "possibility" of the original `number`.
	      // I guess it's fine not checking that one. It works as is anyway.
	      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata)) {
	        // Don't strip the national prefix.
	        return {
	          nationalNumber: number
	        };
	      }
	    }
	  }
	
	  return {
	    nationalNumber: nationalNumber,
	    carrierCode: carrierCode
	  };
	} // In some countries, the same digit could be a national prefix
	// or a leading digit of a valid phone number.
	// For example, in Russia, national prefix is `8`,
	// and also `800 555 35 35` is a valid number
	// in which `8` is not a national prefix, but the first digit
	// of a national (significant) number.
	// Same's with Belarus:
	// `82004910060` is a valid national (significant) number,
	// but `2004910060` is not.
	// To support such cases (to prevent the code from always stripping
	// national prefix), a condition is imposed: a national prefix
	// is not extracted when the original number is "viable" and the
	// resultant number is not, a "viable" national number being the one
	// that matches `national_number_pattern`.
	
	
	function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
	  // The equivalent in Google's code is:
	  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
	  if ((0, _matchesEntirely["default"])(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, _matchesEntirely["default"])(nationalNumberAfter, metadata.nationalNumberPattern())) {
	    return false;
	  } // This "is possible" national number (length) check has been commented out
	  // because it's superceded by the (effectively) same check done in the
	  // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
	  // In other words, why run the same check twice if it could only be run once.
	  // // Check the national (significant) number length after extracting national prefix and carrier code.
	  // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
	  // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
	  // if (metadata.possibleLengths()) {
	  // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
	  // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
	  // 		return false
	  // 	}
	  // }
	
	
	  return true;
	}
	
	function isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
	  switch ((0, _checkNumberLength["default"])(nationalNumber, metadata)) {
	    case 'TOO_SHORT':
	    case 'INVALID_LENGTH':
	      // This library ignores "local-only" phone numbers (for simplicity).
	      // See the readme for more info on what are "local-only" phone numbers.
	      // case 'IS_POSSIBLE_LOCAL_ONLY':
	      return false;
	
	    default:
	      return true;
	  }
	}
	//# sourceMappingURL=extractNationalNumber.js.map

/***/ }),
/* 517 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = extractNationalNumberFromPossiblyIncompleteNumber;
	
	/**
	 * Strips any national prefix (such as 0, 1) present in a
	 * (possibly incomplete) number provided.
	 * "Carrier codes" are only used  in Colombia and Brazil,
	 * and only when dialing within those countries from a mobile phone to a fixed line number.
	 * Sometimes it won't actually strip national prefix
	 * and will instead prepend some digits to the `number`:
	 * for example, when number `2345678` is passed with `VI` country selected,
	 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
	 * @param {string} number — National number digits.
	 * @param {object} metadata — Metadata with country selected.
	 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
	 */
	function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
	  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
	    // See METADATA.md for the description of
	    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
	    // Attempt to parse the first digits as a national prefix.
	    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
	    var prefixMatch = prefixPattern.exec(number);
	
	    if (prefixMatch) {
	      var nationalNumber;
	      var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
	      // If a `national_prefix_for_parsing` has any "capturing groups"
	      // then it means that the national (significant) number is equal to
	      // those "capturing groups" transformed via `national_prefix_transform_rule`,
	      // and nothing could be said about the actual national prefix:
	      // what is it and was it even there.
	      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
	      // then everything it matches is a national prefix.
	      // To determine whether `national_prefix_for_parsing` matched any
	      // "capturing groups", the value of the result of calling `.exec()`
	      // is looked at, and if it has non-undefined values where there're
	      // "capturing groups" in the regular expression, then it means
	      // that "capturing groups" have been matched.
	      // It's not possible to tell whether there'll be any "capturing gropus"
	      // before the matching process, because a `national_prefix_for_parsing`
	      // could exhibit both behaviors.
	
	      var capturedGroupsCount = prefixMatch.length - 1;
	      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
	
	      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
	        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
	        // then carrier code is the second one.
	
	        if (capturedGroupsCount > 1) {
	          carrierCode = prefixMatch[1];
	        }
	      } // If there're no "capturing groups",
	      // or if there're "capturing groups" but no
	      // `national_prefix_transform_rule`,
	      // then just strip the national prefix from the number,
	      // and possibly a carrier code.
	      // Seems like there could be more.
	      else {
	        // `prefixBeforeNationalNumber` is the whole substring matched by
	        // the `national_prefix_for_parsing` regular expression.
	        // There seem to be no guarantees that it's just a national prefix.
	        // For example, if there's a carrier code, it's gonna be a
	        // part of `prefixBeforeNationalNumber` too.
	        var prefixBeforeNationalNumber = prefixMatch[0];
	        nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
	        // then carrier code is the first one.
	
	        if (hasCapturedGroups) {
	          carrierCode = prefixMatch[1];
	        }
	      } // Tries to guess whether a national prefix was present in the input.
	      // This is not something copy-pasted from Google's library:
	      // they don't seem to have an equivalent for that.
	      // So this isn't an "officially approved" way of doing something like that.
	      // But since there seems no other existing method, this library uses it.
	
	
	      var nationalPrefix;
	
	      if (hasCapturedGroups) {
	        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
	        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
	        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
	        // and the rest of the phone number is `23456789`.
	        // The national number is transformed via `9$1` to `91123456789`.
	        // National prefix `0` is detected being present at the start.
	        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
	
	        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
	          nationalPrefix = metadata.numberingPlan.nationalPrefix();
	        }
	      } else {
	        nationalPrefix = prefixMatch[0];
	      }
	
	      return {
	        nationalNumber: nationalNumber,
	        nationalPrefix: nationalPrefix,
	        carrierCode: carrierCode
	      };
	    }
	  }
	
	  return {
	    nationalNumber: number
	  };
	}
	//# sourceMappingURL=extractNationalNumberFromPossiblyIncompleteNumber.js.map

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getCountryByCallingCode;
	
	var _metadata = _interopRequireDefault(__webpack_require__(43));
	
	var _getNumberType = _interopRequireDefault(__webpack_require__(210));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
	
	function getCountryByCallingCode(callingCode, nationalPhoneNumber, metadata) {
	  /* istanbul ignore if */
	  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
	    if (metadata.isNonGeographicCallingCode(callingCode)) {
	      return '001';
	    }
	  } // Is always non-empty, because `callingCode` is always valid
	
	
	  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
	
	  if (!possibleCountries) {
	    return;
	  } // If there's just one country corresponding to the country code,
	  // then just return it, without further phone number digits validation.
	
	
	  if (possibleCountries.length === 1) {
	    return possibleCountries[0];
	  }
	
	  return selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata.metadata);
	}
	
	function selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata) {
	  // Re-create `metadata` because it will be selecting a `country`.
	  metadata = new _metadata["default"](metadata);
	
	  for (var _iterator = _createForOfIteratorHelperLoose(possibleCountries), _step; !(_step = _iterator()).done;) {
	    var country = _step.value;
	    metadata.country(country); // Leading digits check would be the simplest and fastest one.
	    // Leading digits patterns are only defined for about 20% of all countries.
	    // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
	    // Matching "leading digits" is a sufficient but not necessary condition.
	
	    if (metadata.leadingDigits()) {
	      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
	        return country;
	      }
	    } // Else perform full validation with all of those
	    // fixed-line/mobile/etc regular expressions.
	    else if ((0, _getNumberType["default"])({
	      phone: nationalPhoneNumber,
	      country: country
	    }, undefined, metadata.metadata)) {
	      return country;
	    }
	  }
	}
	//# sourceMappingURL=getCountryByCallingCode.js.map

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isValidNumberForRegion;
	
	var _validate_ = _interopRequireDefault(__webpack_require__(211));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Checks if a given phone number is valid within a given region.
	 * Is just an alias for `phoneNumber.isValid() && phoneNumber.country === country`.
	 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
	 */
	function isValidNumberForRegion(input, country, options, metadata) {
	  // If assigning the `{}` default value is moved to the arguments above,
	  // code coverage would decrease for some weird reason.
	  options = options || {};
	  return input.country === country && (0, _validate_["default"])(input, options, metadata);
	}
	//# sourceMappingURL=isValidNumberForRegion_.js.map

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parseNumber;
	
	var _parse_ = _interopRequireDefault(__webpack_require__(121));
	
	var _parsePhoneNumber = __webpack_require__(140);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// `options`:
	//  {
	//    country:
	//    {
	//      restrict - (a two-letter country code)
	//                 the phone number must be in this country
	//
	//      default - (a two-letter country code)
	//                default country to use for phone number parsing and validation
	//                (if no country code could be derived from the phone number)
	//    }
	//  }
	//
	// Returns `{ country, number }`
	//
	// Example use cases:
	//
	// ```js
	// parse('8 (800) 555-35-35', 'RU')
	// parse('8 (800) 555-35-35', 'RU', metadata)
	// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
	// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
	// parse('+7 800 555 35 35')
	// parse('+7 800 555 35 35', metadata)
	// ```
	//
	function parseNumber() {
	  var _normalizeArguments = (0, _parsePhoneNumber.normalizeArguments)(arguments),
	      text = _normalizeArguments.text,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _parse_["default"])(text, options, metadata);
	}
	//# sourceMappingURL=parse.js.map

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parsePhoneNumberFromString;
	
	var _parsePhoneNumber = __webpack_require__(140);
	
	var _parsePhoneNumberFromString_ = _interopRequireDefault(__webpack_require__(1350));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function parsePhoneNumberFromString() {
	  var _normalizeArguments = (0, _parsePhoneNumber.normalizeArguments)(arguments),
	      text = _normalizeArguments.text,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _parsePhoneNumberFromString_["default"])(text, options, metadata);
	}
	//# sourceMappingURL=parsePhoneNumberFromString.js.map

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parsePhoneNumber;
	
	var _parse_ = _interopRequireDefault(__webpack_require__(121));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function parsePhoneNumber(text, options, metadata) {
	  return (0, _parse_["default"])(text, _objectSpread(_objectSpread({}, options), {}, {
	    v2: true
	  }), metadata);
	}
	//# sourceMappingURL=parsePhoneNumber_.js.map

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = searchNumbers;
	
	var _parsePhoneNumber = __webpack_require__(140);
	
	var _PhoneNumberMatcher = _interopRequireDefault(__webpack_require__(319));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * @return ES6 `for ... of` iterator.
	 */
	function searchNumbers() {
	  var _normalizeArguments = (0, _parsePhoneNumber.normalizeArguments)(arguments),
	      text = _normalizeArguments.text,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  var matcher = new _PhoneNumberMatcher["default"](text, options, metadata);
	  return _defineProperty({}, Symbol.iterator, function () {
	    return {
	      next: function next() {
	        if (matcher.hasNext()) {
	          return {
	            done: false,
	            value: matcher.next()
	          };
	        }
	
	        return {
	          done: true
	        };
	      }
	    };
	  });
	}
	//# sourceMappingURL=searchNumbers.js.map

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	// The `/custom` export has been long deprecated: use `/core` export instead.
	
	'use strict'
	
	var parsePhoneNumberFromString = __webpack_require__(521).default
	
	// ES5 `require()` "default" "interoperability" hack.
	// https://github.com/babel/babel/issues/2212#issuecomment-131827986
	// An alternative approach:
	// https://www.npmjs.com/package/babel-plugin-add-module-exports
	exports = module.exports = parsePhoneNumberFromString
	exports['default'] = parsePhoneNumberFromString
	
	exports.ParseError = __webpack_require__(318).default
	var parsePhoneNumberWithError = __webpack_require__(140).default
	// `parsePhoneNumber()` named export has been renamed to `parsePhoneNumberWithError()`.
	exports.parsePhoneNumber = parsePhoneNumberWithError
	exports.parsePhoneNumberWithError = parsePhoneNumberWithError
	
	// `parsePhoneNumberFromString()` named export is now considered legacy:
	// it has been promoted to a default export due to being too verbose.
	exports.parsePhoneNumberFromString = parsePhoneNumberFromString
	
	// Deprecated: remove `parse()` export in 2.0.0.
	// (renamed to `parseNumber()`)
	exports.parse              = __webpack_require__(520).default
	exports.parseNumber        = __webpack_require__(520).default
	// Deprecated: remove `format()` export in 2.0.0.
	// (renamed to `formatNumber()`)
	exports.format             = __webpack_require__(512).default
	exports.formatNumber       = __webpack_require__(512).default
	exports.getNumberType      = __webpack_require__(321).default
	exports.getExampleNumber   = __webpack_require__(1344).default
	exports.isValidNumber      = __webpack_require__(1353).default
	exports.isValidNumberForRegion = __webpack_require__(1349).default
	
	// Deprecated.
	exports.isPossibleNumber   = __webpack_require__(1348).default
	
	exports.findNumbers        = __webpack_require__(504).default
	exports.searchNumbers      = __webpack_require__(523).default
	exports.findPhoneNumbersInText = __webpack_require__(510).default
	exports.searchPhoneNumbersInText = __webpack_require__(1351).default
	exports.PhoneNumberMatcher = __webpack_require__(319).default
	
	// Deprecated.
	exports.findPhoneNumbers   = __webpack_require__(509).default
	exports.searchPhoneNumbers = __webpack_require__(509).searchPhoneNumbers
	exports.PhoneNumberSearch  = __webpack_require__(511).PhoneNumberSearch
	
	exports.AsYouType = __webpack_require__(502).default
	
	exports.formatIncompletePhoneNumber = __webpack_require__(1342).default
	exports.parseIncompletePhoneNumber  = __webpack_require__(326).default
	exports.parsePhoneNumberCharacter   = __webpack_require__(326).parsePhoneNumberCharacter
	exports.parseDigits   = __webpack_require__(120).default
	
	// Deprecated: `DIGITS` were used by `react-phone-number-input`.
	// Replaced by `parseDigits()`.
	//
	// Deprecated: `DIGIT_PLACEHOLDER` was used by `react-phone-number-input`.
	// Not used anymore.
	//
	exports.DIGITS            = __webpack_require__(120).DIGITS
	exports.DIGIT_PLACEHOLDER = __webpack_require__(503).DIGIT_PLACEHOLDER
	
	exports.getCountries = __webpack_require__(1343).default
	exports.getCountryCallingCode = __webpack_require__(320).default
	// `getPhoneCode` name is deprecated, use `getCountryCallingCode` instead.
	exports.getPhoneCode = exports.getCountryCallingCode
	
	exports.Metadata = __webpack_require__(43).default
	exports.isSupportedCountry = __webpack_require__(43).isSupportedCountry
	exports.getExtPrefix = __webpack_require__(43).getExtPrefix
	
	exports.parseRFC3966 = __webpack_require__(207).parseRFC3966
	exports.formatRFC3966 = __webpack_require__(207).formatRFC3966
	
	// exports['default'] = ...

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object ? baseValues(object, keys(object)) : [];
	}
	
	module.exports = includes;


/***/ }),
/* 526 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ }),
/* 527 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return basePickBy(object, props, function(value, key) {
	    return key in object;
	  });
	}
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick from.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, props, predicate) {
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key];
	
	    if (predicate(value, key)) {
	      result[key] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = baseRest(function(object, props) {
	  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
	});
	
	module.exports = pick;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(122),
	    root = __webpack_require__(53);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(53);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(122),
	    root = __webpack_require__(53);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 531 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 532 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(551),
	    isArguments = __webpack_require__(178),
	    isArray = __webpack_require__(28),
	    isIndex = __webpack_require__(225);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 534 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(174);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (typeof key == 'number' && value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(339),
	    keys = __webpack_require__(126);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(331),
	    arrayIncludes = __webpack_require__(332),
	    arrayIncludesWith = __webpack_require__(532),
	    arrayMap = __webpack_require__(101),
	    baseUnary = __webpack_require__(171),
	    cacheHas = __webpack_require__(553);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(142);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),
/* 539 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1368),
	    keys = __webpack_require__(126);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(554),
	    isKey = __webpack_require__(226),
	    toKey = __webpack_require__(123);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(216),
	    isArray = __webpack_require__(28);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(539),
	    baseIsNaN = __webpack_require__(1374);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(227),
	    nativeKeys = __webpack_require__(569);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(52),
	    isPrototype = __webpack_require__(227),
	    nativeKeysIn = __webpack_require__(1448);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(142),
	    isArrayLike = __webpack_require__(103);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(548);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return basePickBy(object, props, function(value, key) {
	    return key in object;
	  });
	}
	
	module.exports = basePick;


/***/ }),
/* 548 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick from.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, props, predicate) {
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key];
	
	    if (predicate(value, key)) {
	      result[key] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ }),
/* 549 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(177),
	    metaMap = __webpack_require__(568);
	
	/**
	 * The base implementation of `setData` without support for hot loop detection.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ }),
/* 551 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(331),
	    arrayIncludes = __webpack_require__(332),
	    arrayIncludesWith = __webpack_require__(532),
	    cacheHas = __webpack_require__(553),
	    createSet = __webpack_require__(1414),
	    setToArray = __webpack_require__(230);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ }),
/* 553 */
/***/ (function(module, exports) {

	/**
	 * Checks if a cache value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(28),
	    stringToPath = __webpack_require__(573);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	module.exports = castPath;


/***/ }),
/* 555 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ }),
/* 556 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(555),
	    composeArgsRight = __webpack_require__(556),
	    countHolders = __webpack_require__(1403),
	    createCtor = __webpack_require__(220),
	    createRecurry = __webpack_require__(558),
	    getHolder = __webpack_require__(342),
	    reorder = __webpack_require__(1450),
	    replaceHolders = __webpack_require__(229),
	    root = __webpack_require__(53);
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    ARY_FLAG = 128,
	    FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & ARY_FLAG,
	      isBind = bitmask & BIND_FLAG,
	      isBindKey = bitmask & BIND_KEY_FLAG,
	      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	      isFlip = bitmask & FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybrid;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(564),
	    setData = __webpack_require__(571),
	    setWrapToString = __webpack_require__(572);
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	  if (!(bitmask & CURRY_BOUND_FLAG)) {
	    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	module.exports = createRecurry;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(331),
	    arraySome = __webpack_require__(534);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 560 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(542),
	    getSymbolsIn = __webpack_require__(1421),
	    keysIn = __webpack_require__(589);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(1449);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(554),
	    isArguments = __webpack_require__(178),
	    isArray = __webpack_require__(28),
	    isIndex = __webpack_require__(225),
	    isKey = __webpack_require__(226),
	    isLength = __webpack_require__(349),
	    toKey = __webpack_require__(123);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(327),
	    getData = __webpack_require__(341),
	    getFuncName = __webpack_require__(562),
	    lodash = __webpack_require__(1514);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(52);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 566 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 567 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(530);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(345);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(560);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(192)(module)))

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(550),
	    now = __webpack_require__(590);
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 150,
	    HOT_SPAN = 16;
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = (function() {
	  var count = 0,
	      lastCalled = 0;
	
	  return function(key, value) {
	    var stamp = now(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return key;
	      }
	    } else {
	      count = 0;
	    }
	    return baseSetData(key, value);
	  };
	}());
	
	module.exports = setData;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1469),
	    defineProperty = __webpack_require__(1416),
	    getWrapDetails = __webpack_require__(1423),
	    identity = __webpack_require__(177),
	    insertWrapDetails = __webpack_require__(1433),
	    updateWrapDetails = __webpack_require__(1462);
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	var setWrapToString = !defineProperty ? identity : function(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return defineProperty(wrapper, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)))
	  });
	};
	
	module.exports = setWrapToString;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1491),
	    toString = __webpack_require__(127);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 574 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 575 */
/***/ (function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array ? array.length : 0,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(1410),
	    findIndex = __webpack_require__(347);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 577 */
/***/ (function(module, exports) {

	module.exports = {
	  'cap': false,
	  'curry': false,
	  'fixed': false,
	  'immutable': false,
	  'rearg': false
	};


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(61),
	    func = convert('isEmpty', __webpack_require__(45), __webpack_require__(577));
	
	func.placeholder = __webpack_require__(56);
	module.exports = func;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(61),
	    func = convert('join', __webpack_require__(588));
	
	func.placeholder = __webpack_require__(56);
	module.exports = func;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(61),
	    func = convert('last', __webpack_require__(237), __webpack_require__(577));
	
	func.placeholder = __webpack_require__(56);
	module.exports = func;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(231);


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(61),
	    func = convert('sortBy', __webpack_require__(351));
	
	func.placeholder = __webpack_require__(56);
	module.exports = func;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(1370),
	    hasPath = __webpack_require__(563);
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}
	
	module.exports = has;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(543),
	    toInteger = __webpack_require__(106);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Gets the index at which the first occurrence of `value` is found in `array`
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. If `fromIndex` is negative, it's used as the
	 * offset from the end of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 * @example
	 *
	 * _.indexOf([1, 2, 1, 2], 2);
	 * // => 1
	 *
	 * // Search from the `fromIndex`.
	 * _.indexOf([1, 2, 1, 2], 2, 2);
	 * // => 3
	 */
	function indexOf(array, value, fromIndex) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseIndexOf(array, value, index);
	}
	
	module.exports = indexOf;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(53),
	    stubFalse = __webpack_require__(1503);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(192)(module)))

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsRegExp = __webpack_require__(1376),
	    baseUnary = __webpack_require__(171),
	    nodeUtil = __webpack_require__(570);
	
	/* Node.js helper references. */
	var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
	
	/**
	 * Checks if `value` is classified as a `RegExp` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 * @example
	 *
	 * _.isRegExp(/abc/);
	 * // => true
	 *
	 * _.isRegExp('/abc/');
	 * // => false
	 */
	var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	module.exports = isRegExp;


/***/ }),
/* 587 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ }),
/* 588 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeJoin = arrayProto.join;
	
	/**
	 * Converts all elements in `array` into a string separated by `separator`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to convert.
	 * @param {string} [separator=','] The element separator.
	 * @returns {string} Returns the joined string.
	 * @example
	 *
	 * _.join(['a', 'b', 'c'], '~');
	 * // => 'a~b~c'
	 */
	function join(array, separator) {
	  return array ? nativeJoin.call(array, separator) : '';
	}
	
	module.exports = join;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(533),
	    baseKeysIn = __webpack_require__(545),
	    isArrayLike = __webpack_require__(103);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(53);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(217),
	    baseEach = __webpack_require__(142),
	    baseIteratee = __webpack_require__(44),
	    baseReduce = __webpack_require__(1386),
	    isArray = __webpack_require__(28);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ }),
/* 592 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(594);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(52),
	    isSymbol = __webpack_require__(144);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                '_'
	            ),
	            standalone:
	                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                    '_'
	                ),
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Carousel = __webpack_require__(1523);
	
	module.exports = Carousel;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(1525);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(862);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1535);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 734 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 735 */
/***/ (function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	module.exports = {
	    'default': 'RFC3986',
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return value;
	        }
	    },
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};


/***/ }),
/* 736 */
/***/ (function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	exports.arrayToObject = function (source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	exports.merge = function (target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if (typeof target === 'object') {
	            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = exports.arrayToObject(target, options);
	    }
	
	    if (Array.isArray(target) && Array.isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                if (target[i] && typeof target[i] === 'object') {
	                    target[i] = exports.merge(target[i], item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (Object.prototype.hasOwnProperty.call(acc, key)) {
	            acc[key] = exports.merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	exports.decode = function (str) {
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	exports.encode = function (str) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D || // -
	            c === 0x2E || // .
	            c === 0x5F || // _
	            c === 0x7E || // ~
	            (c >= 0x30 && c <= 0x39) || // 0-9
	            (c >= 0x41 && c <= 0x5A) || // a-z
	            (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)] + hexTable[0x80 | ((c >> 12) & 0x3F)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]; // eslint-disable-line max-len
	    }
	
	    return out;
	};
	
	exports.compact = function (obj, references) {
	    if (typeof obj !== 'object' || obj === null) {
	        return obj;
	    }
	
	    var refs = references || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0; i < obj.length; ++i) {
	            if (obj[i] && typeof obj[i] === 'object') {
	                compacted.push(exports.compact(obj[i], refs));
	            } else if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    keys.forEach(function (key) {
	        obj[key] = exports.compact(obj[key], refs);
	    });
	
	    return obj;
	};
	
	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	exports.isBuffer = function (obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = /*#__PURE__*/__webpack_require__(360);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	/**
	 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
	 * terms, to at least one element of the given list; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Boolean
	 * @param {Object} a The item to compare against.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
	 * @see R.any
	 * @example
	 *
	 *      R.contains(3, [1, 2, 3]); //=> true
	 *      R.contains(4, [1, 2, 3]); //=> false
	 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
	 *      R.contains([42], [[42]]); //=> true
	 */
	
	
	var contains = /*#__PURE__*/_curry2(_contains);
	module.exports = contains;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	/**
	 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
	 * otherwise the first argument is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {a} default The default value.
	 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
	 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
	 * @example
	 *
	 *      var defaultTo42 = R.defaultTo(42);
	 *
	 *      defaultTo42(null);  //=> 42
	 *      defaultTo42(undefined);  //=> 42
	 *      defaultTo42('Ramda');  //=> 'Ramda'
	 *      // parseInt('string') results in NaN
	 *      defaultTo42(parseInt('string')); //=> 42
	 */
	
	
	var defaultTo = /*#__PURE__*/_curry2(function defaultTo(d, v) {
	  return v == null || v !== v ? d : v;
	});
	module.exports = defaultTo;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _isFunction = /*#__PURE__*/__webpack_require__(361);
	
	var lift = /*#__PURE__*/__webpack_require__(362);
	
	var or = /*#__PURE__*/__webpack_require__(1579);
	
	/**
	 * A function wrapping calls to the two functions in an `||` operation,
	 * returning the result of the first function if it is truth-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * truth-y value.
	 *
	 * In addition to functions, `R.either` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f a predicate
	 * @param {Function} g another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
	 * @see R.or
	 * @example
	 *
	 *      var gt10 = x => x > 10;
	 *      var even = x => x % 2 === 0;
	 *      var f = R.either(gt10, even);
	 *      f(101); //=> true
	 *      f(8); //=> true
	 */
	
	
	var either = /*#__PURE__*/_curry2(function either(f, g) {
	  return _isFunction(f) ? function _either() {
	    return f.apply(this, arguments) || g.apply(this, arguments);
	  } : lift(or)(f, g);
	});
	module.exports = either;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(183);
	
	var _xfind = /*#__PURE__*/__webpack_require__(1568);
	
	/**
	 * Returns the first element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Dispatches to the `find` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 *        desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
	 *      R.find(R.propEq('a', 4))(xs); //=> undefined
	 */
	
	
	var find = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['find'], _xfind, function find(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx += 1;
	  }
	}));
	module.exports = find;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	/**
	 * Returns true if its arguments are identical, false otherwise. Values are
	 * identical if they reference the same memory. `NaN` is identical to `NaN`;
	 * `0` and `-0` are not identical.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      var o = {};
	 *      R.identical(o, o); //=> true
	 *      R.identical(1, 1); //=> true
	 *      R.identical(1, '1'); //=> false
	 *      R.identical([], []); //=> false
	 *      R.identical(0, -0); //=> false
	 *      R.identical(NaN, NaN); //=> true
	 */
	
	
	var identical = /*#__PURE__*/_curry2(function identical(a, b) {
	  // SameValue algorithm
	  if (a === b) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return a !== 0 || 1 / a === 1 / b;
	  } else {
	    // Step 6.a: NaN == NaN
	    return a !== a && b !== b;
	  }
	});
	module.exports = identical;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var _identity = /*#__PURE__*/__webpack_require__(1558);
	
	/**
	 * A function that does nothing but return the parameter supplied to it. Good
	 * as a default or placeholder function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x The value to return.
	 * @return {*} The input value, `x`.
	 * @example
	 *
	 *      R.identity(1); //=> 1
	 *
	 *      var obj = {};
	 *      R.identity(obj) === obj; //=> true
	 * @symb R.identity(a) = a
	 */
	
	
	var identity = /*#__PURE__*/_curry1(_identity);
	module.exports = identity;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArray = /*#__PURE__*/__webpack_require__(184);
	
	/**
	 * This checks whether a function has a [methodname] function. If it isn't an
	 * array it will execute that function otherwise it will default to the ramda
	 * implementation.
	 *
	 * @private
	 * @param {Function} fn ramda implemtation
	 * @param {String} methodname property to check for a custom implementation
	 * @return {Object} Whatever the return value of the method is.
	 */
	
	
	function _checkForMethod(methodname, fn) {
	  return function () {
	    var length = arguments.length;
	    if (length === 0) {
	      return fn();
	    }
	    var obj = arguments[length - 1];
	    return _isArray(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
	  };
	}
	module.exports = _checkForMethod;

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	function _complement(f) {
	  return function () {
	    return !f.apply(this, arguments);
	  };
	}
	module.exports = _complement;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	var _has = /*#__PURE__*/__webpack_require__(147);
	
	var toString = Object.prototype.toString;
	var _isArguments = function () {
	  return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
	    return toString.call(x) === '[object Arguments]';
	  } : function _isArguments(x) {
	    return _has('callee', x);
	  };
	};
	
	module.exports = _isArguments;

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	function _isObject(x) {
	  return Object.prototype.toString.call(x) === '[object Object]';
	}
	module.exports = _isObject;

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	function _isString(x) {
	  return Object.prototype.toString.call(x) === '[object String]';
	}
	module.exports = _isString;

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	function _map(fn, functor) {
	  var idx = 0;
	  var len = functor.length;
	  var result = Array(len);
	  while (idx < len) {
	    result[idx] = fn(functor[idx]);
	    idx += 1;
	  }
	  return result;
	}
	module.exports = _map;

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	function _reduced(x) {
	  return x && x['@@transducer/reduced'] ? x : {
	    '@@transducer/value': x,
	    '@@transducer/reduced': true
	  };
	}
	module.exports = _reduced;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _reduced = /*#__PURE__*/__webpack_require__(749);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(242);
	
	var XAny = /*#__PURE__*/function () {
	
	  function XAny(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.any = false;
	  }
	  XAny.prototype['@@transducer/init'] = _xfBase.init;
	  XAny.prototype['@@transducer/result'] = function (result) {
	    if (!this.any) {
	      result = this.xf['@@transducer/step'](result, false);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAny.prototype['@@transducer/step'] = function (result, input) {
	    if (this.f(input)) {
	      this.any = true;
	      result = _reduced(this.xf['@@transducer/step'](result, true));
	    }
	    return result;
	  };
	
	  return XAny;
	}();
	
	var _xany = /*#__PURE__*/_curry2(function _xany(f, xf) {
	  return new XAny(f, xf);
	});
	module.exports = _xany;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	/**
	 * Checks if the input value is `null` or `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Type
	 * @sig * -> Boolean
	 * @param {*} x The value to test.
	 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
	 * @example
	 *
	 *      R.isNil(null); //=> true
	 *      R.isNil(undefined); //=> true
	 *      R.isNil(0); //=> false
	 *      R.isNil([]); //=> false
	 */
	
	
	var isNil = /*#__PURE__*/_curry1(function isNil(x) {
	  return x == null;
	});
	module.exports = isNil;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	var _complement = /*#__PURE__*/__webpack_require__(744);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(183);
	
	var _xany = /*#__PURE__*/__webpack_require__(750);
	
	var any = /*#__PURE__*/__webpack_require__(1541);
	
	/**
	 * Returns `true` if no elements of the list match the predicate, `false`
	 * otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
	 * @see R.all, R.any
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *      var isOdd = n => n % 2 === 1;
	 *
	 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
	 *      R.none(isOdd, [1, 3, 5, 7, 8, 11]); //=> false
	 */
	
	
	var none = /*#__PURE__*/_curry2( /*#__PURE__*/_complement( /*#__PURE__*/_dispatchable(['any'], _xany, any)));
	module.exports = none;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	/**
	 * A function that returns the `!` of its argument. It will return `true` when
	 * passed false-y value, and `false` when passed a truth-y one.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig * -> Boolean
	 * @param {*} a any value
	 * @return {Boolean} the logical inverse of passed argument.
	 * @see R.complement
	 * @example
	 *
	 *      R.not(true); //=> false
	 *      R.not(false); //=> true
	 *      R.not(0); //=> true
	 *      R.not(1); //=> false
	 */
	
	
	var not = /*#__PURE__*/_curry1(function not(a) {
	  return !a;
	});
	module.exports = not;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(68);
	
	var defaultTo = /*#__PURE__*/__webpack_require__(738);
	
	var path = /*#__PURE__*/__webpack_require__(87);
	
	/**
	 * If the given, non-null object has a value at the given path, returns the
	 * value at that path. Otherwise returns the provided default value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig a -> [Idx] -> {a} -> a
	 * @param {*} d The default value.
	 * @param {Array} p The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path` of the supplied object or the default value.
	 * @example
	 *
	 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
	 */
	
	
	var pathOr = /*#__PURE__*/_curry3(function pathOr(d, p, obj) {
	  return defaultTo(d, path(p, obj));
	});
	module.exports = pathOr;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(68);
	
	var equals = /*#__PURE__*/__webpack_require__(107);
	
	/**
	 * Returns `true` if the specified object property is equal, in
	 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
	 * You can test multiple properties with [`R.where`](#where).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig String -> a -> Object -> Boolean
	 * @param {String} name
	 * @param {*} val
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.whereEq, R.propSatisfies, R.equals
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond'};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown'};
	 *      var rusty = {name: 'Rusty', age: 10, hair: 'brown'};
	 *      var alois = {name: 'Alois', age: 15, disposition: 'surly'};
	 *      var kids = [abby, fred, rusty, alois];
	 *      var hasBrownHair = R.propEq('hair', 'brown');
	 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
	 */
	
	
	var propEq = /*#__PURE__*/_curry3(function propEq(name, val, obj) {
	  return equals(val, obj[name]);
	});
	module.exports = propEq;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	var _complement = /*#__PURE__*/__webpack_require__(744);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var filter = /*#__PURE__*/__webpack_require__(1550);
	
	/**
	 * The complement of [`filter`](#filter).
	 *
	 * Acts as a transducer if a transformer is given in list position. Filterable
	 * objects include plain objects or any object that has a filter method such
	 * as `Array`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.filter, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isOdd = (n) => n % 2 === 1;
	 *
	 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	
	
	var reject = /*#__PURE__*/_curry2(function reject(pred, filterable) {
	  return filter(_complement(pred), filterable);
	});
	module.exports = reject;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(68);
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is not satisfied, the function will return the result of
	 * calling the `whenFalseFn` function with the same argument. If the predicate
	 * is satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred        A predicate function
	 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
	 *                               to a falsy value.
	 * @param {*}        x           An object to test with the `pred` function and
	 *                               pass to `whenFalseFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
	 * @see R.ifElse, R.when
	 * @example
	 *
	 *      let safeInc = R.unless(R.isNil, R.inc);
	 *      safeInc(null); //=> null
	 *      safeInc(1); //=> 2
	 */
	
	
	var unless = /*#__PURE__*/_curry3(function unless(pred, whenFalseFn, x) {
	  return pred(x) ? x : whenFalseFn(x);
	});
	module.exports = unless;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(108);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classNames = __webpack_require__(248);
	
	var _classNames2 = _interopRequireDefault(_classNames);
	
	var _keys = __webpack_require__(249);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navbar = function (_Component) {
	  _inherits(Navbar, _Component);
	
	  function Navbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Navbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNextClick = function () {
	      if (_this.props.onNextClick) {
	        _this.props.onNextClick();
	      }
	    }, _this.handlePreviousClick = function () {
	      if (_this.props.onPreviousClick) {
	        _this.props.onPreviousClick();
	      }
	    }, _this.handleNextKeyDown = function (e) {
	      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
	        return;
	      }
	      e.preventDefault();
	      _this.handleNextClick();
	    }, _this.handlePreviousKeyDown = function (e) {
	      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
	        return;
	      }
	      e.preventDefault();
	      _this.handlePreviousClick();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Navbar, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          className = _props.className,
	          showPreviousButton = _props.showPreviousButton,
	          showNextButton = _props.showNextButton,
	          labels = _props.labels,
	          dir = _props.dir;
	
	
	      var previousClickHandler = void 0;
	      var nextClickHandler = void 0;
	      var previousKeyDownHandler = void 0;
	      var nextKeyDownHandler = void 0;
	      var shouldShowPrevious = void 0;
	      var shouldShowNext = void 0;
	
	      if (dir === 'rtl') {
	        previousClickHandler = this.handleNextClick;
	        nextClickHandler = this.handlePreviousClick;
	        previousKeyDownHandler = this.handleNextKeyDown;
	        nextKeyDownHandler = this.handlePreviousKeyDown;
	        shouldShowNext = showPreviousButton;
	        shouldShowPrevious = showNextButton;
	      } else {
	        previousClickHandler = this.handlePreviousClick;
	        nextClickHandler = this.handleNextClick;
	        previousKeyDownHandler = this.handlePreviousKeyDown;
	        nextKeyDownHandler = this.handleNextKeyDown;
	        shouldShowNext = showNextButton;
	        shouldShowPrevious = showPreviousButton;
	      }
	
	      var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;
	
	      var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;
	
	      var previousButton = _react2.default.createElement('span', {
	        tabIndex: '0',
	        role: 'button',
	        'aria-label': labels.previousMonth,
	        key: 'previous',
	        className: previousClassName,
	        onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
	        onClick: shouldShowPrevious ? previousClickHandler : undefined
	      });
	
	      var nextButton = _react2.default.createElement('span', {
	        tabIndex: '0',
	        role: 'button',
	        'aria-label': labels.nextMonth,
	        key: 'right',
	        className: nextClassName,
	        onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
	        onClick: shouldShowNext ? nextClickHandler : undefined
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className || classNames.navBar },
	        dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]
	      );
	    }
	  }]);
	
	  return Navbar;
	}(_react.Component);
	
	Navbar.defaultProps = {
	  classNames: _classNames2.default,
	  dir: 'ltr',
	  labels: {
	    previousMonth: 'Previous Month',
	    nextMonth: 'Next Month'
	  },
	  showPreviousButton: true,
	  showNextButton: true
	};
	exports.default = Navbar;
	Navbar.propTypes =  false ? {
	  classNames: _propTypes2.default.shape({
	    navBar: _propTypes2.default.string.isRequired,
	    navButtonPrev: _propTypes2.default.string.isRequired,
	    navButtonNext: _propTypes2.default.string.isRequired
	  }),
	  className: _propTypes2.default.string,
	  showPreviousButton: _propTypes2.default.bool,
	  showNextButton: _propTypes2.default.bool,
	  onPreviousClick: _propTypes2.default.func,
	  onNextClick: _propTypes2.default.func,
	  dir: _propTypes2.default.string,
	  labels: _propTypes2.default.shape({
	    previousMonth: _propTypes2.default.string.isRequired,
	    nextMonth: _propTypes2.default.string.isRequired
	  })
	} : {};
	//# sourceMappingURL=Navbar.js.map

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(108);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Weekday = function (_Component) {
	  _inherits(Weekday, _Component);
	
	  function Weekday() {
	    _classCallCheck(this, Weekday);
	
	    return _possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
	  }
	
	  _createClass(Weekday, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props !== nextProps;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          weekday = _props.weekday,
	          className = _props.className,
	          weekdaysLong = _props.weekdaysLong,
	          weekdaysShort = _props.weekdaysShort,
	          localeUtils = _props.localeUtils,
	          locale = _props.locale;
	
	      var title = void 0;
	      if (weekdaysLong) {
	        title = weekdaysLong[weekday];
	      } else {
	        title = localeUtils.formatWeekdayLong(weekday, locale);
	      }
	      var content = void 0;
	      if (weekdaysShort) {
	        content = weekdaysShort[weekday];
	      } else {
	        content = localeUtils.formatWeekdayShort(weekday, locale);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, role: 'columnheader' },
	        _react2.default.createElement(
	          'abbr',
	          { title: title },
	          content
	        )
	      );
	    }
	  }]);
	
	  return Weekday;
	}(_react.Component);
	
	exports.default = Weekday;
	Weekday.propTypes =  false ? {
	  weekday: _propTypes2.default.number,
	  className: _propTypes2.default.string,
	  locale: _propTypes2.default.string,
	  localeUtils: _propTypes2.default.object,
	
	  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string)
	} : {};
	//# sourceMappingURL=Weekday.js.map

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	
	var UAParser = __webpack_require__(1611);
	
	var UA = new UAParser();
	var browser = UA.getBrowser();
	var cpu = UA.getCPU();
	var device = UA.getDevice();
	var engine = UA.getEngine();
	var os = UA.getOS();
	var ua = UA.getUA();
	
	var setDefaults = function setDefaults(p) {
	  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
	  return p ? p : d;
	};
	var getNavigatorInstance = function getNavigatorInstance() {
	  if (typeof window !== 'undefined') {
	    if (window.navigator || navigator) {
	      return window.navigator || navigator;
	    }
	  }
	
	  return false;
	};
	var isIOS13Check = function isIOS13Check(type) {
	  var nav = getNavigatorInstance();
	  return nav && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
	};
	
	function _typeof(obj) {
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function (obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    });
	    keys.push.apply(keys, symbols);
	  }
	
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(source, true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(source).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return _assertThisInitialized(self);
	}
	
	var DEVICE_TYPES = {
	  MOBILE: 'mobile',
	  TABLET: 'tablet',
	  SMART_TV: 'smarttv',
	  CONSOLE: 'console',
	  WEARABLE: 'wearable',
	  BROWSER: undefined
	};
	var BROWSER_TYPES = {
	  CHROME: 'Chrome',
	  FIREFOX: "Firefox",
	  OPERA: "Opera",
	  YANDEX: "Yandex",
	  SAFARI: "Safari",
	  INTERNET_EXPLORER: "Internet Explorer",
	  EDGE: "Edge",
	  CHROMIUM: "Chromium",
	  IE: 'IE',
	  MOBILE_SAFARI: "Mobile Safari"
	};
	var OS_TYPES = {
	  IOS: 'iOS',
	  ANDROID: "Android",
	  WINDOWS_PHONE: "Windows Phone"
	};
	var initialData = {
	  isMobile: false,
	  isTablet: false,
	  isBrowser: false,
	  isSmartTV: false,
	  isConsole: false,
	  isWearable: false
	};
	var checkType = function checkType(type) {
	  switch (type) {
	    case DEVICE_TYPES.MOBILE:
	      return {
	        isMobile: true
	      };
	
	    case DEVICE_TYPES.TABLET:
	      return {
	        isTablet: true
	      };
	
	    case DEVICE_TYPES.SMART_TV:
	      return {
	        isSmartTV: true
	      };
	
	    case DEVICE_TYPES.CONSOLE:
	      return {
	        isConsole: true
	      };
	
	    case DEVICE_TYPES.WEARABLE:
	      return {
	        isWearable: true
	      };
	
	    case DEVICE_TYPES.BROWSER:
	      return {
	        isBrowser: true
	      };
	
	    default:
	      return initialData;
	  }
	};
	var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
	  return {
	    isBrowser: isBrowser,
	    browserMajorVersion: setDefaults(browser.major),
	    browserFullVersion: setDefaults(browser.version),
	    browserName: setDefaults(browser.name),
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var mobilePayload = function mobilePayload(type, device, os, ua) {
	  return _objectSpread2({}, type, {
	    vendor: setDefaults(device.vendor),
	    model: setDefaults(device.model),
	    os: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    ua: setDefaults(ua)
	  });
	};
	var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
	  return {
	    isSmartTV: isSmartTV,
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var consolePayload = function consolePayload(isConsole, engine, os, ua) {
	  return {
	    isConsole: isConsole,
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var wearPayload = function wearPayload(isWearable, engine, os, ua) {
	  return {
	    isWearable: isWearable,
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	
	var type = checkType(device.type);
	
	function deviceDetect() {
	  var isBrowser = type.isBrowser,
	      isMobile = type.isMobile,
	      isTablet = type.isTablet,
	      isSmartTV = type.isSmartTV,
	      isConsole = type.isConsole,
	      isWearable = type.isWearable;
	
	  if (isBrowser) {
	    return broPayload(isBrowser, browser, engine, os, ua);
	  }
	
	  if (isSmartTV) {
	    return stvPayload(isSmartTV, engine, os, ua);
	  }
	
	  if (isConsole) {
	    return consolePayload(isConsole, engine, os, ua);
	  }
	
	  if (isMobile) {
	    return mobilePayload(type, device, os, ua);
	  }
	
	  if (isTablet) {
	    return mobilePayload(type, device, os, ua);
	  }
	
	  if (isWearable) {
	    return wearPayload(isWearable, engine, os, ua);
	  }
	}
	
	var isMobileType = function isMobileType() {
	  return device.type === DEVICE_TYPES.MOBILE;
	};
	
	var isTabletType = function isTabletType() {
	  return device.type === DEVICE_TYPES.TABLET;
	};
	
	var isMobileAndTabletType = function isMobileAndTabletType() {
	  switch (device.type) {
	    case DEVICE_TYPES.MOBILE:
	    case DEVICE_TYPES.TABLET:
	      return true;
	
	    default:
	      return false;
	  }
	};
	
	var isSmartTVType = function isSmartTVType() {
	  return device.type === DEVICE_TYPES.SMART_TV;
	};
	
	var isBrowserType = function isBrowserType() {
	  return device.type === DEVICE_TYPES.BROWSER;
	};
	
	var isWearableType = function isWearableType() {
	  return device.type === DEVICE_TYPES.WEARABLE;
	};
	
	var isConsoleType = function isConsoleType() {
	  return device.type === DEVICE_TYPES.CONSOLE;
	};
	
	var isAndroidType = function isAndroidType() {
	  return os.name === OS_TYPES.ANDROID;
	};
	
	var isWinPhoneType = function isWinPhoneType() {
	  return os.name === OS_TYPES.WINDOWS_PHONE;
	};
	
	var isIOSType = function isIOSType() {
	  return os.name === OS_TYPES.IOS;
	};
	
	var isChromeType = function isChromeType() {
	  return browser.name === BROWSER_TYPES.CHROME;
	};
	
	var isFirefoxType = function isFirefoxType() {
	  return browser.name === BROWSER_TYPES.FIREFOX;
	};
	
	var isChromiumType = function isChromiumType() {
	  return browser.name === BROWSER_TYPES.CHROMIUM;
	};
	
	var isEdgeType = function isEdgeType() {
	  return browser.name === BROWSER_TYPES.EDGE;
	};
	
	var isYandexType = function isYandexType() {
	  return browser.name === BROWSER_TYPES.YANDEX;
	};
	
	var isSafariType = function isSafariType() {
	  return browser.name === BROWSER_TYPES.SAFARI || browser.name === BROWSER_TYPES.MOBILE_SAFARI;
	};
	
	var isMobileSafariType = function isMobileSafariType() {
	  return browser.name === BROWSER_TYPES.MOBILE_SAFARI;
	};
	
	var isOperaType = function isOperaType() {
	  return browser.name === BROWSER_TYPES.OPERA;
	};
	
	var isIEType = function isIEType() {
	  return browser.name === BROWSER_TYPES.INTERNET_EXPLORER || browser.name === BROWSER_TYPES.IE;
	};
	
	var isElectronType = function isElectronType() {
	  var nav = getNavigatorInstance();
	  var ua = nav && nav.userAgent.toLowerCase();
	  return typeof ua === 'string' ? /electron/.test(ua) : false;
	};
	
	var getIOS13 = function getIOS13() {
	  var nav = getNavigatorInstance();
	  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
	};
	
	var getIPad13 = function getIPad13() {
	  return isIOS13Check('iPad');
	};
	
	var getIphone13 = function getIphone13() {
	  return isIOS13Check('iPhone');
	};
	
	var getIPod13 = function getIPod13() {
	  return isIOS13Check('iPod');
	};
	
	var getBrowserFullVersion = function getBrowserFullVersion() {
	  return setDefaults(browser.version);
	};
	
	var getBrowserVersion = function getBrowserVersion() {
	  return setDefaults(browser.major);
	};
	
	var getOsVersion = function getOsVersion() {
	  return setDefaults(os.version);
	};
	
	var getOsName = function getOsName() {
	  return setDefaults(os.name);
	};
	
	var getBrowserName = function getBrowserName() {
	  return setDefaults(browser.name);
	};
	
	var getMobileVendor = function getMobileVendor() {
	  return setDefaults(device.vendor);
	};
	
	var getMobileModel = function getMobileModel() {
	  return setDefaults(device.model);
	};
	
	var getEngineName = function getEngineName() {
	  return setDefaults(engine.name);
	};
	
	var getEngineVersion = function getEngineVersion() {
	  return setDefaults(engine.version);
	};
	
	var getUseragent = function getUseragent() {
	  return setDefaults(ua);
	};
	
	var getDeviceType = function getDeviceType() {
	  return setDefaults(device.type, 'browser');
	};
	
	var isSmartTV = isSmartTVType();
	var isConsole = isConsoleType();
	var isWearable = isWearableType();
	var isMobileSafari = isMobileSafariType() || getIPad13();
	var isChromium = isChromiumType();
	var isMobile = isMobileAndTabletType() || getIPad13();
	var isMobileOnly = isMobileType();
	var isTablet = isTabletType() || getIPad13();
	var isBrowser = isBrowserType();
	var isAndroid = isAndroidType();
	var isWinPhone = isWinPhoneType();
	var isIOS = isIOSType() || getIPad13();
	var isChrome = isChromeType();
	var isFirefox = isFirefoxType();
	var isSafari = isSafariType();
	var isOpera = isOperaType();
	var isIE = isIEType();
	var osVersion = getOsVersion();
	var osName = getOsName();
	var fullBrowserVersion = getBrowserFullVersion();
	var browserVersion = getBrowserVersion();
	var browserName = getBrowserName();
	var mobileVendor = getMobileVendor();
	var mobileModel = getMobileModel();
	var engineName = getEngineName();
	var engineVersion = getEngineVersion();
	var getUA = getUseragent();
	var isEdge = isEdgeType();
	var isYandex = isYandexType();
	var deviceType = getDeviceType();
	var isIOS13 = getIOS13();
	var isIPad13 = getIPad13();
	var isIPhone13 = getIphone13();
	var isIPod13 = getIPod13();
	var isElectron = isElectronType();
	
	var AndroidView = function AndroidView(_ref) {
	  var renderWithFragment = _ref.renderWithFragment,
	      children = _ref.children,
	      viewClassName = _ref.viewClassName,
	      style = _ref.style;
	  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var BrowserView = function BrowserView(_ref2) {
	  var renderWithFragment = _ref2.renderWithFragment,
	      children = _ref2.children,
	      viewClassName = _ref2.viewClassName,
	      style = _ref2.style;
	  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var IEView = function IEView(_ref3) {
	  var renderWithFragment = _ref3.renderWithFragment,
	      children = _ref3.children,
	      viewClassName = _ref3.viewClassName,
	      style = _ref3.style;
	  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var IOSView = function IOSView(_ref4) {
	  var renderWithFragment = _ref4.renderWithFragment,
	      children = _ref4.children,
	      viewClassName = _ref4.viewClassName,
	      style = _ref4.style;
	  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var MobileView = function MobileView(_ref5) {
	  var renderWithFragment = _ref5.renderWithFragment,
	      children = _ref5.children,
	      viewClassName = _ref5.viewClassName,
	      style = _ref5.style;
	  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var TabletView = function TabletView(_ref6) {
	  var renderWithFragment = _ref6.renderWithFragment,
	      children = _ref6.children,
	      viewClassName = _ref6.viewClassName,
	      style = _ref6.style;
	  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var WinPhoneView = function WinPhoneView(_ref7) {
	  var renderWithFragment = _ref7.renderWithFragment,
	      children = _ref7.children,
	      viewClassName = _ref7.viewClassName,
	      style = _ref7.style;
	  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var MobileOnlyView = function MobileOnlyView(_ref8) {
	  var renderWithFragment = _ref8.renderWithFragment,
	      children = _ref8.children,
	      viewClassName = _ref8.viewClassName,
	      style = _ref8.style;
	  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var SmartTVView = function SmartTVView(_ref9) {
	  var renderWithFragment = _ref9.renderWithFragment,
	      children = _ref9.children,
	      viewClassName = _ref9.viewClassName,
	      style = _ref9.style;
	  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var ConsoleView = function ConsoleView(_ref10) {
	  var renderWithFragment = _ref10.renderWithFragment,
	      children = _ref10.children,
	      viewClassName = _ref10.viewClassName,
	      style = _ref10.style;
	  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var WearableView = function WearableView(_ref11) {
	  var renderWithFragment = _ref11.renderWithFragment,
	      children = _ref11.children,
	      viewClassName = _ref11.viewClassName,
	      style = _ref11.style;
	  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var CustomView = function CustomView(_ref12) {
	  var renderWithFragment = _ref12.renderWithFragment,
	      children = _ref12.children,
	      viewClassName = _ref12.viewClassName,
	      style = _ref12.style,
	      condition = _ref12.condition;
	  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	
	function withOrientationChange(WrappedComponent) {
	  return (
	    /*#__PURE__*/
	    function (_React$Component) {
	      _inherits(_class, _React$Component);
	
	      function _class(props) {
	        var _this;
	
	        _classCallCheck(this, _class);
	
	        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
	        _this.isEventListenerAdded = false;
	        _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
	        _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
	        _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
	        _this.state = {
	          isLandscape: false,
	          isPortrait: false
	        };
	        return _this;
	      }
	
	      _createClass(_class, [{
	        key: "handleOrientationChange",
	        value: function handleOrientationChange() {
	          if (!this.isEventListenerAdded) {
	            this.isEventListenerAdded = true;
	          }
	
	          var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
	          this.setState({
	            isPortrait: orientation === 0,
	            isLandscape: orientation === 90
	          });
	        }
	      }, {
	        key: "onOrientationChange",
	        value: function onOrientationChange() {
	          this.handleOrientationChange();
	        }
	      }, {
	        key: "onPageLoad",
	        value: function onPageLoad() {
	          this.handleOrientationChange();
	        }
	      }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
	            if (!this.isEventListenerAdded) {
	              this.handleOrientationChange();
	              window.addEventListener("load", this.onPageLoad, false);
	            } else {
	              window.removeEventListener("load", this.onPageLoad, false);
	            }
	
	            window.addEventListener("resize", this.onOrientationChange, false);
	          }
	        }
	      }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	          window.removeEventListener("resize", this.onOrientationChange, false);
	        }
	      }, {
	        key: "render",
	        value: function render() {
	          return React__default.createElement(WrappedComponent, _extends({}, this.props, {
	            isLandscape: this.state.isLandscape,
	            isPortrait: this.state.isPortrait
	          }));
	        }
	      }]);
	
	      return _class;
	    }(React__default.Component)
	  );
	}
	
	exports.AndroidView = AndroidView;
	exports.BrowserView = BrowserView;
	exports.ConsoleView = ConsoleView;
	exports.CustomView = CustomView;
	exports.IEView = IEView;
	exports.IOSView = IOSView;
	exports.MobileOnlyView = MobileOnlyView;
	exports.MobileView = MobileView;
	exports.SmartTVView = SmartTVView;
	exports.TabletView = TabletView;
	exports.WearableView = WearableView;
	exports.WinPhoneView = WinPhoneView;
	exports.browserName = browserName;
	exports.browserVersion = browserVersion;
	exports.deviceDetect = deviceDetect;
	exports.deviceType = deviceType;
	exports.engineName = engineName;
	exports.engineVersion = engineVersion;
	exports.fullBrowserVersion = fullBrowserVersion;
	exports.getUA = getUA;
	exports.isAndroid = isAndroid;
	exports.isBrowser = isBrowser;
	exports.isChrome = isChrome;
	exports.isChromium = isChromium;
	exports.isConsole = isConsole;
	exports.isEdge = isEdge;
	exports.isElectron = isElectron;
	exports.isFirefox = isFirefox;
	exports.isIE = isIE;
	exports.isIOS = isIOS;
	exports.isIOS13 = isIOS13;
	exports.isIPad13 = isIPad13;
	exports.isIPhone13 = isIPhone13;
	exports.isIPod13 = isIPod13;
	exports.isMobile = isMobile;
	exports.isMobileOnly = isMobileOnly;
	exports.isMobileSafari = isMobileSafari;
	exports.isOpera = isOpera;
	exports.isSafari = isSafari;
	exports.isSmartTV = isSmartTV;
	exports.isTablet = isTablet;
	exports.isWearable = isWearable;
	exports.isWinPhone = isWinPhone;
	exports.isYandex = isYandex;
	exports.mobileModel = mobileModel;
	exports.mobileVendor = mobileVendor;
	exports.osName = osName;
	exports.osVersion = osVersion;
	exports.withOrientationChange = withOrientationChange;


/***/ }),
/* 761 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(129);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(151);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactInstrumentation = __webpack_require__(76);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1673);
	var warning = __webpack_require__(19);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(24);
	
	var LinkedValueUtils = __webpack_require__(369);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactUpdates = __webpack_require__(85);
	
	var warning = __webpack_require__(19);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 766 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 767 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var invariant = __webpack_require__(13);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1633);
	
	var containsNode = __webpack_require__(1303);
	var focusNode = __webpack_require__(484);
	var getActiveElement = __webpack_require__(485);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var DOMLazyTree = __webpack_require__(150);
	var DOMProperty = __webpack_require__(151);
	var React = __webpack_require__(155);
	var ReactBrowserEventEmitter = __webpack_require__(250);
	var ReactCurrentOwner = __webpack_require__(91);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactDOMContainerInfo = __webpack_require__(1627);
	var ReactDOMFeatureFlags = __webpack_require__(1629);
	var ReactFeatureFlags = __webpack_require__(767);
	var ReactInstanceMap = __webpack_require__(188);
	var ReactInstrumentation = __webpack_require__(76);
	var ReactMarkupChecksum = __webpack_require__(1643);
	var ReactReconciler = __webpack_require__(152);
	var ReactUpdateQueue = __webpack_require__(372);
	var ReactUpdates = __webpack_require__(85);
	
	var emptyObject = __webpack_require__(138);
	var instantiateReactComponent = __webpack_require__(777);
	var invariant = __webpack_require__(13);
	var setInnerHTML = __webpack_require__(254);
	var shouldUpdateReactComponent = __webpack_require__(378);
	var warning = __webpack_require__(19);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var React = __webpack_require__(155);
	
	var invariant = __webpack_require__(13);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 774 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(771);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(55);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26),
	    _assign = __webpack_require__(24);
	
	var ReactCompositeComponent = __webpack_require__(1624);
	var ReactEmptyComponent = __webpack_require__(766);
	var ReactHostComponent = __webpack_require__(768);
	
	var getNextDebugID = __webpack_require__(1741);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(19);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 778 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(55);
	var escapeTextContentForBrowser = __webpack_require__(253);
	var setInnerHTML = __webpack_require__(254);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var ReactCurrentOwner = __webpack_require__(91);
	var REACT_ELEMENT_TYPE = __webpack_require__(1639);
	
	var getIteratorFn = __webpack_require__(1670);
	var invariant = __webpack_require__(13);
	var KeyEscapeUtils = __webpack_require__(368);
	var warning = __webpack_require__(19);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 781 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 782 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _Modal = __webpack_require__(1686);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _metadata = __webpack_require__(1328);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _default = __webpack_require__(1330);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _InternationalIcon = __webpack_require__(1690);
	
	var _InternationalIcon2 = _interopRequireDefault(_InternationalIcon);
	
	var _PropTypes = __webpack_require__(785);
	
	var _PhoneInputNative = __webpack_require__(1692);
	
	var _PhoneInputNative2 = _interopRequireDefault(_PhoneInputNative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PhoneInputNativeDefaultMetadata = (_temp2 = _class = function (_Component) {
		_inherits(PhoneInputNativeDefaultMetadata, _Component);
	
		function PhoneInputNativeDefaultMetadata() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, PhoneInputNativeDefaultMetadata);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhoneInputNativeDefaultMetadata.__proto__ || Object.getPrototypeOf(PhoneInputNativeDefaultMetadata)).call.apply(_ref, [this].concat(args))), _this), _this.storeInputRef = function (ref) {
				return _this.input = ref;
			}, _this.render = function () {
				return _react2.default.createElement(_PhoneInputNative2.default, _extends({ ref: _this.storeInputRef }, _this.props));
			}, _this.focus = function () {
				return _this.input.focus();
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		return PhoneInputNativeDefaultMetadata;
	}(_react.Component), _class.propTypes = {
		metadata: _PropTypes.metadata.isRequired,
		labels: _PropTypes.labels.isRequired,
		internationalIcon: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
		metadata: _metadata2.default,
		labels: _default2.default,
		internationalIcon: _InternationalIcon2.default
	}, _temp2);
	exports.default = PhoneInputNativeDefaultMetadata;
	//# sourceMappingURL=PhoneInputNativeDefaultMetadata.js.map

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.labels = exports.metadata = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var metadata = exports.metadata = _propTypes2.default.shape({
		country_calling_codes: _propTypes2.default.object.isRequired,
		countries: _propTypes2.default.object.isRequired
	});
	
	var labels = exports.labels = _propTypes2.default.objectOf(_propTypes2.default.string);
	//# sourceMappingURL=PropTypes.js.map

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	exports = module.exports = __webpack_require__(784).default
	exports['default'] = __webpack_require__(784).default

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(316);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(1702);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          if (this.subscription) this.subscription.tryUnsubscribe();
	          this.initSubscription();
	          if (shouldHandleStateChanges) this.subscription.trySubscribe();
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(790);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(235);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(381);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(384);
	
	var _ContextUtils = __webpack_require__(383);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    bool = _React$PropTypes.bool,
	    object = _React$PropTypes.object,
	    string = _React$PropTypes.string,
	    func = _React$PropTypes.func,
	    oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object, func]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 792 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(109);
	
	var _PatternUtils = __webpack_require__(153);
	
	var _InternalPropTypes = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(315);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(314);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(499);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(798);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(154);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1718);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1715);
	
	var _isActive2 = __webpack_require__(1722);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1719);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1724);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(315);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(314);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(316);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(383);
	
	var _PropTypes = __webpack_require__(384);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(157);
	
	var ReactCurrentOwner = __webpack_require__(91);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(19);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 801 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _setDisplayName = __webpack_require__(69);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(79);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createEagerFactory = __webpack_require__(78);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getContext = function getContext(contextTypes) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    var GetContext = function GetContext(ownerProps, context) {
	      return factory(_extends({}, ownerProps, context));
	    };
	
	    GetContext.contextTypes = contextTypes;
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'getContext'))(GetContext);
	    }
	    return GetContext;
	  };
	};
	
	exports.default = getContext;

/***/ }),
/* 804 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _setDisplayName = __webpack_require__(69);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(79);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createEagerFactory = __webpack_require__(78);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withContext = function withContext(childContextTypes, getChildContext) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    var WithContext = function (_Component) {
	      _inherits(WithContext, _Component);
	
	      function WithContext() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithContext);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
	          return getChildContext(_this.props);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithContext.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return WithContext;
	    }(_react.Component);
	
	    WithContext.childContextTypes = childContextTypes;
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withContext'))(WithContext);
	    }
	    return WithContext;
	  };
	};
	
	exports.default = withContext;

/***/ }),
/* 806 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  } else {
	    var _ret = function () {
	      var last = funcs[funcs.length - 1];
	      var rest = funcs.slice(0, -1);
	      return {
	        v: function v() {
	          return rest.reduceRight(function (composed, f) {
	            return f(composed);
	          }, last.apply(undefined, arguments));
	        }
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	}

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports["default"] = createStore;
	
	var _isPlainObject = __webpack_require__(235);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1759);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [initialState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, initialState, enhancer) {
	  var _ref2;
	
	  if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = initialState;
	    initialState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, initialState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = initialState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2["default"])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2["default"]] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2["default"]] = observable, _ref2;
	}

/***/ }),
/* 808 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	
	// https://github.com/thirdpartyjs/thirdpartyjs-code/blob/master/examples/templates/02/loading-files/index.html
	
	/**
	 * Invoke `fn(err)` when the given `el` script loads.
	 *
	 * @param {Element} el
	 * @param {Function} fn
	 * @api public
	 */
	
	module.exports = function(el, fn){
	  return el.addEventListener
	    ? add(el, fn)
	    : attach(el, fn);
	};
	
	/**
	 * Add event listener to `el`, `fn()`.
	 *
	 * @param {Element} el
	 * @param {Function} fn
	 * @api private
	 */
	
	function add(el, fn){
	  el.addEventListener('load', function(_, e){ fn(null, e); }, false);
	  el.addEventListener('error', function(e){
	    var err = new Error('script error "' + el.src + '"');
	    err.event = e;
	    fn(err);
	  }, false);
	}
	
	/**
	 * Attach event.
	 *
	 * @param {Element} el
	 * @param {Function} fn
	 * @api private
	 */
	
	function attach(el, fn){
	  el.attachEvent('onreadystatechange', function(e){
	    if (!/complete|loaded/.test(el.readyState)) return;
	    fn(null, e);
	  });
	  el.attachEvent('onerror', function(e){
	    var err = new Error('failed to load the script "' + el.src + '"');
	    err.event = e || window.event;
	    fn(err);
	  });
	}


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Facade = __webpack_require__(130);
	var get = __webpack_require__(182);
	var inherit = __webpack_require__(80).inherit;
	var isEmail = __webpack_require__(204);
	var newDate = __webpack_require__(353);
	var trim = __webpack_require__(814);
	var type = __webpack_require__(80).type;
	
	/**
	 * Initialize a new `Identify` facade with a `dictionary` of arguments.
	 *
	 * @param {Object} dictionary - The object to wrap.
	 * @param {string} [dictionary.userId] - The ID of the user.
	 * @param {string} [dictionary.anonymousId] - The anonymous ID of the user.
	 * @param {string} [dictionary.traits] - The user's traits.
	 * @param {Object} opts - Options about what kind of Facade to create.
	 *
	 * @augments Facade
	 */
	function Identify(dictionary, opts) {
	  Facade.call(this, dictionary, opts);
	}
	
	inherit(Identify, Facade);
	
	/**
	 * Return the type of facade this is. This will always return `"identify"`.
	 *
	 * @return {string}
	 */
	Identify.prototype.action = function() {
	  return 'identify';
	};
	
	/**
	 * An alias for {@link Identify#action}.
	 *
	 * @function
	 * @return {string}
	 */
	Identify.prototype.type = Identify.prototype.action;
	
	/**
	 * Get the user's traits. This is identical to how {@link Facade#traits} works,
	 * except it looks at `traits.*` instead of `options.traits.*`.
	 *
	 * Traits are gotten from `traits`, augmented with a property `id` with
	 * the event's `userId`.
	 *
	 * The parameter `aliases` is meant to transform keys in `traits` into new
	 * keys. Each alias like `{ "xxx": "yyy" }` will take whatever is at `xxx` in
	 * the traits, and move it to `yyy`. If `xxx` is a method of this facade, it'll
	 * be called as a function instead of treated as a key into the traits.
	 *
	 * @example
	 * var obj = { traits: { foo: "bar" }, anonymousId: "xxx" }
	 * var identify = new Identify(obj)
	 *
	 * identify.traits() // { "foo": "bar" }
	 * identify.traits({ "foo": "asdf" }) // { "asdf": "bar" }
	 * identify.traits({ "sessionId": "rofl" }) // { "rofl": "xxx" }
	 *
	 * @param {Object} aliases - A mapping from keys to the new keys they should be
	 * transformed to.
	 * @return {Object}
	 */
	Identify.prototype.traits = function(aliases) {
	  var ret = this.field('traits') || {};
	  var id = this.userId();
	  aliases = aliases || {};
	
	  if (id) ret.id = id;
	
	  for (var alias in aliases) {
	    var value = this[alias] == null ? this.proxy('traits.' + alias) : this[alias]();
	    if (value == null) continue;
	    ret[aliases[alias]] = value;
	    if (alias !== aliases[alias]) delete ret[alias];
	  }
	
	  return ret;
	};
	
	/**
	 * Get the user's email from `traits.email`, falling back to `userId` only if
	 * it looks like a valid email.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Identify.prototype.email = function() {
	  var email = this.proxy('traits.email');
	  if (email) return email;
	
	  var userId = this.userId();
	  if (isEmail(userId)) return userId;
	};
	
	/**
	 * Get the time of creation of the user from `traits.created` or
	 * `traits.createdAt`.
	 *
	 * @return {Date}
	 */
	Identify.prototype.created = function() {
	  var created = this.proxy('traits.created') || this.proxy('traits.createdAt');
	  if (created) return newDate(created);
	};
	
	/**
	 * Get the time of creation of the user's company from `traits.company.created`
	 * or `traits.company.createdAt`.
	 *
	 * @return {Date}
	 */
	Identify.prototype.companyCreated = function() {
	  var created = this.proxy('traits.company.created') || this.proxy('traits.company.createdAt');
	
	  if (created) {
	    return newDate(created);
	  }
	};
	
	/**
	 * Get the user's company name from `traits.company.name`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Identify.prototype.companyName = function() {
	  return this.proxy('traits.company.name');
	};
	
	/**
	 * Get the user's name `traits.name`, falling back to combining {@link
	 * Identify#firstName} and {@link Identify#lastName} if possible.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Identify.prototype.name = function() {
	  var name = this.proxy('traits.name');
	  if (typeof name === 'string') {
	    return trim(name);
	  }
	
	  var firstName = this.firstName();
	  var lastName = this.lastName();
	  if (firstName && lastName) {
	    return trim(firstName + ' ' + lastName);
	  }
	};
	
	/**
	 * Get the user's first name from `traits.firstName`, optionally splitting it
	 * out of a the full name if that's all that was provided.
	 *
	 * Splitting the full name works on the assumption that the full name is of the
	 * form "FirstName LastName"; it will not work for non-Western names.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Identify.prototype.firstName = function() {
	  var firstName = this.proxy('traits.firstName');
	  if (typeof firstName === 'string') {
	    return trim(firstName);
	  }
	
	  var name = this.proxy('traits.name');
	  if (typeof name === 'string') {
	    return trim(name).split(' ')[0];
	  }
	};
	
	/**
	 * Get the user's last name from `traits.lastName`, optionally splitting it out
	 * of a the full name if that's all that was provided.
	 *
	 * Splitting the full name works on the assumption that the full name is of the
	 * form "FirstName LastName"; it will not work for non-Western names.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Identify.prototype.lastName = function() {
	  var lastName = this.proxy('traits.lastName');
	  if (typeof lastName === 'string') {
	    return trim(lastName);
	  }
	
	  var name = this.proxy('traits.name');
	  if (typeof name !== 'string') {
	    return;
	  }
	
	  var space = trim(name).indexOf(' ');
	  if (space === -1) {
	    return;
	  }
	
	  return trim(name.substr(space + 1));
	};
	
	/**
	 * Get the user's "unique id" from `userId`, `traits.username`, or
	 * `traits.email`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Identify.prototype.uid = function() {
	  return this.userId() || this.username() || this.email();
	};
	
	/**
	 * Get the user's description from `traits.description` or `traits.background`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Identify.prototype.description = function() {
	  return this.proxy('traits.description') || this.proxy('traits.background');
	};
	
	/**
	 * Get the user's age from `traits.age`, falling back to computing it from
	 * `traits.birthday` and the current time.
	 *
	 * @return {number}
	 */
	Identify.prototype.age = function() {
	  var date = this.birthday();
	  var age = get(this.traits(), 'age');
	  if (age != null) return age;
	  if (type(date) !== 'date') return;
	  var now = new Date();
	  return now.getFullYear() - date.getFullYear();
	};
	
	/**
	 * Get the URL of the user's avatar from `traits.avatar`, `traits.photoUrl`, or
	 * `traits.avatarUrl`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Identify.prototype.avatar = function() {
	  var traits = this.traits();
	  return get(traits, 'avatar') || get(traits, 'photoUrl') || get(traits, 'avatarUrl');
	};
	
	/**
	 * Get the user's job position from `traits.position` or `traits.jobTitle`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Identify.prototype.position = function() {
	  var traits = this.traits();
	  return get(traits, 'position') || get(traits, 'jobTitle');
	};
	
	/**
	 * Get the user's username from `traits.username`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {string}
	 */
	Identify.prototype.username = Facade.proxy('traits.username');
	
	/**
	 * Get the user's website from `traits.website`, or if there are multiple in
	 * `traits.websites`, return the first one.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {string}
	 */
	Identify.prototype.website = Facade.one('traits.website');
	
	/**
	 * Get the user's websites from `traits.websites`, or if there is only one in
	 * `traits.website`, then wrap it in an array.
	 *
	 * This *should* be an array of strings, but may not be if the client isn't
	 * adhering to the spec.
	 *
	 * @function
	 * @return {array}
	 */
	Identify.prototype.websites = Facade.multi('traits.website');
	
	/**
	 * Get the user's phone number from `traits.phone`, or if there are multiple in
	 * `traits.phones`, return the first one.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {string}
	 */
	Identify.prototype.phone = Facade.one('traits.phone');
	
	/**
	 * Get the user's phone numbers from `traits.phones`, or if there is only one
	 * in `traits.phone`, then wrap it in an array.
	 *
	 * This *should* be an array of strings, but may not be if the client isn't
	 * adhering to the spec.
	 *
	 * @function
	 * @return {array}
	 */
	Identify.prototype.phones = Facade.multi('traits.phone');
	
	/**
	 * Get the user's address from `traits.address`.
	 *
	 * This *should* be an object, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {object}
	 */
	Identify.prototype.address = Facade.proxy('traits.address');
	
	/**
	 * Get the user's gender from `traits.gender`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {string}
	 */
	Identify.prototype.gender = Facade.proxy('traits.gender');
	
	/**
	 * Get the user's birthday from `traits.birthday`.
	 *
	 * This *should* be a Date if `opts.traverse` was enabled (it is by default)
	 * when constructing this Identify. Otherwise, it should be a string. But it
	 * may be neither if the client isn't adhering to the spec.
	 * spec.
	 *
	 * @function
	 * @return {object}
	 */
	Identify.prototype.birthday = Facade.proxy('traits.birthday');
	
	module.exports = Identify;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var inherit = __webpack_require__(80).inherit;
	var Facade = __webpack_require__(130);
	var Track = __webpack_require__(389);
	var isEmail = __webpack_require__(204);
	
	/**
	 * Initialize a new `Page` facade with a `dictionary` of arguments.
	 *
	 * @param {Object} dictionary - The object to wrap.
	 * @param {string} [dictionary.category] - The page category.
	 * @param {string} [dictionary.name] - The page name.
	 * @param {string} [dictionary.properties] - The page properties.
	 * @param {Object} opts - Options about what kind of Facade to create.
	 *
	 * @augments Facade
	 */
	function Page(dictionary, opts) {
	  Facade.call(this, dictionary, opts);
	}
	
	inherit(Page, Facade);
	
	/**
	 * Return the type of facade this is. This will always return `"page"`.
	 *
	 * @return {string}
	 */
	Page.prototype.action = function() {
	  return 'page';
	};
	
	/**
	 * An alias for {@link Page#action}.
	 *
	 * @function
	 * @return {string}
	 */
	Page.prototype.type = Page.prototype.action;
	
	/**
	 * Get the page category from `category`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Page.prototype.category = Facade.field('category');
	
	/**
	 * Get the page name from `name`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Page.prototype.name = Facade.field('name');
	
	/**
	 * Get the page title from `properties.title`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Page.prototype.title = Facade.proxy('properties.title');
	
	/**
	 * Get the page path from `properties.path`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Page.prototype.path = Facade.proxy('properties.path');
	
	/**
	 * Get the page URL from `properties.url`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Page.prototype.url = Facade.proxy('properties.url');
	
	/**
	 * Get the HTTP referrer from `context.referrer.url`, `context.page.referrer`,
	 * or `properties.referrer`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Page.prototype.referrer = function() {
	  return this.proxy('context.referrer.url')
	    || this.proxy('context.page.referrer')
	    || this.proxy('properties.referrer');
	};
	
	/**
	 * Get the page's properties. This is identical to how {@link Facade#traits}
	 * works, except it looks at `properties.*` instead of `options.traits.*`.
	 *
	 * Properties are gotten from `properties`, augmented with the page's `name`
	 * and `category`.
	 *
	 * The parameter `aliases` is meant to transform keys in `properties` into new
	 * keys. Each alias like `{ "xxx": "yyy" }` will take whatever is at `xxx` in
	 * the traits, and move it to `yyy`. If `xxx` is a method of this facade, it'll
	 * be called as a function instead of treated as a key into the traits.
	 *
	 * @example
	 * var obj = { properties: { foo: "bar" }, anonymousId: "xxx" }
	 * var page = new Page(obj)
	 *
	 * page.traits() // { "foo": "bar" }
	 * page.traits({ "foo": "asdf" }) // { "asdf": "bar" }
	 * page.traits({ "sessionId": "rofl" }) // { "rofl": "xxx" }
	 *
	 * @param {Object} aliases - A mapping from keys to the new keys they should be
	 * transformed to.
	 * @return {Object}
	 */
	Page.prototype.properties = function(aliases) {
	  var props = this.field('properties') || {};
	  var category = this.category();
	  var name = this.name();
	  aliases = aliases || {};
	
	  if (category) props.category = category;
	  if (name) props.name = name;
	
	  for (var alias in aliases) {
	    var value = this[alias] == null
	      ? this.proxy('properties.' + alias)
	      : this[alias]();
	    if (value == null) continue;
	    props[aliases[alias]] = value;
	    if (alias !== aliases[alias]) delete props[alias];
	  }
	
	  return props;
	};
	
	/**
	 * Get the user's email from `context.traits.email` or `properties.email`,
	 * falling back to `userId` if it's a valid email.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Page.prototype.email = function() {
	  var email = this.proxy('context.traits.email') || this.proxy('properties.email');
	  if (email) return email;
	
	  var userId = this.userId();
	  if (isEmail(userId)) return userId;
	};
	
	/**
	 * Get the page fullName. This is `$category $name` if both are present, and
	 * just `name` otherwiser.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Page.prototype.fullName = function() {
	  var category = this.category();
	  var name = this.name();
	  return name && category
	    ? category + ' ' + name
	    : name;
	};
	
	/**
	 * Get an event name from this page call. If `name` is present, this will be
	 * `Viewed $name Page`; otherwise, it will be `Loaded a Page`.
	 *
	 * @param {string} name - The name of this page.
	 * @return {string}
	 */
	Page.prototype.event = function(name) {
	  return name
	    ? 'Viewed ' + name + ' Page'
	    : 'Loaded a Page';
	};
	
	/**
	 * Convert this Page to a {@link Track} facade. The inputted `name` will be
	 * converted to the Track's event name via {@link Page#event}.
	 *
	 * @param {string} name
	 * @return {Track}
	 */
	Page.prototype.track = function(name) {
	  var json = this.json();
	  json.event = this.event(name);
	  json.timestamp = this.timestamp();
	  json.properties = this.properties();
	  return new Track(json, this.opts);
	};
	
	module.exports = Page;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1273);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(62)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!./style.css", function() {
				var newContent = require("!!../css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var defaultParams = {
	  title: '',
	  text: '',
	  type: null,
	  allowOutsideClick: false,
	  showConfirmButton: true,
	  showCancelButton: false,
	  closeOnConfirm: true,
	  closeOnCancel: true,
	  confirmButtonText: 'OK',
	  confirmButtonColor: '#8CD4F5',
	  cancelButtonText: 'Cancel',
	  imageUrl: null,
	  imageSize: null,
	  timer: null,
	  customClass: '',
	  html: false,
	  animation: true,
	  allowEscapeKey: true,
	  inputType: 'text',
	  inputPlaceholder: '',
	  inputValue: '',
	  showLoaderOnConfirm: false
	};
	
	exports['default'] = defaultParams;
	module.exports = exports['default'];

/***/ }),
/* 814 */
/***/ (function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Generated by CoffeeScript 1.10.0
	var slice = [].slice;
	
	(function(root, factory) {
	  if (('function' === "function") && (__webpack_require__(816) != null)) {
	    return !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined" && exports !== null) {
	    return module.exports = factory();
	  } else {
	    return root.UrlPattern = factory();
	  }
	})(this, function() {
	  var P, UrlPattern, astNodeContainsSegmentsForProvidedParams, astNodeToNames, astNodeToRegexString, baseAstNodeToRegexString, concatMap, defaultOptions, escapeForRegex, getParam, keysAndValuesToObject, newParser, regexGroupCount, stringConcatMap, stringify;
	  escapeForRegex = function(string) {
	    return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	  };
	  concatMap = function(array, f) {
	    var i, length, results;
	    results = [];
	    i = -1;
	    length = array.length;
	    while (++i < length) {
	      results = results.concat(f(array[i]));
	    }
	    return results;
	  };
	  stringConcatMap = function(array, f) {
	    var i, length, result;
	    result = '';
	    i = -1;
	    length = array.length;
	    while (++i < length) {
	      result += f(array[i]);
	    }
	    return result;
	  };
	  regexGroupCount = function(regex) {
	    return (new RegExp(regex.toString() + '|')).exec('').length - 1;
	  };
	  keysAndValuesToObject = function(keys, values) {
	    var i, key, length, object, value;
	    object = {};
	    i = -1;
	    length = keys.length;
	    while (++i < length) {
	      key = keys[i];
	      value = values[i];
	      if (value == null) {
	        continue;
	      }
	      if (object[key] != null) {
	        if (!Array.isArray(object[key])) {
	          object[key] = [object[key]];
	        }
	        object[key].push(value);
	      } else {
	        object[key] = value;
	      }
	    }
	    return object;
	  };
	  P = {};
	  P.Result = function(value, rest) {
	    this.value = value;
	    this.rest = rest;
	  };
	  P.Tagged = function(tag, value) {
	    this.tag = tag;
	    this.value = value;
	  };
	  P.tag = function(tag, parser) {
	    return function(input) {
	      var result, tagged;
	      result = parser(input);
	      if (result == null) {
	        return;
	      }
	      tagged = new P.Tagged(tag, result.value);
	      return new P.Result(tagged, result.rest);
	    };
	  };
	  P.regex = function(regex) {
	    return function(input) {
	      var matches, result;
	      matches = regex.exec(input);
	      if (matches == null) {
	        return;
	      }
	      result = matches[0];
	      return new P.Result(result, input.slice(result.length));
	    };
	  };
	  P.sequence = function() {
	    var parsers;
	    parsers = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    return function(input) {
	      var i, length, parser, rest, result, values;
	      i = -1;
	      length = parsers.length;
	      values = [];
	      rest = input;
	      while (++i < length) {
	        parser = parsers[i];
	        result = parser(rest);
	        if (result == null) {
	          return;
	        }
	        values.push(result.value);
	        rest = result.rest;
	      }
	      return new P.Result(values, rest);
	    };
	  };
	  P.pick = function() {
	    var indexes, parsers;
	    indexes = arguments[0], parsers = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	    return function(input) {
	      var array, result;
	      result = P.sequence.apply(P, parsers)(input);
	      if (result == null) {
	        return;
	      }
	      array = result.value;
	      result.value = array[indexes];
	      return result;
	    };
	  };
	  P.string = function(string) {
	    var length;
	    length = string.length;
	    return function(input) {
	      if (input.slice(0, length) === string) {
	        return new P.Result(string, input.slice(length));
	      }
	    };
	  };
	  P.lazy = function(fn) {
	    var cached;
	    cached = null;
	    return function(input) {
	      if (cached == null) {
	        cached = fn();
	      }
	      return cached(input);
	    };
	  };
	  P.baseMany = function(parser, end, stringResult, atLeastOneResultRequired, input) {
	    var endResult, parserResult, rest, results;
	    rest = input;
	    results = stringResult ? '' : [];
	    while (true) {
	      if (end != null) {
	        endResult = end(rest);
	        if (endResult != null) {
	          break;
	        }
	      }
	      parserResult = parser(rest);
	      if (parserResult == null) {
	        break;
	      }
	      if (stringResult) {
	        results += parserResult.value;
	      } else {
	        results.push(parserResult.value);
	      }
	      rest = parserResult.rest;
	    }
	    if (atLeastOneResultRequired && results.length === 0) {
	      return;
	    }
	    return new P.Result(results, rest);
	  };
	  P.many1 = function(parser) {
	    return function(input) {
	      return P.baseMany(parser, null, false, true, input);
	    };
	  };
	  P.concatMany1Till = function(parser, end) {
	    return function(input) {
	      return P.baseMany(parser, end, true, true, input);
	    };
	  };
	  P.firstChoice = function() {
	    var parsers;
	    parsers = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    return function(input) {
	      var i, length, parser, result;
	      i = -1;
	      length = parsers.length;
	      while (++i < length) {
	        parser = parsers[i];
	        result = parser(input);
	        if (result != null) {
	          return result;
	        }
	      }
	    };
	  };
	  newParser = function(options) {
	    var U;
	    U = {};
	    U.wildcard = P.tag('wildcard', P.string(options.wildcardChar));
	    U.optional = P.tag('optional', P.pick(1, P.string(options.optionalSegmentStartChar), P.lazy(function() {
	      return U.pattern;
	    }), P.string(options.optionalSegmentEndChar)));
	    U.name = P.regex(new RegExp("^[" + options.segmentNameCharset + "]+"));
	    U.named = P.tag('named', P.pick(1, P.string(options.segmentNameStartChar), P.lazy(function() {
	      return U.name;
	    })));
	    U.escapedChar = P.pick(1, P.string(options.escapeChar), P.regex(/^./));
	    U["static"] = P.tag('static', P.concatMany1Till(P.firstChoice(P.lazy(function() {
	      return U.escapedChar;
	    }), P.regex(/^./)), P.firstChoice(P.string(options.segmentNameStartChar), P.string(options.optionalSegmentStartChar), P.string(options.optionalSegmentEndChar), U.wildcard)));
	    U.token = P.lazy(function() {
	      return P.firstChoice(U.wildcard, U.optional, U.named, U["static"]);
	    });
	    U.pattern = P.many1(P.lazy(function() {
	      return U.token;
	    }));
	    return U;
	  };
	  defaultOptions = {
	    escapeChar: '\\',
	    segmentNameStartChar: ':',
	    segmentValueCharset: 'a-zA-Z0-9-_~ %',
	    segmentNameCharset: 'a-zA-Z0-9',
	    optionalSegmentStartChar: '(',
	    optionalSegmentEndChar: ')',
	    wildcardChar: '*'
	  };
	  baseAstNodeToRegexString = function(astNode, segmentValueCharset) {
	    if (Array.isArray(astNode)) {
	      return stringConcatMap(astNode, function(node) {
	        return baseAstNodeToRegexString(node, segmentValueCharset);
	      });
	    }
	    switch (astNode.tag) {
	      case 'wildcard':
	        return '(.*?)';
	      case 'named':
	        return "([" + segmentValueCharset + "]+)";
	      case 'static':
	        return escapeForRegex(astNode.value);
	      case 'optional':
	        return '(?:' + baseAstNodeToRegexString(astNode.value, segmentValueCharset) + ')?';
	    }
	  };
	  astNodeToRegexString = function(astNode, segmentValueCharset) {
	    if (segmentValueCharset == null) {
	      segmentValueCharset = defaultOptions.segmentValueCharset;
	    }
	    return '^' + baseAstNodeToRegexString(astNode, segmentValueCharset) + '$';
	  };
	  astNodeToNames = function(astNode) {
	    if (Array.isArray(astNode)) {
	      return concatMap(astNode, astNodeToNames);
	    }
	    switch (astNode.tag) {
	      case 'wildcard':
	        return ['_'];
	      case 'named':
	        return [astNode.value];
	      case 'static':
	        return [];
	      case 'optional':
	        return astNodeToNames(astNode.value);
	    }
	  };
	  getParam = function(params, key, nextIndexes, sideEffects) {
	    var index, maxIndex, result, value;
	    if (sideEffects == null) {
	      sideEffects = false;
	    }
	    value = params[key];
	    if (value == null) {
	      if (sideEffects) {
	        throw new Error("no values provided for key `" + key + "`");
	      } else {
	        return;
	      }
	    }
	    index = nextIndexes[key] || 0;
	    maxIndex = Array.isArray(value) ? value.length - 1 : 0;
	    if (index > maxIndex) {
	      if (sideEffects) {
	        throw new Error("too few values provided for key `" + key + "`");
	      } else {
	        return;
	      }
	    }
	    result = Array.isArray(value) ? value[index] : value;
	    if (sideEffects) {
	      nextIndexes[key] = index + 1;
	    }
	    return result;
	  };
	  astNodeContainsSegmentsForProvidedParams = function(astNode, params, nextIndexes) {
	    var i, length;
	    if (Array.isArray(astNode)) {
	      i = -1;
	      length = astNode.length;
	      while (++i < length) {
	        if (astNodeContainsSegmentsForProvidedParams(astNode[i], params, nextIndexes)) {
	          return true;
	        }
	      }
	      return false;
	    }
	    switch (astNode.tag) {
	      case 'wildcard':
	        return getParam(params, '_', nextIndexes, false) != null;
	      case 'named':
	        return getParam(params, astNode.value, nextIndexes, false) != null;
	      case 'static':
	        return false;
	      case 'optional':
	        return astNodeContainsSegmentsForProvidedParams(astNode.value, params, nextIndexes);
	    }
	  };
	  stringify = function(astNode, params, nextIndexes) {
	    if (Array.isArray(astNode)) {
	      return stringConcatMap(astNode, function(node) {
	        return stringify(node, params, nextIndexes);
	      });
	    }
	    switch (astNode.tag) {
	      case 'wildcard':
	        return getParam(params, '_', nextIndexes, true);
	      case 'named':
	        return getParam(params, astNode.value, nextIndexes, true);
	      case 'static':
	        return astNode.value;
	      case 'optional':
	        if (astNodeContainsSegmentsForProvidedParams(astNode.value, params, nextIndexes)) {
	          return stringify(astNode.value, params, nextIndexes);
	        } else {
	          return '';
	        }
	    }
	  };
	  UrlPattern = function(arg1, arg2) {
	    var groupCount, options, parsed, parser, withoutWhitespace;
	    if (arg1 instanceof UrlPattern) {
	      this.isRegex = arg1.isRegex;
	      this.regex = arg1.regex;
	      this.ast = arg1.ast;
	      this.names = arg1.names;
	      return;
	    }
	    this.isRegex = arg1 instanceof RegExp;
	    if (!(('string' === typeof arg1) || this.isRegex)) {
	      throw new TypeError('argument must be a regex or a string');
	    }
	    if (this.isRegex) {
	      this.regex = arg1;
	      if (arg2 != null) {
	        if (!Array.isArray(arg2)) {
	          throw new Error('if first argument is a regex the second argument may be an array of group names but you provided something else');
	        }
	        groupCount = regexGroupCount(this.regex);
	        if (arg2.length !== groupCount) {
	          throw new Error("regex contains " + groupCount + " groups but array of group names contains " + arg2.length);
	        }
	        this.names = arg2;
	      }
	      return;
	    }
	    if (arg1 === '') {
	      throw new Error('argument must not be the empty string');
	    }
	    withoutWhitespace = arg1.replace(/\s+/g, '');
	    if (withoutWhitespace !== arg1) {
	      throw new Error('argument must not contain whitespace');
	    }
	    options = {
	      escapeChar: (arg2 != null ? arg2.escapeChar : void 0) || defaultOptions.escapeChar,
	      segmentNameStartChar: (arg2 != null ? arg2.segmentNameStartChar : void 0) || defaultOptions.segmentNameStartChar,
	      segmentNameCharset: (arg2 != null ? arg2.segmentNameCharset : void 0) || defaultOptions.segmentNameCharset,
	      segmentValueCharset: (arg2 != null ? arg2.segmentValueCharset : void 0) || defaultOptions.segmentValueCharset,
	      optionalSegmentStartChar: (arg2 != null ? arg2.optionalSegmentStartChar : void 0) || defaultOptions.optionalSegmentStartChar,
	      optionalSegmentEndChar: (arg2 != null ? arg2.optionalSegmentEndChar : void 0) || defaultOptions.optionalSegmentEndChar,
	      wildcardChar: (arg2 != null ? arg2.wildcardChar : void 0) || defaultOptions.wildcardChar
	    };
	    parser = newParser(options);
	    parsed = parser.pattern(arg1);
	    if (parsed == null) {
	      throw new Error("couldn't parse pattern");
	    }
	    if (parsed.rest !== '') {
	      throw new Error("could only partially parse pattern");
	    }
	    this.ast = parsed.value;
	    this.regex = new RegExp(astNodeToRegexString(this.ast, options.segmentValueCharset));
	    this.names = astNodeToNames(this.ast);
	  };
	  UrlPattern.prototype.match = function(url) {
	    var groups, match;
	    match = this.regex.exec(url);
	    if (match == null) {
	      return null;
	    }
	    groups = match.slice(1);
	    if (this.names) {
	      return keysAndValuesToObject(this.names, groups);
	    } else {
	      return groups;
	    }
	  };
	  UrlPattern.prototype.stringify = function(params) {
	    if (params == null) {
	      params = {};
	    }
	    if (this.isRegex) {
	      throw new Error("can't stringify patterns generated from a regex");
	    }
	    if (params !== Object(params)) {
	      throw new Error("argument must be an object or undefined");
	    }
	    return stringify(this.ast, params, {});
	  };
	  UrlPattern.escapeForRegex = escapeForRegex;
	  UrlPattern.concatMap = concatMap;
	  UrlPattern.stringConcatMap = stringConcatMap;
	  UrlPattern.regexGroupCount = regexGroupCount;
	  UrlPattern.keysAndValuesToObject = keysAndValuesToObject;
	  UrlPattern.P = P;
	  UrlPattern.newParser = newParser;
	  UrlPattern.defaultOptions = defaultOptions;
	  UrlPattern.astNodeToRegexString = astNodeToRegexString;
	  UrlPattern.astNodeToNames = astNodeToNames;
	  UrlPattern.getParam = getParam;
	  UrlPattern.astNodeContainsSegmentsForProvidedParams = astNodeContainsSegmentsForProvidedParams;
	  UrlPattern.stringify = stringify;
	  return UrlPattern;
	});


/***/ }),
/* 816 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./yelp-0.png": 1830,
		"./yelp-1.5.png": 1831,
		"./yelp-1.png": 1832,
		"./yelp-2.5.png": 1833,
		"./yelp-2.png": 1834,
		"./yelp-3.5.png": 1835,
		"./yelp-3.png": 1836,
		"./yelp-4.5.png": 1837,
		"./yelp-4.png": 1838,
		"./yelp-5.png": 1839
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 817;


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1532).enable();
	  window.Promise = __webpack_require__(1531);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1326);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(24);
	
	// Array.prototype.find() polyfill from MDN
	if (typeof Array.prototype.find === 'undefined') {
	    Object.defineProperty(Array.prototype, 'find', {
	    value: function(predicate) {
	     // 1. Let O be ? ToObject(this value).
	      if (this == null) {
	        throw new TypeError('"this" is null or not defined');
	      }
	
	      var o = Object(this);
	
	      // 2. Let len be ? ToLength(? Get(O, "length")).
	      var len = o.length >>> 0;
	
	      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
	      if (typeof predicate !== 'function') {
	        throw new TypeError('predicate must be a function');
	      }
	
	      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
	      var thisArg = arguments[1];
	
	      // 5. Let k be 0.
	      var k = 0;
	
	      // 6. Repeat, while k < len
	      while (k < len) {
	        // a. Let Pk be ! ToString(k).
	        // b. Let kValue be ? Get(O, Pk).
	        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
	        // d. If testResult is true, return kValue.
	        var kValue = o[k];
	        if (predicate.call(thisArg, kValue, k, o)) {
	          return kValue;
	        }
	        // e. Increase k by 1.
	        k++;
	      }
	
	      // 7. Return undefined.
	      return undefined;
	    }
	  });
	};


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * Module dependencies.
	 */
	
	var arity = __webpack_require__(820);
	
	var objToString = Object.prototype.toString;
	
	/**
	 * Determine if a value is a function.
	 *
	 * @param {*} val
	 * @return {boolean}
	 */
	// TODO: Move to lib
	var isFunction = function(val) {
	  return typeof val === 'function';
	};
	
	/**
	 * Determine if a value is a number.
	 *
	 * @param {*} val
	 * @return {boolean}
	 */
	// TODO: Move to lib
	var isNumber = function(val) {
	  var type = typeof val;
	  return type === 'number' || (type === 'object' && objToString.call(val) === '[object Number]');
	};
	
	/**
	 * Wrap a function `fn` in a function that will invoke `fn` when invoked `n` or
	 * more times.
	 *
	 * @name after
	 * @api public
	 * @category Function
	 * @param {Number} n The number of
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A function that will call `fn` after `n` or more
	 * invocations.
	 * @example
	 */
	var after = function after(n, fn) {
	  if (!isNumber(n)) {
	    throw new TypeError('Expected a number but received ' + typeof n);
	  }
	
	  if (!isFunction(fn)) {
	    throw new TypeError('Expected a function but received ' + typeof fn);
	  }
	
	  var callCount = 0;
	
	  return arity(fn.length, function() {
	    callCount += 1;
	
	    if (callCount < n) {
	      return;
	    }
	
	    return fn.apply(this, arguments);
	  });
	};
	
	/*
	 * Exports.
	 */
	
	module.exports = after;


/***/ }),
/* 820 */
/***/ (function(module, exports) {

	'use strict';
	
	var objToString = Object.prototype.toString;
	
	/**
	 * Determine if a value is a function.
	 *
	 * @param {*} val
	 * @return {boolean}
	 */
	// TODO: Move to lib
	var isFunction = function(val) {
	  return typeof val === 'function';
	};
	
	/**
	 * Determine if a value is a number.
	 *
	 * @param {*} val
	 * @return {boolean}
	 */
	// TODO: Move to lib
	var isNumber = function(val) {
	  var type = typeof val;
	  return type === 'number' || (type === 'object' && objToString.call(val) === '[object Number]');
	};
	
	 /**
	  * Creates an array of generic, numbered argument names.
	  *
	  * @name createParams
	  * @api private
	  * @param {number} n
	  * @return {Array}
	  * @example
	  * argNames(2);
	  * //=> ['arg1', 'arg2']
	  */
	var createParams = function createParams(n) {
	  var args = [];
	
	  for (var i = 1; i <= n; i += 1) {
	    args.push('arg' + i);
	  }
	
	  return args;
	};
	
	 /**
	  * Dynamically construct a wrapper function of `n` arity that.
	  *
	  * If at all possible, prefer a function from the arity wrapper cache above to
	  * avoid allocating a new function at runtime.
	  *
	  * @name createArityWrapper
	  * @api private
	  * @param {number} n
	  * @return {Function(Function)}
	  */
	var createArityWrapper = function createArityWrapper(n) {
	  var paramNames = createParams(n).join(', ');
	  var wrapperBody = ''.concat(
	    '  return function(', paramNames, ') {\n',
	    '    return func.apply(this, arguments);\n',
	    '  };'
	  );
	
	  /* eslint-disable no-new-func */
	  return new Function('func', wrapperBody);
	  /* eslint-enable no-new-func */
	};
	
	// Cache common arity wrappers to avoid constructing them at runtime
	var arityWrapperCache = [
	  /* eslint-disable no-unused-vars */
	  function(fn) {
	    return function() {
	      return fn.apply(this, arguments);
	    };
	  },
	
	  function(fn) {
	    return function(arg1) {
	      return fn.apply(this, arguments);
	    };
	  },
	
	  function(fn) {
	    return function(arg1, arg2) {
	      return fn.apply(this, arguments);
	    };
	  },
	
	  function(fn) {
	    return function(arg1, arg2, arg3) {
	      return fn.apply(this, arguments);
	    };
	  },
	
	  function(fn) {
	    return function(arg1, arg2, arg3, arg4) {
	      return fn.apply(this, arguments);
	    };
	  },
	
	  function(fn) {
	    return function(arg1, arg2, arg3, arg4, arg5) {
	      return fn.apply(this, arguments);
	    };
	  }
	  /* eslint-enable no-unused-vars */
	];
	
	/**
	 * Takes a function and an [arity](https://en.wikipedia.org/wiki/Arity) `n`, and returns a new
	 * function that expects `n` arguments.
	 *
	 * @name arity
	 * @api public
	 * @category Function
	 * @see {@link curry}
	 * @param {Number} n The desired arity of the returned function.
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A function of n arity, wrapping `fn`.
	 * @example
	 * var add = function(a, b) {
	 *   return a + b;
	 * };
	 *
	 * // Check the number of arguments this function expects by accessing `.length`:
	 * add.length;
	 * //=> 2
	 *
	 * var unaryAdd = arity(1, add);
	 * unaryAdd.length;
	 * //=> 1
	 */
	var arity = function arity(n, func) {
	  if (!isFunction(func)) {
	    throw new TypeError('Expected a function but got ' + typeof func);
	  }
	
	  n = Math.max(isNumber(n) ? n : 0, 0);
	
	  if (!arityWrapperCache[n]) {
	    arityWrapperCache[n] = createArityWrapper(n);
	  }
	
	  return arityWrapperCache[n](func);
	};
	
	/*
	 * Exports.
	 */
	
	module.exports = arity;


/***/ }),
/* 821 */
/***/ (function(module, exports) {

	'use strict';
	
	var max = Math.max;
	
	/**
	 * Produce a new array composed of all but the first `n` elements of an input `collection`.
	 *
	 * @name drop
	 * @api public
	 * @param {number} count The number of elements to drop.
	 * @param {Array} collection The collection to iterate over.
	 * @return {Array} A new array containing all but the first element from `collection`.
	 * @example
	 * drop(0, [1, 2, 3]); // => [1, 2, 3]
	 * drop(1, [1, 2, 3]); // => [2, 3]
	 * drop(2, [1, 2, 3]); // => [3]
	 * drop(3, [1, 2, 3]); // => []
	 * drop(4, [1, 2, 3]); // => []
	 */
	var drop = function drop(count, collection) {
	  var length = collection ? collection.length : 0;
	
	  if (!length) {
	    return [];
	  }
	
	  // Preallocating an array *significantly* boosts performance when dealing with
	  // `arguments` objects on v8. For a summary, see:
	  // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	  var toDrop = max(Number(count) || 0, 0);
	  var resultsLength = max(length - toDrop, 0);
	  var results = new Array(resultsLength);
	
	  for (var i = 0; i < resultsLength; i += 1) {
	    results[i] = collection[i + toDrop];
	  }
	
	  return results;
	};
	
	/*
	 * Exports.
	 */
	
	module.exports = drop;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * Module dependencies.
	 */
	
	var each = __webpack_require__(133);
	
	/**
	 * Check if a predicate function returns `true` for all values in a `collection`.
	 * Checks owned, enumerable values and exits early when `predicate` returns
	 * `false`.
	 *
	 * @name every
	 * @param {Function} predicate The function used to test values.
	 * @param {Array|Object|string} collection The collection to search.
	 * @return {boolean} True if all values passes the predicate test, otherwise false.
	 * @example
	 * var isEven = function(num) { return num % 2 === 0; };
	 *
	 * every(isEven, []); // => true
	 * every(isEven, [1, 2]); // => false
	 * every(isEven, [2, 4, 6]); // => true
	 */
	var every = function every(predicate, collection) {
	  if (typeof predicate !== 'function') {
	    throw new TypeError('`predicate` must be a function but was a ' + typeof predicate);
	  }
	
	  var result = true;
	
	  each(function(val, key, collection) {
	    result = !!predicate(val, key, collection);
	
	    // Exit early
	    if (!result) {
	      return false;
	    }
	  }, collection);
	
	  return result;
	};
	
	/*
	 * Exports.
	 */
	
	module.exports = every;


/***/ }),
/* 823 */
/***/ (function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Copy the properties of one or more `objects` onto a destination object. Input objects are iterated over
	 * in left-to-right order, so duplicate properties on later objects will overwrite those from
	 * erevious ones. Only enumerable and own properties of the input objects are copied onto the
	 * resulting object.
	 *
	 * @name extend
	 * @api public
	 * @category Object
	 * @param {Object} dest The destination object.
	 * @param {...Object} sources The source objects.
	 * @return {Object} `dest`, extended with the properties of all `sources`.
	 * @example
	 * var a = { a: 'a' };
	 * var b = { b: 'b' };
	 * var c = { c: 'c' };
	 *
	 * extend(a, b, c);
	 * //=> { a: 'a', b: 'b', c: 'c' };
	 */
	var extend = function extend(dest /*, sources */) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	
	  for (var i = 0; i < sources.length; i += 1) {
	    for (var key in sources[i]) {
	      if (has.call(sources[i], key)) {
	        dest[key] = sources[i][key];
	      }
	    }
	  }
	
	  return dest;
	};
	
	/*
	 * Exports.
	 */
	
	module.exports = extend;


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * Module dependencies.
	 */
	
	var each = __webpack_require__(133);
	
	/**
	 * Reduces all the values in a collection down into a single value. Does so by iterating through the
	 * collection from left to right, repeatedly calling an `iterator` function and passing to it four
	 * arguments: `(accumulator, value, index, collection)`.
	 *
	 * Returns the final return value of the `iterator` function.
	 *
	 * @name foldl
	 * @api public
	 * @param {Function} iterator The function to invoke per iteration.
	 * @param {*} accumulator The initial accumulator value, passed to the first invocation of `iterator`.
	 * @param {Array|Object} collection The collection to iterate over.
	 * @return {*} The return value of the final call to `iterator`.
	 * @example
	 * foldl(function(total, n) {
	 *   return total + n;
	 * }, 0, [1, 2, 3]);
	 * //=> 6
	 *
	 * var phonebook = { bob: '555-111-2345', tim: '655-222-6789', sheila: '655-333-1298' };
	 *
	 * foldl(function(results, phoneNumber) {
	 *  if (phoneNumber[0] === '6') {
	 *    return results.concat(phoneNumber);
	 *  }
	 *  return results;
	 * }, [], phonebook);
	 * // => ['655-222-6789', '655-333-1298']
	 */
	var foldl = function foldl(iterator, accumulator, collection) {
	  if (typeof iterator !== 'function') {
	    throw new TypeError('Expected a function but received a ' + typeof iterator);
	  }
	
	  each(function(val, i, collection) {
	    accumulator = iterator(accumulator, val, i, collection);
	  }, collection);
	
	  return accumulator;
	};
	
	/*
	 * Exports.
	 */
	
	module.exports = foldl;


/***/ }),
/* 825 */
/***/ (function(module, exports) {

	'use strict';
	
	var hop = Object.prototype.hasOwnProperty;
	var strCharAt = String.prototype.charAt;
	var toStr = Object.prototype.toString;
	
	/**
	 * Returns the character at a given index.
	 *
	 * @param {string} str
	 * @param {number} index
	 * @return {string|undefined}
	 */
	// TODO: Move to a library
	var charAt = function(str, index) {
	  return strCharAt.call(str, index);
	};
	
	/**
	 * hasOwnProperty, wrapped as a function.
	 *
	 * @name has
	 * @api private
	 * @param {*} context
	 * @param {string|number} prop
	 * @return {boolean}
	 */
	
	// TODO: Move to a library
	var has = function has(context, prop) {
	  return hop.call(context, prop);
	};
	
	/**
	 * Returns true if a value is a string, otherwise false.
	 *
	 * @name isString
	 * @api private
	 * @param {*} val
	 * @return {boolean}
	 */
	
	// TODO: Move to a library
	var isString = function isString(val) {
	  return toStr.call(val) === '[object String]';
	};
	
	/**
	 * Returns true if a value is array-like, otherwise false. Array-like means a
	 * value is not null, undefined, or a function, and has a numeric `length`
	 * property.
	 *
	 * @name isArrayLike
	 * @api private
	 * @param {*} val
	 * @return {boolean}
	 */
	// TODO: Move to a library
	var isArrayLike = function isArrayLike(val) {
	  return val != null && (typeof val !== 'function' && typeof val.length === 'number');
	};
	
	
	/**
	 * indexKeys
	 *
	 * @name indexKeys
	 * @api private
	 * @param {} target
	 * @param {Function} pred
	 * @return {Array}
	 */
	var indexKeys = function indexKeys(target, pred) {
	  pred = pred || has;
	
	  var results = [];
	
	  for (var i = 0, len = target.length; i < len; i += 1) {
	    if (pred(target, i)) {
	      results.push(String(i));
	    }
	  }
	
	  return results;
	};
	
	/**
	 * Returns an array of an object's owned keys.
	 *
	 * @name objectKeys
	 * @api private
	 * @param {*} target
	 * @param {Function} pred Predicate function used to include/exclude values from
	 * the resulting array.
	 * @return {Array}
	 */
	var objectKeys = function objectKeys(target, pred) {
	  pred = pred || has;
	
	  var results = [];
	
	  for (var key in target) {
	    if (pred(target, key)) {
	      results.push(String(key));
	    }
	  }
	
	  return results;
	};
	
	/**
	 * Creates an array composed of all keys on the input object. Ignores any non-enumerable properties.
	 * More permissive than the native `Object.keys` function (non-objects will not throw errors).
	 *
	 * @name keys
	 * @api public
	 * @category Object
	 * @param {Object} source The value to retrieve keys from.
	 * @return {Array} An array containing all the input `source`'s keys.
	 * @example
	 * keys({ likes: 'avocado', hates: 'pineapple' });
	 * //=> ['likes', 'pineapple'];
	 *
	 * // Ignores non-enumerable properties
	 * var hasHiddenKey = { name: 'Tim' };
	 * Object.defineProperty(hasHiddenKey, 'hidden', {
	 *   value: 'i am not enumerable!',
	 *   enumerable: false
	 * })
	 * keys(hasHiddenKey);
	 * //=> ['name'];
	 *
	 * // Works on arrays
	 * keys(['a', 'b', 'c']);
	 * //=> ['0', '1', '2']
	 *
	 * // Skips unpopulated indices in sparse arrays
	 * var arr = [1];
	 * arr[4] = 4;
	 * keys(arr);
	 * //=> ['0', '4']
	 */
	var keys = function keys(source) {
	  if (source == null) {
	    return [];
	  }
	
	  // IE6-8 compatibility (string)
	  if (isString(source)) {
	    return indexKeys(source, charAt);
	  }
	
	  // IE6-8 compatibility (arguments)
	  if (isArrayLike(source)) {
	    return indexKeys(source, has);
	  }
	
	  return objectKeys(source);
	};
	
	/*
	 * Exports.
	 */
	
	module.exports = keys;


/***/ }),
/* 826 */
/***/ (function(module, exports) {

	'use strict';
	
	var objToString = Object.prototype.toString;
	
	// TODO: Move to lib
	var existy = function(val) {
	  return val != null;
	};
	
	// TODO: Move to lib
	var isArray = function(val) {
	  return objToString.call(val) === '[object Array]';
	};
	
	// TODO: Move to lib
	var isString = function(val) {
	   return typeof val === 'string' || objToString.call(val) === '[object String]';
	};
	
	// TODO: Move to lib
	var isObject = function(val) {
	  return val != null && typeof val === 'object';
	};
	
	/**
	 * Returns a copy of the new `object` containing only the specified properties.
	 *
	 * @name pick
	 * @api public
	 * @param {string|string[]} props The property or properties to keep.
	 * @param {Object} object The object to iterate over.
	 * @return {Object} A new object containing only the specified properties from `object`.
	 * @example
	 * var person = { name: 'Tim', occupation: 'enchanter', fears: 'rabbits' };
	 *
	 * pick('name', person);
	 * //=> { name: 'Tim' }
	 *
	 * pick(['name', 'fears'], person);
	 * //=> { name: 'Tim', fears: 'rabbits' }
	 */
	var pick = function pick(props, object) {
	  if (!existy(object) || !isObject(object)) {
	    return {};
	  }
	
	  if (isString(props)) {
	    props = [props];
	  }
	
	  if (!isArray(props)) {
	    props = [];
	  }
	
	  var result = {};
	
	  for (var i = 0; i < props.length; i += 1) {
	    if (isString(props[i]) && props[i] in object) {
	      result[props[i]] = object[props[i]];
	    }
	  }
	
	  return result;
	};
	
	/*
	 * Exports.
	 */
	
	module.exports = pick;


/***/ }),
/* 827 */
/***/ (function(module, exports) {

	'use strict';
	
	var max = Math.max;
	
	/**
	 * Produce a new array by passing each value in the input `collection` through a transformative
	 * `iterator` function. The `iterator` function is passed three arguments:
	 * `(value, index, collection)`.
	 *
	 * @name rest
	 * @api public
	 * @param {Array} collection The collection to iterate over.
	 * @return {Array} A new array containing all but the first element from `collection`.
	 * @example
	 * rest([1, 2, 3]); // => [2, 3]
	 */
	var rest = function rest(collection) {
	  if (collection == null || !collection.length) {
	    return [];
	  }
	
	  // Preallocating an array *significantly* boosts performance when dealing with
	  // `arguments` objects on v8. For a summary, see:
	  // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	  var results = new Array(max(collection.length - 2, 0));
	
	  for (var i = 1; i < collection.length; i += 1) {
	    results[i - 1] = collection[i];
	  }
	
	  return results;
	};
	
	/*
	 * Exports.
	 */
	
	module.exports = rest;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	
	var type = __webpack_require__(86);
	var clone = __webpack_require__(1261);
	
	
	/**
	 * Expose `alias`.
	 */
	
	module.exports = alias;
	
	
	/**
	 * Alias an `object`.
	 *
	 * @param {Object} obj
	 * @param {Mixed} method
	 */
	
	function alias (obj, method) {
	  switch (type(method)) {
	    case 'object': return aliasByDictionary(clone(obj), method);
	    case 'function': return aliasByFunction(clone(obj), method);
	  }
	}
	
	
	/**
	 * Convert the keys in an `obj` using a dictionary of `aliases`.
	 *
	 * @param {Object} obj
	 * @param {Object} aliases
	 */
	
	function aliasByDictionary (obj, aliases) {
	  for (var key in aliases) {
	    if (undefined === obj[key]) continue;
	    obj[aliases[key]] = obj[key];
	    delete obj[key];
	  }
	  return obj;
	}
	
	
	/**
	 * Convert the keys in an `obj` using a `convert` function.
	 *
	 * @param {Object} obj
	 * @param {Function} convert
	 */
	
	function aliasByFunction (obj, convert) {
	  // have to create another object so that ie8 won't infinite loop on keys
	  var output = {};
	  for (var key in obj) output[convert(key)] = obj[key];
	  return output;
	}


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_clonedeep_1 = __importDefault(__webpack_require__(212));
	var lodash_pick_1 = __importDefault(__webpack_require__(527));
	var _analytics = global.analytics;
	/*
	 * Module dependencies.
	 */
	var Alias = __webpack_require__(131).Alias;
	var Emitter = __webpack_require__(303);
	var Facade = __webpack_require__(131);
	var Group = __webpack_require__(131).Group;
	var Identify = __webpack_require__(131).Identify;
	var SourceMiddlewareChain = __webpack_require__(260).SourceMiddlewareChain;
	var IntegrationMiddlewareChain = __webpack_require__(260)
	    .IntegrationMiddlewareChain;
	var DestinationMiddlewareChain = __webpack_require__(260)
	    .DestinationMiddlewareChain;
	var Page = __webpack_require__(131).Page;
	var Track = __webpack_require__(131).Track;
	var bindAll = __webpack_require__(118);
	var extend = __webpack_require__(836);
	var cookie = __webpack_require__(259);
	var metrics = __webpack_require__(831);
	var debug = __webpack_require__(110);
	var defaults = __webpack_require__(390);
	var group = __webpack_require__(830);
	var is = __webpack_require__(167);
	var isMeta = __webpack_require__(851);
	var memory = __webpack_require__(393);
	var nextTick = __webpack_require__(239);
	var normalize = __webpack_require__(832);
	var on = __webpack_require__(1264).bind;
	var pageDefaults = __webpack_require__(833);
	var prevent = __webpack_require__(854);
	var querystring = __webpack_require__(1266);
	var store = __webpack_require__(261);
	var user = __webpack_require__(834);
	var type = __webpack_require__(86);
	/**
	 * Initialize a new `Analytics` instance.
	 */
	function Analytics() {
	    this._options({});
	    this.Integrations = {};
	    this._sourceMiddlewares = new SourceMiddlewareChain();
	    this._integrationMiddlewares = new IntegrationMiddlewareChain();
	    this._destinationMiddlewares = {};
	    this._integrations = {};
	    this._readied = false;
	    this._timeout = 300;
	    // XXX: BACKWARDS COMPATIBILITY
	    this._user = user;
	    this.log = debug('analytics.js');
	    bindAll(this);
	    var self = this;
	    this.on('initialize', function (_, options) {
	        if (options.initialPageview)
	            self.page();
	        self._parseQuery(window.location.search);
	    });
	}
	/**
	 * Mix in event emitter.
	 */
	Emitter(Analytics.prototype);
	/**
	 * Use a `plugin`.
	 */
	Analytics.prototype.use = function (plugin) {
	    plugin(this);
	    return this;
	};
	/**
	 * Define a new `Integration`.
	 */
	Analytics.prototype.addIntegration = function (Integration) {
	    var name = Integration.prototype.name;
	    if (!name)
	        throw new TypeError('attempted to add an invalid integration');
	    this.Integrations[name] = Integration;
	    return this;
	};
	/**
	 * Define a new `SourceMiddleware`
	 */
	Analytics.prototype.addSourceMiddleware = function (middleware) {
	    this._sourceMiddlewares.add(middleware);
	    return this;
	};
	/**
	 * Define a new `IntegrationMiddleware`
	 * @deprecated
	 */
	Analytics.prototype.addIntegrationMiddleware = function (middleware) {
	    this._integrationMiddlewares.add(middleware);
	    return this;
	};
	/**
	 * Define a new `DestinationMiddleware`
	 * Destination Middleware is chained after integration middleware
	 */
	Analytics.prototype.addDestinationMiddleware = function (integrationName, middlewares) {
	    var self = this;
	    middlewares.forEach(function (middleware) {
	        if (!self._destinationMiddlewares[integrationName]) {
	            self._destinationMiddlewares[integrationName] = new DestinationMiddlewareChain();
	        }
	        self._destinationMiddlewares[integrationName].add(middleware);
	    });
	    return self;
	};
	/**
	 * Initialize with the given integration `settings` and `options`.
	 *
	 * Aliased to `init` for convenience.
	 */
	Analytics.prototype.init = Analytics.prototype.initialize = function (settings, options) {
	    settings = settings || {};
	    options = options || {};
	    this._options(options);
	    this._readied = false;
	    // clean unknown integrations from settings
	    var self = this;
	    Object.keys(settings).forEach(function (key) {
	        var Integration = self.Integrations[key];
	        if (!Integration)
	            delete settings[key];
	    });
	    // add integrations
	    Object.keys(settings).forEach(function (key) {
	        var opts = settings[key];
	        var name = key;
	        // Don't load disabled integrations
	        if (options.integrations) {
	            if (options.integrations[name] === false ||
	                (options.integrations.All === false && !options.integrations[name])) {
	                return;
	            }
	        }
	        var Integration = self.Integrations[name];
	        var clonedOpts = {};
	        extend(true, clonedOpts, opts); // deep clone opts
	        var integration = new Integration(clonedOpts);
	        self.log('initialize %o - %o', name, opts);
	        self.add(integration);
	    });
	    var integrations = this._integrations;
	    // load user now that options are set
	    user.load();
	    group.load();
	    // make ready callback
	    var readyCallCount = 0;
	    var integrationCount = Object.keys(integrations).length;
	    var ready = function () {
	        readyCallCount++;
	        if (readyCallCount >= integrationCount) {
	            self._readied = true;
	            self.emit('ready');
	        }
	    };
	    // init if no integrations
	    if (integrationCount <= 0) {
	        ready();
	    }
	    // initialize integrations, passing ready
	    // create a list of any integrations that did not initialize - this will be passed with all events for replay support:
	    this.failedInitializations = [];
	    var initialPageSkipped = false;
	    Object.keys(integrations).forEach(function (key) {
	        var integration = integrations[key];
	        if (options.initialPageview &&
	            integration.options.initialPageview === false) {
	            // We've assumed one initial pageview, so make sure we don't count the first page call.
	            var page_1 = integration.page;
	            integration.page = function () {
	                if (initialPageSkipped) {
	                    return page_1.apply(this, arguments);
	                }
	                initialPageSkipped = true;
	                return;
	            };
	        }
	        integration.analytics = self;
	        integration.once('ready', ready);
	        try {
	            metrics.increment('analytics_js.integration.invoke', {
	                method: 'initialize',
	                integration_name: integration.name
	            });
	            integration.initialize();
	        }
	        catch (e) {
	            var integrationName = integration.name;
	            metrics.increment('analytics_js.integration.invoke.error', {
	                method: 'initialize',
	                integration_name: integration.name
	            });
	            self.failedInitializations.push(integrationName);
	            self.log('Error initializing %s integration: %o', integrationName, e);
	            // Mark integration as ready to prevent blocking of anyone listening to analytics.ready()
	            integration.ready();
	        }
	    });
	    // backwards compat with angular plugin and used for init logic checks
	    this.initialized = true;
	    this.emit('initialize', settings, options);
	    return this;
	};
	/**
	 * Set the user's `id`.
	 */
	Analytics.prototype.setAnonymousId = function (id) {
	    this.user().anonymousId(id);
	    return this;
	};
	/**
	 * Add an integration.
	 */
	Analytics.prototype.add = function (integration) {
	    this._integrations[integration.name] = integration;
	    return this;
	};
	/**
	 * Identify a user by optional `id` and `traits`.
	 *
	 * @param {string} [id=user.id()] User ID.
	 * @param {Object} [traits=null] User traits.
	 * @param {Object} [options=null]
	 * @param {Function} [fn]
	 * @return {Analytics}
	 */
	Analytics.prototype.identify = function (id, traits, options, fn) {
	    // Argument reshuffling.
	    /* eslint-disable no-unused-expressions, no-sequences */
	    if (is.fn(options))
	        (fn = options), (options = null);
	    if (is.fn(traits))
	        (fn = traits), (options = null), (traits = null);
	    if (is.object(id))
	        (options = traits), (traits = id), (id = user.id());
	    /* eslint-enable no-unused-expressions, no-sequences */
	    // clone traits before we manipulate so we don't do anything uncouth, and take
	    // from `user` so that we carryover anonymous traits
	    user.identify(id, traits);
	    var msg = this.normalize({
	        options: options,
	        traits: user.traits(),
	        userId: user.id()
	    });
	    // Add the initialize integrations so the server-side ones can be disabled too
	    // NOTE: We need to merge integrations, not override them with assign
	    // since it is possible to change the initialized integrations at runtime.
	    if (this.options.integrations) {
	        msg.integrations = __assign(__assign({}, this.options.integrations), msg.integrations);
	    }
	    this._invoke('identify', new Identify(msg));
	    // emit
	    this.emit('identify', id, traits, options);
	    this._callback(fn);
	    return this;
	};
	/**
	 * Return the current user.
	 *
	 * @return {Object}
	 */
	Analytics.prototype.user = function () {
	    return user;
	};
	/**
	 * Identify a group by optional `id` and `traits`. Or, if no arguments are
	 * supplied, return the current group.
	 *
	 * @param {string} [id=group.id()] Group ID.
	 * @param {Object} [traits=null] Group traits.
	 * @param {Object} [options=null]
	 * @param {Function} [fn]
	 * @return {Analytics|Object}
	 */
	Analytics.prototype.group = function (id, traits, options, fn) {
	    /* eslint-disable no-unused-expressions, no-sequences */
	    if (!arguments.length)
	        return group;
	    if (is.fn(options))
	        (fn = options), (options = null);
	    if (is.fn(traits))
	        (fn = traits), (options = null), (traits = null);
	    if (is.object(id))
	        (options = traits), (traits = id), (id = group.id());
	    /* eslint-enable no-unused-expressions, no-sequences */
	    // grab from group again to make sure we're taking from the source
	    group.identify(id, traits);
	    var msg = this.normalize({
	        options: options,
	        traits: group.traits(),
	        groupId: group.id()
	    });
	    // Add the initialize integrations so the server-side ones can be disabled too
	    // NOTE: We need to merge integrations, not override them with assign
	    // since it is possible to change the initialized integrations at runtime.
	    if (this.options.integrations) {
	        msg.integrations = __assign(__assign({}, this.options.integrations), msg.integrations);
	    }
	    this._invoke('group', new Group(msg));
	    this.emit('group', id, traits, options);
	    this._callback(fn);
	    return this;
	};
	/**
	 * Track an `event` that a user has triggered with optional `properties`.
	 *
	 * @param {string} event
	 * @param {Object} [properties=null]
	 * @param {Object} [options=null]
	 * @param {Function} [fn]
	 * @return {Analytics}
	 */
	Analytics.prototype.track = function (event, properties, options, fn) {
	    // Argument reshuffling.
	    /* eslint-disable no-unused-expressions, no-sequences */
	    if (is.fn(options))
	        (fn = options), (options = null);
	    if (is.fn(properties))
	        (fn = properties), (options = null), (properties = null);
	    /* eslint-enable no-unused-expressions, no-sequences */
	    // figure out if the event is archived.
	    var plan = this.options.plan || {};
	    var events = plan.track || {};
	    var planIntegrationOptions = {};
	    // normalize
	    var msg = this.normalize({
	        properties: properties,
	        options: options,
	        event: event
	    });
	    // plan.
	    plan = events[event];
	    if (plan) {
	        this.log('plan %o - %o', event, plan);
	        if (plan.enabled === false) {
	            // Disabled events should always be sent to Segment.
	            planIntegrationOptions = { All: false, 'Segment.io': true };
	        }
	        else {
	            planIntegrationOptions = plan.integrations || {};
	        }
	    }
	    else {
	        var defaultPlan = events.__default || { enabled: true };
	        if (!defaultPlan.enabled) {
	            // Disabled events should always be sent to Segment.
	            planIntegrationOptions = { All: false, 'Segment.io': true };
	        }
	    }
	    // Add the initialize integrations so the server-side ones can be disabled too
	    // NOTE: We need to merge integrations, not override them with assign
	    // since it is possible to change the initialized integrations at runtime.
	    msg.integrations = __assign(__assign({}, this._mergeInitializeAndPlanIntegrations(planIntegrationOptions)), msg.integrations);
	    this._invoke('track', new Track(msg));
	    this.emit('track', event, properties, options);
	    this._callback(fn);
	    return this;
	};
	/**
	 * Helper method to track an outbound link that would normally navigate away
	 * from the page before the analytics calls were sent.
	 *
	 * BACKWARDS COMPATIBILITY: aliased to `trackClick`.
	 *
	 * @param {Element|Array} links
	 * @param {string|Function} event
	 * @param {Object|Function} properties (optional)
	 * @return {Analytics}
	 */
	Analytics.prototype.trackClick = Analytics.prototype.trackLink = function (links, event, properties) {
	    var _this = this;
	    var elements = [];
	    if (!links)
	        return this;
	    // always arrays, handles jquery
	    if (links instanceof Element) {
	        elements = [links];
	    }
	    else if ("toArray" in links) {
	        elements = links.toArray();
	    }
	    else {
	        elements = links;
	    }
	    elements.forEach(function (el) {
	        if (type(el) !== 'element') {
	            throw new TypeError('Must pass HTMLElement to `analytics.trackLink`.');
	        }
	        on(el, 'click', function (e) {
	            var ev = is.fn(event) ? event(el) : event;
	            var props = is.fn(properties) ? properties(el) : properties;
	            var href = el.getAttribute('href') ||
	                el.getAttributeNS('http://www.w3.org/1999/xlink', 'href') ||
	                el.getAttribute('xlink:href');
	            _this.track(ev, props);
	            // @ts-ignore
	            if (href && el.target !== '_blank' && !isMeta(e)) {
	                prevent(e);
	                _this._callback(function () {
	                    window.location.href = href;
	                });
	            }
	        });
	    });
	    return this;
	};
	/**
	 * Helper method to track an outbound form that would normally navigate away
	 * from the page before the analytics calls were sent.
	 *
	 * BACKWARDS COMPATIBILITY: aliased to `trackSubmit`.
	 *
	 * @param {Element|Array} forms
	 * @param {string|Function} event
	 * @param {Object|Function} properties (optional)
	 * @return {Analytics}
	 */
	Analytics.prototype.trackSubmit = Analytics.prototype.trackForm = function (forms, event, properties) {
	    var _this = this;
	    if (!forms)
	        return this;
	    // always arrays, handles jquery
	    if (type(forms) === 'element')
	        forms = [forms];
	    var elements = forms;
	    elements.forEach(function (el) {
	        if (type(el) !== 'element')
	            throw new TypeError('Must pass HTMLElement to `analytics.trackForm`.');
	        var handler = function (e) {
	            prevent(e);
	            var ev = is.fn(event) ? event(el) : event;
	            var props = is.fn(properties) ? properties(el) : properties;
	            _this.track(ev, props);
	            _this._callback(function () {
	                el.submit();
	            });
	        };
	        // Support the events happening through jQuery or Zepto instead of through
	        // the normal DOM API, because `el.submit` doesn't bubble up events...
	        var $ = window.jQuery || window.Zepto;
	        if ($) {
	            $(el).submit(handler);
	        }
	        else {
	            on(el, 'submit', handler);
	        }
	    });
	    return this;
	};
	/**
	 * Trigger a pageview, labeling the current page with an optional `category`,
	 * `name` and `properties`.
	 *
	 * @param {string} [category]
	 * @param {string} [name]
	 * @param {Object|string} [properties] (or path)
	 * @param {Object} [options]
	 * @param {Function} [fn]
	 * @return {Analytics}
	 */
	Analytics.prototype.page = function (category, name, properties, options, fn) {
	    // Argument reshuffling.
	    /* eslint-disable no-unused-expressions, no-sequences */
	    if (is.fn(options))
	        (fn = options), (options = null);
	    if (is.fn(properties))
	        (fn = properties), (options = properties = null);
	    if (is.fn(name))
	        (fn = name), (options = properties = name = null);
	    if (type(category) === 'object')
	        (options = name), (properties = category), (name = category = null);
	    if (type(name) === 'object')
	        (options = properties), (properties = name), (name = null);
	    if (type(category) === 'string' && type(name) !== 'string')
	        (name = category), (category = null);
	    /* eslint-enable no-unused-expressions, no-sequences */
	    properties = lodash_clonedeep_1.default(properties) || {};
	    if (name)
	        properties.name = name;
	    if (category)
	        properties.category = category;
	    // Ensure properties has baseline spec properties.
	    // TODO: Eventually move these entirely to `options.context.page`
	    // FIXME: This is purposely not overriding `defs`. There was a bug in the logic implemented by `@ndhoule/defaults`.
	    //        This bug made it so we only would overwrite values in `defs` that were set to `undefined`.
	    //        In some cases, though, pageDefaults  will return defaults with values set to "" (such as `window.location.search` defaulting to "").
	    //        The decision to not fix this bus was made to preserve backwards compatibility.
	    var defs = pageDefaults();
	    properties = __assign(__assign({}, properties), defs);
	    // Mirror user overrides to `options.context.page` (but exclude custom properties)
	    // (Any page defaults get applied in `this.normalize` for consistency.)
	    // Weird, yeah--moving special props to `context.page` will fix this in the long term.
	    var overrides = lodash_pick_1.default(properties, Object.keys(defs));
	    if (!is.empty(overrides)) {
	        options = options || {};
	        options.context = options.context || {};
	        options.context.page = overrides;
	    }
	    var msg = this.normalize({
	        properties: properties,
	        category: category,
	        options: options,
	        name: name
	    });
	    // Add the initialize integrations so the server-side ones can be disabled too
	    // NOTE: We need to merge integrations, not override them with assign
	    // since it is possible to change the initialized integrations at runtime.
	    if (this.options.integrations) {
	        msg.integrations = __assign(__assign({}, this.options.integrations), msg.integrations);
	    }
	    this._invoke('page', new Page(msg));
	    this.emit('page', category, name, properties, options);
	    this._callback(fn);
	    return this;
	};
	/**
	 * FIXME: BACKWARDS COMPATIBILITY: convert an old `pageview` to a `page` call.
	 * @api private
	 */
	Analytics.prototype.pageview = function (url) {
	    var properties = {};
	    if (url)
	        properties.path = url;
	    this.page(properties);
	    return this;
	};
	/**
	 * Merge two previously unassociated user identities.
	 *
	 * @param {string} to
	 * @param {string} from (optional)
	 * @param {Object} options (optional)
	 * @param {Function} fn (optional)
	 * @return {Analytics}
	 */
	Analytics.prototype.alias = function (to, from, options, fn) {
	    // Argument reshuffling.
	    /* eslint-disable no-unused-expressions, no-sequences */
	    if (is.fn(options))
	        (fn = options), (options = null);
	    if (is.fn(from))
	        (fn = from), (options = null), (from = null);
	    if (is.object(from))
	        (options = from), (from = null);
	    /* eslint-enable no-unused-expressions, no-sequences */
	    var msg = this.normalize({
	        options: options,
	        previousId: from,
	        userId: to
	    });
	    // Add the initialize integrations so the server-side ones can be disabled too
	    // NOTE: We need to merge integrations, not override them with assign
	    // since it is possible to change the initialized integrations at runtime.
	    if (this.options.integrations) {
	        msg.integrations = __assign(__assign({}, this.options.integrations), msg.integrations);
	    }
	    this._invoke('alias', new Alias(msg));
	    this.emit('alias', to, from, options);
	    this._callback(fn);
	    return this;
	};
	/**
	 * Register a `fn` to be fired when all the analytics services are ready.
	 */
	Analytics.prototype.ready = function (fn) {
	    if (is.fn(fn)) {
	        if (this._readied) {
	            nextTick(fn);
	        }
	        else {
	            this.once('ready', fn);
	        }
	    }
	    return this;
	};
	/**
	 * Set the `timeout` (in milliseconds) used for callbacks.
	 */
	Analytics.prototype.timeout = function (timeout) {
	    this._timeout = timeout;
	};
	/**
	 * Enable or disable debug.
	 */
	Analytics.prototype.debug = function (str) {
	    if (!arguments.length || str) {
	        debug.enable('analytics:' + (str || '*'));
	    }
	    else {
	        debug.disable();
	    }
	};
	/**
	 * Apply options.
	 * @api private
	 */
	Analytics.prototype._options = function (options) {
	    options = options || {};
	    this.options = options;
	    cookie.options(options.cookie);
	    metrics.options(options.metrics);
	    store.options(options.localStorage);
	    user.options(options.user);
	    group.options(options.group);
	    return this;
	};
	/**
	 * Callback a `fn` after our defined timeout period.
	 * @api private
	 */
	Analytics.prototype._callback = function (fn) {
	    if (is.fn(fn)) {
	        this._timeout ? setTimeout(fn, this._timeout) : nextTick(fn);
	    }
	    return this;
	};
	/**
	 * Call `method` with `facade` on all enabled integrations.
	 *
	 * @param {string} method
	 * @param {Facade} facade
	 * @return {Analytics}
	 * @api private
	 */
	Analytics.prototype._invoke = function (method, facade) {
	    var self = this;
	    try {
	        this._sourceMiddlewares.applyMiddlewares(extend(true, new Facade({}), facade), this._integrations, function (result) {
	            // A nullified payload should not be sent.
	            if (result === null) {
	                self.log('Payload with method "%s" was null and dropped by source a middleware.', method);
	                return;
	            }
	            // Check if the payload is still a Facade. If not, convert it to one.
	            if (!(result instanceof Facade)) {
	                result = new Facade(result);
	            }
	            self.emit('invoke', result);
	            metrics.increment('analytics_js.invoke', {
	                method: method
	            });
	            applyIntegrationMiddlewares(result);
	        });
	    }
	    catch (e) {
	        metrics.increment('analytics_js.invoke.error', {
	            method: method
	        });
	        self.log('Error invoking .%s method of %s integration: %o', method, name, e);
	    }
	    return this;
	    function applyIntegrationMiddlewares(facade) {
	        var failedInitializations = self.failedInitializations || [];
	        Object.keys(self._integrations).forEach(function (key) {
	            var integration = self._integrations[key];
	            var name = integration.name;
	            var facadeCopy = extend(true, new Facade({}), facade);
	            if (!facadeCopy.enabled(name))
	                return;
	            // Check if an integration failed to initialize.
	            // If so, do not process the message as the integration is in an unstable state.
	            if (failedInitializations.indexOf(name) >= 0) {
	                self.log('Skipping invocation of .%s method of %s integration. Integration failed to initialize properly.', method, name);
	            }
	            else {
	                try {
	                    // Apply any integration middlewares that exist, then invoke the integration with the result.
	                    self._integrationMiddlewares.applyMiddlewares(facadeCopy, integration.name, function (result) {
	                        // A nullified payload should not be sent to an integration.
	                        if (result === null) {
	                            self.log('Payload to integration "%s" was null and dropped by a middleware.', name);
	                            return;
	                        }
	                        // Check if the payload is still a Facade. If not, convert it to one.
	                        if (!(result instanceof Facade)) {
	                            result = new Facade(result);
	                        }
	                        // apply destination middlewares
	                        // Apply any integration middlewares that exist, then invoke the integration with the result.
	                        if (self._destinationMiddlewares[integration.name]) {
	                            self._destinationMiddlewares[integration.name].applyMiddlewares(facadeCopy, integration.name, function (result) {
	                                // A nullified payload should not be sent to an integration.
	                                if (result === null) {
	                                    self.log('Payload to destination "%s" was null and dropped by a middleware.', name);
	                                    return;
	                                }
	                                // Check if the payload is still a Facade. If not, convert it to one.
	                                if (!(result instanceof Facade)) {
	                                    result = new Facade(result);
	                                }
	                                metrics.increment('analytics_js.integration.invoke', {
	                                    method: method,
	                                    integration_name: integration.name
	                                });
	                                integration.invoke.call(integration, method, result);
	                            });
	                        }
	                        else {
	                            metrics.increment('analytics_js.integration.invoke', {
	                                method: method,
	                                integration_name: integration.name
	                            });
	                            integration.invoke.call(integration, method, result);
	                        }
	                    });
	                }
	                catch (e) {
	                    metrics.increment('analytics_js.integration.invoke.error', {
	                        method: method,
	                        integration_name: integration.name
	                    });
	                    self.log('Error invoking .%s method of %s integration: %o', method, name, e);
	                }
	            }
	        });
	    }
	};
	/**
	 * Push `args`.
	 *
	 * @param {Array} args
	 * @api private
	 */
	Analytics.prototype.push = function (args) {
	    var method = args.shift();
	    if (!this[method])
	        return;
	    this[method].apply(this, args);
	};
	/**
	 * Reset group and user traits and id's.
	 *
	 * @api public
	 */
	Analytics.prototype.reset = function () {
	    this.user().logout();
	    this.group().logout();
	};
	/**
	 * Parse the query string for callable methods.
	 *
	 * @api private
	 */
	Analytics.prototype._parseQuery = function (query) {
	    // Parse querystring to an object
	    var q = querystring.parse(query);
	    // Create traits and properties objects, populate from querysting params
	    var traits = pickPrefix('ajs_trait_', q);
	    var props = pickPrefix('ajs_prop_', q);
	    // Trigger based on callable parameters in the URL
	    if (q.ajs_uid)
	        this.identify(q.ajs_uid, traits);
	    if (q.ajs_event)
	        this.track(q.ajs_event, props);
	    if (q.ajs_aid)
	        user.anonymousId(q.ajs_aid);
	    return this;
	    /**
	     * Create a shallow copy of an input object containing only the properties
	     * whose keys are specified by a prefix, stripped of that prefix
	     *
	     * @return {Object}
	     * @api private
	     */
	    function pickPrefix(prefix, object) {
	        var length = prefix.length;
	        var sub;
	        return Object.keys(object).reduce(function (acc, key) {
	            if (key.substr(0, length) === prefix) {
	                sub = key.substr(length);
	                acc[sub] = object[key];
	            }
	            return acc;
	        }, {});
	    }
	};
	/**
	 * Normalize the given `msg`.
	 */
	Analytics.prototype.normalize = function (msg) {
	    msg = normalize(msg, Object.keys(this._integrations));
	    if (msg.anonymousId)
	        user.anonymousId(msg.anonymousId);
	    msg.anonymousId = user.anonymousId();
	    // Ensure all outgoing requests include page data in their contexts.
	    msg.context.page = __assign(__assign({}, pageDefaults()), msg.context.page);
	    return msg;
	};
	/**
	 * Merges the tracking plan and initialization integration options.
	 *
	 * @param  {Object} planIntegrations Tracking plan integrations.
	 * @return {Object}                  The merged integrations.
	 */
	Analytics.prototype._mergeInitializeAndPlanIntegrations = function (planIntegrations) {
	    // Do nothing if there are no initialization integrations
	    if (!this.options.integrations) {
	        return planIntegrations;
	    }
	    // Clone the initialization integrations
	    var integrations = extend({}, this.options.integrations);
	    var integrationName;
	    // Allow the tracking plan to disable integrations that were explicitly
	    // enabled on initialization
	    if (planIntegrations.All === false) {
	        integrations = { All: false };
	    }
	    for (integrationName in planIntegrations) {
	        if (planIntegrations.hasOwnProperty(integrationName)) {
	            // Don't allow the tracking plan to re-enable disabled integrations
	            if (this.options.integrations[integrationName] !== false) {
	                integrations[integrationName] = planIntegrations[integrationName];
	            }
	        }
	    }
	    return integrations;
	};
	/**
	 * No conflict support.
	 */
	Analytics.prototype.noConflict = function () {
	    window.analytics = _analytics;
	    return this;
	};
	/*
	 * Exports.
	 */
	module.exports = Analytics;
	module.exports.cookie = cookie;
	module.exports.memory = memory;
	module.exports.store = store;
	module.exports.metrics = metrics;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Module dependencies.
	 */
	var Entity = __webpack_require__(392);
	var bindAll = __webpack_require__(118);
	var debug = __webpack_require__(110)('analytics:group');
	var inherit = __webpack_require__(317);
	/**
	 * Group defaults
	 */
	Group.defaults = {
	    persist: true,
	    cookie: {
	        key: 'ajs_group_id'
	    },
	    localStorage: {
	        key: 'ajs_group_properties'
	    }
	};
	/**
	 * Initialize a new `Group` with `options`.
	 */
	function Group(options) {
	    this.defaults = Group.defaults;
	    this.debug = debug;
	    Entity.call(this, options);
	}
	/**
	 * Inherit `Entity`
	 */
	inherit(Group, Entity);
	/**
	 * Expose the group singleton.
	 */
	module.exports = bindAll(new Group());
	/**
	 * Expose the `Group` constructor.
	 */
	module.exports.Group = Group;


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var bindAll = __webpack_require__(118);
	var send = __webpack_require__(855);
	var debug = __webpack_require__(110)('analytics.js:metrics');
	function Metrics(options) {
	    this.options(options);
	}
	/**
	 * Set the metrics options.
	 */
	Metrics.prototype.options = function (options) {
	    options = options || {};
	    this.host = options.host || 'api.segment.io/v1';
	    this.sampleRate = options.sampleRate || 0; // disable metrics by default.
	    this.flushTimer = options.flushTimer || 30 * 1000 /* 30s */;
	    this.maxQueueSize = options.maxQueueSize || 20;
	    this.queue = [];
	    if (this.sampleRate > 0) {
	        var self = this;
	        setInterval(function () {
	            self._flush();
	        }, this.flushTimer);
	    }
	};
	/**
	 * Increments the counter identified by name and tags by one.
	 */
	Metrics.prototype.increment = function (metric, tags) {
	    if (Math.random() > this.sampleRate) {
	        return;
	    }
	    if (this.queue.length >= this.maxQueueSize) {
	        return;
	    }
	    this.queue.push({ type: 'Counter', metric: metric, value: 1, tags: tags });
	    // Trigger a flush if this is an error metric.
	    if (metric.indexOf('error') > 0) {
	        this._flush();
	    }
	};
	/**
	 * Flush all queued metrics.
	 */
	Metrics.prototype._flush = function () {
	    var self = this;
	    if (self.queue.length <= 0) {
	        return;
	    }
	    var payload = { series: this.queue };
	    var headers = { 'Content-Type': 'text/plain' };
	    self.queue = [];
	    // This endpoint does not support jsonp, so only proceed if the browser
	    // supports xhr.
	    if (send.type !== 'xhr')
	        return;
	    send('https://' + this.host + '/m', payload, headers, function (err, res) {
	        debug('sent %O, received %O', payload, [err, res]);
	    });
	};
	/**
	 * Expose the metrics singleton.
	 */
	module.exports = bindAll(new Metrics());
	/**
	 * Expose the `Metrics` constructor.
	 */
	module.exports.Metrics = Metrics;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_includes_1 = __importDefault(__webpack_require__(525));
	/**
	 * Module Dependencies.
	 */
	var debug = __webpack_require__(110)('analytics.js:normalize');
	var type = __webpack_require__(86);
	var uuid = __webpack_require__(396);
	var md5 = __webpack_require__(1772).hash;
	/**
	 * HOP.
	 */
	var has = Object.prototype.hasOwnProperty;
	/**
	 * Expose `normalize`
	 */
	module.exports = normalize;
	/**
	 * Toplevel properties.
	 */
	var toplevel = ['integrations', 'anonymousId', 'timestamp', 'context'];
	function normalize(msg, list) {
	    var lower = list === null || list === void 0 ? void 0 : list.map(function (s) {
	        return s.toLowerCase();
	    });
	    var opts = msg.options || {};
	    var integrations = opts.integrations || {};
	    var providers = opts.providers || {};
	    var context = opts.context || {};
	    var ret = {};
	    debug('<-', msg);
	    // integrations.
	    Object.keys(opts).forEach(function (key) {
	        if (!integration(key))
	            return;
	        if (!has.call(integrations, key))
	            integrations[key] = opts[key];
	        delete opts[key];
	    });
	    // providers.
	    delete opts.providers;
	    Object.keys(providers).forEach(function (key) {
	        if (!integration(key))
	            return;
	        if (type(integrations[key]) === 'object')
	            return;
	        if (has.call(integrations, key) && typeof providers[key] === 'boolean')
	            return;
	        integrations[key] = providers[key];
	    });
	    // move all toplevel options to msg
	    // and the rest to context.
	    Object.keys(opts).forEach(function (key) {
	        if (lodash_includes_1.default(toplevel, key)) {
	            ret[key] = opts[key];
	        }
	        else {
	            context[key] = opts[key];
	        }
	    }, opts);
	    // generate and attach a messageId to msg
	    msg.messageId = 'ajs-' + md5(window.JSON.stringify(msg) + uuid());
	    // cleanup
	    delete msg.options;
	    ret.integrations = integrations;
	    ret.context = context;
	    ret = __assign(__assign({}, msg), ret);
	    debug('->', ret);
	    return ret;
	    function integration(name) {
	        return !!(lodash_includes_1.default(list, name) ||
	            name.toLowerCase() === 'all' ||
	            lodash_includes_1.default(lower, name.toLowerCase()));
	    }
	}


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_includes_1 = __importDefault(__webpack_require__(525));
	var canonical_1 = __importDefault(__webpack_require__(845));
	var component_url_1 = __importDefault(__webpack_require__(480));
	/**
	 * Return a default `options.context.page` object.
	 *
	 * https://segment.com/docs/spec/page/#properties
	 */
	function pageDefaults() {
	    return {
	        path: canonicalPath(),
	        referrer: document.referrer,
	        search: location.search,
	        title: document.title,
	        url: canonicalUrl(location.search)
	    };
	}
	/**
	 * Return the canonical path for the page.
	 */
	function canonicalPath() {
	    var canon = canonical_1.default();
	    if (!canon)
	        return window.location.pathname;
	    var parsed = component_url_1.default.parse(canon);
	    return parsed.pathname;
	}
	/**
	 * Return the canonical URL for the page concat the given `search`
	 * and strip the hash.
	 */
	function canonicalUrl(search) {
	    var canon = canonical_1.default();
	    if (canon)
	        return lodash_includes_1.default(canon, '?') ? canon : canon + search;
	    var url = window.location.href;
	    var i = url.indexOf('#');
	    return i === -1 ? url : url.slice(0, i);
	}
	/*
	 * Exports.
	 */
	module.exports = pageDefaults;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var Entity = __webpack_require__(392);
	var bindAll = __webpack_require__(118);
	var cookie = __webpack_require__(259);
	var debug = __webpack_require__(110)('analytics:user');
	var inherit = __webpack_require__(317);
	var rawCookie = __webpack_require__(397);
	var uuid = __webpack_require__(838);
	var localStorage = __webpack_require__(261);
	User.defaults = {
	    persist: true,
	    cookie: {
	        key: 'ajs_user_id',
	        oldKey: 'ajs_user'
	    },
	    localStorage: {
	        key: 'ajs_user_traits'
	    }
	};
	/**
	 * Initialize a new `User` with `options`.
	 */
	function User(options) {
	    this.defaults = User.defaults;
	    this.debug = debug;
	    Entity.call(this, options);
	}
	/**
	 * Inherit `Entity`
	 */
	inherit(User, Entity);
	/**
	 * Set/get the user id.
	 *
	 * When the user id changes, the method will reset his anonymousId to a new one.
	 *
	 * @example
	 * // didn't change because the user didn't have previous id.
	 * anonymousId = user.anonymousId();
	 * user.id('foo');
	 * assert.equal(anonymousId, user.anonymousId());
	 *
	 * // didn't change because the user id changed to null.
	 * anonymousId = user.anonymousId();
	 * user.id('foo');
	 * user.id(null);
	 * assert.equal(anonymousId, user.anonymousId());
	 *
	 * // change because the user had previous id.
	 * anonymousId = user.anonymousId();
	 * user.id('foo');
	 * user.id('baz'); // triggers change
	 * user.id('baz'); // no change
	 * assert.notEqual(anonymousId, user.anonymousId());
	 */
	User.prototype.id = function (id) {
	    var prev = this._getId();
	    var ret = Entity.prototype.id.apply(this, arguments);
	    if (prev == null)
	        return ret;
	    // FIXME: We're relying on coercion here (1 == "1"), but our API treats these
	    // two values differently. Figure out what will break if we remove this and
	    // change to strict equality
	    /* eslint-disable eqeqeq */
	    if (prev != id && id)
	        this.anonymousId(null);
	    /* eslint-enable eqeqeq */
	    return ret;
	};
	/**
	 * Set / get / remove anonymousId.
	 *
	 * @param {String} anonymousId
	 * @return {String|User}
	 */
	User.prototype.anonymousId = function (anonymousId) {
	    var store = this.storage();
	    // set / remove
	    if (arguments.length) {
	        store.set('ajs_anonymous_id', anonymousId);
	        this._setAnonymousIdInLocalStorage(anonymousId);
	        return this;
	    }
	    // new
	    anonymousId = store.get('ajs_anonymous_id');
	    if (anonymousId) {
	        // value exists in cookie, copy it to localStorage
	        this._setAnonymousIdInLocalStorage(anonymousId);
	        // refresh cookie to extend expiry
	        store.set('ajs_anonymous_id', anonymousId);
	        return anonymousId;
	    }
	    if (!this._options.localStorageFallbackDisabled) {
	        // if anonymousId doesn't exist in cookies, check localStorage
	        anonymousId = localStorage.get('ajs_anonymous_id');
	        if (anonymousId) {
	            // Write to cookies if available in localStorage but not cookies
	            store.set('ajs_anonymous_id', anonymousId);
	            return anonymousId;
	        }
	    }
	    // old - it is not stringified so we use the raw cookie.
	    anonymousId = rawCookie('_sio');
	    if (anonymousId) {
	        anonymousId = anonymousId.split('----')[0];
	        store.set('ajs_anonymous_id', anonymousId);
	        this._setAnonymousIdInLocalStorage(anonymousId);
	        store.remove('_sio');
	        return anonymousId;
	    }
	    // empty
	    anonymousId = uuid.v4();
	    store.set('ajs_anonymous_id', anonymousId);
	    this._setAnonymousIdInLocalStorage(anonymousId);
	    return store.get('ajs_anonymous_id');
	};
	/**
	 * Set the user's `anonymousid` in local storage.
	 */
	User.prototype._setAnonymousIdInLocalStorage = function (id) {
	    if (!this._options.localStorageFallbackDisabled) {
	        localStorage.set('ajs_anonymous_id', id);
	    }
	};
	/**
	 * Remove anonymous id on logout too.
	 */
	User.prototype.logout = function () {
	    Entity.prototype.logout.call(this);
	    this.anonymousId(null);
	};
	/**
	 * Load saved user `id` or `traits` from storage.
	 */
	User.prototype.load = function () {
	    if (this._loadOldCookie())
	        return;
	    Entity.prototype.load.call(this);
	};
	/**
	 * BACKWARDS COMPATIBILITY: Load the old user from the cookie.
	 *
	 * @api private
	 */
	User.prototype._loadOldCookie = function () {
	    var user = cookie.get(this._options.cookie.oldKey);
	    if (!user)
	        return false;
	    this.id(user.id);
	    this.traits(user.traits);
	    cookie.remove(this._options.cookie.oldKey);
	    return true;
	};
	/**
	 * Expose the user singleton.
	 */
	module.exports = bindAll(new User());
	/**
	 * Expose the `User` constructor.
	 */
	module.exports.User = User;


/***/ }),
/* 835 */
[1844, 837],
/* 836 */
/***/ (function(module, exports) {

	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var defineProperty = Object.defineProperty;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
	var setProperty = function setProperty(target, options) {
		if (defineProperty && options.name === '__proto__') {
			defineProperty(target, options.name, {
				enumerable: true,
				configurable: true,
				value: options.newValue,
				writable: true
			});
		} else {
			target[options.name] = options.newValue;
		}
	};
	
	// Return undefined instead of __proto__ if '__proto__' is not an own property
	var getProperty = function getProperty(obj, name) {
		if (name === '__proto__') {
			if (!hasOwn.call(obj, name)) {
				return void 0;
			} else if (gOPD) {
				// In early versions of node, obj['__proto__'] is buggy when obj has
				// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
				return gOPD(obj, name).value;
			}
		}
	
		return obj[name];
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = getProperty(target, name);
					copy = getProperty(options, name);
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							setProperty(target, { name: name, newValue: extend(deep, clone, copy) });
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							setProperty(target, { name: name, newValue: copy });
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};


/***/ }),
/* 837 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(839);
	var v4 = __webpack_require__(396);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(395);
	var bytesToUuid = __webpack_require__(394);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/uuidjs/uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	
	var alias = __webpack_require__(828);
	var dates = __webpack_require__(846);
	var del = __webpack_require__(182).del;
	var includes = __webpack_require__(391);
	var integration = __webpack_require__(841);
	var iso = __webpack_require__(857);
	var pick = __webpack_require__(826);
	var is = __webpack_require__(167);
	var indexOf = __webpack_require__(1265);
	
	/**
	 * Expose `Mixpanel` integration.
	 */
	
	var Mixpanel = (module.exports = integration('Mixpanel')
	  .global('mixpanel')
	  .option('eventIncrements', [])
	  .option('propIncrements', [])
	  .option('peopleProperties', [])
	  .option('superProperties', [])
	  .option('cookieName', '')
	  .option('crossSubdomainCookie', false)
	  .option('secureCookie', false)
	  .option('persistence', 'cookie')
	  .option('nameTag', true)
	  .option('pageview', false)
	  .option('people', false)
	  .option('token', '')
	  .option('setAllTraitsByDefault', true)
	  .option('consolidatedPageCalls', true)
	  .option('trackAllPages', false)
	  .option('trackNamedPages', false)
	  .option('trackCategorizedPages', false)
	  .option('groupIdentifierTraits', [])
	  .option('sourceName', '')
	  .option('enableEuropeanUnionEndpoint', false)
	  .tag('<script src="//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js">'));
	
	/**
	 * Options aliases.
	 */
	
	var optionsAliases = {
	  cookieName: 'cookie_name',
	  crossSubdomainCookie: 'cross_subdomain_cookie',
	  secureCookie: 'secure_cookie'
	};
	
	/**
	 * Initialize.
	 *
	 * https://mixpanel.com/help/reference/javascript#installing
	 * https://mixpanel.com/help/reference/javascript-full-api-reference#mixpanel.init
	 *
	 * @api public
	 */
	
	Mixpanel.prototype.initialize = function() {
	  /* eslint-disable */
	  (function(e,a){if(!a.__SV){var b=window;try{var c,l,i,j=b.location,g=j.hash;c=function(a,b){return(l=a.match(RegExp(b+"=([^&]*)")))?l[1]:null};g&&c(g,"state")&&(i=JSON.parse(decodeURIComponent(c(g,"state"))),"mpeditor"===i.action&&(b.sessionStorage.setItem("_mpcehash",g),history.replaceState(i.desiredHash||"",e.title,j.pathname+j.search)))}catch(m){}var k,h;window.mixpanel=a;a._i=[];a.init=function(b,c,f){function e(b,a){var c=a.split(".");2==c.length&&(b=b[c[0]],a=c[1]);b[a]=function(){b.push([a].concat(Array.prototype.slice.call(arguments,
	0)))}}var d=a;"undefined"!==typeof f?d=a[f]=[]:f="mixpanel";d.people=d.people||[];d.toString=function(b){var a="mixpanel";"mixpanel"!==f&&(a+="."+f);b||(a+=" (stub)");return a};d.people.toString=function(){return d.toString(1)+".people (stub)"};k="disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user".split(" ");
	for(h=0;h<k.length;h++)e(d,k[h]);a._i.push([b,c,f])};a.__SV=1.2;}})(document,window.mixpanel||[]);
	  /* eslint-enable */
	  this.options.eventIncrements = lowercase(this.options.eventIncrements);
	  this.options.propIncrements = lowercase(this.options.propIncrements);
	  var options = alias(this.options, optionsAliases);
	  if (this.options.enableEuropeanUnionEndpoint) {
	    // https://developer.mixpanel.com/docs/implement-mixpanel#section-implementing-mixpanel-in-the-european-union-eu
	    options.api_host = 'https://api-eu.mixpanel.com';
	  }
	  // tag ajs requests with Segment by request from Mixpanel team for better mutual debugging
	  options.loaded = function(mixpanel) {
	    mixpanel.register({ mp_lib: 'Segment: web' });
	  };
	  window.mixpanel.init(options.token, options);
	  this.load(this.ready);
	};
	
	/**
	 * Loaded?
	 *
	 * @api private
	 * @return {boolean}
	 */
	
	Mixpanel.prototype.loaded = function() {
	  return !!(window.mixpanel && window.mixpanel.config);
	};
	
	/**
	 * Page.
	 *
	 * https://mixpanel.com/help/reference/javascript-full-api-reference#mixpanel.track_pageview
	 *
	 * @api public
	 * @param {Page} page
	 */
	
	Mixpanel.prototype.page = function(page) {
	  var category = page.category();
	  var name = page.name();
	  var opts = this.options;
	
	  // consolidated Page Calls
	  if (opts.consolidatedPageCalls) {
	    this.track(page.track());
	    return;
	  }
	
	  // all pages
	  if (opts.trackAllPages) {
	    this.track(page.track());
	    return;
	  }
	
	  // categorized pages
	  if (opts.trackCategorizedPages && category) {
	    // If this option is checked and name was also passed, used the full name which includes both category & name
	    if (name) {
	      this.track(page.track(page.fullName()));
	      return;
	    }
	    this.track(page.track(category));
	    return;
	  }
	
	  // named pages
	  if (name && opts.trackNamedPages) {
	    this.track(page.track(name));
	  }
	};
	
	/**
	 * Trait aliases.
	 */
	
	var traitAliases = {
	  created: '$created',
	  email: '$email',
	  firstName: '$first_name',
	  lastName: '$last_name',
	  lastSeen: '$last_seen',
	  name: '$name',
	  username: '$username',
	  phone: '$phone'
	};
	
	/**
	 * Identify.
	 *
	 * https://mixpanel.com/help/reference/javascript#super-properties
	 * https://mixpanel.com/help/reference/javascript#user-identity
	 * https://mixpanel.com/help/reference/javascript#storing-user-profiles
	 *
	 * @api public
	 * @param {Identify} identify
	 */
	
	Mixpanel.prototype.identify = function(identify) {
	  var username = identify.username();
	  var email = identify.email();
	  var id = identify.userId();
	  var setAllTraitsByDefault = this.options.setAllTraitsByDefault;
	  var people = this.options.people;
	  var peopleProperties = extendTraits(this.options.peopleProperties);
	  var superProperties = this.options.superProperties;
	
	  // id
	  if (id) window.mixpanel.identify(id);
	
	  // name tag
	  var nametag = email || username || id;
	  if (nametag) window.mixpanel.name_tag(nametag);
	
	  var traits = identify.traits(traitAliases);
	  if (traits.$created) del(traits, 'createdAt');
	  traits = dates(traits, iso);
	
	  // determine which traits to union to existing properties and which to set as new properties
	  var traitsToUnion = {};
	  var traitsToSet = {};
	  for (var key in traits) {
	    if (!traits.hasOwnProperty(key)) continue;
	
	    var trait = traits[key];
	    if (Array.isArray(trait) && trait.length > 0) {
	      traitsToUnion[key] = trait;
	      // since mixpanel doesn't offer a union method for super properties we have to do it manually by retrieving the existing list super property
	      // from mixpanel and manually unioning to it ourselves
	      var existingTrait = window.mixpanel.get_property(key);
	      if (existingTrait && Array.isArray(existingTrait)) {
	        traits[key] = unionArrays(existingTrait, trait);
	      }
	    } else {
	      traitsToSet[key] = trait;
	    }
	  }
	
	  if (setAllTraitsByDefault) {
	    window.mixpanel.register(traits);
	    if (people) {
	      window.mixpanel.people.set(traitsToSet);
	      window.mixpanel.people.union(traitsToUnion);
	    }
	  } else {
	    // explicitly set select traits as people and super properties
	    var mappedSuperProps = mapTraits(superProperties);
	    var superProps = pick(mappedSuperProps || [], traits);
	    if (!is.empty(superProps)) window.mixpanel.register(superProps);
	    if (people) {
	      var mappedPeopleProps = mapTraits(peopleProperties);
	      var peoplePropsToSet = pick(mappedPeopleProps || [], traitsToSet);
	      var peoplePropsToUnion = pick(mappedPeopleProps || [], traitsToUnion);
	      if (!is.empty(peoplePropsToSet))
	        window.mixpanel.people.set(peoplePropsToSet);
	      if (!is.empty(peoplePropsToUnion))
	        window.mixpanel.people.union(peoplePropsToUnion);
	    }
	  }
	};
	
	/**
	 * Track.
	 *
	 * https://mixpanel.com/help/reference/javascript#sending-events
	 * https://mixpanel.com/help/reference/javascript#tracking-revenue
	 *
	 * @api public
	 * @param {Track} track
	 */
	
	Mixpanel.prototype.track = function(track) {
	  var eventIncrements = this.options.eventIncrements || this.options.increments; // TODO: remove settings.increments check, it's only here as we cutover from increments to eventIncrements
	  var propIncrements = this.options.propIncrements;
	  var eventLowercase = track.event().toLowerCase();
	  var people = this.options.people;
	  var props = track.properties();
	  var revenue = track.revenue();
	  // Don't map traits, clients should use identify instead.
	  var superProps = pick(this.options.superProperties, props);
	  var sourceName = this.options.sourceName;
	
	  if (sourceName) props.segment_source_name = sourceName;
	
	  // delete mixpanel's reserved properties, so they don't conflict
	  delete props.distinct_id;
	  delete props.ip;
	  delete props.mp_name_tag;
	  delete props.mp_note;
	  delete props.token;
	
	  props = dates(props, iso);
	  invertObjectArrays(props);
	
	  // Mixpanel People operations
	  if (people) {
	    // increment event count
	    if (includes(eventLowercase, eventIncrements)) {
	      window.mixpanel.people.increment(track.event());
	      window.mixpanel.people.set('Last ' + track.event(), new Date());
	    }
	    // increment property counts
	    for (var key in props) {
	      if (!Object.prototype.hasOwnProperty.call(props, key)) {
	        continue;
	      }
	      var prop = props[key];
	      if (includes(key.toLowerCase(), propIncrements)) {
	        window.mixpanel.people.increment(key, prop);
	      }
	    }
	    // track revenue
	    if (revenue) {
	      window.mixpanel.people.track_charge(revenue);
	    }
	  }
	
	  // track the event
	  var query;
	  if (props.link_query) {
	    query = props.link_query; // DOM query
	    delete props.link_query;
	    window.mixpanel.track_links(query, track.event(), props);
	  } else if (props.form_query) {
	    // DOM query
	    query = props.form_query;
	    delete props.form_query;
	    window.mixpanel.track_forms(query, track.event(), props);
	  } else {
	    window.mixpanel.track(track.event(), props);
	  }
	
	  // register super properties if present in context.mixpanel.superProperties
	  if (!is.empty(superProps)) {
	    window.mixpanel.register(superProps);
	  }
	};
	
	/**
	 * Alias.
	 *
	 * https://mixpanel.com/help/reference/javascript#user-identity
	 * https://mixpanel.com/help/reference/javascript-full-api-reference#mixpanel.alias
	 *
	 * @api public
	 * @param {Alias} alias
	 */
	
	Mixpanel.prototype.alias = function(alias) {
	  var mp = window.mixpanel;
	  var to = alias.to();
	  if (mp.get_distinct_id && mp.get_distinct_id() === to) return;
	  // HACK: internal mixpanel API to ensure we don't overwrite
	  if (mp.get_property && mp.get_property('$people_distinct_id') === to) return;
	  // although undocumented, mixpanel takes an optional original id
	  mp.alias(to, alias.from());
	};
	
	/**
	 *
	 * @param {Group} group
	 */
	
	Mixpanel.prototype.group = function(group) {
	  var groupIdentifierTraits = this.options.groupIdentifierTraits;
	  var groupId = group.groupId();
	  var userId = this.analytics.user().id();
	  var traits = group.properties();
	  if (!groupId || !userId || !groupIdentifierTraits.length) {
	    return;
	  }
	
	  if (traits && Object.keys(traits).length) {
	    for (var ind = 0; ind < groupIdentifierTraits.length; ind++) {
	      window.mixpanel
	        .get_group(groupIdentifierTraits[ind], groupId)
	        .set_once(traits);
	    }
	  }
	  for (var i = 0; i < groupIdentifierTraits.length; i++) {
	    window.mixpanel.set_group(groupIdentifierTraits[i], [groupId]);
	  }
	};
	
	/**
	 * Lowercase the given `arr`.
	 *
	 * @api private
	 * @param {Array} arr
	 * @return {Array}
	 */
	
	function lowercase(arr) {
	  var ret = new Array(arr.length);
	
	  for (var i = 0; i < arr.length; ++i) {
	    ret[i] = String(arr[i]).toLowerCase();
	  }
	
	  return ret;
	}
	
	/**
	 * Map Special traits in the given `arr`.
	 * From the TraitAliases for Mixpanel's special props
	 *
	 * @api private
	 * @param {Array} arr
	 * @return {Array}
	 */
	
	function mapTraits(arr) {
	  var ret = new Array(arr.length);
	
	  for (var i = 0; i < arr.length; ++i) {
	    if (traitAliases.hasOwnProperty(arr[i])) {
	      ret.push(traitAliases[arr[i]]);
	    } else {
	      ret.push(arr[i]);
	    }
	  }
	
	  return ret;
	}
	
	/**
	 * extend Mixpanel's special trait keys in the given `arr`.
	 *
	 * @api private
	 * @param {Array} arr
	 * @return {Array}
	 */
	
	function extendTraits(arr) {
	  var keys = [];
	
	  for (var key in traitAliases) {
	    if (traitAliases.hasOwnProperty(key)) {
	      keys.push(key);
	    }
	  }
	
	  for (var i = 0; i < keys.length; ++i) {
	    if (indexOf(arr, keys[i]) < 0) {
	      arr.push(keys[i]);
	    }
	  }
	
	  return arr;
	}
	
	/**
	 * Since Mixpanel doesn't support lists of objects, invert each list of objects to a set of lists of object properties.
	 * Treats list transformation atomically, e.g. will only transform if EVERY item in list is an object
	 *
	 * @api private
	 * @param {Object} props
	 * @example
	 * input: {products: [{sku: 32, revenue: 99}, {sku:2, revenue: 103}]}
	 * output: {products_skus: [32, 2], products_revenues: [99, 103]}
	 */
	
	function invertObjectArrays(props) {
	  var properties = props;
	  for (var propName in properties) {  // eslint-disable-line
	    var propValue = properties[propName];
	    if (!properties.hasOwnProperty(propName) || !Array.isArray(propValue)) {
	      continue;
	    }
	
	    var invertedArrays = invertObjectArray(propName, propValue);
	    if (Object.keys(invertedArrays).length !== 0) {
	      // make sure obj isn't empty
	      mergeArraysIntoObj(properties, invertedArrays);
	      delete properties[propName];
	    }
	  }
	}
	
	// Example:
	// input: 'products', [{sku: 32, revenue: 99}, {sku:2, revenue: 103}]
	// output: {products_skus: [32, 2], products_revenues: [99, 103]}
	function invertObjectArray(propName, arr) {
	  var invertedArrays = {};
	
	  // invert object lists and collect into invertedLists
	  for (var i = 0; i < arr.length; i++) {
	    var elem = arr[i];
	
	    // abort operation if non-object encountered in array
	    if (typeof elem !== 'object') {
	      return {};
	    }
	    for (var key in elem) {
	      if (!elem.hasOwnProperty(key)) {
	        continue;
	      }
	      var attrKey = propName + '_' + key + 's'; // e.g. products_skus
	
	      // append to list if it exists or create new one if not
	      if (attrKey in invertedArrays) {
	        invertedArrays[attrKey].push(elem[key]);
	      } else {
	        invertedArrays[attrKey] = [elem[key]];
	      }
	    }
	  }
	  return invertedArrays;
	}
	
	function mergeArraysIntoObj(destination, source) {
	  var d = destination;
	  for (var arrayName in source) {
	    if (source.hasOwnProperty(arrayName)) {
	      var arr = source[arrayName];
	      d[arrayName] = arrayName in d ? d[arrayName].concat(arr) : arr;
	    }
	  }
	}
	
	/**
	 * Return union of two arrays
	 * Pulled from https://stackoverflow.com/a/3629861
	 *
	 * @param {Array} x
	 * @param {Array} y
	 * @return {Array} res
	 * @api private
	 */
	
	function unionArrays(x, y) {
	  var obj = {};
	  // store items of each array as keys/values of obj, implicitly overwriting duplicates
	  var i;
	  for (i = 0; i < x.length; i++) {
	    obj[x[i]] = x[i];
	  }
	  for (i = 0; i < y.length; i++) {
	    obj[y[i]] = y[i];
	  }
	  return Object.keys(obj);
	}


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	
	var bind = __webpack_require__(477);
	var clone = __webpack_require__(258);
	var debug = __webpack_require__(305);
	var defaults = __webpack_require__(390);
	var extend = __webpack_require__(823);
	var slug = __webpack_require__(1770);
	var protos = __webpack_require__(842);
	var statics = __webpack_require__(843);
	
	/**
	 * Create a new `Integration` constructor.
	 *
	 * @constructs Integration
	 * @param {string} name
	 * @return {Function} Integration
	 */
	
	function createIntegration(name) {
	  /**
	   * Initialize a new `Integration`.
	   *
	   * @class
	   * @param {Object} options
	   */
	
	  function Integration(options) {
	    if (options && options.addIntegration) {
	      // plugin
	      return options.addIntegration(Integration);
	    }
	    this.debug = debug('analytics:integration:' + slug(name));
	    this.options = defaults(clone(options) || {}, this.defaults);
	    this._queue = [];
	    this.once('ready', bind(this, this.flush));
	
	    Integration.emit('construct', this);
	    this.ready = bind(this, this.ready);
	    this._wrapInitialize();
	    this._wrapPage();
	    this._wrapTrack();
	  }
	
	  Integration.prototype.defaults = {};
	  Integration.prototype.globals = [];
	  Integration.prototype.templates = {};
	  Integration.prototype.name = name;
	  extend(Integration, statics);
	  extend(Integration.prototype, protos);
	
	  return Integration;
	}
	
	/**
	 * Exports.
	 */
	
	module.exports = createIntegration;


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(303);
	var after = __webpack_require__(819);
	var each = __webpack_require__(133);
	var events = __webpack_require__(861);
	var every = __webpack_require__(822);
	var fmt = __webpack_require__(850);
	var foldl = __webpack_require__(824);
	var is = __webpack_require__(167);
	var loadIframe = __webpack_require__(1354);
	var loadScript = __webpack_require__(853);
	var nextTick = __webpack_require__(239);
	var normalize = __webpack_require__(1816);
	
	/**
	 * hasOwnProperty reference.
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * No operation.
	 */
	
	var noop = function noop() {};
	
	/**
	 * Window defaults.
	 */
	
	var onerror = window.onerror;
	var onload = null;
	
	/**
	 * Mixin emitter.
	 */
	
	/* eslint-disable new-cap */
	Emitter(exports);
	/* eslint-enable new-cap */
	
	/**
	 * Initialize.
	 */
	
	exports.initialize = function() {
	  var ready = this.ready;
	  nextTick(ready);
	};
	
	/**
	 * Loaded?
	 *
	 * @api private
	 * @return {boolean}
	 */
	
	exports.loaded = function() {
	  return false;
	};
	
	/**
	 * Page.
	 *
	 * @api public
	 * @param {Page} page
	 */
	
	/* eslint-disable no-unused-vars */
	exports.page = function(page) {};
	/* eslint-enable no-unused-vars */
	
	/**
	 * Track.
	 *
	 * @api public
	 * @param {Track} track
	 */
	
	/* eslint-disable no-unused-vars */
	exports.track = function(track) {};
	/* eslint-enable no-unused-vars */
	
	/**
	 * Get values from items in `options` that are mapped to `key`.
	 * `options` is an integration setting which is a collection
	 * of type 'map', 'array', or 'mixed'
	 *
	 * Use cases include mapping events to pixelIds (map), sending generic
	 * conversion pixels only for specific events (array), or configuring dynamic
	 * mappings of event properties to query string parameters based on event (mixed)
	 *
	 * @api public
	 * @param {Object|Object[]|String[]} options An object, array of objects, or
	 * array of strings pulled from settings.mapping.
	 * @param {string} key The name of the item in options whose metadata
	 * we're looking for.
	 * @return {Array} An array of settings that match the input `key` name.
	 * @example
	 *
	 * // 'Map'
	 * var events = { my_event: 'a4991b88' };
	 * .map(events, 'My Event');
	 * // => ["a4991b88"]
	 * .map(events, 'whatever');
	 * // => []
	 *
	 * // 'Array'
	 * * var events = ['Completed Order', 'My Event'];
	 * .map(events, 'My Event');
	 * // => ["My Event"]
	 * .map(events, 'whatever');
	 * // => []
	 *
	 * // 'Mixed'
	 * var events = [{ key: 'my event', value: '9b5eb1fa' }];
	 * .map(events, 'my_event');
	 * // => ["9b5eb1fa"]
	 * .map(events, 'whatever');
	 * // => []
	 */
	
	exports.map = function(options, key) {
	  var normalizedComparator = normalize(key);
	  var mappingType = getMappingType(options);
	
	  if (mappingType === 'unknown') {
	    return [];
	  }
	
	  return foldl(function(matchingValues, val, key) {
	    var compare;
	    var result;
	
	    if (mappingType === 'map') {
	      compare = key;
	      result = val;
	    }
	
	    if (mappingType === 'array') {
	      compare = val;
	      result = val;
	    }
	
	    if (mappingType === 'mixed') {
	      compare = val.key;
	      result = val.value;
	    }
	
	    if (normalize(compare) === normalizedComparator) {
	      matchingValues.push(result);
	    }
	
	    return matchingValues;
	  }, [], options);
	};
	
	/**
	 * Invoke a `method` that may or may not exist on the prototype with `args`,
	 * queueing or not depending on whether the integration is "ready". Don't
	 * trust the method call, since it contains integration party code.
	 *
	 * @api private
	 * @param {string} method
	 * @param {...*} args
	 */
	
	exports.invoke = function(method) {
	  if (!this[method]) return;
	  var args = Array.prototype.slice.call(arguments, 1);
	  if (!this._ready) return this.queue(method, args);
	
	  this.debug('%s with %o', method, args);
	  return this[method].apply(this, args);
	};
	
	/**
	 * Queue a `method` with `args`. If the integration assumes an initial
	 * pageview, then let the first call to `page` pass through.
	 *
	 * @api private
	 * @param {string} method
	 * @param {Array} args
	 */
	
	exports.queue = function(method, args) {
	  if (method === 'page' && this._assumesPageview && !this._initialized) {
	    return this.page.apply(this, args);
	  }
	
	  this._queue.push({ method: method, args: args });
	};
	
	/**
	 * Flush the internal queue.
	 *
	 * @api private
	 */
	
	exports.flush = function() {
	  this._ready = true;
	  var self = this;
	
	  each(function(call) {
	    self[call.method].apply(self, call.args);
	  }, this._queue);
	
	  // Empty the queue.
	  this._queue.length = 0;
	};
	
	/**
	 * Reset the integration, removing its global variables.
	 *
	 * @api private
	 */
	
	exports.reset = function() {
	  for (var i = 0; i < this.globals.length; i++) {
	    window[this.globals[i]] = undefined;
	  }
	
	  window.onerror = onerror;
	  window.onload = onload;
	};
	
	/**
	 * Load a tag by `name`.
	 *
	 * @param {string} name The name of the tag.
	 * @param {Object} locals Locals used to populate the tag's template variables
	 * (e.g. `userId` in '<img src="https://whatever.com/{{ userId }}">').
	 * @param {Function} [callback=noop] A callback, invoked when the tag finishes
	 * loading.
	 */
	
	exports.load = function(name, locals, callback) {
	  // Argument shuffling
	  if (typeof name === 'function') { callback = name; locals = null; name = null; }
	  if (name && typeof name === 'object') { callback = locals; locals = name; name = null; }
	  if (typeof locals === 'function') { callback = locals; locals = null; }
	
	  // Default arguments
	  name = name || 'library';
	  locals = locals || {};
	
	  locals = this.locals(locals);
	  var template = this.templates[name];
	  if (!template) throw new Error(fmt('template "%s" not defined.', name));
	  var attrs = render(template, locals);
	  callback = callback || noop;
	  var self = this;
	  var el;
	
	  switch (template.type) {
	  case 'img':
	    attrs.width = 1;
	    attrs.height = 1;
	    el = loadImage(attrs, callback);
	    break;
	  case 'script':
	    el = loadScript(attrs, function(err) {
	      if (!err) return callback();
	      self.debug('error loading "%s" error="%s"', self.name, err);
	    });
	      // TODO: hack until refactoring load-script
	    delete attrs.src;
	    each(function(val, key) {
	      el.setAttribute(key, val);
	    }, attrs);
	    break;
	  case 'iframe':
	    el = loadIframe(attrs, callback);
	    break;
	  default:
	      // No default case
	  }
	
	  return el;
	};
	
	/**
	 * Locals for tag templates.
	 *
	 * By default it includes a cache buster and all of the options.
	 *
	 * @param {Object} [locals]
	 * @return {Object}
	 */
	
	exports.locals = function(locals) {
	  locals = locals || {};
	  var cache = Math.floor(new Date().getTime() / 3600000);
	  if (!locals.hasOwnProperty('cache')) locals.cache = cache;
	  each(function(val, key) {
	    if (!locals.hasOwnProperty(key)) locals[key] = val;
	  }, this.options);
	  return locals;
	};
	
	/**
	 * Simple way to emit ready.
	 *
	 * @api public
	 */
	
	exports.ready = function() {
	  this.emit('ready');
	};
	
	/**
	 * Wrap the initialize method in an exists check, so we don't have to do it for
	 * every single integration.
	 *
	 * @api private
	 */
	
	exports._wrapInitialize = function() {
	  var initialize = this.initialize;
	  this.initialize = function() {
	    this.debug('initialize');
	    this._initialized = true;
	    var ret = initialize.apply(this, arguments);
	    this.emit('initialize');
	    return ret;
	  };
	
	  if (this._assumesPageview) this.initialize = after(2, this.initialize);
	};
	
	/**
	 * Wrap the page method to call `initialize` instead if the integration assumes
	 * a pageview.
	 *
	 * @api private
	 */
	
	exports._wrapPage = function() {
	  var page = this.page;
	  this.page = function() {
	    if (this._assumesPageview && !this._initialized) {
	      return this.initialize.apply(this, arguments);
	    }
	
	    return page.apply(this, arguments);
	  };
	};
	
	/**
	 * Wrap the track method to call other ecommerce methods if available depending
	 * on the `track.event()`.
	 *
	 * @api private
	 */
	
	exports._wrapTrack = function() {
	  var t = this.track;
	  this.track = function(track) {
	    var event = track.event();
	    var called;
	    var ret;
	
	    for (var method in events) {
	      if (has.call(events, method)) {
	        var regexp = events[method];
	        if (!this[method]) continue;
	        if (!regexp.test(event)) continue;
	        ret = this[method].apply(this, arguments);
	        called = true;
	        break;
	      }
	    }
	
	    if (!called) ret = t.apply(this, arguments);
	    return ret;
	  };
	};
	
	/**
	 * Determine the type of the option passed to `#map`
	 *
	 * @api private
	 * @param {Object|Object[]} mapping
	 * @return {String} mappingType
	 */
	
	function getMappingType(mapping) {
	  if (is.array(mapping)) {
	    return every(isMixed, mapping) ? 'mixed' : 'array';
	  }
	  if (is.object(mapping)) return 'map';
	  return 'unknown';
	}
	
	/**
	 * Determine if item in mapping array is a valid "mixed" type value
	 *
	 * Must be an object with properties "key" (of type string)
	 * and "value" (of any type)
	 *
	 * @api private
	 * @param {*} item
	 * @return {Boolean}
	 */
	
	function isMixed(item) {
	  if (!is.object(item)) return false;
	  if (!is.string(item.key)) return false;
	  if (!has.call(item, 'value')) return false;
	  return true;
	}
	
	/**
	 * TODO: Document me
	 *
	 * @api private
	 * @param {Object} attrs
	 * @param {Function} fn
	 * @return {Image}
	 */
	
	function loadImage(attrs, fn) {
	  fn = fn || function() {};
	  var img = new Image();
	  img.onerror = error(fn, 'failed to load pixel', img);
	  img.onload = function() { fn(); };
	  img.src = attrs.src;
	  img.width = 1;
	  img.height = 1;
	  return img;
	}
	
	/**
	 * TODO: Document me
	 *
	 * @api private
	 * @param {Function} fn
	 * @param {string} message
	 * @param {Element} img
	 * @return {Function}
	 */
	
	function error(fn, message, img) {
	  return function(e) {
	    e = e || window.event;
	    var err = new Error(message);
	    err.event = e;
	    err.source = img;
	    fn(err);
	  };
	}
	
	/**
	 * Render template + locals into an `attrs` object.
	 *
	 * @api private
	 * @param {Object} template
	 * @param {Object} locals
	 * @return {Object}
	 */
	
	function render(template, locals) {
	  return foldl(function(attrs, val, key) {
	    attrs[key] = val.replace(/\{\{\ *(\w+)\ *\}\}/g, function(_, $1) {
	      return locals[$1];
	    });
	    return attrs;
	  }, {}, template.attrs);
	}


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(303);
	var domify = __webpack_require__(1295);
	var each = __webpack_require__(133);
	var includes = __webpack_require__(391);
	
	/**
	 * Mix in emitter.
	 */
	
	/* eslint-disable new-cap */
	Emitter(exports);
	/* eslint-enable new-cap */
	
	/**
	 * Add a new option to the integration by `key` with default `value`.
	 *
	 * @api public
	 * @param {string} key
	 * @param {*} value
	 * @return {Integration}
	 */
	
	exports.option = function(key, value) {
	  this.prototype.defaults[key] = value;
	  return this;
	};
	
	/**
	 * Add a new mapping option.
	 *
	 * This will create a method `name` that will return a mapping for you to use.
	 *
	 * @api public
	 * @param {string} name
	 * @return {Integration}
	 * @example
	 * Integration('My Integration')
	 *   .mapping('events');
	 *
	 * new MyIntegration().track('My Event');
	 *
	 * .track = function(track){
	 *   var events = this.events(track.event());
	 *   each(send, events);
	 *  };
	 */
	
	exports.mapping = function(name) {
	  this.option(name, []);
	  this.prototype[name] = function(key) {
	    return this.map(this.options[name], key);
	  };
	  return this;
	};
	
	/**
	 * Register a new global variable `key` owned by the integration, which will be
	 * used to test whether the integration is already on the page.
	 *
	 * @api public
	 * @param {string} key
	 * @return {Integration}
	 */
	
	exports.global = function(key) {
	  this.prototype.globals.push(key);
	  return this;
	};
	
	/**
	 * Mark the integration as assuming an initial pageview, so to defer loading
	 * the script until the first `page` call, noop the first `initialize`.
	 *
	 * @api public
	 * @return {Integration}
	 */
	
	exports.assumesPageview = function() {
	  this.prototype._assumesPageview = true;
	  return this;
	};
	
	/**
	 * Mark the integration as being "ready" once `load` is called.
	 *
	 * @api public
	 * @return {Integration}
	 */
	
	exports.readyOnLoad = function() {
	  this.prototype._readyOnLoad = true;
	  return this;
	};
	
	/**
	 * Mark the integration as being "ready" once `initialize` is called.
	 *
	 * @api public
	 * @return {Integration}
	 */
	
	exports.readyOnInitialize = function() {
	  this.prototype._readyOnInitialize = true;
	  return this;
	};
	
	/**
	 * Define a tag to be loaded.
	 *
	 * @api public
	 * @param {string} [name='library'] A nicename for the tag, commonly used in
	 * #load. Helpful when the integration has multiple tags and you need a way to
	 * specify which of the tags you want to load at a given time.
	 * @param {String} str DOM tag as string or URL.
	 * @return {Integration}
	 */
	
	exports.tag = function(name, tag) {
	  if (tag == null) {
	    tag = name;
	    name = 'library';
	  }
	  this.prototype.templates[name] = objectify(tag);
	  return this;
	};
	
	/**
	 * Given a string, give back DOM attributes.
	 *
	 * Do it in a way where the browser doesn't load images or iframes. It turns
	 * out domify will load images/iframes because whenever you construct those
	 * DOM elements, the browser immediately loads them.
	 *
	 * @api private
	 * @param {string} str
	 * @return {Object}
	 */
	
	function objectify(str) {
	  // replace `src` with `data-src` to prevent image loading
	  str = str.replace(' src="', ' data-src="');
	
	  var el = domify(str);
	  var attrs = {};
	
	  each(function(attr) {
	    // then replace it back
	    var name = attr.name === 'data-src' ? 'src' : attr.name;
	    if (!includes(attr.name + '=', str)) return;
	    attrs[name] = attr.value;
	  }, el.attributes);
	
	  return {
	    type: el.tagName.toLowerCase(),
	    attrs: attrs
	  };
	}


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	var utf8Encode = __webpack_require__(1841);
	var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	module.exports = encode;
	function encode(input) {
	    var output = "";
	    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    input = utf8Encode(input);
	
	    while (i < input.length) {
	
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	            enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	            enc4 = 64;
	        }
	
	        output = output +
	            keyStr.charAt(enc1) + keyStr.charAt(enc2) +
	            keyStr.charAt(enc3) + keyStr.charAt(enc4);
	
	    }
	
	    return output;
	}

/***/ }),
/* 845 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Get the current page's canonical URL.
	 *
	 * @return {string|undefined}
	 */
	function canonical() {
	  var tags = document.getElementsByTagName('link');
	  // eslint-disable-next-line no-cond-assign
	  for (var i = 0, tag; tag = tags[i]; i++) {
	    if (tag.getAttribute('rel') === 'canonical') {
	      return tag.getAttribute('href');
	    }
	  }
	}
	
	/*
	 * Exports.
	 */
	
	module.exports = canonical;


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * Module dependencies.
	 */
	
	var clone = __webpack_require__(258);
	var each = __webpack_require__(133);
	var type = __webpack_require__(86);
	
	/**
	 * Recursively convert an `obj`'s dates to new values.
	 *
	 * @param {Object} obj
	 * @param {Function} convert
	 * @return {Object}
	 */
	function convertDates(obj, convert) {
	  obj = clone(obj);
	  each(function(val, key) {
	    if (type(val) === 'date') {
	      obj[key] = convert(val);
	    }
	    if (type(val) === 'object' || type(val) === 'array') {
	      obj[key] = convertDates(val, convert);
	    }
	  }, obj);
	  return obj;
	}
	
	/*
	 * Exports.
	 */
	
	module.exports = convertDates;


/***/ }),
/* 847 */
[1843, 848],
/* 848 */
[1844, 849],
/* 849 */
837,
/* 850 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// Stringifier
	var toString = global.JSON && typeof JSON.stringify === 'function' ? JSON.stringify : String;
	
	/**
	 * Format the given `str`.
	 *
	 * @param {string} str
	 * @param {...*} [args]
	 * @return {string}
	 */
	function fmt(str) {
	  var args = Array.prototype.slice.call(arguments, 1);
	  var j = 0;
	
	  return str.replace(/%([a-z])/gi, function(match, f) {
	    return fmt[f] ? fmt[f](args[j++]) : match + f;
	  });
	}
	
	// Formatters
	fmt.o = toString;
	fmt.s = String;
	fmt.d = parseInt;
	
	/*
	 * Exports.
	 */
	
	module.exports = fmt;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 851 */
/***/ (function(module, exports) {

	'use strict';
	
	function isMeta(e) {
	  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) {
	    return true;
	  }
	
	  // Logic that handles checks for the middle mouse button, based
	  // on [jQuery](https://github.com/jquery/jquery/blob/master/src/event.js#L466).
	  var which = e.which;
	  var button = e.button;
	  if (!which && button !== undefined) {
	    // eslint-disable-next-line no-bitwise, no-extra-parens
	    return (!button & 1) && (!button & 2) && (button & 4);
	  } else if (which === 2) {
	    return true;
	  }
	
	  return false;
	}
	
	/*
	 * Exports.
	 */
	
	module.exports = isMeta;


/***/ }),
/* 852 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Matcher, slightly modified from:
	 *
	 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
	 */
	
	var matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
	
	/**
	 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
	 *
	 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
	 *
	 * @param {String} iso
	 * @return {Date}
	 */
	
	exports.parse = function(iso) {
	  var numericKeys = [1, 5, 6, 7, 11, 12];
	  var arr = matcher.exec(iso);
	  var offset = 0;
	
	  // fallback to native parsing
	  if (!arr) {
	    return new Date(iso);
	  }
	
	  /* eslint-disable no-cond-assign */
	  // remove undefined values
	  for (var i = 0, val; val = numericKeys[i]; i++) {
	    arr[val] = parseInt(arr[val], 10) || 0;
	  }
	  /* eslint-enable no-cond-assign */
	
	  // allow undefined days and months
	  arr[2] = parseInt(arr[2], 10) || 1;
	  arr[3] = parseInt(arr[3], 10) || 1;
	
	  // month is 0-11
	  arr[2]--;
	
	  // allow abitrary sub-second precision
	  arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
	
	  // apply timezone if one exists
	  if (arr[4] === ' ') {
	    offset = new Date().getTimezoneOffset();
	  } else if (arr[9] !== 'Z' && arr[10]) {
	    offset = arr[11] * 60 + arr[12];
	    if (arr[10] === '+') {
	      offset = 0 - offset;
	    }
	  }
	
	  var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
	  return new Date(millis);
	};
	
	
	/**
	 * Checks whether a `string` is an ISO date string. `strict` mode requires that
	 * the date string at least have a year, month and date.
	 *
	 * @param {String} string
	 * @param {Boolean} strict
	 * @return {Boolean}
	 */
	
	exports.is = function(string, strict) {
	  if (typeof string !== 'string') {
	    return false;
	  }
	  if (strict && (/^\d{4}-\d{2}-\d{2}/).test(string) === false) {
	    return false;
	  }
	  return matcher.test(string);
	};


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * Module dependencies.
	 */
	
	var onload = __webpack_require__(809);
	var tick = __webpack_require__(239);
	var type = __webpack_require__(86);
	
	/**
	 * Loads a script asynchronously.
	 *
	 * @param {Object} options
	 * @param {Function} cb
	 */
	function loadScript(options, cb) {
	  if (!options) {
	    throw new Error('Can\'t load nothing...');
	  }
	
	  // Allow for the simplest case, just passing a `src` string.
	  if (type(options) === 'string') {
	    options = { src : options };
	  }
	
	  var https = document.location.protocol === 'https:' || document.location.protocol === 'chrome-extension:';
	
	  // If you use protocol relative URLs, third-party scripts like Google
	  // Analytics break when testing with `file:` so this fixes that.
	  if (options.src && options.src.indexOf('//') === 0) {
	    options.src = (https ? 'https:' : 'http:') + options.src;
	  }
	
	  // Allow them to pass in different URLs depending on the protocol.
	  if (https && options.https) {
	    options.src = options.https;
	  } else if (!https && options.http) {
	    options.src = options.http;
	  }
	
	  // Make the `<script>` element and insert it before the first script on the
	  // page, which is guaranteed to exist since this Javascript is running.
	  var script = document.createElement('script');
	  script.type = 'text/javascript';
	  script.async = true;
	  script.src = options.src;
	
	  // If we have a cb, attach event handlers. Does not work on < IE9 because
	  // older browser versions don't register element.onerror
	  if (type(cb) === 'function') {
	    onload(script, cb);
	  }
	
	  tick(function() {
	    // Append after event listeners are attached for IE.
	    var firstScript = document.getElementsByTagName('script')[0];
	    firstScript.parentNode.insertBefore(script, firstScript);
	  });
	
	  // Return the script element in case they want to do anything special, like
	  // give it an ID or attributes.
	  return script;
	}
	
	/*
	 * Exports.
	 */
	
	module.exports = loadScript;


/***/ }),
/* 854 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Prevent default on a given event.
	 *
	 * @param {Event} e
	 * @example
	 * anchor.onclick = prevent;
	 * anchor.onclick = function(e){
	 *   if (something) return prevent(e);
	 * };
	 */
	
	function preventDefault(e) {
	  e = e || window.event;
	  return e.preventDefault ? e.preventDefault() : e.returnValue = false;
	}
	
	/*
	 * Exports.
	 */
	
	module.exports = preventDefault;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * Module dependencies.
	 */
	
	var JSON = __webpack_require__(501);
	var base64encode = __webpack_require__(844);
	var cors = __webpack_require__(1319);
	var jsonp = __webpack_require__(1331);
	
	/*
	 * Exports.
	 */
	
	exports = module.exports = cors ? json : base64;
	
	/**
	 * Expose `callback`
	 */
	
	exports.callback = 'callback';
	
	/**
	 * Expose `prefix`
	 */
	
	exports.prefix = 'data';
	
	/**
	 * Expose `json`.
	 */
	
	exports.json = json;
	
	/**
	 * Expose `base64`.
	 */
	
	exports.base64 = base64;
	
	/**
	 * Expose `type`
	 */
	
	exports.type = cors ? 'xhr' : 'jsonp';
	
	/**
	 * Send the given `obj` to `url` with `fn(err, req)`.
	 *
	 * @param {String} url
	 * @param {Object} obj
	 * @param {Object} headers
	 * @param {Function} fn
	 * @api private
	 */
	
	function json(url, obj, headers, fn) {
	  if (arguments.length === 3) fn = headers, headers = {};
	
	  var req = new XMLHttpRequest;
	  req.onerror = fn;
	  req.onreadystatechange = done;
	  req.open('POST', url, true);
	
	  // TODO: Remove this eslint disable
	  // eslint-disable-next-line guard-for-in
	  for (var k in headers) {
	    req.setRequestHeader(k, headers[k]);
	  }
	  req.send(JSON.stringify(obj));
	
	  function done() {
	    if (req.readyState === 4) {
	      return fn(null, req);
	    }
	  }
	}
	
	/**
	 * Send the given `obj` to `url` with `fn(err, req)`.
	 *
	 * @param {String} url
	 * @param {Object} obj
	 * @param {Function} fn
	 * @api private
	 */
	
	function base64(url, obj, _, fn) {
	  if (arguments.length === 3) fn = _;
	
	  var prefix = exports.prefix;
	  var data = encode(obj);
	  url += '?' + prefix + '=' + data;
	  jsonp(url, { param: exports.callback }, function(err, obj) {
	    if (err) return fn(err);
	    fn(null, {
	      url: url,
	      body: obj
	    });
	  });
	}
	
	/**
	 * Encodes `obj`.
	 *
	 * @param {Object} obj
	 */
	
	function encode(obj) {
	  var str = '';
	  str = JSON.stringify(obj);
	  str = base64encode(str);
	  str = str.replace(/\+/g, '-').replace(/\//g, '_');
	  return encodeURIComponent(str);
	}


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict"
	
	var JSON = __webpack_require__(501);
	
	module.exports = (function() {
		// Store.js
		var store = {},
			win = (typeof window != 'undefined' ? window : global),
			doc = win.document,
			localStorageName = 'localStorage',
			scriptTag = 'script',
			storage
	
		store.disabled = false
		store.version = '1.3.20'
		store.set = function(key, value) {}
		store.get = function(key, defaultVal) {}
		store.has = function(key) { return store.get(key) !== undefined }
		store.remove = function(key) {}
		store.clear = function() {}
		store.transact = function(key, defaultVal, transactionFn) {
			if (transactionFn == null) {
				transactionFn = defaultVal
				defaultVal = null
			}
			if (defaultVal == null) {
				defaultVal = {}
			}
			var val = store.get(key, defaultVal)
			transactionFn(val)
			store.set(key, val)
		}
		store.getAll = function() {
			var ret = {}
			store.forEach(function(key, val) {
				ret[key] = val
			})
			return ret
		}
		store.forEach = function() {}
		store.serialize = function(value) {
			return JSON.stringify(value)
		}
		store.deserialize = function(value) {
			if (typeof value != 'string') { return undefined }
			try { return JSON.parse(value) }
			catch(e) { return value || undefined }
		}
	
		// Functions to encapsulate questionable FireFox 3.6.13 behavior
		// when about.config::dom.storage.enabled === false
		// See https://github.com/marcuswestin/store.js/issues#issue/13
		function isLocalStorageNameSupported() {
			try { return (localStorageName in win && win[localStorageName]) }
			catch(err) { return false }
		}
	
		if (isLocalStorageNameSupported()) {
			storage = win[localStorageName]
			store.set = function(key, val) {
				if (val === undefined) { return store.remove(key) }
				storage.setItem(key, store.serialize(val))
				return val
			}
			store.get = function(key, defaultVal) {
				var val = store.deserialize(storage.getItem(key))
				return (val === undefined ? defaultVal : val)
			}
			store.remove = function(key) { storage.removeItem(key) }
			store.clear = function() { storage.clear() }
			store.forEach = function(callback) {
				for (var i=0; i<storage.length; i++) {
					var key = storage.key(i)
					callback(key, store.get(key))
				}
			}
		} else if (doc && doc.documentElement.addBehavior) {
			var storageOwner,
				storageContainer
			// Since #userData storage applies only to specific paths, we need to
			// somehow link our data to a specific path.  We choose /favicon.ico
			// as a pretty safe option, since all browsers already make a request to
			// this URL anyway and being a 404 will not hurt us here.  We wrap an
			// iframe pointing to the favicon in an ActiveXObject(htmlfile) object
			// (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
			// since the iframe access rules appear to allow direct access and
			// manipulation of the document element, even for a 404 page.  This
			// document can be used instead of the current document (which would
			// have been limited to the current path) to perform #userData storage.
			try {
				storageContainer = new ActiveXObject('htmlfile')
				storageContainer.open()
				storageContainer.write('<'+scriptTag+'>document.w=window</'+scriptTag+'><iframe src="/favicon.ico"></iframe>')
				storageContainer.close()
				storageOwner = storageContainer.w.frames[0].document
				storage = storageOwner.createElement('div')
			} catch(e) {
				// somehow ActiveXObject instantiation failed (perhaps some special
				// security settings or otherwse), fall back to per-path storage
				storage = doc.createElement('div')
				storageOwner = doc.body
			}
			var withIEStorage = function(storeFunction) {
				return function() {
					var args = Array.prototype.slice.call(arguments, 0)
					args.unshift(storage)
					// See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
					// and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
					storageOwner.appendChild(storage)
					storage.addBehavior('#default#userData')
					storage.load(localStorageName)
					var result = storeFunction.apply(store, args)
					storageOwner.removeChild(storage)
					return result
				}
			}
	
			// In IE7, keys cannot start with a digit or contain certain chars.
			// See https://github.com/marcuswestin/store.js/issues/40
			// See https://github.com/marcuswestin/store.js/issues/83
			var forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g")
			var ieKeyFix = function(key) {
				return key.replace(/^d/, '___$&').replace(forbiddenCharsRegex, '___')
			}
			store.set = withIEStorage(function(storage, key, val) {
				key = ieKeyFix(key)
				if (val === undefined) { return store.remove(key) }
				storage.setAttribute(key, store.serialize(val))
				storage.save(localStorageName)
				return val
			})
			store.get = withIEStorage(function(storage, key, defaultVal) {
				key = ieKeyFix(key)
				var val = store.deserialize(storage.getAttribute(key))
				return (val === undefined ? defaultVal : val)
			})
			store.remove = withIEStorage(function(storage, key) {
				key = ieKeyFix(key)
				storage.removeAttribute(key)
				storage.save(localStorageName)
			})
			store.clear = withIEStorage(function(storage) {
				var attributes = storage.XMLDocument.documentElement.attributes
				storage.load(localStorageName)
				for (var i=attributes.length-1; i>=0; i--) {
					storage.removeAttribute(attributes[i].name)
				}
				storage.save(localStorageName)
			})
			store.forEach = withIEStorage(function(storage, callback) {
				var attributes = storage.XMLDocument.documentElement.attributes
				for (var i=0, attr; attr=attributes[i]; ++i) {
					callback(attr.name, store.deserialize(storage.getAttribute(attr.name)))
				}
			})
		}
	
		try {
			var testKey = '__storejs__'
			store.set(testKey, testKey)
			if (store.get(testKey) != testKey) { store.disabled = true }
			store.remove(testKey)
		} catch(e) {
			store.disabled = true
		}
		store.enabled = !store.disabled
		
		return store
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Pad a `number` with a ten's place zero.
	 *
	 * @param {number} number
	 * @return {string}
	 */
	function pad(number) {
	  var n = number.toString();
	  return n.length === 1 ? '0' + n : n;
	}
	
	/**
	 * Turn a `date` into an ISO string.
	 *
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString
	 *
	 * @param {Date} date
	 * @return {string}
	 */
	function toISOString(date) {
	  return date.getUTCFullYear()
	    + '-' + pad(date.getUTCMonth() + 1)
	    + '-' + pad(date.getUTCDate())
	    + 'T' + pad(date.getUTCHours())
	    + ':' + pad(date.getUTCMinutes())
	    + ':' + pad(date.getUTCSeconds())
	    + '.' + String((date.getUTCMilliseconds()/1000).toFixed(3)).slice(2, 5)
	    + 'Z';
	}
	
	/*
	 * Exports.
	 */
	
	module.exports = toISOString;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	
	var parse = __webpack_require__(480).parse;
	var cookie = __webpack_require__(1262);
	
	/**
	 * Get the top domain.
	 *
	 * The function constructs the levels of domain and attempts to set a global
	 * cookie on each one when it succeeds it returns the top level domain.
	 *
	 * The method returns an empty string when the hostname is an ip or `localhost`.
	 *
	 * Example levels:
	 *
	 *      domain.levels('http://www.google.co.uk');
	 *      // => ["co.uk", "google.co.uk", "www.google.co.uk"]
	 *
	 * Example:
	 *
	 *      domain('http://localhost:3000/baz');
	 *      // => ''
	 *      domain('http://dev:3000/baz');
	 *      // => ''
	 *      domain('http://127.0.0.1:3000/baz');
	 *      // => ''
	 *      domain('http://segment.io/baz');
	 *      // => 'segment.io'
	 *
	 * @param {string} url
	 * @return {string}
	 * @api public
	 */
	function domain(url) {
	  var cookie = exports.cookie;
	  var levels = exports.levels(url);
	
	  // Lookup the real top level one.
	  for (var i = 0; i < levels.length; ++i) {
	    var cname = '__tld__';
	    var domain = levels[i];
	    var opts = { domain: '.' + domain };
	
	    cookie(cname, 1, opts);
	    if (cookie(cname)) {
	      cookie(cname, null, opts);
	      return domain;
	    }
	  }
	
	  return '';
	}
	
	/**
	 * Levels returns all levels of the given url.
	 *
	 * @param {string} url
	 * @return {Array}
	 * @api public
	 */
	domain.levels = function(url) {
	  var host = parse(url).hostname;
	  var parts = host.split('.');
	  var last = parts[parts.length - 1];
	  var levels = [];
	
	  // Ip address.
	  if (parts.length === 4 && last === parseInt(last, 10)) {
	    return levels;
	  }
	
	  // Localhost.
	  if (parts.length <= 1) {
	    return levels;
	  }
	
	  // Create levels.
	  for (var i = parts.length - 2; i >= 0; --i) {
	    levels.push(parts.slice(i).join('.'));
	  }
	
	  return levels;
	};
	
	/**
	 * Expose cookie on domain.
	 */
	domain.cookie = cookie;
	
	/*
	 * Exports.
	 */
	
	exports = module.exports = domain;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var tabbable = __webpack_require__(1813);
	var focusin = __webpack_require__(1318);
	var polyfilled = false;
	
	function init(element) {
	
	  // lazily polyfill focusin for firefox
	  if (!polyfilled) {
	    focusin.polyfill();
	    polyfilled = true;
	  }
	
	  function focus() {
	    (tabbable(element)[0] || element).focus()
	  }
	
	  function onFocusIn(event) {
	    if (element !== event.target && !element.contains(event.target)) {
	      focus();
	    }
	  }
	
	  focus();
	
	  document.addEventListener('focusin', onFocusIn);
	
	  return function teardown() {
	    document.removeEventListener('focusin', onFocusIn);
	  };
	}
	
	var teardownFn;
	
	exports.scopeFocus = function(element) {
	  if (teardownFn) teardownFn();
	  teardownFn = init(element);
	};
	
	exports.unscopeFocus = function() {
	  if (teardownFn) teardownFn();
	  teardownFn = null;
	};


/***/ }),
/* 860 */
/***/ (function(module, exports) {

	'use strict';
	
	var storedFocusElement;
	
	exports.storeFocus = function() {
	  storedFocusElement = document.activeElement;
	};
	
	exports.clearStoredFocus = function() {
	  storedFocusElement = null;
	};
	
	exports.restoreFocus = function() {
	  if (!storedFocusElement) return;
	  try { storedFocusElement.focus(); } catch (err) {}
	  storedFocusElement = null;
	};


/***/ }),
/* 861 */
/***/ (function(module, exports) {

	
	module.exports = {
	  // Promotions
	  promotionViewed: /^[ _]?promotion[ _]?viewed?[ _]?$/i,
	  viewedPromotion: /^[ _]?viewed[ _]?promotion?[ _]?$/i,
	  promotionClicked: /^[ _]?promotion[ _]?clicked?[ _]?$/i,
	  clickedPromotion: /^[ _]?clicked[ _]?promotion?[ _]?$/i,
	  // Browsing
	  productsSearched: /^[ _]?products[ _]?searched[ _]?$/i,
	  productListViewed: /^[ _]?product[ _]?list[ _]?viewed[ _]?$/i,
	  productListFiltered: /^[ _]?product[ _]?list[ _]?filtered[ _]?$/i,
	  viewedProductCategory: /^[ _]?viewed[ _]?product[ _]?category[ _]?$/i,
	  viewedProductDetails: /^[ _]?viewed[ _]?product[ _]?details?[ _]?$/i,
	  // Core Ordering
	  productClicked: /^[ _]?product[ _]?clicked[ _]?$/i,
	  clickedProduct: /^[ _]?clicked[ _]?product[ _]?$/i,
	  productViewed: /^[ _]?product[ _]?viewed[ _]?$/i,
	  viewedProduct: /^[ _]?viewed[ _]?product[ _]?$/i,
	  productAdded: /^[ _]?product[ _]?added[ _]?$/i,
	  addedProduct: /^[ _]?added[ _]?product[ _]?$/i,
	  productRemoved: /^[ _]?product[ _]?removed[ _]?$/i,
	  removedProduct: /^[ _]?removed[ _]?product[ _]?$/i,
	  cartViewed: /^[ _]?cart[ _]?viewed[ _]?$/i,
	  orderStarted: /^[ _]?order[ _]?started[ _]?$/i,
	  startedOrder: /^[ _]?started[ _]?order[ _]?$/i,
	  orderUpdated: /^[ _]?order[ _]?updated[ _]?$/i,
	  updatedOrder: /^[ _]?updated[ _]?order[ _]?$/i,
	  orderCompleted: /^[ _]?order[ _]?completed[ _]?$/i,
	  completedOrder: /^[ _]?completed[ _]?order[ _]?$/i,
	  orderRefunded: /^[ _]?order[ _]?refunded[ _]?$/i,
	  refundedOrder: /^[ _]?refunded[ _]?order[ _]?$/i,
	  orderCancelled: /^[ _]?order[ _]?cancelled[ _]?$/i,
	  paymentInfoAdded: /^[ _]?payment[ _]?info[ _]?added[ _]?$/i,
	  checkoutStarted: /^[ _]?checkout[ _]?started[ _]?$/i,
	  checkoutStepViewed: /^[ _]?checkout[ _]?step[ _]?viewed[ _]?$/i,
	  viewedCheckoutStep: /^[ _]?viewed[ _]?checkout[ _]?step[ _]?$/i,
	  checkoutStepCompleted: /^[ _]?checkout[ _]?step[ _]?completed[ _]?$/i,
	  completedCheckoutStep: /^[ _]?completed[ _]?checkout[ _]?step[ _]?$/i,
	  // Coupons
	  couponEntered: /^[ _]?coupon[ _]?entered[ _]?$/i,
	  couponApplied: /^[ _]?coupon[ _]?applied[ _]?$/i,
	  couponDenied: /^[ _]?coupon[ _]?denied[ _]?$/i,
	  couponRemoved: /^[ _]?coupon[ _]?removed[ _]?$/i,
	  // Wishlisting
	  productAddedToWishlist: /^[ _]?product[ _]?added[ _]?to[ _]?wishlist[ _]?$/i,
	  wishlistProductRemoved: /^[ _]?wishlist[ _]?product[ _]?removed[ _]?$/i,
	  wishlistProductAddedToCart: /^[ _]?wishlist[ _]?product[ _]?added[ _]?to[ _]?cart[ _]?$/i,
	  // Sharing
	  productShared: /^[ _]?product[ _]?shared[ _]?$/i,
	  cartShared: /^[ _]?cart[ _]?shared[ _]?$/i,
	  // Reviewing
	  productRemoved: /^[ _]?product[ _]?removed[ _]?$/i,
	  // App Lifecycle
	  applicationInstalled: /^[ _]?application[ _]?installed[ _]?$/i,
	  applicationUpdated: /^[ _]?application[ _]?updated[ _]?$/i,
	  applicationOpened: /^[ _]?application[ _]?opened[ _]?$/i,
	  applicationBackgrounded: /^[ _]?application[ _]?backgrounded[ _]?$/i,
	  applicationUninstalled: /^[ _]?application[ _]?uninstalled[ _]?$/i,
	  // App Campaign and Referral Events
	  installAttributed: /^[ _]?install[ _]?attributed[ _]?$/i,
	  deepLinkOpened: /^[ _]?deep[ _]?link[ _]?opened[ _]?$/i,
	  pushNotificationReceived: /^[ _]?push[ _]?notification[ _]?received[ _]?$/i,
	  pushNotificationTapped: /^[ _]?push[ _]?notification[ _]?received[ _]?$/i,
	  pushNotificationBounced: /^[ _]?push[ _]?notification[ _]?bounced[ _]?$/i
	};


/***/ }),
/* 862 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _ShopMainLayout = __webpack_require__(160);
	
	var _ShopMainLayout2 = _interopRequireDefault(_ShopMainLayout);
	
	var _Barbers = __webpack_require__(194);
	
	var _Barbers2 = _interopRequireDefault(_Barbers);
	
	var _Services = __webpack_require__(268);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _MakeReservation = __webpack_require__(163);
	
	var _MakeReservation2 = _interopRequireDefault(_MakeReservation);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var barberUrl = (0, _helpers.generateUrlString)({ shopRoute: '' });
	var serviceUrl = (0, _helpers.generateUrlString)({ shopRoute: '', barberRoute: '' });
	var pickTimeUrl = (0, _helpers.generateUrlString)({ shopRoute: '', barberRoute: '', serviceId: '' });
	
	var makeReservationUrl = (0, _helpers.generateUrlString)({
	  shopRoute: '',
	  barberRoute: '',
	  serviceId: '',
	  reservationTime: ''
	});
	
	var redirectFromOldUrl = function redirectFromOldUrl(nextState, replace, callback) {
	  if (nextState.params.shopRoute.length === 2) {
	    replace({
	      pathname: '/' + nextState.params.barberRoute + '/' + (nextState.params.serviceId ? nextState.params.serviceId : '')
	    });
	  }
	  callback();
	};
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _reactRouter.Route,
	    { component: _ShopMainLayout2.default },
	    _react2.default.createElement(_reactRouter.Route, { path: barberUrl, component: _Barbers2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: serviceUrl,
	      component: _Services2.default,
	      onEnter: redirectFromOldUrl,
	      ignoreScrollBehavior: true
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: pickTimeUrl,
	      component: _Services2.default,
	      onEnter: redirectFromOldUrl,
	      ignoreScrollBehavior: true
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: makeReservationUrl,
	      component: _MakeReservation2.default,
	      onEnter: redirectFromOldUrl
	    }),
	    _react2.default.createElement(_reactRouter.Redirect, {
	      from: makeReservationUrl + '/**',
	      to: makeReservationUrl
	    })
	  );
	};

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setAcceptCookie = undefined;
	
	var _constants = __webpack_require__(193);
	
	// eslint-disable-next-line import/prefer-default-export
	var setAcceptCookie = exports.setAcceptCookie = function setAcceptCookie(payload) {
	  return {
	    type: _constants.SET_ACCEPT_COOKIE,
	    payload: payload
	  };
	};

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCookieConsent = __webpack_require__(1594);
	
	var _reactCookieConsent2 = _interopRequireDefault(_reactCookieConsent);
	
	var _constants = __webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AcceptCookies = function AcceptCookies(_ref) {
	  var onAccept = _ref.onAccept;
	  return _react2.default.createElement(
	    _reactCookieConsent2.default,
	    {
	      location: 'bottom',
	      buttonText: 'OK',
	      containerClasses: 'c-acceptcookie',
	      buttonClasses: 'c-acceptcookie__button',
	      cookieName: _constants.COOKIE,
	      style: { background: '', alignItems: '', justifyContent: '' },
	      buttonStyle: { background: '', color: '', padding: '' },
	      onAccept: onAccept
	    },
	    'This website stores cookies on your computer. These cookies are used to provide a more personalized experience and to track your whereabouts around our website in compliance with the European General Data Protection Regulation.'
	  );
	};
	AcceptCookies.propTypes = {
	  onAccept: _propTypes2.default.func.isRequired
	};
	
	exports.default = AcceptCookies;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose = __webpack_require__(4);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _reactRedux = __webpack_require__(6);
	
	var _lifecycle = __webpack_require__(15);
	
	var _lifecycle2 = _interopRequireDefault(_lifecycle);
	
	var _jsCookie = __webpack_require__(1327);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _withHandlers = __webpack_require__(9);
	
	var _withHandlers2 = _interopRequireDefault(_withHandlers);
	
	var _preventRenderForKioskMode = __webpack_require__(433);
	
	var _preventRenderForKioskMode2 = _interopRequireDefault(_preventRenderForKioskMode);
	
	var _preventRenderForEmbeddedMode = __webpack_require__(432);
	
	var _preventRenderForEmbeddedMode2 = _interopRequireDefault(_preventRenderForEmbeddedMode);
	
	var _preventRenderForWebNotifications = __webpack_require__(1001);
	
	var _preventRenderForWebNotifications2 = _interopRequireDefault(_preventRenderForWebNotifications);
	
	var _actions = __webpack_require__(864);
	
	var _constants = __webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AcceptCookiesContainer = (0, _compose2.default)(_preventRenderForEmbeddedMode2.default, _preventRenderForKioskMode2.default, _preventRenderForWebNotifications2.default, (0, _reactRedux.connect)(null, { setAcceptCookie: _actions.setAcceptCookie }), (0, _lifecycle2.default)({
	  componentDidMount: function componentDidMount() {
	    this.props.setAcceptCookie(_jsCookie2.default.get(_constants.COOKIE));
	  }
	}), (0, _withHandlers2.default)({
	  onAccept: function onAccept(props) {
	    return function () {
	      props.setAcceptCookie(true);
	    };
	  }
	}));
	
	exports.default = AcceptCookiesContainer;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(193);
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case _constants.SET_ACCEPT_COOKIE:
	      return Boolean(payload);
	
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAcceptCookie = undefined;
	
	var _prop2 = __webpack_require__(88);
	
	var _prop3 = _interopRequireDefault(_prop2);
	
	var _pipe2 = __webpack_require__(75);
	
	var _pipe3 = _interopRequireDefault(_pipe2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line import/prefer-default-export
	var getAcceptCookie = exports.getAcceptCookie = (0, _pipe3.default)((0, _prop3.default)('acceptCookie'), Boolean);

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _each2 = __webpack_require__(1472);
	
	var _each3 = _interopRequireDefault(_each2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _analytics = __webpack_require__(829);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _urlPattern = __webpack_require__(815);
	
	var _urlPattern2 = _interopRequireDefault(_urlPattern);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _selectors = __webpack_require__(11);
	
	var _root = __webpack_require__(475);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var getBrandId = function getBrandId() {
	  try {
	    // Match the url pattern to pull current shop route, as we're outside router
	    var pattern = new _urlPattern2.default(_config2.default.urlPatterns.booking + '/*');
	
	    var match = pattern.match(window.location.pathname);
	    var shopRoute = match.shopRoute;
	
	    var state = _root.store.getState();
	    var brandId = (0, _selectors.getShopBrandId)(state, shopRoute);
	
	    return brandId;
	  } catch (e) {
	    return null;
	  }
	};
	
	var Analytics = function () {
	  function Analytics() {
	    var _this = this;
	
	    var integrations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Analytics);
	
	    this.engine = new _analytics2.default();
	    this.useSampling = ("production") === 'production';
	
	    // Math.random() has uniform distribution, so theres no need to
	    // deal with Gaussian bell intricacies: https://tc39.es/ecma262/#sec-math.random
	
	    // We're looking at 5% of visitors
	    this.isInSampledPercentile = Math.random() >= 0.95;
	
	    (0, _each3.default)(integrations, function (Integration) {
	      return _this.engine.use(Integration);
	    });
	
	    this.engine.initialize(_config2.default.analytics);
	  }
	
	  _createClass(Analytics, [{
	    key: 'fireEvent',
	    value: function fireEvent(event) {
	      var customOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (this.useSampling && !this.isInSampledPercentile) {
	        return false;
	      }
	
	      var options = customOptions || {};
	
	      var traits = _extends({
	        platform: 'web',
	        brandId: getBrandId()
	      }, options);
	
	      this.engine.track(event, traits);
	      return true;
	    }
	  }, {
	    key: 'trackPageview',
	    value: function trackPageview(name) {
	      if (this.useSampling && !this.isInSampledPercentile) {
	        return false;
	      }
	
	      var traits = {
	        platform: 'web',
	        brandId: getBrandId(),
	        name: name
	      };
	
	      // Mixpanel doesn't support Page events, so we're adding custom ones
	      this.engine.track('Pageview', traits);
	      return true;
	    }
	  }, {
	    key: 'identify',
	    value: function identify(id) {
	      var traits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.useSampling && !this.isInSampledPercentile) {
	        return;
	      }
	
	      this.engine.identify(id, _extends({
	        platform: 'web'
	      }, traits));
	    }
	  }]);
	
	  return Analytics;
	}();
	
	exports.default = Analytics;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _branchSdk = __webpack_require__(1251);
	
	var _branchSdk2 = _interopRequireDefault(_branchSdk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BranchService = function () {
	  function BranchService(key) {
	    _classCallCheck(this, BranchService);
	
	    this.branch = _branchSdk2.default;
	    if (key) this.init(key);
	  }
	
	  _createClass(BranchService, [{
	    key: 'init',
	    value: function init(key) {
	      var _this = this;
	
	      this.branch.init(key, null, function (err) {
	        if (!err) _this.openBanner();
	      });
	    }
	  }, {
	    key: 'openBanner',
	    value: function openBanner() {
	      this.branch.banner(BranchService.BANNER_CONFIG);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.branch.closeJourney();
	      this.branch.logout();
	    }
	  }]);
	
	  return BranchService;
	}();
	
	BranchService.BANNER_CONFIG = {
	  showiOS: true,
	  showiPad: true,
	  showAndroid: false,
	  showDesktop: false,
	  make_new_link: true
	};
	exports.default = BranchService;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BranchService = __webpack_require__(870);
	
	var _BranchService2 = _interopRequireDefault(_BranchService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Branch = function (_Component) {
	  _inherits(Branch, _Component);
	
	  function Branch() {
	    _classCallCheck(this, Branch);
	
	    return _possibleConstructorReturn(this, (Branch.__proto__ || Object.getPrototypeOf(Branch)).apply(this, arguments));
	  }
	
	  _createClass(Branch, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.branch = new _BranchService2.default(this.props.branchKey);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var keyLoaded = this.props.branchKey !== undefined;
	      var keyChanged = this.props.branchKey !== prevProps.branchKey;
	
	      if (keyChanged && keyLoaded) {
	        this.branch.destroy();
	        this.branch = new _BranchService2.default(this.props.branchKey);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Branch;
	}(_react.Component);
	
	Branch.propTypes = {
	  branchKey: _propTypes2.default.string
	};
	Branch.defaultProps = {
	  branchKey: null
	};
	exports.default = Branch;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _withBranchKey = __webpack_require__(873);
	
	var _withBranchKey2 = _interopRequireDefault(_withBranchKey);
	
	var _preventRenderForEmbeddedMode = __webpack_require__(432);
	
	var _preventRenderForEmbeddedMode2 = _interopRequireDefault(_preventRenderForEmbeddedMode);
	
	var _preventRenderForKioskMode = __webpack_require__(433);
	
	var _preventRenderForKioskMode2 = _interopRequireDefault(_preventRenderForKioskMode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BranchContainer = (0, _compose3.default)(_preventRenderForKioskMode2.default, _preventRenderForEmbeddedMode2.default, _withBranchKey2.default);
	
	exports.default = BranchContainer;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _selectors = __webpack_require__(875);
	
	var _selectors2 = __webpack_require__(295);
	
	var _extensions = __webpack_require__(95);
	
	var _extensions2 = _interopRequireDefault(_extensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withBranchKey = (0, _compose3.default)(_reactRouter.withRouter, _extensions2.default, (0, _reactRedux.connect)(function (state, ownProps) {
	  var brandRoute = ownProps.params.brandRoute;
	  var shopId = (0, _selectors2.getShopId)(state, ownProps.params.shopRoute);
	  return {
	    brandRoute: brandRoute,
	    shopId: shopId,
	    branchKey: (0, _selectors.getBranchKey)(state, brandRoute, shopId)
	  };
	}), (0, _withPropsOnChange3.default)(['brandRoute', 'shopId'], function (props) {
	  var brandRoute = props.brandRoute,
	      shopId = props.shopId;
	
	
	  if (brandRoute || shopId) {
	    props.fetchExtension(brandRoute || shopId);
	  }
	}));
	
	exports.default = withBranchKey;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Branch = __webpack_require__(872);
	
	var _Branch2 = _interopRequireDefault(_Branch);
	
	var _Branch3 = __webpack_require__(871);
	
	var _Branch4 = _interopRequireDefault(_Branch3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _Branch2.default)(_Branch4.default);

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBranchKey = undefined;
	
	var _path2 = __webpack_require__(87);
	
	var _path3 = _interopRequireDefault(_path2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line import/prefer-default-export
	var getBranchKey = exports.getBranchKey = function getBranchKey(state, brandRoute, shopId) {
	  return (0, _path3.default)(['extensions', 'byRoute', brandRoute, 'branchKey'], state) || (0, _path3.default)(['extensions', 'byShopId', shopId, 'branchKey'], state) || (0, _path3.default)(['extensions', 'byId', shopId, 'branchKey'], state);
	};

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _branch = __webpack_require__(874);
	
	var _branch2 = _interopRequireDefault(_branch);
	
	var _gtag = __webpack_require__(882);
	
	var _gtag2 = _interopRequireDefault(_gtag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Analytics = function Analytics() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_branch2.default, null),
	    _react2.default.createElement(_gtag2.default, null)
	  );
	};
	
	exports.default = Analytics;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _helpers = __webpack_require__(7);
	
	var _selectors = __webpack_require__(159);
	
	var _ownerPixels = __webpack_require__(879);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	var _fbPixel = __webpack_require__(158);
	
	var _fbPixel2 = _interopRequireDefault(_fbPixel);
	
	var _withConsent = __webpack_require__(399);
	
	var _withConsent2 = _interopRequireDefault(_withConsent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, props) {
	  return {
	    brandId: (0, _selectors.getBrandId)(state, props.params.brandRoute)
	  };
	}), _WithShop2.default, _withConsent2.default, (0, _withPropsOnChange3.default)(['shop', 'brandId'], function (props) {
	  var brandId = props.shop ? props.shop.brandId : props.brandId;
	  var pixel = (0, _ownerPixels.getPixelForOwner)('brand', brandId);
	  if (!pixel && props.shop) {
	    pixel = (0, _ownerPixels.getPixelForOwner)('shop', props.shop.id);
	  }
	
	  if (pixel) {
	    _fbPixel2.default.init();
	    _fbPixel2.default.setPixelFor('ownerPixel', pixel);
	    _fbPixel2.default.trackPageView('ownerPixel');
	    return;
	  }
	
	  _fbPixel2.default.setPixelFor('ownerPixel', null);
	}))(_helpers.nullFunc);

/***/ }),
/* 878 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var events = {
	  PAGE_LOAD: 'Page Load',
	  PAGE_VIEW: 'Page View',
	  QUERY_SHOP: 'Query Entered',
	  SELECT_SHOP: 'Start Booking',
	  CHOOSE_PROFESSIONAL_CLICKED: 'Choose professional clicked',
	  CHOOSE_SERVICE_CLICKED: 'Choose Service clicked',
	  SELECT_BARBER: 'Professional Selected',
	  SELECT_ANY_BARBER: 'Any Professional Selected',
	  SELECT_SERVICE: 'Service Selected',
	  SELECT_DATE: 'Selected date',
	  SELECT_TIME: 'Selected time',
	  REVIEW_AND_BOOK: 'Date and Time Selected',
	  REVIEW_AND_PAY: 'Review and Pay',
	  WAITING_LIST: 'Waiting List clicked',
	  WAITING_LIST_WITH_APPLE_PAY: 'Waiting List with Apple Pay clicked',
	  FILL_PERSONAL_INFO: 'Filled personal info',
	  START_PAYMENT: 'Start Payment',
	  CREDIT_CARD_NUMBER_ENTERED: 'CC Number Entered',
	  CREDIT_CARD_EXP_DATE_ENTERED: 'CC Expiry Date Entered',
	  CREDIT_CARD_CVC_ENTERED: 'CC Security Code Entered',
	  CREDIT_CARD_ZIP_CODE_ENTERED: 'CC Zip Code Entered',
	  TIP_OPTION_ACTIVE: 'Tip option is active',
	  TIP_SELECTED: 'Tup Selected',
	  FILL_CARD_INFO: 'Filled Card Info',
	  ABANDON_PAYMENT: 'Abandoned Payment',
	  PAYMENT_ERROR: 'Payment Failure',
	  RESERVE_AND_PAY: 'Reserve and Pay Confirmed',
	  RESERVE_AND_PROVIDE_CARD: 'Reserve and Provide Card clicked',
	  RESERVE: 'Reserve Confirmed',
	  BOOKING_COMPLETE: 'Booking Complete',
	  SHOW_STRIPE_MODAL: 'Showed Stripe Modal',
	  SHOW_SQUIRE_MODAL: 'Showed Squire Modal',
	  ONLY_PAY_ACTIVE: 'Only Pay is Active',
	  RESERVE_AND_PROVIDE_CARD_ACTIVE: 'Reserve and Provide card is Active',
	  RESERVE_WITHOUT_PAY_ACTIVE: 'Reserve without Pay is Active',
	  ONLY_RESERVE_ACTIVE: 'Only Reserve is Active',
	  PROMO_ACTIVE: 'Promo is Active'
	};
	
	exports.default = events;

/***/ }),
/* 879 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable max-len */
	var pixelsByOwner = {
	  brand: {
	    'a5c0154b-ca93-4960-b0a5-d3727386b826': '608442746933717'
	  },
	  shop: {
	    'b08cc742-5ce1-443e-8522-4bc739ec1dd1': '2297729117182943',
	    'e7c62bc1-97a1-48e6-a50d-d54bc7d6e6e6': '5373545996029121'
	  }
	};
	
	// eslint-disable-next-line import/prefer-default-export
	var getPixelForOwner = exports.getPixelForOwner = function getPixelForOwner(ownerType, ownerId) {
	  return pixelsByOwner[ownerType] ? pixelsByOwner[ownerType][ownerId] : undefined;
	};

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _helpers = __webpack_require__(881);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	var _selectors = __webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scriptId = 'outer-gtag-script';
	var activeScript = null;
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, props) {
	  return {
	    brandId: (0, _selectors.getBrandId)(state, props.params.brandRoute)
	  };
	}), _WithShop2.default, (0, _withPropsOnChange3.default)(['shop', 'brandId'], function (props) {
	  var brandId = props.shop ? props.shop.brandId : props.brandId;
	  var script = (0, _helpers.getTrackingScript)(brandId);
	
	  if (script && script.code && script !== activeScript) {
	    var scriptEl = document.createElement('script');
	    scriptEl.id = scriptId;
	    scriptEl.type = 'text/javascript';
	
	    try {
	      scriptEl.appendChild(document.createTextNode(script.code));
	      document.body.appendChild(scriptEl);
	    } catch (e) {
	      scriptEl.text = script.code;
	      document.body.appendChild(scriptEl);
	    }
	
	    activeScript = script;
	  }
	
	  // user left a brand
	  if (!script && activeScript) {
	    var _scriptEl = document.getElementById(scriptId);
	    if (_scriptEl) {
	      document.body.removeChild(_scriptEl);
	    }
	
	    if (activeScript.dispose) {
	      activeScript.dispose();
	    }
	
	    activeScript = null;
	  }
	}))((0, _renderNothing3.default)());

/***/ }),
/* 881 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable max-len */
	var scriptByBrandId = {
	  '08b5230e-8541-41f1-a776-5644bdfd4b40': {
	    code: '\n      (function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){ (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o), m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m) })(window,document,\'script\',\'//www.google-analytics.com/analytics.js\',\'krwnGA\');\n      krwnGA(\'create\', \'UA-84932343-1\',\'auto\', {\'allowLinker\': true});\n      krwnGA(\'require\', \'linker\');\n      krwnGA(\'linker:autoLink\', [\'krwn.co\'] );\n      krwnGA(\'send\', \'pageview\');\n    ',
	    dispose: function dispose() {
	      window.krwnGA = function gaNoop() {};
	    }
	  },
	  'a9582d57-553c-4a99-8a68-05958923f2ef': {
	    code: '\n      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\n      new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],\n      j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\n      \'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);\n      })(window,document,\'script\',\'kingsDataLayer\',\'GTM-5QV4TND\');\n    ',
	    dispose: function dispose() {
	      window.kingsDataLayer = [];
	    }
	  },
	  'cce706a3-c15a-4728-9d81-f2f8d8e57172': {
	    code: '\n      var s = document.createElement(\'script\');\n      s.async = true;\n      s.src = \'https://www.googletagmanager.com/gtag/js?id=AW-10926152046\' + \'&l=stylzDataLayer\';\n      document.head.appendChild(s);\n      \n      window.stylzDataLayer = window.stylzDataLayer || [];\n      function stylzGtag(){stylzDataLayer.push(arguments);}\n      stylzGtag(\'js\', new Date());\n    \n      stylzGtag(\'config\', \'AW-10926152046\');\n    ',
	    dispose: function dispose() {
	      window.stylzGtag = function stylzGtag() {
	        return null;
	      };
	      window.stylzDataLayer = [];
	    }
	  }
	};
	
	// eslint-disable-next-line import/prefer-default-export
	var getTrackingScript = exports.getTrackingScript = function getTrackingScript(brandId) {
	  return scriptByBrandId[brandId];
	};

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GtagContainer = __webpack_require__(880);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GtagContainer).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _analytics = __webpack_require__(840);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Here, all integrations
	 */
	exports.default = {
	  Mixpanel: _analytics2.default
	};

/***/ }),
/* 884 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BAY_AREA = exports.BAY_AREA = 'Bay Area';
	var BAY_AREA_CITIES = exports.BAY_AREA_CITIES = ['Concord', 'Manteca', 'Martinez', 'Menlo Park', 'Oakland', 'Pleasanton', 'Sacramento', 'San Francisco', 'San Jose'];
	
	var NO_GREASE_CONCORD_SHOP = exports.NO_GREASE_CONCORD_SHOP = 'a920a0aa-3f5c-4de6-90a1-7c853316459c';

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _Barber = __webpack_require__(886);
	
	var _Barber2 = _interopRequireDefault(_Barber);
	
	var _WithToggle = __webpack_require__(63);
	
	var _WithToggle2 = _interopRequireDefault(_WithToggle);
	
	var _passcode = __webpack_require__(198);
	
	var _selectors = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    shop: (0, _selectors.getShopByRoute)(state, ownProps.params.shopRoute)
	  };
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(mapStateToProps, { showPasscode: _passcode.showPasscode }), _WithToggle2.default, (0, _withHandlers3.default)({
	  onClick: function onClick(props) {
	    return function (e) {
	      if (props.barber.requirePasscode) {
	        e.preventDefault();
	        props.showPasscode(props.barber.id);
	      }
	      if (props.onClick) props.onClick(e, props.barber, props.shop, props.link);
	    };
	  }
	}))(_Barber2.default);

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _InstagramLink = __webpack_require__(412);
	
	var _InstagramLink2 = _interopRequireDefault(_InstagramLink);
	
	var _shapes = __webpack_require__(23);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _passcode = __webpack_require__(198);
	
	var _passcode2 = _interopRequireDefault(_passcode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Barber = function Barber(_ref) {
	  var link = _ref.link,
	      barber = _ref.barber,
	      disabled = _ref.disabled,
	      onClick = _ref.onClick;
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    {
	      className: (0, _classnames2.default)('c-select-box', {
	        'is-disabled': disabled,
	        'is-active': barber.isActive
	      }),
	      onClick: onClick,
	      to: link
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'u-fill-parent u-bg-white' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-barber' },
	        _react2.default.createElement('div', {
	          className: 'c-barber__image',
	          style: { backgroundImage: 'url(' + (barber.thumbnail || _config2.default.fallbackBarberThumbnail) + ')' }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-barber__instagram' },
	          _react2.default.createElement(_InstagramLink2.default, { user: barber.instagram })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-barber__details' },
	          _react2.default.createElement(
	            'div',
	            { className: 'layout layout--flush layout--middle' },
	            _react2.default.createElement(
	              'div',
	              { className: 'layout__item u-1/2 u-1/1-large-and-up' },
	              _react2.default.createElement(
	                'div',
	                { className: 'c-barber__details-name' },
	                barber.firstName
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'layout__item u-1/2 u-1/1-large-and-up' },
	              _react2.default.createElement(
	                'div',
	                { className: 'large-and-up-mt large-and-up-pt--' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'c-heading u-co-gray-1 zeta u-lh-1' },
	                  'Next Available:'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'epsilon' },
	                  barber.nextTimeFormatted || 'No available times'
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_passcode2.default, { barber: barber, link: link })
	  );
	};
	Barber.propTypes = {
	  barber: _shapes.barberShape.isRequired,
	  onClick: _propTypes2.default.func.isRequired,
	  link: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool
	};
	Barber.defaultProps = {
	  link: '',
	  disabled: false
	};
	
	exports.default = Barber;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = barbersReducer;
	
	var _immutable = __webpack_require__(66);
	
	var _constants = __webpack_require__(10);
	
	var initialState = (0, _immutable.fromJS)({
	  items: []
	});
	
	function barbersReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.RECEIVE_BARBER:
	      {
	        var barberIndex = state.get('items').findIndex(function (barber) {
	          return barber.get('id') === action.payload.id;
	        });
	        return state.setIn(['items', barberIndex], action.payload);
	      }
	
	    case _constants.RECEIVE_BARBERS:
	      {
	        return state.set('items', (0, _immutable.fromJS)(action.payload));
	      }
	
	    case _constants.RECEIVE_BARBER_AVAILABLE_TIME:
	      {
	        var _barberIndex = state.get('items').findIndex(function (barber) {
	          return barber.get('id') === action.payload.id;
	        });
	        return state.setIn(['items', _barberIndex, 'nextTime'], action.payload.nextTime);
	      }
	
	    case _constants.REQUEST_BARBER_AVAILABLE_TIME:
	      return state;
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactGateway = __webpack_require__(77);
	
	var _Layout = __webpack_require__(112);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _Title = __webpack_require__(114);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _GiftCardLink = __webpack_require__(418);
	
	var _GiftCardLink2 = _interopRequireDefault(_GiftCardLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BrandLayout = function BrandLayout(_ref) {
	  var children = _ref.children,
	      brandName = _ref.brandName,
	      brandImage = _ref.brandImage,
	      brandLogo = _ref.brandLogo;
	  return _react2.default.createElement(
	    _Layout2.default,
	    { backgroundImage: brandImage, logo: brandLogo, noFooter: true },
	    _react2.default.createElement(
	      _Title2.default,
	      null,
	      brandName
	    ),
	    _react2.default.createElement(_GiftCardLink2.default, { withBrand: true, className: 'u-mt- medium-and-up-mt+' }),
	    _react2.default.createElement(_reactGateway.GatewayDest, { name: 'subtitle', className: 'u-show-for-large-and-up' }),
	    children
	  );
	};
	BrandLayout.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  brandName: _propTypes2.default.string,
	  brandImage: _propTypes2.default.string,
	  brandLogo: _propTypes2.default.string
	};
	BrandLayout.defaultProps = {
	  brandName: '',
	  brandImage: '',
	  brandLogo: ''
	};
	
	exports.default = BrandLayout;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(11);
	
	var _ShopList = __webpack_require__(467);
	
	var _ShopList2 = _interopRequireDefault(_ShopList);
	
	var _actions = __webpack_require__(64);
	
	var _selectors2 = __webpack_require__(159);
	
	var _extensions = __webpack_require__(95);
	
	var _extensions2 = _interopRequireDefault(_extensions);
	
	var _helpers = __webpack_require__(7);
	
	var _constants = __webpack_require__(10);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getUrlPattern = function getUrlPattern(shop) {
	  if (shop.kind === _constants.SHOP_TYPE.commision || (0, _selectors.getShopAllowBookWithAnyBarber)(shop)) {
	    return _config2.default.urlPatterns.booking;
	  }
	  return _config2.default.urlPatterns.barber;
	};
	
	var ShopsContainer = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    brandRoute: ownProps.params.brandRoute,
	    shopIds: (0, _selectors2.getBrandShops)(state, ownProps.params.brandRoute),
	    shops: (0, _selectors.getShops)(state),
	    isLoading: state.shops.isFetching
	  };
	}, { fetchShopsById: _actions.fetchShopsById }), _extensions2.default, (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    this.props.fetchExtension(this.props.brandRoute, true);
	  }
	}), (0, _withPropsOnChange3.default)(['shopIds'], function (props) {
	  props.fetchShopsById(props.shopIds);
	}), (0, _withPropsOnChange3.default)(['shops'], function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(props) {
	    var url;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            // If there is only one shop we should redirect to that shop right away
	            if (props.shops.length === 1) {
	              url = (0, _helpers.generateUrlString)({ shopRoute: props.shops[0].route }, getUrlPattern(props.shops[0]));
	
	              props.router.push(url);
	            }
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function (_x) {
	    return _ref.apply(this, arguments);
	  };
	}()));
	
	exports.default = ShopsContainer(_ShopList2.default);

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _Shops = __webpack_require__(889);
	
	var _Shops2 = _interopRequireDefault(_Shops);
	
	var _BrandLayout = __webpack_require__(404);
	
	var _BrandLayout2 = _interopRequireDefault(_BrandLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _reactRouter.Route,
	    { component: _BrandLayout2.default },
	    _react2.default.createElement(_reactRouter.Route, { path: '/brands/:brandRoute', component: _Shops2.default })
	  );
	};

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchCampaign = undefined;
	
	var _constants = __webpack_require__(10);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line import/prefer-default-export
	var fetchCampaign = exports.fetchCampaign = function fetchCampaign(campaignId, source, customerId) {
	  return function (dispatch) {
	    dispatch({ type: _constants.FETCH_CAMPAIGN });
	    return fetch(_config2.default.url + '/campaign/' + campaignId + '/' + source + '/' + (customerId || '')).then(_helpers.checkStatus).then(function (response) {
	      return dispatch({ type: _constants.FETCH_CAMPAIGN_SUCCESS, payload: response });
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactRouter = __webpack_require__(5);
	
	var _PromoValue = __webpack_require__(893);
	
	var _PromoValue2 = _interopRequireDefault(_PromoValue);
	
	var _GlobalErrorAndRedirectionListener = __webpack_require__(265);
	
	var _GlobalErrorAndRedirectionListener2 = _interopRequireDefault(_GlobalErrorAndRedirectionListener);
	
	var _Loader = __webpack_require__(82);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ensureHttps = function ensureHttps(htmlString) {
	  var parser = new DOMParser();
	  var doc = parser.parseFromString(htmlString, 'text/html');
	  var anchors = doc.querySelectorAll('a[href]');
	  anchors.forEach(function (anchor) {
	    var hrefValue = anchor.getAttribute('href');
	    // Check if hrefValue does not start with a protocol (http, https, ftp, etc.)
	    if (!/^(\w+:)?\/\//.test(hrefValue)) {
	      anchor.setAttribute('href', 'https://'.concat(hrefValue));
	    }
	  });
	  return doc.body.innerHTML;
	};
	
	var CampaignEmail = function CampaignEmail(_ref) {
	  var loading = _ref.loading,
	      logo = _ref.logo,
	      shopName = _ref.shopName,
	      shopAddress = _ref.shopAddress,
	      backgroundImage = _ref.backgroundImage,
	      color = _ref.color,
	      subject = _ref.subject,
	      body = _ref.body,
	      promo = _ref.promo,
	      unsubscribeUrl = _ref.unsubscribeUrl,
	      goToBookAppointment = _ref.goToBookAppointment;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-campaign-email-wrapper' },
	    _react2.default.createElement(_GlobalErrorAndRedirectionListener2.default, null),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Campaign'
	      )
	    ),
	    loading && _react2.default.createElement(_Loader2.default, null),
	    !loading && _react2.default.createElement(
	      'div',
	      { className: 'c-campaign-email' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-campaign-email__header', style: { color: color, backgroundImage: 'url(' + backgroundImage + ')' } },
	        logo && _react2.default.createElement('img', { className: 'c-logo', src: logo, alt: '' }),
	        logo && _react2.default.createElement(
	          'div',
	          { className: 'u-co-white u-mt-' },
	          shopName
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-campaign-email__body' },
	        _react2.default.createElement('div', { className: 'delta u-type--normal u-mb-', dangerouslySetInnerHTML: { __html: subject } }),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: ensureHttps(body) } }),
	        !(0, _isEmpty3.default)(promo) && _react2.default.createElement(
	          'div',
	          { className: 'u-type--normal u-p u-mt', style: { backgroundColor: color, borderRadius: 2, color: '#fff' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'u-type--bold', style: { fontSize: 22 } },
	            _react2.default.createElement(_PromoValue2.default, { promo: promo })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'u-type--bold u-mt-' },
	            'Get ',
	            _react2.default.createElement(_PromoValue2.default, { promo: promo }),
	            ' off next time you visit!'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'u-mt-' },
	            'Book an appointment ',
	            promo.expirationDate && _react2.default.createElement(
	              'span',
	              null,
	              'by ',
	              _react2.default.createElement(
	                'b',
	                null,
	                promo.expirationDate
	              )
	            ),
	            ' and get ',
	            _react2.default.createElement(
	              'b',
	              null,
	              _react2.default.createElement(_PromoValue2.default, { promo: promo }),
	              ' off'
	            ),
	            ' using the code',
	            ' ',
	            _react2.default.createElement(
	              'b',
	              { className: 'u-type--uppercase' },
	              promo.code
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'u-mt u-mb-' },
	            _react2.default.createElement(
	              'a',
	              {
	                role: 'button',
	                tabIndex: 0,
	                onClick: goToBookAppointment,
	                className: 'c-campaign-email__button',
	                style: { color: color }
	              },
	              'Book An Appointment'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-campaign-email__footer u-mt' },
	        _react2.default.createElement(
	          'div',
	          { className: 'u-type--semibold' },
	          shopName
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          shopAddress
	        ),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: unsubscribeUrl },
	          'Unsubscribe'
	        )
	      )
	    )
	  );
	};
	
	CampaignEmail.propTypes = {
	  loading: _propTypes2.default.bool.isRequired,
	  logo: _propTypes2.default.string,
	  shopName: _propTypes2.default.string,
	  shopAddress: _propTypes2.default.string,
	  backgroundImage: _propTypes2.default.string,
	  color: _propTypes2.default.string,
	  subject: _propTypes2.default.string,
	  body: _propTypes2.default.string,
	  promo: _propTypes2.default.shape({
	    code: _propTypes2.default.string,
	    value: _propTypes2.default.number,
	    expirationDate: _propTypes2.default.string
	  }),
	  unsubscribeUrl: _propTypes2.default.string,
	  goToBookAppointment: _propTypes2.default.func.isRequired
	};
	CampaignEmail.defaultProps = {
	  logo: '',
	  shopName: '',
	  shopAddress: '',
	  backgroundImage: '',
	  color: '',
	  subject: '',
	  body: '',
	  promo: {},
	  unsubscribeUrl: ''
	};
	
	exports.default = CampaignEmail;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _constants = __webpack_require__(894);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PromoValue = function PromoValue(_ref) {
	  var promo = _ref.promo,
	      props = _objectWithoutProperties(_ref, ['promo']);
	
	  if (promo.kind === _constants.PROMO_TYPE.percentage) {
	    return _react2.default.createElement(
	      'span',
	      props,
	      promo.value,
	      '%'
	    );
	  }
	
	  return _react2.default.createElement(_Money2.default, Object.assign({ cents: promo.value }, props));
	};
	PromoValue.propTypes = {
	  promo: _propTypes2.default.shape({
	    amount: _propTypes2.default.number,
	    kind: _propTypes2.default.number
	  }).isRequired
	};
	
	exports.default = PromoValue;

/***/ }),
/* 894 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PROMO_TYPE = exports.PROMO_TYPE = { // eslint-disable-line import/prefer-default-export
	  amount: 0,
	  percentage: 1
	};

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _CampaignEmail = __webpack_require__(892);
	
	var _CampaignEmail2 = _interopRequireDefault(_CampaignEmail);
	
	var _actions = __webpack_require__(891);
	
	var _selectors = __webpack_require__(405);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CampaignEmailContainer = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    loading: (0, _selectors.getCampaignLoading)(state),
	    logo: (0, _selectors.getCampaignLogo)(state),
	    shopName: (0, _selectors.getCampaignShopName)(state),
	    shopAddress: (0, _selectors.getCampaignShopAddress)(state),
	    backgroundImage: (0, _selectors.getCampaignBackgroundImage)(state),
	    color: (0, _selectors.getCampaignColor)(state),
	    subject: (0, _selectors.getCampaignSubject)(state),
	    body: (0, _selectors.getCampaignBody)(state),
	    promo: (0, _selectors.getCampaignPromo)(state),
	    campaignId: ownProps.params.campaignId,
	    source: ownProps.params.source,
	    customerId: ownProps.params.customerId,
	    bookUrl: (0, _selectors.getCampaignBookUrl)(state),
	    unsubscribeUrl: (0, _selectors.getCampaignUnsubscribeUrl)(state)
	  };
	}, { fetchCampaign: _actions.fetchCampaign }), (0, _withHandlers3.default)({
	  fetchCampaign: function fetchCampaign(props) {
	    return function () {
	      return props.fetchCampaign(props.campaignId, props.source, props.customerId);
	    };
	  },
	  goToBookAppointment: function goToBookAppointment(props) {
	    return function () {
	      return window.location.href = props.bookUrl;
	    };
	  }
	}), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    this.props.fetchCampaign();
	  }
	}))(_CampaignEmail2.default);
	
	exports.default = CampaignEmailContainer;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { item: {}, loading: false };
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case _constants.FETCH_CAMPAIGN:
	      return { item: {}, loading: true };
	    case _constants.FETCH_CAMPAIGN_SUCCESS:
	      return { item: payload, loading: false };
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.requestCities = requestCities;
	exports.receiveCities = receiveCities;
	exports.fetchAllCities = fetchAllCities;
	
	var _constants = __webpack_require__(10);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _bayAreaShops = __webpack_require__(402);
	
	var _bayAreaShops2 = _interopRequireDefault(_bayAreaShops);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requestCities() {
	  return {
	    type: _constants.REQUEST_CITIES
	  };
	}
	
	function receiveCities(cities) {
	  return {
	    type: _constants.RECEIVE_CITIES,
	    payload: cities
	  };
	}
	
	function shouldFetchCities(state) {
	  if (!state.cities.items.length) {
	    return true;
	  } else if (state.isFetching) {
	    return false;
	  }
	  return true;
	}
	
	function fetchAllCities() {
	  return function (dispatch, getState) {
	    if (!shouldFetchCities(getState())) return Promise.resolve();
	
	    dispatch(requestCities());
	
	    return fetch(_config2.default.url + '/shop/cities').then(_helpers.checkStatus).then(_bayAreaShops2.default.fetchCities).then(function (cities) {
	      return dispatch(receiveCities(cities));
	    }).catch((0, _helpers.handleRequestError)(dispatch));
	  };
	}

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sortBy2 = __webpack_require__(351);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	exports.default = citiesReducer;
	
	var _immutable = __webpack_require__(66);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InitialState = (0, _immutable.Record)({
	  items: []
	});
	
	var initialState = new InitialState();
	
	function citiesReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.RECEIVE_CITIES:
	      return state.set('items', (0, _sortBy3.default)(action.payload));
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactClickOutside = __webpack_require__(1593);
	
	var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);
	
	var _AddToCalendarContainer = __webpack_require__(406);
	
	var _AddToCalendarContainer2 = _interopRequireDefault(_AddToCalendarContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CALENDARS = [{ type: 'ical', label: 'iCalendar' }, { type: 'google', label: 'Google Calendar' }, { type: 'outlook', label: 'Outlook' }, { type: 'outlookonline', label: 'Outlook Online' }, { type: 'yahoo', label: 'Yahoo!' }];
	
	var AddToCalendarButton = function (_Component) {
	  _inherits(AddToCalendarButton, _Component);
	
	  function AddToCalendarButton(props) {
	    _classCallCheck(this, AddToCalendarButton);
	
	    var _this = _possibleConstructorReturn(this, (AddToCalendarButton.__proto__ || Object.getPrototypeOf(AddToCalendarButton)).call(this, props));
	
	    _this.state = { show: false };
	
	    _this.onButtonClick = _this.onButtonClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(AddToCalendarButton, [{
	    key: 'onButtonClick',
	    value: function onButtonClick() {
	      this.setState({ show: !this.state.show });
	    }
	  }, {
	    key: 'handleClickOutside',
	    value: function handleClickOutside() {
	      this.setState({ show: false });
	    }
	  }, {
	    key: 'renderRoutes',
	    value: function renderRoutes() {
	      var _this2 = this;
	
	      return CALENDARS.map(function (calendar) {
	        return _react2.default.createElement(
	          'li',
	          { key: calendar.type },
	          _react2.default.createElement(
	            'a',
	            {
	              className: 'c-btn c-btn--small c-btn--secondary u-block u-mv-- u-mh',
	              href: _this2.props.getCalendarLink(calendar.type),
	              target: '_blank',
	              rel: 'noopener noreferrer'
	            },
	            calendar.label
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown() {
	      return _react2.default.createElement(
	        'ul',
	        {
	          className: 'list-bare',
	          style: {
	            display: 'block',
	            position: 'absolute',
	            float: 'left',
	            backgroundColor: '#fff',
	            zIndex: 20,
	            width: '100%'
	          }
	        },
	        this.renderRoutes()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'u-position-relative' },
	        _react2.default.createElement(
	          'button',
	          { className: 'c-btn c-btn--secondary u-1/1', onClick: this.onButtonClick },
	          'Add to Calendar'
	        ),
	        this.state.show && this.renderDropdown()
	      );
	    }
	  }]);
	
	  return AddToCalendarButton;
	}(_react.Component);
	
	AddToCalendarButton.propTypes = {
	  getCalendarLink: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactClickOutside2.default)((0, _AddToCalendarContainer2.default)(AddToCalendarButton));

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shapes = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Checkbox = function Checkbox(_ref) {
	  var id = _ref.id,
	      label = _ref.label,
	      onChange = _ref.onChange,
	      name = _ref.name,
	      required = _ref.required;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-checkbox' },
	    _react2.default.createElement('input', Object.assign({
	      className: 'c-checkbox__input',
	      type: 'checkbox'
	    }, { id: id, onChange: onChange, name: name, required: required })),
	    _react2.default.createElement('label', { className: 'c-checkbox__mark', htmlFor: id }),
	    _react2.default.createElement(
	      'label',
	      { className: 'c-checkbox__label', htmlFor: id },
	      _react2.default.createElement(
	        'span',
	        { className: 'c-checkbox__text' },
	        label
	      )
	    )
	  );
	};
	Checkbox.propTypes = _shapes.fieldPropTypes;
	Checkbox.defaultProps = {
	  name: '',
	  required: false,
	  onChange: null
	};
	
	exports.default = Checkbox;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDayPicker = __webpack_require__(1600);
	
	var _reactDayPicker2 = _interopRequireDefault(_reactDayPicker);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(7);
	
	var _WithToggle = __webpack_require__(63);
	
	var _WithToggle2 = _interopRequireDefault(_WithToggle);
	
	var _Modal = __webpack_require__(93);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarElement = function NavbarElement(_ref) {
	  var onPreviousClick = _ref.onPreviousClick,
	      onNextClick = _ref.onNextClick;
	  return _react2.default.createElement(
	    'div',
	    { className: 'DayPicker-NavBar' },
	    _react2.default.createElement(
	      'button',
	      {
	        className: 'DayPicker-NavButton DayPicker-NavButton--next',
	        type: 'button',
	        onClick: function onClick() {
	          return onNextClick();
	        }
	      },
	      _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.ARROW_CIRCLE_RIGHT, className: 'DayPicker-Icon' })
	    ),
	    _react2.default.createElement(
	      'button',
	      {
	        className: 'DayPicker-NavButton DayPicker-NavButton--prev',
	        type: 'button',
	        onClick: function onClick() {
	          return onPreviousClick();
	        }
	      },
	      _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.ARROW_CIRCLE_LEFT, className: 'DayPicker-Icon' })
	    )
	  );
	};
	NavbarElement.propTypes = {
	  onPreviousClick: _propTypes2.default.func.isRequired,
	  onNextClick: _propTypes2.default.func.isRequired
	};
	
	var DatePickerButton = function DatePickerButton(_ref2) {
	  var selectedDay = _ref2.selectedDay,
	      onDayClick = _ref2.onDayClick,
	      on = _ref2.on,
	      off = _ref2.off,
	      toggled = _ref2.toggled,
	      disabledDays = _ref2.disabledDays,
	      daysOff = _ref2.daysOff,
	      daysOn = _ref2.daysOn,
	      weekdaysOff = _ref2.weekdaysOff;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'button',
	      {
	        className: 'c-btn c-btn--bare u-co-teal u-nudge-t3',
	        type: 'button',
	        onClick: on
	      },
	      _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.CALENDAR, className: 'c-datepicker-icon' })
	    ),
	    toggled && _react2.default.createElement(
	      _Modal2.default,
	      { close: off },
	      _react2.default.createElement(_reactDayPicker2.default, {
	        onDayClick: onDayClick,
	        selectedDays: selectedDay,
	        disabledDays: disabledDays,
	        month: selectedDay,
	        navbarElement: NavbarElement,
	        modifiers: { daysOff: daysOff, daysOn: daysOn, weekdaysOff: { daysOfWeek: weekdaysOff } }
	      })
	    )
	  );
	};
	DatePickerButton.propTypes = {
	  on: _propTypes2.default.func.isRequired,
	  off: _propTypes2.default.func.isRequired,
	  toggled: _propTypes2.default.bool.isRequired,
	  onDayClick: _propTypes2.default.func,
	  selectedDay: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
	  disabledDays: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
	  daysOff: _propTypes2.default.array, // eslint-disable-line react/forbid-prop-types
	  daysOn: _propTypes2.default.array, // eslint-disable-line react/forbid-prop-types
	  weekdaysOff: _propTypes2.default.array // eslint-disable-line react/forbid-prop-types
	};
	DatePickerButton.defaultProps = {
	  onDayClick: _helpers.nullFunc,
	  selectedDay: new Date(),
	  disabledDays: null,
	  daysOff: null,
	  daysOn: null,
	  weekdaysOff: null
	};
	
	exports.default = (0, _compose3.default)(_WithToggle2.default, (0, _withHandlers3.default)(function (initialProps) {
	  if (!initialProps.onDayClick) return null;
	  return {
	    onDayClick: function onDayClick(props) {
	      return function (day) {
	        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	            disabled = _ref3.disabled;
	
	        if (disabled) return;
	        props.onDayClick(day);
	        props.off();
	      };
	    }
	  };
	}))(DatePickerButton);

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _SquireShopLink = __webpack_require__(914);
	
	var _SquireShopLink2 = _interopRequireDefault(_SquireShopLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var year = new Date().getFullYear();
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: 'u-bg-white' },
	    _react2.default.createElement(
	      'div',
	      { className: 'o-wrapper o-wrapper--page' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-footer u-pt+' },
	        _react2.default.createElement(
	          'div',
	          { className: 'c-footer__brand u-mb' },
	          'Squire'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'layout' },
	          _react2.default.createElement(
	            'div',
	            { className: 'layout__item u-8/10-medium-and-up' },
	            _react2.default.createElement(
	              'div',
	              { className: 'c-footer__company u-mb+' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Squire Technologies is a company',
	                _react2.default.createElement('br', null),
	                'dedicated to making style and',
	                _react2.default.createElement('br', null),
	                'grooming for men simple.'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'u-mt' },
	                '\xA9 ',
	                year,
	                ' Squire Technologies'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'c-footer__section-heading u-co-teal-blue u-mb--' },
	              'FEEL FREE TO CONTACT US'
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: 'c-footer__email', href: 'mailto:support@getsquire.com' },
	              'support@getsquire.com'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'layout__item u-2/10-medium-and-up' },
	            _react2.default.createElement(
	              'div',
	              { className: 'c-footer__section-heading u-mb' },
	              'Follow us'
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                className: 'c-footer__social-link',
	                href: 'https://www.linkedin.com/company/5160648',
	                target: '_blank',
	                rel: 'noopener noreferrer'
	              },
	              _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.LINKEDIN })
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                className: 'c-footer__social-link',
	                href: 'https://twitter.com/getsquire',
	                target: '_blank',
	                rel: 'noopener noreferrer'
	              },
	              _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.TWITTER })
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                className: 'c-footer__social-link',
	                href: 'https://www.facebook.com/SquireTechnologies/',
	                target: '_blank',
	                rel: 'noopener noreferrer'
	              },
	              _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.FACEBOOK })
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                className: 'c-footer__social-link',
	                href: 'https://www.instagram.com/getsquire/',
	                target: '_blank',
	                rel: 'noopener noreferrer'
	              },
	              _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.INSTAGRAM })
	            ),
	            _react2.default.createElement(_SquireShopLink2.default, null)
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactGateway = __webpack_require__(77);
	
	var _selectors = __webpack_require__(21);
	
	var reservationSelectors = _interopRequireWildcard(_selectors);
	
	var _selectors2 = __webpack_require__(11);
	
	var shopSelectors = _interopRequireWildcard(_selectors2);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var homeUrl = _ref.homeUrl,
	      kiosk = _ref.kiosk,
	      location = _ref.location,
	      shopLogo = _ref.shopLogo;
	
	  var linkTo = kiosk || location.query.showShops ? homeUrl : '';
	
	  return _react2.default.createElement(
	    'header',
	    { className: 'c-header-wrapper' },
	    _react2.default.createElement(
	      'div',
	      { className: 'o-wrapper o-wrapper--page' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-header' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'c-header__logo' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: linkTo },
	            _react2.default.createElement('img', { src: shopLogo, alt: '' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-header__title' },
	          _react2.default.createElement(_reactGateway.GatewayDest, { name: 'title', className: 'u-inline-block' })
	        )
	      )
	    )
	  );
	};
	Header.propTypes = {
	  homeUrl: _propTypes2.default.string,
	  kiosk: _propTypes2.default.bool,
	  location: _propTypes2.default.shape({
	    query: _propTypes2.default.object
	  }).isRequired,
	  shopLogo: _propTypes2.default.string.isRequired
	};
	Header.defaultProps = {
	  homeUrl: '/',
	  kiosk: false
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  var shopId = shopSelectors.getShopId(state, ownProps.params.shopRoute) || reservationSelectors.getShopId(state);
	  var isLogoFetching = ownProps.params.shopRoute && !shopId && state.app.isFetching;
	  return {
	    shopLogo: isLogoFetching ? '' : ownProps.logo || shopSelectors.getShopLogo(state, shopId) || reservationSelectors.getShopLogo(state) || _config2.default.fallbackShopLogo
	  };
	}))(Header);

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _sweetalertReact = __webpack_require__(132);
	
	var _sweetalertReact2 = _interopRequireDefault(_sweetalertReact);
	
	var _actions = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InvalidPromoError = function (_Component) {
	  _inherits(InvalidPromoError, _Component);
	
	  function InvalidPromoError() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InvalidPromoError);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InvalidPromoError.__proto__ || Object.getPrototypeOf(InvalidPromoError)).call.apply(_ref, [this].concat(args))), _this), _this.closeModal = function () {
	      _this.props.clearErrors();
	    }, _this.confirm = function () {
	      _this.closeModal();
	      if (_this.props.onConfirm) {
	        _this.props.onConfirm();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InvalidPromoError, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_sweetalertReact2.default, {
	        show: this.props.hasError,
	        title: 'Heads Up!',
	        text: this.props.errorMessage,
	        type: 'warning',
	        confirmButtonColor: '#009d92',
	        confirmButtonText: 'Yes',
	        showCancelButton: true,
	        cancelButtonText: 'No',
	        onEscapeKey: this.closeModal,
	        onConfirm: this.confirm,
	        onCancel: this.closeModal
	      });
	    }
	  }]);
	
	  return InvalidPromoError;
	}(_react.Component);
	
	InvalidPromoError.propTypes = {
	  errorMessage: _propTypes2.default.string,
	  clearErrors: _propTypes2.default.func.isRequired,
	  hasError: _propTypes2.default.bool,
	  onConfirm: _propTypes2.default.func // eslint-disable-line react/require-default-props
	};
	
	InvalidPromoError.defaultProps = {
	  errorMessage: '',
	  hasError: false
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    errorMessage: state.reservation.get('errorMessage'),
	    hasError: !!state.reservation.get('errorMessage')
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    clearErrors: function clearErrors() {
	      return dispatch((0, _actions.clearErrors)());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InvalidPromoError);

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _squireLogoLight = __webpack_require__(309);
	
	var _squireLogoLight2 = _interopRequireDefault(_squireLogoLight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LightLogo = function LightLogo() {
	  return _react2.default.createElement('img', { src: _squireLogoLight2.default, alt: 'Squire' });
	};
	
	exports.default = LightLogo;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGateway = __webpack_require__(77);
	
	var _Layout = __webpack_require__(112);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainLayout = function MainLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    _Layout2.default,
	    null,
	    _react2.default.createElement(_reactGateway.GatewayDest, { name: 'subtitle', className: 'u-show-for-large-and-up' }),
	    children
	  );
	};
	MainLayout.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = MainLayout;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalCloseButton = function ModalCloseButton(props) {
	  return _react2.default.createElement("button", Object.assign({ className: "c-modal__close" }, props));
	};
	
	exports.default = ModalCloseButton;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NextLink = function NextLink(_ref) {
	  var to = _ref.to,
	      onNextClick = _ref.onNextClick;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-text-center u-mt+ ' },
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: to, className: 'c-btn c-btn--primary u-ph++', onClick: onNextClick },
	      'Next'
	    )
	  );
	};
	NextLink.propTypes = {
	  to: _propTypes2.default.string,
	  onNextClick: _propTypes2.default.func
	};
	NextLink.defaultProps = {
	  to: '',
	  onNextClick: function onNextClick() {
	    return true;
	  }
	};
	
	exports.default = NextLink;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _sweetalertReact = __webpack_require__(132);
	
	var _sweetalertReact2 = _interopRequireDefault(_sweetalertReact);
	
	var _actions = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OnlyPrepayError = function (_Component) {
	  _inherits(OnlyPrepayError, _Component);
	
	  function OnlyPrepayError() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OnlyPrepayError);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OnlyPrepayError.__proto__ || Object.getPrototypeOf(OnlyPrepayError)).call.apply(_ref, [this].concat(args))), _this), _this.closeModal = function () {
	      _this.props.clearErrors();
	    }, _this.confirm = function () {
	      _this.closeModal();
	      if (_this.props.onConfirm) {
	        _this.props.onConfirm();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OnlyPrepayError, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_sweetalertReact2.default, {
	        show: this.props.hasError,
	        title: 'Error',
	        text: this.props.errorMessage,
	        type: 'error',
	        confirmButtonColor: '#009d92',
	        confirmButtonText: 'Book and Pay',
	        showCancelButton: true,
	        cancelButtonText: 'Cancel',
	        onEscapeKey: this.closeModal,
	        onConfirm: this.confirm,
	        onCancel: this.closeModal
	      });
	    }
	  }]);
	
	  return OnlyPrepayError;
	}(_react.Component);
	
	OnlyPrepayError.propTypes = {
	  errorMessage: _propTypes2.default.string,
	  clearErrors: _propTypes2.default.func.isRequired,
	  hasError: _propTypes2.default.bool,
	  onConfirm: _propTypes2.default.func // eslint-disable-line react/require-default-props
	};
	
	OnlyPrepayError.defaultProps = {
	  errorMessage: '',
	  hasError: false
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    errorMessage: state.reservation.get('errorMessage'),
	    hasError: !!state.reservation.get('errorMessage')
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    clearErrors: function clearErrors() {
	      return dispatch((0, _actions.clearErrors)());
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OnlyPrepayError);

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactPhoneNumberInput = __webpack_require__(786);
	
	var _reactPhoneNumberInput2 = _interopRequireDefault(_reactPhoneNumberInput);
	
	__webpack_require__(812);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _intl = __webpack_require__(300);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CountryCodePhoneInput = function CountryCodePhoneInput(_ref) {
	  var value = _ref.value,
	      shop = _ref.shop,
	      _onChange = _ref.onChange,
	      props = _objectWithoutProperties(_ref, ['value', 'shop', 'onChange']);
	
	  return _react2.default.createElement(_reactPhoneNumberInput2.default, Object.assign({}, props, {
	    value: value,
	    country: !value && (0, _intl.getCountryCodeByCountryAndCurrency)(shop) || '',
	    international: false,
	    countryOptions: ['US', 'CA', 'GB', '...'],
	    onChange: function onChange(val) {
	      return _onChange(val || '');
	    },
	    flagsPath: 'https://flagicons.lipis.dev/flags/4x3/'
	  }));
	};
	
	CountryCodePhoneInput.propTypes = {
	  shop: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
	  value: _propTypes2.default.string,
	  onChange: _propTypes2.default.func.isRequired
	};
	
	CountryCodePhoneInput.defaultProps = {
	  currency: _config2.default.defaultCurrency,
	  value: null,
	  shop: {}
	};
	
	exports.default = (0, _WithShop2.default)(CountryCodePhoneInput);

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-text-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement('meta', { name: 'robots', content: 'noindex' })
	    ),
	    _react2.default.createElement(
	      _Title2.default,
	      { className: 'alpha' },
	      '404'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'gamma u-mb++' },
	      'The page you requested does not exist.'
	    ),
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: '/' },
	      'Return to main page.'
	    )
	  );
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _Title = __webpack_require__(114);
	
	var _Title2 = _interopRequireDefault(_Title);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	var _shapes = __webpack_require__(23);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(_ref) {
	  var shop = _ref.shop;
	  return _react2.default.createElement(
	    'footer',
	    { className: 'u-bg-white' },
	    _react2.default.createElement(
	      'div',
	      { className: 'o-wrapper o-wrapper--page' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-footer c-footer--shop u-pt' },
	        _react2.default.createElement(
	          'div',
	          { className: 'c-heading c-heading--huge u-co-teal-blue' },
	          shop.name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-heading c-heading--large u-mv--' },
	          shop.address
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-heading c-heading--large' },
	          (0, _helpers.formatPhone)(shop.phone)
	        )
	      )
	    )
	  );
	};
	Footer.propTypes = {
	  shop: _shapes.shopShape
	};
	Footer.defaultProps = {
	  shop: {}
	};
	
	exports.default = (0, _compose3.default)(_WithShop2.default, (0, _branch3.default)(function (props) {
	  return (0, _isEmpty3.default)(props.shop);
	}, _renderNothing3.default))(Footer);

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGateway = __webpack_require__(77);
	
	var _Layout = __webpack_require__(112);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainLayout = function MainLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    _Layout2.default,
	    { shopLayout: true },
	    _react2.default.createElement(_reactGateway.GatewayDest, { name: 'subtitle', className: 'u-show-for-large-and-up' }),
	    children
	  );
	};
	MainLayout.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = MainLayout;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShopLink = function ShopLink() {
	  var url = _config2.default.squireShopUrl;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-mt' },
	    _react2.default.createElement(
	      'a',
	      { className: 'c-btn c-btn--secondary c-btn--small', href: 'http://' + url + '.getsquire.com/' },
	      'For barbers'
	    )
	  );
	};
	
	module.exports = ShopLink;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shapes = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Step = function Step(_ref) {
	  var step = _ref.step,
	      router = _ref.router,
	      disabled = _ref.disabled,
	      className = _ref.className;
	
	  var isActive = router.isActive(step.url, true);
	  var classNames = (0, _classnames2.default)('c-breadcrumbs__item', {
	    'is-active': isActive,
	    'is-disabled': disabled
	  }, className);
	
	  return _react2.default.createElement(
	    'li',
	    { className: classNames },
	    _react2.default.createElement(
	      _reactRouter.Link,
	      {
	        to: step.url,
	        tabIndex: disabled ? -1 : 0,
	        className: step.trim ? 'u-text-trim u-mw-160 u-inline-block' : ''
	      },
	      step.text
	    )
	  );
	};
	Step.propTypes = {
	  step: _shapes.stepShape.isRequired,
	  router: _propTypes2.default.shape({
	    isActive: _propTypes2.default.func.isRequired
	  }).isRequired,
	  disabled: _propTypes2.default.bool,
	  className: _propTypes2.default.string
	};
	Step.defaultProps = {
	  to: null,
	  trim: false,
	  disabled: false,
	  className: ''
	};
	
	exports.default = (0, _reactRouter.withRouter)(Step);

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _WithBarberShortName = __webpack_require__(986);
	
	var _WithBarberShortName2 = _interopRequireDefault(_WithBarberShortName);
	
	var _WithServiceName = __webpack_require__(996);
	
	var _WithServiceName2 = _interopRequireDefault(_WithServiceName);
	
	var _WithReservationTime = __webpack_require__(993);
	
	var _WithReservationTime2 = _interopRequireDefault(_WithReservationTime);
	
	var _Step = __webpack_require__(915);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	var _shapes = __webpack_require__(23);
	
	var _steps = __webpack_require__(1239);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Steps = function Steps(_ref) {
	  var steps = _ref.steps;
	
	  var className = 'u-hide-for-medium-and-down';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-steps' },
	    _react2.default.createElement(
	      'ul',
	      { className: 'c-breadcrumbs' },
	      steps.map(function (step, i) {
	        return _react2.default.createElement(_Step2.default, { step: step, className: i > 0 ? className : '', trim: step.key, key: step.key });
	      })
	    )
	  );
	};
	Steps.propTypes = {
	  steps: _shapes.stepsShape.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var _textValues;
	
	  var textValues = (_textValues = {}, _defineProperty(_textValues, _constants.STEPS.barber, ownProps.barberName), _defineProperty(_textValues, _constants.STEPS.service, ownProps.serviceName), _defineProperty(_textValues, _constants.STEPS.time, ownProps.reservationTime), _textValues);
	
	  return {
	    steps: (0, _steps.generateSteps)(textValues, ownProps.params, ownProps.urlPattern),
	    textValues: textValues
	  };
	};
	
	exports.default = (0, _compose3.default)(_WithBarberShortName2.default, _WithServiceName2.default, _WithReservationTime2.default, (0, _reactRedux.connect)(mapStateToProps))(Steps);

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThrottledButton = function ThrottledButton(props) {
	  return _react2.default.createElement('button', props);
	};
	
	var DEFAULT_TIMEOUT = 1000;
	
	exports.default = (0, _compose3.default)((0, _withState3.default)('isInternallyDisabled', 'setIsInternallyDisabled', false), (0, _withHandlers3.default)({
	  onClick: function onClick(props) {
	    return function () {
	      props.setIsInternallyDisabled(true);
	      props.onClick.apply(props, arguments);
	
	      var debounceTime = props.timeout || DEFAULT_TIMEOUT;
	      setTimeout(function () {
	        props.setIsInternallyDisabled(false);
	      }, debounceTime);
	    };
	  }
	}), (0, _withProps3.default)(function (props) {
	  return {
	    disabled: props.disabled || props.isInternallyDisabled
	  };
	}))(ThrottledButton);

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(5);
	
	var _momentTimezone = __webpack_require__(67);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _WithApplePay = __webpack_require__(274);
	
	var _WithApplePay2 = _interopRequireDefault(_WithApplePay);
	
	var _helpers = __webpack_require__(7);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WaitingListLink = function WaitingListLink(_ref) {
	  var to = _ref.to,
	      hasApplePay = _ref.hasApplePay,
	      service = _ref.service,
	      date = _ref.date,
	      time = _ref.time,
	      timezone = _ref.timezone,
	      barber = _ref.barber,
	      from = _ref.from,
	      shop = _ref.shop;
	
	  var proceedToCheckout = function proceedToCheckout() {
	    var isApplePay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return function () {
	      _BookingAnalytics2.default.proceedToCheckout(_extends({}, from === 'barber' ? { barber: barber && barber.toJS() } : { service: service }, {
	        date: date,
	        time: _momentTimezone2.default.tz(time, timezone).format('h:mmA'),
	        isApplePay: isApplePay,
	        hasApplePay: hasApplePay,
	        waitingList: true,
	        shop: shop
	      }));
	
	      return true;
	    };
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'layout layout--auto layout--center u-mt' },
	    _react2.default.createElement(
	      'div',
	      { className: 'layout__item' },
	      _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          onClick: proceedToCheckout(),
	          to: to,
	          className: 'c-btn c-btn--primary c-btn--small'
	        },
	        'Put me on a waiting list'
	      )
	    ),
	    hasApplePay && false && /* TODO: Reenable applePay link */
	    _react2.default.createElement(
	      'div',
	      { className: 'layout__item' },
	      _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          onClick: proceedToCheckout(true),
	          to: (0, _helpers.extendLocation)(to, { query: { applePay: true } }),
	          className: 'c-btn c-btn--default c-btn--small'
	        },
	        _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.APPLE, size: 'large' }),
	        ' Put me on a waiting list'
	      )
	    )
	  );
	};
	WaitingListLink.propTypes = {
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    pathname: _propTypes2.default.string,
	    query: _propTypes2.default.object
	  })]).isRequired,
	  from: _propTypes2.default.string.isRequired,
	  hasApplePay: _propTypes2.default.bool.isRequired,
	  service: _propTypes2.default.string.isRequired,
	  barber: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
	  shop: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
	  date: _propTypes2.default.string.isRequired,
	  time: _propTypes2.default.string.isRequired,
	  timezone: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _WithApplePay2.default)(WaitingListLink);

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _yelp_fullcolor_outline2x = __webpack_require__(1840);
	
	var _yelp_fullcolor_outline2x2 = _interopRequireDefault(_yelp_fullcolor_outline2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YelpRating = function (_Component) {
	  _inherits(YelpRating, _Component);
	
	  function YelpRating(props) {
	    _classCallCheck(this, YelpRating);
	
	    var _this = _possibleConstructorReturn(this, (YelpRating.__proto__ || Object.getPrototypeOf(YelpRating)).call(this, props));
	
	    _this.updateFromProps = _this.updateFromProps.bind(_this);
	    _this.updateFromProps(props);
	    return _this;
	  }
	
	  _createClass(YelpRating, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.updateFromProps(nextProps);
	    }
	  }, {
	    key: 'updateFromProps',
	    value: function updateFromProps(props) {
	      try {
	        var roundedToHalf = Math.round(props.rating * 2) / 2;
	        // eslint-disable-next-line global-require,import/no-dynamic-require
	        this.imageRating = __webpack_require__(817)("./yelp-" + roundedToHalf + '.png');
	        this.yelpUrl = 'https://www.yelp.com/biz/' + props.yelpId;
	      } catch (e) {
	        // do nothing
	      }
	    }
	
	    /**
	      if you want to link to yelp business page
	       <a target="_blank" href={this.yelpUrl} >
	        <img className={this.props.class} src={this.imageRating} />&nbsp;
	        <img className={this.props.class} src={this.yelpLogo} />
	      </a>
	    */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = (0, _classnames2.default)('c-yelp-rating', this.props.className);
	
	      if (this.props.rating === 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement('img', { src: this.imageRating, alt: '' }),
	        '\xA0',
	        _react2.default.createElement('img', { src: _yelp_fullcolor_outline2x2.default, alt: '' })
	      );
	    }
	  }]);
	
	  return YelpRating;
	}(_react.Component);
	
	YelpRating.propTypes = {
	  rating: _propTypes2.default.number,
	  className: _propTypes2.default.string
	};
	YelpRating.defaultProps = {
	  rating: null,
	  className: ''
	};
	
	exports.default = YelpRating;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _actions = __webpack_require__(94);
	
	var _CampaignUnsubscribe = __webpack_require__(926);
	
	var _CampaignUnsubscribe2 = _interopRequireDefault(_CampaignUnsubscribe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CampaignUnsubscribeContainer = (0, _compose3.default)(_reactRouter.withRouter, (0, _withState3.default)('phone', 'setPhone', ''), (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    isFetching: state.confirmation.get('isFetching'),
	    errorMessage: state.confirmation.get('errorMessage'),
	    successMessage: state.confirmation.get('successMessage'),
	    ownerType: ownProps.params.ownerType,
	    ownerId: ownProps.params.ownerId,
	    customerId: ownProps.params.customerId
	  };
	}, { campaignUnsubscribe: _actions.campaignUnsubscribe }), (0, _withHandlers3.default)({
	  onSubmit: function onSubmit(props) {
	    return function (e) {
	      e.preventDefault();
	      return props.campaignUnsubscribe(props.ownerType, props.ownerId, props.phone);
	    };
	  },
	  setPhoneValue: function setPhoneValue(_ref) {
	    var setPhone = _ref.setPhone;
	    return function (value) {
	      return setPhone(value);
	    };
	  }
	}), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    if (this.props.customerId) {
	      this.props.campaignUnsubscribe(this.props.ownerType, this.props.ownerId, this.props.customerId);
	    }
	  }
	}))(_CampaignUnsubscribe2.default);
	
	exports.default = CampaignUnsubscribeContainer;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(49);
	
	var _actions = __webpack_require__(94);
	
	var _ConfirmBarber = __webpack_require__(927);
	
	var _ConfirmBarber2 = _interopRequireDefault(_ConfirmBarber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConfirmBarberContainer = function (_Component) {
	  _inherits(ConfirmBarberContainer, _Component);
	
	  function ConfirmBarberContainer() {
	    _classCallCheck(this, ConfirmBarberContainer);
	
	    return _possibleConstructorReturn(this, (ConfirmBarberContainer.__proto__ || Object.getPrototypeOf(ConfirmBarberContainer)).apply(this, arguments));
	  }
	
	  _createClass(ConfirmBarberContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.confirmBarber();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_ConfirmBarber2.default, {
	        isFetching: this.props.isFetching,
	        successMessage: this.props.successMessage,
	        errorMessage: this.props.errorMessage
	      });
	    }
	  }]);
	
	  return ConfirmBarberContainer;
	}(_react.Component);
	
	ConfirmBarberContainer.propTypes = {
	  confirmBarber: _propTypes2.default.func.isRequired,
	  isFetching: _propTypes2.default.bool,
	  successMessage: _propTypes2.default.string,
	  errorMessage: _propTypes2.default.string
	};
	ConfirmBarberContainer.defaultProps = {
	  isFetching: false,
	  successMessage: '',
	  errorMessage: ''
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isFetching: state.confirmation.get('isFetching'),
	    errorMessage: state.confirmation.get('errorMessage'),
	    successMessage: state.confirmation.get('successMessage')
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	  return (0, _redux.bindActionCreators)({
	    confirmBarber: _actions.confirmBarber.bind(null, ownProps.params.shopId, ownProps.params.barberId)
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConfirmBarberContainer);

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actions = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RemoveFromWaitingListLink = function RemoveFromWaitingListLink(_ref) {
	  var isFetching = _ref.isFetching,
	      successMessage = _ref.successMessage;
	
	  var message = function () {
	    if (isFetching) {
	      return 'Removing customer from waiting list... Please wait...';
	    }
	    return successMessage;
	  }();
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-text-center' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'c-heading u-mv+' },
	      'Remove customer from waiting list'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-heading--large' },
	      message
	    )
	  );
	};
	
	RemoveFromWaitingListLink.propTypes = {
	  isFetching: _propTypes2.default.bool,
	  successMessage: _propTypes2.default.string
	};
	RemoveFromWaitingListLink.defaultProps = {
	  isFetching: false,
	  successMessage: ''
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state) {
	  return {
	    isFetching: state.confirmation.get('isFetching'),
	    errorMessage: state.confirmation.get('errorMessage'),
	    successMessage: state.confirmation.get('successMessage')
	  };
	}, { removeCustomerFromWaitingList: _actions.removeCustomerFromWaitingList }), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    this.props.removeCustomerFromWaitingList(this.props.params.customerId);
	  }
	}))(RemoveFromWaitingListLink);

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _over2 = __webpack_require__(1494);
	
	var _over3 = _interopRequireDefault(_over2);
	
	var _merge3 = __webpack_require__(1492);
	
	var _merge4 = _interopRequireDefault(_merge3);
	
	var _partialRight2 = __webpack_require__(1495);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(49);
	
	var _reactRouter = __webpack_require__(5);
	
	var _WithValidatePassword = __webpack_require__(1000);
	
	var _WithValidatePassword2 = _interopRequireDefault(_WithValidatePassword);
	
	var _ResetPassword = __webpack_require__(928);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _actions = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResetPasswordContainer = function (_Component) {
	  _inherits(ResetPasswordContainer, _Component);
	
	  function ResetPasswordContainer(props) {
	    _classCallCheck(this, ResetPasswordContainer);
	
	    var _this = _possibleConstructorReturn(this, (ResetPasswordContainer.__proto__ || Object.getPrototypeOf(ResetPasswordContainer)).call(this, props));
	
	    _this.state = {
	      password: { value: '' },
	      repeatPassword: { value: '', error: '' },
	      valid: false
	    };
	
	    _this.handlePasswordChange = (0, _over3.default)([(0, _partialRight3.default)(_this.handleInputChange, 'password').bind(_this), _this.props.validatePassword]);
	    _this.handleRepeatPasswordChange = (0, _partialRight3.default)(_this.handleInputChange, 'repeatPassword').bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResetPasswordContainer, [{
	    key: 'comparePasswords',
	    value: function comparePasswords() {
	      if (this.state.password.value !== this.state.repeatPassword.value) return 'Passwords don\'t match!';
	
	      return '';
	    }
	  }, {
	    key: 'validatePasswords',
	    value: function validatePasswords(state) {
	      var repeatPasswordError = this.comparePasswords();
	      var valid = !repeatPasswordError;
	
	      var newState = (0, _merge4.default)(state, {
	        repeatPassword: { error: repeatPasswordError },
	        valid: valid
	      });
	
	      return newState;
	    }
	  }, {
	    key: 'handleInputChange',
	    value: function handleInputChange(e, field) {
	      var nextState = (0, _merge4.default)(this.state, _defineProperty({}, field, { value: e.target.value }));
	
	      this.setState(this.validatePasswords(nextState));
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	      this.props.resetPassword(this.state.password.value);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_ResetPassword2.default, {
	        passwordValue: this.state.password.value,
	        repeatPasswordValue: this.state.repeatPassword.value,
	        onPasswordChange: this.handlePasswordChange,
	        onRepeatPasswordChange: this.handleRepeatPasswordChange,
	        repeatPasswordError: this.state.repeatPassword.error,
	        onSubmit: this.handleSubmit,
	        valid: this.state.valid,
	        errorMessage: this.props.errorMessage,
	        successMessage: this.props.successMessage,
	        isFetching: this.props.isFetching,
	        validatePassword: this.props.validatePassword,
	        validatePasswordWarning: this.props.validatePasswordWarning
	      });
	    }
	  }]);
	
	  return ResetPasswordContainer;
	}(_react.Component);
	
	ResetPasswordContainer.propTypes = {
	  resetPassword: _propTypes2.default.func.isRequired,
	  isFetching: _propTypes2.default.bool,
	  errorMessage: _propTypes2.default.string,
	  successMessage: _propTypes2.default.string,
	  validatePassword: _propTypes2.default.func.isRequired,
	  validatePasswordWarning: _propTypes2.default.string.isRequired
	};
	ResetPasswordContainer.defaultProps = {
	  isFetching: false,
	  successMessage: '',
	  errorMessage: ''
	};
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isFetching: state.confirmation.get('isFetching'),
	    errorMessage: state.confirmation.get('errorMessage'),
	    successMessage: state.confirmation.get('successMessage')
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	  return (0, _redux.bindActionCreators)({
	    resetPassword: _actions.resetPassword.bind(null, ownProps.params.token)
	  }, dispatch);
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _WithValidatePassword2.default)(ResetPasswordContainer);

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BarberVerifyEmail = exports.CustomerVerifyEmail = undefined;
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _VerifyEmail = __webpack_require__(929);
	
	var _VerifyEmail2 = _interopRequireDefault(_VerifyEmail);
	
	var _actions = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VerifyEmailContainer = function VerifyEmailContainer(verifyEmail) {
	  return (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	    return {
	      isFetching: state.confirmation.get('isFetching'),
	      errorMessage: state.confirmation.get('errorMessage'),
	      successMessage: state.confirmation.get('successMessage'),
	      token: ownProps.params.token
	    };
	  }, { verifyEmail: verifyEmail }), (0, _lifecycle3.default)({
	    componentDidMount: function componentDidMount() {
	      this.props.verifyEmail(this.props.token);
	    }
	  }))(_VerifyEmail2.default);
	};
	
	exports.default = VerifyEmailContainer;
	var CustomerVerifyEmail = exports.CustomerVerifyEmail = VerifyEmailContainer(_actions.verifyCustomerEmail);
	var BarberVerifyEmail = exports.BarberVerifyEmail = VerifyEmailContainer(_actions.verifyBarberEmail);

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _actions = __webpack_require__(94);
	
	var _selectors = __webpack_require__(21);
	
	var _WaitingListBook = __webpack_require__(930);
	
	var _WaitingListBook2 = _interopRequireDefault(_WaitingListBook);
	
	var _redirectWhenPropAvailable = __webpack_require__(1002);
	
	var _redirectWhenPropAvailable2 = _interopRequireDefault(_redirectWhenPropAvailable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)((0, _reactRedux.connect)(function (state) {
	  return {
	    appointmentId: (0, _selectors.getAppointmentId)(state)
	  };
	}, { bookAppointmentTimeSlot: _actions.bookAppointmentTimeSlot }), _reactRouter.withRouter, (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    this.props.bookAppointmentTimeSlot(this.props.params);
	  }
	}), (0, _redirectWhenPropAvailable2.default)('appointmentId', function (props) {
	  return '/view-reservation/' + (0, _get3.default)(props, 'appointmentId');
	}))(_WaitingListBook2.default);

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Field = __webpack_require__(264);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CampaignUnsubscribe = function CampaignUnsubscribe(_ref) {
	  var isFetching = _ref.isFetching,
	      successMessage = _ref.successMessage,
	      errorMessage = _ref.errorMessage,
	      customerId = _ref.customerId,
	      onSubmit = _ref.onSubmit,
	      setPhoneValue = _ref.setPhoneValue,
	      phone = _ref.phone;
	  return _react2.default.createElement(
	    'div',
	    null,
	    !successMessage && !customerId && _react2.default.createElement(
	      'form',
	      { className: 'layout layout--flush layout--center', onSubmit: onSubmit },
	      _react2.default.createElement(
	        'h3',
	        { className: 'c-heading--huge u-text-left u-mt+ u-mb' },
	        'Please enter your phone number'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-3/4' },
	        _react2.default.createElement(_Field2.default, {
	          id: 'phone',
	          label: 'Phone number',
	          type: 'tel',
	          placeholder: 'Enter phone number',
	          required: true,
	          value: phone,
	          onChange: setPhoneValue
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-1/4 u-text-left u-mt--' },
	        _react2.default.createElement(
	          'button',
	          { className: 'c-btn c-btn--default u-ph-', disabled: !phone },
	          'Submit'
	        )
	      )
	    ),
	    isFetching && _react2.default.createElement(
	      'div',
	      { className: 'c-heading--large u-mt+' },
	      'Unsubscribing... Please wait...'
	    ),
	    !isFetching && errorMessage && _react2.default.createElement(
	      'div',
	      { className: 'c-heading--large u-co-red u-mt+' },
	      errorMessage
	    ),
	    !isFetching && successMessage && _react2.default.createElement(
	      'div',
	      { className: 'c-heading--large u-mt+' },
	      successMessage
	    )
	  );
	};
	CampaignUnsubscribe.propTypes = {
	  isFetching: _propTypes2.default.bool,
	  successMessage: _propTypes2.default.string,
	  errorMessage: _propTypes2.default.string,
	  customerId: _propTypes2.default.string,
	  onSubmit: _propTypes2.default.func.isRequired,
	  setPhoneValue: _propTypes2.default.func.isRequired,
	  phone: _propTypes2.default.string
	};
	CampaignUnsubscribe.defaultProps = {
	  isFetching: false,
	  successMessage: '',
	  errorMessage: '',
	  customerId: '',
	  phone: ''
	};
	
	exports.default = CampaignUnsubscribe;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmBarber = function ConfirmBarber(_ref) {
	  var isFetching = _ref.isFetching,
	      successMessage = _ref.successMessage,
	      errorMessage = _ref.errorMessage;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-text-center' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'c-heading u-mv+' },
	      'Confirm professional'
	    ),
	    isFetching ? _react2.default.createElement(
	      'div',
	      { className: 'c-heading--large' },
	      'Confirming professional... Please wait...'
	    ) : _react2.default.createElement(
	      'div',
	      { className: 'c-heading--large' },
	      successMessage || errorMessage
	    )
	  );
	};
	ConfirmBarber.propTypes = {
	  isFetching: _propTypes2.default.bool,
	  successMessage: _propTypes2.default.string,
	  errorMessage: _propTypes2.default.string
	};
	ConfirmBarber.defaultProps = {
	  isFetching: false,
	  successMessage: '',
	  errorMessage: ''
	};
	
	exports.default = ConfirmBarber;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Field = __webpack_require__(264);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResetPassword = function ResetPassword(_ref) {
	  var passwordValue = _ref.passwordValue,
	      repeatPasswordValue = _ref.repeatPasswordValue,
	      repeatPasswordError = _ref.repeatPasswordError,
	      onPasswordChange = _ref.onPasswordChange,
	      onRepeatPasswordChange = _ref.onRepeatPasswordChange,
	      onSubmit = _ref.onSubmit,
	      valid = _ref.valid,
	      isFetching = _ref.isFetching,
	      successMessage = _ref.successMessage,
	      errorMessage = _ref.errorMessage,
	      validatePasswordWarning = _ref.validatePasswordWarning;
	  return _react2.default.createElement(
	    'div',
	    { className: 'o-wrapper o-wrapper--small' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'c-heading u-text-center u-mt+ u-mb' },
	      'Reset Password'
	    ),
	    _react2.default.createElement(
	      'form',
	      {
	        onSubmit: onSubmit,
	        hidden: isFetching || successMessage || errorMessage
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-mb- u-ph' },
	        'The password must be at least 8 characters long and include at least one letter and number.'
	      ),
	      _react2.default.createElement(_Field2.default, {
	        id: 'password',
	        name: 'pass',
	        className: 'u-mb',
	        type: 'password',
	        label: 'Enter password',
	        value: passwordValue,
	        errorMessage: validatePasswordWarning,
	        error: !!validatePasswordWarning,
	        onChange: onPasswordChange,
	        required: true
	      }),
	      _react2.default.createElement(_Field2.default, {
	        id: 'repeatpassword',
	        name: 'repeatpass',
	        className: 'u-mb+',
	        type: 'password',
	        label: 'Repeat password',
	        value: repeatPasswordValue,
	        errorMessage: repeatPasswordError,
	        error: !!repeatPasswordError,
	        onChange: onRepeatPasswordChange,
	        required: true
	      }),
	      _react2.default.createElement(
	        'button',
	        {
	          type: 'submit',
	          className: 'c-btn c-btn--secondary',
	          style: { margin: 'auto' },
	          disabled: !valid
	        },
	        'Reset password',
	        valid
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-heading--large' },
	      successMessage || errorMessage
	    )
	  );
	};
	ResetPassword.propTypes = {
	  passwordValue: _propTypes2.default.string,
	  repeatPasswordValue: _propTypes2.default.string,
	  repeatPasswordError: _propTypes2.default.string,
	  onPasswordChange: _propTypes2.default.func,
	  onRepeatPasswordChange: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  valid: _propTypes2.default.bool,
	  isFetching: _propTypes2.default.bool,
	  successMessage: _propTypes2.default.string,
	  errorMessage: _propTypes2.default.string,
	  validatePasswordWarning: _propTypes2.default.string.isRequired
	};
	ResetPassword.defaultProps = {
	  passwordValue: '',
	  repeatPasswordValue: '',
	  repeatPasswordError: '',
	  onPasswordChange: null,
	  onRepeatPasswordChange: null,
	  onSubmit: null,
	  valid: false,
	  isFetching: false,
	  successMessage: '',
	  errorMessage: ''
	};
	
	exports.default = ResetPassword;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VerifyEmail = function VerifyEmail(_ref) {
	  var isFetching = _ref.isFetching,
	      successMessage = _ref.successMessage,
	      errorMessage = _ref.errorMessage;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-text-center' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'c-heading u-mv+' },
	      'Verify email'
	    ),
	    isFetching ? _react2.default.createElement(
	      'div',
	      { className: 'c-heading--large' },
	      'Verifying email... Please wait...'
	    ) : _react2.default.createElement(
	      'div',
	      { className: 'c-heading--large' },
	      successMessage || errorMessage
	    )
	  );
	};
	VerifyEmail.propTypes = {
	  isFetching: _propTypes2.default.bool,
	  successMessage: _propTypes2.default.string,
	  errorMessage: _propTypes2.default.string
	};
	VerifyEmail.defaultProps = {
	  isFetching: false,
	  successMessage: '',
	  errorMessage: ''
	};
	
	exports.default = VerifyEmail;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSpinkit = __webpack_require__(90);
	
	var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);
	
	var _Title = __webpack_require__(114);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WaitingListBook = function WaitingListBook() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-text-center u-pt++' },
	    _react2.default.createElement(
	      _Title2.default,
	      null,
	      'Book appointment'
	    ),
	    'Booking appointment...',
	    _react2.default.createElement(_reactSpinkit2.default, { className: 'u-co-teal-blue u-mt-', noFadeIn: true })
	  );
	};
	
	exports.default = WaitingListBook;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = confirmationReducer;
	
	var _immutable = __webpack_require__(66);
	
	var _constants = __webpack_require__(10);
	
	var initialState = (0, _immutable.fromJS)({
	  errorMessage: null,
	  successMessage: null,
	  isFetching: false
	});
	
	function confirmationReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.VERIFY_EMAIL:
	    case _constants.CONFIRM_BARBER:
	    case _constants.VERIFY_PASSWORD:
	    case _constants.REMOVE_CUSTOMER_FROM_WAITING_LIST:
	    case _constants.CAMPAIGN_UNSUBSCRIBE:
	      return state.set('isFetching', true);
	
	    case _constants.VERIFY_PASSWORD_SUCCESS:
	    case _constants.USER_TOKEN_SUCCESS:
	    case _constants.REMOVE_CUSTOMER_FROM_WAITING_LIST_SUCCESS:
	    case _constants.CONFIRM_BARBER_SUCCESS:
	    case _constants.CAMPAIGN_UNSUBSCRIBE_SUCCESS:
	      return state.withMutations(function (s) {
	        return s.set('successMessage', action.payload).set('errorMessage', false).set('isFetching', false);
	      });
	
	    case _constants.VERIFY_PASSWORD_ERROR:
	    case _constants.USER_TOKEN_ERROR:
	    case _constants.CAMPAIGN_UNSUBSCRIBE_ERROR:
	      return state.withMutations(function (s) {
	        return s.set('errorMessage', action.payload).set('isFetching', false);
	      });
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchDaysOff = undefined;
	
	var _constants = __webpack_require__(10);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestDaysOff = function requestDaysOff(id) {
	  return {
	    type: _constants.REQUEST_DAYS_OFF,
	    payload: id
	  };
	};
	
	var receiveDaysOff = function receiveDaysOff(payload) {
	  return {
	    type: _constants.RECEIVE_DAYS_OFF,
	    payload: payload
	  };
	};
	
	var fetchDaysOff = exports.fetchDaysOff = function fetchDaysOff(barber) {
	  var id = barber.get('id');
	  return function (dispatch) {
	    dispatch(requestDaysOff(id));
	    var url = _config2.default.url + '/barber/' + id + '/days-off';
	    return fetch(url).then(_helpers.checkStatus).then(function (daysOff) {
	      return dispatch(receiveDaysOff(daysOff));
	    });
	  };
	};
	
	exports.default = fetchDaysOff;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	exports.default = daysOffReducer;
	
	var _immutable = __webpack_require__(66);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InitialState = (0, _immutable.Record)({
	  items: [],
	  isFetching: false,
	  updatedAt: null
	});
	
	var initialState = new InitialState();
	
	function daysOffReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.REQUEST_DAYS_OFF:
	      return state.set('isFetching', true).set('items', []).set('updatedAt', Date.now());
	
	    case _constants.RECEIVE_DAYS_OFF:
	      {
	        if ((0, _isEmpty3.default)(action.payload)) return state.set('isFetching', false);
	
	        return state.withMutations(function (s) {
	          return s.set('items', action.payload).set('isFetching', false).set('updatedAt', Date.now());
	        });
	      }
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _ShopMainLayout = __webpack_require__(160);
	
	var _ShopMainLayout2 = _interopRequireDefault(_ShopMainLayout);
	
	var _WithBarberUrlPattern = __webpack_require__(987);
	
	var _WithBarberUrlPattern2 = _interopRequireDefault(_WithBarberUrlPattern);
	
	var _Barbers = __webpack_require__(194);
	
	var _Barbers2 = _interopRequireDefault(_Barbers);
	
	var _Services = __webpack_require__(268);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _MakeReservation = __webpack_require__(163);
	
	var _MakeReservation2 = _interopRequireDefault(_MakeReservation);
	
	var _helpers = __webpack_require__(7);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (urlPattern) {
	  var urls = (0, _helpers.getBarberUrls)(urlPattern);
	
	  // Put component in variable to prevent re-rendering
	  var BarberServices = (0, _WithBarberUrlPattern2.default)(_Services2.default);
	  var DynamicBarbers = (0, _withHandlers3.default)({
	    onBarberClick: function onBarberClick() {
	      return function (e, barber, shop) {
	        _BookingAnalytics2.default.selectBarber(barber, { shop: shop });
	      };
	    }
	  })((0, _WithBarberUrlPattern2.default)(_Barbers2.default));
	
	  return _react2.default.createElement(
	    _reactRouter.Route,
	    { component: (0, _WithBarberUrlPattern2.default)(_ShopMainLayout2.default) },
	    _react2.default.createElement(_reactRouter.Route, { path: urls.barbers, component: DynamicBarbers }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: urls.services,
	      component: BarberServices,
	      ignoreScrollBehavior: true
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: urls.pickTime,
	      component: BarberServices,
	      ignoreScrollBehavior: true
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: urls.makeReservation,
	      component: (0, _WithBarberUrlPattern2.default)(_MakeReservation2.default)
	    }),
	    _react2.default.createElement(_reactRouter.Redirect, {
	      from: urls.makeReservation + '/**',
	      to: urls.makeReservation
	    })
	  );
	};

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(49);
	
	var _FetchOnMount = __webpack_require__(134);
	
	var _FetchOnMount2 = _interopRequireDefault(_FetchOnMount);
	
	var _Choose = __webpack_require__(938);
	
	var _Choose2 = _interopRequireDefault(_Choose);
	
	var _actions = __webpack_require__(64);
	
	var _helpers = __webpack_require__(7);
	
	var _selectors = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    allowBookWithAnyBarber: (0, _selectors.getAllowBookWithAnyBarber)(state, ownProps.params.shopRoute),
	    generateUrlString: function generateUrlString(urlPattern) {
	      return (0, _helpers.generateUrlString)({ shopRoute: ownProps.params.shopRoute }, urlPattern);
	    }
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	  return (0, _redux.bindActionCreators)({
	    fetchData: _actions.fetchShop.bind(null, ownProps.params.shopRoute)
	  }, dispatch);
	};
	
	exports.default = (0, _compose3.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _FetchOnMount2.default)(_Choose2.default);

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _WithServicesUrlPattern = __webpack_require__(997);
	
	var _WithServicesUrlPattern2 = _interopRequireDefault(_WithServicesUrlPattern);
	
	var _ShopMainLayout = __webpack_require__(160);
	
	var _ShopMainLayout2 = _interopRequireDefault(_ShopMainLayout);
	
	var _ServicesContainer = __webpack_require__(943);
	
	var _ServicesContainer2 = _interopRequireDefault(_ServicesContainer);
	
	var _Barber = __webpack_require__(941);
	
	var _Barber2 = _interopRequireDefault(_Barber);
	
	var _MakeReservation = __webpack_require__(163);
	
	var _MakeReservation2 = _interopRequireDefault(_MakeReservation);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (urlPattern) {
	  var urls = (0, _helpers.getServiceUrls)(urlPattern);
	
	  // Put component in variable to prevent rerendering
	  var ServiceBarbers = (0, _WithServicesUrlPattern2.default)(_Barber2.default);
	
	  return _react2.default.createElement(
	    _reactRouter.Route,
	    { component: (0, _WithServicesUrlPattern2.default)(_ShopMainLayout2.default) },
	    _react2.default.createElement(_reactRouter.Route, {
	      path: urls.services,
	      component: (0, _WithServicesUrlPattern2.default)(_ServicesContainer2.default)
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: urls.barbers,
	      component: ServiceBarbers,
	      ignoreScrollBehavior: true
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: urls.pickTime,
	      component: ServiceBarbers,
	      ignoreScrollBehavior: true
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: urls.makeReservation,
	      component: (0, _WithServicesUrlPattern2.default)(_MakeReservation2.default)
	    }),
	    _react2.default.createElement(_reactRouter.Redirect, {
	      from: urls.makeReservation + '/**',
	      to: urls.makeReservation
	    })
	  );
	};

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _ShopMainLayout = __webpack_require__(160);
	
	var _ShopMainLayout2 = _interopRequireDefault(_ShopMainLayout);
	
	var _WithTimeUrlPattern = __webpack_require__(999);
	
	var _WithTimeUrlPattern2 = _interopRequireDefault(_WithTimeUrlPattern);
	
	var _PickTime = __webpack_require__(947);
	
	var _PickTime2 = _interopRequireDefault(_PickTime);
	
	var _DynamicBarbers = __webpack_require__(946);
	
	var _DynamicBarbers2 = _interopRequireDefault(_DynamicBarbers);
	
	var _Services = __webpack_require__(948);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _MakeReservation = __webpack_require__(163);
	
	var _MakeReservation2 = _interopRequireDefault(_MakeReservation);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (urlPattern) {
	  var urls = (0, _helpers.getTimeUrls)(urlPattern);
	
	  return _react2.default.createElement(
	    _reactRouter.Route,
	    { component: (0, _WithTimeUrlPattern2.default)(_ShopMainLayout2.default) },
	    _react2.default.createElement(_reactRouter.Route, {
	      path: urls.pickTime,
	      component: (0, _WithTimeUrlPattern2.default)(_PickTime2.default),
	      ignoreScrollBehavior: true
	    }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: urls.barbers, component: (0, _WithTimeUrlPattern2.default)(_DynamicBarbers2.default) },
	      _react2.default.createElement(_reactRouter.Route, {
	        path: urls.services,
	        component: (0, _WithTimeUrlPattern2.default)(_Services2.default),
	        ignoreScrollBehavior: true
	      })
	    ),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: urls.makeReservation,
	      component: (0, _WithTimeUrlPattern2.default)(_MakeReservation2.default)
	    }),
	    _react2.default.createElement(_reactRouter.Redirect, {
	      from: urls.makeReservation + '/**',
	      to: urls.makeReservation
	    })
	  );
	};

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Subtitle = __webpack_require__(113);
	
	var _Subtitle2 = _interopRequireDefault(_Subtitle);
	
	var _ChooseBox = __webpack_require__(939);
	
	var _ChooseBox2 = _interopRequireDefault(_ChooseBox);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Choose = function Choose(_ref) {
	  var generateUrlString = _ref.generateUrlString,
	      allowBookWithAnyBarber = _ref.allowBookWithAnyBarber;
	
	  var barberRoute = generateUrlString(_config2.default.urlPatterns.barber);
	  var serviceRoute = generateUrlString(_config2.default.urlPatterns.service);
	  var timeRoute = generateUrlString(_config2.default.urlPatterns.time);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Subtitle2.default,
	      null,
	      'I want to...'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'layout' },
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up' },
	        _react2.default.createElement(
	          _ChooseBox2.default,
	          { to: barberRoute, onClick: function onClick() {
	              _BookingAnalytics2.default.chooseProfessional();
	            } },
	          'Choose a professional'
	        )
	      ),
	      allowBookWithAnyBarber && _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up' },
	        _react2.default.createElement(
	          _ChooseBox2.default,
	          { to: serviceRoute, onClick: function onClick() {
	              _BookingAnalytics2.default.chooseService();
	            } },
	          'Choose a service'
	        )
	      ),
	      false && allowBookWithAnyBarber && _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up' },
	        _react2.default.createElement(
	          _ChooseBox2.default,
	          { to: timeRoute },
	          'Choose a time'
	        )
	      )
	    )
	  );
	};
	Choose.propTypes = {
	  generateUrlString: _propTypes2.default.func.isRequired,
	  allowBookWithAnyBarber: _propTypes2.default.bool.isRequired
	};
	
	exports.default = Choose;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChooseBox = function ChooseBox(_ref) {
	  var to = _ref.to,
	      children = _ref.children,
	      onClick = _ref.onClick;
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { className: 'c-select-box', to: to, onClick: onClick },
	    _react2.default.createElement(
	      'div',
	      { className: 'u-fill-parent u-text-center u-bg-white' },
	      _react2.default.createElement(
	        'div',
	        { className: 'o-tableize o-tableize--full o-tableize--fixed o-tableize--middle u-fill-parent' },
	        _react2.default.createElement(
	          'div',
	          { className: 'o-tableize__cell u-1/1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'c-heading c-heading--huge c-heading--underline-center' },
	            children
	          )
	        )
	      )
	    )
	  );
	};
	ChooseBox.propTypes = {
	  to: _propTypes2.default.string,
	  children: _propTypes2.default.node.isRequired,
	  onClick: _propTypes2.default.func
	};
	ChooseBox.defaultProps = {
	  to: '',
	  onClick: function onClick() {
	    return true;
	  }
	};
	
	exports.default = ChooseBox;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _ShopMainLayout = __webpack_require__(160);
	
	var _ShopMainLayout2 = _interopRequireDefault(_ShopMainLayout);
	
	var _Choose = __webpack_require__(935);
	
	var _Choose2 = _interopRequireDefault(_Choose);
	
	var _BarberRoutes = __webpack_require__(934);
	
	var _BarberRoutes2 = _interopRequireDefault(_BarberRoutes);
	
	var _ServicesRoutes = __webpack_require__(936);
	
	var _ServicesRoutes2 = _interopRequireDefault(_ServicesRoutes);
	
	var _TimeRoutes = __webpack_require__(937);
	
	var _TimeRoutes2 = _interopRequireDefault(_TimeRoutes);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _reactRouter.Route,
	    { path: 'book' },
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { component: _ShopMainLayout2.default },
	      _react2.default.createElement(_reactRouter.Route, {
	        component: _Choose2.default,
	        path: (0, _helpers.generateUrlString)({ shopRoute: '' }, _config2.default.urlPatterns.booking)
	      })
	    ),
	    (0, _BarberRoutes2.default)(_config2.default.urlPatterns.barber),
	    (0, _ServicesRoutes2.default)(_config2.default.urlPatterns.service),
	    (0, _TimeRoutes2.default)(_config2.default.urlPatterns.time),
	    _config2.default.bookingFallbackRedirects.map(function (redirectProps) {
	      return _react2.default.createElement(_reactRouter.Redirect, Object.assign({}, redirectProps, { key: redirectProps.from }));
	    })
	  );
	};

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AddScrollHeight = __webpack_require__(263);
	
	var _AddScrollHeight2 = _interopRequireDefault(_AddScrollHeight);
	
	var _Barbers = __webpack_require__(944);
	
	var _Barbers2 = _interopRequireDefault(_Barbers);
	
	var _PickTime = __webpack_require__(468);
	
	var _PickTime2 = _interopRequireDefault(_PickTime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DynamicBarbers = function DynamicBarbers(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Barbers2.default, props),
	    _react2.default.createElement(
	      _AddScrollHeight2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'c-second-layer' },
	        _react2.default.createElement(_PickTime2.default, Object.assign({}, props, { autoHeight: true, from: 'barber' }))
	      )
	    )
	  );
	};
	
	exports.default = DynamicBarbers;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _NextLink = __webpack_require__(908);
	
	var _NextLink2 = _interopRequireDefault(_NextLink);
	
	var _Services = __webpack_require__(296);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Services = function Services(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Services2.default, props),
	    props.nextLink && _react2.default.createElement(_NextLink2.default, { to: props.nextLink, onNextClick: props.onNextClick })
	  );
	};
	Services.propTypes = {
	  nextLink: _propTypes2.default.string,
	  onNextClick: _propTypes2.default.func.isRequired
	};
	Services.defaultProps = {
	  nextLink: ''
	};
	
	exports.default = Services;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _actions = __webpack_require__(64);
	
	var _selectors = __webpack_require__(11);
	
	var _helpers = __webpack_require__(7);
	
	var _actions2 = __webpack_require__(117);
	
	var _hoc = __webpack_require__(297);
	
	var _Services = __webpack_require__(942);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	var _selectors2 = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetchData = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(null, { fetchServices: _actions2.fetchServices, fetchShop: _actions.fetchShop }), (0, _withHandlers3.default)({
	  fetchData: function fetchData(props) {
	    return function () {
	      return props.fetchShop(props.params.shopRoute).then(function () {
	        return props.fetchServices(props.params.shopRoute, props.params.barberRoute, props.params, props.urlPattern);
	      });
	    };
	  }
	}));
	
	var generateUrl = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    shop: (0, _selectors.getShopByRoute)(state, ownProps.params.shopRoute),
	    allowMultipleServices: (0, _selectors.getAllowMultipleServices)(state, ownProps.params.shopRoute),
	    getServiceNames: function getServiceNames(serviceId) {
	      return (0, _selectors2.getServiceName)(state, serviceId);
	    }
	  };
	}), (0, _withHandlers3.default)({
	  generateUrlString: function generateUrlString(props) {
	    return function (params) {
	      return (0, _helpers.generateUrlString)(_extends({}, props.params, params), props.urlPattern);
	    };
	  }
	}), (0, _withState3.default)('selectedIds', 'setSelectedService', ''), (0, _withState3.default)('nextLink', 'setNextLink', ''), (0, _withHandlers3.default)({
	  onServiceClick: function onServiceClick(props) {
	    return function (id) {
	      return function (e) {
	        var serviceId = function () {
	          if (!props.allowMultipleServices) return id;
	          if (!props.selectedIds) return id;
	
	          return (0, _helpers.toggleItemInArray)(props.selectedIds.split(';'), id).join(';');
	        }();
	
	        props.setSelectedService(function () {
	          return serviceId;
	        });
	
	        var nextLink = props.generateUrlString({ serviceId: serviceId });
	
	        // No need to show next link if only one service can be booked at a time
	        if (!props.allowMultipleServices) {
	          e.preventDefault();
	
	          return props.router.push(nextLink);
	        }
	
	        props.setNextLink(function () {
	          return nextLink;
	        });
	
	        return true;
	      };
	    };
	  }
	}));
	
	exports.default = (0, _compose3.default)(fetchData, generateUrl, _hoc.commonServicesProvider, (0, _withHandlers3.default)({
	  onNextClick: function onNextClick(props) {
	    return function () {
	      _BookingAnalytics2.default.selectService(props.getServiceNames(props.selectedIds), { shop: props.shop });
	    };
	  }
	}))(_Services2.default);

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _Barbers = __webpack_require__(194);
	
	var _Barbers2 = _interopRequireDefault(_Barbers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BarbersContainer = (0, _compose3.default)(_reactRouter.withRouter, (0, _withHandlers3.default)({
	  onBarberClick: function onBarberClick(props) {
	    return function (e, _barber, _shop, barberLink) {
	      e.preventDefault();
	      props.router.replace(barberLink);
	    };
	  }
	}))(_Barbers2.default);
	
	exports.default = BarbersContainer;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(49);
	
	var _FetchOnMount = __webpack_require__(134);
	
	var _FetchOnMount2 = _interopRequireDefault(_FetchOnMount);
	
	var _Barbers = __webpack_require__(403);
	
	var _Barbers2 = _interopRequireDefault(_Barbers);
	
	var _actions = __webpack_require__(64);
	
	var _selectors = __webpack_require__(11);
	
	var _actions2 = __webpack_require__(99);
	
	var _actions3 = __webpack_require__(92);
	
	var _selectors2 = __webpack_require__(951);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    barbers: (0, _selectors2.getAvailableTimeBarbers)(state, ownProps.params),
	    shop: (0, _selectors.getShopByRoute)(state, ownProps.params.shopRoute),
	    generateUrlString: function generateUrlString(params) {
	      return (0, _helpers.generateUrlString)(_extends({}, ownProps.params, params), ownProps.urlPattern);
	    }
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	  var parsedTime = (0, _helpers.parseTimeSlug)((0, _get3.default)(ownProps, 'params.reservationTime'));
	  var startDay = parsedTime && parsedTime.format(_config2.default.apiDateFormat);
	
	  return (0, _redux.bindActionCreators)({
	    fetchShop: _actions.fetchShop.bind(null, ownProps.params.shopRoute, ownProps.urlPattern),
	    fetchAvailability: _actions2.fetchShopAvailability.bind(null, ownProps.params.shopRoute, startDay),
	    fetchBarbers: _actions3.fetchBarbers.bind(null, ownProps.params.shopRoute, ownProps.params, ownProps.urlPattern)
	  }, dispatch);
	};
	
	var fetchData = (0, _withHandlers3.default)({
	  fetchData: function fetchData(props) {
	    return function () {
	      return props.fetchShop().then(function () {
	        return props.fetchAvailability();
	      }).then(function () {
	        return props.fetchBarbers();
	      });
	    };
	  }
	});
	
	exports.default = (0, _compose3.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), fetchData, _FetchOnMount2.default)(_Barbers2.default);

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Barbers = __webpack_require__(945);
	
	var _Barbers2 = _interopRequireDefault(_Barbers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DynamicBarbers = function DynamicBarbers(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Barbers2.default, props),
	    props.children
	  );
	};
	DynamicBarbers.propTypes = {
	  children: _propTypes2.default.node
	};
	DynamicBarbers.defaultProps = {
	  children: null
	};
	
	exports.default = DynamicBarbers;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pickBy2 = __webpack_require__(105);
	
	var _pickBy3 = _interopRequireDefault(_pickBy2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(49);
	
	var _momentTimezone = __webpack_require__(67);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _selectors = __webpack_require__(71);
	
	var _actions = __webpack_require__(99);
	
	var _PickTime = __webpack_require__(949);
	
	var _PickTime2 = _interopRequireDefault(_PickTime);
	
	var _actions2 = __webpack_require__(64);
	
	var _selectors2 = __webpack_require__(11);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shouldFetchNextUnfetchedDay = function shouldFetchNextUnfetchedDay(props, nextDay) {
	  if (props.isFetching) return false;
	  if ((0, _momentTimezone2.default)(props.nextUnfetchedDay).week() - (0, _momentTimezone2.default)(nextDay || props.activeDay).week() > 1) return false;
	  return props.shouldLoadTimesForInterval(props.nextUnfetchedDay);
	};
	
	var fetchData = (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    this.props.clearBarberAvailability();
	    this.props.fetchShop().then(function () {
	      return _this.props.fetchAvailability((0, _momentTimezone2.default)());
	    }).catch(_helpers.nullFunc);
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if (shouldFetchNextUnfetchedDay(this.props)) {
	      this.props.fetchAvailability((0, _momentTimezone2.default)(this.props.nextUnfetchedDay));
	    }
	  }
	});
	
	var slideChangeHandlers = (0, _withHandlers3.default)({
	  onDateSliderBeforeChange: function onDateSliderBeforeChange(props) {
	    return function (previousIndex, nextIndex) {
	      var nextDay = (0, _momentTimezone2.default)().add(nextIndex, 'days');
	      if (nextIndex > previousIndex && shouldFetchNextUnfetchedDay(props, nextDay)) {
	        props.fetchAvailability(props.nextUnfetchedDay);
	      }
	    };
	  },
	
	  onDateSliderAfterChange: function onDateSliderAfterChange(props) {
	    return function (index) {
	      var weekDay = (0, _momentTimezone2.default)(props.activeDay).day();
	      var activeDay = (0, _momentTimezone2.default)().add(index, 'days').day(weekDay).format(_config2.default.apiDateFormat);
	
	      props.setActiveDay(activeDay);
	    };
	  }
	});
	
	var selectedTimeUrlState = (0, _compose3.default)((0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    selectedTime: (0, _selectors.getActiveTime)(state),
	    nextLink: (0, _selectors.getNextLink)(state, ownProps.generateUrlString)
	  };
	}, { setSelectedTime: _actions.setActiveTime }), (0, _withHandlers3.default)({
	  setTime: function setTime(props) {
	    return function (item) {
	      return function () {
	        var reservationTime = (0, _momentTimezone2.default)(item.time).format(_config2.default.timeSlugFormat);
	        props.setSelectedTime(reservationTime);
	      };
	    };
	  }
	}));
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var timezone = (0, _selectors2.getShopTimezone)(state, ownProps.params.shopRoute);
	
	  return {
	    shopId: (0, _selectors2.getShopId)(state, ownProps.params.shopRoute),
	    serviceId: _constants.ANY_SERVICE,
	    activeDay: state.times.activeDay,
	    times: (0, _selectors.getActiveDayTimes)(state, timezone),
	    noTimesAvailable: (0, _selectors.getNoTimesAvailable)(state),
	    days: (0, _selectors.getDays)(state),
	    shouldLoadTimesForInterval: _selectors.shouldLoadTimesForInterval.bind(null, state),
	    nextUnfetchedDay: (0, _selectors.getNextUnfetchedDay)(state),
	    isFetching: state.times.get('isFetching'),
	    timezone: timezone,
	    generateUrlString: function generateUrlString(params) {
	      return (0, _helpers.generateUrlString)(_extends({
	        shopRoute: ownProps.params.shopRoute
	      }, (0, _pickBy3.default)(params)), ownProps.urlPattern);
	    }
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	  return (0, _redux.bindActionCreators)({
	    fetchShop: _actions2.fetchShop.bind(null, ownProps.params.shopRoute, ownProps.urlPattern),
	    fetchAvailability: _actions.fetchShopAvailability.bind(null, ownProps.params.shopRoute),
	    clearBarberAvailability: _actions.clearBarberAvailability,
	    setActiveDay: _actions.setActiveDay
	  }, dispatch);
	};
	
	exports.default = (0, _compose3.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), fetchData, selectedTimeUrlState, slideChangeHandlers)(_PickTime2.default);

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _defaultProps2 = __webpack_require__(1744);
	
	var _defaultProps3 = _interopRequireDefault(_defaultProps2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _hoc = __webpack_require__(297);
	
	var _selectors = __webpack_require__(27);
	
	var _actions = __webpack_require__(117);
	
	var _helpers = __webpack_require__(7);
	
	var _Services = __webpack_require__(950);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetchData = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(null, { fetchServices: _actions.fetchServices }), (0, _withHandlers3.default)({
	  fetchData: function fetchData(props) {
	    return function () {
	      return props.fetchServices(props.params.shopRoute, props.params.barberRoute, props.params, props.urlPattern);
	    };
	  }
	}));
	
	var fetchDataOnBarberChange = (0, _withPropsOnChange3.default)(function (props, nextProps) {
	  return props.params.barberRoute !== nextProps.params.barberRoute;
	}, function (props) {
	  props.fetchData();
	});
	
	var generateUrl = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    allowMultipleServices: (0, _selectors.getAllowMultipleServices)(state, ownProps.params.barberRoute, ownProps.params.shopRoute)
	  };
	}), (0, _withHandlers3.default)({
	  generateUrlString: function generateUrlString(props) {
	    return function (params) {
	      return (0, _helpers.generateUrlString)(_extends({}, props.params, params), props.urlPattern);
	    };
	  }
	}), (0, _withState3.default)('selectedIds', 'setSelectedService', ''), (0, _withState3.default)('nextLink', 'setNextLink', ''), (0, _withHandlers3.default)({
	  onServiceClick: function onServiceClick(props) {
	    return function (id) {
	      return function () {
	        var serviceId = function () {
	          if (!props.allowMultipleServices) return id;
	          if (!props.selectedIds) return id;
	
	          return (0, _helpers.toggleItemInArray)(props.selectedIds.split(';'), id).join(';');
	        }();
	
	        props.setSelectedService(function () {
	          return serviceId;
	        });
	        props.setNextLink(function () {
	          return props.generateUrlString({ serviceId: serviceId });
	        });
	      };
	    };
	  }
	}));
	
	exports.default = (0, _compose3.default)(fetchData, fetchDataOnBarberChange, generateUrl, _hoc.commonServicesProvider, (0, _defaultProps3.default)({
	  autoHeight: true
	}))(_Services2.default);

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(5);
	
	var _Subtitle = __webpack_require__(113);
	
	var _Subtitle2 = _interopRequireDefault(_Subtitle);
	
	var _DateTimePicker = __webpack_require__(298);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PickTime = function PickTime(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pos-relative' },
	    _react2.default.createElement(
	      _Subtitle2.default,
	      null,
	      'Choose date & time'
	    ),
	    _react2.default.createElement(_DateTimePicker2.default, props),
	    props.nextLink && _react2.default.createElement(
	      'div',
	      { className: 'u-text-center' },
	      _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          to: props.nextLink,
	          className: 'c-btn c-btn--primary u-mt'
	        },
	        'Next'
	      )
	    )
	  );
	};
	PickTime.propTypes = {
	  nextLink: _propTypes2.default.string
	};
	PickTime.defaultProps = {
	  nextLink: ''
	};
	
	exports.default = PickTime;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _WithAutoHeight = __webpack_require__(427);
	
	var _WithAutoHeight2 = _interopRequireDefault(_WithAutoHeight);
	
	var _AddScrollHeight = __webpack_require__(263);
	
	var _AddScrollHeight2 = _interopRequireDefault(_AddScrollHeight);
	
	var _ReserveLink = __webpack_require__(413);
	
	var _ReserveLink2 = _interopRequireDefault(_ReserveLink);
	
	var _Services = __webpack_require__(296);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Services = function Services(props) {
	  return _react2.default.createElement(
	    _AddScrollHeight2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'c-second-layer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'o-wrapper o-wrapper--page u-pt' },
	        _react2.default.createElement(_Services2.default, Object.assign({}, props, { nested: true })),
	        props.nextLink && _react2.default.createElement(_ReserveLink2.default, { to: props.nextLink })
	      )
	    )
	  );
	};
	Services.propTypes = {
	  nextLink: _propTypes2.default.string
	};
	Services.defaultProps = {
	  nextLink: ''
	};
	
	exports.default = (0, _WithAutoHeight2.default)(Services);

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAvailableTimeBarbers = undefined;
	
	var _indexOf2 = __webpack_require__(584);
	
	var _indexOf3 = _interopRequireDefault(_indexOf2);
	
	var _filter2 = __webpack_require__(175);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _selectors = __webpack_require__(27);
	
	var _selectors2 = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line import/prefer-default-export
	var getAvailableTimeBarbers = exports.getAvailableTimeBarbers = function getAvailableTimeBarbers(state, _ref) {
	  var barberRoute = _ref.barberRoute,
	      shopRoute = _ref.shopRoute,
	      reservationTime = _ref.reservationTime;
	
	  var selected = (0, _selectors2.getSelectedTimeBarberRoute)(state, reservationTime);
	  return (0, _filter3.default)((0, _selectors.getBarbers)(state, { shopRoute: shopRoute, barberRoute: barberRoute }), function (barber) {
	    return (0, _indexOf3.default)(selected, barber.route) > -1;
	  });
	};

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchExtension = undefined;
	
	var _history = __webpack_require__(201);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _constants = __webpack_require__(416);
	
	var _constants2 = __webpack_require__(10);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestExtensionAction = function requestExtensionAction(idOrRoute) {
	  return {
	    type: _constants.LOAD_EXTENSION,
	    payload: idOrRoute
	  };
	}; /* eslint-disable import/prefer-default-export */
	
	
	var receiveExtensionAction = function receiveExtensionAction(extension) {
	  return {
	    type: _constants.LOAD_EXTENSION_SUCCESS,
	    payload: extension
	  };
	};
	
	var errorExtensionAction = function errorExtensionAction(error, idOrRoute) {
	  return {
	    type: _constants.LOAD_EXTENSION_ERROR,
	    payload: { error: error, idOrRoute: idOrRoute }
	  };
	};
	
	var errorRedirectAction = function errorRedirectAction() {
	  return {
	    type: _constants2.BAD_ROUTE,
	    payload: '/404'
	  };
	};
	
	var redirectIfOldBrandRoute = function redirectIfOldBrandRoute(idOrRoute, isBrandPageLookup) {
	  return function (extension) {
	    if (extension && isBrandPageLookup && extension.route !== idOrRoute) {
	      _history.history.replace('/brands/' + extension.route);
	      return false;
	    }
	    return extension;
	  };
	};
	
	var fetchExtension = exports.fetchExtension = function fetchExtension(idOrRoute) {
	  var isBrandPageLookup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  return function (dispatch) {
	    var isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(idOrRoute);
	    if (!idOrRoute || isUuid) {
	      return false;
	    }
	
	    dispatch(requestExtensionAction(idOrRoute));
	
	    var url = _config2.default.url + '/extension/' + idOrRoute + '?include=brand';
	    return fetch(url, {
	      method: 'GET',
	      headers: {
	        Accept: 'application/json',
	        'Content-Type': 'application/json'
	      }
	    }).then(_helpers.checkStatus).then(redirectIfOldBrandRoute(idOrRoute, isBrandPageLookup)).then(function (extension) {
	      if (extension === false) return;
	      dispatch(receiveExtensionAction(extension));
	    }).catch(function (error) {
	      errorExtensionAction(error, idOrRoute);
	      if (error.code === 'ServiceUnavailable') {
	        (0, _helpers.handleRequestError)(dispatch)(error);
	      } else if (isBrandPageLookup) {
	        dispatch(errorRedirectAction());
	      }
	    });
	  };
	};

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduce2 = __webpack_require__(245);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _assoc2 = __webpack_require__(355);
	
	var _assoc3 = _interopRequireDefault(_assoc2);
	
	var _redux = __webpack_require__(49);
	
	var _functional = __webpack_require__(1237);
	
	var _constants = __webpack_require__(416);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var byId = function byId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case _constants.LOAD_EXTENSION_SUCCESS:
	      return (0, _assoc3.default)(payload.id, payload, state);
	    default:
	      return state;
	  }
	};
	
	var byShopId = function byShopId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _ref2 = arguments[1];
	  var type = _ref2.type,
	      payload = _ref2.payload;
	
	  switch (type) {
	    case _constants.LOAD_EXTENSION_SUCCESS:
	      return (0, _reduce3.default)(function (prevState, shopId) {
	        return (0, _assoc3.default)(shopId, payload, prevState);
	      }, state, payload.shops);
	    default:
	      return state;
	  }
	};
	
	var byRoute = function byRoute() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _ref3 = arguments[1];
	  var type = _ref3.type,
	      payload = _ref3.payload;
	
	  switch (type) {
	    case _constants.LOAD_EXTENSION_SUCCESS:
	      return (0, _assoc3.default)(payload.route, payload, state);
	    default:
	      return state;
	  }
	};
	
	var list = function list() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var _ref4 = arguments[1];
	  var type = _ref4.type,
	      payload = _ref4.payload;
	
	  switch (type) {
	    case _constants.LOAD_EXTENSION_SUCCESS:
	      return (0, _functional.addItem)(payload.id, state);
	    default:
	      return state;
	  }
	};
	
	var busy = function busy() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var _ref5 = arguments[1];
	  var type = _ref5.type;
	
	  switch (type) {
	    case _constants.LOAD_EXTENSION:
	      return true;
	    case _constants.LOAD_EXTENSION_ERROR:
	    case _constants.LOAD_EXTENSION_SUCCESS:
	      return false;
	    default:
	      return state;
	  }
	};
	
	var loadingList = function loadingList() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var _ref6 = arguments[1];
	  var type = _ref6.type,
	      payload = _ref6.payload;
	
	  switch (type) {
	    case _constants.LOAD_EXTENSION:
	      return [].concat(_toConsumableArray(state), [payload]);
	    case _constants.LOAD_EXTENSION_ERROR:
	      return state.filter(function (item) {
	        return item !== payload.idOrRoute;
	      });
	    case _constants.LOAD_EXTENSION_SUCCESS:
	      return state.filter(function (item) {
	        return ![payload.id, payload.route].concat(_toConsumableArray(payload.shops)).includes(item);
	      });
	    default:
	      return state;
	  }
	};
	
	var error = function error() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var _ref7 = arguments[1];
	  var type = _ref7.type,
	      payload = _ref7.payload;
	
	  switch (type) {
	    case _constants.LOAD_EXTENSION_ERROR:
	      return payload.error;
	    case _constants.LOAD_EXTENSION_SUCCESS:
	      return null;
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  byId: byId,
	  byShopId: byShopId,
	  byRoute: byRoute,
	  list: list,
	  busy: busy,
	  loadingList: loadingList,
	  error: error
	});

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GiftCard = __webpack_require__(960);
	
	var _GiftCard2 = _interopRequireDefault(_GiftCard);
	
	var _GiftCardMessage = __webpack_require__(975);
	
	var _GiftCardMessage2 = _interopRequireDefault(_GiftCardMessage);
	
	var _OrderInformation = __webpack_require__(967);
	
	var _OrderInformation2 = _interopRequireDefault(_OrderInformation);
	
	var _StripeCheckoutButton = __webpack_require__(456);
	
	var _StripeCheckoutButton2 = _interopRequireDefault(_StripeCheckoutButton);
	
	var _ContactInformation = __webpack_require__(459);
	
	var _ContactInformation2 = _interopRequireDefault(_ContactInformation);
	
	var _ProcessingIndicator = __webpack_require__(292);
	
	var _ProcessingIndicator2 = _interopRequireDefault(_ProcessingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Checkout = function Checkout(_ref) {
	  var currency = _ref.currency,
	      gcAmount = _ref.gcAmount,
	      user = _ref.user,
	      paymentEnabled = _ref.paymentEnabled,
	      checkout = _ref.checkout;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_GiftCardMessage2.default, { className: 'u-mt u-mb' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'layout layout--flush' },
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-2/3-small-plus-and-up' },
	        _react2.default.createElement(_GiftCard2.default, null),
	        _react2.default.createElement(_ContactInformation2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-1/3-small-plus-and-up ' },
	        _react2.default.createElement(
	          'div',
	          { className: 'u-mt+ small-plus-and-up-ml+ small-plus-and-up-pl small-plus-and-up-mt0' },
	          _react2.default.createElement(_OrderInformation2.default, { gcAmount: gcAmount }),
	          _react2.default.createElement(
	            _StripeCheckoutButton2.default,
	            {
	              className: 'c-btn c-btn--primary u-1/1 u-mb-',
	              onSuccess: checkout,
	              currency: currency,
	              amount: gcAmount,
	              email: user.email,
	              disabled: !paymentEnabled
	            },
	            'Buy Now'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _ProcessingIndicator2.default,
	      null,
	      'Processing order'
	    )
	  );
	};
	
	Checkout.propTypes = {
	  currency: _propTypes2.default.string.isRequired,
	  gcAmount: _propTypes2.default.number.isRequired,
	  user: _propTypes2.default.shape({ email: _propTypes2.default.string }).isRequired,
	  paymentEnabled: _propTypes2.default.bool.isRequired,
	  checkout: _propTypes2.default.func.isRequired
	};
	
	exports.default = Checkout;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _actions = __webpack_require__(419);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	var _withGiftCardLink = __webpack_require__(272);
	
	var _withGiftCardLink2 = _interopRequireDefault(_withGiftCardLink);
	
	var _WithShopCurrency = __webpack_require__(135);
	
	var _WithShopCurrency2 = _interopRequireDefault(_WithShopCurrency);
	
	var _withGiftCardAmount = __webpack_require__(422);
	
	var _withGiftCardAmount2 = _interopRequireDefault(_withGiftCardAmount);
	
	var _withGiftCardBarber = __webpack_require__(271);
	
	var _withGiftCardBarber2 = _interopRequireDefault(_withGiftCardBarber);
	
	var _selectors = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_WithShopCurrency2.default, _WithShop2.default, _withGiftCardAmount2.default, _withGiftCardBarber2.default, _withGiftCardLink2.default, _reactRouter.withRouter, (0, _reactRedux.connect)(function (state) {
	  return {
	    user: (0, _selectors.getUser)(state),
	    formValid: (0, _selectors.getIsFormValid)(state)
	  };
	}, { buyGiftCard: _actions.buyGiftCard }), (0, _withProps3.default)(function (props) {
	  return {
	    paymentEnabled: props.formValid && !!props.shop && props.gcAmount && !!props.gcBarber
	  };
	}), (0, _withHandlers3.default)({
	  checkout: function checkout(props) {
	    return function (token) {
	      var onlyShopRoute = props.link.pathname.split('/').slice(0, 3).join('/');
	      var successUrl = onlyShopRoute + '/' + props.gcBarber.route + '/' + props.gcAmount + '/view';
	
	      if (props.location.query.brand) {
	        successUrl = successUrl + '?brand=' + props.location.query.brand;
	      }
	
	      var data = {
	        customer: props.user,
	        amount: props.gcAmount,
	        barberId: props.gcBarber ? props.gcBarber.id : null,
	        paymentToken: token.id
	      };
	
	      props.buyGiftCard(props.shop, data, successUrl);
	    };
	  }
	}));

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BarberSelectionMessage = function BarberSelectionMessage() {
	  return _react2.default.createElement(
	    "p",
	    { className: "u-text-justify u-type--semibold epsilon u-co-black-2" },
	    "By selecting your Professional, you are letting the ownership know that you would like for the purchase price of the Gift Card to be allocated to this particular Professional. By selecting \u201CAny Professional\u201D you are purchasing a general Gift Card that you will be able to use with any Professional at the shop."
	  );
	};
	
	exports.default = BarberSelectionMessage;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PickBarber = __webpack_require__(959);
	
	var _PickBarber2 = _interopRequireDefault(_PickBarber);
	
	var _GiftCardAmount = __webpack_require__(965);
	
	var _GiftCardAmount2 = _interopRequireDefault(_GiftCardAmount);
	
	var _BarberSelectionMessage = __webpack_require__(956);
	
	var _BarberSelectionMessage2 = _interopRequireDefault(_BarberSelectionMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GiftCard = function GiftCard(_ref) {
	  var barbers = _ref.barbers,
	      gcBarber = _ref.gcBarber,
	      onSelectedBarberChange = _ref.onSelectedBarberChange,
	      gcAmount = _ref.gcAmount,
	      onGcAmountChange = _ref.onGcAmountChange,
	      isCommissionShop = _ref.isCommissionShop,
	      areGcSalesDisabledForBarber = _ref.areGcSalesDisabledForBarber;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-mb- medium-and-up-mb+' },
	    !areGcSalesDisabledForBarber && _react2.default.createElement(
	      'div',
	      { className: 'c-heading c-heading--huge u-mb u-pt-- u-show-for-large-and-up' },
	      'Pick a Professional'
	    ),
	    !areGcSalesDisabledForBarber && _react2.default.createElement(
	      'div',
	      {
	        className: 'c-heading c-heading--huge u-mb- u-text-center u-hide-for-large-and-up'
	      },
	      'Pick a Professional'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'layout' },
	      isCommissionShop && !areGcSalesDisabledForBarber && _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-1/1' },
	        _react2.default.createElement(_BarberSelectionMessage2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-1/1 u-1/2-medium-and-up' },
	        !areGcSalesDisabledForBarber && _react2.default.createElement(_PickBarber2.default, {
	          barbers: barbers,
	          selectedBarber: gcBarber,
	          onSelectedBarberChange: onSelectedBarberChange
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-1/1 u-1/2-medium-and-up' },
	        _react2.default.createElement(_GiftCardAmount2.default, {
	          gcAmount: gcAmount,
	          onGcAmountChange: onGcAmountChange
	        })
	      )
	    )
	  );
	};
	
	GiftCard.propTypes = {
	  gcBarber: _propTypes2.default.shape({
	    id: _propTypes2.default.string,
	    firstName: _propTypes2.default.string,
	    lastName: _propTypes2.default.string
	  }),
	  barbers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.string,
	    firstName: _propTypes2.default.string,
	    lastName: _propTypes2.default.string
	  })).isRequired,
	  onSelectedBarberChange: _propTypes2.default.func.isRequired,
	  gcAmount: _propTypes2.default.number.isRequired,
	  onGcAmountChange: _propTypes2.default.func.isRequired,
	  isCommissionShop: _propTypes2.default.bool,
	  areGcSalesDisabledForBarber: _propTypes2.default.bool.isRequired
	};
	
	GiftCard.defaultProps = {
	  isCommissionShop: false
	};
	
	GiftCard.defaultProps = {
	  gcBarber: null
	};
	
	exports.default = GiftCard;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	var _constants = __webpack_require__(10);
	
	var _withGiftCardAmount = __webpack_require__(422);
	
	var _withGiftCardAmount2 = _interopRequireDefault(_withGiftCardAmount);
	
	var _withGiftCardBarber = __webpack_require__(271);
	
	var _withGiftCardBarber2 = _interopRequireDefault(_withGiftCardBarber);
	
	var _actions = __webpack_require__(419);
	
	var _WithGiftCardUrlPattern = __webpack_require__(276);
	
	var _WithGiftCardUrlPattern2 = _interopRequireDefault(_WithGiftCardUrlPattern);
	
	var _selectors = __webpack_require__(27);
	
	var _withAreGcSalesDisabledForBarber = __webpack_require__(421);
	
	var _withAreGcSalesDisabledForBarber2 = _interopRequireDefault(_withAreGcSalesDisabledForBarber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var anyBarber = {
	  id: null,
	  firstName: 'Any',
	  lastName: 'Professional',
	  route: 'any'
	};
	
	var withBarbersProps = (0, _withProps3.default)(function (props) {
	  if (!props.shop) return {};
	
	  var barbers = props.barbers;
	  if (props.shop.kind === _constants.SHOP_TYPE.commission) {
	    barbers = [anyBarber].concat(_toConsumableArray(props.barbers));
	  }
	
	  return {
	    barbers: barbers,
	    barber: props.barber ? props.barber.toJS() : null
	  };
	});
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, _WithGiftCardUrlPattern2.default, _withGiftCardAmount2.default, _withGiftCardBarber2.default, _WithShop2.default, _withAreGcSalesDisabledForBarber2.default, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    barber: (0, _selectors.getBarberByRoute)(state, ownProps.params.barberRoute),
	    barbers: ownProps.location.query.brand ? (0, _selectors.getAllBarbersRaw)(state) : (0, _selectors.getBarbers)(state, ownProps.params)
	  };
	}, {
	  updateGcAmount: _actions.updateGcAmount,
	  updateSelectedBarber: _actions.updateSelectedBarber
	}), withBarbersProps, (0, _withProps3.default)(function (props) {
	  return {
	    isCommissionShop: props.shop && props.shop.kind === _constants.SHOP_TYPE.commission
	  };
	}), (0, _withHandlers3.default)({
	  onGcAmountChange: function onGcAmountChange(props) {
	    return function (amount) {
	      props.updateGcAmount(Number(amount));
	    };
	  },
	  onSelectedBarberChange: function onSelectedBarberChange(props) {
	    return function (barber) {
	      props.updateSelectedBarber(barber);
	    };
	  }
	}), (0, _withPropsOnChange3.default)(['shop'], function (props) {
	  if (props.isCommissionShop && !props.gcBarber) {
	    props.onSelectedBarberChange(anyBarber);
	  }
	}), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    var gcAmount = Number(this.props.params.giftCardAmount);
	    if (gcAmount) {
	      this.props.updateGcAmount(gcAmount);
	    }
	
	    if (this.props.barber) {
	      this.props.onSelectedBarberChange(this.props.barber);
	    }
	  }
	}));

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
	
	
	var fullName = function fullName(barber) {
	  return barber.firstName + ' ' + barber.lastName;
	};
	
	var PickBarber = function (_Component) {
	  _inherits(PickBarber, _Component);
	
	  function PickBarber() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PickBarber);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PickBarber.__proto__ || Object.getPrototypeOf(PickBarber)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
	      var value = e.target.value;
	
	      var selectedBarber = _this.props.barbers.find(function (b) {
	        return b.route === value;
	      });
	      _this.props.onSelectedBarberChange(selectedBarber || null);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PickBarber, [{
	    key: 'renderBarbers',
	    value: function renderBarbers() {
	      var barbers = this.props.barbers;
	
	      return barbers.map(function (barber) {
	        return _react2.default.createElement(
	          'option',
	          {
	            key: barber.route,
	            value: barber.route
	          },
	          fullName(barber)
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var selectedBarber = this.props.selectedBarber;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'u-position-relative' },
	        _react2.default.createElement(
	          'select',
	          {
	            className: 'c-btn c-btn--secondary u-1/1',
	            onChange: this.onChange,
	            value: selectedBarber ? selectedBarber.route : null
	          },
	          _react2.default.createElement(
	            'option',
	            { selected: true, disabled: true },
	            'Select a Professional'
	          ),
	          this.renderBarbers()
	        )
	      );
	    }
	  }]);
	
	  return PickBarber;
	}(_react.Component);
	
	PickBarber.propTypes = {
	  selectedBarber: _propTypes2.default.shape({
	    id: _propTypes2.default.string,
	    firstName: _propTypes2.default.string,
	    lastName: _propTypes2.default.string
	  }),
	  barbers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.string,
	    firstName: _propTypes2.default.string,
	    lastName: _propTypes2.default.string
	  })).isRequired,
	  onSelectedBarberChange: _propTypes2.default.func.isRequired
	};
	
	PickBarber.defaultProps = {
	  selectedBarber: null
	};
	
	exports.default = PickBarber;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GiftCard = __webpack_require__(957);
	
	var _GiftCard2 = _interopRequireDefault(_GiftCard);
	
	var _GiftCardContainer = __webpack_require__(958);
	
	var _GiftCardContainer2 = _interopRequireDefault(_GiftCardContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _GiftCardContainer2.default)(_GiftCard2.default);

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _renderComponent2 = __webpack_require__(57);
	
	var _renderComponent3 = _interopRequireDefault(_renderComponent2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSimpleCurrency = __webpack_require__(386);
	
	var _reactSimpleCurrency2 = _interopRequireDefault(_reactSimpleCurrency);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomAmount = function CustomAmount(_ref) {
	  var onCustomGcChange = _ref.onCustomGcChange,
	      customGcAmount = _ref.customGcAmount,
	      onCustomGcSubmit = _ref.onCustomGcSubmit;
	  return _react2.default.createElement(
	    'form',
	    {
	      className: 'u-text-center layout layout--flush layout__item u-1/1 u-pl-',
	      onSubmit: onCustomGcSubmit
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'layout__item u-3/4' },
	      _react2.default.createElement(_reactSimpleCurrency2.default, {
	        className: 'c-input',
	        min: '0',
	        placeholder: 'Gift Card Amount',
	        required: true,
	        value: customGcAmount,
	        onInputChange: onCustomGcChange,
	        unit: '$'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'layout__item u-1/4' },
	      _react2.default.createElement(
	        'button',
	        { className: 'c-btn c-btn--default u-width-full', disabled: customGcAmount <= 0 },
	        'Set'
	      )
	    )
	  );
	};
	
	CustomAmount.propTypes = {
	  onCustomGcChange: _propTypes2.default.func.isRequired,
	  customGcAmount: _propTypes2.default.number.isRequired,
	  onCustomGcSubmit: _propTypes2.default.func.isRequired
	};
	
	var OpenCustomAmount = function OpenCustomAmount(_ref2) {
	  var toggleCustomGc = _ref2.toggleCustomGc,
	      hasCustomGcAmount = _ref2.hasCustomGcAmount;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-text-center layout layout--flush layout__item u-1/1 u-pl-' },
	    _react2.default.createElement(
	      'button',
	      { className: 'c-btn c-btn--default layout__item u-1/1', onClick: toggleCustomGc },
	      hasCustomGcAmount ? 'Change Amount' : 'Custom Amount'
	    )
	  );
	};
	
	OpenCustomAmount.propTypes = {
	  toggleCustomGc: _propTypes2.default.func.isRequired,
	  hasCustomGcAmount: _propTypes2.default.bool.isRequired
	};
	
	exports.default = (0, _branch3.default)(function (props) {
	  return !props.customGcOpen;
	}, (0, _renderComponent3.default)(OpenCustomAmount))(CustomAmount);

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CustomAmount = __webpack_require__(961);
	
	var _CustomAmount2 = _interopRequireDefault(_CustomAmount);
	
	var _PredefinedAmounts = __webpack_require__(964);
	
	var _PredefinedAmounts2 = _interopRequireDefault(_PredefinedAmounts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GifCardAmount = function GifCardAmount(_ref) {
	  var gcAmount = _ref.gcAmount,
	      onGcAmountChange = _ref.onGcAmountChange,
	      toggleCustomGc = _ref.toggleCustomGc,
	      customGcOpen = _ref.customGcOpen,
	      customGcAmount = _ref.customGcAmount,
	      onCustomGcChange = _ref.onCustomGcChange,
	      onCustomGcSubmit = _ref.onCustomGcSubmit,
	      predefinedAmounts = _ref.predefinedAmounts,
	      hasCustomGcAmount = _ref.hasCustomGcAmount;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-text-center layout layout--flush u--ml- large-and-up--ml' },
	    _react2.default.createElement(_PredefinedAmounts2.default, {
	      gcAmount: gcAmount,
	      onGcAmountChange: onGcAmountChange,
	      predefinedAmounts: predefinedAmounts
	    }),
	    _react2.default.createElement(_CustomAmount2.default, {
	      toggleCustomGc: toggleCustomGc,
	      customGcOpen: customGcOpen,
	      customGcAmount: customGcAmount,
	      onCustomGcChange: onCustomGcChange,
	      onCustomGcSubmit: onCustomGcSubmit,
	      hasCustomGcAmount: hasCustomGcAmount
	    })
	  );
	};
	
	GifCardAmount.propTypes = {
	  gcAmount: _propTypes2.default.number.isRequired,
	  onGcAmountChange: _propTypes2.default.func.isRequired,
	  toggleCustomGc: _propTypes2.default.func.isRequired,
	  onCustomGcChange: _propTypes2.default.func.isRequired,
	  customGcOpen: _propTypes2.default.bool.isRequired,
	  onCustomGcSubmit: _propTypes2.default.func.isRequired,
	  customGcAmount: _propTypes2.default.number.isRequired,
	  predefinedAmounts: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	  hasCustomGcAmount: _propTypes2.default.bool.isRequired
	};
	
	exports.default = GifCardAmount;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)((0, _withProps3.default)(function (props) {
	  var predefinedAmounts = [5000, 10000, 20000];
	  return {
	    predefinedAmounts: predefinedAmounts,
	    hasCustomGcAmount: props.gcAmount && !predefinedAmounts.some(function (amount) {
	      return amount === props.gcAmount;
	    })
	  };
	}), (0, _withState3.default)('customGcOpen', 'setCustomGcOpen', false), (0, _withState3.default)('customGcAmount', 'setCustomGcAmount', 0), (0, _withHandlers3.default)({
	  toggleCustomGc: function toggleCustomGc(props) {
	    return function () {
	      if (!props.customGcOpen) {
	        props.setCustomGcAmount(0);
	      }
	      props.setCustomGcOpen(!props.customGcOpen);
	    };
	  },
	  onCustomGcChange: function onCustomGcChange(props) {
	    return function (amount) {
	      props.setCustomGcAmount(Number(amount));
	    };
	  },
	  onCustomGcSubmit: function onCustomGcSubmit(props) {
	    return function (e) {
	      e.preventDefault();
	      props.onGcAmountChange(props.customGcAmount);
	      props.setCustomGcOpen(false);
	    };
	  },
	  onGcAmountChange: function onGcAmountChange(props) {
	    return function (amount) {
	      if (props.customGcOpen) {
	        props.setCustomGcOpen(false);
	      }
	
	      props.onGcAmountChange(amount);
	    };
	  }
	}));

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PredefinedAmounts = function PredefinedAmounts(_ref) {
	  var gcAmount = _ref.gcAmount,
	      onGcAmountChange = _ref.onGcAmountChange,
	      predefinedAmounts = _ref.predefinedAmounts;
	  return _react2.default.createElement(
	    'div',
	    null,
	    predefinedAmounts.map(function (amount, idx) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-pl- u-1/' + predefinedAmounts.length, key: amount },
	        _react2.default.createElement(
	          'div',
	          { className: 'c-select-btn' },
	          _react2.default.createElement('input', {
	            className: 'c-select-btn__input',
	            type: 'radio',
	            id: 'gc-amount-preset-' + idx,
	            name: 'radio-reserve',
	            onChange: function onChange() {
	              return onGcAmountChange(amount);
	            },
	            checked: amount === gcAmount
	          }),
	          _react2.default.createElement(
	            'label',
	            { className: 'c-select-btn__label c-select-btn__label_tiny', htmlFor: 'gc-amount-preset-' + idx },
	            _react2.default.createElement(
	              'div',
	              { className: 'c-heading c-heading--huge' },
	              _react2.default.createElement(
	                _Money2.default,
	                null,
	                amount
	              )
	            )
	          )
	        )
	      );
	    })
	  );
	};
	
	PredefinedAmounts.propTypes = {
	  gcAmount: _propTypes2.default.number.isRequired,
	  onGcAmountChange: _propTypes2.default.func.isRequired,
	  predefinedAmounts: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired
	};
	
	exports.default = PredefinedAmounts;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GiftCardAmount = __webpack_require__(962);
	
	var _GiftCardAmount2 = _interopRequireDefault(_GiftCardAmount);
	
	var _GiftCardAmountContainer = __webpack_require__(963);
	
	var _GiftCardAmountContainer2 = _interopRequireDefault(_GiftCardAmountContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _GiftCardAmountContainer2.default)(_GiftCardAmount2.default);

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrderInformation = function OrderInformation(_ref) {
	  var gcAmount = _ref.gcAmount;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'c-heading c-heading--huge u-mb u-pt-- u-show-for-large-and-up' },
	      'Order Information'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-heading c-heading--huge u-mb- u-text-center u-hide-for-large-and-up' },
	      'Order Information'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-order-info' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-order-info__desc' },
	        _react2.default.createElement(
	          'div',
	          { className: 'u-inline-block' },
	          'Gift Card:'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-order-info__price' },
	        _react2.default.createElement(
	          _Money2.default,
	          null,
	          gcAmount
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'c-separator u-mt u-mb- c-order-info__separator' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-pt-- u-co-black-2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'c-order-info__desc' },
	          'Total:'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-order-info__price' },
	          _react2.default.createElement(
	            _Money2.default,
	            null,
	            gcAmount
	          )
	        )
	      )
	    )
	  );
	};
	
	OrderInformation.propTypes = {
	  gcAmount: _propTypes2.default.number.isRequired
	};
	
	exports.default = OrderInformation;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _OrderInformation = __webpack_require__(966);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OrderInformation).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Checkout = __webpack_require__(954);
	
	var _Checkout2 = _interopRequireDefault(_Checkout);
	
	var _CheckoutContainer = __webpack_require__(955);
	
	var _CheckoutContainer2 = _interopRequireDefault(_CheckoutContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _CheckoutContainer2.default)(_Checkout2.default);

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Title = __webpack_require__(114);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Layout = __webpack_require__(112);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainLayout = function MainLayout(_ref) {
	  var children = _ref.children,
	      shopName = _ref.shopName;
	  return _react2.default.createElement(
	    _Layout2.default,
	    { shopLayout: true },
	    _react2.default.createElement(
	      _Title2.default,
	      null,
	      shopName
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-pt' },
	      children
	    )
	  );
	};
	
	MainLayout.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  shopName: _propTypes2.default.string
	};
	
	MainLayout.defaultProps = {
	  shopName: ''
	};
	
	exports.default = MainLayout;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	var _WithLoader = __webpack_require__(195);
	
	var _WithLoader2 = _interopRequireDefault(_WithLoader);
	
	var _actions = __webpack_require__(64);
	
	var _FetchOnMount = __webpack_require__(134);
	
	var _FetchOnMount2 = _interopRequireDefault(_FetchOnMount);
	
	var _selectors = __webpack_require__(27);
	
	var _extensions = __webpack_require__(95);
	
	var _WithGiftCardUrlPattern = __webpack_require__(276);
	
	var _WithGiftCardUrlPattern2 = _interopRequireDefault(_WithGiftCardUrlPattern);
	
	var _actions2 = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state, ownProps) {
	  var shopId = ownProps.shop ? ownProps.shop.id : null;
	  return {
	    barbers: (0, _selectors.getBarbers)(state, ownProps.params),
	    extension: (0, _extensions.getExtensionByShopId)(state, shopId)
	  };
	}
	
	var mapDispatchToProps = {
	  fetchShopAction: _actions.fetchShop,
	  fetchBarbersAction: _actions2.fetchBarbers,
	  fetchBrandBarbersAction: _actions2.fetchBrandBarbers
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, _WithShop2.default, _WithGiftCardUrlPattern2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _withProps3.default)(function (props) {
	  if (props.extension && props.location.query.brand) {
	    return { shopName: props.extension.name };
	  }
	  if (props.shop) {
	    return { shopName: props.shop.name };
	  }
	  return { shopName: '' };
	}), (0, _withHandlers3.default)({
	  fetchShop: function fetchShop(props) {
	    return function () {
	      return props.fetchShopAction(props.params.shopRoute, _config2.default.urlPatterns.giftCard);
	    };
	  },
	  fetchBarbers: function fetchBarbers(props) {
	    return function () {
	      if (props.location.query.brand) {
	        return props.fetchBrandBarbersAction(props.location.query.brand, props.params, _config2.default.urlPatterns.giftCard);
	      }
	
	      return props.fetchBarbersAction(props.params.shopRoute, props.params, _config2.default.urlPatterns.giftCard);
	    };
	  }
	}), (0, _withHandlers3.default)({
	  fetchData: function fetchData(props) {
	    return function () {
	      return props.fetchShop().then(props.fetchBarbers);
	    };
	  }
	}), _FetchOnMount2.default, _WithLoader2.default);

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GiftCardLayout = __webpack_require__(969);
	
	var _GiftCardLayout2 = _interopRequireDefault(_GiftCardLayout);
	
	var _GiftCardLayoutContainer = __webpack_require__(970);
	
	var _GiftCardLayoutContainer2 = _interopRequireDefault(_GiftCardLayoutContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _GiftCardLayoutContainer2.default)(_GiftCardLayout2.default);

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GiftCardLink = function GiftCardLink(_ref) {
	  var link = _ref.link,
	      className = _ref.className,
	      text = _ref.text;
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    {
	      className: (0, _classnames2.default)('c-btn c-btn--secondary c-btn--secondary-multiline u-1/1', className),
	      to: link
	    },
	    text
	  );
	};
	
	GiftCardLink.propTypes = {
	  className: _propTypes2.default.string,
	  link: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.string.isRequired
	};
	
	GiftCardLink.defaultProps = {
	  className: ''
	};
	
	exports.default = GiftCardLink;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.textDecider = undefined;
	
	var _propEq2 = __webpack_require__(755);
	
	var _propEq3 = _interopRequireDefault(_propEq2);
	
	var _always2 = __webpack_require__(354);
	
	var _always3 = _interopRequireDefault(_always2);
	
	var _ifElse2 = __webpack_require__(358);
	
	var _ifElse3 = _interopRequireDefault(_ifElse2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _withGiftCardLink = __webpack_require__(272);
	
	var _withGiftCardLink2 = _interopRequireDefault(_withGiftCardLink);
	
	var _hideWithoutGiftCardSales = __webpack_require__(270);
	
	var _hideWithoutGiftCardSales2 = _interopRequireDefault(_hideWithoutGiftCardSales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var textDecider = exports.textDecider = (0, _ifElse3.default)((0, _propEq3.default)('areGcSalesDisabledForBarber', true), (0, _always3.default)('Buy a Gift Card to use for future purchases'), (0, _always3.default)('Support us by prepaying for future services through a purchase of a Gift Card'));
	
	exports.default = (0, _compose3.default)(_hideWithoutGiftCardSales2.default, (0, _withProps3.default)(function (props) {
	  return {
	    text: textDecider(props)
	  };
	}), _withGiftCardLink2.default);

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hideWithoutGiftCardSales = __webpack_require__(270);
	
	var _hideWithoutGiftCardSales2 = _interopRequireDefault(_hideWithoutGiftCardSales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GiftCardMessage = function GiftCardMessage(_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    'p',
	    { className: (0, _classnames2.default)('u-text-justify u-type--semibold epsilon u-co-black-2', className) },
	    'Everyone can appreciate looking good and feeling good, so give yourself (or someone you love) the gift of grooming! Great for the holidays, special occasions, or any last minute gift ideas. Once you complete the purchase you will receive an email and text message with your Gift Card code that you will be able to use next time you are booking an appointment or paying at the shop.'
	  );
	};
	
	GiftCardMessage.propTypes = {
	  className: _propTypes2.default.string
	};
	
	GiftCardMessage.defaultProps = {
	  className: ''
	};
	
	exports.default = (0, _hideWithoutGiftCardSales2.default)(GiftCardMessage);

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GiftCardMessage = __webpack_require__(974);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GiftCardMessage).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _ShopMap = __webpack_require__(290);
	
	var _ShopMap2 = _interopRequireDefault(_ShopMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ViewGiftCard = function ViewGiftCard(_ref) {
	  var shop = _ref.shop,
	      giftCard = _ref.giftCard,
	      gcBarber = _ref.gcBarber,
	      brandId = _ref.brandId;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      { className: 'u-mb+ u-mt', style: { fontSize: '24px' } },
	      'Thank you for your purchase of a gift card! We can\u2019t wait to help make your gift a special experience.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-heading c-heading--huge u-mb u-pt-- u-show-for-large-and-up' },
	      'Gift Card Details'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-heading c-heading--huge u-mb- u-text-center u-hide-for-large-and-up' },
	      'Gift Card Details'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'layout layout--large u-mt+' },
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-1/2-medium-and-up' },
	        _react2.default.createElement(
	          'dl',
	          null,
	          _react2.default.createElement(
	            'dt',
	            { className: 'c-heading c-heading--huge u-line-height-normal' },
	            'Gift Card Code:'
	          ),
	          _react2.default.createElement(
	            'dd',
	            { className: 'c-heading c-heading--huge u-line-height-normal u-mb u-type--bold' },
	            giftCard.code
	          ),
	          _react2.default.createElement(
	            'dt',
	            { className: 'c-heading c-heading--huge u-line-height-normal' },
	            'Gift Card Amount:'
	          ),
	          _react2.default.createElement(
	            'dd',
	            { className: 'c-heading c-heading--huge u-line-height-normal u-mb u-type--bold' },
	            _react2.default.createElement(
	              _Money2.default,
	              null,
	              giftCard.outstandingBalance
	            )
	          ),
	          _react2.default.createElement(
	            'dt',
	            { className: 'c-heading c-heading--huge u-line-height-normal' },
	            'Professional:'
	          ),
	          _react2.default.createElement(
	            'dd',
	            { className: 'c-heading c-heading--huge u-line-height-normal u-mb u-type--bold' },
	            gcBarber.firstName,
	            ' ',
	            gcBarber.lastName
	          ),
	          !brandId && _react2.default.createElement(
	            'dt',
	            { className: 'c-heading c-heading--huge u-line-height-normal' },
	            'Shop:'
	          ),
	          !brandId && _react2.default.createElement(
	            'dd',
	            { className: 'c-heading c-heading--huge u-line-height-normal u-type--bold' },
	            shop.name
	          ),
	          !brandId && _react2.default.createElement(
	            'dt',
	            { className: 'c-heading c-heading--huge u-line-height-normal u-type--bold' },
	            shop.address
	          ),
	          !brandId && _react2.default.createElement(
	            'dd',
	            { className: 'c-heading c-heading--huge u-line-height-normal u-type--bold u-mb+' },
	            shop.zip
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-1/2-medium-and-up' },
	        shop.location && _react2.default.createElement(
	          'div',
	          { className: 'u-mb-' },
	          _react2.default.createElement(_ShopMap2.default, { name: shop.name, address: shop.address })
	        )
	      )
	    )
	  );
	};
	
	ViewGiftCard.propTypes = {
	  shop: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
	  giftCard: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
	  gcBarber: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
	  brandId: _propTypes2.default.string.isRequired
	};
	
	exports.default = ViewGiftCard;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	var _withGiftCardBarber = __webpack_require__(271);
	
	var _withGiftCardBarber2 = _interopRequireDefault(_withGiftCardBarber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, _withGiftCardBarber2.default, _WithShop2.default, (0, _reactRedux.connect)(function (state) {
	  return {
	    giftCard: state.giftCard.get('giftCard')
	  };
	}), (0, _withProps3.default)(function (props) {
	  return {
	    brandId: props.location.query.brand
	  };
	}), (0, _branch3.default)(function (props) {
	  return !props.shop || !props.giftCard;
	}, _renderNothing3.default));

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ViewGiftCard = __webpack_require__(976);
	
	var _ViewGiftCard2 = _interopRequireDefault(_ViewGiftCard);
	
	var _ViewGiftCardContainer = __webpack_require__(977);
	
	var _ViewGiftCardContainer2 = _interopRequireDefault(_ViewGiftCardContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _ViewGiftCardContainer2.default)(_ViewGiftCard2.default);

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getNextLink = undefined;
	
	var _pickBy2 = __webpack_require__(105);
	
	var _pickBy3 = _interopRequireDefault(_pickBy2);
	
	var _negate2 = __webpack_require__(238);
	
	var _negate3 = _interopRequireDefault(_negate2);
	
	var _isNil2 = __webpack_require__(234);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line import/prefer-default-export
	var getNextLink = exports.getNextLink = function getNextLink(_ref, generateUrlString, anyBarber, brand) {
	  var barberRoute = _ref.barberRoute,
	      giftCardAmount = _ref.giftCardAmount;
	
	  var query = _extends({}, anyBarber && { anyBarber: anyBarber }, brand && { brand: brand });
	
	  return {
	    pathname: generateUrlString((0, _pickBy3.default)({ giftCardAmount: giftCardAmount, barberRoute: barberRoute }, (0, _negate3.default)(_isNil3.default))),
	    query: query
	  };
	};

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = giftCardReducer;
	
	var _immutable = __webpack_require__(66);
	
	var _constants = __webpack_require__(420);
	
	var initialState = (0, _immutable.fromJS)({
	  amount: 0,
	  barber: null,
	  giftCard: null
	});
	
	function giftCardReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.UPDATE_GC_AMOUNT:
	      return state.withMutations(function (s) {
	        return s.set('amount', action.payload);
	      });
	    case _constants.UPDATE_GC_BARBER:
	      return state.withMutations(function (s) {
	        return s.set('barber', action.payload);
	      });
	    case _constants.SET_GC:
	      return state.withMutations(function (s) {
	        return s.set('giftCard', action.payload);
	      });
	    default:
	      return state;
	  }
	}

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Checkout = __webpack_require__(968);
	
	var _Checkout2 = _interopRequireDefault(_Checkout);
	
	var _ViewGiftCard = __webpack_require__(978);
	
	var _ViewGiftCard2 = _interopRequireDefault(_ViewGiftCard);
	
	var _GiftCardLayout = __webpack_require__(971);
	
	var _GiftCardLayout2 = _interopRequireDefault(_GiftCardLayout);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var urls = (0, _helpers.getGiftCardUrls)(_config2.default.urlPatterns.giftCard);
	
	var GiftCardRoutes = function GiftCardRoutes() {
	  return _react2.default.createElement(
	    _reactRouter.Route,
	    { component: _GiftCardLayout2.default },
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/gift-card/:shopRoute/:barberRoute/:giftCardAmount/view',
	      component: _ViewGiftCard2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: urls.shopUrl,
	      component: _Checkout2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: urls.barberUrl,
	      component: _Checkout2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: urls.checkoutUrl,
	      component: _Checkout2.default
	    })
	  );
	};
	
	exports.default = GiftCardRoutes;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _renderComponent2 = __webpack_require__(57);
	
	var _renderComponent3 = _interopRequireDefault(_renderComponent2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var NonOptimalStates = function NonOptimalStates(states) {
	  return _compose3.default.apply(undefined, _toConsumableArray(states.map(function (state) {
	    return (0, _branch3.default)(state.when, (0, _renderComponent3.default)(state.render));
	  })));
	};
	
	exports.default = NonOptimalStates;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lifecycle = __webpack_require__(15);
	
	var _lifecycle2 = _interopRequireDefault(_lifecycle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onUnload = (0, _lifecycle2.default)({
	  componentDidMount: function componentDidMount() {
	    if (this.props.onUnload) {
	      window.addEventListener('unload', this.props.onUnload);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.props.onUnload) {
	      this.props.onUnload();
	      window.removeEventListener('unload', this.props.onUnload);
	    }
	  }
	});
	
	exports.default = onUnload;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _reactDom = __webpack_require__(149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScrollToTop = function ScrollToTop() {
	  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  return (0, _lifecycle3.default)({
	    componentDidMount: function componentDidMount() {
	      var node = (0, _reactDom.findDOMNode)(this);
	      if (!node || this.props.kiosk) return;
	
	      // Wait for things to settle
	      setTimeout(function () {
	        return window.scrollTo(window.scrollX, node.getBoundingClientRect().top + window.scrollY + offset);
	      });
	    }
	  });
	};
	
	exports.default = ScrollToTop;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _isBoolean2 = __webpack_require__(1486);
	
	var _isBoolean3 = _interopRequireDefault(_isBoolean2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	var _actions = __webpack_require__(111);
	
	var _WithThirdPartyPromo = __webpack_require__(431);
	
	var _WithThirdPartyPromo2 = _interopRequireDefault(_WithThirdPartyPromo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = {
	  fetchThirdPartyPromotions: _actions.fetchThirdPartyPromoStatus
	};
	
	exports.default = (0, _compose3.default)(_WithThirdPartyPromo2.default, _WithShop2.default, (0, _reactRedux.connect)(null, mapDispatchToProps), (0, _withPropsOnChange3.default)(['shop'], function (props) {
	  var isPromoLoaded = (0, _isBoolean3.default)(props.thirdPartyPromo.active);
	  if (props.shop && !isPromoLoaded) {
	    props.fetchThirdPartyPromotions(props.shop.brandId, props.shop.id);
	  }
	}))((0, _renderNothing3.default)());

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _selectors = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    barberName: (0, _selectors.getBarberShortName)(state, ownProps.params.barberRoute)
	  };
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(mapStateToProps));

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _withProps3.default)({
	  urlPattern: _config2.default.urlPatterns.barber
	});

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	var _actions = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WithFetchBarbers = (0, _compose3.default)(_WithShop2.default, (0, _reactRedux.connect)(null, { fetchBarbers: _actions.fetchBarbers }), (0, _withPropsOnChange3.default)(function (props, nextProps) {
	  return (0, _get3.default)(props, 'shop.route') !== (0, _get3.default)(nextProps, 'shop.route');
	}, function (props) {
	  var shopId = (0, _get3.default)(props, 'shop.route');
	  if (shopId) {
	    props.fetchBarbers(shopId);
	  }
	}));
	
	exports.default = WithFetchBarbers;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _withProps3.default)({
	  baseUrl: '/kiosk'
	});

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withContext2 = __webpack_require__(805);
	
	var _withContext3 = _interopRequireDefault(_withContext2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WithKioskContext = (0, _withContext3.default)({ kiosk: _propTypes2.default.bool.isRequired }, function () {
	  return {
	    kiosk: true
	  };
	});
	
	exports.default = WithKioskContext;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	var _WithKioskUrlPattern = __webpack_require__(429);
	
	var _WithKioskUrlPattern2 = _interopRequireDefault(_WithKioskUrlPattern);
	
	var _helpers = __webpack_require__(7);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, _WithShop2.default, _WithKioskUrlPattern2.default, (0, _withProps3.default)(function (props) {
	  var startFromAnyBarber = (0, _get3.default)(props, 'location.query.startFromAnyBarber', false);
	  var shopRoute = (0, _get3.default)(props, 'shop.route');
	  var redirect = startFromAnyBarber ? (0, _helpers.generateUrlString)({ shopRoute: shopRoute, barberRoute: _constants.ANY_BARBER }, props.urlPattern) : (0, _helpers.generateUrlString)({ shopRoute: shopRoute }, props.urlPattern);
	
	  return { homeUrl: redirect };
	}));

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _withProps3.default)(function () {
	  return { noAutofill: true };
	});

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    reservationTime: ownProps.params.reservationTime && (0, _helpers.formatReservationTime)(ownProps.params.reservationTime, (0, _get3.default)(ownProps, 'shop.timezone'))
	  };
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, _WithShop2.default, (0, _reactRedux.connect)(mapStateToProps));

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _selectors = __webpack_require__(27);
	
	var _WithTimezone = __webpack_require__(115);
	
	var _WithTimezone2 = _interopRequireDefault(_WithTimezone);
	
	var _selectors2 = __webpack_require__(71);
	
	var _helpers = __webpack_require__(7);
	
	var _actions = __webpack_require__(42);
	
	var _selectors3 = __webpack_require__(51);
	
	var _WithFetchAvailability = __webpack_require__(275);
	
	var _WithFetchAvailability2 = _interopRequireDefault(_WithFetchAvailability);
	
	var _actions2 = __webpack_require__(99);
	
	var _WithAnyBarber = __webpack_require__(273);
	
	var _WithAnyBarber2 = _interopRequireDefault(_WithAnyBarber);
	
	var _WithKioskProp = __webpack_require__(59);
	
	var _WithKioskProp2 = _interopRequireDefault(_WithKioskProp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_WithTimezone2.default, _reactRouter.withRouter, _WithFetchAvailability2.default, _WithAnyBarber2.default, _WithKioskProp2.default, (0, _reactRedux.connect)(function (state, ownProps) {
	  var barberRoute = ownProps.params.barberRoute;
	  if (ownProps.anyBarber) {
	    barberRoute = (0, _selectors2.getActiveTimeBarber)(state);
	  }
	
	  return {
	    activeTime: (0, _helpers.parseTimeSlug)((0, _selectors2.getActiveTime)(state), ownProps.timezone),
	    barber: barberRoute && (0, _selectors.getBarberByIdOrRoute)(state, barberRoute),
	    duration: (0, _selectors3.getServiceDuration)(state, ownProps.params.serviceId)
	  };
	}, { clearBarberAvailability: _actions2.clearBarberAvailability }), (0, _withHandlers3.default)({
	  reserveTime: function reserveTime(props) {
	    return function (e, url) {
	      var barber = props.barber && props.barber.toJS();
	      if (!barber || !props.activeTime) return;
	      e.preventDefault();
	      (0, _actions.reserveTime)(barber.id, props.activeTime.toJSON(), props.duration, props.kiosk).then(function () {
	        return props.router.push(url);
	      }).catch(function (err) {
	        props.clearBarberAvailability();
	        props.fetchAvailability((0, _helpers.getAvailableTimesStartDay)(props.timezone)(props.activeTime), (0, _helpers.getAvailableTimesEndDay)(props.timezone)(props.activeTime));
	        window.swal({
	          title: 'Error!',
	          text: err.message,
	          type: 'error',
	          confirmButtonColor: '#dd6b55'
	        });
	      });
	    };
	  }
	}));

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _selectors = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    serviceDuration: (0, _selectors.getServiceDuration)(state, ownProps.params.serviceId)
	  };
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(mapStateToProps));

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _selectors = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    serviceName: (0, _selectors.getServiceName)(state, ownProps.params.serviceId)
	  };
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(mapStateToProps));

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _withProps3.default)({
	  urlPattern: _config2.default.urlPatterns.service
	});

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _selectors = __webpack_require__(11);
	
	var _selectors2 = __webpack_require__(21);
	
	var reservationSelectors = _interopRequireWildcard(_selectors2);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    backgroundImage: ownProps.backgroundImage || (0, _selectors.getImage)(state, ownProps.params.shopRoute) || reservationSelectors.getShopImage(state) || _config2.default.fallbackShopBackground
	  };
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(mapStateToProps));

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _withProps3.default)({
	  urlPattern: _config2.default.urlPatterns.time
	});

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debounce2 = __webpack_require__(124);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _actions = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withValidatePassword = (0, _compose3.default)((0, _withState3.default)('validatePasswordWarning', 'setValidatePasswordWarning', ''), (0, _withHandlers3.default)({
	  validate: function validate(props) {
	    return (0, _debounce3.default)(function (password) {
	      (0, _actions.validatePassword)(password).then(function () {
	        return props.setValidatePasswordWarning('');
	      }).catch(function () {
	        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	            warning = _ref.warning,
	            suggestions = _ref.suggestions;
	
	        return props.setValidatePasswordWarning([warning, suggestions[0]].join(' '));
	      });
	    }, 500);
	  }
	}), (0, _withHandlers3.default)({
	  validatePassword: function validatePassword(props) {
	    return function (e) {
	      return props.validate(e.target.value);
	    };
	  }
	}));
	
	exports.default = withValidatePassword;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkIfWebNotification = function checkIfWebNotification(_ref) {
	  var pathname = _ref.location.pathname;
	  return (/brands\/\S+\/notifications/.test(pathname)
	  );
	};
	
	var preventRenderForWebNotifications = (0, _compose3.default)(_reactRouter.withRouter, (0, _branch3.default)(checkIfWebNotification, _renderNothing3.default));
	
	exports.default = preventRenderForWebNotifications;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (propPath, urlFunction) {
	  return (0, _compose3.default)(_reactRouter.withRouter, (0, _lifecycle3.default)({
	    componentDidUpdate: function componentDidUpdate() {
	      if ((0, _get3.default)(this.props, propPath)) {
	        this.props.router.push(urlFunction(this.props));
	      }
	    }
	  }));
	};

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactGateway = __webpack_require__(77);
	
	var _reactModal = __webpack_require__(783);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _analytics = __webpack_require__(401);
	
	var _GlobalErrorAndRedirectionListener = __webpack_require__(265);
	
	var _GlobalErrorAndRedirectionListener2 = _interopRequireDefault(_GlobalErrorAndRedirectionListener);
	
	var _InstantExperiences = __webpack_require__(1004);
	
	var _InstantExperiences2 = _interopRequireDefault(_InstantExperiences);
	
	var _FbPixel = __webpack_require__(877);
	
	var _FbPixel2 = _interopRequireDefault(_FbPixel);
	
	var _actions = __webpack_require__(111);
	
	var _acceptCookies = __webpack_require__(262);
	
	__webpack_require__(1300);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var APP_ID = 'app';
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    // Pass app div to modal for accessibility features
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	    _reactModal2.default.getApplicationElement = function () {
	      return document.getElementById('' + APP_ID);
	    };
	    _this.onPageLoad = function () {
	      return _BookingAnalytics2.default.pageLoaded();
	    };
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.setApplePay();
	      window.addEventListener('load', this.onPageLoad);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('load', this.onPageLoad);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactGateway.GatewayProvider,
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { id: APP_ID, className: 'u-pb+ large-and-up-pb0' },
	            this.props.children,
	            _react2.default.createElement(_GlobalErrorAndRedirectionListener2.default, null)
	          ),
	          _react2.default.createElement(_reactGateway.GatewayDest, { name: 'modal' }),
	          this.props.acceptCookie && _react2.default.createElement(_analytics.Analytics, null),
	          _react2.default.createElement(_InstantExperiences2.default, null),
	          _react2.default.createElement(_FbPixel2.default, null),
	          _react2.default.createElement(_acceptCookies.AcceptCookies, null)
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	App.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  setApplePay: _propTypes2.default.func.isRequired,
	  acceptCookie: _propTypes2.default.bool.isRequired
	};
	
	
	function mapStateToProps(state) {
	  var user = void 0;
	  if (state.newCustomer) {
	    user = {
	      user_id: state.newCustomer.id,
	      email: state.newCustomer.email,
	      name: state.newCustomer.firstName + ' ' + state.newCustomer.lastName
	    };
	  }
	
	  return {
	    user: user,
	    customer: state.reservation.newCustomer,
	    acceptCookie: (0, _acceptCookies.getAcceptCookie)(state)
	  };
	}
	
	var mapDispatchToProps = {
	  setApplePay: _actions.setApplePay
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _helpers = __webpack_require__(7);
	
	var _actions = __webpack_require__(434);
	
	var _selectors = __webpack_require__(11);
	
	var _selectors2 = __webpack_require__(27);
	
	var _selectors3 = __webpack_require__(277);
	
	var _extensions = __webpack_require__(95);
	
	var _fbPixel = __webpack_require__(158);
	
	var _fbPixel2 = _interopRequireDefault(_fbPixel);
	
	var _withConsent = __webpack_require__(399);
	
	var _withConsent2 = _interopRequireDefault(_withConsent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InstantExperiences = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  var owner = (0, _selectors3.getInstantExperiencesOwner)(state);
	  var pixelId = void 0;
	  var _ownProps$params = ownProps.params,
	      brandRoute = _ownProps$params.brandRoute,
	      shopRoute = _ownProps$params.shopRoute,
	      barberRoute = _ownProps$params.barberRoute;
	
	  switch (owner) {
	    case 'brand':
	      {
	        var extension = (0, _extensions.getExtension)(state, brandRoute);
	        pixelId = (0, _get3.default)(extension, 'pixelId', null);
	        break;
	      }
	    case 'shop':
	      {
	        var shop = (0, _selectors.getShopByRoute)(state, shopRoute);
	        pixelId = (0, _get3.default)(shop, 'pixelId', null);
	        break;
	      }
	    case 'barber':
	      {
	        var barber = (0, _selectors2.getBarberByRoute)(state, barberRoute);
	        pixelId = (0, _get3.default)(barber, 'pixelId', null);
	        break;
	      }
	    default:
	      {
	        pixelId = null;
	        break;
	      }
	  }
	
	  return {
	    pixelId: pixelId,
	    instantExperiencesOwner: owner,
	    instantExperiences: (0, _selectors3.getInstantExperiences)(state)
	  };
	}, { setInstantExperiences: _actions.setInstantExperiences, setInstantExperiencesOwner: _actions.setInstantExperiencesOwner }), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    this.props.setInstantExperiences(this.props.location.query.ig_ix);
	    // Since we changed parameter name at one point on API we need to check both old and new query param
	    this.props.setInstantExperiencesOwner(this.props.location.query.ig_ix_owner || this.props.location.query.owner);
	  }
	}), _withConsent2.default, (0, _withHandlers3.default)({
	  initDeprecatedIgIx: function initDeprecatedIgIx(props) {
	    return function () {
	      props.setInstantExperiences(props.instantExperiences);
	      if (!props.instantExperiences) return;
	      _fbPixel2.default.init(true);
	      _fbPixel2.default.setPixelFor('instantExperience', _config2.default.fbPixel);
	      _fbPixel2.default.trackPageView('instantExperience');
	      if (window.extAsyncInit && window.extAsyncInit.hasRun) {
	        _fbPixel2.default.initExtensions();
	      } else {
	        window.extAsyncInit = _fbPixel2.default.initExtensions;
	      }
	    };
	  }
	}), (0, _withPropsOnChange3.default)(['pixelId', 'instantExperiences'], function (props) {
	  if (props.instantExperiences && !props.instantExperiencesOwner) {
	    props.initDeprecatedIgIx();
	    return;
	  }
	
	  if (!props.pixelId || !props.instantExperiences) {
	    _fbPixel2.default.setPixelFor('instantExperience', null);
	    return;
	  }
	
	  _fbPixel2.default.setPixelFor('instantExperience', props.pixelId);
	  _fbPixel2.default.trackPageView('instantExperience');
	}))(_helpers.nullFunc);
	
	exports.default = InstantExperiences;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(49);
	
	var _constants = __webpack_require__(435);
	
	var instantExperiences = function instantExperiences() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === _constants.SET_INSTANT_EXPERIENCES) return Boolean(payload);
	  return state;
	};
	
	var instantExperiencesOwner = function instantExperiencesOwner() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var _ref2 = arguments[1];
	  var type = _ref2.type,
	      _ref2$payload = _ref2.payload,
	      payload = _ref2$payload === undefined ? null : _ref2$payload;
	
	  if (type === _constants.SET_INSTANT_EXPERIENCES_OWNER) return payload;
	  return state;
	};
	
	exports.default = (0, _redux.combineReducers)({
	  enabled: instantExperiences,
	  owner: instantExperiencesOwner
	});

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(49);
	
	var _reactRouter = __webpack_require__(5);
	
	var _WithShopName = __webpack_require__(196);
	
	var _WithShopName2 = _interopRequireDefault(_WithShopName);
	
	var _ViewReservation = __webpack_require__(1009);
	
	var _ViewReservation2 = _interopRequireDefault(_ViewReservation);
	
	var _actions = __webpack_require__(42);
	
	var _selectors = __webpack_require__(21);
	
	var _helpers = __webpack_require__(7);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KIOSK_RESERVATION_TIMEOUT = 5000;
	var redirectToHome = (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    setTimeout(function () {
	      _this.props.router.push(_this.props.redirect);
	      _this.props.clearReservations();
	    }, KIOSK_RESERVATION_TIMEOUT);
	  }
	});
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var startFromAnyBarber = (0, _get3.default)(ownProps, 'location.query.startFromAnyBarber', false);
	  var shop = (0, _selectors.getShop)(state);
	  var redirect = startFromAnyBarber ? (0, _helpers.generateUrlString)({ shopRoute: shop.route, barberRoute: _constants.ANY_BARBER }, ownProps.urlPattern) : (0, _helpers.generateUrlString)({ shopRoute: shop.route }, ownProps.urlPattern);
	
	  return {
	    reservationError: state.reservation.error,
	    appointment: (0, _selectors.getAppointment)(state),
	    barberName: (0, _selectors.getBarberName)(state),
	    serviceName: (0, _selectors.getServiceName)(state),
	    customer: (0, _selectors.getCustomer)(state),
	    advanceCancelMins: (0, _selectors.getBarberAdvanceCancelMins)(state),
	    canCustomerCancel: (0, _selectors.getCanCustomerCancel)(state),
	    inFuture: (0, _selectors.getAppointmentInFuture)(state),
	    canceled: (0, _selectors.getAppointmentCanceled)(state),
	    redirect: redirect,
	    shop: shop
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	  return (0, _redux.bindActionCreators)({
	    fetchReservation: _actions.fetchReservation.bind(null, ownProps.params.appointmentId),
	    clearReservations: _actions.clearReservations
	  }, dispatch);
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _WithShopName2.default, redirectToHome)(_ViewReservation2.default);

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackButton = function BackButton(props) {
	  return _react2.default.createElement(
	    'button',
	    Object.assign({ type: 'button', className: 'c-back-button' }, props),
	    _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.SLIDE_ARROW_LEFT }),
	    ' Back'
	  );
	};
	BackButton.propTypes = {};
	BackButton.defaultProps = {};
	
	exports.default = BackButton;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGateway = __webpack_require__(77);
	
	var _constants = __webpack_require__(436);
	
	var _WithShopName = __webpack_require__(196);
	
	var _WithShopName2 = _interopRequireDefault(_WithShopName);
	
	var _Title = __webpack_require__(114);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _WithKioskHomeUrl = __webpack_require__(991);
	
	var _WithKioskHomeUrl2 = _interopRequireDefault(_WithKioskHomeUrl);
	
	var _Layout = __webpack_require__(112);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _passcode = __webpack_require__(198);
	
	var _passcode2 = _interopRequireDefault(_passcode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainLayout = function MainLayout(_ref) {
	  var children = _ref.children,
	      homeUrl = _ref.homeUrl,
	      shopName = _ref.shopName;
	  return _react2.default.createElement(
	    _Layout2.default,
	    { shopLayout: true, homeUrl: homeUrl, kiosk: true },
	    _react2.default.createElement(
	      _Title2.default,
	      null,
	      shopName
	    ),
	    _react2.default.createElement(_reactGateway.GatewayDest, { name: _constants.BACK_BUTTON_GATEWAY }),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-pt' },
	      _react2.default.createElement(_reactGateway.GatewayDest, { name: 'subtitle', className: 'u-show-for-large-and-up' }),
	      children
	    ),
	    _react2.default.createElement(_passcode2.default, null)
	  );
	};
	MainLayout.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  homeUrl: _propTypes2.default.string.isRequired,
	  shopName: _propTypes2.default.string
	};
	MainLayout.defaultProps = {
	  shopName: ''
	};
	
	exports.default = (0, _compose3.default)(_WithKioskHomeUrl2.default, _WithShopName2.default)(MainLayout);

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ViewReservation = __webpack_require__(457);
	
	var _ViewReservation2 = _interopRequireDefault(_ViewReservation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewReservation = function (_View) {
	  _inherits(ViewReservation, _View);
	
	  function ViewReservation() {
	    _classCallCheck(this, ViewReservation);
	
	    return _possibleConstructorReturn(this, (ViewReservation.__proto__ || Object.getPrototypeOf(ViewReservation)).apply(this, arguments));
	  }
	
	  _createClass(ViewReservation, [{
	    key: 'renderControls',
	    value: function renderControls() {
	      // eslint-disable-line class-methods-use-this
	      return null;
	    }
	  }, {
	    key: 'renderModals',
	    value: function renderModals() {
	      // eslint-disable-line class-methods-use-this
	      return null;
	    }
	  }]);
	
	  return ViewReservation;
	}(_ViewReservation2.default);
	
	exports.default = ViewReservation;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _BackButton = __webpack_require__(1007);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackButtonContainer = (0, _compose3.default)(_reactRouter.withRouter, (0, _withHandlers3.default)({
	  onClick: function onClick(props) {
	    return function () {
	      return props.router.goBack();
	    };
	  }
	}))(_BackButton2.default);
	
	exports.default = BackButtonContainer;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGateway = __webpack_require__(77);
	
	var _BackButton = __webpack_require__(1010);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _constants = __webpack_require__(436);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WithBackButton = function WithBackButton(Component) {
	  return function (props) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactGateway.Gateway,
	        { into: _constants.BACK_BUTTON_GATEWAY },
	        _react2.default.createElement(_BackButton2.default, null)
	      ),
	      _react2.default.createElement(Component, props)
	    );
	  };
	};
	
	exports.default = WithBackButton;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _compose = __webpack_require__(4);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _WithBackButton = __webpack_require__(1011);
	
	var _WithBackButton2 = _interopRequireDefault(_WithBackButton);
	
	var _WithNoAutofill = __webpack_require__(992);
	
	var _WithNoAutofill2 = _interopRequireDefault(_WithNoAutofill);
	
	var _WithKioskUrlPattern = __webpack_require__(429);
	
	var _WithKioskUrlPattern2 = _interopRequireDefault(_WithKioskUrlPattern);
	
	var _WithKioskBaseUrl = __webpack_require__(989);
	
	var _WithKioskBaseUrl2 = _interopRequireDefault(_WithKioskBaseUrl);
	
	var _WithKioskContext = __webpack_require__(990);
	
	var _WithKioskContext2 = _interopRequireDefault(_WithKioskContext);
	
	var _Kiosk = __webpack_require__(1008);
	
	var _Kiosk2 = _interopRequireDefault(_Kiosk);
	
	var _Barbers = __webpack_require__(194);
	
	var _Barbers2 = _interopRequireDefault(_Barbers);
	
	var _Services = __webpack_require__(268);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _MakeReservation = __webpack_require__(163);
	
	var _MakeReservation2 = _interopRequireDefault(_MakeReservation);
	
	var _ViewReservation = __webpack_require__(1006);
	
	var _ViewReservation2 = _interopRequireDefault(_ViewReservation);
	
	var _helpers = __webpack_require__(7);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var generateUrl = function generateUrl(params) {
	  return (0, _helpers.generateUrlString)(params, _config2.default.urlPatterns.kiosk);
	};
	
	var barberUrl = generateUrl({ shopRoute: '' });
	var serviceUrl = generateUrl({ shopRoute: '', barberRoute: '' });
	var pickTimeUrl = generateUrl({ shopRoute: '', barberRoute: '', serviceId: '' });
	
	var makeReservationUrl = generateUrl({
	  shopRoute: '',
	  barberRoute: '',
	  serviceId: '',
	  reservationTime: ''
	});
	
	// Put component in variable to prevent rerendering
	var BarberServices = (0, _compose2.default)(_WithBackButton2.default, _WithKioskUrlPattern2.default, _WithKioskContext2.default)(_Services2.default);
	var MakeReservationContainer = (0, _compose2.default)(_WithBackButton2.default, _WithKioskBaseUrl2.default, _WithKioskUrlPattern2.default, _WithNoAutofill2.default, _WithKioskContext2.default)(_MakeReservation2.default);
	var BarbersContainer = (0, _compose2.default)(_WithKioskUrlPattern2.default, _WithKioskContext2.default)(_Barbers2.default);
	
	var onChange = function onChange(prevState, nextState, replace) {
	  if ((0, _get3.default)(prevState, 'location.query.startFromAnyBarber') && !(0, _get3.default)(nextState, 'location.query.startFromAnyBarber')) {
	    var newQuery = (0, _get3.default)(nextState, 'location.query');
	    var newLocation = Object.assign({}, nextState.location, { query: _extends({}, newQuery, { startFromAnyBarber: true }) });
	    replace(newLocation);
	  }
	};
	
	var KioskRoutes = function KioskRoutes() {
	  return _react2.default.createElement(
	    _reactRouter.Route,
	    { onChange: onChange },
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { component: _Kiosk2.default },
	      _react2.default.createElement(_reactRouter.Route, { path: '/kiosk/view-reservation/:appointmentId', component: (0, _WithKioskUrlPattern2.default)(_ViewReservation2.default) }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: barberUrl,
	        component: BarbersContainer
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        name: 'services',
	        path: serviceUrl,
	        component: BarberServices,
	        ignoreScrollBehavior: true
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        name: 'picktime',
	        path: pickTimeUrl,
	        component: BarberServices,
	        ignoreScrollBehavior: true
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        name: 'reservation',
	        path: makeReservationUrl,
	        component: MakeReservationContainer
	      })
	    )
	  );
	};
	
	exports.default = KioskRoutes;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SectionTitle = __webpack_require__(438);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	var _UpdateCustomerInfo = __webpack_require__(439);
	
	var _UpdateCustomerInfo2 = _interopRequireDefault(_UpdateCustomerInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpiredCard = function ExpiredCard(props) {
	  return _react2.default.createElement(
	    _UpdateCustomerInfo2.default,
	    props,
	    _react2.default.createElement(
	      _SectionTitle2.default,
	      null,
	      'Update CC Details'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Hey ',
	      props.customerName,
	      '! The credit card that you have on file for your membership with ',
	      props.brandName,
	      ' is set to expire soon. To ensure that there is no interruption on your member account, you can use this easy form to update your payment details.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you would like to wait, you can always ask the folks at ',
	      props.brandName,
	      ' to help you update your membership during your next visit. Once your payment details are up to date, your membership will automatically continue.'
	    )
	  );
	};
	
	ExpiredCard.propTypes = {
	  customerName: _propTypes2.default.string.isRequired,
	  brandName: _propTypes2.default.string.isRequired
	};
	
	exports.default = ExpiredCard;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ExpiredCard = __webpack_require__(1013);
	
	var _ExpiredCard2 = _interopRequireDefault(_ExpiredCard);
	
	var _UpdateCustomerInfoContainer = __webpack_require__(441);
	
	var _UpdateCustomerInfoContainer2 = _interopRequireDefault(_UpdateCustomerInfoContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _UpdateCustomerInfoContainer2.default)(_ExpiredCard2.default);

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SectionTitle = __webpack_require__(438);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	var _UpdateCustomerInfo = __webpack_require__(439);
	
	var _UpdateCustomerInfo2 = _interopRequireDefault(_UpdateCustomerInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Migration = function Migration(props) {
	  return _react2.default.createElement(
	    _UpdateCustomerInfo2.default,
	    props,
	    _react2.default.createElement(
	      _SectionTitle2.default,
	      null,
	      'Migration'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Great news ',
	      props.customerName,
	      '! ',
	      props.brandName,
	      ' is moving to Squire for booking appointments and offering memberships. Squire is the platform that has been adopted by some of the most successful businesses in the industry. To learn more about Squire click ',
	      _react2.default.createElement(
	        'a',
	        {
	          target: '_blank',
	          rel: 'noopener noreferrer',
	          href: 'https://getsquire.com'
	        },
	        'here'
	      ),
	      '.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To continue your membership without any interruptions, you can add your credit card details to avoid any interruption of service. If you would like to wait, you can always ask the folks at ',
	      props.brandName,
	      ' to help you update your membership during your next visit. Once your payment details are up to date, your membership will automatically become active.'
	    )
	  );
	};
	
	Migration.propTypes = {
	  customerName: _propTypes2.default.string.isRequired,
	  brandName: _propTypes2.default.string.isRequired
	};
	
	exports.default = Migration;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Migration = __webpack_require__(1015);
	
	var _Migration2 = _interopRequireDefault(_Migration);
	
	var _UpdateCustomerInfoContainer = __webpack_require__(441);
	
	var _UpdateCustomerInfoContainer2 = _interopRequireDefault(_UpdateCustomerInfoContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _UpdateCustomerInfoContainer2.default)(_Migration2.default);

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PaymentFormContainerStripe = __webpack_require__(462);
	
	var _PaymentFormContainerStripe2 = _interopRequireDefault(_PaymentFormContainerStripe);
	
	var _Modal = __webpack_require__(93);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ModalCloseButton = __webpack_require__(907);
	
	var _ModalCloseButton2 = _interopRequireDefault(_ModalCloseButton);
	
	var _LightLogo = __webpack_require__(905);
	
	var _LightLogo2 = _interopRequireDefault(_LightLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardInfoModal = function CardInfoModal(props) {
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      className: 'c-checkout-modal',
	      close: props.off
	    },
	    _react2.default.createElement(_ModalCloseButton2.default, { onClick: props.off }),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-checkout-modal__header u-mb' },
	      _react2.default.createElement(_LightLogo2.default, null)
	    ),
	    _react2.default.createElement(_PaymentFormContainerStripe2.default, {
	      confirmSetup: props.confirmSetup,
	      title: 'Credit Card Information',
	      buttonLabel: 'Update Information'
	    })
	  );
	};
	
	CardInfoModal.propTypes = {
	  off: _propTypes2.default.func.isRequired,
	  confirmSetup: _propTypes2.default.func.isRequired
	};
	
	exports.default = CardInfoModal;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = function Container(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-membership-container' },
	    children
	  );
	};
	
	Container.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = Container;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Section = function Section(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-membership-section' },
	    children
	  );
	};
	
	Section.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = Section;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sweetalertReact = __webpack_require__(132);
	
	var _sweetalertReact2 = _interopRequireDefault(_sweetalertReact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuccessAlert = function SuccessAlert(props) {
	  return _react2.default.createElement(_sweetalertReact2.default, Object.assign({
	    title: 'Success',
	    type: 'success'
	  }, props));
	};
	
	exports.default = SuccessAlert;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var UpdateCardButton = function UpdateCardButton(_ref) {
	  var children = _ref.children,
	      props = _objectWithoutProperties(_ref, ['children']);
	
	  return _react2.default.createElement(
	    'button',
	    Object.assign({
	      className: 'c-btn c-btn--primary',
	      type: 'button'
	    }, props),
	    children
	  );
	};
	
	UpdateCardButton.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = UpdateCardButton;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _ContactInformation = __webpack_require__(409);
	
	var _ContactInformation2 = _interopRequireDefault(_ContactInformation);
	
	var _actions = __webpack_require__(437);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    fields: state.membership.updateCustomer.get('fields').toJS(),
	    firstName: ownProps.location.query.firstName,
	    lastName: ownProps.location.query.lastName,
	    email: ownProps.location.query.email,
	    phone: ownProps.location.query.phone
	  };
	}, { touchField: _actions.touchField, updateField: _actions.updateField }), (0, _withHandlers3.default)({
	  updateField: function updateField(props) {
	    return function (field) {
	      return function (e) {
	        var valueMap = {
	          checkbox: function checkbox(event) {
	            return event.target.checked;
	          },
	          tel: function tel(value) {
	            return value;
	          },
	          default: function _default(event) {
	            return event.target.value;
	          }
	        };
	
	        var valueFn = valueMap[field.type] || valueMap.default;
	        var value = valueFn(e);
	
	        props.updateField(field.id, value);
	        props.touchField(field.id);
	      };
	    };
	  },
	  touchField: function touchField(props) {
	    return function (field) {
	      return function () {
	        return props.touchField(field.id);
	      };
	    };
	  },
	  updateFieldValue: function updateFieldValue(props) {
	    return function (fieldId, value) {
	      props.updateField(fieldId, value);
	      props.touchField(fieldId);
	    };
	  }
	}), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    ['firstName', 'lastName', 'phone', 'email'].forEach(function (field) {
	      return _this.props.updateFieldValue(field, _this.props[field]);
	    });
	  }
	}))(_ContactInformation2.default);

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateCustomer;
	
	var _immutable = __webpack_require__(66);
	
	var _constants = __webpack_require__(440);
	
	var _helpers = __webpack_require__(7);
	
	var _uiHelpers = __webpack_require__(442);
	
	function isFieldValid(id, value) {
	  switch (id) {
	    case 'phone':
	      return (0, _helpers.isValidPhone)(value);
	
	    case 'email':
	      {
	        return (0, _helpers.isValidEmail)(value);
	      }
	
	    case 'adultsonly':
	      return value === true;
	
	    case 'lastName':
	      return (0, _helpers.isValidLastName)(value);
	
	    default:
	      return (0, _helpers.isValidName)(value);
	  }
	}
	
	var initialState = (0, _immutable.fromJS)({
	  fields: _uiHelpers.contactFields,
	  isSuccess: false
	});
	
	function updateCustomer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.UPDATE_CUSTOMER_TOUCH_FIELD:
	      {
	        var index = state.get('fields').findIndex(function (field) {
	          return field.get('id') === action.payload;
	        });
	        return state.setIn(['fields', index, 'touched'], true);
	      }
	
	    case _constants.UPDATE_CUSTOMER_VALIDATE_FIELD:
	      {
	        var _index = state.get('fields').findIndex(function (field) {
	          return field.get('id') === action.payload.id;
	        });
	        var field = state.get('fields').get(_index);
	        var id = field.get('id');
	
	        return state.setIn(['fields', _index, 'error'], !isFieldValid(id, field.get('value')));
	      }
	    case _constants.UPDATE_CUSTOMER_UPDATE_FIELD:
	      {
	        var _index2 = state.get('fields').findIndex(function (field) {
	          return field.get('id') === action.payload.id;
	        });
	        return state.withMutations(function (s) {
	          return s.setIn(['fields', _index2, 'value'], action.payload.value);
	        });
	      }
	    case _constants.UPDATE_CUSTOMER_SUCCESS:
	      {
	        return state.set('isSuccess', true);
	      }
	    case _constants.UPDATE_CUSTOMERP_CLEAR_SUCCESS:
	      {
	        return state.set('isSuccess', false);
	      }
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var getIsFormValid = exports.getIsFormValid = function getIsFormValid(state) {
	  return state.membership.updateCustomer.get('fields').every(function (field) {
	    return field.get('touched') && !field.get('error');
	  });
	};
	
	var getUser = exports.getUser = function getUser(state) {
	  return state.membership.updateCustomer.get('fields').reduce(function (result, field) {
	    var user = _extends({}, result);
	    user[field.get('id')] = field.get('value') || '';
	    return user;
	  }, {});
	};
	
	var isSuccess = exports.isSuccess = function isSuccess(state) {
	  return state.membership.updateCustomer.get('isSuccess');
	};

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMembershipAgreement = undefined;
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line import/prefer-default-export
	var getMembershipAgreement = exports.getMembershipAgreement = function getMembershipAgreement(id) {
	  var url = _config2.default.url + '/membership/' + id + '/agreement';
	  return fetch(url).then(_helpers.checkStatus);
	};

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(49);
	
	var _reducer = __webpack_require__(1023);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({ updateCustomer: _reducer2.default });

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _BrandLayout = __webpack_require__(404);
	
	var _BrandLayout2 = _interopRequireDefault(_BrandLayout);
	
	var _ExpiredCard = __webpack_require__(1014);
	
	var _ExpiredCard2 = _interopRequireDefault(_ExpiredCard);
	
	var _Migration = __webpack_require__(1016);
	
	var _Migration2 = _interopRequireDefault(_Migration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _reactRouter.Route,
	    { component: _BrandLayout2.default, path: '/membership' },
	    _react2.default.createElement(_reactRouter.Route, { path: 'expired-card/:brandRoute/:customerId', component: _ExpiredCard2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'migration/:brandRoute/:customerId', component: _Migration2.default })
	  );
	};

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debounce2 = __webpack_require__(124);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEBOUNCE_TIMEOUT = 200;
	
	// Prevent SET_ACTIVE_DAY firing twice when clicking "next available
	// time" button if next available time is not in same week that is
	// currently rendered, and thus preventing selecting proper next
	// available day
	var debounceSetActiveDay = function debounceSetActiveDay() {
	  return function (next) {
	    var debounced = (0, _debounce3.default)(next, DEBOUNCE_TIMEOUT, { leading: true, trailing: false });
	    return function (action) {
	      if (action.type !== _constants.SET_ACTIVE_DAY) return next(action);
	
	      return debounced(action);
	    };
	  };
	};
	
	exports.default = debounceSetActiveDay;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var _actions = __webpack_require__(92);
	
	var _actions2 = __webpack_require__(64);
	
	var _actions3 = __webpack_require__(117);
	
	var populateReservationFromAppointment = function populateReservationFromAppointment(store) {
	  return function (next) {
	    return function (action) {
	      if (action.type === _constants.RECEIVE_RESERVATION) {
	        store.dispatch((0, _actions.receiveBarbers)([action.payload.barber]));
	        store.dispatch((0, _actions2.receiveShops)([action.payload.shop]));
	        var services = action.payload.appointment_service.map(function (as) {
	          return as.service;
	        });
	        store.dispatch((0, _actions3.receiveServices)(services));
	      }
	      return next(action);
	    };
	  };
	};
	
	exports.default = populateReservationFromAppointment;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(99);
	
	var _constants = __webpack_require__(10);
	
	/**
	 * By reset time on SET_ACTIVE_DAY action.
	 * resetActiveTime is called inside middleware, and not
	 * inside action in order to prevent racing condition.
	 */
	var resetTimeOnSetActiveDay = function resetTimeOnSetActiveDay() {
	  return function (next) {
	    return function (action) {
	      if (action.type === _constants.SET_ACTIVE_DAY) {
	        next(action);
	        return next((0, _actions.resetActiveTime)());
	      }
	      return next(action);
	    };
	  };
	};
	
	exports.default = resetTimeOnSetActiveDay;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDeviceDetect = __webpack_require__(760);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _routes = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeepLinkRedirect = function DeepLinkRedirect(_ref) {
	  var confirmationCode = _ref.confirmationCode,
	      extension = _ref.extension,
	      customer = _ref.customer,
	      send = _ref.send,
	      smsSent = _ref.smsSent,
	      brandRoute = _ref.brandRoute,
	      reservation = _ref.reservation;
	
	  var androidUrl = extension && extension.playStoreLink ? extension.playStoreLink + '&referrer=confirmationCode%3D' + confirmationCode : _config2.default.flagshipAppUrls.android + '&referrer=confirmationCode%3D' + confirmationCode;
	  var iosUrl = extension && extension.iTunesLink ? extension.iTunesLink : _config2.default.flagshipAppUrls.ios;
	  var shouldRedirect = false;
	
	  if (_reactDeviceDetect.isAndroid && androidUrl) {
	    window.location.assign(androidUrl);
	    shouldRedirect = true;
	  } else if (_reactDeviceDetect.isIOS && iosUrl) {
	    window.location.assign(iosUrl);
	    shouldRedirect = true;
	  } else if (!_reactDeviceDetect.isMobileOnly) {
	    (0, _routes.openLocationWithPrefix)('/view-reservation/' + reservation.appointment.id);
	    shouldRedirect = true;
	  }
	
	  if (brandRoute && !extension || shouldRedirect) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'o-wrapper u-text-center alpha u-mt' },
	      'Loading...'
	    );
	  }
	
	  var copy = smsSent ? 'SMS Sent' : 'Text me the link to phone ending in ' + customer.phone.slice(-4);
	  return _react2.default.createElement(
	    'div',
	    { className: 'o-wrapper u-text-center alpha u-mt' },
	    'Download the ',
	    brandRoute ? extension.name : 'Squire',
	    ' app to manage your appointments.',
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'button',
	      {
	        className: 'c-btn c-btn--secondary u-1/1',
	        onClick: send,
	        disabled: smsSent
	      },
	      copy
	    )
	  );
	};
	
	DeepLinkRedirect.propTypes = {
	  confirmationCode: _propTypes2.default.string.isRequired,
	  extension: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
	  customer: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
	  send: _propTypes2.default.func.isRequired,
	  smsSent: _propTypes2.default.bool.isRequired,
	  brandRoute: _propTypes2.default.string,
	  reservation: _propTypes2.default.object.isRequired // eslint-disable-line react/forbid-prop-types
	};
	DeepLinkRedirect.defaultProps = {
	  brandRoute: '',
	  extension: null
	};
	
	exports.default = DeepLinkRedirect;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDeviceDetect = __webpack_require__(760);
	
	var _routes = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var redirectUrl = function redirectUrl(customerId, brandId, userAgent, sendTrackingEvent) {
	  return function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(url) {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!customerId) {
	                _context.next = 3;
	                break;
	              }
	
	              _context.next = 3;
	              return sendTrackingEvent(customerId, brandId, url, userAgent);
	
	            case 3:
	
	              window.location.assign(url);
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	var MobileAppLinkRedirect = function MobileAppLinkRedirect(_ref2) {
	  var location = _ref2.location,
	      sendTrackingEvent = _ref2.sendTrackingEvent;
	
	  var customerId = location.query.customerId;
	  var brandId = location.query.brandId;
	  var androidUrl = location.query.android;
	  var iosUrl = location.query.ios;
	  var userAgent = navigator.userAgent;
	
	  var redirectUrlWithArgs = redirectUrl(customerId, brandId, userAgent, sendTrackingEvent);
	
	  if (_reactDeviceDetect.isAndroid && androidUrl) {
	    redirectUrlWithArgs(androidUrl);
	  } else if (_reactDeviceDetect.isIOS && iosUrl) {
	    redirectUrlWithArgs(iosUrl);
	  } else if (iosUrl) {
	    redirectUrlWithArgs(iosUrl);
	  } else if (androidUrl) {
	    redirectUrlWithArgs(androidUrl);
	  } else {
	    (0, _routes.openLocationWithPrefix)('/404');
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'o-wrapper u-text-center alpha u-mt' },
	    'Redirecting...'
	  );
	};
	
	MobileAppLinkRedirect.propTypes = {
	  location: _propTypes2.default.object, // eslint-disable-line
	  sendTrackingEvent: _propTypes2.default.func.isRequired // eslint-disable-line
	};
	MobileAppLinkRedirect.defaultProps = {};
	
	exports.default = MobileAppLinkRedirect;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _DeepLinkRedirect = __webpack_require__(1031);
	
	var _DeepLinkRedirect2 = _interopRequireDefault(_DeepLinkRedirect);
	
	var _withExtensions = __webpack_require__(269);
	
	var _withExtensions2 = _interopRequireDefault(_withExtensions);
	
	var _extensions = __webpack_require__(95);
	
	var _actions = __webpack_require__(42);
	
	var _actions2 = __webpack_require__(278);
	
	var _actions3 = _interopRequireDefault(_actions2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var DeepLinkRedirectContainer = (0, _compose3.default)(_withExtensions2.default, _reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    brandRoute: ownProps.params.brandRoute,
	    confirmationCode: ownProps.params.confirmationCode,
	    extension: (0, _extensions.getExtension)(state, ownProps.params.brandRoute),
	    sendAppLinkSms: _actions3.default
	  };
	}), (0, _withState3.default)('reservation', 'setReservation', null), (0, _withState3.default)('fetchReservationError', 'setFetchReservationError', false), (0, _withState3.default)('smsSent', 'setSmsSent', false), (0, _withState3.default)('brandId', 'setBrandId', null), (0, _withHandlers3.default)({
	  send: function send(props) {
	    return function () {
	      return props.sendAppLinkSms(props.brandId, props.reservation.appointment.customer.phone).then(function () {
	        return props.setSmsSent(true);
	      });
	    };
	  },
	  fetchReservation: function fetchReservation(props) {
	    return function () {
	      try {
	        var reservationCall = void 0;
	        if (props.brandRoute) {
	          props.setBrandId(props.extension.brandId);
	          reservationCall = (0, _actions.getBrandReservation)(props.extension.brandId, props.params.confirmationCode);
	        } else {
	          reservationCall = (0, _actions.getReservation)(props.params.confirmationCode);
	        }
	        reservationCall.then(function (reservation) {
	          return props.setReservation(reservation);
	        });
	      } catch (err) {
	        props.setFetchReservationError(err);
	      }
	    };
	  }
	}), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    if (this.props.brandRoute) {
	      this.props.fetchExtension(this.props.brandRoute, true);
	    }
	  }
	}), (0, _withPropsOnChange3.default)(['extension'], function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(props) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return props.fetchReservation();
	
	          case 2:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function (_x) {
	    return _ref.apply(this, arguments);
	  };
	}()), (0, _branch3.default)(function (props) {
	  return !props.confirmationCode || !props.reservation;
	}, _renderNothing3.default), (0, _withProps3.default)(function (_ref2) {
	  var reservation = _ref2.reservation;
	  return {
	    customer: reservation.appointment && reservation.appointment.customer
	  };
	}));
	
	exports.default = DeepLinkRedirectContainer(_DeepLinkRedirect2.default);

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _MobileAppLinkRedirect = __webpack_require__(1032);
	
	var _MobileAppLinkRedirect2 = _interopRequireDefault(_MobileAppLinkRedirect);
	
	var _actions = __webpack_require__(278);
	
	var _flags = __webpack_require__(200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var MobileAppLinkRedirectContainer = (0, _compose3.default)((0, _reactRedux.connect)(function () {
	  return {
	    sendReminderSMSLinkClickedEvent: _actions.sendReminderSMSLinkClickedEvent
	  };
	}), (0, _withHandlers3.default)({
	  sendTrackingEvent: function sendTrackingEvent(props) {
	    return function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(customerId, brandId, redirectLink, userAgent) {
	        var flag, context, shouldTrack;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                flag = 'rebooking-reminder-sms';
	                context = { kind: 'brand', key: brandId, anonymous: false };
	                _context.next = 4;
	                return (0, _flags.getFlag)(flag, brandId && context);
	
	              case 4:
	                shouldTrack = _context.sent;
	
	                if (!shouldTrack) {
	                  _context.next = 7;
	                  break;
	                }
	
	                return _context.abrupt('return', props.sendReminderSMSLinkClickedEvent(customerId, brandId, redirectLink, userAgent));
	
	              case 7:
	                return _context.abrupt('return', Promise.resolve());
	
	              case 8:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined);
	      }));
	
	      return function (_x, _x2, _x3, _x4) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	  }
	}));
	
	exports.default = MobileAppLinkRedirectContainer(_MobileAppLinkRedirect2.default);

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactRouter = __webpack_require__(5);
	
	var _visualIdentity = __webpack_require__(1133);
	
	var _GlobalWrapper = __webpack_require__(1124);
	
	var _GlobalWrapper2 = _interopRequireDefault(_GlobalWrapper);
	
	var _Headers = __webpack_require__(1125);
	
	__webpack_require__(1296);
	
	__webpack_require__(1297);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WidgetAnnouncement = function WidgetAnnouncement(props) {
	  return _react2.default.createElement(
	    _GlobalWrapper2.default,
	    null,
	    _react2.default.createElement(
	      _visualIdentity.Layout,
	      null,
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Your clients can now book directly from your website!'
	        )
	      ),
	      _react2.default.createElement(
	        _Headers.H1,
	        null,
	        'Your clients can now book directly from your website!'
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'browser-background' },
	        _react2.default.createElement('img', {
	          src: 'https://assets.getsquire.com/widget-release-email/widget.gif',
	          title: 'Squire booking widget in action',
	          alt: 'Squire booking widget in action'
	        })
	      ),
	      _react2.default.createElement(
	        _visualIdentity.P,
	        null,
	        'We want to introduce you to the Squire Booking Widget, the best place for your clients to book your barbershop, all without ever having to leave your website. Follow the steps below to install it today; it\u2019ll only take a minute!'
	      ),
	      _react2.default.createElement(
	        _Headers.H3,
	        null,
	        'How do I get this?'
	      ),
	      _react2.default.createElement(
	        _visualIdentity.Ol,
	        null,
	        _react2.default.createElement(
	          _visualIdentity.Li,
	          null,
	          'Copy your widget code snippet below'
	        ),
	        _react2.default.createElement(
	          _visualIdentity.Li,
	          null,
	          'Paste the code within the ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            '<head></head>'
	          ),
	          ' tags of your home page.'
	        )
	      ),
	      _react2.default.createElement(
	        _visualIdentity.Card,
	        null,
	        _react2.default.createElement(
	          _visualIdentity.P,
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Your code snippet:'
	          )
	        ),
	        _react2.default.createElement(
	          _visualIdentity.Pre,
	          null,
	          '<script type="text/javascript"> !function(e,t){var i=e.createElement("script"),sa="setAttribute";i.src="https://widget.getsquire.com/widget.js?"+Date.now(),i[sa]("defer",""),i[sa]("type","text/javascript"),i[sa]("brand",t.brand),i[sa]("x-squire-inline-enabled",t.inline||!1),e.head.appendChild(i)}(document,{brand:"' + props.params.brandId + '",inline:true});</script>'
	        )
	      ),
	      _react2.default.createElement(_visualIdentity.Spacer, { height: '1rem' }),
	      _react2.default.createElement(
	        _visualIdentity.Large,
	        null,
	        _react2.default.createElement(
	          _visualIdentity.Center,
	          null,
	          _react2.default.createElement(
	            _visualIdentity.P,
	            null,
	            'Squire supports your brand and we know you\u2019ll love this new widget! ',
	            _react2.default.createElement('br', null),
	            'Check out some of our partners who are already using it.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _visualIdentity.Center,
	        null,
	        _react2.default.createElement(
	          'div',
	          { id: 'shop-showcase' },
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://glassboxbarbershop.com/',
	              target: '_blank',
	              rel: 'noopener noreferrer',
	              title: 'Glassbox Barber Shop'
	            },
	            _react2.default.createElement('img', {
	              src: 'https://assets.getsquire.com/widget-release-email/shop1.png',
	              srcSet: 'https://assets.getsquire.com/widget-release-email/shop1@2x.png 2x',
	              alt: 'Glassbox logo',
	              title: 'Glassbox logo',
	              role: 'presentation'
	            })
	          ),
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://rosemontbarbershop.com/',
	              target: '_blank',
	              rel: 'noopener noreferrer',
	              title: 'Rosemont Barber Shop'
	            },
	            _react2.default.createElement('img', {
	              src: 'https://assets.getsquire.com/widget-release-email/shop2.png',
	              srcSet: 'https://assets.getsquire.com/widget-release-email/shop2@2x.png 2x',
	              alt: 'Rosemont logo',
	              title: 'Rosemont logo',
	              role: 'presentation'
	            })
	          ),
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://thespotbarbershop.com/',
	              target: '_blank',
	              rel: 'noopener noreferrer',
	              title: 'The Spot Barber Shop'
	            },
	            _react2.default.createElement('img', {
	              src: 'https://assets.getsquire.com/widget-release-email/shop3.png',
	              srcSet: 'https://assets.getsquire.com/widget-release-email/shop3@2x.png 2x',
	              alt: 'The spot logo',
	              title: 'The spot logo',
	              role: 'presentation'
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	WidgetAnnouncement.propTypes = {
	  params: _propTypes2.default.shape({
	    brandId: _propTypes2.default.string.isRequired
	  }).isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(WidgetAnnouncement);

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName,
	      barberName = _ref.barberName;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Appointment Canceled | ',
	        shopName
	      )
	    ),
	    'Hey ',
	    barberName,
	    ', your appointment was canceled'
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1036);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _CustomerInfo = __webpack_require__(98);
	
	var _CustomerInfo2 = _interopRequireDefault(_CustomerInfo);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _utils = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var BarberCanceledAppointment = function BarberCanceledAppointment(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      confirmationCode = _ref.confirmationCode,
	      barber = _ref.barber,
	      service = _ref.service,
	      duration = _ref.duration,
	      dateShort = _ref.dateShort,
	      appointmentNote = _ref.appointmentNote;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name, barberName: barber.firstName, service: service, dateShort: dateShort }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      { danger: true },
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-12 u-mb-10' },
	        'Hey ',
	        barber.firstName,
	        ', your appointment with ',
	        customer.firstName,
	        ' ',
	        (customer.lastName || ' ')[0],
	        '. was canceled.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Canceled appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap u-mb-12' },
	        _react2.default.createElement(_AppointmentInfo2.default, {
	          cancel: true,
	          confirmationCode: confirmationCode,
	          customerName: customer.firstName + ' ' + customer.lastName,
	          service: service,
	          date: date,
	          duration: duration,
	          appointmentNote: appointmentNote,
	          shopLocation: shop.name
	        }),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_CustomerInfo2.default, {
	          customerName: customer.firstName + ' ' + customer.lastName,
	          customerNameShort: '' + (customer.firstName || ' ')[0] + (customer.lastName || ' ')[0],
	          customerPhoto: (0, _utils.getCustomerPhoto)(customer),
	          customerEmail: customer.email,
	          customerNotes: customer.notes,
	          customerPhone: customer.phone,
	          customerFirstName: customer.firstName
	        })
	      ),
	      _react2.default.createElement(_SquireInfo2.default, {
	        standalone: true,
	        reservationLink: _config2.default.commanderUrl + '/appointments',
	        shopName: shop.name,
	        supportLink: _config2.default.commanderUrl + '?intercom=true'
	      })
	    ),
	    _react2.default.createElement(_Footer2.default, { link: _config2.default.commanderUrl + '/barber/profile' })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(BarberCanceledAppointment);

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactRouter = __webpack_require__(5);
	
	var _AddressFooter = __webpack_require__(162);
	
	var _AddressFooter2 = _interopRequireDefault(_AddressFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BarberIgAuth = function BarberIgAuth(props) {
	  var _props$location$query = props.location.query,
	      name = _props$location$query.name,
	      link = _props$location$query.link;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Update to keep your IG pics in Squire!'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-ig-auth-body' },
	      _react2.default.createElement('div', { className: 'c-ig-squire-logo' }),
	      _react2.default.createElement(
	        'h2',
	        { className: 'c-ig-title' },
	        'Hi ',
	        name,
	        ', Happy new year!'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'c-ig-text-body u-mb-8' },
	        'You previously provided us with your Instagram username in Squire Commander. Due to a change with Instagram\u2019s policy, we need you to authorize your account in order to preserve your clients\u2019 booking experience.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-ig-instruction u-mb-5' },
	        _react2.default.createElement(
	          'div',
	          null,
	          '1'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Click the button below to authorize Squire'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-ig-instruction u-mb-10' },
	        _react2.default.createElement(
	          'div',
	          null,
	          '2'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Tag the pictures you\u2019d like to populate on Squire app with #getsquire'
	        )
	      ),
	      _react2.default.createElement('a', { className: 'c-ig-auth-button', href: link, target: '_blank' })
	    ),
	    _react2.default.createElement(_AddressFooter2.default, null)
	  );
	}; /* eslint-disable jsx-a11y/anchor-has-content */
	
	
	BarberIgAuth.propTypes = {
	  location: _propTypes2.default.shape({
	    query: _propTypes2.default.shape({
	      name: _propTypes2.default.string.isRequired,
	      link: _propTypes2.default.string.isRequired
	    }).isRequired
	  }).isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(BarberIgAuth);

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactRouter = __webpack_require__(5);
	
	var _AddressFooter = __webpack_require__(162);
	
	var _AddressFooter2 = _interopRequireDefault(_AddressFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BarberIgAuth = function BarberIgAuth(props) {
	  var _props$location$query = props.location.query,
	      name = _props$location$query.name,
	      link = _props$location$query.link;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Get your IG pics into Squire!'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-ig-auth-body' },
	      _react2.default.createElement('div', { className: 'c-ig-squire-logo' }),
	      _react2.default.createElement(
	        'h2',
	        { className: 'c-ig-title' },
	        'Hi ',
	        name,
	        ', Happy new year!'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'c-ig-text-body u-mb-8' },
	        'Some of our most successful barbers have Instagram profiles and use it to showcase their craft.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'c-ig-text-body u-mb-8' },
	        'We\u2019re working hard to improve the booking experience for your clients and in order to have your pictures show up on the website, you\u2019ll need you to give Squire access.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-ig-instruction u-mb-5' },
	        _react2.default.createElement(
	          'div',
	          null,
	          '1'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Click the button below to authorize Squire'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-ig-instruction u-mb-10' },
	        _react2.default.createElement(
	          'div',
	          null,
	          '2'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Tag the pictures you\u2019d like to populate on Squire app with #getsquire'
	        )
	      ),
	      _react2.default.createElement('a', { className: 'c-ig-auth-button', href: link, target: '_blank' })
	    ),
	    _react2.default.createElement(_AddressFooter2.default, null)
	  );
	}; /* eslint-disable jsx-a11y/anchor-has-content */
	
	
	BarberIgAuth.propTypes = {
	  location: _propTypes2.default.shape({
	    query: _propTypes2.default.shape({
	      name: _propTypes2.default.string.isRequired,
	      link: _propTypes2.default.string.isRequired
	    }).isRequired
	  }).isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(BarberIgAuth);

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName,
	      barberName = _ref.barberName,
	      service = _ref.service,
	      dateShort = _ref.dateShort;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'New Appointment | ',
	        shopName
	      )
	    ),
	    'Hey ',
	    barberName,
	    ', you have a new ',
	    service,
	    ' appointment ',
	    dateShort
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Totals = function Totals(_ref) {
	  var total = _ref.total,
	      tip = _ref.tip;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'u-flex u-justify-content-space-between u-align-end' },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-large u-fw-bold u-co-grey u-hide-on-mobile u-mt-5' },
	        'Total'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-large u-fw-bold u-co-grey u-mt-1 u-hide-on-desktop' },
	        'Total'
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'u-text-huge u-ta-right c-receipt-total--light'
	        },
	        _react2.default.createElement(
	          _Money2.default,
	          { noDecimalsIfInt: true },
	          total
	        )
	      )
	    ),
	    _react2.default.createElement('div', { className: 'c-divider u-mt-4 u-mb-4' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-flex u-justify-content-space-between u-align-center u-mb-2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal u-co-grey' },
	        'Subtotal'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal' },
	        _react2.default.createElement(
	          _Money2.default,
	          { noDecimalsIfInt: true },
	          total - tip
	        )
	      )
	    ),
	    !!tip && _react2.default.createElement(
	      'div',
	      { className: 'u-flex u-justify-content-space-between u-align-center u-mb-2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal u-co-grey u-flex u-align-center' },
	        'Tip',
	        _react2.default.createElement('img', {
	          width: '16px',
	          className: 'u-ml-1',
	          src: 'https://squire-emails.s3-us-west-1.amazonaws.com/images/star.png',
	          alt: ''
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal u-co-green' },
	        _react2.default.createElement(
	          _Money2.default,
	          { noDecimalsIfInt: true },
	          tip
	        )
	      )
	    )
	  );
	};
	
	exports.default = Totals;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1040);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _CustomerInfo = __webpack_require__(98);
	
	var _CustomerInfo2 = _interopRequireDefault(_CustomerInfo);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Totals = __webpack_require__(1041);
	
	var _Totals2 = _interopRequireDefault(_Totals);
	
	var _utils = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var BarberNewAppointment = function BarberNewAppointment(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      confirmationCode = _ref.confirmationCode,
	      barber = _ref.barber,
	      service = _ref.service,
	      duration = _ref.duration,
	      dateShort = _ref.dateShort,
	      appointmentNote = _ref.appointmentNote,
	      total = _ref.total,
	      tip = _ref.tip;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name, barberName: barber.firstName, service: service, dateShort: dateShort }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-12 u-mb-10' },
	        'Hey ',
	        barber.firstName,
	        ', you have a new ',
	        service,
	        ' appointment ',
	        dateShort,
	        '.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-mb-10' },
	        _react2.default.createElement(_Totals2.default, { total: total, tip: tip || 0 })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'New appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap u-mb-12' },
	        _react2.default.createElement(_AppointmentInfo2.default, {
	          confirmationCode: confirmationCode,
	          customerName: customer.firstName + ' ' + customer.lastName,
	          service: service,
	          date: date,
	          duration: duration,
	          appointmentNote: appointmentNote,
	          shopLocation: shop.name
	        }),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_CustomerInfo2.default, {
	          customerName: customer.firstName + ' ' + customer.lastName,
	          customerNameShort: '' + (customer.firstName || ' ')[0] + (customer.lastName || ' ')[0],
	          customerPhoto: (0, _utils.getCustomerPhoto)(customer),
	          customerEmail: customer.email,
	          customerNotes: customer.notes,
	          customerPhone: customer.phone,
	          customerFirstName: customer.firstName
	        })
	      ),
	      _react2.default.createElement(_SquireInfo2.default, {
	        standalone: true,
	        reservationLink: _config2.default.commanderUrl + '/appointments',
	        shopName: shop.name,
	        supportLink: _config2.default.commanderUrl + '?intercom=true'
	      })
	    ),
	    _react2.default.createElement(_Footer2.default, { link: _config2.default.commanderUrl + '/barber/profile' })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(BarberNewAppointment);

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName,
	      service = _ref.service,
	      dateShort = _ref.dateShort,
	      customer = _ref.customer;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Reminder | ',
	        shopName
	      )
	    ),
	    'You have a ',
	    (0, _upperFirst3.default)(service),
	    'appointment with ',
	    (0, _upperFirst3.default)(customer.firstName),
	    ' ',
	    (0, _upperFirst3.default)(customer.lastName),
	    '\xA0',
	    dateShort
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1043);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _CustomerInfo = __webpack_require__(98);
	
	var _CustomerInfo2 = _interopRequireDefault(_CustomerInfo);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _utils = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var BarberReminder = function BarberReminder(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      confirmationCode = _ref.confirmationCode,
	      barber = _ref.barber,
	      service = _ref.service,
	      duration = _ref.duration,
	      dateShort = _ref.dateShort,
	      appointmentNote = _ref.appointmentNote;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name, service: service, dateShort: dateShort, customer: customer }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4 u-mt-12' },
	        'Friendly reminder'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mb-10' },
	        'Hey ',
	        barber.firstName,
	        ', you have a ',
	        service,
	        ' appointment coming up ',
	        dateShort,
	        '.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Upcoming appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap u-mb-12' },
	        _react2.default.createElement(_AppointmentInfo2.default, {
	          confirmationCode: confirmationCode,
	          customerName: customer.firstName + ' ' + customer.lastName,
	          service: service,
	          date: date,
	          duration: duration,
	          appointmentNote: appointmentNote,
	          shopLocation: shop.name
	        }),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_CustomerInfo2.default, {
	          customerName: customer.firstName + ' ' + customer.lastName,
	          customerNameShort: '' + (customer.firstName || ' ')[0] + (customer.lastName || ' ')[0],
	          customerPhoto: (0, _utils.getCustomerPhoto)(customer),
	          customerEmail: customer.email,
	          customerNotes: customer.notes,
	          customerPhone: customer.phone,
	          customerFirstName: customer.firstName
	        })
	      ),
	      _react2.default.createElement(_SquireInfo2.default, {
	        standalone: true,
	        reservationLink: _config2.default.commanderUrl + '/appointments',
	        shopName: shop.name,
	        supportLink: _config2.default.commanderUrl + '?intercom=true'
	      })
	    ),
	    _react2.default.createElement(_Footer2.default, { link: _config2.default.commanderUrl + '/barber/profile' })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(BarberReminder);

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName,
	      barberName = _ref.barberName;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Appointment Updated | ',
	        shopName
	      )
	    ),
	    'Hey ',
	    barberName,
	    ', your appointment was updated'
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1045);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _CustomerInfo = __webpack_require__(98);
	
	var _CustomerInfo2 = _interopRequireDefault(_CustomerInfo);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _utils = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var BarberUpdatedAppointment = function BarberUpdatedAppointment(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      confirmationCode = _ref.confirmationCode,
	      barber = _ref.barber,
	      service = _ref.service,
	      duration = _ref.duration,
	      dateShort = _ref.dateShort,
	      appointmentNote = _ref.appointmentNote;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name, barberName: barber.firstName, service: service, dateShort: dateShort }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-12 u-mb-10' },
	        'Hey ',
	        barber.firstName,
	        ', your appointment with ',
	        (0, _utils.firstNameAndLastInitial)(customer.firstName + ' ' + customer.lastName),
	        ' was updated.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Updated appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap u-mb-12' },
	        _react2.default.createElement(_AppointmentInfo2.default, {
	          confirmationCode: confirmationCode,
	          customerName: customer.firstName + ' ' + customer.lastName,
	          service: service,
	          date: date,
	          duration: duration,
	          appointmentNote: appointmentNote,
	          shopLocation: shop.name
	        }),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_CustomerInfo2.default, {
	          customerName: customer.firstName + ' ' + customer.lastName,
	          customerNameShort: '' + (customer.firstName || ' ')[0] + (customer.lastName || ' ')[0],
	          customerPhoto: (0, _utils.getCustomerPhoto)(customer),
	          customerEmail: customer.email,
	          customerNotes: customer.notes,
	          customerPhone: customer.phone,
	          customerFirstName: customer.firstName
	        })
	      ),
	      _react2.default.createElement(_SquireInfo2.default, {
	        standalone: true,
	        reservationLink: _config2.default.commanderUrl + '/appointments',
	        shopName: shop.name,
	        supportLink: _config2.default.commanderUrl + '?intercom=true'
	      })
	    ),
	    _react2.default.createElement(_Footer2.default, { link: _config2.default.commanderUrl + '/barber/profile' })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(BarberUpdatedAppointment);

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Cta = function Cta(_ref) {
	  var appLink = _ref.appLink;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "u-mt-8 u-mb-6" },
	      _react2.default.createElement(
	        "a",
	        {
	          className: "u-text-large u-td-none u-dotted-border u-co-black u-fw-bold u-display-inline-block",
	          href: appLink,
	          target: "_blank"
	        },
	        "Manage"
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "u-text-large u-fw-bold" },
	        "\xA0waiting list",
	        _react2.default.createElement("br", null),
	        "using our free app."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "u-flex" },
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button u-mr-4", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/google-play.png", alt: "" })
	      ),
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/app-store.png", alt: "" })
	      )
	    )
	  );
	};
	
	exports.default = Cta;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName,
	      position = _ref.position;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Waiting List | ',
	        shopName
	      )
	    ),
	    'You\'re on a ',
	    position,
	    ' position on the waiting list.'
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PostCtaAction = function PostCtaAction() {
	  return _react2.default.createElement(
	    "span",
	    null,
	    _react2.default.createElement(
	      "span",
	      { className: "u-text-small u-co-grey u-hide-on-mobile" },
	      "If you need help or having trouble please contact our\xA0",
	      _react2.default.createElement(
	        "a",
	        {
	          className: "u-co-grey u-td-underline",
	          href: "mailto:support@getsquire.com",
	          target: "_blank",
	          rel: "noopener noreferrer"
	        },
	        "customer support"
	      ),
	      "."
	    ),
	    _react2.default.createElement(
	      "span",
	      { className: "u-text-small u-co-grey u-hide-on-desktop" },
	      "If you need help or having trouble",
	      _react2.default.createElement("br", null),
	      "please contact our\xA0",
	      _react2.default.createElement(
	        "a",
	        {
	          className: "u-co-grey u-td-underline",
	          href: "mailto:support@getsquire.com",
	          target: "_blank",
	          rel: "noopener noreferrer"
	        },
	        "customer support"
	      ),
	      "."
	    )
	  );
	};
	
	exports.default = PostCtaAction;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1048);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _ShopLocation = __webpack_require__(70);
	
	var _ShopLocation2 = _interopRequireDefault(_ShopLocation);
	
	var _PhonesBackground = __webpack_require__(54);
	
	var _PhonesBackground2 = _interopRequireDefault(_PhonesBackground);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _PostCtaAction = __webpack_require__(1049);
	
	var _PostCtaAction2 = _interopRequireDefault(_PostCtaAction);
	
	var _Cta = __webpack_require__(1047);
	
	var _Cta2 = _interopRequireDefault(_Cta);
	
	var _withWaitingListNotification = __webpack_require__(197);
	
	var _withWaitingListNotification2 = _interopRequireDefault(_withWaitingListNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var CustomerAddedToWaitingList = function CustomerAddedToWaitingList(_ref) {
	  var shop = _ref.shop,
	      customer = _ref.customer,
	      barber = _ref.barber,
	      service = _ref.service,
	      address = _ref.address,
	      duration = _ref.duration,
	      appLink = _ref.appLink,
	      currentWaitingListPosition = _ref.currentWaitingListPosition,
	      currentWaitingListPositionTitle = _ref.currentWaitingListPositionTitle,
	      squireInfoClassName = _ref.squireInfoClassName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name, position: currentWaitingListPositionTitle }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-10 u-mb-10' },
	        'Hey ',
	        (0, _upperFirst3.default)(customer.firstName),
	        ', you\'re on the ',
	        currentWaitingListPositionTitle,
	        ' position on the waiting list.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Waiting list'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap' },
	        _react2.default.createElement(_AppointmentInfo2.default, {
	          waitingList: true,
	          position: currentWaitingListPosition,
	          barberName: barber.firstName + ' ' + (barber.lastName || '')[0] + '.',
	          service: service,
	          duration: duration
	        }),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_ShopLocation2.default, {
	          shopName: shop.name,
	          phone: shop.phone,
	          line1: address.line1,
	          line2: address.line2,
	          map: shop.staticMap.url,
	          directions: address.directions
	        })
	      ),
	      shop.mobileAppCta && _react2.default.createElement(_Cta2.default, { appLink: appLink }),
	      shop.mobileAppCta && _react2.default.createElement(_PhonesBackground2.default, { name: 'rebook' }),
	      _react2.default.createElement(
	        'div',
	        { className: squireInfoClassName },
	        _react2.default.createElement(_SquireInfo2.default, {
	          standalone: !shop.mobileAppCta,
	          shopName: shop.name,
	          renderAction: _PostCtaAction2.default
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	};
	
	exports.default = (0, _withWaitingListNotification2.default)(CustomerAddedToWaitingList);

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var ConfirmationCode = function ConfirmationCode(_ref) {
	  var code = _ref.code,
	      className = _ref.className;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-flex u-justify-content-space-between u-align-center ' + (className || '') },
	    _react2.default.createElement(
	      'span',
	      { className: 'u-text-normal u-co-grey u-mr-6' },
	      'Confirmation code'
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'c-badge' },
	      code
	    )
	  );
	};
	
	exports.default = ConfirmationCode;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Appointment Canceled | ',
	        shopName
	      )
	    ),
	    'Your appointment was canceled'
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1052);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _ConfirmationCode = __webpack_require__(1051);
	
	var _ConfirmationCode2 = _interopRequireDefault(_ConfirmationCode);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _ShopLocation = __webpack_require__(70);
	
	var _ShopLocation2 = _interopRequireDefault(_ShopLocation);
	
	var _PhonesBackground = __webpack_require__(54);
	
	var _PhonesBackground2 = _interopRequireDefault(_PhonesBackground);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _BookCta = __webpack_require__(1116);
	
	var _BookCta2 = _interopRequireDefault(_BookCta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var CustomerCanceledAppointment = function CustomerCanceledAppointment(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      confirmationCode = _ref.confirmationCode,
	      barber = _ref.barber,
	      service = _ref.service,
	      address = _ref.address,
	      duration = _ref.duration,
	      reservationLink = _ref.reservationLink,
	      appLink = _ref.appLink,
	      squireInfoClassName = _ref.squireInfoClassName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { date: date, shopName: shop.name }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      { danger: true },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-align-center' },
	        _react2.default.createElement(_Logo2.default, null),
	        _react2.default.createElement(_ConfirmationCode2.default, { className: 'u-hide-on-mobile--flex', code: confirmationCode })
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-12 u-mb-10' },
	        'Hey ',
	        (0, _upperFirst3.default)(customer.firstName),
	        ', your appointment was canceled.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Canceled appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap' },
	        _react2.default.createElement(
	          _AppointmentInfo2.default,
	          {
	            cancel: true,
	            confirmationCode: confirmationCode,
	            barberName: barber.firstName + ' ' + (barber.lastName || '')[0] + '.',
	            service: service,
	            date: date,
	            duration: duration
	          },
	          _react2.default.createElement(
	            'a',
	            { className: 'c-book-again-button u-mt-8 u-text-medium', href: appLink, target: '_blank' },
	            'Book again'
	          )
	        ),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_ShopLocation2.default, {
	          shopName: shop.name,
	          phone: shop.phone,
	          line1: address.line1,
	          line2: address.line2,
	          map: shop.staticMap.url,
	          directions: address.directions
	        })
	      ),
	      shop.mobileAppCta && _react2.default.createElement(_BookCta2.default, { appLink: appLink }),
	      shop.mobileAppCta && _react2.default.createElement(_PhonesBackground2.default, { name: 'rebook' }),
	      _react2.default.createElement(
	        'div',
	        { className: squireInfoClassName },
	        _react2.default.createElement(_SquireInfo2.default, {
	          standalone: !shop.mobileAppCta,
	          reservationLink: reservationLink,
	          shopName: shop.name,
	          isCustomerEmail: true
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(CustomerCanceledAppointment);

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Cta = function Cta(_ref) {
	  var appLink = _ref.appLink;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "u-mt-8 u-mb-6" },
	      _react2.default.createElement(
	        "a",
	        {
	          className: "u-text-large u-td-none u-dotted-border u-co-black u-fw-bold u-display-inline-block",
	          href: appLink,
	          target: "_blank"
	        },
	        "Book"
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "u-text-large u-fw-bold" },
	        "\xA0your next appointment",
	        _react2.default.createElement("br", null),
	        "with this code, using our free app."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "u-flex" },
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button u-mr-4", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/google-play.png", alt: "" })
	      ),
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/app-store.png", alt: "" })
	      )
	    )
	  );
	};
	
	exports.default = Cta;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName,
	      loyaltyAmount = _ref.loyaltyAmount;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Loyalty Program | ',
	        shopName
	      )
	    ),
	    'Thank you for being a loyal customer, you just earned\xA0',
	    _react2.default.createElement(
	      _Money2.default,
	      { noDecimalsIfInt: true },
	      loyaltyAmount
	    ),
	    '\xA0in loyalty rewards!'
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var LoyaltyCodeBadge = function LoyaltyCodeBadge(_ref) {
	  var loyaltyCode = _ref.loyaltyCode;
	  return _react2.default.createElement(
	    "div",
	    { className: "c-loyalty-code u-ta-center" },
	    _react2.default.createElement(
	      "span",
	      { className: "u-text-large u-fw-bold" },
	      loyaltyCode
	    )
	  );
	};
	
	exports.default = LoyaltyCodeBadge;

/***/ }),
/* 1057 */
1049,
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1055);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _PhonesBackground = __webpack_require__(54);
	
	var _PhonesBackground2 = _interopRequireDefault(_PhonesBackground);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _PostCtaAction = __webpack_require__(1057);
	
	var _PostCtaAction2 = _interopRequireDefault(_PostCtaAction);
	
	var _Cta = __webpack_require__(1054);
	
	var _Cta2 = _interopRequireDefault(_Cta);
	
	var _withLoyaltyNotification = __webpack_require__(282);
	
	var _withLoyaltyNotification2 = _interopRequireDefault(_withLoyaltyNotification);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _LoyaltyCode = __webpack_require__(1056);
	
	var _LoyaltyCode2 = _interopRequireDefault(_LoyaltyCode);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var CustomerLoyaltyGrant = function CustomerLoyaltyGrant(_ref) {
	  var shop = _ref.shop,
	      customer = _ref.customer,
	      appLink = _ref.appLink,
	      loyaltyCode = _ref.loyaltyCode,
	      loyaltyAmount = _ref.loyaltyAmount,
	      squireInfoClassName = _ref.squireInfoClassName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name, loyaltyAmount: loyaltyAmount }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-10' },
	        'Hey ',
	        (0, _upperFirst3.default)(customer.firstName),
	        ', thank you for being a loyal customer, you just earned \xA0',
	        _react2.default.createElement(
	          _Money2.default,
	          { noDecimalsIfInt: true },
	          loyaltyAmount
	        ),
	        '!'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-mb-4 u-mt-12' },
	        _react2.default.createElement(_LoyaltyCode2.default, { loyaltyCode: loyaltyCode })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-ta-center u-text-small u-co-grey u-mb-16' },
	        'Use this code next time you book.'
	      ),
	      shop.mobileAppCta && _react2.default.createElement(_Cta2.default, { appLink: appLink }),
	      shop.mobileAppCta && _react2.default.createElement(_PhonesBackground2.default, { name: 'rebook' }),
	      _react2.default.createElement(
	        'div',
	        { className: squireInfoClassName },
	        _react2.default.createElement(_SquireInfo2.default, {
	          standalone: !shop.mobileAppCta,
	          shopName: shop.name,
	          renderAction: _PostCtaAction2.default
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	};
	
	exports.default = (0, _compose3.default)(_withAppointmentNotification2.default, _withLoyaltyNotification2.default)(CustomerLoyaltyGrant);

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Cta = function Cta(_ref) {
	  var appLink = _ref.appLink;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "u-mt-8 u-mb-6" },
	      _react2.default.createElement(
	        "a",
	        {
	          className: "u-text-large u-td-none u-dotted-border u-co-black u-fw-bold u-display-inline-block",
	          href: appLink,
	          target: "_blank"
	        },
	        "Book"
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "u-text-large u-fw-bold" },
	        "\xA0Book  your next appointment",
	        _react2.default.createElement("br", null),
	        "using our free app."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "u-flex" },
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button u-mr-4", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/google-play.png", alt: "" })
	      ),
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/app-store.png", alt: "" })
	      )
	    )
	  );
	};
	
	exports.default = Cta;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName,
	      loyaltyAmount = _ref.loyaltyAmount,
	      loyaltyAmountGoal = _ref.loyaltyAmountGoal,
	      loyaltyTransactionsGoal = _ref.loyaltyTransactionsGoal,
	      isAmountBased = _ref.isAmountBased,
	      customerName = _ref.customerName;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Loyalty Program | ',
	        shopName
	      )
	    ),
	    'Hey ',
	    customerName,
	    ', you will receive ',
	    _react2.default.createElement(
	      _Money2.default,
	      { noDecimalsIfInt: true },
	      loyaltyAmount
	    ),
	    ' off once you reach the goal of ',
	    isAmountBased ? _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        _Money2.default,
	        { noDecimalsIfInt: true },
	        loyaltyAmountGoal
	      ),
	      ' total transaction amount'
	    ) : loyaltyTransactionsGoal + ' transactions',
	    '.'
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1061 */
1049,
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1060);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _PhonesBackground = __webpack_require__(54);
	
	var _PhonesBackground2 = _interopRequireDefault(_PhonesBackground);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _PostCtaAction = __webpack_require__(1061);
	
	var _PostCtaAction2 = _interopRequireDefault(_PostCtaAction);
	
	var _Cta = __webpack_require__(1059);
	
	var _Cta2 = _interopRequireDefault(_Cta);
	
	var _withLoyaltyNotification = __webpack_require__(282);
	
	var _withLoyaltyNotification2 = _interopRequireDefault(_withLoyaltyNotification);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var CustomerLoyaltyInitiation = function CustomerLoyaltyInitiation(_ref) {
	  var shop = _ref.shop,
	      customer = _ref.customer,
	      appLink = _ref.appLink,
	      loyaltyAmount = _ref.loyaltyAmount,
	      loyaltyAmountGoal = _ref.loyaltyAmountGoal,
	      loyaltyTransactionsGoal = _ref.loyaltyTransactionsGoal,
	      isAmountBased = _ref.isAmountBased,
	      squireInfoClassName = _ref.squireInfoClassName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, {
	      shopName: shop.name,
	      loyaltyAmountGoal: loyaltyAmountGoal,
	      loyaltyTransactionsGoal: loyaltyTransactionsGoal,
	      isAmountBased: isAmountBased,
	      loyaltyAmount: loyaltyAmount,
	      customerName: (0, _upperFirst3.default)(customer.firstName)
	    }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal u-co-grey u-mt-10 u-3/4' },
	        shop.name,
	        ' is now offering a loyalty program for its valued customers.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-5 u-mb-20' },
	        isAmountBased && _react2.default.createElement(
	          'span',
	          null,
	          'Hey ',
	          (0, _upperFirst3.default)(customer.firstName),
	          ', you\'ll receive ',
	          _react2.default.createElement(
	            _Money2.default,
	            { noDecimalsIfInt: true },
	            loyaltyAmount
	          ),
	          '\xA0off once you reach the goal of ',
	          _react2.default.createElement(
	            _Money2.default,
	            { noDecimalsIfInt: true },
	            loyaltyAmountGoal
	          ),
	          '.'
	        ),
	        !isAmountBased && _react2.default.createElement(
	          'span',
	          null,
	          'Hey ',
	          (0, _upperFirst3.default)(customer.firstName),
	          ', you\'ll receive a ',
	          _react2.default.createElement(
	            _Money2.default,
	            { noDecimalsIfInt: true },
	            loyaltyAmount
	          ),
	          '\xA0loyalty reward after ',
	          loyaltyTransactionsGoal,
	          ' transactions.'
	        )
	      ),
	      shop.mobileAppCta && _react2.default.createElement(_Cta2.default, { appLink: appLink }),
	      shop.mobileAppCta && _react2.default.createElement(_PhonesBackground2.default, { name: 'rebook' }),
	      _react2.default.createElement(
	        'div',
	        { className: squireInfoClassName },
	        _react2.default.createElement(_SquireInfo2.default, {
	          standalone: !shop.mobileAppCta,
	          shopName: shop.name,
	          renderAction: _PostCtaAction2.default
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	};
	
	exports.default = (0, _compose3.default)(_withAppointmentNotification2.default, _withLoyaltyNotification2.default)(CustomerLoyaltyInitiation);

/***/ }),
/* 1063 */
1059,
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Loyalty Program | ',
	        shopName
	      )
	    ),
	    'You are half way to reaching your rewards under our loyalty program in ',
	    shopName,
	    '.'
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(47);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _withExtensionContextConsumer = __webpack_require__(136);
	
	var _withExtensionContextConsumer2 = _interopRequireDefault(_withExtensionContextConsumer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var LoyaltyIndicator = function LoyaltyIndicator(_ref) {
	  var loyaltyAmountGoal = _ref.loyaltyAmountGoal,
	      loyaltyTransactionsGoal = _ref.loyaltyTransactionsGoal,
	      isAmountBased = _ref.isAmountBased,
	      progress = _ref.progress,
	      _ref$extension = _ref.extension,
	      extension = _ref$extension === undefined ? {} : _ref$extension;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-loyalty-indicator' },
	    _react2.default.createElement('div', {
	      className: 'c-loyalty-indicator__progress',
	      style: { width: progress + '%', backgroundColor: (0, _utils.hexToCssHex)(extension.primaryColor) }
	    }),
	    _react2.default.createElement(
	      'span',
	      { className: 'c-loyalty-indicator__goal u-text-normal u-co-grey--light' },
	      isAmountBased ? _react2.default.createElement(
	        _Money2.default,
	        { noDecimalsIfInt: true },
	        loyaltyAmountGoal
	      ) : loyaltyTransactionsGoal + ' transactions'
	    )
	  );
	};
	
	exports.default = (0, _withExtensionContextConsumer2.default)(LoyaltyIndicator);

/***/ }),
/* 1066 */
1049,
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1064);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _PhonesBackground = __webpack_require__(54);
	
	var _PhonesBackground2 = _interopRequireDefault(_PhonesBackground);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _PostCtaAction = __webpack_require__(1066);
	
	var _PostCtaAction2 = _interopRequireDefault(_PostCtaAction);
	
	var _Cta = __webpack_require__(1063);
	
	var _Cta2 = _interopRequireDefault(_Cta);
	
	var _withLoyaltyNotification = __webpack_require__(282);
	
	var _withLoyaltyNotification2 = _interopRequireDefault(_withLoyaltyNotification);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _Indicator = __webpack_require__(1065);
	
	var _Indicator2 = _interopRequireDefault(_Indicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var CustomerLoyaltyUpdate = function CustomerLoyaltyUpdate(_ref) {
	  var shop = _ref.shop,
	      customer = _ref.customer,
	      appLink = _ref.appLink,
	      isAmountBased = _ref.isAmountBased,
	      loyaltyAmountGoal = _ref.loyaltyAmountGoal,
	      loyaltyTransactionsGoal = _ref.loyaltyTransactionsGoal,
	      loyaltyProgress = _ref.loyaltyProgress,
	      loyaltyAmount = _ref.loyaltyAmount,
	      squireInfoClassName = _ref.squireInfoClassName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-10' },
	        'Hey ',
	        (0, _upperFirst3.default)(customer.firstName),
	        ', you\u2019re halfway to your ',
	        loyaltyAmount,
	        ' loyalty reward.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-mb-20 u-mt-12' },
	        _react2.default.createElement(_Indicator2.default, {
	          isAmountBased: isAmountBased,
	          loyaltyAmountGoal: loyaltyAmountGoal,
	          loyaltyTransactionsGoal: loyaltyTransactionsGoal,
	          progress: loyaltyProgress
	        })
	      ),
	      shop.mobileAppCta && _react2.default.createElement(_Cta2.default, { appLink: appLink }),
	      shop.mobileAppCta && _react2.default.createElement(_PhonesBackground2.default, { name: 'rebook' }),
	      _react2.default.createElement(
	        'div',
	        { className: squireInfoClassName },
	        _react2.default.createElement(_SquireInfo2.default, {
	          standalone: !shop.mobileAppCta,
	          shopName: shop.name,
	          renderAction: _PostCtaAction2.default
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	};
	
	exports.default = (0, _compose3.default)(_withAppointmentNotification2.default, _withLoyaltyNotification2.default)(CustomerLoyaltyUpdate);

/***/ }),
/* 1068 */
1051,
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName,
	      date = _ref.date;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'New Appointment | ',
	        shopName
	      )
	    ),
	    'You\'re all set for your appointment at ',
	    shopName,
	    ' on ',
	    date
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1069);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _ConfirmationCode = __webpack_require__(1068);
	
	var _ConfirmationCode2 = _interopRequireDefault(_ConfirmationCode);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _ShopLocation = __webpack_require__(70);
	
	var _ShopLocation2 = _interopRequireDefault(_ShopLocation);
	
	var _RescheduleOrCancel = __webpack_require__(288);
	
	var _RescheduleOrCancel2 = _interopRequireDefault(_RescheduleOrCancel);
	
	var _PhonesBackground = __webpack_require__(54);
	
	var _PhonesBackground2 = _interopRequireDefault(_PhonesBackground);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _AddToCalendar = __webpack_require__(443);
	
	var _AddToCalendar2 = _interopRequireDefault(_AddToCalendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var AppointmentConfirmation = function AppointmentConfirmation(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      confirmationCode = _ref.confirmationCode,
	      barber = _ref.barber,
	      service = _ref.service,
	      address = _ref.address,
	      duration = _ref.duration,
	      reservationLink = _ref.reservationLink,
	      appLink = _ref.appLink,
	      appointment = _ref.appointment,
	      squireInfoClassName = _ref.squireInfoClassName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { date: date, shopName: shop.name }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-align-center' },
	        _react2.default.createElement(_Logo2.default, null),
	        _react2.default.createElement(_ConfirmationCode2.default, { className: 'u-hide-on-mobile--flex', code: confirmationCode })
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-12 u-mb-10' },
	        'Hey ',
	        (0, _upperFirst3.default)(customer.firstName),
	        ', your appointment',
	        _react2.default.createElement('br', null),
	        'is confirmed.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Upcoming appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap' },
	        _react2.default.createElement(
	          _AppointmentInfo2.default,
	          {
	            confirmationCode: confirmationCode,
	            barberName: barber.firstName + ' ' + (barber.lastName || '')[0] + '.',
	            service: service,
	            date: date,
	            duration: duration
	          },
	          _react2.default.createElement(_AddToCalendar2.default, {
	            className: 'u-mt-6',
	            appointment: appointment,
	            customer: customer,
	            shop: shop,
	            barberName: barber.firstName + ' ' + (barber.lastName || '')[0] + '.',
	            serviceName: service
	          })
	        ),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_ShopLocation2.default, {
	          shopName: shop.name,
	          phone: shop.phone,
	          line1: address.line1,
	          line2: address.line2,
	          map: shop.staticMap.url,
	          directions: address.directions
	        })
	      ),
	      shop.mobileAppCta && _react2.default.createElement(_RescheduleOrCancel2.default, { appLink: appLink, shop: shop }),
	      shop.mobileAppCta && _react2.default.createElement(_PhonesBackground2.default, { name: 'confirmation' }),
	      _react2.default.createElement(
	        'div',
	        { className: squireInfoClassName },
	        _react2.default.createElement(_SquireInfo2.default, {
	          standalone: !shop.mobileAppCta,
	          reservationLink: reservationLink,
	          shopName: shop.name,
	          isCustomerEmail: true
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(AppointmentConfirmation);

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Cta = function Cta(_ref) {
	  var appLink = _ref.appLink;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "u-mt-8 u-mb-6" },
	      _react2.default.createElement(
	        "a",
	        {
	          className: "u-text-large u-td-none u-dotted-border u-co-black u-fw-bold u-display-inline-block",
	          href: appLink,
	          target: "_blank"
	        },
	        "Book"
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "u-text-large u-fw-bold" },
	        "\xA0your previous",
	        _react2.default.createElement("br", null),
	        "appointment again"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "u-flex" },
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button u-mr-4", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/google-play.png", alt: "" })
	      ),
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/app-store.png", alt: "" })
	      )
	    )
	  );
	};
	
	exports.default = Cta;

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Book Again | ',
	        shopName
	      )
	    ),
	    'It\'s time to book your next haircut'
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1073 */
1049,
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1072);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _ShopLocation = __webpack_require__(70);
	
	var _ShopLocation2 = _interopRequireDefault(_ShopLocation);
	
	var _PhonesBackground = __webpack_require__(54);
	
	var _PhonesBackground2 = _interopRequireDefault(_PhonesBackground);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _PostCtaAction = __webpack_require__(1073);
	
	var _PostCtaAction2 = _interopRequireDefault(_PostCtaAction);
	
	var _Cta = __webpack_require__(1071);
	
	var _Cta2 = _interopRequireDefault(_Cta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var CustomerRebook = function CustomerRebook(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      confirmationCode = _ref.confirmationCode,
	      barber = _ref.barber,
	      service = _ref.service,
	      address = _ref.address,
	      duration = _ref.duration,
	      appLink = _ref.appLink,
	      squireInfoClassName = _ref.squireInfoClassName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mt-12' },
	        'Friendly reminder'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-2 u-mb-10' },
	        'Hey ',
	        (0, _upperFirst3.default)(customer.firstName),
	        ', it\'s time to book your next appointment.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Previous appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap' },
	        _react2.default.createElement(_AppointmentInfo2.default, {
	          confirmationCode: confirmationCode,
	          barberName: barber.firstName + ' ' + (barber.lastName || '')[0] + '.',
	          service: service,
	          date: date,
	          duration: duration
	        }),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_ShopLocation2.default, {
	          shopName: shop.name,
	          phone: shop.phone,
	          line1: address.line1,
	          line2: address.line2,
	          map: shop.staticMap.url,
	          directions: address.directions
	        })
	      ),
	      shop.mobileAppCta && _react2.default.createElement(_Cta2.default, { appLink: appLink }),
	      shop.mobileAppCta && _react2.default.createElement(_PhonesBackground2.default, { name: 'rebook' }),
	      _react2.default.createElement(
	        'div',
	        { className: squireInfoClassName },
	        _react2.default.createElement(_SquireInfo2.default, {
	          standalone: !shop.mobileAppCta,
	          shopName: shop.name,
	          renderAction: _PostCtaAction2.default
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(CustomerRebook);

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName,
	      service = _ref.service,
	      date = _ref.date;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Reminder | ',
	        shopName
	      )
	    ),
	    'You are scheduled for a ',
	    service,
	    ' ',
	    date
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1075);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _ShopLocation = __webpack_require__(70);
	
	var _ShopLocation2 = _interopRequireDefault(_ShopLocation);
	
	var _RescheduleOrCancel = __webpack_require__(288);
	
	var _RescheduleOrCancel2 = _interopRequireDefault(_RescheduleOrCancel);
	
	var _PhonesBackground = __webpack_require__(54);
	
	var _PhonesBackground2 = _interopRequireDefault(_PhonesBackground);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var CustomerReminder = function CustomerReminder(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      confirmationCode = _ref.confirmationCode,
	      barber = _ref.barber,
	      service = _ref.service,
	      address = _ref.address,
	      duration = _ref.duration,
	      reservationLink = _ref.reservationLink,
	      dateShort = _ref.dateShort,
	      appLink = _ref.appLink,
	      squireInfoClassName = _ref.squireInfoClassName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name, date: date, service: service }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mt-12' },
	        'Friendly reminder'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-2 u-mb-10' },
	        'Hey ',
	        (0, _upperFirst3.default)(customer.firstName),
	        ', your ',
	        service,
	        ' with ',
	        barber.firstName,
	        ' is coming up ',
	        dateShort,
	        '.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Upcoming appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap' },
	        _react2.default.createElement(_AppointmentInfo2.default, {
	          confirmationCode: confirmationCode,
	          barberName: barber.firstName + ' ' + (barber.lastName || '')[0] + '.',
	          service: service,
	          date: date,
	          duration: duration
	        }),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_ShopLocation2.default, {
	          shopName: shop.name,
	          phone: shop.phone,
	          line1: address.line1,
	          line2: address.line2,
	          map: shop.staticMap.url,
	          directions: address.directions
	        })
	      ),
	      shop.mobileAppCta && _react2.default.createElement(_RescheduleOrCancel2.default, { appLink: appLink, shop: shop }),
	      shop.mobileAppCta && _react2.default.createElement(_PhonesBackground2.default, { name: 'reminder' }),
	      _react2.default.createElement(
	        'div',
	        { className: squireInfoClassName },
	        _react2.default.createElement(_SquireInfo2.default, {
	          standalone: !shop.mobileAppCta,
	          reservationLink: reservationLink,
	          shopName: shop.name
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(CustomerReminder);

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Cta = function Cta(_ref) {
	  var appLink = _ref.appLink;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "u-mt-8 u-mb-6" },
	      _react2.default.createElement(
	        "a",
	        {
	          className: "u-text-large u-td-none u-dotted-border u-co-black u-fw-bold u-display-inline-block",
	          href: appLink,
	          target: "_blank"
	        },
	        "Pay now your"
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "u-text-large u-fw-bold" },
	        "\xA0appointment",
	        _react2.default.createElement("br", null),
	        "using our free app."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "u-flex" },
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button u-mr-4", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/google-play.png", alt: "" })
	      ),
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/app-store.png", alt: "" })
	      )
	    )
	  );
	};
	
	exports.default = Cta;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Pay Online | ',
	        shopName
	      )
	    ),
	    'Avoid the hassle of having to pay in person by paying for your appointment now.'
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1078);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _ShopLocation = __webpack_require__(70);
	
	var _ShopLocation2 = _interopRequireDefault(_ShopLocation);
	
	var _PhonesBackground = __webpack_require__(54);
	
	var _PhonesBackground2 = _interopRequireDefault(_PhonesBackground);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _Cta = __webpack_require__(1077);
	
	var _Cta2 = _interopRequireDefault(_Cta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var CustomerUnpaidAppointment = function CustomerUnpaidAppointment(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      confirmationCode = _ref.confirmationCode,
	      barber = _ref.barber,
	      service = _ref.service,
	      address = _ref.address,
	      duration = _ref.duration,
	      appLink = _ref.appLink,
	      squireInfoClassName = _ref.squireInfoClassName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mt-12' },
	        'Stay safe'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-2 u-mb-10' },
	        'Hey ',
	        (0, _upperFirst3.default)(customer.firstName),
	        ', avoid the hassle of having',
	        _react2.default.createElement('br', null),
	        'to pay in person by paying now.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Upcoming appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap' },
	        _react2.default.createElement(
	          _AppointmentInfo2.default,
	          {
	            confirmationCode: confirmationCode,
	            barberName: barber.firstName + ' ' + (barber.lastName || '')[0] + '.',
	            service: service,
	            date: date,
	            duration: duration
	          },
	          _react2.default.createElement(
	            'a',
	            { className: 'c-pay-now-button u-mt-8 u-text-medium', href: appLink, target: '_blank' },
	            _react2.default.createElement('span', { className: 'u-mr-2' }),
	            'Pay now'
	          )
	        ),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_ShopLocation2.default, {
	          shopName: shop.name,
	          phone: shop.phone,
	          line1: address.line1,
	          line2: address.line2,
	          map: shop.staticMap.url,
	          directions: address.directions
	        })
	      ),
	      shop.mobileAppCta && _react2.default.createElement(_Cta2.default, { appLink: appLink }),
	      shop.mobileAppCta && _react2.default.createElement(_PhonesBackground2.default, { name: 'rebook' }),
	      _react2.default.createElement(
	        'div',
	        { className: squireInfoClassName },
	        _react2.default.createElement(_SquireInfo2.default, {
	          standalone: !shop.mobileAppCta,
	          shopName: shop.name
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(CustomerUnpaidAppointment);

/***/ }),
/* 1080 */
1051,
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Appointment Updated | ',
	        shopName
	      )
	    ),
	    'Your appointment was updated'
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1081);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _ConfirmationCode = __webpack_require__(1080);
	
	var _ConfirmationCode2 = _interopRequireDefault(_ConfirmationCode);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _ShopLocation = __webpack_require__(70);
	
	var _ShopLocation2 = _interopRequireDefault(_ShopLocation);
	
	var _RescheduleOrCancel = __webpack_require__(288);
	
	var _RescheduleOrCancel2 = _interopRequireDefault(_RescheduleOrCancel);
	
	var _PhonesBackground = __webpack_require__(54);
	
	var _PhonesBackground2 = _interopRequireDefault(_PhonesBackground);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var CustomerUpdatedAppointment = function CustomerUpdatedAppointment(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      confirmationCode = _ref.confirmationCode,
	      barber = _ref.barber,
	      service = _ref.service,
	      address = _ref.address,
	      duration = _ref.duration,
	      reservationLink = _ref.reservationLink,
	      appLink = _ref.appLink,
	      squireInfoClassName = _ref.squireInfoClassName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { date: date, shopName: shop.name }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-align-center' },
	        _react2.default.createElement(_Logo2.default, null),
	        _react2.default.createElement(_ConfirmationCode2.default, { className: 'u-hide-on-mobile--flex', code: confirmationCode })
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-12 u-mb-10' },
	        'Hey ',
	        (0, _upperFirst3.default)(customer.firstName),
	        ', your appointment was updated.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Updated appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap' },
	        _react2.default.createElement(_AppointmentInfo2.default, {
	          confirmationCode: confirmationCode,
	          barberName: barber.firstName + ' ' + (barber.lastName || '')[0] + '.',
	          service: service,
	          date: date,
	          duration: duration
	        }),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_ShopLocation2.default, {
	          shopName: shop.name,
	          phone: shop.phone,
	          line1: address.line1,
	          line2: address.line2,
	          map: shop.staticMap.url,
	          directions: address.directions
	        })
	      ),
	      shop.mobileAppCta && _react2.default.createElement(_RescheduleOrCancel2.default, { appLink: appLink, shop: shop }),
	      shop.mobileAppCta && _react2.default.createElement(_PhonesBackground2.default, { name: 'confirmation' }),
	      _react2.default.createElement(
	        'div',
	        { className: squireInfoClassName },
	        _react2.default.createElement(_SquireInfo2.default, {
	          standalone: !shop.mobileAppCta,
	          reservationLink: reservationLink,
	          shopName: shop.name,
	          isCustomerEmail: true
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(CustomerUpdatedAppointment);

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Cta = function Cta(_ref) {
	  var appLink = _ref.appLink;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "u-mt-8 u-mb-6" },
	      _react2.default.createElement(
	        "a",
	        {
	          className: "u-text-large u-td-none u-dotted-border u-co-black u-fw-bold u-display-inline-block",
	          href: appLink,
	          target: "_blank"
	        },
	        "Book"
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "u-text-large u-fw-bold" },
	        "\xA0your appointment.",
	        _react2.default.createElement("br", null),
	        "using our free app."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "u-flex" },
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button u-mr-4", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/google-play.png", alt: "" })
	      ),
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/app-store.png", alt: "" })
	      )
	    )
	  );
	};
	
	exports.default = Cta;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName,
	      customerName = _ref.customerName;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Waiting List | ',
	        shopName
	      )
	    ),
	    'Hey ',
	    customerName,
	    ', you made it! A new slot is now available to book.'
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1085 */
1049,
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1084);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _ShopLocation = __webpack_require__(70);
	
	var _ShopLocation2 = _interopRequireDefault(_ShopLocation);
	
	var _PhonesBackground = __webpack_require__(54);
	
	var _PhonesBackground2 = _interopRequireDefault(_PhonesBackground);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _PostCtaAction = __webpack_require__(1085);
	
	var _PostCtaAction2 = _interopRequireDefault(_PostCtaAction);
	
	var _Cta = __webpack_require__(1083);
	
	var _Cta2 = _interopRequireDefault(_Cta);
	
	var _withWaitingListNotification = __webpack_require__(197);
	
	var _withWaitingListNotification2 = _interopRequireDefault(_withWaitingListNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var CustomerWaitingListNewSlot = function CustomerWaitingListNewSlot(_ref) {
	  var shop = _ref.shop,
	      customer = _ref.customer,
	      barber = _ref.barber,
	      service = _ref.service,
	      address = _ref.address,
	      duration = _ref.duration,
	      appLink = _ref.appLink,
	      currentWaitingListPosition = _ref.currentWaitingListPosition,
	      squireInfoClassName = _ref.squireInfoClassName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name, customerName: (0, _upperFirst3.default)(customer.firstName) }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-10 u-mb-10' },
	        'Hey ',
	        (0, _upperFirst3.default)(customer.firstName),
	        ', you made it! A new slot is now available to book.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Waiting list'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap' },
	        _react2.default.createElement(
	          _AppointmentInfo2.default,
	          {
	            waitingList: true,
	            position: currentWaitingListPosition,
	            barberName: barber.firstName + ' ' + (barber.lastName || '')[0] + '.',
	            service: service,
	            duration: duration
	          },
	          _react2.default.createElement(
	            'a',
	            { className: 'c-book-again-button u-co-white u-mt-8 u-text-medium', href: appLink, target: '_blank' },
	            'Book now'
	          )
	        ),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_ShopLocation2.default, {
	          shopName: shop.name,
	          phone: shop.phone,
	          line1: address.line1,
	          line2: address.line2,
	          map: shop.staticMap.url,
	          directions: address.directions
	        })
	      ),
	      shop.mobileAppCta && _react2.default.createElement(_Cta2.default, { appLink: appLink }),
	      shop.mobileAppCta && _react2.default.createElement(_PhonesBackground2.default, { name: 'rebook' }),
	      _react2.default.createElement(
	        'div',
	        { className: squireInfoClassName },
	        _react2.default.createElement(_SquireInfo2.default, {
	          standalone: !shop.mobileAppCta,
	          shopName: shop.name,
	          renderAction: _PostCtaAction2.default
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	};
	
	exports.default = (0, _withWaitingListNotification2.default)(CustomerWaitingListNewSlot);

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Cta = function Cta(_ref) {
	  var appLink = _ref.appLink;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "u-mt-8 u-mb-6" },
	      _react2.default.createElement(
	        "a",
	        {
	          className: "u-text-large u-td-none u-dotted-border u-co-black u-fw-bold u-display-inline-block",
	          href: appLink,
	          target: "_blank"
	        },
	        "Book"
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "u-text-large u-fw-bold" },
	        "\xA0your next appointment",
	        _react2.default.createElement("br", null),
	        "using our free app."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "u-flex" },
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button u-mr-4", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/google-play.png", alt: "" })
	      ),
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/app-store.png", alt: "" })
	      )
	    )
	  );
	};
	
	exports.default = Cta;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName,
	      customerName = _ref.customerName;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Waiting List | ',
	        shopName
	      )
	    ),
	    'Hey ',
	    customerName,
	    ', you didn\'t make it today so we removed you. Try again.'
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1089 */
1049,
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1088);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _ShopLocation = __webpack_require__(70);
	
	var _ShopLocation2 = _interopRequireDefault(_ShopLocation);
	
	var _PhonesBackground = __webpack_require__(54);
	
	var _PhonesBackground2 = _interopRequireDefault(_PhonesBackground);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _PostCtaAction = __webpack_require__(1089);
	
	var _PostCtaAction2 = _interopRequireDefault(_PostCtaAction);
	
	var _Cta = __webpack_require__(1087);
	
	var _Cta2 = _interopRequireDefault(_Cta);
	
	var _withWaitingListNotification = __webpack_require__(197);
	
	var _withWaitingListNotification2 = _interopRequireDefault(_withWaitingListNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var CustomerWaitingListPurged = function CustomerWaitingListPurged(_ref) {
	  var shop = _ref.shop,
	      customer = _ref.customer,
	      barber = _ref.barber,
	      service = _ref.service,
	      address = _ref.address,
	      duration = _ref.duration,
	      appLink = _ref.appLink,
	      squireInfoClassName = _ref.squireInfoClassName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name, customerName: (0, _upperFirst3.default)(customer.firstName) }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-10 u-mb-10' },
	        'Hey ',
	        (0, _upperFirst3.default)(customer.firstName),
	        ', you didn\'t make it today so we removed you. Try again.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Waiting list'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap' },
	        _react2.default.createElement(
	          _AppointmentInfo2.default,
	          {
	            waitingList: true,
	            barberName: barber.firstName + ' ' + (barber.lastName || '')[0] + '.',
	            service: service,
	            duration: duration
	          },
	          _react2.default.createElement(
	            'a',
	            { className: 'c-book-again-button u-co-white u-mt-8 u-text-medium', href: appLink, target: '_blank' },
	            'Book again'
	          )
	        ),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_ShopLocation2.default, {
	          shopName: shop.name,
	          phone: shop.phone,
	          line1: address.line1,
	          line2: address.line2,
	          map: shop.staticMap.url,
	          directions: address.directions
	        })
	      ),
	      shop.mobileAppCta && _react2.default.createElement(_Cta2.default, { appLink: appLink }),
	      shop.mobileAppCta && _react2.default.createElement(_PhonesBackground2.default, { name: 'rebook' }),
	      _react2.default.createElement(
	        'div',
	        { className: squireInfoClassName },
	        _react2.default.createElement(_SquireInfo2.default, {
	          standalone: !shop.mobileAppCta,
	          shopName: shop.name,
	          renderAction: _PostCtaAction2.default
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	};
	
	exports.default = (0, _withWaitingListNotification2.default)(CustomerWaitingListPurged);

/***/ }),
/* 1091 */
1087,
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName,
	      customerName = _ref.customerName;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Waiting List | ',
	        shopName
	      )
	    ),
	    'Hey ',
	    customerName,
	    ', you have been removed from the waiting list.'
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1093 */
1049,
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1092);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _ShopLocation = __webpack_require__(70);
	
	var _ShopLocation2 = _interopRequireDefault(_ShopLocation);
	
	var _PhonesBackground = __webpack_require__(54);
	
	var _PhonesBackground2 = _interopRequireDefault(_PhonesBackground);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _PostCtaAction = __webpack_require__(1093);
	
	var _PostCtaAction2 = _interopRequireDefault(_PostCtaAction);
	
	var _Cta = __webpack_require__(1091);
	
	var _Cta2 = _interopRequireDefault(_Cta);
	
	var _withWaitingListNotification = __webpack_require__(197);
	
	var _withWaitingListNotification2 = _interopRequireDefault(_withWaitingListNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var CustomerWaitingListRemoved = function CustomerWaitingListRemoved(_ref) {
	  var shop = _ref.shop,
	      customer = _ref.customer,
	      barber = _ref.barber,
	      service = _ref.service,
	      address = _ref.address,
	      duration = _ref.duration,
	      appLink = _ref.appLink,
	      squireInfoClassName = _ref.squireInfoClassName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name, customerName: (0, _upperFirst3.default)(customer.firstName) }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-10 u-mb-10' },
	        'Hey ',
	        (0, _upperFirst3.default)(customer.firstName),
	        ', you have been removed from the waiting list.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Waiting list'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap' },
	        _react2.default.createElement(
	          _AppointmentInfo2.default,
	          {
	            waitingList: true,
	            barberName: barber.firstName + ' ' + (barber.lastName || '')[0] + '.',
	            service: service,
	            duration: duration
	          },
	          _react2.default.createElement(
	            'a',
	            { className: 'c-book-again-button u-co-white u-mt-8 u-text-medium', href: appLink, target: '_blank' },
	            'Book again'
	          )
	        ),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_ShopLocation2.default, {
	          shopName: shop.name,
	          phone: shop.phone,
	          line1: address.line1,
	          line2: address.line2,
	          map: shop.staticMap.url,
	          directions: address.directions
	        })
	      ),
	      shop.mobileAppCta && _react2.default.createElement(_Cta2.default, { appLink: appLink }),
	      shop.mobileAppCta && _react2.default.createElement(_PhonesBackground2.default, { name: 'rebook' }),
	      _react2.default.createElement(
	        'div',
	        { className: squireInfoClassName },
	        _react2.default.createElement(_SquireInfo2.default, {
	          standalone: !shop.mobileAppCta,
	          shopName: shop.name,
	          renderAction: _PostCtaAction2.default
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	};
	
	exports.default = (0, _withWaitingListNotification2.default)(CustomerWaitingListRemoved);

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _FlagshipAppointmentInfo = __webpack_require__(283);
	
	var _FlagshipAppointmentInfo2 = _interopRequireDefault(_FlagshipAppointmentInfo);
	
	var _FlagshipNotification = __webpack_require__(284);
	
	var _FlagshipNotification2 = _interopRequireDefault(_FlagshipNotification);
	
	var _FlagshipRescheduleOrCancel = __webpack_require__(285);
	
	var _FlagshipRescheduleOrCancel2 = _interopRequireDefault(_FlagshipRescheduleOrCancel);
	
	var _FlagshipSharedBottom = __webpack_require__(286);
	
	var _FlagshipSharedBottom2 = _interopRequireDefault(_FlagshipSharedBottom);
	
	var _FlagshipShopLocation = __webpack_require__(287);
	
	var _FlagshipShopLocation2 = _interopRequireDefault(_FlagshipShopLocation);
	
	var _Header = __webpack_require__(280);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Helmets = __webpack_require__(281);
	
	var _Helmets2 = _interopRequireDefault(_Helmets);
	
	var _ColorBar = __webpack_require__(1098);
	
	var _ColorBar2 = _interopRequireDefault(_ColorBar);
	
	var _Footer = __webpack_require__(279);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var FlagshipAppointmentCancelled = function FlagshipAppointmentCancelled(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      barber = _ref.barber,
	      confirmationCode = _ref.confirmationCode,
	      service = _ref.service,
	      duration = _ref.duration,
	      address = _ref.address,
	      appLink = _ref.appLink,
	      iosLink = _ref.iosLink,
	      androidLink = _ref.androidLink,
	      reservationLink = _ref.reservationLink;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Helmets2.default, null),
	    _react2.default.createElement(
	      _Header2.default,
	      null,
	      'Hey ',
	      (0, _upperFirst3.default)(customer.firstName),
	      ', your appointment was cancelled.'
	    ),
	    _react2.default.createElement(
	      _FlagshipNotification2.default,
	      null,
	      _react2.default.createElement(_ColorBar2.default, { color: '#FF3B30' }),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-12 u-mb-10 u-hide-breaks-on-mobile' },
	        'Hey ',
	        (0, _upperFirst3.default)(customer.firstName),
	        ', your appointment',
	        ' ',
	        _react2.default.createElement('br', null),
	        'has been cancelled.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Cancelled appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap u-align-stretch' },
	        _react2.default.createElement(
	          _FlagshipAppointmentInfo2.default,
	          {
	            confirmationCode: confirmationCode,
	            barberName: barber.firstName + ' ' + (barber.lastName || '')[0] + '.',
	            service: service,
	            date: date,
	            duration: duration,
	            customerName: customer.firstName + ' ' + (customer.lastName || '')[0] + '.',
	            className: 'cancelled'
	          },
	          _react2.default.createElement(
	            'a',
	            { href: appLink, className: 'flgshp-button u-mt-6' },
	            'Book again'
	          )
	        ),
	        _react2.default.createElement(_FlagshipShopLocation2.default, {
	          shopName: shop.name,
	          phone: shop.phone,
	          line1: address.line1,
	          line2: address.line2,
	          map: shop.staticMap ? shop.staticMap.url : '',
	          directions: address.directions
	        })
	      ),
	      shop.mobileAppCta && _react2.default.createElement(_FlagshipRescheduleOrCancel2.default, { appLink: appLink, androidLink: androidLink, iosLink: iosLink }),
	      _react2.default.createElement(_FlagshipSharedBottom2.default, { reservationLink: reservationLink, shopName: shop.name })
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(FlagshipAppointmentCancelled);

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _lowerCase2 = __webpack_require__(1490);
	
	var _lowerCase3 = _interopRequireDefault(_lowerCase2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _FlagshipAppointmentInfo = __webpack_require__(283);
	
	var _FlagshipAppointmentInfo2 = _interopRequireDefault(_FlagshipAppointmentInfo);
	
	var _FlagshipNotification = __webpack_require__(284);
	
	var _FlagshipNotification2 = _interopRequireDefault(_FlagshipNotification);
	
	var _FlagshipRescheduleOrCancel = __webpack_require__(285);
	
	var _FlagshipRescheduleOrCancel2 = _interopRequireDefault(_FlagshipRescheduleOrCancel);
	
	var _FlagshipSharedBottom = __webpack_require__(286);
	
	var _FlagshipSharedBottom2 = _interopRequireDefault(_FlagshipSharedBottom);
	
	var _FlagshipShopLocation = __webpack_require__(287);
	
	var _FlagshipShopLocation2 = _interopRequireDefault(_FlagshipShopLocation);
	
	var _Header = __webpack_require__(280);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Helmets = __webpack_require__(281);
	
	var _Helmets2 = _interopRequireDefault(_Helmets);
	
	var _Footer = __webpack_require__(279);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var FlagshipAppointmentReminder = function FlagshipAppointmentReminder(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      barber = _ref.barber,
	      confirmationCode = _ref.confirmationCode,
	      service = _ref.service,
	      duration = _ref.duration,
	      address = _ref.address,
	      appLink = _ref.appLink,
	      iosLink = _ref.iosLink,
	      androidLink = _ref.androidLink,
	      reservationLink = _ref.reservationLink;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Helmets2.default, null),
	    _react2.default.createElement(
	      _Header2.default,
	      null,
	      'You are scheduled for ',
	      (0, _lowerCase3.default)(service),
	      ' in 24 hours.'
	    ),
	    _react2.default.createElement(
	      _FlagshipNotification2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4 u-pt-30' },
	        'Friendly reminder'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mb-12 u-hide-breaks-on-mobile' },
	        'Hey ',
	        (0, _upperFirst3.default)(customer.firstName),
	        ', your ',
	        (0, _lowerCase3.default)(service),
	        ' with ',
	        barber.firstName,
	        '\xA0',
	        (barber.lastName || '')[0],
	        ' is coming up in 24 hours.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Upcoming appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap u-align-stretch' },
	        _react2.default.createElement(_FlagshipAppointmentInfo2.default, {
	          confirmationCode: confirmationCode,
	          barberName: barber.firstName + ' ' + (barber.lastName || '')[0] + '.',
	          service: service,
	          date: date,
	          duration: duration,
	          customerName: customer.firstName + ' ' + (customer.lastName || '')[0] + '.'
	        }),
	        _react2.default.createElement(_FlagshipShopLocation2.default, {
	          shopName: shop.name,
	          phone: shop.phone,
	          line1: address.line1,
	          line2: address.line2,
	          map: shop.staticMap ? shop.staticMap.url : '',
	          directions: address.directions
	        })
	      ),
	      shop.mobileAppCta && _react2.default.createElement(_FlagshipRescheduleOrCancel2.default, { appLink: appLink, androidLink: androidLink, iosLink: iosLink }),
	      _react2.default.createElement(_FlagshipSharedBottom2.default, { reservationLink: reservationLink, shopName: shop.name })
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(FlagshipAppointmentReminder);

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _AddToCalendar = __webpack_require__(443);
	
	var _AddToCalendar2 = _interopRequireDefault(_AddToCalendar);
	
	var _FlagshipAppointmentInfo = __webpack_require__(283);
	
	var _FlagshipAppointmentInfo2 = _interopRequireDefault(_FlagshipAppointmentInfo);
	
	var _FlagshipNotification = __webpack_require__(284);
	
	var _FlagshipNotification2 = _interopRequireDefault(_FlagshipNotification);
	
	var _FlagshipRescheduleOrCancel = __webpack_require__(285);
	
	var _FlagshipRescheduleOrCancel2 = _interopRequireDefault(_FlagshipRescheduleOrCancel);
	
	var _FlagshipSharedBottom = __webpack_require__(286);
	
	var _FlagshipSharedBottom2 = _interopRequireDefault(_FlagshipSharedBottom);
	
	var _FlagshipShopLocation = __webpack_require__(287);
	
	var _FlagshipShopLocation2 = _interopRequireDefault(_FlagshipShopLocation);
	
	var _ConfirmationCode = __webpack_require__(1099);
	
	var _ConfirmationCode2 = _interopRequireDefault(_ConfirmationCode);
	
	var _Header = __webpack_require__(280);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Helmets = __webpack_require__(281);
	
	var _Helmets2 = _interopRequireDefault(_Helmets);
	
	var _Footer = __webpack_require__(279);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var FlagshipAppointmentConfirmation = function FlagshipAppointmentConfirmation(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      barber = _ref.barber,
	      confirmationCode = _ref.confirmationCode,
	      service = _ref.service,
	      duration = _ref.duration,
	      appointment = _ref.appointment,
	      address = _ref.address,
	      appLink = _ref.appLink,
	      iosLink = _ref.iosLink,
	      androidLink = _ref.androidLink,
	      reservationLink = _ref.reservationLink;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Helmets2.default, null),
	    _react2.default.createElement(
	      _Header2.default,
	      null,
	      'You\'re all set for your appointment at ',
	      shop.name,
	      ' on ',
	      date
	    ),
	    _react2.default.createElement(
	      _FlagshipNotification2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-end' },
	        _react2.default.createElement(_ConfirmationCode2.default, { className: 'confirmation-code', code: confirmationCode })
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-12 u-mb-10 u-hide-breaks-on-mobile' },
	        'Hey ',
	        (0, _upperFirst3.default)(customer.firstName),
	        ', your appointment',
	        ' ',
	        _react2.default.createElement('br', null),
	        'is confirmed.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Upcoming appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap u-align-stretch' },
	        _react2.default.createElement(
	          _FlagshipAppointmentInfo2.default,
	          {
	            confirmationCode: confirmationCode,
	            barberName: barber.firstName + ' ' + (barber.lastName || '')[0] + '.',
	            service: service,
	            date: date,
	            duration: duration,
	            customerName: customer.firstName + ' ' + (customer.lastName || '')[0] + '.'
	          },
	          _react2.default.createElement(_AddToCalendar2.default, {
	            className: 'u-mt-6',
	            appointment: appointment,
	            customer: customer,
	            shop: shop,
	            barberName: barber.firstName + ' ' + (barber.lastName || '')[0] + '.',
	            serviceName: service
	          })
	        ),
	        _react2.default.createElement(_FlagshipShopLocation2.default, {
	          shopName: shop.name,
	          phone: shop.phone,
	          line1: address.line1,
	          line2: address.line2,
	          map: shop.staticMap ? shop.staticMap.url : '',
	          directions: address.directions
	        })
	      ),
	      shop.mobileAppCta && _react2.default.createElement(_FlagshipRescheduleOrCancel2.default, { appLink: appLink, androidLink: androidLink, iosLink: iosLink }),
	      _react2.default.createElement(_FlagshipSharedBottom2.default, { reservationLink: reservationLink, shopName: shop.name })
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(FlagshipAppointmentConfirmation);

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var ColorBar = function ColorBar(_ref) {
	  var color = _ref.color;
	  return _react2.default.createElement("div", { className: "flgshp-color-bar", style: { backgroundColor: color } });
	};
	
	exports.default = ColorBar;

/***/ }),
/* 1099 */
1051,
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/no-array-index-key,react/prop-types */
	var getQuantityByType = function getQuantityByType(item) {
	  var _item$quantityByType = item.quantityByType,
	      service = _item$quantityByType.service,
	      product = _item$quantityByType.product;
	
	  service = service && (service <= 1 ? service + ' service' : service + ' services');
	  product = product && (product <= 1 ? product + ' product' : product + ' products');
	  return [service, product].filter(Boolean).join(' + ');
	};
	
	var Breakdown = function Breakdown(_ref) {
	  var total = _ref.total,
	      date = _ref.date,
	      datetime = _ref.datetime,
	      subtotal = _ref.subtotal,
	      tip = _ref.tip,
	      taxesAndFees = _ref.taxesAndFees,
	      promo = _ref.promo,
	      promoCode = _ref.promoCode,
	      discount = _ref.discount,
	      items = _ref.items,
	      totalByType = _ref.totalByType,
	      giftCardCode = _ref.giftCardCode,
	      last4 = _ref.last4,
	      brand = _ref.brand,
	      transactionId = _ref.transactionId,
	      refunded = _ref.refunded;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'u-flex u-align-center u-justify-content-space-between' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'u-text-large u-fw-bold' },
	          'Total price'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'u-text-medium u-co-grey' },
	          'Incl. all taxes & fees'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'c-receipt-total u-ta-right',
	          style: { fontSize: '48px !important', lineHeight: '48px !important' }
	        },
	        _react2.default.createElement(
	          _Money2.default,
	          { noDecimalsIfInt: true },
	          total
	        )
	      )
	    ),
	    _react2.default.createElement('div', { className: 'c-divider u-mt-5 u-mb-5' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-flex u-justify-content-space-between u-mb-8' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'u-text-extrasmall u-co-grey--light u-tt-uppercase u-fw-bold u-mb-1' },
	          'Date'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'u-text-normal' },
	            date
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'u-text-extrasmall u-co-grey--light u-tt-uppercase u-fw-bold u-ta-right u-mb-1' },
	          'Time'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'u-text-normal u-ta-right' },
	          datetime
	        )
	      )
	    ),
	    items.map(function (item, idx) {
	      return _react2.default.createElement(
	        'div',
	        { key: idx },
	        _react2.default.createElement(
	          'div',
	          { className: 'u-flex u-justify-content-space-between u-align-center u-mt-8 u-mb-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'u-text-normal u-fw-bold' },
	            item.barberName
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'u-text-small u-co-grey u-float-right u-hide-on-mobile',
	              style: { lineHeight: '22px !important' }
	            },
	            getQuantityByType(item)
	          )
	        ),
	        item.subItems.map(function (subItem, innerIdx) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'u-flex u-justify-content-space-between u-align-center u-mb-2', key: innerIdx },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'c-items-count' },
	                subItem.quantity
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'u-text-normal u-co-grey',
	                  style: { lineHeight: '20px !important' }
	                },
	                subItem.name
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'u-text-normal' },
	              _react2.default.createElement(
	                _Money2.default,
	                { noDecimalsIfInt: true },
	                subItem.amount
	              )
	            )
	          );
	        }),
	        !!item.tip && _react2.default.createElement(
	          'div',
	          { className: 'u-flex u-justify-content-space-between u-align-center u-mb-2' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('span', { style: { display: 'inline-block', minWidth: '30px' } }),
	            _react2.default.createElement(
	              'span',
	              { className: 'u-text-normal u-co-grey' },
	              'Tip'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'u-text-normal' },
	            _react2.default.createElement(
	              _Money2.default,
	              { noDecimalsIfInt: true },
	              item.tip
	            )
	          )
	        )
	      );
	    }),
	    _react2.default.createElement('div', { className: 'c-divider u-mt-8 u-mb-6' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-flex u-justify-content-space-between u-align-center u-mb-2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal u-co-grey' },
	        'Subtotal'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal' },
	        _react2.default.createElement(
	          _Money2.default,
	          { noDecimalsIfInt: true },
	          subtotal
	        )
	      )
	    ),
	    !!tip && _react2.default.createElement(
	      'div',
	      { className: 'u-flex u-justify-content-space-between u-align-center u-mb-2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal u-co-grey' },
	        'Tip'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal' },
	        _react2.default.createElement(
	          _Money2.default,
	          { noDecimalsIfInt: true },
	          tip
	        )
	      )
	    ),
	    !!taxesAndFees && _react2.default.createElement(
	      'div',
	      { className: 'u-flex u-justify-content-space-between u-align-center u-mb-2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal u-co-grey' },
	        'Taxes & fees'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-norma' },
	        _react2.default.createElement(
	          _Money2.default,
	          { noDecimalsIfInt: true },
	          taxesAndFees
	        )
	      )
	    ),
	    !!promo && _react2.default.createElement(
	      'div',
	      { className: 'u-flex u-justify-content-space-between u-align-center u-mb-2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal u-co-grey' },
	        'Promo \u2013 ',
	        promoCode
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal u-co-green' },
	        '-',
	        _react2.default.createElement(
	          _Money2.default,
	          { noDecimalsIfInt: true },
	          promo
	        )
	      )
	    ),
	    !!discount && _react2.default.createElement(
	      'div',
	      { className: 'u-flex u-justify-content-space-between u-align-center u-mb-2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal u-co-grey' },
	        'Discount'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal u-co-green' },
	        '-',
	        _react2.default.createElement(
	          _Money2.default,
	          { noDecimalsIfInt: true },
	          discount
	        )
	      )
	    ),
	    !!refunded && _react2.default.createElement(
	      'div',
	      { className: 'u-flex u-justify-content-space-between u-align-center u-mb-2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal u-co-red u-fw-bold' },
	        'Refunded'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal u-co-red u-fw-bold' },
	        _react2.default.createElement(
	          _Money2.default,
	          { noDecimalsIfInt: true },
	          refunded
	        )
	      )
	    ),
	    _react2.default.createElement('div', { className: 'c-divider u-mt-8 u-mb-8' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-mb-16' },
	      !!totalByType.card && _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-align-center u-mb-2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'u-flex u-justify-content-space-between u-align-center' },
	          _react2.default.createElement('img', {
	            width: '38px',
	            height: '24px',
	            className: 'u-mr-4',
	            src: 'https://squire-emails.s3-us-west-1.amazonaws.com/images/logo-' + brand + '.png',
	            alt: ''
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'u-text-normal u-fw-bold' },
	            '\u2022\u2022\u2022\u2022 ',
	            last4
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'u-text-normal' },
	          _react2.default.createElement(
	            _Money2.default,
	            { noDecimalsIfInt: true },
	            totalByType.card
	          )
	        )
	      ),
	      !!totalByType.giftCard && _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-align-center u-mb-2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'u-flex u-justify-content-space-between u-align-center' },
	          _react2.default.createElement('img', {
	            width: '38px',
	            height: '24px',
	            className: 'u-mr-4',
	            src: 'https://squire-emails.s3-us-west-1.amazonaws.com/images/logo-gift-card.png',
	            alt: ''
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'u-text-normal u-fw-bold' },
	            'Gift Card: ',
	            giftCardCode
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'u-text-normal u-co-green' },
	          _react2.default.createElement(
	            _Money2.default,
	            { noDecimalsIfInt: true },
	            totalByType.giftCard
	          )
	        )
	      ),
	      !!totalByType.cash && _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-align-center u-mb-2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'u-flex u-justify-content-space-between u-align-center' },
	          _react2.default.createElement('img', {
	            width: '38px',
	            height: '24px',
	            className: 'u-mr-4',
	            src: 'https://squire-emails.s3-us-west-1.amazonaws.com/images/logo-cash.png',
	            alt: ''
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'u-text-normal u-fw-bold' },
	            'Cash'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'u-text-normal' },
	          _react2.default.createElement(
	            _Money2.default,
	            { noDecimalsIfInt: true },
	            totalByType.cash
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-mt-5 u-text-tiny u-co-grey--light u-ta-center u-hide-on-mobile' },
	        _react2.default.createElement(
	          'span',
	          { className: 'u-mr-5' },
	          'AID ',
	          transactionId
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'u-mr-5' },
	          date
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          datetime
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-mt-5 u-text-tiny u-co-grey--light u-ta-center u-hide-on-desktop' },
	        _react2.default.createElement(
	          'div',
	          { className: 'u-mb-2' },
	          'AID ',
	          transactionId
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          date,
	          ' ',
	          datetime
	        )
	      )
	    )
	  );
	};
	
	exports.default = Breakdown;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Receipt | ',
	        shopName
	      )
	    ),
	    'Here is your receipt from ',
	    shopName
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1102 */
1049,
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withExtensionContextConsumer = __webpack_require__(136);
	
	var _withExtensionContextConsumer2 = _interopRequireDefault(_withExtensionContextConsumer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSubtitle = function getSubtitle(last4, refunded) {
	  if (refunded) return 'Your order has been successfully refunded.';
	  return last4 ? 'Your card was successfully charged.' : 'Your were successfully charged.';
	};
	
	// eslint-disable-next-line react/prop-types
	var Title = function Title(_ref) {
	  var logoUrl = _ref.logoUrl,
	      last4 = _ref.last4,
	      refunded = _ref.refunded,
	      _ref$extension = _ref.extension,
	      extension = _ref$extension === undefined ? {} : _ref$extension;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-receipt-title' },
	    _react2.default.createElement('img', { className: 'u-hide-on-desktop u-mb-12', width: '64px', height: '64px', src: logoUrl, alt: 'Logo' }),
	    _react2.default.createElement(
	      'h2',
	      { className: 'u-text-huge u-fw-bold u-mt-2 u-mb-2' },
	      refunded ? 'Refunded!' : 'Thank you!'
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-normal' },
	        getSubtitle(last4, refunded)
	      )
	    ),
	    extension.appIconImage && _react2.default.createElement('img', {
	      className: 'c-receipt-title__logo u-hide-on-mobile',
	      width: '90px',
	      height: '90px',
	      src: extension.appIconImage,
	      alt: 'Logo'
	    })
	  );
	};
	
	exports.default = (0, _withExtensionContextConsumer2.default)(Title);

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _omit2 = __webpack_require__(350);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1101);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _ShopLocation = __webpack_require__(70);
	
	var _ShopLocation2 = _interopRequireDefault(_ShopLocation);
	
	var _PhonesBackground = __webpack_require__(54);
	
	var _PhonesBackground2 = _interopRequireDefault(_PhonesBackground);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _Title = __webpack_require__(1103);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Breakdown = __webpack_require__(1100);
	
	var _Breakdown2 = _interopRequireDefault(_Breakdown);
	
	var _PostCtaAction = __webpack_require__(1102);
	
	var _PostCtaAction2 = _interopRequireDefault(_PostCtaAction);
	
	var _withReceiptNotification = __webpack_require__(1108);
	
	var _withReceiptNotification2 = _interopRequireDefault(_withReceiptNotification);
	
	var _ReceiptCta = __webpack_require__(1118);
	
	var _ReceiptCta2 = _interopRequireDefault(_ReceiptCta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var CustomerReminder = function CustomerReminder(_ref) {
	  var shop = _ref.shop,
	      receipt = _ref.receipt,
	      address = _ref.address,
	      transactionId = _ref.transactionId,
	      appLink = _ref.appLink,
	      squireInfoClassName = _ref.squireInfoClassName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Title2.default, {
	        last4: receipt.last4,
	        refunded: receipt.refunded
	      }),
	      _react2.default.createElement('div', { className: 'u-mb-20 u-hide-on-mobile' }),
	      _react2.default.createElement('div', { className: 'u-mb-10 u-hide-on-desktop' }),
	      _react2.default.createElement(_Breakdown2.default, {
	        total: receipt.total,
	        date: receipt.date,
	        datetime: receipt.datetime,
	        subtotal: receipt.subtotal,
	        tip: receipt.tip,
	        taxesAndFees: receipt.taxAndFee,
	        promo: receipt.promo,
	        promoCode: receipt.promoCode,
	        discount: receipt.discount,
	        items: receipt.items,
	        totalByType: receipt.totalByType,
	        last4: receipt.last4,
	        brand: receipt.brand,
	        transactionId: transactionId,
	        refunded: receipt.refunded,
	        giftCardCode: receipt.giftCardCode
	      }),
	      receipt.appointments.length ? _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey' },
	        'Your Appointment'
	      ) : null,
	      receipt.appointments.length ? _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap u-mt-4' },
	        _react2.default.createElement(_AppointmentInfo2.default, { appointments: receipt.appointments.map(function (appt) {
	            return (0, _omit3.default)(appt, ['customerName']);
	          }) }),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_ShopLocation2.default, {
	          fixed: true,
	          shopName: shop.name,
	          phone: shop.phone,
	          line1: address.line1,
	          line2: address.line2,
	          map: shop.staticMap.url,
	          directions: address.directions
	        })
	      ) : null,
	      shop.mobileAppCta && _react2.default.createElement(_ReceiptCta2.default, { appointments: receipt.appointments, appLink: appLink }),
	      shop.mobileAppCta && _react2.default.createElement(_PhonesBackground2.default, { name: 'receipt' }),
	      _react2.default.createElement(
	        'div',
	        { className: squireInfoClassName },
	        _react2.default.createElement(_SquireInfo2.default, {
	          standalone: !shop.mobileAppCta,
	          shopName: shop.name,
	          renderAction: _PostCtaAction2.default
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { link: appLink })
	  );
	}; /* eslint-disable react/no-array-index-key */
	exports.default = (0, _withReceiptNotification2.default)(CustomerReminder);

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _renderComponent2 = __webpack_require__(57);
	
	var _renderComponent3 = _interopRequireDefault(_renderComponent2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Loader = __webpack_require__(82);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var LOADING_STATE = -1;
	
	var withBrandContextProvider = (0, _compose3.default)(_reactRouter.withRouter, (0, _withState3.default)('brand', 'setBrand', {}), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    if (this.props.brand === LOADING_STATE) {
	      return;
	    }
	
	    this.props.setBrand(LOADING_STATE);
	
	    fetch(_config2.default.url + '/brand/' + this.props.params.brandId).then(function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	        var brand;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return (0, _helpers.checkStatus)(res);
	
	              case 2:
	                brand = _context.sent;
	
	                _this.props.setBrand(brand);
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }());
	  }
	}), (0, _branch3.default)(function (props) {
	  return props.brand === LOADING_STATE;
	}, (0, _renderComponent3.default)(_Loader2.default)));
	
	exports.default = withBrandContextProvider;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withContext2 = __webpack_require__(805);
	
	var _withContext3 = _interopRequireDefault(_withContext2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _extensions = __webpack_require__(95);
	
	var _withExtensions = __webpack_require__(269);
	
	var _withExtensions2 = _interopRequireDefault(_withExtensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_withExtensions2.default, _reactRouter.withRouter, (0, _reactRedux.connect)(function (state, props) {
	  return {
	    extension: (0, _extensions.getExtension)(state, props.params.brandRoute)
	  };
	}), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    this.props.fetchExtension(this.props.params.brandRoute);
	  }
	}), (0, _withContext3.default)({ extension: _propTypes2.default.object }, function (props) {
	  return { extension: props.extension };
	}));

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _renderComponent2 = __webpack_require__(57);
	
	var _renderComponent3 = _interopRequireDefault(_renderComponent2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _actions = __webpack_require__(1025);
	
	var _Loader = __webpack_require__(82);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _withState3.default)('busy', 'setBusy', false), (0, _withState3.default)('agreement', 'setAgreement', null), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    return _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var membershipId;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              membershipId = _this.props.location.query.membership;
	
	              _this.props.setBusy(true);
	              (0, _actions.getMembershipAgreement)(membershipId).then(function (_ref) {
	                var agreement = _ref.agreement;
	                return _this.props.setAgreement(agreement);
	              }).finally(function () {
	                return _this.props.setBusy(false);
	              });
	
	            case 3:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}), (0, _branch3.default)(function (props) {
	  return props.busy;
	}, (0, _renderComponent3.default)(_Loader2.default)), (0, _branch3.default)(function (props) {
	  return !props.agreement;
	}, _renderNothing3.default));

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _renderComponent2 = __webpack_require__(57);
	
	var _renderComponent3 = _interopRequireDefault(_renderComponent2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _map2 = __webpack_require__(74);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(5);
	
	var _actions = __webpack_require__(451);
	
	var _Loader = __webpack_require__(82);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _helpers = __webpack_require__(7);
	
	var _utils = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var formatBrand = function formatBrand(rawBrand) {
	  var nonGenericCards = ['mastercard', 'visa', 'discover', 'americanexpress'];
	  var brand = (rawBrand || '').replace(/\s/g, '').toLowerCase();
	
	  if (nonGenericCards.includes(brand)) {
	    return brand;
	  }
	
	  return 'generic';
	};
	
	var getService = function getService(appt) {
	  var service = (0, _map3.default)(appt.appointment_service, 'name').join(', ');
	  if (service.length > 20) {
	    return service.slice(0, 20) + '...';
	  }
	  return service;
	};
	
	var getDate = function getDate(appt, shop) {
	  var timezone = shop.timezone;
	  var date = _moment2.default.utc(appt.dateTime).tz(timezone).format('ddd, MMM Do');
	  var startTime = _moment2.default.utc(appt.dateTime).tz(timezone).format('h:mm A');
	  return date + ', ' + startTime;
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _withState3.default)('busy', 'setBusy', true), (0, _withState3.default)('receipt', 'setReceipt', null), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    return _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var receipt;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return (0, _actions.getReceipt)(_this.props.params.id, _this.props.params.transactionId);
	
	            case 3:
	              receipt = _context.sent;
	
	              _this.props.setReceipt(receipt);
	
	            case 5:
	              _context.prev = 5;
	
	              _this.props.setBusy(false);
	              return _context.finish(5);
	
	            case 8:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[0,, 5, 8]]);
	    }))();
	  }
	}), (0, _branch3.default)(function (props) {
	  return props.busy;
	}, (0, _renderComponent3.default)(_Loader2.default)), (0, _branch3.default)(function (props) {
	  return !props.receipt;
	}, _renderNothing3.default), (0, _withProps3.default)(function (_ref) {
	  var receipt = _ref.receipt,
	      params = _ref.params;
	  var shop = receipt.shop;
	
	  var confirmationCode = (0, _get3.default)(receipt, 'appointments[0].confirmationCode', '');
	  return _extends({
	    shop: shop,
	    address: (0, _utils.getShopAddress)(shop),
	    phone: shop.phone,
	    logo: shop.logo,
	    transactionId: params.transactionId
	  }, (0, _utils.getAppLinks)(params.brandRoute, confirmationCode), {
	    receipt: _extends({}, receipt, {
	      brand: formatBrand(receipt.brand),
	      date: (0, _moment2.default)(receipt.createdAt).format('MM/DD/YYYY'),
	      datetime: (0, _moment2.default)(receipt.createdAt).format('hh:mm:ss A'),
	      appointments: (0, _map3.default)(receipt.appointments, function (appt) {
	        return {
	          confirmationCode: appt.confirmationCode,
	          customerName: appt.customer.firstName,
	          barberName: appt.barber.firstName + ' ' + (appt.barber.lastName || '')[0],
	          service: getService(appt),
	          date: getDate(appt, shop),
	          duration: (0, _helpers.formatDuration)(appt.duration),
	          barber: appt.barber
	        };
	      })
	    }),
	    squireInfoClassName: shop.mobileAppCta ? 'c-phones-background__content' : 'u-mt-15'
	  });
	}));

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _withExtensionContextProvider = __webpack_require__(1106);
	
	var _withExtensionContextProvider2 = _interopRequireDefault(_withExtensionContextProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BasicLayout = function BasicLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-notifications c-notifications-basic-layout' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement('meta', { name: 'viewport', content: 'width=670, initial-scale=1, maximum-scale=1' })
	    ),
	    children
	  );
	};
	
	BasicLayout.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = (0, _withExtensionContextProvider2.default)(BasicLayout);

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IgAuthLayout = function IgAuthLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-notifications c-notifications-ig-auth-layout' },
	    children
	  );
	};
	
	IgAuthLayout.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = IgAuthLayout;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MembershipLayout = function MembershipLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-notifications c-membership-layout' },
	    children
	  );
	};
	
	MembershipLayout.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = MembershipLayout;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _AddressFooter = __webpack_require__(162);
	
	var _AddressFooter2 = _interopRequireDefault(_AddressFooter);
	
	var _withMembershipAgreement = __webpack_require__(1107);
	
	var _withMembershipAgreement2 = _interopRequireDefault(_withMembershipAgreement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MembershipAgreement = function MembershipAgreement(_ref) {
	  var brandLogo = _ref.brandLogo,
	      agreement = _ref.agreement;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'c-membership-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-membership-header' },
	        _react2.default.createElement('img', { src: brandLogo, className: 'c-brand-logo u-mb-8', alt: 'logo' }),
	        _react2.default.createElement(
	          'h2',
	          { className: 'c-membership-title' },
	          'Your membership Terms & Conditions'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-membership-text' },
	        _react2.default.createElement(
	          'p',
	          null,
	          agreement
	        )
	      )
	    ),
	    _react2.default.createElement(_AddressFooter2.default, null)
	  );
	};
	
	MembershipAgreement.propTypes = {
	  brandLogo: _propTypes2.default.string.isRequired,
	  agreement: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, _withMembershipAgreement2.default, (0, _withProps3.default)(function (props) {
	  return {
	    brandLogo: props.location.query.brandLogo
	  };
	}))(MembershipAgreement);

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _AddressFooter = __webpack_require__(162);
	
	var _AddressFooter2 = _interopRequireDefault(_AddressFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MembershipCardExpiry = function MembershipCardExpiry(_ref) {
	  var customerName = _ref.customerName,
	      brandName = _ref.brandName,
	      brandLogo = _ref.brandLogo,
	      onUpdate = _ref.onUpdate;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'c-membership-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-membership-header' },
	        _react2.default.createElement('img', { src: brandLogo, className: 'c-brand-logo u-mb-8', alt: brandName }),
	        _react2.default.createElement(
	          'h2',
	          { className: 'c-membership-title' },
	          'Your credit card is expiring soon!'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-membership-text u-mb-8' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Hey ',
	          customerName,
	          '!'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Your credit card is set to expire within the next 30 days.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'To continue your membership with ',
	          brandName,
	          ' please update your payment details. If you choose not to update your payment details now, you can do so during your next appointment.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Cheers, ',
	          _react2.default.createElement('br', null),
	          brandName
	        )
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'c-btn c-btn--primary c-membership-btn', onClick: onUpdate },
	        'Update Credit Card Details'
	      )
	    ),
	    _react2.default.createElement(_AddressFooter2.default, null)
	  );
	};
	
	MembershipCardExpiry.propTypes = {
	  customerName: _propTypes2.default.string.isRequired,
	  brandName: _propTypes2.default.string.isRequired,
	  brandLogo: _propTypes2.default.string.isRequired,
	  onUpdate: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    customerName: ownProps.location.query.customerName,
	    brandName: ownProps.location.query.brandName,
	    brandLogo: ownProps.location.query.brandLogo,
	    updateLink: ownProps.location.query.updateLink
	  };
	}), (0, _withHandlers3.default)({
	  onUpdate: function onUpdate(props) {
	    return function () {
	      props.router.replace(props.updateLink);
	    };
	  }
	}))(MembershipCardExpiry);

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _AddressFooter = __webpack_require__(162);
	
	var _AddressFooter2 = _interopRequireDefault(_AddressFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MembershipMigration = function MembershipMigration(_ref) {
	  var customerName = _ref.customerName,
	      brandName = _ref.brandName,
	      brandLogo = _ref.brandLogo,
	      backgroundImage = _ref.backgroundImage,
	      onUpdate = _ref.onUpdate;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'c-membership-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-membership-header' },
	        _react2.default.createElement('img', { src: brandLogo, className: 'c-brand-logo u-mb-8', alt: brandName }),
	        _react2.default.createElement(
	          'h2',
	          { className: 'c-membership-title' },
	          'Your barbershop is coming to Squire'
	        ),
	        backgroundImage && _react2.default.createElement('img', { src: backgroundImage, className: 'c-brand-background u-mb-8', alt: brandName })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-membership-text u-mb-8' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Hey ',
	          customerName,
	          '!'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Great news, your barbershop has moved to Squire! The most successful barbershops run on ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://getsquire.com' },
	            'Squire'
	          ),
	          ', confirming your membership details will ensure that your next appointment is as smooth as your last.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'To continue your membership with ',
	          brandName,
	          ' please update your payment details. If you choose not to update your payment details now, you can do so during your next appointment.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Cheers, ',
	          _react2.default.createElement('br', null),
	          brandName
	        )
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'c-btn c-btn--primary c-membership-btn', onClick: onUpdate },
	        'Update Credit Card Details'
	      )
	    ),
	    _react2.default.createElement(_AddressFooter2.default, null)
	  );
	};
	
	MembershipMigration.propTypes = {
	  customerName: _propTypes2.default.string.isRequired,
	  brandName: _propTypes2.default.string.isRequired,
	  brandLogo: _propTypes2.default.string.isRequired,
	  backgroundImage: _propTypes2.default.string.isRequired,
	  onUpdate: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    customerName: ownProps.location.query.customerName,
	    brandName: ownProps.location.query.brandName,
	    brandLogo: ownProps.location.query.brandLogo,
	    backgroundImage: ownProps.location.query.backgroundImage,
	    updateLink: ownProps.location.query.updateLink
	  };
	}), (0, _withHandlers3.default)({
	  onUpdate: function onUpdate(props) {
	    return function () {
	      props.router.replace(props.updateLink);
	    };
	  }
	}))(MembershipMigration);

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _BasicLayout = __webpack_require__(1109);
	
	var _BasicLayout2 = _interopRequireDefault(_BasicLayout);
	
	var _IgAuthLayout = __webpack_require__(1110);
	
	var _IgAuthLayout2 = _interopRequireDefault(_IgAuthLayout);
	
	var _CustomerNewAppointment = __webpack_require__(1070);
	
	var _CustomerNewAppointment2 = _interopRequireDefault(_CustomerNewAppointment);
	
	var _CustomerReminder = __webpack_require__(1076);
	
	var _CustomerReminder2 = _interopRequireDefault(_CustomerReminder);
	
	var _Receipt = __webpack_require__(1104);
	
	var _Receipt2 = _interopRequireDefault(_Receipt);
	
	var _CustomerRebook = __webpack_require__(1074);
	
	var _CustomerRebook2 = _interopRequireDefault(_CustomerRebook);
	
	var _BarberNewAppointment = __webpack_require__(1042);
	
	var _BarberNewAppointment2 = _interopRequireDefault(_BarberNewAppointment);
	
	var _ShopNewAppointment = __webpack_require__(1138);
	
	var _ShopNewAppointment2 = _interopRequireDefault(_ShopNewAppointment);
	
	var _ShopReminder = __webpack_require__(1140);
	
	var _ShopReminder2 = _interopRequireDefault(_ShopReminder);
	
	var _BarberReminder = __webpack_require__(1044);
	
	var _BarberReminder2 = _interopRequireDefault(_BarberReminder);
	
	var _BarberUpdatedAppointment = __webpack_require__(1046);
	
	var _BarberUpdatedAppointment2 = _interopRequireDefault(_BarberUpdatedAppointment);
	
	var _BarberCanceledAppointment = __webpack_require__(1037);
	
	var _BarberCanceledAppointment2 = _interopRequireDefault(_BarberCanceledAppointment);
	
	var _ShopUpdatedAppointment = __webpack_require__(1142);
	
	var _ShopUpdatedAppointment2 = _interopRequireDefault(_ShopUpdatedAppointment);
	
	var _ShopCanceledAppointment = __webpack_require__(1135);
	
	var _ShopCanceledAppointment2 = _interopRequireDefault(_ShopCanceledAppointment);
	
	var _CustomerCanceledAppointment = __webpack_require__(1053);
	
	var _CustomerCanceledAppointment2 = _interopRequireDefault(_CustomerCanceledAppointment);
	
	var _CustomerUpdatedAppointment = __webpack_require__(1082);
	
	var _CustomerUpdatedAppointment2 = _interopRequireDefault(_CustomerUpdatedAppointment);
	
	var _CustomerLoyaltyInitiation = __webpack_require__(1062);
	
	var _CustomerLoyaltyInitiation2 = _interopRequireDefault(_CustomerLoyaltyInitiation);
	
	var _CustomerLoyaltyUpdate = __webpack_require__(1067);
	
	var _CustomerLoyaltyUpdate2 = _interopRequireDefault(_CustomerLoyaltyUpdate);
	
	var _CustomerLoyaltyGrant = __webpack_require__(1058);
	
	var _CustomerLoyaltyGrant2 = _interopRequireDefault(_CustomerLoyaltyGrant);
	
	var _CustomerAddedToWaitingList = __webpack_require__(1050);
	
	var _CustomerAddedToWaitingList2 = _interopRequireDefault(_CustomerAddedToWaitingList);
	
	var _CustomerWaitingListNewSlot = __webpack_require__(1086);
	
	var _CustomerWaitingListNewSlot2 = _interopRequireDefault(_CustomerWaitingListNewSlot);
	
	var _CustomerWaitingListPurged = __webpack_require__(1090);
	
	var _CustomerWaitingListPurged2 = _interopRequireDefault(_CustomerWaitingListPurged);
	
	var _CustomerWaitingListRemoved = __webpack_require__(1094);
	
	var _CustomerWaitingListRemoved2 = _interopRequireDefault(_CustomerWaitingListRemoved);
	
	var _CustomerUnpaidAppointment = __webpack_require__(1079);
	
	var _CustomerUnpaidAppointment2 = _interopRequireDefault(_CustomerUnpaidAppointment);
	
	var _BarberIgAuth = __webpack_require__(1038);
	
	var _BarberIgAuth2 = _interopRequireDefault(_BarberIgAuth);
	
	var _BarberIgAuthInstructions = __webpack_require__(1039);
	
	var _BarberIgAuthInstructions2 = _interopRequireDefault(_BarberIgAuthInstructions);
	
	var _CustomerNewAppointment3 = __webpack_require__(1097);
	
	var _CustomerNewAppointment4 = _interopRequireDefault(_CustomerNewAppointment3);
	
	var _CustomerAppointmentCancelled = __webpack_require__(1095);
	
	var _CustomerAppointmentCancelled2 = _interopRequireDefault(_CustomerAppointmentCancelled);
	
	var _CustomerAppointmentReminder = __webpack_require__(1096);
	
	var _CustomerAppointmentReminder2 = _interopRequireDefault(_CustomerAppointmentReminder);
	
	var _WidgetAnnouncement = __webpack_require__(1035);
	
	var _WidgetAnnouncement2 = _interopRequireDefault(_WidgetAnnouncement);
	
	var _MembershipLayout = __webpack_require__(1111);
	
	var _MembershipLayout2 = _interopRequireDefault(_MembershipLayout);
	
	var _MembershipCardExpiry = __webpack_require__(1113);
	
	var _MembershipCardExpiry2 = _interopRequireDefault(_MembershipCardExpiry);
	
	var _MembershipMigration = __webpack_require__(1114);
	
	var _MembershipMigration2 = _interopRequireDefault(_MembershipMigration);
	
	var _MembershipAgreement = __webpack_require__(1112);
	
	var _MembershipAgreement2 = _interopRequireDefault(_MembershipAgreement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// membership
	
	
	// flagship
	var NotificationsRoutes = function NotificationsRoutes() {
	  return _react2.default.createElement(
	    _reactRouter.Route,
	    { path: '/' },
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: 'brands/:brandRoute/notifications' },
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { component: _BasicLayout2.default },
	        _react2.default.createElement(_reactRouter.Route, { path: 'appointment-confirmation/:confirmationCode', component: _CustomerNewAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'reminder/:confirmationCode', component: _CustomerReminder2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'rebook/:confirmationCode', component: _CustomerRebook2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'appointment-canceled/:confirmationCode', component: _CustomerCanceledAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'appointment-updated/:confirmationCode', component: _CustomerUpdatedAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'unpaid-appointment/:confirmationCode', component: _CustomerUnpaidAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'barber-appointment/:confirmationCode', component: _BarberNewAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'barber-reminder/:confirmationCode', component: _BarberReminder2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'barber-updated/:confirmationCode', component: _BarberUpdatedAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'barber-canceled/:confirmationCode', component: _BarberCanceledAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'shop-appointment/:confirmationCode', component: _ShopNewAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'shop-reminder/:confirmationCode', component: _ShopReminder2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'shop-updated/:confirmationCode', component: _ShopUpdatedAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'shop-canceled/:confirmationCode', component: _ShopCanceledAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'receipt/:id/:transactionId', component: _Receipt2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'loyalty-initiation/:confirmationCode', component: _CustomerLoyaltyInitiation2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'loyalty-update/:confirmationCode', component: _CustomerLoyaltyUpdate2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'loyalty-grant/:confirmationCode/reward/:customerRewardId', component: _CustomerLoyaltyGrant2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'waiting-list-confirmed/:customerWaitingListId', component: _CustomerAddedToWaitingList2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'waiting-list-new-time-slot/:customerWaitingListId', component: _CustomerWaitingListNewSlot2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'waiting-list-purged/:customerWaitingListId', component: _CustomerWaitingListPurged2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'waiting-list-removed/:customerWaitingListId', component: _CustomerWaitingListRemoved2.default })
	      )
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: 'notifications' },
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { component: _BasicLayout2.default },
	        _react2.default.createElement(_reactRouter.Route, { path: 'appointment-confirmation/:confirmationCode', component: _CustomerNewAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'reminder/:confirmationCode', component: _CustomerReminder2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'rebook/:confirmationCode', component: _CustomerRebook2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'appointment-canceled/:confirmationCode', component: _CustomerCanceledAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'appointment-updated/:confirmationCode', component: _CustomerUpdatedAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'unpaid-appointment/:confirmationCode', component: _CustomerUnpaidAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'barber-appointment/:confirmationCode', component: _BarberNewAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'barber-reminder/:confirmationCode', component: _BarberReminder2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'barber-updated/:confirmationCode', component: _BarberUpdatedAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'barber-canceled/:confirmationCode', component: _BarberCanceledAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'shop-appointment/:confirmationCode', component: _ShopNewAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'shop-reminder/:confirmationCode', component: _ShopReminder2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'shop-updated/:confirmationCode', component: _ShopUpdatedAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'shop-canceled/:confirmationCode', component: _ShopCanceledAppointment2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'receipt/:id/:transactionId', component: _Receipt2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'loyalty-initiation/:confirmationCode', component: _CustomerLoyaltyInitiation2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'loyalty-update/:confirmationCode', component: _CustomerLoyaltyUpdate2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'loyalty-grant/:confirmationCode/reward/:customerRewardId', component: _CustomerLoyaltyGrant2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'waiting-list-confirmed/:customerWaitingListId', component: _CustomerAddedToWaitingList2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'waiting-list-new-time-slot/:customerWaitingListId', component: _CustomerWaitingListNewSlot2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'waiting-list-purged/:customerWaitingListId', component: _CustomerWaitingListPurged2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'waiting-list-removed/:customerWaitingListId', component: _CustomerWaitingListRemoved2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'flagship-appointment-confirmation/:confirmationCode', component: _CustomerNewAppointment4.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'flagship-appointment-reminder/:confirmationCode', component: _CustomerAppointmentReminder2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'flagship-appointment-cancellation/:confirmationCode', component: _CustomerAppointmentCancelled2.default })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { component: _IgAuthLayout2.default },
	        _react2.default.createElement(_reactRouter.Route, { path: 'barber-ig-auth', component: _BarberIgAuth2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'barber-ig-auth-instructions', component: _BarberIgAuthInstructions2.default })
	      ),
	      _react2.default.createElement(_reactRouter.Route, { path: 'widget-announcement/:brandId', component: _WidgetAnnouncement2.default }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { component: _MembershipLayout2.default },
	        _react2.default.createElement(_reactRouter.Route, { path: 'card-expiry', component: _MembershipCardExpiry2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'membership-migration', component: _MembershipMigration2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'membership-agreement', component: _MembershipAgreement2.default })
	      )
	    )
	  );
	};
	
	exports.default = NotificationsRoutes;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var BookCta = function BookCta(_ref) {
	  var appLink = _ref.appLink;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "u-mt-8 u-mb-6" },
	      _react2.default.createElement(
	        "a",
	        {
	          className: "u-text-large u-td-none u-dotted-border u-co-black u-fw-bold",
	          href: appLink,
	          target: "_blank"
	        },
	        "Book"
	      ),
	      "\xA0",
	      _react2.default.createElement(
	        "span",
	        { className: "u-text-large u-fw-bold" },
	        "your appointment",
	        _react2.default.createElement("br", null),
	        "again using our free app."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "u-flex" },
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button u-mr-4", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/google-play.png", alt: "" })
	      ),
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/app-store.png", alt: "" })
	      )
	    )
	  );
	};
	
	exports.default = BookCta;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var PostCtaAction = function PostCtaAction(_ref) {
	  var reservationLink = _ref.reservationLink;
	  return _react2.default.createElement(
	    "span",
	    null,
	    _react2.default.createElement(
	      "span",
	      { className: "u-text-small u-co-grey u-hide-on-mobile" },
	      "If you need to modify or cancel this appointment, view\xA0",
	      _react2.default.createElement(
	        "a",
	        {
	          className: "u-co-grey u-td-underline",
	          href: reservationLink,
	          target: "_blank",
	          rel: "noopener noreferrer"
	        },
	        "reservation"
	      ),
	      "."
	    ),
	    _react2.default.createElement(
	      "span",
	      { className: "u-text-small u-co-grey u-hide-on-desktop" },
	      "If you need to modify or cancel this",
	      _react2.default.createElement("br", null),
	      "appointment, view\xA0",
	      _react2.default.createElement(
	        "a",
	        {
	          className: "u-co-grey u-td-underline",
	          href: reservationLink,
	          target: "_blank",
	          rel: "noopener noreferrer"
	        },
	        "reservation"
	      ),
	      "."
	    )
	  );
	};
	
	exports.default = PostCtaAction;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var ReceiptCta = function ReceiptCta(_ref) {
	  var appointments = _ref.appointments,
	      appLink = _ref.appLink;
	  return _react2.default.createElement(
	    "div",
	    null,
	    appointments.length ? _react2.default.createElement(
	      "div",
	      { className: "u-mt-8 u-mb-6" },
	      _react2.default.createElement(
	        "a",
	        {
	          className: "u-text-large u-td-none u-dotted-border u-co-black u-fw-bold",
	          href: appLink,
	          target: "_blank"
	        },
	        "Change Payment"
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "u-text-large u-fw-bold" },
	        ","
	      ),
	      "\xA0",
	      _react2.default.createElement(
	        "a",
	        { className: "u-text-large u-td-none u-dotted-border u-co-black u-fw-bold", href: appLink, target: "_blank" },
	        "Modify Tip"
	      ),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "span",
	        { className: "u-text-large u-fw-bold" },
	        " or "
	      ),
	      _react2.default.createElement(
	        "a",
	        {
	          className: "u-text-large u-td-none u-dotted-border u-co-black u-fw-bold",
	          href: appLink,
	          target: "_blank"
	        },
	        "Book Next Appointment"
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "u-text-large u-fw-bold" },
	        _react2.default.createElement("br", null),
	        "using our free app."
	      )
	    ) : _react2.default.createElement(
	      "div",
	      { className: "u-mt-8 u-mb-6" },
	      _react2.default.createElement(
	        "a",
	        {
	          className: "u-text-large u-td-none u-dotted-border u-co-black u-fw-bold",
	          href: appLink,
	          target: "_blank"
	        },
	        "Book your next haircut"
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "u-text-large u-fw-bold" },
	        _react2.default.createElement("br", null),
	        "using our free app."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "u-flex" },
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button u-mr-4", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/google-play.png", alt: "" })
	      ),
	      _react2.default.createElement(
	        "a",
	        { className: "c-store-button", href: appLink, target: "_blank" },
	        _react2.default.createElement("img", { src: "https://squire-emails.s3-us-west-1.amazonaws.com/images/app-store.png", alt: "" })
	      )
	    )
	  );
	};
	
	exports.default = ReceiptCta;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Loader = function Loader() {
	  return _react2.default.createElement("div", { className: "Loader" });
	};
	
	exports.default = Loader;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPhoneNumberInput = __webpack_require__(786);
	
	var _reactPhoneNumberInput2 = _interopRequireDefault(_reactPhoneNumberInput);
	
	__webpack_require__(812);
	
	var _Loader = __webpack_require__(1119);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _metadataMin = __webpack_require__(500);
	
	var _metadataMin2 = _interopRequireDefault(_metadataMin);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _intl = __webpack_require__(300);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var PhoneInputComponent = function PhoneInputComponent(_ref) {
	  var send = _ref.send,
	      changePhoneNumber = _ref.changePhoneNumber,
	      isFetching = _ref.isFetching,
	      smsStatus = _ref.smsStatus,
	      shop = _ref.shop;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-nots-phone' },
	    isFetching && _react2.default.createElement(_Loader2.default, null),
	    smsStatus === 'error' && _react2.default.createElement(
	      'p',
	      { className: 'u-text-small u-co-error' },
	      'Oops! You\'re not mobile. Txt link instead.'
	    ),
	    smsStatus === 'success' && _react2.default.createElement(
	      'p',
	      { className: 'u-text-small u-co-success' },
	      'The link was sent successfully!'
	    ),
	    !isFetching && smsStatus === '' && _react2.default.createElement('div', { style: { width: '32px', height: '4px', marginBottom: '10px', marginTop: '32px' } }),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-nots-phone_input-wrapper' },
	      _react2.default.createElement(_reactPhoneNumberInput2.default, {
	        className: 'c-nots-phone_input',
	        metadata: _metadataMin2.default,
	        international: false,
	        country: (0, _intl.getCountryCodeByCountryAndCurrency)(shop) || 'US',
	        countryOptions: ['US', 'CA', 'GB', '...'],
	        onChange: changePhoneNumber,
	        flagsPath: 'https://flagicons.lipis.dev/flags/4x3/'
	      }),
	      _react2.default.createElement(
	        'button',
	        { className: 'c-nots-phone_submit-btn', onClick: send },
	        _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.SEND_ARROW })
	      )
	    )
	  );
	}; /* eslint-disable */
	exports.default = PhoneInputComponent;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _PhoneInputComponent = __webpack_require__(1120);
	
	var _PhoneInputComponent2 = _interopRequireDefault(_PhoneInputComponent);
	
	var _actions = __webpack_require__(278);
	
	var _extensions = __webpack_require__(95);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var PhoneInputComponentContainer = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    extension: (0, _extensions.getExtension)(state, ownProps.params.brandRoute),
	    sendAppLinkSms: _actions.sendAppLinkSms
	  };
	}), (0, _withState3.default)('phone', 'setPhone', null), (0, _withState3.default)('brandId', 'setBrandId', null), (0, _withState3.default)('smsStatus', 'setSmsStatus', ''), (0, _withState3.default)('isFetching', 'setIsFetching', false), (0, _withHandlers3.default)({
	  send: function send(props) {
	    return _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              props.setIsFetching(true);
	              props.setSmsStatus('');
	              _context.next = 4;
	              return props.sendAppLinkSms(props.brandId, props.phone);
	
	            case 4:
	              res = _context.sent;
	
	              if (!res.ok) {
	                props.setSmsStatus('error');
	              } else {
	                props.setSmsStatus('success');
	              }
	              props.setIsFetching(false);
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	  },
	  changePhoneNumber: function changePhoneNumber(props) {
	    return function (phone) {
	      props.setSmsStatus('');
	      props.setPhone('+' + phone);
	    };
	  }
	}), (0, _withPropsOnChange3.default)(['extension'], function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(props) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            props.setBrandId(props.extension.brandId);
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function (_x) {
	    return _ref2.apply(this, arguments);
	  };
	}()));
	
	exports.default = PhoneInputComponentContainer(_PhoneInputComponent2.default);

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function Card(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-vi-card' },
	    props.children
	  );
	};
	
	Card.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = Card;

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Center = function Center(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-vi-center' },
	    props.children
	  );
	};
	
	Center.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = Center;

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(20);
	
	__webpack_require__(1299);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GlobalWrapper = function GlobalWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-vi-global-wrapper' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement('meta', { name: 'viewport', content: 'width=670, initial-scale=1, maximum-scale=1' })
	    ),
	    children
	  );
	};
	
	GlobalWrapper.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = GlobalWrapper;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var H1 = exports.H1 = function H1(props) {
	  return _react2.default.createElement(
	    'h1',
	    { className: 'c-vi-header' },
	    props.children
	  );
	};
	
	var H2 = exports.H2 = function H2(props) {
	  return _react2.default.createElement(
	    'h2',
	    { className: 'c-vi-header' },
	    props.children
	  );
	};
	
	var H3 = exports.H3 = function H3(props) {
	  return _react2.default.createElement(
	    'h3',
	    { className: 'c-vi-header' },
	    props.children
	  );
	};
	
	var H4 = exports.H4 = function H4(props) {
	  return _react2.default.createElement(
	    'h4',
	    { className: 'c-vi-header' },
	    props.children
	  );
	};
	
	var H5 = exports.H5 = function H5(props) {
	  return _react2.default.createElement(
	    'h5',
	    { className: 'c-vi-header' },
	    props.children
	  );
	};
	
	var H6 = exports.H6 = function H6(props) {
	  return _react2.default.createElement(
	    'h6',
	    { className: 'c-vi-header' },
	    props.children
	  );
	};

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Large = function Large(props) {
	  return _react2.default.createElement(
	    'p',
	    { className: 'c-vi-large-text' },
	    props.children
	  );
	};
	
	Large.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = Large;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Logo = __webpack_require__(446);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _InnerFooter = __webpack_require__(445);
	
	var _InnerFooter2 = _interopRequireDefault(_InnerFooter);
	
	var _withBrandContextProvider = __webpack_require__(1105);
	
	var _withBrandContextProvider2 = _interopRequireDefault(_withBrandContextProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      brand = _ref.brand;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-vi-layout-wrapper' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      children
	    ),
	    _react2.default.createElement(_InnerFooter2.default, { shopName: brand && brand.name })
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  brand: _propTypes2.default.object.isRequired // eslint-disable-line react/forbid-prop-types
	};
	
	exports.default = (0, _withBrandContextProvider2.default)(Layout);

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Li = function Li(props) {
	  return _react2.default.createElement(
	    'p',
	    { className: 'c-vi-li' },
	    props.children
	  );
	};
	
	Li.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = Li;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Ol = function Ol(props) {
	  return _react2.default.createElement(
	    'p',
	    { className: 'c-vi-ol' },
	    props.children
	  );
	};
	
	Ol.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = Ol;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var P = function P(props) {
	  return _react2.default.createElement(
	    'p',
	    { className: 'c-vi-p' },
	    props.children
	  );
	};
	
	P.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = P;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pre = function Pre(props) {
	  return _react2.default.createElement(
	    'pre',
	    { className: 'c-vi-pre' },
	    props.children
	  );
	};
	
	Pre.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = Pre;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Spacer = function Spacer(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-vi-spacer', style: { height: props.height } },
	    props.children
	  );
	};
	
	Spacer.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  height: _propTypes2.default.string.isRequired
	};
	
	exports.default = Spacer;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InnerFooter = __webpack_require__(445);
	
	Object.defineProperty(exports, 'InnerFooter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InnerFooter).default;
	  }
	});
	
	var _Layout = __webpack_require__(1127);
	
	Object.defineProperty(exports, 'Layout', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Layout).default;
	  }
	});
	
	var _Logo = __webpack_require__(446);
	
	Object.defineProperty(exports, 'Logo', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Logo).default;
	  }
	});
	
	var _P = __webpack_require__(1130);
	
	Object.defineProperty(exports, 'P', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_P).default;
	  }
	});
	
	var _Ol = __webpack_require__(1129);
	
	Object.defineProperty(exports, 'Ol', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Ol).default;
	  }
	});
	
	var _Li = __webpack_require__(1128);
	
	Object.defineProperty(exports, 'Li', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Li).default;
	  }
	});
	
	var _Card = __webpack_require__(1122);
	
	Object.defineProperty(exports, 'Card', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Card).default;
	  }
	});
	
	var _Hr = __webpack_require__(444);
	
	Object.defineProperty(exports, 'Hr', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hr).default;
	  }
	});
	
	var _Pre = __webpack_require__(1131);
	
	Object.defineProperty(exports, 'Pre', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Pre).default;
	  }
	});
	
	var _Large = __webpack_require__(1126);
	
	Object.defineProperty(exports, 'Large', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Large).default;
	  }
	});
	
	var _Center = __webpack_require__(1123);
	
	Object.defineProperty(exports, 'Center', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Center).default;
	  }
	});
	
	var _Spacer = __webpack_require__(1132);
	
	Object.defineProperty(exports, 'Spacer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Spacer).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName,
	      barberName = _ref.barberName;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Appointment Canceled | ',
	        shopName
	      )
	    ),
	    barberName,
	    '\'s appointment was cancelled'
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1134);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _CustomerInfo = __webpack_require__(98);
	
	var _CustomerInfo2 = _interopRequireDefault(_CustomerInfo);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _utils = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var ShopCanceledAppointment = function ShopCanceledAppointment(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      confirmationCode = _ref.confirmationCode,
	      barber = _ref.barber,
	      service = _ref.service,
	      duration = _ref.duration,
	      dateShort = _ref.dateShort,
	      appointmentNote = _ref.appointmentNote;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name, barberName: barber.firstName, service: service, dateShort: dateShort }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      { danger: true },
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-12 u-mb-10' },
	        barber.firstName,
	        '\'s appointment with ',
	        customer.firstName,
	        ' ',
	        (customer.lastName || ' ')[0],
	        '. was canceled.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Canceled appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap u-mb-12' },
	        _react2.default.createElement(_AppointmentInfo2.default, {
	          cancel: true,
	          confirmationCode: confirmationCode,
	          customerName: customer.firstName + ' ' + customer.lastName,
	          barberName: barber.firstName + ' ' + (barber.lastName || ' ')[0],
	          service: service,
	          date: date,
	          duration: duration,
	          appointmentNote: appointmentNote,
	          shopLocation: shop.name
	        }),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_CustomerInfo2.default, {
	          customerName: customer.firstName + ' ' + customer.lastName,
	          customerNameShort: '' + (customer.firstName || ' ')[0] + (customer.lastName || ' ')[0],
	          customerPhoto: (0, _utils.getCustomerPhoto)(customer),
	          customerEmail: customer.email,
	          customerNotes: customer.notes,
	          customerPhone: customer.phone,
	          customerFirstName: customer.firstName
	        })
	      ),
	      _react2.default.createElement(_SquireInfo2.default, {
	        standalone: true,
	        reservationLink: _config2.default.commanderUrl + '/appointments',
	        shopName: shop.name,
	        supportLink: _config2.default.commanderUrl + '?intercom=true'
	      })
	    ),
	    _react2.default.createElement(_Footer2.default, { link: _config2.default.commanderUrl + '/settings' })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(ShopCanceledAppointment);

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName,
	      barberName = _ref.barberName,
	      service = _ref.service,
	      dateShort = _ref.dateShort;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'New Appointment | ',
	        shopName
	      )
	    ),
	    barberName,
	    ' has a new ',
	    service,
	    ' appointment ',
	    dateShort
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Totals = function Totals(_ref) {
	  var total = _ref.total;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-flex u-justify-content-space-between u-align-end' },
	    _react2.default.createElement(
	      'div',
	      { className: 'u-text-large u-fw-bold u-hide-on-mobile u-mt-5' },
	      'Total price'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-text-large u-fw-bold u-mt-1 u-hide-on-desktop' },
	      'Total price'
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'u-text-huge u-ta-right c-receipt-total--light'
	      },
	      _react2.default.createElement(
	        _Money2.default,
	        { noDecimalsIfInt: true },
	        total
	      )
	    )
	  );
	};
	
	exports.default = Totals;

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1136);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _CustomerInfo = __webpack_require__(98);
	
	var _CustomerInfo2 = _interopRequireDefault(_CustomerInfo);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Totals = __webpack_require__(1137);
	
	var _Totals2 = _interopRequireDefault(_Totals);
	
	var _utils = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var ShopNewAppointment = function ShopNewAppointment(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      confirmationCode = _ref.confirmationCode,
	      barber = _ref.barber,
	      service = _ref.service,
	      duration = _ref.duration,
	      dateShort = _ref.dateShort,
	      appointmentNote = _ref.appointmentNote,
	      total = _ref.total,
	      tip = _ref.tip;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name, barberName: barber.firstName, service: service, dateShort: dateShort }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-12 u-mb-10' },
	        barber.firstName,
	        ' has a new ',
	        service,
	        ' appointment ',
	        dateShort,
	        '.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-mb-10' },
	        _react2.default.createElement(_Totals2.default, { total: total, tip: tip || 0 })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'New appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap u-mb-12' },
	        _react2.default.createElement(_AppointmentInfo2.default, {
	          confirmationCode: confirmationCode,
	          customerName: customer.firstName + ' ' + customer.lastName,
	          barberName: barber.firstName + ' ' + (barber.lastName || ' ')[0],
	          service: service,
	          date: date,
	          duration: duration,
	          appointmentNote: appointmentNote,
	          shopLocation: shop.name
	        }),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_CustomerInfo2.default, {
	          customerName: customer.firstName + ' ' + customer.lastName,
	          customerNameShort: '' + (customer.firstName || ' ')[0] + (customer.lastName || ' ')[0],
	          customerPhoto: (0, _utils.getCustomerPhoto)(customer),
	          customerEmail: customer.email,
	          customerNotes: customer.notes,
	          customerPhone: customer.phone,
	          customerFirstName: customer.firstName
	        })
	      ),
	      _react2.default.createElement(_SquireInfo2.default, {
	        standalone: true,
	        reservationLink: _config2.default.commanderUrl + '/appointments',
	        shopName: shop.name,
	        supportLink: _config2.default.commanderUrl + '?intercom=true'
	      })
	    ),
	    _react2.default.createElement(_Footer2.default, { link: _config2.default.commanderUrl + '/settings' })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(ShopNewAppointment);

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName,
	      barberName = _ref.barberName,
	      service = _ref.service,
	      dateShort = _ref.dateShort;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Reminder | ',
	        shopName
	      )
	    ),
	    barberName,
	    ' has a ',
	    service,
	    ' appointment coming up ',
	    dateShort
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1139);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _CustomerInfo = __webpack_require__(98);
	
	var _CustomerInfo2 = _interopRequireDefault(_CustomerInfo);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _utils = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var ShopReminder = function ShopReminder(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      confirmationCode = _ref.confirmationCode,
	      barber = _ref.barber,
	      service = _ref.service,
	      duration = _ref.duration,
	      dateShort = _ref.dateShort,
	      appointmentNote = _ref.appointmentNote;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name, barberName: barber.firstName, service: service, dateShort: dateShort }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-12 u-mb-10' },
	        barber.firstName,
	        ' has a ',
	        service,
	        ' appointment coming up ',
	        dateShort,
	        '.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'New appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap u-mb-12' },
	        _react2.default.createElement(_AppointmentInfo2.default, {
	          confirmationCode: confirmationCode,
	          customerName: customer.firstName + ' ' + customer.lastName,
	          barberName: barber.firstName + ' ' + (barber.lastName || ' ')[0],
	          service: service,
	          date: date,
	          duration: duration,
	          appointmentNote: appointmentNote,
	          shopLocation: shop.name
	        }),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_CustomerInfo2.default, {
	          customerName: customer.firstName + ' ' + customer.lastName,
	          customerNameShort: '' + (customer.firstName || ' ')[0] + (customer.lastName || ' ')[0],
	          customerPhoto: (0, _utils.getCustomerPhoto)(customer),
	          customerEmail: customer.email,
	          customerNotes: customer.notes,
	          customerPhone: customer.phone,
	          customerFirstName: customer.firstName
	        })
	      ),
	      _react2.default.createElement(_SquireInfo2.default, {
	        standalone: true,
	        reservationLink: _config2.default.commanderUrl + '/appointments',
	        shopName: shop.name,
	        supportLink: _config2.default.commanderUrl + '?intercom=true'
	      })
	    ),
	    _react2.default.createElement(_Footer2.default, { link: _config2.default.commanderUrl + '/settings' })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(ShopReminder);

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var Header = function Header(_ref) {
	  var shopName = _ref.shopName,
	      barberName = _ref.barberName;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Appointment Updated | ',
	        shopName
	      )
	    ),
	    barberName,
	    '\'s appointment was updated'
	  );
	};
	
	exports.default = Header;

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentContainer = __webpack_require__(32);
	
	var _AppointmentContainer2 = _interopRequireDefault(_AppointmentContainer);
	
	var _Header = __webpack_require__(1141);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(33);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Logo = __webpack_require__(36);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AppointmentInfo = __webpack_require__(41);
	
	var _AppointmentInfo2 = _interopRequireDefault(_AppointmentInfo);
	
	var _SquireInfo = __webpack_require__(34);
	
	var _SquireInfo2 = _interopRequireDefault(_SquireInfo);
	
	var _withAppointmentNotification = __webpack_require__(37);
	
	var _withAppointmentNotification2 = _interopRequireDefault(_withAppointmentNotification);
	
	var _CustomerInfo = __webpack_require__(98);
	
	var _CustomerInfo2 = _interopRequireDefault(_CustomerInfo);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _utils = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var ShopUpdatedAppointment = function ShopUpdatedAppointment(_ref) {
	  var shop = _ref.shop,
	      date = _ref.date,
	      customer = _ref.customer,
	      confirmationCode = _ref.confirmationCode,
	      barber = _ref.barber,
	      service = _ref.service,
	      duration = _ref.duration,
	      dateShort = _ref.dateShort,
	      appointmentNote = _ref.appointmentNote;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, { shopName: shop.name, barberName: barber.firstName, service: service, dateShort: dateShort }),
	    _react2.default.createElement(
	      _AppointmentContainer2.default,
	      null,
	      _react2.default.createElement(_Logo2.default, null),
	      _react2.default.createElement(
	        'h2',
	        { className: 'u-text-huge u-fw-bold u-mt-12 u-mb-10' },
	        barber.firstName,
	        '\'s appointment with ',
	        customer.firstName,
	        ' ',
	        (customer.lastName || ' ')[0],
	        '. was updated.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4' },
	        'Updated appointment'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-space-between u-flex-wrap u-mb-12' },
	        _react2.default.createElement(_AppointmentInfo2.default, {
	          confirmationCode: confirmationCode,
	          customerName: customer.firstName + ' ' + customer.lastName,
	          barberName: barber.firstName + ' ' + (barber.lastName || ' ')[0],
	          service: service,
	          date: date,
	          duration: duration,
	          appointmentNote: appointmentNote,
	          shopLocation: shop.name
	        }),
	        _react2.default.createElement('div', { className: 'c-appointment-info-divider u-hide-on-desktop' }),
	        _react2.default.createElement(_CustomerInfo2.default, {
	          customerName: customer.firstName + ' ' + customer.lastName,
	          customerNameShort: '' + (customer.firstName || ' ')[0] + (customer.lastName || ' ')[0],
	          customerPhoto: (0, _utils.getCustomerPhoto)(customer),
	          customerEmail: customer.email,
	          customerNotes: customer.notes,
	          customerPhone: customer.phone,
	          customerFirstName: customer.firstName
	        })
	      ),
	      _react2.default.createElement(_SquireInfo2.default, {
	        standalone: true,
	        reservationLink: _config2.default.commanderUrl + '/appointments',
	        shopName: shop.name,
	        supportLink: _config2.default.commanderUrl + '?intercom=true'
	      })
	    ),
	    _react2.default.createElement(_Footer2.default, { link: _config2.default.commanderUrl + '/settings' })
	  );
	};
	
	exports.default = (0, _withAppointmentNotification2.default)(ShopUpdatedAppointment);

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Modal = __webpack_require__(93);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Input = __webpack_require__(266);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Passcode = function Passcode(_ref) {
	  var close = _ref.close,
	      onChange = _ref.onChange,
	      onSubmit = _ref.onSubmit,
	      passcode = _ref.passcode,
	      passcodeError = _ref.passcodeError;
	  return _react2.default.createElement(
	    _Modal2.default,
	    { title: 'Enter booking code', close: close },
	    _react2.default.createElement(
	      'form',
	      { className: 'layout layout--flush', onSubmit: onSubmit },
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-3/4' },
	        _react2.default.createElement(_Input2.default, {
	          type: 'text',
	          placeholder: 'Enter booking code',
	          className: 'u-mt0',
	          required: true,
	          value: passcode,
	          onChange: onChange
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-1/4' },
	        _react2.default.createElement(
	          'button',
	          { className: 'c-btn c-btn--default u-ph-', disabled: !passcode },
	          'Submit'
	        )
	      )
	    ),
	    passcodeError && _react2.default.createElement(
	      'p',
	      { className: 'u-co-red u-mt-' },
	      _react2.default.createElement(
	        'strong',
	        null,
	        passcodeError
	      )
	    )
	  );
	};
	
	Passcode.propTypes = {
	  close: _propTypes2.default.func.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  passcode: _propTypes2.default.string,
	  passcodeError: _propTypes2.default.string
	};
	
	Passcode.defaultProps = {
	  passcode: '',
	  passcodeError: ''
	};
	
	exports.default = Passcode;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _noop2 = __webpack_require__(145);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _selectors = __webpack_require__(27);
	
	var _selectors2 = __webpack_require__(1145);
	
	var _actions = __webpack_require__(447);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hideIfNotVisibleForBarber = (0, _branch3.default)(function (_ref) {
	  var barber = _ref.barber,
	      visibleFor = _ref.visibleFor;
	  return !barber || barber.route !== visibleFor && barber.id !== visibleFor;
	}, _renderNothing3.default);
	
	var withBarberFromProps = (0, _compose3.default)((0, _withProps3.default)(function (props) {
	  return {
	    close: props.hidePasscode
	  };
	}), (0, _withHandlers3.default)({
	  onSubmit: function onSubmit(props) {
	    return function (e) {
	      e.preventDefault();
	      props.setPasscode(props.passcode);
	      props.validatePasscode(props.barber.id, props.passcode).then(function (passcode) {
	        if (!passcode.valid && passcode.error) {
	          props.setPasscodeError(passcode.error);
	          return;
	        }
	
	        props.hidePasscode();
	        props.setPasscodePassed(props.barber);
	        props.router.push(props.link);
	      });
	    };
	  }
	}), hideIfNotVisibleForBarber);
	
	var withBarberFromRoute = (0, _compose3.default)((0, _reactRedux.connect)(function (state, ownProps) {
	  var barber = (0, _selectors.getBarberByRoute)(state, ownProps.params.barberRoute);
	  return {
	    barber: barber ? barber.toJS() : null,
	    isPassed: barber ? (0, _selectors2.getIsPassedByIdOrRoute)(state, barber.get('id')) : true
	  };
	}), (0, _branch3.default)(function (props) {
	  return !props.barber || props.isPassed;
	}, _renderNothing3.default), (0, _withPropsOnChange3.default)(['barber'], function (props) {
	  if (props.barber && props.barber.requirePasscode) {
	    props.showPasscode(props.barber.id);
	  }
	}), (0, _withProps3.default)(function () {
	  return {
	    close: _noop3.default
	  };
	}), (0, _withHandlers3.default)({
	  onSubmit: function onSubmit(props) {
	    return function (e) {
	      e.preventDefault();
	      props.setPasscode(props.passcode);
	      props.validatePasscode(props.barber.id, props.passcode).then(function (passcode) {
	        if (!passcode.valid && passcode.error) {
	          props.setPasscodeError(passcode.error);
	          return;
	        }
	
	        props.hidePasscode();
	        props.setPasscodePassed(props.barber);
	      });
	    };
	  }
	}), hideIfNotVisibleForBarber);
	
	exports.default = (0, _compose3.default)((0, _reactRedux.connect)(function (state) {
	  return {
	    visibleFor: (0, _selectors2.getIsVisible)(state)
	  };
	}, {
	  hidePasscode: _actions.hidePasscode,
	  showPasscode: _actions.showPasscode,
	  validatePasscode: _actions.validatePasscode,
	  setPasscodePassed: _actions.setPasscodePassed
	}), _reactRouter.withRouter, (0, _withState3.default)('passcode', 'setPasscode', ''), (0, _withState3.default)('passcodeError', 'setPasscodeError', ''), (0, _withHandlers3.default)({
	  onChange: function onChange(props) {
	    return function (e) {
	      return props.setPasscode(e.target.value);
	    };
	  }
	}), (0, _withPropsOnChange3.default)(['visibleFor'], function (props) {
	  if (!props.visibleFor) {
	    props.setPasscode('');
	    props.setPasscodeError('');
	  }
	}), (0, _lifecycle3.default)({
	  componentWillMount: function componentWillMount() {
	    this.props.hidePasscode();
	  }
	}), (0, _branch3.default)(function (props) {
	  return props.barber;
	}, withBarberFromProps, withBarberFromRoute));

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIsPassedByIdOrRoute = exports.getIsVisible = undefined;
	
	var _path2 = __webpack_require__(87);
	
	var _path3 = _interopRequireDefault(_path2);
	
	var _either2 = __webpack_require__(739);
	
	var _either3 = _interopRequireDefault(_either2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getIsVisible = exports.getIsVisible = (0, _path3.default)(['passcode', 'visibleFor']);
	var getIsPassedByIdOrRoute = exports.getIsPassedByIdOrRoute = function getIsPassedByIdOrRoute(state, idOrRoute) {
	  return (0, _either3.default)((0, _path3.default)(['passcode', 'byBarberId', idOrRoute]), (0, _path3.default)(['passcode', 'byBarberRoute', idOrRoute]))(state);
	};

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _actions = __webpack_require__(1147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Position = function (_Component) {
	  _inherits(Position, _Component);
	
	  function Position() {
	    _classCallCheck(this, Position);
	
	    return _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).apply(this, arguments));
	  }
	
	  _createClass(Position, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      navigator.geolocation.getCurrentPosition(function (position) {
	        _this2.props.setPosition({
	          lat: position.coords.latitude,
	          lng: position.coords.longitude
	        });
	      }, function (error) {
	        // eslint-disable-next-line no-console
	        console.log('Location unavailable: ', error);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Position;
	}(_react.Component);
	
	Position.propTypes = {
	  setPosition: _propTypes2.default.func.isRequired
	};
	
	var mapDispatchToProps = { setPosition: _actions.setPosition };
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(Position);

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setPosition = undefined;
	
	var _constants = __webpack_require__(450);
	
	// eslint-disable-next-line import/prefer-default-export
	var setPosition = exports.setPosition = function setPosition(position) {
	  return {
	    type: _constants.SET_POSITION,
	    payload: position
	  };
	};

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = reducer;
	
	var _constants = __webpack_require__(450);
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === _constants.SET_POSITION) return payload;
	  return state;
	}

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _map2 = __webpack_require__(74);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _Loader = __webpack_require__(82);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _GlobalErrorAndRedirectionListener = __webpack_require__(265);
	
	var _GlobalErrorAndRedirectionListener2 = _interopRequireDefault(_GlobalErrorAndRedirectionListener);
	
	var _selectors = __webpack_require__(452);
	
	var _helpers = __webpack_require__(7);
	
	var _actions = __webpack_require__(451);
	
	var _cardLogoAmericanexpress = __webpack_require__(1824);
	
	var _cardLogoAmericanexpress2 = _interopRequireDefault(_cardLogoAmericanexpress);
	
	var _cardLogoDiscover = __webpack_require__(1825);
	
	var _cardLogoDiscover2 = _interopRequireDefault(_cardLogoDiscover);
	
	var _cardLogoGeneric = __webpack_require__(1826);
	
	var _cardLogoGeneric2 = _interopRequireDefault(_cardLogoGeneric);
	
	var _cardLogoMastercard = __webpack_require__(1827);
	
	var _cardLogoMastercard2 = _interopRequireDefault(_cardLogoMastercard);
	
	var _cardLogoVisa = __webpack_require__(1828);
	
	var _cardLogoVisa2 = _interopRequireDefault(_cardLogoVisa);
	
	var _squireLogo = __webpack_require__(488);
	
	var _squireLogo2 = _interopRequireDefault(_squireLogo);
	
	var _squireLogoMonochrome = __webpack_require__(1829);
	
	var _squireLogoMonochrome2 = _interopRequireDefault(_squireLogoMonochrome);
	
	var _forhims = __webpack_require__(1823);
	
	var _forhims2 = _interopRequireDefault(_forhims);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReceiptTip = function ReceiptTip(_ref) {
	  var tip = _ref.tip;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(ReceiptItem, { name: 'Tip', amount: tip, alwaysShow: true }),
	    _react2.default.createElement('hr', { className: 'c-receipt__divider' })
	  );
	};
	ReceiptTip.propTypes = {
	  tip: _propTypes2.default.number.isRequired
	};
	ReceiptTip.defaultProps = {
	  tip: 0
	};
	
	var ReceiptType = function ReceiptType(_ref2) {
	  var terminalId = _ref2.terminalId,
	      last4 = _ref2.last4;
	
	  if (terminalId) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'o-tableize__content c-receipt__note' },
	      'Cardholder Payment Receipt'
	    );
	  }
	  if (last4) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'o-tableize__content c-receipt__note' },
	      'Card Payment Receipt'
	    );
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'o-tableize__content c-receipt__note' },
	    'Cash Payment Receipt'
	  );
	};
	ReceiptType.propTypes = {
	  terminalId: _propTypes2.default.string,
	  last4: _propTypes2.default.string
	};
	ReceiptType.defaultProps = {
	  terminalId: '',
	  last4: ''
	};
	
	var ReceiptItem = function ReceiptItem(_ref3) {
	  var name = _ref3.name,
	      amount = _ref3.amount,
	      negative = _ref3.negative,
	      alwaysShow = _ref3.alwaysShow,
	      total = _ref3.total;
	
	  if (!amount && !alwaysShow) return null;
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('c-receipt__item', { 'c-receipt__item--negative': negative }, { 'c-receipt__item--total': total })
	    },
	    _react2.default.createElement(
	      'div',
	      null,
	      name
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)({ 'c-receipt__value': total }) },
	      negative ? '-' : '',
	      _react2.default.createElement(
	        _Money2.default,
	        null,
	        amount
	      )
	    )
	  );
	};
	ReceiptItem.propTypes = {
	  name: _propTypes2.default.string,
	  amount: _propTypes2.default.number,
	  alwaysShow: _propTypes2.default.bool,
	  negative: _propTypes2.default.bool,
	  total: _propTypes2.default.bool
	};
	ReceiptItem.defaultProps = {
	  name: '',
	  amount: 0,
	  alwaysShow: false,
	  negative: false,
	  total: false
	};
	
	var cardBrandsImage = {
	  'American Express': _cardLogoAmericanexpress2.default,
	  Discover: _cardLogoDiscover2.default,
	  MasterCard: _cardLogoMastercard2.default,
	  Visa: _cardLogoVisa2.default
	};
	
	var year = new Date().getFullYear();
	
	var ReceiptComponent = function ReceiptComponent(_ref4) {
	  var receipt = _ref4.receipt,
	      loading = _ref4.loading;
	
	  var isDiscounted = receipt.discount > 0 || receipt.promo > 0;
	  var logo = (0, _get3.default)(receipt, 'shop.logo') ? (0, _get3.default)(receipt, 'shop.logo.url') : _squireLogo2.default;
	  var phoneFormatted = (0, _helpers.formatPhone)((0, _get3.default)(receipt, 'shop.phone', ''));
	  var showMultipleTaxes = (0, _get3.default)(receipt, 'taxes', []).length > 1;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('c-receipt-wrapper', { 'c-receipt-wrapper--ad': receipt.receiptAds })
	    },
	    _react2.default.createElement(_GlobalErrorAndRedirectionListener2.default, null),
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Receipt from: ',
	        (0, _get3.default)(receipt, 'shop.name', '')
	      )
	    ),
	    loading && _react2.default.createElement(_Loader2.default, null),
	    !loading && _react2.default.createElement(
	      'div',
	      { className: 'c-receipt' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-receipt-inner' },
	        _react2.default.createElement('div', { className: (0, _classnames2.default)('c-receipt__border', { 'c-receipt__border--ad': receipt.receiptAds })
	        }),
	        !!receipt.refunded && _react2.default.createElement(
	          'div',
	          { className: 'c-receipt__refund' },
	          _react2.default.createElement(
	            'div',
	            { className: 'c-receipt__refund-text' },
	            'Refunded'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-receipt__header' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'c-receipt__header-text c-receipt__header-text--shop' },
	              (0, _get3.default)(receipt, 'shop.name')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'c-receipt__header-text' },
	              (0, _get3.default)(receipt, 'shop.address.street', ''),
	              _react2.default.createElement('br', null),
	              (0, _get3.default)(receipt, 'shop.address.city', ''),
	              ',\xA0',
	              (0, _get3.default)(receipt, 'shop.address.state', ''),
	              ' ',
	              (0, _get3.default)(receipt, 'shop.address.zip', ''),
	              _react2.default.createElement('br', null),
	              (0, _get3.default)(receipt, 'shop.address.country', ''),
	              _react2.default.createElement('br', null),
	              phoneFormatted
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'c-receipt__header-logo' },
	            _react2.default.createElement('img', { src: logo, alt: 'logo', width: '95' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'o-tableize' },
	          _react2.default.createElement(
	            'div',
	            { className: 'o-tableize__cell' },
	            _react2.default.createElement(ReceiptType, {
	              terminalId: receipt.terminalId,
	              last4: receipt.last4
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'o-tableize__cell' },
	            _react2.default.createElement(
	              'div',
	              { className: 'o-tableize__content c-receipt__total' },
	              _react2.default.createElement(
	                _Money2.default,
	                null,
	                receipt.total
	              )
	            )
	          )
	        ),
	        (0, _map3.default)(receipt.items, function (item, idx) {
	          return _react2.default.createElement(
	            'div',
	            { key: item.barberName + '-' + idx },
	            _react2.default.createElement(
	              'span',
	              { className: 'c-receipt__barber' },
	              item.barberName
	            ),
	            _react2.default.createElement('br', null),
	            (0, _map3.default)(item.subItems, function (subitem, subIdx) {
	              return _react2.default.createElement(ReceiptItem, {
	                key: subitem.name + '-' + subIdx,
	                name: '+ ' + subitem.name,
	                amount: subitem.amount
	              });
	            })
	          );
	        }),
	        isDiscounted && _react2.default.createElement('hr', { className: 'c-receipt__divider c-receipt__divider--negative' }),
	        _react2.default.createElement(ReceiptItem, { name: 'Discount', amount: receipt.discount, negative: true }),
	        _react2.default.createElement(ReceiptItem, {
	          name: (receipt.isLoyaltyPromo ? 'Loyalty Reward' : 'Promo') + ' (' + receipt.promoCode + ')',
	          amount: receipt.promo,
	          negative: true
	        }),
	        _react2.default.createElement('hr', { className: (0, _classnames2.default)('c-receipt__divider', { 'c-receipt__divider--negative': isDiscounted }) }),
	        (0, _map3.default)(receipt.items, 'subItems').length > 1 && _react2.default.createElement(ReceiptItem, { name: 'Subtotal', amount: receipt.subtotal }),
	        showMultipleTaxes && (0, _map3.default)(receipt.taxes, function (tax) {
	          return _react2.default.createElement(ReceiptItem, { name: tax.name, amount: tax.amount });
	        }),
	        showMultipleTaxes && _react2.default.createElement(ReceiptItem, { name: 'Fees', amount: receipt.fee }),
	        !showMultipleTaxes && _react2.default.createElement(ReceiptItem, { name: 'Taxes & Fees', amount: receipt.taxAndFee }),
	        _react2.default.createElement(ReceiptTip, {
	          tip: receipt.tip
	        }),
	        _react2.default.createElement(ReceiptItem, { name: 'Total', amount: receipt.totalBeforeRefund, alwaysShow: true, total: true }),
	        !!receipt.refunded && _react2.default.createElement('hr', { className: 'c-receipt__divider c-receipt__divider' }),
	        _react2.default.createElement(ReceiptItem, { name: 'Refunded', amount: receipt.refunded, negative: true }),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-receipt__info' },
	          receipt.last4 && _react2.default.createElement(
	            'div',
	            { className: 'c-receipt__info-line c-receipt__info-line--tall' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Card'
	            ),
	            _react2.default.createElement('img', { src: cardBrandsImage[receipt.brand] || _cardLogoGeneric2.default, alt: 'card logo', width: '26', height: '26' })
	          ),
	          receipt.last4 && _react2.default.createElement(
	            'div',
	            { className: 'c-receipt__info-line' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Account'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              '**** **** **** ',
	              receipt.last4
	            )
	          ),
	          receipt.giftCardCode && _react2.default.createElement(
	            'div',
	            { className: 'c-receipt__info-line c-receipt__info-line--tall' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Gift Card'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              receipt.giftCardCode
	            )
	          ),
	          (0, _map3.default)(receipt.paymentDetails, function (value, key) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'c-receipt__info-line', key: key },
	              _react2.default.createElement(
	                'div',
	                null,
	                key
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                value
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-receipt__note c-receipt__note--black' },
	          'Please retain receipt!'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'o-tableize c-receipt__datetime' },
	          _react2.default.createElement(
	            'div',
	            { className: 'o-tableize__cell' },
	            _react2.default.createElement(
	              'div',
	              { className: 'o-tableize__content' },
	              receipt.createdAtTime
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'o-tableize__cell' },
	            _react2.default.createElement(
	              'div',
	              { className: 'o-tableize__content u-text-right' },
	              receipt.createdAtDate
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-receipt__info c-receipt__info--small' },
	          (0, _map3.default)(receipt.clearingDetails, function (value, key) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'c-receipt__info-line', key: key },
	              _react2.default.createElement(
	                'div',
	                null,
	                key
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                value
	              )
	            );
	          })
	        ),
	        _react2.default.createElement('div', { className: (0, _classnames2.default)('c-receipt__border', 'c-receipt__border--bottom', { 'c-receipt__border--ad': receipt.receiptAds })
	        }),
	        !receipt.receiptAds && _react2.default.createElement(
	          'div',
	          { className: 'c-receipt__footer' },
	          '\xA9 ',
	          year,
	          ' Squire Technologies, Inc.',
	          _react2.default.createElement('br', null),
	          '12 East 49th Street, #16-109',
	          _react2.default.createElement('br', null),
	          'New York, NY 10017',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://getsquire.com/privacy-policy.html', target: '_blank', rel: 'noopener noreferrer' },
	            'Squire Privacy Policy'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://getsquire.com/', target: '_blank', rel: 'noopener noreferrer' },
	            _react2.default.createElement('img', { className: 'u-mt', src: _squireLogoMonochrome2.default, width: '25', alt: '' })
	          )
	        )
	      )
	    ),
	    receipt.receiptAds && _react2.default.createElement(
	      'div',
	      { className: 'c-receipt__ad' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.forhims.com/squire', target: '_blank', rel: 'noopener noreferrer' },
	        _react2.default.createElement('img', { src: _forhims2.default, alt: 'forhims' })
	      )
	    )
	  );
	};
	ReceiptComponent.propTypes = {
	  receipt: _propTypes2.default.shape({
	    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({ name: _propTypes2.default.string, amount: _propTypes2.default.number })),
	    total: _propTypes2.default.number,
	    tip: _propTypes2.default.number,
	    taxAndFee: _propTypes2.default.number,
	    subtotal: _propTypes2.default.number,
	    promo: _propTypes2.default.number,
	    discount: _propTypes2.default.number
	  }),
	  loading: _propTypes2.default.bool.isRequired
	};
	ReceiptComponent.defaultProps = { receipt: {} };
	
	var Receipt = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    receipt: (0, _selectors.getReceipt)(state),
	    loading: (0, _selectors.getReceiptLoading)(state),
	    transactionIdentifier: ownProps.params.transactionIdentifier,
	    id: ownProps.params.id
	  };
	}, { fetchReceipt: _actions.fetchReceipt }), (0, _withHandlers3.default)({
	  fetchReceipt: function fetchReceipt(props) {
	    return function () {
	      return props.fetchReceipt(props.id, props.transactionIdentifier);
	    };
	  }
	}), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    this.props.fetchReceipt();
	  }
	}))(ReceiptComponent);
	
	exports.default = Receipt;

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(10);
	
	var receiptReducer = function receiptReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { item: {}, loading: false };
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case _constants.FETCH_RECEIPT:
	      return { item: {}, loading: true };
	    case _constants.FETCH_RECEIPT_SUCCESS:
	      return { item: payload, loading: false };
	    default:
	      return state;
	  }
	};
	
	exports.default = receiptReducer;

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = appReducer;
	
	var _immutable = __webpack_require__(66);
	
	var _constants = __webpack_require__(10);
	
	var DEFAULT_CONFIRM_TEXT = 'Back to home';
	var BAD_TIME_CONFIRM_TEXT = 'Choose another time';
	var FAILED_CHARGES_CONFIRM_TEXT = 'Close';
	
	var InitialState = (0, _immutable.Record)({
	  error_message: null,
	  redirect_to: null,
	  isFetching: false,
	  confirmButtonText: DEFAULT_CONFIRM_TEXT,
	  applePay: false,
	  thirdPartyPromotion: {}
	});
	
	var initialState = new InitialState();
	
	function appReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.REQUEST_CITIES:
	    case _constants.REQUEST_SHOP:
	    case _constants.REQUEST_BARBER:
	    case _constants.REQUEST_BARBERS:
	    case _constants.REQUEST_SERVICE:
	    case _constants.REQUEST_SERVICES:
	      return state.set('isFetching', true);
	
	    case _constants.RECEIVE_CITIES:
	    case _constants.RECEIVE_SHOP:
	    case _constants.RECEIVE_BARBER:
	    case _constants.RECEIVE_BARBERS:
	    case _constants.RECEIVE_SERVICE:
	    case _constants.RECEIVE_SERVICES:
	      return state.set('isFetching', false);
	
	    case _constants.MAINTENANCE_MODE:
	      return state.set('error_message', action.payload).set('confirmButtonText', 'OK');
	
	    case _constants.SET_ERROR_MESSAGE:
	      return state.set('error_message', action.error.message);
	
	    case _constants.CLEAR_ERROR:
	      return state.set('error_message', null);
	
	    case _constants.SET_REDIRECTION:
	      return state.set('redirect_to', action.payload);
	
	    case _constants.REQUEST_ERROR:
	      return state.set('error_message', action.payload).set('redirect_to', '/');
	
	    case _constants.BAD_ROUTE:
	      return state.withMutations(function (s) {
	        return s.set('isFetching', false).set('redirect_to', action.payload);
	      });
	
	    case _constants.CLEAR_REDIRECTION:
	      return state.set('redirect_to', null);
	
	    case _constants.TIME_UNAVAILABLE:
	      return state.withMutations(function (s) {
	        return s.set('error_message', action.payload.message).set('redirect_to', action.payload.redirect).set('confirmButtonText', BAD_TIME_CONFIRM_TEXT);
	      });
	
	    case _constants.FAILED_CHARGES:
	      return state.withMutations(function (s) {
	        return s.set('error_message', action.payload).set('confirmButtonText', FAILED_CHARGES_CONFIRM_TEXT);
	      });
	
	    case _constants.SET_APPLE_PAY:
	      return state.set('applePay', action.payload);
	
	    case _constants.THIRD_PARTY_PROMO:
	      return state.setIn(['thirdPartyPromotion'], action.payload);
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _actions = __webpack_require__(42);
	
	var _ReservationCanceled = __webpack_require__(1185);
	
	var _ReservationCanceled2 = _interopRequireDefault(_ReservationCanceled);
	
	var _selectors = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    appointment: (0, _selectors.getAppointment)(state),
	    barberName: (0, _selectors.getBarberName)(state),
	    serviceName: (0, _selectors.getServiceName)(state),
	    shop: (0, _selectors.getShop)(state),
	    customer: (0, _selectors.getCustomer)(state),
	    rebookLink: (0, _selectors.getRebookLink)(state),
	    scheduleLink: (0, _selectors.getScheduleLink)(state),
	    appointmentId: ownProps.params.appointmentId
	  };
	};
	
	var mapDispatchToProps = {
	  fetchReservation: _actions.fetchReservation,
	  clearReservations: _actions.clearReservations
	};
	
	exports.default = (0, _compose3.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _withHandlers3.default)({
	  fetchReservation: function fetchReservation(props) {
	    return function () {
	      return props.fetchReservation(props.appointmentId);
	    };
	  }
	}), (0, _lifecycle3.default)({
	  componentWillMount: function componentWillMount() {
	    this.props.fetchReservation();
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.props.clearReservations();
	  }
	}))(_ReservationCanceled2.default);

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(49);
	
	var _selectors = __webpack_require__(21);
	
	var _ViewReservation = __webpack_require__(457);
	
	var _ViewReservation2 = _interopRequireDefault(_ViewReservation);
	
	var _actions = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    reservationError: state.reservation.error,
	    appointment: (0, _selectors.getAppointment)(state),
	    barberName: (0, _selectors.getBarberName)(state),
	    serviceName: (0, _selectors.getServiceName)(state),
	    shop: (0, _selectors.getShop)(state),
	    customer: (0, _selectors.getCustomer)(state),
	    advanceCancelMins: (0, _selectors.getBarberAdvanceCancelMins)(state),
	    canCustomerCancel: (0, _selectors.getCanCustomerCancel)(state),
	    inFuture: (0, _selectors.getAppointmentInFuture)(state),
	    canceled: (0, _selectors.getAppointmentCanceled)(state),
	    rebookLink: (0, _selectors.getRebookLink)(state),
	    scheduleLink: (0, _selectors.getScheduleLink)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	  return (0, _redux.bindActionCreators)({
	    fetchReservation: _actions.fetchReservation.bind(null, ownProps.params.appointmentId),
	    cancelAppointment: _actions.cancelAppointment.bind(null, ownProps.params.appointmentId),
	    clearReservations: _actions.clearReservations
	  }, dispatch);
	};
	
	var redirectIfCanceled = (0, _compose3.default)(_reactRouter.withRouter, (0, _withPropsOnChange3.default)(['canceled', 'appointmentId'], function (props) {
	  if (props.params.appointmentId && props.canceled) {
	    props.router.replace('/appointment-canceled/' + props.params.appointmentId);
	  }
	}));
	
	var fetchPromoWhenCustomerHasId = (0, _compose3.default)((0, _withPropsOnChange3.default)(['customer'], function (props) {
	  var fetchPromo = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return (0, _actions.fetchThirdPartyPromoCode)(props.customer.id, props.params.appointmentId).then(function (data) {
	                if (data.length !== 0 && data[0].promo) {
	                  props.setPromoCode(data[0].promo);
	                }
	                props.setIsPromoRequested(true);
	              }).catch(function () {
	                props.setIsPromoRequested(true);
	              });
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function fetchPromo() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  if (props.customer.id && props.isPromoRequested === false) {
	    fetchPromo();
	  }
	}));
	
	exports.default = (0, _compose3.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), redirectIfCanceled, (0, _withState3.default)('isPromoRequested', 'setIsPromoRequested', false), (0, _withState3.default)('promoCode', 'setPromoCode', null), fetchPromoWhenCustomerHasId)(_ViewReservation2.default);

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApplePay = __webpack_require__(407);
	
	var _ApplePay2 = _interopRequireDefault(_ApplePay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pay = function Pay(_ref) {
	  var onClick = _ref.onClick;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-text-center u-pt' },
	    _react2.default.createElement(_ApplePay2.default, {
	      className: 'u-1/1 u-1/2-medium-and-up',
	      onClick: onClick
	    })
	  );
	};
	Pay.propTypes = {
	  onClick: _propTypes2.default.func
	};
	Pay.defaultProps = {
	  onClick: null
	};
	
	exports.default = Pay;

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _noop2 = __webpack_require__(145);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(93);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _squireLogoLight = __webpack_require__(309);
	
	var _squireLogoLight2 = _interopRequireDefault(_squireLogoLight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppointmentPaidModal = function AppointmentPaidModal() {
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      className: 'c-checkout-modal',
	      close: _noop3.default
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'c-checkout-modal__header' },
	      _react2.default.createElement('img', { src: _squireLogoLight2.default, alt: 'Squire' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-payment-modal-tip-grid' },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex-1 u-flex u-flex-column u-justify-content-space-between u-align-center u-mt' },
	        'You already submitted a payment for this appointment. Thank you.'
	      )
	    )
	  );
	};
	
	exports.default = AppointmentPaidModal;

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AskForEmailConsentModalContents = function AskForEmailConsentModalContents(_ref) {
	  var close = _ref.close,
	      shopName = _ref.shopName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'c-icon' },
	      _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.EMAIL })
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'heading' },
	      shopName,
	      ' wants to keep in touch!'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'u-text-extrasmall' },
	      'By clicking "Yes" below you agree to receive automated promotional email messages at the email at you provided.'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'u-text-extrasmall' },
	      'Consent is not a condition of purchase. View',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://getsquire.com/terms-of-service', target: '_blank', rel: 'noopener noreferrer' },
	        'Terms'
	      ),
	      ' ',
	      '&',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://getsquire.com/privacy-policy', target: '_blank', rel: 'noopener noreferrer' },
	        'Privacy'
	      ),
	      ' ',
	      'for more information.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-buttons-container' },
	      _react2.default.createElement(
	        'button',
	        { className: 'c-btn c-btn--primary', onClick: close(true) },
	        'Yes'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'c-btn c-btn--secondary', onClick: close(false) },
	        'Skip'
	      )
	    )
	  );
	};
	
	AskForEmailConsentModalContents.propTypes = {
	  close: _propTypes2.default.func.isRequired,
	  shopName: _propTypes2.default.string.isRequired
	};
	
	exports.default = AskForEmailConsentModalContents;

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _noop2 = __webpack_require__(145);
	
	var _noop3 = _interopRequireDefault(_noop2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AskForEmailConsentClass = function AskForEmailConsentClass(id, modalContents, passthroughProps) {
	  var _this = this;
	
	  _classCallCheck(this, AskForEmailConsentClass);
	
	  this.el = null;
	  this.modalRef = null;
	  this.resolvePromise = null;
	  this.promise = new Promise(function (resolve) {
	    _this.resolvePromise = resolve;
	  });
	
	  this.close = function (value) {
	    return function () {
	      _this.resolvePromise(value);
	      _this.unmount();
	    };
	  };
	
	  this.unmount = function () {
	    (0, _reactDom.unmountComponentAtNode)((0, _reactDom.findDOMNode)(_this.el));
	    document.body.removeChild(_this.el);
	  };
	
	  if (document.getElementById(id)) {
	    // eslint-disable-next-line no-console
	    console.error('Modal ' + id + ' already displayed!');
	  }
	
	  this.el = document.createElement('div');
	  this.el.id = id;
	
	  document.body.appendChild(this.el);
	
	  (0, _reactDom.render)(_react2.default.createElement(
	    'div',
	    { className: 'c-consent-modal-backdrop' },
	    _react2.default.createElement(
	      'div',
	      { className: 'c-modal c-consent-modal xis-hidden c-notifications', close: _noop3.default },
	      modalContents(_extends({ close: this.close }, passthroughProps))
	    )
	  ), this.el);
	};
	
	// eslint-disable-next-line arrow-body-style
	
	
	var AskForEmailConsent = function AskForEmailConsent(id, child, passthroughProps) {
	  return new AskForEmailConsentClass(id, child, passthroughProps).promise;
	};
	
	exports.default = AskForEmailConsent;

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AskForSMSConsentModalContents = function AskForSMSConsentModalContents(_ref) {
	  var close = _ref.close,
	      shopName = _ref.shopName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'c-icon' },
	      _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.SMS })
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'heading' },
	      shopName,
	      ' wants to keep in touch!'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'u-text-extrasmall' },
	      'By clicking "Yes" below you agree to receive automated promotional text messages at the mobile number you provided when booking your appointment.'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'u-text-extrasmall' },
	      'Consent is not a condition of purchase. Text HELP for help and STOP to cancel. Msg and data rates may apply and msg rate varies. Not all carriers covered. View',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://getsquire.com/terms-of-service', target: '_blank', rel: 'noopener noreferrer' },
	        'Terms'
	      ),
	      ' ',
	      '&',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://getsquire.com/privacy-policy', target: '_blank', rel: 'noopener noreferrer' },
	        'Privacy'
	      ),
	      ' ',
	      'for more information.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-buttons-container' },
	      _react2.default.createElement(
	        'button',
	        { className: 'c-btn c-btn--primary', onClick: close(true) },
	        'Yes'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'c-btn c-btn--secondary', onClick: close(false) },
	        'Skip'
	      )
	    )
	  );
	};
	
	AskForSMSConsentModalContents.propTypes = {
	  close: _propTypes2.default.func.isRequired,
	  shopName: _propTypes2.default.string.isRequired
	};
	
	exports.default = AskForSMSConsentModalContents;

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookingFee = function BookingFee(_ref) {
	  var fees = _ref.fees,
	      isChopMurrayHillShop = _ref.isChopMurrayHillShop;
	  return _react2.default.createElement(
	    'div',
	    null,
	    !isChopMurrayHillShop && _react2.default.createElement(
	      'div',
	      { className: 'c-order-info__desc' },
	      'Fees:'
	    ),
	    isChopMurrayHillShop && _react2.default.createElement(
	      'div',
	      { className: 'c-order-info__desc' },
	      'Fees:',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        { className: 'c-order-info__subtitle' },
	        '(only for Reserve & Pay)'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-order-info__price' },
	      _react2.default.createElement(
	        _Money2.default,
	        null,
	        fees
	      )
	    )
	  );
	};
	
	BookingFee.propTypes = {
	  fees: _propTypes2.default.number.isRequired,
	  isChopMurrayHillShop: _propTypes2.default.bool.isRequired
	};
	
	exports.default = (0, _compose3.default)((0, _branch3.default)(function (props) {
	  return !props.fees;
	}, _renderNothing3.default))(BookingFee);

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _sweetalertReact = __webpack_require__(132);
	
	var _sweetalertReact2 = _interopRequireDefault(_sweetalertReact);
	
	var _WithToggle = __webpack_require__(63);
	
	var _WithToggle2 = _interopRequireDefault(_WithToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BrokenReserveAndPayButton = function BrokenReserveAndPayButton(props) {
	  var on = props.on,
	      off = props.off,
	      toggled = props.toggled,
	      disabled = props.disabled,
	      confirmAndClose = props.confirmAndClose;
	
	
	  return _react2.default.createElement(
	    'button',
	    {
	      onClick: on,
	      className: 'c-btn c-btn--primary u-1/1 u-mb-',
	      disabled: disabled
	    },
	    'Reserve & Pay',
	    _react2.default.createElement(_sweetalertReact2.default, {
	      show: toggled,
	      title: 'Error',
	      text: 'Please use RESERVE button.',
	      type: 'error',
	      confirmButtonColor: '#009d92',
	      confirmButtonText: 'Reserve',
	      onEscapeKey: off,
	      onConfirm: confirmAndClose,
	      onCancel: off,
	      showCancelButton: true,
	      cancelButtonText: 'Close'
	    })
	  );
	};
	
	BrokenReserveAndPayButton.propTypes = {
	  on: _propTypes2.default.func.isRequired,
	  off: _propTypes2.default.func.isRequired,
	  toggled: _propTypes2.default.bool.isRequired,
	  disabled: _propTypes2.default.bool.isRequired,
	  confirmAndClose: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _compose3.default)(_WithToggle2.default, (0, _withHandlers3.default)({
	  confirmAndClose: function confirmAndClose(props) {
	    return function () {
	      props.off();
	      props.onConfirm();
	    };
	  }
	}))(BrokenReserveAndPayButton);

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sweetalertReact = __webpack_require__(132);
	
	var _sweetalertReact2 = _interopRequireDefault(_sweetalertReact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CancelAppointmentModal = function CancelAppointmentModal(_ref) {
	  var isOpen = _ref.isOpen,
	      closeModal = _ref.closeModal,
	      onConfirm = _ref.onConfirm;
	  return _react2.default.createElement(_sweetalertReact2.default, {
	    show: isOpen,
	    title: 'Cancel Appointment',
	    text: 'Do you really want to cancel this appointment?',
	    type: 'warning',
	    confirmButtonColor: '#dd6b55',
	    confirmButtonText: 'Yes, cancel appointment',
	    cancelButtonText: 'No',
	    onCancel: closeModal,
	    onEscapeKey: closeModal,
	    onConfirm: onConfirm,
	    showCancelButton: true
	  });
	};
	CancelAppointmentModal.propTypes = {
	  isOpen: _propTypes2.default.bool,
	  closeModal: _propTypes2.default.func.isRequired,
	  onConfirm: _propTypes2.default.func.isRequired
	};
	CancelAppointmentModal.defaultProps = {
	  isOpen: false
	};
	exports.default = CancelAppointmentModal;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CheckoutModal = __webpack_require__(291);
	
	var _CheckoutModal2 = _interopRequireDefault(_CheckoutModal);
	
	var _CheckoutModal3 = __webpack_require__(289);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckoutButton = function CheckoutButton(_ref) {
	  var disabled = _ref.disabled,
	      className = _ref.className,
	      panelLabel = _ref.panelLabel,
	      children = _ref.children,
	      on = _ref.on,
	      off = _ref.off,
	      formDisabled = _ref.formDisabled,
	      onSuccess = _ref.onSuccess,
	      toggled = _ref.toggled,
	      action = _ref.action,
	      showPromo = _ref.showPromo,
	      onBeforeOpen = _ref.onBeforeOpen,
	      onBeforeClose = _ref.onBeforeClose;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_CheckoutModal3.FontsPreloader, null),
	    _react2.default.createElement(
	      'button',
	      {
	        className: className,
	        type: 'button',
	        disabled: disabled || formDisabled,
	        onClick: on
	      },
	      children
	    ),
	    _react2.default.createElement(_CheckoutModal2.default, {
	      onSuccess: onSuccess,
	      off: off,
	      panelLabel: panelLabel,
	      toggled: toggled,
	      action: action,
	      showPromo: showPromo,
	      onBeforeOpen: onBeforeOpen,
	      onBeforeClose: onBeforeClose
	    })
	  );
	};
	
	CheckoutButton.propTypes = {
	  formDisabled: _propTypes2.default.bool.isRequired,
	  disabled: _propTypes2.default.bool.isRequired,
	  toggled: _propTypes2.default.bool.isRequired,
	  onSuccess: _propTypes2.default.func.isRequired,
	  className: _propTypes2.default.string,
	  panelLabel: _propTypes2.default.string,
	  children: _propTypes2.default.node.isRequired,
	  on: _propTypes2.default.func.isRequired,
	  off: _propTypes2.default.func.isRequired,
	  action: _propTypes2.default.string,
	  showPromo: _propTypes2.default.bool,
	  onBeforeOpen: _propTypes2.default.func,
	  onBeforeClose: _propTypes2.default.func
	};
	
	CheckoutButton.defaultProps = {
	  className: '',
	  action: '',
	  panelLabel: '',
	  showPromo: false,
	  onBeforeOpen: _helpers.nullFunc,
	  onBeforeClose: _helpers.nullFunc
	};
	
	exports.default = CheckoutButton;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(5);
	
	var _RescheduleLink = __webpack_require__(1210);
	
	var _RescheduleLink2 = _interopRequireDefault(_RescheduleLink);
	
	var _AddToCalendarButton = __webpack_require__(899);
	
	var _AddToCalendarButton2 = _interopRequireDefault(_AddToCalendarButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Controls = function Controls(_ref) {
	  var canceled = _ref.canceled,
	      inFuture = _ref.inFuture,
	      isCancelable = _ref.isCancelable,
	      cancelAppointment = _ref.cancelAppointment,
	      barberName = _ref.barberName,
	      serviceName = _ref.serviceName,
	      shop = _ref.shop,
	      customer = _ref.customer,
	      appointment = _ref.appointment,
	      rebookLink = _ref.rebookLink,
	      scheduleLink = _ref.scheduleLink,
	      clearReservations = _ref.clearReservations;
	
	  if (!canceled && inFuture) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      isCancelable && _react2.default.createElement(_RescheduleLink2.default, null),
	      isCancelable && _react2.default.createElement(
	        'button',
	        { onClick: cancelAppointment, className: 'c-btn c-btn--secondary u-1/1 u-mb--' },
	        'Cancel appointment'
	      ),
	      _react2.default.createElement(_AddToCalendarButton2.default, {
	        barberName: barberName,
	        serviceName: serviceName,
	        shop: shop,
	        customer: customer,
	        appointment: appointment
	      }),
	      _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          onClick: clearReservations,
	          to: scheduleLink,
	          className: 'c-btn c-btn--secondary u-1/1 u-mt--'
	        },
	        'Schedule another appointment'
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { to: rebookLink, className: 'c-btn c-btn--secondary u-1/1' },
	    'Rebook appointment'
	  );
	};
	Controls.propTypes = {
	  appointment: _propTypes2.default.shape({
	    start: _propTypes2.default.string,
	    formatted: _propTypes2.default.string,
	    duration: _propTypes2.default.number
	  }).isRequired,
	  barberName: _propTypes2.default.string,
	  serviceName: _propTypes2.default.string,
	  shop: _propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    address: _propTypes2.default.string,
	    zip: _propTypes2.default.string,
	    location: _propTypes2.default.shape({
	      lat: _propTypes2.default.number,
	      lng: _propTypes2.default.number
	    })
	  }).isRequired,
	  customer: _propTypes2.default.shape({
	    name: _propTypes2.default.string,
	    email: _propTypes2.default.string
	  }).isRequired,
	  inFuture: _propTypes2.default.bool,
	  canceled: _propTypes2.default.bool,
	  rebookLink: _propTypes2.default.string,
	  isCancelable: _propTypes2.default.bool.isRequired,
	  cancelAppointment: _propTypes2.default.func.isRequired,
	  scheduleLink: _propTypes2.default.string,
	  clearReservations: _propTypes2.default.func.isRequired
	};
	Controls.defaultProps = {
	  barberName: '',
	  serviceName: '',
	  inFuture: false,
	  canceled: true,
	  rebookLink: '/',
	  scheduleLink: '/'
	};
	
	exports.default = Controls;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactSimpleCurrency = __webpack_require__(386);
	
	var _reactSimpleCurrency2 = _interopRequireDefault(_reactSimpleCurrency);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Modal = __webpack_require__(93);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomTip = function CustomTip(_ref) {
	  var close = _ref.close,
	      onChange = _ref.onChange,
	      onSubmit = _ref.onSubmit,
	      tip = _ref.tip;
	  return _react2.default.createElement(
	    _Modal2.default,
	    { title: 'Custom tip', close: close },
	    _react2.default.createElement(
	      'form',
	      { className: 'layout layout--flush', onSubmit: onSubmit },
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-3/4' },
	        _react2.default.createElement(
	          'span',
	          { className: 'c-input-prefix' },
	          '$'
	        ),
	        _react2.default.createElement(_reactSimpleCurrency2.default, {
	          className: 'c-input c-input--prepend',
	          type: 'number',
	          min: '0',
	          placeholder: 'Enter tip amount',
	          required: true,
	          value: tip,
	          onInputChange: onChange
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-1/4' },
	        _react2.default.createElement(
	          'button',
	          { className: 'c-btn c-btn--default u-ph-', disabled: tip < 0 },
	          'Set tip'
	        )
	      )
	    )
	  );
	};
	CustomTip.propTypes = {
	  close: _propTypes2.default.func.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  tip: _propTypes2.default.number.isRequired
	};
	CustomTip.defaultProps = {};
	
	exports.default = CustomTip;

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pick = __webpack_require__(180);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSpinkit = __webpack_require__(90);
	
	var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);
	
	var _withNewCheckoutButton = __webpack_require__(294);
	
	var _withNewCheckoutButton2 = _interopRequireDefault(_withNewCheckoutButton);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	* Unfortunately there's no way to execute validations before showing stripe modal using react-stripe-checkout
	* This guarded button hides the original button and hits it via ref only in case validation is successful
	*/
	var GuardedCheckoutButton = function (_React$Component) {
	  _inherits(GuardedCheckoutButton, _React$Component);
	
	  function GuardedCheckoutButton(props) {
	    _classCallCheck(this, GuardedCheckoutButton);
	
	    var _this = _possibleConstructorReturn(this, (GuardedCheckoutButton.__proto__ || Object.getPrototypeOf(GuardedCheckoutButton)).call(this, props));
	
	    _this.onClick = function () {
	      _this.setState({ disabled: true });
	      _this.props.validate().then(function () {
	        _this.ref.click();
	      }).finally(function () {
	        return _this.setState({ disabled: false });
	      });
	    };
	
	    _this.getCheckoutButtonProps = function () {
	      var list = ['onSuccess', 'currency', 'amount', 'panelLabel', 'email'];
	      return (0, _pick2.default)(_this.props, list);
	    };
	
	    _this.setRef = function (ref) {
	      return _this.ref = ref;
	    };
	
	    _this.state = { disabled: false };
	    return _this;
	  }
	
	  _createClass(GuardedCheckoutButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _withNewCheckoutButton2.default,
	          Object.assign({}, this.getCheckoutButtonProps(), {
	            className: 'is-hidden',
	            action: this.props.action,
	            showPromo: this.props.showPromo,
	            onBeforeClose: this.props.onBeforeClose,
	            onBeforeOpen: this.props.onBeforeOpen
	          }),
	          _react2.default.createElement('span', { ref: this.setRef })
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            className: this.props.className,
	            disabled: this.props.disabled || this.state.disabled,
	            onClick: this.onClick
	          },
	          this.props.children,
	          this.state.disabled && _react2.default.createElement(_reactSpinkit2.default, { spinnerName: 'triple-bounce', noFadeIn: true })
	        )
	      );
	    }
	  }]);
	
	  return GuardedCheckoutButton;
	}(_react2.default.Component);
	
	GuardedCheckoutButton.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
	  validate: _propTypes2.default.func.isRequired,
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  showPromo: _propTypes2.default.bool,
	  onBeforeOpen: _propTypes2.default.func,
	  onBeforeClose: _propTypes2.default.func,
	  action: _propTypes2.default.string
	};
	
	GuardedCheckoutButton.defaultProps = {
	  className: '',
	  disabled: false,
	  showPromo: false,
	  onBeforeOpen: _helpers.nullFunc,
	  onBeforeClose: _helpers.nullFunc,
	  action: 'reserveAndPay'
	};
	
	exports.default = GuardedCheckoutButton;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ValidateAppointment = __webpack_require__(293);
	
	var _ValidateAppointment2 = _interopRequireDefault(_ValidateAppointment);
	
	var _WaitingListApplePay = __webpack_require__(1192);
	
	var _WaitingListApplePay2 = _interopRequireDefault(_WaitingListApplePay);
	
	var _WaitingListButton = __webpack_require__(1193);
	
	var _WaitingListButton2 = _interopRequireDefault(_WaitingListButton);
	
	var _ContactInformation = __webpack_require__(459);
	
	var _ContactInformation2 = _interopRequireDefault(_ContactInformation);
	
	var _notDesktop = __webpack_require__(415);
	
	var _notDesktop2 = _interopRequireDefault(_notDesktop);
	
	var _desktop = __webpack_require__(414);
	
	var _desktop2 = _interopRequireDefault(_desktop);
	
	var _OrderInformation = __webpack_require__(1198);
	
	var _OrderInformation2 = _interopRequireDefault(_OrderInformation);
	
	var _ReedemCode = __webpack_require__(1209);
	
	var _ReedemCode2 = _interopRequireDefault(_ReedemCode);
	
	var _Tip = __webpack_require__(1212);
	
	var _Tip2 = _interopRequireDefault(_Tip);
	
	var _ApplePay = __webpack_require__(458);
	
	var _ApplePay2 = _interopRequireDefault(_ApplePay);
	
	var _Pay = __webpack_require__(1199);
	
	var _Pay2 = _interopRequireDefault(_Pay);
	
	var _TermsOfService = __webpack_require__(1211);
	
	var _TermsOfService2 = _interopRequireDefault(_TermsOfService);
	
	var _ProcessingIndicator = __webpack_require__(292);
	
	var _ProcessingIndicator2 = _interopRequireDefault(_ProcessingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MakeReservation = function MakeReservation(_ref) {
	  var totalAmount = _ref.totalAmount,
	      bookNoPay = _ref.bookNoPay,
	      tipEnabled = _ref.tipEnabled,
	      userEmail = _ref.userEmail,
	      paymentEnabled = _ref.paymentEnabled,
	      handleReserveAndPay = _ref.handleReserveAndPay,
	      handleBookAndReserve = _ref.handleBookAndReserve,
	      handleReserve = _ref.handleReserve,
	      reservationTime = _ref.reservationTime,
	      noAutofill = _ref.noAutofill,
	      timeWaitingList = _ref.timeWaitingList,
	      addCustomerToWaitingList = _ref.addCustomerToWaitingList,
	      bookAndReserve = _ref.bookAndReserve,
	      bookAndPayCopy = _ref.bookAndPayCopy,
	      withApplePay = _ref.withApplePay,
	      noExtrasForBookNoPay = _ref.noExtrasForBookNoPay,
	      applePay = _ref.applePay,
	      applePayAddCustomerToWaitingList = _ref.applePayAddCustomerToWaitingList,
	      showPromo = _ref.showPromo;
	
	  var paymentOptions = !timeWaitingList && _react2.default.createElement(_Pay2.default, {
	    totalAmount: totalAmount,
	    bookNoPay: bookNoPay,
	    paymentEnabled: paymentEnabled,
	    email: userEmail,
	    handleReserveAndPay: handleReserveAndPay,
	    handleBookAndReserve: handleBookAndReserve,
	    handleReserve: handleReserve,
	    bookAndReserve: bookAndReserve,
	    showPromo: showPromo
	  });
	
	  var waitingListPaymentOptions = timeWaitingList && _react2.default.createElement(_WaitingListButton2.default, {
	    email: userEmail,
	    disabled: !paymentEnabled,
	    onSuccess: addCustomerToWaitingList
	  });
	
	  var noExtrasPaymentOptions = noExtrasForBookNoPay && paymentOptions || null;
	  var noExtrasWaitingListPaymentOptions = noExtrasForBookNoPay && !withApplePay && waitingListPaymentOptions || null;
	
	  var regularPaymentOptions = !noExtrasForBookNoPay && paymentOptions || null;
	  var regularWaitingListPaymentOptions = !noExtrasForBookNoPay && !withApplePay && waitingListPaymentOptions || null;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-mt' },
	    _react2.default.createElement(_ValidateAppointment2.default, null),
	    _react2.default.createElement(
	      _notDesktop2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'c-heading u--mt u-co-teal-blue' },
	        'Appointment time:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-heading c-heading--large u-mb' },
	        reservationTime
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'layout layout--flush' },
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-2/3-small-plus-and-up' },
	        _react2.default.createElement(_ContactInformation2.default, { noAutofill: noAutofill }),
	        _react2.default.createElement(
	          'div',
	          { className: 'u-type--semibold epsilon u-co-black-2' },
	          timeWaitingList && _react2.default.createElement(
	            'p',
	            null,
	            'Your credit/debit card is required in order to be placed on the waiting list. If there is an opening you will receive a text message with the time and a reservation link, You will have 10 minutes to accept the reservation by clicking the link in the text message. If the particular time does not work for you, simply ignore the text message. Your credit card will NOT be charged unless you accept a reservation by click on the link in the text message.'
	          ),
	          !timeWaitingList && _react2.default.createElement(
	            'p',
	            { className: 'u-text-justify' },
	            bookAndPayCopy
	          ),
	          _react2.default.createElement(_TermsOfService2.default, null)
	        ),
	        _react2.default.createElement(_Tip2.default, { showOnApplePay: true }),
	        !timeWaitingList && _react2.default.createElement(_ApplePay2.default, { onClick: function onClick() {
	            return applePay();
	          } }),
	        timeWaitingList && _react2.default.createElement(_WaitingListApplePay2.default, { onClick: applePayAddCustomerToWaitingList })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item u-1/3-small-plus-and-up' },
	        _react2.default.createElement(
	          'div',
	          { className: 'u-mt+ small-plus-and-up-ml+ small-plus-and-up-pl small-plus-and-up-mt0' },
	          _react2.default.createElement(_OrderInformation2.default, null),
	          totalAmount && _react2.default.createElement(_ReedemCode2.default, null),
	          noExtrasPaymentOptions,
	          noExtrasWaitingListPaymentOptions
	        )
	      ),
	      tipEnabled && _react2.default.createElement(
	        _notDesktop2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'layout__item u-2/3-small-plus-and-up' },
	          _react2.default.createElement(_Tip2.default, null)
	        )
	      ),
	      _react2.default.createElement(
	        _notDesktop2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'layout__item u-1/3-small-plus-and-up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'u-pl0 small-plus-and-up-pl u-ml0 small-plus-and-up-ml+ u-mt+ small-and-up-mt0' },
	            regularPaymentOptions,
	            regularWaitingListPaymentOptions
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _desktop2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'layout layout--flush medium-and-up-mt' },
	        _react2.default.createElement(
	          'div',
	          { className: 'layout__item u-2/3' },
	          _react2.default.createElement(_Tip2.default, null)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'layout__item u-1/3' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'u-ml+ u-pl',
	              style: { marginTop: 59 }
	            },
	            regularPaymentOptions,
	            regularWaitingListPaymentOptions
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _ProcessingIndicator2.default,
	      null,
	      'Processing order'
	    )
	  );
	};
	
	MakeReservation.propTypes = {
	  totalAmount: _propTypes2.default.number,
	  bookNoPay: _propTypes2.default.bool,
	  tipEnabled: _propTypes2.default.bool,
	  handleReserveAndPay: _propTypes2.default.func,
	  handleBookAndReserve: _propTypes2.default.func,
	  handleReserve: _propTypes2.default.func,
	  paymentEnabled: _propTypes2.default.bool,
	  userEmail: _propTypes2.default.string,
	  reservationTime: _propTypes2.default.string,
	  noAutofill: _propTypes2.default.bool,
	  timeWaitingList: _propTypes2.default.bool.isRequired,
	  addCustomerToWaitingList: _propTypes2.default.func.isRequired,
	  bookAndReserve: _propTypes2.default.bool,
	  bookAndPayCopy: _propTypes2.default.string,
	  withApplePay: _propTypes2.default.bool.isRequired,
	  noExtrasForBookNoPay: _propTypes2.default.bool.isRequired,
	  applePay: _propTypes2.default.func.isRequired,
	  applePayAddCustomerToWaitingList: _propTypes2.default.func.isRequired,
	  showPromo: _propTypes2.default.bool.isRequired
	};
	
	MakeReservation.defaultProps = {
	  totalAmount: 0,
	  bookNoPay: false,
	  tipEnabled: false,
	  paymentEnabled: false,
	  userEmail: '',
	  handleReserveAndPay: null,
	  handleBookAndReserve: null,
	  handleReserve: null,
	  applePay: null,
	  reservationTime: '',
	  noAutofill: false,
	  bookAndReserve: false,
	  bookAndPayCopy: ''
	};
	
	exports.default = MakeReservation;

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CancelAppointmentModal = __webpack_require__(1161);
	
	var _CancelAppointmentModal2 = _interopRequireDefault(_CancelAppointmentModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modals = function Modals(_ref) {
	  var confirmModal = _ref.confirmModal,
	      closeConfirmModal = _ref.closeConfirmModal,
	      cancelAppointment = _ref.cancelAppointment;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_CancelAppointmentModal2.default, {
	      isOpen: confirmModal.open,
	      closeModal: closeConfirmModal,
	      onConfirm: cancelAppointment
	    })
	  );
	};
	Modals.propTypes = {
	  confirmModal: _propTypes2.default.shape({ open: _propTypes2.default.bool }).isRequired,
	  closeConfirmModal: _propTypes2.default.func.isRequired,
	  cancelAppointment: _propTypes2.default.func.isRequired
	};
	exports.default = Modals;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Promo = __webpack_require__(1206);
	
	var _Promo2 = _interopRequireDefault(_Promo);
	
	var _PromoTidal = __webpack_require__(1180);
	
	var _PromoTidal2 = _interopRequireDefault(_PromoTidal);
	
	var _PromoModal = __webpack_require__(1178);
	
	var _PromoModal2 = _interopRequireDefault(_PromoModal);
	
	var _OnlyPrepayError = __webpack_require__(909);
	
	var _OnlyPrepayError2 = _interopRequireDefault(_OnlyPrepayError);
	
	var _BrokenReserveAndPayButton = __webpack_require__(1160);
	
	var _BrokenReserveAndPayButton2 = _interopRequireDefault(_BrokenReserveAndPayButton);
	
	var _ReserveAndPayButton = __webpack_require__(1187);
	
	var _ReserveAndPayButton2 = _interopRequireDefault(_ReserveAndPayButton);
	
	var _GuardedCheckoutButton = __webpack_require__(1197);
	
	var _GuardedCheckoutButton2 = _interopRequireDefault(_GuardedCheckoutButton);
	
	var _TrackClick = __webpack_require__(424);
	
	var _TrackClick2 = _interopRequireDefault(_TrackClick);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	var _tidalLogoWhite = __webpack_require__(308);
	
	var _tidalLogoWhite2 = _interopRequireDefault(_tidalLogoWhite);
	
	var _helpers = __webpack_require__(7);
	
	var _flags = __webpack_require__(200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/sort-comp */
	
	
	var Pay = function (_React$Component) {
	  _inherits(Pay, _React$Component);
	
	  function Pay(props) {
	    _classCallCheck(this, Pay);
	
	    var _this = _possibleConstructorReturn(this, (Pay.__proto__ || Object.getPrototypeOf(Pay)).call(this, props));
	
	    _this.state = {
	      showPromoModal: false,
	      isBookAndReserve: false,
	      isTurnstileChallengeVisible: false
	    };
	
	    _this.setReserveRef = function (ref) {
	      return _this.reserveRef = ref;
	    };
	
	    _this.setBookAndPayRef = function (ref) {
	      return _this.bookAndPayRef = ref;
	    };
	
	    _this.setReserveWithCardRef = function (ref) {
	      return _this.reserveWithCardRef = ref;
	    };
	
	    _this.bookAndPay = function () {
	      if (_this.bookAndPayRef) {
	        _this.bookAndPayRef.click();
	      }
	    };
	
	    _this.onBrokenReserveConfirm = function () {
	      if (_this.props.isReserveWithCardAvailable && _this.reserveWithCardRef) {
	        _this.reserveWithCardRef.click();
	        return;
	      }
	
	      if (_this.props.isReserveNoPayAvailable && _this.reserveRef) {
	        _this.reserveRef.click();
	      }
	    };
	
	    _this.closePromoModal = _this.closePromoModal.bind(_this);
	    _this.handleReserve = _this.props.handleReserve.bind(_this);
	    _this.handleBookAndReserve = _this.props.handleBookAndReserve.bind(_this);
	    return _this;
	  }
	
	  _createClass(Pay, [{
	    key: 'getVisibleElements',
	    value: function getVisibleElements() {
	      return {
	        reserve: !!this.reserveRef,
	        bookAndPay: !!this.bookAndPayRef,
	        reserveWithCard: !!this.reserveWithCardRef
	      };
	    }
	  }, {
	    key: 'checkForActivePromo',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var isBookAndReserve = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        var shouldRequestTurnstile, _ref2, success, token;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (this.props.thirdPartyPromo.active) {
	                  _context.next = 25;
	                  break;
	                }
	
	                if (!isBookAndReserve) {
	                  _context.next = 3;
	                  break;
	                }
	
	                return _context.abrupt('return', this.handleBookAndReserve());
	
	              case 3:
	                _context.next = 5;
	                return (0, _flags.getFlag)('check-if-human');
	
	              case 5:
	                shouldRequestTurnstile = _context.sent;
	
	                if (shouldRequestTurnstile) {
	                  _context.next = 8;
	                  break;
	                }
	
	                return _context.abrupt('return', this.handleReserve());
	
	              case 8:
	
	                this.setState({ isTurnstileChallengeVisible: true });
	                _context.next = 11;
	                return (0, _helpers.wait)(10);
	
	              case 11:
	                _context.next = 13;
	                return (0, _helpers.renderTurnstileChallenge)('#turnstile');
	
	              case 13:
	                _ref2 = _context.sent;
	                success = _ref2.success;
	                token = _ref2.token;
	
	                if (success) {
	                  _context.next = 21;
	                  break;
	                }
	
	                _context.next = 19;
	                return (0, _helpers.wait)(3000);
	
	              case 19:
	                // let users contemplate their browsing history for a while
	                this.setState({ isTurnstileChallengeVisible: false });
	                return _context.abrupt('return', null);
	
	              case 21:
	                _context.next = 23;
	                return (0, _helpers.wait)(1000);
	
	              case 23:
	                // pending-to-success animation
	                this.setState({ isTurnstileChallengeVisible: false });
	
	                return _context.abrupt('return', this.handleReserve(token));
	
	              case 25:
	
	                this.setState({ showPromoModal: true });
	                return _context.abrupt('return', null);
	
	              case 27:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function checkForActivePromo() {
	        return _ref.apply(this, arguments);
	      }
	
	      return checkForActivePromo;
	    }()
	  }, {
	    key: 'closePromoModal',
	    value: function closePromoModal() {
	      this.setState({ showPromoModal: false });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _BookingAnalytics2.default.buttonsActive(_extends({}, this.getVisibleElements(), { shop: this.props.shop }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          paymentEnabled = _props.paymentEnabled,
	          handleReserveAndPay = _props.handleReserveAndPay,
	          handleBookAndReserve = _props.handleBookAndReserve,
	          isKrwnZazzPlaceSteFoyShop = _props.isKrwnZazzPlaceSteFoyShop,
	          isReserveAndPayAvailable = _props.isReserveAndPayAvailable,
	          isReserveWithCardAvailable = _props.isReserveWithCardAvailable,
	          isReserveNoPayAvailable = _props.isReserveNoPayAvailable,
	          isProcessAvailable = _props.isProcessAvailable,
	          thirdPartyPromo = _props.thirdPartyPromo,
	          isLadyClipperShop = _props.isLadyClipperShop,
	          currency = _props.currency,
	          totalAmount = _props.totalAmount,
	          email = _props.email,
	          shop = _props.shop;
	
	
	      var allowBookAndReserve = shop.allowBookAndReserve;
	
	      var paymentModalReserveAndPay = _react2.default.createElement(_ReserveAndPayButton2.default, Object.assign({}, this.props, {
	        handleReserveAndPay: handleReserveAndPay,
	        currency: currency,
	        totalAmount: totalAmount,
	        email: email,
	        paymentEnabled: paymentEnabled,
	        isLadyClipperShop: isLadyClipperShop,
	        title: 'I want the 2 free months, I\'ll reserve with card now',
	        showPromo: thirdPartyPromo.active,
	        onBeforeClose: function onBeforeClose() {
	          return _this2.setState({ showPromoModal: false });
	        }
	      }));
	
	      var paymentModalCustomReserve = isReserveWithCardAvailable ? _react2.default.createElement(
	        _TrackClick2.default,
	        { method: 'reserveAndPay' },
	        _react2.default.createElement(
	          _GuardedCheckoutButton2.default,
	          Object.assign({}, this.props, {
	            action: 'reserveAndPay',
	            onSuccess: handleBookAndReserve,
	            currency: currency,
	            amount: totalAmount,
	            email: email,
	            disabled: !paymentEnabled,
	            panelLabel: 'Reserve',
	            className: 'c-btn c-btn--secondary delta u-1/1',
	            onBeforeClose: function onBeforeClose() {
	              return _this2.setState({ showPromoModal: false });
	            }
	          }),
	          _react2.default.createElement(
	            'span',
	            { ref: this.setReserveWithCardRef },
	            'I just want to reserve'
	          )
	        )
	      ) : null;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', { className: 'is-hidden preload', src: _tidalLogoWhite2.default, alt: 'PROMO' }),
	        isReserveAndPayAvailable && !isKrwnZazzPlaceSteFoyShop && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ReserveAndPayButton2.default, Object.assign({}, this.props, {
	            handleReserveAndPay: handleReserveAndPay,
	            currency: currency,
	            totalAmount: totalAmount,
	            email: email,
	            paymentEnabled: paymentEnabled,
	            isLadyClipperShop: isLadyClipperShop,
	            showPromo: thirdPartyPromo.active,
	            title: !allowBookAndReserve ? 'Reserve With Card' : undefined
	          })),
	          thirdPartyPromo.active && _react2.default.createElement(_Promo2.default, {
	            title: 'And get 2 free months of TIDAL - a $20 value',
	            component: _react2.default.createElement(_PromoTidal2.default, { payButton: function payButton() {
	                return _react2.default.createElement(_ReserveAndPayButton2.default, Object.assign({}, _this2.props, {
	                  handleReserveAndPay: handleReserveAndPay,
	                  currency: currency,
	                  totalAmount: totalAmount,
	                  email: email,
	                  paymentEnabled: paymentEnabled,
	                  isLadyClipperShop: isLadyClipperShop,
	                  showPromo: thirdPartyPromo.active,
	                  onBeforeClose: function onBeforeClose() {
	                    return _this2.setState({ showPromoModal: false });
	                  },
	                  title: !allowBookAndReserve ? 'Reserve With Card' : undefined
	                }));
	              }
	            })
	          })
	        ),
	        isProcessAvailable && !isKrwnZazzPlaceSteFoyShop && _react2.default.createElement(
	          _TrackClick2.default,
	          { method: 'reserveAndPay' },
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'c-btn c-btn--primary u-1/1 u-mb-',
	              onClick: handleReserveAndPay,
	              disabled: !paymentEnabled
	            },
	            'Process'
	          )
	        ),
	        isReserveAndPayAvailable && isKrwnZazzPlaceSteFoyShop && _react2.default.createElement(_BrokenReserveAndPayButton2.default, {
	          disabled: !paymentEnabled,
	          onConfirm: this.onBrokenReserveConfirm
	        }),
	        isReserveWithCardAvailable && thirdPartyPromo.active && _react2.default.createElement(
	          _TrackClick2.default,
	          { method: 'reserveAndProvideCard' },
	          _react2.default.createElement(
	            'button',
	            {
	              onClick: function onClick() {
	                return _this2.checkForActivePromo(true);
	              },
	              className: 'c-btn c-btn--secondary delta u-1/1',
	              disabled: !paymentEnabled
	            },
	            'Reserve'
	          )
	        ),
	        isReserveWithCardAvailable && !thirdPartyPromo.active && _react2.default.createElement(
	          _TrackClick2.default,
	          { method: 'reserveAndPay' },
	          _react2.default.createElement(
	            _GuardedCheckoutButton2.default,
	            Object.assign({}, this.props, {
	              className: 'c-btn c-btn--secondary delta u-1/1',
	              onSuccess: handleBookAndReserve,
	              currency: currency,
	              amount: totalAmount,
	              email: email,
	              action: 'reserveAndPay',
	              panelLabel: 'Reserve',
	              disabled: !paymentEnabled,
	              onBeforeClose: function onBeforeClose() {
	                return _this2.setState({ showPromoModal: false });
	              }
	            }),
	            _react2.default.createElement(
	              'span',
	              { ref: this.setReserveWithCardRef },
	              'Reserve'
	            )
	          )
	        ),
	        isReserveNoPayAvailable && _react2.default.createElement(
	          _TrackClick2.default,
	          { method: 'reserve' },
	          _react2.default.createElement(
	            'button',
	            {
	              onClick: function onClick() {
	                return _this2.checkForActivePromo(false);
	              },
	              className: 'c-btn c-btn--secondary delta u-1/1 u-pos-relative',
	              disabled: !paymentEnabled
	            },
	            _react2.default.createElement(
	              'span',
	              { ref: this.setReserveRef },
	              'Reserve'
	            ),
	            this.state.isTurnstileChallengeVisible && _react2.default.createElement('div', { className: 'c-turnstile-modal', id: 'turnstile' })
	          ),
	          _react2.default.createElement(_OnlyPrepayError2.default, { onConfirm: this.bookAndPay })
	        ),
	        this.state.showPromoModal && _react2.default.createElement(_PromoModal2.default, {
	          closeModal: this.closePromoModal,
	          handleReserve: isReserveWithCardAvailable ? this.handleBookAndReserve : this.handleReserve,
	          reserveAndPayButton: paymentModalReserveAndPay,
	          customReserveButton: paymentModalCustomReserve
	        })
	      );
	    }
	  }]);
	
	  return Pay;
	}(_react2.default.Component);
	
	Pay.propTypes = {
	  handleReserveAndPay: _propTypes2.default.func,
	  handleBookAndReserve: _propTypes2.default.func,
	  handleReserve: _propTypes2.default.func,
	  paymentEnabled: _propTypes2.default.bool,
	  isKrwnZazzPlaceSteFoyShop: _propTypes2.default.bool.isRequired,
	  isReserveAndPayAvailable: _propTypes2.default.bool,
	  isReserveWithCardAvailable: _propTypes2.default.bool,
	  isReserveNoPayAvailable: _propTypes2.default.bool,
	  isLadyClipperShop: _propTypes2.default.bool.isRequired,
	  isProcessAvailable: _propTypes2.default.bool,
	  thirdPartyPromo: _propTypes2.default.shape({ active: _propTypes2.default.bool }),
	  shop: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
	  email: _propTypes2.default.string,
	  totalAmount: _propTypes2.default.number,
	  currency: _propTypes2.default.string.isRequired
	};
	
	Pay.defaultProps = {
	  handleReserveAndPay: null,
	  handleBookAndReserve: null,
	  handleReserve: null,
	  paymentEnabled: false,
	  isReserveAndPayAvailable: false,
	  isReserveWithCardAvailable: false,
	  isReserveNoPayAvailable: false,
	  isProcessAvailable: false,
	  thirdPartyPromo: { active: false },
	  totalAmount: 0,
	  email: ''
	};
	
	exports.default = Pay;

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSpinkit = __webpack_require__(90);
	
	var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _shapes = __webpack_require__(23);
	
	var _helpers = __webpack_require__(7);
	
	var _ErrorMsg = __webpack_require__(410);
	
	var _ErrorMsg2 = _interopRequireDefault(_ErrorMsg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReedemCode = function ReedemCode(_ref) {
	  var handleSubmit = _ref.handleSubmit,
	      isFetching = _ref.isFetching,
	      error = _ref.error,
	      isValid = _ref.isValid,
	      promoCode = _ref.promoCode,
	      onChange = _ref.onChange,
	      submitEnabled = _ref.submitEnabled,
	      hasLoyaltyProgram = _ref.hasLoyaltyProgram,
	      hasPromotions = _ref.hasPromotions,
	      giftCardEnabled = _ref.giftCardEnabled,
	      inputDisabled = _ref.inputDisabled,
	      remainingGiftCardBalance = _ref.remainingGiftCardBalance,
	      hasGiftCardBalance = _ref.hasGiftCardBalance;
	
	  var promoLabel = function () {
	    var labels = [];
	    if (hasLoyaltyProgram) labels.push('Loyalty');
	    if (giftCardEnabled) labels.push('Gift Card');
	    labels.push('Promo');
	    var separator = labels.length > 2 ? '/' : ' or ';
	    return '' + labels.join(separator);
	  }();
	
	  if (!hasPromotions) return null;
	
	  return _react2.default.createElement(
	    'form',
	    {
	      className: 'c-payment-modal-promo',
	      onSubmit: handleSubmit
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'u-mb-- u-mt-- u-hide-for-small-and-down' },
	      error && _react2.default.createElement(
	        _ErrorMsg2.default,
	        null,
	        error
	      ),
	      hasGiftCardBalance && _react2.default.createElement(
	        'div',
	        { className: 'c-heading epsilon u-type--bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Remaining balance:'
	        ),
	        '\xA0',
	        _react2.default.createElement(
	          _Money2.default,
	          null,
	          remainingGiftCardBalance
	        )
	      ),
	      !error && !hasGiftCardBalance && _react2.default.createElement('div', { style: { height: '20px' } })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-flex' },
	      _react2.default.createElement('input', {
	        className: (0, _classnames2.default)('c-payment-modal-promo__input', { 'c-payment-modal-promo__input--empty': !promoCode }),
	        value: promoCode,
	        onChange: onChange,
	        disabled: inputDisabled,
	        placeholder: promoLabel
	      }),
	      _react2.default.createElement(
	        'button',
	        {
	          className: 'c-payment-modal-promo__submit',
	          disabled: !submitEnabled || isFetching,
	          type: 'submit'
	        },
	        isValid && 'Change',
	        !isValid && !isFetching && 'Redeem',
	        isFetching && _react2.default.createElement(_reactSpinkit2.default, { name: 'three-bounce', className: 'c-checkout-modal__spinner', noFadeIn: true })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-mt-- u-mb-- u-hide-for-medium-and-up' },
	      error && _react2.default.createElement(
	        _ErrorMsg2.default,
	        null,
	        error
	      ),
	      hasGiftCardBalance && _react2.default.createElement(
	        'div',
	        { className: 'c-heading epsilon u-type--bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Remaining balance:'
	        ),
	        '\xA0',
	        _react2.default.createElement(
	          _Money2.default,
	          null,
	          remainingGiftCardBalance
	        )
	      )
	    )
	  );
	};
	ReedemCode.propTypes = {
	  handleSubmit: _shapes.handler,
	  isFetching: _shapes.flag,
	  error: _propTypes2.default.string,
	  isValid: _shapes.flag,
	  promoCode: _propTypes2.default.string,
	  onChange: _shapes.handler,
	  submitEnabled: _shapes.flag.isRequired,
	  hasLoyaltyProgram: _shapes.flag,
	  hasPromotions: _shapes.flag,
	  giftCardEnabled: _shapes.flag,
	  inputDisabled: _shapes.flag,
	  remainingGiftCardBalance: _propTypes2.default.number.isRequired,
	  hasGiftCardBalance: _shapes.flag.isRequired
	};
	ReedemCode.defaultProps = {
	  hasLoyaltyProgram: false,
	  hasPromotions: true,
	  handleSubmit: _helpers.nullFunc,
	  isFetching: false,
	  error: '',
	  isValid: false,
	  promoCode: '',
	  onChange: _helpers.nullFunc,
	  giftCardEnabled: false,
	  inputDisabled: false
	};
	
	exports.default = ReedemCode;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSpinkit = __webpack_require__(90);
	
	var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _InputZip = __webpack_require__(411);
	
	var _InputZip2 = _interopRequireDefault(_InputZip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable jsx-a11y/label-has-for */
	var PaymentForm = function PaymentForm(_ref) {
	  var amount = _ref.amount,
	      panelLabel = _ref.panelLabel,
	      submit = _ref.submit,
	      formDisabled = _ref.formDisabled,
	      cardNumber = _ref.cardNumber,
	      cardExpiry = _ref.cardExpiry,
	      cardCvc = _ref.cardCvc,
	      zipCode = _ref.zipCode,
	      setCardNumber = _ref.setCardNumber,
	      setCardExpiry = _ref.setCardExpiry,
	      setCardCvc = _ref.setCardCvc,
	      setZipCode = _ref.setZipCode,
	      cardBrand = _ref.cardBrand,
	      cardBrandIcon = _ref.cardBrandIcon,
	      payFacInputErrors = _ref.payFacInputErrors,
	      hasErrors = _ref.hasErrors,
	      payFacInputsDisabled = _ref.payFacInputsDisabled,
	      isCoveredByDiscount = _ref.isCoveredByDiscount,
	      hasApplePay = _ref.hasApplePay,
	      toggleApplePay = _ref.toggleApplePay,
	      shopCountry = _ref.shopCountry,
	      cardNumberBlur = _ref.cardNumberBlur,
	      cardExpiryBlur = _ref.cardExpiryBlur,
	      cardCvcBlur = _ref.cardCvcBlur,
	      zipCodeBlur = _ref.zipCodeBlur,
	      setCardExpiryRef = _ref.setCardExpiryRef,
	      setCardCvcRef = _ref.setCardCvcRef,
	      setZipCodeRef = _ref.setZipCodeRef,
	      submitEnabled = _ref.submitEnabled;
	  return _react2.default.createElement(
	    'form',
	    {
	      className: (0, _classnames2.default)('c-card-information u-flex u-flex-column', { 'c-card-information--discounted': isCoveredByDiscount }),
	      onSubmit: submit
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'c-payment-modal-heading u-mb' },
	      'Payment Information'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-flex-1 u-flex u-flex-column u-justify-content-space-between' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { className: 'c-checkout-modal__input-label u-mb', id: 'cardNumberInputLabel' },
	          _react2.default.createElement(
	            'div',
	            null,
	            'Card Number'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'PayFacElement PayFacCardNumberElement u-position-relative' },
	            cardBrandIcon && cardBrand !== 'unknown' && _react2.default.createElement(
	              'span',
	              { className: 'c-checkout-modal__card-number-brand' },
	              _react2.default.createElement('img', { src: cardBrandIcon, alt: cardBrand })
	            ),
	            cardBrand === 'unknown' && _react2.default.createElement(
	              'span',
	              { className: 'c-checkout-modal__card-number-brand c-checkout-modal__card-number-brand_default' },
	              _react2.default.createElement('img', { src: cardBrandIcon, alt: cardBrand })
	            ),
	            _react2.default.createElement('input', {
	              id: 'payFacCardNumberInput',
	              placeholder: 'Card Number',
	              value: cardNumber,
	              onChange: setCardNumber,
	              onBlur: cardNumberBlur,
	              disabled: payFacInputsDisabled,
	              className: (0, _classnames2.default)({ 'is-invalid': payFacInputErrors.cardNumber })
	            })
	          ),
	          payFacInputErrors.cardNumber && _react2.default.createElement(
	            'div',
	            { className: 'c-checkout-modal__input-error u-co-red' },
	            payFacInputErrors.cardNumber
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-checkout-modal__input-group u-mb--' },
	          _react2.default.createElement(
	            'label',
	            { className: 'c-checkout-modal__input-label' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Exp. Date'
	            ),
	            _react2.default.createElement('input', {
	              id: 'payFacCardExpiryInput',
	              placeholder: 'MM/YY',
	              value: cardExpiry,
	              onChange: setCardExpiry,
	              onBlur: cardExpiryBlur,
	              ref: setCardExpiryRef,
	              disabled: payFacInputsDisabled,
	              className: (0, _classnames2.default)('PayFacElement', { 'is-invalid': payFacInputErrors.cardExpiry })
	            }),
	            payFacInputErrors.cardExpiry && _react2.default.createElement(
	              'div',
	              { className: 'c-checkout-modal__input-error u-co-red' },
	              payFacInputErrors.cardExpiry
	            )
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'c-checkout-modal__input-label' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'CVC'
	            ),
	            _react2.default.createElement('input', {
	              id: 'payFacCardCvcInput',
	              placeholder: 'CVC',
	              value: cardCvc,
	              onChange: setCardCvc,
	              onBlur: cardCvcBlur,
	              ref: setCardCvcRef,
	              disabled: payFacInputsDisabled,
	              className: (0, _classnames2.default)('PayFacElement', { 'is-invalid': payFacInputErrors.cardCvc })
	            }),
	            payFacInputErrors.cardCvc && _react2.default.createElement(
	              'div',
	              { className: 'c-checkout-modal__input-error u-co-red' },
	              payFacInputErrors.cardCvc
	            )
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'c-checkout-modal__input-label' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'ZIP / Postal'
	            ),
	            _react2.default.createElement(_InputZip2.default, {
	              country: shopCountry,
	              id: 'payFacZipCodeInput',
	              placeholder: 'ZIP/Postal Code',
	              value: zipCode,
	              onChange: setZipCode,
	              disabled: formDisabled || payFacInputsDisabled,
	              onBlur: zipCodeBlur,
	              setRef: setZipCodeRef,
	              className: (0, _classnames2.default)('PayFacElement', { 'is-invalid': payFacInputErrors.zipCode })
	            }),
	            payFacInputErrors.zipCode && _react2.default.createElement(
	              'div',
	              { className: 'c-checkout-modal__input-error c-checkout-modal__input-error_top u-co-red' },
	              payFacInputErrors.zipCode
	            )
	          )
	        )
	      ),
	      !isCoveredByDiscount && _react2.default.createElement(
	        'button',
	        { className: 'c-button', disabled: !submitEnabled || formDisabled || hasErrors },
	        formDisabled ? _react2.default.createElement(_reactSpinkit2.default, { name: 'three-bounce', className: 'c-checkout-modal__spinner', noFadeIn: true }) : _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            panelLabel,
	            '\xA0',
	            Number(amount) && _react2.default.createElement(
	              _Money2.default,
	              null,
	              amount
	            )
	          )
	        )
	      ),
	      isCoveredByDiscount && _react2.default.createElement(
	        'button',
	        { className: 'c-button' },
	        'Process'
	      ),
	      !isCoveredByDiscount && hasApplePay && _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'c-btn-link c-btn-link--small u-mt- u-co-black-3 u-font-weight-normal',
	          onClick: toggleApplePay
	        },
	        'Or pay with Apple pay'
	      )
	    )
	  );
	};
	
	PaymentForm.propTypes = {
	  formDisabled: _propTypes2.default.bool.isRequired,
	  amount: _propTypes2.default.number.isRequired,
	  submit: _propTypes2.default.func.isRequired,
	  panelLabel: _propTypes2.default.string,
	  setCardNumber: _propTypes2.default.func.isRequired,
	  setCardExpiry: _propTypes2.default.func.isRequired,
	  setCardCvc: _propTypes2.default.func.isRequired,
	  setZipCode: _propTypes2.default.func.isRequired,
	  cardNumber: _propTypes2.default.string.isRequired,
	  cardExpiry: _propTypes2.default.string.isRequired,
	  cardCvc: _propTypes2.default.string.isRequired,
	  zipCode: _propTypes2.default.string.isRequired,
	  cardBrand: _propTypes2.default.string.isRequired,
	  cardBrandIcon: _propTypes2.default.string.isRequired,
	  payFacInputErrors: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
	  hasErrors: _propTypes2.default.bool.isRequired,
	  payFacInputsDisabled: _propTypes2.default.bool.isRequired,
	  isCoveredByDiscount: _propTypes2.default.bool.isRequired,
	  hasApplePay: _propTypes2.default.bool,
	  toggleApplePay: _propTypes2.default.func,
	  shopCountry: _propTypes2.default.string.isRequired,
	  cardNumberBlur: _propTypes2.default.func.isRequired,
	  cardExpiryBlur: _propTypes2.default.func.isRequired,
	  cardCvcBlur: _propTypes2.default.func.isRequired,
	  zipCodeBlur: _propTypes2.default.func.isRequired,
	  setCardExpiryRef: _propTypes2.default.func.isRequired,
	  setCardCvcRef: _propTypes2.default.func.isRequired,
	  setZipCodeRef: _propTypes2.default.func.isRequired,
	  submitEnabled: _propTypes2.default.bool.isRequired
	};
	
	PaymentForm.defaultProps = {
	  panelLabel: 'Pay',
	  hasApplePay: true,
	  toggleApplePay: function toggleApplePay() {}
	};
	
	exports.default = PaymentForm;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSpinkit = __webpack_require__(90);
	
	var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _visa = __webpack_require__(496);
	
	var _visa2 = _interopRequireDefault(_visa);
	
	var _mastercard = __webpack_require__(494);
	
	var _mastercard2 = _interopRequireDefault(_mastercard);
	
	var _amex = __webpack_require__(490);
	
	var _amex2 = _interopRequireDefault(_amex);
	
	var _discover = __webpack_require__(492);
	
	var _discover2 = _interopRequireDefault(_discover);
	
	var _diners = __webpack_require__(491);
	
	var _diners2 = _interopRequireDefault(_diners);
	
	var _jcb = __webpack_require__(493);
	
	var _jcb2 = _interopRequireDefault(_jcb);
	
	var _unionpay = __webpack_require__(495);
	
	var _unionpay2 = _interopRequireDefault(_unionpay);
	
	var _default = __webpack_require__(489);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _InputZip = __webpack_require__(411);
	
	var _InputZip2 = _interopRequireDefault(_InputZip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable jsx-a11y/label-has-for */
	var brandIcons = {
	  visa: _visa2.default,
	  mastercard: _mastercard2.default,
	  amex: _amex2.default,
	  discover: _discover2.default,
	  diners: _diners2.default,
	  jcb: _jcb2.default,
	  unionpay: _unionpay2.default,
	  unknown: _default2.default
	};
	
	var PaymentForm = function PaymentForm(_ref) {
	  var amount = _ref.amount,
	      panelLabel = _ref.panelLabel,
	      submit = _ref.submit,
	      formDisabled = _ref.formDisabled,
	      zipCode = _ref.zipCode,
	      setZipCode = _ref.setZipCode,
	      cardNumberId = _ref.cardNumberId,
	      cardExpiryId = _ref.cardExpiryId,
	      cardCvcId = _ref.cardCvcId,
	      zipCodeId = _ref.zipCodeId,
	      cardBrand = _ref.cardBrand,
	      stripeInputErrors = _ref.stripeInputErrors,
	      hasErrors = _ref.hasErrors,
	      isCoveredByDiscount = _ref.isCoveredByDiscount,
	      hasApplePay = _ref.hasApplePay,
	      toggleApplePay = _ref.toggleApplePay,
	      shopCountry = _ref.shopCountry,
	      zipCodeBlur = _ref.zipCodeBlur,
	      submitEnabled = _ref.submitEnabled,
	      title = _ref.title,
	      buttonLabel = _ref.buttonLabel;
	  return _react2.default.createElement(
	    'form',
	    {
	      className: (0, _classnames2.default)('c-card-information u-flex u-flex-column', { 'c-card-information--discounted': isCoveredByDiscount }),
	      onSubmit: submit
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'c-payment-modal-heading u-mb' },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-flex-1 u-flex u-flex-column u-justify-content-space-between' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { className: 'c-checkout-modal__input-label u-mb', id: 'cardNumberInputLabel' },
	          _react2.default.createElement(
	            'div',
	            null,
	            'Card Number'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'StripeElement StripeCardNumberElement u-position-relative' },
	            brandIcons[cardBrand] && cardBrand !== 'unknown' && _react2.default.createElement(
	              'span',
	              { className: 'c-checkout-modal__card-number-brand' },
	              _react2.default.createElement('img', { src: brandIcons[cardBrand], alt: cardBrand })
	            ),
	            (!brandIcons[cardBrand] || cardBrand === 'unknown') && _react2.default.createElement(
	              'span',
	              { className: 'c-checkout-modal__card-number-brand c-checkout-modal__card-number-brand_default' },
	              _react2.default.createElement('img', { src: brandIcons.unknown, alt: cardBrand })
	            ),
	            _react2.default.createElement('div', { id: cardNumberId })
	          ),
	          stripeInputErrors.cardNumber && _react2.default.createElement(
	            'div',
	            { className: 'c-checkout-modal__input-error u-co-red' },
	            stripeInputErrors.cardNumber
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-checkout-modal__input-group u-mb--' },
	          _react2.default.createElement(
	            'label',
	            { className: 'c-checkout-modal__input-label' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Exp. Date'
	            ),
	            _react2.default.createElement('div', { id: cardExpiryId, className: 'StripeElement' }),
	            stripeInputErrors.cardExpiry && _react2.default.createElement(
	              'div',
	              { className: 'c-checkout-modal__input-error u-co-red' },
	              stripeInputErrors.cardExpiry
	            )
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'c-checkout-modal__input-label' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'CVC'
	            ),
	            _react2.default.createElement('div', { id: cardCvcId, className: 'StripeElement' }),
	            stripeInputErrors.cardCvc && _react2.default.createElement(
	              'div',
	              { className: 'c-checkout-modal__input-error u-co-red' },
	              stripeInputErrors.cardCvc
	            )
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'c-checkout-modal__input-label' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'ZIP / Postal'
	            ),
	            _react2.default.createElement(_InputZip2.default, {
	              country: shopCountry,
	              id: zipCodeId,
	              className: 'StripeElement',
	              placeholder: 'ZIP/Postal Code',
	              value: zipCode,
	              onChange: setZipCode,
	              disabled: formDisabled,
	              onBlur: zipCodeBlur
	            }),
	            stripeInputErrors.zipCode && _react2.default.createElement(
	              'div',
	              { className: 'c-checkout-modal__input-error c-checkout-modal__input-error_top u-co-red' },
	              stripeInputErrors.zipCode
	            )
	          )
	        )
	      ),
	      !isCoveredByDiscount && _react2.default.createElement(
	        'button',
	        { className: 'c-button', disabled: !submitEnabled || formDisabled || hasErrors },
	        formDisabled ? _react2.default.createElement(_reactSpinkit2.default, { name: 'three-bounce', className: 'c-checkout-modal__spinner', noFadeIn: true }) : _react2.default.createElement(
	          'span',
	          null,
	          buttonLabel || _react2.default.createElement(
	            'span',
	            null,
	            panelLabel,
	            '\xA0',
	            Number(amount) && _react2.default.createElement(
	              _Money2.default,
	              null,
	              amount
	            )
	          )
	        )
	      ),
	      isCoveredByDiscount && _react2.default.createElement(
	        'button',
	        { className: 'c-button' },
	        'Process'
	      ),
	      !isCoveredByDiscount && hasApplePay && _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'c-btn-link c-btn-link--small u-mt- u-co-black-3 u-font-weight-normal',
	          onClick: toggleApplePay
	        },
	        'Or pay with Apple pay'
	      )
	    )
	  );
	};
	
	PaymentForm.propTypes = {
	  formDisabled: _propTypes2.default.bool.isRequired,
	  amount: _propTypes2.default.number.isRequired,
	  submit: _propTypes2.default.func.isRequired,
	  panelLabel: _propTypes2.default.string,
	  setZipCode: _propTypes2.default.func.isRequired,
	  zipCode: _propTypes2.default.string.isRequired,
	  cardNumberId: _propTypes2.default.string.isRequired,
	  cardExpiryId: _propTypes2.default.string.isRequired,
	  cardCvcId: _propTypes2.default.string.isRequired,
	  zipCodeId: _propTypes2.default.string.isRequired,
	  cardBrand: _propTypes2.default.string.isRequired,
	  stripeInputErrors: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
	  hasErrors: _propTypes2.default.bool.isRequired,
	  isCoveredByDiscount: _propTypes2.default.bool.isRequired,
	  hasApplePay: _propTypes2.default.bool,
	  toggleApplePay: _propTypes2.default.func,
	  shopCountry: _propTypes2.default.string.isRequired,
	  zipCodeBlur: _propTypes2.default.func.isRequired,
	  submitEnabled: _propTypes2.default.bool.isRequired,
	  title: _propTypes2.default.string,
	  buttonLabel: _propTypes2.default.string
	};
	
	PaymentForm.defaultProps = {
	  panelLabel: 'Pay',
	  hasApplePay: true,
	  toggleApplePay: function toggleApplePay() {},
	  title: 'Payment Information',
	  buttonLabel: ''
	};
	
	exports.default = PaymentForm;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSpinkit = __webpack_require__(90);
	
	var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable jsx-a11y/label-has-for */
	var PaymentFormWithoutCard = function PaymentFormWithoutCard(_ref) {
	  var amount = _ref.amount,
	      panelLabel = _ref.panelLabel,
	      confirmSetup = _ref.confirmSetup,
	      formDisabled = _ref.formDisabled,
	      hasErrors = _ref.hasErrors;
	  return _react2.default.createElement(
	    'form',
	    {
	      className: 'c-card-information u-flex u-flex-column',
	      onSubmit: confirmSetup
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'c-payment-modal-heading u-mb' },
	      'Payment Information'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-flex-1 u-flex u-flex-column u-justify-content-space-between' },
	      _react2.default.createElement(
	        'div',
	        { className: 'u-co-gray' },
	        'By clicking charge you are authorizing us to charge the card that was provided when you booked the appointment.'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'c-button', disabled: formDisabled || hasErrors },
	        formDisabled ? _react2.default.createElement(_reactSpinkit2.default, { name: 'three-bounce', className: 'c-checkout-modal__spinner', noFadeIn: true }) : _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            panelLabel,
	            '\xA0',
	            Number(amount) && _react2.default.createElement(
	              _Money2.default,
	              null,
	              amount
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	PaymentFormWithoutCard.propTypes = {
	  formDisabled: _propTypes2.default.bool.isRequired,
	  amount: _propTypes2.default.number.isRequired,
	  confirmSetup: _propTypes2.default.func.isRequired,
	  panelLabel: _propTypes2.default.string,
	  hasErrors: _propTypes2.default.bool.isRequired
	};
	
	PaymentFormWithoutCard.defaultProps = {
	  panelLabel: 'Pay'
	};
	
	exports.default = PaymentFormWithoutCard;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactSimpleCurrency = __webpack_require__(386);
	
	var _reactSimpleCurrency2 = _interopRequireDefault(_reactSimpleCurrency);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomTip = function CustomTip(_ref) {
	  var onChange = _ref.onChange,
	      onSubmit = _ref.onSubmit,
	      tip = _ref.tip,
	      increment = _ref.increment,
	      decrement = _ref.decrement;
	  return _react2.default.createElement(
	    'form',
	    { className: 'c-payment-modal-tip-custom', onSubmit: onSubmit },
	    _react2.default.createElement(
	      'div',
	      { className: 'c-payment-modal-tip-custom__input' },
	      _react2.default.createElement(
	        'span',
	        null,
	        '$'
	      ),
	      _react2.default.createElement(_reactSimpleCurrency2.default, {
	        className: 'c-input',
	        type: 'number',
	        min: '0',
	        required: true,
	        value: tip,
	        onInputChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-payment-modal-tip-custom__controls' },
	      _react2.default.createElement(
	        'button',
	        { type: 'button', onClick: decrement },
	        '\u2212'
	      ),
	      _react2.default.createElement(
	        'button',
	        { type: 'button', onClick: increment },
	        '+'
	      )
	    ),
	    _react2.default.createElement(
	      'button',
	      { className: 'c-payment-modal-tip-custom__submit', disabled: tip < 0 },
	      'Set'
	    )
	  );
	};
	
	CustomTip.propTypes = {
	  onChange: _propTypes2.default.func.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  increment: _propTypes2.default.func.isRequired,
	  decrement: _propTypes2.default.func.isRequired,
	  tip: _propTypes2.default.number.isRequired
	};
	
	exports.default = CustomTip;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _some = __webpack_require__(181);
	
	var _some2 = _interopRequireDefault(_some);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _PaymentModalCustomTip = __webpack_require__(1201);
	
	var _PaymentModalCustomTip2 = _interopRequireDefault(_PaymentModalCustomTip);
	
	var _shapes = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tip = function Tip(_ref) {
	  var tips = _ref.tips,
	      onTipSelect = _ref.onTipSelect,
	      off = _ref.off,
	      toggle = _ref.toggle,
	      toggled = _ref.toggled,
	      hasCustomTip = _ref.hasCustomTip,
	      customTip = _ref.customTip,
	      total = _ref.total;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'c-payment-modal-heading u-mt- u-mb u-hide-for-medium-and-up' },
	      'Tip'
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: { height: '40px' },
	        className: 'u-flex u-align-center u-justify-content-space-between u-mb- u-flex-wrap u-hide-for-small-and-down'
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-payment-modal-heading u-mt-' },
	        'Tip'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flex u-justify-content-end' },
	        toggled && _react2.default.createElement(_PaymentModalCustomTip2.default, { close: off })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-text-center u-mb- c-payment-modal-tip' },
	      tips.map(function (tip, i) {
	        if (!tip.amount && !(0, _some2.default)(tips, 'amount')) return null;
	        return _react2.default.createElement(
	          'button',
	          {
	            className: (0, _classnames2.default)('c-payment-modal-tip-button', { 'is-selected': tip.active && !toggled }),
	            type: 'radio',
	            name: 'radio-reserve',
	            id: 'payment_tip' + i,
	            onClick: function onClick() {
	              return onTipSelect(tip.flat ? tip.amount : tip.value);
	            },
	            key: tip.value || tip.amount
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'c-payment-modal-tip-button__heading' },
	            tip.value || tip.flat ? _react2.default.createElement(
	              _Money2.default,
	              null,
	              tip.amount
	            ) : 'None'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'c-payment-modal-tip-button__subheading' },
	            tip.desc
	          )
	        );
	      }),
	      _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          className: (0, _classnames2.default)('c-payment-modal-tip-button', { 'is-selected': hasCustomTip || toggled }),
	          onClick: toggle
	        },
	        hasCustomTip ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'c-payment-modal-tip-button__heading' },
	            _react2.default.createElement(
	              _Money2.default,
	              null,
	              customTip
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'c-payment-modal-tip-button__subheading' },
	            'About ',
	            Math.floor(customTip / total * 100),
	            '%'
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'c-payment-modal-tip-button__heading' },
	          (0, _some2.default)(tips, 'amount') ? 'Custom' : 'Add Tip'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-flex u-justify-content-end u-mt- u-hide-for-medium-and-up' },
	      toggled && _react2.default.createElement(_PaymentModalCustomTip2.default, { close: off })
	    )
	  );
	};
	Tip.propTypes = {
	  tips: _propTypes2.default.arrayOf(_shapes.tipShape),
	  onTipSelect: _propTypes2.default.func,
	  toggle: _propTypes2.default.func.isRequired,
	  off: _propTypes2.default.func.isRequired,
	  toggled: _propTypes2.default.bool.isRequired,
	  hasCustomTip: _propTypes2.default.bool.isRequired,
	  customTip: _propTypes2.default.number.isRequired,
	  total: _propTypes2.default.number.isRequired
	};
	Tip.defaultProps = {
	  tips: [],
	  onTipSelect: null
	};
	
	exports.default = Tip;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _NextAvailableButton = __webpack_require__(471);
	
	var _NextAvailableButton2 = _interopRequireDefault(_NextAvailableButton);
	
	var _AutoHeight = __webpack_require__(408);
	
	var _AutoHeight2 = _interopRequireDefault(_AutoHeight);
	
	var _DateTimePicker = __webpack_require__(298);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _InvalidPromoError = __webpack_require__(904);
	
	var _InvalidPromoError2 = _interopRequireDefault(_InvalidPromoError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PickTime = function PickTime(_ref) {
	  var rescheduleAndAskPromo = _ref.rescheduleAndAskPromo,
	      rescheduleAndRemovePromo = _ref.rescheduleAndRemovePromo,
	      setTime = _ref.setTime,
	      setActiveDay = _ref.setActiveDay,
	      isTurnstileChallengeVisible = _ref.isTurnstileChallengeVisible,
	      props = _objectWithoutProperties(_ref, ['rescheduleAndAskPromo', 'rescheduleAndRemovePromo', 'setTime', 'setActiveDay', 'isTurnstileChallengeVisible']);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-second-layer' },
	    _react2.default.createElement(
	      _AutoHeight2.default,
	      null,
	      _react2.default.createElement(_DateTimePicker2.default, Object.assign({
	        setTime: setTime,
	        setActiveDay: setActiveDay
	      }, props)),
	      _react2.default.createElement(
	        'div',
	        { className: 'layout layout--small layout--center layout--auto u-mt' },
	        props.selectedTime && _react2.default.createElement(
	          'div',
	          { className: 'layout__item' },
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'c-btn c-btn--primary u-pos-relative',
	              onClick: rescheduleAndAskPromo
	            },
	            'Reschedule',
	            isTurnstileChallengeVisible && _react2.default.createElement('div', { className: 'c-turnstile-modal', id: 'turnstile' })
	          )
	        ),
	        props.noTimesAvailable && _react2.default.createElement(
	          'div',
	          { className: 'layout__item' },
	          _react2.default.createElement(_NextAvailableButton2.default, {
	            setTime: setTime,
	            setActiveDay: setActiveDay
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_InvalidPromoError2.default, { onConfirm: rescheduleAndRemovePromo })
	  );
	};
	PickTime.propTypes = {
	  rescheduleAndAskPromo: _propTypes2.default.func.isRequired,
	  rescheduleAndRemovePromo: _propTypes2.default.func.isRequired,
	  selectedTime: _propTypes2.default.string.isRequired,
	  setTime: _propTypes2.default.func.isRequired,
	  setActiveDay: _propTypes2.default.func.isRequired,
	  noTimesAvailable: _propTypes2.default.bool.isRequired,
	  isTurnstileChallengeVisible: _propTypes2.default.bool.isRequired
	};
	
	exports.default = PickTime;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSpinkit = __webpack_require__(90);
	
	var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProcessingIndicator = function ProcessingIndicator(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-processing-indicator' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'c-processing-indicator__text' },
	      children
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-co-branding' },
	      _react2.default.createElement(_reactSpinkit2.default, { spinnerName: 'three-bounce', noFadeIn: true })
	    )
	  );
	};
	ProcessingIndicator.propTypes = {
	  children: _propTypes2.default.string
	};
	ProcessingIndicator.defaultProps = {
	  children: ''
	};
	
	exports.default = ProcessingIndicator;

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _chevron = __webpack_require__(486);
	
	var _chevron2 = _interopRequireDefault(_chevron);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Promo = function Promo(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    !props.isExpanded && _react2.default.createElement(
	      'button',
	      {
	        className: 'c-btn c-btn-promo',
	        onClick: props.expandPromo
	      },
	      props.title,
	      _react2.default.createElement('img', { src: _chevron2.default, alt: 'Expand Promotion' })
	    ),
	    props.isExpanded && props.component
	  );
	};
	
	Promo.propTypes = {
	  title: _propTypes2.default.string,
	  component: _propTypes2.default.oneOf([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	  isExpanded: _propTypes2.default.bool.isRequired,
	  expandPromo: _propTypes2.default.func.isRequired
	};
	
	Promo.defaultProps = {
	  title: 'Promotion Available',
	  component: 'Error loading promotion details'
	};
	
	exports.default = Promo;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PromoModalTidal = __webpack_require__(1179);
	
	var _PromoModalTidal2 = _interopRequireDefault(_PromoModalTidal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PromoModal = function PromoModal(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('div', { className: 'c-promo-modal_fog' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-promo-modal' },
	      _react2.default.createElement(_PromoModalTidal2.default, Object.assign({ closeModal: props.closeModal }, props))
	    )
	  );
	};
	
	PromoModal.propTypes = {
	  closeModal: _propTypes2.default.func.isRequired
	};
	
	exports.default = PromoModal;

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _tidalLogoWhite = __webpack_require__(308);
	
	var _tidalLogoWhite2 = _interopRequireDefault(_tidalLogoWhite);
	
	var _tidalClose = __webpack_require__(1313);
	
	var _tidalClose2 = _interopRequireDefault(_tidalClose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PromoModalTidal = function PromoModalTidal(_ref) {
	  var closeModal = _ref.closeModal,
	      reserveAndPayButton = _ref.reserveAndPayButton,
	      handleReserve = _ref.handleReserve,
	      customReserveButton = _ref.customReserveButton,
	      showPromo = _ref.showPromo;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-promo-modal-tidal' },
	    _react2.default.createElement(
	      'div',
	      { className: 'c-promo-modal_tidal_flag' },
	      '2 Free Months'
	    ),
	    _react2.default.createElement(
	      'button',
	      { className: 'c-promo-modal_close', onClick: closeModal },
	      _react2.default.createElement('img', { src: _tidalClose2.default, alt: 'Close Modal' })
	    ),
	    _react2.default.createElement('img', { className: 'c-promo-modal_logo', src: _tidalLogoWhite2.default, alt: 'TIDAL' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Are you sure you want to proceed without\xA0',
	      _react2.default.createElement(
	        'b',
	        null,
	        '2 free months of music streaming with TIDAL?'
	      )
	    ),
	    reserveAndPayButton,
	    customReserveButton,
	    !customReserveButton && _react2.default.createElement(
	      'button',
	      { className: 'c-btn c-btn--secondary', onClick: handleReserve, showPromo: showPromo },
	      'I just want to reserve'
	    )
	  );
	};
	
	PromoModalTidal.propTypes = {
	  closeModal: _propTypes2.default.func.isRequired,
	  reserveAndPayButton: _propTypes2.default.func.isRequired,
	  handleReserve: _propTypes2.default.func.isRequired,
	  customReserveButton: _propTypes2.default.func,
	  showPromo: _propTypes2.default.bool
	};
	
	PromoModalTidal.defaultProps = {
	  customReserveButton: null,
	  showPromo: false
	};
	
	exports.default = PromoModalTidal;

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _tidalLogoWhite = __webpack_require__(308);
	
	var _tidalLogoWhite2 = _interopRequireDefault(_tidalLogoWhite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PromoTidal = function PromoTidal(_ref) {
	  var payButton = _ref.payButton;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-promo-tidal' },
	    _react2.default.createElement(
	      'div',
	      { className: 'c-promo-tidal-header' },
	      _react2.default.createElement('img', { className: 'c-promo-tidal-header_logo', src: _tidalLogoWhite2.default, alt: 'TIDAL' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Reserve with a card now and you will receive\xA0',
	        _react2.default.createElement(
	          'b',
	          null,
	          '2 free months of music streaming with TIDAL - a $20 value'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-promo-tidal-details' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-promo-tidal-details_title' },
	        'Other benefits to paying now'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'save time by not having to wait to pay '
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'stay safe and sanitary by touching fewer surfaces'
	        )
	      ),
	      payButton(),
	      _react2.default.createElement(
	        'p',
	        { className: 'c-promo-tidal-details_terms' },
	        'Not available for current or past TIDAL subscribers. TIDAL Terms & Conditions apply'
	      )
	    )
	  );
	};
	
	PromoTidal.propTypes = {
	  payButton: _propTypes2.default.func.isRequired
	};
	
	exports.default = PromoTidal;

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _chevron = __webpack_require__(486);
	
	var _chevron2 = _interopRequireDefault(_chevron);
	
	var _tidalLogoBlack = __webpack_require__(487);
	
	var _tidalLogoBlack2 = _interopRequireDefault(_tidalLogoBlack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PromoTidalCheckout = function PromoTidalCheckout(_ref) {
	  var expand = _ref.expand,
	      isExpanded = _ref.isExpanded;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-promo-tidal-checkout u-float-right' },
	    _react2.default.createElement(
	      'div',
	      { className: 'c-promo-tidal-checkout_right' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'c-promo-tidal-checkout_main' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Finalize this transaction and you will receive',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'b',
	              null,
	              '2 free months of music streaming with TIDAL'
	            )
	          ),
	          _react2.default.createElement('img', { className: 'c-promo-modal_logo', src: _tidalLogoBlack2.default, alt: 'TIDAL' })
	        )
	      )
	    ),
	    !isExpanded && _react2.default.createElement(
	      'div',
	      { className: 'c-promo-tidal-checkout_expand' },
	      _react2.default.createElement(
	        'button',
	        { onClick: expand },
	        'more',
	        _react2.default.createElement('img', { src: _chevron2.default, alt: 'Expand Promotion' })
	      )
	    ),
	    isExpanded && _react2.default.createElement(
	      'div',
	      { className: 'c-promo-tidal-checkout_left' },
	      _react2.default.createElement(
	        'div',
	        null,
	        'Other benefits to paying now'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'save time by not having to wait to pay'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'stay safe and sanitary by touching fewer surfaces'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-promo-tidal-checkout_terms' },
	      'Not available for current or past TIDAL subscribers',
	      _react2.default.createElement('br', null),
	      'TIDAL Terms & Conditions apply'
	    )
	  );
	};
	
	PromoTidalCheckout.propTypes = {
	  isExpanded: _propTypes2.default.bool.isRequired,
	  expand: _propTypes2.default.func.isRequired
	};
	
	exports.default = PromoTidalCheckout;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _tidalLogoBlack = __webpack_require__(487);
	
	var _tidalLogoBlack2 = _interopRequireDefault(_tidalLogoBlack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PromoTidalReservation = function PromoTidalReservation(_ref) {
	  var promoCode = _ref.promoCode,
	      onCopyClick = _ref.onCopyClick,
	      promoUrl = _ref.promoUrl,
	      showCopiedMessageClass = _ref.showCopiedMessageClass;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-promo-tidal-reservation' },
	    _react2.default.createElement(
	      'div',
	      { className: 'c-promo-tidal-reservation_wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-promo-tidal-reservation_wrapper_flag' },
	        '2 Free Months'
	      ),
	      _react2.default.createElement('img', { className: 'c-promo-tidal-reservation_wrapper_logo', src: _tidalLogoBlack2.default, alt: 'TIDAL' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-promo-tidal-reservation_wrapper_content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'c-promo-tidal-reservation_wrapper_content_code' },
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'c-promo-tidal-reservation_wrapper_content_code_copy',
	              onClick: onCopyClick
	            },
	            'COPY'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'c-promo-tidal-reservation_wrapper_content_code_title' },
	            'TIDAL Redemption Code'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'c-promo-tidal-reservation_wrapper_content_code' },
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'c-promo-tidal-reservation_wrapper_content_code_copyconfirmation ' + (showCopiedMessageClass ? 'show' : '')
	              },
	              'promo code has been copied to clipboard'
	            ),
	            promoCode
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-promo-tidal-reservation_wrapper_content_terms' },
	          'This redemption code needs to be applied on the TIDAL subscription page.'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        {
	          className: 'c-btn c-btn--default',
	          href: '' + promoUrl,
	          target: '_blank'
	        },
	        'redeem my 2 free months of TIDAL'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-promo-tidal-reservation_terms' },
	      'Not available for current or past TIDAL subscribers must redeem by March 29th 2021. TIDAL Terms & Conditions apply'
	    )
	  );
	}; /* eslint-disable max-len */
	
	
	PromoTidalReservation.propTypes = {
	  promoCode: _propTypes2.default.string.isRequired,
	  onCopyClick: _propTypes2.default.func.isRequired,
	  promoUrl: _propTypes2.default.string.isRequired,
	  showCopiedMessageClass: _propTypes2.default.bool.isRequired
	};
	
	exports.default = PromoTidalReservation;

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSpinkit = __webpack_require__(90);
	
	var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);
	
	var _shapes = __webpack_require__(23);
	
	var _helpers = __webpack_require__(7);
	
	var _ErrorMsg = __webpack_require__(410);
	
	var _ErrorMsg2 = _interopRequireDefault(_ErrorMsg);
	
	var _Input = __webpack_require__(266);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReedemCode = function ReedemCode(_ref) {
	  var handleSubmit = _ref.handleSubmit,
	      isFetching = _ref.isFetching,
	      error = _ref.error,
	      isValid = _ref.isValid,
	      promoCode = _ref.promoCode,
	      onChange = _ref.onChange,
	      submitEnabled = _ref.submitEnabled,
	      hasLoyaltyProgram = _ref.hasLoyaltyProgram,
	      hasPromotions = _ref.hasPromotions,
	      giftCardEnabled = _ref.giftCardEnabled,
	      inputDisabled = _ref.inputDisabled,
	      remainingGiftCardBalance = _ref.remainingGiftCardBalance,
	      hasGiftCardBalance = _ref.hasGiftCardBalance,
	      validationNote = _ref.validationNote;
	
	  var promoLabel = function () {
	    var labels = [];
	    if (hasLoyaltyProgram) labels.push('Loyalty');
	    if (giftCardEnabled) labels.push('Gift Card');
	    labels.push('Promo');
	    var separator = labels.length > 2 ? '/' : ' or ';
	    return labels.join(separator) + ' Code';
	  }();
	
	  if (!hasPromotions) return null;
	
	  return _react2.default.createElement(
	    'form',
	    {
	      className: 'u-mt+',
	      onSubmit: handleSubmit,
	      disabled: isFetching
	    },
	    _react2.default.createElement(_Input2.default, {
	      id: 'reedem',
	      label: promoLabel,
	      size: 'small',
	      value: promoCode,
	      onChange: onChange,
	      disabled: inputDisabled
	    }),
	    error && _react2.default.createElement(
	      _ErrorMsg2.default,
	      { className: 'u-mt-- u--mb-' },
	      error
	    ),
	    hasGiftCardBalance && _react2.default.createElement(
	      'div',
	      { className: 'u-type--bold u-pb+ u-pt-' },
	      _react2.default.createElement(
	        'span',
	        { className: 'u-mr-- u-float-left' },
	        'Remaining balance:'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'u-float-right' },
	        _react2.default.createElement(
	          _Money2.default,
	          null,
	          remainingGiftCardBalance
	        )
	      )
	    ),
	    validationNote && _react2.default.createElement(
	      'div',
	      { className: 'u-type--bold u-pv-' },
	      validationNote
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-text-right u-mt-' },
	      _react2.default.createElement(
	        'button',
	        {
	          className: 'c-btn c-btn--secondary c-btn--small',
	          disabled: !submitEnabled,
	          type: 'submit'
	        },
	        function () {
	          if (isFetching) return _react2.default.createElement(_reactSpinkit2.default, { spinnerName: 'double-bounce', noFadeIn: true });
	          if (isValid) return 'Change code';
	          return 'Redeem';
	        }()
	      )
	    )
	  );
	};
	ReedemCode.propTypes = {
	  handleSubmit: _shapes.handler,
	  isFetching: _shapes.flag,
	  error: _propTypes2.default.string,
	  isValid: _shapes.flag,
	  promoCode: _propTypes2.default.string,
	  onChange: _shapes.handler,
	  submitEnabled: _shapes.flag.isRequired,
	  hasLoyaltyProgram: _shapes.flag,
	  hasPromotions: _shapes.flag,
	  giftCardEnabled: _shapes.flag,
	  inputDisabled: _shapes.flag,
	  remainingGiftCardBalance: _propTypes2.default.number.isRequired,
	  hasGiftCardBalance: _shapes.flag.isRequired,
	  validationNote: _propTypes2.default.string
	};
	ReedemCode.defaultProps = {
	  hasLoyaltyProgram: false,
	  hasPromotions: true,
	  handleSubmit: _helpers.nullFunc,
	  isFetching: false,
	  error: '',
	  isValid: false,
	  promoCode: '',
	  onChange: _helpers.nullFunc,
	  giftCardEnabled: false,
	  inputDisabled: false,
	  validationNote: ''
	};
	
	exports.default = ReedemCode;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(5);
	
	var _UnableToRescheduleModal = __webpack_require__(1191);
	
	var _UnableToRescheduleModal2 = _interopRequireDefault(_UnableToRescheduleModal);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RescheduleLink = function RescheduleLink(_ref) {
	  var rescheduleLink = _ref.rescheduleLink,
	      onClick = _ref.onClick,
	      off = _ref.off,
	      toggled = _ref.toggled;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-mb--' },
	    _react2.default.createElement(
	      _reactRouter.Link,
	      {
	        className: 'c-btn c-btn--secondary u-1/1',
	        to: rescheduleLink,
	        onClick: onClick
	      },
	      'Reschedule appointment'
	    ),
	    _react2.default.createElement(_UnableToRescheduleModal2.default, {
	      isOpen: toggled,
	      closeModal: off
	    })
	  );
	};
	RescheduleLink.propTypes = {
	  rescheduleLink: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  off: _propTypes2.default.func.isRequired,
	  toggled: _propTypes2.default.bool.isRequired
	};
	RescheduleLink.defaultProps = {
	  rescheduleLink: '',
	  onClick: _helpers.nullFunc
	};
	
	exports.default = RescheduleLink;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(5);
	
	var _Subtitle = __webpack_require__(113);
	
	var _Subtitle2 = _interopRequireDefault(_Subtitle);
	
	var _ReservationInfo = __webpack_require__(455);
	
	var _ReservationInfo2 = _interopRequireDefault(_ReservationInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReservationCanceled = function ReservationCanceled(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Subtitle2.default,
	      null,
	      'Appointment Canceled'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-mt+' },
	      _react2.default.createElement(_ReservationInfo2.default, props),
	      _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          to: props.scheduleLink,
	          className: 'c-btn c-btn--secondary u-mt+ u-1/1 u-1/2-medium-and-up'
	        },
	        'Schedule another appointment'
	      )
	    )
	  );
	};
	
	ReservationCanceled.propTypes = {
	  scheduleLink: _propTypes2.default.string
	};
	ReservationCanceled.defaultProps = {
	  scheduleLink: '/'
	};
	
	exports.default = ReservationCanceled;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReservationError = function ReservationError(_ref) {
	  var error = _ref.error;
	  return _react2.default.createElement(
	    'div',
	    { className: 'layout layout--large u-mt++' },
	    _react2.default.createElement(
	      'div',
	      { className: 'layout__item u-text-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-heading--large' },
	        error
	      )
	    )
	  );
	};
	ReservationError.propTypes = {
	  error: _propTypes2.default.string.isRequired
	};
	
	exports.default = ReservationError;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withNewCheckoutButton = __webpack_require__(294);
	
	var _withNewCheckoutButton2 = _interopRequireDefault(_withNewCheckoutButton);
	
	var _TrackClick = __webpack_require__(424);
	
	var _TrackClick2 = _interopRequireDefault(_TrackClick);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReserveAndPayButton = function ReserveAndPayButton(_ref) {
	  var handleReserveAndPay = _ref.handleReserveAndPay,
	      currency = _ref.currency,
	      totalAmount = _ref.totalAmount,
	      email = _ref.email,
	      paymentEnabled = _ref.paymentEnabled,
	      isLadyClipperShop = _ref.isLadyClipperShop,
	      title = _ref.title,
	      showPromo = _ref.showPromo,
	      onBeforeClose = _ref.onBeforeClose,
	      onBeforeOpen = _ref.onBeforeOpen;
	  return _react2.default.createElement(
	    _TrackClick2.default,
	    { method: 'reserveAndPay' },
	    _react2.default.createElement(
	      _withNewCheckoutButton2.default,
	      {
	        className: 'c-btn c-btn--primary u-1/1 u-mb-',
	        onSuccess: handleReserveAndPay,
	        currency: currency,
	        amount: totalAmount,
	        email: email,
	        disabled: !paymentEnabled,
	        showPromo: showPromo,
	        onBeforeClose: onBeforeClose,
	        onBeforeOpen: onBeforeOpen
	      },
	      _react2.default.createElement(
	        'span',
	        null,
	        isLadyClipperShop ? 'Reserve now' : title
	      )
	    )
	  );
	};
	
	ReserveAndPayButton.propTypes = {
	  handleReserveAndPay: _propTypes2.default.func,
	  currency: _propTypes2.default.string.isRequired,
	  totalAmount: _propTypes2.default.number,
	  email: _propTypes2.default.string,
	  paymentEnabled: _propTypes2.default.bool,
	  isLadyClipperShop: _propTypes2.default.bool.isRequired,
	  title: _propTypes2.default.string,
	  showPromo: _propTypes2.default.bool,
	  onBeforeOpen: _propTypes2.default.func,
	  onBeforeClose: _propTypes2.default.func
	};
	
	ReserveAndPayButton.defaultProps = {
	  handleReserveAndPay: null,
	  totalAmount: 0,
	  email: '',
	  paymentEnabled: false,
	  isLadyClipperShop: false,
	  title: 'Reserve & Pay',
	  showPromo: false,
	  onBeforeOpen: _helpers.nullFunc,
	  onBeforeClose: _helpers.nullFunc
	};
	
	exports.default = ReserveAndPayButton;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _map2 = __webpack_require__(74);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _BookingFee = __webpack_require__(1159);
	
	var _BookingFee2 = _interopRequireDefault(_BookingFee);
	
	var _shapes = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TaxesAndFees = function TaxesAndFees(_ref) {
	  var taxes = _ref.taxes,
	      fees = _ref.fees,
	      isSquireFeeShop = _ref.isSquireFeeShop,
	      isChopMurrayHillShop = _ref.isChopMurrayHillShop,
	      taxBreakdown = _ref.taxBreakdown;
	
	  if (isSquireFeeShop) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'c-order-info__desc' },
	        'Squire Fee:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-order-info__price' },
	        _react2.default.createElement(
	          _Money2.default,
	          null,
	          taxes + fees
	        )
	      )
	    );
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    Boolean(taxes) && taxBreakdown.length === 1 && _react2.default.createElement(
	      'div',
	      { className: 'c-order-info__desc' },
	      'Taxes:'
	    ),
	    Boolean(taxes) && taxBreakdown.length === 1 && _react2.default.createElement(
	      'div',
	      { className: 'c-order-info__price' },
	      _react2.default.createElement(
	        _Money2.default,
	        null,
	        taxes
	      )
	    ),
	    taxBreakdown.length > 1 && (0, _map3.default)(taxBreakdown, function (tax) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'c-order-info__desc' },
	          tax.name,
	          ':'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-order-info__price' },
	          _react2.default.createElement(
	            _Money2.default,
	            null,
	            tax.amount
	          )
	        )
	      );
	    }),
	    _react2.default.createElement(_BookingFee2.default, {
	      fees: fees,
	      isChopMurrayHillShop: isChopMurrayHillShop
	    })
	  );
	};
	TaxesAndFees.propTypes = {
	  isSquireFeeShop: _propTypes2.default.bool.isRequired,
	  taxes: _propTypes2.default.number,
	  fees: _propTypes2.default.number,
	  isChopMurrayHillShop: _propTypes2.default.bool.isRequired,
	  taxBreakdown: _shapes.taxBreakdownArray
	};
	TaxesAndFees.defaultProps = {
	  taxes: 0,
	  fees: 0,
	  taxBreakdown: []
	};
	
	exports.default = TaxesAndFees;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TermsOfService = function TermsOfService() {
	  return _react2.default.createElement(
	    'p',
	    { className: 'u-mt' },
	    'By booking an appointment you agree to the',
	    ' ',
	    _react2.default.createElement(
	      'a',
	      { target: '_blank', rel: 'noreferrer noopener', href: 'https://getsquire.com/terms-of-service' },
	      'terms of service'
	    ),
	    ' and the',
	    ' ',
	    _react2.default.createElement(
	      'a',
	      { target: '_blank', rel: 'noreferrer noopener', href: 'https://getsquire.com/privacy-policy' },
	      'privacy policy'
	    ),
	    '.'
	  );
	};
	
	exports.default = TermsOfService;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _some = __webpack_require__(181);
	
	var _some2 = _interopRequireDefault(_some);
	
	var _Money = __webpack_require__(29);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _CustomTip = __webpack_require__(1196);
	
	var _CustomTip2 = _interopRequireDefault(_CustomTip);
	
	var _shapes = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tip = function Tip(_ref) {
	  var tips = _ref.tips,
	      onTipSelect = _ref.onTipSelect,
	      on = _ref.on,
	      off = _ref.off,
	      toggled = _ref.toggled,
	      hasCustomTip = _ref.hasCustomTip;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'c-heading c-heading--huge u-mb u-show-for-large-and-up' },
	      'Tip'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'c-heading c-heading--huge u-mb- u-text-center u-hide-for-large-and-up' },
	      'Tip'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-text-center layout layout--flush u--ml- large-and-up--ml u-mb-' },
	      tips.map(function (tip, i) {
	        if (!tip.amount && !(0, _some2.default)(tips, 'amount')) return null;
	        return _react2.default.createElement(
	          'div',
	          { className: 'layout__item u-pl- large-and-up-pl u-1/5', key: tip.value || tip.amount },
	          _react2.default.createElement(
	            'div',
	            { className: 'c-select-btn' },
	            _react2.default.createElement('input', {
	              className: 'c-select-btn__input',
	              type: 'radio',
	              name: 'radio-reserve',
	              id: 'tip' + i,
	              onChange: function onChange() {
	                return onTipSelect(tip.flat ? tip.amount : tip.value);
	              },
	              checked: tip.active
	            }),
	            _react2.default.createElement(
	              'label',
	              { className: 'c-select-btn__label', htmlFor: 'tip' + i },
	              _react2.default.createElement(
	                'div',
	                { className: 'c-heading c-heading--huge' },
	                tip.value || tip.flat ? _react2.default.createElement(
	                  _Money2.default,
	                  null,
	                  tip.amount
	                ) : 'None'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'epsilon u-co-gray-1 u-type--bold u--mt-- u-show-for-large-and-up' },
	                tip.desc
	              )
	            )
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-text-center u-mt' },
	      _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          className: (0, _classnames2.default)('c-btn c-btn--default', { 'is-selected': hasCustomTip }),
	          onClick: on
	        },
	        (0, _some2.default)(tips, 'amount') ? 'Custom Tip' : 'Add Tip'
	      ),
	      toggled && _react2.default.createElement(_CustomTip2.default, { close: off })
	    )
	  );
	};
	Tip.propTypes = {
	  tips: _propTypes2.default.arrayOf(_shapes.tipShape),
	  onTipSelect: _propTypes2.default.func,
	  on: _propTypes2.default.func.isRequired,
	  off: _propTypes2.default.func.isRequired,
	  toggled: _propTypes2.default.bool.isRequired,
	  hasCustomTip: _propTypes2.default.bool.isRequired
	};
	Tip.defaultProps = {
	  tips: [],
	  onTipSelect: null
	};
	
	exports.default = Tip;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sweetalertReact = __webpack_require__(132);
	
	var _sweetalertReact2 = _interopRequireDefault(_sweetalertReact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ERROR_TEXT = ['You have an appointment in less than professional\'s advance cancelation time. ', 'Please call the shop for further assistance.'].join('');
	
	var UnableToRescheduleModal = function UnableToRescheduleModal(_ref) {
	  var isOpen = _ref.isOpen,
	      closeModal = _ref.closeModal;
	  return _react2.default.createElement(_sweetalertReact2.default, {
	    show: isOpen,
	    title: 'Unable to reschedule appointment',
	    text: ERROR_TEXT,
	    type: 'error',
	    onConfirm: closeModal,
	    onEscapeKey: closeModal
	  });
	};
	UnableToRescheduleModal.propTypes = {
	  isOpen: _propTypes2.default.bool,
	  closeModal: _propTypes2.default.func.isRequired
	};
	UnableToRescheduleModal.defaultProps = {
	  isOpen: false
	};
	exports.default = UnableToRescheduleModal;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApplePay = __webpack_require__(458);
	
	var _ApplePay2 = _interopRequireDefault(_ApplePay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WaitingListApplePay = function WaitingListApplePay(_ref) {
	  var onClick = _ref.onClick;
	  return _react2.default.createElement(
	    'div',
	    { className: 'u-text-center u-pt' },
	    _react2.default.createElement(_ApplePay2.default, {
	      className: 'u-1/1 u-1/2-medium-and-up',
	      onClick: onClick
	    })
	  );
	};
	WaitingListApplePay.propTypes = {
	  onClick: _propTypes2.default.func
	};
	WaitingListApplePay.defaultProps = {
	  onClick: null
	};
	
	exports.default = WaitingListApplePay;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _CheckoutModal = __webpack_require__(291);
	
	var _CheckoutModal2 = _interopRequireDefault(_CheckoutModal);
	
	var _WithToggle = __webpack_require__(63);
	
	var _WithToggle2 = _interopRequireDefault(_WithToggle);
	
	var _CheckoutModal3 = __webpack_require__(289);
	
	var _withNewCheckoutButton = __webpack_require__(294);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WaitingListButton = function WaitingListButton(_ref) {
	  var disabled = _ref.disabled,
	      on = _ref.on,
	      off = _ref.off,
	      formDisabled = _ref.formDisabled,
	      onSuccess = _ref.onSuccess,
	      toggled = _ref.toggled,
	      children = _ref.children,
	      className = _ref.className,
	      panelLabel = _ref.panelLabel;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_CheckoutModal3.FontsPreloader, null),
	    _react2.default.createElement(
	      'button',
	      {
	        className: className,
	        type: 'button',
	        disabled: disabled || formDisabled,
	        onClick: on
	      },
	      children
	    ),
	    _react2.default.createElement(_CheckoutModal2.default, {
	      onSuccess: onSuccess,
	      off: off,
	      panelLabel: panelLabel,
	      toggled: toggled
	    })
	  );
	};
	
	WaitingListButton.propTypes = {
	  formDisabled: _propTypes2.default.bool.isRequired,
	  disabled: _propTypes2.default.bool.isRequired,
	  toggled: _propTypes2.default.bool.isRequired,
	  onSuccess: _propTypes2.default.func.isRequired,
	  on: _propTypes2.default.func.isRequired,
	  off: _propTypes2.default.func.isRequired,
	  children: _propTypes2.default.string.isRequired,
	  className: _propTypes2.default.string.isRequired,
	  panelLabel: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _compose3.default)((0, _withProps3.default)(function () {
	  return {
	    children: 'Put me on a waiting list',
	    className: 'c-btn c-btn--primary u-1/1 u-mb- delta',
	    panelLabel: 'Process'
	  };
	}), _withNewCheckoutButton.withNewCheckoutButton, _reactRouter.withRouter, _WithToggle2.default)(WaitingListButton);

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _WithToggle = __webpack_require__(63);
	
	var _WithToggle2 = _interopRequireDefault(_WithToggle);
	
	var _CheckoutButton = __webpack_require__(1162);
	
	var _CheckoutButton2 = _interopRequireDefault(_CheckoutButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, _WithToggle2.default, (0, _lifecycle3.default)({
	  componentDidUpdate: function componentDidUpdate(props) {
	    var didTurnToTrue = this.props.toggled === true && props.toggled === false;
	    if (didTurnToTrue && this.props.onBeforeOpen) {
	      this.props.onBeforeOpen(props);
	    }
	
	    var didTurnToFalse = this.props.toggled === false && props.toggled === true;
	    if (didTurnToFalse && this.props.onBeforeClose) {
	      this.props.onBeforeClose(props);
	    }
	  }
	}))(_CheckoutButton2.default);

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _renderComponent2 = __webpack_require__(57);
	
	var _renderComponent3 = _interopRequireDefault(_renderComponent2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _setDisplayName2 = __webpack_require__(69);
	
	var _setDisplayName3 = _interopRequireDefault(_setDisplayName2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__(6);
	
	var _CheckoutModal = __webpack_require__(291);
	
	var _CheckoutModal2 = _interopRequireDefault(_CheckoutModal);
	
	var _ValidateAppointment = __webpack_require__(293);
	
	var _selectors = __webpack_require__(21);
	
	var _actions = __webpack_require__(42);
	
	var _AppointmentPaidModal = __webpack_require__(1155);
	
	var _AppointmentPaidModal2 = _interopRequireDefault(_AppointmentPaidModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)((0, _setDisplayName3.default)('CheckoutContainer'), _ValidateAppointment.ValidateAppointmentContainer, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    tipAmount: (0, _selectors.getActiveTipAmount)(state, ownProps.serviceId),
	    promoCode: (0, _selectors.getPromoCode)(state),
	    appointmentId: (0, _selectors.getAppointmentId)(state),
	    isAppointmentPaid: (0, _selectors.isAppointmentPaid)(state),
	    canBeChargedWithSavedCard: (0, _selectors.canBeChargedWithSavedCard)(state),
	    isReservation: !!(0, _get3.default)(ownProps, 'location.query.isReservation')
	  };
	}, { chargeAppointment: _actions.chargeAppointment, fetchReservation: _actions.fetchReservation }), (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    this.props.fetchReservation(this.props.params.appointmentId);
	  }
	}), (0, _branch3.default)(function (props) {
	  return !props.appointmentId;
	}, _renderNothing3.default), (0, _branch3.default)(function (props) {
	  return props.isAppointmentPaid;
	}, (0, _renderComponent3.default)(_AppointmentPaidModal2.default)), (0, _withHandlers3.default)({
	  onSuccess: function onSuccess(props) {
	    return function (paymentToken, chargeWithSavedCard) {
	      return props.chargeAppointment(props.appointmentId, _extends({
	        tipAmount: props.tipAmount,
	        promoCode: props.promoCode,
	        chargeWithSavedCard: chargeWithSavedCard
	      }, props.isReservation ? { isReservation: true } : {}, paymentToken ? { paymentToken: paymentToken.id } : {}));
	    };
	  }
	}))(_CheckoutModal2.default);

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CustomTip = __webpack_require__(1164);
	
	var _CustomTip2 = _interopRequireDefault(_CustomTip);
	
	var _CustomTipSharedContainer = __webpack_require__(460);
	
	var _CustomTipSharedContainer2 = _interopRequireDefault(_CustomTipSharedContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _CustomTipSharedContainer2.default)(_CustomTip2.default);

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _selectors = __webpack_require__(27);
	
	var _actions = __webpack_require__(42);
	
	var _selectors2 = __webpack_require__(21);
	
	var _selectors3 = __webpack_require__(11);
	
	var _GuardedCheckoutButton = __webpack_require__(1165);
	
	var _GuardedCheckoutButton2 = _interopRequireDefault(_GuardedCheckoutButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    shopId: (0, _selectors3.getShopId)(state, ownProps.params.shopRoute),
	    barberId: (0, _selectors.getBarberId)(state, ownProps.params.barberRoute),
	    promoCode: (0, _selectors2.getPromoCode)(state),
	    customer: (0, _selectors2.getIsFormValid)(state) ? (0, _selectors2.getUser)(state) : undefined,
	    giftCardEnabled: (0, _selectors3.getGiftCardEnabled)(state, ownProps.params.shopRoute),
	    dateTime: (0, _moment2.default)(ownProps.params.reservationTime, _config2.default.timeSlugFormat).toJSON()
	  };
	}), (0, _withHandlers3.default)({
	  validate: function validate(props) {
	    return function () {
	      return (0, _actions.validatePrepayOnlyCustomer)(props.dispatch)(_extends({}, props.customer, {
	        shopId: props.shopId,
	        barberId: props.barberId,
	        serviceCost: props.costWithTaxes,
	        promoCode: props.promoCode,
	        includeWaitingListFee: props.timeWaitingList,
	        tipAmount: props.tipAmount,
	        dateTime: props.dateTime,
	        validatePrepayOnly: true
	      }));
	    };
	  }
	}))(_GuardedCheckoutButton2.default);

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _withCost = __webpack_require__(116);
	
	var _withCost2 = _interopRequireDefault(_withCost);
	
	var _withCostWithoutFees = __webpack_require__(1213);
	
	var _withCostWithoutFees2 = _interopRequireDefault(_withCostWithoutFees);
	
	var _OrderInformation = __webpack_require__(453);
	
	var _OrderInformation2 = _interopRequireDefault(_OrderInformation);
	
	var _OrderInformationSharedContainer = __webpack_require__(461);
	
	var _OrderInformationSharedContainer2 = _interopRequireDefault(_OrderInformationSharedContainer);
	
	var _selectors = __webpack_require__(11);
	
	var _WithApplePayQuery = __webpack_require__(96);
	
	var _WithApplePayQuery2 = _interopRequireDefault(_WithApplePayQuery);
	
	var _WithTimeWaitingList = __webpack_require__(97);
	
	var _WithTimeWaitingList2 = _interopRequireDefault(_WithTimeWaitingList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withCostHOC = (0, _compose3.default)(_WithTimeWaitingList2.default, (0, _branch3.default)(function (props) {
	  return props.showOnlyCostAndTaxes;
	}, _withCostWithoutFees2.default, _withCost2.default));
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, _WithApplePayQuery2.default, (0, _reactRedux.connect)(function (state, ownProps) {
	  var noExtrasForReserveNoPay = (0, _selectors.getNoExtrasForReserveNoPay)(state, ownProps.params.shopRoute);
	
	  return {
	    noExtrasForReserveNoPay: noExtrasForReserveNoPay,
	    showOnlyCostAndTaxes: noExtrasForReserveNoPay && !ownProps.withApplePay
	  };
	}, null), withCostHOC, _OrderInformationSharedContainer2.default)(_OrderInformation2.default);

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _WithShopCurrency = __webpack_require__(135);
	
	var _WithShopCurrency2 = _interopRequireDefault(_WithShopCurrency);
	
	var _selectors = __webpack_require__(11);
	
	var _WithBookNoPayQuery = __webpack_require__(161);
	
	var _WithBookNoPayQuery2 = _interopRequireDefault(_WithBookNoPayQuery);
	
	var _WithApplePayQuery = __webpack_require__(96);
	
	var _WithApplePayQuery2 = _interopRequireDefault(_WithApplePayQuery);
	
	var _Pay = __webpack_require__(1168);
	
	var _Pay2 = _interopRequireDefault(_Pay);
	
	var _WithShop = __webpack_require__(46);
	
	var _WithShop2 = _interopRequireDefault(_WithShop);
	
	var _WithThirdPartyPromo = __webpack_require__(431);
	
	var _WithThirdPartyPromo2 = _interopRequireDefault(_WithThirdPartyPromo);
	
	var _withCost = __webpack_require__(116);
	
	var _withCost2 = _interopRequireDefault(_withCost);
	
	var _withKioskIsReserveOnly = __webpack_require__(465);
	
	var _withKioskIsReserveOnly2 = _interopRequireDefault(_withKioskIsReserveOnly);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_withCost2.default, _WithShop2.default, _WithThirdPartyPromo2.default, _withKioskIsReserveOnly2.default, _WithApplePayQuery2.default, _reactRouter.withRouter, (0, _branch3.default)(function (prop) {
	  return prop.withApplePay;
	}, _renderNothing3.default), (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    isLadyClipperShop: (0, _selectors.getIsLadyClipperShop)(state, ownProps.params.shopRoute),
	    noExtrasForBookNoPay: (0, _selectors.getNoExtrasForReserveNoPay)(state, ownProps.params.shopRoute),
	    isKrwnZazzPlaceSteFoyShop: (0, _selectors.getIsKrwnZazzPlaceSteFoyShop)(state, ownProps.params.shopRoute)
	  };
	}), _WithShopCurrency2.default, _WithBookNoPayQuery2.default, (0, _withProps3.default)(function (props) {
	  if (!props.shop) {
	    return {
	      isReserveAndPayAvailable: false,
	      isReserveWithCardAvailable: false,
	      isReserveNoPayAvailable: false
	    };
	  }
	
	  if (!!props.isCoveredByDiscount && !props.noExtrasForBookNoPay) {
	    return {
	      isProcessAvailable: true
	    };
	  }
	
	  return {
	    isReserveAndPayAvailable: (!!props.totalAmount || props.noExtrasForBookNoPay) && !props.bookNoPayQuery && !props.isReserveNoPayOnly,
	    isReserveWithCardAvailable: !!props.totalAmount && props.bookAndReserve && !props.isReserveNoPayOnly,
	    isReserveNoPayAvailable: (!props.totalAmount || props.bookNoPay && !props.bookAndReserve || props.isReserveNoPayOnly) && !props.discount
	  };
	}))(_Pay2.default);

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _renderComponent2 = __webpack_require__(57);
	
	var _renderComponent3 = _interopRequireDefault(_renderComponent2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _PaymentFormPayFac = __webpack_require__(1170);
	
	var _PaymentFormPayFac2 = _interopRequireDefault(_PaymentFormPayFac);
	
	var _WithToggle = __webpack_require__(63);
	
	var _WithToggle2 = _interopRequireDefault(_WithToggle);
	
	var _PaymentFormApplePay = __webpack_require__(454);
	
	var _PaymentFormApplePay2 = _interopRequireDefault(_PaymentFormApplePay);
	
	var _applePay = __webpack_require__(299);
	
	var _withRouteParameters = __webpack_require__(83);
	
	var _withRouteParameters2 = _interopRequireDefault(_withRouteParameters);
	
	var _selectors = __webpack_require__(11);
	
	var _withPayFacInput = __webpack_require__(1214);
	
	var _withPayFacInput2 = _interopRequireDefault(_withPayFacInput);
	
	var _payFac = __webpack_require__(472);
	
	var _payFac2 = _interopRequireDefault(_payFac);
	
	var _selectors2 = __webpack_require__(21);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var areWeOnChargeAppointment = (0, _selectors2.getAppointmentId)(state);
	  var hasApplePay = state.app.applePay && !props.disableApplePay;
	  return {
	    hasApplePay: hasApplePay,
	    currency: (0, _selectors.getShopCurrency)(state, props.shopRoute),
	    shopCountry: (0, _selectors.getShopCountry)(state, props.shopRoute),
	    areWeOnChargeAppointment: (0, _selectors2.getAppointmentId)(state),
	    initialState: hasApplePay && areWeOnChargeAppointment,
	    isValidating: (0, _selectors2.getIsValidatingAppointment)(state)
	  };
	};
	
	var showSwalError = function showSwalError(error) {
	  window.swal({
	    title: 'Error',
	    text: (0, _get3.default)(error, 'message', ''),
	    type: 'error',
	    confirmButtonColor: '#dd6b55'
	  });
	};
	
	exports.default = (0, _compose3.default)(_withRouteParameters2.default, (0, _reactRedux.connect)(mapStateToProps), _WithToggle2.default, (0, _withState3.default)('processing', 'setProcessing', false), (0, _withProps3.default)(function (props) {
	  return {
	    toggleApplePay: props.toggle,
	    formDisabled: props.formDisabled || props.processing || props.isValidating
	  };
	}), (0, _withHandlers3.default)({
	  handleProcessingError: function handleProcessingError(props) {
	    return function (error) {
	      props.setProcessing(false);
	      showSwalError(error);
	    };
	  }
	}), (0, _withHandlers3.default)({
	  onClick: function onClick(props) {
	    return function () {
	      props.setProcessing(true);
	      (0, _applePay.applePaySession)(props.amount, props.currency, function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(result) {
	          var setupResponse;
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  _BookingAnalytics2.default.fillCardInfo({ source: 'squire_modal', isApplePay: true });
	                  _context.next = 3;
	                  return props.confirmSetup(result.token);
	
	                case 3:
	                  setupResponse = _context.sent;
	
	                  props.setProcessing(false);
	                  return _context.abrupt('return', setupResponse);
	
	                case 6:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, undefined);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }(), props.handleProcessingError, function () {
	        return props.setProcessing(false);
	      });
	    };
	  }
	}), (0, _branch3.default)(function (props) {
	  return props.toggled;
	}, (0, _renderComponent3.default)(_PaymentFormApplePay2.default)), (0, _withPayFacInput2.default)({}), (0, _withState3.default)('submitEnabled', 'setSubmitEnabled', false), (0, _withHandlers3.default)({
	  submit: function submit(props) {
	    return function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	        var token, payFac, result;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                e.preventDefault();
	
	                props.setProcessing(true);
	                token = null;
	
	                if (props.isCoveredByDiscount) {
	                  _context2.next = 21;
	                  break;
	                }
	
	                payFac = new _payFac2.default();
	
	                props.setPayFacInputsDisabled(true);
	
	                _context2.prev = 6;
	                _context2.next = 9;
	                return payFac.createToken({
	                  cardNumber: props.cardNumber,
	                  expiry: props.cardExpiry,
	                  cvc: props.cardCvc,
	                  zipCode: props.zipCode
	                });
	
	              case 9:
	                result = _context2.sent;
	
	                token = { id: result.token };
	                _context2.next = 18;
	                break;
	
	              case 13:
	                _context2.prev = 13;
	                _context2.t0 = _context2['catch'](6);
	
	                props.handleProcessingError(_context2.t0);
	                props.setProcessing(false);
	                return _context2.abrupt('return');
	
	              case 18:
	                _context2.prev = 18;
	
	                props.setPayFacInputsDisabled(false);
	                return _context2.finish(18);
	
	              case 21:
	                _context2.prev = 21;
	                _context2.next = 24;
	                return props.confirmSetup(token);
	
	              case 24:
	                _context2.next = 29;
	                break;
	
	              case 26:
	                _context2.prev = 26;
	                _context2.t1 = _context2['catch'](21);
	
	                props.handleProcessingError(_context2.t1);
	
	              case 29:
	                _context2.prev = 29;
	
	                props.setProcessing(false);
	                return _context2.finish(29);
	
	              case 32:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, undefined, [[6, 13, 18, 21], [21, 26, 29, 32]]);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	  },
	  setCardNumber: function setCardNumber(props) {
	    return function (event) {
	      props.onCardNumberChange(event.target.value, true);
	    };
	  },
	  cardNumberBlur: function cardNumberBlur(props) {
	    return function (event) {
	      props.onCardNumberChange(event.target.value);
	    };
	  },
	  setCardExpiry: function setCardExpiry(props) {
	    return function (event) {
	      props.onCardExpiryChange(event.target.value, true);
	    };
	  },
	  cardExpiryBlur: function cardExpiryBlur(props) {
	    return function (event) {
	      props.onCardExpiryChange(event.target.value);
	    };
	  },
	  setCardCvc: function setCardCvc(props) {
	    return function (event) {
	      props.onCardCvcChange(event.target.value, true);
	    };
	  },
	  cardCvcBlur: function cardCvcBlur(props) {
	    return function (event) {
	      props.onCardCvcChange(event.target.value);
	    };
	  },
	  setZipCode: function setZipCode(props) {
	    return function (event) {
	      props.setZipCode(event.target.value);
	      props.validateZipCode(event.target.value);
	    };
	  },
	  zipCodeBlur: function zipCodeBlur(props) {
	    return function () {
	      if (!props.hasErrors) {
	        if (props.zipCode) {
	          _BookingAnalytics2.default.fillCardInfoField('cardZipCode');
	        }
	        _BookingAnalytics2.default.fillCardInfo({ source: 'squire_modal' });
	      }
	    };
	  }
	}), (0, _lifecycle3.default)({
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (this.props.cardNumber) {
	      if (prevProps.isCoveredByDiscount !== this.props.isCoveredByDiscount) {
	        this.props.setPayFacInputsDisabled(this.props.isCoveredByDiscount);
	      }
	    }
	
	    if (this.props.cardNumber !== '' && this.props.cardExpiry !== '' && this.props.cardCvc !== '' && this.props.zipCode !== '' && this.props.submitEnabled === false) {
	      this.props.setSubmitEnabled(true);
	    }
	  }
	}))(_PaymentFormPayFac2.default);

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CustomTipSharedContainer = __webpack_require__(460);
	
	var _CustomTipSharedContainer2 = _interopRequireDefault(_CustomTipSharedContainer);
	
	var _PaymentModalCustomTip = __webpack_require__(1173);
	
	var _PaymentModalCustomTip2 = _interopRequireDefault(_PaymentModalCustomTip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _CustomTipSharedContainer2.default)(_PaymentModalCustomTip2.default);

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _withCost = __webpack_require__(116);
	
	var _withCost2 = _interopRequireDefault(_withCost);
	
	var _OrderInformation = __webpack_require__(453);
	
	var _OrderInformation2 = _interopRequireDefault(_OrderInformation);
	
	var _OrderInformationSharedContainer = __webpack_require__(461);
	
	var _OrderInformationSharedContainer2 = _interopRequireDefault(_OrderInformationSharedContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_withCost2.default, _OrderInformationSharedContainer2.default, (0, _withProps3.default)(function (props) {
	  return {
	    // sending 'kioskMode' here from outside payment modal,
	    // since kiosk context (and hence kiosk prop) gets lost inside Modal
	    shouldShowTip: !props.bookNoPayQuery && props.activeTip && !props.kioskMode,
	    headingClassName: 'c-payment-modal-heading u-mb',
	    className: 'c-payment-modal-order-info'
	  };
	}))(_OrderInformation2.default);

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _PaymenModalReedemCode = __webpack_require__(1169);
	
	var _PaymenModalReedemCode2 = _interopRequireDefault(_PaymenModalReedemCode);
	
	var _ReedemCodeSharedContainer = __webpack_require__(463);
	
	var _ReedemCodeSharedContainer2 = _interopRequireDefault(_ReedemCodeSharedContainer);
	
	var _WithTimeWaitingList = __webpack_require__(97);
	
	var _WithTimeWaitingList2 = _interopRequireDefault(_WithTimeWaitingList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_WithTimeWaitingList2.default, (0, _branch3.default)(function (props) {
	  return props.timeWaitingList;
	}, _renderNothing3.default), _ReedemCodeSharedContainer2.default)(_PaymenModalReedemCode2.default);

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _TipSharedContainer = __webpack_require__(464);
	
	var _TipSharedContainer2 = _interopRequireDefault(_TipSharedContainer);
	
	var _PaymentModalTip = __webpack_require__(1174);
	
	var _PaymentModalTip2 = _interopRequireDefault(_PaymentModalTip);
	
	var _withRouteParameters = __webpack_require__(83);
	
	var _withRouteParameters2 = _interopRequireDefault(_withRouteParameters);
	
	var _actions = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_withRouteParameters2.default, (0, _reactRedux.connect)(null, { setTip: _actions.setTip }), _TipSharedContainer2.default, (0, _lifecycle3.default)({
	  componentDidMount: function componentDidMount() {
	    this.props.setTip(this.props.defaultTip);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.props.setTip(0);
	  }
	}))(_PaymentModalTip2.default);

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(38);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(71);
	
	var _selectors2 = __webpack_require__(21);
	
	var _AvailableTimeRangeProvider = __webpack_require__(425);
	
	var _AvailableTimeRangeProvider2 = _interopRequireDefault(_AvailableTimeRangeProvider);
	
	var _actions = __webpack_require__(42);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _WithTimezone = __webpack_require__(115);
	
	var _WithTimezone2 = _interopRequireDefault(_WithTimezone);
	
	var _actions2 = __webpack_require__(99);
	
	var _PickTime = __webpack_require__(1175);
	
	var _PickTime2 = _interopRequireDefault(_PickTime);
	
	var _selectors3 = __webpack_require__(27);
	
	var _WithFetchBarbers = __webpack_require__(988);
	
	var _WithFetchBarbers2 = _interopRequireDefault(_WithFetchBarbers);
	
	var _helpers = __webpack_require__(7);
	
	var _flags = __webpack_require__(200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var PickTimeContainer = (0, _compose3.default)(_WithTimezone2.default, _WithFetchBarbers2.default, (0, _reactRedux.connect)(function (state, ownProps) {
	  var noTimesAvailable = (0, _selectors.getNoTimesAvailable)(state);
	
	  return {
	    noTimesAvailable: noTimesAvailable,
	    appointmentId: (0, _selectors2.getAppointmentId)(state),
	    appointmentTime: (0, _selectors2.getAppointmentTime)(state),
	    activeDay: (0, _selectors.getActiveDay)(state),
	    selectedTime: !noTimesAvailable && (0, _selectors.getActiveTime)(state),
	    times: (0, _selectors.getActiveDayTimes)(state, ownProps.timezone),
	    selectedBarberId: (0, _selectors3.getBarberId)(state, (0, _selectors.getActiveTimeBarber)(state)),
	    isAppointmentPaid: (0, _selectors2.isAppointmentPaid)(state)
	  };
	}, {
	  clearBarberAvailability: _actions2.clearBarberAvailability,
	  setActiveDay: _actions2.setActiveDay,
	  setActiveTime: _actions2.setActiveTime,
	  reschedule: _actions.reschedule,
	  setActiveTimeBarber: _actions2.setActiveTimeBarber
	}), (0, _withState3.default)('isTurnstileChallengeVisible', 'setTurnstileChallengeVisibility', false), (0, _AvailableTimeRangeProvider2.default)('activeDay'), (0, _withHandlers3.default)({
	  setTime: function setTime(props) {
	    return function (_ref) {
	      var time = _ref.time,
	          _ref$barberRoute = _ref.barberRoute,
	          barberRoute = _ref$barberRoute === undefined ? '' : _ref$barberRoute;
	      return function () {
	        props.setActiveTime((0, _moment2.default)(time).format(_config2.default.timeSlugFormat));
	        return props.setActiveTimeBarber(barberRoute);
	      };
	    };
	  },
	  rescheduleAndAskPromo: function rescheduleAndAskPromo(props) {
	    return _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var isBotProtectionOn, _ref3, success, token;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return (0, _flags.getFlag)('check-if-human');
	
	            case 2:
	              isBotProtectionOn = _context.sent;
	
	              if (!(props.isAppointmentPaid || !isBotProtectionOn)) {
	                _context.next = 5;
	                break;
	              }
	
	              return _context.abrupt('return', props.reschedule(props.appointmentId, (0, _moment2.default)(props.selectedTime, _config2.default.timeSlugFormat).toJSON(), props.selectedBarberId, 'ask' // api returns an error in case a promo code is not valid for selected date
	              ));
	
	            case 5:
	
	              props.setTurnstileChallengeVisibility(true);
	
	              _context.next = 8;
	              return (0, _helpers.wait)(10);
	
	            case 8:
	              _context.next = 10;
	              return (0, _helpers.renderTurnstileChallenge)('#turnstile');
	
	            case 10:
	              _ref3 = _context.sent;
	              success = _ref3.success;
	              token = _ref3.token;
	
	              if (success) {
	                _context.next = 18;
	                break;
	              }
	
	              _context.next = 16;
	              return (0, _helpers.wait)(3000);
	
	            case 16:
	              // let users contemplate their browsing history for a while
	              props.setTurnstileChallengeVisibility(false);
	              return _context.abrupt('return', null);
	
	            case 18:
	              _context.next = 20;
	              return (0, _helpers.wait)(1000);
	
	            case 20:
	              // pending-to-success animation
	              props.setTurnstileChallengeVisibility(false);
	
	              return _context.abrupt('return', props.reschedule(props.appointmentId, (0, _moment2.default)(props.selectedTime, _config2.default.timeSlugFormat).toJSON(), props.selectedBarberId, 'ask', // api returns an error in case a promo code is not valid for selected date
	              token));
	
	            case 22:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	  },
	  rescheduleAndRemovePromo: function rescheduleAndRemovePromo(props) {
	    return _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var isBotProtectionOn, _ref5, success, token;
	
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.next = 2;
	              return (0, _flags.getFlag)('check-if-human');
	
	            case 2:
	              isBotProtectionOn = _context2.sent;
	
	              if (!(props.isAppointmentPaid || !isBotProtectionOn)) {
	                _context2.next = 5;
	                break;
	              }
	
	              return _context2.abrupt('return', props.reschedule(props.appointmentId, (0, _moment2.default)(props.selectedTime, _config2.default.timeSlugFormat).toJSON(), props.selectedBarberId, 'yes' // api removes promo code in case it's not valid for selected date
	              ));
	
	            case 5:
	
	              props.setTurnstileChallengeVisibility(true);
	
	              _context2.next = 8;
	              return (0, _helpers.wait)(10);
	
	            case 8:
	              _context2.next = 10;
	              return (0, _helpers.renderTurnstileChallenge)('#turnstile');
	
	            case 10:
	              _ref5 = _context2.sent;
	              success = _ref5.success;
	              token = _ref5.token;
	
	              if (success) {
	                _context2.next = 18;
	                break;
	              }
	
	              _context2.next = 16;
	              return (0, _helpers.wait)(3000);
	
	            case 16:
	              // let users contemplate their browsing history for a while
	              props.setTurnstileChallengeVisibility(false);
	              return _context2.abrupt('return', null);
	
	            case 18:
	              _context2.next = 20;
	              return (0, _helpers.wait)(1000);
	
	            case 20:
	              // pending-to-success animation
	              props.setTurnstileChallengeVisibility(false);
	
	              return _context2.abrupt('return', props.reschedule(props.appointmentId, (0, _moment2.default)(props.selectedTime, _config2.default.timeSlugFormat).toJSON(), props.selectedBarberId, 'yes', // api removes promo code in case it's not valid for selected date
	              token));
	
	            case 22:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	  }
	}), (0, _lifecycle3.default)({
	  componentWillUnmount: function componentWillUnmount() {
	    this.props.setActiveTime('');
	  }
	}), (0, _withPropsOnChange3.default)(['appointmentTime'], function (props) {
	  props.setActiveTime((0, _moment2.default)(props.appointmentTime).format(_config2.default.timeSlugFormat));
	}))(_PickTime2.default);
	
	exports.default = PickTimeContainer;

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _Promo = __webpack_require__(1177);
	
	var _Promo2 = _interopRequireDefault(_Promo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)((0, _withState3.default)('isExpanded', 'setIsExpanded', false), (0, _withHandlers3.default)({
	  expandPromo: function expandPromo(props) {
	    return function () {
	      props.setIsExpanded(true);
	    };
	  }
	}))(_Promo2.default);

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _PromoTidalCheckout = __webpack_require__(1181);
	
	var _PromoTidalCheckout2 = _interopRequireDefault(_PromoTidalCheckout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)((0, _withState3.default)('isExpanded', 'setIsExpanded', false), (0, _withHandlers3.default)({
	  expand: function expand(props) {
	    return function () {
	      props.setIsExpanded(true);
	    };
	  }
	}))(_PromoTidalCheckout2.default);

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _PromoTidalReservation = __webpack_require__(1182);
	
	var _PromoTidalReservation2 = _interopRequireDefault(_PromoTidalReservation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)((0, _withProps3.default)(function (props) {
	  return {
	    promoUrl: 'https://offer.tidal.com/voucher?code=' + props.promoCode
	  };
	}), (0, _withState3.default)('showCopiedMessageClass', 'setshowCopiedMessageClass', false), (0, _withHandlers3.default)({
	  onCopyClick: function onCopyClick(props) {
	    return function () {
	      navigator.clipboard.writeText(props.promoCode);
	
	      props.setshowCopiedMessageClass(true);
	      setTimeout(function () {
	        return props.setshowCopiedMessageClass(false);
	      }, 3000);
	    };
	  }
	}))(_PromoTidalReservation2.default);

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _ReedemCode = __webpack_require__(1183);
	
	var _ReedemCode2 = _interopRequireDefault(_ReedemCode);
	
	var _ReedemCodeSharedContainer = __webpack_require__(463);
	
	var _ReedemCodeSharedContainer2 = _interopRequireDefault(_ReedemCodeSharedContainer);
	
	var _WithTimeWaitingList = __webpack_require__(97);
	
	var _WithTimeWaitingList2 = _interopRequireDefault(_WithTimeWaitingList);
	
	var _selectors = __webpack_require__(11);
	
	var _WithApplePayQuery = __webpack_require__(96);
	
	var _WithApplePayQuery2 = _interopRequireDefault(_WithApplePayQuery);
	
	var _withRouteParameters = __webpack_require__(83);
	
	var _withRouteParameters2 = _interopRequireDefault(_withRouteParameters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    noExtrasForBookNoPay: (0, _selectors.getNoExtrasForReserveNoPay)(state, ownProps.shopRoute)
	  };
	};
	
	exports.default = (0, _compose3.default)(_WithApplePayQuery2.default, _withRouteParameters2.default, _WithTimeWaitingList2.default, (0, _reactRedux.connect)(mapStateToProps, null), (0, _branch3.default)(function (props) {
	  return props.timeWaitingList || props.noExtrasForBookNoPay && !props.withApplePay;
	}, _renderNothing3.default), _ReedemCodeSharedContainer2.default)(_ReedemCode2.default);

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _helpers = __webpack_require__(7);
	
	var _WithToggle = __webpack_require__(63);
	
	var _WithToggle2 = _interopRequireDefault(_WithToggle);
	
	var _selectors = __webpack_require__(21);
	
	var _RescheduleLink = __webpack_require__(1184);
	
	var _RescheduleLink2 = _interopRequireDefault(_RescheduleLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RescheduleLinkContainer = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state) {
	  return {
	    isReschedulable: (0, _helpers.appointmentIsCancelable)((0, _selectors.getAppointmentStart)(state), (0, _selectors.getBarberAdvanceCancelMins)(state)) && (0, _selectors.getCanCustomerCancel)(state)
	  };
	}), _WithToggle2.default, (0, _withProps3.default)(function (props) {
	  if (!props.isReschedulable) {
	    return {
	      onClick: props.on,
	      rescheduleLink: null
	    };
	  }
	  return {
	    rescheduleLink: '/view-reservation/' + props.params.appointmentId + '/reschedule'
	  };
	}))(_RescheduleLink2.default);
	
	exports.default = RescheduleLinkContainer;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose = __webpack_require__(4);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _branch = __webpack_require__(14);
	
	var _branch2 = _interopRequireDefault(_branch);
	
	var _renderNothing = __webpack_require__(22);
	
	var _renderNothing2 = _interopRequireDefault(_renderNothing);
	
	var _TermsOfService = __webpack_require__(1189);
	
	var _TermsOfService2 = _interopRequireDefault(_TermsOfService);
	
	var _WithKioskProp = __webpack_require__(59);
	
	var _WithKioskProp2 = _interopRequireDefault(_WithKioskProp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TermsOfServiceContainer = (0, _compose2.default)(_WithKioskProp2.default, (0, _branch2.default)(function (props) {
	  return props.kiosk;
	}, _renderNothing2.default))(_TermsOfService2.default);
	
	exports.default = TermsOfServiceContainer;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _Tip = __webpack_require__(1190);
	
	var _Tip2 = _interopRequireDefault(_Tip);
	
	var _TipSharedContainer = __webpack_require__(464);
	
	var _TipSharedContainer2 = _interopRequireDefault(_TipSharedContainer);
	
	var _selectors = __webpack_require__(27);
	
	var _selectors2 = __webpack_require__(11);
	
	var _WithApplePayQuery = __webpack_require__(96);
	
	var _WithApplePayQuery2 = _interopRequireDefault(_WithApplePayQuery);
	
	var _WithKioskProp = __webpack_require__(59);
	
	var _WithKioskProp2 = _interopRequireDefault(_WithKioskProp);
	
	var _WithTimeWaitingList = __webpack_require__(97);
	
	var _WithTimeWaitingList2 = _interopRequireDefault(_WithTimeWaitingList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_reactRouter.withRouter, _WithApplePayQuery2.default, _WithKioskProp2.default, _WithTimeWaitingList2.default, (0, _reactRedux.connect)(function (state, ownProps) {
	  var tipEnabledForBarber = (0, _selectors.getTipEnabledForBarber)(state, ownProps.params.barberRoute);
	  var noExtrasForReserveNoPay = (0, _selectors2.getNoExtrasForReserveNoPay)(state, ownProps.params.shopRoute);
	
	  return {
	    tipEnabled: tipEnabledForBarber && (!noExtrasForReserveNoPay || ownProps.withApplePay) && !ownProps.kiosk
	  };
	}), _TipSharedContainer2.default)(_Tip2.default);

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _WithKioskProp = __webpack_require__(59);
	
	var _WithKioskProp2 = _interopRequireDefault(_WithKioskProp);
	
	var _selectors = __webpack_require__(21);
	
	var reservationSelectors = _interopRequireWildcard(_selectors);
	
	var _WithBookNoPayQuery = __webpack_require__(161);
	
	var _WithBookNoPayQuery2 = _interopRequireDefault(_WithBookNoPayQuery);
	
	var _selectors2 = __webpack_require__(51);
	
	var servicesSelectors = _interopRequireWildcard(_selectors2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_WithKioskProp2.default, _reactRouter.withRouter, _WithBookNoPayQuery2.default, (0, _reactRedux.connect)(function (state, ownProps) {
	  var serviceCost = reservationSelectors.getServicesCost(state);
	  var taxes = reservationSelectors.getTaxBreakdownAmount(state);
	  var taxBreakdown = reservationSelectors.getTaxBreakdown(state);
	  var totalAmount = reservationSelectors.getTotalAmount(state);
	
	  return {
	    servicesNamesShort: servicesSelectors.getServiceNameShort(state, ownProps.params.serviceId),
	    servicesNamesLong: servicesSelectors.getServiceNameLong(state, ownProps.params.serviceId),
	    taxes: taxes,
	    totalAmount: totalAmount,
	    costWithTaxes: serviceCost + taxes,
	    serviceCost: serviceCost,
	    taxBreakdown: taxBreakdown
	  };
	}));

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reduce2 = __webpack_require__(591);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _payFac = __webpack_require__(472);
	
	var _payFac2 = _interopRequireDefault(_payFac);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var payFac = new _payFac2.default();
	
	  return (0, _compose3.default)((0, _withState3.default)('payFacInputErrors', 'setPayFacInputErrors', {}), (0, _withState3.default)('hasErrors', 'setHasErrors', false), (0, _withState3.default)('payFacInputsDisabled', 'setPayFacInputsDisabled', false), (0, _withState3.default)('cardBrand', 'setCardBrand', 'unknown'), (0, _withState3.default)('cardBrandIcon', 'setCardBrandIcon', _payFac.DEFAULT_ICON), (0, _withState3.default)('cardNumber', 'setCardNumber', ''), (0, _withState3.default)('cardExpiry', 'setCardExpiry', ''), (0, _withState3.default)('cardCvc', 'setCardCvc', ''), (0, _withState3.default)('zipCode', 'setZipCode', ''), (0, _withState3.default)('cardExpiryRef', 'setCardExpiryRef', null), (0, _withState3.default)('cardCvcRef', 'setCardCvcRef', null), (0, _withState3.default)('zipCodeRef', 'setZipCodeRef', null), (0, _withHandlers3.default)({
	    updateErrors: function updateErrors(props) {
	      return function (error) {
	        var errors = _extends({}, props.payFacInputErrors, error);
	
	        var hasErrors = !!(0, _reduce3.default)(errors, function (memo, err) {
	          return memo || err;
	        }, false);
	
	        props.setPayFacInputErrors(errors);
	        props.setHasErrors(hasErrors);
	        return hasErrors;
	      };
	    }
	  }), (0, _withHandlers3.default)({
	    onCardNumberChange: function onCardNumberChange(props) {
	      return function (cardNumber) {
	        var checkPotentiallyValid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var validation = payFac.validateCardNumber(cardNumber, checkPotentiallyValid);
	        props.setCardBrand(validation.card && validation.card.type ? validation.card.type : 'unknown');
	        props.setCardBrandIcon(validation.brandIcon);
	        props.setCardNumber(validation.formatted || '');
	        props.updateErrors({ cardNumber: validation.error });
	
	        if (validation.isValid) {
	          _BookingAnalytics2.default.fillCardInfoField('cardNumber');
	          props.cardExpiryRef.focus();
	        }
	      };
	    },
	    onCardExpiryChange: function onCardExpiryChange(props) {
	      return function (expiry) {
	        var checkPotentiallyValid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var validation = payFac.validateCardExpiry(expiry, checkPotentiallyValid);
	        props.setCardExpiry(validation.formatted || '');
	        props.updateErrors({ cardExpiry: validation.error });
	
	        if (validation.isValid) {
	          _BookingAnalytics2.default.fillCardInfoField('cardExpiry');
	          props.cardCvcRef.focus();
	        }
	      };
	    },
	    onCardCvcChange: function onCardCvcChange(props) {
	      return function (cvc) {
	        var checkPotentiallyValid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var validation = payFac.validateCardCvc(cvc, props.cardNumber, checkPotentiallyValid);
	        props.setCardCvc(validation.formattedCvc || '');
	        props.updateErrors({ cardCvc: validation.cvcError });
	
	        if (validation.card && validation.card && cvc.length === validation.card.code.size) {
	          _BookingAnalytics2.default.fillCardInfoField('cardCvc');
	          props.zipCodeRef.focus();
	        }
	      };
	    },
	    validateZipCode: function validateZipCode(props) {
	      return function (zipCode) {
	        return props.updateErrors({ zipCode: zipCode ? null : 'Zip/postal code is required' });
	      };
	    }
	  }));
	};

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _findIndex2 = __webpack_require__(347);
	
	var _findIndex3 = _interopRequireDefault(_findIndex2);
	
	var _upperFirst2 = __webpack_require__(30);
	
	var _upperFirst3 = _interopRequireDefault(_upperFirst2);
	
	var _reduce2 = __webpack_require__(591);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _stripe = __webpack_require__(473);
	
	var _stripe2 = _interopRequireDefault(_stripe);
	
	var _helpers = __webpack_require__(7);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var style = {
	  base: {
	    lineHeight: '40px',
	    backgroundColor: '#fff',
	    padding: '0 10px',
	    marginLeft: '10px',
	    fontSize: '14px',
	    fontFamily: 'Open Sans, sans-serif',
	    color: '#4F4442',
	
	    '::placeholder': {
	      color: 'rgba(0,0,0,0.5)'
	    }
	  }
	};
	
	var fonts = [{
	  src: 'local("Open Sans"), url("https://fonts.gstatic.com/s/opensans/v17/mem8YaGs126MiZpBA-UFVZ0bf8pkAg.woff2")',
	  family: 'Open Sans',
	  style: 'normal'
	}];
	
	var focusOrder = ['cardNumber', 'cardExpiry', 'cardCvc', 'zipCode'];
	
	exports.default = function (_ref) {
	  var _ref$cardNumberId = _ref.cardNumberId,
	      cardNumberId = _ref$cardNumberId === undefined ? 'stripeCardNumberInput' : _ref$cardNumberId,
	      _ref$cardCvcId = _ref.cardCvcId,
	      cardCvcId = _ref$cardCvcId === undefined ? 'stripeCardCvcInput' : _ref$cardCvcId,
	      _ref$cardExpiryId = _ref.cardExpiryId,
	      cardExpiryId = _ref$cardExpiryId === undefined ? 'stripeCardExpiryInput' : _ref$cardExpiryId,
	      _ref$zipCodeId = _ref.zipCodeId,
	      zipCodeId = _ref$zipCodeId === undefined ? 'stripeZipCodeInput' : _ref$zipCodeId;
	
	  var stripe = new _stripe2.default();
	  return (0, _compose3.default)((0, _withState3.default)('generatedInputId', '_', function () {
	    return (0, _helpers.generateShortId)();
	  }), (0, _withState3.default)('stripeInputErrors', 'setStripeInputErrors', {}), (0, _withState3.default)('hasErrors', 'setHasErrors', false), (0, _withState3.default)('cardBrand', 'setCardBrand', 'unknown'), (0, _withState3.default)('cardNumber', 'setCardNumber', null), (0, _withState3.default)('cardExpiry', 'setCardExpiry', null), (0, _withState3.default)('cardCvc', 'setCardCvc', null), (0, _withState3.default)('zipCode', 'setZipCode', null), (0, _withProps3.default)(function (props) {
	    return {
	      cardNumberId: cardNumberId + '_' + props.generatedInputId,
	      cardCvcId: cardCvcId + '_' + props.generatedInputId,
	      cardExpiryId: cardExpiryId + '_' + props.generatedInputId,
	      zipCodeId: zipCodeId + '_' + props.generatedInputId
	    };
	  }), (0, _withHandlers3.default)({
	    validateZipCode: function validateZipCode(props) {
	      return function () {
	        if (!props.zipCode) {
	          return true;
	        }
	
	        var zipCode = props.zipCode.value;
	        var errors = _extends({}, props.stripeInputErrors, {
	          zipCode: zipCode ? null : 'Zip/postal code is required'
	        });
	        var hasErrors = (0, _reduce3.default)(errors, function (memo, err) {
	          return memo || err;
	        }, false);
	
	        props.setStripeInputErrors(errors);
	        props.setHasErrors(hasErrors);
	        return !hasErrors;
	      };
	    },
	    onChange: function onChange(props) {
	      return function (event) {
	        var error = (0, _get3.default)(event, 'error.message');
	        var cardBrand = event.elementType === 'cardNumber' ? event.brand : props.cardBrand;
	        var errors = _extends({}, props.stripeInputErrors, _defineProperty({}, event.elementType, error));
	
	        props.setStripeInputErrors(errors);
	        props.setHasErrors((0, _reduce3.default)(errors, function (memo, err) {
	          return memo || err;
	        }, false));
	        props.setCardBrand(cardBrand);
	
	        if (event.complete) {
	          // We have a well-formed and potentially completed input value. We can fire event for analytics
	          _BookingAnalytics2.default.fillCardInfoField(event.elementType);
	
	          var activeFocusIdx = (0, _findIndex3.default)(focusOrder, function (item) {
	            return item === event.elementType;
	          });
	          var nextFocusName = focusOrder[activeFocusIdx + 1];
	          var el = props[nextFocusName];
	
	          // amex allows both 3 and 4 digit CVCs but event.complete is true even with 3 digits,
	          // so we can't rely on that field and we can't autofocus to the next element
	          // once amex cvc is marked as complete
	          var isAmexCvcChange = cardBrand === 'amex' && event.elementType === 'cardCvc';
	
	          if (el && !isAmexCvcChange) {
	            el.focus();
	          }
	        }
	      };
	    }
	  }), (0, _withHandlers3.default)({
	    setUpElement: function setUpElement(props) {
	      return function (elements, type, config) {
	        var element = elements.create(type, config);
	        element.mount('#' + props[type + 'Id']);
	        element.addListener('change', props.onChange);
	        props['set' + (0, _upperFirst3.default)(type)](element);
	      };
	    },
	    disposeElement: function disposeElement(props) {
	      return function (type) {
	        props[type].removeListener('change', props.onChange);
	        props[type].focus();
	        props[type].blur();
	        props[type].destroy();
	      };
	    },
	    clearElement: function clearElement(props) {
	      return function (type) {
	        if (props[type]) {
	          props[type].clear();
	        }
	      };
	    }
	  }), (0, _withHandlers3.default)({
	    mountStripeInputs: function mountStripeInputs(props) {
	      return function () {
	        var elements = stripe.elements({ fonts: fonts });
	        props.setUpElement(elements, 'cardNumber', {
	          style: { base: _extends({}, style.base, { paddingLeft: '40px' }) },
	          placeholder: 'Card Number'
	        });
	        props.setUpElement(elements, 'cardExpiry', { style: style });
	        props.setUpElement(elements, 'cardCvc', { style: style });
	
	        var zipCode = document.getElementById(props.zipCodeId);
	        props.setZipCode(zipCode);
	      };
	    },
	    unmountStripeInputs: function unmountStripeInputs(props) {
	      return function () {
	        props.disposeElement('cardNumber');
	        props.disposeElement('cardExpiry');
	        props.disposeElement('cardCvc');
	      };
	    },
	    clearStripeInputs: function clearStripeInputs(props) {
	      return function () {
	        props.clearElement('cardNumber');
	        props.clearElement('cardExpiry');
	        props.clearElement('cardCvc');
	        props.setStripeInputErrors({});
	        props.setHasErrors(false);
	      };
	    },
	    setStripeInputsDisabled: function setStripeInputsDisabled(props) {
	      return function (state) {
	        props.cardNumber.update({ disabled: state });
	        props.cardExpiry.update({ disabled: state });
	        props.cardCvc.update({ disabled: state });
	
	        if (state) {
	          props.zipCode.setAttribute('disabled', state);
	        } else {
	          props.zipCode.removeAttribute('disabled');
	        }
	      };
	    },
	    focusInput: function focusInput(props) {
	      return function (name) {
	        props[name].focus();
	      };
	    }
	  }));
	};

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(234);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reservationReducer;
	
	var _immutable = __webpack_require__(66);
	
	var _constants = __webpack_require__(10);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_FIELDS = [{
	  id: 'firstName',
	  name: 'fname',
	  label: 'First name',
	  errorMessage: 'You must enter first name',
	  autoComplete: 'given-name',
	  required: true
	}, {
	  id: 'lastName',
	  name: 'lname',
	  label: 'Last name',
	  errorMessage: 'You must enter last name',
	  autoComplete: 'family-name',
	  required: true
	}, {
	  id: 'phone',
	  name: 'phone',
	  label: 'Phone number',
	  errorMessage: 'You must enter valid phone number',
	  autoComplete: 'tel-national',
	  required: true,
	  type: 'tel'
	}, {
	  id: 'email',
	  name: 'email',
	  label: 'Email address',
	  errorMessage: 'You must enter valid email that you own',
	  autoComplete: 'email',
	  required: true,
	  type: 'email'
	}];
	
	var initialState = (0, _immutable.fromJS)({
	  tip: null,
	  tips: [],
	  services: [],
	  fields: DEFAULT_FIELDS,
	  appointment: {},
	  isFetching: false,
	  paymentProcessing: false,
	  timeAvailable: false,
	  fees: 0,
	  promo: {
	    isValid: false,
	    error: '',
	    isFetching: false,
	    amount: 0,
	    promoCode: '',
	    validationNote: ''
	  },
	  giftCard: {
	    appliedAmount: null,
	    remainingAmount: null
	  },
	  customTip: null,
	  total: 0,
	  totalWithoutTipAndFees: 0,
	  processing: false,
	  errorMessage: null,
	  taxBreakdown: [],
	  outstandingAppointmentValidateRequests: [],
	  membershipDiscounts: []
	});
	
	function isFieldValid(id, value, countryCode, shop) {
	  switch (id) {
	    case 'phone':
	      return (0, _helpers.isValidPhone)(value, countryCode);
	
	    case 'email':
	      {
	        // forbid using shop email and its variations for booking on prod
	        var isAllowedEmail = ("production") !== 'production' || !(0, _helpers.isSameEmail)(shop.email, value);
	        return (0, _helpers.isValidEmail)(value) && isAllowedEmail;
	      }
	
	    case 'adultsonly':
	      return value === true;
	
	    case 'lastName':
	      return (0, _helpers.isValidLastName)(value);
	
	    default:
	      return (0, _helpers.isValidName)(value);
	  }
	}
	
	function reservationReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SET_TIPS:
	      return state.withMutations(function (s) {
	        return s.set('tips', action.payload);
	      });
	
	    case _constants.RESET_TIP:
	      return state.withMutations(function (s) {
	        return s.set('tip', initialState.get('tip')).set('customTip', initialState.get('customTip'));
	      });
	
	    case _constants.SET_TIP:
	      return state.withMutations(function (s) {
	        var tip = action.payload;
	        if (action.payload === 0) {
	          s.set('customTip', 0);
	        } else if (action.payload === null) {
	          tip = 0;
	        } else if (action.payload !== '') {
	          s.set('customTip', initialState.get('customTip'));
	        }
	
	        s.set('tip', tip);
	      });
	
	    case _constants.SET_CUSTOM_TIP:
	      {
	        return state.withMutations(function (s) {
	          return s.set('customTip', action.payload).set('tip', initialState.get('tip'));
	        });
	      }
	
	    case _constants.SET_SERVICES:
	      return state.withMutations(function (s) {
	        return s.set('services', action.payload);
	      });
	
	    case _constants.SET_TOTAL:
	      return state.withMutations(function (s) {
	        return s.set('total', action.payload);
	      });
	
	    case _constants.SET_TOTAL_WITHOUT_TIP_AND_FEES:
	      return state.withMutations(function (s) {
	        return s.set('totalWithoutTipAndFees', action.payload);
	      });
	
	    case _constants.ADD_FIELD:
	      {
	        return state.withMutations(function (s) {
	          var fields = state.get('fields').push((0, _immutable.fromJS)(action.payload));
	          return s.set('fields', fields);
	        });
	      }
	
	    case _constants.TOUCH_FIELD:
	      {
	        var index = state.get('fields').findIndex(function (field) {
	          return field.get('id') === action.payload;
	        });
	        return state.setIn(['fields', index, 'touched'], true);
	      }
	
	    case _constants.VALIDATE_FIELD:
	      {
	        var _index = state.get('fields').findIndex(function (field) {
	          return field.get('id') === action.payload.id;
	        });
	        var field = state.get('fields').get(_index);
	        var id = field.get('id');
	        var countryCode = action.payload.countryCode;
	
	        return state.setIn(['fields', _index, 'error'], !isFieldValid(id, field.get('value'), countryCode, action.payload.shop));
	      }
	
	    case _constants.UPDATE_FIELD:
	      {
	        var _index2 = state.get('fields').findIndex(function (field) {
	          return field.get('id') === action.payload.id;
	        });
	        return state.withMutations(function (s) {
	          return s.setIn(['fields', _index2, 'value'], action.payload.value);
	        });
	      }
	
	    case _constants.REQUEST_RESERVATION:
	      return state.set('isFetching', true);
	
	    case _constants.RECEIVE_RESERVATION:
	    case _constants.BOOK_APPOINTMENT_TIME_SLOT_SUCCESS:
	      return state.withMutations(function (s) {
	        return s.set('isFetching', false).set('appointment', (0, _immutable.fromJS)(_extends({}, action.payload, { shop: (0, _helpers.transformShopAddress)(action.payload.shop) })));
	      });
	
	    case _constants.CLEAR_RESERVATIONS:
	      return state.set('appointment', {});
	
	    case _constants.RESET_FIELDS:
	      return state.set('fields', (0, _immutable.fromJS)(DEFAULT_FIELDS));
	
	    case _constants.PROCESS_PAYMENT:
	      return state.set('paymentProcessing', true);
	
	    case _constants.RESET_PROCESS_PAYMENT:
	    case _constants.PROCESS_PAYMENT_SUCCESS:
	    case _constants.FAILED_CHARGES:
	      return state.set('paymentProcessing', false);
	
	    case _constants.CHECK_TIME_AVAILABLE:
	    case _constants.TIME_UNAVAILABLE:
	      return state.set('timeAvailable', false);
	
	    case _constants.VALIDATING_APPT_REQUEST_STARTED:
	      return state.updateIn(['outstandingAppointmentValidateRequests'], function (list) {
	        return list.push(action.payload);
	      });
	
	    case _constants.VALIDATING_APPT_REQUEST_FINISHED:
	      return state.set('outstandingAppointmentValidateRequests', state.get('outstandingAppointmentValidateRequests').filter(function (id) {
	        return id !== action.payload;
	      }));
	
	    case _constants.TIME_AVAILABLE:
	      return state.set('timeAvailable', true);
	
	    case _constants.RESET_PROMO_CODE:
	      return state.set('promo', initialState.get('promo')).set('giftCard', initialState.get('giftCard'));
	
	    case _constants.REMOVE_PROMO_FROM_RESERVATION:
	      return state.setIn(['promo', 'promoCode'], initialState.get('promo').promoCode);
	
	    case _constants.RESET_PROMO_ERROR:
	      return state.setIn(['promo', 'error'], initialState.get('promo').error);
	
	    case _constants.SET_PROMO_CODE:
	      return state.setIn(['promo', 'amount'], action.payload.amount || 0).setIn(['promo', 'promoCode'], action.payload.promoCode).setIn(['promo', 'isValid'], !(0, _isNil3.default)(action.payload.amount)).setIn(['promo', 'error'], false).setIn(['promo', 'isFetching'], (0, _isNil3.default)(action.payload.amount)).setIn(['promo', 'validationNote'], action.payload.validationNote).setIn(['giftCard', 'appliedAmount'], null).setIn(['giftCard', 'remainingAmount'], null);
	
	    case _constants.SET_GIFT_CARD_CODE:
	      return state.setIn(['promo', 'amount'], 0).setIn(['promo', 'promoCode'], action.payload.promoCode).setIn(['promo', 'isValid'], true).setIn(['promo', 'error'], false).setIn(['promo', 'isFetching'], false).setIn(['giftCard', 'appliedAmount'], action.payload.appliedAmount || 0).setIn(['giftCard', 'remainingAmount'], action.payload.remainingAmount || 0);
	
	    case _constants.FETCH_PROMO_CODE:
	      return state.setIn(['promo', 'isFetching'], true);
	
	    case _constants.SET_MEMBERSHIP_DISCOUNTS:
	      return state.set('membershipDiscounts', action.payload);
	
	    case _constants.INVALID_PROMO_CODE:
	      return state.setIn(['promo', 'isValid'], false).setIn(['promo', 'error'], action.payload).setIn(['promo', 'isFetching'], false);
	
	    case _constants.RESET_FEE:
	      return state.set('fees', initialState.fees);
	
	    case _constants.FETCH_FEE:
	      return state.set('fees', action.payload);
	
	    case _constants.SET_PROCESSING:
	      return state.set('processing', Boolean(action.payload));
	
	    case _constants.FAILED_BOOK_AND_RESERVE:
	    case _constants.RESCHEDULE_INVALID_PROMO_ERROR:
	      return state.set('errorMessage', action.payload);
	
	    case _constants.CLEAR_ERROR:
	      return state.set('errorMessage', null);
	    case _constants.SET_TAX_BREAKDOWN:
	      return state.set('taxBreakdown', (0, _immutable.fromJS)(action.payload));
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pickBy2 = __webpack_require__(105);
	
	var _pickBy3 = _interopRequireDefault(_pickBy2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _hoc = __webpack_require__(297);
	
	var _ScrollToTop = __webpack_require__(984);
	
	var _ScrollToTop2 = _interopRequireDefault(_ScrollToTop);
	
	var _WithKioskProp = __webpack_require__(59);
	
	var _WithKioskProp2 = _interopRequireDefault(_WithKioskProp);
	
	var _actions = __webpack_require__(64);
	
	var _actions2 = __webpack_require__(92);
	
	var _selectors = __webpack_require__(27);
	
	var _actions3 = __webpack_require__(117);
	
	var _helpers = __webpack_require__(7);
	
	var _Services = __webpack_require__(296);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SCROLL_OFFSET = -1;
	
	var fetchData = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(null, {
	  fetchShop: _actions.fetchShop,
	  fetchBarbers: _actions2.fetchBarbers,
	  fetchServices: _actions3.fetchServices
	}), (0, _withHandlers3.default)({
	  fetchData: function fetchData(props) {
	    return function () {
	      return props.fetchShop(props.params.shopRoute, props.urlPattern).then(function () {
	        return props.fetchBarbers(props.params.shopRoute, props.urlPattern);
	      }).then(function () {
	        return props.fetchServices(props.params.shopRoute, props.params.barberRoute, props.params, props.urlPattern, props.kiosk);
	      });
	    };
	  }
	}));
	
	var generateUrl = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    allowMultipleServices: (0, _selectors.getAllowMultipleServices)(state, ownProps.params.barberRoute, ownProps.params.shopRoute),
	    selectedIds: ownProps.params.serviceId || ''
	  };
	}), (0, _withHandlers3.default)({
	  generateUrlString: function generateUrlString(props) {
	    return function (id) {
	      var serviceId = function () {
	        if (!props.allowMultipleServices) return id;
	        if (!props.selectedIds) return id;
	
	        return (0, _helpers.toggleItemInArray)(props.selectedIds.split(';'), id).join(';');
	      }();
	
	      return (0, _helpers.generateUrlString)((0, _pickBy3.default)({
	        shopRoute: props.params.shopRoute,
	        barberRoute: props.params.barberRoute,
	        serviceId: serviceId
	      }), props.urlPattern);
	    };
	  }
	}), (0, _withHandlers3.default)({
	  onServiceClick: function onServiceClick(props) {
	    return function (id) {
	      return function (e) {
	        e.preventDefault();
	        props.router.replace(props.generateUrlString(id));
	      };
	    };
	  }
	}));
	
	exports.default = (0, _compose3.default)(_WithKioskProp2.default, fetchData, _hoc.commonServicesProvider, generateUrl, (0, _ScrollToTop2.default)(SCROLL_OFFSET))(_Services2.default);

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isUndefined2 = __webpack_require__(587);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shapes = __webpack_require__(23);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Category = function Category(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'layout__item' },
	    _react2.default.createElement('button', Object.assign({}, props, {
	      className: (0, _classnames2.default)('c-tag', { 'is-active': props.active, 'is-selected': props.selected })
	    }))
	  );
	};
	Category.propTypes = {
	  active: _shapes.flag,
	  selected: _shapes.flag
	};
	Category.defaultProps = {
	  active: false,
	  selected: false
	};
	
	var Categories = function Categories(_ref) {
	  var categories = _ref.categories,
	      setCategory = _ref.setCategory,
	      resetCategory = _ref.resetCategory,
	      selectedCategory = _ref.selectedCategory;
	
	  if ((0, _isEmpty3.default)(categories)) return null;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'layout layout--small layout--auto u-mb' },
	    _react2.default.createElement(
	      'div',
	      { className: 'layout__item u-1/1' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'c-heading c-heading' },
	        'Categories'
	      )
	    ),
	    _react2.default.createElement(
	      Category,
	      {
	        onClick: function onClick() {
	          return resetCategory();
	        },
	        active: (0, _isUndefined3.default)(selectedCategory)
	      },
	      'All services'
	    ),
	    categories.map(function (category) {
	      return _react2.default.createElement(
	        Category,
	        {
	          onClick: function onClick() {
	            return setCategory(category.id);
	          },
	          active: category.id === selectedCategory,
	          selected: category.selected
	        },
	        category.name
	      );
	    })
	  );
	};
	Categories.propTypes = {
	  categories: _shapes.categoriesShape,
	  selectedCategory: _shapes.categoryShape,
	  setCategory: _shapes.handler,
	  resetCategory: _shapes.handler
	};
	Categories.defaultProps = {
	  categories: [],
	  selectedCategory: undefined,
	  setCategory: _helpers.nullFunc,
	  resetCategory: _helpers.nullFunc
	};
	
	exports.default = Categories;

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(5);
	
	var _ServiceDetails = __webpack_require__(466);
	
	var _ServiceDetails2 = _interopRequireDefault(_ServiceDetails);
	
	var _helpers = __webpack_require__(7);
	
	var _withGiftCardLink = __webpack_require__(272);
	
	var _withGiftCardLink2 = _interopRequireDefault(_withGiftCardLink);
	
	var _hideWithoutGiftCardSales = __webpack_require__(270);
	
	var _hideWithoutGiftCardSales2 = _interopRequireDefault(_hideWithoutGiftCardSales);
	
	var _WithKioskProp = __webpack_require__(59);
	
	var _WithKioskProp2 = _interopRequireDefault(_WithKioskProp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var service = { name: 'Gift Card' };
	
	var GiftCardService = function GiftCardService(_ref) {
	  var link = _ref.link;
	  return _react2.default.createElement(
	    'div',
	    { className: 'layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up' },
	    _react2.default.createElement(
	      _reactRouter.Link,
	      {
	        className: 'c-select-box c-select-box--small c-select-box--no-hover u-text-center u-bg-black-2',
	        to: link
	      },
	      _react2.default.createElement(_ServiceDetails2.default, { service: service })
	    )
	  );
	};
	
	GiftCardService.propTypes = {
	  link: _propTypes2.default.string.isRequired
	};
	
	GiftCardService.defaultProps = {
	  generateUrlString: _helpers.nullFunc,
	  onClick: _helpers.nullFunc
	};
	
	exports.default = (0, _compose3.default)(_WithKioskProp2.default, _hideWithoutGiftCardSales2.default, _withGiftCardLink2.default, (0, _branch3.default)(function (props) {
	  return props.kiosk;
	}, _renderNothing3.default))(GiftCardService);

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoServices = function NoServices() {
	  return _react2.default.createElement(
	    "div",
	    { className: "layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up u-mb0" },
	    "There are no services for selected professional"
	  );
	};
	
	exports.default = NoServices;

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(5);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shapes = __webpack_require__(23);
	
	var _ServiceDetails = __webpack_require__(466);
	
	var _ServiceDetails2 = _interopRequireDefault(_ServiceDetails);
	
	var _helpers = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Service = function Service(_ref) {
	  var service = _ref.service,
	      generateUrlString = _ref.generateUrlString,
	      onClick = _ref.onClick;
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    {
	      rel: 'nofollow',
	      onClick: onClick,
	      className: (0, _classnames2.default)('c-select-box c-select-box--small c-select-box--no-hover', 'u-text-center u-bg-black-2', { 'is-active': service.selected }),
	      to: generateUrlString(service.id)
	    },
	    _react2.default.createElement(_ServiceDetails2.default, { service: service })
	  );
	};
	Service.propTypes = {
	  service: _shapes.serviceShape.isRequired,
	  generateUrlString: _propTypes2.default.func,
	  onClick: _propTypes2.default.func
	};
	Service.defaultProps = {
	  generateUrlString: _helpers.nullFunc,
	  onClick: _helpers.nullFunc
	};
	exports.default = Service;

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withProps2 = __webpack_require__(12);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _filter2 = __webpack_require__(175);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _isUndefined2 = __webpack_require__(587);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)((0, _withState3.default)('selectedCategory', 'setCategory'), (0, _withHandlers3.default)({
	  resetCategory: function resetCategory(_ref) {
	    var setCategory = _ref.setCategory;
	    return function () {
	      return setCategory();
	    };
	  }
	}), (0, _withProps3.default)(function (_ref2) {
	  var services = _ref2.services,
	      selectedCategory = _ref2.selectedCategory;
	  return {
	    services: (0, _isUndefined3.default)(selectedCategory) ? services : (0, _filter3.default)(services, { serviceCategoryId: selectedCategory })
	  };
	}));

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = servicesReducer;
	
	var _immutable = __webpack_require__(66);
	
	var _constants = __webpack_require__(10);
	
	var initialState = (0, _immutable.fromJS)({
	  items: [],
	  allFetched: false
	});
	
	function servicesReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.REQUEST_SERVICE:
	      return state.set('allFetched', false);
	
	    case _constants.ALL_SERVICES_FETCHED:
	      return state.set('allFetched', true);
	
	    case _constants.RECEIVE_SERVICES:
	      return state.set('items', (0, _immutable.fromJS)(action.payload));
	
	    case _constants.RECEIVE_SERVICE:
	      {
	        var index = state.get('items').findIndex(function (item) {
	          return item.get('id') === action.payload.id;
	        });
	        return state.setIn(['items', index === -1 ? state.get('items').size : index], (0, _immutable.fromJS)(action.payload));
	      }
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(1487);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _debounce2 = __webpack_require__(124);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(11);
	
	var _ShopList = __webpack_require__(467);
	
	var _ShopList2 = _interopRequireDefault(_ShopList);
	
	var _Position = __webpack_require__(1146);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _actions = __webpack_require__(64);
	
	var _actions2 = __webpack_require__(897);
	
	var _Title = __webpack_require__(114);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _shapes = __webpack_require__(23);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions3 = __webpack_require__(42);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Shops = function (_Component) {
	  _inherits(Shops, _Component);
	
	  function Shops(props) {
	    _classCallCheck(this, Shops);
	
	    var _this = _possibleConstructorReturn(this, (Shops.__proto__ || Object.getPrototypeOf(Shops)).call(this, props));
	
	    _this.fetchShops = (0, _debounce3.default)(_this.props.fetchShops, 250);
	    return _this;
	  }
	
	  _createClass(Shops, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.clearReservations();
	      if (this.hasFilters() || this.hasLocation()) {
	        this.fetchShops(this.props);
	        return;
	      }
	
	      if (this.props.position) this.props.updateFilter(this.props.position);
	      this.props.fetchAllCities();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!(0, _isEqual3.default)(this.props.position, prevProps.position)) {
	        this.props.updateFilter(this.props.position);
	        return;
	      }
	
	      if (this.didUpdateFilter(prevProps)) {
	        this.fetchShops(this.props);
	      }
	    }
	  }, {
	    key: 'didUpdateFilter',
	    value: function didUpdateFilter(prevProps) {
	      var _props = this.props,
	          lat = _props.lat,
	          lng = _props.lng,
	          searchName = _props.searchName,
	          city = _props.city;
	
	
	      var positionChanged = lat !== prevProps.lat || lng !== prevProps.lng;
	      var cityChanged = city !== prevProps.city;
	      var searchChanged = searchName !== prevProps.searchName;
	
	      return positionChanged || cityChanged || searchChanged;
	    }
	  }, {
	    key: 'hasLocation',
	    value: function hasLocation() {
	      return this.props.lat && this.props.lng;
	    }
	  }, {
	    key: 'hasFilters',
	    value: function hasFilters() {
	      return this.props.searchName || this.props.city;
	    }
	  }, {
	    key: 'handleCityChange',
	    value: function handleCityChange(city) {
	      var _props2 = this.props,
	          lat = _props2.lat,
	          lng = _props2.lng,
	          searchName = _props2.searchName;
	
	      this.props.updateFilter({ lat: lat, lng: lng, city: city, searchName: searchName });
	    }
	  }, {
	    key: 'handleSearchNameChange',
	    value: function handleSearchNameChange(searchName) {
	      var _props3 = this.props,
	          lat = _props3.lat,
	          lng = _props3.lng,
	          city = _props3.city;
	
	      this.props.updateFilter({ lat: lat, lng: lng, city: city, searchName: searchName });
	    }
	
	    // eslint-disable-next-line class-methods-use-this
	
	  }, {
	    key: 'handleSearchNameFinish',
	    value: function handleSearchNameFinish(term) {
	      if (term !== '') {
	        _BookingAnalytics2.default.queryShop({ term: term });
	      }
	    }
	  }, {
	    key: 'isLoadingShopsNearby',
	    value: function isLoadingShopsNearby() {
	      return !this.hasFilters() && this.props.shops.length === 0 && this.props.isLoading;
	    }
	  }, {
	    key: 'noShopsNearby',
	    value: function noShopsNearby() {
	      return !this.hasFilters() && this.props.shops.length === 0 && !this.props.isLoading;
	    }
	  }, {
	    key: 'noFilterShops',
	    value: function noFilterShops() {
	      return this.hasFilters() && this.props.shops.length === 0 && !this.props.isLoading;
	    }
	  }, {
	    key: 'renderShops',
	    value: function renderShops() {
	      var _this2 = this;
	
	      var error = function () {
	        if (_this2.isLoadingShopsNearby()) return 'Loading shops near you...';
	        if (_this2.noShopsNearby()) return 'There are no shops nearby. Please search by name or choose a city.';
	        if (_this2.noFilterShops()) return 'There are no shops that match the search criteria';
	        return null;
	      }();
	
	      if (error) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'layout u-mt+' },
	          _react2.default.createElement(
	            'div',
	            { className: 'layout__item u-1/2-medium-and-up u-1/2-extralarge-and-up u-mb0' },
	            error
	          )
	        );
	      }
	
	      return _react2.default.createElement(_ShopList2.default, { shops: this.props.shops, isLoading: this.props.isLoading });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Position2.default, null),
	        _react2.default.createElement(
	          _Title2.default,
	          null,
	          'Choose a barbershop'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'layout layout--bottom u-pt+' },
	          _react2.default.createElement(
	            'div',
	            { className: 'layout__item u-2/3-large-and-up' },
	            _react2.default.createElement(
	              'div',
	              { className: 'c-search' },
	              _react2.default.createElement('input', {
	                type: 'text',
	                className: 'c-search__input',
	                placeholder: 'Search by name...',
	                value: this.props.searchName,
	                onChange: function onChange(e) {
	                  return _this3.handleSearchNameChange(e.target.value);
	                },
	                onBlur: function onBlur(e) {
	                  return _this3.handleSearchNameFinish(e.target.value);
	                }
	              }),
	              _react2.default.createElement(_Icon2.default, { className: 'c-search__icon', glyph: _Icon.GLYPHS.SEARCH })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'layout__item u-1/3-large-and-up' },
	            _react2.default.createElement(
	              'select',
	              {
	                className: 'c-select',
	                value: this.props.city,
	                onChange: function onChange(e) {
	                  return _this3.handleCityChange(e.target.value);
	                }
	              },
	              _react2.default.createElement(
	                'option',
	                { value: '-1' },
	                'City'
	              ),
	              this.props.cities.map(function (city) {
	                return _react2.default.createElement(
	                  'option',
	                  { value: city, key: city },
	                  city
	                );
	              })
	            )
	          )
	        ),
	        this.renderShops()
	      );
	    }
	  }]);
	
	  return Shops;
	}(_react.Component);
	
	Shops.propTypes = {
	  fetchAllCities: _propTypes2.default.func.isRequired,
	  updateFilter: _propTypes2.default.func.isRequired,
	  fetchShops: _propTypes2.default.func.isRequired,
	  shops: _propTypes2.default.arrayOf(_shapes.shopShape),
	  cities: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  searchName: _propTypes2.default.string,
	  city: _propTypes2.default.string,
	  lat: _propTypes2.default.number,
	  lng: _propTypes2.default.number,
	  position: _shapes.positionShape,
	  isLoading: _propTypes2.default.bool,
	  clearReservations: _propTypes2.default.func.isRequired
	};
	Shops.defaultProps = {
	  shops: [],
	  cities: [],
	  searchName: '',
	  city: '',
	  lat: 0,
	  lng: 0,
	  position: null,
	  isLoading: false
	};
	
	function mapStateToProps(state) {
	  return {
	    shops: (0, _selectors.getShops)(state),
	    searchName: state.shops.searchName,
	    city: state.shops.city,
	    lat: state.shops.lat,
	    lng: state.shops.lng,
	    cities: state.cities.items,
	    position: state.position,
	    isLoading: state.shops.isFetching
	  };
	}
	
	var dispatchToProps = {
	  fetchAllCities: _actions2.fetchAllCities,
	  updateFilter: _actions.updateFilter,
	  fetchShops: _actions.fetchShops,
	  clearReservations: _actions3.clearReservations
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, dispatchToProps)(Shops);

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _position = __webpack_require__(1822);
	
	var _position2 = _interopRequireDefault(_position);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = function format(distance) {
	  if (distance > 100) return '>100';
	  if (distance > 10) return distance.toFixed();
	
	  return distance.toFixed(2);
	};
	
	var Distance = function Distance(_ref) {
	  var distance = _ref.distance;
	
	  if (!distance) return null;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-distance-marker u-pin-top-right u-mt--' },
	    _react2.default.createElement('img', { src: _position2.default, alt: '' }),
	    _react2.default.createElement(
	      'span',
	      null,
	      format(distance),
	      ' mi'
	    )
	  );
	};
	Distance.propTypes = {
	  distance: _propTypes2.default.number
	};
	Distance.defaultProps = {
	  distance: 0
	};
	
	exports.default = Distance;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get2 = __webpack_require__(18);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(5);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _InstagramLink = __webpack_require__(412);
	
	var _InstagramLink2 = _interopRequireDefault(_InstagramLink);
	
	var _YelpRating = __webpack_require__(919);
	
	var _YelpRating2 = _interopRequireDefault(_YelpRating);
	
	var _shapes = __webpack_require__(23);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Distance = __webpack_require__(1225);
	
	var _Distance2 = _interopRequireDefault(_Distance);
	
	var _BookingAnalytics = __webpack_require__(31);
	
	var _BookingAnalytics2 = _interopRequireDefault(_BookingAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Shop = function Shop(_ref) {
	  var selected = _ref.selected,
	      shop = _ref.shop,
	      url = _ref.url;
	
	  var imgSource = (0, _get3.default)(shop, 'photos[0].thumbnail') || _config2.default.fallbackShopThumbnail;
	  var boxClassName = (0, _classnames2.default)('c-select-box', 'c-select-box--with-overlay', { 'is-active': selected });
	
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    {
	      className: boxClassName,
	      style: { backgroundImage: 'url(' + imgSource + ')' },
	      to: url,
	      onClick: function onClick() {
	        _BookingAnalytics2.default.selectShop(shop);
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'u-pin-bottom u-p' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-heading c-heading--large u-mb- u-co-white' },
	        shop.name
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-co-teal-blue' },
	        shop.address
	      ),
	      _react2.default.createElement(_YelpRating2.default, { className: 'u-mt-', rating: shop.yelpRating, yelpId: shop.yelpID })
	    ),
	    _react2.default.createElement(_Distance2.default, { distance: shop.distance }),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-pin-bottom-right' },
	      _react2.default.createElement(_InstagramLink2.default, { user: shop.instagram })
	    )
	  );
	};
	Shop.propTypes = {
	  selected: _propTypes2.default.bool,
	  shop: _shapes.shopShape.isRequired,
	  url: _propTypes2.default.string.isRequired
	};
	Shop.defaultProps = {
	  selected: false,
	  distance: 0
	};
	
	exports.default = Shop;

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = shopsReducer;
	
	var _immutable = __webpack_require__(66);
	
	var _constants = __webpack_require__(10);
	
	var _helpers = __webpack_require__(7);
	
	var InitialState = (0, _immutable.Record)({
	  items: [],
	  city: '',
	  searchName: '',
	  lat: 0,
	  lng: 0,
	  isFetching: false
	});
	
	var initialState = new InitialState();
	
	function shopsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.REQUEST_SHOPS:
	      return state.set('isFetching', true);
	    case _constants.CLEAR_SHOPS:
	      return state.set('items', []);
	
	    case _constants.UPDATE_FILTER:
	      {
	        var _action$payload = action.payload,
	            lat = _action$payload.lat,
	            lng = _action$payload.lng,
	            searchName = _action$payload.searchName,
	            city = _action$payload.city;
	
	
	        return state.withMutations(function (newState) {
	          if (newState.get('lat') !== lat) {
	            newState.set('lat', lat);
	          }
	          if (newState.get('lng') !== lng) {
	            newState.set('lng', lng);
	          }
	          if (newState.get('city') !== city) {
	            newState.set('city', city);
	          }
	          if (newState.get('searchName') !== searchName) {
	            newState.set('searchName', searchName);
	          }
	        });
	      }
	
	    case _constants.RECEIVE_SHOPS:
	      {
	        var shops = action.payload.filter(function (_ref) {
	          var id = _ref.id;
	          return state.get('items').every(function (item) {
	            return item.id !== id;
	          });
	        }).map(_helpers.transformShopAddress);
	        return state.withMutations(function (s) {
	          return s.set('items', s.get('items').concat(shops)).set('isFetching', false);
	        });
	      }
	
	    case _constants.RECEIVE_SHOP:
	      {
	        var item = _extends({}, action.payload);
	        var address = '';
	        if (item.address) {
	          // eslint-disable-next-line no-shadow
	          var _item$address = item.address,
	              street = _item$address.street,
	              _city = _item$address.city,
	              _state = _item$address.state,
	              zip = _item$address.zip,
	              country = _item$address.country;
	
	          item.city = _city;
	          item.zip = zip;
	          item.country = country;
	          if (street && _city && _state) {
	            address = street + ', ' + _city + ', ' + _state;
	          }
	        }
	        item.address = address;
	        return state.set('items', state.get('items').concat([item]));
	      }
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _findIndex2 = __webpack_require__(347);
	
	var _findIndex3 = _interopRequireDefault(_findIndex2);
	
	var _debounce2 = __webpack_require__(124);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _nukaCarousel = __webpack_require__(730);
	
	var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DatePickerButton = __webpack_require__(901);
	
	var _DatePickerButton2 = _interopRequireDefault(_DatePickerButton);
	
	var _shapes = __webpack_require__(23);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ITEMS_PER_SLIDE = 7;
	
	var sliderControls = [{
	  // eslint-disable-next-line react/prop-types
	  component: function component(_ref) {
	    var previousSlide = _ref.previousSlide,
	        currentSlide = _ref.currentSlide;
	    return _react2.default.createElement(
	      'button',
	      {
	        className: 'c-date-slider__prev',
	        onClick: previousSlide,
	        disabled: currentSlide === 0
	      },
	      _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.PREV_WEEK, className: 'c-date-slider__arrow-icon' })
	    );
	  },
	  style: {
	    position: 'static',
	    order: -1
	  }
	}, {
	  // eslint-disable-next-line react/prop-types
	  component: function component(_ref2) {
	    var nextSlide = _ref2.nextSlide,
	        currentSlide = _ref2.currentSlide,
	        slideCount = _ref2.slideCount,
	        slidesToScroll = _ref2.slidesToScroll;
	    return _react2.default.createElement(
	      'button',
	      {
	        className: 'c-date-slider__next',
	        onClick: nextSlide,
	        disabled: currentSlide + slidesToScroll >= slideCount
	      },
	      _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.NEXT_WEEK, className: 'c-date-slider__arrow-icon' })
	    );
	  },
	  style: {
	    position: 'static',
	    order: -1
	  }
	}];
	
	var sliderSettings = {
	  className: 'c-date-slider',
	  dragging: true,
	  speed: 500,
	  slidesToShow: ITEMS_PER_SLIDE,
	  slidesToScroll: ITEMS_PER_SLIDE,
	  cellAlign: 'left',
	  cellSpacing: 0,
	  decorators: sliderControls
	};
	
	var DateSlider = function (_Component) {
	  _inherits(DateSlider, _Component);
	
	  function DateSlider() {
	    var _ref3;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DateSlider);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = DateSlider.__proto__ || Object.getPrototypeOf(DateSlider)).call.apply(_ref3, [this].concat(args))), _this), _this.onAfterSlide = function (nextIndex) {
	      var nextDay = (0, _moment2.default)().add(nextIndex, 'days').format(_config2.default.apiDateFormat);
	      _this.index = nextIndex;
	      _this.props.setActiveDay(nextDay);
	    }, _this.onMouseDown = function (e) {
	      _this.mouseDown = true;
	      _this.mouseX = e.clientX;
	      _this.sliding = false;
	    }, _this.onMouseUp = function () {
	      _this.mouseDown = false;
	    }, _this.onMouseMove = (0, _debounce3.default)(function (e) {
	      if (!_this.mouseDown) return;
	      if (Math.abs(e.clientX - _this.mouseX) > _this.delta) {
	        _this.sliding = true;
	        return;
	      }
	
	      _this.sliding = false;
	    }, 200), _this.onClickCapture = function (e) {
	      if (_this.sliding) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    }, _this.onDatePickerDayClick = function (day) {
	      _this.props.setActiveDay((0, _moment2.default)(day).format(_config2.default.apiDateFormat));
	    }, _this.sliding = false, _this.mouseDown = false, _this.mouseX = 0, _this.delta = 2, _this.index = 0, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DateSlider, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var newIndex = ITEMS_PER_SLIDE * Math.floor((0, _findIndex3.default)(nextProps.days, 'active') / ITEMS_PER_SLIDE);
	      this.index = newIndex;
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.updatedAt !== nextProps.updatedAt || this.props.activeDay !== nextProps.activeDay;
	    }
	  }, {
	    key: 'getDisabledDays',
	    value: function getDisabledDays() {
	      var today = new Date();
	      var endDay = (0, _moment2.default)(today).add(this.props.advanceBookDays - 1, 'days').toDate();
	
	      return {
	        before: today,
	        after: endDay
	      };
	    }
	  }, {
	    key: 'renderSlides',
	    value: function renderSlides() {
	      var _this2 = this;
	
	      if ((0, _isEmpty3.default)(this.props.days)) return null;
	
	      return this.props.days.map(function (day) {
	        var className = (0, _classnames2.default)('c-date-slider__item', { 'is-active': day.active }, { 'is-disabled': day.disabled });
	        return _react2.default.createElement(
	          'button',
	          {
	            className: className,
	            onClick: _this2.props.onDayClick(day.date),
	            key: day.date
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'c-heading c-heading--tiny u-co-gray-1' },
	            day.dayOfWeek
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'c-date-slider__item-day' },
	            day.formatted
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseDown: this.onMouseDown,
	          onMouseUp: this.onMouseUp,
	          onMouseMove: function onMouseMove(e) {
	            e.persist();
	            _this3.onMouseMove(e);
	          },
	          onClickCapture: this.onClickCapture,
	          role: 'presentation'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'c-date-slider__date' },
	          _react2.default.createElement(
	            'div',
	            { className: 'layout layout--tiny layout--auto' },
	            _react2.default.createElement(
	              'div',
	              { className: 'layout__item' },
	              (0, _moment2.default)(this.props.activeDay).format('ddd, MMM D, YYYY')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'layout__item' },
	              _react2.default.createElement(
	                'div',
	                { className: 'c-date-slider__date-picker' },
	                _react2.default.createElement(_DatePickerButton2.default, {
	                  onDayClick: this.onDatePickerDayClick,
	                  selectedDay: (0, _moment2.default)(this.props.activeDay).toDate(),
	                  disabledDays: this.getDisabledDays(),
	                  daysOff: this.props.daysOff,
	                  daysOn: this.props.daysOn,
	                  weekdaysOff: this.props.weekdaysOff
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _nukaCarousel2.default,
	          Object.assign({
	            afterSlide: this.onAfterSlide,
	            slideIndex: this.index
	          }, sliderSettings),
	          this.renderSlides()
	        )
	      );
	    }
	  }]);
	
	  return DateSlider;
	}(_react.Component);
	
	DateSlider.propTypes = {
	  days: _propTypes2.default.arrayOf(_shapes.dayShape).isRequired,
	  activeDay: _propTypes2.default.string.isRequired,
	  setActiveDay: _propTypes2.default.func.isRequired,
	  onDayClick: _propTypes2.default.func.isRequired,
	  updatedAt: _propTypes2.default.number,
	  advanceBookDays: _propTypes2.default.number,
	  daysOff: _propTypes2.default.array.isRequired, // eslint-disable-line react/forbid-prop-types
	  daysOn: _propTypes2.default.array.isRequired, // eslint-disable-line react/forbid-prop-types
	  weekdaysOff: _propTypes2.default.array.isRequired // eslint-disable-line react/forbid-prop-types
	};
	
	DateSlider.defaultProps = {
	  updatedAt: 0,
	  advanceBookDays: 0
	};
	
	exports.default = DateSlider;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NextAvailableButton = function NextAvailableButton(_ref) {
	  var onClick = _ref.onClick;
	  return _react2.default.createElement(
	    'button',
	    { type: 'button', className: 'c-btn c-btn--default c-btn--small u-mt', onClick: onClick },
	    'Next Available Time'
	  );
	};
	NextAvailableButton.propTypes = {
	  onClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = NextAvailableButton;

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shapes = __webpack_require__(23);
	
	var _NextAvailableButton = __webpack_require__(471);
	
	var _NextAvailableButton2 = _interopRequireDefault(_NextAvailableButton);
	
	var _WithAutoHeight = __webpack_require__(427);
	
	var _WithAutoHeight2 = _interopRequireDefault(_WithAutoHeight);
	
	var _DateTimePicker = __webpack_require__(298);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	var _ReserveLink = __webpack_require__(413);
	
	var _ReserveLink2 = _interopRequireDefault(_ReserveLink);
	
	var _WaitingListLink = __webpack_require__(1235);
	
	var _WaitingListLink2 = _interopRequireDefault(_WaitingListLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PickTime = function PickTime(_ref) {
	  var setActiveDay = _ref.setActiveDay,
	      times = _ref.times,
	      selectedTime = _ref.selectedTime,
	      setTime = _ref.setTime,
	      timezone = _ref.timezone,
	      noTimesAvailable = _ref.noTimesAvailable,
	      isFetching = _ref.isFetching,
	      nextLink = _ref.nextLink,
	      waitingListLink = _ref.waitingListLink,
	      shouldShowWaitingList = _ref.shouldShowWaitingList,
	      serviceId = _ref.serviceId,
	      barberId = _ref.barberId,
	      from = _ref.from;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_DateTimePicker2.default, {
	      setActiveDay: setActiveDay,
	      times: times,
	      selectedTime: selectedTime,
	      setTime: setTime,
	      timezone: timezone,
	      noTimesAvailable: noTimesAvailable,
	      isFetching: isFetching,
	      serviceId: serviceId,
	      barberId: barberId
	    }),
	    serviceId && selectedTime && _react2.default.createElement(_ReserveLink2.default, { to: nextLink, selectedTime: selectedTime, from: from }),
	    !isFetching && serviceId && barberId && noTimesAvailable && _react2.default.createElement(
	      'div',
	      { className: 'layout layout--small layout--center layout--auto' },
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item' },
	        _react2.default.createElement(_NextAvailableButton2.default, {
	          setTime: setTime,
	          setActiveDay: setActiveDay
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'layout__item' },
	        shouldShowWaitingList && _react2.default.createElement(_WaitingListLink2.default, { to: waitingListLink, from: from })
	      )
	    )
	  );
	};
	PickTime.propTypes = {
	  setActiveDay: _propTypes2.default.func.isRequired,
	  times: _shapes.timesShape,
	  selectedTime: _propTypes2.default.string,
	  setTime: _propTypes2.default.func.isRequired,
	  timezone: _propTypes2.default.string,
	  noTimesAvailable: _propTypes2.default.bool,
	  isFetching: _propTypes2.default.bool,
	  nextLink: _shapes.linkShape,
	  serviceId: _propTypes2.default.string,
	  barberId: _propTypes2.default.string,
	  shouldShowWaitingList: _propTypes2.default.bool,
	  waitingListLink: _shapes.linkShape,
	  from: _propTypes2.default.string.isRequired
	};
	PickTime.defaultProps = {
	  times: [],
	  selectedTime: '',
	  timezone: null,
	  noTimesAvailable: false,
	  isFetching: false,
	  nextLink: '',
	  serviceId: '',
	  barberId: '',
	  shouldShowWaitingList: false,
	  waitingListLink: ''
	};
	
	exports.default = (0, _WithAutoHeight2.default)(PickTime);

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shapes = __webpack_require__(23);
	
	var _TimeSlot = __webpack_require__(470);
	
	var _TimeSlot2 = _interopRequireDefault(_TimeSlot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderIfTimes = function renderIfTimes(noTimes) {
	  return (0, _branch3.default)(noTimes, _renderNothing3.default);
	};
	var enhance = renderIfTimes(function (props) {
	  return props.times.length === 0;
	});
	
	var TimeGrid = function TimeGrid(_ref) {
	  var times = _ref.times,
	      timezone = _ref.timezone,
	      selectedTime = _ref.selectedTime,
	      setTime = _ref.setTime;
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-time-grid' },
	    times.map(function (item) {
	      return _react2.default.createElement(_TimeSlot2.default, {
	        key: item.time,
	        item: item,
	        timezone: timezone,
	        selectedTime: selectedTime,
	        setTime: setTime
	      });
	    })
	  );
	};
	
	TimeGrid.propTypes = {
	  times: _propTypes2.default.arrayOf(_shapes.timeShape),
	  timezone: _propTypes2.default.string,
	  selectedTime: _propTypes2.default.string,
	  setTime: _propTypes2.default.func.isRequired
	};
	TimeGrid.defaultProps = {
	  timezone: null,
	  times: [],
	  selectedTime: null
	};
	
	exports.default = enhance(TimeGrid);

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _nukaCarousel = __webpack_require__(730);
	
	var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);
	
	var _Icon = __webpack_require__(58);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _shapes = __webpack_require__(23);
	
	var _TimeSlot = __webpack_require__(470);
	
	var _TimeSlot2 = _interopRequireDefault(_TimeSlot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SLIDE_WIDTH = '54px';
	
	var renderIfTimes = function renderIfTimes(noTimes) {
	  return (0, _branch3.default)(noTimes, _renderNothing3.default);
	};
	var enhance = renderIfTimes(function (props) {
	  return props.times.length === 0;
	});
	
	var sliderControls = [{
	  // eslint-disable-next-line react/prop-types
	  component: function component(_ref) {
	    var previousSlide = _ref.previousSlide,
	        currentSlide = _ref.currentSlide;
	    return _react2.default.createElement(
	      'button',
	      {
	        className: 'c-date-slider__prev',
	        onClick: previousSlide,
	        disabled: currentSlide === 0
	      },
	      _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.PREV_WEEK, size: 'small' })
	    );
	  },
	  style: {
	    position: 'static',
	    order: -1
	  }
	}, {
	  // eslint-disable-next-line react/prop-types
	  component: function component(_ref2) {
	    var nextSlide = _ref2.nextSlide,
	        currentSlide = _ref2.currentSlide,
	        slideCount = _ref2.slideCount,
	        slidesToScroll = _ref2.slidesToScroll;
	    return _react2.default.createElement(
	      'button',
	      {
	        className: 'c-date-slider__next',
	        onClick: nextSlide,
	        disabled: currentSlide + slidesToScroll >= slideCount
	      },
	      _react2.default.createElement(_Icon2.default, { glyph: _Icon.GLYPHS.NEXT_WEEK, size: 'small' })
	    );
	  },
	  style: {
	    position: 'static',
	    order: 1
	  }
	}];
	var sliderSettings = {
	  className: 'c-time-slider',
	  dragging: true,
	  speed: 500,
	  cellAlign: 'left',
	  slideWidth: SLIDE_WIDTH,
	  decorators: sliderControls,
	  slidesToScroll: 'auto'
	};
	
	var TimeSlider = function TimeSlider(_ref3) {
	  var times = _ref3.times,
	      timezone = _ref3.timezone,
	      selectedTime = _ref3.selectedTime,
	      setTime = _ref3.setTime;
	  return _react2.default.createElement(
	    _nukaCarousel2.default,
	    sliderSettings,
	    times.map(function (item) {
	      return _react2.default.createElement(_TimeSlot2.default, {
	        key: item.time,
	        item: item,
	        timezone: timezone,
	        selectedTime: selectedTime,
	        setTime: setTime
	      });
	    })
	  );
	};
	
	TimeSlider.propTypes = {
	  times: _propTypes2.default.arrayOf(_shapes.timeShape),
	  timezone: _propTypes2.default.string,
	  selectedTime: _propTypes2.default.string,
	  setTime: _propTypes2.default.func.isRequired
	};
	TimeSlider.defaultProps = {
	  timezone: null,
	  times: []
	};
	
	exports.default = enhance(TimeSlider);

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withPropsOnChange2 = __webpack_require__(35);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(27);
	
	var _selectors2 = __webpack_require__(11);
	
	var _WithAnyBarber = __webpack_require__(273);
	
	var _WithAnyBarber2 = _interopRequireDefault(_WithAnyBarber);
	
	var _WithAdvanceBookDays = __webpack_require__(426);
	
	var _WithAdvanceBookDays2 = _interopRequireDefault(_WithAdvanceBookDays);
	
	var _DateSlider = __webpack_require__(1228);
	
	var _DateSlider2 = _interopRequireDefault(_DateSlider);
	
	var _selectors3 = __webpack_require__(71);
	
	var _selectors4 = __webpack_require__(21);
	
	var reservationSelectors = _interopRequireWildcard(_selectors4);
	
	var _actions = __webpack_require__(932);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DateSliderContainer = (0, _compose3.default)(_reactRouter.withRouter, _WithAdvanceBookDays2.default, _WithAnyBarber2.default, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    barber: (0, _selectors.getBarberByIdOrRoute)(state, ownProps.params.barberRoute),
	    days: (0, _selectors3.getDaysUpToAdvanceBookDays)(state, ownProps.advanceBookDays),
	    updatedAt: state.times.updatedAt,
	    daysOff: ownProps.params.barberRoute ? (0, _selectors.getBarberDaysOffAsDates)(state) : reservationSelectors.getBarberDaysOffAsDates(state),
	    daysOn: ownProps.params.barberRoute ? (0, _selectors.getBarberDaysOnAsDates)(state, ownProps.params.barberRoute) : reservationSelectors.getBarberDaysOnAsDates(state),
	    weekdaysOff: function () {
	      if (!ownProps.params.barberRoute) {
	        return reservationSelectors.getBarberWeekdaysOff(state);
	      }
	      if (ownProps.anyBarber) {
	        return (0, _selectors2.getShopWeekdaysOff)(state, ownProps.params.shopRoute);
	      }
	      return (0, _selectors.getBarberWeekdaysOff)(state, ownProps.params.barberRoute);
	    }()
	  };
	}, {
	  fetchDaysOff: _actions.fetchDaysOff
	}), (0, _withHandlers3.default)({
	  onDayClick: function onDayClick(props) {
	    return function (day) {
	      return function () {
	        return props.setActiveDay(day);
	      };
	    };
	  },
	  fetch: function fetch(props) {
	    return function () {
	      return props.barber && props.fetchDaysOff(props.barber);
	    };
	  }
	}), (0, _withPropsOnChange3.default)(function (props, nextProps) {
	  return props.barber && props.barber !== nextProps.barber;
	}, function (props) {
	  return props.fetch();
	}))(_DateSlider2.default);
	
	exports.default = DateSliderContainer;

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimesError = exports.noTimes = exports.BarberError = exports.noBarber = exports.ServiceError = exports.noService = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimePicker = __webpack_require__(469);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	var _NonOptimalStates = __webpack_require__(982);
	
	var _NonOptimalStates2 = _interopRequireDefault(_NonOptimalStates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noService = exports.noService = function noService(_ref) {
	  var serviceId = _ref.serviceId;
	  return !serviceId;
	};
	var ServiceError = exports.ServiceError = function ServiceError() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    'Please select service first'
	  );
	};
	
	var noBarber = exports.noBarber = function noBarber(_ref2) {
	  var barberId = _ref2.barberId;
	  return !barberId;
	};
	var BarberError = exports.BarberError = function BarberError() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    'Please select a professional'
	  );
	};
	
	var noTimes = exports.noTimes = function noTimes(_ref3) {
	  var noTimesAvailable = _ref3.noTimesAvailable;
	  return noTimesAvailable;
	};
	var TimesError = exports.TimesError = function TimesError() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    'There are no available time for selected day.'
	  );
	};
	
	var TimePickerContainer = (0, _NonOptimalStates2.default)([{ when: noService, render: ServiceError }, { when: noBarber, render: BarberError }, { when: noTimes, render: TimesError }])(_TimePicker2.default);
	
	exports.default = TimePickerContainer;

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _renderNothing2 = __webpack_require__(22);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _branch2 = __webpack_require__(14);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(5);
	
	var _WithTimezone = __webpack_require__(115);
	
	var _WithTimezone2 = _interopRequireDefault(_WithTimezone);
	
	var _selectors = __webpack_require__(71);
	
	var _WaitingListLink = __webpack_require__(918);
	
	var _WaitingListLink2 = _interopRequireDefault(_WaitingListLink);
	
	var _selectors2 = __webpack_require__(51);
	
	var _helpers = __webpack_require__(7);
	
	var _selectors3 = __webpack_require__(27);
	
	var _selectors4 = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _compose3.default)(_WithTimezone2.default, _reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  var activeDay = (0, _selectors.getActiveDay)(state);
	  var noNextAvailableTime = !(0, _selectors.getNextAvailableTime)(state, activeDay, ownProps.timezone);
	  var isWholeDayOff = (0, _selectors.getIsWholeDayOff)(state, activeDay);
	  return {
	    shouldHideLink: noNextAvailableTime || isWholeDayOff,
	    service: (0, _selectors2.getServiceName)(state, ownProps.params.serviceId),
	    date: (0, _selectors.getActiveDay)(state),
	    time: (0, _helpers.parseTimeSlug)((0, _selectors.getActiveTime)(state), ownProps.timezone),
	    barber: (0, _selectors3.getBarberByIdOrRoute)(state, ownProps.params.barberRoute),
	    shop: (0, _selectors4.getShopByRoute)(state, ownProps.params.shopRoute)
	  };
	}), (0, _branch3.default)(function (props) {
	  return props.shouldHideLink;
	}, _renderNothing3.default))(_WaitingListLink2.default);

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEmpty2 = __webpack_require__(45);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _unionBy2 = __webpack_require__(1509);
	
	var _unionBy3 = _interopRequireDefault(_unionBy2);
	
	exports.default = timesReducer;
	
	var _immutable = __webpack_require__(66);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(10);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InitialState = (0, _immutable.Record)({
	  activeDay: (0, _moment2.default)().format(_config2.default.apiDateFormat),
	  activeTime: '',
	  activeTimeBarber: '',
	  items: [],
	  isFetching: false,
	  updatedAt: null
	});
	
	var initialState = new InitialState();
	
	function timesReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.CLEAR_BARBER_AVAILABILITY:
	      return state.set('items', []).set('updatedAt', Date.now());
	
	    case _constants.REQUEST_BARBER_AVAILABILITY:
	      return state.set('isFetching', true);
	
	    case _constants.SET_ACTIVE_DAY:
	      return state.set('activeDay', action.payload);
	
	    case _constants.SET_ACTIVE_TIME:
	      return state.set('activeTime', action.payload);
	
	    case _constants.SET_ACTIVE_TIME_BARBER:
	      return state.set('activeTimeBarber', action.payload);
	
	    case _constants.RECEIVE_BARBER_AVAILABILITY:
	      {
	        if ((0, _isEmpty3.default)(action.payload)) return state.set('isFetching', false);
	
	        return state.withMutations(function (s) {
	          return s.set('items', (0, _unionBy3.default)(state.items, action.payload, 'day')).set('isFetching', false).set('updatedAt', Date.now());
	        });
	      }
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addItem = undefined;
	
	var _without2 = __webpack_require__(1592);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _pipe2 = __webpack_require__(75);
	
	var _pipe3 = _interopRequireDefault(_pipe2);
	
	var _curry2 = __webpack_require__(1547);
	
	var _curry3 = _interopRequireDefault(_curry2);
	
	var _append2 = __webpack_require__(1544);
	
	var _append3 = _interopRequireDefault(_append2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line import/prefer-default-export
	var addItem = exports.addItem = (0, _curry3.default)(function (item, list) {
	  return (0, _pipe3.default)((0, _without3.default)([item]), (0, _append3.default)(item))(list);
	});

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ravenMock = {
	  captureException: function captureException(e) {
	    console.log(e); // eslint-disable-line no-console
	  }
	};
	
	var sentry = function sentry() {
	  if (!window.Sentry) {
	    return ravenMock;
	  }
	
	  return window.Sentry;
	};
	
	exports.default = sentry;

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generateSteps = undefined;
	
	var _last2 = __webpack_require__(580);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _flow2 = __webpack_require__(231);
	
	var _flow3 = _interopRequireDefault(_flow2);
	
	var _transform2 = __webpack_require__(1483);
	
	var _transform3 = _interopRequireDefault(_transform2);
	
	var _sortBy2 = __webpack_require__(582);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _map2 = __webpack_require__(232);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _pick2 = __webpack_require__(1480);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _get2 = __webpack_require__(176);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _paramsMap;
	
	var _helpers = __webpack_require__(7);
	
	var _constants = __webpack_require__(10);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var paramsMap = (_paramsMap = {}, _defineProperty(_paramsMap, _constants.STEPS.barber, 'barberRoute'), _defineProperty(_paramsMap, _constants.STEPS.service, 'serviceId'), _defineProperty(_paramsMap, _constants.STEPS.time, 'reservationTime'), _paramsMap);
	
	var getShopUrlAndParams = function getShopUrlAndParams(_ref, urlPattern) {
	  var _ref$shopRoute = _ref.shopRoute,
	      shopRoute = _ref$shopRoute === undefined ? ':shopRoute' : _ref$shopRoute;
	
	  var params = { shopRoute: shopRoute };
	  var url = (0, _helpers.generateUrlString)(params, urlPattern);
	  return { params: params, url: url };
	};
	var makeUrlsArray = function makeUrlsArray(params, urlPattern) {
	  return (0, _transform3.default)(function (result, step) {
	    var param = paramsMap[step.key];
	    var newParams = _extends({}, (0, _get3.default)('params')((0, _last3.default)(result)), _defineProperty({}, param, ':' + param), (0, _pick3.default)(param)(params));
	
	    result.push({
	      params: newParams,
	      url: (0, _helpers.generateUrlString)(newParams, urlPattern)
	    });
	  }, [getShopUrlAndParams(params, urlPattern)]);
	};
	
	var addUrls = function addUrls(params, urlPattern) {
	  return function (steps) {
	    var urlsArray = makeUrlsArray(params, urlPattern)(steps);
	    return (0, _map3.default)(function (step) {
	      return _extends({}, step, { url: urlsArray.shift().url });
	    })(steps);
	  };
	};
	
	var addTextValues = function addTextValues(textValues) {
	  return function (step) {
	    return _extends({}, step, {
	      text: textValues[step.key]
	    });
	  };
	};
	
	var getFallbackText = function getFallbackText(key) {
	  if (key === _constants.STEPS.barber) return 'Professional';
	  if (key === _constants.STEPS.service) return 'Service';
	  if (key === _constants.STEPS.time) return 'Time';
	  if (key === _constants.STEPS.reservation) return 'Reserve';
	  return null;
	};
	
	var addFallbackText = function addFallbackText(step) {
	  if (step.text) return step;
	  return _extends({}, step, { text: getFallbackText(step.key) });
	};
	
	var addTrimToService = function addTrimToService(step) {
	  return _extends({}, step, {
	    trim: step.key === _constants.STEPS.service
	  });
	};
	
	var transformStep = function transformStep(textValues) {
	  return (0, _flow3.default)(addTextValues(textValues), addFallbackText, addTrimToService);
	};
	
	var orderFromUrlPattern = function orderFromUrlPattern(urlPattern) {
	  return (0, _flow3.default)((0, _sortBy3.default)(function (step) {
	    return urlPattern.toLowerCase().indexOf(step);
	  }), (0, _map3.default)(function (key) {
	    return { key: key };
	  }))([_constants.STEPS.barber, _constants.STEPS.service, _constants.STEPS.time]);
	};
	
	var addReserveStep = function addReserveStep(steps) {
	  return [].concat(_toConsumableArray(steps), [{ key: _constants.STEPS.reservation }]);
	};
	
	// eslint-disable-next-line import/prefer-default-export
	var generateSteps = exports.generateSteps = function generateSteps(textValues, params) {
	  var urlPattern = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _config2.default.urlPatterns.old;
	  return (0, _flow3.default)(addReserveStep, addUrls(params, urlPattern), (0, _map3.default)(transformStep(textValues)))(orderFromUrlPattern(urlPattern)) || [];
	};

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRouter = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Info = __webpack_require__(474);
	
	var _Info2 = _interopRequireDefault(_Info);
	
	var _Subtitle = __webpack_require__(113);
	
	var _Subtitle2 = _interopRequireDefault(_Subtitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WaitingListInfo = function WaitingListInfo(_ref) {
	  var barberName = _ref.barberName,
	      serviceName = _ref.serviceName,
	      serviceDuration = _ref.serviceDuration,
	      shopName = _ref.shopName,
	      shopAddress = _ref.shopAddress,
	      shopZip = _ref.shopZip,
	      shopLocation = _ref.shopLocation,
	      numberInLine = _ref.numberInLine;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Subtitle2.default,
	      null,
	      'Waiting List'
	    ),
	    _react2.default.createElement(_Info2.default, {
	      barberName: barberName,
	      serviceName: serviceName,
	      serviceDuration: serviceDuration,
	      shopName: shopName,
	      shopAddress: shopAddress,
	      shopZip: shopZip,
	      shopLocation: shopLocation,
	      numberInLine: numberInLine
	    }),
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: '/', className: 'c-btn c-btn--secondary u-mt+' },
	      'Back to home'
	    )
	  );
	};
	WaitingListInfo.propTypes = {
	  barberName: _propTypes2.default.string.isRequired,
	  serviceName: _propTypes2.default.string.isRequired,
	  serviceDuration: _propTypes2.default.string.isRequired,
	  shopName: _propTypes2.default.string.isRequired,
	  shopAddress: _propTypes2.default.string.isRequired,
	  shopZip: _propTypes2.default.string.isRequired,
	  shopLocation: _propTypes2.default.shape({
	    coordinates: _propTypes2.default.arrayOf(_propTypes2.default.number)
	  }),
	  numberInLine: _propTypes2.default.number.isRequired
	};
	WaitingListInfo.defaultProps = {
	  shopLocation: null
	};
	
	exports.default = WaitingListInfo;

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRouter = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimePicker = __webpack_require__(469);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	var _Info = __webpack_require__(474);
	
	var _Info2 = _interopRequireDefault(_Info);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WaitingListTimes = function WaitingListTimes(_ref) {
	  var barberName = _ref.barberName,
	      serviceName = _ref.serviceName,
	      serviceDuration = _ref.serviceDuration,
	      shopName = _ref.shopName,
	      shopAddress = _ref.shopAddress,
	      shopZip = _ref.shopZip,
	      shopLocation = _ref.shopLocation,
	      timezone = _ref.timezone,
	      day = _ref.day,
	      times = _ref.times,
	      setTime = _ref.setTime,
	      selectedTime = _ref.selectedTime,
	      bookingLink = _ref.bookingLink,
	      removeLink = _ref.removeLink;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      { className: 'c-heading c-heading--huge u-mv' },
	      'Book appointment for ',
	      day
	    ),
	    _react2.default.createElement(_Info2.default, {
	      barberName: barberName,
	      serviceName: serviceName,
	      serviceDuration: serviceDuration,
	      shopName: shopName,
	      shopAddress: shopAddress,
	      shopZip: shopZip,
	      shopLocation: shopLocation
	    }),
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { className: 'c-btn c-btn--secondary', to: removeLink },
	      'Remove me from list'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-mt+ u-text-center' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'c-heading c-heading--underline-center c-heading--huge u-mb' },
	        'Choose time'
	      ),
	      _react2.default.createElement(_TimePicker2.default, {
	        times: times,
	        setTime: setTime,
	        timezone: timezone,
	        selectedTime: selectedTime
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-mt' },
	        bookingLink && _react2.default.createElement(
	          _reactRouter.Link,
	          { className: 'c-btn c-btn--primary', to: bookingLink },
	          'Book'
	        )
	      )
	    )
	  );
	};
	WaitingListTimes.propTypes = {
	  barberName: _propTypes2.default.string.isRequired,
	  serviceName: _propTypes2.default.string.isRequired,
	  serviceDuration: _propTypes2.default.number.isRequired,
	  shopName: _propTypes2.default.string.isRequired,
	  shopAddress: _propTypes2.default.string.isRequired,
	  shopZip: _propTypes2.default.string.isRequired,
	  shopLocation: _propTypes2.default.shape({
	    coordinates: _propTypes2.default.arrayOf(_propTypes2.default.number)
	  }),
	  day: _propTypes2.default.string.isRequired,
	  times: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    time: _propTypes2.default.string,
	    waitingListSlotId: _propTypes2.default.string
	  })),
	  timezone: _propTypes2.default.string,
	  setTime: _propTypes2.default.func.isRequired,
	  selectedTime: _propTypes2.default.string.isRequired,
	  bookingLink: _propTypes2.default.string.isRequired,
	  removeLink: _propTypes2.default.string.isRequired
	};
	WaitingListTimes.defaultProps = {
	  shopLocation: null,
	  timezone: '',
	  times: []
	};
	exports.default = WaitingListTimes;

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lifecycle2 = __webpack_require__(15);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(164);
	
	var _WaitingListInfo = __webpack_require__(1240);
	
	var _WaitingListInfo2 = _interopRequireDefault(_WaitingListInfo);
	
	var _selectors2 = __webpack_require__(51);
	
	var _selectors3 = __webpack_require__(11);
	
	var _actions = __webpack_require__(301);
	
	var _selectors4 = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WaitingListInfoContainer = (0, _compose3.default)((0, _reactRedux.connect)(function (state) {
	  var shopId = (0, _selectors.getWaitingListInfoShopId)(state);
	  var barberId = (0, _selectors.getWaitingListInfoBarberId)(state);
	  var serviceIds = (0, _selectors.getWaitingListInfoServiceIds)(state);
	
	  return {
	    barberName: (0, _selectors4.getBarberName)(state, barberId),
	    serviceName: (0, _selectors2.getServiceName)(state, serviceIds),
	    serviceDuration: (0, _selectors2.getServiceDuration)(state, serviceIds),
	    shopName: (0, _selectors3.getShopName)(state, (0, _selectors3.getShopRoute)(state, shopId)),
	    shopAddress: (0, _selectors3.getShopAddress)(state, (0, _selectors3.getShopRoute)(state, shopId)),
	    shopZip: (0, _selectors3.getShopZip)(state, (0, _selectors3.getShopRoute)(state, shopId)),
	    shopLocation: (0, _selectors3.getShopLocation)(state, (0, _selectors3.getShopRoute)(state, shopId)),
	    numberInLine: (0, _selectors.getWaitingListInfoNumberInLine)(state)
	  };
	}, { clearWaitingListInfo: _actions.clearWaitingListInfo }), (0, _lifecycle3.default)({
	  componentWillUnmount: function componentWillUnmount() {
	    this.props.clearWaitingListInfo();
	  }
	}))(_WaitingListInfo2.default);
	
	exports.default = WaitingListInfoContainer;

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _withState2 = __webpack_require__(25);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withHandlers2 = __webpack_require__(9);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _compose2 = __webpack_require__(4);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _helpers = __webpack_require__(7);
	
	var _WithLoader = __webpack_require__(195);
	
	var _WithLoader2 = _interopRequireDefault(_WithLoader);
	
	var _FetchOnMount = __webpack_require__(134);
	
	var _FetchOnMount2 = _interopRequireDefault(_FetchOnMount);
	
	var _actions = __webpack_require__(301);
	
	var _WaitingListTimes = __webpack_require__(1241);
	
	var _WaitingListTimes2 = _interopRequireDefault(_WaitingListTimes);
	
	var _selectors = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BOOK_TIME_SLOT = 'book-time-slot';
	var REMOVE_FROM_WAITING_LIST = 'customer/waiting-list';
	
	var WaitingListTimesContainer = (0, _compose3.default)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state, ownProps) {
	  return {
	    waitingListCustomerId: ownProps.params.waitingListCustomerId,
	    slotId: ownProps.params.slotId,
	    barberName: (0, _selectors.getWaitingListTimesBarberName)(state),
	    serviceName: (0, _selectors.getWaitingListTimesServiceName)(state),
	    serviceDuration: (0, _selectors.getWaitingListTimesServiceDuration)(state),
	    shopName: (0, _selectors.getWaitingListTimesShopName)(state),
	    shopAddress: (0, _selectors.getWaitingListTimesShopAddress)(state),
	    shopZip: (0, _selectors.getWaitingListTimesShopZip)(state),
	    shopLocation: (0, _selectors.getWaitingListTimeShopLocation)(state),
	    timezone: (0, _selectors.getWaitingListTimesTimezone)(state),
	    day: (0, _selectors.getWaitingListTimesDay)(state),
	    times: (0, _selectors.getWaitingListTimesTimes)(state),
	    removeLink: REMOVE_FROM_WAITING_LIST + '/' + ownProps.params.waitingListCustomerId
	  };
	}, { fetchWaitingListTimes: _actions.fetchWaitingListTimes }), (0, _withState3.default)('isLoading', 'setIsLoading', true), (0, _withState3.default)('selectedTime', 'setSelectedTime', ''), (0, _withState3.default)('bookingLink', 'setBookingLink', ''), (0, _withHandlers3.default)({
	  fetchData: function fetchData(props) {
	    return function () {
	      return props.fetchWaitingListTimes(props.waitingListCustomerId, props.slotId).then(function () {
	        return props.setIsLoading(false);
	      });
	    };
	  },
	  setTime: function setTime(props) {
	    return function (timeItem) {
	      return function () {
	        props.setSelectedTime((0, _helpers.getReservationTimeFromTimeItem)(timeItem));
	        props.setBookingLink(BOOK_TIME_SLOT + '/' + timeItem.waitingListSlotId + '/' + props.waitingListCustomerId);
	      };
	    };
	  }
	}), _FetchOnMount2.default, _WithLoader2.default)(_WaitingListTimes2.default);
	
	exports.default = WaitingListTimesContainer;

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(49);
	
	var _constants = __webpack_require__(10);
	
	var waitingListTimes = function waitingListTimes() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case _constants.CLEAR_WAITING_LIST_TIMES:
	      return {};
	    case _constants.SET_WAITING_LIST_TIMES:
	      return payload;
	    default:
	      return state;
	  }
	};
	
	var waitingListInfo = function waitingListInfo() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _ref2 = arguments[1];
	  var type = _ref2.type,
	      payload = _ref2.payload;
	
	  switch (type) {
	    case _constants.CLEAR_WAITING_LIST_INFO:
	      return {};
	    case _constants.SET_WAITING_LIST_INFO:
	      return _extends({}, payload);
	    default:
	      return state;
	  }
	};
	
	var reducer = (0, _redux.combineReducers)({
	  waitingListTimes: waitingListTimes,
	  waitingListInfo: waitingListInfo
	});
	
	exports.default = reducer;

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(149);
	
	var _root = __webpack_require__(475);
	
	var _root2 = _interopRequireDefault(_root);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	__webpack_require__(200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// initialize flags client
	
	// support stripe v2
	// for newer functionality use /utils/stripe.js
	function setStripeKey() {
	  Stripe.setPublishableKey(_config2.default.stripeKey);
	} /* global Stripe */
	
	
	setStripeKey();
	
	(0, _reactDom.render)(_react2.default.createElement(_root2.default, null), document.getElementById('root'));

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(49);
	
	var _reducer = __webpack_require__(1244);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__(1150);
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__(1151);
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reducer7 = __webpack_require__(898);
	
	var _reducer8 = _interopRequireDefault(_reducer7);
	
	var _reducer9 = __webpack_require__(1227);
	
	var _reducer10 = _interopRequireDefault(_reducer9);
	
	var _reducer11 = __webpack_require__(887);
	
	var _reducer12 = _interopRequireDefault(_reducer11);
	
	var _reducer13 = __webpack_require__(1223);
	
	var _reducer14 = _interopRequireDefault(_reducer13);
	
	var _reducer15 = __webpack_require__(1236);
	
	var _reducer16 = _interopRequireDefault(_reducer15);
	
	var _reducer17 = __webpack_require__(1216);
	
	var _reducer18 = _interopRequireDefault(_reducer17);
	
	var _reducer19 = __webpack_require__(931);
	
	var _reducer20 = _interopRequireDefault(_reducer19);
	
	var _reducer21 = __webpack_require__(1148);
	
	var _reducer22 = _interopRequireDefault(_reducer21);
	
	var _reducer23 = __webpack_require__(896);
	
	var _reducer24 = _interopRequireDefault(_reducer23);
	
	var _reducer25 = __webpack_require__(1005);
	
	var _reducer26 = _interopRequireDefault(_reducer25);
	
	var _reducer27 = __webpack_require__(867);
	
	var _reducer28 = _interopRequireDefault(_reducer27);
	
	var _reducer29 = __webpack_require__(933);
	
	var _reducer30 = _interopRequireDefault(_reducer29);
	
	var _reducer31 = __webpack_require__(953);
	
	var _reducer32 = _interopRequireDefault(_reducer31);
	
	var _reducer33 = __webpack_require__(980);
	
	var _reducer34 = _interopRequireDefault(_reducer33);
	
	var _reducer35 = __webpack_require__(449);
	
	var _reducer36 = _interopRequireDefault(_reducer35);
	
	var _reducer37 = __webpack_require__(1026);
	
	var _reducer38 = _interopRequireDefault(_reducer37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  app: _reducer6.default,
	  cities: _reducer8.default,
	  shops: _reducer10.default,
	  barbers: _reducer12.default,
	  services: _reducer14.default,
	  times: _reducer16.default,
	  reservation: _reducer18.default,
	  confirmation: _reducer20.default,
	  position: _reducer22.default,
	  receipt: _reducer4.default,
	  waitingList: _reducer2.default,
	  campaign: _reducer24.default,
	  instantExperiences: _reducer26.default,
	  acceptCookie: _reducer28.default,
	  daysOff: _reducer30.default,
	  extensions: _reducer32.default,
	  giftCard: _reducer34.default,
	  passcode: _reducer36.default,
	  membership: _reducer38.default
	});

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRouter = __webpack_require__(5);
	
	var _reactRouterScroll = __webpack_require__(1708);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CampaignUnsubscribe = __webpack_require__(920);
	
	var _CampaignUnsubscribe2 = _interopRequireDefault(_CampaignUnsubscribe);
	
	var _routes = __webpack_require__(137);
	
	var _VerifyEmail = __webpack_require__(924);
	
	var _WaitingListTimes = __webpack_require__(1243);
	
	var _WaitingListTimes2 = _interopRequireDefault(_WaitingListTimes);
	
	var _WaitingListInfo = __webpack_require__(1242);
	
	var _WaitingListInfo2 = _interopRequireDefault(_WaitingListInfo);
	
	var _Receipt = __webpack_require__(1149);
	
	var _Receipt2 = _interopRequireDefault(_Receipt);
	
	var _RemoveFromWaitingList = __webpack_require__(922);
	
	var _RemoveFromWaitingList2 = _interopRequireDefault(_RemoveFromWaitingList);
	
	var _index = __webpack_require__(1003);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _routes2 = __webpack_require__(940);
	
	var _routes3 = _interopRequireDefault(_routes2);
	
	var _routes4 = __webpack_require__(1012);
	
	var _routes5 = _interopRequireDefault(_routes4);
	
	var _routes6 = __webpack_require__(890);
	
	var _routes7 = _interopRequireDefault(_routes6);
	
	var _routes8 = __webpack_require__(981);
	
	var _routes9 = _interopRequireDefault(_routes8);
	
	var _routes10 = __webpack_require__(1115);
	
	var _routes11 = _interopRequireDefault(_routes10);
	
	var _Layout = __webpack_require__(112);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _MainLayout = __webpack_require__(906);
	
	var _MainLayout2 = _interopRequireDefault(_MainLayout);
	
	var _OldRoutes = __webpack_require__(863);
	
	var _OldRoutes2 = _interopRequireDefault(_OldRoutes);
	
	var _ReservationCanceled = __webpack_require__(1152);
	
	var _ReservationCanceled2 = _interopRequireDefault(_ReservationCanceled);
	
	var _ResetPassword = __webpack_require__(923);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _MobileAppLinkRedirect = __webpack_require__(1034);
	
	var _MobileAppLinkRedirect2 = _interopRequireDefault(_MobileAppLinkRedirect);
	
	var _DeepLinkRedirect = __webpack_require__(1033);
	
	var _DeepLinkRedirect2 = _interopRequireDefault(_DeepLinkRedirect);
	
	var _Route = __webpack_require__(911);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _ShopSecondaryLayout = __webpack_require__(913);
	
	var _ShopSecondaryLayout2 = _interopRequireDefault(_ShopSecondaryLayout);
	
	var _Shops = __webpack_require__(1224);
	
	var _Shops2 = _interopRequireDefault(_Shops);
	
	var _ConfirmBarber = __webpack_require__(921);
	
	var _ConfirmBarber2 = _interopRequireDefault(_ConfirmBarber);
	
	var _ViewReservation = __webpack_require__(1153);
	
	var _ViewReservation2 = _interopRequireDefault(_ViewReservation);
	
	var _PickTime = __webpack_require__(1205);
	
	var _PickTime2 = _interopRequireDefault(_PickTime);
	
	var _WaitingListBook = __webpack_require__(925);
	
	var _WaitingListBook2 = _interopRequireDefault(_WaitingListBook);
	
	var _CampaignEmail = __webpack_require__(895);
	
	var _CampaignEmail2 = _interopRequireDefault(_CampaignEmail);
	
	var _CheckoutContainer = __webpack_require__(1195);
	
	var _CheckoutContainer2 = _interopRequireDefault(_CheckoutContainer);
	
	var _routes12 = __webpack_require__(1027);
	
	var _routes13 = _interopRequireDefault(_routes12);
	
	var _history = __webpack_require__(201);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scrollMiddleware = (0, _reactRouterScroll.useScroll)(function (prevRouterProps, _ref) {
	  var routes = _ref.routes;
	  return !routes.some(function (route) {
	    return route.ignoreScrollBehavior;
	  });
	});
	
	exports.default = function (onRouteUpdate) {
	  return _react2.default.createElement(
	    _reactRouter.Router,
	    {
	      history: _history.history,
	      render: (0, _reactRouter.applyRouterMiddleware)(scrollMiddleware),
	      onUpdate: onRouteUpdate
	    },
	    _react2.default.createElement(_reactRouter.Route, { path: '/receipt/:id/:transactionIdentifier', component: _Receipt2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/campaign/:campaignId/:source(/:customerId)', component: _CampaignEmail2.default }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: '/', component: _index2.default, onChange: (0, _routes.composeReplaceHooks)(_routes.persistShowShops) },
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { component: _Layout2.default },
	        _react2.default.createElement(_reactRouter.Route, { path: 'verify-email/customer/:token', component: _VerifyEmail.CustomerVerifyEmail }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'verify-email/barber/:token', component: _VerifyEmail.BarberVerifyEmail }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'confirm/:shopId/:barberId', component: _ConfirmBarber2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'reset-password/:token', component: _ResetPassword2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'app-link', component: _MobileAppLinkRedirect2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'apps/confirmation/:confirmationCode', component: _DeepLinkRedirect2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'apps/:brandRoute/confirmation/:confirmationCode', component: _DeepLinkRedirect2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'customer/waiting-list/:customerId', component: _RemoveFromWaitingList2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'unsubscribe/campaign/:ownerType/:ownerId(/:customerId)', component: _CampaignUnsubscribe2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: '404', component: _Route2.default, status: 404 })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { component: _MainLayout2.default },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _Shops2.default })
	      ),
	      (0, _routes7.default)(),
	      (0, _routes5.default)(),
	      (0, _routes9.default)(),
	      (0, _routes11.default)(),
	      (0, _routes13.default)(),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { component: _ShopSecondaryLayout2.default },
	        _react2.default.createElement(_reactRouter.Route, { path: 'view-reservation/:appointmentId/charge', component: _CheckoutContainer2.default }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: 'view-reservation/:appointmentId', component: _ViewReservation2.default },
	          _react2.default.createElement(_reactRouter.Route, { path: 'reschedule', component: _PickTime2.default })
	        ),
	        _react2.default.createElement(_reactRouter.Route, { path: 'appointment-canceled/:appointmentId', component: _ReservationCanceled2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'book-time-slot/:waitingListSlotId/:waitingListCustomerId', component: _WaitingListBook2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'waiting-list', component: _WaitingListInfo2.default }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: 'waiting-list-times/:waitingListCustomerId/:slotId',
	          component: _WaitingListTimes2.default
	        })
	      ),
	      (0, _routes3.default)(),
	      (0, _OldRoutes2.default)(),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { component: _Layout2.default },
	        _react2.default.createElement(_reactRouter.Route, { path: '*', component: _Route2.default, status: 404 })
	      )
	    )
	  );
	};

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(49);
	
	var _reduxSentryMiddleware = __webpack_require__(1754);
	
	var _reduxSentryMiddleware2 = _interopRequireDefault(_reduxSentryMiddleware);
	
	var _reduxThunk = __webpack_require__(1755);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxPromise = __webpack_require__(1753);
	
	var _reduxPromise2 = _interopRequireDefault(_reduxPromise);
	
	var _resetTimeOnSetActiveDay = __webpack_require__(1030);
	
	var _resetTimeOnSetActiveDay2 = _interopRequireDefault(_resetTimeOnSetActiveDay);
	
	var _debounceSetActiveDay = __webpack_require__(1028);
	
	var _debounceSetActiveDay2 = _interopRequireDefault(_debounceSetActiveDay);
	
	var _populateReservationFromAppointment = __webpack_require__(1029);
	
	var _populateReservationFromAppointment2 = _interopRequireDefault(_populateReservationFromAppointment);
	
	var _reducer = __webpack_require__(1246);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _sentry = __webpack_require__(1238);
	
	var _sentry2 = _interopRequireDefault(_sentry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var composeEnhancers = void 0;
	var middlewares = [_debounceSetActiveDay2.default, _resetTimeOnSetActiveDay2.default, _populateReservationFromAppointment2.default, _reduxThunk2.default, _reduxPromise2.default];
	
	if (false) {
	  // eslint-disable-next-line no-underscore-dangle
	  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	} else {
	  if (window.Sentry) {
	    var sentryMiddleware = (0, _reduxSentryMiddleware2.default)((0, _sentry2.default)());
	    middlewares.push(sentryMiddleware);
	  }
	
	  composeEnhancers = _redux.compose;
	}
	
	function configureStore(preloadedState) {
	  return (0, _redux.createStore)(_reducer2.default, preloadedState, composeEnhancers(_redux.applyMiddleware.apply(undefined, middlewares)));
	}

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(1250);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {(function() {for(var aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,d){if(d.get||d.set)throw new TypeError("ES3 does not support getters and setters.");a!=Array.prototype&&a!=Object.prototype&&(a[b]=d.value)},k="undefined"!=typeof window&&window===this?this:"undefined"!=typeof global&&null!=global?global:this,n=["String","prototype","includes"],ba=0;ba<n.length-1;ba++){var ca=n[ba];ca in k||(k[ca]={});k=k[ca]}
	var da=n[n.length-1],ea=k[da],fa=ea?ea:function(a,b){if(null==this)throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");if(a instanceof RegExp)throw new TypeError("First argument to String.prototype.includes must not be a regular expression");return-1!==(this+"").indexOf(a,b||0)};fa!=ea&&null!=fa&&aa(k,da,{configurable:!0,writable:!0,value:fa});
	function ga(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var d=Object.prototype.toString.call(a);if("[object Window]"==d)return"object";if("[object Array]"==d||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==d||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
	else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ha(a,b,d){return a.call.apply(a.bind,arguments)}function ia(a,b,d){if(!a)throw Error();if(2<arguments.length){var c=Array.prototype.slice.call(arguments,2);return function(){var d=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(d,c);return a.apply(b,d)}}return function(){return a.apply(b,arguments)}}
	function ja(a,b,d){ja=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ha:ia;return ja.apply(null,arguments)};function ka(a){return/^\s*$/.test(a)?!1:/^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g,"@").replace(/(?:"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)[\s\u2028\u2029]*(?=:|,|]|}|$)/g,"]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g,""))}function la(a){a=String(a);if(ka(a))try{return eval("("+a+")")}catch(b){}throw Error("Invalid JSON string: "+a);}function p(a){var b=[];ma(new na,a,b);return b.join("")}function na(){}
	function ma(a,b,d){if(null==b)d.push("null");else{if("object"==typeof b){if("array"==ga(b)){var c=b;b=c.length;d.push("[");for(var e="",f=0;f<b;f++)d.push(e),ma(a,c[f],d),e=",";d.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{d.push("{");e="";for(c in b)Object.prototype.hasOwnProperty.call(b,c)&&(f=b[c],"function"!=typeof f&&(d.push(e),oa(c,d),d.push(":"),ma(a,f,d),e=","));d.push("}");return}}switch(typeof b){case "string":oa(b,d);break;case "number":d.push(isFinite(b)&&
	!isNaN(b)?String(b):"null");break;case "boolean":d.push(String(b));break;case "function":d.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var pa={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},qa=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g;
	function oa(a,b){b.push('"',a.replace(qa,function(b){var a=pa[b];a||(a="\\u"+(b.charCodeAt(0)|65536).toString(16).substr(1),pa[b]=a);return a}),'"')};function t(a){a=String(a);try{return JSON.parse(a)}catch(b){}throw Error("Invalid JSON string: "+a);}function u(a){try{return"object"===typeof JSON&&"function"===typeof JSON.stringify?JSON.stringify(a):p(a)}catch(b){}throw Error("Could not stringify object");};function ra(){function a(){if(b.length)b[0](function(){b.shift();a()})}var b=[];return function(d){b.push(d);1===b.length&&a()}};function v(a,b,d){a=a.replace(/\$(\d)/g,function(a,d){return b[parseInt(d,10)-1]});d&&(a+="\n Failure Code:"+d);return a}function sa(a){return{data:a.data||"",data_parsed:a.data_parsed||{},has_app:a.has_app||null,identity:a.identity||null,referring_identity:a.referring_identity||null,referring_link:a.referring_link||null}}
	function ta(a){var b=/^\$journeys_\S+$/,d=a.data,c={};if(!d)return{};switch(typeof d){case "string":try{d=t(d)}catch(e){d=la(d)}break;case "object":break;default:d={}}Object.keys(d).forEach(function(a){b.test(a)&&(c[a]=d[a])});return c}function ua(){var a;a="_branch_view_id".replace(/[\[\]]/g,"\\$&");return(a=(new RegExp("[?&]"+a+"(=([^&#]*)|&|#|$)")).exec(String(window.location)))&&a[2]?decodeURIComponent(a[2].replace(/\+/g," ")):""}
	function va(a){a.source="web-sdk";var b=a.data;switch(typeof b){case "string":try{b=t(b)}catch(d){b=la(b)}break;case "object":break;default:b={}}b.$canonical_url||(b.$canonical_url=String(window.location));b.$og_title||(b.$og_title=w("title"));b.$og_description||(b.$og_description=w("description"));b.$og_image_url||(b.$og_image_url=w("image"));b.$og_video||(b.$og_video=w("video"));"string"===typeof b.$desktop_url&&(b.$desktop_url=b.$desktop_url.replace(/#r:[a-z0-9-_]+$/i,"").replace(/([\?\&]_branch_match_id=\d+)/,
	""));try{t(b)}catch(d){b=p(b)}a.data=b;return a}function wa(a){return a?a.substring(a.lastIndexOf("/")+1,a.length):null}function x(a,b){a&&"object"===typeof a||(a={});if(!b||"object"!==typeof b)return a;for(var d in b)b.hasOwnProperty(d)&&(a[d]=b[d]);return a}function xa(){try{var a=window.location.hash.match(/r:([^&]*)/);if(a&&1<=a.length)return a[1]}catch(b){}}
	function y(){var a=navigator.userAgent;return a.match(/android/i)?"android":a.match(/ipad/i)?"ipad":a.match(/i(os|p(hone|od))/i)?"ios":a.match(/\(BB[1-9][0-9]*\;/i)?"blackberry":a.match(/Windows Phone/i)?"windows_phone":a.match(/Kindle/i)||a.match(/Silk/i)||a.match(/KFTT/i)||a.match(/KFOT/i)||a.match(/KFJWA/i)||a.match(/KFJWI/i)||a.match(/KFSOWI/i)||a.match(/KFTHWA/i)||a.match(/KFTHWI/i)||a.match(/KFAPWA/i)||a.match(/KFAPWI/i)?"kindle":!1}
	function ya(){var a=navigator.userAgent,b;if(/^((?!chrome|android|crios|fxios).)*safari/i.test(a))a:{var d;d=11;if((a=/version\/([^ ]*)/i.exec(a))&&a[1])try{if(parseFloat(a[1])>=d){b=!0;break a}}catch(c){}b=!1}else b=!1;return b}function za(){try{var a=window.location.search.substring(1).match(/_branch_match_id=([^&]*)/);if(a&&1<=a.length)return a[1]}catch(b){}}function Aa(a){return a.replace(/(\-\w)/g,function(b){return b[1].toUpperCase()})}
	function Ba(a){var b="",d,c,e,f,h,l,g=0;a=a.replace(/\r\n/g,"\n");c="";for(e=0;e<a.length;e++)f=a.charCodeAt(e),128>f?c+=String.fromCharCode(f):(127<f&&2048>f?c+=String.fromCharCode(f>>6|192):(c+=String.fromCharCode(f>>12|224),c+=String.fromCharCode(f>>6&63|128)),c+=String.fromCharCode(f&63|128));for(a=c;g<a.length;)d=a.charCodeAt(g++),c=a.charCodeAt(g++),e=a.charCodeAt(g++),f=d>>2,d=(d&3)<<4|c>>4,h=(c&15)<<2|e>>6,l=e&63,isNaN(c)?l=h=64:isNaN(e)&&(l=64),b=b+"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(f)+
	"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(d)+"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(h)+"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(l);return b}function Ca(a,b,d){"function"===typeof a.addEventListener?a.addEventListener(b,d,void 0):"function"===typeof a.attachEvent?a.attachEvent("on"+b,d):a["on"+b]=d}
	function Da(a){if(!a)return null;-1<a.indexOf("://")&&(a=a.split("://")[1]);return a.substring(a.indexOf("/")+1)}function Ea(a){if(!a)return null;-1<a.indexOf("://")?a=a.split("://")[1]:"/"===a.charAt(0)&&(a=a.slice(1));return a}function w(a){var b;a=String(a);b=b||null;(a=document.querySelector('meta[property="og:'+a+'"]'))&&a.content&&(b=a.content);return b}
	function Fa(){for(var a={},b=document.getElementsByTagName("meta"),d=0;d<b.length;d++)if((b[d].getAttribute("name")||b[d].getAttribute("property"))&&b[d].getAttribute("content")){var c=b[d].getAttribute("name"),e=b[d].getAttribute("property"),c=c||e;"al:ios:url"===c?a.$ios_deeplink_path=Ea(b[d].getAttribute("content")):"al:android:url"===c?a.$android_deeplink_path=Ea(b[d].getAttribute("content")):(c=c.split(":"),3===c.length&&"branch"===c[0]&&"deeplink"===c[1]&&(a[c[2]]=b[d].getAttribute("content")))}return a}
	function Ga(){var a;try{a=(navigator.language||navigator.browserLanguage||"en").split(/[^a-z^A-Z0-9-]/).shift().toLowerCase()}catch(b){a="en"}return a}function Ha(a,b){var d=[];b.forEach(function(b){-1===a.indexOf(b)&&d.push(b)});return d}
	var Ia=["purchase"],z={missingPurchaseEvent:"event name is either missing, of the wrong type or not valid. Please specify 'purchase' as the event name.",missingCommerceData:"commerce_data is either missing, of the wrong type or empty. Please ensure that commerce_data is constructed correctly.",invalidKeysForRoot:"Please remove the following keys from the root of commerce_data: ",invalidKeysForProducts:"Please remove the following keys from commerce_data.products: ",invalidProductListType:"commerce_data.products must be an array of objects",
	invalidProductType:"Each product in the products list must be an object"};
	function Ja(a){var b="sku name price quantity brand category variant".split(" "),d=Ha("common type transaction_id currency revenue revenue_in_usd exchange_rate shipping tax coupon affiliation persona products".split(" "),Object.keys(a));if(d.length)return z.invalidKeysForRoot+d.join(", ");var c=[],e;if(a.hasOwnProperty("products")){if(!Array.isArray(a.products))return z.invalidProductListType;a.products.forEach(function(a){"object"!==typeof a&&(e=z.invalidProductType);c=c.concat(Ha(b,Object.keys(a)))});
	if(e)return e;if(c.length)return z.invalidKeysForProducts+c.join(", ")}return null}function Ka(a,b){if(!a||"string"!==typeof a||-1===Ia.indexOf(a.toLowerCase()))return z.missingPurchaseEvent;if(!b||"object"!==typeof b||!Object.keys(b).length)return z.missingCommerceData;var d=Ja(b);return d?d:null}function A(a){return"string"!==typeof a?null:a.replace(/</g,"&lt;").replace(/>/g,"&gt;")};function B(a,b){return function(d,c,e){if("number"===typeof e||e)if(0===b){if("object"!==typeof e)return v("API request $1, parameter $2 is not $3",[d,c,"an object"])}else if(3===b){if(!(e instanceof Array))return v("API request $1, parameter $2 is not $3",[d,c,"an array"])}else if(2===b){if("number"!==typeof e)return v("API request $1, parameter $2 is not $3",[d,c,"a number"])}else if(4===b){if("boolean"!==typeof e)return v("API request $1, parameter $2 is not $3",[d,c,"a boolean"])}else{if("string"!==
	typeof e)return v("API request $1, parameter $2 is not $3",[d,c,"a string"]);if(1!==b&&!b.test(e))return v("API request $1, parameter $2 is not $3",[d,c,"in the proper format"])}else if(a)return v("API request $1 missing parameter $2",[d,c]);return!1}}var C=/^[0-9]{15,20}$/;function D(a){return x(a,{browser_fingerprint_id:B(!0,C),identity_id:B(!0,C),sdk:B(!0,1),session_id:B(!0,C)})}
	var La={destination:"https://api.branch.io",endpoint:"/v1/open",method:"POST",a:{browser_fingerprint_id:B(!1,C),alternative_browser_fingerprint_id:B(!1,C),identity_id:B(!1,C),link_identifier:B(!1,1),sdk:B(!1,1),options:B(!1,0),initial_referrer:B(!1,1)}},Ma={destination:"https://app.link",endpoint:"/_r",method:"GET",U:!0,a:{sdk:B(!0,1),_t:B(!1,C),branch_key:B(!0,1)}},Na={destination:"",endpoint:"",method:"GET",f:{link_url:B(!0,1)},a:{click:B(!0,1)}},Oa={destination:"https://bnc.lt",endpoint:"/c",method:"POST",
	f:{link_url:B(!0,1)},a:{sdk:B(!1,1),phone:B(!0,1)}},Pa={destination:"https://api.branch.io",endpoint:"/v1/referralcode",method:"POST",a:D({amount:B(!0,2),bucket:B(!1,1),calculation_type:B(!0,2),creation_source:B(!0,2),expiration:B(!1,1),location:B(!0,2),prefix:B(!1,1),type:B(!0,1)})},Qa={destination:"https://api.branch.io",endpoint:"/v1/referralcode",method:"POST",f:{code:B(!0,1)},a:D({})},Ra={destination:"https://api.branch.io",endpoint:"/v1/applycode",method:"POST",f:{code:B(!0,1)},a:D({})},Sa=
	{destination:"https://api.branch.io",endpoint:"/v1/logout",method:"POST",a:D({session_id:B(!0,C)})},Ta={destination:"https://api.branch.io",endpoint:"/v1/profile",method:"POST",a:D({identity_id:B(!0,C),identity:B(!0,1)})},Ua={destination:"https://api.branch.io",endpoint:"/v1/referrals",method:"GET",f:{identity_id:B(!0,C)},a:D({})},Va={destination:"https://api.branch.io",endpoint:"/v1/credithistory",method:"GET",a:D({begin_after_id:B(!1,C),bucket:B(!1,1),direction:B(!1,2),length:B(!1,2),link_click_id:B(!1,
	C)})},Wa={destination:"https://api.branch.io",endpoint:"/v1/credits",method:"GET",a:D({branch_key:B(!0,1),identity:B(!0,1)})},Xa={destination:"https://api.branch.io",endpoint:"/v1/redeem",method:"POST",a:D({amount:B(!0,2),bucket:B(!0,1),identity_id:B(!0,C)})},Ya={destination:"https://api.branch.io",endpoint:"/v1/url",method:"POST",va:"obj",a:D({alias:B(!1,1),campaign:B(!1,1),channel:B(!1,1),data:B(!1,1),feature:B(!1,1),identity_id:B(!0,C),stage:B(!1,1),tags:B(!1,3),type:B(!1,2),source:B(!1,1)})},
	Za={destination:"https://api.branch.io",endpoint:"/v1/deepview",U:!0,method:"POST",a:D({campaign:B(!1,1),_t:B(!1,C),channel:B(!1,1),data:B(!0,1),feature:B(!1,1),link_click_id:B(!1,1),open_app:B(!1,4),append_deeplink_path:B(!1,4),stage:B(!1,1),tags:B(!1,3),deepview_type:B(!0,1),source:B(!0,1)})},$a={destination:"https://api.branch.io",endpoint:"/v1/has-app",method:"GET",a:{browser_fingerprint_id:B(!0,C)}},ab={destination:"https://api.branch.io",endpoint:"/v1/event",method:"POST",a:D({event:B(!0,1),
	metadata:B(!0,0),initial_referrer:B(!1,1)})},bb={destination:"https://api.branch.io",endpoint:"/v1/event",method:"POST",a:D({event:B(!0,1),metadata:B(!1,0),initial_referrer:B(!1,1),commerce_data:B(!0,0)})};function E(a){for(var b=0;b<a.length;b++){var d=this[a[b]],d="function"===typeof d?d():d;if(d.isEnabled())return d.s={},d}}function G(a){return"branch_session"===a||"branch_session_first"===a?a:"BRANCH_WEBSDK_KEY"+a}function cb(a){return"true"===a?!0:"false"===a?!1:a}
	function db(a){var b;try{b=a&&localStorage?localStorage:sessionStorage}catch(d){return{isEnabled:function(){return!1}}}return{getAll:function(){if("undefined"===typeof b)return null;var a=null,c;for(c in b)c.indexOf("BRANCH_WEBSDK_KEY")||(null===a&&(a={}),a[c.replace("BRANCH_WEBSDK_KEY","")]=cb(b.getItem(c)));return a},get:function(a,c){return cb(c&&localStorage?localStorage.getItem(G(a)):b.getItem(G(a)))},set:function(a,c,e){e&&localStorage?localStorage.setItem(G(a),c):b.setItem(G(a),c)},remove:function(a,
	c){c&&localStorage?localStorage.removeItem(G(a)):b.removeItem(G(a))},clear:function(){Object.keys(b).forEach(function(a){a.indexOf("BRANCH_WEBSDK_KEY")||b.removeItem(a)})},isEnabled:function(){try{return b.setItem("test",""),b.removeItem("test"),!0}catch(d){return!1}}}}E.prototype.local=function(){return db(!0)};E.prototype.session=function(){return db(!1)};
	function fb(a){return{getAll:function(){for(var a=document.cookie.split(";"),d={},c=0;c<a.length;c++){var e=a[c].replace(" ",""),e=e.substring(0,e.length);-1!==e.indexOf("BRANCH_WEBSDK_KEY")&&(e=e.split("="),d[e[0].replace("BRANCH_WEBSDK_KEY","")]=cb(e[1]))}return d},get:function(a){a=G(a)+"=";for(var b=document.cookie.split(";"),c=0;c<b.length;c++){var e=b[c],e=e.substring(1,e.length);if(!e.indexOf(a))return cb(e.substring(a.length,e.length))}return null},set:function(b,d){var c=G(b),e="";a&&(e=
	new Date,e.setTime(e.getTime()+31536E6),e="; branch_expiration_date="+e.toGMTString()+"; expires="+e.toGMTString());document.cookie=c+"="+d+e+"; path=/"},remove:function(a){document.cookie=G(a)+"=; expires=; path=/"},clear:function(){function b(a){document.cookie=a.substring(0,a.indexOf("="))+"=;expires=-1;path=/"}for(var d=document.cookie.split(";"),c=0;c<d.length;c++){var e=d[c],e=e.substring(1,e.length);-1!==e.indexOf("BRANCH_WEBSDK_KEY")&&(a||-1!==e.indexOf("branch_expiration_date=")?a&&0<e.indexOf("branch_expiration_date=")&&
	b(e):b(e))}},isEnabled:function(){return navigator.cookieEnabled}}}E.prototype.cookie=function(){return fb(!1)};E.prototype.permcookie=function(){return fb(!0)};E.prototype.pojo={getAll:function(){return this.s},get:function(a){return this.s[a]||null},set:function(a,b){this.s[a]=b},remove:function(a){delete this.s[a]},clear:function(){this.s={}},isEnabled:function(){return!0}};function H(a,b){try{return t(a.get(b?"branch_session_first":"branch_session",b))||null}catch(d){return null}}function gb(a,b,d){a.set("branch_session",p(b));d&&a.set("branch_session_first",p(b),!0)}function hb(a,b){if(b){var d=H(a)||{},d=x(d,b);a.set("branch_session",p(d))}};function ib(){}ib.prototype.g=0;function jb(a,b,d){if("undefined"===typeof b)return"";var c=[];if(b instanceof Array){for(a=0;a<b.length;a++)c.push(encodeURIComponent(d)+"="+encodeURIComponent(b[a]));return c.join("&")}for(var e in b)b.hasOwnProperty(e)&&(b[e]instanceof Array||"object"===typeof b[e]?c.push(jb(a,b[e],d?d+"."+e:e)):c.push(encodeURIComponent(d?d+"."+e:e)+"="+encodeURIComponent(b[e])));return c.join("&")}
	function lb(a,b,d){function c(a,c){"undefined"===typeof c&&(c={});if(a.branch_key&&g.test(a.branch_key))return c.branch_key=a.branch_key,c;if(a.app_id&&l.test(a.app_id))return c.app_id=a.app_id,c;throw Error(v("API request $1 missing parameter $2",[b.endpoint,"branch_key or app_id"]));}var e,f,h=b.destination+b.endpoint,l=/^[0-9]{15,20}$/,g=/key_(live|test)_[A-Za-z0-9]{32}/;if("/v1/has-app"===b.endpoint)try{b.f=c(d,b.f)}catch(r){return{error:r.message}}if("undefined"!==typeof b.f)for(e in b.f)if(b.f.hasOwnProperty(e)){if(f=
	"function"===typeof b.f[e]?b.f[e](b.endpoint,e,d[e]):f)return{error:f};h+="/"+d[e]}var m={};if("undefined"!==typeof b.a)for(e in b.a)if(b.a.hasOwnProperty(e)){if(f=b.a[e](b.endpoint,e,d[e]))return{error:f};f=d[e];"undefined"!==typeof f&&""!==f&&null!==f&&(m[e]=f)}if("POST"===b.method||"/v1/credithistory"===b.endpoint)try{d=c(d,m)}catch(r){return{error:r.message}}"/v1/event"===b.endpoint&&(m.metadata=u(m.metadata||{}),m.hasOwnProperty("commerce_data")&&(m.commerce_data=u(m.commerce_data||{})));"/v1/open"===
	b.endpoint&&(m.options=u(m.options||{}));return{data:jb(a,m,""),url:h.replace(/^\//,"")}}function mb(a,b,d){var c=document.createElement("script");c.type="text/javascript";c.async=!0;c.src=a;a=document.getElementsByTagName("head");!a||1>a.length?"function"===typeof b&&b():(a[0].appendChild(c),"function"===typeof b&&Ca(c,"error",b),"function"===typeof d&&Ca(c,"load",d))}
	function nb(a,b,d,c,e){var f="branch_callback__"+a.g++;a=0<=b.indexOf("branch.io")?"&data=":"&post_data=";d="POST"===c?encodeURIComponent(Ba(p(d))):"";var h=window.setTimeout(function(){window[f]=function(){};e(Error("Request timed out"),null,504)},5E3);window[f]=function(a){window.clearTimeout(h);e(null,a)};mb(b+(0>b.indexOf("?")?"?":"")+(d?a+d:"")+(0<=b.indexOf("/c/")?"&click=1":"")+"&callback="+f,function(){e(Error("Request blocked by client, probably adblock"),null)},function(){try{"function"===
	typeof this.remove?this.remove():this.parentNode.removeChild(this)}catch(l){}delete window[f]})}
	function ob(a,b,d,c,e,f,h){var l=window.XMLHttpRequest?new XMLHttpRequest:new ActiveXObject("Microsoft.XMLHTTP");l.ontimeout=function(){f(Error("Request timed out"),null,504)};l.onerror=function(a){f(Error(a.error||"Error in API: "+l.status),null,l.status)};l.onreadystatechange=function(){var a;if(4===l.readyState)if(200===l.status){if(h)a=l.responseText;else try{a=t(l.responseText)}catch(m){a={}}f(null,a,l.status)}else 402===l.status?f(Error("Not enough credits to redeem."),null,l.status):"4"!==
	l.status.toString().substring(0,1)&&"5"!==l.status.toString().substring(0,1)||f(Error("Error in API: "+l.status),null,l.status)};try{l.open(c,b,!0),l.timeout=5E3,l.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),l.send(d)}catch(g){e.set("use_jsonp",!0),nb(a,b,d,c,f)}}
	function pb(a,b,d,c,e){function f(){c.get("use_jsonp")||b.U?nb(a,g,d,b.method,h):ob(a,g,m,b.method,c,h)}function h(a,b,c){a&&0<r&&"5"===(c||"").toString().substring(0,1)?(r--,window.setTimeout(function(){f()},200)):e(a,b)}var l=lb(a,b,d);if(l.error)return e(Error(l.error));var g,m="";"GET"===b.method?g=l.url+"?"+l.data:(g=l.url,m=l.data);var r=2;f()};function I(a){a&&a.parentNode.removeChild(a)}function qb(a,b){a&&!a.className.match(new RegExp("(\\s|^)"+b+"(\\s|$)"))&&(a.className+=" "+b)}function rb(a){var b=document.body;b&&b.className.match(new RegExp("(\\s|^)"+a+"(\\s|$)"))&&(b.className=b.className.replace(new RegExp("(\\s|^)"+a+"(\\s|$)")," "))}function sb(a){var b=new Date;return b.setDate(b.getDate()+a)}
	function tb(a){return document.body.currentStyle?document.body.currentStyle[Aa(a)]:window.getComputedStyle(document.body).getPropertyValue(a)}
	function ub(a){function b(a){function c(){return Math.max(document.documentElement.clientHeight,window.innerHeight||0)/100}function d(){return Math.max(document.documentElement.clientWidth,window.innerWidth||0)/100}if(!a)return 0;var f=a.replace(/[0-9,\.]/g,"");a=a.match(/\d+/g);var h=parseInt(0<a.length?a[0]:"0",10);return parseInt({px:function(a){return a},em:function(a){return document.body.currentStyle?a*b(document.body.currentStyle.fontSize):a*parseFloat(window.getComputedStyle(document.body).fontSize)},
	rem:function(a){return document.documentElement.currentStyle?a*b(document.documentElement.currentStyle.fontSize):a*parseFloat(window.getComputedStyle(document.documentElement).fontSize)},vw:function(a){return a*d()},vh:function(a){return a*c()},vmin:function(a){return a*Math.min(c(),d())},vmax:function(a){return a*Math.max(c(),d())},"%":function(){return document.body.clientWidth/100*h}}[f](h),10)}return(b("76px")+b(a)).toString()+"px"}
	function vb(a,b){var d=a.get("hideBanner",!0);if(b.ia&&navigator&&Number(navigator.doNotTrack))return!1;try{"string"===typeof d&&(d=t(d))}catch(e){d=!1}var d="number"===typeof d?new Date>=new Date(d):!d,c=b.F;"number"===typeof c&&(c=!1);return!document.getElementById("branch-banner")&&!document.getElementById("branch-banner-iframe")&&(d||c)&&(b.ka&&!y()||b.I&&"android"===y()||b.la&&"ipad"===y()||b.M&&"ios"===y()||b.J&&"blackberry"===y()||b.L&&"windows_phone"===y()||b.K&&"kindle"===y())};function wb(a,b){return"#branch-banner-iframe { position: "+("top"!==b||a?"fixed":"absolute")+"; }\n"}
	function xb(a,b){var d=".branch-banner-is-active { -webkit-transition: all 0.375s ease; transition: all 00.375s ease; }\n#branch-banner { width:100%; z-index: 99999; font-family: Helvetica Neue, Sans-serif; -webkit-font-smoothing: antialiased; -webkit-user-select: none; -moz-user-select: none; user-select: none; -webkit-transition: all 0.25s ease; transition: all 00.25s ease; }\n#branch-banner .button{ border: 1px solid "+(a.buttonBorderColor||("dark"===a.theme?"transparent":"#ccc"))+"; background: "+
	(a.buttonBackgroundColor||"#fff")+"; color: "+(a.buttonFontColor||"#000")+"; cursor: pointer; margin-top: 0px; font-size: 14px; display: inline-block; margin-left: 5px; font-weight: 400; text-decoration: none;  border-radius: 4px; padding: 6px 12px; transition: all .2s ease;}\n#branch-banner .button:hover {  border: 1px solid "+(a.buttonBorderColorHover||("dark"===a.theme?"transparent":"#BABABA"))+"; background: "+(a.buttonBackgroundColorHover||"#E0E0E0")+"; color: "+(a.buttonFontColorHover||"#000")+
	";}\n#branch-banner .button:focus { outline: none; }\n#branch-banner * { margin-right: 4px; position: relative; line-height: 1.2em; }\n#branch-banner-close { font-weight: 400; cursor: pointer; float: left; z-index: 2;padding: 0 5px 0 5px; margin-right: 0; }\n#branch-banner .content { width:100%; overflow: hidden; height: 76px; background: rgba(255, 255, 255, 0.95); color: #333; "+("top"===a.position?"border-bottom":"border-top")+': 1px solid #ddd; }\n#branch-banner-close { color: #000; font-size: 24px; top: 14px; opacity: .5; transition: opacity .3s ease; }\n#branch-banner-close:hover { opacity: 1; }\n#branch-banner .title { font-size: 18px; font-weight:bold; color: #555; }\n#branch-banner .description { font-size: 12px; font-weight: normal; color: #777; max-height: 30px; overflow: hidden; }\n#branch-banner .icon { float: left; padding-bottom: 40px; margin-right: 10px; margin-left: 5px; }\n#branch-banner .icon img { width: 63px; height: 63px; margin-right: 0; }\n#branch-banner .reviews { font-size:13px; margin: 1px 0 3px 0; color: #777; }\n#branch-banner .reviews .star { display:inline-block; position: relative; margin-right:0; }\n#branch-banner .reviews .star span { display: inline-block; margin-right: 0; color: #555; position: absolute; top: 0; left: 0; }\n#branch-banner .reviews .review-count { font-size:10px; }\n#branch-banner .reviews .star .half { width: 50%; overflow: hidden; display: block; }\n#branch-banner .content .left { padding: 6px 5px 6px 5px; }\n#branch-banner .vertically-align-middle { top: 50%; transform: translateY(-50%); -webkit-transform: translateY(-50%); -ms-transform: translateY(-50%); }\n#branch-banner .details > * { display: block; }\n#branch-banner .content .left { height: 63px; }\n#branch-banner .content .right { float: right; height: 63px; margin-bottom: 50px; padding-top: 22px; z-index: 1; }\n#branch-banner .right > div { float: left; }\n#branch-banner-action { top: 17px; }\n#branch-banner .content:after { content: ""; position: absolute; left: 0; right: 0; top: 100%; height: 1px; background: rgba(0, 0, 0, 0.2); }\n#branch-banner .theme-dark.content { background: rgba(51, 51, 51, 0.95); }\n#branch-banner .theme-dark #branch-banner-close{ color: #fff; text-shadow: 0 1px 1px rgba(0, 0, 0, .15); }\n#branch-banner .theme-dark .details { text-shadow: 0 1px 1px rgba(0, 0, 0, .15); }\n#branch-banner .theme-dark .title { color: #fff; }\n#branch-banner .theme-dark .description { color: #fff; }\n#branch-banner .theme-dark .reviews { color: #888; }\n#branch-banner .theme-dark .reviews .star span{ color: #fff; }\n#branch-banner .theme-dark .reviews .review-count{ color: #fff; }\n',
	c=y();"ios"!==c&&"ipad"!==c||!a.M?"android"===c&&a.I?d+="#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n#branch-banner #branch-banner-close,#branch-banner .theme-dark #branch-banner-close { height:17px; width: 17px; text-align: center; font-size: 15px; top: 24px;  border-radius:14px; border:0; line-height:14px; color:#b1b1b3; background:#efefef; padding: 0; opacity: 1; }\n#branch-banner .button { top: 0; text-decoration:none; border-bottom: 3px solid #A4C639; padding: 0 10px; height: 24px; line-height: 24px; text-align: center; color: #fff; margin-top: 2px;  font-weight: bold; background-color: #A4C639; border-radius: 5px; }\n#branch-banner .button:hover { border-bottom:3px solid #8c9c29; background-color: #c1d739; }\n":
	"blackberry"===c&&a.J?d+="#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n":
	"windows_phone"===c&&a.L?d+="#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n":
	"kindle"===c&&a.K?d+="#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n":
	(d+="#branch-banner { position: fixed; min-width: 600px; }\n#branch-sms-block * { vertical-align: bottom; font-size: 15px; }\n#branch-sms-block { display: inline-block; }\n#branch-banner input{ border: 1px solid #ccc;  font-weight: 400;  border-radius: 4px; height: 30px; padding: 5px 7px 4px; width: 145px; font-size: 14px;}\n#branch-banner input:focus { outline: none; }\n#branch-banner input.error { color: rgb(194, 0, 0); border-color: rgb(194, 0, 0); }\n#branch-banner .branch-icon-wrapper { width:25px; height: 25px; vertical-align: middle; display: inline-block; margin-top: -18px; }\n@keyframes branch-spinner { 0% { transform: rotate(0deg); -webkit-transform: rotate(0deg); -ms-transform: rotate(0deg); } 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg); -ms-transform: rotate(360deg); } }\n@-webkit-keyframes branch-spinner { 0% { transform: rotate(0deg); -webkit-transform: rotate(0deg); -ms-transform: rotate(0deg); } 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg); -ms-transform: rotate(360deg); } }\n#branch-spinner { -webkit-animation: branch-spinner 1s ease-in-out infinite; animation: branch-spinner 1s ease-in-out infinite; transition: all 0.7s ease-in-out; border:2px solid #ddd; border-bottom-color:#428bca; width:80%; height:80%; border-radius:50%; -webkit-font-smoothing: antialiased !important; }\n#branch-banner .theme-dark input { border-color: transparent; }\n",
	d=window.ActiveXObject?d+"#branch-banner .checkmark { color: #428bca; font-size: 22px; }\n":d+"#branch-banner .checkmark { stroke: #428bca; stroke-dashoffset: 745.74853515625; stroke-dasharray: 745.74853515625; -webkit-animation: dash 2s ease-out forwards; animation: dash 2s ease-out forwards; }\n@-webkit-keyframes dash { 0% { stroke-dashoffset: 745.748535 15625; } 100% { stroke-dashoffset: 0; } }\n@keyframes dash { 0% { stroke-dashoffset: 745.74853515625; } 100% { stroke-dashoffset: 0; } }\n"):d+=
	"#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n";
	d+=a.$;a.w&&(d+="body { margin: 0; }\n",c=document.createElement("style"),c.type="text/css",c.id="branch-iframe-css",c.innerHTML="body { -webkit-transition: all 0.375s ease; transition: all 00.375s ease; }\n#branch-banner-iframe { box-shadow: 0 0 5px rgba(0, 0, 0, .35); width: 1px; min-width:100%; left: 0; right: 0; border: 0; height: 76px; z-index: 99999; -webkit-transition: all 0.25s ease; transition: all 00.25s ease; }\n"+(y()?wb(a.ea,a.position):wb(a.aa,a.position)),(document.head||document.getElementsByTagName("head")[0]).appendChild(c));
	c=document.createElement("style");c.type="text/css";c.id="branch-css";c.innerHTML=d;d=a.w?b.contentWindow.document:document;(d=d.head||d.getElementsByTagName("head")[0])&&"function"===typeof d.appendChild&&d.appendChild(c);"top"===a.position?b.style.top="-76px":"bottom"===a.position&&(b.style.bottom="-76px")};function yb(a,b){var d;if(a.u||a.G){if(a.u){d="";for(var c=0;5>c;c++)d+='<span class="star"><svg class="star" fill="#555555" height="12" viewBox="3 2 20 19" width="12" xmlns="http://www.w3.org/2000/svg"><path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"/><path d="M0 0h24v24H0z" fill="none"/><foreignObject display="none"><span class="star">\u2606</span></foreignObject></svg>',
	a.u>c&&(d+=c+1>a.u&&a.u%1?'<span class="half"><svg fill="#555555" height="12" viewBox="3 2 20 19" width="12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M0 0h24v24H0V0z" id="a"/></defs><clipPath id="b"><use overflow="visible" xlink:href="#a"/></clipPath><path clip-path="url(#b)" d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"/></svg><foreignObject display="none"><span class="half">\u2605</span></foreignObject></span>':
	'<span class="full"><svg fill="#555555" height="12" viewBox="3 2 20 19" width="12" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/><path d="M0 0h24v24H0z" fill="none"/><foreignObject display="none"><span class="full">\u2605</span></foreignObject></svg> </span>'),d+="</span>";d='<span class="stars">'+d+"</span>"}else d="";d='<div class="reviews">'+d+(a.G?'<span class="review-count">'+
	a.G+"</span>":"")+"</div>"}else d="";return'<div class="content'+(a.theme?" theme-"+a.theme:"")+'"><div class="right">'+b+'</div><div class="left">'+(a.ba?"":'<div id="branch-banner-close" class="branch-animation" aria-label="Close">&times;</div>')+'<div class="icon"><img src="'+a.icon+'" alt="Application icon"></div><div class="details vertically-align-middle"><div class="title">'+a.title+"</div>"+d+'<div class="description">'+a.description+"</div></div></div></div>"}
	function zb(a,b){var d='<div id="branch-sms-form-container">'+(y()?'<a id="branch-mobile-action" class="button" href="#" target="_parent">'+((H(b)||{}).has_app?a.fa:a.ca)+"</a>":'<div class="branch-icon-wrapper" id="branch-loader-wrapper" style="opacity: 0;"><div id="branch-spinner"></div></div><div id="branch-sms-block"><form id="sms-form"><input type="phone" aria-label="Enter phone number" class="branch-animation" name="branch-sms-phone" id="branch-sms-phone" placeholder="'+a.ha+'"><button type="submit" id="branch-sms-send" class="branch-animation button">'+
	a.ja+"</button></form></div>")+"</div>";if(a.w){var c=document.createElement("iframe");c.src="about:blank";c.style.overflow="hidden";c.scrolling="no";c.id="branch-banner-iframe";c.className="branch-animation";document.body.appendChild(c);var e=y(),d='<html><head></head><body class="'+("ios"===e||"ipad"===e?"branch-banner-ios":"android"===e?"branch-banner-android":"branch-banner-desktop")+'"><div id="branch-banner" class="branch-animation">'+yb(a,d)+"</body></html>";c.contentWindow.document.open();
	c.contentWindow.document.write(d);c.contentWindow.document.close()}else c=document.createElement("div"),c.id="branch-banner",c.className="branch-animation",c.innerHTML=yb(a,d),document.body.appendChild(c);return d=c};function Ab(a,b,d,c){function e(){h();g.style.background="#FFD4D4";l.className="error";setTimeout(function(){g.style.background="#FFFFFF";l.className=""},2E3)}function f(){q=a.createElement("div");q.className="branch-icon-wrapper";q.id="branch-checkmark";q.style="opacity: 0;";q.innerHTML=window.ActiveXObject?'<span class="checkmark">&#x2713;</span>':'<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 98.5 98.5" enable-background="new 0 0 98.5 98.5" xml:space="preserve"><path class="checkmark" fill="none" stroke-width="8" stroke-miterlimit="10" d="M81.7,17.8C73.5,9.3,62,4,49.2,4C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"/></svg>';
	r.appendChild(q);g.style.opacity="0";l.style.opacity="0";m.style.opacity="0";setTimeout(function(){q.style.opacity="1"},20);l.value=""}function h(){g.removeAttribute("disabled");l.removeAttribute("disabled");g.style.opacity="1";l.style.opacity="1";m.style.opacity="0"}var l=a.getElementById("branch-sms-phone"),g=a.getElementById("branch-sms-send"),m=a.getElementById("branch-loader-wrapper"),r=a.getElementById("branch-sms-form-container"),q;if(l){var F=l.value;/^\d{7,}$/.test(F.replace(/[\s()+\-\.]|ext/gi,
	""))?(J(b,"willSendBannerSMS"),g.setAttribute("disabled",""),l.setAttribute("disabled",""),g.style.opacity=".4",l.style.opacity=".4",m.style.opacity="1",l.className="",b.sendSMS(F,c,d,function(a){a?(J(b,"sendBannerSMSError"),e()):(J(b,"didSendBannerSMS"),f(),setTimeout(function(){r.removeChild(q);h()},3E3))})):e()}}
	function Bb(a,b,d,c){function e(a,d){"function"===typeof a&&(d=a,a={});a=a||{};"top"===b.position?h.style.top="-76px":"bottom"===b.position&&(h.style.bottom="-76px");"number"===typeof b.F?c.set("hideBanner",sb(b.F),!0):c.set("hideBanner",!0,!0);a.T?("top"===b.position?document.body.style.marginTop=m:"bottom"===b.position&&(document.body.style.marginBottom=q),rb("branch-banner-is-active"),I(h),I(document.getElementById("branch-css")),d()):(setTimeout(function(){I(h);I(document.getElementById("branch-css"));
	d()},270),setTimeout(function(){"top"===b.position?document.body.style.marginTop=m:"bottom"===b.position&&(document.body.style.marginBottom=q);rb("branch-banner-is-active")},20))}function f(){"top"===b.position?h.style.top="0":"bottom"===b.position&&(h.style.bottom="0");J(a,"didShowBanner")}if(!vb(c,b))return J(a,"willNotShowBanner"),null;J(a,"willShowBanner");var h=zb(b,c);xb(b,h);d.channel=d.channel||"app banner";var l=b.w?h.contentWindow.document:document;if(y()){b.open_app=b.ga;b.append_deeplink_path=
	b.Z;b.make_new_link=b.da;b.deepview_type="banner";a.deepview(d,b);var g=l.getElementById("branch-mobile-action");g&&(g.onclick=function(b){b.preventDefault();a.deepviewCta()})}else l.getElementById("sms-form")?l.getElementById("sms-form").addEventListener("submit",function(c){c.preventDefault();Ab(l,a,b,d)}):h.onload=function(){l=h.contentWindow.document;l.getElementById("sms-form")&&l.getElementById("sms-form").addEventListener("submit",function(c){c.preventDefault();Ab(l,a,b,d)})};var g=tb("margin-top"),
	m=document.body.style.marginTop,r=tb("margin-bottom"),q=document.body.style.marginBottom,F=l.getElementById("branch-banner-close");F&&(F.onclick=function(b){b.preventDefault();J(a,"willCloseBanner");e({},function(){J(a,"didCloseBanner")})});qb(document.body,"branch-banner-is-active");"top"===b.position?document.body.style.marginTop=ub(g):"bottom"===b.position&&(document.body.style.marginBottom=ub(r));b.T?f():setTimeout(f,20);return e};var K,L="top",M="absolute",N="76px",O=!1,Cb=!1,P=[],Db=window.innerHeight,Eb=window.innerWidth;window.innerHeight<window.innerWidth&&(Db=window.innerWidth,Eb=window.innerHeight);var Fb=0,Gb=0,Hb=/<script type="application\/json">((.|\s)*?)<\/script>/,Ib=/<script type="text\/javascript">((.|\s)*?)<\/script>/,Jb=/<style type="text\/css" id="branch-css">((.|\s)*?)<\/style>/,Kb=/#branch-banner-spacer {((.|\s)*?)}/,Lb=/margin-bottom: (.*?);/,Q=null,Mb=null,Nb=!1,R=!1,Ob=!1,S=!1,Pb=!1,Qb="",U=[];
	function Rb(a){if(a=a.match(Hb))return t(a[1])}
	function Sb(){var a=document.createElement("style");a.type="text/css";a.id="branch-iframe-css";Fb=tb("margin-top");var b=+Fb.slice(0,-2);Gb=tb("margin-bottom");var d=+Gb.slice(0,-2),c=+N.slice(0,-2);"top"===L?document.body.style.marginTop=(+c+b).toString()+"px":"bottom"===L&&(document.body.style.marginBottom=(+c+d).toString()+"px");0<P.length&&P.forEach(function(a){var b,c=window.getComputedStyle(a);c&&(b=O&&"fixed"===c.getPropertyValue("position"));b||(a.style.marginTop=N)});"top"===Qb&&Qb!==L&&
	Pb&&U&&0<U.length&&U.forEach(function(a){a.style.marginTop=0});Pb=!1;Qb="";U=[];S=!1;a.innerHTML=Tb();document.head.appendChild(a)}
	function Tb(){var a="",b="";document.body.style.transition="";document.getElementById("branch-banner-iframe")&&(document.getElementById("branch-banner-iframe").style.transition="");Ob||(a="body { -webkit-transition: all 0.375s ease; }\n",document.body.style.transition="all 00.375s ease",b="-webkit-transition: all 0.25s ease; transition: all 00.25s ease;");return(a?a:"")+("#branch-banner-iframe { box-shadow: 0 0 5px rgba(0, 0, 0, .35); width: 1px; min-width:100%; left: 0; right: 0; border: 0; height: "+
	N+"; z-index: 99999; "+b+" }\n#branch-banner-iframe { position: "+M+"; }\n@media only screen and (orientation: landscape) { body { "+("top"===L?"margin-top: ":"margin-bottom: ")+(O?Eb+"px":N)+"; }\n#branch-banner-iframe { height: "+(O?Eb+"px":N)+"; }")}
	function Ub(a){qb(document.body,"branch-banner-is-active");O&&"fixed"===M&&qb(document.body,"branch-banner-no-scroll");setTimeout(function(){"top"===L?a.style.top="0":"bottom"===L&&(a.style.bottom="0");J(Q,"didShowJourney",{banner_id:K});Nb=!0},20)}function Vb(a){var b=7;if(a=a.match(Hb))a=t(a[1])||{},"number"===typeof a.dismissPeriod&&(b=a.dismissPeriod);return-1===b?!0:sb(b)}
	function Wb(a,b,d,c,e){Mb=c;if(d&&c){var f=c.contentWindow.document;Array.prototype.forEach.call(f.querySelectorAll("#branch-mobile-action"),function(a){a.addEventListener("click",function(){J(Q,"didClickJourneyCTA",{banner_id:K});S=!0;d();Xb(c)})});var h=f.querySelectorAll(".branch-banner-continue");Array.prototype.forEach.call(h,function(d){d.addEventListener("click",function(){J(Q,"didClickJourneyContinue",{banner_id:K});S=!0;Xb(c);b.set("hideBanner"+a.id,e,!0)})});h=f.querySelectorAll(".branch-banner-close");
	Array.prototype.forEach.call(h,function(d){d.addEventListener("click",function(){J(Q,"didClickJourneyClose",{banner_id:K});S=!0;Xb(c);b.set("hideBanner"+a.id,e,!0)})})}}
	function Xb(a){if(Ob&&!R){document.body.style.transition="all 00.375s ease";document.getElementById("branch-banner-iframe").style.transition="all 00.25s ease";var b=document.getElementById("branch-iframe-css").innerHTML+"\n";document.getElementById("branch-iframe-css").innerHTML="";document.getElementById("branch-iframe-css").innerHTML=b+"body { -webkit-transition: all 0.375s ease; }\n#branch-banner-iframe { -webkit-transition: all 0.25s ease; }\n"}"top"===L?a.style.top="-"+N:"bottom"===L&&(a.style.bottom=
	"-"+N);J(Q,"willCloseJourney",{banner_id:K});setTimeout(function(){I(a);I(document.getElementById("branch-css"));I(document.getElementById("branch-iframe-css"));I(document.getElementById("branch-journey-cta"));(!R||S)&&P&&0<P.length?P.forEach(function(a){a.style.marginTop=0}):(Pb=R,Qb=L,U=P);"top"===L?document.body.style.marginTop=Fb:"bottom"===L&&(document.body.style.marginBottom=Gb);rb("branch-banner-is-active");rb("branch-banner-no-scroll");J(Q,"didCloseJourney",{banner_id:K});Nb=!1},R?0:270)}
	;var Yb=1;
	function Zb(a,b){J(Q,"willShowJourney",{banner_id:K});var d=b?"OPEN":"GET",c=a,e=Rb(c);e&&e.bannerHeight&&e.position&&e.sticky?(N=e.bannerHeight,L=e.position,M=e.sticky):(c=c.match(Kb))?(L="top",(c=c[1].match(Lb))&&(N=c[1]),M="absolute"):(L="bottom",M="fixed");if(-1!==N.indexOf("vh")||-1!==N.indexOf("%"))c=N.indexOf("vh")?N.slice(0,-2):N.slice(0,-1),N=c/100*Db+"px",100>c?Cb=!0:O=!0;if(c=Rb(a)){var f;b&&c&&c.ctaText&&c.ctaText.has_app?f=c.ctaText.has_app:c&&c.ctaText&&c.ctaText.no_app&&(f=c.ctaText.no_app);
	d=f;P=[];if(c&&c.injectorSelector&&(f=document.querySelectorAll(c.injectorSelector)))for(c=0;c<f.length;c++)P.push(f[c].parentElement)}f=(f=a.match(Jb))?f[1]:void 0;if(c=a.match(Ib))c=c[1],e=document.createElement("script"),e.id="branch-journey-cta",e.innerHTML=c,document.body.appendChild(e);var c=a,e=c.match(Hb),h=c.match(Ib),l=c.match(Jb);e&&(c=c.replace(Hb,""));h&&(c=c.replace(Ib,""));l&&(c=c.replace(Jb,""));a=c;c=document.createElement("iframe");c.src="about:blank";c.style.overflow="hidden";c.scrolling=
	"no";c.id="branch-banner-iframe";c.className="branch-animation";document.body.appendChild(c);e=y();e='<html><head></head><body class="'+("ios"===e||"ipad"===e?"branch-banner-ios":"android"===e?"branch-banner-android":"branch-banner-desktop")+'">'+a+"</body></html>";c.contentWindow.document.open();c.contentWindow.document.write(e);c.contentWindow.document.close();Sb();e=document.createElement("style");e.type="text/css";e.id="branch-css";e.innerHTML=f;f=c.contentWindow.document;f.head.appendChild(e);
	if(Cb||O){var g=f.getElementsByClassName("branch-banner-content")[0];g&&(g.style.height=N)}"top"===L?c.style.top="-"+N:"bottom"===L&&(c.style.bottom="-"+N);try{var g=f.getElementsByClassName("branch-banner-content")[0],m=window.getComputedStyle(g).getPropertyValue("background-color").split(", ");m[3]&&!parseFloat(m[3])&&(c.style.boxShadow="none")}catch(r){}c.contentWindow.document.getElementById("branch-mobile-action").innerHTML=d;Ub(c);return c}
	function $b(a,b,d,c,e,f,h){if(!(document.getElementById("branch-banner")||document.getElementById("branch-banner-iframe")||document.getElementById("branch-banner-container"))){Q=h;var l=null,g=null;d=d||{};d.feature="journeys";d=va(d);(h=document.getElementById("branch-iframe-css"))&&h.parentElement.removeChild(h);var m=document.createElement("div");m.id="branch-banner";document.body.insertBefore(m,null);qb(m,"branch-banner-is-active");if(b.html)Zb(b.html,e);else if(b.url){var r="branch_view_callback__"+
	Yb++;d=encodeURIComponent(Ba(p(d)));h=b.url+"&callback="+r;h+="&_lan="+(Q.ma||Ga());ob(a,h+("&data="+d),{},"GET",{},function(a,d){var h=!1;if(!a&&d){var eb=f?0:Vb(d),kb=window.setTimeout(function(){window[r]=function(){}},5E3);window[r]=function(a){window.clearTimeout(kb);h||(g=a,Wb(b,c,g,l,eb))};l=Zb(d,e);if(null===l){h=!0;return}Wb(b,c,g,l,eb)}document.body.removeChild(m)},!0)}}}
	function ac(a,b){var d=b.b.get("hideBanner"+a.id,!0);if(!0===d||d>Date.now())return!0;b.b.remove("hideBanner"+a.id,!0);return!1}
	function bc(a,b,d,c,e){e.m=!!d.branch_view_enabled;e.b.set("branch_view_enabled",e.m);var f=null,h=null,l=null,g=null,m=null,r=!1,q=!1,F=!1;c&&(f=c.branch_view_id||null,h=c.no_journeys||null,e.ma=c.user_language||Ga(),Ob=c.disable_entry_animation||!1,R=c.disable_exit_animation||!1,q=c.make_new_link||!1,F=c.open_app||!1);(f=f||ua()||null)&&y()&&(r=!0,g={id:f,ua:-1,url:"https://api.branch.io/v1/branchview/"+a+"/"+f+"?_a=audience_rule_id&_t="+b.D});!g&&d.hasOwnProperty("branch_view_data")&&(g=d.branch_view_data,
	l=ac(g,e));!g||l||h?J(e,"willNotShowJourney"):(K=g.id,e.renderQueue(function(){var a=q,c=F,d=e.A||{};d.data||(d.data={});a=a?null:wa(cc(e));d.data=x(Fa(),d.data);d.data=x(ta(H(e.b)||{}),d.data);d.data=a?x({link_click_id:a},d.data):d.data;m=d=x({open_app:c},d);$b(e.N,g,m,e.b,b.has_app,r,e)}))};var V={androidAppIndexingTagsPresent:!1,iosAppIndexingTagsPresent:!1,androidDetailsComplete:!1,iosDetailsComplete:!1},W={};function dc(a){var b;"android"===a&&V.androidDetailsComplete&&(b="android-app://"+W.androidPackageName+"/"+W.androidURL,b=ec(b),fc(b));"ios"===a&&V.iosDetailsComplete&&(b="ios-app://"+W.iosAppId+"/"+W.iosURL,b=ec(b),fc(b))}
	function ec(a){var b={"~channel":"Firebase App Indexing","~feature":"Auto App Indexing",$canonical_url:String(window.location)};if("object"===typeof W.data)for(var d in W.data)W.data.hasOwnProperty(d)&&!b.hasOwnProperty(d)&&(b[d]=W.data[d]);return a+(-1<a.indexOf("?")?"&":"?")+"link_click_id=a-"+btoa(u(b))}function fc(a){var b=document.createElement("link");b.setAttribute("rel","alternate");b.setAttribute("href",a);document.head.appendChild(b)}
	function gc(a){"android"===a&&"string"===typeof W.androidPackageName&&"string"===typeof W.androidURL&&(V.androidDetailsComplete=!0,dc("android"));"ios"===a&&"string"===typeof W.iosAppId&&"string"===typeof W.iosURL&&(V.iosDetailsComplete=!0,dc("ios"))}
	function hc(a){for(var b=document.getElementsByTagName("meta"),d=0;d<b.length;d++){var c=b[d];"ios"===a&&"al:ios:app_store_id"===c.getAttribute("property")&&(W.iosAppId=c.getAttribute("content"));"ios"===a&&"al:ios:url"===c.getAttribute("property")&&(W.iosURL=c.getAttribute("content").replace("://","/"));"android"===a&&"al:android:package"===c.getAttribute("property")&&(W.androidPackageName=c.getAttribute("content"));"android"===a&&"al:android:url"===c.getAttribute("property")&&(W.androidURL=c.getAttribute("content").replace("://",
	"/"))}gc(a)};var ic;
	function X(a,b,d){return function(){var c=this,e,f,h=arguments[arguments.length-1];a&&"function"===typeof h?(e=Array.prototype.slice.call(arguments,0,arguments.length-1)||[],f=h):(f=function(){},e=Array.prototype.slice.call(arguments));c.X(function(l){function g(b,d){try{if(b&&!a)throw b;1===a?f(b):2===a&&f(b,d)}finally{l()}}if(!d){if(1===c.j)return g(Error(v("Branch SDK initialization pending and a Branch method was called outside of the queue order")),null);if(2===c.j)return g(Error(v("Branch SDK initialization failed, so further methods cannot be called",c.h,
	c.l)),null);if(0===c.j||!c.j)return g(Error(v("Branch SDK not initialized")),null)}e.unshift(g);b.apply(c,e)})}}function Y(){if(!(this instanceof Y))return ic||(ic=new Y),ic;this.X=ra();this.b=new E(["session","cookie","pojo"]);this.N=new ib;this.g=[];this.P="web2.25.0";this.h=this.j=0;this.l=null}
	Y.prototype.c=function(a,b,d){this.O&&(b.app_id=this.O);this.i&&(b.branch_key=this.i);(a.a&&a.a.session_id||a.f&&a.f.session_id)&&this.H&&(b.session_id=this.H);(a.a&&a.a.identity_id||a.f&&a.f.identity_id)&&this.v&&(b.identity_id=this.v);(a.a&&a.a.link_click_id||a.f&&a.f.link_click_id)&&this.V&&(b.link_click_id=this.V);(a.a&&a.a.sdk||a.f&&a.f.sdk)&&this.P&&(b.sdk=this.P);(a.a&&a.a.browser_fingerprint_id||a.f&&a.f.browser_fingerprint_id)&&this.D&&(b.browser_fingerprint_id=this.D);return pb(this.N,a,
	b,this.b,function(a,b){d(a,b)})};function cc(a){var b=H(a.b);return(b=b&&b.referring_link)?b:(a=a.b.get("click_id"))?"https://bnc.lt/c/"+a:null}function J(a,b,d){for(var c=0;c<a.g.length;c++)a.g[c].event&&a.g[c].event!==b||a.g[c].listener(b,d)}
	Y.prototype.init=X(2,function(a,b,d){function c(){var a,b;"undefined"!==typeof document.hidden?(a="hidden",b="visibilitychange"):"undefined"!==typeof document.mozHidden?(a="mozHidden",b="mozvisibilitychange"):"undefined"!==typeof document.msHidden?(a="msHidden",b="msvisibilitychange"):"undefined"!==typeof document.webkitHidden&&(a="webkitHidden",b="webkitvisibilitychange");b&&document.addEventListener(b,function(){document[a]||(h(null),"function"===typeof g.C&&g.C())},!1)}function e(c,e){e&&(e=l(e),
	gb(g.b,e,F),g.j=3,e.data_parsed=e.data&&0!==e.data.length?t(e.data):{});if(c)return g.j=2,g.h||(g.h=1,g.l=c.message),a(c,e&&sa(e));g.c(ab,{event:"pageview",metadata:{url:r,user_agent:navigator.userAgent,language:navigator.language,page_has_microdata:f(),screen_width:screen.width||-1,screen_height:screen.height||-1,og_data:{$og_title:w("title"),$og_description:w("description"),$og_image_url:w("image"),$og_video:w("video")},hosted_deeplink_data:Fa()},initial_referrer:document.referrer},function(c,f){c||
	"object"!==typeof f||bc(b,e,f,d,g);try{a(c,e&&sa(e))}catch(nc){}finally{g.renderFinalize()}})}function f(){var a=!1;try{a=!!(document.querySelectorAll('*[itemtype^="http://schema.org"]')||[]).length}catch(kb){a=!1}return a}function h(a){var b={sdk:"2.25.0",branch_key:g.i},c=H(g.b)||{},d=H(g.b,!0)||{};d.browser_fingerprint_id&&(b._t=d.browser_fingerprint_id);ya()||g.c(Ma,b,function(a,b){a&&(g.h=3,g.l=a.message);b&&(c.browser_fingerprint_id=b)});g.c($a,{browser_fingerprint_id:c.browser_fingerprint_id},
	function(b,d){b&&(g.h=4,g.l=b.message);b||!d||c.has_app||(c.has_app=!0,hb(g.b,c),J(g,"didDownloadApp"));a&&a(null,c)})}function l(a){a.link_click_id&&(g.V=a.link_click_id.toString());a.session_id&&(g.H=a.session_id.toString());a.identity_id&&(g.v=a.identity_id.toString());a.link&&(g.W=a.link);if(a.referring_link){var b=a.referring_link;a.referring_link=b?"http"!==b.substring(0,4)?"https://bnc.lt"+b:b:null}!a.click_id&&a.referring_link&&(a.click_id=wa(a.referring_link));g.D=a.browser_fingerprint_id;
	return a}var g=this;g.j=1;-1<b.indexOf("key_")?g.i=b:g.O=b;d=d&&"function"===typeof d?{}:d;var m=H(g.b),r=d&&d.url||String(window.location),q=(d&&"undefined"!==typeof d.branch_match_id&&null!==d.branch_match_id?d.branch_match_id:null)||za()||xa(),F=!m||!m.identity_id;g.m=!!g.b.get("branch_view_enabled");if(m&&m.session_id&&!q)hb(g.b,{data:""}),c(),h(e);else{var m={sdk:"2.25.0",branch_key:g.i},T=H(g.b,!0)||{};T.browser_fingerprint_id&&(m._t=T.browser_fingerprint_id);ya()?g.c(La,{link_identifier:q,
	browser_fingerprint_id:q||T.browser_fingerprint_id,alternative_browser_fingerprint_id:T.browser_fingerprint_id,options:d,initial_referrer:document.referrer},function(a,b){a&&(g.h=2,g.l=a.message);a||"object"!==typeof b||(g.m=!!b.branch_view_enabled,g.b.set("branch_view_enabled",g.m),q&&(b.click_id=q));c();e(a,b)}):g.c(Ma,m,function(a,b){if(a)return g.h=3,g.l=a.message,e(a,null);g.c(La,{link_identifier:q,browser_fingerprint_id:q||b,alternative_browser_fingerprint_id:T.browser_fingerprint_id,options:d,
	initial_referrer:document.referrer},function(a,b){a&&(g.h=2,g.l=a.message);a||"object"!==typeof b||(g.m=!!b.branch_view_enabled,g.b.set("branch_view_enabled",g.m),q&&(b.click_id=q));c();e(a,b)})})}},!0);Y.prototype.renderQueue=X(0,function(a,b){this.Y?b():(this.o=this.o||[],this.o.push(b));a(null,null)});Y.prototype.renderFinalize=X(2,function(a){this.o&&0<this.o.length&&(this.o.forEach(function(a){a.call(this)}),delete this.o);this.Y=!0;a(null,null)});
	Y.prototype.data=X(2,function(a){var b=sa(H(this.b));b.referring_link=cc(this);b.data_parsed=b.data&&0!==b.data.length?t(b.data):{};a(null,b)});Y.prototype.first=X(2,function(a){a(null,sa(H(this.b,!0)))});Y.prototype.setIdentity=X(2,function(a,b){var d=this;this.c(Ta,{identity:b},function(c,e){c&&a(c);e=e||{};d.v=e.identity_id?e.identity_id.toString():null;d.W=e.link;d.S=b;e.referring_data_parsed=e.referring_data?t(e.referring_data):null;hb(d.b,e);a(null,e)})});
	Y.prototype.logout=X(1,function(a){var b=this;this.c(Sa,{},function(d,c){d&&a(d);c=c||{};c={data_parsed:null,data:null,referring_link:null,click_id:null,link_click_id:null,identity:null,session_id:c.session_id,identity_id:c.identity_id,link:c.link,device_fingerprint_id:b.ta||null};b.W=c.link;b.H=c.session_id;b.v=c.identity_id;b.S=c.identity;hb(b.b,c);a(null)})});
	Y.prototype.track=X(1,function(a,b,d,c){var e=this;d=d||{};c=c||{};e.c(ab,{event:b,metadata:x({url:document.URL,user_agent:navigator.userAgent,language:navigator.language},d),initial_referrer:document.referrer},function(d,h){d||"object"!==typeof h||"pageview"!==b||bc(e.i,H(e.b),h,c,e);"function"===typeof a&&a.apply(this,arguments)})});Y.prototype.link=X(2,function(a,b){this.c(Ya,va(b),function(b,c){a(b,c&&c.url)})});
	Y.prototype.sendSMS=X(1,function(a,b,d,c){function e(c){f.c(Oa,{link_url:c,phone:b},function(b){a(b||null)})}var f=this;if("function"===typeof c)c={};else if("undefined"===typeof c||null===c)c={};c.make_new_link=c.make_new_link||!1;d.channel&&"app banner"!==d.channel||(d.channel="sms");var h=cc(f);h&&!c.make_new_link?e(h.substring(h.lastIndexOf("/")+1,h.length)):f.c(Ya,va(d),function(b,c){if(b)return a(b);var d=c.url;/(bnc.lt\/|app\.link\/)/.test(d)||(d="https://bnc.lt/"+Da(d));f.c(Na,{link_url:d,
	click:"click"},function(b,c){if(b)return a(b);e(c.click_id)})})});
	Y.prototype.deepview=X(1,function(a,b,d){var c=this;d||(d={});d.deepview_type="undefined"===typeof d.deepview_type?"deepview":"banner";b.data=x(Fa(),b.data);var e="https://bnc.lt/a/"+c.i,f=!0,h;for(h in b)b.hasOwnProperty(h)&&"data"!==h&&(f?(e+="?",f=!1):e+="&",e+=encodeURIComponent(h)+"="+encodeURIComponent(b[h]));b=va(b);if(d.open_app||null===d.open_app||"undefined"===typeof d.open_app)b.open_app=!0;b.append_deeplink_path=!!d.append_deeplink_path;b.deepview_type=d.deepview_type;(f=cc(c))&&!d.make_new_link&&
	(b.link_click_id=f.substring(f.lastIndexOf("/")+1,f.length));b.banner_options=d;c.C=ja(this.c,c,Za,b,function(b,d){if(b)return c.B=function(){window.location=e},a(b);"function"===typeof d&&(c.B=d);a(null)});c.C()});Y.prototype.deepviewCta=X(1,function(a){if("undefined"===typeof this.B)throw Error("Cannot call Deepview CTA, please call branch.deepview() first.");window.event&&(window.event.preventDefault?window.event.preventDefault():window.event.returnValue=!1);J(this,"didDeepviewCTA");this.B();a()});
	Y.prototype.referrals=X(2,function(a){this.c(Ua,{},a)});Y.prototype.getCode=X(2,function(a,b){b.type="credit";b.creation_source=b.creation_source||2;this.c(Pa,b,a)});Y.prototype.validateCode=X(1,function(a,b){this.c(Qa,{code:b},a)});Y.prototype.applyCode=X(1,function(a,b){this.c(Ra,{code:b},a)});Y.prototype.credits=X(2,function(a){this.c(Wa,{branch_key:this.i,identity:this.S},a)});Y.prototype.creditHistory=X(2,function(a,b){this.c(Va,b||{},a)});
	Y.prototype.redeem=X(1,function(a,b,d){this.c(Xa,{amount:b,bucket:d},function(b){a(b||null)})});Y.prototype.addListener=function(a,b){"function"===typeof a&&void 0===b&&(b=a);b&&this.g.push({listener:b,event:a||null})};Y.prototype.removeListener=function(a){a&&(this.g=this.g.filter(function(b){if(b.listener!==a)return b}))};function jc(a,b,d){d=d||{};try{a.A=t(u(d))}finally{a.A=a.A||{}}b()}Y.prototype.setBranchViewData=X(1,function(a,b){jc.call(null,this,a,b)});
	Y.prototype.closeJourney=X(1,function(a){var b=this;b.renderQueue(function(){if(Mb&&Nb)J(b,"didCallJourneyClose",{banner_id:K}),Xb(Mb);else return a("Journey already dismissed.")});a()});
	Y.prototype.banner=X(1,function(a,b,d){d=d||{};jc.call(null,this,function(){},d);"undefined"===typeof b.showAgain&&"undefined"!==typeof b.forgetHide&&(b.showAgain=b.forgetHide);var c={icon:A(b.icon)||"",title:A(b.title)||"",description:A(b.description)||"",G:"number"===typeof b.reviewCount&&0<b.reviewCount?Math.floor(b.reviewCount):null,u:"number"===typeof b.rating&&5>=b.rating&&0<b.rating?Math.round(2*b.rating)/2:null,fa:A(b.openAppButtonText)||"View in app",ca:A(b.downloadAppButtonText)||"Download App",
	ja:A(b.sendLinkText)||"Send Link",ha:A(b.phonePreviewText)||"(999) 999-9999",w:"undefined"===typeof b.iframe?!0:b.iframe,M:"undefined"===typeof b.showiOS?!0:b.showiOS,la:"undefined"===typeof b.showiPad?!0:b.showiPad,I:"undefined"===typeof b.showAndroid?!0:b.showAndroid,J:"undefined"===typeof b.showBlackberry?!0:b.showBlackberry,L:"undefined"===typeof b.showWindowsPhone?!0:b.showWindowsPhone,K:"undefined"===typeof b.showKindle?!0:b.showKindle,ka:"undefined"===typeof b.showDesktop?!0:b.showDesktop,
	ba:!!b.disableHide,F:"number"===typeof b.forgetHide?b.forgetHide:!!b.forgetHide,ia:"undefined"===typeof b.respectDNT?!1:b.respectDNT,position:b.position||"top",$:b.customCSS||"",ea:"undefined"===typeof b.mobileSticky?!1:b.mobileSticky,aa:"undefined"===typeof b.desktopSticky?!0:b.desktopSticky,pa:b.buttonBorderColor||"",na:b.buttonBackgroundColor||"",ra:b.buttonFontColor||"",qa:b.buttonBorderColorHover||"",oa:b.buttonBackgroundColorHover||"",sa:b.buttonFontColorHover||"",da:!!b.make_new_link,ga:!!b.open_app,
	T:!!b.immediate,Z:!!b.append_deeplink_path};"undefined"!==typeof b.showMobile&&(c.M=b.showMobile,c.I=b.showMobile,c.J=b.showMobile,c.L=b.showMobile,c.K=b.showMobile);d.data=x(Fa(),d.data);var e=this;e.renderQueue(function(){e.R=Bb(e,c,d,e.b)});a()});Y.prototype.closeBanner=X(0,function(a){var b=this;b.renderQueue(function(){b.R&&(J(b,"willCloseBanner"),b.R(function(){J(b,"didCloseBanner")}))});a()});
	Y.prototype.autoAppIndex=X(1,function(a,b){b=b||{};var d=document.getElementsByTagName("link"),c=d.length;if(c)for(var e=0;e<c;e++){var f=d[e],h=f.href;h&&(h.includes("ios-app")&&(V.iosAppIndexingTagsPresent=!0,f.setAttribute("href",ec(h))),h.includes("android-app")&&(V.androidAppIndexingTagsPresent=!0,f.setAttribute("href",ec(h))))}W=b;V.androidAppIndexingTagsPresent||(gc("android"),V.androidDetailsComplete||hc("android"));V.iosAppIndexingTagsPresent||(gc("ios"),V.iosDetailsComplete||hc("ios"));
	V.iosDetailsComplete||V.androidDetailsComplete?a(null):a("Firebase App Indexing tags were not added to your webpage. Please check your configuration.")});Y.prototype.trackCommerceEvent=X(1,function(a,b,d,c){var e=this;e.renderQueue(function(){var f=Ka(b,d);if(f)return a(Error(f));e.c(bb,{event:b,metadata:x({url:document.URL,user_agent:navigator.userAgent,language:navigator.language},c||{}),initial_referrer:document.referrer,commerce_data:d},function(b){a(b||null)})});a()});var Z=new Y;if(window.branch&&window.branch._q)for(var kc=window.branch._q,lc=0;lc<kc.length;lc++){var mc=kc[lc];Z[mc[0]].apply(Z,mc[1])} true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return Z}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"===typeof exports&&(module.exports=Z);window&&(window.branch=Z);})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.cardNumber = void 0;
	var luhn10 = __webpack_require__(1259);
	var getCardTypes = __webpack_require__(304);
	function verification(card, isPotentiallyValid, isValid) {
	    return {
	        card: card,
	        isPotentiallyValid: isPotentiallyValid,
	        isValid: isValid,
	    };
	}
	function cardNumber(value, options) {
	    if (options === void 0) { options = {}; }
	    var isPotentiallyValid, isValid, maxLength;
	    if (typeof value !== "string" && typeof value !== "number") {
	        return verification(null, false, false);
	    }
	    var testCardValue = String(value).replace(/-|\s/g, "");
	    if (!/^\d*$/.test(testCardValue)) {
	        return verification(null, false, false);
	    }
	    var potentialTypes = getCardTypes(testCardValue);
	    if (potentialTypes.length === 0) {
	        return verification(null, false, false);
	    }
	    else if (potentialTypes.length !== 1) {
	        return verification(null, true, false);
	    }
	    var cardType = potentialTypes[0];
	    if (options.maxLength && testCardValue.length > options.maxLength) {
	        return verification(cardType, false, false);
	    }
	    if (cardType.type === getCardTypes.types.UNIONPAY &&
	        options.luhnValidateUnionPay !== true) {
	        isValid = true;
	    }
	    else {
	        isValid = luhn10(testCardValue);
	    }
	    maxLength = Math.max.apply(null, cardType.lengths);
	    if (options.maxLength) {
	        maxLength = Math.min(options.maxLength, maxLength);
	    }
	    for (var i = 0; i < cardType.lengths.length; i++) {
	        if (cardType.lengths[i] === testCardValue.length) {
	            isPotentiallyValid = testCardValue.length < maxLength || isValid;
	            return verification(cardType, isPotentiallyValid, isValid);
	        }
	    }
	    return verification(cardType, testCardValue.length < maxLength, false);
	}
	exports.cardNumber = cardNumber;


/***/ }),
/* 1253 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.cardholderName = void 0;
	var CARD_NUMBER_REGEX = /^[\d\s-]*$/;
	var MAX_LENGTH = 255;
	function verification(isValid, isPotentiallyValid) {
	    return { isValid: isValid, isPotentiallyValid: isPotentiallyValid };
	}
	function cardholderName(value) {
	    if (typeof value !== "string") {
	        return verification(false, false);
	    }
	    if (value.length === 0) {
	        return verification(false, true);
	    }
	    if (value.length > MAX_LENGTH) {
	        return verification(false, false);
	    }
	    if (CARD_NUMBER_REGEX.test(value)) {
	        return verification(false, true);
	    }
	    return verification(true, true);
	}
	exports.cardholderName = cardholderName;


/***/ }),
/* 1254 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.cvv = void 0;
	var DEFAULT_LENGTH = 3;
	function includes(array, thing) {
	    for (var i = 0; i < array.length; i++) {
	        if (thing === array[i]) {
	            return true;
	        }
	    }
	    return false;
	}
	function max(array) {
	    var maximum = DEFAULT_LENGTH;
	    var i = 0;
	    for (; i < array.length; i++) {
	        maximum = array[i] > maximum ? array[i] : maximum;
	    }
	    return maximum;
	}
	function verification(isValid, isPotentiallyValid) {
	    return { isValid: isValid, isPotentiallyValid: isPotentiallyValid };
	}
	function cvv(value, maxLength) {
	    if (maxLength === void 0) { maxLength = DEFAULT_LENGTH; }
	    maxLength = maxLength instanceof Array ? maxLength : [maxLength];
	    if (typeof value !== "string") {
	        return verification(false, false);
	    }
	    if (!/^\d*$/.test(value)) {
	        return verification(false, false);
	    }
	    if (includes(maxLength, value.length)) {
	        return verification(true, true);
	    }
	    if (value.length < Math.min.apply(null, maxLength)) {
	        return verification(false, true);
	    }
	    if (value.length > max(maxLength)) {
	        return verification(false, false);
	    }
	    return verification(true, true);
	}
	exports.cvv = cvv;


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.expirationDate = void 0;
	var parse_date_1 = __webpack_require__(1258);
	var expiration_month_1 = __webpack_require__(476);
	var expiration_year_1 = __webpack_require__(302);
	function verification(isValid, isPotentiallyValid, month, year) {
	    return {
	        isValid: isValid,
	        isPotentiallyValid: isPotentiallyValid,
	        month: month,
	        year: year,
	    };
	}
	function expirationDate(value, maxElapsedYear) {
	    var date;
	    if (typeof value === "string") {
	        value = value.replace(/^(\d\d) (\d\d(\d\d)?)$/, "$1/$2");
	        date = parse_date_1.parseDate(String(value));
	    }
	    else if (value !== null && typeof value === "object") {
	        var fullDate = __assign({}, value);
	        date = {
	            month: String(fullDate.month),
	            year: String(fullDate.year),
	        };
	    }
	    else {
	        return verification(false, false, null, null);
	    }
	    var monthValid = expiration_month_1.expirationMonth(date.month);
	    var yearValid = expiration_year_1.expirationYear(date.year, maxElapsedYear);
	    if (monthValid.isValid) {
	        if (yearValid.isCurrentYear) {
	            var isValidForThisYear = monthValid.isValidForThisYear;
	            return verification(isValidForThisYear, isValidForThisYear, date.month, date.year);
	        }
	        if (yearValid.isValid) {
	            return verification(true, true, date.month, date.year);
	        }
	    }
	    if (monthValid.isPotentiallyValid && yearValid.isPotentiallyValid) {
	        return verification(false, true, null, null);
	    }
	    return verification(false, false, null, null);
	}
	exports.expirationDate = expirationDate;


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (this && this.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var creditCardType = __importStar(__webpack_require__(304));
	var cardholder_name_1 = __webpack_require__(1253);
	var card_number_1 = __webpack_require__(1252);
	var expiration_date_1 = __webpack_require__(1255);
	var expiration_month_1 = __webpack_require__(476);
	var expiration_year_1 = __webpack_require__(302);
	var cvv_1 = __webpack_require__(1254);
	var postal_code_1 = __webpack_require__(1260);
	var cardValidator = {
	    creditCardType: creditCardType,
	    cardholderName: cardholder_name_1.cardholderName,
	    number: card_number_1.cardNumber,
	    expirationDate: expiration_date_1.expirationDate,
	    expirationMonth: expiration_month_1.expirationMonth,
	    expirationYear: expiration_year_1.expirationYear,
	    cvv: cvv_1.cvv,
	    postalCode: postal_code_1.postalCode,
	};
	module.exports = cardValidator;


/***/ }),
/* 1257 */
/***/ (function(module, exports) {

	"use strict";
	// Polyfill taken from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray#Polyfill>.
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isArray = void 0;
	exports.isArray = Array.isArray ||
	    function (arg) {
	        return Object.prototype.toString.call(arg) === "[object Array]";
	    };


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.parseDate = void 0;
	var expiration_year_1 = __webpack_require__(302);
	var is_array_1 = __webpack_require__(1257);
	function getNumberOfMonthDigitsInDateString(dateString) {
	    var firstCharacter = Number(dateString[0]);
	    var assumedYear;
	    /*
	      if the first character in the string starts with `0`,
	      we know that the month will be 2 digits.
	  
	      '0122' => {month: '01', year: '22'}
	    */
	    if (firstCharacter === 0) {
	        return 2;
	    }
	    /*
	      if the first character in the string starts with
	      number greater than 1, it must be a 1 digit month
	  
	      '322' => {month: '3', year: '22'}
	    */
	    if (firstCharacter > 1) {
	        return 1;
	    }
	    /*
	      if the first 2 characters make up a number between
	      13-19, we know that the month portion must be 1
	  
	      '139' => {month: '1', year: '39'}
	    */
	    if (firstCharacter === 1 && Number(dateString[1]) > 2) {
	        return 1;
	    }
	    /*
	      if the first 2 characters make up a number between
	      10-12, we check if the year portion would be considered
	      valid if we assumed that the month was 1. If it is
	      not potentially valid, we assume the month must have
	      2 digits.
	  
	      '109' => {month: '10', year: '9'}
	      '120' => {month: '1', year: '20'} // when checked in the year 2019
	      '120' => {month: '12', year: '0'} // when checked in the year 2021
	    */
	    if (firstCharacter === 1) {
	        assumedYear = dateString.substr(1);
	        return expiration_year_1.expirationYear(assumedYear).isPotentiallyValid ? 1 : 2;
	    }
	    /*
	      If the length of the value is exactly 5 characters,
	      we assume a full year was passed in, meaning the remaining
	      single leading digit must be the month value.
	  
	      '12202' => {month: '1', year: '2202'}
	    */
	    if (dateString.length === 5) {
	        return 1;
	    }
	    /*
	      If the length of the value is more than five characters,
	      we assume a full year was passed in addition to the month
	      and therefore the month portion must be 2 digits.
	  
	      '112020' => {month: '11', year: '2020'}
	    */
	    if (dateString.length > 5) {
	        return 2;
	    }
	    /*
	      By default, the month value is the first value
	    */
	    return 1;
	}
	function parseDate(datestring) {
	    var date;
	    if (/^\d{4}-\d{1,2}$/.test(datestring)) {
	        date = datestring.split("-").reverse();
	    }
	    else if (/\//.test(datestring)) {
	        date = datestring.split(/\s*\/\s*/g);
	    }
	    else if (/\s/.test(datestring)) {
	        date = datestring.split(/ +/g);
	    }
	    if (is_array_1.isArray(date)) {
	        return {
	            month: date[0] || "",
	            year: date.slice(1).join(),
	        };
	    }
	    var numberOfDigitsInMonth = getNumberOfMonthDigitsInDateString(datestring);
	    var month = datestring.substr(0, numberOfDigitsInMonth);
	    return {
	        month: month,
	        year: datestring.substr(month.length),
	    };
	}
	exports.parseDate = parseDate;


/***/ }),
/* 1259 */
/***/ (function(module, exports) {

	/* eslint-disable */
	/*
	 * Luhn algorithm implementation in JavaScript
	 * Copyright (c) 2009 Nicholas C. Zakas
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 */
	"use strict";
	function luhn10(identifier) {
	    var sum = 0;
	    var alt = false;
	    var i = identifier.length - 1;
	    var num;
	    while (i >= 0) {
	        num = parseInt(identifier.charAt(i), 10);
	        if (alt) {
	            num *= 2;
	            if (num > 9) {
	                num = (num % 10) + 1; // eslint-disable-line no-extra-parens
	            }
	        }
	        alt = !alt;
	        sum += num;
	        i--;
	    }
	    return sum % 10 === 0;
	}
	module.exports = luhn10;


/***/ }),
/* 1260 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.postalCode = void 0;
	var DEFAULT_MIN_POSTAL_CODE_LENGTH = 3;
	function verification(isValid, isPotentiallyValid) {
	    return { isValid: isValid, isPotentiallyValid: isPotentiallyValid };
	}
	function postalCode(value, options) {
	    if (options === void 0) { options = {}; }
	    var minLength = options.minLength || DEFAULT_MIN_POSTAL_CODE_LENGTH;
	    if (typeof value !== "string") {
	        return verification(false, false);
	    }
	    else if (value.length < minLength) {
	        return verification(false, true);
	    }
	    return verification(true, true);
	}
	exports.postalCode = postalCode;


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var type;
	try {
	  type = __webpack_require__(86);
	} catch (_) {
	  type = __webpack_require__(86);
	}
	
	/**
	 * Module exports.
	 */
	
	module.exports = clone;
	
	/**
	 * Clones objects.
	 *
	 * @param {Mixed} any object
	 * @api public
	 */
	
	function clone(obj){
	  switch (type(obj)) {
	    case 'object':
	      var copy = {};
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          copy[key] = clone(obj[key]);
	        }
	      }
	      return copy;
	
	    case 'array':
	      var copy = new Array(obj.length);
	      for (var i = 0, l = obj.length; i < l; i++) {
	        copy[i] = clone(obj[i]);
	      }
	      return copy;
	
	    case 'regexp':
	      // from millermedeiros/amd-utils - MIT
	      var flags = '';
	      flags += obj.multiline ? 'm' : '';
	      flags += obj.global ? 'g' : '';
	      flags += obj.ignoreCase ? 'i' : '';
	      return new RegExp(obj.source, flags);
	
	    case 'date':
	      return new Date(obj.getTime());
	
	    default: // string, number, boolean, …
	      return obj;
	  }
	}


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var debug = __webpack_require__(305)('cookie');
	
	/**
	 * Set or get cookie `name` with `value` and `options` object.
	 *
	 * @param {String} name
	 * @param {String} value
	 * @param {Object} options
	 * @return {Mixed}
	 * @api public
	 */
	
	module.exports = function(name, value, options){
	  switch (arguments.length) {
	    case 3:
	    case 2:
	      return set(name, value, options);
	    case 1:
	      return get(name);
	    default:
	      return all();
	  }
	};
	
	/**
	 * Set cookie `name` to `value`.
	 *
	 * @param {String} name
	 * @param {String} value
	 * @param {Object} options
	 * @api private
	 */
	
	function set(name, value, options) {
	  options = options || {};
	  var str = encode(name) + '=' + encode(value);
	
	  if (null == value) options.maxage = -1;
	
	  if (options.maxage) {
	    options.expires = new Date(+new Date + options.maxage);
	  }
	
	  if (options.path) str += '; path=' + options.path;
	  if (options.domain) str += '; domain=' + options.domain;
	  if (options.expires) str += '; expires=' + options.expires.toUTCString();
	  if (options.secure) str += '; secure';
	
	  document.cookie = str;
	}
	
	/**
	 * Return all cookies.
	 *
	 * @return {Object}
	 * @api private
	 */
	
	function all() {
	  var str;
	  try {
	    str = document.cookie;
	  } catch (err) {
	    if (typeof console !== 'undefined' && typeof console.error === 'function') {
	      console.error(err.stack || err);
	    }
	    return {};
	  }
	  return parse(str);
	}
	
	/**
	 * Get cookie `name`.
	 *
	 * @param {String} name
	 * @return {String}
	 * @api private
	 */
	
	function get(name) {
	  return all()[name];
	}
	
	/**
	 * Parse cookie `str`.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parse(str) {
	  var obj = {};
	  var pairs = str.split(/ *; */);
	  var pair;
	  if ('' == pairs[0]) return obj;
	  for (var i = 0; i < pairs.length; ++i) {
	    pair = pairs[i].split('=');
	    obj[decode(pair[0])] = decode(pair[1]);
	  }
	  return obj;
	}
	
	/**
	 * Encode.
	 */
	
	function encode(value){
	  try {
	    return encodeURIComponent(value);
	  } catch (e) {
	    debug('error `encode(%o)` - %o', value, e)
	  }
	}
	
	/**
	 * Decode.
	 */
	
	function decode(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    debug('error `decode(%o)` - %o', value, e)
	  }
	}


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	try {
	  var type = __webpack_require__(478);
	} catch (err) {
	  var type = __webpack_require__(478);
	}
	
	var toFunction = __webpack_require__(1815);
	
	/**
	 * HOP reference.
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Iterate the given `obj` and invoke `fn(val, i)`
	 * in optional context `ctx`.
	 *
	 * @param {String|Array|Object} obj
	 * @param {Function} fn
	 * @param {Object} [ctx]
	 * @api public
	 */
	
	module.exports = function(obj, fn, ctx){
	  fn = toFunction(fn);
	  ctx = ctx || this;
	  switch (type(obj)) {
	    case 'array':
	      return array(obj, fn, ctx);
	    case 'object':
	      if ('number' == typeof obj.length) return array(obj, fn, ctx);
	      return object(obj, fn, ctx);
	    case 'string':
	      return string(obj, fn, ctx);
	  }
	};
	
	/**
	 * Iterate string chars.
	 *
	 * @param {String} obj
	 * @param {Function} fn
	 * @param {Object} ctx
	 * @api private
	 */
	
	function string(obj, fn, ctx) {
	  for (var i = 0; i < obj.length; ++i) {
	    fn.call(ctx, obj.charAt(i), i);
	  }
	}
	
	/**
	 * Iterate object keys.
	 *
	 * @param {Object} obj
	 * @param {Function} fn
	 * @param {Object} ctx
	 * @api private
	 */
	
	function object(obj, fn, ctx) {
	  for (var key in obj) {
	    if (has.call(obj, key)) {
	      fn.call(ctx, key, obj[key]);
	    }
	  }
	}
	
	/**
	 * Iterate array-ish.
	 *
	 * @param {Array|Object} obj
	 * @param {Function} fn
	 * @param {Object} ctx
	 * @api private
	 */
	
	function array(obj, fn, ctx) {
	  for (var i = 0; i < obj.length; ++i) {
	    fn.call(ctx, obj[i], i);
	  }
	}


/***/ }),
/* 1264 */
/***/ (function(module, exports) {

	var bind = window.addEventListener ? 'addEventListener' : 'attachEvent',
	    unbind = window.removeEventListener ? 'removeEventListener' : 'detachEvent',
	    prefix = bind !== 'addEventListener' ? 'on' : '';
	
	/**
	 * Bind `el` event `type` to `fn`.
	 *
	 * @param {Element} el
	 * @param {String} type
	 * @param {Function} fn
	 * @param {Boolean} capture
	 * @return {Function}
	 * @api public
	 */
	
	exports.bind = function(el, type, fn, capture){
	  el[bind](prefix + type, fn, capture || false);
	  return fn;
	};
	
	/**
	 * Unbind `el` event `type`'s callback `fn`.
	 *
	 * @param {Element} el
	 * @param {String} type
	 * @param {Function} fn
	 * @param {Boolean} capture
	 * @return {Function}
	 * @api public
	 */
	
	exports.unbind = function(el, type, fn, capture){
	  el[unbind](prefix + type, fn, capture || false);
	  return fn;
	};

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var trim = __webpack_require__(814);
	var type = __webpack_require__(1267);
	
	var pattern = /(\w+)\[(\d+)\]/
	
	/**
	 * Safely encode the given string
	 * 
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	var encode = function(str) {
	  try {
	    return encodeURIComponent(str);
	  } catch (e) {
	    return str;
	  }
	};
	
	/**
	 * Safely decode the string
	 * 
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	var decode = function(str) {
	  try {
	    return decodeURIComponent(str.replace(/\+/g, ' '));
	  } catch (e) {
	    return str;
	  }
	}
	
	/**
	 * Parse the given query `str`.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api public
	 */
	
	exports.parse = function(str){
	  if ('string' != typeof str) return {};
	
	  str = trim(str);
	  if ('' == str) return {};
	  if ('?' == str.charAt(0)) str = str.slice(1);
	
	  var obj = {};
	  var pairs = str.split('&');
	  for (var i = 0; i < pairs.length; i++) {
	    var parts = pairs[i].split('=');
	    var key = decode(parts[0]);
	    var m;
	
	    if (m = pattern.exec(key)) {
	      obj[m[1]] = obj[m[1]] || [];
	      obj[m[1]][m[2]] = decode(parts[1]);
	      continue;
	    }
	
	    obj[parts[0]] = null == parts[1]
	      ? ''
	      : decode(parts[1]);
	  }
	
	  return obj;
	};
	
	/**
	 * Stringify the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api public
	 */
	
	exports.stringify = function(obj){
	  if (!obj) return '';
	  var pairs = [];
	
	  for (var key in obj) {
	    var value = obj[key];
	
	    if ('array' == type(value)) {
	      for (var i = 0; i < value.length; ++i) {
	        pairs.push(encode(key + '[' + i + ']') + '=' + encode(value[i]));
	      }
	      continue;
	    }
	
	    pairs.push(encode(key) + '=' + encode(obj[key]));
	  }
	
	  return pairs.join('&');
	};


/***/ }),
/* 1267 */
/***/ (function(module, exports) {

	/**
	 * toString ref.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Return the type of `val`.
	 *
	 * @param {Mixed} val
	 * @return {String}
	 * @api public
	 */
	
	module.exports = function(val){
	  switch (toString.call(val)) {
	    case '[object Date]': return 'date';
	    case '[object RegExp]': return 'regexp';
	    case '[object Arguments]': return 'arguments';
	    case '[object Array]': return 'array';
	    case '[object Error]': return 'error';
	  }
	
	  if (val === null) return 'null';
	  if (val === undefined) return 'undefined';
	  if (val !== val) return 'nan';
	  if (val && val.nodeType === 1) return 'element';
	
	  val = val.valueOf
	    ? val.valueOf()
	    : Object.prototype.valueOf.apply(val)
	
	  return typeof val;
	};


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.addMatchingCardsToResults = void 0;
	var clone_1 = __webpack_require__(481);
	var matches_1 = __webpack_require__(1272);
	function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
	    var i, patternLength;
	    for (i = 0; i < cardConfiguration.patterns.length; i++) {
	        var pattern = cardConfiguration.patterns[i];
	        if (!matches_1.matches(cardNumber, pattern)) {
	            continue;
	        }
	        var clonedCardConfiguration = clone_1.clone(cardConfiguration);
	        if (Array.isArray(pattern)) {
	            patternLength = String(pattern[0]).length;
	        }
	        else {
	            patternLength = String(pattern).length;
	        }
	        if (cardNumber.length >= patternLength) {
	            clonedCardConfiguration.matchStrength = patternLength;
	        }
	        results.push(clonedCardConfiguration);
	        break;
	    }
	}
	exports.addMatchingCardsToResults = addMatchingCardsToResults;


/***/ }),
/* 1269 */
/***/ (function(module, exports) {

	"use strict";
	var cardTypes = {
	    visa: {
	        niceType: "Visa",
	        type: "visa",
	        patterns: [4],
	        gaps: [4, 8, 12],
	        lengths: [16, 18, 19],
	        code: {
	            name: "CVV",
	            size: 3,
	        },
	    },
	    mastercard: {
	        niceType: "Mastercard",
	        type: "mastercard",
	        patterns: [[51, 55], [2221, 2229], [223, 229], [23, 26], [270, 271], 2720],
	        gaps: [4, 8, 12],
	        lengths: [16],
	        code: {
	            name: "CVC",
	            size: 3,
	        },
	    },
	    "american-express": {
	        niceType: "American Express",
	        type: "american-express",
	        patterns: [34, 37],
	        gaps: [4, 10],
	        lengths: [15],
	        code: {
	            name: "CID",
	            size: 4,
	        },
	    },
	    "diners-club": {
	        niceType: "Diners Club",
	        type: "diners-club",
	        patterns: [[300, 305], 36, 38, 39],
	        gaps: [4, 10],
	        lengths: [14, 16, 19],
	        code: {
	            name: "CVV",
	            size: 3,
	        },
	    },
	    discover: {
	        niceType: "Discover",
	        type: "discover",
	        patterns: [6011, [644, 649], 65],
	        gaps: [4, 8, 12],
	        lengths: [16, 19],
	        code: {
	            name: "CID",
	            size: 3,
	        },
	    },
	    jcb: {
	        niceType: "JCB",
	        type: "jcb",
	        patterns: [2131, 1800, [3528, 3589]],
	        gaps: [4, 8, 12],
	        lengths: [16, 17, 18, 19],
	        code: {
	            name: "CVV",
	            size: 3,
	        },
	    },
	    unionpay: {
	        niceType: "UnionPay",
	        type: "unionpay",
	        patterns: [
	            620,
	            [624, 626],
	            [62100, 62182],
	            [62184, 62187],
	            [62185, 62197],
	            [62200, 62205],
	            [622010, 622999],
	            622018,
	            [622019, 622999],
	            [62207, 62209],
	            [622126, 622925],
	            [623, 626],
	            6270,
	            6272,
	            6276,
	            [627700, 627779],
	            [627781, 627799],
	            [6282, 6289],
	            6291,
	            6292,
	            810,
	            [8110, 8131],
	            [8132, 8151],
	            [8152, 8163],
	            [8164, 8171],
	        ],
	        gaps: [4, 8, 12],
	        lengths: [14, 15, 16, 17, 18, 19],
	        code: {
	            name: "CVN",
	            size: 3,
	        },
	    },
	    maestro: {
	        niceType: "Maestro",
	        type: "maestro",
	        patterns: [
	            493698,
	            [500000, 504174],
	            [504176, 506698],
	            [506779, 508999],
	            [56, 59],
	            63,
	            67,
	            6,
	        ],
	        gaps: [4, 8, 12],
	        lengths: [12, 13, 14, 15, 16, 17, 18, 19],
	        code: {
	            name: "CVC",
	            size: 3,
	        },
	    },
	    elo: {
	        niceType: "Elo",
	        type: "elo",
	        patterns: [
	            401178,
	            401179,
	            438935,
	            457631,
	            457632,
	            431274,
	            451416,
	            457393,
	            504175,
	            [506699, 506778],
	            [509000, 509999],
	            627780,
	            636297,
	            636368,
	            [650031, 650033],
	            [650035, 650051],
	            [650405, 650439],
	            [650485, 650538],
	            [650541, 650598],
	            [650700, 650718],
	            [650720, 650727],
	            [650901, 650978],
	            [651652, 651679],
	            [655000, 655019],
	            [655021, 655058],
	        ],
	        gaps: [4, 8, 12],
	        lengths: [16],
	        code: {
	            name: "CVE",
	            size: 3,
	        },
	    },
	    mir: {
	        niceType: "Mir",
	        type: "mir",
	        patterns: [[2200, 2204]],
	        gaps: [4, 8, 12],
	        lengths: [16, 17, 18, 19],
	        code: {
	            name: "CVP2",
	            size: 3,
	        },
	    },
	    hiper: {
	        niceType: "Hiper",
	        type: "hiper",
	        patterns: [637095, 63737423, 63743358, 637568, 637599, 637609, 637612],
	        gaps: [4, 8, 12],
	        lengths: [16],
	        code: {
	            name: "CVC",
	            size: 3,
	        },
	    },
	    hipercard: {
	        niceType: "Hipercard",
	        type: "hipercard",
	        patterns: [606282],
	        gaps: [4, 8, 12],
	        lengths: [16],
	        code: {
	            name: "CVC",
	            size: 3,
	        },
	    },
	};
	module.exports = cardTypes;


/***/ }),
/* 1270 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.findBestMatch = void 0;
	function hasEnoughResultsToDetermineBestMatch(results) {
	    var numberOfResultsWithMaxStrengthProperty = results.filter(function (result) { return result.matchStrength; }).length;
	    /*
	     * if all possible results have a maxStrength property that means the card
	     * number is sufficiently long enough to determine conclusively what the card
	     * type is
	     * */
	    return (numberOfResultsWithMaxStrengthProperty > 0 &&
	        numberOfResultsWithMaxStrengthProperty === results.length);
	}
	function findBestMatch(results) {
	    if (!hasEnoughResultsToDetermineBestMatch(results)) {
	        return null;
	    }
	    return results.reduce(function (bestMatch, result) {
	        if (!bestMatch) {
	            return result;
	        }
	        /*
	         * If the current best match pattern is less specific than this result, set
	         * the result as the new best match
	         * */
	        if (Number(bestMatch.matchStrength) < Number(result.matchStrength)) {
	            return result;
	        }
	        return bestMatch;
	    });
	}
	exports.findBestMatch = findBestMatch;


/***/ }),
/* 1271 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isValidInputType = void 0;
	function isValidInputType(cardNumber) {
	    return typeof cardNumber === "string" || cardNumber instanceof String;
	}
	exports.isValidInputType = isValidInputType;


/***/ }),
/* 1272 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
	 * */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.matches = void 0;
	function matchesRange(cardNumber, min, max) {
	    var maxLengthToCheck = String(min).length;
	    var substr = cardNumber.substr(0, maxLengthToCheck);
	    var integerRepresentationOfCardNumber = parseInt(substr, 10);
	    min = parseInt(String(min).substr(0, substr.length), 10);
	    max = parseInt(String(max).substr(0, substr.length), 10);
	    return (integerRepresentationOfCardNumber >= min &&
	        integerRepresentationOfCardNumber <= max);
	}
	function matchesPattern(cardNumber, pattern) {
	    pattern = String(pattern);
	    return (pattern.substring(0, cardNumber.length) ===
	        cardNumber.substring(0, pattern.length));
	}
	function matches(cardNumber, pattern) {
	    if (Array.isArray(pattern)) {
	        return matchesRange(cardNumber, pattern[0], pattern[1]);
	    }
	    return matchesPattern(cardNumber, pattern);
	}
	exports.matches = matches;


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(60)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".react-phone-number-input__row{display:flex;align-items:center}.react-phone-number-input__phone{flex:1;min-width:0}.react-phone-number-input__icon{width:1.24em;height:.93em;border:1px solid rgba(0,0,0,.5);box-sizing:content-box}.react-phone-number-input__icon--international{width:calc(.93em + 2px);height:calc(.93em + 2px);padding-left:.155em;padding-right:.155em;border:none}.react-phone-number-input__error{margin-left:calc(1.24em + 2px + .3em + .35em + .5em);margin-top:0.3rem;color:#d30f00}.react-phone-number-input__icon-image{max-width:100%;max-height:100%}.react-phone-number-input__ext-input::-webkit-inner-spin-button,.react-phone-number-input__ext-input::-webkit-outer-spin-button{margin:0!important;-webkit-appearance:none!important;-moz-appearance:textfield!important}.react-phone-number-input__ext-input{width:3em}.react-phone-number-input__ext{white-space:nowrap}.react-phone-number-input__ext,.react-phone-number-input__ext-input{margin-left:.5em}.react-phone-number-input__country--native{position:relative;align-self:stretch;display:flex;align-items:center;margin-right:.5em}.react-phone-number-input__country-select{position:absolute;top:0;left:0;height:100%;width:100%;z-index:1;border:0;opacity:0;cursor:pointer}.react-phone-number-input__country-select-arrow{display:block;content:\"\";width:0;height:0;margin-bottom:.1em;margin-top:.3em;margin-left:.3em;border-width:.35em .2em 0;border-style:solid;border-left-color:transparent;border-right-color:transparent;color:#b8bdc4;opacity:.7;transition:color .1s}.react-phone-number-input__country-select-divider{font-size:1px;background:#000}.react-phone-number-input__country-select:focus+.react-phone-number-input__country-select-arrow{color:#03b2cb}.react-phone-number-input__input{height:1.8rem;outline:none;border-radius:0;padding:0;appearance:none;border:none;border-bottom:1px solid #c5d2e0;transition:border .1s;font-size:inherit}.react-phone-number-input__input:focus{border-color:#03b2cb}.react-phone-number-input__input--disabled{cursor:default}.react-phone-number-input__input--invalid,.react-phone-number-input__input--invalid:focus{border-color:#eb2010}.react-phone-number-input__input:-webkit-autofill{box-shadow:inset 0 0 0 1000px #fff}.react-phone-number-input__country .rrui__select__button{border-bottom:none}", ""]);
	
	// exports


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(60)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".sk-chasing-dots{width:27px;height:27px;position:relative;-webkit-animation:sk-rotate 2s infinite linear;animation:sk-rotate 2s infinite linear}.sk-dot1,.sk-dot2{width:60%;height:60%;display:inline-block;position:absolute;top:0;background-color:#333;border-radius:100%;-webkit-animation:sk-bounce 2s infinite ease-in-out;animation:sk-bounce 2s infinite ease-in-out}.sk-dot2{top:auto;bottom:0;-webkit-animation-delay:-1s;animation-delay:-1s}@-webkit-keyframes sk-rotate{to{-webkit-transform:rotate(1turn)}}@keyframes sk-rotate{to{transform:rotate(1turn);-webkit-transform:rotate(1turn)}}@-webkit-keyframes sk-bounce{0%,to{-webkit-transform:scale(0)}50%{-webkit-transform:scale(1)}}@keyframes sk-bounce{0%,to{transform:scale(0);-webkit-transform:scale(0)}50%{transform:scale(1);-webkit-transform:scale(1)}}", ""]);
	
	// exports


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(60)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".sk-circle-wrapper{width:22px;height:22px;position:relative}.sk-circle{width:100%;height:100%;position:absolute;left:0;top:0}.sk-circle:before{content:\"\";display:block;margin:0 auto;width:20%;height:20%;background-color:#333;border-radius:100%;-webkit-animation:sk-bouncedelay 1.2s infinite ease-in-out;animation:sk-bouncedelay 1.2s infinite ease-in-out;-webkit-animation-fill-mode:both;animation-fill-mode:both}.sk-circle2{-webkit-transform:rotate(30deg);transform:rotate(30deg)}.sk-circle3{-webkit-transform:rotate(60deg);transform:rotate(60deg)}.sk-circle4{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.sk-circle5{-webkit-transform:rotate(120deg);transform:rotate(120deg)}.sk-circle6{-webkit-transform:rotate(150deg);transform:rotate(150deg)}.sk-circle7{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.sk-circle8{-webkit-transform:rotate(210deg);transform:rotate(210deg)}.sk-circle9{-webkit-transform:rotate(240deg);transform:rotate(240deg)}.sk-circle10{-webkit-transform:rotate(270deg);transform:rotate(270deg)}.sk-circle11{-webkit-transform:rotate(300deg);transform:rotate(300deg)}.sk-circle12{-webkit-transform:rotate(330deg);transform:rotate(330deg)}.sk-circle2:before{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.sk-circle3:before{-webkit-animation-delay:-1s;animation-delay:-1s}.sk-circle4:before{-webkit-animation-delay:-.9s;animation-delay:-.9s}.sk-circle5:before{-webkit-animation-delay:-.8s;animation-delay:-.8s}.sk-circle6:before{-webkit-animation-delay:-.7s;animation-delay:-.7s}.sk-circle7:before{-webkit-animation-delay:-.6s;animation-delay:-.6s}.sk-circle8:before{-webkit-animation-delay:-.5s;animation-delay:-.5s}.sk-circle9:before{-webkit-animation-delay:-.4s;animation-delay:-.4s}.sk-circle10:before{-webkit-animation-delay:-.3s;animation-delay:-.3s}.sk-circle11:before{-webkit-animation-delay:-.2s;animation-delay:-.2s}.sk-circle12:before{-webkit-animation-delay:-.1s;animation-delay:-.1s}@-webkit-keyframes sk-bouncedelay{0%,80%,to{-webkit-transform:scale(0)}40%{-webkit-transform:scale(1)}}@keyframes sk-bouncedelay{0%,80%,to{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}", ""]);
	
	// exports


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(60)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".sk-cube-grid{width:27px;height:27px}.sk-cube{width:33%;height:33%;background:#333;float:left;-webkit-animation:sk-scaleDelay 1.3s infinite ease-in-out;animation:sk-scaleDelay 1.3s infinite ease-in-out}.sk-spinner .sk-cube:first-child{-webkit-animation-delay:.2s;animation-delay:.2s}.sk-spinner .sk-cube:nth-child(2){-webkit-animation-delay:.3s;animation-delay:.3s}.sk-spinner .sk-cube:nth-child(3){-webkit-animation-delay:.4s;animation-delay:.4s}.sk-spinner .sk-cube:nth-child(4){-webkit-animation-delay:.1s;animation-delay:.1s}.sk-spinner .sk-cube:nth-child(5){-webkit-animation-delay:.2s;animation-delay:.2s}.sk-spinner .sk-cube:nth-child(6){-webkit-animation-delay:.3s;animation-delay:.3s}.sk-spinner .sk-cube:nth-child(7){-webkit-animation-delay:0s;animation-delay:0s}.sk-spinner .sk-cube:nth-child(8){-webkit-animation-delay:.1s;animation-delay:.1s}.sk-spinner .sk-cube:nth-child(9){-webkit-animation-delay:.2s;animation-delay:.2s}@-webkit-keyframes sk-scaleDelay{0%,70%,to{-webkit-transform:scale3D(1,1,1)}35%{-webkit-transform:scale3D(0,0,1)}}@keyframes sk-scaleDelay{0%,70%,to{-webkit-transform:scale3D(1,1,1);transform:scale3D(1,1,1)}35%{-webkit-transform:scale3D(1,1,1);transform:scale3D(0,0,1)}}", ""]);
	
	// exports


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(60)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".sk-double-bounce{width:27px;height:27px;position:relative}.sk-double-bounce1,.sk-double-bounce2{width:100%;height:100%;border-radius:50%;background-color:#333;opacity:.6;position:absolute;top:0;left:0;-webkit-animation:sk-bounce 2s infinite ease-in-out;animation:sk-bounce 2s infinite ease-in-out}.sk-double-bounce2{-webkit-animation-delay:-1s;animation-delay:-1s}@-webkit-keyframes sk-bounce{0%,to{-webkit-transform:scale(0)}50%{-webkit-transform:scale(1)}}@keyframes sk-bounce{0%,to{transform:scale(0);-webkit-transform:scale(0)}50%{transform:scale(1);-webkit-transform:scale(1)}}", ""]);
	
	// exports


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(60)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, "@-webkit-keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}@-moz-keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}@-ms-keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}@keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}.sk-fade-in{-webkit-animation:sk-fade-in 2s;-moz-animation:sk-fade-in 2s;-o-animation:sk-fade-in 2s;-ms-animation:sk-fade-in 2s}", ""]);
	
	// exports


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(60)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".sk-folding-cube{width:27px;height:27px;position:relative;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.sk-folding-cube .sk-cube{float:left;width:50%;height:50%;position:relative;-webkit-transform:scale(1.1);-ms-transform:scale(1.1);transform:scale(1.1)}.sk-folding-cube .sk-cube:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background-color:#333;-webkit-animation:sk-foldCubeAngle 2.4s infinite linear both;animation:sk-foldCubeAngle 2.4s infinite linear both;-webkit-transform-origin:100% 100%;-ms-transform-origin:100% 100%;transform-origin:100% 100%}.sk-folding-cube .sk-cube2{-webkit-transform:scale(1.1) rotate(90deg);transform:scale(1.1) rotate(90deg)}.sk-folding-cube .sk-cube3{-webkit-transform:scale(1.1) rotate(180deg);transform:scale(1.1) rotate(180deg)}.sk-folding-cube .sk-cube4{-webkit-transform:scale(1.1) rotate(270deg);transform:scale(1.1) rotate(270deg)}.sk-folding-cube .sk-cube2:before{-webkit-animation-delay:.3s;animation-delay:.3s}.sk-folding-cube .sk-cube3:before{-webkit-animation-delay:.6s;animation-delay:.6s}.sk-folding-cube .sk-cube4:before{-webkit-animation-delay:.9s;animation-delay:.9s}@-webkit-keyframes sk-foldCubeAngle{0%,10%{-webkit-transform:perspective(140px) rotateX(-180deg);transform:perspective(140px) rotateX(-180deg);opacity:0}25%,75%{-webkit-transform:perspective(140px) rotateX(0deg);transform:perspective(140px) rotateX(0deg);opacity:1}90%,to{-webkit-transform:perspective(140px) rotateY(180deg);transform:perspective(140px) rotateY(180deg);opacity:0}}@keyframes sk-foldCubeAngle{0%,10%{-webkit-transform:perspective(140px) rotateX(-180deg);transform:perspective(140px) rotateX(-180deg);opacity:0}25%,75%{-webkit-transform:perspective(140px) rotateX(0deg);transform:perspective(140px) rotateX(0deg);opacity:1}90%,to{-webkit-transform:perspective(140px) rotateY(180deg);transform:perspective(140px) rotateY(180deg);opacity:0}}", ""]);
	
	// exports


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(60)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".sk-pulse{width:27px;height:27px;background-color:#333;border-radius:100%;-webkit-animation:sk-scaleout 1s infinite ease-in-out;animation:sk-scaleout 1s infinite ease-in-out}@-webkit-keyframes sk-scaleout{0%{-webkit-transform:scale(0)}to{-webkit-transform:scale(1);opacity:0}}@keyframes sk-scaleout{0%{transform:scale(0);-webkit-transform:scale(0)}to{transform:scale(1);-webkit-transform:scale(1);opacity:0}}", ""]);
	
	// exports


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(60)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".sk-rotating-plane{width:27px;height:27px;background-color:#333;-webkit-animation:sk-rotateplane 1.2s infinite ease-in-out;animation:sk-rotateplane 1.2s infinite ease-in-out}@-webkit-keyframes sk-rotateplane{0%{-webkit-transform:perspective(120px)}50%{-webkit-transform:perspective(120px) rotateY(180deg)}to{-webkit-transform:perspective(120px) rotateY(180deg) rotateX(180deg)}}@keyframes sk-rotateplane{0%{transform:perspective(120px) rotateX(0deg) rotateY(0deg);-webkit-transform:perspective(120px) rotateX(0deg) rotateY(0deg)}50%{transform:perspective(120px) rotateX(-180.1deg) rotateY(0deg);-webkit-transform:perspective(120px) rotateX(-180.1deg) rotateY(0deg)}to{transform:perspective(120px) rotateX(-180deg) rotateY(-179.9deg);-webkit-transform:perspective(120px) rotateX(-180deg) rotateY(-179.9deg)}}", ""]);
	
	// exports


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(60)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".sk-three-bounce>div{width:18px;height:18px;background-color:#333;border-radius:100%;display:inline-block;-webkit-animation:sk-bouncedelay 1.4s infinite ease-in-out;animation:sk-bouncedelay 1.4s infinite ease-in-out;-webkit-animation-fill-mode:both;animation-fill-mode:both}.sk-three-bounce .sk-bounce1{-webkit-animation-delay:-.32s;animation-delay:-.32s}.sk-three-bounce .sk-bounce2{-webkit-animation-delay:-.16s;animation-delay:-.16s}@-webkit-keyframes sk-bouncedelay{0%,80%,to{-webkit-transform:scale(0)}40%{-webkit-transform:scale(1)}}@keyframes sk-bouncedelay{0%,80%,to{transform:scale(0);-webkit-transform:scale(0)}40%{transform:scale(1);-webkit-transform:scale(1)}}", ""]);
	
	// exports


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(60)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".sk-wandering-cubes{width:27px;height:27px;position:relative}.sk-cube1,.sk-cube2{background-color:#333;width:10px;height:10px;position:absolute;top:0;left:0;-webkit-animation:sk-cubemove 1.8s infinite ease-in-out;animation:sk-cubemove 1.8s infinite ease-in-out}.sk-cube2{-webkit-animation-delay:-.9s;animation-delay:-.9s}@-webkit-keyframes sk-cubemove{25%{-webkit-transform:translateX(22px) rotate(-90deg) scale(.5)}50%{-webkit-transform:translateX(22px) translateY(22px) rotate(-180deg)}75%{-webkit-transform:translateX(0) translateY(22px) rotate(-270deg) scale(.5)}to{-webkit-transform:rotate(-1turn)}}@keyframes sk-cubemove{25%{transform:translateX(42px) rotate(-90deg) scale(.5);-webkit-transform:translateX(42px) rotate(-90deg) scale(.5)}50%{transform:translateX(42px) translateY(42px) rotate(-179deg);-webkit-transform:translateX(42px) translateY(42px) rotate(-179deg)}50.1%{transform:translateX(42px) translateY(42px) rotate(-180deg);-webkit-transform:translateX(42px) translateY(42px) rotate(-180deg)}75%{transform:translateX(0) translateY(42px) rotate(-270deg) scale(.5);-webkit-transform:translateX(0) translateY(42px) rotate(-270deg) scale(.5)}to{transform:rotate(-1turn);-webkit-transform:rotate(-1turn)}}", ""]);
	
	// exports


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(60)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".sk-wave{width:50px;height:27px}.sk-wave>div{background-color:#333;height:100%;width:6px;display:inline-block;-webkit-animation:sk-stretchdelay 1.2s infinite ease-in-out;animation:sk-stretchdelay 1.2s infinite ease-in-out}.sk-wave .sk-rect2{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.sk-wave .sk-rect3{-webkit-animation-delay:-1s;animation-delay:-1s}.sk-wave .sk-rect4{-webkit-animation-delay:-.9s;animation-delay:-.9s}.sk-wave .sk-rect5{-webkit-animation-delay:-.8s;animation-delay:-.8s}@-webkit-keyframes sk-stretchdelay{0%,40%,to{-webkit-transform:scaleY(.4)}20%{-webkit-transform:scaleY(1)}}@keyframes sk-stretchdelay{0%,40%,to{transform:scaleY(.4);-webkit-transform:scaleY(.4)}20%{transform:scaleY(1);-webkit-transform:scaleY(1)}}", ""]);
	
	// exports


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(60)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".sk-wordpress{background:#333;width:27px;height:27px;display:inline-block;border-radius:27px;position:relative;-webkit-animation:sk-inner-circle 1s linear infinite;animation:sk-inner-circle 1s linear infinite}.sk-inner-circle{display:block;background:#fff;width:8px;height:8px;position:absolute;border-radius:8px;top:5px;left:5px}@-webkit-keyframes sk-inner-circle{0%{-webkit-transform:rotate(0)}to{-webkit-transform:rotate(1turn)}}@keyframes sk-inner-circle{0%{transform:rotate(0);-webkit-transform:rotate(0)}to{transform:rotate(1turn);-webkit-transform:rotate(1turn)}}", ""]);
	
	// exports


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(1519);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = Array.prototype.slice.call(arguments);
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    if ('function' === typeof exports.formatArgs) {
	      args = exports.formatArgs.apply(self, args);
	    }
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(1289);
	var isArguments = __webpack_require__(1288);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 1288 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 1289 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(306);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var off = function off() {};
	if (_inDOM2.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	exports.default = off;
	module.exports = exports['default'];

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(306);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var on = function on() {};
	if (_inDOM2.default) {
	  on = function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	exports.default = on;
	module.exports = exports['default'];

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollTop;
	
	var _isWindow = __webpack_require__(482);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow2.default)(node);
	
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	module.exports = exports['default'];

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollTop;
	
	var _isWindow = __webpack_require__(482);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow2.default)(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	module.exports = exports['default'];

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(306);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf = void 0;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM2.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	exports.default = compatRaf;
	module.exports = exports['default'];

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `parse`.
	 */
	
	module.exports = parse;
	
	/**
	 * Tests for browser support.
	 */
	
	var innerHTMLBug = false;
	var bugTestDiv;
	if (typeof document !== 'undefined') {
	  bugTestDiv = document.createElement('div');
	  // Setup
	  bugTestDiv.innerHTML = '  <link/><table></table><a href="/a">a</a><input type="checkbox"/>';
	  // Make sure that link elements get serialized correctly by innerHTML
	  // This requires a wrapper element in IE
	  innerHTMLBug = !bugTestDiv.getElementsByTagName('link').length;
	  bugTestDiv = undefined;
	}
	
	/**
	 * Wrap map from jquery.
	 */
	
	var map = {
	  legend: [1, '<fieldset>', '</fieldset>'],
	  tr: [2, '<table><tbody>', '</tbody></table>'],
	  col: [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  // for script/link/style tags to work in IE6-8, you have to wrap
	  // in a div with a non-whitespace character in front, ha!
	  _default: innerHTMLBug ? [1, 'X<div>', '</div>'] : [0, '', '']
	};
	
	map.td =
	map.th = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	map.option =
	map.optgroup = [1, '<select multiple="multiple">', '</select>'];
	
	map.thead =
	map.tbody =
	map.colgroup =
	map.caption =
	map.tfoot = [1, '<table>', '</table>'];
	
	map.polyline =
	map.ellipse =
	map.polygon =
	map.circle =
	map.text =
	map.line =
	map.path =
	map.rect =
	map.g = [1, '<svg xmlns="http://www.w3.org/2000/svg" version="1.1">','</svg>'];
	
	/**
	 * Parse `html` and return a DOM Node instance, which could be a TextNode,
	 * HTML DOM Node of some kind (<div> for example), or a DocumentFragment
	 * instance, depending on the contents of the `html` string.
	 *
	 * @param {String} html - HTML string to "domify"
	 * @param {Document} doc - The `document` instance to create the Node for
	 * @return {DOMNode} the TextNode, DOM Node, or DocumentFragment instance
	 * @api private
	 */
	
	function parse(html, doc) {
	  if ('string' != typeof html) throw new TypeError('String expected');
	
	  // default to the global `document` object
	  if (!doc) doc = document;
	
	  // tag name
	  var m = /<([\w:]+)/.exec(html);
	  if (!m) return doc.createTextNode(html);
	
	  html = html.replace(/^\s+|\s+$/g, ''); // Remove leading/trailing whitespace
	
	  var tag = m[1];
	
	  // body support
	  if (tag == 'body') {
	    var el = doc.createElement('html');
	    el.innerHTML = html;
	    return el.removeChild(el.lastChild);
	  }
	
	  // wrap map
	  var wrap = map[tag] || map._default;
	  var depth = wrap[0];
	  var prefix = wrap[1];
	  var suffix = wrap[2];
	  var el = doc.createElement('div');
	  el.innerHTML = prefix + html + suffix;
	  while (depth--) el = el.lastChild;
	
	  // one element
	  if (el.firstChild == el.lastChild) {
	    return el.removeChild(el.firstChild);
	  }
	
	  // several elements
	  var fragment = doc.createDocumentFragment();
	  while (el.firstChild) {
	    fragment.appendChild(el.removeChild(el.firstChild));
	  }
	
	  return fragment;
	}


/***/ }),
/* 1296 */
84,
/* 1297 */
84,
/* 1298 */
84,
/* 1299 */
84,
/* 1300 */
84,
/* 1301 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(1301);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1311);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(55);
	
	var createArrayFromMixed = __webpack_require__(1304);
	var getMarkupWrap = __webpack_require__(1306);
	var invariant = __webpack_require__(13);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(55);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1308);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1310);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tidal-close.2c79abb5.svg";

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/squire-logo.21c8c1ef.svg";

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isFSA = isFSA;
	exports.isError = isError;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashIsplainobject = __webpack_require__(1316);
	
	var _lodashIsplainobject2 = _interopRequireDefault(_lodashIsplainobject);
	
	var validKeys = ['type', 'payload', 'error', 'meta'];
	
	function isValidKey(key) {
	  return validKeys.indexOf(key) > -1;
	}
	
	function isFSA(action) {
	  return _lodashIsplainobject2['default'](action) && typeof action.type !== 'undefined' && Object.keys(action).every(isValidKey);
	}
	
	function isError(action) {
	  return action.error === true;
	}

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseFor = __webpack_require__(1355),
	    isArguments = __webpack_require__(526),
	    keysIn = __webpack_require__(1317);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * **Note:** This method assumes objects created by the `Object` constructor
	 * have no inherited enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  var Ctor;
	
	  // Exit early for non `Object` objects.
	  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	    return false;
	  }
	  // IE < 9 iterates inherited properties before own properties. If the first
	  // iterated property is an object's own property then there are no inherited
	  // enumerable properties.
	  var result;
	  // In most environments an object's own properties are iterated before
	  // its inherited properties. If the last iterated property is an object's
	  // own property then there are no inherited enumerable properties.
	  baseForIn(value, function(subValue, key) {
	    result = key;
	  });
	  return result === undefined || hasOwnProperty.call(value, result);
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var isArguments = __webpack_require__(526),
	    isArray = __webpack_require__(1357);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ }),
/* 1318 */
/***/ (function(module, exports) {

	/* from https://gist.github.com/nuxodin/9250e56a3ce6c0446efa */
	
	function polyfill () {
	  var w = window
	  var d = w.document
	
	  if (w.onfocusin === undefined) {
	    d.addEventListener('focus', addPolyfill, true)
	    d.addEventListener('blur', addPolyfill, true)
	    d.addEventListener('focusin', removePolyfill, true)
	    d.addEventListener('focusout', removePolyfill, true)
	  }
	
	  function addPolyfill (e) {
	    var type = e.type === 'focus' ? 'focusin' : 'focusout'
	    var event = new window.CustomEvent(type, { bubbles: true, cancelable: false })
	    event.c1Generated = true
	    e.target.dispatchEvent(event)
	  }
	
	  function removePolyfill (e) {
	    if (!e.c1Generated) {
	      d.removeEventListener('focus', addPolyfill, true)
	      d.removeEventListener('blur', addPolyfill, true)
	      d.removeEventListener('focusin', removePolyfill, true)
	      d.removeEventListener('focusout', removePolyfill, true)
	    }
	    setTimeout(function () {
	      d.removeEventListener('focusin', removePolyfill, true)
	      d.removeEventListener('focusout', removePolyfill, true)
	    })
	  }
	}
	
	module.exports = {
	  polyfill: polyfill
	}


/***/ }),
/* 1319 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */
	
	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}


/***/ }),
/* 1320 */
/***/ (function(module, exports) {

	var haversine = (function () {
	
	  // convert to radians
	  var toRad = function (num) {
	    return num * Math.PI / 180
	  }
	
	  return function haversine (start, end, options) {
	    options   = options || {}
	
	    var radii = {
	      km:    6371,
	      mile:  3960,
	      meter: 6371000,
	      nmi:   3440
	    }
	
	    var R = options.unit in radii
	      ? radii[options.unit]
	      : radii.km
	
	    var dLat = toRad(end.latitude - start.latitude)
	    var dLon = toRad(end.longitude - start.longitude)
	    var lat1 = toRad(start.latitude)
	    var lat2 = toRad(end.latitude)
	
	    var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
	            Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2)
	    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
	
	    if (options.threshold) {
	      return options.threshold > (R * c)
	    }
	
	    return R * c
	  }
	
	})()
	
	if (typeof module !== 'undefined' && module.exports) {
	  module.exports = haversine
	}


/***/ }),
/* 1321 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(310);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(119);
	
	var _DOMUtils = __webpack_require__(166);
	
	var _DOMStateStorage = __webpack_require__(311);
	
	var _PathUtils = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(310);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(119);
	
	var _PathUtils = __webpack_require__(100);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.Actions = exports.useQueries = exports.useBeforeUnload = exports.useBasename = exports.createMemoryHistory = exports.createHashHistory = exports.createHistory = undefined;
	
	var _LocationUtils = __webpack_require__(119);
	
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _createBrowserHistory = __webpack_require__(497);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createHashHistory2 = __webpack_require__(498);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(499);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	var _useBasename2 = __webpack_require__(314);
	
	var _useBasename3 = _interopRequireDefault(_useBasename2);
	
	var _useBeforeUnload2 = __webpack_require__(1325);
	
	var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);
	
	var _useQueries2 = __webpack_require__(315);
	
	var _useQueries3 = _interopRequireDefault(_useQueries2);
	
	var _Actions2 = __webpack_require__(165);
	
	var _Actions = _interopRequireWildcard(_Actions2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createHistory = _createBrowserHistory2.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;
	exports.useBasename = _useBasename3.default;
	exports.useBeforeUnload = _useBeforeUnload3.default;
	exports.useQueries = _useQueries3.default;
	exports.Actions = _Actions;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _DOMUtils = __webpack_require__(166);
	
	var _ExecutionEnvironment = __webpack_require__(203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var startListener = function startListener(getPromptMessage) {
	  var handleBeforeUnload = function handleBeforeUnload(event) {
	    var message = getPromptMessage();
	
	    if (typeof message === 'string') {
	      (event || window.event).returnValue = message;
	      return message;
	    }
	
	    return undefined;
	  };
	
	  (0, _DOMUtils.addEventListener)(window, 'beforeunload', handleBeforeUnload);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, 'beforeunload', handleBeforeUnload);
	  };
	};
	
	/**
	 * Returns a new createHistory function that can be used to create
	 * history objects that know how to use the beforeunload event in web
	 * browsers to cancel navigation.
	 */
	var useBeforeUnload = function useBeforeUnload(createHistory) {
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'useBeforeUnload only works in DOM environments') : (0, _invariant2.default)(false) : void 0;
	
	  return function (options) {
	    var history = createHistory(options);
	
	    var listeners = [];
	    var stopListener = void 0;
	
	    var getPromptMessage = function getPromptMessage() {
	      var message = void 0;
	      for (var i = 0, len = listeners.length; message == null && i < len; ++i) {
	        message = listeners[i].call();
	      }return message;
	    };
	
	    var listenBeforeUnload = function listenBeforeUnload(listener) {
	      if (listeners.push(listener) === 1) stopListener = startListener(getPromptMessage);
	
	      return function () {
	        listeners = listeners.filter(function (item) {
	          return item !== listener;
	        });
	
	        if (listeners.length === 0 && stopListener) {
	          stopListener();
	          stopListener = null;
	        }
	      };
	    };
	
	    return _extends({}, history, {
	      listenBeforeUnload: listenBeforeUnload
	    });
	  };
	};
	
	exports.default = useBeforeUnload;

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(1842);
	module.exports = self.fetch.bind(self);


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.0
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader = false;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init (converter) {
			function api (key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					// We're using "expires" because "max-age" is not supported by IE
					attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value))
							.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					var stringifiedAttributes = '';
	
					for (var attributeName in attributes) {
						if (!attributes[attributeName]) {
							continue;
						}
						stringifiedAttributes += '; ' + attributeName;
						if (attributes[attributeName] === true) {
							continue;
						}
						stringifiedAttributes += '=' + attributes[attributeName];
					}
					return (document.cookie = key + '=' + value + stringifiedAttributes);
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!this.json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ?
							converter.read(cookie, name) : converter(cookie, name) ||
							cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 1328 */
500,
/* 1329 */
/***/ (function(module, exports) {

	module.exports = {
		"version": "2016j",
		"zones": [
			"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
			"Africa/Accra|LMT GMT GHST|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
			"Africa/Nairobi|LMT EAT BEAT BEAUT|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
			"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
			"Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
			"Africa/Bissau|LMT WAT GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4",
			"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
			"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
			"Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5",
			"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1y7p0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
			"Africa/El_Aaiun|LMT WAT WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4",
			"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
			"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|51e5",
			"Africa/Monrovia|MMT LRT GMT|H.8 I.u 0|012|-23Lzg.Q 29s01.m|11e5",
			"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
			"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
			"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
			"Africa/Windhoek|SWAT SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0|32e4",
			"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
			"America/Anchorage|CAT CAWT CAPT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
			"America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
			"America/Araguaina|LMT BRT BRST|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
			"America/Argentina/Buenos_Aires|CMT ART ARST ART ARST|4g.M 40 30 30 20|0121212121212121212121212121212121212121213434343434343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0",
			"America/Argentina/Catamarca|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343454343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0",
			"America/Argentina/Cordoba|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343454343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0",
			"America/Argentina/Jujuy|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|01212121212121212121212121212121212121212134343456543432343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 g0p0 10M0 j3c0 uL0",
			"America/Argentina/La_Rioja|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434534343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0",
			"America/Argentina/Mendoza|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|0121212121212121212121212121212121212121213434345656543235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 g0p0 10M0 agM0 Op0 7TX0 uL0",
			"America/Argentina/Rio_Gallegos|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343434343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0",
			"America/Argentina/Salta|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434543432343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 j3c0 uL0",
			"America/Argentina/San_Juan|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434534343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 g0p0 10M0 ak00 m10 8lb0 uL0",
			"America/Argentina/San_Luis|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|01212121212121212121212121212121212121212134343456536353465653|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 kin0 10M0 ak00 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0",
			"America/Argentina/Tucuman|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|012121212121212121212121212121212121212121343434345434323534343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 ako0 4N0 8BX0 uL0 1qN0 WL0",
			"America/Argentina/Ushuaia|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343434343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 ajA0 8p0 8zb0 uL0",
			"America/Curacao|LMT ANT AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
			"America/Asuncion|AMT PYT PYT PYST|3O.E 40 30 30|012131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
			"America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2",
			"America/Bahia|LMT BRT BRST|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
			"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
			"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
			"America/Belem|LMT BRT BRST|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
			"America/Belize|LMT CST CHDT CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
			"America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2",
			"America/Boa_Vista|LMT AMT AMST|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
			"America/Bogota|BMT COT COST|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
			"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
			"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
			"America/Campo_Grande|LMT AMT AMST|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4",
			"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|CMT VET VET|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
			"America/Cayenne|LMT GFT GFT|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
			"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
			"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
			"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
			"America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2",
			"America/Cuiaba|LMT AMT AMST|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4",
			"America/Danmarkshavn|LMT WGT WGST GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
			"America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2",
			"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
			"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
			"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
			"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
			"America/Eirunepe|LMT ACT ACST AMT|4D.s 50 40 40|0121212121212121212121212121212131|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
			"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
			"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
			"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Fortaleza|LMT BRT BRST|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
			"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"America/Godthab|LMT WGT WGST|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
			"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
			"America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
			"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
			"America/Guayaquil|QMT ECT|5e 50|01|-1yVSK|27e5",
			"America/Guyana|LMT GBGT GYT GYT GYT|3Q.E 3J 3J 30 40|01234|-2dvU7.k 24JzQ.k mlc0 Bxbf|80e4",
			"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
			"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
			"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
			"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
			"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
			"America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
			"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
			"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/La_Paz|CMT BOST BOT|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
			"America/Lima|LMT PET PEST|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
			"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
			"America/Maceio|LMT BRT BRST|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
			"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
			"America/Manaus|LMT AMT AMST|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
			"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
			"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
			"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
			"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
			"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
			"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
			"America/Miquelon|LMT AST PMST PMDT|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
			"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
			"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
			"America/Montevideo|MMT UYT UYHST UYST UYT UYHST|3I.I 3u 30 20 30 2u|012121212121212121212121213434343434345454543453434343434343434343434343434343434343434|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
			"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
			"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
			"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
			"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
			"America/Noronha|LMT FNT FNST|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
			"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Paramaribo|LMT PMT PMT NEGT SRT SRT|3E.E 3E.Q 3E.A 3u 3u 30|012345|-2nDUj.k Wqo0.c qanX.I 1dmLN.o lzc0|24e4",
			"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
			"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Rio_Branco|LMT ACT ACST AMT|4v.c 50 40 40|01212121212121212121212121212131|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
			"America/Porto_Velho|LMT AMT AMST|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
			"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
			"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
			"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
			"America/Recife|LMT BRT BRST|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
			"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
			"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
			"America/Santarem|LMT AMT AMST BRT|3C.M 40 30 30|0121212121212121212121212121213|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
			"America/Santiago|SMT CLT CLT CLST CLST|4G.K 50 40 40 30|010203131313131212421242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5",
			"America/Santo_Domingo|SDMT EST EDT EHDT AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
			"America/Sao_Paulo|LMT BRT BRST|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6",
			"America/Scoresbysund|LMT CGT CGST EGST EGT|1r.Q 20 10 0 10|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
			"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
			"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
			"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
			"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
			"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
			"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
			"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10",
			"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
			"Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
			"Antarctica/Macquarie|AEST AEDT -00 MIST|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
			"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
			"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
			"Antarctica/Palmer|-00 ARST ART ART ARST CLT CLST|0 30 40 30 20 40 30|0121212121234356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|40",
			"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
			"Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
			"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
			"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
			"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
			"Asia/Riyadh|LMT AST|-36.Q -30|01|-TvD6.Q|57e5",
			"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
			"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
			"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
			"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
			"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
			"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
			"Asia/Atyrau|LMT +04 +05 +06|-3r.I -40 -50 -60|01232323232323232323212323232323232321212121212|-1Pc3r.I eUnr.I 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0",
			"Asia/Baghdad|BMT AST ADT|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
			"Asia/Qatar|LMT GST AST|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
			"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|BMT ICT|-6G.4 -70|01|-218SG.4|15e6",
			"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
			"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
			"Asia/Brunei|LMT BNT BNT|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
			"Asia/Kolkata|HMT BURT IST IST|-5R.k -6u -5u -6u|01232|-18LFR.k 1unn.k HB0 7zX0|15e6",
			"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
			"Asia/Choibalsan|LMT ULAT ULAT CHOST CHOT CHOT CHOST|-7C -70 -80 -a0 -90 -80 -90|0123434343434343434343434343434343434343434343456565656565656565656565656565656565656565656565|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|38e3",
			"Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
			"Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
			"Asia/Dhaka|HMT BURT IST DACT BDT BDST|-5R.k -6u -5u -60 -60 -70|01213454|-18LFR.k 1unn.k HB0 m6n0 LqMu 1x6n0 1i00|16e6",
			"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|LMT TLT JST TLT WITA|-8m.k -80 -90 -90 -80|012343|-2le8m.k 1dnXm.k 8HA0 1ew00 Xld0|19e4",
			"Asia/Dubai|LMT GST|-3F.c -40|01|-21JfF.c|39e5",
			"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
			"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0",
			"Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5",
			"Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4",
			"Asia/Ho_Chi_Minh|LMT PLMT ICT IDT JST|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
			"Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
			"Asia/Hovd|LMT HOVT HOVT HOVST|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|BMT JAVT WIB JST WIB WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
			"Asia/Jayapura|LMT WIT ACST|-9m.M -90 -9u|0121|-1uu9m.M sMMm.M L4nu|26e4",
			"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
			"Asia/Kabul|AFT AFT|-40 -4u|01|-10Qs0|46e5",
			"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
			"Asia/Karachi|LMT IST IST KART PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
			"Asia/Urumqi|LMT XJT|-5O.k -60|01|-1GgtO.k|32e5",
			"Asia/Kathmandu|LMT IST NPT|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
			"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
			"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Asia/Kuala_Lumpur|SMT MALT MALST MALT MALT JST MYT|-6T.p -70 -7k -7k -7u -90 -80|01234546|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu 1so1u|71e5",
			"Asia/Kuching|LMT BORT BORT BORTST JST MYT|-7l.k -7u -80 -8k -90 -80|01232323232323232425|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0 1so10|13e4",
			"Asia/Macau|LMT MOT MOST CST|-7y.k -80 -90 -80|0121212121212121212121212121212121212121213|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0 KEp0|57e4",
			"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
			"Asia/Makassar|LMT MMT WITA JST|-7V.A -7V.A -80 -90|01232|-21JjV.A vfc0 myLV.A 8ML0|15e5",
			"Asia/Manila|PHT PHST JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
			"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
			"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
			"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
			"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
			"Asia/Oral|LMT +04 +05 +06|-3p.o -40 -50 -60|01232323232323232121212121212121212121212121212|-1Pc3p.o eUnp.o 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
			"Asia/Pontianak|LMT PMT WIB JST WIB WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
			"Asia/Pyongyang|LMT KST JCST JST KST|-8n -8u -90 -90 -90|012341|-2um8n 97XR 12FXu jdA0 2Onc0|29e5",
			"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4",
			"Asia/Rangoon|RMT BURT JST MMT|-6o.E -6u -90 -6u|0123|-21Jio.E SmnS.E 7j9u|48e5",
			"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
			"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
			"Asia/Seoul|LMT KST JCST JST KST KDT KDT|-8r.Q -8u -90 -90 -90 -9u -a0|01234151515151515146464|-2um8r.Q 97XV.Q 12FXu jjA0 kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
			"Asia/Singapore|SMT MALT MALST MALT MALT JST SGT SGT|-6T.p -70 -7k -7k -7u -90 -7u -80|012345467|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu Mspu DTA0|56e5",
			"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
			"Asia/Taipei|JWST JST CST CDT|-80 -90 -80 -90|01232323232323232323232323232323232323232|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
			"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
			"Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
			"Asia/Tehran|LMT TMT IRST IRST IRDT IRDT|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
			"Asia/Thimphu|LMT IST BTT|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
			"Asia/Tokyo|JCST JST JDT|-90 -90 -a0|0121212121|-1iw90 pKq0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6",
			"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
			"Asia/Ulaanbaatar|LMT ULAT ULAT ULAST|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
			"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
			"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
			"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
			"Atlantic/Azores|HMT AZOT AZOST AZOMT AZOT AZOST WET|1S.w 20 10 0 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545456545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
			"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
			"Atlantic/Canary|LMT CANT WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Atlantic/Cape_Verde|LMT CVT CVST CVT|1y.4 20 10 10|01213|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4",
			"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
			"Atlantic/Madeira|FMT MADT MADST MADMT WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
			"Atlantic/Reykjavik|LMT IST ISST GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
			"Atlantic/South_Georgia|GST|20|0||30",
			"Atlantic/Stanley|SMT FKT FKST FKT FKST|3P.o 40 30 30 20|0121212121212134343212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 U10 1qM0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
			"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
			"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
			"Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746",
			"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
			"Australia/Eucla|ACWST ACWDT|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
			"Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
			"Australia/Lord_Howe|AEST LHST LHDT LHDT|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
			"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
			"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
			"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Easter|EMT EAST EASST EAST EASST|7h.s 70 60 60 50|0121212121212121212121212121234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2",
			"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"EST|EST|50|0|",
			"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Etc/GMT+0|GMT|0|0|",
			"Etc/GMT+1|-01|10|0|",
			"Etc/GMT+10|-10|a0|0|",
			"Etc/GMT+11|-11|b0|0|",
			"Etc/GMT+12|-12|c0|0|",
			"Etc/GMT+2|-02|20|0|",
			"Etc/GMT+3|-03|30|0|",
			"Etc/GMT+4|-04|40|0|",
			"Etc/GMT+5|-05|50|0|",
			"Etc/GMT+6|-06|60|0|",
			"Etc/GMT+7|-07|70|0|",
			"Etc/GMT+8|-08|80|0|",
			"Etc/GMT+9|-09|90|0|",
			"Etc/GMT-1|+01|-10|0|",
			"Etc/GMT-10|+10|-a0|0|",
			"Etc/GMT-11|+11|-b0|0|",
			"Etc/GMT-12|+12|-c0|0|",
			"Etc/GMT-13|+13|-d0|0|",
			"Etc/GMT-14|+14|-e0|0|",
			"Etc/GMT-2|+02|-20|0|",
			"Etc/GMT-3|+03|-30|0|",
			"Etc/GMT-4|+04|-40|0|",
			"Etc/GMT-5|+05|-50|0|",
			"Etc/GMT-6|+06|-60|0|",
			"Etc/GMT-7|+07|-70|0|",
			"Etc/GMT-8|+08|-80|0|",
			"Etc/GMT-9|+09|-90|0|",
			"Etc/UCT|UCT|0|0|",
			"Etc/UTC|UTC|0|0|",
			"Europe/Amsterdam|AMT NST NEST NET CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
			"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
			"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
			"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
			"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
			"Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
			"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
			"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
			"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
			"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
			"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
			"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
			"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
			"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
			"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
			"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|01010101010101010101010121212121234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-28dd0 11A0 1go0 19A0 1co0 1dA0 b1A0 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 iyo0 Rc0 18o0 1hc0 1io0 1a00 14o0 5aL0 MM0 1vc0 17A0 1i00 1bc0 1eo0 17d0 1in0 17A0 6hA0 10N0 XIL0 1a10 1in0 17d0 19X0 1cN0 1fz0 1a10 1fX0 1cp0 1cO0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
			"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
			"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
			"Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
			"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
			"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
			"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
			"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
			"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810",
			"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
			"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
			"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
			"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
			"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zaporozhye|CUT EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
			"HST|HST|a0|0|",
			"Indian/Chagos|LMT IOT IOT|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
			"Indian/Christmas|CXT|-70|0||21e2",
			"Indian/Cocos|CCT|-6u|0||596",
			"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
			"Indian/Mahe|LMT SCT|-3F.M -40|01|-2yO3F.M|79e3",
			"Indian/Maldives|MMT MVT|-4S -50|01|-olgS|35e4",
			"Indian/Mauritius|LMT MUT MUST|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
			"Indian/Reunion|LMT RET|-3F.Q -40|01|-2mDDF.Q|84e4",
			"Pacific/Kwajalein|MHT KWAT MHT|-b0 c0 -c0|012|-AX0 W9X0|14e3",
			"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"MST|MST|70|0|",
			"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Chatham|CHAST CHAST CHADT|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
			"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Apia|LMT WSST SST SDT WSDT WSST|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
			"Pacific/Bougainville|PGT JST BST|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
			"Pacific/Chuuk|CHUT|-a0|0||49e3",
			"Pacific/Efate|LMT VUT VUST|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
			"Pacific/Enderbury|PHOT PHOT PHOT|c0 b0 -d0|012|nIc0 B8n0|1",
			"Pacific/Fakaofo|TKT TKT|b0 -d0|01|1Gfn0|483",
			"Pacific/Fiji|LMT FJT FJST|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4",
			"Pacific/Funafuti|TVT|-c0|0||45e2",
			"Pacific/Galapagos|LMT ECT GALT|5W.o 50 60|012|-1yVS1.A 2dTz1.A|25e3",
			"Pacific/Gambier|LMT GAMT|8X.M 90|01|-2jof0.c|125",
			"Pacific/Guadalcanal|LMT SBT|-aD.M -b0|01|-2joyD.M|11e4",
			"Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4",
			"Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4",
			"Pacific/Kiritimati|LINT LINT LINT|aE a0 -e0|012|nIaE B8nk|51e2",
			"Pacific/Kosrae|KOST KOST|-b0 -c0|010|-AX0 1bdz0|66e2",
			"Pacific/Majuro|MHT MHT|-b0 -c0|01|-AX0|28e3",
			"Pacific/Marquesas|LMT MART|9i 9u|01|-2joeG|86e2",
			"Pacific/Pago_Pago|LMT NST BST SST|bm.M b0 b0 b0|0123|-2nDMB.c 2gVzB.c EyM0|37e2",
			"Pacific/Nauru|LMT NRT JST NRT|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3",
			"Pacific/Niue|NUT NUT NUT|bk bu b0|012|-KfME 17y0a|12e2",
			"Pacific/Norfolk|NMT NFT NFST NFT|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4",
			"Pacific/Noumea|LMT NCT NCST|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
			"Pacific/Palau|PWT|-90|0||21e3",
			"Pacific/Pitcairn|PNT PST|8u 80|01|18Vku|56",
			"Pacific/Pohnpei|PONT|-b0|0||34e3",
			"Pacific/Port_Moresby|PGT|-a0|0||25e4",
			"Pacific/Rarotonga|CKT CKHST CKT|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
			"Pacific/Tahiti|LMT TAHT|9W.g a0|01|-2joe1.I|18e4",
			"Pacific/Tarawa|GILT|-c0|0||29e3",
			"Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121212121212121212121212121212121212121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|75e3",
			"Pacific/Wake|WAKT|-c0|0||16e3",
			"Pacific/Wallis|WFT|-c0|0||94",
			"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"
		],
		"links": [
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Sao_Tome",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Cairo|Egypt",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Khartoum|Africa/Juba",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|US/Alaska",
			"America/Argentina/Buenos_Aires|America/Buenos_Aires",
			"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
			"America/Argentina/Catamarca|America/Catamarca",
			"America/Argentina/Cordoba|America/Cordoba",
			"America/Argentina/Cordoba|America/Rosario",
			"America/Argentina/Jujuy|America/Jujuy",
			"America/Argentina/Mendoza|America/Mendoza",
			"America/Atikokan|America/Coral_Harbour",
			"America/Chicago|US/Central",
			"America/Curacao|America/Aruba",
			"America/Curacao|America/Kralendijk",
			"America/Curacao|America/Lower_Princes",
			"America/Denver|America/Shiprock",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Detroit|US/Michigan",
			"America/Edmonton|Canada/Mountain",
			"America/Fort_Wayne|America/Indiana/Indianapolis",
			"America/Fort_Wayne|America/Indianapolis",
			"America/Fort_Wayne|US/East-Indiana",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Indiana/Knox|America/Knox_IN",
			"America/Indiana/Knox|US/Indiana-Starke",
			"America/Jamaica|Jamaica",
			"America/Kentucky/Louisville|America/Louisville",
			"America/Los_Angeles|US/Pacific",
			"America/Los_Angeles|US/Pacific-New",
			"America/Manaus|Brazil/West",
			"America/Mazatlan|Mexico/BajaSur",
			"America/Mexico_City|Mexico/General",
			"America/New_York|US/Eastern",
			"America/Noronha|Brazil/DeNoronha",
			"America/Panama|America/Cayman",
			"America/Phoenix|US/Arizona",
			"America/Port_of_Spain|America/Anguilla",
			"America/Port_of_Spain|America/Antigua",
			"America/Port_of_Spain|America/Dominica",
			"America/Port_of_Spain|America/Grenada",
			"America/Port_of_Spain|America/Guadeloupe",
			"America/Port_of_Spain|America/Marigot",
			"America/Port_of_Spain|America/Montserrat",
			"America/Port_of_Spain|America/St_Barthelemy",
			"America/Port_of_Spain|America/St_Kitts",
			"America/Port_of_Spain|America/St_Lucia",
			"America/Port_of_Spain|America/St_Thomas",
			"America/Port_of_Spain|America/St_Vincent",
			"America/Port_of_Spain|America/Tortola",
			"America/Port_of_Spain|America/Virgin",
			"America/Regina|Canada/East-Saskatchewan",
			"America/Regina|Canada/Saskatchewan",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Tijuana|America/Ensenada",
			"America/Tijuana|America/Santa_Isabel",
			"America/Tijuana|Mexico/BajaNorte",
			"America/Toronto|America/Montreal",
			"America/Toronto|Canada/Eastern",
			"America/Vancouver|Canada/Pacific",
			"America/Whitehorse|Canada/Yukon",
			"America/Winnipeg|Canada/Central",
			"Asia/Ashgabat|Asia/Ashkhabad",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Ho_Chi_Minh|Asia/Saigon",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Macau|Asia/Macao",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Nicosia|Europe/Nicosia",
			"Asia/Qatar|Asia/Bahrain",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Riyadh|Asia/Aden",
			"Asia/Riyadh|Asia/Kuwait",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|PRC",
			"Asia/Singapore|Singapore",
			"Asia/Taipei|ROC",
			"Asia/Tehran|Iran",
			"Asia/Thimphu|Asia/Thimbu",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Urumqi|Asia/Kashgar",
			"Atlantic/Faroe|Atlantic/Faeroe",
			"Atlantic/Reykjavik|Iceland",
			"Australia/Adelaide|Australia/South",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Broken_Hill|Australia/Yancowinna",
			"Australia/Darwin|Australia/North",
			"Australia/Hobart|Australia/Tasmania",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Melbourne|Australia/Victoria",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/NSW",
			"Etc/GMT+0|Etc/GMT",
			"Etc/GMT+0|Etc/GMT-0",
			"Etc/GMT+0|Etc/GMT0",
			"Etc/GMT+0|Etc/Greenwich",
			"Etc/GMT+0|GMT",
			"Etc/GMT+0|GMT+0",
			"Etc/GMT+0|GMT-0",
			"Etc/GMT+0|GMT0",
			"Etc/GMT+0|Greenwich",
			"Etc/UCT|UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Belgrade|Europe/Ljubljana",
			"Europe/Belgrade|Europe/Podgorica",
			"Europe/Belgrade|Europe/Sarajevo",
			"Europe/Belgrade|Europe/Skopje",
			"Europe/Belgrade|Europe/Zagreb",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Helsinki|Europe/Mariehamn",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Lisbon|Portugal",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Oslo|Arctic/Longyearbyen",
			"Europe/Oslo|Atlantic/Jan_Mayen",
			"Europe/Prague|Europe/Bratislava",
			"Europe/Rome|Europe/San_Marino",
			"Europe/Rome|Europe/Vatican",
			"Europe/Warsaw|Poland",
			"Europe/Zurich|Europe/Busingen",
			"Europe/Zurich|Europe/Vaduz",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Chuuk|Pacific/Truk",
			"Pacific/Chuuk|Pacific/Yap",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kwajalein|Kwajalein",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Pohnpei|Pacific/Ponape"
		]
	};

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

	module.exports = {
		"ext": "ext.",
		"AF": "Afghanistan (‫افغانستان‬‎)",
		"AX": "Åland Islands",
		"AL": "Albania (Shqipëri)",
		"DZ": "Algeria (‫الجزائر‬‎)",
		"AS": "American Samoa (Amerika Sāmoa)",
		"AD": "Andorra",
		"AO": "Angola",
		"AI": "Anguilla",
		"AG": "Antigua and Barbuda",
		"AR": "Argentina",
		"AM": "Armenia (Հայաստան)",
		"AW": "Aruba",
		"AU": "Australia",
		"AT": "Austria (Österreich)",
		"AZ": "Azerbaijan (Azərbaycan)",
		"BS": "Bahamas",
		"BH": "Bahrain (‫البحرين‬‎)",
		"BD": "Bangladesh (বাংলাদেশ)",
		"BB": "Barbados",
		"BY": "Belarus (Беларусь)",
		"BE": "Belgium (België)",
		"BZ": "Belize",
		"BJ": "Benin (Bénin)",
		"BM": "Bermuda",
		"BT": "Bhutan (འབྲུག)",
		"BO": "Bolivia",
		"BA": "Bosnia and Herzegovina",
		"BW": "Botswana",
		"BR": "Brazil (Brasil)",
		"IO": "British Indian Ocean Territory",
		"VG": "British Virgin Islands",
		"BN": "Brunei (Negara Brunei Darussalam)",
		"BG": "Bulgaria (България)",
		"BF": "Burkina Faso",
		"BI": "Burundi (Uburundi)",
		"KH": "Cambodia (កម្ពុជា)",
		"CM": "Cameroon (Cameroun)",
		"CA": "Canada",
		"CV": "Cape Verde (Kabu Verdi)",
		"BQ": "Caribbean Netherlands",
		"KY": "Cayman Islands",
		"CF": "Central African Republic",
		"TD": "Chad (Tchad)",
		"CL": "Chile",
		"CN": "China (中国)",
		"CX": "Christmas Island",
		"CC": "Cocos (Keeling) Islands",
		"CO": "Colombia",
		"KM": "Comoros (‫جزر القمر‬‎)",
		"CD": "Congo (DRC) (Kongo)",
		"CG": "Congo (Republic) (Congo-Brazzaville)",
		"CK": "Cook Islands",
		"CR": "Costa Rica",
		"CI": "Côte d’Ivoire",
		"HR": "Croatia (Hrvatska)",
		"CU": "Cuba",
		"CW": "Curaçao",
		"CY": "Cyprus (Κύπρος)",
		"CZ": "Czech Republic (Česká republika)",
		"DK": "Denmark (Danmark)",
		"DJ": "Djibouti",
		"DM": "Dominica",
		"DO": "Dominican Republic",
		"EC": "Ecuador",
		"EG": "Egypt (‫مصر‬‎)",
		"SV": "El Salvador",
		"GQ": "Equatorial Guinea (Guinea Ecuatorial)",
		"ER": "Eritrea",
		"EE": "Estonia (Eesti)",
		"ET": "Ethiopia",
		"FK": "Falkland Islands (Islas Malvinas)",
		"FO": "Faroe Islands (Føroyar)",
		"FJ": "Fiji (Matanitu Tugalala o Viti)",
		"FI": "Finland (Suomi)",
		"FR": "France (République française)",
		"GF": "French Guiana (Guyane française)",
		"PF": "French Polynesia (Polynésie française)",
		"GA": "Gabon (République gabonaise)",
		"GM": "Gambia",
		"GE": "Georgia (საქართველო)",
		"DE": "Germany (Deutschland)",
		"GH": "Ghana (Gaana)",
		"GI": "Gibraltar",
		"GR": "Greece (Ελλάδα)",
		"GL": "Greenland (Kalaallit Nunaat)",
		"GD": "Grenada",
		"GP": "Guadeloupe",
		"GU": "Guam (Guåhån)",
		"GT": "Guatemala",
		"GG": "Guernsey",
		"GN": "Guinea (Guinée)",
		"GW": "Guinea-Bissau (Guiné Bissau)",
		"GY": "Guyana",
		"HT": "Haiti (République d'Haïti)",
		"HN": "Honduras",
		"HK": "Hong Kong (香港)",
		"HU": "Hungary (Magyarország)",
		"IS": "Iceland (Ísland)",
		"IN": "India (भारत)",
		"ID": "Indonesia",
		"IR": "Iran (‫ایران‬‎)",
		"IQ": "Iraq (‫العراق‬‎)",
		"IE": "Ireland",
		"IM": "Isle of Man",
		"IL": "Israel (‫ישראל‬‎)",
		"IT": "Italy (Italia)",
		"JM": "Jamaica",
		"JP": "Japan (日本)",
		"JE": "Jersey",
		"JO": "Jordan (‫الأردن‬‎)",
		"KZ": "Kazakhstan (Казахстан)",
		"KE": "Kenya",
		"KI": "Kiribati",
		"KW": "Kuwait (‫الكويت‬‎)",
		"KG": "Kyrgyzstan (Кыргызстан)",
		"LA": "Laos (ລາວ)",
		"LV": "Latvia (Latvija)",
		"LB": "Lebanon (‫لبنان‬‎)",
		"LS": "Lesotho",
		"LR": "Liberia",
		"LY": "Libya (‫ليبيا‬‎)",
		"LI": "Liechtenstein",
		"LT": "Lithuania (Lietuva)",
		"LU": "Luxembourg (Lëtzebuerg)",
		"MO": "Macau (澳門)",
		"MK": "Macedonia (FYROM) (Македонија)",
		"MG": "Madagascar (Madagasikara)",
		"MW": "Malawi (Malaŵi)",
		"MY": "Malaysia",
		"MV": "Maldives",
		"ML": "Mali",
		"MT": "Malta",
		"MH": "Marshall Islands",
		"MQ": "Martinique",
		"MR": "Mauritania (‫موريتانيا‬‎)",
		"MU": "Mauritius (Moris)",
		"YT": "Mayotte",
		"MX": "Mexico (México)",
		"FM": "Micronesia",
		"MD": "Moldova (Republica Moldova)",
		"MC": "Monaco",
		"MN": "Mongolia (Монгол)",
		"ME": "Montenegro (Crna Gora)",
		"MS": "Montserrat",
		"MA": "Morocco (‫المغرب‬‎)",
		"MZ": "Mozambique (Moçambique)",
		"MM": "Myanmar (Burma) (မြန်မာ)",
		"NA": "Namibia (Namibië)",
		"NR": "Nauru (Repubrikin Naoero)",
		"NP": "Nepal (नेपाल)",
		"NL": "Netherlands (Nederland)",
		"NC": "New Caledonia (Nouvelle-Calédonie)",
		"NZ": "New Zealand",
		"NI": "Nicaragua",
		"NE": "Niger (Nijar)",
		"NG": "Nigeria",
		"NU": "Niue (Niuē)",
		"NF": "Norfolk Island",
		"KP": "North Korea (조선 민주주의 인민 공화국)",
		"MP": "Northern Mariana Islands",
		"NO": "Norway (Norge)",
		"OM": "Oman (‫عُمان‬‎)",
		"PK": "Pakistan (‫پاکستان‬‎)",
		"PW": "Palau (Beluu er a Belau)",
		"PS": "Palestine (‫فلسطين‬‎)",
		"PA": "Panama (Panamá)",
		"PG": "Papua New Guinea",
		"PY": "Paraguay (Tetã Paraguái)",
		"PE": "Peru (Perú)",
		"PH": "Philippines (Republika ng Pilipinas)",
		"PL": "Poland (Polska)",
		"PT": "Portugal (República Portuguesa)",
		"PR": "Puerto Rico",
		"QA": "Qatar (‫قطر‬‎)",
		"RE": "Réunion (La Réunion)",
		"RO": "Romania (România)",
		"RU": "Russia (Россия)",
		"RW": "Rwanda",
		"BL": "Saint Barthélemy (Saint-Barthélemy)",
		"SH": "Saint Helena",
		"KN": "Saint Kitts and Nevis",
		"LC": "Saint Lucia",
		"MF": "Saint Martin (Saint-Martin)",
		"PM": "Saint Pierre and Miquelon",
		"VC": "Saint Vincent and the Grenadines",
		"WS": "Samoa (Sāmoa)",
		"SM": "San Marino",
		"ST": "São Tomé and Príncipe",
		"SA": "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
		"SN": "Senegal (Sénégal)",
		"RS": "Serbia (Србија)",
		"SC": "Seychelles (Repiblik Sesel)",
		"SL": "Sierra Leone",
		"SG": "Singapore (Singapura) (新加坡共和国)",
		"SX": "Sint Maarten",
		"SK": "Slovakia (Slovensko)",
		"SI": "Slovenia (Slovenija)",
		"SB": "Solomon Islands",
		"SO": "Somalia (Soomaaliya)",
		"ZA": "South Africa",
		"KR": "South Korea (대한민국)",
		"SS": "South Sudan (‫جنوب السودان‬‎)",
		"ES": "Spain (España)",
		"LK": "Sri Lanka (ශ්‍රී ලංකාව)",
		"SD": "Sudan (‫السودان‬‎)",
		"SR": "Suriname",
		"SJ": "Svalbard and Jan Mayen",
		"SZ": "Swaziland (Umbuso weSwatini)",
		"SE": "Sweden (Sverige)",
		"CH": "Switzerland (Schweiz)",
		"SY": "Syria (‫سوريا‬‎)",
		"TW": "Taiwan (台灣)",
		"TJ": "Tajikistan (Ҷумҳурии Тоҷикистон)",
		"TZ": "Tanzania",
		"TH": "Thailand (ไทย)",
		"TL": "Timor-Leste (Timór-Leste)",
		"TG": "Togo (République togolaise)",
		"TK": "Tokelau",
		"TO": "Tonga",
		"TT": "Trinidad and Tobago",
		"TN": "Tunisia (‫تونس‬‎)",
		"TR": "Turkey (Türkiye)",
		"TM": "Turkmenistan (Türkmenistan)",
		"TC": "Turks and Caicos Islands",
		"TV": "Tuvalu",
		"VI": "U.S. Virgin Islands",
		"UG": "Uganda",
		"UA": "Ukraine (Україна)",
		"AE": "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
		"GB": "United Kingdom",
		"US": "United States",
		"UY": "Uruguay",
		"UZ": "Uzbekistan (Oʻzbekiston)",
		"VU": "Vanuatu",
		"VA": "Vatican City (Città del Vaticano)",
		"VE": "Venezuela",
		"VN": "Vietnam (Việt Nam)",
		"WF": "Wallis and Futuna (Wallis-et-Futuna)",
		"EH": "Western Sahara (‫الصحراء الغربية‬‎)",
		"YE": "Yemen (‫اليمن‬‎)",
		"ZM": "Zambia",
		"ZW": "Zimbabwe",
		"ZZ": "International"
	};

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var debug = __webpack_require__(305)('jsonp');
	
	/**
	 * Module exports.
	 */
	
	module.exports = jsonp;
	
	/**
	 * Callback index.
	 */
	
	var count = 0;
	
	/**
	 * Noop function.
	 */
	
	function noop(){}
	
	/**
	 * JSONP handler
	 *
	 * Options:
	 *  - param {String} qs parameter (`callback`)
	 *  - prefix {String} qs parameter (`__jp`)
	 *  - name {String} qs parameter (`prefix` + incr)
	 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
	 *
	 * @param {String} url
	 * @param {Object|Function} optional options / callback
	 * @param {Function} optional callback
	 */
	
	function jsonp(url, opts, fn){
	  if ('function' == typeof opts) {
	    fn = opts;
	    opts = {};
	  }
	  if (!opts) opts = {};
	
	  var prefix = opts.prefix || '__jp';
	
	  // use the callback name that was passed if one was provided.
	  // otherwise generate a unique name by incrementing our counter.
	  var id = opts.name || (prefix + (count++));
	
	  var param = opts.param || 'callback';
	  var timeout = null != opts.timeout ? opts.timeout : 60000;
	  var enc = encodeURIComponent;
	  var target = document.getElementsByTagName('script')[0] || document.head;
	  var script;
	  var timer;
	
	
	  if (timeout) {
	    timer = setTimeout(function(){
	      cleanup();
	      if (fn) fn(new Error('Timeout'));
	    }, timeout);
	  }
	
	  function cleanup(){
	    if (script.parentNode) script.parentNode.removeChild(script);
	    window[id] = noop;
	    if (timer) clearTimeout(timer);
	  }
	
	  function cancel(){
	    if (window[id]) {
	      cleanup();
	    }
	  }
	
	  window[id] = function(data){
	    debug('jsonp got', data);
	    cleanup();
	    if (fn) fn(null, data);
	  };
	
	  // add qs component
	  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
	  url = url.replace('?&', '?');
	
	  debug('jsonp req "%s"', url);
	
	  // create script
	  script = document.createElement('script');
	  script.src = url;
	  target.parentNode.insertBefore(script, target);
	
	  return cancel;
	}


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _AsYouTypeFormatterPatternParser = _interopRequireDefault(__webpack_require__(1333));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	var PatternMatcher = /*#__PURE__*/function () {
	  function PatternMatcher(pattern) {
	    _classCallCheck(this, PatternMatcher);
	
	    this.matchTree = new _AsYouTypeFormatterPatternParser["default"]().parse(pattern);
	  }
	
	  _createClass(PatternMatcher, [{
	    key: "match",
	    value: function match(string) {
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          allowOverflow = _ref.allowOverflow;
	
	      if (!string) {
	        throw new Error('String is required');
	      }
	
	      var result = _match(string.split(''), this.matchTree, true);
	
	      if (result && result.match) {
	        delete result.matchedChars;
	      }
	
	      if (result && result.overflow) {
	        if (!allowOverflow) {
	          return;
	        }
	      }
	
	      return result;
	    }
	  }]);
	
	  return PatternMatcher;
	}();
	/**
	 * Matches `characters` against a pattern compiled into a `tree`.
	 * @param  {string[]} characters
	 * @param  {Tree} tree — A pattern compiled into a `tree`. See the `*.d.ts` file for the description of the `tree` structure.
	 * @param  {boolean} last — Whether it's the last (rightmost) subtree on its level of the match tree.
	 * @return {object} See the `*.d.ts` file for the description of the result object.
	 */
	
	
	exports["default"] = PatternMatcher;
	
	function _match(characters, tree, last) {
	  // If `tree` is a string, then `tree` is a single character.
	  // That's because when a pattern is parsed, multi-character-string parts
	  // of a pattern are compiled into arrays of single characters.
	  // I still wrote this piece of code for a "general" hypothetical case
	  // when `tree` could be a string of several characters, even though
	  // such case is not possible with the current implementation.
	  if (typeof tree === 'string') {
	    var characterString = characters.join('');
	
	    if (tree.indexOf(characterString) === 0) {
	      // `tree` is always a single character.
	      // If `tree.indexOf(characterString) === 0`
	      // then `characters.length === tree.length`.
	
	      /* istanbul ignore else */
	      if (characters.length === tree.length) {
	        return {
	          match: true,
	          matchedChars: characters
	        };
	      } // `tree` is always a single character.
	      // If `tree.indexOf(characterString) === 0`
	      // then `characters.length === tree.length`.
	
	      /* istanbul ignore next */
	
	
	      return {
	        partialMatch: true // matchedChars: characters
	
	      };
	    }
	
	    if (characterString.indexOf(tree) === 0) {
	      if (last) {
	        // The `else` path is not possible because `tree` is always a single character.
	        // The `else` case for `characters.length > tree.length` would be
	        // `characters.length <= tree.length` which means `characters.length <= 1`.
	        // `characters` array can't be empty, so that means `characters === [tree]`,
	        // which would also mean `tree.indexOf(characterString) === 0` and that'd mean
	        // that the `if (tree.indexOf(characterString) === 0)` condition before this
	        // `if` condition would be entered, and returned from there, not reaching this code.
	
	        /* istanbul ignore else */
	        if (characters.length > tree.length) {
	          return {
	            overflow: true
	          };
	        }
	      }
	
	      return {
	        match: true,
	        matchedChars: characters.slice(0, tree.length)
	      };
	    }
	
	    return;
	  }
	
	  if (Array.isArray(tree)) {
	    var restCharacters = characters.slice();
	    var i = 0;
	
	    while (i < tree.length) {
	      var subtree = tree[i];
	
	      var result = _match(restCharacters, subtree, last && i === tree.length - 1);
	
	      if (!result) {
	        return;
	      } else if (result.overflow) {
	        return result;
	      } else if (result.match) {
	        // Continue with the next subtree with the rest of the characters.
	        restCharacters = restCharacters.slice(result.matchedChars.length);
	
	        if (restCharacters.length === 0) {
	          if (i === tree.length - 1) {
	            return {
	              match: true,
	              matchedChars: characters
	            };
	          } else {
	            return {
	              partialMatch: true // matchedChars: characters
	
	            };
	          }
	        }
	      } else {
	        /* istanbul ignore else */
	        if (result.partialMatch) {
	          return {
	            partialMatch: true // matchedChars: characters
	
	          };
	        } else {
	          throw new Error("Unsupported match result:\n".concat(JSON.stringify(result, null, 2)));
	        }
	      }
	
	      i++;
	    } // If `last` then overflow has already been checked
	    // by the last element of the `tree` array.
	
	    /* istanbul ignore if */
	
	
	    if (last) {
	      return {
	        overflow: true
	      };
	    }
	
	    return {
	      match: true,
	      matchedChars: characters.slice(0, characters.length - restCharacters.length)
	    };
	  }
	
	  switch (tree.op) {
	    case '|':
	      var partialMatch;
	
	      for (var _iterator = _createForOfIteratorHelperLoose(tree.args), _step; !(_step = _iterator()).done;) {
	        var branch = _step.value;
	
	        var _result = _match(characters, branch, last);
	
	        if (_result) {
	          if (_result.overflow) {
	            return _result;
	          } else if (_result.match) {
	            return {
	              match: true,
	              matchedChars: _result.matchedChars
	            };
	          } else {
	            /* istanbul ignore else */
	            if (_result.partialMatch) {
	              partialMatch = true;
	            } else {
	              throw new Error("Unsupported match result:\n".concat(JSON.stringify(_result, null, 2)));
	            }
	          }
	        }
	      }
	
	      if (partialMatch) {
	        return {
	          partialMatch: true // matchedChars: ...
	
	        };
	      } // Not even a partial match.
	
	
	      return;
	
	    case '[]':
	      for (var _iterator2 = _createForOfIteratorHelperLoose(tree.args), _step2; !(_step2 = _iterator2()).done;) {
	        var _char = _step2.value;
	
	        if (characters[0] === _char) {
	          if (characters.length === 1) {
	            return {
	              match: true,
	              matchedChars: characters
	            };
	          }
	
	          if (last) {
	            return {
	              overflow: true
	            };
	          }
	
	          return {
	            match: true,
	            matchedChars: [_char]
	          };
	        }
	      } // No character matches.
	
	
	      return;
	
	    /* istanbul ignore next */
	
	    default:
	      throw new Error("Unsupported instruction tree: ".concat(tree));
	  }
	}
	//# sourceMappingURL=AsYouTypeFormatter.PatternMatcher.js.map

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	var PatternParser = /*#__PURE__*/function () {
	  function PatternParser() {
	    _classCallCheck(this, PatternParser);
	  }
	
	  _createClass(PatternParser, [{
	    key: "parse",
	    value: function parse(pattern) {
	      this.context = [{
	        or: true,
	        instructions: []
	      }];
	      this.parsePattern(pattern);
	
	      if (this.context.length !== 1) {
	        throw new Error('Non-finalized contexts left when pattern parse ended');
	      }
	
	      var _this$context$ = this.context[0],
	          branches = _this$context$.branches,
	          instructions = _this$context$.instructions;
	
	      if (branches) {
	        return {
	          op: '|',
	          args: branches.concat([expandSingleElementArray(instructions)])
	        };
	      }
	      /* istanbul ignore if */
	
	
	      if (instructions.length === 0) {
	        throw new Error('Pattern is required');
	      }
	
	      if (instructions.length === 1) {
	        return instructions[0];
	      }
	
	      return instructions;
	    }
	  }, {
	    key: "startContext",
	    value: function startContext(context) {
	      this.context.push(context);
	    }
	  }, {
	    key: "endContext",
	    value: function endContext() {
	      this.context.pop();
	    }
	  }, {
	    key: "getContext",
	    value: function getContext() {
	      return this.context[this.context.length - 1];
	    }
	  }, {
	    key: "parsePattern",
	    value: function parsePattern(pattern) {
	      if (!pattern) {
	        throw new Error('Pattern is required');
	      }
	
	      var match = pattern.match(OPERATOR);
	
	      if (!match) {
	        if (ILLEGAL_CHARACTER_REGEXP.test(pattern)) {
	          throw new Error("Illegal characters found in a pattern: ".concat(pattern));
	        }
	
	        this.getContext().instructions = this.getContext().instructions.concat(pattern.split(''));
	        return;
	      }
	
	      var operator = match[1];
	      var before = pattern.slice(0, match.index);
	      var rightPart = pattern.slice(match.index + operator.length);
	
	      switch (operator) {
	        case '(?:':
	          if (before) {
	            this.parsePattern(before);
	          }
	
	          this.startContext({
	            or: true,
	            instructions: [],
	            branches: []
	          });
	          break;
	
	        case ')':
	          if (!this.getContext().or) {
	            throw new Error('")" operator must be preceded by "(?:" operator');
	          }
	
	          if (before) {
	            this.parsePattern(before);
	          }
	
	          if (this.getContext().instructions.length === 0) {
	            throw new Error('No instructions found after "|" operator in an "or" group');
	          }
	
	          var _this$getContext = this.getContext(),
	              branches = _this$getContext.branches;
	
	          branches.push(expandSingleElementArray(this.getContext().instructions));
	          this.endContext();
	          this.getContext().instructions.push({
	            op: '|',
	            args: branches
	          });
	          break;
	
	        case '|':
	          if (!this.getContext().or) {
	            throw new Error('"|" operator can only be used inside "or" groups');
	          }
	
	          if (before) {
	            this.parsePattern(before);
	          } // The top-level is an implicit "or" group, if required.
	
	
	          if (!this.getContext().branches) {
	            // `branches` are not defined only for the root implicit "or" operator.
	
	            /* istanbul ignore else */
	            if (this.context.length === 1) {
	              this.getContext().branches = [];
	            } else {
	              throw new Error('"branches" not found in an "or" group context');
	            }
	          }
	
	          this.getContext().branches.push(expandSingleElementArray(this.getContext().instructions));
	          this.getContext().instructions = [];
	          break;
	
	        case '[':
	          if (before) {
	            this.parsePattern(before);
	          }
	
	          this.startContext({
	            oneOfSet: true
	          });
	          break;
	
	        case ']':
	          if (!this.getContext().oneOfSet) {
	            throw new Error('"]" operator must be preceded by "[" operator');
	          }
	
	          this.endContext();
	          this.getContext().instructions.push({
	            op: '[]',
	            args: parseOneOfSet(before)
	          });
	          break;
	
	        /* istanbul ignore next */
	
	        default:
	          throw new Error("Unknown operator: ".concat(operator));
	      }
	
	      if (rightPart) {
	        this.parsePattern(rightPart);
	      }
	    }
	  }]);
	
	  return PatternParser;
	}();
	
	exports["default"] = PatternParser;
	
	function parseOneOfSet(pattern) {
	  var values = [];
	  var i = 0;
	
	  while (i < pattern.length) {
	    if (pattern[i] === '-') {
	      if (i === 0 || i === pattern.length - 1) {
	        throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
	      }
	
	      var prevValue = pattern[i - 1].charCodeAt(0) + 1;
	      var nextValue = pattern[i + 1].charCodeAt(0) - 1;
	      var value = prevValue;
	
	      while (value <= nextValue) {
	        values.push(String.fromCharCode(value));
	        value++;
	      }
	    } else {
	      values.push(pattern[i]);
	    }
	
	    i++;
	  }
	
	  return values;
	}
	
	var ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/;
	var OPERATOR = new RegExp( // any of:
	'(' + // or operator
	'\\|' + // or
	'|' + // or group start
	'\\(\\?\\:' + // or
	'|' + // or group end
	'\\)' + // or
	'|' + // one-of set start
	'\\[' + // or
	'|' + // one-of set end
	'\\]' + ')');
	
	function expandSingleElementArray(array) {
	  if (array.length === 1) {
	    return array[0];
	  }
	
	  return array;
	}
	//# sourceMappingURL=AsYouTypeFormatter.PatternParser.js.map

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canFormatCompleteNumber = canFormatCompleteNumber;
	exports["default"] = formatCompleteNumber;
	
	var _checkNumberLength = _interopRequireDefault(__webpack_require__(208));
	
	var _parseDigits = _interopRequireDefault(__webpack_require__(120));
	
	var _formatNationalNumberUsingFormat = _interopRequireDefault(__webpack_require__(323));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function formatCompleteNumber(state, format, _ref) {
	  var metadata = _ref.metadata,
	      shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule,
	      getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
	  var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));
	
	  if (matcher.test(state.nationalSignificantNumber)) {
	    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
	      metadata: metadata,
	      shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
	      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
	    });
	  }
	}
	
	function canFormatCompleteNumber(nationalSignificantNumber, metadata) {
	  return (0, _checkNumberLength["default"])(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
	}
	
	function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
	  var metadata = _ref2.metadata,
	      shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule,
	      getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
	  // `format` has already been checked for `nationalPrefix` requirement.
	  var nationalSignificantNumber = state.nationalSignificantNumber,
	      international = state.international,
	      nationalPrefix = state.nationalPrefix,
	      carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
	  // If the resulting formatted number is a valid formatted number, then return it.
	  //
	  // Google's AsYouType formatter is different in a way that it doesn't try
	  // to format using the "national prefix formatting rule", and instead it
	  // simply prepends a national prefix followed by a " " character.
	  // This code does that too, but as a fallback.
	  // The reason is that "national prefix formatting rule" may use parentheses,
	  // which wouldn't be included has it used the simpler Google's way.
	  //
	
	  if (shouldTryNationalPrefixFormattingRule(format)) {
	    var formattedNumber = formatNationalNumber(state, format, {
	      useNationalPrefixFormattingRule: true,
	      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
	      metadata: metadata
	    });
	
	    if (formattedNumber) {
	      return formattedNumber;
	    }
	  } // Format the number without using `national_prefix_formatting_rule`.
	
	
	  return formatNationalNumber(state, format, {
	    useNationalPrefixFormattingRule: false,
	    getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
	    metadata: metadata
	  });
	}
	
	function formatNationalNumber(state, format, _ref3) {
	  var metadata = _ref3.metadata,
	      useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule,
	      getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
	  var formattedNationalNumber = (0, _formatNationalNumberUsingFormat["default"])(state.nationalSignificantNumber, format, {
	    carrierCode: state.carrierCode,
	    useInternationalFormat: state.international,
	    withNationalPrefix: useNationalPrefixFormattingRule,
	    metadata: metadata
	  });
	
	  if (!useNationalPrefixFormattingRule) {
	    if (state.nationalPrefix) {
	      // If a national prefix was extracted, then just prepend it,
	      // followed by a " " character.
	      formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
	    } else if (state.complexPrefixBeforeNationalSignificantNumber) {
	      formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
	    }
	  }
	
	  if (isValidFormattedNationalNumber(formattedNationalNumber, state)) {
	    return formattedNationalNumber;
	  }
	} // Check that the formatted phone number contains exactly
	// the same digits that have been input by the user.
	// For example, when "0111523456789" is input for `AR` country,
	// the extracted `this.nationalSignificantNumber` is "91123456789",
	// which means that the national part of `this.digits` isn't simply equal to
	// `this.nationalPrefix` + `this.nationalSignificantNumber`.
	//
	// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
	// being formatted via `metadata[country].national_prefix_transform_rule`.
	// For example, for `VI` country, it prepends `340` to the national number,
	// and if this check hasn't been implemented, then there would be a bug
	// when `340` "area coude" is "duplicated" during input for `VI` country:
	// https://github.com/catamphetamine/libphonenumber-js/issues/318
	//
	// So, all these "gotchas" are filtered out.
	//
	// In the original Google's code, the comments say:
	// "Check that we didn't remove nor add any extra digits when we matched
	// this formatting pattern. This usually happens after we entered the last
	// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
	// formatted but AYTF should retain all the number entered and not change
	// in order to match a format (of same leading digits and length) display
	// in that way."
	// "If it's the same (i.e entered number and format is same), then it's
	// safe to return this in formatted number as nothing is lost / added."
	// Otherwise, don't use this format.
	// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
	// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
	//
	
	
	function isValidFormattedNationalNumber(formattedNationalNumber, state) {
	  return (0, _parseDigits["default"])(formattedNationalNumber) === state.getNationalDigits();
	}
	//# sourceMappingURL=AsYouTypeFormatter.complete.js.map

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DIGIT_PLACEHOLDER = void 0;
	exports.closeNonPairedParens = closeNonPairedParens;
	exports.countOccurences = countOccurences;
	exports.cutAndStripNonPairedParens = cutAndStripNonPairedParens;
	exports.populateTemplateWithDigits = populateTemplateWithDigits;
	exports.repeat = repeat;
	exports.stripNonPairedParens = stripNonPairedParens;
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	// Should be the same as `DIGIT_PLACEHOLDER` in `libphonenumber-metadata-generator`.
	var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)
	
	exports.DIGIT_PLACEHOLDER = DIGIT_PLACEHOLDER;
	var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER); // Counts all occurences of a symbol in a string.
	// Unicode-unsafe (because using `.split()`).
	
	function countOccurences(symbol, string) {
	  var count = 0; // Using `.split('')` to iterate through a string here
	  // to avoid requiring `Symbol.iterator` polyfill.
	  // `.split('')` is generally not safe for Unicode,
	  // but in this particular case for counting brackets it is safe.
	  // for (const character of string)
	
	  for (var _iterator = _createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
	    var character = _step.value;
	
	    if (character === symbol) {
	      count++;
	    }
	  }
	
	  return count;
	} // Repeats a string (or a symbol) N times.
	// http://stackoverflow.com/questions/202605/repeat-string-javascript
	
	
	function repeat(string, times) {
	  if (times < 1) {
	    return '';
	  }
	
	  var result = '';
	
	  while (times > 1) {
	    if (times & 1) {
	      result += string;
	    }
	
	    times >>= 1;
	    string += string;
	  }
	
	  return result + string;
	}
	
	function cutAndStripNonPairedParens(string, cutBeforeIndex) {
	  if (string[cutBeforeIndex] === ')') {
	    cutBeforeIndex++;
	  }
	
	  return stripNonPairedParens(string.slice(0, cutBeforeIndex));
	}
	
	function closeNonPairedParens(template, cut_before) {
	  var retained_template = template.slice(0, cut_before);
	  var opening_braces = countOccurences('(', retained_template);
	  var closing_braces = countOccurences(')', retained_template);
	  var dangling_braces = opening_braces - closing_braces;
	
	  while (dangling_braces > 0 && cut_before < template.length) {
	    if (template[cut_before] === ')') {
	      dangling_braces--;
	    }
	
	    cut_before++;
	  }
	
	  return template.slice(0, cut_before);
	}
	
	function stripNonPairedParens(string) {
	  var dangling_braces = [];
	  var i = 0;
	
	  while (i < string.length) {
	    if (string[i] === '(') {
	      dangling_braces.push(i);
	    } else if (string[i] === ')') {
	      dangling_braces.pop();
	    }
	
	    i++;
	  }
	
	  var start = 0;
	  var cleared_string = '';
	  dangling_braces.push(string.length);
	
	  for (var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++) {
	    var index = _dangling_braces[_i];
	    cleared_string += string.slice(start, index);
	    start = index + 1;
	  }
	
	  return cleared_string;
	}
	
	function populateTemplateWithDigits(template, position, digits) {
	  // Using `.split('')` to iterate through a string here
	  // to avoid requiring `Symbol.iterator` polyfill.
	  // `.split('')` is generally not safe for Unicode,
	  // but in this particular case for `digits` it is safe.
	  // for (const digit of digits)
	  for (var _iterator2 = _createForOfIteratorHelperLoose(digits.split('')), _step2; !(_step2 = _iterator2()).done;) {
	    var digit = _step2.value;
	
	    // If there is room for more digits in current `template`,
	    // then set the next digit in the `template`,
	    // and return the formatted digits so far.
	    // If more digits are entered than the current format could handle.
	    if (template.slice(position + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
	      return;
	    }
	
	    position = template.search(DIGIT_PLACEHOLDER_MATCHER);
	    template = template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
	  }
	
	  return [template, position];
	}
	//# sourceMappingURL=AsYouTypeFormatter.util.js.map

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	exports.extractFormattedDigitsAndPlus = extractFormattedDigitsAndPlus;
	
	var _extractCountryCallingCode2 = _interopRequireDefault(__webpack_require__(515));
	
	var _extractCountryCallingCodeFromInternationalNumberWithoutPlusSign = _interopRequireDefault(__webpack_require__(322));
	
	var _extractNationalNumberFromPossiblyIncompleteNumber = _interopRequireDefault(__webpack_require__(517));
	
	var _stripIddPrefix = _interopRequireDefault(__webpack_require__(324));
	
	var _parseDigits = _interopRequireDefault(__webpack_require__(120));
	
	var _constants = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + _constants.VALID_PUNCTUATION + _constants.VALID_DIGITS + ']+';
	var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
	var VALID_FORMATTED_PHONE_NUMBER_PART = '(?:' + '[' + _constants.PLUS_CHARS + ']' + '[' + _constants.VALID_PUNCTUATION + _constants.VALID_DIGITS + ']*' + '|' + '[' + _constants.VALID_PUNCTUATION + _constants.VALID_DIGITS + ']+' + ')';
	var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + _constants.VALID_PUNCTUATION + _constants.VALID_DIGITS + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
	// different national prefixes.
	// Matches anything that's not a digit or a square bracket.
	
	var COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;
	
	var AsYouTypeParser = /*#__PURE__*/function () {
	  function AsYouTypeParser(_ref) {
	    var defaultCountry = _ref.defaultCountry,
	        defaultCallingCode = _ref.defaultCallingCode,
	        metadata = _ref.metadata,
	        onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;
	
	    _classCallCheck(this, AsYouTypeParser);
	
	    this.defaultCountry = defaultCountry;
	    this.defaultCallingCode = defaultCallingCode;
	    this.metadata = metadata;
	    this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
	  }
	
	  _createClass(AsYouTypeParser, [{
	    key: "input",
	    value: function input(text, state) {
	      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text),
	          _extractFormattedDigi2 = _slicedToArray(_extractFormattedDigi, 2),
	          formattedDigits = _extractFormattedDigi2[0],
	          hasPlus = _extractFormattedDigi2[1];
	
	      var digits = (0, _parseDigits["default"])(formattedDigits); // Checks for a special case: just a leading `+` has been entered.
	
	      var justLeadingPlus;
	
	      if (hasPlus) {
	        if (!state.digits) {
	          state.startInternationalNumber();
	
	          if (!digits) {
	            justLeadingPlus = true;
	          }
	        }
	      }
	
	      if (digits) {
	        this.inputDigits(digits, state);
	      }
	
	      return {
	        digits: digits,
	        justLeadingPlus: justLeadingPlus
	      };
	    }
	    /**
	     * Inputs "next" phone number digits.
	     * @param  {string} digits
	     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
	     */
	
	  }, {
	    key: "inputDigits",
	    value: function inputDigits(nextDigits, state) {
	      var digits = state.digits;
	      var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.
	
	      state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
	      // Some users input their phone number in international format,
	      // but in an "out-of-country" dialing format instead of using the leading `+`.
	      // https://github.com/catamphetamine/libphonenumber-js/issues/185
	      // Detect such numbers as soon as there're at least 3 digits.
	      // Google's library attempts to extract IDD prefix at 3 digits,
	      // so this library just copies that behavior.
	      // I guess that's because the most commot IDD prefixes are
	      // `00` (Europe) and `011` (US).
	      // There exist really long IDD prefixes too:
	      // for example, in Australia the default IDD prefix is `0011`,
	      // and it could even be as long as `14880011`.
	      // An IDD prefix is extracted here, and then every time when
	      // there's a new digit and the number couldn't be formatted.
	
	      if (hasReceivedThreeLeadingDigits) {
	        this.extractIddPrefix(state);
	      }
	
	      if (this.isWaitingForCountryCallingCode(state)) {
	        if (!this.extractCountryCallingCode(state)) {
	          return;
	        }
	      } else {
	        state.appendNationalSignificantNumberDigits(nextDigits);
	      } // If a phone number is being input in international format,
	      // then it's not valid for it to have a national prefix.
	      // Still, some people incorrectly input such numbers with a national prefix.
	      // In such cases, only attempt to strip a national prefix if the number becomes too long.
	      // (but that is done later, not here)
	
	
	      if (!state.international) {
	        if (!this.hasExtractedNationalSignificantNumber) {
	          this.extractNationalSignificantNumber(state.getNationalDigits(), function (stateUpdate) {
	            return state.update(stateUpdate);
	          });
	        }
	      }
	    }
	  }, {
	    key: "isWaitingForCountryCallingCode",
	    value: function isWaitingForCountryCallingCode(_ref2) {
	      var international = _ref2.international,
	          callingCode = _ref2.callingCode;
	      return international && !callingCode;
	    } // Extracts a country calling code from a number
	    // being entered in internatonal format.
	
	  }, {
	    key: "extractCountryCallingCode",
	    value: function extractCountryCallingCode(state) {
	      var _extractCountryCallin = (0, _extractCountryCallingCode2["default"])('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
	          countryCallingCode = _extractCountryCallin.countryCallingCode,
	          number = _extractCountryCallin.number;
	
	      if (countryCallingCode) {
	        state.setCallingCode(countryCallingCode);
	        state.update({
	          nationalSignificantNumber: number
	        });
	        return true;
	      }
	    }
	  }, {
	    key: "reset",
	    value: function reset(numberingPlan) {
	      if (numberingPlan) {
	        this.hasSelectedNumberingPlan = true;
	
	        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();
	
	        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
	      } else {
	        this.hasSelectedNumberingPlan = undefined;
	        this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
	      }
	    }
	    /**
	     * Extracts a national (significant) number from user input.
	     * Google's library is different in that it only applies `national_prefix_for_parsing`
	     * and doesn't apply `national_prefix_transform_rule` after that.
	     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
	     * @return {boolean} [extracted]
	     */
	
	  }, {
	    key: "extractNationalSignificantNumber",
	    value: function extractNationalSignificantNumber(nationalDigits, setState) {
	      if (!this.hasSelectedNumberingPlan) {
	        return;
	      }
	
	      var _extractNationalNumbe = (0, _extractNationalNumberFromPossiblyIncompleteNumber["default"])(nationalDigits, this.metadata),
	          nationalPrefix = _extractNationalNumbe.nationalPrefix,
	          nationalNumber = _extractNationalNumbe.nationalNumber,
	          carrierCode = _extractNationalNumbe.carrierCode;
	
	      if (nationalNumber === nationalDigits) {
	        return;
	      }
	
	      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
	      return true;
	    }
	    /**
	     * In Google's code this function is called "attempt to extract longer NDD".
	     * "Some national prefixes are a substring of others", they say.
	     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
	     */
	
	  }, {
	    key: "extractAnotherNationalSignificantNumber",
	    value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
	      if (!this.hasExtractedNationalSignificantNumber) {
	        return this.extractNationalSignificantNumber(nationalDigits, setState);
	      }
	
	      if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) {
	        return;
	      }
	
	      var _extractNationalNumbe2 = (0, _extractNationalNumberFromPossiblyIncompleteNumber["default"])(nationalDigits, this.metadata),
	          nationalPrefix = _extractNationalNumbe2.nationalPrefix,
	          nationalNumber = _extractNationalNumbe2.nationalNumber,
	          carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
	      // then it's always extracted as additional digits are added.
	      // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
	      // doesn't do anything different from what it currently does.
	      // So, just in case, here's this check, though it doesn't occur.
	
	      /* istanbul ignore if */
	
	
	      if (nationalNumber === prevNationalSignificantNumber) {
	        return;
	      }
	
	      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
	      return true;
	    }
	  }, {
	    key: "onExtractedNationalNumber",
	    value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
	      var complexPrefixBeforeNationalSignificantNumber;
	      var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.
	
	      var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
	      // last substring of the `digits`, then it means that it hasn't been altered:
	      // no digits have been removed from the national (significant) number
	      // while applying `national_prefix_transform_rule`.
	      // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
	
	      if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
	        nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
	        // as just a basic national prefix, then such prefix is stored in
	        // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
	        // prepended "as is" to the national (significant) number to produce
	        // a formatted result.
	
	        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
	        // because `onExtractedNationalNumber()` isn't called
	        // when a national (significant) number hasn't been actually "extracted":
	        // when a national (significant) number is equal to the national part of `digits`,
	        // then `onExtractedNationalNumber()` doesn't get called.
	
	        if (prefixBeforeNationalNumber !== nationalPrefix) {
	          complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
	        }
	      }
	
	      setState({
	        nationalPrefix: nationalPrefix,
	        carrierCode: carrierCode,
	        nationalSignificantNumber: nationalSignificantNumber,
	        nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
	        complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
	      }); // `onExtractedNationalNumber()` is only called when
	      // the national (significant) number actually did change.
	
	      this.hasExtractedNationalSignificantNumber = true;
	      this.onNationalSignificantNumberChange();
	    }
	  }, {
	    key: "reExtractNationalSignificantNumber",
	    value: function reExtractNationalSignificantNumber(state) {
	      // Attempt to extract a national prefix.
	      //
	      // Some people incorrectly input national prefix
	      // in an international phone number.
	      // For example, some people write British phone numbers as `+44(0)...`.
	      //
	      // Also, in some rare cases, it is valid for a national prefix
	      // to be a part of an international phone number.
	      // For example, mobile phone numbers in Mexico are supposed to be
	      // dialled internationally using a `1` national prefix,
	      // so the national prefix will be part of an international number.
	      //
	      // Quote from:
	      // https://www.mexperience.com/dialing-cell-phones-in-mexico/
	      //
	      // "Dialing a Mexican cell phone from abroad
	      // When you are calling a cell phone number in Mexico from outside Mexico,
	      // it’s necessary to dial an additional “1” after Mexico’s country code
	      // (which is “52”) and before the area code.
	      // You also ignore the 045, and simply dial the area code and the
	      // cell phone’s number.
	      //
	      // If you don’t add the “1”, you’ll receive a recorded announcement
	      // asking you to redial using it.
	      //
	      // For example, if you are calling from the USA to a cell phone
	      // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
	      // (Note that this is different to calling a land line in Mexico City
	      // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
	      //
	      // Google's demo output:
	      // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
	      //
	      if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function (stateUpdate) {
	        return state.update(stateUpdate);
	      })) {
	        return true;
	      } // If no format matches the phone number, then it could be
	      // "a really long IDD" (quote from a comment in Google's library).
	      // An IDD prefix is first extracted when the user has entered at least 3 digits,
	      // and then here — every time when there's a new digit and the number
	      // couldn't be formatted.
	      // For example, in Australia the default IDD prefix is `0011`,
	      // and it could even be as long as `14880011`.
	      //
	      // Could also check `!hasReceivedThreeLeadingDigits` here
	      // to filter out the case when this check duplicates the one
	      // already performed when there're 3 leading digits,
	      // but it's not a big deal, and in most cases there
	      // will be a suitable `format` when there're 3 leading digits.
	      //
	
	
	      if (this.extractIddPrefix(state)) {
	        this.extractCallingCodeAndNationalSignificantNumber(state);
	        return true;
	      } // Google's AsYouType formatter supports sort of an "autocorrection" feature
	      // when it "autocorrects" numbers that have been input for a country
	      // with that country's calling code.
	      // Such "autocorrection" feature looks weird, but different people have been requesting it:
	      // https://github.com/catamphetamine/libphonenumber-js/issues/376
	      // https://github.com/catamphetamine/libphonenumber-js/issues/375
	      // https://github.com/catamphetamine/libphonenumber-js/issues/316
	
	
	      if (this.fixMissingPlus(state)) {
	        this.extractCallingCodeAndNationalSignificantNumber(state);
	        return true;
	      }
	    }
	  }, {
	    key: "extractIddPrefix",
	    value: function extractIddPrefix(state) {
	      // An IDD prefix can't be present in a number written with a `+`.
	      // Also, don't re-extract an IDD prefix if has already been extracted.
	      var international = state.international,
	          IDDPrefix = state.IDDPrefix,
	          digits = state.digits,
	          nationalSignificantNumber = state.nationalSignificantNumber;
	
	      if (international || IDDPrefix) {
	        return;
	      } // Some users input their phone number in "out-of-country"
	      // dialing format instead of using the leading `+`.
	      // https://github.com/catamphetamine/libphonenumber-js/issues/185
	      // Detect such numbers.
	
	
	      var numberWithoutIDD = (0, _stripIddPrefix["default"])(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
	
	      if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
	        // If an IDD prefix was stripped then convert the IDD-prefixed number
	        // to international number for subsequent parsing.
	        state.update({
	          IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
	        });
	        this.startInternationalNumber(state);
	        return true;
	      }
	    }
	  }, {
	    key: "fixMissingPlus",
	    value: function fixMissingPlus(state) {
	      if (!state.international) {
	        var _extractCountryCallin2 = (0, _extractCountryCallingCodeFromInternationalNumberWithoutPlusSign["default"])(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
	            newCallingCode = _extractCountryCallin2.countryCallingCode,
	            number = _extractCountryCallin2.number;
	
	        if (newCallingCode) {
	          state.update({
	            missingPlus: true
	          });
	          this.startInternationalNumber(state);
	          return true;
	        }
	      }
	    }
	  }, {
	    key: "startInternationalNumber",
	    value: function startInternationalNumber(state) {
	      state.startInternationalNumber(); // If a national (significant) number has been extracted before, reset it.
	
	      if (state.nationalSignificantNumber) {
	        state.resetNationalSignificantNumber();
	        this.onNationalSignificantNumberChange();
	        this.hasExtractedNationalSignificantNumber = undefined;
	      }
	    }
	  }, {
	    key: "extractCallingCodeAndNationalSignificantNumber",
	    value: function extractCallingCodeAndNationalSignificantNumber(state) {
	      if (this.extractCountryCallingCode(state)) {
	        // `this.extractCallingCode()` is currently called when the number
	        // couldn't be formatted during the standard procedure.
	        // Normally, the national prefix would be re-extracted
	        // for an international number if such number couldn't be formatted,
	        // but since it's already not able to be formatted,
	        // there won't be yet another retry, so also extract national prefix here.
	        this.extractNationalSignificantNumber(state.getNationalDigits(), function (stateUpdate) {
	          return state.update(stateUpdate);
	        });
	      }
	    }
	  }]);
	
	  return AsYouTypeParser;
	}();
	/**
	 * Extracts formatted phone number from text (if there's any).
	 * @param  {string} text
	 * @return {string} [formattedPhoneNumber]
	 */
	
	
	exports["default"] = AsYouTypeParser;
	
	function extractFormattedPhoneNumber(text) {
	  // Attempt to extract a possible number from the string passed in.
	  var startsAt = text.search(VALID_FORMATTED_PHONE_NUMBER_PART);
	
	  if (startsAt < 0) {
	    return;
	  } // Trim everything to the left of the phone number.
	
	
	  text = text.slice(startsAt); // Trim the `+`.
	
	  var hasPlus;
	
	  if (text[0] === '+') {
	    hasPlus = true;
	    text = text.slice('+'.length);
	  } // Trim everything to the right of the phone number.
	
	
	  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.
	
	  if (hasPlus) {
	    text = '+' + text;
	  }
	
	  return text;
	}
	/**
	 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
	 * @param  {string} text
	 * @return {any[]}
	 */
	
	
	function _extractFormattedDigitsAndPlus(text) {
	  // Extract a formatted phone number part from text.
	  var extractedNumber = extractFormattedPhoneNumber(text) || ''; // Trim a `+`.
	
	  if (extractedNumber[0] === '+') {
	    return [extractedNumber.slice('+'.length), true];
	  }
	
	  return [extractedNumber];
	}
	/**
	 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
	 * @param  {string} text
	 * @return {any[]}
	 */
	
	
	function extractFormattedDigitsAndPlus(text) {
	  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text),
	      _extractFormattedDigi4 = _slicedToArray(_extractFormattedDigi3, 2),
	      formattedDigits = _extractFormattedDigi4[0],
	      hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
	  // can possibly be a part of some valid phone number
	  // then parse phone number characters from a formatted phone number.
	
	
	  if (!VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) {
	    formattedDigits = '';
	  }
	
	  return [formattedDigits, hasPlus];
	}
	//# sourceMappingURL=AsYouTypeParser.js.map

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	var AsYouTypeState = /*#__PURE__*/function () {
	  function AsYouTypeState(_ref) {
	    var onCountryChange = _ref.onCountryChange,
	        onCallingCodeChange = _ref.onCallingCodeChange;
	
	    _classCallCheck(this, AsYouTypeState);
	
	    this.onCountryChange = onCountryChange;
	    this.onCallingCodeChange = onCallingCodeChange;
	  }
	
	  _createClass(AsYouTypeState, [{
	    key: "reset",
	    value: function reset(defaultCountry, defaultCallingCode) {
	      this.international = false;
	      this.IDDPrefix = undefined;
	      this.missingPlus = undefined;
	      this.callingCode = undefined;
	      this.digits = '';
	      this.resetNationalSignificantNumber();
	      this.initCountryAndCallingCode(defaultCountry, defaultCallingCode);
	    }
	  }, {
	    key: "resetNationalSignificantNumber",
	    value: function resetNationalSignificantNumber() {
	      this.nationalSignificantNumber = this.getNationalDigits();
	      this.nationalSignificantNumberMatchesInput = true;
	      this.nationalPrefix = undefined;
	      this.carrierCode = undefined;
	      this.complexPrefixBeforeNationalSignificantNumber = undefined;
	    }
	  }, {
	    key: "update",
	    value: function update(properties) {
	      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
	        var key = _Object$keys[_i];
	        this[key] = properties[key];
	      }
	    }
	  }, {
	    key: "initCountryAndCallingCode",
	    value: function initCountryAndCallingCode(country, callingCode) {
	      this.setCountry(country);
	      this.setCallingCode(callingCode);
	    }
	  }, {
	    key: "setCountry",
	    value: function setCountry(country) {
	      this.country = country;
	      this.onCountryChange(country);
	    }
	  }, {
	    key: "setCallingCode",
	    value: function setCallingCode(callingCode) {
	      this.callingCode = callingCode;
	      return this.onCallingCodeChange(this.country, callingCode);
	    }
	  }, {
	    key: "startInternationalNumber",
	    value: function startInternationalNumber() {
	      // Prepend the `+` to parsed input.
	      this.international = true; // If a default country was set then reset it
	      // because an explicitly international phone
	      // number is being entered.
	
	      this.initCountryAndCallingCode();
	    }
	  }, {
	    key: "appendDigits",
	    value: function appendDigits(nextDigits) {
	      this.digits += nextDigits;
	    }
	  }, {
	    key: "appendNationalSignificantNumberDigits",
	    value: function appendNationalSignificantNumberDigits(nextDigits) {
	      this.nationalSignificantNumber += nextDigits;
	    }
	    /**
	     * Returns the part of `this.digits` that corresponds to the national number.
	     * Basically, all digits that have been input by the user, except for the
	     * international prefix and the country calling code part
	     * (if the number is an international one).
	     * @return {string}
	     */
	
	  }, {
	    key: "getNationalDigits",
	    value: function getNationalDigits() {
	      if (this.international) {
	        return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
	      }
	
	      return this.digits;
	    }
	  }, {
	    key: "getDigitsWithoutInternationalPrefix",
	    value: function getDigitsWithoutInternationalPrefix() {
	      if (this.international) {
	        if (this.IDDPrefix) {
	          return this.digits.slice(this.IDDPrefix.length);
	        }
	      }
	
	      return this.digits;
	    }
	  }]);
	
	  return AsYouTypeState;
	}();
	
	exports["default"] = AsYouTypeState;
	//# sourceMappingURL=AsYouTypeState.js.map

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// https://medium.com/dsinjs/implementing-lru-cache-in-javascript-94ba6755cda9
	var Node = /*#__PURE__*/_createClass(function Node(key, value) {
	  var next = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var prev = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  _classCallCheck(this, Node);
	
	  this.key = key;
	  this.value = value;
	  this.next = next;
	  this.prev = prev;
	});
	
	var LRUCache = /*#__PURE__*/function () {
	  //set default limit of 10 if limit is not passed.
	  function LRUCache() {
	    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
	
	    _classCallCheck(this, LRUCache);
	
	    this.size = 0;
	    this.limit = limit;
	    this.head = null;
	    this.tail = null;
	    this.cache = {};
	  } // Write Node to head of LinkedList
	  // update cache with Node key and Node reference
	
	
	  _createClass(LRUCache, [{
	    key: "put",
	    value: function put(key, value) {
	      this.ensureLimit();
	
	      if (!this.head) {
	        this.head = this.tail = new Node(key, value);
	      } else {
	        var node = new Node(key, value, this.head);
	        this.head.prev = node;
	        this.head = node;
	      } //Update the cache map
	
	
	      this.cache[key] = this.head;
	      this.size++;
	    } // Read from cache map and make that node as new Head of LinkedList
	
	  }, {
	    key: "get",
	    value: function get(key) {
	      if (this.cache[key]) {
	        var value = this.cache[key].value; // node removed from it's position and cache
	
	        this.remove(key); // write node again to the head of LinkedList to make it most recently used
	
	        this.put(key, value);
	        return value;
	      }
	
	      console.log("Item not available in cache for key ".concat(key));
	    }
	  }, {
	    key: "ensureLimit",
	    value: function ensureLimit() {
	      if (this.size === this.limit) {
	        this.remove(this.tail.key);
	      }
	    }
	  }, {
	    key: "remove",
	    value: function remove(key) {
	      var node = this.cache[key];
	
	      if (node.prev !== null) {
	        node.prev.next = node.next;
	      } else {
	        this.head = node.next;
	      }
	
	      if (node.next !== null) {
	        node.next.prev = node.prev;
	      } else {
	        this.tail = node.prev;
	      }
	
	      delete this.cache[key];
	      this.size--;
	    }
	  }, {
	    key: "clear",
	    value: function clear() {
	      this.head = null;
	      this.tail = null;
	      this.size = 0;
	      this.cache = {};
	    } // // Invokes the callback function with every node of the chain and the index of the node.
	    // forEach(fn) {
	    //   let node = this.head;
	    //   let counter = 0;
	    //   while (node) {
	    //     fn(node, counter);
	    //     node = node.next;
	    //     counter++;
	    //   }
	    // }
	    // // To iterate over LRU with a 'for...of' loop
	    // *[Symbol.iterator]() {
	    //   let node = this.head;
	    //   while (node) {
	    //     yield node;
	    //     node = node.next;
	    //   }
	    // }
	
	  }]);
	
	  return LRUCache;
	}();
	
	exports["default"] = LRUCache;
	//# sourceMappingURL=LRUCache.js.map

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.containsMoreThanOneSlashInNationalNumber = containsMoreThanOneSlashInNationalNumber;
	exports["default"] = void 0;
	
	var _validate_ = _interopRequireDefault(__webpack_require__(211));
	
	var _parseDigits = _interopRequireDefault(__webpack_require__(120));
	
	var _util = __webpack_require__(206);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	/**
	 * Leniency when finding potential phone numbers in text segments
	 * The levels here are ordered in increasing strictness.
	 */
	var _default = {
	  /**
	   * Phone numbers accepted are "possible", but not necessarily "valid".
	   */
	  POSSIBLE: function POSSIBLE(number, candidate, metadata) {
	    return true;
	  },
	
	  /**
	   * Phone numbers accepted are "possible" and "valid".
	   * Numbers written in national format must have their national-prefix
	   * present if it is usually written for a number of this type.
	   */
	  VALID: function VALID(number, candidate, metadata) {
	    if (!(0, _validate_["default"])(number, undefined, metadata) || !containsOnlyValidXChars(number, candidate.toString(), metadata)) {
	      return false;
	    } // Skipped for simplicity.
	    // return isNationalPrefixPresentIfRequired(number, metadata)
	
	
	    return true;
	  },
	
	  /**
	   * Phone numbers accepted are "valid" and
	   * are grouped in a possible way for this locale. For example, a US number written as
	   * "65 02 53 00 00" and "650253 0000" are not accepted at this leniency level, whereas
	   * "650 253 0000", "650 2530000" or "6502530000" are.
	   * Numbers with more than one '/' symbol in the national significant number
	   * are also dropped at this level.
	   *
	   * Warning: This level might result in lower coverage especially for regions outside of
	   * country code "+1". If you are not sure about which level to use,
	   * email the discussion group libphonenumber-discuss@googlegroups.com.
	   */
	  STRICT_GROUPING: function STRICT_GROUPING(number, candidate, metadata, regExpCache) {
	    var candidateString = candidate.toString();
	
	    if (!(0, _validate_["default"])(number, undefined, metadata) || !containsOnlyValidXChars(number, candidateString, metadata) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number, metadata)) {
	      return false;
	    }
	
	    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsRemainGrouped, regExpCache);
	  },
	
	  /**
	   * Phone numbers accepted are {@linkplain PhoneNumberUtil#isValidNumber(PhoneNumber) valid} and
	   * are grouped in the same way that we would have formatted it, or as a single block. For
	   * example, a US number written as "650 2530000" is not accepted at this leniency level, whereas
	   * "650 253 0000" or "6502530000" are.
	   * Numbers with more than one '/' symbol are also dropped at this level.
	   * <p>
	   * Warning: This level might result in lower coverage especially for regions outside of country
	   * code "+1". If you are not sure about which level to use, email the discussion group
	   * libphonenumber-discuss@googlegroups.com.
	   */
	  EXACT_GROUPING: function EXACT_GROUPING(number, candidate, metadata, regExpCache) {
	    var candidateString = candidate.toString();
	
	    if (!(0, _validate_["default"])(number, undefined, metadata) || !containsOnlyValidXChars(number, candidateString, metadata) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number, metadata)) {
	      return false;
	    }
	
	    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsAreExactlyPresent, regExpCache);
	  }
	};
	exports["default"] = _default;
	
	function containsOnlyValidXChars(number, candidate, metadata) {
	  // The characters 'x' and 'X' can be (1) a carrier code, in which case they always precede the
	  // national significant number or (2) an extension sign, in which case they always precede the
	  // extension number. We assume a carrier code is more than 1 digit, so the first case has to
	  // have more than 1 consecutive 'x' or 'X', whereas the second case can only have exactly 1 'x'
	  // or 'X'. We ignore the character if it appears as the last character of the string.
	  for (var index = 0; index < candidate.length - 1; index++) {
	    var charAtIndex = candidate.charAt(index);
	
	    if (charAtIndex === 'x' || charAtIndex === 'X') {
	      var charAtNextIndex = candidate.charAt(index + 1);
	
	      if (charAtNextIndex === 'x' || charAtNextIndex === 'X') {
	        // This is the carrier code case, in which the 'X's always precede the national
	        // significant number.
	        index++;
	
	        if (util.isNumberMatch(number, candidate.substring(index)) != MatchType.NSN_MATCH) {
	          return false;
	        } // This is the extension sign case, in which the 'x' or 'X' should always precede the
	        // extension number.
	
	      } else if ((0, _parseDigits["default"])(candidate.substring(index)) !== number.ext) {
	        return false;
	      }
	    }
	  }
	
	  return true;
	}
	
	function isNationalPrefixPresentIfRequired(number, _metadata) {
	  // First, check how we deduced the country code. If it was written in international format, then
	  // the national prefix is not required.
	  if (number.getCountryCodeSource() != 'FROM_DEFAULT_COUNTRY') {
	    return true;
	  }
	
	  var phoneNumberRegion = util.getRegionCodeForCountryCode(number.getCountryCode());
	  var metadata = util.getMetadataForRegion(phoneNumberRegion);
	
	  if (metadata == null) {
	    return true;
	  } // Check if a national prefix should be present when formatting this number.
	
	
	  var nationalNumber = util.getNationalSignificantNumber(number);
	  var formatRule = util.chooseFormattingPatternForNumber(metadata.numberFormats(), nationalNumber); // To do this, we check that a national prefix formatting rule was present
	  // and that it wasn't just the first-group symbol ($1) with punctuation.
	
	  if (formatRule && formatRule.getNationalPrefixFormattingRule().length > 0) {
	    if (formatRule.getNationalPrefixOptionalWhenFormatting()) {
	      // The national-prefix is optional in these cases, so we don't need to check if it was
	      // present.
	      return true;
	    }
	
	    if (PhoneNumberUtil.formattingRuleHasFirstGroupOnly(formatRule.getNationalPrefixFormattingRule())) {
	      // National Prefix not needed for this number.
	      return true;
	    } // Normalize the remainder.
	
	
	    var rawInputCopy = PhoneNumberUtil.normalizeDigitsOnly(number.getRawInput()); // Check if we found a national prefix and/or carrier code at the start of the raw input, and
	    // return the result.
	
	    return util.maybeStripNationalPrefixAndCarrierCode(rawInputCopy, metadata, null);
	  }
	
	  return true;
	}
	
	function containsMoreThanOneSlashInNationalNumber(number, candidate) {
	  var firstSlashInBodyIndex = candidate.indexOf('/');
	
	  if (firstSlashInBodyIndex < 0) {
	    // No slashes, this is okay.
	    return false;
	  } // Now look for a second one.
	
	
	  var secondSlashInBodyIndex = candidate.indexOf('/', firstSlashInBodyIndex + 1);
	
	  if (secondSlashInBodyIndex < 0) {
	    // Only one slash, this is okay.
	    return false;
	  } // If the first slash is after the country calling code, this is permitted.
	
	
	  var candidateHasCountryCode = number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN || number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN;
	
	  if (candidateHasCountryCode && PhoneNumberUtil.normalizeDigitsOnly(candidate.substring(0, firstSlashInBodyIndex)) === String(number.getCountryCode())) {
	    // Any more slashes and this is illegal.
	    return candidate.slice(secondSlashInBodyIndex + 1).indexOf('/') >= 0;
	  }
	
	  return true;
	}
	
	function checkNumberGroupingIsValid(number, candidate, metadata, checkGroups, regExpCache) {
	  var normalizedCandidate = normalizeDigits(candidate, true
	  /* keep non-digits */
	  );
	  var formattedNumberGroups = getNationalNumberGroups(metadata, number, null);
	
	  if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
	    return true;
	  } // If this didn't pass, see if there are any alternate formats that match, and try them instead.
	
	
	  var alternateFormats = MetadataManager.getAlternateFormatsForCountry(number.getCountryCode());
	  var nationalSignificantNumber = util.getNationalSignificantNumber(number);
	
	  if (alternateFormats) {
	    for (var _iterator = _createForOfIteratorHelperLoose(alternateFormats.numberFormats()), _step; !(_step = _iterator()).done;) {
	      var alternateFormat = _step.value;
	
	      if (alternateFormat.leadingDigitsPatterns().length > 0) {
	        // There is only one leading digits pattern for alternate formats.
	        var leadingDigitsRegExp = regExpCache.getPatternForRegExp('^' + alternateFormat.leadingDigitsPatterns()[0]);
	
	        if (!leadingDigitsRegExp.test(nationalSignificantNumber)) {
	          // Leading digits don't match; try another one.
	          continue;
	        }
	      }
	
	      formattedNumberGroups = getNationalNumberGroups(metadata, number, alternateFormat);
	
	      if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	}
	/**
	 * Helper method to get the national-number part of a number, formatted without any national
	 * prefix, and return it as a set of digit blocks that would be formatted together following
	 * standard formatting rules.
	 */
	
	
	function getNationalNumberGroups(metadata, number, formattingPattern) {
	  if (formattingPattern) {
	    // We format the NSN only, and split that according to the separator.
	    var nationalSignificantNumber = util.getNationalSignificantNumber(number);
	    return util.formatNsnUsingPattern(nationalSignificantNumber, formattingPattern, 'RFC3966', metadata).split('-');
	  } // This will be in the format +CC-DG1-DG2-DGX;ext=EXT where DG1..DGX represents groups of digits.
	
	
	  var rfc3966Format = formatNumber(number, 'RFC3966', metadata); // We remove the extension part from the formatted string before splitting it into different
	  // groups.
	
	  var endIndex = rfc3966Format.indexOf(';');
	
	  if (endIndex < 0) {
	    endIndex = rfc3966Format.length;
	  } // The country-code will have a '-' following it.
	
	
	  var startIndex = rfc3966Format.indexOf('-') + 1;
	  return rfc3966Format.slice(startIndex, endIndex).split('-');
	}
	
	function allNumberGroupsAreExactlyPresent(metadata, number, normalizedCandidate, formattedNumberGroups) {
	  var candidateGroups = normalizedCandidate.split(NON_DIGITS_PATTERN); // Set this to the last group, skipping it if the number has an extension.
	
	  var candidateNumberGroupIndex = number.hasExtension() ? candidateGroups.length - 2 : candidateGroups.length - 1; // First we check if the national significant number is formatted as a block.
	  // We use contains and not equals, since the national significant number may be present with
	  // a prefix such as a national number prefix, or the country code itself.
	
	  if (candidateGroups.length == 1 || candidateGroups[candidateNumberGroupIndex].contains(util.getNationalSignificantNumber(number))) {
	    return true;
	  } // Starting from the end, go through in reverse, excluding the first group, and check the
	  // candidate and number groups are the same.
	
	
	  var formattedNumberGroupIndex = formattedNumberGroups.length - 1;
	
	  while (formattedNumberGroupIndex > 0 && candidateNumberGroupIndex >= 0) {
	    if (candidateGroups[candidateNumberGroupIndex] !== formattedNumberGroups[formattedNumberGroupIndex]) {
	      return false;
	    }
	
	    formattedNumberGroupIndex--;
	    candidateNumberGroupIndex--;
	  } // Now check the first group. There may be a national prefix at the start, so we only check
	  // that the candidate group ends with the formatted number group.
	
	
	  return candidateNumberGroupIndex >= 0 && (0, _util.endsWith)(candidateGroups[candidateNumberGroupIndex], formattedNumberGroups[0]);
	}
	
	function allNumberGroupsRemainGrouped(metadata, number, normalizedCandidate, formattedNumberGroups) {
	  var fromIndex = 0;
	
	  if (number.getCountryCodeSource() !== CountryCodeSource.FROM_DEFAULT_COUNTRY) {
	    // First skip the country code if the normalized candidate contained it.
	    var countryCode = String(number.getCountryCode());
	    fromIndex = normalizedCandidate.indexOf(countryCode) + countryCode.length();
	  } // Check each group of consecutive digits are not broken into separate groupings in the
	  // {@code normalizedCandidate} string.
	
	
	  for (var i = 0; i < formattedNumberGroups.length; i++) {
	    // Fails if the substring of {@code normalizedCandidate} starting from {@code fromIndex}
	    // doesn't contain the consecutive digits in formattedNumberGroups[i].
	    fromIndex = normalizedCandidate.indexOf(formattedNumberGroups[i], fromIndex);
	
	    if (fromIndex < 0) {
	      return false;
	    } // Moves {@code fromIndex} forward.
	
	
	    fromIndex += formattedNumberGroups[i].length();
	
	    if (i == 0 && fromIndex < normalizedCandidate.length()) {
	      // We are at the position right after the NDC. We get the region used for formatting
	      // information based on the country code in the phone number, rather than the number itself,
	      // as we do not need to distinguish between different countries with the same country
	      // calling code and this is faster.
	      var region = util.getRegionCodeForCountryCode(number.getCountryCode());
	
	      if (util.getNddPrefixForRegion(region, true) != null && Character.isDigit(normalizedCandidate.charAt(fromIndex))) {
	        // This means there is no formatting symbol after the NDC. In this case, we only
	        // accept the number if there is no formatting symbol at all in the number, except
	        // for extensions. This is only important for countries with national prefixes.
	        var nationalSignificantNumber = util.getNationalSignificantNumber(number);
	        return (0, _util.startsWith)(normalizedCandidate.slice(fromIndex - formattedNumberGroups[i].length), nationalSignificantNumber);
	      }
	    }
	  } // The check here makes sure that we haven't mistakenly already used the extension to
	  // match the last group of the subscriber number. Note the extension cannot have
	  // formatting in-between digits.
	
	
	  return normalizedCandidate.slice(fromIndex).contains(number.getExtension());
	}
	//# sourceMappingURL=Leniency.js.map

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _LRUCache = _interopRequireDefault(__webpack_require__(1338));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	// A cache for frequently used country-specific regular expressions. Set to 32 to cover ~2-3
	// countries being used for the same doc with ~10 patterns for each country. Some pages will have
	// a lot more countries in use, but typically fewer numbers for each so expanding the cache for
	// that use-case won't have a lot of benefit.
	var RegExpCache = /*#__PURE__*/function () {
	  function RegExpCache(size) {
	    _classCallCheck(this, RegExpCache);
	
	    this.cache = new _LRUCache["default"](size);
	  }
	
	  _createClass(RegExpCache, [{
	    key: "getPatternForRegExp",
	    value: function getPatternForRegExp(pattern) {
	      var regExp = this.cache.get(pattern);
	
	      if (!regExp) {
	        regExp = new RegExp('^' + pattern);
	        this.cache.put(pattern, regExp);
	      }
	
	      return regExp;
	    }
	  }]);
	
	  return RegExpCache;
	}();
	
	exports["default"] = RegExpCache;
	//# sourceMappingURL=RegExpCache.js.map

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = findNumbers;
	
	var _PhoneNumberMatcher = _interopRequireDefault(__webpack_require__(319));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function findNumbers(text, options, metadata) {
	  var matcher = new _PhoneNumberMatcher["default"](text, options, metadata);
	  var results = [];
	
	  while (matcher.hasNext()) {
	    results.push(matcher.next());
	  }
	
	  return results;
	}
	//# sourceMappingURL=findNumbers_.js.map

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = formatIncompletePhoneNumber;
	
	var _AsYouType = _interopRequireDefault(__webpack_require__(502));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Formats a (possibly incomplete) phone number.
	 * The phone number can be either in E.164 format
	 * or in a form of national number digits.
	 * @param {string} value - A possibly incomplete phone number. Either in E.164 format or in a form of national number digits.
	 * @param {string?} country - Two-letter ("ISO 3166-1 alpha-2") country code.
	 * @return {string} Formatted (possibly incomplete) phone number.
	 */
	function formatIncompletePhoneNumber(value, country, metadata) {
	  if (!metadata) {
	    metadata = country;
	    country = undefined;
	  }
	
	  return new _AsYouType["default"](country, metadata).input(value);
	}
	//# sourceMappingURL=formatIncompletePhoneNumber.js.map

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getCountries;
	
	var _metadata = _interopRequireDefault(__webpack_require__(43));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getCountries(metadata) {
	  return new _metadata["default"](metadata).getCountries();
	}
	//# sourceMappingURL=getCountries.js.map

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getExampleNumber;
	
	var _PhoneNumber = _interopRequireDefault(__webpack_require__(205));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getExampleNumber(country, examples, metadata) {
	  if (examples[country]) {
	    return new _PhoneNumber["default"](country, examples[country], metadata);
	  }
	}
	//# sourceMappingURL=getExampleNumber.js.map

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = extractExtension;
	
	var _createExtensionPattern = _interopRequireDefault(__webpack_require__(209));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// Regexp of all known extension prefixes used by different regions followed by
	// 1 or more valid digits, for use when parsing.
	var EXTN_PATTERN = new RegExp('(?:' + (0, _createExtensionPattern["default"])() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
	// connected, usually indicated with extn, ext, x or similar) from the end of
	// the number, and returns it.
	
	function extractExtension(number) {
	  var start = number.search(EXTN_PATTERN);
	
	  if (start < 0) {
	    return {};
	  } // If we find a potential extension, and the number preceding this is a viable
	  // number, we assume it is an extension.
	
	
	  var numberWithoutExtension = number.slice(0, start);
	  var matches = number.match(EXTN_PATTERN);
	  var i = 1;
	
	  while (i < matches.length) {
	    if (matches[i]) {
	      return {
	        number: numberWithoutExtension,
	        ext: matches[i]
	      };
	    }
	
	    i++;
	  }
	}
	//# sourceMappingURL=extractExtension.js.map

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getIddPrefix;
	
	var _metadata = _interopRequireDefault(__webpack_require__(43));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Pattern that makes it easy to distinguish whether a region has a single
	 * international dialing prefix or not. If a region has a single international
	 * prefix (e.g. 011 in USA), it will be represented as a string that contains
	 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
	 * the tone. If there are multiple available international prefixes in a
	 * region, they will be represented as a regex string that always contains one
	 * or more characters that are not ASCII digits or a tilde.
	 */
	var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
	// a preferred IDD prefix is returned.
	
	function getIddPrefix(country, callingCode, metadata) {
	  var countryMetadata = new _metadata["default"](metadata);
	  countryMetadata.selectNumberingPlan(country, callingCode);
	
	  if (countryMetadata.defaultIDDPrefix()) {
	    return countryMetadata.defaultIDDPrefix();
	  }
	
	  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
	    return countryMetadata.IDDPrefix();
	  }
	}
	//# sourceMappingURL=getIddPrefix.js.map

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = mergeArrays;
	
	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	/**
	 * Merges two arrays.
	 * @param  {*} a
	 * @param  {*} b
	 * @return {*}
	 */
	function mergeArrays(a, b) {
	  var merged = a.slice();
	
	  for (var _iterator = _createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;) {
	    var element = _step.value;
	
	    if (a.indexOf(element) < 0) {
	      merged.push(element);
	    }
	  }
	
	  return merged.sort(function (a, b) {
	    return a - b;
	  }); // ES6 version, requires Set polyfill.
	  // let merged = new Set(a)
	  // for (const element of b) {
	  // 	merged.add(i)
	  // }
	  // return Array.from(merged).sort((a, b) => a - b)
	}
	//# sourceMappingURL=mergeArrays.js.map

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isPossibleNumber;
	
	var _getNumberType = __webpack_require__(321);
	
	var _isPossibleNumber_ = _interopRequireDefault(__webpack_require__(325));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Checks if a given phone number is possible.
	 * Which means it only checks phone number length
	 * and doesn't test any regular expressions.
	 *
	 * Examples:
	 *
	 * ```js
	 * isPossibleNumber('+78005553535', metadata)
	 * isPossibleNumber('8005553535', 'RU', metadata)
	 * isPossibleNumber('88005553535', 'RU', metadata)
	 * isPossibleNumber({ phone: '8005553535', country: 'RU' }, metadata)
	 * ```
	 */
	function isPossibleNumber() {
	  var _normalizeArguments = (0, _getNumberType.normalizeArguments)(arguments),
	      input = _normalizeArguments.input,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _isPossibleNumber_["default"])(input, options, metadata);
	}
	//# sourceMappingURL=isPossibleNumber.js.map

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isValidNumberForRegion;
	
	var _isViablePhoneNumber = _interopRequireDefault(__webpack_require__(168));
	
	var _parse_ = _interopRequireDefault(__webpack_require__(121));
	
	var _isValidNumberForRegion_ = _interopRequireDefault(__webpack_require__(519));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isValidNumberForRegion(number, country, metadata) {
	  if (typeof number !== 'string') {
	    throw new TypeError('number must be a string');
	  }
	
	  if (typeof country !== 'string') {
	    throw new TypeError('country must be a string');
	  } // `parse` extracts phone numbers from raw text,
	  // therefore it will cut off all "garbage" characters,
	  // while this `validate` function needs to verify
	  // that the phone number contains no "garbage"
	  // therefore the explicit `isViablePhoneNumber` check.
	
	
	  var input;
	
	  if ((0, _isViablePhoneNumber["default"])(number)) {
	    input = (0, _parse_["default"])(number, {
	      defaultCountry: country
	    }, metadata);
	  } else {
	    input = {};
	  }
	
	  return (0, _isValidNumberForRegion_["default"])(input, country, undefined, metadata);
	}
	//# sourceMappingURL=isValidNumberForRegion.js.map

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parsePhoneNumberFromString;
	
	var _parsePhoneNumber_ = _interopRequireDefault(__webpack_require__(522));
	
	var _ParseError = _interopRequireDefault(__webpack_require__(318));
	
	var _metadata = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function parsePhoneNumberFromString(text, options, metadata) {
	  // Validate `defaultCountry`.
	  if (options && options.defaultCountry && !(0, _metadata.isSupportedCountry)(options.defaultCountry, metadata)) {
	    options = _objectSpread(_objectSpread({}, options), {}, {
	      defaultCountry: undefined
	    });
	  } // Parse phone number.
	
	
	  try {
	    return (0, _parsePhoneNumber_["default"])(text, options, metadata);
	  } catch (error) {
	    /* istanbul ignore else */
	    if (error instanceof _ParseError["default"]) {//
	    } else {
	      throw error;
	    }
	  }
	}
	//# sourceMappingURL=parsePhoneNumberFromString_.js.map

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = searchPhoneNumbersInText;
	
	var _searchNumbers = _interopRequireDefault(__webpack_require__(523));
	
	var _findPhoneNumbersInText = __webpack_require__(510);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function searchPhoneNumbersInText(text, defaultCountry, options, metadata) {
	  var args = (0, _findPhoneNumbersInText.getArguments)(defaultCountry, options, metadata);
	  return (0, _searchNumbers["default"])(text, args.options, args.metadata);
	}
	//# sourceMappingURL=searchPhoneNumbersInText.js.map

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	
	// Copy-pasted from:
	// https://github.com/substack/semver-compare/blob/master/index.js
	//
	// Inlining this function because some users reported issues with
	// importing from `semver-compare` in a browser with ES6 "native" modules.
	//
	// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
	// https://github.com/catamphetamine/libphonenumber-js/issues/381
	function _default(a, b) {
	  a = a.split('-');
	  b = b.split('-');
	  var pa = a[0].split('.');
	  var pb = b[0].split('.');
	
	  for (var i = 0; i < 3; i++) {
	    var na = Number(pa[i]);
	    var nb = Number(pb[i]);
	    if (na > nb) return 1;
	    if (nb > na) return -1;
	    if (!isNaN(na) && isNaN(nb)) return 1;
	    if (isNaN(na) && !isNaN(nb)) return -1;
	  }
	
	  if (a[1] && b[1]) {
	    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
	  }
	
	  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
	}
	//# sourceMappingURL=semver-compare.js.map

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isValidNumber;
	
	var _validate_ = _interopRequireDefault(__webpack_require__(211));
	
	var _getNumberType = __webpack_require__(321);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// Finds out national phone number type (fixed line, mobile, etc)
	function isValidNumber() {
	  var _normalizeArguments = (0, _getNumberType.normalizeArguments)(arguments),
	      input = _normalizeArguments.input,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _validate_["default"])(input, options, metadata);
	}
	//# sourceMappingURL=validate.js.map

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var is = __webpack_require__(167);
	var onload = __webpack_require__(809);
	var tick = __webpack_require__(239);
	
	/**
	 * Expose `loadScript`.
	 *
	 * @param {Object} options
	 * @param {Function} fn
	 * @api public
	 */
	
	module.exports = function loadIframe(options, fn){
	  if (!options) throw new Error('Cant load nothing...');
	
	  // Allow for the simplest case, just passing a `src` string.
	  if (is.string(options)) options = { src : options };
	
	  var https = document.location.protocol === 'https:' ||
	              document.location.protocol === 'chrome-extension:';
	
	  // If you use protocol relative URLs, third-party scripts like Google
	  // Analytics break when testing with `file:` so this fixes that.
	  if (options.src && options.src.indexOf('//') === 0) {
	    options.src = https ? 'https:' + options.src : 'http:' + options.src;
	  }
	
	  // Allow them to pass in different URLs depending on the protocol.
	  if (https && options.https) options.src = options.https;
	  else if (!https && options.http) options.src = options.http;
	
	  // Make the `<iframe>` element and insert it before the first iframe on the
	  // page, which is guaranteed to exist since this Javaiframe is running.
	  var iframe = document.createElement('iframe');
	  iframe.src = options.src;
	  iframe.width = options.width || 1;
	  iframe.height = options.height || 1;
	  iframe.style.display = 'none';
	
	  // If we have a fn, attach event handlers, even in IE. Based off of
	  // the Third-Party Javascript script loading example:
	  // https://github.com/thirdpartyjs/thirdpartyjs-code/blob/master/examples/templates/02/loading-files/index.html
	  if (is.fn(fn)) {
	    onload(iframe, fn);
	  }
	
	  tick(function(){
	    // Append after event listeners are attached for IE.
	    var firstScript = document.getElementsByTagName('script')[0];
	    firstScript.parentNode.insertBefore(iframe, firstScript);
	  });
	
	  // Return the iframe element in case they want to do anything special, like
	  // give it an ID or attributes.
	  return iframe;
	};


/***/ }),
/* 1355 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * Creates a base function for methods like `_.forIn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = baseFor;


/***/ }),
/* 1356 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * This method is like `_.assign` except that it iterates over own and
	 * inherited source properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assign
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	 */
	var assignIn = createAssigner(function(object, source) {
	  copyObject(source, keysIn(source), object);
	});
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = assignIn;


/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(122),
	    root = __webpack_require__(53);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1425),
	    hashDelete = __webpack_require__(1426),
	    hashGet = __webpack_require__(1427),
	    hashHas = __webpack_require__(1428),
	    hashSet = __webpack_require__(1429);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(122),
	    root = __webpack_require__(53);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 1361 */
/***/ (function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ }),
/* 1362 */
/***/ (function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ }),
/* 1363 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(549);
	
	/**
	 * Gets the size of an ASCII `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	var asciiSize = baseProperty('length');
	
	module.exports = asciiSize;


/***/ }),
/* 1365 */
/***/ (function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ }),
/* 1366 */
/***/ (function(module, exports) {

	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	module.exports = asciiWords;


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(142);
	
	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1406);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 1370 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}
	
	module.exports = baseHas;


/***/ }),
/* 1371 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(214),
	    equalArrays = __webpack_require__(559),
	    equalByTag = __webpack_require__(1417),
	    equalObjects = __webpack_require__(1418),
	    getTag = __webpack_require__(344),
	    isArray = __webpack_require__(28),
	    isHostObject = __webpack_require__(224),
	    isTypedArray = __webpack_require__(236);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(214),
	    baseIsEqual = __webpack_require__(335);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 1374 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(179),
	    isHostObject = __webpack_require__(224),
	    isMasked = __webpack_require__(1436),
	    isObject = __webpack_require__(52),
	    toSource = __webpack_require__(574);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(52);
	
	/** `Object#toString` result references. */
	var regexpTag = '[object RegExp]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.isRegExp` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 */
	function baseIsRegExp(value) {
	  return isObject(value) && objectToString.call(value) == regexpTag;
	}
	
	module.exports = baseIsRegExp;


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(349),
	    isObjectLike = __webpack_require__(104);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1373),
	    getMatchData = __webpack_require__(1420),
	    matchesStrictComparable = __webpack_require__(567);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(335),
	    get = __webpack_require__(18),
	    hasIn = __webpack_require__(1485),
	    isKey = __webpack_require__(226),
	    isStrictComparable = __webpack_require__(565),
	    matchesStrictComparable = __webpack_require__(567),
	    toKey = __webpack_require__(123);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(214),
	    arrayEach = __webpack_require__(141),
	    assignMergeValue = __webpack_require__(535),
	    baseKeysIn = __webpack_require__(545),
	    baseMergeDeep = __webpack_require__(1381),
	    isArray = __webpack_require__(28),
	    isObject = __webpack_require__(52),
	    isTypedArray = __webpack_require__(236);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  if (!(isArray(source) || isTypedArray(source))) {
	    var props = baseKeysIn(source);
	  }
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  });
	}
	
	module.exports = baseMerge;


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(535),
	    baseClone = __webpack_require__(334),
	    copyArray = __webpack_require__(172),
	    isArguments = __webpack_require__(178),
	    isArray = __webpack_require__(28),
	    isArrayLikeObject = __webpack_require__(233),
	    isFunction = __webpack_require__(179),
	    isObject = __webpack_require__(52),
	    isPlainObject = __webpack_require__(235),
	    isTypedArray = __webpack_require__(236),
	    toPlainObject = __webpack_require__(1506);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    newValue = srcValue;
	    if (isArray(srcValue) || isTypedArray(srcValue)) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	      else {
	        newValue = objValue;
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(101),
	    baseIteratee = __webpack_require__(44),
	    baseMap = __webpack_require__(546),
	    baseSortBy = __webpack_require__(1389),
	    baseUnary = __webpack_require__(171),
	    compareMultiple = __webpack_require__(1400),
	    identity = __webpack_require__(177);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(541);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 1384 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = basePropertyOf;


/***/ }),
/* 1385 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor,
	    nativeRandom = Math.random;
	
	/**
	 * The base implementation of `_.random` without support for returning
	 * floating-point numbers.
	 *
	 * @private
	 * @param {number} lower The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the random number.
	 */
	function baseRandom(lower, upper) {
	  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	}
	
	module.exports = baseRandom;


/***/ }),
/* 1386 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ }),
/* 1387 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(142);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ }),
/* 1389 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ }),
/* 1390 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ }),
/* 1391 */
/***/ (function(module, exports) {

	/**
	 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	 *
	 * @private
	 * @param {Array} props The property identifiers.
	 * @param {Array} values The property values.
	 * @param {Function} assignFunc The function to assign values.
	 * @returns {Object} Returns the new object.
	 */
	function baseZipObject(props, values, assignFunc) {
	  var index = -1,
	      length = props.length,
	      valsLength = values.length,
	      result = {};
	
	  while (++index < length) {
	    var value = index < valsLength ? values[index] : undefined;
	    assignFunc(result, props[index], value);
	  }
	  return result;
	}
	
	module.exports = baseZipObject;


/***/ }),
/* 1392 */
/***/ (function(module, exports) {

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(338);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(1361),
	    arrayReduce = __webpack_require__(217),
	    mapToArray = __webpack_require__(566);
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ }),
/* 1395 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(1362),
	    arrayReduce = __webpack_require__(217),
	    setToArray = __webpack_require__(230);
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(215);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(338);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(144);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(1399);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(339),
	    getSymbols = __webpack_require__(343);
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(53);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 1403 */
/***/ (function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      result++;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(73),
	    isIterateeCall = __webpack_require__(143);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(103);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 1406 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	var createCtor = __webpack_require__(220),
	    root = __webpack_require__(53);
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBind;


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	var castSlice = __webpack_require__(219),
	    hasUnicode = __webpack_require__(173),
	    stringToArray = __webpack_require__(346),
	    toString = __webpack_require__(127);
	
	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);
	
	    var strSymbols = hasUnicode(string)
	      ? stringToArray(string)
	      : undefined;
	
	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);
	
	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);
	
	    return chr[methodName]() + trailing;
	  };
	}
	
	module.exports = createCaseFirst;


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(169),
	    createCtor = __webpack_require__(220),
	    createHybrid = __webpack_require__(557),
	    createRecurry = __webpack_require__(558),
	    getHolder = __webpack_require__(342),
	    replaceHolders = __webpack_require__(229),
	    root = __webpack_require__(53);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurry;


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(44),
	    isArrayLike = __webpack_require__(103),
	    keys = __webpack_require__(126);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	var LodashWrapper = __webpack_require__(328),
	    baseFlatten = __webpack_require__(102),
	    baseRest = __webpack_require__(73),
	    getData = __webpack_require__(341),
	    getFuncName = __webpack_require__(562),
	    isArray = __webpack_require__(28),
	    isLaziable = __webpack_require__(564);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var CURRY_FLAG = 8,
	    PARTIAL_FLAG = 32,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256;
	
	/**
	 * Creates a `_.flow` or `_.flowRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new flow function.
	 */
	function createFlow(fromRight) {
	  return baseRest(function(funcs) {
	    funcs = baseFlatten(funcs, 1);
	
	    var length = funcs.length,
	        index = length,
	        prereq = LodashWrapper.prototype.thru;
	
	    if (fromRight) {
	      funcs.reverse();
	    }
	    while (index--) {
	      var func = funcs[index];
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	        var wrapper = new LodashWrapper([], true);
	      }
	    }
	    index = wrapper ? index : length;
	    while (++index < length) {
	      func = funcs[index];
	
	      var funcName = getFuncName(func),
	          data = funcName == 'wrapper' ? getData(func) : undefined;
	
	      if (data && isLaziable(data[0]) &&
	            data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) &&
	            !data[4].length && data[9] == 1
	          ) {
	        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	      } else {
	        wrapper = (func.length == 1 && isLaziable(func))
	          ? wrapper[funcName]()
	          : wrapper.thru(func);
	      }
	    }
	    return function() {
	      var args = arguments,
	          value = args[0];
	
	      if (wrapper && args.length == 1 &&
	          isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	        return wrapper.plant(value).value();
	      }
	      var index = 0,
	          result = length ? funcs[index].apply(this, args) : value;
	
	      while (++index < length) {
	        result = funcs[index].call(this, result);
	      }
	      return result;
	    };
	  });
	}
	
	module.exports = createFlow;


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(169),
	    arrayMap = __webpack_require__(101),
	    baseFlatten = __webpack_require__(102),
	    baseIteratee = __webpack_require__(44),
	    baseRest = __webpack_require__(73),
	    baseUnary = __webpack_require__(171),
	    isArray = __webpack_require__(28);
	
	/**
	 * Creates a function like `_.over`.
	 *
	 * @private
	 * @param {Function} arrayFunc The function to iterate over iteratees.
	 * @returns {Function} Returns the new over function.
	 */
	function createOver(arrayFunc) {
	  return baseRest(function(iteratees) {
	    iteratees = (iteratees.length == 1 && isArray(iteratees[0]))
	      ? arrayMap(iteratees[0], baseUnary(baseIteratee))
	      : arrayMap(baseFlatten(iteratees, 1), baseUnary(baseIteratee));
	
	    return baseRest(function(args) {
	      var thisArg = this;
	      return arrayFunc(iteratees, function(iteratee) {
	        return apply(iteratee, thisArg, args);
	      });
	    });
	  });
	}
	
	module.exports = createOver;


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(169),
	    createCtor = __webpack_require__(220),
	    root = __webpack_require__(53);
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartial;


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(528),
	    noop = __webpack_require__(145),
	    setToArray = __webpack_require__(230);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	var basePropertyOf = __webpack_require__(1384);
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 'ss'
	};
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	module.exports = deburrLetter;


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(122);
	
	/* Used to set `toString` methods. */
	var defineProperty = (function() {
	  var func = getNative(Object, 'defineProperty'),
	      name = getNative.name;
	
	  return (name && name.length > 2) ? func : undefined;
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(215),
	    Uint8Array = __webpack_require__(529),
	    eq = __webpack_require__(174),
	    equalArrays = __webpack_require__(559),
	    mapToArray = __webpack_require__(566),
	    setToArray = __webpack_require__(230);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(126);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(542),
	    getSymbols = __webpack_require__(343),
	    keys = __webpack_require__(126);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(565),
	    keys = __webpack_require__(126);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(216),
	    getPrototype = __webpack_require__(223),
	    getSymbols = __webpack_require__(343),
	    stubArray = __webpack_require__(592);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbol properties
	 * of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 1422 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 1423 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	module.exports = getWrapDetails;


/***/ }),
/* 1424 */
/***/ (function(module, exports) {

	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	module.exports = hasUnicodeWord;


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(228);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	module.exports = hashClear;


/***/ }),
/* 1426 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	module.exports = hashDelete;


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(228);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(228);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(228);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 1430 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(338),
	    cloneDataView = __webpack_require__(1393),
	    cloneMap = __webpack_require__(1394),
	    cloneRegExp = __webpack_require__(1395),
	    cloneSet = __webpack_require__(1396),
	    cloneSymbol = __webpack_require__(1397),
	    cloneTypedArray = __webpack_require__(1398);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(170),
	    getPrototype = __webpack_require__(223),
	    isPrototype = __webpack_require__(227);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 1433 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length,
	      lastIndex = length - 1;
	
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	module.exports = insertWrapDetails;


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(215),
	    isArguments = __webpack_require__(178),
	    isArray = __webpack_require__(28);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 1435 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1402);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 1437 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(218);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(218);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(218);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(218);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1359),
	    ListCache = __webpack_require__(213),
	    Map = __webpack_require__(329);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(222);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(222);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(222);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(222);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(555),
	    composeArgsRight = __webpack_require__(556),
	    replaceHolders = __webpack_require__(229);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	    ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ }),
/* 1448 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 1449 */
/***/ (function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(172),
	    isIndex = __webpack_require__(225);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ }),
/* 1451 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 1452 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(213);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	module.exports = stackClear;


/***/ }),
/* 1454 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	module.exports = stackDelete;


/***/ }),
/* 1455 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 1456 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(213),
	    Map = __webpack_require__(329),
	    MapCache = __webpack_require__(330);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiSize = __webpack_require__(1364),
	    hasUnicode = __webpack_require__(173),
	    unicodeSize = __webpack_require__(1459);
	
	/**
	 * Gets the number of symbols in `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the string size.
	 */
	function stringSize(string) {
	  return hasUnicode(string)
	    ? unicodeSize(string)
	    : asciiSize(string);
	}
	
	module.exports = stringSize;


/***/ }),
/* 1459 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Gets the size of a Unicode `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	function unicodeSize(string) {
	  var result = reUnicode.lastIndex = 0;
	  while (reUnicode.test(string)) {
	    result++;
	  }
	  return result;
	}
	
	module.exports = unicodeSize;


/***/ }),
/* 1460 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ }),
/* 1461 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
	  rsUpper + '+' + rsOptUpperContr,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	module.exports = unicodeWords;


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(141),
	    arrayIncludes = __webpack_require__(332);
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256,
	    FLIP_FLAG = 512;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', ARY_FLAG],
	  ['bind', BIND_FLAG],
	  ['bindKey', BIND_KEY_FLAG],
	  ['curry', CURRY_FLAG],
	  ['curryRight', CURRY_RIGHT_FLAG],
	  ['flip', FLIP_FLAG],
	  ['partial', PARTIAL_FLAG],
	  ['partialRight', PARTIAL_RIGHT_FLAG],
	  ['rearg', REARG_FLAG]
	];
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	module.exports = updateWrapDetails;


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(327),
	    LodashWrapper = __webpack_require__(328),
	    copyArray = __webpack_require__(172);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(221);
	
	/** Used to compose bitmasks for function metadata. */
	var ARY_FLAG = 128;
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments,
	 * ignoring any additional arguments.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} [n=func.length] The arity cap.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new capped function.
	 * @example
	 *
	 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	 * // => [6, 8, 10]
	 */
	function ary(func, n, guard) {
	  n = guard ? undefined : n;
	  n = (func && n == null) ? func.length : n;
	  return createWrap(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	}
	
	module.exports = ary;


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(106);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that invokes `func`, with the `this` binding and arguments
	 * of the created function, while it's called less than `n` times. Subsequent
	 * calls to the created function return the result of the last `func` invocation.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {number} n The number of calls at which `func` is no longer invoked.
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * jQuery(element).on('click', _.before(5, addContactToList));
	 * // => Allows adding up to 4 contacts to the list.
	 */
	function before(n, func) {
	  var result;
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  n = toInteger(n);
	  return function() {
	    if (--n > 0) {
	      result = func.apply(this, arguments);
	    }
	    if (n <= 1) {
	      func = undefined;
	    }
	    return result;
	  };
	}
	
	module.exports = before;


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(127),
	    upperFirst = __webpack_require__(30);
	
	/**
	 * Converts the first character of `string` to upper case and the remaining
	 * to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to capitalize.
	 * @returns {string} Returns the capitalized string.
	 * @example
	 *
	 * _.capitalize('FRED');
	 * // => 'Fred'
	 */
	function capitalize(string) {
	  return upperFirst(toString(string).toLowerCase());
	}
	
	module.exports = capitalize;


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(28);
	
	/**
	 * Casts `value` as an array if it's not one.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.4.0
	 * @category Lang
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast array.
	 * @example
	 *
	 * _.castArray(1);
	 * // => [1]
	 *
	 * _.castArray({ 'a': 1 });
	 * // => [{ 'a': 1 }]
	 *
	 * _.castArray('abc');
	 * // => ['abc']
	 *
	 * _.castArray(null);
	 * // => [null]
	 *
	 * _.castArray(undefined);
	 * // => [undefined]
	 *
	 * _.castArray();
	 * // => []
	 *
	 * var array = [1, 2, 3];
	 * console.log(_.castArray(array) === array);
	 * // => true
	 */
	function castArray() {
	  if (!arguments.length) {
	    return [];
	  }
	  var value = arguments[0];
	  return isArray(value) ? value : [value];
	}
	
	module.exports = castArray;


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(334);
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value, false, true);
	}
	
	module.exports = clone;


/***/ }),
/* 1469 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(221);
	
	/** Used to compose bitmasks for function metadata. */
	var CURRY_FLAG = 8;
	
	/**
	 * Creates a function that accepts arguments of `func` and either invokes
	 * `func` returning its result, if at least `arity` number of arguments have
	 * been provided, or returns a function that accepts the remaining `func`
	 * arguments, and so on. The arity of `func` may be specified if `func.length`
	 * is not sufficient.
	 *
	 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curry(abc);
	 *
	 * curried(1)(2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(1)(_, 3)(2);
	 * // => [1, 2, 3]
	 */
	function curry(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrap(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curry.placeholder;
	  return result;
	}
	
	// Assign default placeholders.
	curry.placeholder = {};
	
	module.exports = curry;


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	var deburrLetter = __webpack_require__(1415),
	    toString = __webpack_require__(127);
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0';
	
	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']';
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1475);


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(1363),
	    baseEvery = __webpack_require__(1367),
	    baseIteratee = __webpack_require__(44),
	    isArray = __webpack_require__(28),
	    isIterateeCall = __webpack_require__(143);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * **Note:** This method returns `true` for
	 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	 * elements of empty collections.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = every;


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(102);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array ? array.length : 0;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(141),
	    baseEach = __webpack_require__(142),
	    baseIteratee = __webpack_require__(44),
	    isArray = __webpack_require__(28);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _([1, 2]).forEach(function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = forEach;


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	var mapping = __webpack_require__(1477),
	    mutateMap = mapping.mutate,
	    fallbackHolder = __webpack_require__(56);
	
	/**
	 * Creates a function, with an arity of `n`, that invokes `func` with the
	 * arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} n The arity of the new function.
	 * @returns {Function} Returns the new function.
	 */
	function baseArity(func, n) {
	  return n == 2
	    ? function(a, b) { return func.apply(undefined, arguments); }
	    : function(a) { return func.apply(undefined, arguments); };
	}
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
	 * any additional arguments.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} n The arity cap.
	 * @returns {Function} Returns the new function.
	 */
	function baseAry(func, n) {
	  return n == 2
	    ? function(a, b) { return func(a, b); }
	    : function(a) { return func(a); };
	}
	
	/**
	 * Creates a clone of `array`.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the cloned array.
	 */
	function cloneArray(array) {
	  var length = array ? array.length : 0,
	      result = Array(length);
	
	  while (length--) {
	    result[length] = array[length];
	  }
	  return result;
	}
	
	/**
	 * Creates a function that clones a given object using the assignment `func`.
	 *
	 * @private
	 * @param {Function} func The assignment function.
	 * @returns {Function} Returns the new cloner function.
	 */
	function createCloner(func) {
	  return function(object) {
	    return func({}, object);
	  };
	}
	
	/**
	 * Creates a function that wraps `func` and uses `cloner` to clone the first
	 * argument it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} cloner The function to clone arguments.
	 * @returns {Function} Returns the new immutable function.
	 */
	function wrapImmutable(func, cloner) {
	  return function() {
	    var length = arguments.length;
	    if (!length) {
	      return;
	    }
	    var args = Array(length);
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var result = args[0] = cloner.apply(undefined, args);
	    func.apply(undefined, args);
	    return result;
	  };
	}
	
	/**
	 * The base implementation of `convert` which accepts a `util` object of methods
	 * required to perform conversions.
	 *
	 * @param {Object} util The util object.
	 * @param {string} name The name of the function to convert.
	 * @param {Function} func The function to convert.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
	 * @param {boolean} [options.curry=true] Specify currying.
	 * @param {boolean} [options.fixed=true] Specify fixed arity.
	 * @param {boolean} [options.immutable=true] Specify immutable operations.
	 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function baseConvert(util, name, func, options) {
	  var setPlaceholder,
	      isLib = typeof name == 'function',
	      isObj = name === Object(name);
	
	  if (isObj) {
	    options = func;
	    func = name;
	    name = undefined;
	  }
	  if (func == null) {
	    throw new TypeError;
	  }
	  options || (options = {});
	
	  var config = {
	    'cap': 'cap' in options ? options.cap : true,
	    'curry': 'curry' in options ? options.curry : true,
	    'fixed': 'fixed' in options ? options.fixed : true,
	    'immutable': 'immutable' in options ? options.immutable : true,
	    'rearg': 'rearg' in options ? options.rearg : true
	  };
	
	  var forceCurry = ('curry' in options) && options.curry,
	      forceFixed = ('fixed' in options) && options.fixed,
	      forceRearg = ('rearg' in options) && options.rearg,
	      placeholder = isLib ? func : fallbackHolder,
	      pristine = isLib ? func.runInContext() : undefined;
	
	  var helpers = isLib ? func : {
	    'ary': util.ary,
	    'assign': util.assign,
	    'clone': util.clone,
	    'curry': util.curry,
	    'forEach': util.forEach,
	    'isArray': util.isArray,
	    'isFunction': util.isFunction,
	    'iteratee': util.iteratee,
	    'keys': util.keys,
	    'rearg': util.rearg,
	    'spread': util.spread,
	    'toInteger': util.toInteger,
	    'toPath': util.toPath
	  };
	
	  var ary = helpers.ary,
	      assign = helpers.assign,
	      clone = helpers.clone,
	      curry = helpers.curry,
	      each = helpers.forEach,
	      isArray = helpers.isArray,
	      isFunction = helpers.isFunction,
	      keys = helpers.keys,
	      rearg = helpers.rearg,
	      spread = helpers.spread,
	      toInteger = helpers.toInteger,
	      toPath = helpers.toPath;
	
	  var aryMethodKeys = keys(mapping.aryMethod);
	
	  var wrappers = {
	    'castArray': function(castArray) {
	      return function() {
	        var value = arguments[0];
	        return isArray(value)
	          ? castArray(cloneArray(value))
	          : castArray.apply(undefined, arguments);
	      };
	    },
	    'iteratee': function(iteratee) {
	      return function() {
	        var func = arguments[0],
	            arity = arguments[1],
	            result = iteratee(func, arity),
	            length = result.length;
	
	        if (config.cap && typeof arity == 'number') {
	          arity = arity > 2 ? (arity - 2) : 1;
	          return (length && length <= arity) ? result : baseAry(result, arity);
	        }
	        return result;
	      };
	    },
	    'mixin': function(mixin) {
	      return function(source) {
	        var func = this;
	        if (!isFunction(func)) {
	          return mixin(func, Object(source));
	        }
	        var pairs = [];
	        each(keys(source), function(key) {
	          if (isFunction(source[key])) {
	            pairs.push([key, func.prototype[key]]);
	          }
	        });
	
	        mixin(func, Object(source));
	
	        each(pairs, function(pair) {
	          var value = pair[1];
	          if (isFunction(value)) {
	            func.prototype[pair[0]] = value;
	          } else {
	            delete func.prototype[pair[0]];
	          }
	        });
	        return func;
	      };
	    },
	    'nthArg': function(nthArg) {
	      return function(n) {
	        var arity = n < 0 ? 1 : (toInteger(n) + 1);
	        return curry(nthArg(n), arity);
	      };
	    },
	    'rearg': function(rearg) {
	      return function(func, indexes) {
	        var arity = indexes ? indexes.length : 0;
	        return curry(rearg(func, indexes), arity);
	      };
	    },
	    'runInContext': function(runInContext) {
	      return function(context) {
	        return baseConvert(util, runInContext(context), options);
	      };
	    }
	  };
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Casts `func` to a function with an arity capped iteratee if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCap(name, func) {
	    if (config.cap) {
	      var indexes = mapping.iterateeRearg[name];
	      if (indexes) {
	        return iterateeRearg(func, indexes);
	      }
	      var n = !isLib && mapping.iterateeAry[name];
	      if (n) {
	        return iterateeAry(func, n);
	      }
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to a curried function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCurry(name, func, n) {
	    return (forceCurry || (config.curry && n > 1))
	      ? curry(func, n)
	      : func;
	  }
	
	  /**
	   * Casts `func` to a fixed arity function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the cast function.
	   */
	  function castFixed(name, func, n) {
	    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
	      var data = mapping.methodSpread[name],
	          start = data && data.start;
	
	      return start  === undefined ? ary(func, n) : spread(func, start);
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to an rearged function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castRearg(name, func, n) {
	    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
	      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
	      : func;
	  }
	
	  /**
	   * Creates a clone of `object` by `path`.
	   *
	   * @private
	   * @param {Object} object The object to clone.
	   * @param {Array|string} path The path to clone by.
	   * @returns {Object} Returns the cloned object.
	   */
	  function cloneByPath(object, path) {
	    path = toPath(path);
	
	    var index = -1,
	        length = path.length,
	        lastIndex = length - 1,
	        result = clone(Object(object)),
	        nested = result;
	
	    while (nested != null && ++index < length) {
	      var key = path[index],
	          value = nested[key];
	
	      if (value != null) {
	        nested[path[index]] = clone(index == lastIndex ? value : Object(value));
	      }
	      nested = nested[key];
	    }
	    return result;
	  }
	
	  /**
	   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
	   * version with conversion `options` applied.
	   *
	   * @param {Object} [options] The options object. See `baseConvert` for more details.
	   * @returns {Function} Returns the converted `lodash`.
	   */
	  function convertLib(options) {
	    return _.runInContext.convert(options)(undefined);
	  }
	
	  /**
	   * Create a converter function for `func` of `name`.
	   *
	   * @param {string} name The name of the function to convert.
	   * @param {Function} func The function to convert.
	   * @returns {Function} Returns the new converter function.
	   */
	  function createConverter(name, func) {
	    var oldOptions = options;
	    return function(options) {
	      var newUtil = isLib ? pristine : helpers,
	          newFunc = isLib ? pristine[name] : func,
	          newOptions = assign(assign({}, oldOptions), options);
	
	      return baseConvert(newUtil, name, newFunc, newOptions);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
	   * arguments, ignoring any additional arguments.
	   *
	   * @private
	   * @param {Function} func The function to cap iteratee arguments for.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeAry(func, n) {
	    return overArg(func, function(func) {
	      return typeof func == 'function' ? baseAry(func, n) : func;
	    });
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee with arguments
	   * arranged according to the specified `indexes` where the argument value at
	   * the first index is provided as the first argument, the argument value at
	   * the second index is provided as the second argument, and so on.
	   *
	   * @private
	   * @param {Function} func The function to rearrange iteratee arguments for.
	   * @param {number[]} indexes The arranged argument indexes.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeRearg(func, indexes) {
	    return overArg(func, function(func) {
	      var n = indexes.length;
	      return baseArity(rearg(baseAry(func, n), indexes), n);
	    });
	  }
	
	  /**
	   * Creates a function that invokes `func` with its first argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function() {
	      var length = arguments.length;
	      if (!length) {
	        return func();
	      }
	      var args = Array(length);
	      while (length--) {
	        args[length] = arguments[length];
	      }
	      var index = config.rearg ? 0 : (length - 1);
	      args[index] = transform(args[index]);
	      return func.apply(undefined, args);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` and applys the conversions
	   * rules by `name`.
	   *
	   * @private
	   * @param {string} name The name of the function to wrap.
	   * @param {Function} func The function to wrap.
	   * @returns {Function} Returns the converted function.
	   */
	  function wrap(name, func) {
	    name = mapping.aliasToReal[name] || name;
	
	    var result,
	        wrapped = func,
	        wrapper = wrappers[name];
	
	    if (wrapper) {
	      wrapped = wrapper(func);
	    }
	    else if (config.immutable) {
	      if (mutateMap.array[name]) {
	        wrapped = wrapImmutable(func, cloneArray);
	      }
	      else if (mutateMap.object[name]) {
	        wrapped = wrapImmutable(func, createCloner(func));
	      }
	      else if (mutateMap.set[name]) {
	        wrapped = wrapImmutable(func, cloneByPath);
	      }
	    }
	    each(aryMethodKeys, function(aryKey) {
	      each(mapping.aryMethod[aryKey], function(otherName) {
	        if (name == otherName) {
	          var spreadData = mapping.methodSpread[name],
	              afterRearg = spreadData && spreadData.afterRearg;
	
	          result = afterRearg
	            ? castFixed(name, castRearg(name, wrapped, aryKey), aryKey)
	            : castRearg(name, castFixed(name, wrapped, aryKey), aryKey);
	
	          result = castCap(name, result);
	          result = castCurry(name, result, aryKey);
	          return false;
	        }
	      });
	      return !result;
	    });
	
	    result || (result = wrapped);
	    if (result == func) {
	      result = forceCurry ? curry(result, 1) : function() {
	        return func.apply(this, arguments);
	      };
	    }
	    result.convert = createConverter(name, func);
	    if (mapping.placeholder[name]) {
	      setPlaceholder = true;
	      result.placeholder = func.placeholder = placeholder;
	    }
	    return result;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  if (!isObj) {
	    return wrap(name, func);
	  }
	  var _ = func;
	
	  // Convert methods by ary cap.
	  var pairs = [];
	  each(aryMethodKeys, function(aryKey) {
	    each(mapping.aryMethod[aryKey], function(key) {
	      var func = _[mapping.remap[key] || key];
	      if (func) {
	        pairs.push([key, wrap(key, func)]);
	      }
	    });
	  });
	
	  // Convert remaining methods.
	  each(keys(_), function(key) {
	    var func = _[key];
	    if (typeof func == 'function') {
	      var length = pairs.length;
	      while (length--) {
	        if (pairs[length][0] == key) {
	          return;
	        }
	      }
	      func.convert = createConverter(key, func);
	      pairs.push([key, func]);
	    }
	  });
	
	  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
	  each(pairs, function(pair) {
	    _[pair[0]] = pair[1];
	  });
	
	  _.convert = convertLib;
	  if (setPlaceholder) {
	    _.placeholder = placeholder;
	  }
	  // Assign aliases.
	  each(keys(_), function(key) {
	    each(mapping.realToAlias[key] || [], function(alias) {
	      _[alias] = _[key];
	    });
	  });
	
	  return _;
	}
	
	module.exports = baseConvert;


/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	/** Used to map aliases to their real names. */
	exports.aliasToReal = {
	
	  // Lodash aliases.
	  'each': 'forEach',
	  'eachRight': 'forEachRight',
	  'entries': 'toPairs',
	  'entriesIn': 'toPairsIn',
	  'extend': 'assignIn',
	  'extendAll': 'assignInAll',
	  'extendAllWith': 'assignInAllWith',
	  'extendWith': 'assignInWith',
	  'first': 'head',
	
	  // Methods that are curried variants of others.
	  'conforms': 'conformsTo',
	  'matches': 'isMatch',
	  'property': 'get',
	
	  // Ramda aliases.
	  '__': 'placeholder',
	  'F': 'stubFalse',
	  'T': 'stubTrue',
	  'all': 'every',
	  'allPass': 'overEvery',
	  'always': 'constant',
	  'any': 'some',
	  'anyPass': 'overSome',
	  'apply': 'spread',
	  'assoc': 'set',
	  'assocPath': 'set',
	  'complement': 'negate',
	  'compose': 'flowRight',
	  'contains': 'includes',
	  'dissoc': 'unset',
	  'dissocPath': 'unset',
	  'dropLast': 'dropRight',
	  'dropLastWhile': 'dropRightWhile',
	  'equals': 'isEqual',
	  'identical': 'eq',
	  'indexBy': 'keyBy',
	  'init': 'initial',
	  'invertObj': 'invert',
	  'juxt': 'over',
	  'omitAll': 'omit',
	  'nAry': 'ary',
	  'path': 'get',
	  'pathEq': 'matchesProperty',
	  'pathOr': 'getOr',
	  'paths': 'at',
	  'pickAll': 'pick',
	  'pipe': 'flow',
	  'pluck': 'map',
	  'prop': 'get',
	  'propEq': 'matchesProperty',
	  'propOr': 'getOr',
	  'props': 'at',
	  'symmetricDifference': 'xor',
	  'symmetricDifferenceBy': 'xorBy',
	  'symmetricDifferenceWith': 'xorWith',
	  'takeLast': 'takeRight',
	  'takeLastWhile': 'takeRightWhile',
	  'unapply': 'rest',
	  'unnest': 'flatten',
	  'useWith': 'overArgs',
	  'where': 'conformsTo',
	  'whereEq': 'isMatch',
	  'zipObj': 'zipObject'
	};
	
	/** Used to map ary to method names. */
	exports.aryMethod = {
	  '1': [
	    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
	    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
	    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
	    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
	    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
	    'uniqueId', 'words', 'zipAll'
	  ],
	  '2': [
	    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
	    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
	    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
	    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
	    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
	    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
	    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
	    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
	    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
	    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
	    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
	    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
	    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
	    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
	    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
	    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
	    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
	    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
	    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
	    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
	    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
	    'zipObjectDeep'
	  ],
	  '3': [
	    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
	    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
	    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
	    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
	    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
	    'padCharsStart', 'pullAllBy', 'pullAllWith', 'reduce', 'reduceRight', 'replace',
	    'set', 'slice', 'sortedIndexBy', 'sortedLastIndexBy', 'transform', 'unionBy',
	    'unionWith', 'update', 'xorBy', 'xorWith', 'zipWith'
	  ],
	  '4': [
	    'fill', 'setWith', 'updateWith'
	  ]
	};
	
	/** Used to map ary to rearg configs. */
	exports.aryRearg = {
	  '2': [1, 0],
	  '3': [2, 0, 1],
	  '4': [3, 2, 0, 1]
	};
	
	/** Used to map method names to their iteratee ary. */
	exports.iterateeAry = {
	  'dropRightWhile': 1,
	  'dropWhile': 1,
	  'every': 1,
	  'filter': 1,
	  'find': 1,
	  'findFrom': 1,
	  'findIndex': 1,
	  'findIndexFrom': 1,
	  'findKey': 1,
	  'findLast': 1,
	  'findLastFrom': 1,
	  'findLastIndex': 1,
	  'findLastIndexFrom': 1,
	  'findLastKey': 1,
	  'flatMap': 1,
	  'flatMapDeep': 1,
	  'flatMapDepth': 1,
	  'forEach': 1,
	  'forEachRight': 1,
	  'forIn': 1,
	  'forInRight': 1,
	  'forOwn': 1,
	  'forOwnRight': 1,
	  'map': 1,
	  'mapKeys': 1,
	  'mapValues': 1,
	  'partition': 1,
	  'reduce': 2,
	  'reduceRight': 2,
	  'reject': 1,
	  'remove': 1,
	  'some': 1,
	  'takeRightWhile': 1,
	  'takeWhile': 1,
	  'times': 1,
	  'transform': 2
	};
	
	/** Used to map method names to iteratee rearg configs. */
	exports.iterateeRearg = {
	  'mapKeys': [1]
	};
	
	/** Used to map method names to rearg configs. */
	exports.methodRearg = {
	  'assignInAllWith': [1, 2, 0],
	  'assignInWith': [1, 2, 0],
	  'assignAllWith': [1, 2, 0],
	  'assignWith': [1, 2, 0],
	  'differenceBy': [1, 2, 0],
	  'differenceWith': [1, 2, 0],
	  'getOr': [2, 1, 0],
	  'intersectionBy': [1, 2, 0],
	  'intersectionWith': [1, 2, 0],
	  'isEqualWith': [1, 2, 0],
	  'isMatchWith': [2, 1, 0],
	  'mergeAllWith': [1, 2, 0],
	  'mergeWith': [1, 2, 0],
	  'padChars': [2, 1, 0],
	  'padCharsEnd': [2, 1, 0],
	  'padCharsStart': [2, 1, 0],
	  'pullAllBy': [2, 1, 0],
	  'pullAllWith': [2, 1, 0],
	  'setWith': [3, 1, 2, 0],
	  'sortedIndexBy': [2, 1, 0],
	  'sortedLastIndexBy': [2, 1, 0],
	  'unionBy': [1, 2, 0],
	  'unionWith': [1, 2, 0],
	  'updateWith': [3, 1, 2, 0],
	  'xorBy': [1, 2, 0],
	  'xorWith': [1, 2, 0],
	  'zipWith': [1, 2, 0]
	};
	
	/** Used to map method names to spread configs. */
	exports.methodSpread = {
	  'assignAll': { 'start': 0 },
	  'assignAllWith': { 'afterRearg': true, 'start': 1 },
	  'assignInAll': { 'start': 0 },
	  'assignInAllWith': { 'afterRearg': true, 'start': 1 },
	  'defaultsAll': { 'start': 0 },
	  'defaultsDeepAll': { 'start': 0 },
	  'invokeArgs': { 'start': 2 },
	  'invokeArgsMap': { 'start': 2 },
	  'mergeAll': { 'start': 0 },
	  'mergeAllWith': { 'afterRearg': true, 'start': 1 },
	  'partial': { 'start': 1 },
	  'partialRight': { 'start': 1 },
	  'without': { 'start': 1 },
	  'zipAll': { 'start': 0 }
	};
	
	/** Used to identify methods which mutate arrays or objects. */
	exports.mutate = {
	  'array': {
	    'fill': true,
	    'pull': true,
	    'pullAll': true,
	    'pullAllBy': true,
	    'pullAllWith': true,
	    'pullAt': true,
	    'remove': true,
	    'reverse': true
	  },
	  'object': {
	    'assign': true,
	    'assignAll': true,
	    'assignAllWith': true,
	    'assignIn': true,
	    'assignInAll': true,
	    'assignInAllWith': true,
	    'assignInWith': true,
	    'assignWith': true,
	    'defaults': true,
	    'defaultsAll': true,
	    'defaultsDeep': true,
	    'defaultsDeepAll': true,
	    'merge': true,
	    'mergeAll': true,
	    'mergeAllWith': true,
	    'mergeWith': true,
	  },
	  'set': {
	    'set': true,
	    'setWith': true,
	    'unset': true,
	    'update': true,
	    'updateWith': true
	  }
	};
	
	/** Used to track methods with placeholder support */
	exports.placeholder = {
	  'bind': true,
	  'bindKey': true,
	  'curry': true,
	  'curryRight': true,
	  'partial': true,
	  'partialRight': true
	};
	
	/** Used to map real names to their aliases. */
	exports.realToAlias = (function() {
	  var hasOwnProperty = Object.prototype.hasOwnProperty,
	      object = exports.aliasToReal,
	      result = {};
	
	  for (var key in object) {
	    var value = object[key];
	    if (hasOwnProperty.call(result, value)) {
	      result[value].push(key);
	    } else {
	      result[value] = [key];
	    }
	  }
	  return result;
	}());
	
	/** Used to map method names to other names. */
	exports.remap = {
	  'assignAll': 'assign',
	  'assignAllWith': 'assignWith',
	  'assignInAll': 'assignIn',
	  'assignInAllWith': 'assignInWith',
	  'curryN': 'curry',
	  'curryRightN': 'curryRight',
	  'defaultsAll': 'defaults',
	  'defaultsDeepAll': 'defaultsDeep',
	  'findFrom': 'find',
	  'findIndexFrom': 'findIndex',
	  'findLastFrom': 'findLast',
	  'findLastIndexFrom': 'findLastIndex',
	  'getOr': 'get',
	  'includesFrom': 'includes',
	  'indexOfFrom': 'indexOf',
	  'invokeArgs': 'invoke',
	  'invokeArgsMap': 'invokeMap',
	  'lastIndexOfFrom': 'lastIndexOf',
	  'mergeAll': 'merge',
	  'mergeAllWith': 'mergeWith',
	  'padChars': 'pad',
	  'padCharsEnd': 'padEnd',
	  'padCharsStart': 'padStart',
	  'propertyOf': 'get',
	  'restFrom': 'rest',
	  'spreadFrom': 'spread',
	  'trimChars': 'trim',
	  'trimCharsEnd': 'trimEnd',
	  'trimCharsStart': 'trimStart',
	  'zipAll': 'zip'
	};
	
	/** Used to track methods that skip fixing their arity. */
	exports.skipFixed = {
	  'castArray': true,
	  'flow': true,
	  'flowRight': true,
	  'iteratee': true,
	  'mixin': true,
	  'rearg': true,
	  'runInContext': true
	};
	
	/** Used to track methods that skip rearranging arguments. */
	exports.skipRearg = {
	  'add': true,
	  'assign': true,
	  'assignIn': true,
	  'bind': true,
	  'bindKey': true,
	  'concat': true,
	  'difference': true,
	  'divide': true,
	  'eq': true,
	  'gt': true,
	  'gte': true,
	  'isEqual': true,
	  'lt': true,
	  'lte': true,
	  'matchesProperty': true,
	  'merge': true,
	  'multiply': true,
	  'overArgs': true,
	  'partial': true,
	  'partialRight': true,
	  'propertyOf': true,
	  'random': true,
	  'range': true,
	  'rangeRight': true,
	  'subtract': true,
	  'zip': true,
	  'zipObject': true,
	  'zipObjectDeep': true
	};


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  'ary': __webpack_require__(1464),
	  'assign': __webpack_require__(536),
	  'clone': __webpack_require__(1468),
	  'curry': __webpack_require__(1470),
	  'forEach': __webpack_require__(141),
	  'isArray': __webpack_require__(28),
	  'isFunction': __webpack_require__(179),
	  'iteratee': __webpack_require__(1489),
	  'keys': __webpack_require__(544),
	  'rearg': __webpack_require__(1498),
	  'spread': __webpack_require__(1501),
	  'toInteger': __webpack_require__(106),
	  'toPath': __webpack_require__(1505)
	};


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(61),
	    func = convert('filter', __webpack_require__(175));
	
	func.placeholder = __webpack_require__(56);
	module.exports = func;


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(61),
	    func = convert('pick', __webpack_require__(180));
	
	func.placeholder = __webpack_require__(56);
	module.exports = func;


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(61),
	    func = convert('reject', __webpack_require__(1499));
	
	func.placeholder = __webpack_require__(56);
	module.exports = func;


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(61),
	    func = convert('sumBy', __webpack_require__(352));
	
	func.placeholder = __webpack_require__(56);
	module.exports = func;


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(61),
	    func = convert('transform', __webpack_require__(1507));
	
	func.placeholder = __webpack_require__(56);
	module.exports = func;


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(61),
	    func = convert('zipObject', __webpack_require__(1515));
	
	func.placeholder = __webpack_require__(56);
	module.exports = func;


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1371),
	    hasPath = __webpack_require__(563);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(104);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a boolean primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	 * @example
	 *
	 * _.isBoolean(false);
	 * // => true
	 *
	 * _.isBoolean(null);
	 * // => false
	 */
	function isBoolean(value) {
	  return value === true || value === false ||
	    (isObjectLike(value) && objectToString.call(value) == boolTag);
	}
	
	module.exports = isBoolean;


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(335);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are **not** supported.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(104);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && objectToString.call(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(334),
	    baseIteratee = __webpack_require__(44);
	
	/**
	 * Creates a function that invokes `func` with the arguments of the created
	 * function. If `func` is a property name, the created function returns the
	 * property value for a given element. If `func` is an array or object, the
	 * created function returns `true` for elements that contain the equivalent
	 * source properties, otherwise it returns `false`.
	 *
	 * @static
	 * @since 4.0.0
	 * @memberOf _
	 * @category Util
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @returns {Function} Returns the callback.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, _.iteratee(['user', 'fred']));
	 * // => [{ 'user': 'fred', 'age': 40 }]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, _.iteratee('user'));
	 * // => ['barney', 'fred']
	 *
	 * // Create custom iteratee shorthands.
	 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	 *     return func.test(string);
	 *   };
	 * });
	 *
	 * _.filter(['abc', 'def'], /ef/);
	 * // => ['def']
	 */
	function iteratee(func) {
	  return baseIteratee(typeof func == 'function' ? func : baseClone(func, true));
	}
	
	module.exports = iteratee;


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(340);
	
	/**
	 * Converts `string`, as space separated words, to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the lower cased string.
	 * @example
	 *
	 * _.lowerCase('--Foo-Bar--');
	 * // => 'foo bar'
	 *
	 * _.lowerCase('fooBar');
	 * // => 'foo bar'
	 *
	 * _.lowerCase('__FOO_BAR__');
	 * // => 'foo bar'
	 */
	var lowerCase = createCompounder(function(result, word, index) {
	  return result + (index ? ' ' : '') + word.toLowerCase();
	});
	
	module.exports = lowerCase;


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(330);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(1380),
	    createAssigner = __webpack_require__(1404);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	var before = __webpack_require__(1465);
	
	/**
	 * Creates a function that is restricted to invoking `func` once. Repeat calls
	 * to the function return the value of the first invocation. The `func` is
	 * invoked with the `this` binding and arguments of the created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * var initialize = _.once(createApplication);
	 * initialize();
	 * initialize();
	 * // => `createApplication` is invoked once
	 */
	function once(func) {
	  return before(2, func);
	}
	
	module.exports = once;


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(101),
	    createOver = __webpack_require__(1412);
	
	/**
	 * Creates a function that invokes `iteratees` with the arguments it receives
	 * and returns their results.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to invoke.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var func = _.over([Math.max, Math.min]);
	 *
	 * func(1, 2, 3, 4);
	 * // => [4, 1]
	 */
	var over = createOver(arrayMap);
	
	module.exports = over;


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(73),
	    createWrap = __webpack_require__(221),
	    getHolder = __webpack_require__(342),
	    replaceHolders = __webpack_require__(229);
	
	/** Used to compose bitmasks for function metadata. */
	var PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * This method is like `_.partial` except that partially applied arguments
	 * are appended to the arguments it receives.
	 *
	 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * function greet(greeting, name) {
	 *   return greeting + ' ' + name;
	 * }
	 *
	 * var greetFred = _.partialRight(greet, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 *
	 * // Partially applied with placeholders.
	 * var sayHelloTo = _.partialRight(greet, 'hello', _);
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 */
	var partialRight = baseRest(function(func, partials) {
	  var holders = replaceHolders(partials, getHolder(partialRight));
	  return createWrap(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partialRight.placeholder = {};
	
	module.exports = partialRight;


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(549),
	    basePropertyDeep = __webpack_require__(1383),
	    isKey = __webpack_require__(226),
	    toKey = __webpack_require__(123);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRandom = __webpack_require__(1385),
	    isIterateeCall = __webpack_require__(143),
	    toFinite = __webpack_require__(593);
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseFloat = parseFloat;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min,
	    nativeRandom = Math.random;
	
	/**
	 * Produces a random number between the inclusive `lower` and `upper` bounds.
	 * If only one argument is provided a number between `0` and the given number
	 * is returned. If `floating` is `true`, or either `lower` or `upper` are
	 * floats, a floating-point number is returned instead of an integer.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.7.0
	 * @category Number
	 * @param {number} [lower=0] The lower bound.
	 * @param {number} [upper=1] The upper bound.
	 * @param {boolean} [floating] Specify returning a floating-point number.
	 * @returns {number} Returns the random number.
	 * @example
	 *
	 * _.random(0, 5);
	 * // => an integer between 0 and 5
	 *
	 * _.random(5);
	 * // => also an integer between 0 and 5
	 *
	 * _.random(5, true);
	 * // => a floating-point number between 0 and 5
	 *
	 * _.random(1.2, 5.2);
	 * // => a floating-point number between 1.2 and 5.2
	 */
	function random(lower, upper, floating) {
	  if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	    upper = floating = undefined;
	  }
	  if (floating === undefined) {
	    if (typeof upper == 'boolean') {
	      floating = upper;
	      upper = undefined;
	    }
	    else if (typeof lower == 'boolean') {
	      floating = lower;
	      lower = undefined;
	    }
	  }
	  if (lower === undefined && upper === undefined) {
	    lower = 0;
	    upper = 1;
	  }
	  else {
	    lower = toFinite(lower);
	    if (upper === undefined) {
	      upper = lower;
	      lower = 0;
	    } else {
	      upper = toFinite(upper);
	    }
	  }
	  if (lower > upper) {
	    var temp = lower;
	    lower = upper;
	    upper = temp;
	  }
	  if (floating || lower % 1 || upper % 1) {
	    var rand = nativeRandom();
	    return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	  }
	  return baseRandom(lower, upper);
	}
	
	module.exports = random;


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(102),
	    baseRest = __webpack_require__(73),
	    createWrap = __webpack_require__(221);
	
	/** Used to compose bitmasks for function metadata. */
	var REARG_FLAG = 256;
	
	/**
	 * Creates a function that invokes `func` with arguments arranged according
	 * to the specified `indexes` where the argument value at the first index is
	 * provided as the first argument, the argument value at the second index is
	 * provided as the second argument, and so on.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to rearrange arguments for.
	 * @param {...(number|number[])} indexes The arranged argument indexes.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var rearged = _.rearg(function(a, b, c) {
	 *   return [a, b, c];
	 * }, [2, 0, 1]);
	 *
	 * rearged('b', 'c', 'a')
	 * // => ['a', 'b', 'c']
	 */
	var rearg = baseRest(function(func, indexes) {
	  return createWrap(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes, 1));
	});
	
	module.exports = rearg;


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(531),
	    baseFilter = __webpack_require__(538),
	    baseIteratee = __webpack_require__(44),
	    isArray = __webpack_require__(28),
	    negate = __webpack_require__(238);
	
	/**
	 * The opposite of `_.filter`; this method returns the elements of `collection`
	 * that `predicate` does **not** return truthy for.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.filter
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': true }
	 * ];
	 *
	 * _.reject(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.reject(users, { 'age': 40, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.reject(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.reject(users, 'active');
	 * // => objects for ['barney']
	 */
	function reject(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, negate(baseIteratee(predicate, 3)));
	}
	
	module.exports = reject;


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(337),
	    castSlice = __webpack_require__(219),
	    hasUnicode = __webpack_require__(173),
	    isIterateeCall = __webpack_require__(143),
	    isRegExp = __webpack_require__(586),
	    stringToArray = __webpack_require__(346),
	    toString = __webpack_require__(127);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Splits `string` by `separator`.
	 *
	 * **Note:** This method is based on
	 * [`String#split`](https://mdn.io/String/split).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to split.
	 * @param {RegExp|string} separator The separator pattern to split by.
	 * @param {number} [limit] The length to truncate results to.
	 * @returns {Array} Returns the string segments.
	 * @example
	 *
	 * _.split('a-b-c', '-', 2);
	 * // => ['a', 'b']
	 */
	function split(string, separator, limit) {
	  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	    separator = limit = undefined;
	  }
	  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	  if (!limit) {
	    return [];
	  }
	  string = toString(string);
	  if (string && (
	        typeof separator == 'string' ||
	        (separator != null && !isRegExp(separator))
	      )) {
	    separator = baseToString(separator);
	    if (!separator && hasUnicode(string)) {
	      return castSlice(stringToArray(string), 0, limit);
	    }
	  }
	  return string.split(separator, limit);
	}
	
	module.exports = split;


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(169),
	    arrayPush = __webpack_require__(216),
	    baseRest = __webpack_require__(73),
	    castSlice = __webpack_require__(219),
	    toInteger = __webpack_require__(106);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * create function and an array of arguments much like
	 * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	 *
	 * **Note:** This method is based on the
	 * [spread operator](https://mdn.io/spread_operator).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.2.0
	 * @category Function
	 * @param {Function} func The function to spread arguments over.
	 * @param {number} [start=0] The start position of the spread.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.spread(function(who, what) {
	 *   return who + ' says ' + what;
	 * });
	 *
	 * say(['fred', 'hello']);
	 * // => 'fred says hello'
	 *
	 * var numbers = Promise.all([
	 *   Promise.resolve(40),
	 *   Promise.resolve(36)
	 * ]);
	 *
	 * numbers.then(_.spread(function(x, y) {
	 *   return x + y;
	 * }));
	 * // => a Promise of 76
	 */
	function spread(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
	  return baseRest(function(args) {
	    var array = args[start],
	        otherArgs = castSlice(args, 0, start);
	
	    if (array) {
	      arrayPush(otherArgs, array);
	    }
	    return apply(func, this, otherArgs);
	  });
	}
	
	module.exports = spread;


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(340),
	    upperFirst = __webpack_require__(30);
	
	/**
	 * Converts `string` to
	 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.1.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the start cased string.
	 * @example
	 *
	 * _.startCase('--foo-bar--');
	 * // => 'Foo Bar'
	 *
	 * _.startCase('fooBar');
	 * // => 'Foo Bar'
	 *
	 * _.startCase('__FOO_BAR__');
	 * // => 'FOO BAR'
	 */
	var startCase = createCompounder(function(result, word, index) {
	  return result + (index ? ' ' : '') + upperFirst(word);
	});
	
	module.exports = startCase;


/***/ }),
/* 1503 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(44),
	    baseTimes = __webpack_require__(551),
	    toInteger = __webpack_require__(106);
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Invokes the iteratee `n` times, returning an array of the results of
	 * each invocation. The iteratee is invoked with one argument; (index).
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 * @example
	 *
	 * _.times(3, String);
	 * // => ['0', '1', '2']
	 *
	 *  _.times(4, _.constant(0));
	 * // => [0, 0, 0, 0]
	 */
	function times(n, iteratee) {
	  n = toInteger(n);
	  if (n < 1 || n > MAX_SAFE_INTEGER) {
	    return [];
	  }
	  var index = MAX_ARRAY_LENGTH,
	      length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	  iteratee = baseIteratee(iteratee);
	  n -= MAX_ARRAY_LENGTH;
	
	  var result = baseTimes(length, iteratee);
	  while (++index < n) {
	    iteratee(index);
	  }
	  return result;
	}
	
	module.exports = times;


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(101),
	    copyArray = __webpack_require__(172),
	    isArray = __webpack_require__(28),
	    isSymbol = __webpack_require__(144),
	    stringToPath = __webpack_require__(573),
	    toKey = __webpack_require__(123);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(value));
	}
	
	module.exports = toPath;


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(339),
	    keysIn = __webpack_require__(589);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(141),
	    baseCreate = __webpack_require__(170),
	    baseForOwn = __webpack_require__(540),
	    baseIteratee = __webpack_require__(44),
	    getPrototype = __webpack_require__(223),
	    isArray = __webpack_require__(28),
	    isFunction = __webpack_require__(179),
	    isObject = __webpack_require__(52),
	    isTypedArray = __webpack_require__(236);
	
	/**
	 * An alternative to `_.reduce`; this method transforms `object` to a new
	 * `accumulator` object which is the result of running each of its own
	 * enumerable string keyed properties thru `iteratee`, with each invocation
	 * potentially mutating the `accumulator` object. If `accumulator` is not
	 * provided, a new object with the same `[[Prototype]]` will be used. The
	 * iteratee is invoked with four arguments: (accumulator, value, key, object).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The custom accumulator value.
	 * @returns {*} Returns the accumulated value.
	 * @example
	 *
	 * _.transform([2, 3, 4], function(result, n) {
	 *   result.push(n *= n);
	 *   return n % 2 == 0;
	 * }, []);
	 * // => [4, 9]
	 *
	 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] }
	 */
	function transform(object, iteratee, accumulator) {
	  var isArr = isArray(object) || isTypedArray(object);
	  iteratee = baseIteratee(iteratee, 4);
	
	  if (accumulator == null) {
	    if (isArr || isObject(object)) {
	      var Ctor = object.constructor;
	      if (isArr) {
	        accumulator = isArray(object) ? new Ctor : [];
	      } else {
	        accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	      }
	    } else {
	      accumulator = {};
	    }
	  }
	  (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	    return iteratee(accumulator, value, index, object);
	  });
	  return accumulator;
	}
	
	module.exports = transform;


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(337),
	    castSlice = __webpack_require__(219),
	    hasUnicode = __webpack_require__(173),
	    isObject = __webpack_require__(52),
	    isRegExp = __webpack_require__(586),
	    stringSize = __webpack_require__(1458),
	    stringToArray = __webpack_require__(346),
	    toInteger = __webpack_require__(106),
	    toString = __webpack_require__(127);
	
	/** Used as default options for `_.truncate`. */
	var DEFAULT_TRUNC_LENGTH = 30,
	    DEFAULT_TRUNC_OMISSION = '...';
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Truncates `string` if it's longer than the given maximum string length.
	 * The last characters of the truncated string are replaced with the omission
	 * string which defaults to "...".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to truncate.
	 * @param {Object} [options={}] The options object.
	 * @param {number} [options.length=30] The maximum string length.
	 * @param {string} [options.omission='...'] The string to indicate text is omitted.
	 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	 * @returns {string} Returns the truncated string.
	 * @example
	 *
	 * _.truncate('hi-diddly-ho there, neighborino');
	 * // => 'hi-diddly-ho there, neighbo...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'length': 24,
	 *   'separator': ' '
	 * });
	 * // => 'hi-diddly-ho there,...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'length': 24,
	 *   'separator': /,? +/
	 * });
	 * // => 'hi-diddly-ho there...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'omission': ' [...]'
	 * });
	 * // => 'hi-diddly-ho there, neig [...]'
	 */
	function truncate(string, options) {
	  var length = DEFAULT_TRUNC_LENGTH,
	      omission = DEFAULT_TRUNC_OMISSION;
	
	  if (isObject(options)) {
	    var separator = 'separator' in options ? options.separator : separator;
	    length = 'length' in options ? toInteger(options.length) : length;
	    omission = 'omission' in options ? baseToString(options.omission) : omission;
	  }
	  string = toString(string);
	
	  var strLength = string.length;
	  if (hasUnicode(string)) {
	    var strSymbols = stringToArray(string);
	    strLength = strSymbols.length;
	  }
	  if (length >= strLength) {
	    return string;
	  }
	  var end = length - stringSize(omission);
	  if (end < 1) {
	    return omission;
	  }
	  var result = strSymbols
	    ? castSlice(strSymbols, 0, end).join('')
	    : string.slice(0, end);
	
	  if (separator === undefined) {
	    return result + omission;
	  }
	  if (strSymbols) {
	    end += (result.length - end);
	  }
	  if (isRegExp(separator)) {
	    if (string.slice(end).search(separator)) {
	      var match,
	          substring = result;
	
	      if (!separator.global) {
	        separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	      }
	      separator.lastIndex = 0;
	      while ((match = separator.exec(substring))) {
	        var newEnd = match.index;
	      }
	      result = result.slice(0, newEnd === undefined ? end : newEnd);
	    }
	  } else if (string.indexOf(baseToString(separator), end) != end) {
	    var index = result.lastIndexOf(separator);
	    if (index > -1) {
	      result = result.slice(0, index);
	    }
	  }
	  return result + omission;
	}
	
	module.exports = truncate;


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(102),
	    baseIteratee = __webpack_require__(44),
	    baseRest = __webpack_require__(73),
	    baseUniq = __webpack_require__(552),
	    isArrayLikeObject = __webpack_require__(233),
	    last = __webpack_require__(237);
	
	/**
	 * This method is like `_.union` except that it accepts `iteratee` which is
	 * invoked for each element of each `arrays` to generate the criterion by
	 * which uniqueness is computed. Result values are chosen from the first
	 * array in which the value occurs. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function} [iteratee=_.identity]
	 *  The iteratee invoked per element.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	var unionBy = baseRest(function(arrays) {
	  var iteratee = last(arrays);
	  if (isArrayLikeObject(iteratee)) {
	    iteratee = undefined;
	  }
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2));
	});
	
	module.exports = unionBy;


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(44),
	    baseUniq = __webpack_require__(552);
	
	/**
	 * This method is like `_.uniq` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * uniqueness is computed. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee=_.identity]
	 *  The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniqBy(array, iteratee) {
	  return (array && array.length)
	    ? baseUniq(array, baseIteratee(iteratee, 2))
	    : [];
	}
	
	module.exports = uniqBy;


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(340);
	
	/**
	 * Converts `string`, as space separated words, to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the upper cased string.
	 * @example
	 *
	 * _.upperCase('--foo-bar');
	 * // => 'FOO BAR'
	 *
	 * _.upperCase('fooBar');
	 * // => 'FOO BAR'
	 *
	 * _.upperCase('__foo_bar__');
	 * // => 'FOO BAR'
	 */
	var upperCase = createCompounder(function(result, word, index) {
	  return result + (index ? ' ' : '') + word.toUpperCase();
	});
	
	module.exports = upperCase;


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(537),
	    baseRest = __webpack_require__(73),
	    isArrayLikeObject = __webpack_require__(233);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.pull`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiWords = __webpack_require__(1366),
	    hasUnicodeWord = __webpack_require__(1424),
	    toString = __webpack_require__(127),
	    unicodeWords = __webpack_require__(1461);
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = words;


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(327),
	    LodashWrapper = __webpack_require__(328),
	    baseLodash = __webpack_require__(336),
	    isArray = __webpack_require__(28),
	    isObjectLike = __webpack_require__(104),
	    wrapperClone = __webpack_require__(1463);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array of at least `200` elements
	 * and any iteratees accept only one argument. The heuristic for whether a
	 * section qualifies for shortcut fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(333),
	    baseZipObject = __webpack_require__(1391);
	
	/**
	 * This method is like `_.fromPairs` except that it accepts two arrays,
	 * one of property identifiers and one of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.4.0
	 * @category Array
	 * @param {Array} [props=[]] The property identifiers.
	 * @param {Array} [values=[]] The property values.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * _.zipObject(['a', 'b'], [1, 2]);
	 * // => { 'a': 1, 'b': 2 }
	 */
	function zipObject(props, values) {
	  return baseZipObject(props || [], values || [], assignValue);
	}
	
	module.exports = zipObject;


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.10
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else if (typeof module === 'object' && module.exports) {
			module.exports = factory(require('moment')); // Node
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Do not load moment-timezone a second time.
		if (moment.tz !== undefined) {
			logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
			return moment;
		}
	
		var VERSION = "0.5.10",
			zones = {},
			links = {},
			names = {},
			guesses = {},
			cachedGuess,
	
			momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.offset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			return b.zone.population - a.zone.population;
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName){
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				if (split[5]) {
					addToGuesses(normalized, split[2].split(' '));
				}
			}
		}
	
		function getZone (name, caller) {
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			return !!(m._a && (m._tzm === undefined));
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.offset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					mom.utcOffset(-offset, keepTime);
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name) {
			if (name) {
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName = abbrWrap(fn.zoneName);
		fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
		fn.utc      = resetZoneWrap(fn.utc);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 595,
		"./af.js": 595,
		"./ar": 602,
		"./ar-dz": 596,
		"./ar-dz.js": 596,
		"./ar-kw": 597,
		"./ar-kw.js": 597,
		"./ar-ly": 598,
		"./ar-ly.js": 598,
		"./ar-ma": 599,
		"./ar-ma.js": 599,
		"./ar-sa": 600,
		"./ar-sa.js": 600,
		"./ar-tn": 601,
		"./ar-tn.js": 601,
		"./ar.js": 602,
		"./az": 603,
		"./az.js": 603,
		"./be": 604,
		"./be.js": 604,
		"./bg": 605,
		"./bg.js": 605,
		"./bm": 606,
		"./bm.js": 606,
		"./bn": 608,
		"./bn-bd": 607,
		"./bn-bd.js": 607,
		"./bn.js": 608,
		"./bo": 609,
		"./bo.js": 609,
		"./br": 610,
		"./br.js": 610,
		"./bs": 611,
		"./bs.js": 611,
		"./ca": 612,
		"./ca.js": 612,
		"./cs": 613,
		"./cs.js": 613,
		"./cv": 614,
		"./cv.js": 614,
		"./cy": 615,
		"./cy.js": 615,
		"./da": 616,
		"./da.js": 616,
		"./de": 619,
		"./de-at": 617,
		"./de-at.js": 617,
		"./de-ch": 618,
		"./de-ch.js": 618,
		"./de.js": 619,
		"./dv": 620,
		"./dv.js": 620,
		"./el": 621,
		"./el.js": 621,
		"./en-au": 622,
		"./en-au.js": 622,
		"./en-ca": 623,
		"./en-ca.js": 623,
		"./en-gb": 624,
		"./en-gb.js": 624,
		"./en-ie": 625,
		"./en-ie.js": 625,
		"./en-il": 626,
		"./en-il.js": 626,
		"./en-in": 627,
		"./en-in.js": 627,
		"./en-nz": 628,
		"./en-nz.js": 628,
		"./en-sg": 629,
		"./en-sg.js": 629,
		"./eo": 630,
		"./eo.js": 630,
		"./es": 634,
		"./es-do": 631,
		"./es-do.js": 631,
		"./es-mx": 632,
		"./es-mx.js": 632,
		"./es-us": 633,
		"./es-us.js": 633,
		"./es.js": 634,
		"./et": 635,
		"./et.js": 635,
		"./eu": 636,
		"./eu.js": 636,
		"./fa": 637,
		"./fa.js": 637,
		"./fi": 638,
		"./fi.js": 638,
		"./fil": 639,
		"./fil.js": 639,
		"./fo": 640,
		"./fo.js": 640,
		"./fr": 643,
		"./fr-ca": 641,
		"./fr-ca.js": 641,
		"./fr-ch": 642,
		"./fr-ch.js": 642,
		"./fr.js": 643,
		"./fy": 644,
		"./fy.js": 644,
		"./ga": 645,
		"./ga.js": 645,
		"./gd": 646,
		"./gd.js": 646,
		"./gl": 647,
		"./gl.js": 647,
		"./gom-deva": 648,
		"./gom-deva.js": 648,
		"./gom-latn": 649,
		"./gom-latn.js": 649,
		"./gu": 650,
		"./gu.js": 650,
		"./he": 651,
		"./he.js": 651,
		"./hi": 652,
		"./hi.js": 652,
		"./hr": 653,
		"./hr.js": 653,
		"./hu": 654,
		"./hu.js": 654,
		"./hy-am": 655,
		"./hy-am.js": 655,
		"./id": 656,
		"./id.js": 656,
		"./is": 657,
		"./is.js": 657,
		"./it": 659,
		"./it-ch": 658,
		"./it-ch.js": 658,
		"./it.js": 659,
		"./ja": 660,
		"./ja.js": 660,
		"./jv": 661,
		"./jv.js": 661,
		"./ka": 662,
		"./ka.js": 662,
		"./kk": 663,
		"./kk.js": 663,
		"./km": 664,
		"./km.js": 664,
		"./kn": 665,
		"./kn.js": 665,
		"./ko": 666,
		"./ko.js": 666,
		"./ku": 667,
		"./ku.js": 667,
		"./ky": 668,
		"./ky.js": 668,
		"./lb": 669,
		"./lb.js": 669,
		"./lo": 670,
		"./lo.js": 670,
		"./lt": 671,
		"./lt.js": 671,
		"./lv": 672,
		"./lv.js": 672,
		"./me": 673,
		"./me.js": 673,
		"./mi": 674,
		"./mi.js": 674,
		"./mk": 675,
		"./mk.js": 675,
		"./ml": 676,
		"./ml.js": 676,
		"./mn": 677,
		"./mn.js": 677,
		"./mr": 678,
		"./mr.js": 678,
		"./ms": 680,
		"./ms-my": 679,
		"./ms-my.js": 679,
		"./ms.js": 680,
		"./mt": 681,
		"./mt.js": 681,
		"./my": 682,
		"./my.js": 682,
		"./nb": 683,
		"./nb.js": 683,
		"./ne": 684,
		"./ne.js": 684,
		"./nl": 686,
		"./nl-be": 685,
		"./nl-be.js": 685,
		"./nl.js": 686,
		"./nn": 687,
		"./nn.js": 687,
		"./oc-lnc": 688,
		"./oc-lnc.js": 688,
		"./pa-in": 689,
		"./pa-in.js": 689,
		"./pl": 690,
		"./pl.js": 690,
		"./pt": 692,
		"./pt-br": 691,
		"./pt-br.js": 691,
		"./pt.js": 692,
		"./ro": 693,
		"./ro.js": 693,
		"./ru": 694,
		"./ru.js": 694,
		"./sd": 695,
		"./sd.js": 695,
		"./se": 696,
		"./se.js": 696,
		"./si": 697,
		"./si.js": 697,
		"./sk": 698,
		"./sk.js": 698,
		"./sl": 699,
		"./sl.js": 699,
		"./sq": 700,
		"./sq.js": 700,
		"./sr": 702,
		"./sr-cyrl": 701,
		"./sr-cyrl.js": 701,
		"./sr.js": 702,
		"./ss": 703,
		"./ss.js": 703,
		"./sv": 704,
		"./sv.js": 704,
		"./sw": 705,
		"./sw.js": 705,
		"./ta": 706,
		"./ta.js": 706,
		"./te": 707,
		"./te.js": 707,
		"./tet": 708,
		"./tet.js": 708,
		"./tg": 709,
		"./tg.js": 709,
		"./th": 710,
		"./th.js": 710,
		"./tk": 711,
		"./tk.js": 711,
		"./tl-ph": 712,
		"./tl-ph.js": 712,
		"./tlh": 713,
		"./tlh.js": 713,
		"./tr": 714,
		"./tr.js": 714,
		"./tzl": 715,
		"./tzl.js": 715,
		"./tzm": 717,
		"./tzm-latn": 716,
		"./tzm-latn.js": 716,
		"./tzm.js": 717,
		"./ug-cn": 718,
		"./ug-cn.js": 718,
		"./uk": 719,
		"./uk.js": 719,
		"./ur": 720,
		"./ur.js": 720,
		"./uz": 722,
		"./uz-latn": 721,
		"./uz-latn.js": 721,
		"./uz.js": 722,
		"./vi": 723,
		"./vi.js": 723,
		"./x-pseudo": 724,
		"./x-pseudo.js": 724,
		"./yo": 725,
		"./yo.js": 725,
		"./zh-cn": 726,
		"./zh-cn.js": 726,
		"./zh-hk": 727,
		"./zh-hk.js": 727,
		"./zh-mo": 728,
		"./zh-mo.js": 728,
		"./zh-tw": 729,
		"./zh-tw.js": 729
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1517;


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
	/**
	 * Copyright 2012-2017 Craig Campbell
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * Mousetrap is a simple keyboard shortcut library for Javascript with
	 * no external dependencies
	 *
	 * @version 1.6.1
	 * @url craig.is/killing/mice
	 */
	(function(window, document, undefined) {
	
	    // Check if mousetrap is used inside browser, if not, return
	    if (!window) {
	        return;
	    }
	
	    /**
	     * mapping of special keycodes to their corresponding keys
	     *
	     * everything in this dictionary cannot use keypress events
	     * so it has to be here to map to the correct keycodes for
	     * keyup/keydown events
	     *
	     * @type {Object}
	     */
	    var _MAP = {
	        8: 'backspace',
	        9: 'tab',
	        13: 'enter',
	        16: 'shift',
	        17: 'ctrl',
	        18: 'alt',
	        20: 'capslock',
	        27: 'esc',
	        32: 'space',
	        33: 'pageup',
	        34: 'pagedown',
	        35: 'end',
	        36: 'home',
	        37: 'left',
	        38: 'up',
	        39: 'right',
	        40: 'down',
	        45: 'ins',
	        46: 'del',
	        91: 'meta',
	        93: 'meta',
	        224: 'meta'
	    };
	
	    /**
	     * mapping for special characters so they can support
	     *
	     * this dictionary is only used incase you want to bind a
	     * keyup or keydown event to one of these keys
	     *
	     * @type {Object}
	     */
	    var _KEYCODE_MAP = {
	        106: '*',
	        107: '+',
	        109: '-',
	        110: '.',
	        111 : '/',
	        186: ';',
	        187: '=',
	        188: ',',
	        189: '-',
	        190: '.',
	        191: '/',
	        192: '`',
	        219: '[',
	        220: '\\',
	        221: ']',
	        222: '\''
	    };
	
	    /**
	     * this is a mapping of keys that require shift on a US keypad
	     * back to the non shift equivelents
	     *
	     * this is so you can use keyup events with these keys
	     *
	     * note that this will only work reliably on US keyboards
	     *
	     * @type {Object}
	     */
	    var _SHIFT_MAP = {
	        '~': '`',
	        '!': '1',
	        '@': '2',
	        '#': '3',
	        '$': '4',
	        '%': '5',
	        '^': '6',
	        '&': '7',
	        '*': '8',
	        '(': '9',
	        ')': '0',
	        '_': '-',
	        '+': '=',
	        ':': ';',
	        '\"': '\'',
	        '<': ',',
	        '>': '.',
	        '?': '/',
	        '|': '\\'
	    };
	
	    /**
	     * this is a list of special strings you can use to map
	     * to modifier keys when you specify your keyboard shortcuts
	     *
	     * @type {Object}
	     */
	    var _SPECIAL_ALIASES = {
	        'option': 'alt',
	        'command': 'meta',
	        'return': 'enter',
	        'escape': 'esc',
	        'plus': '+',
	        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
	    };
	
	    /**
	     * variable to store the flipped version of _MAP from above
	     * needed to check if we should use keypress or not when no action
	     * is specified
	     *
	     * @type {Object|undefined}
	     */
	    var _REVERSE_MAP;
	
	    /**
	     * loop through the f keys, f1 to f19 and add them to the map
	     * programatically
	     */
	    for (var i = 1; i < 20; ++i) {
	        _MAP[111 + i] = 'f' + i;
	    }
	
	    /**
	     * loop through to map numbers on the numeric keypad
	     */
	    for (i = 0; i <= 9; ++i) {
	
	        // This needs to use a string cause otherwise since 0 is falsey
	        // mousetrap will never fire for numpad 0 pressed as part of a keydown
	        // event.
	        //
	        // @see https://github.com/ccampbell/mousetrap/pull/258
	        _MAP[i + 96] = i.toString();
	    }
	
	    /**
	     * cross browser add event method
	     *
	     * @param {Element|HTMLDocument} object
	     * @param {string} type
	     * @param {Function} callback
	     * @returns void
	     */
	    function _addEvent(object, type, callback) {
	        if (object.addEventListener) {
	            object.addEventListener(type, callback, false);
	            return;
	        }
	
	        object.attachEvent('on' + type, callback);
	    }
	
	    /**
	     * takes the event and returns the key character
	     *
	     * @param {Event} e
	     * @return {string}
	     */
	    function _characterFromEvent(e) {
	
	        // for keypress events we should return the character as is
	        if (e.type == 'keypress') {
	            var character = String.fromCharCode(e.which);
	
	            // if the shift key is not pressed then it is safe to assume
	            // that we want the character to be lowercase.  this means if
	            // you accidentally have caps lock on then your key bindings
	            // will continue to work
	            //
	            // the only side effect that might not be desired is if you
	            // bind something like 'A' cause you want to trigger an
	            // event when capital A is pressed caps lock will no longer
	            // trigger the event.  shift+a will though.
	            if (!e.shiftKey) {
	                character = character.toLowerCase();
	            }
	
	            return character;
	        }
	
	        // for non keypress events the special maps are needed
	        if (_MAP[e.which]) {
	            return _MAP[e.which];
	        }
	
	        if (_KEYCODE_MAP[e.which]) {
	            return _KEYCODE_MAP[e.which];
	        }
	
	        // if it is not in the special map
	
	        // with keydown and keyup events the character seems to always
	        // come in as an uppercase character whether you are pressing shift
	        // or not.  we should make sure it is always lowercase for comparisons
	        return String.fromCharCode(e.which).toLowerCase();
	    }
	
	    /**
	     * checks if two arrays are equal
	     *
	     * @param {Array} modifiers1
	     * @param {Array} modifiers2
	     * @returns {boolean}
	     */
	    function _modifiersMatch(modifiers1, modifiers2) {
	        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
	    }
	
	    /**
	     * takes a key event and figures out what the modifiers are
	     *
	     * @param {Event} e
	     * @returns {Array}
	     */
	    function _eventModifiers(e) {
	        var modifiers = [];
	
	        if (e.shiftKey) {
	            modifiers.push('shift');
	        }
	
	        if (e.altKey) {
	            modifiers.push('alt');
	        }
	
	        if (e.ctrlKey) {
	            modifiers.push('ctrl');
	        }
	
	        if (e.metaKey) {
	            modifiers.push('meta');
	        }
	
	        return modifiers;
	    }
	
	    /**
	     * prevents default for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _preventDefault(e) {
	        if (e.preventDefault) {
	            e.preventDefault();
	            return;
	        }
	
	        e.returnValue = false;
	    }
	
	    /**
	     * stops propogation for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _stopPropagation(e) {
	        if (e.stopPropagation) {
	            e.stopPropagation();
	            return;
	        }
	
	        e.cancelBubble = true;
	    }
	
	    /**
	     * determines if the keycode specified is a modifier key or not
	     *
	     * @param {string} key
	     * @returns {boolean}
	     */
	    function _isModifier(key) {
	        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
	    }
	
	    /**
	     * reverses the map lookup so that we can look for specific keys
	     * to see what can and can't use keypress
	     *
	     * @return {Object}
	     */
	    function _getReverseMap() {
	        if (!_REVERSE_MAP) {
	            _REVERSE_MAP = {};
	            for (var key in _MAP) {
	
	                // pull out the numeric keypad from here cause keypress should
	                // be able to detect the keys from the character
	                if (key > 95 && key < 112) {
	                    continue;
	                }
	
	                if (_MAP.hasOwnProperty(key)) {
	                    _REVERSE_MAP[_MAP[key]] = key;
	                }
	            }
	        }
	        return _REVERSE_MAP;
	    }
	
	    /**
	     * picks the best action based on the key combination
	     *
	     * @param {string} key - character for key
	     * @param {Array} modifiers
	     * @param {string=} action passed in
	     */
	    function _pickBestAction(key, modifiers, action) {
	
	        // if no action was picked in we should try to pick the one
	        // that we think would work best for this key
	        if (!action) {
	            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
	        }
	
	        // modifier keys don't work as expected with keypress,
	        // switch to keydown
	        if (action == 'keypress' && modifiers.length) {
	            action = 'keydown';
	        }
	
	        return action;
	    }
	
	    /**
	     * Converts from a string key combination to an array
	     *
	     * @param  {string} combination like "command+shift+l"
	     * @return {Array}
	     */
	    function _keysFromString(combination) {
	        if (combination === '+') {
	            return ['+'];
	        }
	
	        combination = combination.replace(/\+{2}/g, '+plus');
	        return combination.split('+');
	    }
	
	    /**
	     * Gets info for a specific key combination
	     *
	     * @param  {string} combination key combination ("command+s" or "a" or "*")
	     * @param  {string=} action
	     * @returns {Object}
	     */
	    function _getKeyInfo(combination, action) {
	        var keys;
	        var key;
	        var i;
	        var modifiers = [];
	
	        // take the keys from this pattern and figure out what the actual
	        // pattern is all about
	        keys = _keysFromString(combination);
	
	        for (i = 0; i < keys.length; ++i) {
	            key = keys[i];
	
	            // normalize key names
	            if (_SPECIAL_ALIASES[key]) {
	                key = _SPECIAL_ALIASES[key];
	            }
	
	            // if this is not a keypress event then we should
	            // be smart about using shift keys
	            // this will only work for US keyboards however
	            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
	                key = _SHIFT_MAP[key];
	                modifiers.push('shift');
	            }
	
	            // if this key is a modifier then add it to the list of modifiers
	            if (_isModifier(key)) {
	                modifiers.push(key);
	            }
	        }
	
	        // depending on what the key combination is
	        // we will try to pick the best event for it
	        action = _pickBestAction(key, modifiers, action);
	
	        return {
	            key: key,
	            modifiers: modifiers,
	            action: action
	        };
	    }
	
	    function _belongsTo(element, ancestor) {
	        if (element === null || element === document) {
	            return false;
	        }
	
	        if (element === ancestor) {
	            return true;
	        }
	
	        return _belongsTo(element.parentNode, ancestor);
	    }
	
	    function Mousetrap(targetElement) {
	        var self = this;
	
	        targetElement = targetElement || document;
	
	        if (!(self instanceof Mousetrap)) {
	            return new Mousetrap(targetElement);
	        }
	
	        /**
	         * element to attach key events to
	         *
	         * @type {Element}
	         */
	        self.target = targetElement;
	
	        /**
	         * a list of all the callbacks setup via Mousetrap.bind()
	         *
	         * @type {Object}
	         */
	        self._callbacks = {};
	
	        /**
	         * direct map of string combinations to callbacks used for trigger()
	         *
	         * @type {Object}
	         */
	        self._directMap = {};
	
	        /**
	         * keeps track of what level each sequence is at since multiple
	         * sequences can start out with the same sequence
	         *
	         * @type {Object}
	         */
	        var _sequenceLevels = {};
	
	        /**
	         * variable to store the setTimeout call
	         *
	         * @type {null|number}
	         */
	        var _resetTimer;
	
	        /**
	         * temporary state where we will ignore the next keyup
	         *
	         * @type {boolean|string}
	         */
	        var _ignoreNextKeyup = false;
	
	        /**
	         * temporary state where we will ignore the next keypress
	         *
	         * @type {boolean}
	         */
	        var _ignoreNextKeypress = false;
	
	        /**
	         * are we currently inside of a sequence?
	         * type of action ("keyup" or "keydown" or "keypress") or false
	         *
	         * @type {boolean|string}
	         */
	        var _nextExpectedAction = false;
	
	        /**
	         * resets all sequence counters except for the ones passed in
	         *
	         * @param {Object} doNotReset
	         * @returns void
	         */
	        function _resetSequences(doNotReset) {
	            doNotReset = doNotReset || {};
	
	            var activeSequences = false,
	                key;
	
	            for (key in _sequenceLevels) {
	                if (doNotReset[key]) {
	                    activeSequences = true;
	                    continue;
	                }
	                _sequenceLevels[key] = 0;
	            }
	
	            if (!activeSequences) {
	                _nextExpectedAction = false;
	            }
	        }
	
	        /**
	         * finds all callbacks that match based on the keycode, modifiers,
	         * and action
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event|Object} e
	         * @param {string=} sequenceName - name of the sequence we are looking for
	         * @param {string=} combination
	         * @param {number=} level
	         * @returns {Array}
	         */
	        function _getMatches(character, modifiers, e, sequenceName, combination, level) {
	            var i;
	            var callback;
	            var matches = [];
	            var action = e.type;
	
	            // if there are no events related to this keycode
	            if (!self._callbacks[character]) {
	                return [];
	            }
	
	            // if a modifier key is coming up on its own we should allow it
	            if (action == 'keyup' && _isModifier(character)) {
	                modifiers = [character];
	            }
	
	            // loop through all callbacks for the key that was pressed
	            // and see if any of them match
	            for (i = 0; i < self._callbacks[character].length; ++i) {
	                callback = self._callbacks[character][i];
	
	                // if a sequence name is not specified, but this is a sequence at
	                // the wrong level then move onto the next match
	                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
	                    continue;
	                }
	
	                // if the action we are looking for doesn't match the action we got
	                // then we should keep going
	                if (action != callback.action) {
	                    continue;
	                }
	
	                // if this is a keypress event and the meta key and control key
	                // are not pressed that means that we need to only look at the
	                // character, otherwise check the modifiers as well
	                //
	                // chrome will not fire a keypress if meta or control is down
	                // safari will fire a keypress if meta or meta+shift is down
	                // firefox will fire a keypress if meta or control is down
	                if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {
	
	                    // when you bind a combination or sequence a second time it
	                    // should overwrite the first one.  if a sequenceName or
	                    // combination is specified in this call it does just that
	                    //
	                    // @todo make deleting its own method?
	                    var deleteCombo = !sequenceName && callback.combo == combination;
	                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
	                    if (deleteCombo || deleteSequence) {
	                        self._callbacks[character].splice(i, 1);
	                    }
	
	                    matches.push(callback);
	                }
	            }
	
	            return matches;
	        }
	
	        /**
	         * actually calls the callback function
	         *
	         * if your callback function returns false this will use the jquery
	         * convention - prevent default and stop propogation on the event
	         *
	         * @param {Function} callback
	         * @param {Event} e
	         * @returns void
	         */
	        function _fireCallback(callback, e, combo, sequence) {
	
	            // if this event should not happen stop here
	            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
	                return;
	            }
	
	            if (callback(e, combo) === false) {
	                _preventDefault(e);
	                _stopPropagation(e);
	            }
	        }
	
	        /**
	         * handles a character key event
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event} e
	         * @returns void
	         */
	        self._handleKey = function(character, modifiers, e) {
	            var callbacks = _getMatches(character, modifiers, e);
	            var i;
	            var doNotReset = {};
	            var maxLevel = 0;
	            var processedSequenceCallback = false;
	
	            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
	            for (i = 0; i < callbacks.length; ++i) {
	                if (callbacks[i].seq) {
	                    maxLevel = Math.max(maxLevel, callbacks[i].level);
	                }
	            }
	
	            // loop through matching callbacks for this key event
	            for (i = 0; i < callbacks.length; ++i) {
	
	                // fire for all sequence callbacks
	                // this is because if for example you have multiple sequences
	                // bound such as "g i" and "g t" they both need to fire the
	                // callback for matching g cause otherwise you can only ever
	                // match the first one
	                if (callbacks[i].seq) {
	
	                    // only fire callbacks for the maxLevel to prevent
	                    // subsequences from also firing
	                    //
	                    // for example 'a option b' should not cause 'option b' to fire
	                    // even though 'option b' is part of the other sequence
	                    //
	                    // any sequences that do not match here will be discarded
	                    // below by the _resetSequences call
	                    if (callbacks[i].level != maxLevel) {
	                        continue;
	                    }
	
	                    processedSequenceCallback = true;
	
	                    // keep a list of which sequences were matches for later
	                    doNotReset[callbacks[i].seq] = 1;
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
	                    continue;
	                }
	
	                // if there were no sequence matches but we are still here
	                // that means this is a regular match so we should fire that
	                if (!processedSequenceCallback) {
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
	                }
	            }
	
	            // if the key you pressed matches the type of sequence without
	            // being a modifier (ie "keyup" or "keypress") then we should
	            // reset all sequences that were not matched by this event
	            //
	            // this is so, for example, if you have the sequence "h a t" and you
	            // type "h e a r t" it does not match.  in this case the "e" will
	            // cause the sequence to reset
	            //
	            // modifier keys are ignored because you can have a sequence
	            // that contains modifiers such as "enter ctrl+space" and in most
	            // cases the modifier key will be pressed before the next key
	            //
	            // also if you have a sequence such as "ctrl+b a" then pressing the
	            // "b" key will trigger a "keypress" and a "keydown"
	            //
	            // the "keydown" is expected when there is a modifier, but the
	            // "keypress" ends up matching the _nextExpectedAction since it occurs
	            // after and that causes the sequence to reset
	            //
	            // we ignore keypresses in a sequence that directly follow a keydown
	            // for the same character
	            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
	            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
	                _resetSequences(doNotReset);
	            }
	
	            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
	        };
	
	        /**
	         * handles a keydown event
	         *
	         * @param {Event} e
	         * @returns void
	         */
	        function _handleKeyEvent(e) {
	
	            // normalize e.which for key events
	            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
	            if (typeof e.which !== 'number') {
	                e.which = e.keyCode;
	            }
	
	            var character = _characterFromEvent(e);
	
	            // no character found then stop
	            if (!character) {
	                return;
	            }
	
	            // need to use === for the character check because the character can be 0
	            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
	                _ignoreNextKeyup = false;
	                return;
	            }
	
	            self.handleKey(character, _eventModifiers(e), e);
	        }
	
	        /**
	         * called to set a 1 second timeout on the specified sequence
	         *
	         * this is so after each key press in the sequence you have 1 second
	         * to press the next key before you have to start over
	         *
	         * @returns void
	         */
	        function _resetSequenceTimer() {
	            clearTimeout(_resetTimer);
	            _resetTimer = setTimeout(_resetSequences, 1000);
	        }
	
	        /**
	         * binds a key sequence to an event
	         *
	         * @param {string} combo - combo specified in bind call
	         * @param {Array} keys
	         * @param {Function} callback
	         * @param {string=} action
	         * @returns void
	         */
	        function _bindSequence(combo, keys, callback, action) {
	
	            // start off by adding a sequence level record for this combination
	            // and setting the level to 0
	            _sequenceLevels[combo] = 0;
	
	            /**
	             * callback to increase the sequence level for this sequence and reset
	             * all other sequences that were active
	             *
	             * @param {string} nextAction
	             * @returns {Function}
	             */
	            function _increaseSequence(nextAction) {
	                return function() {
	                    _nextExpectedAction = nextAction;
	                    ++_sequenceLevels[combo];
	                    _resetSequenceTimer();
	                };
	            }
	
	            /**
	             * wraps the specified callback inside of another function in order
	             * to reset all sequence counters as soon as this sequence is done
	             *
	             * @param {Event} e
	             * @returns void
	             */
	            function _callbackAndReset(e) {
	                _fireCallback(callback, e, combo);
	
	                // we should ignore the next key up if the action is key down
	                // or keypress.  this is so if you finish a sequence and
	                // release the key the final key will not trigger a keyup
	                if (action !== 'keyup') {
	                    _ignoreNextKeyup = _characterFromEvent(e);
	                }
	
	                // weird race condition if a sequence ends with the key
	                // another sequence begins with
	                setTimeout(_resetSequences, 10);
	            }
	
	            // loop through keys one at a time and bind the appropriate callback
	            // function.  for any key leading up to the final one it should
	            // increase the sequence. after the final, it should reset all sequences
	            //
	            // if an action is specified in the original bind call then that will
	            // be used throughout.  otherwise we will pass the action that the
	            // next key in the sequence should match.  this allows a sequence
	            // to mix and match keypress and keydown events depending on which
	            // ones are better suited to the key provided
	            for (var i = 0; i < keys.length; ++i) {
	                var isFinal = i + 1 === keys.length;
	                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
	                _bindSingle(keys[i], wrappedCallback, action, combo, i);
	            }
	        }
	
	        /**
	         * binds a single keyboard combination
	         *
	         * @param {string} combination
	         * @param {Function} callback
	         * @param {string=} action
	         * @param {string=} sequenceName - name of sequence if part of sequence
	         * @param {number=} level - what part of the sequence the command is
	         * @returns void
	         */
	        function _bindSingle(combination, callback, action, sequenceName, level) {
	
	            // store a direct mapped reference for use with Mousetrap.trigger
	            self._directMap[combination + ':' + action] = callback;
	
	            // make sure multiple spaces in a row become a single space
	            combination = combination.replace(/\s+/g, ' ');
	
	            var sequence = combination.split(' ');
	            var info;
	
	            // if this pattern is a sequence of keys then run through this method
	            // to reprocess each pattern one key at a time
	            if (sequence.length > 1) {
	                _bindSequence(combination, sequence, callback, action);
	                return;
	            }
	
	            info = _getKeyInfo(combination, action);
	
	            // make sure to initialize array if this is the first time
	            // a callback is added for this key
	            self._callbacks[info.key] = self._callbacks[info.key] || [];
	
	            // remove an existing match if there is one
	            _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);
	
	            // add this call back to the array
	            // if it is a sequence put it at the beginning
	            // if not put it at the end
	            //
	            // this is important because the way these are processed expects
	            // the sequence ones to come first
	            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
	                callback: callback,
	                modifiers: info.modifiers,
	                action: info.action,
	                seq: sequenceName,
	                level: level,
	                combo: combination
	            });
	        }
	
	        /**
	         * binds multiple combinations to the same callback
	         *
	         * @param {Array} combinations
	         * @param {Function} callback
	         * @param {string|undefined} action
	         * @returns void
	         */
	        self._bindMultiple = function(combinations, callback, action) {
	            for (var i = 0; i < combinations.length; ++i) {
	                _bindSingle(combinations[i], callback, action);
	            }
	        };
	
	        // start!
	        _addEvent(targetElement, 'keypress', _handleKeyEvent);
	        _addEvent(targetElement, 'keydown', _handleKeyEvent);
	        _addEvent(targetElement, 'keyup', _handleKeyEvent);
	    }
	
	    /**
	     * binds an event to mousetrap
	     *
	     * can be a single key, a combination of keys separated with +,
	     * an array of keys, or a sequence of keys separated by spaces
	     *
	     * be sure to list the modifier keys first to make sure that the
	     * correct key ends up getting bound (the last key in the pattern)
	     *
	     * @param {string|Array} keys
	     * @param {Function} callback
	     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
	     * @returns void
	     */
	    Mousetrap.prototype.bind = function(keys, callback, action) {
	        var self = this;
	        keys = keys instanceof Array ? keys : [keys];
	        self._bindMultiple.call(self, keys, callback, action);
	        return self;
	    };
	
	    /**
	     * unbinds an event to mousetrap
	     *
	     * the unbinding sets the callback function of the specified key combo
	     * to an empty function and deletes the corresponding key in the
	     * _directMap dict.
	     *
	     * TODO: actually remove this from the _callbacks dictionary instead
	     * of binding an empty function
	     *
	     * the keycombo+action has to be exactly the same as
	     * it was defined in the bind method
	     *
	     * @param {string|Array} keys
	     * @param {string} action
	     * @returns void
	     */
	    Mousetrap.prototype.unbind = function(keys, action) {
	        var self = this;
	        return self.bind.call(self, keys, function() {}, action);
	    };
	
	    /**
	     * triggers an event that has already been bound
	     *
	     * @param {string} keys
	     * @param {string=} action
	     * @returns void
	     */
	    Mousetrap.prototype.trigger = function(keys, action) {
	        var self = this;
	        if (self._directMap[keys + ':' + action]) {
	            self._directMap[keys + ':' + action]({}, keys);
	        }
	        return self;
	    };
	
	    /**
	     * resets the library back to its initial state.  this is useful
	     * if you want to clear out the current keyboard shortcuts and bind
	     * new ones - for example if you switch to another page
	     *
	     * @returns void
	     */
	    Mousetrap.prototype.reset = function() {
	        var self = this;
	        self._callbacks = {};
	        self._directMap = {};
	        return self;
	    };
	
	    /**
	     * should we stop this event before firing off callbacks
	     *
	     * @param {Event} e
	     * @param {Element} element
	     * @return {boolean}
	     */
	    Mousetrap.prototype.stopCallback = function(e, element) {
	        var self = this;
	
	        // if the element has the class "mousetrap" then no need to stop
	        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
	            return false;
	        }
	
	        if (_belongsTo(element, self.target)) {
	            return false;
	        }
	
	        // stop for input, select, and textarea
	        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
	    };
	
	    /**
	     * exposes _handleKey publicly so it can be overwritten by extensions
	     */
	    Mousetrap.prototype.handleKey = function() {
	        var self = this;
	        return self._handleKey.apply(self, arguments);
	    };
	
	    /**
	     * allow custom key mappings
	     */
	    Mousetrap.addKeycodes = function(object) {
	        for (var key in object) {
	            if (object.hasOwnProperty(key)) {
	                _MAP[key] = object[key];
	            }
	        }
	        _REVERSE_MAP = null;
	    };
	
	    /**
	     * Init the global mousetrap functions
	     *
	     * This method is needed to allow the global mousetrap functions to work
	     * now that mousetrap is a constructor function.
	     */
	    Mousetrap.init = function() {
	        var documentMousetrap = Mousetrap(document);
	        for (var method in documentMousetrap) {
	            if (method.charAt(0) !== '_') {
	                Mousetrap[method] = (function(method) {
	                    return function() {
	                        return documentMousetrap[method].apply(documentMousetrap, arguments);
	                    };
	                } (method));
	            }
	        }
	    };
	
	    Mousetrap.init();
	
	    // expose mousetrap to the global object
	    window.Mousetrap = Mousetrap;
	
	    // expose as a common js module
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = Mousetrap;
	    }
	
	    // expose mousetrap as an AMD module
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return Mousetrap;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}) (typeof window !== 'undefined' ? window : null, typeof  window !== 'undefined' ? document : null);


/***/ }),
/* 1519 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options){
	  options = options || {};
	  if ('string' == typeof val) return parse(val);
	  return options.long
	    ? long(val)
	    : short(val);
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = '' + str;
	  if (str.length > 10000) return;
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	  if (!match) return;
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function short(ms) {
	  if (ms >= d) return Math.round(ms / d) + 'd';
	  if (ms >= h) return Math.round(ms / h) + 'h';
	  if (ms >= m) return Math.round(ms / m) + 'm';
	  if (ms >= s) return Math.round(ms / s) + 's';
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function long(ms) {
	  return plural(ms, d, 'day')
	    || plural(ms, h, 'hour')
	    || plural(ms, m, 'minute')
	    || plural(ms, s, 'second')
	    || ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) return;
	  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 1520 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Matcher.
	 */
	
	var matcher = /\d{13}/;
	
	
	/**
	 * Check whether a string is a millisecond date string.
	 *
	 * @param {string} string
	 * @return {boolean}
	 */
	exports.is = function(string) {
	  return matcher.test(string);
	};
	
	
	/**
	 * Convert a millisecond string to a date.
	 *
	 * @param {string} millis
	 * @return {Date}
	 */
	exports.parse = function(millis) {
	  millis = parseInt(millis, 10);
	  return new Date(millis);
	};


/***/ }),
/* 1521 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Matcher.
	 */
	
	var matcher = /\d{10}/;
	
	
	/**
	 * Check whether a string is a second date string.
	 *
	 * @param {string} string
	 * @return {Boolean}
	 */
	exports.is = function(string) {
	  return matcher.test(string);
	};
	
	
	/**
	 * Convert a second string to a date.
	 *
	 * @param {string} seconds
	 * @return {Date}
	 */
	exports.parse = function(seconds) {
	  var millis = parseInt(seconds, 10) * 1000;
	  return new Date(millis);
	};


/***/ }),
/* 1522 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Matcher, slightly modified from:
	 *
	 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
	 */
	
	var matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
	
	/**
	 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
	 *
	 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
	 *
	 * @param {String} iso
	 * @return {Date}
	 */
	
	exports.parse = function(iso) {
	  var numericKeys = [1, 5, 6, 7, 11, 12];
	  var arr = matcher.exec(iso);
	  var offset = 0;
	
	  // fallback to native parsing
	  if (!arr) {
	    return new Date(iso);
	  }
	
	  /* eslint-disable no-cond-assign */
	  // remove undefined values
	  for (var i = 0, val; val = numericKeys[i]; i++) {
	    arr[val] = parseInt(arr[val], 10) || 0;
	  }
	  /* eslint-enable no-cond-assign */
	
	  // allow undefined days and months
	  arr[2] = parseInt(arr[2], 10) || 1;
	  arr[3] = parseInt(arr[3], 10) || 1;
	
	  // month is 0-11
	  arr[2]--;
	
	  // allow abitrary sub-second precision
	  arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
	
	  // apply timezone if one exists
	  if (arr[4] === ' ') {
	    offset = new Date().getTimezoneOffset();
	  } else if (arr[9] !== 'Z' && arr[10]) {
	    offset = arr[11] * 60 + arr[12];
	    if (arr[10] === '+') {
	      offset = 0 - offset;
	    }
	  }
	
	  var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
	  return new Date(millis);
	};
	
	
	/**
	 * Checks whether a `string` is an ISO date string. `strict` mode requires that
	 * the date string at least have a year, month and date.
	 *
	 * @param {String} string
	 * @param {Boolean} strict
	 * @return {Boolean}
	 */
	
	exports.is = function(string, strict) {
	  if (strict && (/^\d{4}-\d{2}-\d{2}/).test(string) === false) {
	    return false;
	  }
	  return matcher.test(string);
	};


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(149);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(1527);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactTweenState = __webpack_require__(1730);
	
	var _reactTweenState2 = _interopRequireDefault(_reactTweenState);
	
	var _decorators = __webpack_require__(1524);
	
	var _decorators2 = _interopRequireDefault(_decorators);
	
	var _objectAssign = __webpack_require__(24);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _exenv = __webpack_require__(307);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _createReactClass = __webpack_require__(731);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addEvent = function addEvent(elem, type, eventHandle) {
	  if (elem === null || typeof elem === 'undefined') {
	    return;
	  }
	  if (elem.addEventListener) {
	    elem.addEventListener(type, eventHandle, false);
	  } else if (elem.attachEvent) {
	    elem.attachEvent('on' + type, eventHandle);
	  } else {
	    elem['on' + type] = eventHandle;
	  }
	};
	
	var removeEvent = function removeEvent(elem, type, eventHandle) {
	  if (elem === null || typeof elem === 'undefined') {
	    return;
	  }
	  if (elem.removeEventListener) {
	    elem.removeEventListener(type, eventHandle, false);
	  } else if (elem.detachEvent) {
	    elem.detachEvent('on' + type, eventHandle);
	  } else {
	    elem['on' + type] = null;
	  }
	};
	
	var Carousel = (0, _createReactClass2.default)({
	  displayName: 'Carousel',
	
	  mixins: [_reactTweenState2.default.Mixin],
	
	  propTypes: {
	    afterSlide: _propTypes2.default.func,
	    autoplay: _propTypes2.default.bool,
	    autoplayInterval: _propTypes2.default.number,
	    beforeSlide: _propTypes2.default.func,
	    cellAlign: _propTypes2.default.oneOf(['left', 'center', 'right']),
	    cellSpacing: _propTypes2.default.number,
	    data: _propTypes2.default.func,
	    decorators: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      component: _propTypes2.default.func,
	      position: _propTypes2.default.oneOf(['TopLeft', 'TopCenter', 'TopRight', 'CenterLeft', 'CenterCenter', 'CenterRight', 'BottomLeft', 'BottomCenter', 'BottomRight']),
	      style: _propTypes2.default.object
	    })),
	    dragging: _propTypes2.default.bool,
	    easing: _propTypes2.default.string,
	    edgeEasing: _propTypes2.default.string,
	    framePadding: _propTypes2.default.string,
	    frameOverflow: _propTypes2.default.string,
	    initialSlideHeight: _propTypes2.default.number,
	    initialSlideWidth: _propTypes2.default.number,
	    slideIndex: _propTypes2.default.number,
	    slidesToShow: _propTypes2.default.number,
	    slidesToScroll: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto'])]),
	    slideWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    speed: _propTypes2.default.number,
	    swiping: _propTypes2.default.bool,
	    vertical: _propTypes2.default.bool,
	    width: _propTypes2.default.string,
	    wrapAround: _propTypes2.default.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      afterSlide: function afterSlide() {},
	      autoplay: false,
	      autoplayInterval: 3000,
	      beforeSlide: function beforeSlide() {},
	      cellAlign: 'left',
	      cellSpacing: 0,
	      data: function data() {},
	      decorators: _decorators2.default,
	      dragging: true,
	      easing: 'easeOutCirc',
	      edgeEasing: 'easeOutElastic',
	      framePadding: '0px',
	      frameOverflow: 'hidden',
	      slideIndex: 0,
	      slidesToScroll: 1,
	      slidesToShow: 1,
	      slideWidth: 1,
	      speed: 500,
	      swiping: true,
	      vertical: false,
	      width: '100%',
	      wrapAround: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      currentSlide: this.props.slideIndex,
	      dragging: false,
	      frameWidth: 0,
	      left: 0,
	      slideCount: 0,
	      slidesToScroll: this.props.slidesToScroll,
	      slideWidth: 0,
	      top: 0
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.setInitialDimensions();
	  },
	  componentDidMount: function componentDidMount() {
	    // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
	    this.mounted = true;
	    this.setDimensions();
	    this.bindEvents();
	    this.setExternalData();
	    if (this.props.autoplay) {
	      this.startAutoplay();
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState({
	      slideCount: nextProps.children.length
	    });
	    this.setDimensions(nextProps);
	    if (this.props.slideIndex !== nextProps.slideIndex && nextProps.slideIndex !== this.state.currentSlide) {
	      this.goToSlide(nextProps.slideIndex);
	    }
	    if (this.props.autoplay !== nextProps.autoplay) {
	      if (nextProps.autoplay) {
	        this.startAutoplay();
	      } else {
	        this.stopAutoplay();
	      }
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.unbindEvents();
	    this.stopAutoplay();
	    // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
	    this.mounted = false;
	  },
	  render: function render() {
	    var self = this;
	    var children = _react2.default.Children.count(this.props.children) > 1 ? this.formatChildren(this.props.children) : this.props.children;
	    return _react2.default.createElement(
	      'div',
	      {
	        className: ['slider', this.props.className || ''].join(' '),
	        ref: 'slider',
	        style: (0, _objectAssign2.default)(this.getSliderStyles(), this.props.style || {})
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          className: 'slider-frame',
	          ref: 'frame',
	          style: this.getFrameStyles()
	        }, this.getTouchEvents(), this.getMouseEvents(), {
	          onClick: this.handleClick
	        }),
	        _react2.default.createElement(
	          'ul',
	          { className: 'slider-list', ref: 'list', style: this.getListStyles() },
	          children
	        )
	      ),
	      this.props.decorators ? this.props.decorators.map(function (Decorator, index) {
	        return _react2.default.createElement(
	          'div',
	          {
	            style: (0, _objectAssign2.default)(self.getDecoratorStyles(Decorator.position), Decorator.style || {}),
	            className: 'slider-decorator-' + index,
	            key: index
	          },
	          _react2.default.createElement(Decorator.component, {
	            currentSlide: self.state.currentSlide,
	            slideCount: self.state.slideCount,
	            frameWidth: self.state.frameWidth,
	            slideWidth: self.state.slideWidth,
	            slidesToScroll: self.state.slidesToScroll,
	            cellSpacing: self.props.cellSpacing,
	            slidesToShow: self.props.slidesToShow,
	            wrapAround: self.props.wrapAround,
	            nextSlide: self.nextSlide,
	            previousSlide: self.previousSlide,
	            goToSlide: self.goToSlide
	          })
	        );
	      }) : null,
	      _react2.default.createElement('style', {
	        type: 'text/css',
	        dangerouslySetInnerHTML: { __html: self.getStyleTagStyles() }
	      })
	    );
	  },
	
	
	  // Touch Events
	
	  touchObject: {},
	
	  getTouchEvents: function getTouchEvents() {
	    var self = this;
	
	    if (self.props.swiping === false) {
	      return null;
	    }
	
	    return {
	      onTouchStart: function onTouchStart(e) {
	        self.touchObject = {
	          startX: e.touches[0].pageX,
	          startY: e.touches[0].pageY
	        };
	        self.handleMouseOver();
	      },
	      onTouchMove: function onTouchMove(e) {
	        var direction = self.swipeDirection(self.touchObject.startX, e.touches[0].pageX, self.touchObject.startY, e.touches[0].pageY);
	
	        if (direction !== 0) {
	          e.preventDefault();
	        }
	
	        var length = self.props.vertical ? Math.round(Math.sqrt(Math.pow(e.touches[0].pageY - self.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.touches[0].pageX - self.touchObject.startX, 2)));
	
	        self.touchObject = {
	          startX: self.touchObject.startX,
	          startY: self.touchObject.startY,
	          endX: e.touches[0].pageX,
	          endY: e.touches[0].pageY,
	          length: length,
	          direction: direction
	        };
	
	        self.setState({
	          left: self.props.vertical ? 0 : self.getTargetLeft(self.touchObject.length * self.touchObject.direction),
	          top: self.props.vertical ? self.getTargetLeft(self.touchObject.length * self.touchObject.direction) : 0
	        });
	      },
	      onTouchEnd: function onTouchEnd(e) {
	        self.handleSwipe(e);
	        self.handleMouseOut();
	      },
	      onTouchCancel: function onTouchCancel(e) {
	        self.handleSwipe(e);
	      }
	    };
	  },
	
	
	  clickSafe: true,
	
	  getMouseEvents: function getMouseEvents() {
	    var self = this;
	
	    if (this.props.dragging === false) {
	      return null;
	    }
	
	    return {
	      onMouseOver: function onMouseOver() {
	        self.handleMouseOver();
	      },
	      onMouseOut: function onMouseOut() {
	        self.handleMouseOut();
	      },
	      onMouseDown: function onMouseDown(e) {
	        self.touchObject = {
	          startX: e.clientX,
	          startY: e.clientY
	        };
	
	        self.setState({
	          dragging: true
	        });
	      },
	      onMouseMove: function onMouseMove(e) {
	        if (!self.state.dragging) {
	          return;
	        }
	
	        var direction = self.swipeDirection(self.touchObject.startX, e.clientX, self.touchObject.startY, e.clientY);
	
	        if (direction !== 0) {
	          e.preventDefault();
	        }
	
	        var length = self.props.vertical ? Math.round(Math.sqrt(Math.pow(e.clientY - self.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.clientX - self.touchObject.startX, 2)));
	
	        self.touchObject = {
	          startX: self.touchObject.startX,
	          startY: self.touchObject.startY,
	          endX: e.clientX,
	          endY: e.clientY,
	          length: length,
	          direction: direction
	        };
	
	        self.setState({
	          left: self.props.vertical ? 0 : self.getTargetLeft(self.touchObject.length * self.touchObject.direction),
	          top: self.props.vertical ? self.getTargetLeft(self.touchObject.length * self.touchObject.direction) : 0
	        });
	      },
	      onMouseUp: function onMouseUp(e) {
	        if (!self.state.dragging) {
	          return;
	        }
	
	        self.handleSwipe(e);
	      },
	      onMouseLeave: function onMouseLeave(e) {
	        if (!self.state.dragging) {
	          return;
	        }
	
	        self.handleSwipe(e);
	      }
	    };
	  },
	  handleMouseOver: function handleMouseOver() {
	    if (this.props.autoplay) {
	      this.autoplayPaused = true;
	      this.stopAutoplay();
	    }
	  },
	  handleMouseOut: function handleMouseOut() {
	    if (this.props.autoplay && this.autoplayPaused) {
	      this.startAutoplay();
	      this.autoplayPaused = null;
	    }
	  },
	  handleClick: function handleClick(e) {
	    if (this.clickSafe === true) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      if (e.nativeEvent) {
	        e.nativeEvent.stopPropagation();
	      }
	    }
	  },
	  handleSwipe: function handleSwipe(e) {
	    if (typeof this.touchObject.length !== 'undefined' && this.touchObject.length > 44) {
	      this.clickSafe = true;
	    } else {
	      this.clickSafe = false;
	    }
	
	    var slidesToShow = this.props.slidesToShow;
	    if (this.props.slidesToScroll === 'auto') {
	      slidesToShow = this.state.slidesToScroll;
	    }
	
	    if (this.touchObject.length > this.state.slideWidth / slidesToShow / 5) {
	      if (this.touchObject.direction === 1) {
	        if (this.state.currentSlide >= _react2.default.Children.count(this.props.children) - slidesToShow && !this.props.wrapAround) {
	          this.animateSlide(_reactTweenState2.default.easingTypes[this.props.edgeEasing]);
	        } else {
	          this.nextSlide();
	        }
	      } else if (this.touchObject.direction === -1) {
	        if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
	          this.animateSlide(_reactTweenState2.default.easingTypes[this.props.edgeEasing]);
	        } else {
	          this.previousSlide();
	        }
	      }
	    } else {
	      this.goToSlide(this.state.currentSlide);
	    }
	
	    this.touchObject = {};
	
	    this.setState({
	      dragging: false
	    });
	  },
	  swipeDirection: function swipeDirection(x1, x2, y1, y2) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = x1 - x2;
	    yDist = y1 - y2;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0) {
	      return 1;
	    }
	    if (swipeAngle <= 360 && swipeAngle >= 315) {
	      return 1;
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return -1;
	    }
	    if (this.props.vertical === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 1;
	      } else {
	        return -1;
	      }
	    }
	    return 0;
	  },
	  autoplayIterator: function autoplayIterator() {
	    if (this.props.wrapAround) {
	      return this.nextSlide();
	    }
	    if (this.state.currentSlide !== this.state.slideCount - this.state.slidesToShow) {
	      this.nextSlide();
	    } else {
	      this.stopAutoplay();
	    }
	  },
	  startAutoplay: function startAutoplay() {
	    this.autoplayID = setInterval(this.autoplayIterator, this.props.autoplayInterval);
	  },
	  resetAutoplay: function resetAutoplay() {
	    if (this.props.autoplay && !this.autoplayPaused) {
	      this.stopAutoplay();
	      this.startAutoplay();
	    }
	  },
	  stopAutoplay: function stopAutoplay() {
	    this.autoplayID && clearInterval(this.autoplayID);
	  },
	
	
	  // Action Methods
	
	  goToSlide: function goToSlide(index) {
	    var self = this;
	    if (index >= _react2.default.Children.count(this.props.children) || index < 0) {
	      if (!this.props.wrapAround) {
	        return;
	      }
	      if (index >= _react2.default.Children.count(this.props.children)) {
	        this.props.beforeSlide(this.state.currentSlide, 0);
	        return this.setState({
	          currentSlide: 0
	        }, function () {
	          self.animateSlide(null, null, self.getTargetLeft(null, index), function () {
	            self.animateSlide(null, 0.01);
	            self.props.afterSlide(0);
	            self.resetAutoplay();
	            self.setExternalData();
	          });
	        });
	      } else {
	        var endSlide = _react2.default.Children.count(this.props.children) - this.state.slidesToScroll;
	        this.props.beforeSlide(this.state.currentSlide, endSlide);
	        return this.setState({
	          currentSlide: endSlide
	        }, function () {
	          self.animateSlide(null, null, self.getTargetLeft(null, index), function () {
	            self.animateSlide(null, 0.01);
	            self.props.afterSlide(endSlide);
	            self.resetAutoplay();
	            self.setExternalData();
	          });
	        });
	      }
	    }
	
	    this.props.beforeSlide(this.state.currentSlide, index);
	
	    if (index !== this.state.currentSlide) {
	      this.props.afterSlide(index);
	    }
	    this.setState({
	      currentSlide: index
	    }, function () {
	      self.animateSlide();
	      self.resetAutoplay();
	      self.setExternalData();
	    });
	  },
	  nextSlide: function nextSlide() {
	    var childrenCount = _react2.default.Children.count(this.props.children);
	    var slidesToShow = this.props.slidesToShow;
	    if (this.props.slidesToScroll === 'auto') {
	      slidesToShow = this.state.slidesToScroll;
	    }
	    if (this.state.currentSlide >= childrenCount - slidesToShow && !this.props.wrapAround) {
	      return;
	    }
	
	    if (this.props.wrapAround) {
	      this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
	    } else {
	      if (this.props.slideWidth !== 1) {
	        return this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
	      }
	      this.goToSlide(Math.min(this.state.currentSlide + this.state.slidesToScroll, childrenCount - slidesToShow));
	    }
	  },
	  previousSlide: function previousSlide() {
	    if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
	      return;
	    }
	
	    if (this.props.wrapAround) {
	      this.goToSlide(this.state.currentSlide - this.state.slidesToScroll);
	    } else {
	      this.goToSlide(Math.max(0, this.state.currentSlide - this.state.slidesToScroll));
	    }
	  },
	
	
	  // Animation
	
	  animateSlide: function animateSlide(easing, duration, endValue, callback) {
	    this.tweenState(this.props.vertical ? 'top' : 'left', {
	      easing: easing || _reactTweenState2.default.easingTypes[this.props.easing],
	      duration: duration || this.props.speed,
	      endValue: endValue || this.getTargetLeft(),
	      onEnd: callback || null
	    });
	  },
	  getTargetLeft: function getTargetLeft(touchOffset, slide) {
	    var offset;
	    var target = slide || this.state.currentSlide;
	    switch (this.props.cellAlign) {
	      case 'left':
	        {
	          offset = 0;
	          offset -= this.props.cellSpacing * target;
	          break;
	        }
	      case 'center':
	        {
	          offset = (this.state.frameWidth - this.state.slideWidth) / 2;
	          offset -= this.props.cellSpacing * target;
	          break;
	        }
	      case 'right':
	        {
	          offset = this.state.frameWidth - this.state.slideWidth;
	          offset -= this.props.cellSpacing * target;
	          break;
	        }
	    }
	
	    var left = this.state.slideWidth * target;
	
	    var lastSlide = this.state.currentSlide > 0 && target + this.state.slidesToScroll >= this.state.slideCount;
	
	    if (lastSlide && this.props.slideWidth !== 1 && !this.props.wrapAround && this.props.slidesToScroll === 'auto') {
	      left = this.state.slideWidth * this.state.slideCount - this.state.frameWidth;
	      offset = 0;
	      offset -= this.props.cellSpacing * (this.state.slideCount - 1);
	    }
	
	    offset -= touchOffset || 0;
	
	    return (left - offset) * -1;
	  },
	
	
	  // Bootstrapping
	
	  bindEvents: function bindEvents() {
	    var self = this;
	    if (_exenv2.default.canUseDOM) {
	      addEvent(window, 'resize', self.onResize);
	      addEvent(document, 'readystatechange', self.onReadyStateChange);
	    }
	  },
	  onResize: function onResize() {
	    this.setDimensions();
	  },
	  onReadyStateChange: function onReadyStateChange() {
	    this.setDimensions();
	  },
	  unbindEvents: function unbindEvents() {
	    var self = this;
	    if (_exenv2.default.canUseDOM) {
	      removeEvent(window, 'resize', self.onResize);
	      removeEvent(document, 'readystatechange', self.onReadyStateChange);
	    }
	  },
	  formatChildren: function formatChildren(children) {
	    var self = this;
	    var positionValue = this.props.vertical ? this.getTweeningValue('top') : this.getTweeningValue('left');
	    return _react2.default.Children.map(children, function (child, index) {
	      return _react2.default.createElement(
	        'li',
	        {
	          className: 'slider-slide',
	          style: self.getSlideStyles(index, positionValue),
	          key: index
	        },
	        child
	      );
	    });
	  },
	  setInitialDimensions: function setInitialDimensions() {
	    var self = this,
	        slideWidth,
	        frameHeight,
	        slideHeight;
	
	    slideWidth = this.props.vertical ? this.props.initialSlideHeight || 0 : this.props.initialSlideWidth || 0;
	    slideHeight = this.props.initialSlideHeight ? this.props.initialSlideHeight * this.props.slidesToShow : 0;
	
	    frameHeight = slideHeight + this.props.cellSpacing * (this.props.slidesToShow - 1);
	
	    this.setState({
	      slideHeight: slideHeight,
	      frameWidth: this.props.vertical ? frameHeight : '100%',
	      slideCount: _react2.default.Children.count(this.props.children),
	      slideWidth: slideWidth
	    }, function () {
	      self.setLeft();
	      self.setExternalData();
	    });
	  },
	  setDimensions: function setDimensions(props) {
	    props = props || this.props;
	
	    var self = this,
	        slideWidth,
	        slidesToScroll,
	        firstSlide,
	        frame,
	        frameWidth,
	        frameHeight,
	        slideHeight;
	
	    slidesToScroll = props.slidesToScroll;
	    frame = this.refs.frame;
	    firstSlide = frame.childNodes[0].childNodes[0];
	    if (firstSlide) {
	      firstSlide.style.height = 'auto';
	      slideHeight = this.props.vertical ? firstSlide.offsetHeight * props.slidesToShow : firstSlide.offsetHeight;
	    } else {
	      slideHeight = 100;
	    }
	
	    if (typeof props.slideWidth !== 'number') {
	      slideWidth = parseInt(props.slideWidth);
	    } else {
	      if (props.vertical) {
	        slideWidth = slideHeight / props.slidesToShow * props.slideWidth;
	      } else {
	        slideWidth = frame.offsetWidth / props.slidesToShow * props.slideWidth;
	      }
	    }
	
	    if (!props.vertical) {
	      slideWidth -= props.cellSpacing * ((100 - 100 / props.slidesToShow) / 100);
	    }
	
	    frameHeight = slideHeight + props.cellSpacing * (props.slidesToShow - 1);
	    frameWidth = props.vertical ? frameHeight : frame.offsetWidth;
	
	    if (props.slidesToScroll === 'auto') {
	      slidesToScroll = Math.floor(frameWidth / (slideWidth + props.cellSpacing));
	    }
	
	    this.setState({
	      slideHeight: slideHeight,
	      frameWidth: frameWidth,
	      slideWidth: slideWidth,
	      slidesToScroll: slidesToScroll,
	      left: props.vertical ? 0 : this.getTargetLeft(),
	      top: props.vertical ? this.getTargetLeft() : 0
	    }, function () {
	      self.setLeft();
	    });
	  },
	  setLeft: function setLeft() {
	    this.setState({
	      left: this.props.vertical ? 0 : this.getTargetLeft(),
	      top: this.props.vertical ? this.getTargetLeft() : 0
	    });
	  },
	
	
	  // Data
	
	  setExternalData: function setExternalData() {
	    if (this.props.data) {
	      this.props.data();
	    }
	  },
	
	
	  // Styles
	
	  getListStyles: function getListStyles() {
	    var listWidth = this.state.slideWidth * _react2.default.Children.count(this.props.children);
	    var spacingOffset = this.props.cellSpacing * _react2.default.Children.count(this.props.children);
	    var transform = 'translate3d(' + this.getTweeningValue('left') + 'px, ' + this.getTweeningValue('top') + 'px, 0)';
	    return {
	      transform: transform,
	      WebkitTransform: transform,
	      msTransform: 'translate(' + this.getTweeningValue('left') + 'px, ' + this.getTweeningValue('top') + 'px)',
	      position: 'relative',
	      display: 'block',
	      margin: this.props.vertical ? this.props.cellSpacing / 2 * -1 + 'px 0px' : '0px ' + this.props.cellSpacing / 2 * -1 + 'px',
	      padding: 0,
	      height: this.props.vertical ? listWidth + spacingOffset : this.state.slideHeight,
	      width: this.props.vertical ? 'auto' : listWidth + spacingOffset,
	      cursor: this.state.dragging === true ? 'pointer' : 'inherit',
	      boxSizing: 'border-box',
	      MozBoxSizing: 'border-box'
	    };
	  },
	  getFrameStyles: function getFrameStyles() {
	    return {
	      position: 'relative',
	      display: 'block',
	      overflow: this.props.frameOverflow,
	      height: this.props.vertical ? this.state.frameWidth || 'initial' : 'auto',
	      margin: this.props.framePadding,
	      padding: 0,
	      transform: 'translate3d(0, 0, 0)',
	      WebkitTransform: 'translate3d(0, 0, 0)',
	      msTransform: 'translate(0, 0)',
	      boxSizing: 'border-box',
	      MozBoxSizing: 'border-box'
	    };
	  },
	  getSlideStyles: function getSlideStyles(index, positionValue) {
	    var targetPosition = this.getSlideTargetPosition(index, positionValue);
	    return {
	      position: 'absolute',
	      left: this.props.vertical ? 0 : targetPosition,
	      top: this.props.vertical ? targetPosition : 0,
	      display: this.props.vertical ? 'block' : 'inline-block',
	      listStyleType: 'none',
	      verticalAlign: 'top',
	      width: this.props.vertical ? '100%' : this.state.slideWidth,
	      height: 'auto',
	      boxSizing: 'border-box',
	      MozBoxSizing: 'border-box',
	      marginLeft: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
	      marginRight: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
	      marginTop: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
	      marginBottom: this.props.vertical ? this.props.cellSpacing / 2 : 'auto'
	    };
	  },
	  getSlideTargetPosition: function getSlideTargetPosition(index, positionValue) {
	    var slidesToShow = this.state.frameWidth / this.state.slideWidth;
	    var targetPosition = (this.state.slideWidth + this.props.cellSpacing) * index;
	    var end = (this.state.slideWidth + this.props.cellSpacing) * slidesToShow * -1;
	
	    if (this.props.wrapAround) {
	      var slidesBefore = Math.ceil(positionValue / this.state.slideWidth);
	      if (this.state.slideCount - slidesBefore <= index) {
	        return (this.state.slideWidth + this.props.cellSpacing) * (this.state.slideCount - index) * -1;
	      }
	
	      var slidesAfter = Math.ceil((Math.abs(positionValue) - Math.abs(end)) / this.state.slideWidth);
	
	      if (this.state.slideWidth !== 1) {
	        slidesAfter = Math.ceil((Math.abs(positionValue) - this.state.slideWidth) / this.state.slideWidth);
	      }
	
	      if (index <= slidesAfter - 1) {
	        return (this.state.slideWidth + this.props.cellSpacing) * (this.state.slideCount + index);
	      }
	    }
	
	    return targetPosition;
	  },
	  getSliderStyles: function getSliderStyles() {
	    return {
	      position: 'relative',
	      display: 'block',
	      width: this.props.width,
	      height: 'auto',
	      boxSizing: 'border-box',
	      MozBoxSizing: 'border-box',
	      visibility: this.state.slideWidth ? 'visible' : 'hidden'
	    };
	  },
	  getStyleTagStyles: function getStyleTagStyles() {
	    return '.slider-slide > img {width: 100%; display: block;}';
	  },
	  getDecoratorStyles: function getDecoratorStyles(position) {
	    switch (position) {
	      case 'TopLeft':
	        {
	          return {
	            position: 'absolute',
	            top: 0,
	            left: 0
	          };
	        }
	      case 'TopCenter':
	        {
	          return {
	            position: 'absolute',
	            top: 0,
	            left: '50%',
	            transform: 'translateX(-50%)',
	            WebkitTransform: 'translateX(-50%)',
	            msTransform: 'translateX(-50%)'
	          };
	        }
	      case 'TopRight':
	        {
	          return {
	            position: 'absolute',
	            top: 0,
	            right: 0
	          };
	        }
	      case 'CenterLeft':
	        {
	          return {
	            position: 'absolute',
	            top: '50%',
	            left: 0,
	            transform: 'translateY(-50%)',
	            WebkitTransform: 'translateY(-50%)',
	            msTransform: 'translateY(-50%)'
	          };
	        }
	      case 'CenterCenter':
	        {
	          return {
	            position: 'absolute',
	            top: '50%',
	            left: '50%',
	            transform: 'translate(-50%,-50%)',
	            WebkitTransform: 'translate(-50%, -50%)',
	            msTransform: 'translate(-50%, -50%)'
	          };
	        }
	      case 'CenterRight':
	        {
	          return {
	            position: 'absolute',
	            top: '50%',
	            right: 0,
	            transform: 'translateY(-50%)',
	            WebkitTransform: 'translateY(-50%)',
	            msTransform: 'translateY(-50%)'
	          };
	        }
	      case 'BottomLeft':
	        {
	          return {
	            position: 'absolute',
	            bottom: 0,
	            left: 0
	          };
	        }
	      case 'BottomCenter':
	        {
	          return {
	            position: 'absolute',
	            bottom: 0,
	            left: '50%',
	            transform: 'translateX(-50%)',
	            WebkitTransform: 'translateX(-50%)',
	            msTransform: 'translateX(-50%)'
	          };
	        }
	      case 'BottomRight':
	        {
	          return {
	            position: 'absolute',
	            bottom: 0,
	            right: 0
	          };
	        }
	      default:
	        {
	          return {
	            position: 'absolute',
	            top: 0,
	            left: 0
	          };
	        }
	    }
	  }
	});
	
	Carousel.ControllerMixin = {
	  getInitialState: function getInitialState() {
	    return {
	      carousels: {}
	    };
	  },
	  setCarouselData: function setCarouselData(carousel) {
	    var data = this.state.carousels;
	    data[carousel] = this.refs[carousel];
	    this.setState({
	      carousels: data
	    });
	  }
	};
	
	exports.default = Carousel;
	module.exports = exports['default'];

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(731);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultDecorators = [{
	  component: (0, _createReactClass2.default)({
	    displayName: 'component',
	    render: function render() {
	      return _react2.default.createElement(
	        'button',
	        {
	          style: this.getButtonStyles(this.props.currentSlide === 0 && !this.props.wrapAround),
	          onClick: this.handleClick },
	        'PREV'
	      );
	    },
	    handleClick: function handleClick(e) {
	      e.preventDefault();
	      this.props.previousSlide();
	    },
	    getButtonStyles: function getButtonStyles(disabled) {
	      return {
	        border: 0,
	        background: 'rgba(0,0,0,0.4)',
	        color: 'white',
	        padding: 10,
	        outline: 0,
	        opacity: disabled ? 0.3 : 1,
	        cursor: 'pointer'
	      };
	    }
	  }),
	  position: 'CenterLeft'
	}, {
	  component: (0, _createReactClass2.default)({
	    displayName: 'component',
	    render: function render() {
	      return _react2.default.createElement(
	        'button',
	        {
	          style: this.getButtonStyles(this.props.currentSlide + this.props.slidesToScroll >= this.props.slideCount && !this.props.wrapAround),
	          onClick: this.handleClick },
	        'NEXT'
	      );
	    },
	    handleClick: function handleClick(e) {
	      e.preventDefault();
	      this.props.nextSlide();
	    },
	    getButtonStyles: function getButtonStyles(disabled) {
	      return {
	        border: 0,
	        background: 'rgba(0,0,0,0.4)',
	        color: 'white',
	        padding: 10,
	        outline: 0,
	        opacity: disabled ? 0.3 : 1,
	        cursor: 'pointer'
	      };
	    }
	  }),
	  position: 'CenterRight'
	}, {
	  component: (0, _createReactClass2.default)({
	    displayName: 'component',
	    render: function render() {
	      var self = this;
	      var indexes = this.getIndexes(self.props.slideCount, self.props.slidesToScroll);
	      return _react2.default.createElement(
	        'ul',
	        { style: self.getListStyles() },
	        indexes.map(function (index) {
	          return _react2.default.createElement(
	            'li',
	            { style: self.getListItemStyles(), key: index },
	            _react2.default.createElement(
	              'button',
	              {
	                style: self.getButtonStyles(self.props.currentSlide === index),
	                onClick: self.props.goToSlide.bind(null, index) },
	              '\u2022'
	            )
	          );
	        })
	      );
	    },
	    getIndexes: function getIndexes(count, inc) {
	      var arr = [];
	      for (var i = 0; i < count; i += inc) {
	        arr.push(i);
	      }
	      return arr;
	    },
	    getListStyles: function getListStyles() {
	      return {
	        position: 'relative',
	        margin: 0,
	        top: -10,
	        padding: 0
	      };
	    },
	    getListItemStyles: function getListItemStyles() {
	      return {
	        listStyleType: 'none',
	        display: 'inline-block'
	      };
	    },
	    getButtonStyles: function getButtonStyles(active) {
	      return {
	        border: 0,
	        background: 'transparent',
	        color: 'black',
	        cursor: 'pointer',
	        padding: 10,
	        outline: 0,
	        fontSize: 24,
	        opacity: active ? 1 : 0.5
	      };
	    }
	  }),
	  position: 'BottomCenter'
	}];
	
	exports.default = DefaultDecorators;
	module.exports = exports['default'];

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(24);
	
	var emptyObject = __webpack_require__(138);
	var _invariant = __webpack_require__(13);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 1526 */
[1845, 1529, 1530, 1528],
/* 1527 */
[1846, 1526],
/* 1528 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1529 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(732);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(732);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(65);
	var invariant = __webpack_require__(13);
	var ReactPropTypesSecret = __webpack_require__(734);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(65);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(19);
	
	var ReactPropTypesSecret = __webpack_require__(734);
	var checkPropTypes = __webpack_require__(1533);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(1538);
	var parse = __webpack_require__(1537);
	var formats = __webpack_require__(735);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(736);
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    parameterLimit: 1000,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0; i < parts.length; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part);
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos));
	            val = options.decoder(part.slice(pos + 1));
	        }
	        if (has.call(obj, key)) {
	            obj[key] = [].concat(obj[key]).concat(val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function parseObjectRecursive(chain, val, options) {
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj;
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(parseObject(chain, val, options));
	    } else {
	        obj = options.plainObjects ? Object.create(null) : {};
	        var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	        var index = parseInt(cleanRoot, 10);
	        if (
	            !isNaN(index) &&
	            root !== cleanRoot &&
	            String(index) === cleanRoot &&
	            index >= 0 &&
	            (options.parseArrays && index <= options.arrayLimit)
	        ) {
	            obj = [];
	            obj[index] = parseObject(chain, val, options);
	        } else {
	            obj[cleanRoot] = parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys
	        // that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts || {};
	
	    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(736);
	var formats = __webpack_require__(735);
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
	        return prefix + '[]';
	    },
	    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
	        return prefix;
	    }
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaults = {
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var stringify = function stringify( // eslint-disable-line func-name-matching
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (Array.isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (Array.isArray(obj)) {
	            values = values.concat(stringify(
	                obj[key],
	                generateArrayPrefix(prefix, key),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        } else {
	            values = values.concat(stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts || {};
	
	    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
	    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
	    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
	    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
	    if (typeof options.format === 'undefined') {
	        options.format = formats.default;
	    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
	        throw new TypeError('Unknown format option provided.');
	    }
	    var formatter = formats.formatters[options.format];
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (Array.isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        keys = keys.concat(stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encode ? encoder : null,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            formatter,
	            encodeValuesOnly
	        ));
	    }
	
	    return keys.join(delimiter);
	};


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1773);
	var objectAssign = __webpack_require__(24);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	/**
	 * Returns `true` if both arguments are `true`; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if it is falsy, otherwise the second argument.
	 * @see R.both
	 * @example
	 *
	 *      R.and(true, true); //=> true
	 *      R.and(true, false); //=> false
	 *      R.and(false, true); //=> false
	 *      R.and(false, false); //=> false
	 */
	
	
	var and = /*#__PURE__*/_curry2(function and(a, b) {
	  return a && b;
	});
	module.exports = and;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(183);
	
	var _xany = /*#__PURE__*/__webpack_require__(750);
	
	/**
	 * Returns `true` if at least one of elements of the list match the predicate,
	 * `false` otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
	 *         otherwise.
	 * @see R.all, R.none, R.transduce
	 * @example
	 *
	 *      var lessThan0 = R.flip(R.lt)(0);
	 *      var lessThan2 = R.flip(R.lt)(2);
	 *      R.any(lessThan0)([1, 2]); //=> false
	 *      R.any(lessThan2)([1, 2]); //=> true
	 */
	
	
	var any = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['any'], _xany, function any(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (fn(list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	}));
	module.exports = any;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var curryN = /*#__PURE__*/__webpack_require__(128);
	
	var max = /*#__PURE__*/__webpack_require__(1578);
	
	var pluck = /*#__PURE__*/__webpack_require__(1582);
	
	var reduce = /*#__PURE__*/__webpack_require__(245);
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if at least one of the provided predicates is
	 * satisfied by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.allPass
	 * @example
	 *
	 *      var isClub = R.propEq('suit', '♣');
	 *      var isSpade = R.propEq('suit', '♠');
	 *      var isBlackCard = R.anyPass([isClub, isSpade]);
	 *
	 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
	 */
	
	
	var anyPass = /*#__PURE__*/_curry1(function anyPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function () {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (preds[idx].apply(this, arguments)) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  });
	});
	module.exports = anyPass;

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(359);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _reduce = /*#__PURE__*/__webpack_require__(185);
	
	var map = /*#__PURE__*/__webpack_require__(244);
	
	/**
	 * ap applies a list of functions to a list of values.
	 *
	 * Dispatches to the `ap` method of the second argument, if present. Also
	 * treats curried functions as applicatives.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig [a -> b] -> [a] -> [b]
	 * @sig Apply f => f (a -> b) -> f a -> f b
	 * @sig (a -> b -> c) -> (a -> b) -> (a -> c)
	 * @param {*} applyF
	 * @param {*} applyX
	 * @return {*}
	 * @example
	 *
	 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
	 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
	 *
	 *      // R.ap can also be used as S combinator
	 *      // when only two functions are passed
	 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
	 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
	 */
	
	
	var ap = /*#__PURE__*/_curry2(function ap(applyF, applyX) {
	  return typeof applyX['fantasy-land/ap'] === 'function' ? applyX['fantasy-land/ap'](applyF) : typeof applyF.ap === 'function' ? applyF.ap(applyX) : typeof applyF === 'function' ? function (x) {
	    return applyF(x)(applyX(x));
	  } :
	  // else
	  _reduce(function (acc, f) {
	    return _concat(acc, map(f, applyX));
	  }, [], applyF);
	});
	module.exports = ap;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(359);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	/**
	 * Returns a new list containing the contents of the given list, followed by
	 * the given element.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The element to add to the end of the new list.
	 * @param {Array} list The list of elements to add a new item to.
	 *        list.
	 * @return {Array} A new list containing the elements of the old list followed by `el`.
	 * @see R.prepend
	 * @example
	 *
	 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
	 *      R.append('tests', []); //=> ['tests']
	 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
	 */
	
	
	var append = /*#__PURE__*/_curry2(function append(el, list) {
	  return _concat(list, [el]);
	});
	module.exports = append;

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(68);
	
	var _has = /*#__PURE__*/__webpack_require__(147);
	
	var _isArray = /*#__PURE__*/__webpack_require__(184);
	
	var _isInteger = /*#__PURE__*/__webpack_require__(1561);
	
	var assoc = /*#__PURE__*/__webpack_require__(355);
	
	var isNil = /*#__PURE__*/__webpack_require__(751);
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the nodes required
	 * to create the given path, and placing the specific value at the tail end of
	 * that path. Note that this copies and flattens prototype properties onto the
	 * new object as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> {a}
	 * @param {Array} path the path to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except along the specified path.
	 * @see R.dissocPath
	 * @example
	 *
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
	 *
	 *      // Any missing or non-object keys in path will be overridden
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
	 */
	
	
	var assocPath = /*#__PURE__*/_curry3(function assocPath(path, val, obj) {
	  if (path.length === 0) {
	    return val;
	  }
	  var idx = path[0];
	  if (path.length > 1) {
	    var nextObj = !isNil(obj) && _has(idx, obj) ? obj[idx] : _isInteger(path[1]) ? [] : {};
	    val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
	  }
	  if (_isInteger(idx) && _isArray(obj)) {
	    var arr = [].concat(obj);
	    arr[idx] = val;
	    return arr;
	  } else {
	    return assoc(idx, val, obj);
	  }
	});
	module.exports = assocPath;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(240);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	/**
	 * Creates a function that is bound to a context.
	 * Note: `R.bind` does not provide the additional argument-binding capabilities of
	 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @category Object
	 * @sig (* -> *) -> {*} -> (* -> *)
	 * @param {Function} fn The function to bind to context
	 * @param {Object} thisObj The context to bind `fn` to
	 * @return {Function} A function that will execute in the context of `thisObj`.
	 * @see R.partial
	 * @example
	 *
	 *      var log = R.bind(console.log, console);
	 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
	 *      // logs {a: 2}
	 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
	 */
	
	
	var bind = /*#__PURE__*/_curry2(function bind(fn, thisObj) {
	  return _arity(fn.length, function () {
	    return fn.apply(thisObj, arguments);
	  });
	});
	module.exports = bind;

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var curryN = /*#__PURE__*/__webpack_require__(128);
	
	/**
	 * Returns a curried equivalent of the provided function. The curried function
	 * has two unusual capabilities. First, its arguments needn't be provided one
	 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
	 * the following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> a) -> (* -> a)
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curryN
	 * @example
	 *
	 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
	 *
	 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	
	
	var curry = /*#__PURE__*/_curry1(function curry(fn) {
	  return curryN(fn.length, fn);
	});
	module.exports = curry;

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var _isArguments = /*#__PURE__*/__webpack_require__(745);
	
	var _isArray = /*#__PURE__*/__webpack_require__(184);
	
	var _isObject = /*#__PURE__*/__webpack_require__(746);
	
	var _isString = /*#__PURE__*/__webpack_require__(747);
	
	/**
	 * Returns the empty value of its argument's type. Ramda defines the empty
	 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
	 * types are supported if they define `<Type>.empty`,
	 * `<Type>.prototype.empty` or implement the
	 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
	 *
	 * Dispatches to the `empty` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x
	 * @return {*}
	 * @example
	 *
	 *      R.empty(Just(42));      //=> Nothing()
	 *      R.empty([1, 2, 3]);     //=> []
	 *      R.empty('unicorns');    //=> ''
	 *      R.empty({x: 1, y: 2});  //=> {}
	 */
	
	
	var empty = /*#__PURE__*/_curry1(function empty(x) {
	  return x != null && typeof x['fantasy-land/empty'] === 'function' ? x['fantasy-land/empty']() : x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function' ? x.constructor['fantasy-land/empty']() : x != null && typeof x.empty === 'function' ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === 'function' ? x.constructor.empty() : _isArray(x) ? [] : _isString(x) ? '' : _isObject(x) ? {} : _isArguments(x) ? function () {
	    return arguments;
	  }() :
	  // else
	  void 0;
	});
	module.exports = empty;

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	/**
	 * Creates a new object by recursively evolving a shallow copy of `object`,
	 * according to the `transformation` functions. All non-primitive properties
	 * are copied by reference.
	 *
	 * A `transformation` function will not be invoked if its corresponding key
	 * does not exist in the evolved object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
	 * @param {Object} transformations The object specifying transformation functions to apply
	 *        to the object.
	 * @param {Object} object The object to be transformed.
	 * @return {Object} The transformed object.
	 * @example
	 *
	 *      var tomato  = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
	 *      var transformations = {
	 *        firstName: R.trim,
	 *        lastName: R.trim, // Will not get invoked.
	 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
	 *      };
	 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
	 */
	
	
	var evolve = /*#__PURE__*/_curry2(function evolve(transformations, object) {
	  var result = {};
	  var transformation, key, type;
	  for (key in object) {
	    transformation = transformations[key];
	    type = typeof transformation;
	    result[key] = type === 'function' ? transformation(object[key]) : transformation && type === 'object' ? evolve(transformation, object[key]) : object[key];
	  }
	  return result;
	});
	module.exports = evolve;

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(183);
	
	var _filter = /*#__PURE__*/__webpack_require__(1556);
	
	var _isObject = /*#__PURE__*/__webpack_require__(746);
	
	var _reduce = /*#__PURE__*/__webpack_require__(185);
	
	var _xfilter = /*#__PURE__*/__webpack_require__(1567);
	
	var keys = /*#__PURE__*/__webpack_require__(243);
	
	/**
	 * Takes a predicate and a `Filterable`, and returns a new filterable of the
	 * same type containing the members of the given filterable which satisfy the
	 * given predicate. Filterable objects include plain objects or any object
	 * that has a filter method such as `Array`.
	 *
	 * Dispatches to the `filter` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array} Filterable
	 * @see R.reject, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	
	
	var filter = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['filter'], _xfilter, function (pred, filterable) {
	  return _isObject(filterable) ? _reduce(function (acc, key) {
	    if (pred(filterable[key])) {
	      acc[key] = filterable[key];
	    }
	    return acc;
	  }, {}, keys(filterable)) :
	  // else
	  _filter(pred, filterable);
	}));
	module.exports = filter;

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var curryN = /*#__PURE__*/__webpack_require__(128);
	
	/**
	 * Returns a new function much like the supplied one, except that the first two
	 * arguments' order is reversed.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
	 * @param {Function} fn The function to invoke with its first two parameters reversed.
	 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
	 * @example
	 *
	 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
	 *
	 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
	 * @symb R.flip(f)(a, b, c) = f(b, a, c)
	 */
	
	
	var flip = /*#__PURE__*/_curry1(function flip(fn) {
	  return curryN(fn.length, function (a, b) {
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = b;
	    args[1] = a;
	    return fn.apply(this, args);
	  });
	});
	module.exports = flip;

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

	function _arrayFromIterator(iter) {
	  var list = [];
	  var next;
	  while (!(next = iter.next()).done) {
	    list.push(next.value);
	  }
	  return list;
	}
	module.exports = _arrayFromIterator;

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

	function _containsWith(pred, x, list) {
	  var idx = 0;
	  var len = list.length;
	
	  while (idx < len) {
	    if (pred(x, list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	}
	module.exports = _containsWith;

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(240);
	
	var _isPlaceholder = /*#__PURE__*/__webpack_require__(241);
	
	/**
	 * Internal curryN function.
	 *
	 * @private
	 * @category Function
	 * @param {Number} length The arity of the curried function.
	 * @param {Array} received An array of arguments received thus far.
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	
	
	function _curryN(length, received, fn) {
	  return function () {
	    var combined = [];
	    var argsIdx = 0;
	    var left = length;
	    var combinedIdx = 0;
	    while (combinedIdx < received.length || argsIdx < arguments.length) {
	      var result;
	      if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
	        result = received[combinedIdx];
	      } else {
	        result = arguments[argsIdx];
	        argsIdx += 1;
	      }
	      combined[combinedIdx] = result;
	      if (!_isPlaceholder(result)) {
	        left -= 1;
	      }
	      combinedIdx += 1;
	    }
	    return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
	  };
	}
	module.exports = _curryN;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	var _arrayFromIterator = /*#__PURE__*/__webpack_require__(1552);
	
	var _containsWith = /*#__PURE__*/__webpack_require__(1553);
	
	var _functionName = /*#__PURE__*/__webpack_require__(1557);
	
	var _has = /*#__PURE__*/__webpack_require__(147);
	
	var identical = /*#__PURE__*/__webpack_require__(741);
	
	var keys = /*#__PURE__*/__webpack_require__(243);
	
	var type = /*#__PURE__*/__webpack_require__(1590);
	
	/**
	 * private _uniqContentEquals function.
	 * That function is checking equality of 2 iterator contents with 2 assumptions
	 * - iterators lengths are the same
	 * - iterators values are unique
	 *
	 * false-positive result will be returned for comparision of, e.g.
	 * - [1,2,3] and [1,2,3,4]
	 * - [1,1,1] and [1,2,3]
	 * */
	
	function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
	  var a = _arrayFromIterator(aIterator);
	  var b = _arrayFromIterator(bIterator);
	
	  function eq(_a, _b) {
	    return _equals(_a, _b, stackA.slice(), stackB.slice());
	  }
	
	  // if *a* array contains any element that is not included in *b*
	  return !_containsWith(function (b, aItem) {
	    return !_containsWith(eq, aItem, b);
	  }, b, a);
	}
	
	function _equals(a, b, stackA, stackB) {
	  if (identical(a, b)) {
	    return true;
	  }
	
	  var typeA = type(a);
	
	  if (typeA !== type(b)) {
	    return false;
	  }
	
	  if (a == null || b == null) {
	    return false;
	  }
	
	  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
	    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
	  }
	
	  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
	    return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
	  }
	
	  switch (typeA) {
	    case 'Arguments':
	    case 'Array':
	    case 'Object':
	      if (typeof a.constructor === 'function' && _functionName(a.constructor) === 'Promise') {
	        return a === b;
	      }
	      break;
	    case 'Boolean':
	    case 'Number':
	    case 'String':
	      if (!(typeof a === typeof b && identical(a.valueOf(), b.valueOf()))) {
	        return false;
	      }
	      break;
	    case 'Date':
	      if (!identical(a.valueOf(), b.valueOf())) {
	        return false;
	      }
	      break;
	    case 'Error':
	      return a.name === b.name && a.message === b.message;
	    case 'RegExp':
	      if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
	        return false;
	      }
	      break;
	  }
	
	  var idx = stackA.length - 1;
	  while (idx >= 0) {
	    if (stackA[idx] === a) {
	      return stackB[idx] === b;
	    }
	    idx -= 1;
	  }
	
	  switch (typeA) {
	    case 'Map':
	      if (a.size !== b.size) {
	        return false;
	      }
	
	      return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));
	    case 'Set':
	      if (a.size !== b.size) {
	        return false;
	      }
	
	      return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));
	    case 'Arguments':
	    case 'Array':
	    case 'Object':
	    case 'Boolean':
	    case 'Number':
	    case 'String':
	    case 'Date':
	    case 'Error':
	    case 'RegExp':
	    case 'Int8Array':
	    case 'Uint8Array':
	    case 'Uint8ClampedArray':
	    case 'Int16Array':
	    case 'Uint16Array':
	    case 'Int32Array':
	    case 'Uint32Array':
	    case 'Float32Array':
	    case 'Float64Array':
	    case 'ArrayBuffer':
	      break;
	    default:
	      // Values of other types are only equal if identical.
	      return false;
	  }
	
	  var keysA = keys(a);
	  if (keysA.length !== keys(b).length) {
	    return false;
	  }
	
	  var extendedStackA = stackA.concat([a]);
	  var extendedStackB = stackB.concat([b]);
	
	  idx = keysA.length - 1;
	  while (idx >= 0) {
	    var key = keysA[idx];
	    if (!(_has(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
	      return false;
	    }
	    idx -= 1;
	  }
	  return true;
	}
	module.exports = _equals;

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

	function _filter(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	
	  while (idx < len) {
	    if (fn(list[idx])) {
	      result[result.length] = list[idx];
	    }
	    idx += 1;
	  }
	  return result;
	}
	module.exports = _filter;

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

	function _functionName(f) {
	  // String(x => x) evaluates to "x => x", so the pattern may not match.
	  var match = String(f).match(/^function (\w*)/);
	  return match == null ? '' : match[1];
	}
	module.exports = _functionName;

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

	function _identity(x) {
	  return x;
	}
	module.exports = _identity;

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	var equals = /*#__PURE__*/__webpack_require__(107);
	
	function _indexOf(list, a, idx) {
	  var inf, item;
	  // Array.prototype.indexOf doesn't exist below IE9
	  if (typeof list.indexOf === 'function') {
	    switch (typeof a) {
	      case 'number':
	        if (a === 0) {
	          // manually crawl the list to distinguish between +0 and -0
	          inf = 1 / a;
	          while (idx < list.length) {
	            item = list[idx];
	            if (item === 0 && 1 / item === inf) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        } else if (a !== a) {
	          // NaN
	          while (idx < list.length) {
	            item = list[idx];
	            if (typeof item === 'number' && item !== item) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        }
	        // non-zero numbers can utilise Set
	        return list.indexOf(a, idx);
	
	      // all these types can utilise Set
	      case 'string':
	      case 'boolean':
	      case 'function':
	      case 'undefined':
	        return list.indexOf(a, idx);
	
	      case 'object':
	        if (a === null) {
	          // null can utilise Set
	          return list.indexOf(a, idx);
	        }
	    }
	  }
	  // anything else not covered above, defer to R.equals
	  while (idx < list.length) {
	    if (equals(list[idx], a)) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	}
	module.exports = _indexOf;

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var _isArray = /*#__PURE__*/__webpack_require__(184);
	
	var _isString = /*#__PURE__*/__webpack_require__(747);
	
	/**
	 * Tests whether or not an object is similar to an array.
	 *
	 * @private
	 * @category Type
	 * @category List
	 * @sig * -> Boolean
	 * @param {*} x The object to test.
	 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
	 * @example
	 *
	 *      _isArrayLike([]); //=> true
	 *      _isArrayLike(true); //=> false
	 *      _isArrayLike({}); //=> false
	 *      _isArrayLike({length: 10}); //=> false
	 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
	 */
	
	
	var _isArrayLike = /*#__PURE__*/_curry1(function isArrayLike(x) {
	  if (_isArray(x)) {
	    return true;
	  }
	  if (!x) {
	    return false;
	  }
	  if (typeof x !== 'object') {
	    return false;
	  }
	  if (_isString(x)) {
	    return false;
	  }
	  if (x.nodeType === 1) {
	    return !!x.length;
	  }
	  if (x.length === 0) {
	    return true;
	  }
	  if (x.length > 0) {
	    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
	  }
	  return false;
	});
	module.exports = _isArrayLike;

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

	/**
	 * Determine if the passed argument is an integer.
	 *
	 * @private
	 * @param {*} n
	 * @category Type
	 * @return {Boolean}
	 */
	module.exports = Number.isInteger || function _isInteger(n) {
	  return n << 0 === n;
	};

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

	function _isTransformer(obj) {
	  return typeof obj['@@transducer/step'] === 'function';
	}
	module.exports = _isTransformer;

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

	function _pipe(f, g) {
	  return function () {
	    return g.call(this, f.apply(this, arguments));
	  };
	}
	module.exports = _pipe;

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

	function _quote(s) {
	  var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b') // \b matches word boundary; [\b] matches backspace
	  .replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');
	
	  return '"' + escaped.replace(/"/g, '\\"') + '"';
	}
	module.exports = _quote;

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

	/**
	 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
	 */
	var pad = function pad(n) {
	  return (n < 10 ? '0' : '') + n;
	};
	
	var _toISOString = typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
	  return d.toISOString();
	} : function _toISOString(d) {
	  return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
	};
	
	module.exports = _toISOString;

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = /*#__PURE__*/__webpack_require__(360);
	
	var _map = /*#__PURE__*/__webpack_require__(748);
	
	var _quote = /*#__PURE__*/__webpack_require__(1564);
	
	var _toISOString = /*#__PURE__*/__webpack_require__(1565);
	
	var keys = /*#__PURE__*/__webpack_require__(243);
	
	var reject = /*#__PURE__*/__webpack_require__(756);
	
	function _toString(x, seen) {
	  var recur = function recur(y) {
	    var xs = seen.concat([x]);
	    return _contains(y, xs) ? '<Circular>' : _toString(y, xs);
	  };
	
	  //  mapPairs :: (Object, [String]) -> [String]
	  var mapPairs = function (obj, keys) {
	    return _map(function (k) {
	      return _quote(k) + ': ' + recur(obj[k]);
	    }, keys.slice().sort());
	  };
	
	  switch (Object.prototype.toString.call(x)) {
	    case '[object Arguments]':
	      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';
	    case '[object Array]':
	      return '[' + _map(recur, x).concat(mapPairs(x, reject(function (k) {
	        return (/^\d+$/.test(k)
	        );
	      }, keys(x)))).join(', ') + ']';
	    case '[object Boolean]':
	      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
	    case '[object Date]':
	      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';
	    case '[object Null]':
	      return 'null';
	    case '[object Number]':
	      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
	    case '[object String]':
	      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);
	    case '[object Undefined]':
	      return 'undefined';
	    default:
	      if (typeof x.toString === 'function') {
	        var repr = x.toString();
	        if (repr !== '[object Object]') {
	          return repr;
	        }
	      }
	      return '{' + mapPairs(x, keys(x)).join(', ') + '}';
	  }
	}
	module.exports = _toString;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(242);
	
	var XFilter = /*#__PURE__*/function () {
	
	  function XFilter(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFilter.prototype['@@transducer/init'] = _xfBase.init;
	  XFilter.prototype['@@transducer/result'] = _xfBase.result;
	  XFilter.prototype['@@transducer/step'] = function (result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
	  };
	
	  return XFilter;
	}();
	
	var _xfilter = /*#__PURE__*/_curry2(function _xfilter(f, xf) {
	  return new XFilter(f, xf);
	});
	module.exports = _xfilter;

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _reduced = /*#__PURE__*/__webpack_require__(749);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(242);
	
	var XFind = /*#__PURE__*/function () {
	
	  function XFind(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.found = false;
	  }
	  XFind.prototype['@@transducer/init'] = _xfBase.init;
	  XFind.prototype['@@transducer/result'] = function (result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, void 0);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFind.prototype['@@transducer/step'] = function (result, input) {
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, input));
	    }
	    return result;
	  };
	
	  return XFind;
	}();
	
	var _xfind = /*#__PURE__*/_curry2(function _xfind(f, xf) {
	  return new XFind(f, xf);
	});
	module.exports = _xfind;

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(242);
	
	var XMap = /*#__PURE__*/function () {
	
	  function XMap(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XMap.prototype['@@transducer/init'] = _xfBase.init;
	  XMap.prototype['@@transducer/result'] = _xfBase.result;
	  XMap.prototype['@@transducer/step'] = function (result, input) {
	    return this.xf['@@transducer/step'](result, this.f(input));
	  };
	
	  return XMap;
	}();
	
	var _xmap = /*#__PURE__*/_curry2(function _xmap(f, xf) {
	  return new XMap(f, xf);
	});
	module.exports = _xmap;

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

	var XWrap = /*#__PURE__*/function () {
	  function XWrap(fn) {
	    this.f = fn;
	  }
	  XWrap.prototype['@@transducer/init'] = function () {
	    throw new Error('init not implemented on XWrap');
	  };
	  XWrap.prototype['@@transducer/result'] = function (acc) {
	    return acc;
	  };
	  XWrap.prototype['@@transducer/step'] = function (acc, x) {
	    return this.f(acc, x);
	  };
	
	  return XWrap;
	}();
	
	function _xwrap(fn) {
	  return new XWrap(fn);
	}
	module.exports = _xwrap;

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _isFunction = /*#__PURE__*/__webpack_require__(361);
	
	var curryN = /*#__PURE__*/__webpack_require__(128);
	
	var toString = /*#__PURE__*/__webpack_require__(1589);
	
	/**
	 * Turns a named method with a specified arity into a function that can be
	 * called directly supplied with arguments and a target object.
	 *
	 * The returned function is curried and accepts `arity + 1` parameters where
	 * the final parameter is the target object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
	 * @param {Number} arity Number of arguments the returned function should take
	 *        before the target object.
	 * @param {String} method Name of the method to call.
	 * @return {Function} A new curried function.
	 * @see R.construct
	 * @example
	 *
	 *      var sliceFrom = R.invoker(1, 'slice');
	 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
	 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
	 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
	 * @symb R.invoker(0, 'method')(o) = o['method']()
	 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
	 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
	 */
	
	
	var invoker = /*#__PURE__*/_curry2(function invoker(arity, method) {
	  return curryN(arity + 1, function () {
	    var target = arguments[arity];
	    if (target != null && _isFunction(target[method])) {
	      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
	    }
	    throw new TypeError(toString(target) + ' does not have a method named "' + method + '"');
	  });
	});
	module.exports = invoker;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	/**
	 * See if an object (`val`) is an instance of the supplied constructor. This
	 * function will check up the inheritance chain, if any.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Type
	 * @sig (* -> {*}) -> a -> Boolean
	 * @param {Object} ctor A constructor
	 * @param {*} val The value to test
	 * @return {Boolean}
	 * @example
	 *
	 *      R.is(Object, {}); //=> true
	 *      R.is(Number, 1); //=> true
	 *      R.is(Object, 1); //=> false
	 *      R.is(String, 's'); //=> true
	 *      R.is(String, new String('')); //=> true
	 *      R.is(Object, new String('')); //=> true
	 *      R.is(Object, 's'); //=> false
	 *      R.is(Number, {}); //=> false
	 */
	
	
	var is = /*#__PURE__*/_curry2(function is(Ctor, val) {
	  return val != null && val.constructor === Ctor || val instanceof Ctor;
	});
	module.exports = is;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var empty = /*#__PURE__*/__webpack_require__(1548);
	
	var equals = /*#__PURE__*/__webpack_require__(107);
	
	/**
	 * Returns `true` if the given value is its type's empty value; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> Boolean
	 * @param {*} x
	 * @return {Boolean}
	 * @see R.empty
	 * @example
	 *
	 *      R.isEmpty([1, 2, 3]);   //=> false
	 *      R.isEmpty([]);          //=> true
	 *      R.isEmpty('');          //=> true
	 *      R.isEmpty(null);        //=> false
	 *      R.isEmpty({});          //=> true
	 *      R.isEmpty({length: 0}); //=> false
	 */
	
	
	var isEmpty = /*#__PURE__*/_curry1(function isEmpty(x) {
	  return x != null && equals(x, empty(x));
	});
	module.exports = isEmpty;

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = /*#__PURE__*/__webpack_require__(1571);
	
	/**
	 * Returns a string made by inserting the `separator` between each element and
	 * concatenating all the elements into a single string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig String -> [a] -> String
	 * @param {Number|String} separator The string used to separate the elements.
	 * @param {Array} xs The elements to join into a string.
	 * @return {String} str The string made by concatenating `xs` with `separator`.
	 * @see R.split
	 * @example
	 *
	 *      var spacer = R.join(' ');
	 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
	 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
	 */
	
	
	var join = /*#__PURE__*/invoker(1, 'join');
	module.exports = join;

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var map = /*#__PURE__*/__webpack_require__(244);
	
	/**
	 * Returns a lens for the given getter and setter functions. The getter "gets"
	 * the value of the focus; the setter "sets" the value of the focus. The setter
	 * should not mutate the data structure.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
	 * @param {Function} getter
	 * @param {Function} setter
	 * @return {Lens}
	 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lens(R.prop('x'), R.assoc('x'));
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	
	
	var lens = /*#__PURE__*/_curry2(function lens(getter, setter) {
	  return function (toFunctorFn) {
	    return function (target) {
	      return map(function (focus) {
	        return setter(focus, target);
	      }, toFunctorFn(getter(target)));
	    };
	  };
	});
	module.exports = lens;

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var assocPath = /*#__PURE__*/__webpack_require__(1545);
	
	var lens = /*#__PURE__*/__webpack_require__(1575);
	
	var path = /*#__PURE__*/__webpack_require__(87);
	
	/**
	 * Returns a lens whose focus is the specified path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig [Idx] -> Lens s a
	 * @param {Array} path The path to use.
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xHeadYLens = R.lensPath(['x', 0, 'y']);
	 *
	 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> 2
	 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
	 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
	 */
	
	
	var lensPath = /*#__PURE__*/_curry1(function lensPath(p) {
	  return lens(path(p), assocPath(p));
	});
	module.exports = lensPath;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var _reduce = /*#__PURE__*/__webpack_require__(185);
	
	var ap = /*#__PURE__*/__webpack_require__(1543);
	
	var curryN = /*#__PURE__*/__webpack_require__(128);
	
	var map = /*#__PURE__*/__webpack_require__(244);
	
	/**
	 * "lifts" a function to be the specified arity, so that it may "map over" that
	 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig Number -> (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.lift, R.ap
	 * @example
	 *
	 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 */
	
	
	var liftN = /*#__PURE__*/_curry2(function liftN(arity, fn) {
	  var lifted = curryN(arity, fn);
	  return curryN(arity, function () {
	    return _reduce(ap, map(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
	  });
	});
	module.exports = liftN;

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	/**
	 * Returns the larger of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.maxBy, R.min
	 * @example
	 *
	 *      R.max(789, 123); //=> 789
	 *      R.max('a', 'b'); //=> 'b'
	 */
	
	
	var max = /*#__PURE__*/_curry2(function max(a, b) {
	  return b > a ? b : a;
	});
	module.exports = max;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	/**
	 * Returns `true` if one or both of its arguments are `true`. Returns `false`
	 * if both arguments are `false`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if truthy, otherwise the second argument.
	 * @see R.either
	 * @example
	 *
	 *      R.or(true, true); //=> true
	 *      R.or(true, false); //=> true
	 *      R.or(false, true); //=> true
	 *      R.or(false, false); //=> false
	 */
	
	
	var or = /*#__PURE__*/_curry2(function or(a, b) {
	  return a || b;
	});
	module.exports = or;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(68);
	
	// `Identity` is a functor that holds a single value, where `map` simply
	// transforms the held value with the provided function.
	
	
	var Identity = function (x) {
	  return { value: x, map: function (f) {
	      return Identity(f(x));
	    } };
	};
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the result of applying the given function to
	 * the focused value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> (a -> a) -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
	 */
	var over = /*#__PURE__*/_curry3(function over(lens, f, x) {
	  // The value returned by the getter function is first transformed with `f`,
	  // then set as the value of an `Identity`. This is then mapped over with the
	  // setter function of the lens.
	  return lens(function (y) {
	    return Identity(f(y));
	  })(x).value;
	});
	module.exports = over;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(68);
	
	var equals = /*#__PURE__*/__webpack_require__(107);
	
	var path = /*#__PURE__*/__webpack_require__(87);
	
	/**
	 * Determines whether a nested path on an object has a specific value, in
	 * [`R.equals`](#equals) terms. Most likely used to filter a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Relation
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> Boolean
	 * @param {Array} path The path of the nested property to use
	 * @param {*} val The value to compare the nested property with
	 * @param {Object} obj The object to check the nested property in
	 * @return {Boolean} `true` if the value equals the nested object property,
	 *         `false` otherwise.
	 * @example
	 *
	 *      var user1 = { address: { zipCode: 90210 } };
	 *      var user2 = { address: { zipCode: 55555 } };
	 *      var user3 = { name: 'Bob' };
	 *      var users = [ user1, user2, user3 ];
	 *      var isFamous = R.pathEq(['address', 'zipCode'], 90210);
	 *      R.filter(isFamous, users); //=> [ user1 ]
	 */
	
	
	var pathEq = /*#__PURE__*/_curry3(function pathEq(_path, val, obj) {
	  return equals(path(_path, obj), val);
	});
	module.exports = pathEq;

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var map = /*#__PURE__*/__webpack_require__(244);
	
	var prop = /*#__PURE__*/__webpack_require__(88);
	
	/**
	 * Returns a new list by plucking the same named property off all objects in
	 * the list supplied.
	 *
	 * `pluck` will work on
	 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
	 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => k -> f {k: v} -> f v
	 * @param {Number|String} key The key name to pluck off of each object.
	 * @param {Array} f The array or functor to consider.
	 * @return {Array} The list of values for the given key.
	 * @see R.props
	 * @example
	 *
	 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
	 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
	 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
	 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
	 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
	 */
	
	
	var pluck = /*#__PURE__*/_curry2(function pluck(p, list) {
	  return map(prop(p), list);
	});
	module.exports = pluck;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(359);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	/**
	 * Returns a new list with the given element at the front, followed by the
	 * contents of the list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The item to add to the head of the output list.
	 * @param {Array} list The array to add to the tail of the output list.
	 * @return {Array} A new array.
	 * @see R.append
	 * @example
	 *
	 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
	 */
	
	
	var prepend = /*#__PURE__*/_curry2(function prepend(el, list) {
	  return _concat([el], list);
	});
	module.exports = prepend;

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(68);
	
	var _has = /*#__PURE__*/__webpack_require__(147);
	
	/**
	 * If the given, non-null object has an own property with the specified name,
	 * returns the value of that property. Otherwise returns the provided default
	 * value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Object
	 * @sig a -> String -> Object -> a
	 * @param {*} val The default value.
	 * @param {String} p The name of the property to return.
	 * @param {Object} obj The object to query.
	 * @return {*} The value of given property of the supplied object or the default value.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var favorite = R.prop('favoriteLibrary');
	 *      var favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
	 *
	 *      favorite(alice);  //=> undefined
	 *      favoriteWithDefault(alice);  //=> 'Ramda'
	 */
	
	
	var propOr = /*#__PURE__*/_curry3(function propOr(val, p, obj) {
	  return obj != null && _has(p, obj) ? obj[p] : val;
	});
	module.exports = propOr;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(68);
	
	var always = /*#__PURE__*/__webpack_require__(354);
	
	var over = /*#__PURE__*/__webpack_require__(1580);
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> a -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
	 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
	 */
	
	
	var set = /*#__PURE__*/_curry3(function set(lens, v, x) {
	  return over(lens, always(v), x);
	});
	module.exports = set;

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = /*#__PURE__*/__webpack_require__(743);
	
	var _curry3 = /*#__PURE__*/__webpack_require__(68);
	
	/**
	 * Returns the elements of the given list or string (or object with a `slice`
	 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
	 *
	 * Dispatches to the `slice` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @sig Number -> Number -> String -> String
	 * @param {Number} fromIndex The start index (inclusive).
	 * @param {Number} toIndex The end index (exclusive).
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
	 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
	 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
	 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
	 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
	 */
	
	
	var slice = /*#__PURE__*/_curry3( /*#__PURE__*/_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
	  return Array.prototype.slice.call(list, fromIndex, toIndex);
	}));
	module.exports = slice;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = /*#__PURE__*/__webpack_require__(743);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var slice = /*#__PURE__*/__webpack_require__(1586);
	
	/**
	 * Returns all but the first element of the given list or string (or object
	 * with a `tail` method).
	 *
	 * Dispatches to the `slice` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.head, R.init, R.last
	 * @example
	 *
	 *      R.tail([1, 2, 3]);  //=> [2, 3]
	 *      R.tail([1, 2]);     //=> [2]
	 *      R.tail([1]);        //=> []
	 *      R.tail([]);         //=> []
	 *
	 *      R.tail('abc');  //=> 'bc'
	 *      R.tail('ab');   //=> 'b'
	 *      R.tail('a');    //=> ''
	 *      R.tail('');     //=> ''
	 */
	
	
	var tail = /*#__PURE__*/_curry1( /*#__PURE__*/_checkForMethod('tail', /*#__PURE__*/slice(1, Infinity)));
	module.exports = tail;

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var _has = /*#__PURE__*/__webpack_require__(147);
	
	/**
	 * Converts an object into an array of key, value arrays. Only the object's
	 * own properties are used.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own properties.
	 * @see R.fromPairs
	 * @example
	 *
	 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
	 */
	
	
	var toPairs = /*#__PURE__*/_curry1(function toPairs(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    if (_has(prop, obj)) {
	      pairs[pairs.length] = [prop, obj[prop]];
	    }
	  }
	  return pairs;
	});
	module.exports = toPairs;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	var _toString = /*#__PURE__*/__webpack_require__(1566);
	
	/**
	 * Returns the string representation of the given value. `eval`'ing the output
	 * should result in a value equivalent to the input value. Many of the built-in
	 * `toString` methods do not satisfy this requirement.
	 *
	 * If the given value is an `[object Object]` with a `toString` method other
	 * than `Object.prototype.toString`, this method is invoked with no arguments
	 * to produce the return value. This means user-defined constructor functions
	 * can provide a suitable `toString` method. For example:
	 *
	 *     function Point(x, y) {
	 *       this.x = x;
	 *       this.y = y;
	 *     }
	 *
	 *     Point.prototype.toString = function() {
	 *       return 'new Point(' + this.x + ', ' + this.y + ')';
	 *     };
	 *
	 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category String
	 * @sig * -> String
	 * @param {*} val
	 * @return {String}
	 * @example
	 *
	 *      R.toString(42); //=> '42'
	 *      R.toString('abc'); //=> '"abc"'
	 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
	 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
	 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
	 */
	
	
	var toString = /*#__PURE__*/_curry1(function toString(val) {
	  return _toString(val, []);
	});
	module.exports = toString;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(39);
	
	/**
	 * Gives a single-word string description of the (native) type of a value,
	 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
	 * attempt to distinguish user Object types any further, reporting them all as
	 * 'Object'.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Type
	 * @sig (* -> {*}) -> String
	 * @param {*} val The value to test
	 * @return {String}
	 * @example
	 *
	 *      R.type({}); //=> "Object"
	 *      R.type(1); //=> "Number"
	 *      R.type(false); //=> "Boolean"
	 *      R.type('s'); //=> "String"
	 *      R.type(null); //=> "Null"
	 *      R.type([]); //=> "Array"
	 *      R.type(/[A-z]/); //=> "RegExp"
	 *      R.type(() => {}); //=> "Function"
	 *      R.type(undefined); //=> "Undefined"
	 */
	
	
	var type = /*#__PURE__*/_curry1(function type(val) {
	  return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
	});
	module.exports = type;

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	// `Const` is a functor that effectively ignores the function given to `map`.
	
	
	var Const = function (x) {
	  return { value: x, 'fantasy-land/map': function () {
	      return this;
	    } };
	};
	
	/**
	 * Returns a "view" of the given data structure, determined by the given lens.
	 * The lens's focus determines which portion of the data structure is visible.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> s -> a
	 * @param {Lens} lens
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});  //=> 1
	 *      R.view(xLens, {x: 4, y: 2});  //=> 4
	 */
	var view = /*#__PURE__*/_curry2(function view(lens, x) {
	  // Using `Const` effectively ignores the setter function of the `lens`,
	  // leaving the value returned by the getter function unmodified.
	  return lens(Const)(x).value;
	});
	module.exports = view;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = /*#__PURE__*/__webpack_require__(360);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(17);
	
	var flip = /*#__PURE__*/__webpack_require__(1551);
	
	var reject = /*#__PURE__*/__webpack_require__(756);
	
	/**
	 * Returns a new list without values in the first argument.
	 * [`R.equals`](#equals) is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @param {Array} list1 The values to be removed from `list2`.
	 * @param {Array} list2 The array to remove values from.
	 * @return {Array} The new array without values in `list1`.
	 * @see R.transduce, R.difference
	 * @example
	 *
	 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
	 */
	
	
	var without = /*#__PURE__*/_curry2(function (xs, list) {
	  return reject(flip(_contains)(xs), list);
	});
	module.exports = without;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var hoistNonReactStatic = __webpack_require__(316);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(149);
	
	module.exports = function enhanceWithClickOutside(WrappedComponent) {
	  var componentName = WrappedComponent.displayName || WrappedComponent.name;
	
	  var EnhancedComponent = React.createClass({
	    displayName: 'Wrapped' + componentName,
	
	    componentDidMount: function componentDidMount() {
	      this.__wrappedComponent = this.refs.wrappedComponent;
	      document.addEventListener('click', this.handleClickOutside, true);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      document.removeEventListener('click', this.handleClickOutside, true);
	    },
	    handleClickOutside: function handleClickOutside(e) {
	      var domNode = ReactDOM.findDOMNode(this);
	      if ((!domNode || !domNode.contains(e.target)) && typeof this.refs.wrappedComponent.handleClickOutside === 'function') {
	        this.refs.wrappedComponent.handleClickOutside(e);
	      }
	    },
	    render: function render() {
	      return React.createElement(WrappedComponent, _extends({}, this.props, { ref: 'wrappedComponent' }));
	    }
	  });
	
	  return hoistNonReactStatic(EnhancedComponent, WrappedComponent);
	};

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 5);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.0
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader = false;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
					__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
					(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
					__WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init (converter) {
			function api (key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					// We're using "expires" because "max-age" is not supported by IE
					attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value))
							.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					var stringifiedAttributes = '';
	
					for (var attributeName in attributes) {
						if (!attributes[attributeName]) {
							continue;
						}
						stringifiedAttributes += '; ' + attributeName;
						if (attributes[attributeName] === true) {
							continue;
						}
						stringifiedAttributes += '=' + attributes[attributeName];
					}
					return (document.cookie = key + '=' + value + stringifiedAttributes);
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!this.json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ?
							converter.read(cookie, name) : converter(cookie, name) ||
							cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (process.env.NODE_ENV !== 'production') {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(9)(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(8)();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(1599);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Cookies = exports.OPTIONS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jsCookie = __webpack_require__(2);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OPTIONS = exports.OPTIONS = {
	  TOP: "top",
	  BOTTOM: "bottom",
	  NONE: "none"
	};
	
	var CookieConsent = function (_Component) {
	  _inherits(CookieConsent, _Component);
	
	  function CookieConsent(props) {
	    _classCallCheck(this, CookieConsent);
	
	    var _this = _possibleConstructorReturn(this, (CookieConsent.__proto__ || Object.getPrototypeOf(CookieConsent)).call(this, props));
	
	    _this.accept.bind(_this);
	
	    _this.state = {
	      visible: false,
	      style: {
	        alignItems: "baseline",
	        background: "#353535",
	        color: "white",
	        display: "flex",
	        flexWrap: "wrap",
	        justifyContent: "space-between",
	        left: "0",
	        position: "fixed",
	        width: "100%",
	        zIndex: "999"
	      },
	      buttonStyle: {
	        background: "#ffd42d",
	        border: "0",
	        borderRadius: "0px",
	        boxShadow: "none",
	        color: "black",
	        flex: "0 0 auto",
	        padding: "5px 10px",
	        margin: "15px"
	      },
	      contentStyle: {
	        flex: "1 0 300px",
	        margin: "15px"
	      }
	    };
	
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(CookieConsent, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _props = this.props,
	          cookieName = _props.cookieName,
	          debug = _props.debug;
	
	      // if cookie undefined or debug
	
	      if (_jsCookie2.default.get(cookieName) === undefined || debug) {
	        this.setState({ visible: true });
	      }
	
	      // if acceptOnScroll is set to true, add a listener
	      if (this.props.acceptOnScroll) {
	        window.addEventListener("scroll", this.handleScroll, { passive: true });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      // remove listener if still set
	      window.removeEventListener("scroll", this.handleScroll);
	    }
	
	    /**
	     * checks whether scroll has exceeded set amount and fire accept if so.
	     */
	
	  }, {
	    key: "handleScroll",
	    value: function handleScroll() {
	      // (top / height) - height * 100
	      var rootNode = document.documentElement,
	          body = document.body,
	          top = "scrollTop",
	          height = "scrollHeight";
	
	      var percentage = (rootNode[top] || body[top]) / ((rootNode[height] || body[height]) - rootNode.clientHeight) * 100;
	
	      if (percentage > this.props.acceptOnScrollPercentage) {
	        this.accept();
	      }
	    }
	
	    /**
	     * Set a persistent cookie
	     */
	
	  }, {
	    key: "accept",
	    value: function accept() {
	      var _props2 = this.props,
	          cookieName = _props2.cookieName,
	          expires = _props2.expires,
	          hideOnAccept = _props2.hideOnAccept,
	          onAccept = _props2.onAccept,
	          extraCookieOptions = _props2.extraCookieOptions;
	
	      // fire onAccept
	
	      onAccept();
	      // remove listener if set
	      window.removeEventListener("scroll", this.handleScroll);
	
	      _jsCookie2.default.set(cookieName, true, _extends({ expires: expires }, extraCookieOptions));
	
	      if (hideOnAccept) {
	        this.setState({ visible: false });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      // If the bar shouldn't be visible don't render anything.
	      if (!this.state.visible) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          location = _props3.location,
	          style = _props3.style,
	          buttonStyle = _props3.buttonStyle,
	          contentStyle = _props3.contentStyle,
	          disableStyles = _props3.disableStyles,
	          buttonText = _props3.buttonText,
	          containerClasses = _props3.containerClasses,
	          contentClasses = _props3.contentClasses,
	          buttonClasses = _props3.buttonClasses;
	
	
	      var myStyle = {};
	      var myButtonStyle = {};
	      var myContentStyle = {};
	
	      if (disableStyles) {
	        // if styles are disabled use the provided styles (or non)
	        myStyle = Object.assign({}, style);
	        myButtonStyle = Object.assign({}, buttonStyle);
	        myContentStyle = Object.assign({}, contentStyle);
	      } else {
	        // if styles aren't disabled merge them with the styles that are provided (or use default styles)
	        myStyle = Object.assign({}, _extends({}, this.state.style, style));
	        myButtonStyle = Object.assign({}, _extends({}, this.state.buttonStyle, buttonStyle));
	        myContentStyle = Object.assign({}, _extends({}, this.state.contentStyle, contentStyle));
	      }
	
	      // syntactic sugar to enable user to easily select top / bottom
	      switch (location) {
	        case OPTIONS.TOP:
	          myStyle.top = "0";
	          myStyle.position = "fixed";
	          break;
	
	        case OPTIONS.BOTTOM:
	          myStyle.bottom = "0";
	          myStyle.position = "fixed";
	          break;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "cookieConsent " + containerClasses, style: myStyle },
	        _react2.default.createElement(
	          "div",
	          { style: myContentStyle, className: contentClasses },
	          this.props.children
	        ),
	        _react2.default.createElement(
	          "button",
	          {
	            style: myButtonStyle,
	            className: buttonClasses,
	            onClick: function onClick() {
	              _this2.accept();
	            }
	          },
	          buttonText
	        )
	      );
	    }
	  }]);
	
	  return CookieConsent;
	}(_react.Component);
	
	CookieConsent.propTypes = {
	  location: _propTypes2.default.oneOf(Object.keys(OPTIONS).map(function (key) {
	    return OPTIONS[key];
	  })),
	  style: _propTypes2.default.object,
	  buttonStyle: _propTypes2.default.object,
	  contentStyle: _propTypes2.default.object,
	  children: _propTypes2.default.any, // eslint-disable-line react/forbid-prop-types
	  disableStyles: _propTypes2.default.bool,
	  hideOnAccept: _propTypes2.default.bool,
	  onAccept: _propTypes2.default.func,
	  buttonText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
	  cookieName: _propTypes2.default.string,
	  debug: _propTypes2.default.bool,
	  expires: _propTypes2.default.number,
	  containerClasses: _propTypes2.default.string,
	  contentClasses: _propTypes2.default.string,
	  buttonClasses: _propTypes2.default.string,
	  acceptOnScroll: _propTypes2.default.bool,
	  acceptOnScrollPercentage: _propTypes2.default.number,
	  extraCookieOptions: _propTypes2.default.object
	};
	
	CookieConsent.defaultProps = {
	  disableStyles: false,
	  hideOnAccept: true,
	  acceptOnScroll: false,
	  acceptOnScrollPercentage: 25,
	  location: OPTIONS.BOTTOM,
	  onAccept: function onAccept() {},
	  cookieName: "CookieConsent",
	  buttonText: "I understand",
	  debug: false,
	  expires: 365,
	  containerClasses: "",
	  contentClasses: "",
	  buttonClasses: "",
	  extraCookieOptions: {}
	};
	
	exports.default = CookieConsent;
	exports.Cookies = _jsCookie2.default;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var printWarning = function() {};
	
	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = __webpack_require__(1);
	  var loggedTypeFailures = {};
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          )
	
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var ReactPropTypesSecret = __webpack_require__(1);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	
	
	var assign = __webpack_require__(6);
	
	var ReactPropTypesSecret = __webpack_require__(1);
	var checkPropTypes = __webpack_require__(7);
	
	var printWarning = function() {};
	
	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ })
	/******/ ]);

/***/ }),
/* 1595 */
1529,
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 1597 */
1530,
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.4.2
	 * react.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var k=__webpack_require__(24),n=__webpack_require__(1597),p=__webpack_require__(1596),q=__webpack_require__(1595),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
	r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
	var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
	G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
	function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
	h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
	function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
	var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
	_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
	b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
	assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1598);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	  Used as main file in package.json
	*/
	
	/* eslint-disable no-var */
	/* eslint-env node */
	
	var DayPicker = __webpack_require__(1603);
	var DateUtils = __webpack_require__(148);
	var LocaleUtils = __webpack_require__(247);
	var ModifiersUtils = __webpack_require__(363);
	var Weekday = __webpack_require__(759);
	var Navbar = __webpack_require__(758);
	var PropTypes = __webpack_require__(1605);
	
	module.exports = DayPicker;
	module.exports.DateUtils = DateUtils;
	module.exports.LocaleUtils = LocaleUtils;
	module.exports.ModifiersUtils = ModifiersUtils;
	module.exports.WeekdayPropTypes = Weekday.propTypes;
	module.exports.NavbarPropTypes = Navbar.propTypes;
	module.exports.PropTypes = PropTypes;


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(108);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LocaleUtils = __webpack_require__(247);
	
	var _LocaleUtils2 = _interopRequireDefault(_LocaleUtils);
	
	var _keys = __webpack_require__(249);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Caption = function (_Component) {
	  _inherits(Caption, _Component);
	
	  function Caption(props) {
	    _classCallCheck(this, Caption);
	
	    var _this = _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));
	
	    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
	    return _this;
	  }
	
	  _createClass(Caption, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
	    }
	  }, {
	    key: 'handleKeyUp',
	    value: function handleKeyUp(e) {
	      if (e.keyCode === _keys.ENTER) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          date = _props.date,
	          months = _props.months,
	          locale = _props.locale,
	          localeUtils = _props.localeUtils,
	          onClick = _props.onClick;
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.caption, role: 'heading' },
	        _react2.default.createElement(
	          'div',
	          { onClick: onClick, onKeyUp: this.handleKeyUp },
	          months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)
	        )
	      );
	    }
	  }]);
	
	  return Caption;
	}(_react.Component);
	
	Caption.defaultProps = {
	  localeUtils: _LocaleUtils2.default
	};
	exports.default = Caption;
	Caption.propTypes =  false ? {
	  date: _propTypes2.default.instanceOf(Date),
	  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  locale: _propTypes2.default.string,
	  localeUtils: _propTypes2.default.object,
	  onClick: _propTypes2.default.func,
	  classNames: _propTypes2.default.shape({
	    caption: _propTypes2.default.string.isRequired
	  }).isRequired
	} : {};
	//# sourceMappingURL=Caption.js.map

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(24);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _propTypes = __webpack_require__(108);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DateUtils = __webpack_require__(148);
	
	var _Helpers = __webpack_require__(246);
	
	var _classNames = __webpack_require__(248);
	
	var _classNames2 = _interopRequireDefault(_classNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */
	
	function handleEvent(handler, day, modifiers) {
	  if (!handler) {
	    return undefined;
	  }
	  return function (e) {
	    e.persist();
	    handler(day, modifiers, e);
	  };
	}
	
	var Day = function (_Component) {
	  _inherits(Day, _Component);
	
	  function Day() {
	    _classCallCheck(this, Day);
	
	    return _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
	  }
	
	  _createClass(Day, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      var propNames = Object.keys(this.props);
	      var nextPropNames = Object.keys(nextProps);
	      if (propNames.length !== nextPropNames.length) {
	        return true;
	      }
	      return propNames.some(function (name) {
	        if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
	          var prop = _this2.props[name];
	          var nextProp = nextProps[name];
	          var modifiers = Object.keys(prop);
	          var nextModifiers = Object.keys(nextProp);
	          if (modifiers.length !== nextModifiers.length) {
	            return true;
	          }
	          return modifiers.some(function (mod) {
	            return !(0, _Helpers.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
	          });
	        }
	        if (name === 'day') {
	          return !(0, _DateUtils.isSameDay)(_this2.props[name], nextProps[name]);
	        }
	        return !(0, _Helpers.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          modifiersStyles = _props.modifiersStyles,
	          day = _props.day,
	          tabIndex = _props.tabIndex,
	          empty = _props.empty,
	          modifiers = _props.modifiers,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseUp = _props.onMouseUp,
	          onMouseDown = _props.onMouseDown,
	          onClick = _props.onClick,
	          onKeyDown = _props.onKeyDown,
	          onTouchStart = _props.onTouchStart,
	          onTouchEnd = _props.onTouchEnd,
	          onFocus = _props.onFocus,
	          ariaLabel = _props.ariaLabel,
	          ariaDisabled = _props.ariaDisabled,
	          ariaSelected = _props.ariaSelected,
	          children = _props.children;
	
	
	      var className = classNames.day;
	      if (classNames !== _classNames2.default) {
	        // When using CSS modules prefix the modifier as required by the BEM syntax
	        className += ' ' + Object.keys(modifiers).join(' ');
	      } else {
	        className += Object.keys(modifiers).map(function (modifier) {
	          return ' ' + className + '--' + modifier;
	        }).join('');
	      }
	
	      var style = void 0;
	      if (modifiersStyles) {
	        Object.keys(modifiers).filter(function (modifier) {
	          return !!modifiersStyles[modifier];
	        }).forEach(function (modifier) {
	          style = (0, _objectAssign2.default)({}, style, modifiersStyles[modifier]);
	        });
	      }
	
	      if (empty) {
	        return _react2.default.createElement('div', { 'aria-disabled': true, className: className, style: style });
	      }
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          tabIndex: tabIndex,
	          style: style,
	          role: 'gridcell',
	          'aria-label': ariaLabel,
	          'aria-disabled': ariaDisabled,
	          'aria-selected': ariaSelected,
	          onClick: handleEvent(onClick, day, modifiers),
	          onKeyDown: handleEvent(onKeyDown, day, modifiers),
	          onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
	          onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
	          onMouseUp: handleEvent(onMouseUp, day, modifiers),
	          onMouseDown: handleEvent(onMouseDown, day, modifiers),
	          onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
	          onTouchStart: handleEvent(onTouchStart, day, modifiers),
	          onFocus: handleEvent(onFocus, day, modifiers)
	        },
	        children
	      );
	    }
	  }]);
	
	  return Day;
	}(_react.Component);
	
	Day.defaultProps = {
	  tabIndex: -1
	};
	Day.defaultProps = {
	  modifiers: {},
	  modifiersStyles: {},
	  empty: false
	};
	exports.default = Day;
	Day.propTypes =  false ? {
	  classNames: _propTypes2.default.shape({
	    day: _propTypes2.default.string.isRequired
	  }).isRequired,
	
	  day: _propTypes2.default.instanceOf(Date).isRequired,
	  children: _propTypes2.default.node.isRequired,
	
	  ariaDisabled: _propTypes2.default.bool,
	  ariaLabel: _propTypes2.default.string,
	  ariaSelected: _propTypes2.default.bool,
	  empty: _propTypes2.default.bool,
	  modifiers: _propTypes2.default.object,
	  modifiersStyles: _propTypes2.default.object,
	  onClick: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onTouchEnd: _propTypes2.default.func,
	  onTouchStart: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  tabIndex: _propTypes2.default.number
	} : {};
	//# sourceMappingURL=Day.js.map

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(108);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Caption = __webpack_require__(1601);
	
	var _Caption2 = _interopRequireDefault(_Caption);
	
	var _Navbar = __webpack_require__(758);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _Month = __webpack_require__(1604);
	
	var _Month2 = _interopRequireDefault(_Month);
	
	var _Weekday = __webpack_require__(759);
	
	var _Weekday2 = _interopRequireDefault(_Weekday);
	
	var _Helpers = __webpack_require__(246);
	
	var Helpers = _interopRequireWildcard(_Helpers);
	
	var _DateUtils = __webpack_require__(148);
	
	var DateUtils = _interopRequireWildcard(_DateUtils);
	
	var _LocaleUtils = __webpack_require__(247);
	
	var LocaleUtils = _interopRequireWildcard(_LocaleUtils);
	
	var _ModifiersUtils = __webpack_require__(363);
	
	var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);
	
	var _classNames = __webpack_require__(248);
	
	var _classNames2 = _interopRequireDefault(_classNames);
	
	var _keys = __webpack_require__(249);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DayPicker = function (_Component) {
	  _inherits(DayPicker, _Component);
	
	  function DayPicker(props) {
	    _classCallCheck(this, DayPicker);
	
	    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = _this.getStateFromProps(props);
	    return _this;
	  }
	
	  _createClass(DayPicker, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.month !== nextProps.month) {
	        this.setState(this.getStateFromProps(nextProps));
	      }
	    }
	  }, {
	    key: 'getNextNavigableMonth',
	    value: function getNextNavigableMonth() {
	      return DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
	    }
	  }, {
	    key: 'getPreviousNavigableMonth',
	    value: function getPreviousNavigableMonth() {
	      return DateUtils.addMonths(this.state.currentMonth, -1);
	    }
	  }, {
	    key: 'allowPreviousMonth',
	    value: function allowPreviousMonth() {
	      var previousMonth = DateUtils.addMonths(this.state.currentMonth, -1);
	      return this.allowMonth(previousMonth);
	    }
	  }, {
	    key: 'allowNextMonth',
	    value: function allowNextMonth() {
	      var nextMonth = DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
	      return this.allowMonth(nextMonth);
	    }
	  }, {
	    key: 'allowMonth',
	    value: function allowMonth(d) {
	      var _props = this.props,
	          fromMonth = _props.fromMonth,
	          toMonth = _props.toMonth,
	          canChangeMonth = _props.canChangeMonth;
	
	      if (!canChangeMonth || fromMonth && Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers.getMonthsDiff(toMonth, d) > 0) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'allowYearChange',
	    value: function allowYearChange() {
	      return this.props.canChangeMonth;
	    }
	  }, {
	    key: 'showMonth',
	    value: function showMonth(d, callback) {
	      var _this2 = this;
	
	      if (!this.allowMonth(d)) {
	        return;
	      }
	      this.setState({ currentMonth: Helpers.startOfMonth(d) }, function () {
	        if (callback) {
	          callback();
	        }
	        if (_this2.props.onMonthChange) {
	          _this2.props.onMonthChange(_this2.state.currentMonth);
	        }
	      });
	    }
	  }, {
	    key: 'showNextYear',
	    value: function showNextYear() {
	      if (!this.allowYearChange()) {
	        return;
	      }
	      var nextMonth = DateUtils.addMonths(this.state.currentMonth, 12);
	      this.showMonth(nextMonth);
	    }
	  }, {
	    key: 'showPreviousYear',
	    value: function showPreviousYear() {
	      if (!this.allowYearChange()) {
	        return;
	      }
	      var nextMonth = DateUtils.addMonths(this.state.currentMonth, -12);
	      this.showMonth(nextMonth);
	    }
	  }, {
	    key: 'focusFirstDayOfMonth',
	    value: function focusFirstDayOfMonth() {
	      Helpers.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
	    }
	  }, {
	    key: 'focusLastDayOfMonth',
	    value: function focusLastDayOfMonth() {
	      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
	      dayNodes[dayNodes.length - 1].focus();
	    }
	  }, {
	    key: 'focusPreviousDay',
	    value: function focusPreviousDay(dayNode) {
	      var _this3 = this;
	
	      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
	      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
	
	      if (dayNodeIndex === 0) {
	        this.showPreviousMonth(function () {
	          return _this3.focusLastDayOfMonth();
	        });
	      } else {
	        dayNodes[dayNodeIndex - 1].focus();
	      }
	    }
	  }, {
	    key: 'focusNextDay',
	    value: function focusNextDay(dayNode) {
	      var _this4 = this;
	
	      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
	      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
	
	      if (dayNodeIndex === dayNodes.length - 1) {
	        this.showNextMonth(function () {
	          return _this4.focusFirstDayOfMonth();
	        });
	      } else {
	        dayNodes[dayNodeIndex + 1].focus();
	      }
	    }
	  }, {
	    key: 'focusNextWeek',
	    value: function focusNextWeek(dayNode) {
	      var _this5 = this;
	
	      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
	      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
	      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;
	
	      if (isInLastWeekOfMonth) {
	        this.showNextMonth(function () {
	          var daysAfterIndex = dayNodes.length - dayNodeIndex;
	          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
	          Helpers.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
	        });
	      } else {
	        dayNodes[dayNodeIndex + 7].focus();
	      }
	    }
	  }, {
	    key: 'focusPreviousWeek',
	    value: function focusPreviousWeek(dayNode) {
	      var _this6 = this;
	
	      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
	      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
	      var isInFirstWeekOfMonth = dayNodeIndex <= 6;
	
	      if (isInFirstWeekOfMonth) {
	        this.showPreviousMonth(function () {
	          var previousMonthDayNodes = Helpers.getDayNodes(_this6.dayPicker, _this6.props.classNames);
	          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
	          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
	          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
	        });
	      } else {
	        dayNodes[dayNodeIndex - 7].focus();
	      }
	    }
	
	    // Event handlers
	
	  }, {
	    key: 'handleOutsideDayClick',
	    value: function handleOutsideDayClick(day) {
	      var currentMonth = this.state.currentMonth;
	      var numberOfMonths = this.props.numberOfMonths;
	
	      var diffInMonths = Helpers.getMonthsDiff(currentMonth, day);
	      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
	        this.showNextMonth();
	      } else if (diffInMonths < 0) {
	        this.showPreviousMonth();
	      }
	    }
	  }, {
	    key: 'renderNavbar',
	    value: function renderNavbar() {
	      var _props2 = this.props,
	          labels = _props2.labels,
	          locale = _props2.locale,
	          localeUtils = _props2.localeUtils,
	          canChangeMonth = _props2.canChangeMonth,
	          navbarElement = _props2.navbarElement,
	          attributes = _objectWithoutProperties(_props2, ['labels', 'locale', 'localeUtils', 'canChangeMonth', 'navbarElement']);
	
	      if (!canChangeMonth) return null;
	
	      var props = {
	        month: this.state.month,
	        classNames: this.props.classNames,
	        className: this.props.classNames.navBar,
	        nextMonth: this.getNextNavigableMonth(),
	        previousMonth: this.getPreviousNavigableMonth(),
	        showPreviousButton: this.allowPreviousMonth(),
	        showNextButton: this.allowNextMonth(),
	        onNextClick: this.showNextMonth,
	        onPreviousClick: this.showPreviousMonth,
	        dir: attributes.dir,
	        labels: labels,
	        locale: locale,
	        localeUtils: localeUtils
	      };
	      return _react2.default.isValidElement(navbarElement) ? _react2.default.cloneElement(navbarElement, props) : _react2.default.createElement(navbarElement, props);
	    }
	  }, {
	    key: 'renderMonths',
	    value: function renderMonths() {
	      var months = [];
	      var firstDayOfWeek = Helpers.getFirstDayOfWeekFromProps(this.props);
	      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
	        var month = DateUtils.addMonths(this.state.currentMonth, i);
	        months.push(_react2.default.createElement(_Month2.default, _extends({
	          key: i
	        }, this.props, {
	          month: month,
	          firstDayOfWeek: firstDayOfWeek,
	          onDayKeyDown: this.handleDayKeyDown,
	          onDayClick: this.handleDayClick
	        })));
	      }
	
	      if (this.props.reverseMonths) {
	        months.reverse();
	      }
	      return months;
	    }
	  }, {
	    key: 'renderFooter',
	    value: function renderFooter() {
	      if (this.props.todayButton) {
	        return _react2.default.createElement(
	          'div',
	          { className: this.props.classNames.footer },
	          this.renderTodayButton()
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderTodayButton',
	    value: function renderTodayButton() {
	      return _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          tabIndex: 0,
	          className: this.props.classNames.todayButton,
	          'aria-label': this.props.todayButton,
	          onClick: this.handleTodayButtonClick
	        },
	        this.props.todayButton
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var className = this.props.classNames.container;
	
	      if (!this.props.onDayClick) {
	        className = className + ' ' + this.props.classNames.interactionDisabled;
	      }
	      if (this.props.className) {
	        className = className + ' ' + this.props.className;
	      }
	      return _react2.default.createElement(
	        'div',
	        _extends({}, this.props.containerProps, {
	          className: className,
	          ref: function ref(el) {
	            return _this7.dayPicker = el;
	          },
	          lang: this.props.locale
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: this.props.classNames.wrapper,
	            tabIndex: this.props.canChangeMonth && this.props.tabIndex ? this.props.tabIndex : -1,
	            onKeyDown: this.handleKeyDown,
	            onFocus: this.props.onFocus,
	            onBlur: this.props.onBlur
	          },
	          this.renderNavbar(),
	          _react2.default.createElement(
	            'div',
	            { className: this.props.classNames.months },
	            this.renderMonths()
	          ),
	          this.renderFooter()
	        )
	      );
	    }
	  }]);
	
	  return DayPicker;
	}(_react.Component);
	
	DayPicker.VERSION = '7.0.7';
	DayPicker.defaultProps = {
	  classNames: _classNames2.default,
	  tabIndex: 0,
	  initialMonth: new Date(),
	  numberOfMonths: 1,
	  labels: {
	    previousMonth: 'Previous Month',
	    nextMonth: 'Next Month'
	  },
	  locale: 'en',
	  localeUtils: LocaleUtils,
	  showOutsideDays: false,
	  fixedWeeks: false,
	  canChangeMonth: true,
	  reverseMonths: false,
	  pagedNavigation: false,
	  showWeekNumbers: false,
	  showWeekDays: true,
	  renderDay: function renderDay(day) {
	    return day.getDate();
	  },
	  renderWeek: function renderWeek(weekNumber) {
	    return weekNumber;
	  },
	  weekdayElement: _react2.default.createElement(_Weekday2.default, null),
	  navbarElement: _react2.default.createElement(_Navbar2.default, { classNames: _classNames2.default }),
	  captionElement: _react2.default.createElement(_Caption2.default, { classNames: _classNames2.default })
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this8 = this;
	
	  this.getStateFromProps = function (props) {
	    var initialMonth = Helpers.startOfMonth(props.month || props.initialMonth);
	    var currentMonth = initialMonth;
	
	    if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
	      var diffInMonths = Helpers.getMonthsDiff(props.fromMonth, currentMonth);
	      currentMonth = DateUtils.addMonths(props.fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
	    } else if (props.toMonth && props.numberOfMonths > 1 && Helpers.getMonthsDiff(currentMonth, props.toMonth) <= 0) {
	      currentMonth = DateUtils.addMonths(props.toMonth, 1 - _this8.props.numberOfMonths);
	    }
	    return { currentMonth: currentMonth };
	  };
	
	  this.dayPicker = null;
	
	  this.showNextMonth = function (callback) {
	    if (!_this8.allowNextMonth()) {
	      return;
	    }
	    var deltaMonths = _this8.props.pagedNavigation ? _this8.props.numberOfMonths : 1;
	    var nextMonth = DateUtils.addMonths(_this8.state.currentMonth, deltaMonths);
	    _this8.showMonth(nextMonth, callback);
	  };
	
	  this.showPreviousMonth = function (callback) {
	    if (!_this8.allowPreviousMonth()) {
	      return;
	    }
	    var deltaMonths = _this8.props.pagedNavigation ? _this8.props.numberOfMonths : 1;
	    var previousMonth = DateUtils.addMonths(_this8.state.currentMonth, -deltaMonths);
	    _this8.showMonth(previousMonth, callback);
	  };
	
	  this.handleKeyDown = function (e) {
	    e.persist();
	
	    switch (e.keyCode) {
	      case _keys.LEFT:
	        _this8.showPreviousMonth();
	        break;
	      case _keys.RIGHT:
	        _this8.showNextMonth();
	        break;
	      case _keys.UP:
	        _this8.showPreviousYear();
	        break;
	      case _keys.DOWN:
	        _this8.showNextYear();
	        break;
	      default:
	        break;
	    }
	
	    if (_this8.props.onKeyDown) {
	      _this8.props.onKeyDown(e);
	    }
	  };
	
	  this.handleDayKeyDown = function (day, modifiers, e) {
	    e.persist();
	    switch (e.keyCode) {
	      case _keys.LEFT:
	        Helpers.cancelEvent(e);
	        _this8.focusPreviousDay(e.target);
	        break;
	      case _keys.RIGHT:
	        Helpers.cancelEvent(e);
	        _this8.focusNextDay(e.target);
	        break;
	      case _keys.UP:
	        Helpers.cancelEvent(e);
	        _this8.focusPreviousWeek(e.target);
	        break;
	      case _keys.DOWN:
	        Helpers.cancelEvent(e);
	        _this8.focusNextWeek(e.target);
	        break;
	      case _keys.ENTER:
	      case _keys.SPACE:
	        Helpers.cancelEvent(e);
	        if (_this8.props.onDayClick) {
	          _this8.handleDayClick(day, modifiers, e);
	        }
	        break;
	      default:
	        break;
	    }
	    if (_this8.props.onDayKeyDown) {
	      _this8.props.onDayKeyDown(day, modifiers, e);
	    }
	  };
	
	  this.handleDayClick = function (day, modifiers, e) {
	    e.persist();
	    if (modifiers[_this8.props.classNames.outside]) {
	      _this8.handleOutsideDayClick(day);
	    }
	    if (_this8.props.onDayClick) {
	      _this8.props.onDayClick(day, modifiers, e);
	    }
	  };
	
	  this.handleTodayButtonClick = function (e) {
	    var today = new Date();
	    var month = new Date(today.getFullYear(), today.getMonth());
	    _this8.showMonth(month);
	    e.target.blur();
	    if (_this8.props.onTodayButtonClick) {
	      e.persist();
	      _this8.props.onTodayButtonClick(new Date(today.getFullYear(), today.getMonth(), today.getDate()), ModifiersUtils.getModifiersForDay(today, _this8.props.modifiers), e);
	    }
	  };
	};
	
	exports.default = DayPicker;
	DayPicker.propTypes =  false ? {
	  // Rendering months
	  initialMonth: _propTypes2.default.instanceOf(Date),
	  month: _propTypes2.default.instanceOf(Date),
	  numberOfMonths: _propTypes2.default.number,
	  fromMonth: _propTypes2.default.instanceOf(Date),
	  toMonth: _propTypes2.default.instanceOf(Date),
	  canChangeMonth: _propTypes2.default.bool,
	  reverseMonths: _propTypes2.default.bool,
	  pagedNavigation: _propTypes2.default.bool,
	  todayButton: _propTypes2.default.string,
	  showWeekNumbers: _propTypes2.default.bool,
	  showWeekDays: _propTypes2.default.bool,
	
	  // Modifiers
	  selectedDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
	  disabledDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
	
	  modifiers: _propTypes2.default.object,
	  modifiersStyles: _propTypes2.default.object,
	
	  // Localization
	  dir: _propTypes2.default.string,
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	  labels: _propTypes2.default.shape({
	    nextMonth: _propTypes2.default.string.isRequired,
	    previousMonth: _propTypes2.default.string.isRequired
	  }),
	  locale: _propTypes2.default.string,
	  localeUtils: _propTypes2.default.shape({
	    formatMonthTitle: _propTypes2.default.func,
	    formatWeekdayShort: _propTypes2.default.func,
	    formatWeekdayLong: _propTypes2.default.func,
	    getFirstDayOfWeek: _propTypes2.default.func
	  }),
	  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
	
	  // Customization
	  showOutsideDays: _propTypes2.default.bool,
	  fixedWeeks: _propTypes2.default.bool,
	
	  // CSS and HTML
	  classNames: _propTypes2.default.shape({
	    body: _propTypes2.default.string,
	    container: _propTypes2.default.string,
	    day: _propTypes2.default.string.isRequired,
	    disabled: _propTypes2.default.string.isRequired,
	    footer: _propTypes2.default.string,
	    interactionDisabled: _propTypes2.default.string,
	    months: _propTypes2.default.string,
	    month: _propTypes2.default.string,
	    navBar: _propTypes2.default.string,
	    outside: _propTypes2.default.string.isRequired,
	    selected: _propTypes2.default.string.isRequired,
	    today: _propTypes2.default.string.isRequired,
	    todayButton: _propTypes2.default.string,
	    week: _propTypes2.default.string,
	    wrapper: _propTypes2.default.string
	  }),
	  className: _propTypes2.default.string,
	  containerProps: _propTypes2.default.object,
	  tabIndex: _propTypes2.default.number,
	
	  // Custom elements
	  renderDay: _propTypes2.default.func,
	  renderWeek: _propTypes2.default.func,
	  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
	  navbarElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
	  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
	
	  // Events
	  onBlur: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  onDayClick: _propTypes2.default.func,
	  onDayKeyDown: _propTypes2.default.func,
	  onDayMouseEnter: _propTypes2.default.func,
	  onDayMouseLeave: _propTypes2.default.func,
	  onDayMouseDown: _propTypes2.default.func,
	  onDayMouseUp: _propTypes2.default.func,
	  onDayTouchStart: _propTypes2.default.func,
	  onDayTouchEnd: _propTypes2.default.func,
	  onDayFocus: _propTypes2.default.func,
	  onMonthChange: _propTypes2.default.func,
	  onCaptionClick: _propTypes2.default.func,
	  onWeekClick: _propTypes2.default.func,
	  onTodayButtonClick: _propTypes2.default.func
	} : {};
	
	
	DayPicker.DateUtils = DateUtils;
	DayPicker.LocaleUtils = LocaleUtils;
	DayPicker.ModifiersUtils = ModifiersUtils;
	//# sourceMappingURL=DayPicker.js.map

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(108);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Weekdays = __webpack_require__(1606);
	
	var _Weekdays2 = _interopRequireDefault(_Weekdays);
	
	var _Day = __webpack_require__(1602);
	
	var _Day2 = _interopRequireDefault(_Day);
	
	var _keys = __webpack_require__(249);
	
	var _ModifiersUtils = __webpack_require__(363);
	
	var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);
	
	var _Helpers = __webpack_require__(246);
	
	var Helpers = _interopRequireWildcard(_Helpers);
	
	var _DateUtils = __webpack_require__(148);
	
	var DateUtils = _interopRequireWildcard(_DateUtils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Month = function (_Component) {
	  _inherits(Month, _Component);
	
	  function Month() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Month);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.renderDay = function (day) {
	      var monthNumber = _this.props.month.getMonth();
	      var propModifiers = Helpers.getModifiersFromProps(_this.props);
	      var dayModifiers = ModifiersUtils.getModifiersForDay(day, propModifiers);
	      if (DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) {
	        dayModifiers.push(_this.props.classNames.today);
	      }
	      if (day.getMonth() !== monthNumber) {
	        dayModifiers.push(_this.props.classNames.outside);
	      }
	
	      var isOutside = day.getMonth() !== monthNumber;
	      var tabIndex = -1;
	      // Focus on the first day of the month
	      if (_this.props.onDayClick && !isOutside && day.getDate() === 1) {
	        tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
	      }
	      var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
	      var modifiers = {};
	      dayModifiers.forEach(function (modifier) {
	        modifiers[modifier] = true;
	      });
	
	      return _react2.default.createElement(
	        _Day2.default,
	        {
	          key: '' + (isOutside ? 'outside-' : '') + key,
	          classNames: _this.props.classNames,
	          day: day,
	          modifiers: modifiers,
	          modifiersStyles: _this.props.modifiersStyles,
	          empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
	          tabIndex: tabIndex,
	          ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
	          ariaDisabled: isOutside || dayModifiers.indexOf('disabled') > -1,
	          ariaSelected: dayModifiers.indexOf('selected') > -1,
	          onClick: _this.props.onDayClick,
	          onFocus: _this.props.onDayFocus,
	          onKeyDown: _this.props.onDayKeyDown,
	          onMouseEnter: _this.props.onDayMouseEnter,
	          onMouseLeave: _this.props.onDayMouseLeave,
	          onMouseDown: _this.props.onDayMouseDown,
	          onMouseUp: _this.props.onDayMouseUp,
	          onTouchEnd: _this.props.onDayTouchEnd,
	          onTouchStart: _this.props.onDayTouchStart
	        },
	        _this.props.renderDay(day, modifiers)
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Month, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          classNames = _props.classNames,
	          month = _props.month,
	          months = _props.months,
	          fixedWeeks = _props.fixedWeeks,
	          captionElement = _props.captionElement,
	          weekdayElement = _props.weekdayElement,
	          locale = _props.locale,
	          localeUtils = _props.localeUtils,
	          weekdaysLong = _props.weekdaysLong,
	          weekdaysShort = _props.weekdaysShort,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          onCaptionClick = _props.onCaptionClick,
	          showWeekNumbers = _props.showWeekNumbers,
	          showWeekDays = _props.showWeekDays,
	          onWeekClick = _props.onWeekClick;
	
	
	      var captionProps = {
	        date: month,
	        classNames: classNames,
	        months: months,
	        localeUtils: localeUtils,
	        locale: locale,
	        onClick: onCaptionClick ? function (e) {
	          return onCaptionClick(month, e);
	        } : undefined
	      };
	      var caption = _react2.default.isValidElement(captionElement) ? _react2.default.cloneElement(captionElement, captionProps) : _react2.default.createElement(captionElement, captionProps);
	
	      var weeks = Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.month, role: 'grid' },
	        caption,
	        showWeekDays && _react2.default.createElement(_Weekdays2.default, {
	          classNames: classNames,
	          weekdaysShort: weekdaysShort,
	          weekdaysLong: weekdaysLong,
	          firstDayOfWeek: firstDayOfWeek,
	          showWeekNumbers: showWeekNumbers,
	          locale: locale,
	          localeUtils: localeUtils,
	          weekdayElement: weekdayElement
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: classNames.body, role: 'rowgroup' },
	          weeks.map(function (week) {
	            var weekNumber = void 0;
	            if (showWeekNumbers) {
	              weekNumber = DateUtils.getWeekNumber(week[0]);
	            }
	            return _react2.default.createElement(
	              'div',
	              {
	                key: week[0].getTime(),
	                className: classNames.week,
	                role: 'row'
	              },
	              showWeekNumbers && _react2.default.createElement(
	                'div',
	                {
	                  className: classNames.weekNumber,
	                  tabIndex: 0,
	                  role: 'gridcell',
	                  onClick: onWeekClick ? function (e) {
	                    return onWeekClick(weekNumber, week, e);
	                  } : undefined,
	                  onKeyUp: onWeekClick ? function (e) {
	                    return e.keyCode === _keys.ENTER && onWeekClick(weekNumber, week, e);
	                  } : undefined
	                },
	                _this2.props.renderWeek(weekNumber, week, month)
	              ),
	              week.map(_this2.renderDay)
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return Month;
	}(_react.Component);
	
	exports.default = Month;
	Month.propTypes =  false ? {
	  classNames: _propTypes2.default.shape({
	    body: _propTypes2.default.string.isRequired,
	    month: _propTypes2.default.string.isRequired,
	    outside: _propTypes2.default.string.isRequired,
	    today: _propTypes2.default.string.isRequired,
	    week: _propTypes2.default.string.isRequired
	  }).isRequired,
	  tabIndex: _propTypes2.default.number,
	
	  month: _propTypes2.default.instanceOf(Date).isRequired,
	  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
	
	  modifiersStyles: _propTypes2.default.object,
	
	  showWeekDays: _propTypes2.default.bool,
	  showOutsideDays: _propTypes2.default.bool,
	
	  renderDay: _propTypes2.default.func.isRequired,
	  renderWeek: _propTypes2.default.func.isRequired,
	
	  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]).isRequired,
	  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]),
	
	  fixedWeeks: _propTypes2.default.bool,
	  showWeekNumbers: _propTypes2.default.bool,
	
	  locale: _propTypes2.default.string.isRequired,
	  localeUtils: _propTypes2.default.object.isRequired,
	  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  firstDayOfWeek: _propTypes2.default.number.isRequired,
	
	  onCaptionClick: _propTypes2.default.func,
	  onDayClick: _propTypes2.default.func,
	  onDayFocus: _propTypes2.default.func,
	  onDayKeyDown: _propTypes2.default.func,
	  onDayMouseEnter: _propTypes2.default.func,
	  onDayMouseLeave: _propTypes2.default.func,
	  onDayMouseDown: _propTypes2.default.func,
	  onDayMouseUp: _propTypes2.default.func,
	  onDayTouchEnd: _propTypes2.default.func,
	  onDayTouchStart: _propTypes2.default.func,
	  onWeekClick: _propTypes2.default.func
	} : {};
	//# sourceMappingURL=Month.js.map

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModifierPropType = undefined;
	
	var _propTypes = __webpack_require__(108);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrimitiveTypes = {
	  localeUtils: _propTypes2.default.shape({
	    formatMonthTitle: _propTypes2.default.func,
	    formatWeekdayShort: _propTypes2.default.func,
	    formatWeekdayLong: _propTypes2.default.func,
	    getFirstDayOfWeek: _propTypes2.default.func
	  }),
	  range: _propTypes2.default.shape({
	    from: _propTypes2.default.instanceOf(Date),
	    to: _propTypes2.default.instanceOf(Date)
	  }),
	  after: _propTypes2.default.shape({
	    after: _propTypes2.default.instanceOf(Date)
	  }),
	  before: _propTypes2.default.shape({
	    before: _propTypes2.default.instanceOf(Date)
	  })
	};
	
	var ModifierPropType = exports.ModifierPropType = _propTypes2.default.oneOfType([PrimitiveTypes.after, PrimitiveTypes.before, PrimitiveTypes.range, _propTypes2.default.func, _propTypes2.default.array]);
	
	exports.default = PrimitiveTypes;
	//# sourceMappingURL=PropTypes.js.map

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(108);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Weekdays = function (_Component) {
	  _inherits(Weekdays, _Component);
	
	  function Weekdays() {
	    _classCallCheck(this, Weekdays);
	
	    return _possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
	  }
	
	  _createClass(Weekdays, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props !== nextProps;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          showWeekNumbers = _props.showWeekNumbers,
	          weekdaysLong = _props.weekdaysLong,
	          weekdaysShort = _props.weekdaysShort,
	          locale = _props.locale,
	          localeUtils = _props.localeUtils,
	          weekdayElement = _props.weekdayElement;
	
	      var days = [];
	      for (var i = 0; i < 7; i += 1) {
	        var weekday = (i + firstDayOfWeek) % 7;
	        var elementProps = {
	          key: i,
	          className: classNames.weekday,
	          weekday: weekday,
	          weekdaysLong: weekdaysLong,
	          weekdaysShort: weekdaysShort,
	          localeUtils: localeUtils,
	          locale: locale
	        };
	        var element = _react2.default.isValidElement(weekdayElement) ? _react2.default.cloneElement(weekdayElement, elementProps) : _react2.default.createElement(weekdayElement, elementProps);
	        days.push(element);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.weekdays, role: 'rowgroup' },
	        _react2.default.createElement(
	          'div',
	          { className: classNames.weekdaysRow, role: 'row' },
	          showWeekNumbers && _react2.default.createElement('div', { className: classNames.weekday }),
	          days
	        )
	      );
	    }
	  }]);
	
	  return Weekdays;
	}(_react.Component);
	
	exports.default = Weekdays;
	Weekdays.propTypes =  false ? {
	  classNames: _propTypes2.default.shape({
	    weekday: _propTypes2.default.string.isRequired,
	    weekdays: _propTypes2.default.string.isRequired,
	    weekdaysRow: _propTypes2.default.string.isRequired
	  }).isRequired,
	
	  firstDayOfWeek: _propTypes2.default.number.isRequired,
	  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  showWeekNumbers: _propTypes2.default.bool,
	  locale: _propTypes2.default.string.isRequired,
	  localeUtils: _propTypes2.default.object.isRequired,
	  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)])
	} : {};
	//# sourceMappingURL=Weekdays.js.map

/***/ }),
/* 1607 */
1529,
/* 1608 */
1530,
/* 1609 */
[1845, 1607, 1608, 1610],
/* 1610 */
1528,
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * UAParser.js v0.7.21
	 * Lightweight JavaScript-based User-Agent string parser
	 * https://github.com/faisalman/ua-parser-js
	 *
	 * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
	 * Licensed under MIT License
	 */
	(function(window,undefined){"use strict";var LIBVERSION="0.7.21",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,/(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,/(bidubrowser|baidubrowser)[\/\s]?([\w\.]+)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]*)/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i],[NAME,VERSION],[/(konqueror)\/([\w\.]+)/i],[[NAME,"Konqueror"],VERSION],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i],[[NAME,"Edge"],VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(Avast)\/([\w\.]+)/i],[[NAME,"Avast Secure Browser"],VERSION],[/(AVG)\/([\w\.]+)/i],[[NAME,"AVG Secure Browser"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/(focus)\/([\w\.]+)/i],[[NAME,"Firefox Focus"],VERSION],[/(opt)\/([\w\.]+)/i],[[NAME,"Opera Touch"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(windowswechat qbcore)\/([\w\.]+)/i],[[NAME,"WeChat(Win) Desktop"],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(brave)\/([\w\.]+)/i],[[NAME,"Brave"],VERSION],[/(qqbrowserlite)\/([\w\.]+)/i],[NAME,VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(baiduboxapp)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(2345Explorer)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(MetaSr)[\/\s]?([\w\.]+)/i],[NAME],[/(LBBROWSER)/i],[NAME],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/safari\s(line)\/([\w\.]+)/i,/android.+(line)\/([\w\.]+)\/iab/i],[NAME,VERSION],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(sailfishbrowser)\/([\w\.]+)/i],[[NAME,"Sailfish Browser"],VERSION],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/(qihu|qhbrowser|qihoobrowser|360browser)/i],[[NAME,"360 Browser"]],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]*)/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"],[TYPE,SMARTTV]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/.+silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/android.+aft([bms])\sbuild/i],[MODEL,[VENDOR,"Amazon"],[TYPE,SMARTTV]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,/(zte)-(\w*)/i,/(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p|vog-l29|ane-lx1|eml-l29)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/android.+(bah2?-a?[lw]\d{2})/i],[MODEL,[VENDOR,"Huawei"],[TYPE,TABLET]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w*)/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]*)/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w*)/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(lenovo)[_\s-]?([\w-]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"],[TYPE,SMARTTV]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel( [23])?( xl)?)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+;\s(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/(mz)-([\w-]{2,})/i],[[VENDOR,"Meizu"],MODEL,[TYPE,MOBILE]],[/android.+a000(1)\s+build/i,/android.+oneplus\s(a\d{4})[\s)]/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+;\s(k88)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2})\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+;\s(PH-1)\s/i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(KS(.+))\s+build/i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/[\s\/\(](smart-?tv)[;\)]/i],[[TYPE,SMARTTV]],[/(android[\w\.\s\-]{0,9});.+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9}).+(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]*)/i,/(tizen|kaios)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w*)/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,/(hurd|linux)\s?([\w\.]*)/i,/(gnu)\s?([\w\.]*)/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]*)/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]*)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,/(unix)\s?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if(true){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return UAParser}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(window){window.UAParser=UAParser}}var $=window&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(40);
	
	var focusNode = __webpack_require__(484);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(187);
	var ExecutionEnvironment = __webpack_require__(55);
	var FallbackCompositionState = __webpack_require__(1620);
	var SyntheticCompositionEvent = __webpack_require__(1657);
	var SyntheticInputEvent = __webpack_require__(1660);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(761);
	var ExecutionEnvironment = __webpack_require__(55);
	var ReactInstrumentation = __webpack_require__(76);
	
	var camelizeStyleName = __webpack_require__(1302);
	var dangerousStyleValue = __webpack_require__(1666);
	var hyphenateStyleName = __webpack_require__(1309);
	var memoizeStringOnly = __webpack_require__(1312);
	var warning = __webpack_require__(19);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(186);
	var EventPropagators = __webpack_require__(187);
	var ExecutionEnvironment = __webpack_require__(55);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactUpdates = __webpack_require__(85);
	var SyntheticEvent = __webpack_require__(89);
	
	var getEventTarget = __webpack_require__(376);
	var isEventSupported = __webpack_require__(377);
	var isTextInputElement = __webpack_require__(778);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var DOMLazyTree = __webpack_require__(150);
	var ExecutionEnvironment = __webpack_require__(55);
	
	var createNodesFromMarkup = __webpack_require__(1305);
	var emptyFunction = __webpack_require__(65);
	var invariant = __webpack_require__(13);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(187);
	var ReactDOMComponentTree = __webpack_require__(40);
	var SyntheticMouseEvent = __webpack_require__(251);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(24);
	
	var PooledClass = __webpack_require__(129);
	
	var getTextContentAccessor = __webpack_require__(776);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(151);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(152);
	
	var instantiateReactComponent = __webpack_require__(777);
	var KeyEscapeUtils = __webpack_require__(368);
	var shouldUpdateReactComponent = __webpack_require__(378);
	var traverseAllChildren = __webpack_require__(780);
	var warning = __webpack_require__(19);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","WEB_ENV":"production","PUBLIC_URL":"/barbershops","FB_PIXEL_ID":378862599177017,"COMMANDER_URL":"https://app.getsquire.com","MIXPANEL_TOKEN":"26fd9fecaed51592cb1906e8549eca1e","FLAGSHIP_ANDROID_APP_URL":"https://play.google.com/store/apps/details?id=com.getsquire.flagship","FLAGSHIP_IOS_APP_URL":"https://apps.apple.com/us/app/squire/id957644357","PUBLISH_URL":"https://getsquire.com/barbershops","SQUIRE_BRANCH_KEY":"key_live_eafRKQ0rBNN7eNjrjJJFRhnlvzeWA93h","SQUIRE_STRIPE_KEY":"pk_live_i7yVGwE1iFznsnhYqqpFNxmg","SQUIRE_INTERCOM_ID":"jnflr57i","SQUIRE_TOKENS_URL":"https://squire-tokens-prod-1.getsquire.com","SQUIRE_PUBNUB_SUBSCRIBE_KEY":"sub-c-b7a5edba-08f4-11e7-83b6-0619f8945a4f","SQUIRE_FULLSTORY_ORG":"100T1W","SQUIRE_API_URL":"https://api.getsquire.com/v1","SQUIRE_GOOGLE_ANALYTICS_ID":"UA-70640238-1"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(800);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)))

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(364);
	var ReactDOMIDOperations = __webpack_require__(1630);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26),
	    _assign = __webpack_require__(24);
	
	var React = __webpack_require__(155);
	var ReactComponentEnvironment = __webpack_require__(370);
	var ReactCurrentOwner = __webpack_require__(91);
	var ReactErrorUtils = __webpack_require__(371);
	var ReactInstanceMap = __webpack_require__(188);
	var ReactInstrumentation = __webpack_require__(76);
	var ReactNodeTypes = __webpack_require__(771);
	var ReactReconciler = __webpack_require__(152);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(138);
	var invariant = __webpack_require__(13);
	var shallowEqual = __webpack_require__(202);
	var shouldUpdateReactComponent = __webpack_require__(378);
	var warning = __webpack_require__(19);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactDefaultInjection = __webpack_require__(1638);
	var ReactMount = __webpack_require__(770);
	var ReactReconciler = __webpack_require__(152);
	var ReactUpdates = __webpack_require__(85);
	var ReactVersion = __webpack_require__(1651);
	
	var findDOMNode = __webpack_require__(1667);
	var getHostComponentFromComposite = __webpack_require__(775);
	var renderSubtreeIntoContainer = __webpack_require__(1674);
	var warning = __webpack_require__(19);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26),
	    _assign = __webpack_require__(24);
	
	var AutoFocusUtils = __webpack_require__(1613);
	var CSSPropertyOperations = __webpack_require__(1615);
	var DOMLazyTree = __webpack_require__(150);
	var DOMNamespaces = __webpack_require__(365);
	var DOMProperty = __webpack_require__(151);
	var DOMPropertyOperations = __webpack_require__(763);
	var EventPluginHub = __webpack_require__(186);
	var EventPluginRegistry = __webpack_require__(366);
	var ReactBrowserEventEmitter = __webpack_require__(250);
	var ReactDOMComponentFlags = __webpack_require__(764);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactDOMInput = __webpack_require__(1631);
	var ReactDOMOption = __webpack_require__(1632);
	var ReactDOMSelect = __webpack_require__(765);
	var ReactDOMTextarea = __webpack_require__(1635);
	var ReactInstrumentation = __webpack_require__(76);
	var ReactMultiChild = __webpack_require__(1644);
	var ReactServerRenderingTransaction = __webpack_require__(1649);
	
	var emptyFunction = __webpack_require__(65);
	var escapeTextContentForBrowser = __webpack_require__(253);
	var invariant = __webpack_require__(13);
	var isEventSupported = __webpack_require__(377);
	var shallowEqual = __webpack_require__(202);
	var validateDOMNesting = __webpack_require__(379);
	var warning = __webpack_require__(19);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(379);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(24);
	
	var DOMLazyTree = __webpack_require__(150);
	var ReactDOMComponentTree = __webpack_require__(40);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(364);
	var ReactDOMComponentTree = __webpack_require__(40);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26),
	    _assign = __webpack_require__(24);
	
	var DOMPropertyOperations = __webpack_require__(763);
	var LinkedValueUtils = __webpack_require__(369);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactUpdates = __webpack_require__(85);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(19);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        // eslint-disable-next-line
	        if (value != valueAsNumber) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	        // eslint-disable-next-line
	      } else if (value != node.value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(24);
	
	var React = __webpack_require__(155);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactDOMSelect = __webpack_require__(765);
	
	var warning = __webpack_require__(19);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(55);
	
	var getNodeForCharacterOffset = __webpack_require__(1671);
	var getTextContentAccessor = __webpack_require__(776);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26),
	    _assign = __webpack_require__(24);
	
	var DOMChildrenOperations = __webpack_require__(364);
	var DOMLazyTree = __webpack_require__(150);
	var ReactDOMComponentTree = __webpack_require__(40);
	
	var escapeTextContentForBrowser = __webpack_require__(253);
	var invariant = __webpack_require__(13);
	var validateDOMNesting = __webpack_require__(379);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26),
	    _assign = __webpack_require__(24);
	
	var LinkedValueUtils = __webpack_require__(369);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactUpdates = __webpack_require__(85);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(19);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(24);
	
	var ReactUpdates = __webpack_require__(85);
	var Transaction = __webpack_require__(252);
	
	var emptyFunction = __webpack_require__(65);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1612);
	var BeforeInputEventPlugin = __webpack_require__(1614);
	var ChangeEventPlugin = __webpack_require__(1616);
	var DefaultEventPluginOrder = __webpack_require__(1618);
	var EnterLeaveEventPlugin = __webpack_require__(1619);
	var HTMLDOMPropertyConfig = __webpack_require__(1621);
	var ReactComponentBrowserEnvironment = __webpack_require__(1623);
	var ReactDOMComponent = __webpack_require__(1626);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactDOMEmptyComponent = __webpack_require__(1628);
	var ReactDOMTreeTraversal = __webpack_require__(1636);
	var ReactDOMTextComponent = __webpack_require__(1634);
	var ReactDefaultBatchingStrategy = __webpack_require__(1637);
	var ReactEventListener = __webpack_require__(1641);
	var ReactInjection = __webpack_require__(1642);
	var ReactReconcileTransaction = __webpack_require__(1647);
	var SVGDOMPropertyConfig = __webpack_require__(1652);
	var SelectEventPlugin = __webpack_require__(1653);
	var SimpleEventPlugin = __webpack_require__(1654);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 1639 */
801,
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(186);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(24);
	
	var EventListener = __webpack_require__(483);
	var ExecutionEnvironment = __webpack_require__(55);
	var PooledClass = __webpack_require__(129);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactUpdates = __webpack_require__(85);
	
	var getEventTarget = __webpack_require__(376);
	var getUnboundedScrollPosition = __webpack_require__(1307);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(151);
	var EventPluginHub = __webpack_require__(186);
	var EventPluginUtils = __webpack_require__(367);
	var ReactComponentEnvironment = __webpack_require__(370);
	var ReactEmptyComponent = __webpack_require__(766);
	var ReactBrowserEventEmitter = __webpack_require__(250);
	var ReactHostComponent = __webpack_require__(768);
	var ReactUpdates = __webpack_require__(85);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1665);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var ReactComponentEnvironment = __webpack_require__(370);
	var ReactInstanceMap = __webpack_require__(188);
	var ReactInstrumentation = __webpack_require__(76);
	
	var ReactCurrentOwner = __webpack_require__(91);
	var ReactReconciler = __webpack_require__(152);
	var ReactChildReconciler = __webpack_require__(1622);
	
	var emptyFunction = __webpack_require__(65);
	var flattenChildren = __webpack_require__(1668);
	var invariant = __webpack_require__(13);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(24);
	
	var CallbackQueue = __webpack_require__(762);
	var PooledClass = __webpack_require__(129);
	var ReactBrowserEventEmitter = __webpack_require__(250);
	var ReactInputSelection = __webpack_require__(769);
	var ReactInstrumentation = __webpack_require__(76);
	var Transaction = __webpack_require__(252);
	var ReactUpdateQueue = __webpack_require__(372);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1645);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(24);
	
	var PooledClass = __webpack_require__(129);
	var Transaction = __webpack_require__(252);
	var ReactInstrumentation = __webpack_require__(76);
	var ReactServerUpdateQueue = __webpack_require__(1650);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(372);
	
	var warning = __webpack_require__(19);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.5.4';

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(187);
	var ExecutionEnvironment = __webpack_require__(55);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactInputSelection = __webpack_require__(769);
	var SyntheticEvent = __webpack_require__(89);
	
	var getActiveElement = __webpack_require__(485);
	var isTextInputElement = __webpack_require__(778);
	var shallowEqual = __webpack_require__(202);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var EventListener = __webpack_require__(483);
	var EventPropagators = __webpack_require__(187);
	var ReactDOMComponentTree = __webpack_require__(40);
	var SyntheticAnimationEvent = __webpack_require__(1655);
	var SyntheticClipboardEvent = __webpack_require__(1656);
	var SyntheticEvent = __webpack_require__(89);
	var SyntheticFocusEvent = __webpack_require__(1659);
	var SyntheticKeyboardEvent = __webpack_require__(1661);
	var SyntheticMouseEvent = __webpack_require__(251);
	var SyntheticDragEvent = __webpack_require__(1658);
	var SyntheticTouchEvent = __webpack_require__(1662);
	var SyntheticTransitionEvent = __webpack_require__(1663);
	var SyntheticUIEvent = __webpack_require__(189);
	var SyntheticWheelEvent = __webpack_require__(1664);
	
	var emptyFunction = __webpack_require__(65);
	var getEventCharCode = __webpack_require__(374);
	var invariant = __webpack_require__(13);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(89);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(89);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(89);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(251);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(189);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(89);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(189);
	
	var getEventCharCode = __webpack_require__(374);
	var getEventKey = __webpack_require__(1669);
	var getEventModifierState = __webpack_require__(375);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(189);
	
	var getEventModifierState = __webpack_require__(375);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(89);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(251);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 1665 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(761);
	var warning = __webpack_require__(19);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(26);
	
	var ReactCurrentOwner = __webpack_require__(91);
	var ReactDOMComponentTree = __webpack_require__(40);
	var ReactInstanceMap = __webpack_require__(188);
	
	var getHostComponentFromComposite = __webpack_require__(775);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(19);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(368);
	var traverseAllChildren = __webpack_require__(780);
	var warning = __webpack_require__(19);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","WEB_ENV":"production","PUBLIC_URL":"/barbershops","FB_PIXEL_ID":378862599177017,"COMMANDER_URL":"https://app.getsquire.com","MIXPANEL_TOKEN":"26fd9fecaed51592cb1906e8549eca1e","FLAGSHIP_ANDROID_APP_URL":"https://play.google.com/store/apps/details?id=com.getsquire.flagship","FLAGSHIP_IOS_APP_URL":"https://apps.apple.com/us/app/squire/id957644357","PUBLISH_URL":"https://getsquire.com/barbershops","SQUIRE_BRANCH_KEY":"key_live_eafRKQ0rBNN7eNjrjJJFRhnlvzeWA93h","SQUIRE_STRIPE_KEY":"pk_live_i7yVGwE1iFznsnhYqqpFNxmg","SQUIRE_INTERCOM_ID":"jnflr57i","SQUIRE_TOKENS_URL":"https://squire-tokens-prod-1.getsquire.com","SQUIRE_PUBNUB_SUBSCRIBE_KEY":"sub-c-b7a5edba-08f4-11e7-83b6-0619f8945a4f","SQUIRE_FULLSTORY_ORG":"100T1W","SQUIRE_API_URL":"https://api.getsquire.com/v1","SQUIRE_GOOGLE_ANALYTICS_ID":"UA-70640238-1"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(800);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)))

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(374);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 1670 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 1671 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(55);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(253);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(770);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(2));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__14__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 11);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = warn;
	
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = trim;
	
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	function trim(s) {
	  return s && s.replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addTrackers = addTrackers;
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	exports["default"] = exports.testModeAPI = exports.plugin = void 0;
	
	var _format2 = _interopRequireDefault(__webpack_require__(3));
	
	var _removeLeadingSlash = _interopRequireDefault(__webpack_require__(7));
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	var _loadGA = _interopRequireDefault(__webpack_require__(8));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _log = _interopRequireDefault(__webpack_require__(9));
	
	var _testModeAPI = _interopRequireDefault(__webpack_require__(10));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	var _alwaysSendToDefaultTracker = true;
	var _redactEmail = true;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI["default"].ga.apply(_testModeAPI["default"], arguments);
	  if (_isNotBrowser) return false;
	  if (!window.ga) return (0, _warn["default"])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format2["default"])(s, _titleCase, _redactEmail);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn["default"])('ga command must be a string');
	      return;
	    }
	
	    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);
	
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn["default"])('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	
	    if (options.redactEmail === false) {
	      _redactEmail = false;
	    }
	
	    if (options.useExistingGa) {
	      return;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function addTrackers(configsOrTrackingId, options) {
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if (_typeof(config) !== 'object') {
	        (0, _warn["default"])('All configs must be an object');
	        return;
	      }
	
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	
	  return true;
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (_isNotBrowser) {
	      return;
	    }
	
	    if (!options || options.standardImplementation !== true) (0, _loadGA["default"])(options);
	  }
	
	  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
	  addTrackers(configsOrTrackingId, options);
	}
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	
	
	function ga() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(void 0, args);
	
	    if (_debug) {
	      (0, _log["default"])("called ga('arguments');");
	      (0, _log["default"])("with arguments: ".concat(JSON.stringify(args)));
	    }
	  }
	
	  return window.ga;
	}
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn["default"])('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if (_typeof(fieldsObject) !== 'object') {
	    (0, _warn["default"])('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn["default"])('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log["default"])("called ga('set', fieldsObject);");
	    (0, _log["default"])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
	  }
	}
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	
	  if (_debug) {
	    (0, _log["default"])("called ga('send', fieldObject);");
	    (0, _log["default"])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
	    (0, _log["default"])("with trackers: ".concat(JSON.stringify(trackerNames)));
	  }
	}
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	
	
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn["default"])('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim["default"])(rawPath);
	
	  if (path === '') {
	    (0, _warn["default"])('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _objectSpread({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log["default"])("called ga('send', 'pageview', path);");
	      var extraLog = '';
	
	      if (title) {
	        extraLog = " and title: ".concat(title);
	      }
	
	      (0, _log["default"])("with path: ".concat(path).concat(extraLog));
	    }
	  }
	}
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn["default"])('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash["default"])((0, _trim["default"])(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn["default"])('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = "/modal/".concat(modalName);
	
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log["default"])("called ga('send', 'pageview', path);");
	      (0, _log["default"])("with path: ".concat(path));
	    }
	  }
	}
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || !value || typeof value !== 'number') {
	      (0, _warn["default"])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {{action: string, category: string}} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn["default"])('args.category AND args.action are required in event()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    }; // Optional Fields
	
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn["default"])('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn["default"])('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn["default"])('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn["default"])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    }); // Send to GA
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    }; // Optional Fields
	
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn["default"])('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    } // Send to GA
	
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   * @param trackerName {String} optional e.g 'trackerName'
	   */
	  require: function require(rawName, options, trackerName) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn["default"])('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim["default"])(rawName);
	
	      if (name === '') {
	        (0, _warn["default"])('`name` cannot be an empty string in .require()');
	        return;
	      }
	
	      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields
	
	      if (options) {
	        if (_typeof(options) !== 'object') {
	          (0, _warn["default"])('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn["default"])('Empty `options` given to .require()');
	        }
	
	        ga(requireString, name, options);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
	        }
	      } else {
	        ga(requireString, name);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "');"));
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload;
	    var actionType;
	
	    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	      args[_key3 - 2] = arguments[_key3];
	    }
	
	    if (args.length === 1) {
	      payload = args[0];
	    } else {
	      actionType = args[0];
	      payload = args[1];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn["default"])('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn["default"])('Expected `action` arg to be a String.');
	      } else {
	        var command = "".concat(pluginName, ":").concat(action);
	        payload = payload || null;
	
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
	          }
	        } else if (payload) {
	          ga(command, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("with payload: ".concat(JSON.stringify(payload)));
	          }
	        } else {
	          ga(command);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	          }
	        }
	      }
	    }
	  }
	};
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	
	exports.plugin = plugin;
	
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn["default"])('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn["default"])('args.label is required in outboundLink()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	    var safetyCallbackCalled = false;
	
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	      hitCallback();
	    }; // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	    // register safety net timeout:
	
	
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA
	
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	var testModeAPI = _testModeAPI["default"];
	exports.testModeAPI = testModeAPI;
	var _default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  testModeAPI: _testModeAPI["default"]
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = format;
	
	var _redactEmail = _interopRequireDefault(__webpack_require__(4));
	
	var _toTitleCase = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function format() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var titleCase = arguments.length > 1 ? arguments[1] : undefined;
	  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  var _str = s || '';
	
	  if (titleCase) {
	    _str = (0, _toTitleCase["default"])(s);
	  }
	
	  if (redactingEmail) {
	    _str = (0, _redactEmail["default"])(_str);
	  }
	
	  return _str;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = redactEmail;
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _mightBeEmail = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function redactEmail(string) {
	  if ((0, _mightBeEmail["default"])(string)) {
	    (0, _warn["default"])('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = mightBeEmail;
	
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return typeof s === 'string' && s.indexOf('@') !== -1;
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = toTitleCase;
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * To Title Case 2.1 - http://individed.com/code/to-title-case/
	 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	 * https://github.com/gouch/to-title-case
	 */
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; // test
	
	function toTitleCase(string) {
	  return (0, _trim["default"])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = removeLeadingSlash;
	
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	
	function _default(options) {
	  var gaAddress = 'https://www.google-analytics.com/analytics.js';
	
	  if (options && options.gaAddress) {
	    gaAddress = options.gaAddress;
	  } else if (options && options.debug) {
	    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
	  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	
	  /* eslint-disable */
	
	
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', gaAddress, 'ga');
	  /* eslint-enable */
	
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = log;
	
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.gaCalls = void 0;
	var gaCalls = [];
	exports.gaCalls = gaCalls;
	var _default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push([].concat(args));
	  },
	  resetCalls: function resetCalls() {
	    gaCalls.length = 0;
	  }
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.OutboundLink = exports.testModeAPI = exports.outboundLink = exports.plugin = exports.exception = exports.event = exports.timing = exports.modalview = exports.pageview = exports.send = exports.set = exports.ga = exports.addTrackers = exports.initialize = void 0;
	
	var _OutboundLink = _interopRequireDefault(__webpack_require__(12));
	
	var Defaults = _interopRequireWildcard(__webpack_require__(2));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialize = Defaults.initialize;
	exports.initialize = initialize;
	var addTrackers = Defaults.addTrackers;
	exports.addTrackers = addTrackers;
	var ga = Defaults.ga;
	exports.ga = ga;
	var set = Defaults.set;
	exports.set = set;
	var send = Defaults.send;
	exports.send = send;
	var pageview = Defaults.pageview;
	exports.pageview = pageview;
	var modalview = Defaults.modalview;
	exports.modalview = modalview;
	var timing = Defaults.timing;
	exports.timing = timing;
	var event = Defaults.event;
	exports.event = event;
	var exception = Defaults.exception;
	exports.exception = exception;
	var plugin = Defaults.plugin;
	exports.plugin = plugin;
	var outboundLink = Defaults.outboundLink;
	exports.outboundLink = outboundLink;
	var testModeAPI = Defaults.testModeAPI;
	exports.testModeAPI = testModeAPI;
	_OutboundLink["default"].origTrackLink = _OutboundLink["default"].trackLink;
	_OutboundLink["default"].trackLink = Defaults.outboundLink;
	var OutboundLink = _OutboundLink["default"];
	exports.OutboundLink = OutboundLink;
	
	var _default = _objectSpread(_objectSpread({}, Defaults), {}, {
	  OutboundLink: OutboundLink
	});
	
	exports["default"] = _default;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink = /*#__PURE__*/function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  var _super = _createSuper(OutboundLink);
	
	  function OutboundLink() {
	    var _this;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick,
	          trackerNames = _this$props.trackerNames;
	      var eventMeta = {
	        label: eventLabel
	      };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        }, trackerNames);
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(OutboundLink, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          href = _this$props2.to,
	          target = _this$props2.target,
	          oldProps = _objectWithoutProperties(_this$props2, ["to", "target"]);
	
	      var props = _objectSpread(_objectSpread({}, oldProps), {}, {
	        target: target,
	        href: href,
	        onClick: this.handleClick
	      });
	
	      if (target === NEWTAB) {
	        props.rel = 'noopener noreferrer';
	      }
	
	      delete props.eventLabel;
	      delete props.trackerNames;
	      return /*#__PURE__*/_react["default"].createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	exports["default"] = OutboundLink;
	
	_defineProperty(OutboundLink, "trackLink", function () {
	  (0, _warn["default"])('ga tracking not enabled');
	});
	
	OutboundLink.propTypes = {
	  eventLabel: _propTypes["default"].string.isRequired,
	  target: _propTypes["default"].string,
	  to: _propTypes["default"].string,
	  onClick: _propTypes["default"].func,
	  trackerNames: _propTypes["default"].arrayOf(_propTypes["default"].string)
	};
	OutboundLink.defaultProps = {
	  target: null,
	  to: null,
	  onClick: null,
	  trackerNames: null
	};
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__13__;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__14__;
	
	/***/ })
	/******/ ]);
	});

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GatewayRegistry = __webpack_require__(255);
	
	var _GatewayRegistry2 = _interopRequireDefault(_GatewayRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Gateway = function (_React$Component) {
	  _inherits(Gateway, _React$Component);
	
	  function Gateway(props, context) {
	    _classCallCheck(this, Gateway);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.gatewayRegistry = context.gatewayRegistry;
	    return _this;
	  }
	
	  Gateway.prototype.componentWillMount = function componentWillMount() {
	    this.id = this.gatewayRegistry.register(this.props.into, this.props.children);
	    this.renderIntoGatewayNode(this.props);
	  };
	
	  Gateway.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    this.gatewayRegistry.clearChild(this.props.into, this.id);
	    this.renderIntoGatewayNode(props);
	  };
	
	  Gateway.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.gatewayRegistry.unregister(this.props.into, this.id);
	  };
	
	  Gateway.prototype.renderIntoGatewayNode = function renderIntoGatewayNode(props) {
	    this.gatewayRegistry.addChild(this.props.into, this.id, props.children);
	  };
	
	  Gateway.prototype.render = function render() {
	    return null;
	  };
	
	  return Gateway;
	}(_react2.default.Component);
	
	Gateway.contextTypes = {
	  gatewayRegistry: _propTypes2.default.instanceOf(_GatewayRegistry2.default).isRequired
	};
	Gateway.propTypes = {
	  into: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string])
	};
	exports.default = Gateway;

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GatewayRegistry = __webpack_require__(255);
	
	var _GatewayRegistry2 = _interopRequireDefault(_GatewayRegistry);
	
	var _reactPropTypes = __webpack_require__(1683);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GatewayDest = function (_React$Component) {
	  _inherits(GatewayDest, _React$Component);
	
	  function GatewayDest(props, context) {
	    _classCallCheck(this, GatewayDest);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.state = {
	      child: null
	    };
	
	    _this.gatewayRegistry = context.gatewayRegistry;
	    return _this;
	  }
	
	  GatewayDest.prototype.componentWillMount = function componentWillMount() {
	    this.gatewayRegistry.addContainer(this.props.name, this);
	  };
	
	  GatewayDest.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.gatewayRegistry.removeContainer(this.props.name, this);
	  };
	
	  GatewayDest.prototype.render = function render() {
	    var _props = this.props,
	        component = _props.component,
	        tagName = _props.tagName,
	        attrs = _objectWithoutProperties(_props, ['component', 'tagName']);
	
	    delete attrs.name;
	    return _react2.default.createElement(component || tagName || 'div', attrs, this.state.children);
	  };
	
	  return GatewayDest;
	}(_react2.default.Component);
	
	GatewayDest.contextTypes = {
	  gatewayRegistry: _propTypes2.default.instanceOf(_GatewayRegistry2.default).isRequired
	};
	GatewayDest.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  tagName: (0, _reactPropTypes.deprecated)(_propTypes2.default.string, 'Use "component" instead.'),
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	exports.default = GatewayDest;

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GatewayRegistry = __webpack_require__(255);
	
	var _GatewayRegistry2 = _interopRequireDefault(_GatewayRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GatewayProvider = function (_React$Component) {
	  _inherits(GatewayProvider, _React$Component);
	
	  GatewayProvider.prototype.getChildContext = function getChildContext() {
	    return {
	      gatewayRegistry: this.gatewayRegistry
	    };
	  };
	
	  function GatewayProvider(props, context) {
	    _classCallCheck(this, GatewayProvider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.gatewayRegistry = new _GatewayRegistry2.default();
	    return _this;
	  }
	
	  GatewayProvider.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return GatewayProvider;
	}(_react2.default.Component);
	
	GatewayProvider.childContextTypes = {
	  gatewayRegistry: _propTypes2.default.instanceOf(_GatewayRegistry2.default).isRequired
	};
	GatewayProvider.propTypes = {
	  children: _propTypes2.default.element
	};
	exports.default = GatewayProvider;

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(380);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(380);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = deprecated;
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	
	/* eslint-disable no-underscore-dangle */
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	/* eslint-enable no-underscore-dangle */

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(380);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isRequiredForA11y = exports.elementType = exports.deprecated = exports.componentOrElement = exports.all = undefined;
	
	var _all2 = __webpack_require__(1679);
	
	var _all3 = _interopRequireDefault(_all2);
	
	var _componentOrElement2 = __webpack_require__(1680);
	
	var _componentOrElement3 = _interopRequireDefault(_componentOrElement2);
	
	var _deprecated2 = __webpack_require__(1681);
	
	var _deprecated3 = _interopRequireDefault(_deprecated2);
	
	var _elementType2 = __webpack_require__(1682);
	
	var _elementType3 = _interopRequireDefault(_elementType2);
	
	var _isRequiredForA11y2 = __webpack_require__(1684);
	
	var _isRequiredForA11y3 = _interopRequireDefault(_isRequiredForA11y2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.all = _all3.default;
	exports.componentOrElement = _componentOrElement3.default;
	exports.deprecated = _deprecated3.default;
	exports.elementType = _elementType3.default;
	exports.isRequiredForA11y = _isRequiredForA11y3.default;

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(24);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(781);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _a11yFocusScope = __webpack_require__(859);
	
	var _a11yFocusScope2 = _interopRequireDefault(_a11yFocusScope);
	
	var _a11yFocusStore = __webpack_require__(860);
	
	var _a11yFocusStore2 = _interopRequireDefault(_a11yFocusStore);
	
	var _exenv = __webpack_require__(307);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function setFocusOn(applicationElement, element) {
	  _a11yFocusStore2.default.storeFocus();
	  if (applicationElement) applicationElement.setAttribute('aria-hidden', 'true');
	  _a11yFocusScope2.default.scopeFocus(element);
	}
	
	function resetFocus(applicationElement) {
	  _a11yFocusScope2.default.unscopeFocus();
	  if (applicationElement) applicationElement.removeAttribute('aria-hidden');
	  _a11yFocusStore2.default.restoreFocus();
	}
	
	var ReactModal2 = function (_React$Component) {
	  _inherits(ReactModal2, _React$Component);
	
	  function ReactModal2() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactModal2);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDocumentKeydown = function (event) {
	      if (_this.props.closeOnEsc && event.keyCode === 27) {
	        _this.props.onClose();
	      }
	    }, _this.handleBackdropClick = function () {
	      if (_this.props.closeOnBackdropClick) {
	        _this.props.onClose();
	      }
	    }, _this.handleModalClick = function (event) {
	      event.stopPropagation();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactModal2.getApplicationElement = function getApplicationElement() {
	    console.warn('`ReactModal2.getApplicationElement` needs to be set for accessibility reasons');
	  };
	
	  ReactModal2.prototype.componentDidMount = function componentDidMount() {
	    if (_exenv2.default.canUseDOM) {
	      setFocusOn(ReactModal2.getApplicationElement(), this.modal);
	      document.addEventListener('keydown', this.handleDocumentKeydown);
	    }
	  };
	
	  ReactModal2.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (_exenv2.default.canUseDOM) {
	      resetFocus(ReactModal2.getApplicationElement());
	      document.removeEventListener('keydown', this.handleDocumentKeydown);
	    }
	  };
	
	  ReactModal2.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { ref: function ref(i) {
	          return _this2.backdrop = i;
	        },
	        className: this.props.backdropClassName,
	        style: this.props.backdropStyles,
	        onClick: this.handleBackdropClick },
	      _react2.default.createElement(
	        'div',
	        { ref: function ref(i) {
	            return _this2.modal = i;
	          },
	          className: this.props.modalClassName,
	          style: this.props.modalStyles,
	          onClick: this.handleModalClick,
	          tabIndex: '-1' },
	        this.props.children
	      )
	    );
	  };
	
	  return ReactModal2;
	}(_react2.default.Component);
	
	ReactModal2.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnBackdropClick: _propTypes2.default.bool,
	
	  backdropClassName: _propTypes2.default.string,
	  backdropStyles: _propTypes2.default.object,
	
	  modalClassName: _propTypes2.default.string,
	  modalStyles: _propTypes2.default.object
	};
	ReactModal2.defaultProps = {
	  closeOnEsc: true,
	  closeOnBackdropClick: true
	};
	exports.default = ReactModal2;

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CountrySelectNative = (_temp2 = _class = function (_Component) {
		_inherits(CountrySelectNative, _Component);
	
		function CountrySelectNative() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, CountrySelectNative);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CountrySelectNative.__proto__ || Object.getPrototypeOf(CountrySelectNative)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (event) {
				var onChange = _this.props.onChange;
	
				var value = event.target.value;
				onChange(value === 'ZZ' ? undefined : value);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(CountrySelectNative, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    name = _props.name,
				    value = _props.value,
				    options = _props.options,
				    disabled = _props.disabled,
				    tabIndex = _props.tabIndex,
				    className = _props.className,
				    SelectArrow = _props.selectArrowComponent;
	
	
				var selectedOption = void 0;
				for (var _iterator = options, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
					var _ref2;
	
					if (_isArray) {
						if (_i >= _iterator.length) break;
						_ref2 = _iterator[_i++];
					} else {
						_i = _iterator.next();
						if (_i.done) break;
						_ref2 = _i.value;
					}
	
					var option = _ref2;
	
					if (!option.divider && option.value === value) {
						selectedOption = option;
					}
				}
	
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)(className, 'react-phone-number-input__country--native') },
					selectedOption && _react2.default.createElement(selectedOption.icon, { value: value }),
					_react2.default.createElement(
						'select',
						{
							name: name,
							value: value || 'ZZ',
							onChange: this.onChange,
							disabled: disabled,
							tabIndex: tabIndex,
							className: 'react-phone-number-input__country-select' },
						options.map(function (_ref3) {
							var value = _ref3.value,
							    label = _ref3.label,
							    divider = _ref3.divider;
							return _react2.default.createElement(
								'option',
								{
									key: divider ? '|' : value || 'ZZ',
									value: divider ? '|' : value || 'ZZ',
									disabled: divider ? true : false,
									className: divider ? 'react-phone-number-input__country-select-divider' : undefined },
								label
							);
						})
					),
					_react2.default.createElement(SelectArrow, null)
				);
			}
		}]);
	
		return CountrySelectNative;
	}(_react.Component), _class.propTypes = {
		selectArrowComponent: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
		selectArrowComponent: function selectArrowComponent() {
			return _react2.default.createElement('div', { className: 'react-phone-number-input__country-select-arrow' });
		}
	}, _temp2);
	exports.default = CountrySelectNative;
	//# sourceMappingURL=CountrySelectNative.js.map

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Default country flag icon.
	// `<img/>` is wrapped in a `<div/>` to prevent SVGs from exploding in size in IE 11.
	// https://github.com/catamphetamine/react-phone-number-input/issues/111
	var FlagComponent = function FlagComponent(_ref) {
		var country = _ref.country,
		    flags = _ref.flags,
		    flagsPath = _ref.flagsPath,
		    className = _ref.className;
	
		if (flags && flags[country]) {
			return flags[country]();
		}
	
		return _react2.default.createElement('img', {
			alt: country,
			className: 'react-phone-number-input__icon-image',
			src: '' + flagsPath + country.toLowerCase() + '.svg' });
	};
	
	FlagComponent.propTypes = {
		// The country to be selected by default.
		// Two-letter country code ("ISO 3166-1 alpha-2").
		country: _propTypes2.default.string.isRequired,
	
		// Country flag icon components.
		// By default flag icons are inserted as `<img/>`s
		// with their `src` pointed to `flag-icon-css` github repo.
		// There might be cases (e.g. an offline application)
		// where having a large (3 megabyte) `<svg/>` flags
		// bundle is more appropriate.
		// `import flags from 'react-phone-number-input/flags'`.
		flags: _propTypes2.default.objectOf(_propTypes2.default.func),
	
		// A base URL path for national flag SVG icons.
		// By default it uses the ones from `flag-icon-css` github repo.
		flagsPath: _propTypes2.default.string.isRequired
	};
	
	exports.default = FlagComponent;
	//# sourceMappingURL=Flag.js.map

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _custom = __webpack_require__(524);
	
	var _reactLifecyclesCompat = __webpack_require__(782);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// `PureComponent` is only available in React >= 15.3.0.
	var PureComponent = _react2.default.PureComponent || _react2.default.Component;
	
	/**
	 * `InputBasic`'s caret is not as "smart" as the default `inputComponent`'s
	 * but still works good enough. When erasing or inserting digits in the middle
	 * of a phone number the caret usually jumps to the end: this is the expected
	 * behaviour and it's the workaround for the [Samsung Galaxy smart caret positioning bug](https://github.com/catamphetamine/react-phone-number-input/issues/75).
	 */
	
	var InputBasic = (0, _reactLifecyclesCompat.polyfill)(_class = (_temp2 = _class2 = function (_PureComponent) {
		_inherits(InputBasic, _PureComponent);
	
		function InputBasic() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, InputBasic);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputBasic.__proto__ || Object.getPrototypeOf(InputBasic)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.onChange = function (event) {
				var onChange = _this.props.onChange;
				var value = _this.state.value;
	
	
				var newValue = (0, _custom.parseIncompletePhoneNumber)(event.target.value);
	
				// By default, if a value is something like `"(123)"`
				// then Backspace would only erase the rightmost brace
				// becoming something like `"(123"`
				// which would give the same `"123"` value
				// which would then be formatted back to `"(123)"`
				// and so a user wouldn't be able to erase the phone number.
				// Working around this issue with this simple hack.
				if (newValue === value) {
					if (_this.format(newValue).indexOf(event.target.value) === 0) {
						// Trim the last digit (or plus sign).
						newValue = newValue.slice(0, -1);
					}
				}
	
				// Prevents React from resetting the `<input/>` caret position.
				// https://github.com/reactjs/react-redux/issues/525#issuecomment-254852039
				// https://github.com/facebook/react/issues/955
				_this.setState({ value: newValue }, function () {
					return onChange(newValue);
				});
			}, _this.onBlur = function (event) {
				var onBlur = _this.props.onBlur;
				var value = _this.state.value;
	
	
				if (onBlur) {
					// `event` is React's `SyntheticEvent`.
					// Its `.value` is read-only therefore cloning it.
					var _event = _extends({}, event, {
						target: _extends({}, event.target, {
							value: value
						})
	
						// Workaround for `redux-form` event detection.
						// https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
					});_event.stopPropagation = event.stopPropagation;
					_event.preventDefault = event.preventDefault;
	
					return onBlur(_event);
				}
			}, _this.focus = function () {
				return _this.input.focus();
			}, _this.storeInput = function (ref) {
				return _this.input = ref;
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(InputBasic, [{
			key: 'format',
			value: function format(value) {
				var _props = this.props,
				    country = _props.country,
				    metadata = _props.metadata;
	
	
				return (0, _custom.formatIncompletePhoneNumber)(value, country, metadata);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props2 = this.props,
				    onChange = _props2.onChange,
				    country = _props2.country,
				    metadata = _props2.metadata,
				    rest = _objectWithoutProperties(_props2, ['onChange', 'country', 'metadata']);
	
				// Prevents React from resetting the `<input/>` caret position.
				// https://github.com/reactjs/react-redux/issues/525#issuecomment-254852039
				// https://github.com/facebook/react/issues/955
	
	
				var value = this.state.value;
	
	
				return _react2.default.createElement('input', _extends({
					type: 'tel',
					autoComplete: 'tel'
				}, rest, {
					ref: this.storeInput,
					value: this.format(value),
					onChange: this.onChange,
					onBlur: this.onBlur }));
			}
		}], [{
			key: 'getDerivedStateFromProps',
	
	
			// Prevents React from resetting the `<input/>` caret position.
			// https://github.com/reactjs/react-redux/issues/525#issuecomment-254852039
			// https://github.com/facebook/react/issues/955
			value: function getDerivedStateFromProps(_ref2) {
				var value = _ref2.value;
	
				return { value: value };
			}
	
			// This `onBlur` interceptor is a workaround for `redux-form`'s bug
			// so that it gets the up-to-date `value` in its `onBlur` handler.
			// Without this fix it just gets the actual (raw) input field textual value.
			// E.g. `+7 800 555 35 35` instead of `+78005553535`.
			//
			// New `value` is taken from `event` in `redux-form`'s `handleBlur()`.
			// https://github.com/erikras/redux-form/blob/785edf8aac3adc84aba2ab6898a4aa8c48687750/src/ConnectedField.js#L168
			// `redux-form` shouldn't have taken the new `value` from `event`.
			//
			// A developer is not supposed to pass this `onBlur` property manually.
			// Instead, `redux-form` passes `onBlur` to this component automatically
			// and this component patches that `onBlur` handler (a hacky way but works).
			//
	
		}]);
	
		return InputBasic;
	}(PureComponent), _class2.propTypes = {
		// The parsed phone number.
		// E.g.: `""`, `"+"`, `"+123"`, `"123"`.
		value: _propTypes2.default.string.isRequired,
	
		// Updates the `value`.
		onChange: _propTypes2.default.func.isRequired,
	
		// `onBlur` workaround for `redux-form`'s bug.
		onBlur: _propTypes2.default.func,
	
		// A two-letter country code for formatting `value`
		// as a national phone number (e.g. `(800) 555 35 35`).
		// E.g. "US", "RU", etc.
		// If no `country` is passed then `value`
		// is formatted as an international phone number.
		// (e.g. `+7 800 555 35 35`)
		country: _propTypes2.default.string,
	
		// `libphonenumber-js` metadata.
		metadata: _propTypes2.default.object.isRequired }, _temp2)) || _class;
	
	exports.default = InputBasic;
	//# sourceMappingURL=InputBasic.js.map

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = InternationalIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function InternationalIcon() {
		return _react2.default.createElement(
			"svg",
			{ version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink",
				viewBox: "0 0 356.926 356.926" },
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("path", { d: "M211.89,213.669c0-10.475-8.521-18.997-18.996-18.997c-0.401,0-0.799,0.017-1.193,0.041v2.406\r c0.396-0.028,0.79-0.061,1.193-0.061c9.158,0,16.608,7.452,16.608,16.611s-7.45,16.61-16.608,16.61\r c-0.269,0-0.53-0.027-0.795-0.041v0.897v1.509v4.723H186.2v3.182h13.388v-3.182h-5.104v-4.774\r C204.218,231.781,211.89,223.607,211.89,213.669z" }),
					_react2.default.createElement(
						"g",
						null,
						_react2.default.createElement("polygon", { points: "260.072,79.408 260.398,82.045 256.447,82.882 255.913,88.517 260.677,88.517 266.998,87.913 270.251,84.021\r 266.788,82.678 264.883,80.488 262.024,75.858 260.677,69.329 255.286,70.409 253.799,72.721 253.799,75.312 256.378,77.084\r " }),
						_react2.default.createElement("polygon", { points: "255.495,81.569 255.773,78.037 252.637,76.683 248.233,77.706 244.945,82.94 244.945,86.344 248.768,86.344\r " }),
						_react2.default.createElement("path", { d: "M164.852,96.598l-0.976,2.498h-4.7v2.428h1.121c0,0,0.07,0.511,0.168,1.191l2.876-0.238l1.783-1.121l0.465-2.248\r l2.335-0.204l0.912-1.888l-2.138-0.442L164.852,96.598z" }),
						_react2.default.createElement("polygon", { points: "152.739,101.001 152.565,103.366 155.976,103.081 156.324,100.705 154.279,99.096 \t\t\t" }),
						_react2.default.createElement("path", { d: "M356.868,176.633c-0.047-5.223-0.313-10.398-0.802-15.505c-1.662-17.01-5.717-33.311-11.828-48.589\r c-0.441-1.127-0.859-2.283-1.336-3.41c-8.121-19.183-19.531-36.646-33.474-51.721c-0.906-0.987-1.835-1.952-2.765-2.916\r c-2.649-2.736-5.333-5.415-8.156-7.971C266.788,17.631,224.642,0,178.463,0C131.896,0,89.447,17.957,57.635,47.271\r c-7.413,6.832-14.221,14.303-20.408,22.285C13.919,99.717,0,137.49,0,178.463c0,98.398,80.059,178.463,178.463,178.463\r c69.225,0,129.316-39.643,158.897-97.399c6.32-12.327,11.247-25.491,14.569-39.294c0.837-3.486,1.58-7.018,2.208-10.585\r c1.801-10.137,2.788-20.56,2.788-31.196C356.902,177.859,356.868,177.249,356.868,176.633z M323.278,105.306l1.022-1.162\r c1.359,2.637,2.649,5.304,3.846,8.028l-1.708-0.07l-3.172,0.436v-7.233H323.278z M297.484,74.156l0.023-7.971\r c2.812,2.975,5.508,6.036,8.087,9.214l-3.207,4.781l-11.247-0.111l-0.696-2.341L297.484,74.156z M82.214,54.364v-0.302h3.567\r l0.325-1.226h5.838v2.55l-1.691,2.236h-8.052v-3.259H82.214z M87.925,62.323c0,0,3.578-0.61,3.892-0.61c0.296,0,0,3.573,0,3.573\r l-8.081,0.511l-1.534-1.847L87.925,62.323z M334.642,133.156h-13.06l-7.971-5.92l-8.365,0.808v5.112h-2.648l-2.848-2.033\r l-14.512-3.671v-9.4l-18.38,1.423l-5.705,3.062h-7.285l-3.59-0.36l-8.854,4.926v9.254l-18.097,13.065l1.5,5.583h3.677\r l-0.964,5.315l-2.58,0.953l-0.133,13.884l15.633,17.823h6.819l0.407-1.081h12.246l3.531-3.265h6.948l3.812,3.811l10.328,1.069\r l-1.359,13.757l11.503,20.28l-6.064,11.572l0.406,5.438l4.775,4.752v13.095l6.251,8.412v10.897h5.391\r c-30.046,36.913-75.823,60.534-127.026,60.534c-90.312,0-163.783-73.454-163.783-163.777c0-22.732,4.665-44.401,13.077-64.089\r v-5.106l5.855-7.11c2.033-3.846,4.212-7.582,6.542-11.235l0.25,2.974l-6.791,8.261c-2.108,3.985-4.084,8.052-5.855,12.217v9.312\r l6.791,3.276v12.955l6.535,11.136l5.316,0.808l0.68-3.817l-6.245-9.661l-1.237-9.388h3.677l1.557,9.673l9.051,13.193l-2.33,4.27\r l5.734,8.795l14.291,3.532v-2.306l5.711,0.808l-0.534,4.078l4.484,0.825l6.948,1.888l9.8,11.171l12.507,0.941l1.237,10.207\r l-8.58,5.984l-0.39,9.115l-1.237,5.588l12.386,15.5l0.947,5.32c0,0,4.49,1.209,5.048,1.209c0.535,0,10.062,7.227,10.062,7.227\r v28.024l3.393,0.964l-2.294,12.92l5.71,7.634l-1.068,12.827l7.563,13.269l9.696,8.47l9.731,0.197l0.952-3.148l-7.163-6.029\r l0.418-2.986l1.272-3.684l0.273-3.741l-4.839-0.14l-2.44-3.066l4.021-3.881l0.546-2.916l-4.496-1.29l0.261-2.719l6.402-0.976\r l9.73-4.672l3.265-6.006l10.196-13.06l-2.312-10.213l3.131-5.438l9.399,0.278l6.327-5.02l2.051-19.693l7.04-8.877l1.237-5.704\r l-6.39-2.045l-4.224-6.942l-14.419-0.145l-11.444-4.351l-0.534-8.162l-3.811-6.675l-10.335-0.145l-5.995-9.382l-5.298-2.585\r l-0.273,2.858l-9.672,0.569l-3.532-4.926l-10.079-2.045l-8.302,9.603l-13.065-2.23l-0.953-14.727l-9.527-1.632l3.805-7.221\r l-1.092-4.148l-12.531,8.371l-7.877-0.964l-2.817-6.158l1.737-6.355l4.339-8.005l9.998-5.072h19.322l-0.064,5.891l6.948,3.235\r l-0.558-10.062l5.007-5.037l10.103-6.64l0.703-4.659l10.068-10.486l10.707-5.937l-0.941-0.773l7.256-6.826l2.655,0.703\r l1.214,1.522l2.76-3.062l0.68-0.296l-3.021-0.43l-3.084-0.987v-2.963l1.632-1.33h3.579l1.655,0.726l1.418,2.858l1.737-0.267\r v-0.244l0.5,0.163l5.02-0.772l0.714-2.463l2.852,0.726v2.667l-2.666,1.818h0.018l0.377,2.928l9.115,2.794c0,0,0,0.035,0.023,0.11\r l2.079-0.18l0.146-3.939l-7.209-3.282l-0.396-1.894l5.972-2.033l0.273-5.722l-6.245-3.805l-0.412-9.667l-8.581,4.218h-3.143\r l0.837-7.355l-11.688-2.748l-4.816,3.654v11.119l-8.673,2.754l-3.486,7.244l-3.758,0.604v-9.277l-8.162-1.133l-4.096-2.667\r l-1.639-6.007l14.611-8.54l7.14-2.179l0.72,4.804l3.991-0.215l0.308-2.411l4.166-0.599l0.07-0.842l-1.784-0.738l-0.407-2.544\r l5.118-0.43l3.091-3.213l0.18-0.238l0.035,0.012l0.941-0.976l10.753-1.354l4.746,4.032l-12.467,6.64l15.871,3.747l2.045-5.31\r h6.948l2.44-4.625l-4.903-1.226v-5.856l-15.359-6.803l-10.62,1.226l-6.001,3.125l0.407,7.628l-6.257-0.953l-0.964-4.212\r l6.007-5.449l-10.898-0.535l-3.125,0.953l-1.359,3.677l4.084,0.686l-0.813,4.084l-6.936,0.406l-1.092,2.725L118.987,52.4\r c0,0-0.273-5.711-0.703-5.711c-0.389,0,7.901-0.145,7.901-0.145l5.995-5.85l-3.271-1.632l-4.339,4.223l-7.222-0.406l-4.403-6.019\r h-9.254L94.03,44.07h8.848l0.796,2.597l-2.307,2.172l9.807,0.279l1.487,3.532l-11.032-0.407l-0.546-2.725l-6.925-1.499\r l-3.689-2.033l-8.255,0.069c27.043-19.699,60.284-31.358,96.226-31.358c41.403,0,79.263,15.476,108.124,40.915l-1.929,3.474\r l-7.564,2.962l-3.194,3.462l0.743,4.02l3.893,0.546l2.358,5.867l6.704-2.713l1.127,7.86h-2.045l-5.519-0.819l-6.111,1.022\r l-5.926,8.377l-8.458,1.319l-1.221,7.25l3.579,0.842l-1.046,4.665l-8.412-1.69l-7.703,1.69l-1.639,4.293l1.325,9.01l4.531,2.115\r l7.61-0.046l5.123-0.465l1.58-4.078l8.018-10.422l5.264,1.081l5.193-4.7l0.976,3.678l12.78,8.621l-1.557,2.108l-5.763-0.308\r l2.23,3.137l3.556,0.79l4.159-1.737l-0.093-5.002l1.859-0.923l-1.487-1.575l-8.528-4.758l-2.254-6.314h7.099l2.243,2.248\r l6.134,5.257l0.244,6.367l6.332,6.733l2.348-9.231l4.392-2.394l0.802,7.552l4.287,4.7l8.54-0.139\r c1.661,4.247,3.148,8.563,4.427,12.978L334.642,133.156z M97.324,81.092l4.27-2.044l3.881,0.929l-1.324,5.211l-4.183,1.319\r L97.324,81.092z M120.073,93.35v3.37h-9.783l-3.689-1.028l0.918-2.341l4.7-1.94h6.437v1.94H120.073z M124.582,98.05v3.259\r l-2.463,1.58l-3.044,0.575c0,0,0-4.903,0-5.415H124.582z M121.822,96.72v-3.893l3.363,3.067L121.822,96.72z M123.355,104.568\r v3.178l-2.347,2.347h-5.211l0.813-3.573l2.463-0.215l0.5-1.226L123.355,104.568z M110.39,98.05h5.408l-6.948,9.696l-2.852-1.534\r l0.616-4.084L110.39,98.05z M132.529,103.464v3.166h-5.211l-1.417-2.062v-2.951h0.406L132.529,103.464z M127.748,99.096\r l1.475-1.557l2.498,1.557l-1.999,1.656L127.748,99.096z M337.291,141.428l0.511-0.61c0.232,0.93,0.441,1.859,0.662,2.789\r L337.291,141.428z" }),
						_react2.default.createElement("path", { d: "M27.734,109.268v5.106c1.771-4.177,3.747-8.231,5.855-12.223L27.734,109.268z" })
					)
				)
			)
		);
	}
	//# sourceMappingURL=InternationalIcon.js.map

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp, _initialiseProps;
	
	// import InputSmart from './InputSmart'
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactLifecyclesCompat = __webpack_require__(782);
	
	var _InputBasic = __webpack_require__(1689);
	
	var _InputBasic2 = _interopRequireDefault(_InputBasic);
	
	var _Flag = __webpack_require__(1688);
	
	var _Flag2 = _interopRequireDefault(_Flag);
	
	var _PropTypes = __webpack_require__(785);
	
	var _inputControl = __webpack_require__(1694);
	
	var _countries = __webpack_require__(1693);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// `PureComponent` is only available in React >= 15.3.0.
	var PureComponent = _react2.default.PureComponent || _react2.default.Component;
	
	var PhoneNumberInput = (0, _reactLifecyclesCompat.polyfill)(_class = (_temp = _class2 = function (_PureComponent) {
		_inherits(PhoneNumberInput, _PureComponent);
	
		function PhoneNumberInput(props) {
			_classCallCheck(this, PhoneNumberInput);
	
			var _this = _possibleConstructorReturn(this, (PhoneNumberInput.__proto__ || Object.getPrototypeOf(PhoneNumberInput)).call(this, props));
	
			_initialiseProps.call(_this);
	
			var _this$props = _this.props,
			    value = _this$props.value,
			    country = _this$props.country,
			    countries = _this$props.countries,
			    labels = _this$props.labels,
			    international = _this$props.international,
			    metadata = _this$props.metadata;
	
	
			var parsed_number = (0, _inputControl.parsePhoneNumber)(value, metadata);
	
			var pre_selected_country = (0, _inputControl.getPreSelectedCountry)(parsed_number, country, countries || (0, _countries.getCountryCodes)(labels), international, metadata);
	
			_this.state = {
				// Workaround for `this.props` inside `getDerivedStateFromProps()`.
				props: _this.props,
	
				// The country selected.
				country: pre_selected_country,
	
				// Generate country `<select/>` options.
				country_select_options: generate_country_select_options(_this.props),
	
				// `parsed_input` state property holds non-formatted user's input.
				// The reason is that there's no way of finding out
				// in which form should `value` be displayed: international or national.
				// E.g. if `value` is `+78005553535` then it could be input
				// by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
				// Hence storing just `value`is not sufficient for correct formatting.
				// E.g. if a user entered `8 (800) 555-35-35`
				// then value is `+78005553535` and `parsed_input` is `88005553535`
				// and if a user entered `+7 800 555 35 35`
				// then value is `+78005553535` and `parsed_input` is `+78005553535`.
				parsed_input: generateParsedInput(value, parsed_number, _this.props),
	
				// `value` property is duplicated in state.
				// The reason is that `getDerivedStateFromProps()`
				// needs this `value` to compare to the new `value` property
				// to find out if `parsed_input` needs updating:
				// If the `value` property changed externally
				// then it won't be equal to state `value`
				// in which case `parsed_input` and `country` get updated.
				value: value
			};
			return _this;
		}
	
		// Country `<select/>` `onChange` handler.
	
	
		// Phone number `<input/>` `onKeyDown` handler.
	
	
		// `<input/>` `onChange` handler.
		// Updates `value` property accordingly.
		// (so that they are kept in sync).
		// `parsed_input` must be a parsed phone number
		// or an empty string.
		// E.g.: `""`, `"+"`, `"+123"`, `"123"`.
	
	
		// This `onBlur` interceptor is a workaround for `redux-form`
		// so that it gets the up-to-date `value` in its `onBlur` handler.
		// Without this fix it just gets the actual (raw) input field textual value.
		// E.g. `+7 800 555 35 35` instead of `+78005553535`.
		//
		// A developer is not supposed to pass this `onBlur` property manually.
		// Instead, `redux-form` passes `onBlur` to this component automatically
		// and this component patches that `onBlur` handler (a hacky way but works).
		//
	
	
		// When country `<select/>` is toggled.
	
	
		// Can be called externally.
	
	
		_createClass(PhoneNumberInput, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    name = _props.name,
				    disabled = _props.disabled,
				    autoComplete = _props.autoComplete,
				    countrySelectTabIndex = _props.countrySelectTabIndex,
				    showCountrySelect = _props.showCountrySelect,
				    style = _props.style,
				    className = _props.className,
				    inputClassName = _props.inputClassName,
				    getInputClassName = _props.getInputClassName,
				    countrySelectProperties = _props.countrySelectProperties,
				    error = _props.error,
				    indicateInvalid = _props.indicateInvalid,
				    CountrySelectComponent = _props.countrySelectComponent,
				    InputComponent = _props.inputComponent,
				    ext = _props.ext,
				    countries = _props.countries,
				    labels = _props.labels,
				    _ = _props.country,
				    flags = _props.flags,
				    flagComponent = _props.flagComponent,
				    flagsPath = _props.flagsPath,
				    international = _props.international,
				    internationalIcon = _props.internationalIcon,
				    displayInitialValueAsLocalNumber = _props.displayInitialValueAsLocalNumber,
				    onCountryChange = _props.onCountryChange,
				    locale = _props.locale,
				    metadata = _props.metadata,
				    phoneNumberInputProps = _objectWithoutProperties(_props, ['name', 'disabled', 'autoComplete', 'countrySelectTabIndex', 'showCountrySelect', 'style', 'className', 'inputClassName', 'getInputClassName', 'countrySelectProperties', 'error', 'indicateInvalid', 'countrySelectComponent', 'inputComponent', 'ext', 'countries', 'labels', 'country', 'flags', 'flagComponent', 'flagsPath', 'international', 'internationalIcon', 'displayInitialValueAsLocalNumber', 'onCountryChange', 'locale', 'metadata']);
	
				var _state = this.state,
				    country = _state.country,
				    hidePhoneInputField = _state.hidePhoneInputField,
				    country_select_options = _state.country_select_options,
				    parsed_input = _state.parsed_input;
	
				// const InputComponent = inputComponent || (smartCaret ? InputSmart : InputBasic)
	
				// Extract `countrySelectProperties` from `this.props`
				// also removing them from `phoneNumberInputProps`.
	
				var _countrySelectProps = {};
				if (countrySelectProperties) {
					for (var key in countrySelectProperties) {
						if (this.props.hasOwnProperty(key)) {
							_countrySelectProps[countrySelectProperties[key]] = this.props[key];
							delete phoneNumberInputProps[key];
						}
					}
				}
	
				return _react2.default.createElement(
					'div',
					{
						style: style,
						className: (0, _classnames2.default)('react-phone-number-input', {
							'react-phone-number-input--invalid': error && indicateInvalid
						}, className) },
					_react2.default.createElement(
						'div',
						{ className: 'react-phone-number-input__row' },
						showCountrySelect && _react2.default.createElement(CountrySelectComponent, _extends({}, _countrySelectProps, {
							ref: this.storeCountrySelectInstance,
							name: name ? name + '__country' : undefined,
							value: country,
							options: country_select_options,
							onChange: this.onCountryChange,
							disabled: disabled,
							tabIndex: countrySelectTabIndex,
							hidePhoneInputField: this.hidePhoneInputField,
							focusPhoneInputField: this.focus,
							className: 'react-phone-number-input__country' })),
						!hidePhoneInputField && _react2.default.createElement(InputComponent, _extends({
							type: 'tel',
							name: name
						}, phoneNumberInputProps, {
							ref: this.storePhoneNumberInputInstance,
							metadata: metadata,
							country: country,
							value: parsed_input || '',
							onChange: this.onChange,
							onBlur: this.onBlur,
							onKeyDown: this.onPhoneNumberKeyDown,
							disabled: disabled,
							autoComplete: autoComplete,
							className: (0, _classnames2.default)('react-phone-number-input__input', 'react-phone-number-input__phone', {
								'react-phone-number-input__input--disabled': disabled,
								'react-phone-number-input__input--invalid': error && indicateInvalid
							}, inputClassName, getInputClassName && getInputClassName({ disabled: disabled, invalid: error && indicateInvalid })) })),
						ext && !hidePhoneInputField && _react2.default.createElement(
							'label',
							{ className: 'react-phone-number-input__ext' },
							labels.ext,
							_react2.default.cloneElement(ext, {
								type: ext.props.type === undefined ? 'number' : ext.props.type,
								className: (0, _classnames2.default)('react-phone-number-input__input', 'react-phone-number-input__ext-input', {
									'react-phone-number-input__input--disabled': disabled
								}, inputClassName, getInputClassName && getInputClassName({ disabled: disabled }), ext.props.className)
							})
						)
					),
					error && indicateInvalid && _react2.default.createElement(
						'div',
						{ className: 'react-phone-number-input__error' },
						error
					)
				);
			}
		}], [{
			key: 'getDerivedStateFromProps',
			value: function getDerivedStateFromProps(props, state) {
				var country = state.country,
				    hasChangedCountry = state.hasChangedCountry,
				    value = state.value,
				    _state$props = state.props,
				    old_default_country = _state$props.country,
				    old_value = _state$props.value;
				var metadata = props.metadata,
				    new_default_country = props.country,
				    new_value = props.value;
	
				// Emulate `prevProps` via `state.props`.
	
				var new_state = { props: props
	
					// If `countries` or `labels` or `international` changed
					// then re-generate country `<select/>` options.
				};if (props.countries !== state.props.countries || props.labels !== state.props.labels || props.international !== state.props.international) {
					new_state.country_select_options = generate_country_select_options(props);
				}
	
				// If the default country changed.
				// (e.g. in case of ajax GeoIP detection after page loaded)
				// then select it but only if the user didn't previously select
				// another country and no phone number has been entered so far.
				// Because if the user has already started inputting a phone number
				// then he's okay with no country being selected at all ("International")
				// and doesn't want to be disturbed, doesn't want his input to be screwed, etc.
				if (new_default_country !== old_default_country && !hasChangedCountry && !value && !new_value) {
					return _extends({}, new_state, {
						country: new_default_country
					});
				}
				// If a new `value` is set externally.
				// (e.g. as a result of an ajax API request
				//  to get user's phone after page loaded)
				// The first part — `new_value !== old_value` —
				// is basically `props.value !== prevProps.value`
				// so it means "if value property was changed externally".
				// The second part — `new_value !== value` —
				// is for ignoring the `getDerivedStateFromProps()` call
				// which happens in `this.onChange()` right after `this.setState()`.
				// If this `getDerivedStateFromProps()` call isn't ignored
				// then the country flag would reset on each input.
				else if (new_value !== old_value && new_value !== value) {
						var parsed_number = (0, _inputControl.parsePhoneNumber)(new_value, metadata);
	
						return _extends({}, new_state, {
							parsed_input: generateParsedInput(new_value, parsed_number, props),
							value: new_value,
							country: new_value ? parsed_number.country : country
						});
					}
	
				// Maybe `new_state.country_select_options` changed.
				// In any case, update `prevProps`.
				return new_state;
			}
		}]);
	
		return PhoneNumberInput;
	}(PureComponent), _class2.propTypes = {
		// Phone number in E.164 format.
		// E.g. "+12223333333" for USA.
		value: _propTypes2.default.string,
	
		// `onChange` handler is called each time
		// the phone number `<input/>` is edited.
		onChange: _propTypes2.default.func.isRequired,
	
		// `onBlur` is usually passed by `redux-form`.
		onBlur: _propTypes2.default.func,
	
		// `onKeyDown` handler (e.g. to handle Enter key press).
		onKeyDown: _propTypes2.default.func,
	
		// Some people requested an `onCountryChange` event listener.
		// No valid reason was given other than compliance with some legacy code
		// which stored both phone number and country in a database.
		// https://github.com/catamphetamine/react-phone-number-input/issues/128
		onCountryChange: _propTypes2.default.func,
	
		// Disables both the phone number `<input/>`
		// and the country `<select/>`.
		// (is `false` by default)
		disabled: _propTypes2.default.bool.isRequired,
	
		// Web browser's "autocomplete" feature
		// remembers the phone number being input
		// and can also autofill the `<input/>`
		// with previously remembered phone numbers.
		//
		// Default value: "tel".
		//
		// https://developers.google.com/web/updates/2015/06/checkout-faster-with-autofill
		//
		// "So when should you use autocomplete="off"?
		//  One example is when you've implemented your own version
		//  of autocomplete for search. Another example is any form field
		//  where users will input and submit different kinds of information
		//  where it would not be useful to have the browser remember
		//  what was submitted previously".
		//
		autoComplete: _propTypes2.default.string.isRequired,
	
		// Should the initially passed phone number `value`
		// be converted to a national phone number for its country.
		// (is `false` by default)
		displayInitialValueAsLocalNumber: _propTypes2.default.bool.isRequired,
	
		// The country to be selected by default.
		// Two-letter country code ("ISO 3166-1 alpha-2").
		country: _propTypes2.default.string,
	
		// Only these countries will be available for selection.
		// Includes all countries by default.
		countries: _propTypes2.default.arrayOf(_propTypes2.default.string),
	
		// Custom country `<select/>` option names.
		// E.g. `{ ZZ: 'Международный', RU: 'Россия', US: 'США', ... }`
		labels: _PropTypes.labels.isRequired,
	
		// Country flag icon components.
		// By default flag icons are inserted as `<img/>`s
		// with their `src` pointed to `flag-icon-css` github repo.
		// There might be cases (e.g. an offline application)
		// where having a large (3 megabyte) `<svg/>` flags
		// bundle is more appropriate.
		// `import flags from 'react-phone-number-input/flags'`.
		flags: _propTypes2.default.objectOf(_propTypes2.default.func),
	
		// Flag icon component.
		flagComponent: _propTypes2.default.func.isRequired,
	
		// A base URL path for national flag SVG icons.
		// By default it uses the ones from `flag-icon-css` github repo.
		flagsPath: _propTypes2.default.string.isRequired,
	
		// Whether to add the "International" option
		// to the list of countries.
		international: _propTypes2.default.bool.isRequired,
	
		// Custom "International" country `<select/>` option icon.
		internationalIcon: _propTypes2.default.func.isRequired,
	
		// Whether to show country `<select/>`.
		// (is `true` by default)
		showCountrySelect: _propTypes2.default.bool.isRequired,
	
		// HTML `tabindex` attribute for the country `<select/>`.
		countrySelectTabIndex: _propTypes2.default.number,
	
		// Can be used to place some countries on top of the list.
		// E.g. `["US", "CA", "AU", "|", "..."]`.
		countryOptions: _propTypes2.default.arrayOf(_propTypes2.default.string),
	
		// `<Phone/>` component CSS style object.
		style: _propTypes2.default.object,
	
		// `<Phone/>` component CSS class.
		className: _propTypes2.default.string,
	
		// `<input/>` CSS class.
		// Both for the phone number `<input/>` and
		// `react-responsive-ui` `<Select/>` autocomplete input.
		inputClassName: _propTypes2.default.string,
	
		// Returns phone number `<input/>` CSS class string.
		// Receives an object of shape `{ disabled : boolean?, invalid : boolean? }`.
		getInputClassName: _propTypes2.default.func,
	
		// Country `<select/>` component.
		//
		// Receives properties:
		//
		// * `name : string?` — HTML `name` attribute.
		// * `value : string?` — The currently selected country code.
		// * `onChange(value : string?)` — Updates the `value`.
		// * `options : object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value : string?, label : string, icon : React.Component }`.
		// * `disabled : boolean?` — HTML `disabled` attribute.
		// * `tabIndex : (number|string)?` — HTML `tabIndex` attribute.
		// * `className : string` — CSS class name.
		//
		// Optional properties (should be ignored unless needed):
		//
		// * `hidePhoneInputField(hide : boolean)` — Can be called to show/hide phone input field. Takes `hide : boolean` argument. E.g. `react-responsive-ui` `<Select/>` uses this to hide phone number input when country select is expanded.
		// * `focusPhoneInputField()` — Can be called to manually focus phone input field. E.g. `react-responsive-ui` `<Select/>` uses this to focus phone number input after country selection in a timeout (after the phone input field is no longer hidden).
		//
		countrySelectComponent: _propTypes2.default.func.isRequired,
	
		// Phone number `<input/>` component.
		//
		// Receives properties:
		//
		// * `value : string` — The parsed phone number. E.g.: `""`, `"+"`, `"+123"`, `"123"`.
		// * `onChange(value : string)` — Updates the `value`.
		// * `country : string?` — The currently selected country. `undefined` means "International" (no country selected).
		// * `metadata : object` — `libphonenumber-js` metadata.
		// * All other properties should be passed through to the underlying `<input/>`.
		//
		// Must also implement `.focus()` method.
		//
		inputComponent: _propTypes2.default.func.isRequired,
	
		// // Set to `false` to use `inputComponent={InputBasic}`
		// // instead of `input-format`'s `<ReactInput/>`.
		// // Is `false` by default.
		// smartCaret : PropTypes.bool.isRequired,
	
		// Phone number extension element.
		ext: _propTypes2.default.node,
	
		// An error message shown below the phone number `<input/>`.
		error: _propTypes2.default.string,
	
		// The `error` is shown only when `indicateInvalid` is `true`.
		// (which is the default).
		// (depecated).
		indicateInvalid: _propTypes2.default.bool,
	
		// Translation.
		locale: _propTypes2.default.objectOf(_propTypes2.default.string),
	
		// Allows passing custom `libphonenumber-js` metadata
		// to reduce the overall bundle size for those compiling "custom" metadata.
		metadata: _PropTypes.metadata.isRequired
	}, _class2.defaultProps = {
		// Not disabled.
		disabled: false,
	
		// Show `error` (if passed).
		// (depecated).
		indicateInvalid: true,
	
		// Remember (and autofill) the value as a phone number.
		autoComplete: 'tel',
	
		// Flag icon component.
		flagComponent: _Flag2.default,
	
		// By default use icons from `flag-icon-css` github repo.
		flagsPath: 'https://lipis.github.io/flag-icon-css/flags/4x3/',
	
		// // Default "International" country `<select/>` option icon (globe).
		// internationalIcon: InternationalIcon,
	
		// Phone number `<input/>` component.
		inputComponent: _InputBasic2.default,
	
		// Show country `<select/>`.
		showCountrySelect: true,
	
		// Don't convert the initially passed phone number `value`
		// to a national phone number for its country.
		// The reason is that the newer generation grows up when
		// there are no stationary phones and therefore everyone inputs
		// phone numbers with a `+` in their smartphones
		// so phone numbers written in international form
		// are gradually being considered more natural than local ones.
		displayInitialValueAsLocalNumber: false,
	
		// // Set to `false` to use `inputComponent={InputBasic}`
		// // instead of `input-format`'s `<ReactInput/>`.
		// // Is `false` by default.
		// smartCaret : false,
	
		// Whether to add the "International" option
		// to the list of countries.
		international: true
	}, _initialiseProps = function _initialiseProps() {
		var _this2 = this;
	
		this.onCountryChange = function (new_country) {
			var _props2 = _this2.props,
			    metadata = _props2.metadata,
			    onChange = _props2.onChange,
			    onCountryChange = _props2.onCountryChange,
			    displayInitialValueAsLocalNumber = _props2.displayInitialValueAsLocalNumber;
			var _state2 = _this2.state,
			    old_parsed_input = _state2.parsed_input,
			    old_country = _state2.country;
	
			// After the new `country` has been selected,
			// if the phone number `<input/>` holds any digits
			// then migrate those digits for the new `country`.
	
			var new_parsed_input = (0, _inputControl.migrateParsedInputForNewCountry)(old_parsed_input, old_country, new_country, metadata, displayInitialValueAsLocalNumber);
	
			var new_value = (0, _inputControl.e164)(new_parsed_input, new_country, metadata);
	
			if (onCountryChange) {
				onCountryChange(new_country);
			}
	
			// Focus phone number `<input/>` upon country selection.
			_this2.focus();
	
			_this2.setState({
				country: new_country,
				hasChangedCountry: true,
				parsed_input: new_parsed_input,
				value: new_value
			}, function () {
				// Update the new `value` property.
				// Doing it after the `state` has been updated
				// because `onChange()` will trigger `getDerivedStateFromProps()`
				// with the new `value` which will be compared to `state.value` there.
				onChange(new_value);
			});
		};
	
		this.onPhoneNumberKeyDown = function (event) {
			var onKeyDown = _this2.props.onKeyDown;
	
			// Actually "Down arrow" key is used for showing "autocomplete" ("autofill") options.
			// (e.g. previously entered phone numbers for `autoComplete="tel"`)
			// so can't hijack "Down arrow" keypress here.
			// // Expand country `<select/>`` on "Down arrow" key press.
			// if (event.keyCode === 40) {
			// 	this.country_select.toggle()
			// }
	
			if (onKeyDown) {
				onKeyDown(event);
			}
		};
	
		this.onChange = function (parsed_input) {
			var _props3 = _this2.props,
			    onChange = _props3.onChange,
			    onCountryChange = _props3.onCountryChange,
			    countries = _props3.countries,
			    international = _props3.international,
			    metadata = _props3.metadata;
			var country = _this2.state.country;
	
	
			if (parsed_input) {
				// If the phone number being input is an international one
				// then tries to derive the country from the phone number.
				// (regardless of whether there's any country currently selected)
				if (parsed_input[0] === '+') {
					var old_country = country;
					country = (0, _inputControl.getCountryForParsedInput)(parsed_input, country, countries, international, metadata);
	
					if (country !== old_country && onCountryChange) {
						onCountryChange(country);
					}
				}
				// If this `onChange()` event was triggered
				// as a result of selecting "International" country
				// then force-prepend a `+` sign if the phone number
				// `<input/>` value isn't in international format.
				else if (!country) {
						parsed_input = '+' + parsed_input;
					}
			}
	
			// Generate the new `value` property.
			var value = (0, _inputControl.e164)(parsed_input, country, metadata);
	
			_this2.setState({
				parsed_input: parsed_input,
				value: value,
				country: country
			},
			// Update the new `value` property.
			// Doing it after the `state` has been updated
			// because `onChange()` will trigger `getDerivedStateFromProps()`
			// with the new `value` which will be compared to `state.value` there.
			function () {
				return onChange(value);
			});
		};
	
		this.onBlur = function (event) {
			var onBlur = _this2.props.onBlur;
			var value = _this2.state.value;
	
	
			if (!onBlur) {
				return;
			}
	
			// `event` is React's `SyntheticEvent`.
			// Its `.value` is read-only therefore cloning it.
			var _event = _extends({}, event, {
				target: _extends({}, event.target, {
					value: value
				})
	
				// For `redux-form` event detection.
				// https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
			});_event.stopPropagation = event.stopPropagation;
			_event.preventDefault = event.preventDefault;
	
			return onBlur(_event);
		};
	
		this.hidePhoneInputField = function (hide) {
			_this2.setState({
				hidePhoneInputField: hide
			});
		};
	
		this.focus = function () {
			return _this2.number_input.focus();
		};
	
		this.storeCountrySelectInstance = function (_) {
			return _this2.country_select = _;
		};
	
		this.storePhoneNumberInputInstance = function (_) {
			return _this2.number_input = _;
		};
	}, _temp)) || _class;
	
	// Generates country `<select/>` options.
	
	
	exports.default = PhoneNumberInput;
	function generate_country_select_options(props) {
		var countries = props.countries,
		    labels = props.labels,
		    international = props.international,
		    countryOptions = props.countryOptions;
	
	
		var CountrySelectOptionIcon = createCountrySelectOptionIconComponent(props);
	
		return transformCountryOptions((0, _inputControl.getCountrySelectOptions)(countries || (0, _countries.getCountryCodes)(labels), labels, international).map(function (_ref) {
			var value = _ref.value,
			    label = _ref.label;
			return {
				value: value,
				label: label,
				icon: CountrySelectOptionIcon
			};
		}), countryOptions);
	}
	
	function createCountrySelectOptionIconComponent(props) {
		var flags = props.flags,
		    flagsPath = props.flagsPath,
		    FlagComponent = props.flagComponent,
		    InternationalIcon = props.internationalIcon;
	
	
		return function (_ref2) {
			var value = _ref2.value;
			return _react2.default.createElement(
				'div',
				{
					className: (0, _classnames2.default)('react-phone-number-input__icon', {
						'react-phone-number-input__icon--international': value === undefined
					}) },
				value ? _react2.default.createElement(FlagComponent, {
					country: value,
					flags: flags,
					flagsPath: flagsPath }) : _react2.default.createElement(InternationalIcon, null)
			);
		};
	}
	
	// Can move some country `<select/>` options
	// to the top of the list, for example.
	// See `countryOptions` property.
	function transformCountryOptions(options, transform) {
		if (!transform) {
			return options;
		}
	
		var optionsOnTop = [];
		var optionsOnBottom = [];
		var appendTo = optionsOnTop;
	
		var _loop = function _loop() {
			if (_isArray) {
				if (_i >= _iterator.length) return 'break';
				_ref3 = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) return 'break';
				_ref3 = _i.value;
			}
	
			var element = _ref3;
	
			if (element === '|') {
				appendTo.push({ divider: true });
			} else if (element === '...' || element === '…') {
				appendTo = optionsOnBottom;
			} else {
				// Find the position of the option.
				var index = options.indexOf(options.filter(function (option) {
					return option.value === element;
				})[0]);
				// Get the option.
				var option = options[index];
				// Remove the option from its default position.
				options.splice(index, 1);
				// Add the option on top.
				appendTo.push(option);
			}
		};
	
		for (var _iterator = transform, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref3;
	
			var _ret = _loop();
	
			if (_ret === 'break') break;
		}
	
		return optionsOnTop.concat(options).concat(optionsOnBottom);
	}
	
	function generateParsedInput(value, parsed_number, props) {
		var displayInitialValueAsLocalNumber = props.displayInitialValueAsLocalNumber,
		    metadata = props.metadata;
	
		// If the `value` (E.164 phone number)
		// belongs to the currently selected country
		// and `displayInitialValueAsLocalNumber` property is `true`
		// then convert `value` (E.164 phone number)
		// to a local phone number digits.
		// E.g. '+78005553535' -> '88005553535'.
	
		if (displayInitialValueAsLocalNumber && parsed_number.country) {
			return (0, _inputControl.generateNationalNumberDigits)(parsed_number, metadata);
		}
	
		return value;
	}
	//# sourceMappingURL=PhoneInput.js.map

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PhoneInput = __webpack_require__(1691);
	
	var _PhoneInput2 = _interopRequireDefault(_PhoneInput);
	
	var _CountrySelectNative = __webpack_require__(1687);
	
	var _CountrySelectNative2 = _interopRequireDefault(_CountrySelectNative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PhoneInputNative = (_temp2 = _class = function (_Component) {
		_inherits(PhoneInputNative, _Component);
	
		function PhoneInputNative() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, PhoneInputNative);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhoneInputNative.__proto__ || Object.getPrototypeOf(PhoneInputNative)).call.apply(_ref, [this].concat(args))), _this), _this.storeInputRef = function (ref) {
				return _this.input = ref;
			}, _this.focus = function () {
				return _this.input.focus();
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(PhoneInputNative, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(_PhoneInput2.default, _extends({}, this.props, {
					ref: this.storeInputRef,
					countrySelectComponent: _CountrySelectNative2.default,
					countrySelectProperties: countrySelectProperties }));
			}
	
			// Proxy `.focus()` method.
	
		}]);
	
		return PhoneInputNative;
	}(_react.Component), _class.propTypes = {
		// Replaces the default country select arrow.
		countrySelectArrowComponent: _propTypes2.default.func
	}, _temp2);
	exports.default = PhoneInputNative;
	
	
	var countrySelectProperties = {
		countrySelectArrowComponent: 'selectArrowComponent'
	};
	//# sourceMappingURL=PhoneInputNative.js.map

/***/ }),
/* 1693 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getCountryCodes = getCountryCodes;
	function getCountryCodes(labels) {
		// Includes all country codes (excluding "ZZ" for "International").
		//
		// From ISO 3166-1:2006(E/F):
		//
		// 8.1.3   User-assigned code elements
		//
		// If users need code elements to represent country names not included
		// in this part of ISO 3166, the series of letters AA, QM to QZ, XA
		// to XZ, and ZZ, and the series AAA to AAZ, QMA to QZZ, XAA to XZZ,
		// and ZZA to ZZZ respectively, and the series of numbers 900 to 999
		// are available. These users should inform the ISO 3166/MA of such use.
		//
		return Object.keys(labels).filter(function (key) {
			return key.length === 2 && key.toUpperCase() === key && key !== 'ZZ';
		});
	}
	//# sourceMappingURL=countries.js.map

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getPreSelectedCountry = getPreSelectedCountry;
	exports.getCountrySelectOptions = getCountrySelectOptions;
	exports.parsePhoneNumber = parsePhoneNumber;
	exports.generateNationalNumberDigits = generateNationalNumberDigits;
	exports.migrateParsedInputForNewCountry = migrateParsedInputForNewCountry;
	exports.e164 = e164;
	exports.getCountryForParsedInput = getCountryForParsedInput;
	exports.get_country_from_possibly_incomplete_international_phone_number = get_country_from_possibly_incomplete_international_phone_number;
	exports.compare_strings = compare_strings;
	exports.strip_country_calling_code = strip_country_calling_code;
	exports.get_national_significant_number_part = get_national_significant_number_part;
	exports.could_number_belong_to_country = could_number_belong_to_country;
	
	var _custom = __webpack_require__(524);
	
	/**
	 * Decides which country should be pre-selected
	 * when the phone number input component is first mounted.
	 * @param  {object} parsedNumber - A parsed number object: `{ country, phone }`. Can be an empty object.
	 * @param  {string?} country - Pre-defined country (two-letter code).
	 * @param  {string[]?} countries - A list of countries available.
	 * @param  {boolean} includeInternationalOption - Whether "International" country option is available.
	 * @param  {object} metadata - `libphonenumber-js` metadata
	 * @return {string?}
	 */
	function getPreSelectedCountry(parsed_number, country, countries, includeInternationalOption, metadata) {
		// If can get country from E.164 phone number
		// then it overrides the `country` passed (or not passed).
		if (parsed_number.country) {
			// `country` will be left `undefined` in case of non-detection.
			country = parsed_number.country;
		}
	
		// Only pre-select a country if it's in the available `countries` list.
		if (countries && countries.indexOf(country) < 0) {
			country = undefined;
		}
	
		// If there will be no "International" option
		// then some `country` must be selected.
		// It will still be the wrong country though.
		// But still country `<select/>` can't be left in a broken state.
		if (!country && !includeInternationalOption && countries && countries.length > 0) {
			country = countries[0];
		}
	
		return country;
	}
	
	/**
	 * Generates a sorted list of country `<select/>` options.
	 * @param  {string[]} countries - A list of two-letter ("ISO 3166-1 alpha-2") country codes.
	 * @param  {object} labels - Custom country labels. E.g. `{ RU: 'Россия', US: 'США', ... }`.
	 * @param  {boolean} includeInternationalOption - Whether should include "International" option at the top of the list.
	 * @return {object[]} A list of objects having shape `{ value : string, label : string }`.
	 */
	function getCountrySelectOptions(countries, country_names, includeInternationalOption) {
		// Generates a `<Select/>` option for each country.
		var country_select_options = countries.map(function (country) {
			return {
				value: country,
				label: country_names[country]
			};
		});
	
		// Sort the list of countries alphabetically.
		country_select_options.sort(function (a, b) {
			return compare_strings(a.label, b.label);
		});
	
		// Add the "International" option to the country list (if suitable)
		if (includeInternationalOption) {
			country_select_options.unshift({
				label: country_names.ZZ
			});
		}
	
		return country_select_options;
	}
	
	/**
	 * Parses a E.164 phone number to an object having shape `{ country : string, phone : string }`.
	 * @param {string} value = E.164 phone number.
	 * @param  {object} metadata - `libphonenumber-js` metadata
	 * @example
	 * parsePhoneNumber('+78005553535')
	 * // returns `{ country: 'RU', phone: '8005553535' }`
	 */
	function parsePhoneNumber(value, metadata) {
		return (0, _custom.parseNumber)(value || '', metadata);
	}
	
	/**
	 * Generates national number digits for a parsed phone.
	 * May prepend national prefix.
	 * The phone number must be a complete and valid phone number.
	 * @param  {object} parsedPhone - Object having shape `{ country : string, phone : string }`.
	 * @param  {object} metadata - `libphonenumber-js` metadata
	 * @return {string}
	 * @example
	 * getNationalNumberDigits({ country: 'RU', phone: '8005553535' })
	 * // returns '88005553535'
	 */
	function generateNationalNumberDigits(parsed_phone, metadata) {
		return (0, _custom.formatNumber)(parsed_phone, 'National', metadata).replace(/\D/g, '');
	}
	
	/**
	 * Migrates `<input/>` parsed `value` for the newly selected `country`.
	 * @param {string?} value - The `value` parsed from phone number `<input/>` (it's the `parsed_input` state property, not the `value` property).
	 * @param {string?} previousCountry - Previously selected country.
	 * @param {string?} newCountry - Newly selected country. Can't be same as previously selected country.
	 * @param {object} metadata - `libphonenumber-js` metadata.
	 * @param {boolean} preferNationalFormat - whether should attempt to convert from international to national number for the new country.
	 * @return {string}
	 */
	function migrateParsedInputForNewCountry(value, previous_country, new_country, metadata, preferNationalFormat) {
		// If `parsed_input` is empty
		// then no need to migrate anything.
		if (!value) {
			return value;
		}
	
		// If switching to some country.
		// (from "International" or another country)
		// If switching from "International" then `value` starts with a `+`.
		// Otherwise it may or may not start with a `+`.
		if (new_country) {
			// If the phone number was entered in international format
			// then migrate it to the newly selected country.
			// The phone number may be incomplete.
			// The phone number entered not necessarily starts with
			// the previously selected country phone prefix.
			if (value[0] === '+') {
				// If the international phone number is for the new country
				// then convert it to local if required.
				if (preferNationalFormat) {
					// If a phone number is being input in international form
					// and the country can already be derived from it,
					// and if it is the new country, then format as a national number.
					var derived_country = get_country_from_possibly_incomplete_international_phone_number(value, metadata);
					if (derived_country === new_country) {
						return strip_country_calling_code(value, derived_country, metadata);
					}
				}
	
				// If the international phone number already contains
				// any country calling code then trim the country calling code part.
				// (that could also be the newly selected country phone code prefix as well)
				// `value` doesn't neccessarily belong to `previous_country`.
				// (e.g. if a user enters an international number
				//  not belonging to any of the reduced `countries` list)
				value = strip_country_calling_code(value, previous_country, metadata);
	
				// Prepend country calling code prefix
				// for the newly selected country.
				return '+' + (0, _custom.getCountryCallingCode)(new_country, metadata) + value;
			}
		}
		// If switching to "International" from a country.
		else {
				// If the phone number was entered in national format.
				if (value[0] !== '+') {
					// Format the national phone number as an international one.
					// The phone number entered not necessarily even starts with
					// the previously selected country phone prefix.
					// Even if the phone number belongs to whole another country
					// it will still be parsed into some national phone number.
					var partial_national_significant_number = get_national_significant_number_part(value, previous_country, metadata);
					return (0, _custom.formatNumber)(partial_national_significant_number, previous_country, 'E.164', metadata);
				}
			}
	
		return value;
	}
	
	/**
	 * Converts phone number digits to a (possibly incomplete) E.164 phone number.
	 * @param  {string?} number - A possibly incomplete phone number digits string. Can be a possibly incomplete E.164 phone number.
	 * @param  {string?} country
	 * @param  {[object} metadata - `libphonenumber-js` metadata.
	 * @return {string?}
	 */
	function e164(number, country, metadata) {
		if (!number) {
			return;
		}
	
		// If the phone number is being input in international format.
		if (number[0] === '+') {
			// If it's just the `+` sign then return nothing.
			if (number === '+') {
				return;
			}
	
			// If there are any digits then the `value` is returned as is.
			return number;
		}
	
		// For non-international phone numbers
		// an accompanying country code is required.
		if (!country) {
			return;
		}
	
		var partial_national_significant_number = get_national_significant_number_part(number, country, metadata);
	
		if (partial_national_significant_number) {
			return (0, _custom.formatNumber)(partial_national_significant_number, country, 'E.164', metadata);
		}
	}
	
	// If the phone number being input is an international one
	// then tries to derive the country from the phone number.
	// (regardless of whether there's any country currently selected)
	/**
	 * @param {string} parsedInput - A possibly incomplete E.164 phone number.
	 * @param {string?} country - Currently selected country.
	 * @param {string[]?} countries - A list of available countries. If not passed then "all countries" are assumed.
	 * @param {boolean} includeInternationalOption - Whether "International" country option is available.
	 * @param  {[object} metadata - `libphonenumber-js` metadata.
	 * @return {string?}
	 */
	function getCountryForParsedInput(parsed_input, country, countries, includeInternationalOption, metadata) {
		if (parsed_input === '+') {
			// Don't change the currently selected country yet.
			return country;
		}
	
		var derived_country = get_country_from_possibly_incomplete_international_phone_number(parsed_input, metadata);
	
		// If a phone number is being input in international form
		// and the country can already be derived from it,
		// then select that country.
		if (derived_country && (!countries || countries.indexOf(derived_country) >= 0)) {
			return derived_country;
		}
		// If "International" country option has not been disabled
		// and the international phone number entered doesn't correspond
		// to the currently selected country then reset the currently selected country.
		else if (country && includeInternationalOption && !could_number_belong_to_country(parsed_input, country, metadata)) {
				return undefined;
			}
	
		// Don't change the currently selected country.
		return country;
	}
	
	/**
	 * Determines the country for a given (possibly incomplete) E.164 phone number.
	 * @param  {string} number - A possibly incomplete E.164 phone number.
	 * @param  {object} metadata - `libphonenumber-js` metadata.
	 * @return {string?}
	 */
	function get_country_from_possibly_incomplete_international_phone_number(number, metadata) {
		var formatter = new _custom.AsYouType(null, metadata);
		formatter.input(number);
		// `001` is a special "non-geograpical entity" code
		// in Google's `libphonenumber` library.
		if (formatter.country === '001') {
			return;
		}
		return formatter.country;
	}
	
	/**
	 * Compares two strings.
	 * A helper for `Array.sort()`.
	 */
	function compare_strings(a, b) {
		// Use `String.localeCompare` if it's available.
		// https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
		// Which means everyone except IE <= 10 and Safari <= 10.
		// `localeCompare()` is available in latest Node.js versions.
		/* istanbul ignore else */
		if (String.prototype.localeCompare) {
			return a.localeCompare(b);
		}
		/* istanbul ignore next */
		return a < b ? -1 : a > b ? 1 : 0;
	}
	
	/**
	 * Strips `+${countryCallingCode}` prefix from an E.164 phone number.
	 * @param {string} number - (possibly incomplete) E.164 phone number.
	 * @param {string?} country - A possible country for this phone number.
	 * @param {object} metadata - `libphonenumber-js` metadata.
	 * @return {string}
	 */
	function strip_country_calling_code(number, country, metadata) {
		// Just an optimization, so that it
		// doesn't have to iterate through all country calling codes.
		if (country) {
			var country_calling_prefix = '+' + (0, _custom.getCountryCallingCode)(country, metadata);
	
			// If `country` fits the actual `number`.
			if (number.length < country_calling_prefix.length) {
				if (country_calling_prefix.indexOf(number) === 0) {
					return '';
				}
			} else {
				if (number.indexOf(country_calling_prefix) === 0) {
					return number.slice(country_calling_prefix.length);
				}
			}
		}
	
		// If `country` doesn't fit the actual `number`.
		// Try all available country calling codes.
		for (var _iterator = Object.keys(metadata.country_calling_codes), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;
	
			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}
	
			var country_calling_code = _ref;
	
			if (number.indexOf(country_calling_code) === '+'.length) {
				return number.slice('+'.length + country_calling_code.length);
			}
		}
	
		return '';
	}
	
	/**
	 * Parses a partially entered national phone number digits
	 * (or a partially entered E.164 international phone number)
	 * and returns the national significant number part.
	 * National significant number returned doesn't come with a national prefix.
	 * @param {string} number - National number digits. Or possibly incomplete E.164 phone number.
	 * @param {string?} country
	 * @param {object} metadata - `libphonenumber-js` metadata.
	 */
	function get_national_significant_number_part(number, country, metadata) {
		// Create "as you type" formatter.
		var formatter = new _custom.AsYouType(country, metadata);
	
		// Input partial national phone number.
		formatter.input(number);
	
		// Return the parsed partial national phone number.
		return formatter.getNationalNumber();
	}
	
	/**
	 * Checks if a partially entered E.164 phone number could belong to a country.
	 * @param  {string} number
	 * @param  {string} country
	 * @return {boolean}
	 */
	function could_number_belong_to_country(number, country, metadata) {
		var country_calling_code = (0, _custom.getCountryCallingCode)(country, metadata);
	
		var i = 0;
		while (i + 1 < number.length && i < country_calling_code.length) {
			if (number[i + 1] !== country_calling_code[i]) {
				return false;
			}
			i++;
		}
	
		return true;
	}
	//# sourceMappingURL=input-control.js.map

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(789);
	
	var _warning = __webpack_require__(381);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store, storeSubscription: null };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports.default = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _PropTypes.storeShape.isRequired,
	  children: _propTypes2.default.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _PropTypes.storeShape.isRequired,
	  storeSubscription: _PropTypes.subscriptionShape
	};
	Provider.displayName = 'Provider';

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(787);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(1703);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(1697);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(1698);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(1699);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(1700);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(49);
	
	var _wrapMapToProps = __webpack_require__(788);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(788);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(790);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(1701);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(381);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 1702 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),
/* 1703 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else if(typeof exports === 'object')
			exports["MediaQuery"] = factory(require("react"));
		else
			root["MediaQuery"] = factory(root["react"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_15__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		var _react = __webpack_require__(15);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _propTypes = __webpack_require__(8);
		
		var _propTypes2 = _interopRequireDefault(_propTypes);
		
		var _matchmediaquery = __webpack_require__(11);
		
		var _matchmediaquery2 = _interopRequireDefault(_matchmediaquery);
		
		var _hyphenateStyleName = __webpack_require__(7);
		
		var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
		
		var _mediaQuery = __webpack_require__(5);
		
		var _mediaQuery2 = _interopRequireDefault(_mediaQuery);
		
		var _toQuery = __webpack_require__(9);
		
		var _toQuery2 = _interopRequireDefault(_toQuery);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		var defaultTypes = {
		  component: _propTypes2.default.node,
		  query: _propTypes2.default.string,
		  values: _propTypes2.default.shape(_mediaQuery2.default.matchers),
		  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
		  onChange: _propTypes2.default.func,
		  onBeforeChange: _propTypes2.default.func
		};
		var mediaKeys = Object.keys(_mediaQuery2.default.all);
		var excludedQueryKeys = Object.keys(defaultTypes);
		var excludedPropKeys = excludedQueryKeys.concat(mediaKeys);
		
		function omit(object, keys) {
		  var newObject = _extends({}, object);
		  keys.forEach(function (key) {
		    return delete newObject[key];
		  });
		  return newObject;
		}
		
		var MediaQuery = function (_React$Component) {
		  _inherits(MediaQuery, _React$Component);
		
		  function MediaQuery() {
		    var _ref;
		
		    var _temp, _this, _ret;
		
		    _classCallCheck(this, MediaQuery);
		
		    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		      args[_key] = arguments[_key];
		    }
		
		    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MediaQuery.__proto__ || Object.getPrototypeOf(MediaQuery)).call.apply(_ref, [this].concat(args))), _this), _this.state = { matches: false }, _this.updateMatches = function () {
		      if (_this._mql.matches === _this.state.matches) {
		        return;
		      }
		      _this.setState({
		        matches: _this._mql.matches
		      });
		    }, _this.removeMql = function () {
		      if (_this._mql) {
		        _this._mql.removeListener(_this.updateMatches);
		        _this._mql.dispose();
		      }
		    }, _temp), _possibleConstructorReturn(_this, _ret);
		  }
		
		  _createClass(MediaQuery, [{
		    key: 'componentWillMount',
		    value: function componentWillMount() {
		      this.updateQuery(this.props);
		    }
		  }, {
		    key: 'componentWillReceiveProps',
		    value: function componentWillReceiveProps(nextProps) {
		      this.updateQuery(nextProps);
		    }
		  }, {
		    key: 'updateQuery',
		    value: function updateQuery(props) {
		      var values = void 0;
		      if (props.query) {
		        this.query = props.query;
		      } else {
		        this.query = (0, _toQuery2.default)(omit(props, excludedQueryKeys));
		      }
		
		      if (!this.query) {
		        throw new Error('Invalid or missing MediaQuery!');
		      }
		
		      if (props.values) {
		        values = Object.keys(props.values).reduce(function (result, key) {
		          result[(0, _hyphenateStyleName2.default)(key)] = props.values[key];
		          return result;
		        }, {});
		      }
		
		      this.removeMql();
		
		      this._mql = (0, _matchmediaquery2.default)(this.query, values);
		      this._mql.addListener(this.updateMatches);
		      this.updateMatches();
		    }
		  }, {
		    key: 'componentWillUpdate',
		    value: function componentWillUpdate(_, nextState) {
		      if (this.props.onBeforeChange && this.state.matches !== nextState.matches) {
		        this.props.onBeforeChange(this.state.matches);
		      }
		    }
		  }, {
		    key: 'componentDidUpdate',
		    value: function componentDidUpdate(_, prevState) {
		      if (this.props.onChange && prevState.matches !== this.state.matches) {
		        this.props.onChange(this.state.matches);
		      }
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      this.removeMql();
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      if (typeof this.props.children === 'function') {
		        return this.props.children(this.state.matches);
		      }
		
		      if (this.state.matches === false) {
		        return null;
		      }
		      var props = omit(this.props, excludedPropKeys);
		      var hasMergeProps = Object.keys(props).length > 0;
		      var childrenCount = _react2.default.Children.count(this.props.children);
		      var wrapChildren = this.props.component || childrenCount > 1 || typeof this.props.children === 'string' || Array.isArray(this.props.children) && childrenCount == 1 || this.props.children === undefined;
		      if (wrapChildren) {
		        return _react2.default.createElement(this.props.component || 'div', props, this.props.children);
		      } else if (hasMergeProps) {
		        return _react2.default.cloneElement(this.props.children, props);
		      } else if (childrenCount) {
		        return this.props.children;
		      } else {
		        return null;
		      }
		    }
		  }]);
		
		  return MediaQuery;
		}(_react2.default.Component);
		
		MediaQuery.displayName = 'MediaQuery';
		MediaQuery.defaultProps = {
		  values: {}
		};
		exports.default = MediaQuery;
		module.exports = exports['default'];
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		// shim for using process in browser
		var process = module.exports = {};
		
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
		
		var cachedSetTimeout;
		var cachedClearTimeout;
		
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
		
		
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
		
		
		
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
		
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
		
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
		
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
		
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
		
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
		
		function noop() {}
		
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		process.prependListener = noop;
		process.prependOnceListener = noop;
		
		process.listeners = function (name) { return [] }
		
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
		
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		"use strict";
		
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
		
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
		
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
		
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
		
		module.exports = emptyFunction;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
		
		'use strict';
		
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
		
		var validateFormat = function validateFormat(format) {};
		
		if (process.env.NODE_ENV !== 'production') {
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
		
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
		
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
		
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
		
		module.exports = invariant;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
		
		'use strict';
		
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
		
		module.exports = ReactPropTypesSecret;
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		var _propTypes = __webpack_require__(8);
		
		var _propTypes2 = _interopRequireDefault(_propTypes);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
		
		// properties that match media queries
		var matchers = {
		  orientation: _propTypes2.default.oneOf(['portrait', 'landscape']),
		
		  scan: _propTypes2.default.oneOf(['progressive', 'interlace']),
		
		  aspectRatio: _propTypes2.default.string,
		  deviceAspectRatio: _propTypes2.default.string,
		
		  height: stringOrNumber,
		  deviceHeight: stringOrNumber,
		
		  width: stringOrNumber,
		  deviceWidth: stringOrNumber,
		
		  color: _propTypes2.default.bool,
		
		  colorIndex: _propTypes2.default.bool,
		
		  monochrome: _propTypes2.default.bool,
		  resolution: stringOrNumber
		
		  // media features
		};var features = _extends({
		  minAspectRatio: _propTypes2.default.string,
		  maxAspectRatio: _propTypes2.default.string,
		  minDeviceAspectRatio: _propTypes2.default.string,
		  maxDeviceAspectRatio: _propTypes2.default.string,
		
		  minHeight: stringOrNumber,
		  maxHeight: stringOrNumber,
		  minDeviceHeight: stringOrNumber,
		  maxDeviceHeight: stringOrNumber,
		
		  minWidth: stringOrNumber,
		  maxWidth: stringOrNumber,
		  minDeviceWidth: stringOrNumber,
		  maxDeviceWidth: stringOrNumber,
		
		  minColor: _propTypes2.default.number,
		  maxColor: _propTypes2.default.number,
		
		  minColorIndex: _propTypes2.default.number,
		  maxColorIndex: _propTypes2.default.number,
		
		  minMonochrome: _propTypes2.default.number,
		  maxMonochrome: _propTypes2.default.number,
		
		  minResolution: stringOrNumber,
		  maxResolution: stringOrNumber
		
		}, matchers);
		
		// media types
		var types = {
		  all: _propTypes2.default.bool,
		  grid: _propTypes2.default.bool,
		  aural: _propTypes2.default.bool,
		  braille: _propTypes2.default.bool,
		  handheld: _propTypes2.default.bool,
		  print: _propTypes2.default.bool,
		  projection: _propTypes2.default.bool,
		  screen: _propTypes2.default.bool,
		  tty: _propTypes2.default.bool,
		  tv: _propTypes2.default.bool,
		  embossed: _propTypes2.default.bool
		};
		
		var all = _extends({}, types, features);
		
		// add the type property
		matchers.type = Object.keys(types);
		
		exports.default = {
		  all: all,
		  types: types,
		  matchers: matchers,
		  features: features
		};
		module.exports = exports['default'];
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2014-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
		
		'use strict';
		
		var emptyFunction = __webpack_require__(2);
		
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
		
		var warning = emptyFunction;
		
		if (process.env.NODE_ENV !== 'production') {
		  (function () {
		    var printWarning = function printWarning(format) {
		      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		        args[_key - 1] = arguments[_key];
		      }
		
		      var argIndex = 0;
		      var message = 'Warning: ' + format.replace(/%s/g, function () {
		        return args[argIndex++];
		      });
		      if (typeof console !== 'undefined') {
		        console.error(message);
		      }
		      try {
		        // --- Welcome to debugging React ---
		        // This error was thrown as a convenience so that you can use this stack
		        // to find the callsite that caused this warning to fire.
		        throw new Error(message);
		      } catch (x) {}
		    };
		
		    warning = function warning(condition, format) {
		      if (format === undefined) {
		        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
		      }
		
		      if (format.indexOf('Failed Composite propType: ') === 0) {
		        return; // Ignore CompositeComponent proptype check.
		      }
		
		      if (!condition) {
		        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		          args[_key2 - 2] = arguments[_key2];
		        }
		
		        printWarning.apply(undefined, [format].concat(args));
		      }
		    };
		  })();
		}
		
		module.exports = warning;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
		'use strict';
		
		var uppercasePattern = /[A-Z]/g;
		var msPattern = /^ms-/;
		var cache = {};
		
		function hyphenateStyleName(string) {
		    return string in cache
		    ? cache[string]
		    : cache[string] = string
		      .replace(uppercasePattern, '-$&')
		      .toLowerCase()
		      .replace(msPattern, '-ms-');
		}
		
		module.exports = hyphenateStyleName;
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
		
		if (process.env.NODE_ENV !== 'production') {
		  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
		    Symbol.for &&
		    Symbol.for('react.element')) ||
		    0xeac7;
		
		  var isValidElement = function(object) {
		    return typeof object === 'object' &&
		      object !== null &&
		      object.$$typeof === REACT_ELEMENT_TYPE;
		  };
		
		  // By explicitly using `prop-types` you are opting into new development behavior.
		  // http://fb.me/prop-types-in-prod
		  var throwOnDirectAccess = true;
		  module.exports = __webpack_require__(14)(isValidElement, throwOnDirectAccess);
		} else {
		  // By explicitly using `prop-types` you are opting into new production behavior.
		  // http://fb.me/prop-types-in-prod
		  module.exports = __webpack_require__(13)();
		}
		
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		exports.default = function (obj) {
		  var rules = [];
		  Object.keys(_mediaQuery2.default.all).forEach(function (k) {
		    var v = obj[k];
		    if (v != null) {
		      rules.push(keyVal(k, v));
		    }
		  });
		  return join(rules);
		};
		
		var _hyphenateStyleName = __webpack_require__(7);
		
		var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
		
		var _mediaQuery = __webpack_require__(5);
		
		var _mediaQuery2 = _interopRequireDefault(_mediaQuery);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		var negate = function negate(cond) {
		  return 'not ' + cond;
		};
		
		function keyVal(k, v) {
		  var realKey = (0, _hyphenateStyleName2.default)(k);
		
		  // px shorthand
		  if (typeof v === 'number') {
		    v = v + 'px';
		  }
		  if (v === true) {
		    return k;
		  }
		  if (v === false) {
		    return negate(k);
		  }
		  return '(' + realKey + ': ' + v + ')';
		}
		
		function join(conds) {
		  return conds.join(' and ');
		}
		
		module.exports = exports['default'];
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {
	
		/*
		Copyright (c) 2014, Yahoo! Inc. All rights reserved.
		Copyrights licensed under the New BSD License.
		See the accompanying LICENSE file for terms.
		*/
		
		'use strict';
		
		exports.match = matchQuery;
		exports.parse = parseQuery;
		
		// -----------------------------------------------------------------------------
		
		var RE_MEDIA_QUERY     = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i,
		    RE_MQ_EXPRESSION   = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/,
		    RE_MQ_FEATURE      = /^(?:(min|max)-)?(.+)/,
		    RE_LENGTH_UNIT     = /(em|rem|px|cm|mm|in|pt|pc)?$/,
		    RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
		
		function matchQuery(mediaQuery, values) {
		    return parseQuery(mediaQuery).some(function (query) {
		        var inverse = query.inverse;
		
		        // Either the parsed or specified `type` is "all", or the types must be
		        // equal for a match.
		        var typeMatch = query.type === 'all' || values.type === query.type;
		
		        // Quit early when `type` doesn't match, but take "not" into account.
		        if ((typeMatch && inverse) || !(typeMatch || inverse)) {
		            return false;
		        }
		
		        var expressionsMatch = query.expressions.every(function (expression) {
		            var feature  = expression.feature,
		                modifier = expression.modifier,
		                expValue = expression.value,
		                value    = values[feature];
		
		            // Missing or falsy values don't match.
		            if (!value) { return false; }
		
		            switch (feature) {
		                case 'orientation':
		                case 'scan':
		                    return value.toLowerCase() === expValue.toLowerCase();
		
		                case 'width':
		                case 'height':
		                case 'device-width':
		                case 'device-height':
		                    expValue = toPx(expValue);
		                    value    = toPx(value);
		                    break;
		
		                case 'resolution':
		                    expValue = toDpi(expValue);
		                    value    = toDpi(value);
		                    break;
		
		                case 'aspect-ratio':
		                case 'device-aspect-ratio':
		                case /* Deprecated */ 'device-pixel-ratio':
		                    expValue = toDecimal(expValue);
		                    value    = toDecimal(value);
		                    break;
		
		                case 'grid':
		                case 'color':
		                case 'color-index':
		                case 'monochrome':
		                    expValue = parseInt(expValue, 10) || 1;
		                    value    = parseInt(value, 10) || 0;
		                    break;
		            }
		
		            switch (modifier) {
		                case 'min': return value >= expValue;
		                case 'max': return value <= expValue;
		                default   : return value === expValue;
		            }
		        });
		
		        return (expressionsMatch && !inverse) || (!expressionsMatch && inverse);
		    });
		}
		
		function parseQuery(mediaQuery) {
		    return mediaQuery.split(',').map(function (query) {
		        query = query.trim();
		
		        var captures    = query.match(RE_MEDIA_QUERY),
		            modifier    = captures[1],
		            type        = captures[2],
		            expressions = captures[3] || '',
		            parsed      = {};
		
		        parsed.inverse = !!modifier && modifier.toLowerCase() === 'not';
		        parsed.type    = type ? type.toLowerCase() : 'all';
		
		        // Split expressions into a list.
		        expressions = expressions.match(/\([^\)]+\)/g) || [];
		
		        parsed.expressions = expressions.map(function (expression) {
		            var captures = expression.match(RE_MQ_EXPRESSION),
		                feature  = captures[1].toLowerCase().match(RE_MQ_FEATURE);
		
		            return {
		                modifier: feature[1],
		                feature : feature[2],
		                value   : captures[2]
		            };
		        });
		
		        return parsed;
		    });
		}
		
		// -- Utilities ----------------------------------------------------------------
		
		function toDecimal(ratio) {
		    var decimal = Number(ratio),
		        numbers;
		
		    if (!decimal) {
		        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
		        decimal = numbers[1] / numbers[2];
		    }
		
		    return decimal;
		}
		
		function toDpi(resolution) {
		    var value = parseFloat(resolution),
		        units = String(resolution).match(RE_RESOLUTION_UNIT)[1];
		
		    switch (units) {
		        case 'dpcm': return value / 2.54;
		        case 'dppx': return value * 96;
		        default    : return value;
		    }
		}
		
		function toPx(length) {
		    var value = parseFloat(length),
		        units = String(length).match(RE_LENGTH_UNIT)[1];
		
		    switch (units) {
		        case 'em' : return value * 16;
		        case 'rem': return value * 16;
		        case 'cm' : return value * 96 / 2.54;
		        case 'mm' : return value * 96 / 2.54 / 10;
		        case 'in' : return value * 96;
		        case 'pt' : return value * 72;
		        case 'pc' : return value * 72 / 12;
		        default   : return value;
		    }
		}
	
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		var staticMatch = __webpack_require__(10).match;
		var dynamicMatch = typeof window !== 'undefined' ? window.matchMedia : null;
		
		// our fake MediaQueryList
		function Mql(query, values){
		  var self = this;
		  if(dynamicMatch){
		    var mql = dynamicMatch.call(window, query);
		    this.matches = mql.matches;
		    this.media = mql.media;
		    // TODO: is there a time it makes sense to remove this listener?
		    mql.addListener(update);
		  } else {
		    this.matches = staticMatch(query, values);
		    this.media = query;
		  }
		
		  this.addListener = addListener;
		  this.removeListener = removeListener;
		  this.dispose = dispose;
		
		  function addListener(listener){
		    if(mql){
		      mql.addListener(listener);
		    }
		  }
		
		  function removeListener(listener){
		    if(mql){
		      mql.removeListener(listener);
		    }
		  }
		
		  // update ourselves!
		  function update(evt){
		    self.matches = evt.matches;
		    self.media = evt.media;
		  }
		
		  function dispose(){
		    if(mql){
		      mql.removeListener(update);
		    }
		  }
		}
		
		function matchMedia(query, values){
		  return new Mql(query, values);
		}
		
		module.exports = matchMedia;
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
		
		'use strict';
		
		if (process.env.NODE_ENV !== 'production') {
		  var invariant = __webpack_require__(3);
		  var warning = __webpack_require__(6);
		  var ReactPropTypesSecret = __webpack_require__(4);
		  var loggedTypeFailures = {};
		}
		
		/**
		 * Assert that the values match with the type specs.
		 * Error messages are memorized and will only be shown once.
		 *
		 * @param {object} typeSpecs Map of name to a ReactPropType
		 * @param {object} values Runtime values that need to be type-checked
		 * @param {string} location e.g. "prop", "context", "child context"
		 * @param {string} componentName Name of the component for error messages.
		 * @param {?Function} getStack Returns the component stack.
		 * @private
		 */
		function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		  if (process.env.NODE_ENV !== 'production') {
		    for (var typeSpecName in typeSpecs) {
		      if (typeSpecs.hasOwnProperty(typeSpecName)) {
		        var error;
		        // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.
		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
		          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
		        } catch (ex) {
		          error = ex;
		        }
		        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
		        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error.message] = true;
		
		          var stack = getStack ? getStack() : '';
		
		          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
		        }
		      }
		    }
		  }
		}
		
		module.exports = checkPropTypes;
		
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
		
		'use strict';
		
		var emptyFunction = __webpack_require__(2);
		var invariant = __webpack_require__(3);
		var ReactPropTypesSecret = __webpack_require__(4);
		
		module.exports = function() {
		  function shim(props, propName, componentName, location, propFullName, secret) {
		    if (secret === ReactPropTypesSecret) {
		      // It is still safe when called from React.
		      return;
		    }
		    invariant(
		      false,
		      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		      'Use PropTypes.checkPropTypes() to call them. ' +
		      'Read more at http://fb.me/use-check-prop-types'
		    );
		  };
		  shim.isRequired = shim;
		  function getShim() {
		    return shim;
		  };
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
		  var ReactPropTypes = {
		    array: shim,
		    bool: shim,
		    func: shim,
		    number: shim,
		    object: shim,
		    string: shim,
		    symbol: shim,
		
		    any: shim,
		    arrayOf: getShim,
		    element: shim,
		    instanceOf: getShim,
		    node: shim,
		    objectOf: getShim,
		    oneOf: getShim,
		    oneOfType: getShim,
		    shape: getShim
		  };
		
		  ReactPropTypes.checkPropTypes = emptyFunction;
		  ReactPropTypes.PropTypes = ReactPropTypes;
		
		  return ReactPropTypes;
		};
	
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
		
		'use strict';
		
		var emptyFunction = __webpack_require__(2);
		var invariant = __webpack_require__(3);
		var warning = __webpack_require__(6);
		
		var ReactPropTypesSecret = __webpack_require__(4);
		var checkPropTypes = __webpack_require__(12);
		
		module.exports = function(isValidElement, throwOnDirectAccess) {
		  /* global Symbol */
		  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
		
		  /**
		   * Returns the iterator method function contained on the iterable object.
		   *
		   * Be sure to invoke the function with the iterable as context:
		   *
		   *     var iteratorFn = getIteratorFn(myIterable);
		   *     if (iteratorFn) {
		   *       var iterator = iteratorFn.call(myIterable);
		   *       ...
		   *     }
		   *
		   * @param {?object} maybeIterable
		   * @return {?function}
		   */
		  function getIteratorFn(maybeIterable) {
		    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
		
		  /**
		   * Collection of methods that allow declaration and validation of props that are
		   * supplied to React components. Example usage:
		   *
		   *   var Props = require('ReactPropTypes');
		   *   var MyArticle = React.createClass({
		   *     propTypes: {
		   *       // An optional string prop named "description".
		   *       description: Props.string,
		   *
		   *       // A required enum prop named "category".
		   *       category: Props.oneOf(['News','Photos']).isRequired,
		   *
		   *       // A prop named "dialog" that requires an instance of Dialog.
		   *       dialog: Props.instanceOf(Dialog).isRequired
		   *     },
		   *     render: function() { ... }
		   *   });
		   *
		   * A more formal specification of how these methods are used:
		   *
		   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		   *   decl := ReactPropTypes.{type}(.isRequired)?
		   *
		   * Each and every declaration produces a function with the same signature. This
		   * allows the creation of custom validation functions. For example:
		   *
		   *  var MyLink = React.createClass({
		   *    propTypes: {
		   *      // An optional string or URI prop named "href".
		   *      href: function(props, propName, componentName) {
		   *        var propValue = props[propName];
		   *        if (propValue != null && typeof propValue !== 'string' &&
		   *            !(propValue instanceof URI)) {
		   *          return new Error(
		   *            'Expected a string or an URI for ' + propName + ' in ' +
		   *            componentName
		   *          );
		   *        }
		   *      }
		   *    },
		   *    render: function() {...}
		   *  });
		   *
		   * @internal
		   */
		
		  var ANONYMOUS = '<<anonymous>>';
		
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
		  var ReactPropTypes = {
		    array: createPrimitiveTypeChecker('array'),
		    bool: createPrimitiveTypeChecker('boolean'),
		    func: createPrimitiveTypeChecker('function'),
		    number: createPrimitiveTypeChecker('number'),
		    object: createPrimitiveTypeChecker('object'),
		    string: createPrimitiveTypeChecker('string'),
		    symbol: createPrimitiveTypeChecker('symbol'),
		
		    any: createAnyTypeChecker(),
		    arrayOf: createArrayOfTypeChecker,
		    element: createElementTypeChecker(),
		    instanceOf: createInstanceTypeChecker,
		    node: createNodeChecker(),
		    objectOf: createObjectOfTypeChecker,
		    oneOf: createEnumTypeChecker,
		    oneOfType: createUnionTypeChecker,
		    shape: createShapeTypeChecker
		  };
		
		  /**
		   * inlined Object.is polyfill to avoid requiring consumers ship their own
		   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		   */
		  /*eslint-disable no-self-compare*/
		  function is(x, y) {
		    // SameValue algorithm
		    if (x === y) {
		      // Steps 1-5, 7-10
		      // Steps 6.b-6.e: +0 != -0
		      return x !== 0 || 1 / x === 1 / y;
		    } else {
		      // Step 6.a: NaN == NaN
		      return x !== x && y !== y;
		    }
		  }
		  /*eslint-enable no-self-compare*/
		
		  /**
		   * We use an Error-like object for backward compatibility as people may call
		   * PropTypes directly and inspect their output. However, we don't use real
		   * Errors anymore. We don't inspect their stack anyway, and creating them
		   * is prohibitively expensive if they are created too often, such as what
		   * happens in oneOfType() for any type before the one that matched.
		   */
		  function PropTypeError(message) {
		    this.message = message;
		    this.stack = '';
		  }
		  // Make `instanceof Error` still work for returned errors.
		  PropTypeError.prototype = Error.prototype;
		
		  function createChainableTypeChecker(validate) {
		    if (process.env.NODE_ENV !== 'production') {
		      var manualPropTypeCallCache = {};
		      var manualPropTypeWarningCount = 0;
		    }
		    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
		      componentName = componentName || ANONYMOUS;
		      propFullName = propFullName || propName;
		
		      if (secret !== ReactPropTypesSecret) {
		        if (throwOnDirectAccess) {
		          // New behavior only for users of `prop-types` package
		          invariant(
		            false,
		            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		            'Use `PropTypes.checkPropTypes()` to call them. ' +
		            'Read more at http://fb.me/use-check-prop-types'
		          );
		        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
		          // Old behavior for people using React.PropTypes
		          var cacheKey = componentName + ':' + propName;
		          if (
		            !manualPropTypeCallCache[cacheKey] &&
		            // Avoid spamming the console because they are often not actionable except for lib authors
		            manualPropTypeWarningCount < 3
		          ) {
		            warning(
		              false,
		              'You are manually calling a React.PropTypes validation ' +
		              'function for the `%s` prop on `%s`. This is deprecated ' +
		              'and will throw in the standalone `prop-types` package. ' +
		              'You may be seeing this warning due to a third-party PropTypes ' +
		              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
		              propFullName,
		              componentName
		            );
		            manualPropTypeCallCache[cacheKey] = true;
		            manualPropTypeWarningCount++;
		          }
		        }
		      }
		      if (props[propName] == null) {
		        if (isRequired) {
		          if (props[propName] === null) {
		            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
		          }
		          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
		        }
		        return null;
		      } else {
		        return validate(props, propName, componentName, location, propFullName);
		      }
		    }
		
		    var chainedCheckType = checkType.bind(null, false);
		    chainedCheckType.isRequired = checkType.bind(null, true);
		
		    return chainedCheckType;
		  }
		
		  function createPrimitiveTypeChecker(expectedType) {
		    function validate(props, propName, componentName, location, propFullName, secret) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== expectedType) {
		        // `propValue` being instance of, say, date/regexp, pass the 'object'
		        // check, but we can offer a more precise error message here rather than
		        // 'of type `object`'.
		        var preciseType = getPreciseType(propValue);
		
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createAnyTypeChecker() {
		    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
		  }
		
		  function createArrayOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
		      }
		      var propValue = props[propName];
		      if (!Array.isArray(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
		      }
		      for (var i = 0; i < propValue.length; i++) {
		        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
		        if (error instanceof Error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createElementTypeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      if (!isValidElement(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createInstanceTypeChecker(expectedClass) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!(props[propName] instanceof expectedClass)) {
		        var expectedClassName = expectedClass.name || ANONYMOUS;
		        var actualClassName = getClassName(props[propName]);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createEnumTypeChecker(expectedValues) {
		    if (!Array.isArray(expectedValues)) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
		
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      for (var i = 0; i < expectedValues.length; i++) {
		        if (is(propValue, expectedValues[i])) {
		          return null;
		        }
		      }
		
		      var valuesString = JSON.stringify(expectedValues);
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createObjectOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
		      }
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
		      }
		      for (var key in propValue) {
		        if (propValue.hasOwnProperty(key)) {
		          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		          if (error instanceof Error) {
		            return error;
		          }
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createUnionTypeChecker(arrayOfTypeCheckers) {
		    if (!Array.isArray(arrayOfTypeCheckers)) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
		
		    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		      var checker = arrayOfTypeCheckers[i];
		      if (typeof checker !== 'function') {
		        warning(
		          false,
		          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
		          'received %s at index %s.',
		          getPostfixForTypeWarning(checker),
		          i
		        );
		        return emptyFunction.thatReturnsNull;
		      }
		    }
		
		    function validate(props, propName, componentName, location, propFullName) {
		      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		        var checker = arrayOfTypeCheckers[i];
		        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
		          return null;
		        }
		      }
		
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createNodeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!isNode(props[propName])) {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      for (var key in shapeTypes) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          continue;
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function isNode(propValue) {
		    switch (typeof propValue) {
		      case 'number':
		      case 'string':
		      case 'undefined':
		        return true;
		      case 'boolean':
		        return !propValue;
		      case 'object':
		        if (Array.isArray(propValue)) {
		          return propValue.every(isNode);
		        }
		        if (propValue === null || isValidElement(propValue)) {
		          return true;
		        }
		
		        var iteratorFn = getIteratorFn(propValue);
		        if (iteratorFn) {
		          var iterator = iteratorFn.call(propValue);
		          var step;
		          if (iteratorFn !== propValue.entries) {
		            while (!(step = iterator.next()).done) {
		              if (!isNode(step.value)) {
		                return false;
		              }
		            }
		          } else {
		            // Iterator will provide entry [k,v] tuples rather than values.
		            while (!(step = iterator.next()).done) {
		              var entry = step.value;
		              if (entry) {
		                if (!isNode(entry[1])) {
		                  return false;
		                }
		              }
		            }
		          }
		        } else {
		          return false;
		        }
		
		        return true;
		      default:
		        return false;
		    }
		  }
		
		  function isSymbol(propType, propValue) {
		    // Native Symbol.
		    if (propType === 'symbol') {
		      return true;
		    }
		
		    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
		    if (propValue['@@toStringTag'] === 'Symbol') {
		      return true;
		    }
		
		    // Fallback for non-spec compliant Symbols which are polyfilled.
		    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
		      return true;
		    }
		
		    return false;
		  }
		
		  // Equivalent of `typeof` but with special handling for array and regexp.
		  function getPropType(propValue) {
		    var propType = typeof propValue;
		    if (Array.isArray(propValue)) {
		      return 'array';
		    }
		    if (propValue instanceof RegExp) {
		      // Old webkits (at least until Android 4.0) return 'function' rather than
		      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
		      // passes PropTypes.object.
		      return 'object';
		    }
		    if (isSymbol(propType, propValue)) {
		      return 'symbol';
		    }
		    return propType;
		  }
		
		  // This handles more types than `getPropType`. Only used for error messages.
		  // See `createPrimitiveTypeChecker`.
		  function getPreciseType(propValue) {
		    if (typeof propValue === 'undefined' || propValue === null) {
		      return '' + propValue;
		    }
		    var propType = getPropType(propValue);
		    if (propType === 'object') {
		      if (propValue instanceof Date) {
		        return 'date';
		      } else if (propValue instanceof RegExp) {
		        return 'regexp';
		      }
		    }
		    return propType;
		  }
		
		  // Returns a string that is postfixed to a warning about an invalid type.
		  // For example, "undefined" or "of type array"
		  function getPostfixForTypeWarning(value) {
		    var type = getPreciseType(value);
		    switch (type) {
		      case 'array':
		      case 'object':
		        return 'an ' + type;
		      case 'boolean':
		      case 'date':
		      case 'regexp':
		        return 'a ' + type;
		      default:
		        return type;
		    }
		  }
		
		  // Returns class name of the object, if any.
		  function getClassName(propValue) {
		    if (!propValue.constructor || !propValue.constructor.name) {
		      return ANONYMOUS;
		    }
		    return propValue.constructor.name;
		  }
		
		  ReactPropTypes.checkPropTypes = checkPropTypes;
		  ReactPropTypes.PropTypes = ReactPropTypes;
		
		  return ReactPropTypes;
		};
		
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_15__;
	
	/***/ })
	/******/ ])
	});
	;
	//# sourceMappingURL=react-responsive.js.map

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scrollBehavior = __webpack_require__(1761);
	
	var _scrollBehavior2 = _interopRequireDefault(_scrollBehavior);
	
	var _StateStorage = __webpack_require__(1707);
	
	var _StateStorage2 = _interopRequireDefault(_StateStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  shouldUpdateScroll: _react2.default.PropTypes.func,
	  routerProps: _react2.default.PropTypes.object.isRequired,
	  children: _react2.default.PropTypes.element.isRequired
	};
	
	var childContextTypes = {
	  scrollBehavior: _react2.default.PropTypes.object.isRequired
	};
	
	var ScrollBehaviorContext = function (_React$Component) {
	  _inherits(ScrollBehaviorContext, _React$Component);
	
	  function ScrollBehaviorContext(props, context) {
	    _classCallCheck(this, ScrollBehaviorContext);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var routerProps = props.routerProps;
	    var router = routerProps.router;
	
	
	    _this.scrollBehavior = new _scrollBehavior2.default({
	      addTransitionHook: router.listenBefore,
	      stateStorage: new _StateStorage2.default(router),
	      getCurrentLocation: function getCurrentLocation() {
	        return _this.props.routerProps.location;
	      },
	      shouldUpdateScroll: _this.shouldUpdateScroll
	    });
	
	    _this.scrollBehavior.updateScroll(null, routerProps);
	    return _this;
	  }
	
	  ScrollBehaviorContext.prototype.getChildContext = function getChildContext() {
	    return {
	      scrollBehavior: this
	    };
	  };
	
	  ScrollBehaviorContext.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var routerProps = this.props.routerProps;
	
	    var prevRouterProps = prevProps.routerProps;
	
	    if (routerProps.location === prevRouterProps.location) {
	      return;
	    }
	
	    this.scrollBehavior.updateScroll(prevRouterProps, routerProps);
	  };
	
	  ScrollBehaviorContext.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.scrollBehavior.stop();
	  };
	
	  ScrollBehaviorContext.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return ScrollBehaviorContext;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	    var shouldUpdateScroll = _this2.props.shouldUpdateScroll;
	
	    if (!shouldUpdateScroll) {
	      return true;
	    }
	
	    // Hack to allow accessing scrollBehavior._stateStorage.
	    return shouldUpdateScroll.call(_this2.scrollBehavior, prevRouterProps, routerProps);
	  };
	
	  this.registerElement = function (key, element, shouldUpdateScroll) {
	    _this2.scrollBehavior.registerElement(key, element, shouldUpdateScroll, _this2.props.routerProps);
	  };
	
	  this.unregisterElement = function (key) {
	    _this2.scrollBehavior.unregisterElement(key);
	  };
	};
	
	ScrollBehaviorContext.propTypes = propTypes;
	ScrollBehaviorContext.childContextTypes = childContextTypes;
	
	exports.default = ScrollBehaviorContext;
	module.exports = exports['default'];

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(149);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  scrollKey: _react2.default.PropTypes.string.isRequired,
	  shouldUpdateScroll: _react2.default.PropTypes.func,
	  children: _react2.default.PropTypes.element.isRequired
	};
	
	var contextTypes = {
	  // This is necessary when rendering on the client. However, when rendering on
	  // the server, this container will do nothing, and thus does not require the
	  // scroll behavior context.
	  scrollBehavior: _react2.default.PropTypes.object
	};
	
	var ScrollContainer = function (_React$Component) {
	  _inherits(ScrollContainer, _React$Component);
	
	  function ScrollContainer(props, context) {
	    _classCallCheck(this, ScrollContainer);
	
	    // We don't re-register if the scroll key changes, so make sure we
	    // unregister with the initial scroll key just in case the user changes it.
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	      var shouldUpdateScroll = _this.props.shouldUpdateScroll;
	
	      if (!shouldUpdateScroll) {
	        return true;
	      }
	
	      // Hack to allow accessing scrollBehavior._stateStorage.
	      return shouldUpdateScroll.call(_this.context.scrollBehavior.scrollBehavior, prevRouterProps, routerProps);
	    };
	
	    _this.scrollKey = props.scrollKey;
	    return _this;
	  }
	
	  ScrollContainer.prototype.componentDidMount = function componentDidMount() {
	    this.context.scrollBehavior.registerElement(this.props.scrollKey, _reactDom2.default.findDOMNode(this), // eslint-disable-line react/no-find-dom-node
	    this.shouldUpdateScroll);
	
	    // Only keep around the current DOM node in development, as this is only
	    // for emitting the appropriate warning.
	    if (false) {
	      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
	    }
	  };
	
	  ScrollContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	     false ? (0, _warning2.default)(nextProps.scrollKey === this.props.scrollKey, '<ScrollContainer> does not support changing scrollKey.') : void 0;
	  };
	
	  ScrollContainer.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (false) {
	      var prevDomNode = this.domNode;
	      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
	
	      process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(this.domNode === prevDomNode, '<ScrollContainer> does not support changing DOM node.') : void 0;
	    }
	  };
	
	  ScrollContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.context.scrollBehavior.unregisterElement(this.scrollKey);
	  };
	
	  ScrollContainer.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return ScrollContainer;
	}(_react2.default.Component);
	
	ScrollContainer.propTypes = propTypes;
	ScrollContainer.contextTypes = contextTypes;
	
	exports.default = ScrollContainer;
	module.exports = exports['default'];

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DOMStateStorage = __webpack_require__(311);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var STATE_KEY_PREFIX = '@@scroll|';
	
	var StateStorage = function () {
	  function StateStorage(router) {
	    _classCallCheck(this, StateStorage);
	
	    this.getFallbackLocationKey = router.createPath;
	  }
	
	  StateStorage.prototype.read = function read(location, key) {
	    return (0, _DOMStateStorage.readState)(this.getStateKey(location, key));
	  };
	
	  StateStorage.prototype.save = function save(location, key, value) {
	    (0, _DOMStateStorage.saveState)(this.getStateKey(location, key), value);
	  };
	
	  StateStorage.prototype.getStateKey = function getStateKey(location, key) {
	    var locationKey = location.key || this.getFallbackLocationKey(location);
	    var stateKeyBase = '' + STATE_KEY_PREFIX + locationKey;
	    return key == null ? stateKeyBase : stateKeyBase + '|' + key;
	  };
	
	  return StateStorage;
	}();
	
	exports.default = StateStorage;
	module.exports = exports['default'];

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.useScroll = exports.ScrollContainer = undefined;
	
	var _ScrollContainer2 = __webpack_require__(1706);
	
	var _ScrollContainer3 = _interopRequireDefault(_ScrollContainer2);
	
	var _useScroll2 = __webpack_require__(1709);
	
	var _useScroll3 = _interopRequireDefault(_useScroll2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ScrollContainer = _ScrollContainer3.default;
	exports.useScroll = _useScroll3.default;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useScroll;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollBehaviorContext = __webpack_require__(1705);
	
	var _ScrollBehaviorContext2 = _interopRequireDefault(_ScrollBehaviorContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useScroll(shouldUpdateScroll) {
	  return {
	    renderRouterContext: function renderRouterContext(child, props) {
	      return _react2.default.createElement(
	        _ScrollBehaviorContext2.default,
	        {
	          shouldUpdateScroll: shouldUpdateScroll,
	          routerProps: props
	        },
	        child
	      );
	    }
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(791);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(154);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(793);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(154);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(109);
	
	var _InternalPropTypes = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(109);
	
	var _InternalPropTypes = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager2 = __webpack_require__(797);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(190);
	
	var _RouterContext = __webpack_require__(385);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(109);
	
	var _RouterUtils = __webpack_require__(794);
	
	var _routerWarning = __webpack_require__(154);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    func = _React$PropTypes.func,
	    object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v2.x or ' + 'earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please upgrade to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(382);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	var enterHooks = new PendingHooks();
	var changeHooks = new PendingHooks();
	
	function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	  var isSync = hook.length < asyncArity;
	
	  var transitionHook = function transitionHook() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (isSync) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	
	  pendingHooks.add(transitionHook);
	
	  return transitionHook;
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location) {
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  enterHooks.clear();
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    var wrappedNext = function wrappedNext() {
	      if (enterHooks.has(hooks[index])) {
	        next.apply(undefined, arguments);
	        enterHooks.remove(hooks[index]);
	      }
	    };
	    hooks[index](nextState, replace, wrappedNext);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  changeHooks.clear();
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    var wrappedNext = function wrappedNext() {
	      if (changeHooks.has(hooks[index])) {
	        next.apply(undefined, arguments);
	        changeHooks.remove(hooks[index]);
	      }
	    };
	    hooks[index](state, nextState, replace, wrappedNext);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(385);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(154);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(497);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(796);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(153);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(382);
	
	var _PromiseUtils = __webpack_require__(792);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(153);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(498);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(796);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(153);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(165);
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(795);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(797);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(109);
	
	var _RouterUtils = __webpack_require__(794);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(382);
	
	var _PromiseUtils = __webpack_require__(792);
	
	var _PatternUtils = __webpack_require__(153);
	
	var _routerWarning = __webpack_require__(154);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(307);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(1769);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1728);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1726)();
	}


/***/ }),
/* 1728 */
1528,
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var scriptLoading = false;
	var scriptLoaded = false;
	var scriptDidError = false;
	
	var ReactStripeCheckout = function (_React$Component) {
	  _inherits(ReactStripeCheckout, _React$Component);
	
	  function ReactStripeCheckout(props) {
	    _classCallCheck(this, ReactStripeCheckout);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReactStripeCheckout).call(this, props));
	
	    _this.onScriptLoaded = function () {
	      if (!ReactStripeCheckout.stripeHandler) {
	        ReactStripeCheckout.stripeHandler = StripeCheckout.configure({
	          key: _this.props.stripeKey
	        });
	        if (_this.hasPendingClick) {
	          _this.showStripeDialog();
	        }
	      }
	    };
	
	    _this.onScriptError = function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this.hideLoadingDialog();
	      if (_this.props.onScriptError) {
	        _this.props.onScriptError.apply(_this, args);
	      }
	    };
	
	    _this.onClosed = function () {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      _this.setState({ open: false });
	      if (_this.props.closed) {
	        _this.props.closed.apply(_this, args);
	      }
	    };
	
	    _this.onOpened = function () {
	      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      _this.setState({ open: true });
	      if (_this.props.opened) {
	        _this.props.opened.apply(_this, args);
	      }
	    };
	
	    _this.getConfig = function () {
	      return ['token', 'image', 'name', 'description', 'amount', 'locale', 'currency', 'panelLabel', 'zipCode', 'shippingAddress', 'billingAddress', 'email', 'allowRememberMe', 'bitcoin', 'alipay', 'alipayReusable'].reduce(function (config, key) {
	        return _extends({}, config, _this.props.hasOwnProperty(key) && _defineProperty({}, key, _this.props[key]));
	      }, {
	        opened: _this.onOpened,
	        closed: _this.onClosed
	      });
	    };
	
	    _this.onClick = function () {
	      // eslint-disable-line react/sort-comp
	      if (_this.props.disabled) {
	        return;
	      }
	
	      if (scriptDidError) {
	        try {
	          throw new Error('Tried to call onClick, but StripeCheckout failed to load');
	        } catch (x) {} // eslint-disable-line no-empty
	      } else if (ReactStripeCheckout.stripeHandler) {
	        _this.showStripeDialog();
	      } else {
	        _this.showLoadingDialog();
	        _this.hasPendingClick = true;
	      }
	    };
	
	    _this.handleOnMouseDown = function () {
	      _this.setState({
	        buttonActive: true
	      });
	    };
	
	    _this.handleOnMouseUp = function () {
	      _this.setState({
	        buttonActive: false
	      });
	    };
	
	    _this.state = {
	      open: false,
	      buttonActive: false
	    };
	    return _this;
	  }
	
	  _createClass(ReactStripeCheckout, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (scriptLoaded) {
	        return;
	      }
	
	      if (scriptLoading) {
	        return;
	      }
	
	      scriptLoading = true;
	
	      var script = document.createElement('script');
	      if (typeof this.props.onScriptTagCreated === 'function') {
	        this.props.onScriptTagCreated(script);
	      }
	
	      script.src = 'https://checkout.stripe.com/checkout.js';
	      script.async = 1;
	
	      this.loadPromise = function () {
	        var canceled = false;
	        var promise = new Promise(function (resolve, reject) {
	          script.onload = function () {
	            scriptLoaded = true;
	            scriptLoading = false;
	            resolve();
	            _this2.onScriptLoaded();
	          };
	          script.onerror = function (event) {
	            scriptDidError = true;
	            scriptLoading = false;
	            reject(event);
	            _this2.onScriptError(event);
	          };
	        });
	        var wrappedPromise = new Promise(function (accept, cancel) {
	          promise.then(function () {
	            return canceled ? cancel({ isCanceled: true }) : accept();
	          }); // eslint-disable-line no-confusing-arrow
	          promise.catch(function (error) {
	            return canceled ? cancel({ isCanceled: true }) : cancel(error);
	          }); // eslint-disable-line no-confusing-arrow
	        });
	
	        return {
	          promise: wrappedPromise,
	          cancel: function cancel() {
	            canceled = true;
	          }
	        };
	      }();
	
	      this.loadPromise.promise.then(this.onScriptLoaded).catch(this.onScriptError);
	
	      document.body.appendChild(script);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!scriptLoading) {
	        this.updateStripeHandler();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.loadPromise) {
	        this.loadPromise.cancel();
	      }
	      if (ReactStripeCheckout.stripeHandler && this.state.open) {
	        ReactStripeCheckout.stripeHandler.close();
	      }
	    }
	  }, {
	    key: 'updateStripeHandler',
	    value: function updateStripeHandler() {
	      if (!ReactStripeCheckout.stripeHandler || this.props.reconfigureOnUpdate) {
	        ReactStripeCheckout.stripeHandler = StripeCheckout.configure({
	          key: this.props.stripeKey
	        });
	      }
	    }
	  }, {
	    key: 'showLoadingDialog',
	    value: function showLoadingDialog() {
	      if (this.props.showLoadingDialog) {
	        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	          args[_key4] = arguments[_key4];
	        }
	
	        this.props.showLoadingDialog.apply(this, args);
	      }
	    }
	  }, {
	    key: 'hideLoadingDialog',
	    value: function hideLoadingDialog() {
	      if (this.props.hideLoadingDialog) {
	        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	          args[_key5] = arguments[_key5];
	        }
	
	        this.props.hideLoadingDialog.apply(this, args);
	      }
	    }
	  }, {
	    key: 'showStripeDialog',
	    value: function showStripeDialog() {
	      this.hideLoadingDialog();
	      ReactStripeCheckout.stripeHandler.open(this.getConfig());
	    }
	  }, {
	    key: 'renderDefaultStripeButton',
	    value: function renderDefaultStripeButton() {
	      return _react2.default.createElement(
	        'button',
	        _extends({}, _defineProperty({}, this.props.triggerEvent, this.onClick), {
	          className: this.props.className,
	          onMouseDown: this.handleOnMouseDown,
	          onFocus: this.handleOnMouseDown,
	          onMouseUp: this.handleOnMouseUp,
	          onMouseOut: this.handleOnMouseUp,
	          onBlur: this.handleOnMouseUp,
	          style: _extends({}, {
	            overflow: 'hidden',
	            display: 'inline-block',
	            background: 'linear-gradient(#28a0e5,#015e94)',
	            border: 0,
	            padding: 1,
	            textDecoration: 'none',
	            borderRadius: 5,
	            boxShadow: '0 1px 0 rgba(0,0,0,0.2)',
	            cursor: 'pointer',
	            visibility: 'visible',
	            userSelect: 'none'
	          }, this.state.buttonActive && {
	            background: '#005d93'
	          }, this.props.style)
	        }),
	        _react2.default.createElement(
	          'span',
	          {
	            style: _extends({}, {
	              backgroundImage: 'linear-gradient(#7dc5ee,#008cdd 85%,#30a2e4)',
	              fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
	              fontSize: 14,
	              position: 'relative',
	              padding: '0 12px',
	              display: 'block',
	              height: 30,
	              lineHeight: '30px',
	              color: '#fff',
	              fontWeight: 'bold',
	              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.25)',
	              textShadow: '0 -1px 0 rgba(0,0,0,0.25)',
	              borderRadius: 4
	            }, this.state.buttonActive && {
	              color: '#eee',
	              boxShadow: 'inset 0 1px 0 rgba(0,0,0,0.1)',
	              backgroundImage: 'linear-gradient(#008cdd,#008cdd 85%,#239adf)'
	            }, this.props.textStyle)
	          },
	          this.props.label
	        )
	      );
	    }
	  }, {
	    key: 'renderDisabledButton',
	    value: function renderDisabledButton() {
	      return _react2.default.createElement(
	        'button',
	        {
	          disabled: true,
	          style: {
	            background: 'rgba(0,0,0,0.2)',
	            overflow: 'hidden',
	            display: 'inline-block',
	            border: 0,
	            padding: 1,
	            textDecoration: 'none',
	            borderRadius: 5,
	            userSelect: 'none'
	          }
	        },
	        _react2.default.createElement(
	          'span',
	          {
	            style: {
	              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.25)',
	              fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
	              fontSize: 14,
	              position: 'relative',
	              padding: '0 12px',
	              display: 'block',
	              height: 30,
	              lineHeight: '30px',
	              borderRadius: 4,
	              color: '#999',
	              background: '#f8f9fa',
	              textShadow: '0 1px 0 rgba(255,255,255,0.5)'
	            }
	          },
	          this.props.label
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.desktopShowModal === true && !this.state.open) {
	        this.onClick();
	      } else if (this.props.desktopShowModal === false && this.state.open) {
	        ReactStripeCheckout.stripeHandler.close();
	      }
	
	      var ComponentClass = this.props.ComponentClass;
	
	      if (this.props.children) {
	        return _react2.default.createElement(ComponentClass, _extends({}, _defineProperty({}, this.props.triggerEvent, this.onClick), {
	          children: this.props.children
	        }));
	      }
	      return this.props.disabled ? this.renderDisabledButton() : this.renderDefaultStripeButton();
	    }
	  }]);
	
	  return ReactStripeCheckout;
	}(_react2.default.Component);
	
	ReactStripeCheckout.defaultProps = {
	  className: 'StripeCheckout',
	  label: 'Pay With Card',
	  locale: 'auto',
	  ComponentClass: 'span',
	  reconfigureOnUpdate: false,
	  triggerEvent: 'onClick'
	};
	ReactStripeCheckout.propTypes = {
	  // Opens / closes the checkout modal by value
	  // WARNING: does not work on mobile due to browser security restrictions
	  // NOTE: Must be set to false when receiving token to prevent modal from
	  //       opening automatically after closing
	  desktopShowModal: _react2.default.PropTypes.bool,
	
	  triggerEvent: _react2.default.PropTypes.oneOf(['onClick', 'onTouchTap', 'onTouchStart']),
	
	  // If included, will render the default blue button with label text.
	  // (Requires including stripe-checkout.css or adding the .styl file
	  // to your pipeline)
	  label: _react2.default.PropTypes.string,
	
	  // Custom styling for default button
	  style: _react2.default.PropTypes.object,
	  // Custom styling for <span> tag inside default button
	  textStyle: _react2.default.PropTypes.object,
	
	  // Prevents any events from opening the popup
	  // Adds the disabled prop to the button and adjusts the styling as well
	  disabled: _react2.default.PropTypes.bool,
	
	  // Named component to wrap button (eg. div)
	  ComponentClass: _react2.default.PropTypes.string,
	
	  // Show a loading indicator
	  showLoadingDialog: _react2.default.PropTypes.func,
	  // Hide the loading indicator
	  hideLoadingDialog: _react2.default.PropTypes.func,
	
	  // Run this method when the scrupt fails to load. Will run if the internet
	  // connection is offline when attemting to load the script.
	  onScriptError: _react2.default.PropTypes.func,
	
	  // Runs when the script tag is created, but before it is added to the DOM
	  onScriptTagCreated: _react2.default.PropTypes.func,
	
	  // By default, any time the React component is updated, it will call
	  // StripeCheckout.configure, which may result in additional XHR calls to the
	  // stripe API.  If you know the first configuration is all you need, you
	  // can set this to false.  Subsequent updates will affect the StripeCheckout.open
	  // (e.g. different prices)
	  reconfigureOnUpdate: _react2.default.PropTypes.bool,
	
	  // =====================================================
	  // Required by stripe
	  // see Stripe docs for more info:
	  //   https://stripe.com/docs/checkout#integration-custom
	  // =====================================================
	
	  // Your publishable key (test or live).
	  // can't use "key" as a prop in react, so have to change the keyname
	  stripeKey: _react2.default.PropTypes.string.isRequired,
	
	  // The callback to invoke when the Checkout process is complete.
	  //   function(token)
	  //     token is the token object created.
	  //     token.id can be used to create a charge or customer.
	  //     token.email contains the email address entered by the user.
	  token: _react2.default.PropTypes.func.isRequired,
	
	  // ==========================
	  // Highly Recommended Options
	  // ==========================
	
	  // Name of the company or website.
	  name: _react2.default.PropTypes.string,
	
	  // A description of the product or service being purchased.
	  description: _react2.default.PropTypes.string,
	
	  // A relative URL pointing to a square image of your brand or product. The
	  // recommended minimum size is 128x128px. The recommended image types are
	  // .gif, .jpeg, and .png.
	  image: _react2.default.PropTypes.string,
	
	  // The amount (in cents) that's shown to the user. Note that you will still
	  // have to explicitly include it when you create a charge using the API.
	  amount: _react2.default.PropTypes.number,
	
	  // Specify auto to display Checkout in the user's preferred language, if
	  // available. English will be used by default.
	  //
	  // https://support.stripe.com/questions/what-languages-does-stripe-checkout-support
	  // for more info.
	  locale: _react2.default.PropTypes.oneOf(['auto', // (Default) Automatically chosen by checkout
	  'zh', // Chinese
	  'nl', // Dutch
	  'en', // English
	  'fr', // French
	  'de', // German
	  'it', // Italian
	  'jp', // Japanease
	  'es']),
	
	  // ==============
	  // Optional Props
	  // ==============
	
	  // The currency of the amount (3-letter ISO code). The default is USD.
	  currency: _react2.default.PropTypes.oneOf(['AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN', 'BAM', 'BBD', // eslint-disable-line comma-spacing
	  'BDT', 'BGN', 'BIF', 'BMD', 'BND', 'BOB', 'BRL', 'BSD', 'BWP', 'BZD', 'CAD', 'CDF', // eslint-disable-line comma-spacing
	  'CHF', 'CLP', 'CNY', 'COP', 'CRC', 'CVE', 'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EEK', // eslint-disable-line comma-spacing
	  'EGP', 'ETB', 'EUR', 'FJD', 'FKP', 'GBP', 'GEL', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', // eslint-disable-line comma-spacing
	  'HKD', 'HNL', 'HRK', 'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'ISK', 'JMD', 'JPY', 'KES', // eslint-disable-line comma-spacing
	  'KGS', 'KHR', 'KMF', 'KRW', 'KYD', 'KZT', 'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LTL', // eslint-disable-line comma-spacing
	  'LVL', 'MAD', 'MDL', 'MGA', 'MKD', 'MNT', 'MOP', 'MRO', 'MUR', 'MVR', 'MWK', 'MXN', // eslint-disable-line comma-spacing
	  'MYR', 'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'PAB', 'PEN', 'PGK', 'PHP', // eslint-disable-line comma-spacing
	  'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF', 'SAR', 'SBD', 'SCR', 'SEK', // eslint-disable-line comma-spacing
	  'SGD', 'SHP', 'SLL', 'SOS', 'SRD', 'STD', 'SVC', 'SZL', 'THB', 'TJS', 'TOP', 'TRY', // eslint-disable-line comma-spacing
	  'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'USD', 'UYU', 'UZS', 'VND', 'VUV', 'WST', 'XAF', // eslint-disable-line comma-spacing
	  'XCD', 'XOF', 'XPF', 'YER', 'ZAR', 'ZMW']),
	
	  // The label of the payment button in the Checkout form (e.g. “Subscribe”,
	  // “Pay {{amount}}”, etc.). If you include {{amount}}, it will be replaced
	  // by the provided amount. Otherwise, the amount will be appended to the
	  // end of your label.
	  panelLabel: _react2.default.PropTypes.string,
	
	  // Specify whether Checkout should validate the billing ZIP code (true or
	  // false)
	  zipCode: _react2.default.PropTypes.bool,
	
	  // Specify whether Checkout should collect the user's billing address
	  // (true or false). The default is false.
	  billingAddress: _react2.default.PropTypes.bool,
	
	  // Specify whether Checkout should collect the user's shipping address
	  // (true or false). The default is false.
	  shippingAddress: _react2.default.PropTypes.bool,
	
	  // Specify whether Checkout should validate the billing ZIP code (true or
	  // false). The default is false.
	  email: _react2.default.PropTypes.string,
	
	  // Specify whether to include the option to "Remember Me" for future
	  // purchases (true or false). The default is true.
	  allowRememberMe: _react2.default.PropTypes.bool,
	
	  // Specify whether to accept Bitcoin in Checkout. The default is false.
	  bitcoin: _react2.default.PropTypes.bool,
	
	  // Specify whether to accept Alipay ('auto', true, or false). The default
	  // is false.
	  alipay: _react2.default.PropTypes.oneOf(['auto', true, false]),
	
	  // Specify if you need reusable access to the customer's Alipay account
	  // (true or false). The default is false.
	  alipayReusable: _react2.default.PropTypes.bool,
	
	  // function() The callback to invoke when Checkout is opened (not supported
	  // in IE6 and IE7).
	  opened: _react2.default.PropTypes.func,
	
	  // function() The callback to invoke when Checkout is closed (not supported
	  // in IE6 and IE7).
	  closed: _react2.default.PropTypes.func
	};
	exports.default = ReactStripeCheckout;


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,n){ true?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports.tweenState=n():e.tweenState=n()}(this,function(){return function(e){function n(r){if(t[r])return t[r].exports;var a=t[r]={exports:{},id:r,loaded:!1};return e[r].call(a.exports,a,a.exports,n),a.loaded=!0,a.exports}var t={};return n.m=e,n.c=t,n.p="",n(0)}({0:function(e,n,t){e.exports=t(90)},1:function(e,n){function t(){c=!1,o.length?s=o.concat(s):f=-1,s.length&&r()}function r(){if(!c){var e=setTimeout(t);c=!0;for(var n=s.length;n;){for(o=s,s=[];++f<n;)o&&o[f].run();f=-1,n=s.length}o=null,c=!1,clearTimeout(e)}}function a(e,n){this.fun=e,this.array=n}function u(){}var o,i=e.exports={},s=[],c=!1,f=-1;i.nextTick=function(e){var n=new Array(arguments.length-1);if(arguments.length>1)for(var t=1;t<arguments.length;t++)n[t-1]=arguments[t];s.push(new a(e,n)),1!==s.length||c||setTimeout(r,0)},a.prototype.run=function(){this.fun.apply(null,this.array)},i.title="browser",i.browser=!0,i.env={},i.argv=[],i.version="",i.versions={},i.on=u,i.addListener=u,i.once=u,i.off=u,i.removeListener=u,i.removeAllListeners=u,i.emit=u,i.binding=function(e){throw new Error("process.binding is not supported")},i.cwd=function(){return"/"},i.chdir=function(e){throw new Error("process.chdir is not supported")},i.umask=function(){return 0}},90:function(e,n,t){"use strict";function r(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(n,"__esModule",{value:!0});var a=t(165),u=r(a),o=t(91),i=r(o),s="ADDITIVE",c=a.easeInOutQuad,f=300,l=0,h={ADDITIVE:"ADDITIVE",DESTRUCTIVE:"DESTRUCTIVE"},v={_rafID:null,getInitialState:function(){return{tweenQueue:[]}},componentWillUnmount:function(){i["default"].cancel(this._rafID),this._rafID=-1},tweenState:function(e,n){var t=this,r=n.easing,a=n.duration,u=n.delay,o=n.beginValue,v=n.endValue,d=n.onEnd,p=n.stackBehavior;this.setState(function(n){var I=n,w=void 0,g=void 0;if("string"==typeof e)w=e,g=e;else{for(var M=0;M<e.length-1;M++)I=I[e[M]];w=e[e.length-1],g=e.join("|")}var m={easing:r||c,duration:null==a?f:a,delay:null==u?l:u,beginValue:null==o?I[w]:o,endValue:v,onEnd:d,stackBehavior:p||s},x=n.tweenQueue;return m.stackBehavior===h.DESTRUCTIVE&&(x=n.tweenQueue.filter(function(e){return e.pathHash!==g})),x.push({pathHash:g,config:m,initTime:Date.now()+m.delay}),I[w]=m.endValue,1===x.length&&(t._rafID=(0,i["default"])(t._rafCb)),{tweenQueue:x}})},getTweeningValue:function(e){var n=this.state,t=void 0,r=void 0;if("string"==typeof e)t=n[e],r=e;else{t=n;for(var a=0;a<e.length;a++)t=t[e[a]];r=e.join("|")}for(var u=Date.now(),a=0;a<n.tweenQueue.length;a++){var o=n.tweenQueue[a],i=o.pathHash,s=o.initTime,c=o.config;if(i===r){var f=u-s>c.duration?c.duration:Math.max(0,u-s),l=0===c.duration?c.endValue:c.easing(f,c.beginValue,c.endValue,c.duration),h=l-c.endValue;t+=h}}return t},_rafCb:function(){var e=this.state;if(0!==e.tweenQueue.length){for(var n=Date.now(),t=[],r=0;r<e.tweenQueue.length;r++){var a=e.tweenQueue[r],u=a.initTime,o=a.config;n-u<o.duration?t.push(a):o.onEnd&&o.onEnd()}-1!==this._rafID&&(this.setState({tweenQueue:t}),this._rafID=(0,i["default"])(this._rafCb))}}};n["default"]={Mixin:v,easingTypes:u["default"],stackBehavior:h},e.exports=n["default"]},91:function(e,n,t){for(var r=t(92),a="undefined"==typeof window?{}:window,u=["moz","webkit"],o="AnimationFrame",i=a["request"+o],s=a["cancel"+o]||a["cancelRequest"+o],c=0;c<u.length&&!i;c++)i=a[u[c]+"Request"+o],s=a[u[c]+"Cancel"+o]||a[u[c]+"CancelRequest"+o];if(!i||!s){var f=0,l=0,h=[],v=1e3/60;i=function(e){if(0===h.length){var n=r(),t=Math.max(0,v-(n-f));f=t+n,setTimeout(function(){var e=h.slice(0);h.length=0;for(var n=0;n<e.length;n++)if(!e[n].cancelled)try{e[n].callback(f)}catch(t){setTimeout(function(){throw t},0)}},Math.round(t))}return h.push({handle:++l,callback:e,cancelled:!1}),l},s=function(e){for(var n=0;n<h.length;n++)h[n].handle===e&&(h[n].cancelled=!0)}}e.exports=function(e){return i.call(a,e)},e.exports.cancel=function(){s.apply(a,arguments)}},92:function(e,n,t){(function(n){(function(){var t,r,a;"undefined"!=typeof performance&&null!==performance&&performance.now?e.exports=function(){return performance.now()}:"undefined"!=typeof n&&null!==n&&n.hrtime?(e.exports=function(){return(t()-a)/1e6},r=n.hrtime,t=function(){var e;return e=r(),1e9*e[0]+e[1]},a=t()):Date.now?(e.exports=function(){return Date.now()-a},a=Date.now()):(e.exports=function(){return(new Date).getTime()-a},a=(new Date).getTime())}).call(this)}).call(n,t(1))},165:function(e,n){"use strict";var t={linear:function(e,n,t,r){var a=t-n;return a*e/r+n},easeInQuad:function(e,n,t,r){var a=t-n;return a*(e/=r)*e+n},easeOutQuad:function(e,n,t,r){var a=t-n;return-a*(e/=r)*(e-2)+n},easeInOutQuad:function(e,n,t,r){var a=t-n;return(e/=r/2)<1?a/2*e*e+n:-a/2*(--e*(e-2)-1)+n},easeInCubic:function(e,n,t,r){var a=t-n;return a*(e/=r)*e*e+n},easeOutCubic:function(e,n,t,r){var a=t-n;return a*((e=e/r-1)*e*e+1)+n},easeInOutCubic:function(e,n,t,r){var a=t-n;return(e/=r/2)<1?a/2*e*e*e+n:a/2*((e-=2)*e*e+2)+n},easeInQuart:function(e,n,t,r){var a=t-n;return a*(e/=r)*e*e*e+n},easeOutQuart:function(e,n,t,r){var a=t-n;return-a*((e=e/r-1)*e*e*e-1)+n},easeInOutQuart:function(e,n,t,r){var a=t-n;return(e/=r/2)<1?a/2*e*e*e*e+n:-a/2*((e-=2)*e*e*e-2)+n},easeInQuint:function(e,n,t,r){var a=t-n;return a*(e/=r)*e*e*e*e+n},easeOutQuint:function(e,n,t,r){var a=t-n;return a*((e=e/r-1)*e*e*e*e+1)+n},easeInOutQuint:function(e,n,t,r){var a=t-n;return(e/=r/2)<1?a/2*e*e*e*e*e+n:a/2*((e-=2)*e*e*e*e+2)+n},easeInSine:function(e,n,t,r){var a=t-n;return-a*Math.cos(e/r*(Math.PI/2))+a+n},easeOutSine:function(e,n,t,r){var a=t-n;return a*Math.sin(e/r*(Math.PI/2))+n},easeInOutSine:function(e,n,t,r){var a=t-n;return-a/2*(Math.cos(Math.PI*e/r)-1)+n},easeInExpo:function(e,n,t,r){var a=t-n;return 0==e?n:a*Math.pow(2,10*(e/r-1))+n},easeOutExpo:function(e,n,t,r){var a=t-n;return e==r?n+a:a*(-Math.pow(2,-10*e/r)+1)+n},easeInOutExpo:function(e,n,t,r){var a=t-n;return 0===e?n:e===r?n+a:(e/=r/2)<1?a/2*Math.pow(2,10*(e-1))+n:a/2*(-Math.pow(2,-10*--e)+2)+n},easeInCirc:function(e,n,t,r){var a=t-n;return-a*(Math.sqrt(1-(e/=r)*e)-1)+n},easeOutCirc:function(e,n,t,r){var a=t-n;return a*Math.sqrt(1-(e=e/r-1)*e)+n},easeInOutCirc:function(e,n,t,r){var a=t-n;return(e/=r/2)<1?-a/2*(Math.sqrt(1-e*e)-1)+n:a/2*(Math.sqrt(1-(e-=2)*e)+1)+n},easeInElastic:function(e,n,t,r){var a,u,o,i=t-n;return o=1.70158,u=0,a=i,0===e?n:1===(e/=r)?n+i:(u||(u=.3*r),a<Math.abs(i)?(a=i,o=u/4):o=u/(2*Math.PI)*Math.asin(i/a),-(a*Math.pow(2,10*(e-=1))*Math.sin((e*r-o)*(2*Math.PI)/u))+n)},easeOutElastic:function(e,n,t,r){var a,u,o,i=t-n;return o=1.70158,u=0,a=i,0===e?n:1===(e/=r)?n+i:(u||(u=.3*r),a<Math.abs(i)?(a=i,o=u/4):o=u/(2*Math.PI)*Math.asin(i/a),a*Math.pow(2,-10*e)*Math.sin((e*r-o)*(2*Math.PI)/u)+i+n)},easeInOutElastic:function(e,n,t,r){var a,u,o,i=t-n;return o=1.70158,u=0,a=i,0===e?n:2===(e/=r/2)?n+i:(u||(u=r*(.3*1.5)),a<Math.abs(i)?(a=i,o=u/4):o=u/(2*Math.PI)*Math.asin(i/a),1>e?-.5*(a*Math.pow(2,10*(e-=1))*Math.sin((e*r-o)*(2*Math.PI)/u))+n:a*Math.pow(2,-10*(e-=1))*Math.sin((e*r-o)*(2*Math.PI)/u)*.5+i+n)},easeInBack:function(e,n,t,r,a){var u=t-n;return void 0===a&&(a=1.70158),u*(e/=r)*e*((a+1)*e-a)+n},easeOutBack:function(e,n,t,r,a){var u=t-n;return void 0===a&&(a=1.70158),u*((e=e/r-1)*e*((a+1)*e+a)+1)+n},easeInOutBack:function(e,n,t,r,a){var u=t-n;return void 0===a&&(a=1.70158),(e/=r/2)<1?u/2*(e*e*(((a*=1.525)+1)*e-a))+n:u/2*((e-=2)*e*(((a*=1.525)+1)*e+a)+2)+n},easeInBounce:function(e,n,r,a){var u,o=r-n;return u=t.easeOutBounce(a-e,0,o,a),o-u+n},easeOutBounce:function(e,n,t,r){var a=t-n;return(e/=r)<1/2.75?a*(7.5625*e*e)+n:2/2.75>e?a*(7.5625*(e-=1.5/2.75)*e+.75)+n:2.5/2.75>e?a*(7.5625*(e-=2.25/2.75)*e+.9375)+n:a*(7.5625*(e-=2.625/2.75)*e+.984375)+n},easeInOutBounce:function(e,n,r,a){var u,o=r-n;return a/2>e?(u=t.easeInBounce(2*e,0,o,a),.5*u+n):(u=t.easeOutBounce(2*e-a,0,o,a),.5*u+.5*o+n)}};e.exports=t}})});

/***/ }),
/* 1731 */
368,
/* 1732 */
[1847, 157],
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1732);
	var ReactElement = __webpack_require__(156);
	
	var emptyFunction = __webpack_require__(65);
	var traverseAllChildren = __webpack_require__(1743);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(157),
	    _assign = __webpack_require__(24);
	
	var ReactComponent = __webpack_require__(387);
	var ReactElement = __webpack_require__(156);
	var ReactPropTypeLocationNames = __webpack_require__(1736);
	var ReactNoopUpdateQueue = __webpack_require__(388);
	
	var emptyObject = __webpack_require__(138);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(19);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	var didWarnDeprecated = false;
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
	      didWarnDeprecated = true;
	    }
	
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(156);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(156),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(733);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(24);
	
	var ReactComponent = __webpack_require__(387);
	var ReactNoopUpdateQueue = __webpack_require__(388);
	
	var emptyObject = __webpack_require__(138);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ }),
/* 1739 */
1651,
/* 1740 */
1670,
/* 1741 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(157);
	
	var ReactElement = __webpack_require__(156);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(157);
	
	var ReactCurrentOwner = __webpack_require__(91);
	var REACT_ELEMENT_TYPE = __webpack_require__(801);
	
	var getIteratorFn = __webpack_require__(1740);
	var invariant = __webpack_require__(13);
	var KeyEscapeUtils = __webpack_require__(1731);
	var warning = __webpack_require__(19);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setDisplayName = __webpack_require__(69);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(79);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createEagerFactory = __webpack_require__(78);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = function defaultProps(props) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    var DefaultProps = function DefaultProps(ownerProps) {
	      return factory(ownerProps);
	    };
	    DefaultProps.defaultProps = props;
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'defaultProps'))(DefaultProps);
	    }
	    return DefaultProps;
	  };
	};
	
	exports.default = defaultProps;

/***/ }),
/* 1745 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
	};
	
	exports.default = isClassComponent;

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isClassComponent = __webpack_require__(1745);
	
	var _isClassComponent2 = _interopRequireDefault(_isClassComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
	  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && (("production") === 'production' || !Component.propTypes));
	};
	
	exports.default = isReferentiallyTransparentFunctionComponent;

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setDisplayName = __webpack_require__(69);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(79);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createEagerFactory = __webpack_require__(78);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapProps = function mapProps(propsMapper) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    var MapProps = function MapProps(props) {
	      return factory(propsMapper(props));
	    };
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'mapProps'))(MapProps);
	    }
	    return MapProps;
	  };
	};
	
	exports.default = mapProps;

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerFactory = __webpack_require__(78);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _getDisplayName = __webpack_require__(804);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var nest = function nest() {
	  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
	    Components[_key] = arguments[_key];
	  }
	
	  var factories = Components.map(_createEagerFactory2.default);
	  var Nest = function Nest(_ref) {
	    var props = _objectWithoutProperties(_ref, []),
	        children = _ref.children;
	
	    return factories.reduceRight(function (child, factory) {
	      return factory(props, child);
	    }, children);
	  };
	
	  if (false) {
	    var displayNames = Components.map(_getDisplayName2.default);
	    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
	  }
	
	  return Nest;
	};
	
	exports.default = nest;

/***/ }),
/* 1749 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	exports.default = setStatic;

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(202);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
	  if (!hasKey && isReferentiallyTransparent) {
	    if (children) {
	      return type(_extends({}, props, { children: children }));
	    }
	    return type(props);
	  }
	
	  var Component = type;
	
	  if (children) {
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  }
	
	  return _react2.default.createElement(Component, props);
	};
	
	exports.default = createEagerElementUtil;

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var pick = function pick(obj, keys) {
	  var result = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (obj.hasOwnProperty(key)) {
	      result[key] = obj[key];
	    }
	  }
	  return result;
	};
	
	exports.default = pick;

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = promiseMiddleware;
	
	var _fluxStandardAction = __webpack_require__(1315);
	
	function isPromise(val) {
	  return val && typeof val.then === 'function';
	}
	
	function promiseMiddleware(_ref) {
	  var dispatch = _ref.dispatch;
	
	  return function (next) {
	    return function (action) {
	      if (!_fluxStandardAction.isFSA(action)) {
	        return isPromise(action) ? action.then(dispatch) : next(action);
	      }
	
	      return isPromise(action.payload) ? action.payload.then(function (result) {
	        return dispatch(_extends({}, action, { payload: result }));
	      }, function (error) {
	        return dispatch(_extends({}, action, { payload: error, error: true }));
	      }) : next(action);
	    };
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (factory());
	}(this, (function () { 'use strict';
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _objectSpread(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i] != null ? arguments[i] : {};
	      var ownKeys = Object.keys(source);
	
	      if (typeof Object.getOwnPropertySymbols === 'function') {
	        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	        }));
	      }
	
	      ownKeys.forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    }
	
	    return target;
	  }
	
	  var identity = function identity(x) {
	    return x;
	  };
	
	  var getUndefined = function getUndefined() {};
	
	  var filter = function filter() {
	    return true;
	  };
	
	  var getType = function getType(action) {
	    return action.type;
	  };
	
	  var createSentryMiddleware = function createSentryMiddleware(Sentry) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$breadcrumbDa = options.breadcrumbDataFromAction,
	        breadcrumbDataFromAction = _options$breadcrumbDa === void 0 ? getUndefined : _options$breadcrumbDa,
	        _options$breadcrumbMe = options.breadcrumbMessageFromAction,
	        breadcrumbMessageFromAction = _options$breadcrumbMe === void 0 ? getType : _options$breadcrumbMe,
	        _options$actionTransf = options.actionTransformer,
	        actionTransformer = _options$actionTransf === void 0 ? identity : _options$actionTransf,
	        _options$stateTransfo = options.stateTransformer,
	        stateTransformer = _options$stateTransfo === void 0 ? identity : _options$stateTransfo,
	        _options$breadcrumbCa = options.breadcrumbCategory,
	        breadcrumbCategory = _options$breadcrumbCa === void 0 ? "redux-action" : _options$breadcrumbCa,
	        _options$filterBreadc = options.filterBreadcrumbActions,
	        filterBreadcrumbActions = _options$filterBreadc === void 0 ? filter : _options$filterBreadc,
	        getUserContext = options.getUserContext,
	        getTags = options.getTags;
	    return function (store) {
	      var lastAction;
	      Sentry.configureScope(function (scope) {
	        scope.addEventProcessor(function (event, hint) {
	          var state = store.getState();
	          event.extra = _objectSpread({}, event.extra, {
	            lastAction: actionTransformer(lastAction),
	            state: stateTransformer(state)
	          });
	
	          if (getUserContext) {
	            event.user = _objectSpread({}, event.user, getUserContext(state));
	          }
	
	          if (getTags) {
	            var tags = getTags(state);
	            Object.keys(tags).forEach(function (key) {
	              event.tags = _objectSpread({}, event.tags, _defineProperty({}, key, tags[key]));
	            });
	          }
	
	          return event;
	        });
	      });
	      return function (next) {
	        return function (action) {
	          if (filterBreadcrumbActions(action)) {
	            Sentry.addBreadcrumb({
	              category: breadcrumbCategory,
	              message: breadcrumbMessageFromAction(action),
	              level: "info",
	              data: breadcrumbDataFromAction(action)
	            });
	          }
	
	          lastAction = action;
	          return next(action);
	        };
	      };
	    };
	  };
	
	  module.exports = createSentryMiddleware;
	
	})));


/***/ }),
/* 1755 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch;
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = applyMiddleware;
	
	var _compose = __webpack_require__(806);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	      var store = createStore(reducer, initialState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2["default"].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 1757 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = combineReducers;
	
	var _createStore = __webpack_require__(807);
	
	var _isPlainObject = __webpack_require__(235);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(808);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2["default"])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key);
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action);
	      if (warningMessage) {
	        (0, _warning2["default"])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global window */
	'use strict';
	
	module.exports = __webpack_require__(1760)(global || window || this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1760 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function symbolObservablePonyfill(root) {
		var result;
		var Symbol = root.Symbol;
	
		if (typeof Symbol === 'function') {
			if (Symbol.observable) {
				result = Symbol.observable;
			} else {
				result = Symbol('observable');
				Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _off = __webpack_require__(1290);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _on = __webpack_require__(1291);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _scrollLeft = __webpack_require__(1292);
	
	var _scrollLeft2 = _interopRequireDefault(_scrollLeft);
	
	var _scrollTop = __webpack_require__(1293);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _requestAnimationFrame = __webpack_require__(1294);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _invariant = __webpack_require__(48);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-underscore-dangle */
	
	// Try at most this many times to scroll, to avoid getting stuck.
	var MAX_SCROLL_ATTEMPTS = 2;
	
	var ScrollBehavior = function () {
	  function ScrollBehavior(_ref) {
	    var _this = this;
	
	    var addTransitionHook = _ref.addTransitionHook,
	        stateStorage = _ref.stateStorage,
	        getCurrentLocation = _ref.getCurrentLocation,
	        shouldUpdateScroll = _ref.shouldUpdateScroll;
	
	    _classCallCheck(this, ScrollBehavior);
	
	    this._onWindowScroll = function () {
	      // It's possible that this scroll operation was triggered by what will be a
	      // `POP` transition. Instead of updating the saved location immediately, we
	      // have to enqueue the update, then potentially cancel it if we observe a
	      // location update.
	      if (_this._saveWindowPositionHandle === null) {
	        _this._saveWindowPositionHandle = (0, _requestAnimationFrame2.default)(_this._saveWindowPosition);
	      }
	
	      if (_this._windowScrollTarget) {
	        var _windowScrollTarget = _this._windowScrollTarget,
	            xTarget = _windowScrollTarget[0],
	            yTarget = _windowScrollTarget[1];
	
	        var x = (0, _scrollLeft2.default)(window);
	        var y = (0, _scrollTop2.default)(window);
	
	        if (x === xTarget && y === yTarget) {
	          _this._windowScrollTarget = null;
	          _this._cancelCheckWindowScroll();
	        }
	      }
	    };
	
	    this._saveWindowPosition = function () {
	      _this._saveWindowPositionHandle = null;
	
	      _this._savePosition(null, window);
	    };
	
	    this._checkWindowScrollPosition = function () {
	      _this._checkWindowScrollHandle = null;
	
	      // We can only get here if scrollTarget is set. Every code path that unsets
	      // scroll target also cancels the handle to avoid calling this handler.
	      // Still, check anyway just in case.
	      /* istanbul ignore if: paranoid guard */
	      if (!_this._windowScrollTarget) {
	        return;
	      }
	
	      _this._scrollToTarget(window, _this._windowScrollTarget);
	
	      ++_this._numWindowScrollAttempts;
	
	      /* istanbul ignore if: paranoid guard */
	      if (_this._numWindowScrollAttempts >= MAX_SCROLL_ATTEMPTS) {
	        _this._windowScrollTarget = null;
	        return;
	      }
	
	      _this._checkWindowScrollHandle = (0, _requestAnimationFrame2.default)(_this._checkWindowScrollPosition);
	    };
	
	    this._scrollToTarget = function (element, target) {
	      if (typeof target === 'string') {
	        var el = document.getElementById(target) || document.getElementsByName(target)[0];
	        if (el) {
	          el.scrollIntoView();
	          return;
	        }
	
	        // Fallback to scrolling to top when target fragment doesn't exist.
	        target = [0, 0]; // eslint-disable-line no-param-reassign
	      }
	
	      var _target = target,
	          x = _target[0],
	          y = _target[1];
	
	      (0, _scrollLeft2.default)(element, x);
	      (0, _scrollTop2.default)(element, y);
	    };
	
	    this._stateStorage = stateStorage;
	    this._getCurrentLocation = getCurrentLocation;
	    this._shouldUpdateScroll = shouldUpdateScroll;
	
	    // This helps avoid some jankiness in fighting against the browser's
	    // default scroll behavior on `POP` transitions.
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if ('scrollRestoration' in window.history) {
	      this._oldScrollRestoration = window.history.scrollRestoration;
	      window.history.scrollRestoration = 'manual';
	    } else {
	      this._oldScrollRestoration = null;
	    }
	
	    this._saveWindowPositionHandle = null;
	    this._checkWindowScrollHandle = null;
	    this._windowScrollTarget = null;
	    this._numWindowScrollAttempts = 0;
	
	    this._scrollElements = {};
	
	    // We have to listen to each window scroll update rather than to just
	    // location updates, because some browsers will update scroll position
	    // before emitting the location change.
	    (0, _on2.default)(window, 'scroll', this._onWindowScroll);
	
	    this._removeTransitionHook = addTransitionHook(function () {
	      if (_this._saveWindowPositionHandle !== null) {
	        _requestAnimationFrame2.default.cancel(_this._saveWindowPositionHandle);
	        _this._saveWindowPositionHandle = null;
	      }
	
	      // It's fine to save element scroll positions here, though; the browser
	      // won't modify them.
	      Object.keys(_this._scrollElements).forEach(function (key) {
	        _this._saveElementPosition(key);
	      });
	    });
	  }
	
	  ScrollBehavior.prototype.registerElement = function registerElement(key, element, shouldUpdateScroll, context) {
	    !!this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is already an element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    this._scrollElements[key] = { element: element, shouldUpdateScroll: shouldUpdateScroll };
	    this._updateElementScroll(key, null, context);
	  };
	
	  ScrollBehavior.prototype.unregisterElement = function unregisterElement(key) {
	    !this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is no element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    delete this._scrollElements[key];
	  };
	
	  ScrollBehavior.prototype.updateScroll = function updateScroll(prevContext, context) {
	    var _this2 = this;
	
	    this._updateWindowScroll(prevContext, context);
	
	    Object.keys(this._scrollElements).forEach(function (key) {
	      _this2._updateElementScroll(key, prevContext, context);
	    });
	  };
	
	  ScrollBehavior.prototype.stop = function stop() {
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if (this._oldScrollRestoration) {
	      window.history.scrollRestoration = this._oldScrollRestoration;
	    }
	
	    (0, _off2.default)(window, 'scroll', this._onWindowScroll);
	    this._cancelCheckWindowScroll();
	
	    this._removeTransitionHook();
	  };
	
	  ScrollBehavior.prototype._cancelCheckWindowScroll = function _cancelCheckWindowScroll() {
	    if (this._checkWindowScrollHandle !== null) {
	      _requestAnimationFrame2.default.cancel(this._checkWindowScrollHandle);
	      this._checkWindowScrollHandle = null;
	    }
	  };
	
	  ScrollBehavior.prototype._saveElementPosition = function _saveElementPosition(key) {
	    var element = this._scrollElements[key].element;
	
	
	    this._savePosition(key, element);
	  };
	
	  ScrollBehavior.prototype._savePosition = function _savePosition(key, element) {
	    this._stateStorage.save(this._getCurrentLocation(), key, [(0, _scrollLeft2.default)(element), (0, _scrollTop2.default)(element)]);
	  };
	
	  ScrollBehavior.prototype._updateWindowScroll = function _updateWindowScroll(prevContext, context) {
	    // Whatever we were doing before isn't relevant any more.
	    this._cancelCheckWindowScroll();
	
	    this._windowScrollTarget = this._getScrollTarget(null, this._shouldUpdateScroll, prevContext, context);
	
	    // Updating the window scroll position is really flaky. Just trying to
	    // scroll it isn't enough. Instead, try to scroll a few times until it
	    // works.
	    this._numWindowScrollAttempts = 0;
	    this._checkWindowScrollPosition();
	  };
	
	  ScrollBehavior.prototype._updateElementScroll = function _updateElementScroll(key, prevContext, context) {
	    var _scrollElements$key = this._scrollElements[key],
	        element = _scrollElements$key.element,
	        shouldUpdateScroll = _scrollElements$key.shouldUpdateScroll;
	
	
	    var scrollTarget = this._getScrollTarget(key, shouldUpdateScroll, prevContext, context);
	    if (!scrollTarget) {
	      return;
	    }
	
	    // Unlike with the window, there shouldn't be any flakiness to deal with
	    // here.
	    this._scrollToTarget(element, scrollTarget);
	  };
	
	  ScrollBehavior.prototype._getDefaultScrollTarget = function _getDefaultScrollTarget(location) {
	    var hash = location.hash;
	    if (hash && hash !== '#') {
	      return hash.charAt(0) === '#' ? hash.slice(1) : hash;
	    }
	    return [0, 0];
	  };
	
	  ScrollBehavior.prototype._getScrollTarget = function _getScrollTarget(key, shouldUpdateScroll, prevContext, context) {
	    var scrollTarget = shouldUpdateScroll ? shouldUpdateScroll.call(this, prevContext, context) : true;
	
	    if (!scrollTarget || Array.isArray(scrollTarget) || typeof scrollTarget === 'string') {
	      return scrollTarget;
	    }
	
	    var location = this._getCurrentLocation();
	    if (location.action === 'PUSH') {
	      return this._getDefaultScrollTarget(location);
	    }
	
	    return this._stateStorage.read(location, key) || this._getDefaultScrollTarget(location);
	  };
	
	  return ScrollBehavior;
	}();
	
	exports.default = ScrollBehavior;
	module.exports = exports['default'];

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var get = __webpack_require__(182);
	
	/**
	 * Add address getters to `proto`.
	 *
	 * @ignore
	 * @param {Function} proto
	 */
	module.exports = function(proto) {
	  proto.zip = trait('postalCode', 'zip');
	  proto.country = trait('country');
	  proto.street = trait('street');
	  proto.state = trait('state');
	  proto.city = trait('city');
	  proto.region = trait('region');
	
	  function trait(a, b) {
	    return function() {
	      var traits = this.traits();
	      var props = this.properties ? this.properties() : {};
	
	      return get(traits, 'address.' + a)
	        || get(traits, a)
	        || (b ? get(traits, 'address.' + b) : null)
	        || (b ? get(traits, b) : null)
	        || get(props, 'address.' + a)
	        || get(props, a)
	        || (b ? get(props, 'address.' + b) : null)
	        || (b ? get(props, b) : null);
	    };
	  }
	};


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var inherit = __webpack_require__(80).inherit;
	var Facade = __webpack_require__(130);
	
	/**
	 * Initialize a new `Alias` facade with a `dictionary` of arguments.
	 *
	 * @param {Object} dictionary - The object to wrap.
	 * @param {string} [dictionary.from] - The previous ID of the user.
	 * @param {string} [dictionary.to] - The new ID of the user.
	 * @param {Object} opts - Options about what kind of Facade to create.
	 *
	 * @augments Facade
	 */
	function Alias(dictionary, opts) {
	  Facade.call(this, dictionary, opts);
	}
	
	inherit(Alias, Facade);
	
	/**
	 * Return the type of facade this is. This will always return `"alias"`.
	 *
	 * @return {string}
	 */
	Alias.prototype.action = function() {
	  return 'alias';
	};
	
	/**
	 * An alias for {@link Alias#action}.
	 *
	 * @function
	 * @return {string}
	 */
	Alias.prototype.type = Alias.prototype.action;
	
	/**
	 * Get the user's previous ID from `previousId` or `from`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Alias.prototype.previousId = function() {
	  return this.field('previousId') || this.field('from');
	};
	
	/**
	 * An alias for {@link Alias#previousId}.
	 *
	 * @function
	 * @return {string}
	 */
	Alias.prototype.from = Alias.prototype.previousId;
	
	/**
	 * Get the user's new ID from `userId` or `to`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Alias.prototype.userId = function() {
	  return this.field('userId') || this.field('to');
	};
	
	/**
	 * An alias for {@link Alias#userId}.
	 *
	 * @function
	 * @return {string}
	 */
	Alias.prototype.to = Alias.prototype.userId;
	
	module.exports = Alias;


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var inherit = __webpack_require__(80).inherit;
	var Facade = __webpack_require__(130);
	
	/**
	 * Initialize a new `Delete` facade with a `dictionary` of arguments.
	 *
	 * @param {Object} dictionary - The object to wrap.
	 * @param {string} [dictionary.category] - The delete category.
	 * @param {string} [dictionary.name] - The delete name.
	 * @param {string} [dictionary.properties] - The delete properties.
	 * @param {Object} opts - Options about what kind of Facade to create.
	 *
	 * @augments Facade
	 */
	function Delete(dictionary, opts) {
	  Facade.call(this, dictionary, opts);
	}
	
	inherit(Delete, Facade);
	
	/**
	 * Return the type of facade this is. This will always return `"delete"`.
	 *
	 * @return {string}
	 */
	Delete.prototype.type = function() {
	  return 'delete';
	};
	
	module.exports = Delete;


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var inherit = __webpack_require__(80).inherit;
	var isEmail = __webpack_require__(204);
	var newDate = __webpack_require__(353);
	var Facade = __webpack_require__(130);
	
	/**
	 * Initialize a new `Group` facade with a `dictionary` of arguments.
	 *
	 * @param {Object} dictionary - The object to wrap.
	 * @param {string} [dictionary.userId] - The user to add to the group.
	 * @param {string} [dictionary.groupId] - The ID of the group.
	 * @param {Object} [dictionary.traits] - The traits of the group.
	 * @param {Object} opts - Options about what kind of Facade to create.
	 *
	 * @augments Facade
	 */
	function Group(dictionary, opts) {
	  Facade.call(this, dictionary, opts);
	}
	
	inherit(Group, Facade);
	
	/**
	 * Return the type of facade this is. This will always return `"group"`.
	 *
	 * @return {string}
	 */
	Group.prototype.action = function() {
	  return 'group';
	};
	
	/**
	 * An alias for {@link Group#action}.
	 *
	 * @function
	 * @return {string}
	 */
	Group.prototype.type = Group.prototype.action;
	
	/**
	 * Get the group ID from `groupId`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @return {string}
	 */
	Group.prototype.groupId = Facade.field('groupId');
	
	/**
	 * Get the time of creation of the group from `traits.createdAt`,
	 * `traits.created`, `properties.createdAt`, or `properties.created`.
	 *
	 * @return {Date}
	 */
	Group.prototype.created = function() {
	  var created = this.proxy('traits.createdAt')
	    || this.proxy('traits.created')
	    || this.proxy('properties.createdAt')
	    || this.proxy('properties.created');
	
	  if (created) return newDate(created);
	};
	
	/**
	 * Get the group's email from `traits.email`, falling back to `groupId` only if
	 * it looks like a valid email.
	 *
	 * @return {string}
	 */
	Group.prototype.email = function() {
	  var email = this.proxy('traits.email');
	  if (email) return email;
	  var groupId = this.groupId();
	  if (isEmail(groupId)) return groupId;
	};
	
	/**
	 * Get the group's traits. This is identical to how {@link Facade#traits}
	 * works, except it looks at `traits.*` instead of `options.traits.*`.
	 *
	 * Traits are gotten from `traits`, augmented with a property `id` with
	 * the event's `groupId`.
	 *
	 * The parameter `aliases` is meant to transform keys in `traits` into new
	 * keys. Each alias like `{ "xxx": "yyy" }` will take whatever is at `xxx` in
	 * the traits, and move it to `yyy`. If `xxx` is a method of this facade, it'll
	 * be called as a function instead of treated as a key into the traits.
	 *
	 * @example
	 * var obj = { traits: { foo: "bar" }, anonymousId: "xxx" }
	 * var group = new Group(obj)
	 *
	 * group.traits() // { "foo": "bar" }
	 * group.traits({ "foo": "asdf" }) // { "asdf": "bar" }
	 * group.traits({ "sessionId": "rofl" }) // { "rofl": "xxx" }
	 *
	 * @param {Object} aliases - A mapping from keys to the new keys they should be
	 * transformed to.
	 * @return {Object}
	 */
	Group.prototype.traits = function(aliases) {
	  var ret = this.properties();
	  var id = this.groupId();
	  aliases = aliases || {};
	
	  if (id) ret.id = id;
	
	  for (var alias in aliases) {
	    var value = this[alias] == null ? this.proxy('traits.' + alias) : this[alias]();
	    if (value == null) continue;
	    ret[aliases[alias]] = value;
	    delete ret[alias];
	  }
	
	  return ret;
	};
	
	/**
	 * Get the group's name from `traits.name`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {string}
	 */
	Group.prototype.name = Facade.proxy('traits.name');
	
	/**
	 * Get the group's industry from `traits.industry`.
	 *
	 * This *should* be a string, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {string}
	 */
	Group.prototype.industry = Facade.proxy('traits.industry');
	
	/**
	 * Get the group's employee count from `traits.employees`.
	 *
	 * This *should* be a number, but may not be if the client isn't adhering to
	 * the spec.
	 *
	 * @function
	 * @return {number}
	 */
	Group.prototype.employees = Facade.proxy('traits.employees');
	
	/**
	 * Get the group's properties from `traits` or `properties`, falling back to
	 * simply an empty object.
	 *
	 * @return {Object}
	 */
	Group.prototype.properties = function() {
	  // TODO remove this function
	  return this.field('traits') || this.field('properties') || {};
	};
	
	module.exports = Group;


/***/ }),
/* 1766 */
/***/ (function(module, exports) {

	'use strict';
	
	// A few integrations are disabled by default. They must be explicitly enabled
	// by setting options[Provider] = true.
	var disabled = {
	  Salesforce: true
	};
	
	/**
	 * Check whether an integration should be enabled by default.
	 *
	 * @ignore
	 * @param {string} integration
	 * @return {boolean}
	 */
	module.exports = function(integration) {
	  return !disabled[integration];
	};


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var inherit = __webpack_require__(80).inherit;
	var Page = __webpack_require__(811);
	var Track = __webpack_require__(389);
	
	/**
	 * Initialize a new `Screen` facade with a `dictionary` of arguments.
	 *
	 * Note that this class extends {@link Page}, so its methods are available to
	 * instances of this class as well.
	 *
	 * @param {Object} dictionary - The object to wrap.
	 * @param {string} [dictionary.category] - The page category.
	 * @param {string} [dictionary.name] - The page name.
	 * @param {string} [dictionary.properties] - The page properties.
	 * @param {Object} opts - Options about what kind of Facade to create.
	 *
	 * @augments Page
	 */
	function Screen(dictionary, opts) {
	  Page.call(this, dictionary, opts);
	}
	
	inherit(Screen, Page);
	
	/**
	 * Return the type of facade this is. This will always return `"screen"`.
	 *
	 * @return {string}
	 */
	Screen.prototype.action = function() {
	  return 'screen';
	};
	
	/**
	 * An alias for {@link Screen#action}.
	 *
	 * @function
	 * @return {string}
	 */
	Screen.prototype.type = Screen.prototype.action;
	
	/**
	 * Get an event name from this screen call. If `name` is present, this will be
	 * `Viewed $name Screen`; otherwise, it will be `Loaded a Screen`.
	 *
	 * @param {string} name - The name of this screen.
	 * @return {string}
	 */
	Screen.prototype.event = function(name) {
	  return name ? 'Viewed ' + name + ' Screen' : 'Loaded a Screen';
	};
	
	/**
	 * Convert this Screen to a {@link Track} facade. The inputted `name` will be
	 * converted to the Track's event name via {@link Screen#event}.
	 *
	 * @param {string} name
	 * @return {Track}
	 */
	Screen.prototype.track = function(name) {
	  var json = this.json();
	  json.event = this.event(name);
	  json.timestamp = this.timestamp();
	  json.properties = this.properties();
	  return new Track(json, this.opts);
	};
	
	module.exports = Screen;


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(146)))

/***/ }),
/* 1769 */
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),
/* 1770 */
/***/ (function(module, exports) {

	
	/**
	 * Generate a slug from the given `str`.
	 *
	 * example:
	 *
	 *        generate('foo bar');
	 *        // > foo-bar
	 *
	 * @param {String} str
	 * @param {Object} options
	 * @config {String|RegExp} [replace] characters to replace, defaulted to `/[^a-z0-9]/g`
	 * @config {String} [separator] separator to insert, defaulted to `-`
	 * @return {String}
	 */
	
	module.exports = function (str, options) {
	  options || (options = {});
	  return str.toLowerCase()
	    .replace(options.replace || /[^a-z0-9]/g, ' ')
	    .replace(/^ +| +$/g, '')
	    .replace(/ +/g, options.separator || '-')
	};


/***/ }),
/* 1771 */
/***/ (function(module, exports) {

	(function(host) {
	
	  var properties = {
	    browser: [
	      [/msie ([\.\_\d]+)/, "ie"],
	      [/trident\/.*?rv:([\.\_\d]+)/, "ie"],
	      [/firefox\/([\.\_\d]+)/, "firefox"],
	      [/chrome\/([\.\_\d]+)/, "chrome"],
	      [/version\/([\.\_\d]+).*?safari/, "safari"],
	      [/mobile safari ([\.\_\d]+)/, "safari"],
	      [/android.*?version\/([\.\_\d]+).*?safari/, "com.android.browser"],
	      [/crios\/([\.\_\d]+).*?safari/, "chrome"],
	      [/opera/, "opera"],
	      [/opera\/([\.\_\d]+)/, "opera"],
	      [/opera ([\.\_\d]+)/, "opera"],
	      [/opera mini.*?version\/([\.\_\d]+)/, "opera.mini"],
	      [/opios\/([a-z\.\_\d]+)/, "opera"],
	      [/blackberry/, "blackberry"],
	      [/blackberry.*?version\/([\.\_\d]+)/, "blackberry"],
	      [/bb\d+.*?version\/([\.\_\d]+)/, "blackberry"],
	      [/rim.*?version\/([\.\_\d]+)/, "blackberry"],
	      [/iceweasel\/([\.\_\d]+)/, "iceweasel"],
	      [/edge\/([\.\d]+)/, "edge"]
	    ],
	    os: [
	      [/linux ()([a-z\.\_\d]+)/, "linux"],
	      [/mac os x/, "macos"],
	      [/mac os x.*?([\.\_\d]+)/, "macos"],
	      [/os ([\.\_\d]+) like mac os/, "ios"],
	      [/openbsd ()([a-z\.\_\d]+)/, "openbsd"],
	      [/android/, "android"],
	      [/android ([a-z\.\_\d]+);/, "android"],
	      [/mozilla\/[a-z\.\_\d]+ \((?:mobile)|(?:tablet)/, "firefoxos"],
	      [/windows\s*(?:nt)?\s*([\.\_\d]+)/, "windows"],
	      [/windows phone.*?([\.\_\d]+)/, "windows.phone"],
	      [/windows mobile/, "windows.mobile"],
	      [/blackberry/, "blackberryos"],
	      [/bb\d+/, "blackberryos"],
	      [/rim.*?os\s*([\.\_\d]+)/, "blackberryos"]
	    ],
	    device: [
	      [/ipad/, "ipad"],
	      [/iphone/, "iphone"],
	      [/lumia/, "lumia"],
	      [/htc/, "htc"],
	      [/nexus/, "nexus"],
	      [/galaxy nexus/, "galaxy.nexus"],
	      [/nokia/, "nokia"],
	      [/ gt\-/, "galaxy"],
	      [/ sm\-/, "galaxy"],
	      [/xbox/, "xbox"],
	      [/(?:bb\d+)|(?:blackberry)|(?: rim )/, "blackberry"]
	    ]
	  };
	
	  var UNKNOWN = "Unknown";
	
	  var propertyNames = Object.keys(properties);
	
	  function Sniffr() {
	    var self = this;
	
	    propertyNames.forEach(function(propertyName) {
	      self[propertyName] = {
	        name: UNKNOWN,
	        version: [],
	        versionString: UNKNOWN
	      };
	    });
	  }
	
	  function determineProperty(self, propertyName, userAgent) {
	    properties[propertyName].forEach(function(propertyMatcher) {
	      var propertyRegex = propertyMatcher[0];
	      var propertyValue = propertyMatcher[1];
	
	      var match = userAgent.match(propertyRegex);
	
	      if (match) {
	        self[propertyName].name = propertyValue;
	
	        if (match[2]) {
	          self[propertyName].versionString = match[2];
	          self[propertyName].version = [];
	        } else if (match[1]) {
	          self[propertyName].versionString = match[1].replace(/_/g, ".");
	          self[propertyName].version = parseVersion(match[1]);
	        } else {
	          self[propertyName].versionString = UNKNOWN;
	          self[propertyName].version = [];
	        }
	      }
	    });
	  }
	
	  function parseVersion(versionString) {
	    return versionString.split(/[\._]/).map(function(versionPart) {
	      return parseInt(versionPart);
	    });
	  }
	
	  Sniffr.prototype.sniff = function(userAgentString) {
	    var self = this;
	    var userAgent = (userAgentString || navigator.userAgent || "").toLowerCase();
	
	    propertyNames.forEach(function(propertyName) {
	      determineProperty(self, propertyName, userAgent);
	    });
	  };
	
	
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Sniffr;
	  } else {
	    host.Sniffr = new Sniffr();
	    host.Sniffr.sniff(navigator.userAgent);
	  }
	})(this);


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	(function (factory) {
	    if (true) {
	        // Node/CommonJS
	        module.exports = factory();
	    } else if (typeof define === 'function' && define.amd) {
	        // AMD
	        define(factory);
	    } else {
	        // Browser globals (with support for web workers)
	        var glob;
	
	        try {
	            glob = window;
	        } catch (e) {
	            glob = self;
	        }
	
	        glob.SparkMD5 = factory();
	    }
	}(function (undefined) {
	
	    'use strict';
	
	    /*
	     * Fastest md5 implementation around (JKM md5).
	     * Credits: Joseph Myers
	     *
	     * @see http://www.myersdaily.org/joseph/javascript/md5-text.html
	     * @see http://jsperf.com/md5-shootout/7
	     */
	
	    /* this function is much faster,
	      so if possible we use it. Some IEs
	      are the only ones I know of that
	      need the idiotic second function,
	      generated by an if clause.  */
	    var add32 = function (a, b) {
	        return (a + b) & 0xFFFFFFFF;
	    },
	        hex_chr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];
	
	
	    function cmn(q, a, b, x, s, t) {
	        a = add32(add32(a, q), add32(x, t));
	        return add32((a << s) | (a >>> (32 - s)), b);
	    }
	
	    function ff(a, b, c, d, x, s, t) {
	        return cmn((b & c) | ((~b) & d), a, b, x, s, t);
	    }
	
	    function gg(a, b, c, d, x, s, t) {
	        return cmn((b & d) | (c & (~d)), a, b, x, s, t);
	    }
	
	    function hh(a, b, c, d, x, s, t) {
	        return cmn(b ^ c ^ d, a, b, x, s, t);
	    }
	
	    function ii(a, b, c, d, x, s, t) {
	        return cmn(c ^ (b | (~d)), a, b, x, s, t);
	    }
	
	    function md5cycle(x, k) {
	        var a = x[0],
	            b = x[1],
	            c = x[2],
	            d = x[3];
	
	        a = ff(a, b, c, d, k[0], 7, -680876936);
	        d = ff(d, a, b, c, k[1], 12, -389564586);
	        c = ff(c, d, a, b, k[2], 17, 606105819);
	        b = ff(b, c, d, a, k[3], 22, -1044525330);
	        a = ff(a, b, c, d, k[4], 7, -176418897);
	        d = ff(d, a, b, c, k[5], 12, 1200080426);
	        c = ff(c, d, a, b, k[6], 17, -1473231341);
	        b = ff(b, c, d, a, k[7], 22, -45705983);
	        a = ff(a, b, c, d, k[8], 7, 1770035416);
	        d = ff(d, a, b, c, k[9], 12, -1958414417);
	        c = ff(c, d, a, b, k[10], 17, -42063);
	        b = ff(b, c, d, a, k[11], 22, -1990404162);
	        a = ff(a, b, c, d, k[12], 7, 1804603682);
	        d = ff(d, a, b, c, k[13], 12, -40341101);
	        c = ff(c, d, a, b, k[14], 17, -1502002290);
	        b = ff(b, c, d, a, k[15], 22, 1236535329);
	
	        a = gg(a, b, c, d, k[1], 5, -165796510);
	        d = gg(d, a, b, c, k[6], 9, -1069501632);
	        c = gg(c, d, a, b, k[11], 14, 643717713);
	        b = gg(b, c, d, a, k[0], 20, -373897302);
	        a = gg(a, b, c, d, k[5], 5, -701558691);
	        d = gg(d, a, b, c, k[10], 9, 38016083);
	        c = gg(c, d, a, b, k[15], 14, -660478335);
	        b = gg(b, c, d, a, k[4], 20, -405537848);
	        a = gg(a, b, c, d, k[9], 5, 568446438);
	        d = gg(d, a, b, c, k[14], 9, -1019803690);
	        c = gg(c, d, a, b, k[3], 14, -187363961);
	        b = gg(b, c, d, a, k[8], 20, 1163531501);
	        a = gg(a, b, c, d, k[13], 5, -1444681467);
	        d = gg(d, a, b, c, k[2], 9, -51403784);
	        c = gg(c, d, a, b, k[7], 14, 1735328473);
	        b = gg(b, c, d, a, k[12], 20, -1926607734);
	
	        a = hh(a, b, c, d, k[5], 4, -378558);
	        d = hh(d, a, b, c, k[8], 11, -2022574463);
	        c = hh(c, d, a, b, k[11], 16, 1839030562);
	        b = hh(b, c, d, a, k[14], 23, -35309556);
	        a = hh(a, b, c, d, k[1], 4, -1530992060);
	        d = hh(d, a, b, c, k[4], 11, 1272893353);
	        c = hh(c, d, a, b, k[7], 16, -155497632);
	        b = hh(b, c, d, a, k[10], 23, -1094730640);
	        a = hh(a, b, c, d, k[13], 4, 681279174);
	        d = hh(d, a, b, c, k[0], 11, -358537222);
	        c = hh(c, d, a, b, k[3], 16, -722521979);
	        b = hh(b, c, d, a, k[6], 23, 76029189);
	        a = hh(a, b, c, d, k[9], 4, -640364487);
	        d = hh(d, a, b, c, k[12], 11, -421815835);
	        c = hh(c, d, a, b, k[15], 16, 530742520);
	        b = hh(b, c, d, a, k[2], 23, -995338651);
	
	        a = ii(a, b, c, d, k[0], 6, -198630844);
	        d = ii(d, a, b, c, k[7], 10, 1126891415);
	        c = ii(c, d, a, b, k[14], 15, -1416354905);
	        b = ii(b, c, d, a, k[5], 21, -57434055);
	        a = ii(a, b, c, d, k[12], 6, 1700485571);
	        d = ii(d, a, b, c, k[3], 10, -1894986606);
	        c = ii(c, d, a, b, k[10], 15, -1051523);
	        b = ii(b, c, d, a, k[1], 21, -2054922799);
	        a = ii(a, b, c, d, k[8], 6, 1873313359);
	        d = ii(d, a, b, c, k[15], 10, -30611744);
	        c = ii(c, d, a, b, k[6], 15, -1560198380);
	        b = ii(b, c, d, a, k[13], 21, 1309151649);
	        a = ii(a, b, c, d, k[4], 6, -145523070);
	        d = ii(d, a, b, c, k[11], 10, -1120210379);
	        c = ii(c, d, a, b, k[2], 15, 718787259);
	        b = ii(b, c, d, a, k[9], 21, -343485551);
	
	        x[0] = add32(a, x[0]);
	        x[1] = add32(b, x[1]);
	        x[2] = add32(c, x[2]);
	        x[3] = add32(d, x[3]);
	    }
	
	    function md5blk(s) {
	        var md5blks = [],
	            i; /* Andy King said do it this way. */
	
	        for (i = 0; i < 64; i += 4) {
	            md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
	        }
	        return md5blks;
	    }
	
	    function md5blk_array(a) {
	        var md5blks = [],
	            i; /* Andy King said do it this way. */
	
	        for (i = 0; i < 64; i += 4) {
	            md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
	        }
	        return md5blks;
	    }
	
	    function md51(s) {
	        var n = s.length,
	            state = [1732584193, -271733879, -1732584194, 271733878],
	            i,
	            length,
	            tail,
	            tmp,
	            lo,
	            hi;
	
	        for (i = 64; i <= n; i += 64) {
	            md5cycle(state, md5blk(s.substring(i - 64, i)));
	        }
	        s = s.substring(i - 64);
	        length = s.length;
	        tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
	        for (i = 0; i < length; i += 1) {
	            tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
	        }
	        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
	        if (i > 55) {
	            md5cycle(state, tail);
	            for (i = 0; i < 16; i += 1) {
	                tail[i] = 0;
	            }
	        }
	
	        // Beware that the final length might not fit in 32 bits so we take care of that
	        tmp = n * 8;
	        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
	        lo = parseInt(tmp[2], 16);
	        hi = parseInt(tmp[1], 16) || 0;
	
	        tail[14] = lo;
	        tail[15] = hi;
	
	        md5cycle(state, tail);
	        return state;
	    }
	
	    function md51_array(a) {
	        var n = a.length,
	            state = [1732584193, -271733879, -1732584194, 271733878],
	            i,
	            length,
	            tail,
	            tmp,
	            lo,
	            hi;
	
	        for (i = 64; i <= n; i += 64) {
	            md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
	        }
	
	        // Not sure if it is a bug, however IE10 will always produce a sub array of length 1
	        // containing the last element of the parent array if the sub array specified starts
	        // beyond the length of the parent array - weird.
	        // https://connect.microsoft.com/IE/feedback/details/771452/typed-array-subarray-issue
	        a = (i - 64) < n ? a.subarray(i - 64) : new Uint8Array(0);
	
	        length = a.length;
	        tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
	        for (i = 0; i < length; i += 1) {
	            tail[i >> 2] |= a[i] << ((i % 4) << 3);
	        }
	
	        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
	        if (i > 55) {
	            md5cycle(state, tail);
	            for (i = 0; i < 16; i += 1) {
	                tail[i] = 0;
	            }
	        }
	
	        // Beware that the final length might not fit in 32 bits so we take care of that
	        tmp = n * 8;
	        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
	        lo = parseInt(tmp[2], 16);
	        hi = parseInt(tmp[1], 16) || 0;
	
	        tail[14] = lo;
	        tail[15] = hi;
	
	        md5cycle(state, tail);
	
	        return state;
	    }
	
	    function rhex(n) {
	        var s = '',
	            j;
	        for (j = 0; j < 4; j += 1) {
	            s += hex_chr[(n >> (j * 8 + 4)) & 0x0F] + hex_chr[(n >> (j * 8)) & 0x0F];
	        }
	        return s;
	    }
	
	    function hex(x) {
	        var i;
	        for (i = 0; i < x.length; i += 1) {
	            x[i] = rhex(x[i]);
	        }
	        return x.join('');
	    }
	
	    // In some cases the fast add32 function cannot be used..
	    if (hex(md51('hello')) !== '5d41402abc4b2a76b9719d911017c592') {
	        add32 = function (x, y) {
	            var lsw = (x & 0xFFFF) + (y & 0xFFFF),
	                msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	            return (msw << 16) | (lsw & 0xFFFF);
	        };
	    }
	
	    // ---------------------------------------------------
	
	    /**
	     * ArrayBuffer slice polyfill.
	     *
	     * @see https://github.com/ttaubert/node-arraybuffer-slice
	     */
	
	    if (typeof ArrayBuffer !== 'undefined' && !ArrayBuffer.prototype.slice) {
	        (function () {
	            function clamp(val, length) {
	                val = (val | 0) || 0;
	
	                if (val < 0) {
	                    return Math.max(val + length, 0);
	                }
	
	                return Math.min(val, length);
	            }
	
	            ArrayBuffer.prototype.slice = function (from, to) {
	                var length = this.byteLength,
	                    begin = clamp(from, length),
	                    end = length,
	                    num,
	                    target,
	                    targetArray,
	                    sourceArray;
	
	                if (to !== undefined) {
	                    end = clamp(to, length);
	                }
	
	                if (begin > end) {
	                    return new ArrayBuffer(0);
	                }
	
	                num = end - begin;
	                target = new ArrayBuffer(num);
	                targetArray = new Uint8Array(target);
	
	                sourceArray = new Uint8Array(this, begin, num);
	                targetArray.set(sourceArray);
	
	                return target;
	            };
	        })();
	    }
	
	    // ---------------------------------------------------
	
	    /**
	     * Helpers.
	     */
	
	    function toUtf8(str) {
	        if (/[\u0080-\uFFFF]/.test(str)) {
	            str = unescape(encodeURIComponent(str));
	        }
	
	        return str;
	    }
	
	    function utf8Str2ArrayBuffer(str, returnUInt8Array) {
	        var length = str.length,
	           buff = new ArrayBuffer(length),
	           arr = new Uint8Array(buff),
	           i;
	
	        for (i = 0; i < length; i += 1) {
	            arr[i] = str.charCodeAt(i);
	        }
	
	        return returnUInt8Array ? arr : buff;
	    }
	
	    function arrayBuffer2Utf8Str(buff) {
	        return String.fromCharCode.apply(null, new Uint8Array(buff));
	    }
	
	    function concatenateArrayBuffers(first, second, returnUInt8Array) {
	        var result = new Uint8Array(first.byteLength + second.byteLength);
	
	        result.set(new Uint8Array(first));
	        result.set(new Uint8Array(second), first.byteLength);
	
	        return returnUInt8Array ? result : result.buffer;
	    }
	
	    function hexToBinaryString(hex) {
	        var bytes = [],
	            length = hex.length,
	            x;
	
	        for (x = 0; x < length - 1; x += 2) {
	            bytes.push(parseInt(hex.substr(x, 2), 16));
	        }
	
	        return String.fromCharCode.apply(String, bytes);
	    }
	
	    // ---------------------------------------------------
	
	    /**
	     * SparkMD5 OOP implementation.
	     *
	     * Use this class to perform an incremental md5, otherwise use the
	     * static methods instead.
	     */
	
	    function SparkMD5() {
	        // call reset to init the instance
	        this.reset();
	    }
	
	    /**
	     * Appends a string.
	     * A conversion will be applied if an utf8 string is detected.
	     *
	     * @param {String} str The string to be appended
	     *
	     * @return {SparkMD5} The instance itself
	     */
	    SparkMD5.prototype.append = function (str) {
	        // Converts the string to utf8 bytes if necessary
	        // Then append as binary
	        this.appendBinary(toUtf8(str));
	
	        return this;
	    };
	
	    /**
	     * Appends a binary string.
	     *
	     * @param {String} contents The binary string to be appended
	     *
	     * @return {SparkMD5} The instance itself
	     */
	    SparkMD5.prototype.appendBinary = function (contents) {
	        this._buff += contents;
	        this._length += contents.length;
	
	        var length = this._buff.length,
	            i;
	
	        for (i = 64; i <= length; i += 64) {
	            md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
	        }
	
	        this._buff = this._buff.substring(i - 64);
	
	        return this;
	    };
	
	    /**
	     * Finishes the incremental computation, reseting the internal state and
	     * returning the result.
	     *
	     * @param {Boolean} raw True to get the raw string, false to get the hex string
	     *
	     * @return {String} The result
	     */
	    SparkMD5.prototype.end = function (raw) {
	        var buff = this._buff,
	            length = buff.length,
	            i,
	            tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
	            ret;
	
	        for (i = 0; i < length; i += 1) {
	            tail[i >> 2] |= buff.charCodeAt(i) << ((i % 4) << 3);
	        }
	
	        this._finish(tail, length);
	        ret = hex(this._hash);
	
	        if (raw) {
	            ret = hexToBinaryString(ret);
	        }
	
	        this.reset();
	
	        return ret;
	    };
	
	    /**
	     * Resets the internal state of the computation.
	     *
	     * @return {SparkMD5} The instance itself
	     */
	    SparkMD5.prototype.reset = function () {
	        this._buff = '';
	        this._length = 0;
	        this._hash = [1732584193, -271733879, -1732584194, 271733878];
	
	        return this;
	    };
	
	    /**
	     * Gets the internal state of the computation.
	     *
	     * @return {Object} The state
	     */
	    SparkMD5.prototype.getState = function () {
	        return {
	            buff: this._buff,
	            length: this._length,
	            hash: this._hash
	        };
	    };
	
	    /**
	     * Gets the internal state of the computation.
	     *
	     * @param {Object} state The state
	     *
	     * @return {SparkMD5} The instance itself
	     */
	    SparkMD5.prototype.setState = function (state) {
	        this._buff = state.buff;
	        this._length = state.length;
	        this._hash = state.hash;
	
	        return this;
	    };
	
	    /**
	     * Releases memory used by the incremental buffer and other additional
	     * resources. If you plan to use the instance again, use reset instead.
	     */
	    SparkMD5.prototype.destroy = function () {
	        delete this._hash;
	        delete this._buff;
	        delete this._length;
	    };
	
	    /**
	     * Finish the final calculation based on the tail.
	     *
	     * @param {Array}  tail   The tail (will be modified)
	     * @param {Number} length The length of the remaining buffer
	     */
	    SparkMD5.prototype._finish = function (tail, length) {
	        var i = length,
	            tmp,
	            lo,
	            hi;
	
	        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
	        if (i > 55) {
	            md5cycle(this._hash, tail);
	            for (i = 0; i < 16; i += 1) {
	                tail[i] = 0;
	            }
	        }
	
	        // Do the final computation based on the tail and length
	        // Beware that the final length may not fit in 32 bits so we take care of that
	        tmp = this._length * 8;
	        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
	        lo = parseInt(tmp[2], 16);
	        hi = parseInt(tmp[1], 16) || 0;
	
	        tail[14] = lo;
	        tail[15] = hi;
	        md5cycle(this._hash, tail);
	    };
	
	    /**
	     * Performs the md5 hash on a string.
	     * A conversion will be applied if utf8 string is detected.
	     *
	     * @param {String}  str The string
	     * @param {Boolean} raw True to get the raw string, false to get the hex string
	     *
	     * @return {String} The result
	     */
	    SparkMD5.hash = function (str, raw) {
	        // Converts the string to utf8 bytes if necessary
	        // Then compute it using the binary function
	        return SparkMD5.hashBinary(toUtf8(str), raw);
	    };
	
	    /**
	     * Performs the md5 hash on a binary string.
	     *
	     * @param {String}  content The binary string
	     * @param {Boolean} raw     True to get the raw string, false to get the hex string
	     *
	     * @return {String} The result
	     */
	    SparkMD5.hashBinary = function (content, raw) {
	        var hash = md51(content),
	            ret = hex(hash);
	
	        return raw ? hexToBinaryString(ret) : ret;
	    };
	
	    // ---------------------------------------------------
	
	    /**
	     * SparkMD5 OOP implementation for array buffers.
	     *
	     * Use this class to perform an incremental md5 ONLY for array buffers.
	     */
	    SparkMD5.ArrayBuffer = function () {
	        // call reset to init the instance
	        this.reset();
	    };
	
	    /**
	     * Appends an array buffer.
	     *
	     * @param {ArrayBuffer} arr The array to be appended
	     *
	     * @return {SparkMD5.ArrayBuffer} The instance itself
	     */
	    SparkMD5.ArrayBuffer.prototype.append = function (arr) {
	        var buff = concatenateArrayBuffers(this._buff.buffer, arr, true),
	            length = buff.length,
	            i;
	
	        this._length += arr.byteLength;
	
	        for (i = 64; i <= length; i += 64) {
	            md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
	        }
	
	        this._buff = (i - 64) < length ? new Uint8Array(buff.buffer.slice(i - 64)) : new Uint8Array(0);
	
	        return this;
	    };
	
	    /**
	     * Finishes the incremental computation, reseting the internal state and
	     * returning the result.
	     *
	     * @param {Boolean} raw True to get the raw string, false to get the hex string
	     *
	     * @return {String} The result
	     */
	    SparkMD5.ArrayBuffer.prototype.end = function (raw) {
	        var buff = this._buff,
	            length = buff.length,
	            tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
	            i,
	            ret;
	
	        for (i = 0; i < length; i += 1) {
	            tail[i >> 2] |= buff[i] << ((i % 4) << 3);
	        }
	
	        this._finish(tail, length);
	        ret = hex(this._hash);
	
	        if (raw) {
	            ret = hexToBinaryString(ret);
	        }
	
	        this.reset();
	
	        return ret;
	    };
	
	    /**
	     * Resets the internal state of the computation.
	     *
	     * @return {SparkMD5.ArrayBuffer} The instance itself
	     */
	    SparkMD5.ArrayBuffer.prototype.reset = function () {
	        this._buff = new Uint8Array(0);
	        this._length = 0;
	        this._hash = [1732584193, -271733879, -1732584194, 271733878];
	
	        return this;
	    };
	
	    /**
	     * Gets the internal state of the computation.
	     *
	     * @return {Object} The state
	     */
	    SparkMD5.ArrayBuffer.prototype.getState = function () {
	        var state = SparkMD5.prototype.getState.call(this);
	
	        // Convert buffer to a string
	        state.buff = arrayBuffer2Utf8Str(state.buff);
	
	        return state;
	    };
	
	    /**
	     * Gets the internal state of the computation.
	     *
	     * @param {Object} state The state
	     *
	     * @return {SparkMD5.ArrayBuffer} The instance itself
	     */
	    SparkMD5.ArrayBuffer.prototype.setState = function (state) {
	        // Convert string to buffer
	        state.buff = utf8Str2ArrayBuffer(state.buff, true);
	
	        return SparkMD5.prototype.setState.call(this, state);
	    };
	
	    SparkMD5.ArrayBuffer.prototype.destroy = SparkMD5.prototype.destroy;
	
	    SparkMD5.ArrayBuffer.prototype._finish = SparkMD5.prototype._finish;
	
	    /**
	     * Performs the md5 hash on an array buffer.
	     *
	     * @param {ArrayBuffer} arr The array buffer
	     * @param {Boolean}     raw True to get the raw string, false to get the hex one
	     *
	     * @return {String} The result
	     */
	    SparkMD5.ArrayBuffer.hash = function (arr, raw) {
	        var hash = md51_array(new Uint8Array(arr)),
	            ret = hex(hash);
	
	        return raw ? hexToBinaryString(ret) : ret;
	    };
	
	    return SparkMD5;
	}));


/***/ }),
/* 1773 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 1774 */
/***/ (function(module, exports) {

	
	/**
	 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
	 * embed the css on the page. This breaks all relative urls because now they are relative to a
	 * bundle instead of the current page.
	 *
	 * One solution is to only use full urls, but that may be impossible.
	 *
	 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
	 *
	 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
	 *
	 */
	
	module.exports = function (css) {
	  // get current location
	  var location = typeof window !== "undefined" && window.location;
	
	  if (!location) {
	    throw new Error("fixUrls requires window.location");
	  }
	
		// blank or null?
		if (!css || typeof css !== "string") {
		  return css;
	  }
	
	  var baseUrl = location.protocol + "//" + location.host;
	  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");
	
		// convert each url(...)
		/*
		This regular expression is just a way to recursively match brackets within
		a string.
	
		 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
		   (  = Start a capturing group
		     (?:  = Start a non-capturing group
		         [^)(]  = Match anything that isn't a parentheses
		         |  = OR
		         \(  = Match a start parentheses
		             (?:  = Start another non-capturing groups
		                 [^)(]+  = Match anything that isn't a parentheses
		                 |  = OR
		                 \(  = Match a start parentheses
		                     [^)(]*  = Match anything that isn't a parentheses
		                 \)  = Match a end parentheses
		             )  = End Group
	              *\) = Match anything and then a close parens
	          )  = Close non-capturing group
	          *  = Match anything
	       )  = Close capturing group
		 \)  = Match a close parens
	
		 /gi  = Get all matches, not the first.  Be case insensitive.
		 */
		var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
			// strip quotes (if they exist)
			var unquotedOrigUrl = origUrl
				.trim()
				.replace(/^"(.*)"$/, function(o, $1){ return $1; })
				.replace(/^'(.*)'$/, function(o, $1){ return $1; });
	
			// already a full url? no change
			if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			  return fullMatch;
			}
	
			// convert the url to a full url
			var newUrl;
	
			if (unquotedOrigUrl.indexOf("//") === 0) {
			  	//TODO: should we add protocol?
				newUrl = unquotedOrigUrl;
			} else if (unquotedOrigUrl.indexOf("/") === 0) {
				// path should be relative to the base url
				newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
			} else {
				// path should be relative to current directory
				newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
			}
	
			// send back the fixed url(...)
			return "url(" + JSON.stringify(newUrl) + ")";
		});
	
		// send back the fixed css
		return fixedCss;
	};


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1274);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(62)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./chasing-dots.css", function() {
				var newContent = require("!!../../css-loader/index.js!./chasing-dots.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1275);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(62)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./circle.css", function() {
				var newContent = require("!!../../css-loader/index.js!./circle.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1276);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(62)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./cube-grid.css", function() {
				var newContent = require("!!../../css-loader/index.js!./cube-grid.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1277);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(62)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./double-bounce.css", function() {
				var newContent = require("!!../../css-loader/index.js!./double-bounce.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1278);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(62)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./fade-in.css", function() {
				var newContent = require("!!../../css-loader/index.js!./fade-in.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1279);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(62)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./folding-cube.css", function() {
				var newContent = require("!!../../css-loader/index.js!./folding-cube.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1280);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(62)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./pulse.css", function() {
				var newContent = require("!!../../css-loader/index.js!./pulse.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1281);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(62)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./rotating-plane.css", function() {
				var newContent = require("!!../../css-loader/index.js!./rotating-plane.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1282);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(62)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./three-bounce.css", function() {
				var newContent = require("!!../../css-loader/index.js!./three-bounce.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1283);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(62)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./wandering-cubes.css", function() {
				var newContent = require("!!../../css-loader/index.js!./wandering-cubes.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1284);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(62)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./wave.css", function() {
				var newContent = require("!!../../css-loader/index.js!./wave.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1285);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(62)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./wordpress.css", function() {
				var newContent = require("!!../../css-loader/index.js!./wordpress.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"0 0 11 13\" id=\"apple-icon.7f23b83d\" > <g> <title>Apple Icon</title> <path stroke=\"null\" id=\"apple-icon.7f23b83d_svg_1\" d=\"m10.690493,10.143632c-0.194532,0.44941 -0.424795,0.863089 -0.691583,1.243419c-0.363656,0.518488 -0.66141,0.877381 -0.890879,1.076677c-0.355716,0.327132 -0.736841,0.494668 -1.144962,0.504196c-0.29299,0 -0.646324,-0.083371 -1.057621,-0.252495c-0.412647,-0.16833 -0.791866,-0.251701 -1.13861,-0.251701c-0.363656,0 -0.753674,0.083371 -1.170847,0.251701c-0.417808,0.169124 -0.754389,0.257259 -1.011727,0.265993c-0.391367,0.016674 -0.781464,-0.155626 -1.170847,-0.517694c-0.248525,-0.216765 -0.55938,-0.588361 -0.93177,-1.11479c-0.399546,-0.562159 -0.728028,-1.214041 -0.985366,-1.957234c-0.275601,-0.802744 -0.413758,-1.580079 -0.413758,-2.332642c0,-0.862056 0.186275,-1.605567 0.55938,-2.228627c0.293228,-0.500464 0.683325,-0.895246 1.171561,-1.18506s1.015777,-0.437499 1.583891,-0.446948c0.310855,0 0.718499,0.096155 1.225078,0.285129c0.505149,0.18961 0.829502,0.285764 0.971709,0.285764c0.106318,0 0.46664,-0.112432 1.077471,-0.336581c0.577642,-0.207872 1.065164,-0.293942 1.464551,-0.260038c1.082235,0.087341 1.895301,0.513963 2.436022,1.282564c-0.967898,0.586456 -1.446686,1.407859 -1.437158,2.461589c0.008734,0.820768 0.306488,1.503775 0.891673,2.046084c0.265199,0.251701 0.561365,0.446233 0.890879,0.584391c-0.071461,0.207237 -0.146892,0.405739 -0.227087,0.596301zm-2.482075,-9.767114c0,0.643315 -0.235027,1.243975 -0.703493,1.799941c-0.565335,0.660934 -1.249136,1.042852 -1.990662,0.982587c-0.009449,-0.077178 -0.014927,-0.158405 -0.014927,-0.243761c0,-0.617581 0.268852,-1.278515 0.74629,-1.818918c0.238362,-0.273616 0.541515,-0.501123 0.909141,-0.68261c0.366833,-0.178779 0.713815,-0.277649 1.040153,-0.294578c0.009528,0.085999 0.013498,0.172006 0.013498,0.257331l0,0.000008z\"/> </g> </symbol>";
	module.exports = sprite.add(image, "apple-icon.7f23b83d");

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"0 0 31 31\" id=\"arrow-circle-left.f6e62691\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <style type=\"text/css\"> #arrow-circle-left.f6e62691 .st0{fill:#51BFBB;} </style> <g> <path class=\"st0\" d=\"M15.5,0C24,0,31,7,31,15.5S24,31,15.5,31S0,24,0,15.5S7,0,15.5,0z M15.5,30c8,0,14.5-6.5,14.5-14.5\r\n\t\tS23.5,1,15.5,1S1,7.5,1,15.5S7.5,30,15.5,30z\"/> </g> <g> <path class=\"st0\" d=\"M18.2,8.1c0.1,0,0.3,0,0.4,0.1c0.2,0.2,0.2,0.5,0,0.7L12,15.5l6.6,6.6c0.2,0.2,0.2,0.5,0,0.7s-0.5,0.2-0.7,0\r\n\t\tl-6.6-6.6C11.1,16,11,15.7,11,15.5s0.1-0.5,0.3-0.6l6.6-6.6C18,8.1,18.1,8.1,18.2,8.1z\"/> </g> </symbol>";
	module.exports = sprite.add(image, "arrow-circle-left.f6e62691");

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"0 0 31 31\" id=\"arrow-circle-right.7cec88bf\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <style type=\"text/css\"> #arrow-circle-right.7cec88bf .st0{fill:#51BFBB;} </style> <g> <path class=\"st0\" d=\"M15.5,31C7,31,0,24,0,15.5S7,0,15.5,0S31,7,31,15.5S24,31,15.5,31z M15.5,1C7.5,1,1,7.5,1,15.5S7.5,30,15.5,30\r\n\t\tS30,23.5,30,15.5S23.5,1,15.5,1z\"/> </g> <g> <path class=\"st0\" d=\"M12.8,22.9c-0.1,0-0.3,0-0.4-0.1c-0.2-0.2-0.2-0.5,0-0.7l6.6-6.6l-6.6-6.6c-0.2-0.2-0.2-0.5,0-0.7\r\n\t\ts0.5-0.2,0.7,0l6.6,6.6c0.2,0.2,0.3,0.4,0.3,0.6s-0.1,0.5-0.3,0.6l-6.6,6.6C13,22.9,12.9,22.9,12.8,22.9z\"/> </g> </symbol>";
	module.exports = sprite.add(image, "arrow-circle-right.7cec88bf");

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"0 0 36.447 36.447\" id=\"icon-calendar.67772324\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <g> <path d=\"M30.224,3.948h-1.098V2.75c0-1.517-1.197-2.75-2.67-2.75c-1.474,0-2.67,1.233-2.67,2.75v1.197h-2.74V2.75\r\n\t\t\tc0-1.517-1.197-2.75-2.67-2.75c-1.473,0-2.67,1.233-2.67,2.75v1.197h-2.74V2.75c0-1.517-1.197-2.75-2.67-2.75\r\n\t\t\tc-1.473,0-2.67,1.233-2.67,2.75v1.197H6.224c-2.343,0-4.25,1.907-4.25,4.25v24c0,2.343,1.907,4.25,4.25,4.25h24\r\n\t\t\tc2.344,0,4.25-1.907,4.25-4.25v-24C34.474,5.855,32.567,3.948,30.224,3.948z M25.286,2.75c0-0.689,0.525-1.25,1.17-1.25\r\n\t\t\tc0.646,0,1.17,0.561,1.17,1.25v4.896c0,0.689-0.524,1.25-1.17,1.25c-0.645,0-1.17-0.561-1.17-1.25V2.75z M17.206,2.75\r\n\t\t\tc0-0.689,0.525-1.25,1.17-1.25s1.17,0.561,1.17,1.25v4.896c0,0.689-0.525,1.25-1.17,1.25s-1.17-0.561-1.17-1.25V2.75z M9.125,2.75\r\n\t\t\tc0-0.689,0.525-1.25,1.17-1.25s1.17,0.561,1.17,1.25v4.896c0,0.689-0.525,1.25-1.17,1.25s-1.17-0.561-1.17-1.25V2.75z\r\n\t\t\t M31.974,32.198c0,0.965-0.785,1.75-1.75,1.75h-24c-0.965,0-1.75-0.785-1.75-1.75v-22h27.5V32.198z\"/> <rect x=\"6.724\" y=\"14.626\" width=\"4.595\" height=\"4.089\"/> <rect x=\"12.857\" y=\"14.626\" width=\"4.596\" height=\"4.089\"/> <rect x=\"18.995\" y=\"14.626\" width=\"4.595\" height=\"4.089\"/> <rect x=\"25.128\" y=\"14.626\" width=\"4.596\" height=\"4.089\"/> <rect x=\"6.724\" y=\"20.084\" width=\"4.595\" height=\"4.086\"/> <rect x=\"12.857\" y=\"20.084\" width=\"4.596\" height=\"4.086\"/> <rect x=\"18.995\" y=\"20.084\" width=\"4.595\" height=\"4.086\"/> <rect x=\"25.128\" y=\"20.084\" width=\"4.596\" height=\"4.086\"/> <rect x=\"6.724\" y=\"25.54\" width=\"4.595\" height=\"4.086\"/> <rect x=\"12.857\" y=\"25.54\" width=\"4.596\" height=\"4.086\"/> <rect x=\"18.995\" y=\"25.54\" width=\"4.595\" height=\"4.086\"/> <rect x=\"25.128\" y=\"25.54\" width=\"4.596\" height=\"4.086\"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </symbol>";
	module.exports = sprite.add(image, "icon-calendar.67772324");

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"0 0 26 21\" id=\"icon-email.e43740eb\" > <path d=\"M3.74219 20.6523H22.6094C24.7188 20.6523 25.9375 19.4336 25.9375 17.0195V4.08203C25.9375 1.67969 24.707 0.460938 22.2578 0.460938H3.39062C1.28125 0.460938 0.0625 1.66797 0.0625 4.08203V17.0195C0.0625 19.4453 1.29297 20.6523 3.74219 20.6523ZM11.6055 11.1484L2.75781 2.41797C3.01562 2.3125 3.32031 2.25391 3.67188 2.25391H22.3281C22.6914 2.25391 23.0078 2.3125 23.2656 2.42969L14.4414 11.1484C13.9375 11.6523 13.4805 11.875 13.0234 11.875C12.5547 11.875 12.0977 11.6406 11.6055 11.1484ZM1.85547 17.0195V4.08203C1.85547 3.98828 1.85547 4.03516 1.85547 3.95312L8.59375 10.5742L1.86719 17.2188C1.85547 17.1602 1.85547 17.0898 1.85547 17.0195ZM24.1445 4.09375V17.0312C24.1445 17.0781 24.1445 17.1367 24.1445 17.1836L17.4531 10.5742L24.1445 3.98828C24.1445 4.09375 24.1445 4.09375 24.1445 4.09375ZM3.67188 18.8594C3.34375 18.8594 3.0625 18.8125 2.81641 18.707L9.82422 11.7812L10.5859 12.5312C11.4062 13.3398 12.1914 13.6797 13.0234 13.6797C13.8438 13.6797 14.6406 13.3398 15.4609 12.5312L16.2227 11.7812L23.2188 18.6953C22.9609 18.8125 22.668 18.8594 22.3281 18.8594H3.67188Z\" fill=\"white\"/> </symbol>";
	module.exports = sprite.add(image, "icon-email.e43740eb");

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"0 0 24 25\" id=\"icon-facebook.a34c7cee\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <!-- Generator: sketchtool 3.8.3 (29802) - http://www.bohemiancoding.com/sketch --> <title>892DC7FA-4FDD-4AF7-8ED4-B528488E6C8C</title> <desc>Created with sketchtool.</desc> <defs/> <g id=\"icon-facebook.a34c7cee_Squire-Website\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\"> <g id=\"icon-facebook.a34c7cee_Homepage-Dark-UI\" transform=\"translate(-1209.000000, -4940.000000)\"> <g id=\"icon-facebook.a34c7cee_facebook\" transform=\"translate(1209.000000, 4940.000000)\"> <path d=\"M22.666436,3.60514505e-05 L1.32405393,3.60514505e-05 C0.59272809,3.60514505e-05 8.98876169e-06,0.594344212 8.98876169e-06,1.32763071 L8.98876169e-06,22.7272309 C8.98876169e-06,23.4604273 0.59272809,24.0549157 1.32405393,24.0549157 L12.8141213,24.0549157 L12.8141213,14.7395814 L9.68764944,14.7395814 L9.68764944,11.1092004 L12.8141213,11.1092004 L12.8141213,8.43192954 C12.8141213,5.32501554 14.7066157,3.6332111 17.4708404,3.6332111 C18.7949753,3.6332111 19.9329528,3.73199207 20.2645483,3.7761551 L20.2645483,7.02312898 L18.3474247,7.02403027 C16.8441438,7.02403027 16.5529978,7.74028246 16.5529978,8.7913625 L16.5529978,11.1092004 L20.1383461,11.1092004 L19.6715596,14.7395814 L16.5529978,14.7395814 L16.5529978,24.0549157 L22.666436,24.0549157 C23.3976719,24.0549157 23.9904809,23.4604273 23.9904809,22.7272309 L23.9904809,1.32763071 C23.9904809,0.594344212 23.3976719,3.60514505e-05 22.666436,3.60514505e-05\" id=\"icon-facebook.a34c7cee_Fill-1\"/> </g> </g> </g> </symbol>";
	module.exports = sprite.add(image, "icon-facebook.a34c7cee");

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"0 0 24 25\" id=\"icon-instagram.24157930\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <!-- Generator: sketchtool 3.8.3 (29802) - http://www.bohemiancoding.com/sketch --> <title>F41B7FDF-1D12-47B6-A009-DEEC8A55C15D</title> <desc>Created with sketchtool.</desc> <defs/> <g id=\"icon-instagram.24157930_Squire-Website\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\"> <g id=\"icon-instagram.24157930_Homepage-Dark-UI\" transform=\"translate(-1266.000000, -4940.000000)\"> <g id=\"icon-instagram.24157930_instagram\" transform=\"translate(1266.000000, 4940.000000)\"> <path d=\"M21.3333333,6.68453977 C21.3333333,7.05369348 21.0348333,7.35299374 20.6666667,7.35299374 L17.3333333,7.35299374 C16.9651667,7.35299374 16.6666667,7.05369348 16.6666667,6.68453977 L16.6666667,3.34226988 C16.6666667,2.97311618 16.9651667,2.67381591 17.3333333,2.67381591 L20.6666667,2.67381591 C21.0348333,2.67381591 21.3333333,2.97311618 21.3333333,3.34226988 L21.3333333,6.68453977 L21.3333333,6.68453977 Z M21.3333333,20.7220733 C21.3333333,21.091227 21.0348333,21.3905273 20.6666667,21.3905273 L3.33333333,21.3905273 C2.96516667,21.3905273 2.66666667,21.091227 2.66666667,20.7220733 L2.66666667,10.0268097 L4.94283333,10.0268097 C4.763,10.6642641 4.66666667,11.3369794 4.66666667,12.0321716 C4.66666667,16.093113 7.94991667,19.3851653 12,19.3851653 C16.0500833,19.3851653 19.3333333,16.093113 19.3333333,12.0321716 C19.3333333,11.3369794 19.237,10.6642641 19.0571667,10.0268097 L21.3333333,10.0268097 L21.3333333,20.7220733 L21.3333333,20.7220733 Z M12,7.35299374 C14.5773333,7.35299374 16.6666667,9.44792851 16.6666667,12.0321716 C16.6666667,14.6164147 14.5773333,16.7113494 12,16.7113494 C9.42266667,16.7113494 7.33333333,14.6164147 7.33333333,12.0321716 C7.33333333,9.44792851 9.42266667,7.35299374 12,7.35299374 L12,7.35299374 Z M20.6666667,0 L3.33333333,0 C1.49241667,0 0,1.49641778 0,3.34226988 L0,20.7220733 C0,22.5679254 1.49241667,24.0643432 3.33333333,24.0643432 L20.6666667,24.0643432 C22.5075833,24.0643432 24,22.5679254 24,20.7220733 L24,3.34226988 C24,1.49641778 22.5075833,0 20.6666667,0 L20.6666667,0 Z\" id=\"icon-instagram.24157930_Fill-1\"/> </g> </g> </g> </symbol>";
	module.exports = sprite.add(image, "icon-instagram.24157930");

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"0 0 25 25\" id=\"icon-linkedin.3bd86b58\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <!-- Generator: sketchtool 3.8.3 (29802) - http://www.bohemiancoding.com/sketch --> <title>E2488BB8-F4C5-4FFF-967B-BE6D6F141D1C</title> <desc>Created with sketchtool.</desc> <defs/> <g id=\"icon-linkedin.3bd86b58_Squire-Website\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\"> <g id=\"icon-linkedin.3bd86b58_Homepage-Dark-UI\" transform=\"translate(-1101.000000, -4939.000000)\"> <g id=\"icon-linkedin.3bd86b58_linkedin\" transform=\"translate(1101.000000, 4939.000000)\"> <path d=\"M21.0880109,20.5054942 L17.426555,20.5054942 L17.426555,14.9205612 C17.426555,13.5890009 17.4025477,11.8757534 15.5231192,11.8757534 C13.6176256,11.8757534 13.3267943,13.3269669 13.3267943,14.8256408 L13.3267943,20.5054942 L9.66876797,20.5054942 L9.66876797,9.02145487 L13.1793209,9.02145487 L13.1793209,10.5916533 L13.2293933,10.5916533 C13.7177703,9.68857194 14.9133338,8.73669348 16.6953613,8.73669348 C20.4027741,8.73669348 21.0880109,11.1143843 21.0880109,14.2073208 L21.0880109,20.5054942 L21.0880109,20.5054942 Z M5.53882671,7.45259339 C4.36246909,7.45259339 3.41452376,6.52544772 3.41452376,5.38239142 C3.41452376,4.24000357 4.36246909,3.31285791 5.53882671,3.31285791 C6.71038287,3.31285791 7.66175782,4.24000357 7.66175782,5.38239142 C7.66175782,6.52544772 6.71038287,7.45259339 5.53882671,7.45259339 L5.53882671,7.45259339 Z M3.70535503,20.5054942 L7.37092654,20.5054942 L7.37092654,9.02145487 L3.70535503,9.02145487 L3.70535503,20.5054942 Z M22.9118797,0 L1.86776782,0 C0.862890898,0 0.0459568284,0.776743521 0.0459568284,1.73530652 L0.0459568284,22.3276997 C0.0459568284,23.2862627 0.862890898,24.0643432 1.86776782,24.0643432 L22.9118797,24.0643432 C23.9195003,24.0643432 24.7384922,23.2862627 24.7384922,22.3276997 L24.7384922,1.73530652 C24.7384922,0.776743521 23.9195003,0 22.9118797,0 L22.9118797,0 Z\" id=\"icon-linkedin.3bd86b58_Fill-10\"/> </g> </g> </g> </symbol>";
	module.exports = sprite.add(image, "icon-linkedin.3bd86b58");

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"0 0 30 30\" id=\"icon-search.82924876\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <style type=\"text/css\"> #icon-search.82924876 .st0{fill:#E2E2E2;} </style> <path id=\"icon-search.82924876_XMLID_2_\" class=\"st0\" d=\"M23.5,21.2C23.5,21.2,23.5,21.2,23.5,21.2c-2-1.7-3.3-3-4-3.6c-0.1-0.1-0.2-0.1-0.2-0.2\r\n\tc-0.2-0.2-0.3-0.5-0.3-0.7c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2c0.4-0.9,0.7-1.9,0.7-3c0-3.8-3.1-7-6.9-7\r\n\tc0,0,0,0,0,0C9.2,6,6.1,9.1,6,12.9c0,3.8,3.1,7,6.9,7c0,0,0,0,0,0c1.1,0,2.1-0.3,3.1-0.7c0,0,0,0,0.1,0c0.1-0.1,0.3-0.1,0.4-0.1\r\n\tc0,0,0,0,0.1,0c0.3,0,0.5,0.1,0.7,0.3c0.1,0.1,0.1,0.1,0.2,0.2c0.6,0.7,2,2,3.7,4c0,0,0,0,0,0c0.6,0.6,1.6,0.6,2.3-0.1\r\n\tC24.1,22.8,24.1,21.7,23.5,21.2z M16.6,16.6c-0.6,0.6-1.2,1-2,1.2c-0.5,0.2-1.1,0.3-1.7,0.3h0c-2.8,0-5.2-2.4-5.1-5.2\r\n\tc0-2.8,2.3-5.1,5.2-5.1h0c1.4,0,2.7,0.6,3.6,1.5c1,1,1.5,2.3,1.5,3.7c0,0.6-0.1,1.2-0.3,1.8C17.6,15.5,17.2,16.1,16.6,16.6z\"/> </symbol>";
	module.exports = sprite.add(image, "icon-search.82924876");

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"0 0 28 25\" id=\"icon-sms.c6c1db95\" > <path d=\"M5.79688 24.8203C7.37891 24.8203 10.6133 23.2266 12.9922 21.5273C21.1602 21.75 27.2891 17.0625 27.2891 10.9219C27.2891 5.02734 21.3828 0.269531 14 0.269531C6.61719 0.269531 0.710938 5.02734 0.710938 10.9219C0.710938 14.7656 3.17188 18.1758 6.875 19.8867C6.34766 20.9062 5.36328 22.2891 4.83594 22.9805C4.21484 23.8008 4.58984 24.8203 5.79688 24.8203ZM7.02734 22.875C6.93359 22.9102 6.89844 22.8398 6.95703 22.7578C7.61328 21.9492 8.55078 20.7305 8.94922 19.9805C9.27734 19.3711 9.19531 18.832 8.44531 18.4805C4.76562 16.7695 2.65625 14.0391 2.65625 10.9219C2.65625 6.11719 7.68359 2.20312 14 2.20312C20.3281 2.20312 25.3555 6.11719 25.3555 10.9219C25.3555 15.7148 20.3281 19.6289 14 19.6289C13.7656 19.6289 13.4023 19.6172 12.9336 19.6055C12.4414 19.6055 12.0664 19.7578 11.6211 20.1094C10.1797 21.1523 8.09375 22.4414 7.02734 22.875Z\" fill=\"white\"/> </symbol>";
	module.exports = sprite.add(image, "icon-sms.c6c1db95");

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"0 0 30 25\" id=\"icon-twitter.3ed33eaf\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <!-- Generator: sketchtool 3.8.3 (29802) - http://www.bohemiancoding.com/sketch --> <title>CE8E1EFC-2C52-430A-AF67-D0914D487930</title> <desc>Created with sketchtool.</desc> <defs/> <g id=\"icon-twitter.3ed33eaf_Squire-Website\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\"> <g id=\"icon-twitter.3ed33eaf_Homepage-Dark-UI\" transform=\"translate(-1152.000000, -4940.000000)\"> <g id=\"icon-twitter.3ed33eaf_twitter\" transform=\"translate(1152.000000, 4940.000000)\"> <path d=\"M29.423139,2.92689318 C28.3405561,3.40828796 27.177148,3.73364219 25.9560538,3.87997067 C27.2024395,3.13084658 28.1595336,1.9446795 28.6102601,0.531357963 C27.4439462,1.22490744 26.1520359,1.72863997 24.7770404,2.00014619 C23.6758386,0.823799084 22.1070135,0.088703543 20.3708341,0.088703543 C17.0369865,0.088703543 14.3341345,2.7986939 14.3341345,6.14126354 C14.3341345,6.61564404 14.3876233,7.07761469 14.4905112,7.52059284 C9.4735426,7.26818702 5.02557848,4.85851535 2.048287,1.19663454 C1.52868161,2.09057632 1.23099552,3.13030702 1.23099552,4.23953296 C1.23099552,6.3393897 2.29678924,8.19202039 3.91652018,9.2773978 C2.92692377,9.24599546 1.99619731,8.97373385 1.18224215,8.52039616 C1.18181166,8.54564753 1.18181166,8.57100682 1.18181166,8.59647401 C1.18181166,11.5290865 3.2626009,13.9754482 6.02410762,14.5314101 C5.51752466,14.6697531 4.98425112,14.7436727 4.43365022,14.7436727 C4.04469955,14.7436727 3.66651121,14.7057956 3.29800897,14.6351134 C4.06611659,17.0398211 6.29542601,18.7897197 8.93693274,18.8386038 C6.87099552,20.4619218 4.26812556,21.4295674 1.44,21.4295674 C0.952789238,21.4295674 0.472251121,21.4009707 0,21.3450724 C2.67142601,23.0623816 5.8444843,24.0643432 9.25345291,24.0643432 C20.3567354,24.0643432 26.4284126,14.8414408 26.4284126,6.84312223 C26.4284126,6.5806806 26.4226009,6.31964183 26.4109776,6.06011383 C27.5903139,5.2067469 28.6138117,4.1406857 29.423139,2.92689318\" id=\"icon-twitter.3ed33eaf_Fill-1\"/> </g> </g> </g> </symbol>";
	module.exports = sprite.add(image, "icon-twitter.3ed33eaf");

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"0 0 12 12\" id=\"info.42610ae9\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <!-- Generator: Sketch 43.2 (39069) - http://www.bohemiancoding.com/sketch --> <title>Page 1</title> <desc>Created with Sketch.</desc> <defs/> <g id=\"info.42610ae9_Desktop\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <g id=\"info.42610ae9_01.0-I-Want-To-Copy-2\" transform=\"translate(-518.000000, -267.000000)\" fill=\"#00A79D\"> <g id=\"info.42610ae9_Page-1\" transform=\"translate(518.000000, 267.000000)\"> <path d=\"M6,11.9888727 C9.30501818,11.9888727 11.9888727,9.30501818 11.9888727,6 C11.9888727,2.69498182 9.30501818,0.0111272727 6,0.0111272727 C2.69498182,0.0111272727 0.0111272727,2.69498182 0.0111272727,6 C0.0111272727,9.30501818 2.69498182,11.9888727 6,11.9888727 Z M6,0.992945455 C8.76567273,0.992945455 11.0070545,3.23432727 11.0070545,6 C11.0070545,8.76567273 8.76567273,11.0070545 6,11.0070545 C3.23432727,11.0070545 0.992945455,8.76567273 0.992945455,6 C0.992945455,3.23432727 3.23432727,0.992945455 6,0.992945455 Z\" id=\"info.42610ae9_Fill-1\"/> <path d=\"M5.98385455,9.10909091 C6.2616,9.10909091 6.47476364,8.89592727 6.47476364,8.61818182 L6.47476364,5.50909091 C6.47476364,5.23134545 6.2616,5.01818182 5.98385455,5.01818182 C5.70589091,5.01818182 5.49294545,5.23134545 5.49294545,5.50909091 L5.49294545,8.61818182 C5.49294545,8.89592727 5.72225455,9.10909091 5.98385455,9.10909091 Z\" id=\"info.42610ae9_Fill-2\"/> <path d=\"M5.98385455,4.2 C6.2616,4.2 6.47476364,3.98683636 6.47476364,3.70909091 L6.47476364,3.21818182 C6.47476364,2.94043636 6.2616,2.72727273 5.98385455,2.72727273 C5.70589091,2.72727273 5.49294545,2.94043636 5.49294545,3.21818182 L5.49294545,3.70909091 C5.49294545,3.98683636 5.72225455,4.2 5.98385455,4.2 Z\" id=\"info.42610ae9_Fill-3\"/> </g> </g> </g> </symbol>";
	module.exports = sprite.add(image, "info.42610ae9");

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"-2 0 8 8\" id=\"next-week.a2f173e0\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <!-- Generator: Sketch 43.2 (39069) - http://www.bohemiancoding.com/sketch --> <title>Page 1</title> <desc>Created with Sketch.</desc> <defs/> <g id=\"next-week.a2f173e0_Desktop\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <g id=\"next-week.a2f173e0_01.0-I-Want-To-Copy-3\" transform=\"translate(-778.000000, -517.000000)\" fill=\"#00A79D\"> <g id=\"next-week.a2f173e0_Time\" transform=\"translate(0.000000, 493.000000)\"> <path d=\"M782.90829,27.9189339 L779.007874,24.0333331 C778.96343,23.988889 778.904171,23.988889 778.859727,24.0333331 L778,24.8930601 L781.039859,27.9184599 C781.069962,27.9625484 781.069962,28.0369775 781.039859,28.0810661 L778,31.1069399 L778.859727,31.9666669 C778.904171,32.011111 778.96343,32.011111 779.007874,31.9666669 L782.90829,28.0815401 C782.952734,28.0369775 782.952734,27.9630225 782.90829,27.9189339 Z\" id=\"next-week.a2f173e0_Page-1\"/> </g> </g> </g> </symbol>";
	module.exports = sprite.add(image, "next-week.a2f173e0");

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"-2 0 8 8\" id=\"prev-week.f36a107b\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <!-- Generator: Sketch 43.2 (39069) - http://www.bohemiancoding.com/sketch --> <title>Page 1 Copy 3</title> <desc>Created with Sketch.</desc> <defs/> <g id=\"prev-week.f36a107b_Desktop\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <g id=\"prev-week.f36a107b_01.0-I-Want-To-Copy-3\" transform=\"translate(-660.000000, -517.000000)\" fill=\"#00A79D\"> <g id=\"prev-week.f36a107b_Time\" transform=\"translate(0.000000, 493.000000)\"> <path d=\"M664.90829,27.9189339 L661.007874,24.0333331 C660.96343,23.988889 660.904171,23.988889 660.859727,24.0333331 L660,24.8930601 L663.039859,27.9184599 C663.069962,27.9625484 663.069962,28.0369775 663.039859,28.0810661 L660,31.1069399 L660.859727,31.9666669 C660.904171,32.011111 660.96343,32.011111 661.007874,31.9666669 L664.90829,28.0815401 C664.952734,28.0369775 664.952734,27.9630225 664.90829,27.9189339 Z\" id=\"prev-week.f36a107b_Page-1-Copy-3\" transform=\"translate(662.470811, 28.000000) scale(-1, 1) translate(-662.470811, -28.000000) \"/> </g> </g> </g> </symbol>";
	module.exports = sprite.add(image, "prev-week.f36a107b");

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"0 0 15 13\" id=\"send-arrow.e107f734\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <title>5AE2619E-9DDE-40AA-9E8C-8D010BD68742</title> <g id=\"send-arrow.e107f734_14-Water-2\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <g id=\"send-arrow.e107f734_Confirmation-Page\" transform=\"translate(-710.000000, -939.000000)\" fill=\"#FFFFFF\" fill-rule=\"nonzero\"> <g id=\"send-arrow.e107f734_Text-Message\" transform=\"translate(445.000000, 788.000000)\"> <g id=\"send-arrow.e107f734_Group-7\" transform=\"translate(248.000000, 134.000000)\"> <path d=\"M25.3980762,29.4760742 C25.6324512,29.4760742 25.859502,29.3808594 26.0572559,29.1831055 L30.8619434,24.3930664 C31.0450488,24.2099609 31.1549121,23.9536133 31.1549121,23.6972656 C31.1549121,23.440918 31.0450488,23.1772461 30.8619434,23.0014648 L26.0719043,18.2114258 C25.8668262,18.0063477 25.6324512,17.9111328 25.3980762,17.9111328 C24.856084,17.9111328 24.4752246,18.2993164 24.4752246,18.8046875 C24.4752246,19.0830078 24.5924121,19.3027344 24.7608691,19.4785156 L26.4234668,21.1484375 L28.2764941,22.8476562 L26.6285449,22.7597656 L18.0518848,22.7597656 C17.4732715,22.7597656 17.0850879,23.140625 17.0850879,23.6972656 C17.0850879,24.2539062 17.4732715,24.6347656 18.0518848,24.6347656 L26.6285449,24.6347656 L28.2764941,24.5395508 L26.4234668,26.2460938 L24.7608691,27.9086914 C24.5924121,28.0844727 24.4752246,28.3041992 24.4752246,28.5825195 C24.4752246,29.0952148 24.856084,29.4760742 25.3980762,29.4760742 Z\" id=\"send-arrow.e107f734_Arrow\"/> </g> </g> </g> </g> </symbol>";
	module.exports = sprite.add(image, "send-arrow.e107f734");

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"0 0 7 12\" id=\"slide-arrow-left.0befe675\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <style type=\"text/css\"> #slide-arrow-left.0befe675 .st0{fill:#C3C3C3;} </style> <title>E4D9AA4A-D82B-4EC8-8766-F7DDA49C3E7D</title> <desc>Created with sketchtool.</desc> <g id=\"slide-arrow-left.0befe675_Squire-Website\"> <g id=\"slide-arrow-left.0befe675__x28_Shops_x29_-Pick-A-Time\" transform=\"translate(-165.000000, -544.000000)\"> <g id=\"slide-arrow-left.0befe675_Up-Arrow\"> <path class=\"st0\" d=\"M171,555.4c-0.1,0-0.3,0-0.4-0.1l-5.4-5.3l5.4-5.3c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-4.6,4.6\n\t\t\t\tl4.6,4.6c0.2,0.2,0.2,0.5,0,0.7C171.3,555.3,171.1,555.4,171,555.4z\"/> </g> </g> </g> </symbol>";
	module.exports = sprite.add(image, "slide-arrow-left.0befe675");

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(50);
	var image = "<symbol viewBox=\"0 0 7 12\" id=\"slide-arrow-right.0056ddf8\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <style type=\"text/css\"> #slide-arrow-right.0056ddf8 .st0{fill:#C3C3C3;} </style> <title>E4D9AA4A-D82B-4EC8-8766-F7DDA49C3E7D</title> <desc>Created with sketchtool.</desc> <g id=\"slide-arrow-right.0056ddf8_Squire-Website\"> <g id=\"slide-arrow-right.0056ddf8__x28_Shops_x29_-Pick-A-Time\" transform=\"translate(-165.000000, -544.000000)\"> <g id=\"slide-arrow-right.0056ddf8_Up-Arrow\"> <path class=\"st0\" d=\"M165.8,555.4c0.1,0,0.3,0,0.4-0.1l5.4-5.3l-5.4-5.3c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7l4.6,4.6\n\t\t\t\tl-4.6,4.6c-0.2,0.2-0.2,0.5,0,0.7C165.5,555.3,165.7,555.4,165.8,555.4z\"/> </g> </g> </g> </symbol>";
	module.exports = sprite.add(image, "slide-arrow-right.0056ddf8");

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	var Sniffr = __webpack_require__(1771);
	
	/**
	 * List of SVG attributes to fix url target in them
	 * @type {string[]}
	 */
	var fixAttributes = [
	  'clipPath',
	  'colorProfile',
	  'src',
	  'cursor',
	  'fill',
	  'filter',
	  'marker',
	  'markerStart',
	  'markerMid',
	  'markerEnd',
	  'mask',
	  'stroke'
	];
	
	/**
	 * Query to find'em
	 * @type {string}
	 */
	var fixAttributesQuery = '[' + fixAttributes.join('],[') + ']';
	/**
	 * @type {RegExp}
	 */
	var URI_FUNC_REGEX = /^url\((.*)\)$/;
	
	/**
	 * Convert array-like to array
	 * @param {Object} arrayLike
	 * @returns {Array.<*>}
	 */
	function arrayFrom(arrayLike) {
	  return Array.prototype.slice.call(arrayLike, 0);
	}
	
	/**
	 * Handles forbidden symbols which cannot be directly used inside attributes with url(...) content.
	 * Adds leading slash for the brackets
	 * @param {string} url
	 * @return {string} encoded url
	 */
	function encodeUrlForEmbedding(url) {
	  return url.replace(/\(|\)/g, "\\$&");
	}
	
	/**
	 * Replaces prefix in `url()` functions
	 * @param {Element} svg
	 * @param {string} currentUrlPrefix
	 * @param {string} newUrlPrefix
	 */
	function baseUrlWorkAround(svg, currentUrlPrefix, newUrlPrefix) {
	  var nodes = svg.querySelectorAll(fixAttributesQuery);
	
	  if (!nodes) {
	    return;
	  }
	
	  arrayFrom(nodes).forEach(function (node) {
	    if (!node.attributes) {
	      return;
	    }
	
	    arrayFrom(node.attributes).forEach(function (attribute) {
	      var attributeName = attribute.localName.toLowerCase();
	
	      if (fixAttributes.indexOf(attributeName) !== -1) {
	        var match = URI_FUNC_REGEX.exec(node.getAttribute(attributeName));
	
	        // Do not touch urls with unexpected prefix
	        if (match && match[1].indexOf(currentUrlPrefix) === 0) {
	          var referenceUrl = encodeUrlForEmbedding(newUrlPrefix + match[1].split(currentUrlPrefix)[1]);
	          node.setAttribute(attributeName, 'url(' + referenceUrl + ')');
	        }
	      }
	    });
	  });
	}
	
	/**
	 * Because of Firefox bug #353575 gradients and patterns don't work if they are within a symbol.
	 * To workaround this we move the gradient definition outside the symbol element
	 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=353575
	 * @param {Element} svg
	 */
	var FirefoxSymbolBugWorkaround = function (svg) {
	  var defs = svg.querySelector('defs');
	
	  var moveToDefsElems = svg.querySelectorAll('symbol linearGradient, symbol radialGradient, symbol pattern');
	  for (var i = 0, len = moveToDefsElems.length; i < len; i++) {
	    defs.appendChild(moveToDefsElems[i]);
	  }
	};
	
	/**
	 * Fix for browser (IE, maybe other too) which are throwing 'WrongDocumentError'
	 * if you insert an element which is not part of the document
	 * @see http://stackoverflow.com/questions/7981100/how-do-i-dynamically-insert-an-svg-image-into-html#7986519
	 * @param {Element} svg
	 */
	function importSvg(svg) {
	  try {
	    if (document.importNode) {
	      return document.importNode(svg, true);
	    }
	  } catch(e) {}
	
	  return svg;
	}
	
	/**
	 * @type {string}
	 */
	var DEFAULT_URI_PREFIX = '#';
	
	/**
	 * @type {string}
	 */
	var xLinkHref = 'xlink:href';
	/**
	 * @type {string}
	 */
	var xLinkNS = 'http://www.w3.org/1999/xlink';
	/**
	 * @type {string}
	 */
	var svgOpening = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="' + xLinkNS + '"';
	/**
	 * @type {string}
	 */
	var svgClosing = '</svg>';
	/**
	 * @type {string}
	 */
	var contentPlaceHolder = '{content}';
	
	/**
	 * Representation of SVG sprite
	 * @constructor
	 */
	function Sprite() {
	  var baseElement = document.getElementsByTagName('base')[0];
	  var currentUrl = window.location.href.split('#')[0];
	  var baseUrl = baseElement && baseElement.href;
	  this.urlPrefix = baseUrl && baseUrl !== currentUrl ? currentUrl + DEFAULT_URI_PREFIX : DEFAULT_URI_PREFIX;
	
	  var sniffr = new Sniffr();
	  sniffr.sniff();
	  this.browser = sniffr.browser;
	  this.content = [];
	
	  if (this.browser.name !== 'ie' && baseUrl) {
	    window.addEventListener('spriteLoaderLocationUpdated', function (e) {
	      var currentPrefix = this.urlPrefix;
	      var newUrlPrefix = e.detail.newUrl.split(DEFAULT_URI_PREFIX)[0] + DEFAULT_URI_PREFIX;
	      baseUrlWorkAround(this.svg, currentPrefix, newUrlPrefix);
	      this.urlPrefix = newUrlPrefix;
	
	      if (this.browser.name === 'firefox' || this.browser.name === 'edge' || this.browser.name === 'chrome' && this.browser.version[0] >= 49) {
	        var nodes = arrayFrom(document.querySelectorAll('use[*|href]'));
	        nodes.forEach(function (node) {
	          var href = node.getAttribute(xLinkHref);
	          if (href && href.indexOf(currentPrefix) === 0) {
	            node.setAttributeNS(xLinkNS, xLinkHref, newUrlPrefix + href.split(DEFAULT_URI_PREFIX)[1]);
	          }
	        });
	      }
	    }.bind(this));
	  }
	}
	
	Sprite.styles = ['position:absolute', 'width:0', 'height:0'];
	
	Sprite.spriteTemplate = function(){ return svgOpening + ' style="'+ Sprite.styles.join(';') +'"><defs>' + contentPlaceHolder + '</defs>' + svgClosing; }
	Sprite.symbolTemplate = function() { return svgOpening + '>' + contentPlaceHolder + svgClosing; }
	
	/**
	 * @type {Array<String>}
	 */
	Sprite.prototype.content = null;
	
	/**
	 * @param {String} content
	 * @param {String} id
	 */
	Sprite.prototype.add = function (content, id) {
	  if (this.svg) {
	    this.appendSymbol(content);
	  }
	
	  this.content.push(content);
	
	  return DEFAULT_URI_PREFIX + id;
	};
	
	/**
	 *
	 * @param content
	 * @param template
	 * @returns {Element}
	 */
	Sprite.prototype.wrapSVG = function (content, template) {
	  var svgString = template.replace(contentPlaceHolder, content);
	
	  var svg = new DOMParser().parseFromString(svgString, 'image/svg+xml').documentElement;
	  var importedSvg = importSvg(svg);
	
	  if (this.browser.name !== 'ie' && this.urlPrefix) {
	    baseUrlWorkAround(importedSvg, DEFAULT_URI_PREFIX, this.urlPrefix);
	  }
	
	  return importedSvg;
	};
	
	Sprite.prototype.appendSymbol = function (content) {
	  var symbol = this.wrapSVG(content, Sprite.symbolTemplate()).childNodes[0];
	
	  this.svg.querySelector('defs').appendChild(symbol);
	  if (this.browser.name === 'firefox') {
	    FirefoxSymbolBugWorkaround(this.svg);
	  }
	};
	
	/**
	 * @returns {String}
	 */
	Sprite.prototype.toString = function () {
	  var wrapper = document.createElement('div');
	  wrapper.appendChild(this.render());
	  return wrapper.innerHTML;
	};
	
	/**
	 * @param {HTMLElement} [target]
	 * @param {Boolean} [prepend=true]
	 * @returns {HTMLElement} Rendered sprite node
	 */
	Sprite.prototype.render = function (target, prepend) {
	  target = target || null;
	  prepend = typeof prepend === 'boolean' ? prepend : true;
	
	  var svg = this.wrapSVG(this.content.join(''), Sprite.spriteTemplate());
	
	  if (this.browser.name === 'firefox') {
	    FirefoxSymbolBugWorkaround(svg);
	  }
	
	  if (target) {
	    if (prepend && target.childNodes[0]) {
	      target.insertBefore(svg, target.childNodes[0]);
	    } else {
	      target.appendChild(svg);
	    }
	  }
	
	  this.svg = svg;
	
	  return svg;
	};
	
	module.exports = Sprite;


/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _sweetalert = __webpack_require__(1812);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _lodash = __webpack_require__(527);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _mousetrap = __webpack_require__(1518);
	
	var _mousetrap2 = _interopRequireDefault(_mousetrap);
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _outsideTargetHandlerFactory = __webpack_require__(1807);
	
	var _outsideTargetHandlerFactory2 = _interopRequireDefault(_outsideTargetHandlerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ALLOWS_KEYS = ['title', 'text', 'type', 'customClass', 'showCancelButton', 'showConfirmButton', 'confirmButtonText', 'confirmButtonColor', 'cancelButtonText', 'imageUrl', 'imageSize', 'html', 'animation', 'inputType', 'inputValue', 'inputPlaceholder', 'showLoaderOnConfirm'];
	
	var REMOVED_KEYS = ['timer', 'closeOnConfirm', 'closeOnCancel', 'allowOutsideClick', 'allowEscapeKey'];
	
	var OVERWRITE_PROPS = {
	  closeOnConfirm: false,
	  closeOnCancel: false,
	  allowOutsideClick: false,
	  allowEscapeKey: false
	};
	
	// reference: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input
	var ALLOWS_INPUT_TYPES = ['button', 'checkbox', 'color', 'date', 'datetime', 'datetime-local', 'email', 'file', 'hidden', 'image', 'month', 'number', 'password', 'radio', 'range', 'reset', 'search', 'submit', 'tel', 'text', 'time', 'url', 'week'];
	
	function warningRemoved(props) {
	  REMOVED_KEYS.forEach(function (key) {
	    (0, _warning2.default)(props[key] === undefined, '%s has been removed from sweetalert-react, pass `show` props and use event hook instead.', '`' + key + '`');
	  });
	}
	
	var SweetAlert = function (_Component) {
	  _inherits(SweetAlert, _Component);
	
	  /* eslint-disable react/no-unused-prop-types */
	  function SweetAlert(props, context) {
	    _classCallCheck(this, SweetAlert);
	
	    var _this = _possibleConstructorReturn(this, (SweetAlert.__proto__ || Object.getPrototypeOf(SweetAlert)).call(this, props, context));
	
	    _this._show = false;
	    return _this;
	  }
	  /* eslint-enable react/no-unused-prop-types */
	
	  _createClass(SweetAlert, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setupWithProps(this.props);
	
	      if (this.props.onOutsideClick) {
	        this.registerOutsideClickHandler(this.props.onOutsideClick);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this.setupWithProps(props);
	
	      var oldOutsideClickHandler = this.props.onOutsideClick;
	      var newOutsideClickHandler = props.onOutsideClick;
	
	      if (oldOutsideClickHandler !== newOutsideClickHandler) {
	        if (oldOutsideClickHandler && newOutsideClickHandler) {
	          this.unregisterOutsideClickHandler();
	          this.registerOutsideClickHandler(newOutsideClickHandler);
	        } else if (oldOutsideClickHandler && !newOutsideClickHandler) {
	          this.unregisterOutsideClickHandler();
	        } else if (!oldOutsideClickHandler && newOutsideClickHandler) {
	          this.registerOutsideClickHandler(newOutsideClickHandler);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unregisterOutsideClickHandler();
	      this.unbindEscapeKey();
	    }
	  }, {
	    key: 'setupWithProps',
	    value: function setupWithProps(props) {
	      var _this2 = this;
	
	      warningRemoved(props);
	      var show = props.show,
	          onConfirm = props.onConfirm,
	          onCancel = props.onCancel,
	          onClose = props.onClose,
	          onEscapeKey = props.onEscapeKey;
	
	      if (show) {
	        (0, _sweetalert2.default)(_extends({}, (0, _lodash2.default)(props, ALLOWS_KEYS), OVERWRITE_PROPS), function (isConfirm) {
	          return _this2.handleClick(isConfirm, onConfirm, onCancel);
	        });
	        this._show = true;
	        if (onEscapeKey) this.bindEscapeKey(onEscapeKey);
	      } else {
	        this.handleClose(onClose);
	      }
	    }
	  }, {
	    key: 'registerOutsideClickHandler',
	    value: function registerOutsideClickHandler(handler) {
	      this._outsideClickHandler = (0, _outsideTargetHandlerFactory2.default)(document.getElementsByClassName('sweet-alert')[0], handler);
	      this.enableOutsideClick();
	    }
	  }, {
	    key: 'unregisterOutsideClickHandler',
	    value: function unregisterOutsideClickHandler() {
	      this.disableOutsideClick();
	      this._outsideClickHandler = null;
	    }
	  }, {
	    key: 'enableOutsideClick',
	    value: function enableOutsideClick() {
	      var fn = this._outsideClickHandler;
	      if (fn) {
	        document.addEventListener('mousedown', fn);
	        document.addEventListener('touchstart', fn);
	      }
	    }
	  }, {
	    key: 'disableOutsideClick',
	    value: function disableOutsideClick() {
	      var fn = this._outsideClickHandler;
	      if (fn) {
	        document.removeEventListener('mousedown', fn);
	        document.removeEventListener('touchstart', fn);
	      }
	    }
	  }, {
	    key: 'bindEscapeKey',
	    value: function bindEscapeKey(onEscapeKey) {
	      _mousetrap2.default.bind('esc', onEscapeKey);
	    }
	  }, {
	    key: 'unbindEscapeKey',
	    value: function unbindEscapeKey() {
	      _mousetrap2.default.unbind('esc');
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(isConfirm, onConfirm, onCancel) {
	      if (isConfirm) {
	        if (onConfirm) onConfirm(isConfirm);
	      } else {
	        if (onCancel) onCancel(); // eslint-disable-line no-lonely-if
	      }
	    }
	  }, {
	    key: 'handleClose',
	    value: function handleClose(onClose) {
	      if (this._show) {
	        _sweetalert2.default.close();
	        this.unbindEscapeKey();
	        if (onClose) onClose();
	        this._show = false;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return SweetAlert;
	}(_react.Component);
	
	SweetAlert.propTypes = {
	  // sweetalert option
	  title: _react.PropTypes.string.isRequired,
	  text: _react.PropTypes.string,
	  type: _react.PropTypes.oneOf(['warning', 'error', 'success', 'info', 'input']),
	  customClass: _react.PropTypes.string,
	  showCancelButton: _react.PropTypes.bool,
	  showConfirmButton: _react.PropTypes.bool,
	  confirmButtonText: _react.PropTypes.string,
	  confirmButtonColor: _react.PropTypes.string,
	  cancelButtonText: _react.PropTypes.string,
	  imageUrl: _react.PropTypes.string,
	  imageSize: function imageSize(props, propName) {
	    if (!/^[1-9]\d*x[1-9]\d*/.test(props[propName])) {
	      return new Error('imageSize should have the format like this: "80x80"');
	    }
	  },
	
	  html: _react.PropTypes.bool,
	  animation: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['pop', 'slide-from-top', 'slide-from-bottom'])]),
	  inputType: _react.PropTypes.oneOf(ALLOWS_INPUT_TYPES),
	  inputPlaceholder: _react.PropTypes.string,
	  inputValue: _react.PropTypes.string,
	  showLoaderOnConfirm: _react.PropTypes.bool,
	
	  // custom option
	  show: _react.PropTypes.bool,
	  onConfirm: _react.PropTypes.func,
	  onCancel: _react.PropTypes.func,
	  onClose: _react.PropTypes.func,
	  onEscapeKey: _react.PropTypes.func,
	  onOutsideClick: _react.PropTypes.func
	};
	SweetAlert.defaultProps = {
	  // sweetalert option
	  text: null,
	  type: null,
	  customClass: null,
	  showCancelButton: false,
	  showConfirmButton: true,
	  confirmButtonText: 'OK',
	  confirmButtonColor: '#aedef4',
	  cancelButtonText: 'Cancel',
	  imageUrl: null,
	  imageSize: '80x80',
	  html: false,
	  animation: true,
	  inputType: 'text',
	  inputPlaceholder: null,
	  inputValue: null,
	  showLoaderOnConfirm: false,
	
	  // custom option
	  show: false
	};
	exports.default = SweetAlert;

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDOMEquals;
	/**
	 * Determinate whether dom1 and dom2 is the same dom or not.
	 *
	 * @param  {HTMLElement}  dom1
	 * @param  {HTMLElement}  dom2
	 * @return {Boolean}
	 */
	function isDOMEquals(dom1, dom2) {
	  return dom1 === dom2;
	}

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = outsideTargetHandlerFactory;
	
	var _isDOMEquals = __webpack_require__(1806);
	
	var _isDOMEquals2 = _interopRequireDefault(_isDOMEquals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *
	 * @param  {HTMLElement}  targetNode
	 * @param  {HTMLElement}  eventHandler
	 * @return {Boolean}
	 */
	function outsideTargetHandlerFactory(targetNode, eventHandler) {
	  return function (evt) {
	    evt.stopPropagation();
	    var current = evt.target;
	    var found = false;
	    while (current.parentNode) {
	      found = (0, _isDOMEquals2.default)(current, targetNode);
	      if (found) return;
	      current = current.parentNode;
	    }
	    eventHandler(evt);
	  };
	}

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _colorLuminance = __webpack_require__(257);
	
	var _getModal = __webpack_require__(256);
	
	var _hasClass$isDescendant = __webpack_require__(191);
	
	/*
	 * User clicked on "Confirm"/"OK" or "Cancel"
	 */
	var handleButton = function handleButton(event, params, modal) {
	  var e = event || window.event;
	  var target = e.target || e.srcElement;
	
	  var targetedConfirm = target.className.indexOf('confirm') !== -1;
	  var targetedOverlay = target.className.indexOf('sweet-overlay') !== -1;
	  var modalIsVisible = _hasClass$isDescendant.hasClass(modal, 'visible');
	  var doneFunctionExists = params.doneFunction && modal.getAttribute('data-has-done-function') === 'true';
	
	  // Since the user can change the background-color of the confirm button programmatically,
	  // we must calculate what the color should be on hover/active
	  var normalColor, hoverColor, activeColor;
	  if (targetedConfirm && params.confirmButtonColor) {
	    normalColor = params.confirmButtonColor;
	    hoverColor = _colorLuminance.colorLuminance(normalColor, -0.04);
	    activeColor = _colorLuminance.colorLuminance(normalColor, -0.14);
	  }
	
	  function shouldSetConfirmButtonColor(color) {
	    if (targetedConfirm && params.confirmButtonColor) {
	      target.style.backgroundColor = color;
	    }
	  }
	
	  switch (e.type) {
	    case 'mouseover':
	      shouldSetConfirmButtonColor(hoverColor);
	      break;
	
	    case 'mouseout':
	      shouldSetConfirmButtonColor(normalColor);
	      break;
	
	    case 'mousedown':
	      shouldSetConfirmButtonColor(activeColor);
	      break;
	
	    case 'mouseup':
	      shouldSetConfirmButtonColor(hoverColor);
	      break;
	
	    case 'focus':
	      var $confirmButton = modal.querySelector('button.confirm');
	      var $cancelButton = modal.querySelector('button.cancel');
	
	      if (targetedConfirm) {
	        $cancelButton.style.boxShadow = 'none';
	      } else {
	        $confirmButton.style.boxShadow = 'none';
	      }
	      break;
	
	    case 'click':
	      var clickedOnModal = modal === target;
	      var clickedOnModalChild = _hasClass$isDescendant.isDescendant(modal, target);
	
	      // Ignore click outside if allowOutsideClick is false
	      if (!clickedOnModal && !clickedOnModalChild && modalIsVisible && !params.allowOutsideClick) {
	        break;
	      }
	
	      if (targetedConfirm && doneFunctionExists && modalIsVisible) {
	        handleConfirm(modal, params);
	      } else if (doneFunctionExists && modalIsVisible || targetedOverlay) {
	        handleCancel(modal, params);
	      } else if (_hasClass$isDescendant.isDescendant(modal, target) && target.tagName === 'BUTTON') {
	        sweetAlert.close();
	      }
	      break;
	  }
	};
	
	/*
	 *  User clicked on "Confirm"/"OK"
	 */
	var handleConfirm = function handleConfirm(modal, params) {
	  var callbackValue = true;
	
	  if (_hasClass$isDescendant.hasClass(modal, 'show-input')) {
	    callbackValue = modal.querySelector('input').value;
	
	    if (!callbackValue) {
	      callbackValue = '';
	    }
	  }
	
	  params.doneFunction(callbackValue);
	
	  if (params.closeOnConfirm) {
	    sweetAlert.close();
	  }
	  // Disable cancel and confirm button if the parameter is true
	  if (params.showLoaderOnConfirm) {
	    sweetAlert.disableButtons();
	  }
	};
	
	/*
	 *  User clicked on "Cancel"
	 */
	var handleCancel = function handleCancel(modal, params) {
	  // Check if callback function expects a parameter (to track cancel actions)
	  var functionAsStr = String(params.doneFunction).replace(/\s/g, '');
	  var functionHandlesCancel = functionAsStr.substring(0, 9) === 'function(' && functionAsStr.substring(9, 10) !== ')';
	
	  if (functionHandlesCancel) {
	    params.doneFunction(false);
	  }
	
	  if (params.closeOnCancel) {
	    sweetAlert.close();
	  }
	};
	
	exports['default'] = {
	  handleButton: handleButton,
	  handleConfirm: handleConfirm,
	  handleCancel: handleCancel
	};
	module.exports = exports['default'];

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _stopEventPropagation$fireClick = __webpack_require__(191);
	
	var _setFocusStyle = __webpack_require__(256);
	
	var handleKeyDown = function handleKeyDown(event, params, modal) {
	  var e = event || window.event;
	  var keyCode = e.keyCode || e.which;
	
	  var $okButton = modal.querySelector('button.confirm');
	  var $cancelButton = modal.querySelector('button.cancel');
	  var $modalButtons = modal.querySelectorAll('button[tabindex]');
	
	  if ([9, 13, 32, 27].indexOf(keyCode) === -1) {
	    // Don't do work on keys we don't care about.
	    return;
	  }
	
	  var $targetElement = e.target || e.srcElement;
	
	  var btnIndex = -1; // Find the button - note, this is a nodelist, not an array.
	  for (var i = 0; i < $modalButtons.length; i++) {
	    if ($targetElement === $modalButtons[i]) {
	      btnIndex = i;
	      break;
	    }
	  }
	
	  if (keyCode === 9) {
	    // TAB
	    if (btnIndex === -1) {
	      // No button focused. Jump to the confirm button.
	      $targetElement = $okButton;
	    } else {
	      // Cycle to the next button
	      if (btnIndex === $modalButtons.length - 1) {
	        $targetElement = $modalButtons[0];
	      } else {
	        $targetElement = $modalButtons[btnIndex + 1];
	      }
	    }
	
	    _stopEventPropagation$fireClick.stopEventPropagation(e);
	    $targetElement.focus();
	
	    if (params.confirmButtonColor) {
	      _setFocusStyle.setFocusStyle($targetElement, params.confirmButtonColor);
	    }
	  } else {
	    if (keyCode === 13) {
	      if ($targetElement.tagName === 'INPUT') {
	        $targetElement = $okButton;
	        $okButton.focus();
	      }
	
	      if (btnIndex === -1) {
	        // ENTER/SPACE clicked outside of a button.
	        $targetElement = $okButton;
	      } else {
	        // Do nothing - let the browser handle it.
	        $targetElement = undefined;
	      }
	    } else if (keyCode === 27 && params.allowEscapeKey === true) {
	      $targetElement = $cancelButton;
	      _stopEventPropagation$fireClick.fireClick($targetElement, e);
	    } else {
	      // Fallback - let the browser handle it.
	      $targetElement = undefined;
	    }
	  }
	};
	
	exports['default'] = handleKeyDown;
	module.exports = exports['default'];

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var injectedHTML =
	
	// Dark overlay
	"<div class=\"sweet-overlay\" tabIndex=\"-1\"></div>" +
	
	// Modal
	"<div class=\"sweet-alert\">" +
	
	// Error icon
	"<div class=\"sa-icon sa-error\">\n      <span class=\"sa-x-mark\">\n        <span class=\"sa-line sa-left\"></span>\n        <span class=\"sa-line sa-right\"></span>\n      </span>\n    </div>" +
	
	// Warning icon
	"<div class=\"sa-icon sa-warning\">\n      <span class=\"sa-body\"></span>\n      <span class=\"sa-dot\"></span>\n    </div>" +
	
	// Info icon
	"<div class=\"sa-icon sa-info\"></div>" +
	
	// Success icon
	"<div class=\"sa-icon sa-success\">\n      <span class=\"sa-line sa-tip\"></span>\n      <span class=\"sa-line sa-long\"></span>\n\n      <div class=\"sa-placeholder\"></div>\n      <div class=\"sa-fix\"></div>\n    </div>" + "<div class=\"sa-icon sa-custom\"></div>" +
	
	// Title, text and input
	"<h2>Title</h2>\n    <p>Text</p>\n    <fieldset>\n      <input type=\"text\" tabIndex=\"3\" />\n      <div class=\"sa-input-error\"></div>\n    </fieldset>" +
	
	// Input errors
	"<div class=\"sa-error-container\">\n      <div class=\"icon\">!</div>\n      <p>Not valid!</p>\n    </div>" +
	
	// Cancel and confirm buttons
	"<div class=\"sa-button-container\">\n      <button class=\"cancel\" tabIndex=\"2\">Cancel</button>\n      <div class=\"sa-confirm-button-container\">\n        <button class=\"confirm\" tabIndex=\"1\">OK</button>" +
	
	// Loading animation
	"<div class=\"la-ball-fall\">\n          <div></div>\n          <div></div>\n          <div></div>\n        </div>\n      </div>\n    </div>" +
	
	// End of modal
	"</div>";
	
	exports["default"] = injectedHTML;
	module.exports = exports["default"];

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _isIE8 = __webpack_require__(257);
	
	var _getModal$getInput$setFocusStyle = __webpack_require__(256);
	
	var _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide = __webpack_require__(191);
	
	var alertTypes = ['error', 'warning', 'info', 'success', 'input', 'prompt'];
	
	/*
	 * Set type, text and actions on modal
	 */
	var setParameters = function setParameters(params) {
	  var modal = _getModal$getInput$setFocusStyle.getModal();
	
	  var $title = modal.querySelector('h2');
	  var $text = modal.querySelector('p');
	  var $cancelBtn = modal.querySelector('button.cancel');
	  var $confirmBtn = modal.querySelector('button.confirm');
	
	  /*
	   * Title
	   */
	  $title.innerHTML = params.html ? params.title : _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.title).split('\n').join('<br>');
	
	  /*
	   * Text
	   */
	  $text.innerHTML = params.html ? params.text : _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.text || '').split('\n').join('<br>');
	  if (params.text) _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.show($text);
	
	  /*
	   * Custom class
	   */
	  if (params.customClass) {
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass(modal, params.customClass);
	    modal.setAttribute('data-custom-class', params.customClass);
	  } else {
	    // Find previously set classes and remove them
	    var customClass = modal.getAttribute('data-custom-class');
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.removeClass(modal, customClass);
	    modal.setAttribute('data-custom-class', '');
	  }
	
	  /*
	   * Icon
	   */
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.hide(modal.querySelectorAll('.sa-icon'));
	
	  if (params.type && !_isIE8.isIE8()) {
	    var _ret = (function () {
	
	      var validType = false;
	
	      for (var i = 0; i < alertTypes.length; i++) {
	        if (params.type === alertTypes[i]) {
	          validType = true;
	          break;
	        }
	      }
	
	      if (!validType) {
	        logStr('Unknown alert type: ' + params.type);
	        return {
	          v: false
	        };
	      }
	
	      var typesWithIcons = ['success', 'error', 'warning', 'info'];
	      var $icon = undefined;
	
	      if (typesWithIcons.indexOf(params.type) !== -1) {
	        $icon = modal.querySelector('.sa-icon.' + 'sa-' + params.type);
	        _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.show($icon);
	      }
	
	      var $input = _getModal$getInput$setFocusStyle.getInput();
	
	      // Animate icon
	      switch (params.type) {
	
	        case 'success':
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon, 'animate');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-tip'), 'animateSuccessTip');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-long'), 'animateSuccessLong');
	          break;
	
	        case 'error':
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon, 'animateErrorIcon');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-x-mark'), 'animateXMark');
	          break;
	
	        case 'warning':
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon, 'pulseWarning');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-body'), 'pulseWarningIns');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-dot'), 'pulseWarningIns');
	          break;
	
	        case 'input':
	        case 'prompt':
	          $input.setAttribute('type', params.inputType);
	          $input.value = params.inputValue;
	          $input.setAttribute('placeholder', params.inputPlaceholder);
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass(modal, 'show-input');
	          setTimeout(function () {
	            $input.focus();
	            $input.addEventListener('keyup', swal.resetInputError);
	          }, 400);
	          break;
	      }
	    })();
	
	    if (typeof _ret === 'object') {
	      return _ret.v;
	    }
	  }
	
	  /*
	   * Custom image
	   */
	  if (params.imageUrl) {
	    var $customIcon = modal.querySelector('.sa-icon.sa-custom');
	
	    $customIcon.style.backgroundImage = 'url(' + params.imageUrl + ')';
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.show($customIcon);
	
	    var _imgWidth = 80;
	    var _imgHeight = 80;
	
	    if (params.imageSize) {
	      var dimensions = params.imageSize.toString().split('x');
	      var imgWidth = dimensions[0];
	      var imgHeight = dimensions[1];
	
	      if (!imgWidth || !imgHeight) {
	        logStr('Parameter imageSize expects value with format WIDTHxHEIGHT, got ' + params.imageSize);
	      } else {
	        _imgWidth = imgWidth;
	        _imgHeight = imgHeight;
	      }
	    }
	
	    $customIcon.setAttribute('style', $customIcon.getAttribute('style') + 'width:' + _imgWidth + 'px; height:' + _imgHeight + 'px');
	  }
	
	  /*
	   * Show cancel button?
	   */
	  modal.setAttribute('data-has-cancel-button', params.showCancelButton);
	  if (params.showCancelButton) {
	    $cancelBtn.style.display = 'inline-block';
	  } else {
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.hide($cancelBtn);
	  }
	
	  /*
	   * Show confirm button?
	   */
	  modal.setAttribute('data-has-confirm-button', params.showConfirmButton);
	  if (params.showConfirmButton) {
	    $confirmBtn.style.display = 'inline-block';
	  } else {
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.hide($confirmBtn);
	  }
	
	  /*
	   * Custom text on cancel/confirm buttons
	   */
	  if (params.cancelButtonText) {
	    $cancelBtn.innerHTML = _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.cancelButtonText);
	  }
	  if (params.confirmButtonText) {
	    $confirmBtn.innerHTML = _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.confirmButtonText);
	  }
	
	  /*
	   * Custom color on confirm button
	   */
	  if (params.confirmButtonColor) {
	    // Set confirm button to selected background color
	    $confirmBtn.style.backgroundColor = params.confirmButtonColor;
	
	    // Set the confirm button color to the loading ring
	    $confirmBtn.style.borderLeftColor = params.confirmLoadingButtonColor;
	    $confirmBtn.style.borderRightColor = params.confirmLoadingButtonColor;
	
	    // Set box-shadow to default focused button
	    _getModal$getInput$setFocusStyle.setFocusStyle($confirmBtn, params.confirmButtonColor);
	  }
	
	  /*
	   * Allow outside click
	   */
	  modal.setAttribute('data-allow-outside-click', params.allowOutsideClick);
	
	  /*
	   * Callback function
	   */
	  var hasDoneFunction = params.doneFunction ? true : false;
	  modal.setAttribute('data-has-done-function', hasDoneFunction);
	
	  /*
	   * Animation
	   */
	  if (!params.animation) {
	    modal.setAttribute('data-animation', 'none');
	  } else if (typeof params.animation === 'string') {
	    modal.setAttribute('data-animation', params.animation); // Custom animation
	  } else {
	    modal.setAttribute('data-animation', 'pop');
	  }
	
	  /*
	   * Timer
	   */
	  modal.setAttribute('data-timer', params.timer);
	};
	
	exports['default'] = setParameters;
	module.exports = exports['default'];

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	// SweetAlert
	// 2014-2015 (c) - Tristan Edwards
	// github.com/t4t5/sweetalert
	
	/*
	 * jQuery-like functions for manipulating the DOM
	 */
	
	var _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation = __webpack_require__(191);
	
	/*
	 * Handy utilities
	 */
	
	var _extend$hexToRgb$isIE8$logStr$colorLuminance = __webpack_require__(257);
	
	/*
	 *  Handle sweetAlert's DOM elements
	 */
	
	var _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition = __webpack_require__(256);
	
	// Handle button events and keyboard events
	
	var _handleButton$handleConfirm$handleCancel = __webpack_require__(1808);
	
	var _handleKeyDown = __webpack_require__(1809);
	
	var _handleKeyDown2 = _interopRequireWildcard(_handleKeyDown);
	
	// Default values
	
	var _defaultParams = __webpack_require__(813);
	
	var _defaultParams2 = _interopRequireWildcard(_defaultParams);
	
	var _setParameters = __webpack_require__(1811);
	
	var _setParameters2 = _interopRequireWildcard(_setParameters);
	
	/*
	 * Remember state in cases where opening and handling a modal will fiddle with it.
	 * (We also use window.previousActiveElement as a global variable)
	 */
	var previousWindowKeyDown;
	var lastFocusedButton;
	
	/*
	 * Global sweetAlert function
	 * (this is what the user calls)
	 */
	var sweetAlert, swal;
	
	exports['default'] = sweetAlert = swal = function () {
	  var customizations = arguments[0];
	
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass(document.body, 'stop-scrolling');
	  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.resetInput();
	
	  /*
	   * Use argument if defined or default value from params object otherwise.
	   * Supports the case where a default value is boolean true and should be
	   * overridden by a corresponding explicit argument which is boolean false.
	   */
	  function argumentOrDefault(key) {
	    var args = customizations;
	    return args[key] === undefined ? _defaultParams2['default'][key] : args[key];
	  }
	
	  if (customizations === undefined) {
	    _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('SweetAlert expects at least 1 attribute!');
	    return false;
	  }
	
	  var params = _extend$hexToRgb$isIE8$logStr$colorLuminance.extend({}, _defaultParams2['default']);
	
	  switch (typeof customizations) {
	
	    // Ex: swal("Hello", "Just testing", "info");
	    case 'string':
	      params.title = customizations;
	      params.text = arguments[1] || '';
	      params.type = arguments[2] || '';
	      break;
	
	    // Ex: swal({ title:"Hello", text: "Just testing", type: "info" });
	    case 'object':
	      if (customizations.title === undefined) {
	        _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('Missing "title" argument!');
	        return false;
	      }
	
	      params.title = customizations.title;
	
	      for (var customName in _defaultParams2['default']) {
	        params[customName] = argumentOrDefault(customName);
	      }
	
	      // Show "Confirm" instead of "OK" if cancel button is visible
	      params.confirmButtonText = params.showCancelButton ? 'Confirm' : _defaultParams2['default'].confirmButtonText;
	      params.confirmButtonText = argumentOrDefault('confirmButtonText');
	
	      // Callback function when clicking on "OK"/"Cancel"
	      params.doneFunction = arguments[1] || null;
	
	      break;
	
	    default:
	      _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('Unexpected type of argument! Expected "string" or "object", got ' + typeof customizations);
	      return false;
	
	  }
	
	  _setParameters2['default'](params);
	  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.fixVerticalPosition();
	  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.openModal(arguments[1]);
	
	  // Modal interactions
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	
	  /*
	   * Make sure all modal buttons respond to all events
	   */
	  var $buttons = modal.querySelectorAll('button');
	  var buttonEvents = ['onclick', 'onmouseover', 'onmouseout', 'onmousedown', 'onmouseup', 'onfocus'];
	  var onButtonEvent = function onButtonEvent(e) {
	    return _handleButton$handleConfirm$handleCancel.handleButton(e, params, modal);
	  };
	
	  for (var btnIndex = 0; btnIndex < $buttons.length; btnIndex++) {
	    for (var evtIndex = 0; evtIndex < buttonEvents.length; evtIndex++) {
	      var btnEvt = buttonEvents[evtIndex];
	      $buttons[btnIndex][btnEvt] = onButtonEvent;
	    }
	  }
	
	  // Clicking outside the modal dismisses it (if allowed by user)
	  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getOverlay().onclick = onButtonEvent;
	
	  previousWindowKeyDown = window.onkeydown;
	
	  var onKeyEvent = function onKeyEvent(e) {
	    return _handleKeyDown2['default'](e, params, modal);
	  };
	  window.onkeydown = onKeyEvent;
	
	  window.onfocus = function () {
	    // When the user has focused away and focused back from the whole window.
	    setTimeout(function () {
	      // Put in a timeout to jump out of the event sequence.
	      // Calling focus() in the event sequence confuses things.
	      if (lastFocusedButton !== undefined) {
	        lastFocusedButton.focus();
	        lastFocusedButton = undefined;
	      }
	    }, 0);
	  };
	
	  // Show alert with enabled buttons always
	  swal.enableButtons();
	};
	
	/*
	 * Set default params for each popup
	 * @param {Object} userParams
	 */
	sweetAlert.setDefaults = swal.setDefaults = function (userParams) {
	  if (!userParams) {
	    throw new Error('userParams is required');
	  }
	  if (typeof userParams !== 'object') {
	    throw new Error('userParams has to be a object');
	  }
	
	  _extend$hexToRgb$isIE8$logStr$colorLuminance.extend(_defaultParams2['default'], userParams);
	};
	
	/*
	 * Animation when closing modal
	 */
	sweetAlert.close = swal.close = function () {
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.fadeOut(_sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getOverlay(), 5);
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.fadeOut(modal, 5);
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(modal, 'showSweetAlert');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass(modal, 'hideSweetAlert');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(modal, 'visible');
	
	  /*
	   * Reset icon animations
	   */
	  var $successIcon = modal.querySelector('.sa-icon.sa-success');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($successIcon, 'animate');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($successIcon.querySelector('.sa-tip'), 'animateSuccessTip');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($successIcon.querySelector('.sa-long'), 'animateSuccessLong');
	
	  var $errorIcon = modal.querySelector('.sa-icon.sa-error');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorIcon, 'animateErrorIcon');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorIcon.querySelector('.sa-x-mark'), 'animateXMark');
	
	  var $warningIcon = modal.querySelector('.sa-icon.sa-warning');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($warningIcon, 'pulseWarning');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($warningIcon.querySelector('.sa-body'), 'pulseWarningIns');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($warningIcon.querySelector('.sa-dot'), 'pulseWarningIns');
	
	  // Reset custom class (delay so that UI changes aren't visible)
	  setTimeout(function () {
	    var customClass = modal.getAttribute('data-custom-class');
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(modal, customClass);
	  }, 300);
	
	  // Make page scrollable again
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(document.body, 'stop-scrolling');
	
	  // Reset the page to its previous state
	  window.onkeydown = previousWindowKeyDown;
	  if (window.previousActiveElement) {
	    window.previousActiveElement.focus();
	  }
	  lastFocusedButton = undefined;
	  clearTimeout(modal.timeout);
	
	  return true;
	};
	
	/*
	 * Validation of the input field is done by user
	 * If something is wrong => call showInputError with errorMessage
	 */
	sweetAlert.showInputError = swal.showInputError = function (errorMessage) {
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	
	  var $errorIcon = modal.querySelector('.sa-input-error');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass($errorIcon, 'show');
	
	  var $errorContainer = modal.querySelector('.sa-error-container');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass($errorContainer, 'show');
	
	  $errorContainer.querySelector('p').innerHTML = errorMessage;
	
	  setTimeout(function () {
	    sweetAlert.enableButtons();
	  }, 1);
	
	  modal.querySelector('input').focus();
	};
	
	/*
	 * Reset input error DOM elements
	 */
	sweetAlert.resetInputError = swal.resetInputError = function (event) {
	  // If press enter => ignore
	  if (event && event.keyCode === 13) {
	    return false;
	  }
	
	  var $modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	
	  var $errorIcon = $modal.querySelector('.sa-input-error');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorIcon, 'show');
	
	  var $errorContainer = $modal.querySelector('.sa-error-container');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorContainer, 'show');
	};
	
	/*
	 * Disable confirm and cancel buttons
	 */
	sweetAlert.disableButtons = swal.disableButtons = function (event) {
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	  var $confirmButton = modal.querySelector('button.confirm');
	  var $cancelButton = modal.querySelector('button.cancel');
	  $confirmButton.disabled = true;
	  $cancelButton.disabled = true;
	};
	
	/*
	 * Enable confirm and cancel buttons
	 */
	sweetAlert.enableButtons = swal.enableButtons = function (event) {
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	  var $confirmButton = modal.querySelector('button.confirm');
	  var $cancelButton = modal.querySelector('button.cancel');
	  $confirmButton.disabled = false;
	  $cancelButton.disabled = false;
	};
	
	if (typeof window !== 'undefined') {
	  // The 'handle-click' module requires
	  // that 'sweetAlert' was set as global.
	  window.sweetAlert = window.swal = sweetAlert;
	} else {
	  _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('SweetAlert is a frontend module!');
	}
	module.exports = exports['default'];

/***/ }),
/* 1813 */
/***/ (function(module, exports) {

	module.exports = function(el) {
	  var basicTabbables = [];
	  var orderedTabbables = [];
	
	  // A node is "available" if
	  // - it's computed style
	  var isUnavailable = createIsUnavailable();
	
	  var candidateSelectors = [
	    'input',
	    'select',
	    'a[href]',
	    'textarea',
	    'button',
	    '[tabindex]',
	  ];
	
	  var candidates = el.querySelectorAll(candidateSelectors);
	
	  var candidate, candidateIndex;
	  for (var i = 0, l = candidates.length; i < l; i++) {
	    candidate = candidates[i];
	    candidateIndex = parseInt(candidate.getAttribute('tabindex'), 10) || candidate.tabIndex;
	
	    if (
	      candidateIndex < 0
	      || (candidate.tagName === 'INPUT' && candidate.type === 'hidden')
	      || candidate.disabled
	      || isUnavailable(candidate)
	    ) {
	      continue;
	    }
	
	    if (candidateIndex === 0) {
	      basicTabbables.push(candidate);
	    } else {
	      orderedTabbables.push({
	        tabIndex: candidateIndex,
	        node: candidate,
	      });
	    }
	  }
	
	  var tabbableNodes = orderedTabbables
	    .sort(function(a, b) {
	      return a.tabIndex - b.tabIndex;
	    })
	    .map(function(a) {
	      return a.node
	    });
	
	  Array.prototype.push.apply(tabbableNodes, basicTabbables);
	
	  return tabbableNodes;
	}
	
	function createIsUnavailable() {
	  // Node cache must be refreshed on every check, in case
	  // the content of the element has changed
	  var isOffCache = [];
	
	  // "off" means `display: none;`, as opposed to "hidden",
	  // which means `visibility: hidden;`. getComputedStyle
	  // accurately reflects visiblity in context but not
	  // "off" state, so we need to recursively check parents.
	
	  function isOff(node, nodeComputedStyle) {
	    if (node === document.documentElement) return false;
	
	    // Find the cached node (Array.prototype.find not available in IE9)
	    for (var i = 0, length = isOffCache.length; i < length; i++) {
	      if (isOffCache[i][0] === node) return isOffCache[i][1];
	    }
	
	    nodeComputedStyle = nodeComputedStyle || window.getComputedStyle(node);
	
	    var result = false;
	
	    if (nodeComputedStyle.display === 'none') {
	      result = true;
	    } else if (node.parentNode) {
	      result = isOff(node.parentNode);
	    }
	
	    isOffCache.push([node, result]);
	
	    return result;
	  }
	
	  return function isUnavailable(node) {
	    if (node === document.documentElement) return false;
	
	    var computedStyle = window.getComputedStyle(node);
	
	    if (isOff(node, computedStyle)) return true;
	
	    return computedStyle.visibility === 'hidden';
	  }
	}


/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1768);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module Dependencies
	 */
	
	var expr;
	try {
	  expr = __webpack_require__(479);
	} catch(e) {
	  expr = __webpack_require__(479);
	}
	
	/**
	 * Expose `toFunction()`.
	 */
	
	module.exports = toFunction;
	
	/**
	 * Convert `obj` to a `Function`.
	 *
	 * @param {Mixed} obj
	 * @return {Function}
	 * @api private
	 */
	
	function toFunction(obj) {
	  switch ({}.toString.call(obj)) {
	    case '[object Object]':
	      return objectToFunction(obj);
	    case '[object Function]':
	      return obj;
	    case '[object String]':
	      return stringToFunction(obj);
	    case '[object RegExp]':
	      return regexpToFunction(obj);
	    default:
	      return defaultToFunction(obj);
	  }
	}
	
	/**
	 * Default to strict equality.
	 *
	 * @param {Mixed} val
	 * @return {Function}
	 * @api private
	 */
	
	function defaultToFunction(val) {
	  return function(obj){
	    return val === obj;
	  };
	}
	
	/**
	 * Convert `re` to a function.
	 *
	 * @param {RegExp} re
	 * @return {Function}
	 * @api private
	 */
	
	function regexpToFunction(re) {
	  return function(obj){
	    return re.test(obj);
	  };
	}
	
	/**
	 * Convert property `str` to a function.
	 *
	 * @param {String} str
	 * @return {Function}
	 * @api private
	 */
	
	function stringToFunction(str) {
	  // immediate such as "> 20"
	  if (/^ *\W+/.test(str)) return new Function('_', 'return _ ' + str);
	
	  // properties such as "name.first" or "age > 18" or "age > 18 && age < 36"
	  return new Function('_', 'return ' + get(str));
	}
	
	/**
	 * Convert `object` to a function.
	 *
	 * @param {Object} object
	 * @return {Function}
	 * @api private
	 */
	
	function objectToFunction(obj) {
	  var match = {};
	  for (var key in obj) {
	    match[key] = typeof obj[key] === 'string'
	      ? defaultToFunction(obj[key])
	      : toFunction(obj[key]);
	  }
	  return function(val){
	    if (typeof val !== 'object') return false;
	    for (var key in match) {
	      if (!(key in val)) return false;
	      if (!match[key](val[key])) return false;
	    }
	    return true;
	  };
	}
	
	/**
	 * Built the getter function. Supports getter style functions
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function get(str) {
	  var props = expr(str);
	  if (!props.length) return '_.' + str;
	
	  var val, i, prop;
	  for (i = 0; i < props.length; i++) {
	    prop = props[i];
	    val = '_.' + prop;
	    val = "('function' == typeof " + val + " ? " + val + "() : " + val + ")";
	
	    // mimic negative lookbehind to avoid problems with nested properties
	    str = stripNested(prop, str, val);
	  }
	
	  return str;
	}
	
	/**
	 * Mimic negative lookbehind to avoid problems with nested properties.
	 *
	 * See: http://blog.stevenlevithan.com/archives/mimic-lookbehind-javascript
	 *
	 * @param {String} prop
	 * @param {String} str
	 * @param {String} val
	 * @return {String}
	 * @api private
	 */
	
	function stripNested (prop, str, val) {
	  return str.replace(new RegExp('(\\.)?' + prop, 'g'), function($0, $1) {
	    return $1 ? $0 : val;
	  });
	}


/***/ }),
/* 1816 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `toNoCase`.
	 */
	
	module.exports = toNoCase;
	
	
	/**
	 * Test whether a string is camel-case.
	 */
	
	var hasSpace = /\s/;
	var hasSeparator = /[\W_]/;
	
	
	/**
	 * Remove any starting case from a `string`, like camel or snake, but keep
	 * spaces and punctuation that may be important otherwise.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toNoCase (string) {
	  if (hasSpace.test(string)) return string.toLowerCase();
	  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase();
	  return uncamelize(string).toLowerCase();
	}
	
	
	/**
	 * Separator splitter.
	 */
	
	var separatorSplitter = /[\W_]+(.|$)/g;
	
	
	/**
	 * Un-separate a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function unseparate (string) {
	  return string.replace(separatorSplitter, function (m, next) {
	    return next ? ' ' + next : '';
	  });
	}
	
	
	/**
	 * Camelcase splitter.
	 */
	
	var camelSplitter = /(.)([A-Z]+)/g;
	
	
	/**
	 * Un-camelcase a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function uncamelize (string) {
	  return string.replace(camelSplitter, function (m, previous, uppers) {
	    return previous + ' ' + uppers.toLowerCase().split('').join(' ');
	  });
	}

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

	
	/**
	 * toString ref.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Return the type of `val`.
	 *
	 * @param {Mixed} val
	 * @return {String}
	 * @api public
	 */
	
	module.exports = function(val){
	  switch (toString.call(val)) {
	    case '[object Function]': return 'function';
	    case '[object Date]': return 'date';
	    case '[object RegExp]': return 'regexp';
	    case '[object Arguments]': return 'arguments';
	    case '[object Array]': return 'array';
	  }
	
	  if (val === null) return 'null';
	  if (val === undefined) return 'undefined';
	  if (val === Object(val)) return 'object';
	
	  return typeof val;
	};


/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/barber-hero.1aef2b73.jpg";

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/barbershop.5184f65d.jpg";

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/default-barber.bcb59459.jpg";

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/instagram-logo.514db983.png";

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/forhims.5372c933.png";

/***/ }),
/* 1824 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1826 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH4QwWDDAMfqQEeQAABFRJREFUeNrt3GFoG3UYx/Hf410jqEUqk7VVijKkU7TO0S5Nl5RUEBHBbb4aDlH0lZsUh0j3xhdzb0RUZBMRRPSloH2hCCJOWtcOk9G5aTewOsVtUGW4xQzrNnPt44td4CwOwmhrk34/UJq75Mpx9737/9uESgAAAAAAAAAAAAAAAGgoNjJWcA7DynUNh4AAQAAgABAACAAEAAIAAYAAQAAgABAACAAEAAIAAYAAQAAgABAACAB1Lkw8Hjaztzkkjc/dd0vqmx/AqXw2vZ/D0/hGxgo7GAJAACAAAuAQEAAIAAQAAgABgABAACAAEAAIAAQAAgABgADQiJL/KrYs6SyHZEVYLel66d+fCbwx/gJDAAgABAACAAGAAEAAIAAQAAgABAACQIMIOQRXbY+ZzdTZPne4+3YCWBh789n07/W0w6PjxYyk7QwBIAAQAAgABEAA4O8AWHIjY4W1Ztbl7mEQBIX+vp6fCWAFGB0vbnL3lyR1uV/+RP7s7OzcyFhhb3t7+/OdazrmCKABjX090RxF0fvu/ugVhuLnpqenT0p6gzlA493uV0VRdFBS9eRXJL0n6UEze1jSuXj90NFjUwF3gMa68m+IougzSffEq46Y2dZ8Nv1DYlh4x92HJLWWy+UuSUeScwVJz0g6k0qlXtuYXn+RAOrI7OzsPknd8eJ+SZvy2fRf828SkoYkyd3XVgMYHS9m3P1zSc2SVKlUmiXtOnpsKiiVSrsk7ZA0Z2aD7r5ZkrW0tDy97u7Ovwlgedz6N7v7k/Hit2EYbslluueffJnZqeqE0N1vl6TxwuGbK5XKR9WTHz+37dA3k7tLpdKwpIcS64erj8vl8uvJOwhzgP/v5DdJeiVevGhm23KZ7j//8yoMw18TizdJUhRFr0pqj9edjL/fOjMzcyBx8kvzftQvra2tk0wCl4fHJN0RP96Xz6aPX+mFG9Pr/5B0IV5sGR0vrnP3x+O7w6iZJd/CrQ4nU2EY3ivpx+rFb2ZPdK7piAhgeXiqevUHQfByDa8/H5/wWyQ9K8ni9S+kUqkvJf2WeO2JMAzvz2W6TwdB8ICZbU2lUrfls+kDTAKXga8OHlo9NzeXixc/7u/rOVfDZmclrXb3OyXl4hgO5rPpiXhIGZT0gZlNBEGwJZfpnpak/r6ek4khgr8DLAfuvqF6BZvZFzVudiL+3iHpuvjxm9UnB3K9HwZBsKqtrS1TPfn8Grh8dSZm+Mdr2cDMvnP3RxKrTidn9/HVXlroHeUOsDh3gGsTi5dq3ObTeUHsGcj1VhZ7XwlgEZjZpCSXdKapqemnWrYZyPUWdfl9gEtm9lZbW9u7S7GvDAGLIJ9NfzIyVrgrCIIzfRvuO1/rdgO53p2Sdi7lvhLAIhnI9X5fD/vJELDCEQABgABAACAArED8Gnj1XhwdL16opx1293YCWDiD1U/xMASAAEAAqMdJoJkd5jAAAAAAAAAAAAAAAAAADeIff/A1zah2Yt8AAAAASUVORK5CYII="

/***/ }),
/* 1827 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1828 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1829 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAA5CAYAAACPr42tAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC8+AAAvPgGfNCOsAAAAB3RJTUUH4QwWDCEoEX7DuAAABBlJREFUaN7tm0+olFUUwH9vnNL3XiYuShO11FDQhf1xcRHu4kaIFG0slP5SK8UQK1xoKOpCcaNYiLgq25RghtADCxcXuovOIjBIxAjD8sUrK9H3J3vyxmkxd2p6zMx3xe/O8z6/A8P8+c6533y/Ofecc893B+uki0L+lS4A62QYuBbpHD3AfKPV0O0OZJ3MBH4ARiN91+Gyf9ELjAE/RThJN1DNaaybwB8RgFSBBcD0uodUgWNGqxfv1qlinZwEnio1fDblLg8fUwBKRRj9vxRACiAFkAJIASRlINZJFN28pNwpCEYrrJMSULZOVgLPAY8Dc4AHfR1wGRgAzgGngC+skzGjVaU+RtIeUv+FPYxDQMWX3RZ4BzDAEmAmcD/wKKCB9cBJ4G9gzDrpqxdOsb0mqod4EO8Ce25zqGc9mBNGqxdS9pDTOcBolOetkx+TA2KdYJ1sAp6OMPwC6+TzpID44Lc3QPWwjx09vk3Q65fh/Rl2zyQVQ6yTZcB9GWpvG60ONskeF4F51slvPvs0/SGtk61Gq32pxJBXAnQ+yUilOzLsX42RcWIBeSRAZ6gVDH+hv2bYPxCjLomVdvsDdBZaJ2ebXZRP15eB07RuP15LJoYAJ4AtGTrbjFYvtwnMAqwKqYBTyDJCdiP4JevktRyyWTKF2ZEAnY+sk10TtZDrKBCj1VvALwGqO62TbwLSdNpA/PyeGwjlSWDIOtk50d4S00MaoXwZaLbLOrkKrJsoMFEXdw1QVgObA81mAMesk7PA8k6Did4xq2cCo9X7/mK/DjRdBnxrnXxYBzspgIyTQaNVvVs2EGjzunUyCjw26YA01A19Rqs5wDbgeoDpvcAZ6+SNyeYh46fRPqNVD3A80PQD6+TNSQekSXpeCzwBDAaYHLJOVsSKKRMOpGEanTFazaC2ISZLvorVgY/VIJqO353UQkaMVpUWKXpxRnMIoNs6WWO0+iwVD/ndL89bPUy7uoWwXuzulKbMSMbxSrspZLT6jtr2qXbyUEpAsvaUlQKC4sWM410pAbmScXx5RvsQYGHGGFdTAnIg4/h+62R2mzgS0k3fn0yWMVodsU4OAlPbqA1YJ99Tuzdzgdp9GQNsDDjFqNHqcDIe4t1+Q4DqEuA9oM9XqxsDT7EhVmEWy0MAjloni4DtOQ+/x2h1NLnS3RdZO4B5wI0chrxBbYv49pitgKgdM//cD0wDZt3CIq5RPvW204xWl8aV+2lMmSZwqtR2B631u4i6fcDtBRb5913AXz7AjlC7jXHdaHWTDkqZDou/wBH/uAJc4g6SYhdiAaQAUgApgBRAOgOkcqd/2cg3qyrw378yq8CfwHnybbyUgHVGq59zhPIw8HHOMKrAUqBcL8wGfZU4P4IH5l383ePXR3nLMDD8D0xdc890lDDMAAAAAElFTkSuQmCC"

/***/ }),
/* 1830 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAAAcCAYAAADvLBRZAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AwBDhw384juHgAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAANYSURBVHja7dvPbhpHHMDx7+yQXf4YG3Bkq1FalYoHyCV9kV5M8gbJpSe/g2/JIXmD5gVS9dLETW82URun8Q1qnzAOqa3EGBsW70wPTVFsF5alhkjsb6SVkGZ25vOTfrM7sxpUpVJBKYVS6g7wPXALuMbVlB6wBTyw1j6x1g5tLI5YOl4BD/91qI8J+Qi4x2TLY2vt/ZDAxRFzh6pUKneAH5hOuQs8GVAnDnHcVZubmxXg9pQGfAl8O6BOHOKoqI2NDT/qmiCbzdLr9eh0OuOsGdwBdeIQRy9hrYm8QC0U8vR6Per1etRbr41ZJ46YOBJhO6yLxfM80ukM1lr29/c5OzvjcxRxzKYjYSImZD5f6H8KyOcLvG2+/SyBi2M2HZGekI7jkMvlPnk0F2i+a2KMmWrQ4phdR6SEzOfyONrB8s89OqFZWFjg8PBwurNQHDPrGDkhXddlcXERLjS/vnidVquF7/tTCVocs+1QL359ca4LrTW5hRxe0sPzPFzXJeklUUoN7chaS6fbwfd9ut0u3U6X9x/eEwTBpTEHdSEOcVx6QgZBQKFQIJPJRJohSilSyRSpZAqAdrvNweEBUXfx4oi3Q63/sn5JprWmWCwyn50fC33UOmJ3d/e/ZuHIM1Ec8XSo5+vP7aAdU+mbEnPzc5EGOz46prZTG7azGjlwccTPoZ49+9kO28aXSiWyI86EVuuIWq0Wts2PFLg44uVwrLUMuoIgoFqtjrRD8n2farVKEAQM63OcSxzxcYR+9jHGkEgkQgfUWmOMGXuxHFbEEQ9HaEK6rovjqGFP7o8DOniex+np6cS+c4lj9h2hCZlKpTnfxNJoNNBas7S0fKFtipOTk4kELo54OEITMplM9n+32212dv7sd9psvqNY/JpMZq4/4KReDeKIhyM0IdPpFMYY9vbq1Ov1cx0eH7fY3t5meXmZmze/7B87mkQRRzwcocfPgsDw+o/Xg9/91rLXaPDXwQE3vriBmVDg4oiHQz398WnkI+r/o1zpUXlxzJ4jYa3ZYnp/4tkKqRNHvB2v9Ep5pQ18N6UBV4E3A+rEIY5VXS6vvLHWLk1hFjxWSq0NqReHONZ0ubwC8JO1tgp8BSwB+grXJr8Dq0qptbAzc+KIpeO3Tx1/Azj8DaWoeKCvAAAAAElFTkSuQmCC"

/***/ }),
/* 1831 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1832 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1833 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1834 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1835 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1836 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1837 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1838 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1839 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAAAcCAYAAADvLBRZAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AwBDiMFY4GVogAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAOBSURBVHja7dtPaBxVHMDx75vJy2ZnbYQ2BjQgazZqm9TWgxVp7R+vOYSggph68WAoFmpE8CaCeIl4aA9WxbM9KRYP9SBIzLFpm23rH5ruJkWyTReimAjZNbO7z0NibKu7szPdXWHf78G77NuZ3+fBmzfv/WZG5XUCB1AwBkwATwKaxhQfSAMnDZypBPxZHFY6ZoFTfzvU5oD8CHid5pbTFTge0HFxWO5QeZ0YAz6nNeUocKZKmzjEcVTd0onzwL4WBZwBnq7SJg5xnFdLOrEedk3Q9fwo5fkF/PTlKGuGzipt4hCHr27qhAl71I5vv6G8uMjvr74W5SpQVX4XhzhQiyEHpB7cRW96BuP75FM7Kd/K/y8dF0d7OhyzGbHe6h0b39BrjXdsnLDHN6qKoz0d6pcQM6TTvY2HbmRQ9yUAqCz/ys3UTkyh0NIrURzt63AqQL01/srYVjAAp2cH8ZdfIsw5GlHF0b6O+m7ZroubTLJtczq+vXSfOI6bTGJct/m3BHG0vUPN33XL1v2P0PXcEfTjj6EH+tGpFB0DKZSuvfM3vk8pk8XPZvEz8/jX5ih8N0VpYSHSrUEcdjpU9q4B6dzfzYPnvia276l7ynD+OXOBpeERKiurkTouDjsd/1pDllZWyQ2PUJiajhysMDVNbniE0spq5PWIOOx0qLkqu2zlefSd/YL4kUPhg42+iFlba8huThx2OdS1Tq/qtn4j6Jd4h+sLuvb9NLnRF2p1OlJ6QRz2ONTPNQYkgON59P+QpqOvr2awUi5HdmhvPTmnSPkucdjh6AjKepaLRdzt2wNHv9vTg/H98A8+6yzisMMRmIfUySQqHg9O88di6EcHmpbrEocdjsAB2bl76M75u1Ri+YMP+e3Tz8DcOd5je/Y0rePisMMR+OgwNrhr64TFK1fJ7D/I0jvvkjsxQebZwxRm0/8EfGJ30x5LicMOR+AMGRsaxKyvk3/vfa7vP0jh8pWttrULF8kcOERu4i3Kq3/Qtbd5V6I47HAEbmoqhSJzzxyg+ONP/70FK5dZ/vgTVr46ywNvvtG0xbM47HCoS51e6FfU76E09FV5cbSfwzGQbuELnOmIbeKwwzHrmI2PxVsV8GTENnHY4Tjljrv6qoFemv+p42kFkzXaxSGOSXfc1QDnKnDdwMMGeg24DRrxvoFLBt5WMKmCUeKwz3HxdsdfcYhM79XFlngAAAAASUVORK5CYII="

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/yelp_fullcolor_outline@2x.cac05e9d.png";

/***/ }),
/* 1841 */
/***/ (function(module, exports) {

	module.exports = encode;
	
	function encode(string) {
	    string = string.replace(/\r\n/g, "\n");
	    var utftext = "";
	
	    for (var n = 0; n < string.length; n++) {
	
	        var c = string.charCodeAt(n);
	
	        if (c < 128) {
	            utftext += String.fromCharCode(c);
	        }
	        else if ((c > 127) && (c < 2048)) {
	            utftext += String.fromCharCode((c >> 6) | 192);
	            utftext += String.fromCharCode((c & 63) | 128);
	        }
	        else {
	            utftext += String.fromCharCode((c >> 12) | 224);
	            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
	            utftext += String.fromCharCode((c & 63) | 128);
	        }
	
	    }
	
	    return utftext;
	}

/***/ }),
/* 1842 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","WEB_ENV":"production","PUBLIC_URL":"/barbershops","FB_PIXEL_ID":378862599177017,"COMMANDER_URL":"https://app.getsquire.com","MIXPANEL_TOKEN":"26fd9fecaed51592cb1906e8549eca1e","FLAGSHIP_ANDROID_APP_URL":"https://play.google.com/store/apps/details?id=com.getsquire.flagship","FLAGSHIP_IOS_APP_URL":"https://apps.apple.com/us/app/squire/id957644357","PUBLISH_URL":"https://getsquire.com/barbershops","SQUIRE_BRANCH_KEY":"key_live_eafRKQ0rBNN7eNjrjJJFRhnlvzeWA93h","SQUIRE_STRIPE_KEY":"pk_live_i7yVGwE1iFznsnhYqqpFNxmg","SQUIRE_INTERCOM_ID":"jnflr57i","SQUIRE_TOKENS_URL":"https://squire-tokens-prod-1.getsquire.com","SQUIRE_PUBNUB_SUBSCRIBE_KEY":"sub-c-b7a5edba-08f4-11e7-83b6-0619f8945a4f","SQUIRE_FULLSTORY_ORG":"100T1W","SQUIRE_API_URL":"https://api.getsquire.com/v1","SQUIRE_GOOGLE_ANALYTICS_ID":"UA-70640238-1"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)))

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(__webpack_module_template_argument_0__);
	var invariant = __webpack_require__(__webpack_module_template_argument_1__);
	var ReactPropTypesSecret = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__)();
	}


/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.ed73418f.js